/* design-my-book.js */

/* =========================
   MODE / NAVIGATION FIXES
   ========================= */

/* session ID + per-session book counter for PDF filenames */
const DMB_SESSION_ID = Date.now().toString(36);
let dmbBookCounter = 0;

/* Polaroid frame geometry — uniform white border on three sides + a thicker
   bottom strip (the classic look). Returns inset values in the object's own
   coordinate units (= builder px; multiply by scale for the PDF canvas).
   Declared at top level so BOTH IIFEs (builder render + PDF render) can use it. */
function dmbPolaroidInsetVals(w, h) {
  w = w || 0; h = h || 0;
  var pad = Math.max(6, Math.min(w, h) * 0.07);
  var bottom = Math.max(pad * 2.4, h * 0.17);
  return { top: pad, left: pad, right: pad, bottom: bottom };
}


const DMB_MAP_LIBRARY = {
  lebanon: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 240" class="dmb-country-map" data-map-name="lebanon">
      <path d="M55 10 L75 20 L80 40 L72 60 L85 85 L78 110 L88 140 L80 170 L70 205 L58 230 L45 220 L42 190 L35 160 L30 130 L36 100 L32 75 L40 50 L48 25 Z"></path>
    </svg>
  `,
  afghanistan: `
    <svg
      xmlns:mapsvg="http://mapsvg.com"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      mapsvg:geoViewBox="60.517000 38.490877 74.889862 29.377200"
      version="1.1"
      id="svg2"
      width="699.60461"
      height="532.77234">
      <path
        id="AF-PIA"
        title="Paktya"
        
        d="m 456.68715,266.76119 -2.93,-1.73 -0.34,-0.13 -0.3,-0.07 -0.27,-0.02 -0.26,0.08 -0.29,0.19 -1.69,2.07 -2.7,1.69 -0.54,0.2 -0.58,-0.02 -0.17,-0.21 -0.01,-0.39 0.06,-0.43 0.03,-0.36 -0.07,-0.29 -0.17,-0.2 -0.38,-0.22 -0.44,-0.17 -1.65,-0.4 -2.16,-0.16 -0.6,0.06 -0.82,-0.01 -0.47,0.08 -0.46,0.15 -1.07,0.67 -0.31,0.32 -0.39,1.18 -0.72,1.5 -0.5,0.7 -0.82,0.93 -0.54,0.48 -0.59,0.34 -1.89,1.66 -0.27,0.28 -2.59,2.75 -0.35,0.71 -0.27,0.36 -1.54,1.06 -4.85,2.28 -4.71,3.54 -0.66,0.51 -0.6,0.63 -0.76,1.56 -0.54,1.6 -0.93,1.68 -0.64,0.56 -0.32,0.22 -0.56,0.28 -0.65,0.22 -0.76,0.12 -0.58,0 -1,-0.42 -0.76,-0.14 -7.19,-0.06 -0.17,2.12 0.09,2.06 0.12,1.08 0.19,0.7 0.58,1.09 0.43,1.05 0.11,0.57 -0.06,0.5 -1.18,2.61 -0.28,1 3.54,-1.31 1.25,-0.21 0.91,0.51 0.51,0.1 0.36,-0.09 0.37,-0.16 0.27,-0.03 0.25,0.04 1.08,0.49 0.27,0.21 0.19,0.21 0.52,1.02 0.77,1.06 0.16,0.32 0.07,0.39 0.01,0.6 -0.2,2.74 0.04,1.18 0.42,3.41 -0.02,0.31 -0.05,0.28 -0.01,0.49 0.19,0.64 0.25,1.32 0.23,0.38 0.14,0.03 0.16,-0.01 0.31,-0.05 0.72,-0.3 0.68,-0.43 1.31,-1.25 1.97,-1.17 2.39,-1.08 1.66,-1.05 0.4,-0.41 0.02,-0.16 -0.02,-0.16 -0.04,-0.18 -0.04,-0.24 -0.01,-0.36 0.11,-0.15 0.15,-0.07 0.29,0.02 0.32,0.08 0.19,0.09 0.2,0.15 0.14,0.14 0.39,0.32 1.46,1.16 1.01,0.2 0.88,-0.13 2.22,-0.79 0.78,-0.08 0.34,0.17 0.19,0.12 0.97,0.32 0.24,-1.19 0.16,-0.28 0.66,-0.74 0.85,-1.03 0.2,-0.72 0.13,-0.63 0.25,-0.39 2.62,-2.35 1.12,-0.67 0.31,-0.38 0.46,-0.73 0.27,-0.69 1.14,-3.7 -0.82,-0.89 -0.05,-0.71 0.27,-0.69 0.78,-1.51 0.26,-0.71 1.49,-1.25 0.74,-0.46 0.73,-0.36 2.99,-0.91 3.34,-0.33 0.13,0.02 0.07,0.04 0.8,0.62 1.46,-2.22 0.26,-0.23 0.45,-0.3 0.38,-0.05 1.15,-0.41 0.8,-0.51 1.12,-0.49 1.4,-0.85 1.2,-0.39 0.33,-0.22 0.81,-0.9 0.23,-0.46 0.13,-0.41 0.01,-0.85 -1.16,-0.16 -0.73,-0.46 -0.5,-1.12 -0.34,-1.14 -0.43,-0.88 -1.15,-1.7 -0.43,-0.93 -0.65,-2.21 -0.43,-0.77 -1.42,-1.43 -0.3,-0.86 0.64,-0.85 0.86,-0.89 0.09,-0.87 -0.16,-0.88 0.1,-0.92 0.81,-0.82 0.78,-0.27 -0.38,-0.55 z"
        />
      <path
        id="AF-WAR"
        title="Wardak"
        
        d="m 384.03715,232.72119 -0.92,-0.15 -0.28,-0.08 -0.21,-0.27 -0.17,-0.26 -0.31,-1.73 -0.08,-0.89 -0.14,-0.46 -0.24,-0.56 -2.5,-2.54 -0.21,-0.48 -0.2,-0.67 -0.1,-1.16 -0.31,-1.11 -5.59,2.91 -1.37,1.03 -0.7,1.16 -1.01,1.1 -0.53,0.44 -0.39,0.16 -0.54,-0.31 -0.36,-0.1 -0.42,0.01 -0.56,0.13 -0.35,0.22 -0.33,0.36 -0.32,0.49 -0.95,1.09 -0.2,0.3 -0.25,0.74 -1.09,2.32 -2.98,-0.34 -8.92,-2.53 -1.13,-0.2 -1.83,0.25 -1.39,-0.04 -0.8,-0.12 -0.93,-0.28 -1.49,-0.14 -0.4,-0.12 -0.23,-0.23 -0.24,-0.3 -0.39,-0.32 -0.93,-0.41 -0.55,-0.17 -0.45,-0.07 -0.29,0.04 -0.29,0.1 -1.37,0.84 -0.31,0.13 -4.25,0.86 -2.7,0.37 -0.4,0.14 -0.48,0.24 -0.17,0.23 -0.25,0.64 0.48,1.64 0.51,0.73 1.45,1.22 0.28,0.42 0.11,0.45 -0.06,1.02 -0.09,0.35 -0.17,0.25 -0.84,0.67 -0.24,0.12 -0.27,0.07 -1.3,0.14 -0.31,0.12 -0.3,0.19 -0.25,0.25 -0.24,0.33 -0.25,0.44 -0.24,0.58 -0.31,0.94 0.01,0.72 0.12,0.5 0.27,0.35 0.31,0.25 0.34,0.18 0.33,0.13 3.38,0.31 2.13,-0.11 0.49,0.04 0.45,0.14 0.49,0.38 0.24,0.39 0.13,0.41 0.05,0.37 -0.01,0.38 -0.06,0.31 -0.12,0.23 -0.15,0.18 -0.21,0.13 -0.18,0.09 -0.39,0.11 -1.08,0.61 -0.11,0.23 -0.03,0.31 0.18,0.15 0.28,0.1 1.56,0.19 0.6,0.17 4.78,2.18 0.57,0.45 0.17,0.34 -0.48,0.51 -0.7,0.95 -0.15,0.32 -0.21,0.57 -0.13,0.19 -0.2,0.16 -3.9,1.51 -0.34,0.33 -0.32,0.5 -0.3,1.19 0,0.62 0.2,0.5 0.87,0.81 2.29,0.31 0.81,-0.01 1.51,-0.52 0.24,-0.18 0.1,-0.19 0.29,-1.34 0.19,-0.29 0.32,-0.32 0.62,-0.49 0.43,-0.23 0.39,-0.13 3.29,-0.7 1.22,-0.06 1.49,0.34 1.8,0.69 1.5,1.04 1.22,1.16 0.53,0.27 0.66,0.16 2.24,0.17 0.64,-0.04 0.74,-0.15 3.09,-1.08 1.39,-0.74 0.7,-0.58 0.26,-0.09 0.34,-0.19 0.16,-0.14 0.69,-0.45 1.06,0.25 0.72,0.49 1.46,1.38 0.39,0.6 0.25,0.55 0.48,2.62 0.03,0.45 -0.08,0.85 0.02,0.49 0.06,0.51 0.16,0.64 0.05,0.43 -0.02,0.43 -0.07,0.38 0.03,0.51 0.12,0.59 0.43,1.46 0.03,0.82 0.35,1 0.49,0.32 0.61,0.17 3.03,1.23 0.25,0.2 0.5,0.86 2.33,1.45 0.71,0.77 0.18,0.29 4.14,4.37 0.32,0.28 0.29,0.15 0.24,0.01 0.48,-0.04 0.43,-0.1 1.08,-0.04 0.45,1.28 -0.01,0.33 -0.05,0.46 -0.4,1.17 -0.23,0.96 -0.01,0.51 0.07,0.37 0.09,0.13 0.13,0.15 0.43,0.3 0.62,0.28 1.94,0.48 0.51,0 0.8,-0.09 0.42,-0.17 4.1,-2.41 0.33,-0.27 2.05,-2.55 1.16,-1.14 1.63,-1.85 0.2,-0.34 0.38,-0.87 0.32,-2.09 -0.08,-0.44 -0.17,-0.54 -0.5,-0.63 -0.08,-0.16 -0.02,-0.09 0.12,-0.16 0.64,-1.24 0.55,-0.75 1.19,-1.02 0.66,-0.36 0.69,-0.28 2.33,-0.48 0.43,-0.15 0.2,-0.17 0.06,-0.23 0,-0.11 -0.09,-0.33 -0.7,-1.75 -0.21,-0.24 -0.51,-0.44 -0.61,-0.4 -1.12,-1.01 -0.47,-0.69 -0.24,-0.66 0.17,-2.1 0.46,-1.99 1.03,-2.24 0.86,-1.15 1.03,-0.96 0.67,-0.46 1.43,-3.4 0.96,-1.5 1.27,-1.46 -0.26,-0.89 -0.85,-2.86 -1.66,-1.24 -0.34,-0.17 -1.55,-0.4 -0.27,-0.12 -0.21,-0.23 -0.17,-0.38 -0.25,-0.77 -0.22,-0.51 -0.21,-0.37 -0.18,-0.5 -0.09,-0.71 0.08,-1.61 0.5,-1.96 -0.08,-1.3 0.6,-2.04 -0.62,0.18 -0.76,-0.14 -1.49,-0.67 -1.68,-0.48 -0.71,-0.36 -0.38,-0.05 -1.47,0.09 -0.64,-0.07 -0.7,-0.27 -0.87,-0.67 -0.24,-0.14 -0.21,-0.09 -0.85,-0.23 -0.68,-0.31 -3.58,-0.88 -0.48,0.01 -0.69,0.29 -2.86,1.88 -1.49,0.75 -0.8,0.25 -0.26,0.16 -0.41,0.43 -0.25,0.13 -0.34,0.04 z"
        />
      <path
        id="AF-SAM"
        title="Samangan"
        
        d="m 368.52715,117.15119 -9.66,-1.37 -2.34,-0.29 -1.12,-0.37 -0.64,-0.41 -0.28,-0.24 -1.51,-0.95 -2.77,-1.36 -0.68,-0.19 -0.78,0.05 -0.74,0.18 -1.4,0.57 -0.67,0.18 -5.53,-0.52 -0.69,0.25 -0.68,1.67 -0.51,0.48 -2.21,0.67 -0.98,0.49 -0.47,0.38 -0.43,0.44 -0.15,0.24 -0.09,0.15 -0.01,0.15 0.04,0.14 0.08,0.15 0.84,1.13 1.3,2.73 0.06,0.46 0.02,0.66 -1.14,3.19 -0.7,2.89 -0.06,2.7 -0.34,2.19 -0.23,0.39 -0.34,0.48 -0.76,0.62 -0.44,0.47 -0.2,0.36 -0.05,0.29 0.05,0.19 0.09,0.28 0.09,0.4 0,0.4 -0.1,0.8 -0.23,0.45 -0.34,0.38 -1.01,0.94 -0.81,0.98 -0.48,0.46 -0.39,0.3 -0.69,0.21 -2.57,0.39 -0.9,0.29 -4.57,3.51 -0.98,0.96 -0.01,0.1 0.01,0.13 0.05,0.2 0.11,0.19 0.17,0.2 0.3,0.23 0.12,0.11 0.08,0.16 0.04,0.24 0.03,0.63 0.03,0.13 0.18,0.39 0.31,0.5 1.33,1.78 0.11,0.45 0.02,0.53 -0.13,1.17 -0.21,0.68 -0.25,0.5 -0.31,0.25 -0.79,0.42 -0.38,0.33 -0.2,0.41 -0.16,0.61 -0.22,0.4 -0.25,0.29 -0.61,0.47 -0.65,0.78 -1.85,2.22 -1.02,0.78 -1.81,0.87 -0.44,0.43 -0.36,0.44 -0.81,1.47 -0.2,0.56 -0.11,0.51 -0.07,0.49 0.06,0.65 4.59,2.16 1.11,0.98 0.15,0.68 0.02,0.23 0.01,0.18 -0.04,0.15 -0.06,0.17 -0.12,0.19 -0.19,0.18 -0.27,0.18 -0.91,0.4 -0.24,0.21 -0.17,0.26 -0.05,0.39 0.14,0.21 1.08,0.57 0.15,0.16 0.07,0.15 -0.07,0.5 -0.01,0.31 0.07,0.79 -0.03,0.23 -0.06,0.17 -0.14,0.06 -0.68,0.17 -0.15,0.07 -0.09,0.08 -0.03,0.13 0.01,0.24 0.28,1.53 0.02,0.43 -0.01,0.52 -0.07,0.68 -0.11,0.5 -0.17,0.44 -0.23,0.42 -0.29,0.4 -2.29,2.31 -0.83,0.68 -0.9,0.57 -1.55,0.7 -0.76,0.47 -0.59,0.6 2.65,1.06 1.32,0.26 4.87,0.03 1.36,-0.32 4.37,-1.96 3.78,-0.97 4.53,-1.76 0.55,-0.08 0.43,0.04 0.27,0.12 0.6,0.14 0.97,0.06 1.9,0.53 5.23,-2.14 3.01,-0.62 1.22,-0.02 6.41,1.5 0.64,0.06 0.52,-0.04 2.64,-0.89 0.48,-0.02 0.36,0.1 0.24,0.23 0.4,0.58 0.26,0.25 0.39,0.23 0.39,0.05 4.82,-0.73 1.95,0.11 4.26,-0.93 2.62,-2.73 0.18,-0.38 0.03,-0.56 0.1,-0.52 0.22,-0.56 1.08,-1.41 0.63,-1.1 0.26,-1.8 -0.58,-0.78 -0.22,-0.21 -1.25,-0.73 -0.1,-0.55 0.02,-0.29 0.05,-0.39 0.24,-0.82 0.36,-0.82 6.98,-9.35 0.2,-0.41 0.2,-1.92 0.18,-0.69 0.23,-2.31 0,-0.38 -0.06,-0.81 0.03,-0.38 0.12,-0.37 0.34,-0.82 0.22,-0.4 0.33,-0.38 1.45,-0.72 4.51,-3.99 0.97,-1.11 2.14,-3.65 -0.11,-0.5 -0.35,-0.62 -0.3,-0.39 -1.18,-1.14 -3.23,-2.46 -2.04,-1.09 -0.55,-0.48 -2.27,-3.04 -3.35,-5.52 -2.35,-3.55 -0.23,-0.48 -0.36,-0.94 -0.21,-0.37 -0.69,-0.92 -0.14,-0.34 -0.04,-0.36 0.15,-0.54 0.36,-0.8 0.21,-0.34 0.3,-0.29 0.4,-0.22 1.12,-0.31 0.71,-0.52 -1.59,-0.46 -0.86,-0.87 -3.93,1.61 -1.37,0.27 z"
        />
      <path
        id="AF-PAR"
        title="Parwan"
        
        d="m 423.87715,186.02119 -1.73,-0.41 -1.15,0.98 -0.46,0.66 -0.4,0.35 -0.32,0.19 -0.33,0.1 -2.45,1.11 -0.53,0.35 -0.38,0.39 -0.83,1.55 -0.46,0.69 -0.32,0.33 -0.33,0.2 -2.05,0.59 -0.42,0.28 -0.22,0.24 -0.35,0.73 -2.17,1.48 -0.39,0.09 -0.49,0.04 -2.01,-1.41 -1.88,0.55 -0.28,0.18 -0.44,0.33 -0.47,0.48 -0.49,0.8 -0.79,1.06 -0.73,1.36 -0.37,0.43 -0.09,0.05 -3.59,2.75 -0.69,0.41 -2.22,0.49 -0.29,0.18 -0.14,0.23 0.02,0.18 0.07,0.3 0.27,0.57 0.09,0.29 0.03,0.2 -0.18,0.65 -1.34,0.73 -1,0.21 -2.48,0.12 -2.98,-0.26 -3.22,0.46 -0.7,-0.08 -3.56,-1 -0.33,0.03 -0.16,0.16 -0.03,0.24 -0.06,0.29 -0.17,0.29 -0.3,0.37 -0.56,0.44 -0.69,0.43 -1.35,0.46 -1.04,0.55 -0.37,0.5 2.55,2.75 0.63,1.74 0.04,1.51 0.15,1.32 -0.06,1.76 -0.25,1.81 0.12,0.31 0.12,0.18 0.92,0.52 0.57,0.48 0.31,1.11 0.1,1.16 0.2,0.67 0.21,0.48 2.5,2.54 0.24,0.56 0.14,0.46 0.08,0.89 0.31,1.73 0.17,0.26 0.21,0.27 0.28,0.08 0.92,0.15 0.34,-0.04 0.25,-0.13 0.41,-0.43 0.26,-0.16 0.8,-0.25 1.49,-0.75 2.86,-1.88 0.69,-0.29 0.48,-0.01 3.58,0.88 0.68,0.31 0.85,0.23 0.21,0.09 0.24,0.14 0.87,0.67 0.7,0.27 0.64,0.07 1.47,-0.09 0.38,0.05 0.71,0.36 1.68,0.48 1.49,0.67 0.76,0.14 0.62,-0.18 0.63,-2.32 -0.2,-2.52 1.2,-2.59 0.62,-0.55 0.17,-0.8 1.39,-4.2 1.84,-2.95 0.17,-0.2 3.51,0.9 0.71,-0.05 4.42,0.29 1.44,-0.35 0.94,0.15 0.85,0.39 0.86,0.65 0.56,0.52 2.06,1.23 0.38,1.57 1.59,2.58 0.33,0.74 0.51,0.47 0.99,0.2 0.85,0.73 1.22,2.85 0.6,2.67 0.76,2.41 1.03,0.18 1.94,-0.6 0.67,-0.48 0.62,-0.71 0.21,-0.6 0.14,-0.63 0.24,-0.67 0.43,-0.27 0.59,0 1.7,0.36 0.4,-1.86 0.12,-0.36 0,-0.43 -0.52,-0.29 -0.28,-0.25 -0.3,-0.37 -0.28,-0.53 -0.32,-0.33 -0.25,-0.43 -0.3,-0.75 -0.19,-0.78 -0.05,-1.05 0.21,-2.95 -0.04,-1.23 0.2,-2.45 -0.26,-1.35 -1.61,-0.55 -2.12,-0.82 -2.93,-0.15 -1.4,-1.49 -0.91,-1.23 -0.64,-0.48 -0.77,-0.45 -1.35,-0.3 -1.28,-0.66 -0.75,-0.9 -0.19,-1.15 0.09,-1.15 0.38,-3.29 -0.23,-2.27 -1.83,0.26 -0.07,-2.07 0.19,-1.05 0.13,-6.69 0.58,-2.67 0.04,-1.49 -0.78,-1.14 -0.32,-0.23 -0.31,0.1 -0.65,0.03 z"
        />
      <path
        id="AF-LOG"
        title="Logar"
        
        d="m 435.57715,261.02119 -1,-1.89 -1.05,-1.38 -0.35,-0.56 -0.29,-0.76 -0.13,-0.48 -0.25,-0.55 -0.34,-0.57 -1.47,-1.9 -0.94,-0.82 -0.64,-0.65 -0.58,-0.8 -1.17,-2.19 -0.56,-0.41 -3.99,2.7 -0.26,0.29 -0.3,0.18 -0.32,0.03 -0.85,-0.41 -0.77,0.12 -0.79,0.32 -0.7,0.08 -7.17,-2.44 -1.27,1.46 -0.96,1.5 -1.43,3.4 -0.67,0.46 -1.03,0.96 -0.86,1.15 -1.03,2.24 -0.46,1.99 -0.17,2.1 0.24,0.66 0.47,0.69 1.12,1.01 0.61,0.4 0.51,0.44 0.21,0.24 0.7,1.75 0.09,0.33 0,0.11 -0.06,0.23 -0.2,0.17 -0.43,0.15 -2.33,0.48 -0.69,0.28 -0.66,0.36 -1.19,1.02 -0.55,0.75 -0.64,1.24 -0.12,0.16 0.02,0.09 0.08,0.16 0.5,0.63 0.17,0.54 0.08,0.44 -0.32,2.09 -0.38,0.87 -0.2,0.34 -1.63,1.85 1.46,0.7 0.19,0.23 0.24,0.4 0.07,0.38 0.38,1.18 0.45,1 0.16,0.47 0.03,0.3 -0.12,0.08 -0.4,0.08 -0.19,0.1 -0.2,0.19 -0.2,0.4 -0.17,0.46 -0.1,0.62 0.1,0.31 0.2,0.24 0.24,0.17 0.24,0.2 0.06,0.22 -0.03,0.67 0.04,0.2 0.35,0.43 0.14,1.28 0,0.01 7.19,0.06 0.76,0.14 1,0.42 0.58,0 0.76,-0.12 0.65,-0.22 0.56,-0.28 0.32,-0.22 0.64,-0.56 0.93,-1.68 0.54,-1.6 0.76,-1.56 0.6,-0.63 0.66,-0.51 4.71,-3.54 4.85,-2.28 1.54,-1.06 0.27,-0.36 0.35,-0.71 2.59,-2.75 0.27,-0.28 1.89,-1.66 0.59,-0.34 0.54,-0.48 0.82,-0.93 0.5,-0.7 0.72,-1.5 0.39,-1.18 0.31,-0.32 1.07,-0.67 0.46,-0.15 0.47,-0.08 0.82,0.01 0.6,-0.06 2.16,0.16 1.65,0.4 0.44,0.17 0.38,0.22 0.17,0.2 0.07,0.29 -0.03,0.36 -0.06,0.43 0.01,0.39 0.17,0.21 0.58,0.02 0.54,-0.2 2.7,-1.69 1.69,-2.07 0.29,-0.19 0.26,-0.08 0.27,0.02 0.3,0.07 0.34,0.13 2.93,1.73 -0.86,-1.24 -0.5,-1.99 -0.52,-0.87 -0.4,-0.43 -0.74,-0.94 -0.24,-0.83 -0.09,-0.17 -0.13,-0.17 -0.36,-0.37 -0.13,-0.16 -0.12,-0.21 -0.17,-0.47 -0.5,-0.85 -0.21,-0.61 -0.12,-0.24 -0.18,-0.17 -0.22,-0.15 -0.55,-0.26 -0.13,-0.09 -0.11,-0.18 -0.15,-0.27 -0.1,-0.13 -0.14,-0.12 -0.42,-0.23 -0.09,-0.08 -0.13,-0.14 -0.34,-0.45 -0.23,-0.19 -0.35,-0.09 -0.48,0.08 -1.03,0.35 -5.7,2.66 -3.61,2.53 -0.92,-0.19 -0.63,0.79 -0.16,0.13 -0.35,0.01 z"
        />
      <path
        id="AF-LAG"
        title="Laghman"
        
        d="m 463.39715,204.55119 -0.44,-0.37 -0.48,-1 -0.14,-2.33 -0.19,-0.59 -0.3,-0.64 -1.26,-2.02 -0.28,-1.03 -0.35,0.91 -0.38,0.7 -1.82,2.46 -0.77,0.7 -1.49,0.95 -1.57,0.78 -0.36,0.22 -0.53,0.23 -0.3,0.06 -0.17,0.15 -0.17,0.34 -0.1,0.64 -0.49,1.05 0.75,2.31 1.69,1.33 0.25,0.47 0.31,0.78 0.17,0.8 0.36,1.05 1.48,2.4 0.32,0.85 0.45,2.09 -0.92,1.37 1.54,4.34 0.01,0.67 -0.06,0.88 -0.27,0.4 -0.52,0.55 -1.97,1.76 -0.5,0.82 -0.35,0.74 -0.07,0.55 0.05,0.94 -0.11,2.37 -0.22,0.5 -0.19,0.32 -0.92,1.03 0.05,1.34 0.72,1.88 -0.08,0.64 -0.32,0.83 -0.4,0.81 -0.49,1.25 -0.16,0.81 -0.05,0.81 0.02,0.49 0.16,1.36 1.47,0.48 5.22,-0.6 2.74,-0.53 2.83,0.61 0.82,-0.17 2.88,-1.34 5.13,-0.88 2.74,-0.8 2.43,-1.23 0.62,-0.54 1.35,-1.02 1.24,-2.58 0.09,-0.83 0.03,-1.02 -0.79,-3.9 1.18,-1 2.59,-0.98 0.54,-0.39 0.35,-2.37 0.32,-0.69 0.51,-0.65 1.52,-1.17 1.7,-0.87 1.46,-0.46 0.21,-1.86 0.02,-2.33 -0.14,-1.11 -0.28,-1.09 -0.6,-1.14 -0.27,-0.7 -0.04,-0.57 0.01,-0.54 -0.07,-0.63 -0.23,-0.71 -0.6,-0.79 -0.9,1.26 -2.31,1.94 -0.57,0.32 -2.57,1.08 -2.52,0.73 -0.69,0.02 -0.66,-0.18 -2.28,-1.39 -2.22,-0.35 -0.55,-0.36 -1,-2.17 -1.06,-1.14 -1.27,-1.74 -0.67,-2.52 -1.31,-1.24 -3.88,-0.69 -1.66,0.08 z"
        />
      <path
        id="AF-PAN"
        title="Panjshayr"
        
        d="m 474.91715,159.94119 -3.03,-1.36 -1.36,-1.08 -0.29,-0.07 -0.03,0.19 0.1,0.46 -0.03,0.55 -0.3,0.69 -0.48,0.66 -0.64,0.72 -0.62,0.55 -1.11,0.54 -3.32,0.38 -2.02,0.81 -0.81,0.46 -0.19,0.02 -0.09,-0.12 -0.04,-0.41 -0.04,-0.17 -0.1,-0.1 -0.12,-0.08 -0.63,-0.22 -0.6,1.57 -0.21,0.23 -0.34,0.28 -1.5,0.71 -0.38,0.46 -0.91,1.83 -0.43,0.55 -0.43,0.35 -0.74,0.21 -0.69,0.07 -0.72,-0.03 -1.28,1.93 -0.43,1.2 -0.19,0.94 -0.12,1.24 -0.61,3.07 -0.24,0.74 -0.47,0.7 -2.42,0.71 -6.11,3.99 -0.82,0.35 -2.61,-0.35 -2.2,0.26 -0.55,0.18 -0.33,0.26 -0.43,0.76 -1.31,1.27 -1.36,-0.09 -0.7,0.25 -0.58,0.44 -0.42,0.22 -1.56,-0.06 -2.14,0.66 -0.04,1.49 -0.58,2.67 -0.13,6.69 -0.19,1.05 0.07,2.07 1.83,-0.26 0.78,-0.39 0.4,-0.81 0.69,0.25 0.66,0.46 2.51,0.19 2.07,0.78 0.94,-0.05 1.02,-0.28 0.66,-0.04 0.95,0.37 2.39,-0.09 0.55,0.15 3.35,-0.96 2.17,0.25 1.54,0.35 0.89,0.49 0.67,0.63 1.61,2.27 1.06,1.22 0.49,-1.05 0.1,-0.64 0.17,-0.34 0.17,-0.15 0.3,-0.06 0.53,-0.23 0.36,-0.22 1.57,-0.78 1.49,-0.95 0.77,-0.7 1.82,-2.46 0.38,-0.7 0.35,-0.91 0.12,-3.15 -0.23,-0.6 -0.47,-0.9 -1.95,-1.72 0.08,-0.76 0.4,-0.64 0.5,-0.5 0.83,-0.53 3.61,-1.89 1.13,-1.58 0.22,-0.6 0.83,-1.42 0.25,-0.05 0.27,0.14 0.49,0.16 0.69,-0.02 1.13,-0.35 0.79,-0.62 0.61,-0.69 0.42,-0.77 0.26,-0.64 0.05,-0.44 -0.11,-0.29 -0.17,-0.24 -0.13,-0.27 -0.02,-0.68 0.08,-0.31 0.32,-0.23 1.2,-0.69 0.37,-0.54 0.23,-0.78 0.2,-2.82 0.56,-1.46 0.35,-0.78 0.01,-0.66 0.35,-2.97 0.23,-1.02 0.17,-2.64 0.94,-2.68 z"
        />
      <path
        id="AF-KAP"
        title="Kapisa"
        
        d="m 434.00715,201.45119 -2.07,-0.78 -2.51,-0.19 -0.66,-0.46 -0.69,-0.25 -0.4,0.81 -0.78,0.39 0.23,2.27 -0.38,3.29 -0.09,1.15 0.19,1.15 0.75,0.9 1.28,0.66 1.35,0.3 0.77,0.45 0.64,0.48 0.91,1.23 1.4,1.49 2.93,0.15 2.12,0.82 1.61,0.55 0.26,1.35 -0.2,2.45 0.04,1.23 -0.21,2.95 0.05,1.05 0.19,0.78 0.3,0.75 0.25,0.43 0.32,0.33 0.28,0.53 0.3,0.37 0.28,0.25 0.52,0.29 0,0.43 -0.12,0.36 -0.4,1.86 1.08,0.59 0.54,0 2.53,-0.65 1.42,0 0.33,-0.39 0.24,-0.64 0.16,-0.78 2.21,-5.73 0.85,-0.74 2.25,-1.11 0.66,-0.24 0.36,-0.3 0.11,-0.25 0.45,-0.79 1.01,-1.03 0.92,-1.37 -0.45,-2.09 -0.32,-0.85 -1.48,-2.4 -0.36,-1.05 -0.17,-0.8 -0.31,-0.78 -0.25,-0.47 -1.69,-1.33 -0.75,-2.31 -1.06,-1.22 -1.61,-2.27 -0.67,-0.63 -0.89,-0.49 -1.54,-0.35 -2.17,-0.25 -3.35,0.96 -0.55,-0.15 -2.39,0.09 -0.95,-0.37 -0.66,0.04 -1.02,0.28 -0.94,0.05 z"
        />
      <path
        id="AF-KAB"
        title="Kabul"
        
        d="m 415.82715,217.64119 -3.51,-0.9 -0.17,0.2 -1.84,2.95 -1.39,4.2 -0.17,0.8 -0.62,0.55 -1.2,2.59 0.2,2.52 -0.63,2.32 -0.6,2.04 0.08,1.3 -0.5,1.96 -0.08,1.61 0.09,0.71 0.18,0.5 0.21,0.37 0.22,0.51 0.25,0.77 0.17,0.38 0.21,0.23 0.27,0.12 1.55,0.4 0.34,0.17 1.66,1.24 0.85,2.86 0.26,0.89 7.17,2.44 0.7,-0.08 0.79,-0.32 0.77,-0.12 0.85,0.41 0.32,-0.03 0.3,-0.18 0.26,-0.29 3.99,-2.7 0.56,0.41 1.17,2.19 0.58,0.8 0.64,0.65 0.94,0.82 1.47,1.9 0.34,0.57 0.25,0.55 0.13,0.48 0.29,0.76 0.35,0.56 1.05,1.38 1,1.89 0.35,-0.01 0.16,-0.13 0.63,-0.79 -0.32,-2.12 0.06,-0.42 0.15,-0.2 0.29,-0.25 0.79,-0.44 2.43,-1.8 2.99,-3.1 1.94,-2.6 0.35,-0.57 0.11,-0.5 0,-0.31 -0.22,-0.82 -0.03,-0.27 0,-0.21 0.04,-0.13 1.62,-0.38 5.62,-0.67 -0.16,-1.36 -0.02,-0.49 0.05,-0.81 0.16,-0.81 0.49,-1.25 0.4,-0.81 0.32,-0.83 0.08,-0.64 -0.72,-1.88 -0.05,-1.34 0.92,-1.03 0.19,-0.32 0.22,-0.5 0.11,-2.37 -0.05,-0.94 0.07,-0.55 0.35,-0.74 0.5,-0.82 1.97,-1.76 0.52,-0.55 0.27,-0.4 0.06,-0.88 -0.01,-0.67 -1.54,-4.34 -1.01,1.03 -0.45,0.79 -0.11,0.25 -0.36,0.3 -0.66,0.24 -2.25,1.11 -0.85,0.74 -2.21,5.73 -0.16,0.78 -0.24,0.64 -0.33,0.39 -1.42,0 -2.53,0.65 -0.54,0 -1.08,-0.59 -1.7,-0.36 -0.59,0 -0.43,0.27 -0.24,0.67 -0.14,0.63 -0.21,0.6 -0.62,0.71 -0.67,0.48 -1.94,0.6 -1.03,-0.18 -0.76,-2.41 -0.6,-2.67 -1.22,-2.85 -0.85,-0.73 -0.99,-0.2 -0.51,-0.47 -0.33,-0.74 -1.59,-2.58 -0.38,-1.57 -2.06,-1.23 -0.56,-0.52 -0.86,-0.65 -0.85,-0.39 -0.94,-0.15 -1.44,0.35 -4.42,-0.29 -0.71,0.05 z"
        />
      <path
        id="AF-BGL"
        title="Baghlan"
        
        d="m 380.28715,118.00119 -0.45,-0.14 -1.21,-0.7 -2.35,-0.56 -0.71,0.52 -1.12,0.31 -0.4,0.22 -0.3,0.29 -0.21,0.34 -0.36,0.8 -0.15,0.54 0.04,0.36 0.14,0.34 0.69,0.92 0.21,0.37 0.36,0.94 0.23,0.48 2.35,3.55 3.35,5.52 2.27,3.04 0.55,0.48 2.04,1.09 3.23,2.46 1.18,1.14 0.3,0.39 0.35,0.62 0.11,0.5 -2.14,3.65 -0.97,1.11 -4.51,3.99 -1.45,0.72 -0.33,0.38 -0.22,0.4 -0.34,0.82 -0.12,0.37 -0.03,0.38 0.06,0.81 0,0.38 -0.23,2.31 -0.18,0.69 -0.2,1.92 -0.2,0.41 -6.98,9.35 -0.36,0.82 -0.24,0.82 -0.05,0.39 -0.02,0.29 0.1,0.55 1.25,0.73 0.22,0.21 0.58,0.78 -0.26,1.8 -0.63,1.1 -1.08,1.41 -0.22,0.56 -0.1,0.52 -0.03,0.56 -0.18,0.38 -2.62,2.73 -0.13,1.53 0.19,1.04 0.73,2.01 0.06,0.49 -0.06,0.44 -0.37,0.84 -0.17,0.63 0.02,0.53 0.38,1.21 -0.04,0.4 -0.18,0.35 -0.2,0.27 -0.19,0.48 -0.17,0.63 -0.27,1.72 -0.14,0.47 -0.34,0.74 -0.13,0.54 -0.32,0.69 -1.24,0.68 -0.29,0.25 -0.34,0.37 -0.24,0.35 -0.27,0.53 -0.11,0.39 -0.22,1.29 0,0.35 0.07,0.32 0.12,0.3 0.09,0.32 0.04,0.35 0,0.35 -0.03,0.37 0,0.35 0.21,1.99 0.12,0.46 0.17,0.26 0.25,0.18 1.48,0.45 0.16,0.11 0.15,0.17 0.18,0.16 0.22,0.12 0.28,0.03 0.34,-0.04 1.13,-0.27 0.34,0 0.35,0.08 0.32,0.17 1.7,1.45 0.23,0.09 0.24,0 0.21,-0.03 0.3,-0.14 0.37,-0.5 1.04,-0.55 1.35,-0.46 0.69,-0.43 0.56,-0.44 0.3,-0.37 0.17,-0.29 0.06,-0.29 0.03,-0.24 0.16,-0.16 0.33,-0.03 3.56,1 0.7,0.08 3.22,-0.46 2.98,0.26 2.48,-0.12 1,-0.21 1.34,-0.73 0.18,-0.65 -0.03,-0.2 -0.09,-0.29 -0.27,-0.57 -0.07,-0.3 -0.02,-0.18 0.14,-0.23 0.29,-0.18 2.22,-0.49 0.69,-0.41 3.59,-2.75 0.09,-0.05 0.37,-0.43 0.73,-1.36 0.79,-1.06 0.49,-0.8 0.47,-0.48 0.44,-0.33 0.28,-0.18 1.88,-0.55 2.01,1.41 0.49,-0.04 0.39,-0.09 2.17,-1.48 0.35,-0.73 0.22,-0.24 0.42,-0.28 2.05,-0.59 0.33,-0.2 0.32,-0.33 0.46,-0.69 0.83,-1.55 0.38,-0.39 0.53,-0.35 2.45,-1.11 0.33,-0.1 0.32,-0.19 0.4,-0.35 0.46,-0.66 1.15,-0.98 1.73,0.41 0.65,-0.03 0.31,-0.1 0.32,0.23 0.78,1.14 2.14,-0.66 1.56,0.06 0.42,-0.22 0.58,-0.44 0.7,-0.25 1.36,0.09 1.31,-1.27 0.43,-0.76 0.33,-0.26 0.55,-0.18 2.2,-0.26 2.61,0.35 0.82,-0.35 6.11,-3.99 2.42,-0.71 0.47,-0.7 0.24,-0.74 0.61,-3.07 0.12,-1.24 0.19,-0.94 0.43,-1.2 1.28,-1.93 0.72,0.03 0.69,-0.07 0.74,-0.21 0.43,-0.35 0.43,-0.55 0.91,-1.83 0.38,-0.46 1.5,-0.71 0.34,-0.28 0.21,-0.23 0.6,-1.57 -0.23,-4.62 -0.22,-0.51 -0.36,-0.57 -0.71,-0.93 -0.29,-0.47 -0.1,-0.44 0.04,-0.42 -0.02,-0.11 -0.05,-0.17 -0.12,-0.2 -0.18,-0.21 -0.38,-0.34 -0.28,-0.4 -0.5,-1.11 -0.09,-0.32 -0.02,-0.17 0,-0.31 -0.04,-0.19 -0.09,-0.26 -0.85,-1.65 -1,-1.24 -2.9,-2.69 -0.5,-6.88 -0.58,-1.17 -0.65,-0.17 -1.23,0.11 -0.17,-0.02 -0.18,-0.06 -0.19,-0.11 -0.2,-0.21 -0.19,-0.39 -0.18,-0.55 -0.09,-0.91 0,-1.22 -0.07,-0.6 -0.17,-0.71 -0.79,-2.2 -0.5,-0.19 -1.16,1.06 -1.55,0.91 -2.93,1.17 -0.75,0.11 -0.79,0.23 -0.65,0.39 -3.16,2.51 -2.05,0.62 -1.71,-0.08 -0.4,0.1 -0.33,0.16 -0.19,0.16 -0.15,0.1 -0.11,-0.03 -0.13,-0.11 -0.23,-0.31 -0.23,-0.14 -0.39,0 -0.26,0.1 -0.25,0.16 -0.38,0.34 -0.15,0.07 -0.18,-0.09 -0.23,-0.27 -0.45,-0.79 -0.24,-0.56 -0.28,-0.83 -0.19,-0.28 -0.29,-0.17 -0.62,-0.09 -0.81,-0.22 -0.59,-0.83 -0.67,-0.98 -0.18,-0.33 -0.22,-0.33 -0.39,-0.28 -0.61,-0.28 -1.85,-0.48 -0.88,-0.13 -1.96,-0.71 -0.94,-0.6 -1.39,-1.24 -0.59,-0.78 -0.33,-0.36 -0.57,-0.44 -0.06,-0.07 -0.05,-0.12 -0.05,-0.13 -0.59,-0.27 -2.32,-0.44 -1.2,-0.24 -0.24,0.04 -0.27,0.12 -1.35,0.85 -0.35,0.15 -0.33,0.08 -0.44,-0.12 -0.52,-0.31 -2.12,-1.68 -3.08,-3.89 -0.6,-1.34 -2.98,0.43 -0.78,0.3 -0.5,0.07 -0.56,-0.04 -4.11,-1.17 -7.91,-0.55 -2.58,0.13 z"
        />
      <path
        id="AF-TAK"
        title="Takhar"
        
        d="m 461.85715,57.031194 -0.27,-0.26 -0.19,-0.41 -0.25,-0.31 -0.63,-0.12 -1.02,-0.38 -0.53,-0.87 -0.45,-0.97 -0.8,-0.71 -1.14,-0.06 -2.04,1.04 -0.98,0.28 -0.48,0.22 -0.51,0.44 -0.5,0.26 -0.51,-0.28 -0.35,-0.26 -1.08,-0.33 -0.39,-0.05 -1.2,0.15 -2.05,0.89 -1.08,0.21 -6.61,-0.6 -0.97,0.43 -0.84,2.57 -1.05,1.03 -2.15,1.58 -0.17,0.29 -0.3,0.73 -0.19,0.31 -0.38,0.35 -0.69,0.49 -0.25,0.34 -0.3,0.96 -0.1,1.14 0.04,2.33 0.09,0.22 0.45,0.12 0.14,0.27 -0.01,0.33 -0.12,0.09 -0.13,0.04 -0.06,0.18 0.02,0.57 0.07,0.57 0.15,0.52 0.25,0.42 0.41,0.91 0.32,2.1 0.4,0.55 -0.39,1.34 0.82,0.38 0.89,0.19 -0.15,0.77 -1.67,2.81 -0.8,0.78 -1.96,1.25 -0.77,0.92 -0.53,0.49 -0.57,0.22 -0.17,0.03 0.07,0.21 1.33,1.54 0.06,0.28 0.03,0.37 -0.91,1.2 -0.11,0.23 -0.33,1.41 0,0.57 0.07,0.59 0.15,0.8 0.02,0.5 -0.58,8.51 -0.56,1.699996 -0.53,0.64 -0.18,0.1 -0.13,0.05 -2.23,0.26 -0.66,0.72 -0.04,0.22 -0.04,0.42 0.18,1.24 -0.05,1.28 -0.07,0.4 -0.32,0.4 -0.07,0.13 -0.02,0.18 0.03,0.26 0.04,0.1 0.43,0.77 0.2,0.57 0.06,0.49 -0.02,0.45 -0.08,0.54 0.07,0.23 0.16,0.1 0.25,0.04 0.1,0.03 0.12,0.09 0.13,0.14 0.31,0.52 0.57,1.24 0.04,0.55 -0.06,0.52 -0.93,2.03 -0.36,1.34 -0.16,0.42 -0.2,0.3 -0.21,0.27 -1.37,1.13 -0.13,0.16 -0.09,0.16 -0.05,0.17 -0.07,0.15 -0.11,0.13 -0.21,0.13 -0.58,0.24 -0.76,0.72 -0.04,0.2 0.01,0.25 0.41,0.58 0.49,0.85 0.53,2.18 0.6,1.03 0.44,0.57 0.16,0.46 0.02,0.54 -0.07,0.6 0.03,0.81 0.18,0.63 0.45,0.89 0.2,0.63 0.11,0.48 0.01,0.97 0.59,0.83 0.81,0.22 0.62,0.09 0.29,0.17 0.19,0.28 0.28,0.83 0.24,0.56 0.45,0.79 0.23,0.27 0.18,0.09 0.15,-0.07 0.38,-0.34 0.25,-0.16 0.26,-0.1 0.39,0 0.23,0.14 0.23,0.31 0.13,0.11 0.11,0.03 0.15,-0.1 0.19,-0.16 0.33,-0.16 0.4,-0.1 1.71,0.08 2.05,-0.62 3.16,-2.51 0.65,-0.39 0.79,-0.23 0.75,-0.11 2.93,-1.17 1.55,-0.91 1.16,-1.06 0.5,0.19 0.79,2.2 0.17,0.71 0.07,0.6 0,1.22 0.09,0.91 0.18,0.55 0.19,0.39 0.2,0.21 0.19,0.11 0.18,0.06 0.17,0.02 1.23,-0.11 0.65,0.17 0.58,1.17 0.5,6.88 2.9,2.69 1,1.24 0.85,1.65 0.09,0.26 0.04,0.19 0,0.31 0.02,0.17 0.09,0.32 0.5,1.11 0.28,0.4 0.38,0.34 0.18,0.21 0.12,0.2 0.05,0.17 0.02,0.11 -0.04,0.42 0.1,0.44 0.29,0.47 0.71,0.93 0.36,0.57 0.22,0.51 0.23,4.62 0.63,0.22 0.12,0.08 0.1,0.1 0.04,0.17 0.04,0.41 0.09,0.12 0.19,-0.02 0.81,-0.46 2.02,-0.81 3.32,-0.38 1.11,-0.54 0.62,-0.55 0.64,-0.72 0.48,-0.66 0.3,-0.69 0.03,-0.55 -0.1,-0.46 0.03,-0.19 0.29,0.07 1.36,1.08 3.03,1.36 0.48,-0.41 0.17,-0.22 0.2,-0.31 0.31,-0.63 0.16,-0.18 0.17,-0.12 1.1,-0.48 2.11,-1.35 0.54,-0.5 0.91,-1.15 0.29,-0.23 2.46,-1.27 0.24,-0.35 0.08,-0.47 -0.29,-0.71 -1.01,-1.47 -0.24,-0.45 -0.14,-0.47 0.01,-0.47 0.25,-0.54 0.42,-0.6 0.06,-0.29 -0.05,-0.57 0.04,-0.49 0.5,-1.7 0.19,-1.01 0.11,-0.36 0.13,-0.29 0.57,-0.85 0.13,-1.72 -0.24,-6.34 -0.4,-0.6 -0.21,-0.21 -0.4,-0.24 -0.54,-0.17 -1.67,-0.16 -1.84,0.17 -0.33,-0.01 -3.16,-1.03 -1.62,-0.33 -0.35,0 -1,0.25 -0.53,-0.28 -0.72,-0.65 -3.38,-4.04 -2.74,-2.09 -1.94,-1.07 -0.23,-0.29 -0.13,-0.47 0.13,-2.16 -0.05,-0.58 -0.16,-0.62 -0.62,-1.57 -0.25,-1.48 -0.36,-0.94 -0.23,-1.42 -0.03,-2.21 0.29,-2.67 -0.07,-13.239996 -0.06,-0.48 0.21,-0.27 0.61,-0.49 0.39,-0.18 0.28,-0.21 0.12,-0.25 0.09,-0.53 0.02,-0.35 0.7,-1.2 1.33,-0.51 0.38,-0.29 0.21,-0.2 0.21,-0.89 1.15,-1.93 -1.15,-1.98 -0.78,-0.96 -1.82,-1.38 -0.39,-0.56 -0.28,-0.75 -0.06,-1.19 0.18,-1.39 -0.05,-0.66 -0.21,-0.78 -1.12,-2.93 -0.13,-1.64 0.3,-3.47 0.38,-1.59 0.23,-0.48 0.55,-0.76 0.25,-0.26 0.1,-0.22 -0.07,-0.17 -0.41,-0.2 -0.41,-0.1 -0.43,-0.05 -0.27,-0.08 -0.18,-0.64 -0.14,-1.21 -0.18,-6.32 0.29,-1.19 -0.02,-0.06 z"
        />
      <path
        id="AF-NAN"
        title="Nangarhar"
        
        d="m 495.44715,234.78119 -0.35,-0.19 -0.27,-0.17 -1.51,-2.01 -0.26,-1.09 0,-0.93 0.22,-1.4 0.23,-0.89 0.33,-0.71 0.12,-0.47 0.09,-0.88 0,-0.32 -0.05,-0.35 -0.22,-0.72 -0.18,-0.44 -0.79,-1.08 -1.3,-0.76 -1.46,0.46 -1.7,0.87 -1.52,1.17 -0.51,0.65 -0.32,0.69 -0.35,2.37 -0.54,0.39 -2.59,0.98 -1.18,1 0.79,3.9 -0.03,1.02 -0.09,0.83 -1.24,2.58 -1.35,1.02 -0.62,0.54 -2.43,1.23 -2.74,0.8 -5.13,0.88 -2.88,1.34 -0.82,0.17 -2.83,-0.61 -2.74,0.53 -5.22,0.6 -1.47,-0.48 -5.62,0.67 -1.62,0.38 -0.04,0.13 0,0.21 0.03,0.27 0.22,0.82 0,0.31 -0.11,0.5 -0.35,0.57 -1.94,2.6 -2.99,3.1 -2.43,1.8 -0.79,0.44 -0.29,0.25 -0.15,0.2 -0.06,0.42 0.32,2.12 0.92,0.19 3.61,-2.53 5.7,-2.66 1.03,-0.35 0.48,-0.08 0.35,0.09 0.23,0.19 0.34,0.45 0.13,0.14 0.09,0.08 0.42,0.23 0.14,0.12 0.1,0.13 0.15,0.27 0.11,0.18 0.13,0.09 0.55,0.26 0.22,0.15 0.18,0.17 0.12,0.24 0.21,0.61 0.5,0.85 0.17,0.47 0.12,0.21 0.13,0.16 0.36,0.37 0.13,0.17 0.09,0.17 0.24,0.83 0.74,0.94 0.4,0.43 0.52,0.87 0.5,1.99 0.86,1.24 0.38,0.55 0.52,-0.18 2.57,-0.4 1.64,0.11 10.47,3.69 2.76,0.27 1.66,0.84 0.89,0.26 3.92,0.17 4,0.86 1.48,0.06 6.51,-0.94 6.55,0.07 3.44,-0.66 0.86,-1.72 0.21,-0.75 0.49,-0.14 1.3,0.42 0.9,0.08 0.69,-0.23 0.57,-0.53 0.55,-0.79 1,-0.35 2.38,-0.5 0.77,-0.72 0.22,-1.1 -0.16,-0.93 -0.05,-0.96 0.54,-1.17 1.35,-1.56 0.3,-0.78 0.07,-1.41 -0.14,-1.18 -0.47,-2.05 0.01,-1.07 1.42,-4.09 -0.21,-1.45 -3.45,-1.93 -1.51,-1.45 -1.37,-1.69 -1,-1.51 -0.47,-1.11 -0.27,-1.31 0.07,-1.3 0.56,-1.04 0.71,-0.33 -0.06,0.01 -5.9,0.43 -1.81,-0.26 -2.55,1.11 -1.39,0.14 -0.47,-1.42 0.19,-0.28 0.29,-0.36 0.65,-0.37 0.27,-0.23 0.15,-0.23 0.06,-0.25 -0.22,-0.24 -0.41,-0.25 -1.01,-0.24 -0.55,-0.05 -0.44,0.07 -0.49,0.3 -0.21,0.09 z"
        />
      <path
        id="AF-KDZ"
        title="Kunduz"
        
        d="m 425.06715,84.321194 -4.59,-3.11 -0.25,-0.12 -1.08,-0.74 -0.45,-0.51 -0.86,-2.16 -0.88,-0.74 -1.1,-0.73 -0.97,-0.88 -0.71,-2.22 -0.76,-1.07 -0.98,-0.9 -0.96,-0.54 -3.31,-0.41 -0.17,-0.08 -0.28,-0.06 -0.13,0.21 0.25,0.72 0.31,0.4 0.79,0.59 0.22,0.26 0.17,0.88 -0.25,0.55 -0.54,0.14 -0.7,-0.32 -0.65,-0.86 -0.43,-0.98 -0.55,-0.78 -1.01,-0.26 -1.07,0.35 -0.18,0.69 0.58,1.84 0.12,1.3 -0.2,0.59 -0.58,-0.04 -1.8,-1.17 -0.57,-0.27 -0.63,-0.06 -1,0.1 -1.89,-0.27 -0.88,0.04 -0.55,0.65 0.25,0.24 0.13,0.27 0.28,0.74 -1.09,0.17 -0.6,0.88 -0.27,0.98 -0.19,0.46 -0.87,0.13 -1.82,0.58 -0.97,0.12 -0.23,0.27 -0.67,1.17 -0.43,0.26 -0.52,0.05 -2.3,0.52 -3.01,0.23 0.69,1.42 -0.32,0.91 -0.95,0.48 -1.26,0.13 -0.96,-0.22 -0.94,-0.37 -0.94,-0.08 -0.92,0.67 -0.36,1.01 0.04,1.23 0.32,2.55 -0.51,0.87 -1.17,-0.01 -1.99,-0.67 -1.27,0.18 -0.9,0.75 -0.77,0.8 -0.9,0.38 -0.6,0.38 -3.21,2.77 -0.49,0.33 -0.59,0.24 -0.38,-0.01 -0.01,0.08 0.47,2.51 0.1,3.479996 0.09,0.51 2.61,6.4 1.3,2.3 0.3,0.35 0.78,0.57 0.97,0.92 0.67,0.9 0.32,0.66 0.37,1.43 0.86,0.87 1.59,0.46 2.35,0.56 1.21,0.7 0.45,0.14 2.58,-0.13 7.91,0.55 4.11,1.17 0.56,0.04 0.5,-0.07 0.78,-0.3 2.98,-0.43 0.6,1.34 3.08,3.89 2.12,1.68 0.52,0.31 0.44,0.12 0.33,-0.08 0.35,-0.15 1.35,-0.85 0.27,-0.12 0.24,-0.04 1.2,0.24 2.32,0.44 0.59,0.27 0.05,0.13 0.05,0.12 0.06,0.07 0.57,0.44 0.33,0.36 0.59,0.78 1.39,1.24 0.94,0.6 1.96,0.71 0.88,0.13 1.85,0.48 0.61,0.28 0.39,0.28 0.22,0.33 0.18,0.33 0.67,0.98 -0.01,-0.97 -0.11,-0.48 -0.2,-0.63 -0.45,-0.89 -0.18,-0.63 -0.03,-0.81 0.07,-0.6 -0.02,-0.54 -0.16,-0.46 -0.44,-0.57 -0.6,-1.03 -0.53,-2.18 -0.49,-0.85 -0.41,-0.58 -0.01,-0.25 0.04,-0.2 0.76,-0.72 0.58,-0.24 0.21,-0.13 0.11,-0.13 0.07,-0.15 0.05,-0.17 0.09,-0.16 0.13,-0.16 1.37,-1.13 0.21,-0.27 0.2,-0.3 0.16,-0.42 0.36,-1.34 0.93,-2.03 0.06,-0.52 -0.04,-0.55 -0.57,-1.24 -0.31,-0.52 -0.13,-0.14 -0.12,-0.09 -0.1,-0.03 -0.25,-0.04 -0.16,-0.1 -0.07,-0.23 0.08,-0.54 0.02,-0.45 -0.06,-0.49 -0.2,-0.57 -0.43,-0.77 -0.04,-0.1 -0.03,-0.26 0.02,-0.18 0.07,-0.13 0.32,-0.4 0.07,-0.4 0.05,-1.28 -0.18,-1.24 0.04,-0.42 0.04,-0.22 0.66,-0.72 2.23,-0.26 0.13,-0.05 0.18,-0.1 0.53,-0.64 0.56,-1.699996 0.58,-8.51 -0.02,-0.5 -0.15,-0.8 -0.07,-0.59 0,-0.57 0.33,-1.41 0.11,-0.23 0.91,-1.2 -0.03,-0.37 -0.06,-0.28 -1.33,-1.54 -0.07,-0.21 -1.12,0.24 -0.96,0.46 -0.98,0.09 z"
        />
      <path
        id="AF-KNR"
        title="Kunar"
        
        d="m 531.75715,214.23119 0.71,-0.29 0.47,-0.41 0.34,-0.63 0.42,-1.37 0.39,-0.63 0,0 0,0 0,-0.01 0.53,-0.38 0.34,-0.48 0.08,-0.55 -0.26,-0.6 0.07,-2.6 1.26,-1.57 3.35,-2.35 1.22,-1.89 0.42,-1.16 -0.2,-0.8 -1.48,-1.2 -2.69,-3.11 -0.87,-1.5 0.08,-1.61 1.49,-1.94 2.37,-2.07 0.48,-0.88 0.07,-1.16 -0.41,-0.8 -0.64,-0.73 -0.36,-0.52 -0.33,0.61 -0.34,0.4 -0.48,0.42 -1.04,0.72 -0.61,0.29 -1.01,0.34 -0.4,0.27 -0.35,0.6 -0.33,0.37 -1.13,0.52 -0.22,0.28 -0.17,0.41 -0.42,1.64 -0.45,0.34 -2.1,0.2 -0.87,-0.21 -0.73,-0.62 -0.66,0.09 -5.77,2.2 -1.26,0.9 -0.68,1 -0.57,1.01 -0.27,0.96 0,2.11 -1.05,1.36 -0.26,0.45 -0.28,0.66 -0.39,2.1 -0.46,1.17 -0.24,0.49 -0.51,0.35 -0.39,-0.8 -0.2,-0.27 -0.25,-0.15 -0.47,0.23 -0.43,0.27 -1.96,2.4 -1.46,-0.43 -0.39,-0.17 -0.68,-0.12 -0.74,0 -3.28,0.56 -0.58,0.18 -0.56,0.27 -0.66,0.08 -0.48,-0.02 -2.71,-0.92 -2.22,-0.39 -0.78,-0.25 -0.93,-0.44 -1.43,-0.92 -1.68,-0.78 -1.13,3.33 -0.34,0.78 -2.29,4.04 0.6,0.79 0.23,0.71 0.07,0.63 -0.01,0.54 0.04,0.57 0.27,0.7 0.6,1.14 0.28,1.09 0.14,1.11 -0.02,2.33 -0.21,1.86 1.3,0.76 0.79,1.08 0.18,0.44 0.22,0.72 0.05,0.35 0,0.32 -0.09,0.88 -0.12,0.47 -0.33,0.71 -0.23,0.89 -0.22,1.4 0,0.93 0.26,1.09 1.51,2.01 0.27,0.17 0.35,0.19 0.21,-0.09 0.49,-0.3 0.44,-0.07 0.55,0.05 1.01,0.24 0.41,0.25 0.22,0.24 -0.06,0.25 -0.15,0.23 -0.27,0.23 -0.65,0.37 -0.29,0.36 -0.19,0.28 0.47,1.42 1.39,-0.14 2.55,-1.11 1.81,0.26 5.9,-0.43 0.06,-0.01 0.12,-0.05 1.03,-0.01 1.97,0.31 0.88,-0.44 0.53,-1.18 0.16,-1.44 -0.18,-1.22 -0.36,-1.31 0.06,-0.9 0.51,-0.69 3.41,-2.8 1.87,-0.99 0.66,-0.65 2.55,-3.67 0.74,-2.01 0.9,-1.82 1.72,-1.33 5.84,-2.38 z"
        />
      <path
        id="AF-NUR"
        title="Nuristan"
        
        d="m 538.93715,182.99119 -0.27,-0.4 -0.29,-1.33 0.21,-1.13 0.33,-1.07 0.03,-1.15 -0.45,-0.88 -0.8,-0.6 -2.67,-1.32 -0.97,-0.79 -0.46,-1.01 0.61,-1.2 0.88,-1.13 0.28,-1.09 -0.21,-1.06 -0.61,-1.04 -0.33,-0.33 -0.71,-0.57 -0.28,-0.42 -0.22,-0.67 0,-0.54 0.05,-0.52 -0.06,-0.59 -0.31,-0.89 -1.62,-2.93 -0.7,-0.9 -2.2,-1.58 -0.51,-0.9 -0.21,-1.97 -0.72,-0.85 -1.41,-0.6 -1.37,-0.31 -1.3,-0.54 -1.24,-1.35 -0.68,-0.52 -1.75,-0.97 -0.53,-0.49 -0.05,-0.22 0,0 -0.75,0.63 -0.54,0.62 -0.47,0.72 -0.7,1.31 -0.4,0.64 -0.38,0.45 -0.63,0.49 -0.26,0.46 -0.23,0.67 -0.38,2.23 -0.1,1.11 -0.15,0.61 -0.24,0.62 -1.41,2.16 -0.42,0.81 -0.22,0.32 -0.28,0.23 -0.71,0.38 -0.72,0.28 -0.29,0.18 -0.26,0.37 -0.19,0.54 -0.16,0.93 0.14,0.67 0.22,0.37 1.12,0.65 0.34,0.28 0.29,0.32 0.24,0.36 -0.03,0.43 -0.28,0.45 -1.4,1.28 -0.93,1.66 -1.78,0.81 -0.93,-0.09 -0.34,-0.09 -0.34,-0.03 -0.3,0.12 -0.29,0.28 -0.44,1.01 -0.13,0.51 0.05,0.38 0.08,0.41 0.03,0.35 -0.06,0.66 0.06,0.3 0.27,0.62 0.07,0.33 0.09,0.73 0.18,0.8 0.03,0.42 -0.06,0.4 -0.12,0.32 -0.58,0.92 -0.12,0.27 -0.38,0.13 -0.63,-0.05 -2.44,-0.6 -1.73,0.25 -1.35,-0.52 -0.77,-0.81 -0.98,-1.29 -0.32,-0.25 -0.44,0.08 -0.49,0.38 -0.84,1.11 -0.22,0.56 -0.04,0.49 0.05,0.3 -0.02,0.31 -0.08,0.31 -0.12,0.32 -0.34,0.39 -0.48,0.37 -1.04,0.55 -1.29,0.46 -1.62,-0.23 -0.27,-0.75 -0.12,-0.87 -0.02,-0.51 0.04,-0.97 0.07,-0.52 0.29,-1.01 0.49,-1.21 0.1,-0.41 0.04,-0.45 -0.08,-0.48 -0.2,-0.44 -0.36,-0.51 -2.12,-2.34 -0.16,-0.42 -0.08,-0.4 -0.1,-0.83 -0.12,-0.37 -0.16,-0.34 -0.35,-0.32 -0.48,-0.28 -2.24,-0.75 -1.35,-0.72 -0.56,-0.11 -0.6,0.06 -0.88,0.39 -0.53,0.36 -1.16,1.06 -1.19,0.37 -3.05,-0.59 -0.56,1.46 -0.2,2.82 -0.23,0.78 -0.37,0.54 -1.2,0.69 -0.32,0.23 -0.08,0.31 0.02,0.68 0.13,0.27 0.17,0.24 0.11,0.29 -0.05,0.44 -0.26,0.64 -0.42,0.77 -0.61,0.69 -0.79,0.62 -1.13,0.35 -0.69,0.02 -0.49,-0.16 -0.27,-0.14 -0.25,0.05 -0.83,1.42 -0.22,0.6 -1.13,1.58 -3.61,1.89 -0.83,0.53 -0.5,0.5 -0.4,0.64 -0.08,0.76 1.95,1.72 0.47,0.9 0.23,0.6 -0.12,3.15 0.28,1.03 1.26,2.02 0.3,0.64 0.19,0.59 0.14,2.33 0.48,1 0.44,0.37 1.66,-0.08 3.88,0.69 1.31,1.24 0.67,2.52 1.27,1.74 1.06,1.14 1,2.17 0.55,0.36 2.22,0.35 2.28,1.39 0.66,0.18 0.69,-0.02 2.52,-0.73 2.57,-1.08 0.57,-0.32 2.31,-1.94 0.9,-1.26 2.29,-4.04 0.34,-0.78 1.13,-3.33 1.68,0.78 1.43,0.92 0.93,0.44 0.78,0.25 2.22,0.39 2.71,0.92 0.48,0.02 0.66,-0.08 0.56,-0.27 0.58,-0.18 3.28,-0.56 0.74,0 0.68,0.12 0.39,0.17 1.46,0.43 1.96,-2.4 0.43,-0.27 0.47,-0.23 0.25,0.15 0.2,0.27 0.39,0.8 0.51,-0.35 0.24,-0.49 0.46,-1.17 0.39,-2.1 0.28,-0.66 0.26,-0.45 1.05,-1.36 0,-2.11 0.27,-0.96 0.57,-1.01 0.68,-1 1.26,-0.9 5.77,-2.2 0.66,-0.09 0.73,0.62 0.87,0.21 2.1,-0.2 0.45,-0.34 0.42,-1.64 0.17,-0.41 0.22,-0.28 1.13,-0.52 0.33,-0.37 0.35,-0.6 0.4,-0.27 1.01,-0.34 0.61,-0.29 1.04,-0.72 0.48,-0.42 0.34,-0.4 0.33,-0.61 z"
        />
      <path
        id="AF-BDS"
        title="Badakhshan"
        
        d="m 508.89715,0.25119373 -1.13,0.04 -0.35,0.44 0.16,1.40999997 -0.51,0.63 -1.16,-0.29 -2,-0.96 -0.57,0.09 -0.28,0.27 -0.18,0.28 -0.33,0.17 -0.43,-0.03 -0.79,-0.27 -0.44,-0.09 -1.53,0 -0.79,0.18 -0.33,0.43 -0.6,1.06 -2.84,0.3 -0.89,0.57 0,0.42 0.96,0.74 -0.39,0.72 -1.71,1.29 -0.45,0.25 -1.11,-0.07 -0.45,0.26 -0.2,0.55 -0.01,0.64 0.05,0.63 0,0.5200003 -0.66,2.11 -0.49,0.25 -0.66,0.17 -0.59,0.34 -0.45,1.52 -1.42,2.82 -1.26,3.4 -0.6,1.04 -0.5,0.5 -1.65,0.72 -0.51,0.38 -2.15,2.23 -2.17,2.9 -0.41,0.3 -0.94,0.5 -0.23,0.13 -0.25,0.32 -0.24,0.55 -0.53,0.23 -0.58,0.11 -0.33,0.19 -0.17,0.57 -0.02,0.52 0.17,0.51 0.38,0.49 -1.13,0.43 -1.14,0.19 -1.09,-0.22 -0.97,-0.81 -0.57,1.56 0.23,1.89 0.68,1.79 0.82,1.28 0.55,0.26 1.6,0.5 0.33,0.52 0.13,0.87 0.32,0.81 0.44,0.65 0.46,0.43 -0.26,0.71 0.1,0.85 0.49,1.79 0.06,0.9 -0.12,0.54 -0.17,0.49 -0.1,0.77 -0.61,0.89 -0.23,0.17 -0.2,0.22 0.01,0.49 0.07,0.56 -0.06,0.41 -0.28,0.45 -0.1,0.13 -0.25,0.25 -0.16,-0.06 -0.94,0.04 -0.09,0.02 -0.71,1.79 -0.12,0.53 -0.32,0.2 -1.69,2.12 -1.4,0.56 -1.46,-0.27 -1.44,-0.52 -1.34,-0.23 0.31,0.46 -1.51,-0.28 -0.45,-0.18 -0.17,-0.15 0.02,0.06 -0.29,1.19 0.18,6.32 0.14,1.21 0.18,0.64 0.27,0.08 0.43,0.05 0.41,0.1 0.41,0.2 0.07,0.17 -0.1,0.22 -0.25,0.26 -0.55,0.76 -0.23,0.48 -0.38,1.59 -0.3,3.47 0.13,1.64 1.12,2.93 0.21,0.78 0.05,0.66 -0.18,1.39 0.06,1.19 0.28,0.75 0.39,0.56 1.82,1.38 0.78,0.96 1.15,1.98 -1.15,1.93 -0.21,0.89 -0.21,0.2 -0.38,0.29 -1.33,0.51 -0.7,1.2 -0.02,0.35 -0.09,0.53 -0.12,0.25 -0.28,0.21 -0.39,0.18 -0.61,0.49 -0.21,0.27 0.06,0.48 0.07,13.239996 -0.29,2.67 0.03,2.21 0.23,1.42 0.36,0.94 0.25,1.48 0.62,1.57 0.16,0.62 0.05,0.58 -0.13,2.16 0.13,0.47 0.23,0.29 1.94,1.07 2.74,2.09 3.38,4.04 0.72,0.65 0.53,0.28 1,-0.25 0.35,0 1.62,0.33 3.16,1.03 0.33,0.01 1.84,-0.17 1.67,0.16 0.54,0.17 0.4,0.24 0.21,0.21 0.4,0.6 0.24,6.34 -0.13,1.72 -0.57,0.85 -0.13,0.29 -0.11,0.36 -0.19,1.01 -0.5,1.7 -0.04,0.49 0.05,0.57 -0.06,0.29 -0.42,0.6 -0.25,0.54 -0.01,0.47 0.14,0.47 0.24,0.45 1.01,1.47 0.29,0.71 -0.08,0.47 -0.24,0.35 -2.46,1.27 -0.29,0.23 -0.91,1.15 -0.54,0.5 -2.11,1.35 -1.1,0.48 -0.17,0.12 -0.16,0.18 -0.31,0.63 -0.2,0.31 -0.17,0.22 -0.48,0.41 -0.94,2.68 -0.17,2.64 -0.23,1.02 -0.35,2.97 -0.01,0.66 -0.35,0.78 3.05,0.59 1.19,-0.37 1.16,-1.06 0.53,-0.36 0.88,-0.39 0.6,-0.06 0.56,0.11 1.35,0.72 2.24,0.75 0.48,0.28 0.35,0.32 0.16,0.34 0.12,0.37 0.1,0.83 0.08,0.4 0.16,0.42 2.12,2.34 0.36,0.51 0.2,0.44 0.08,0.48 -0.04,0.45 -0.1,0.41 -0.49,1.21 -0.29,1.01 -0.07,0.52 -0.04,0.97 0.02,0.51 0.12,0.87 0.27,0.75 1.62,0.23 1.29,-0.46 1.04,-0.55 0.48,-0.37 0.34,-0.39 0.12,-0.32 0.08,-0.31 0.02,-0.31 -0.05,-0.3 0.04,-0.49 0.22,-0.56 0.84,-1.11 0.49,-0.38 0.44,-0.08 0.32,0.25 0.98,1.29 0.77,0.81 1.35,0.52 1.73,-0.25 2.44,0.6 0.63,0.05 0.38,-0.13 0.12,-0.27 0.58,-0.92 0.12,-0.32 0.06,-0.4 -0.03,-0.42 -0.18,-0.8 -0.09,-0.73 -0.07,-0.33 -0.27,-0.62 -0.06,-0.3 0.06,-0.66 -0.03,-0.35 -0.08,-0.41 -0.05,-0.38 0.13,-0.51 0.44,-1.01 0.29,-0.28 0.3,-0.12 0.34,0.03 0.34,0.09 0.93,0.09 1.78,-0.81 0.93,-1.66 1.4,-1.28 0.28,-0.45 0.03,-0.43 -0.24,-0.36 -0.29,-0.32 -0.34,-0.28 -1.12,-0.65 -0.22,-0.37 -0.14,-0.67 0.16,-0.93 0.19,-0.54 0.26,-0.37 0.29,-0.18 0.72,-0.28 0.71,-0.38 0.28,-0.23 0.22,-0.32 0.42,-0.81 1.41,-2.16 0.24,-0.62 0.15,-0.61 0.1,-1.11 0.38,-2.23 0.23,-0.67 0.26,-0.46 0.63,-0.49 0.38,-0.45 0.4,-0.64 0.7,-1.31 0.47,-0.72 0.54,-0.62 0.75,-0.63 0,0 -0.19,-0.9 0.46,-0.93 1.56,-1.58 0.24,-0.56 0.25,-1.27 0.26,-0.44 1.9,-1.25 1.48,-0.7 0.45,-0.33 0.34,-0.56 0.24,-1.28 0.25,-0.4 3.07,-1.08 0.99,-0.77 3.7,-4.16 0.81,-0.55 0.91,-0.33 1.18,-0.25 0.94,-0.51 -0.27,-0.79 -0.51,-0.93 0.24,-0.92 1.22,-1.21 0.39,-0.64 0.41,-0.97 0.58,-1.86 0.47,-0.52 0.91,-0.1 0.97,0.41 2.8,1.89 1.42,1.54 0.72,0.29 0.77,-0.05 0.76,-0.28 0.57,-0.67 -0.14,-0.82 -0.82,-1.64 -0.07,-1.9 1,-0.65 3.14,-0.21 0.79,-0.29 0.62,-0.54 0.59,-0.63 0.67,-0.55 2.3,-1.33 0.78,-0.81 1.01,-0.57 1.99,-0.49 0.78,-0.74 0.06,-0.55 -0.2,-0.51 -0.08,-0.5 0.42,-0.51 0.57,-0.32 1.22,-0.4 2.82,-0.39 0.85,-0.5 -0.34,-0.99 -0.73,-1.17 0.19,-0.77 0.78,-0.56 2.13,-0.91 4.29,-0.99 2.14,-0.13 2,-0.66 2.22,0.15 1.02,-0.28 3.04,-2.58 2.35,-1.21 3.12,-0.75 3.21,-0.23 4.05,0.6 4.29,-0.22 1.41,-0.39 1.18,-0.629996 1.2,-0.3 1.5,0.619996 0.66,0.03 0.58,-0.279996 1.16,-0.81 0.79,-0.29 7.24,-0.77 1.53,0.16 1.42,0.38 0.72,0.09 0.69,-0.08 2.43,-0.86 2.32,0.17 3.21,-0.44 1.5,0.22 1.58,0.26 6.34,-1.09 3.37,0.14 0.07,0.01 0.01,0 0.03,0 2.96,0.13 2.97,0.55 1.5,0.63 3.97,2.519996 1.45,0.37 1.43,0.55 1.41,0.01 2.86,-0.95 0.47,-0.61 0.23,-2.079996 0.32,-0.84 0.69,-0.54 0.8,-0.2 3.18,0.4 1.17,-0.43 2.37,-1.94 4.05,-2.58 1.26,-1.05 2.01,-0.56 1.04,-0.07 0.95,0.31 0.18,0.14 0.16,0.18 0.88,1.31 0.95,0.85 0.78,-0.23 0.33,-1.93 0.19,-0.46 0.06,-0.45 -0.09,-0.41 -0.25,-0.36 -1.12,-0.52 -0.65,-1.02 -0.57,-1.18 -0.85,-1.02 -3.02,-1.5 -1.54,-1.14 -0.8,-1.29 0.11,-1.17 0.68,-0.31 1.84,0.25 1.03,-0.15 0.73,-0.42 0.54,-0.76 0.43,-1.23 0.52,-0.97 0.62,-0.34 1.56,-0.04 2.12,-0.6 0.68,-0.08 0.32,0.16 0.6,0.64 0.29,0.12 0.41,-0.15 0.19,-0.22 0.13,-0.24 0.63,-0.61 0.16,-0.4 0.23,-0.29 0.97,-0.1 0.26,-0.15 1.09,-1.01 0.51,-0.64 0.59,-0.42 0.77,0.1 0.32,0.47 1.91,4.19 0.52,0.34 0.92,-0.09 3.84,-0.95 -1.44,-0.82 -2.22,-3.8 -1.37,-1.48 -6.21,-3.83 -1.41,0.78 -4.93,0.33 -0.42,0.01 -0.41,-0.1 -1.75,-0.54 -1.06,-0.46 -0.91,0.08 -0.85,0.19 -1.41,-0.26 -0.54,-0.02 -0.49,-0.16 -0.7,-1.19 -0.48,-0.31 -0.55,0.04 -0.56,0.39 -0.26,-0.79 -0.57,1.63 -1.18,0.16 -1.41,-0.38 -1.28,0.02 -0.79,0.82 -0.08,2.1 -0.89,1.05 -1.19,0.51 -5.39,1.08 -3.65,1.34 -1.03,0.22 -2.73,1.29 -2.08,0.24 -0.98,0.3 -1.84,1.72 -0.69,0.16 -0.74,-0.19 -1.1,-0.1 -0.48,0.18 -0.79,0.61 -0.52,0.04 -0.33,-0.26 -0.69,-0.95 -0.37,-0.34 -1,-0.08 -2.05,0.64 -0.78,-0.47 -0.21,-1.27 0.62,-1.2 1.02,-0.89 1.02,-0.37 1.86,-0.19 0.71,-0.35 0.83,-0.7 0.82,-0.97 0.32,-0.88 0.01,-2.57 0.06,-0.5 0.31,-1.54 -1.73,-0.21 -2.1,0.04 -3.37,-0.9 -5.81,-2.15 -2.17,0.07 -3.01,1.67 -0.81,-0.24 -0.81,-0.49 -1.16,-0.15 -1.2,0.12 -0.99,0.34 -0.76,0.57 -2.37,2.55 -0.53,0.25 -1.04,-0.4 -0.43,0.15 -1.85,1.46 -0.76,0.94 -0.83,1.78 -0.56,0.84 -0.98,0.67 -3.49,0.35 -3.46,2.1 -1.07,1.29 -1.2,0.42 -2.28,0.43 -1.93,1.19 -1.44,1.99 -2.26,4.72 -2.02,3.19 -0.3,1.17 -0.43,0.57 -7.23,1.08 -1.63,0.83 -3.35,-0.62 -2.18,0.45 -4.91,2 -1.91,1.32 -0.48,0.54 -0.7,1.07 -0.45,0.46 -1.64,0.95 -1.27,1.4 -14.07,10.509996 -1.89,0.79 -2.38,0.45 -2.36,0 -2.28,-0.51 -2.03,-1.07 -1.64,-1.72 -0.65,-1.06 -0.53,-1.14 -0.37,-1.24 -0.33,-2.79 -0.49,-1.219996 -2.75,-4.48 -0.42,-1.09 -0.15,-1.32 0,-2.49 -0.17,-0.71 -0.84,-1.31 -0.29,-0.65 -0.1,-0.74 0.1,-3.67 0.38,-2.5 0.28,-0.93 0.34,-0.55 -0.18,-1.46 1.79,-3.07 0.04,-1.7 0.29,-0.77 0.13,-1.28 -0.09,-2.57 -0.36,-2.35 0.15,-0.87 0.55,-1.37 0.47,-2.45 -0.69,-4.93 0.22,-2.68 0.17,-0.35 0.59,-0.81 0.23,-0.51 0.13,-0.62 0.23,-1.89 0.56,-1.91 0.08,-0.6 -0.11,-0.67 -0.45,-1.31 -0.08,-0.57 0.4,-1.1 1.79,-1.17 0.76,-1.08 0.19,-1.11 0.04,-1.46 -0.08,-1.34 -0.15,-0.74 0.36,-0.43 -1.47,-1.83 -1.47,-1 -1.74,-0.11 -5.92,2.04 -0.88,0.68 -0.96,0.53 -1.04,-0.45 -1.84,-1.5 -0.52,-0.07 -0.37,0.11 -0.25,-0.13 -0.18,-0.79 0.06,-0.65 0.49,-1.39 0.32,-1.57 1.45,-2.73 0.66,-2.52 0.9,-1.75 0.31,-1.8 0.88,-2.67 0.26,-1.4 -0.31,-2.74 -1.15,-1.82 -1.66,-1.11 -4,-1.6800003 -2.99,-3.12 -1.87,-1.38 -1.36,-0.7 -0.6,-0.14 -0.59,0.02 -0.38,0.17 -0.35,0.03 -0.5,-0.42 -0.32,-0.51 -0.41,-1.13 -0.28,-0.49 -0.49,-0.55 -0.5,-0.42999997 -0.56,-0.33 -0.62,-0.17 z"
        />
      <path
        id="AF-PKA"
        title="Paktika"
        
        d="m 408.15715,303.86119 -0.51,-0.1 -0.91,-0.51 -1.25,0.21 -3.54,1.31 -0.11,0.09 -3.38,3.02 -0.56,0.8 -0.51,1.62 -0.21,1.07 -0.31,0.95 -0.47,0.95 -0.56,0.86 -2.89,3.31 -4.54,3.4 -0.58,0.75 -0.37,0.73 -2.21,6.69 -2,2.12 -0.35,0.72 -0.6,0.99 -3.35,3.27 -0.58,0.5 -0.48,0.44 -0.09,0.23 -0.11,0.56 -0.08,0.92 -0.36,0.62 -1.28,1.33 -1.97,1.53 -0.64,0.37 -1.29,0.51 -1.29,0.27 -2.94,0.22 -0.63,0.15 -0.39,-0.04 -0.47,-0.19 -2,-1.28 -4.15,-4.11 -2.38,2.84 -1.95,3.51 -0.13,0.35 -0.05,0.25 0.02,0.26 1.03,1.16 4.49,3.43 0.39,1.35 0.45,0.61 1.42,0.94 2.14,2.09 0.25,0.17 1.02,0.46 0.16,0.12 0.18,0.19 0.19,0.37 0.96,3.03 0.32,1.79 0.2,0.63 0.09,0.46 -0.02,0.38 -0.4,1.07 -0.15,0.6 -0.01,0.63 0.35,2.35 -0.1,2.13 -0.48,0.68 -0.14,0.35 -0.09,0.46 0.1,0.66 0.64,2.39 0.06,0.49 0.01,0.49 -0.32,1.59 -1.3,3.03 0.83,2.7 0.37,2.12 0.03,0.43 -0.01,0.18 -0.15,0.54 -0.58,1.56 -0.86,2 -1.45,2.22 -0.19,0.43 -0.03,0.32 -0.02,0.35 0.05,0.88 0.15,1.14 0.13,0.57 0.15,0.52 0.23,0.52 0.26,0.44 0.37,0.43 0.86,0.71 1.79,1.07 0.34,0.25 0.01,0 0.3,-0.55 1.03,-2.43 0.62,-0.76 1,-0.07 1.24,0.44 1.07,0.59 1.23,1.01 0.51,0.76 0.6,0.6 1.06,0.16 1.92,-0.09 1.92,0.15 5.09,1.83 1.79,0.3 0.83,-0.27 1.05,-0.63 0.63,-0.72 -0.44,-0.51 -0.94,-0.13 -2.9,0.07 -1.06,-0.17 -0.84,-0.38 -0.17,-0.56 0.94,-0.74 2.1,-1.12 1.15,-0.4 1.08,-0.02 1.63,0.64 2.83,1.61 2.73,0.51 0.61,0.34 0.32,0.7 0.15,2.31 0.36,0.83 1.25,1.47 2.24,3.24 1.28,0.92 1.93,-0.23 3.08,-1.58 1.65,-0.53 1.76,0.12 1.29,-0.55 1.75,-1.25 1.53,-1.41 0.64,-1.02 0.74,-0.47 0.69,-0.79 5.31,-8.23 1.32,-1.43 2.32,-1.75 0.12,-0.21 0.17,-0.32 -0.13,-0.74 -1.52,-4.35 -0.95,-5.42 0.04,-1.24 0.37,-2.42 0.02,-2.43 0.34,-2.45 0.05,-1.25 -0.18,-1.2 -1.25,-3.21 -0.51,-2.47 0.23,-2.38 0.91,-2.18 1.47,-1.85 0.98,-0.64 2.01,-0.7 0.86,-0.72 2.56,-3.86 0.58,-1.12 0.15,-0.71 -0.48,-1.91 -0.09,-1.01 -0.13,-0.44 -0.34,-0.25 -0.41,-0.17 -0.43,-0.29 -0.34,-0.38 -0.25,-0.45 -0.09,-1.13 0.53,-0.77 1.64,-1.24 1.19,-1.67 1.25,-0.95 0.29,-0.27 0.48,-1.68 -0.91,-6.26 0.47,-0.99 -0.02,0 -4.56,-1.67 -1.86,-0.18 -0.22,-1.41 1.45,-1.65 1.42,-2.08 0.14,-0.47 0.02,-0.62 -0.19,-1.35 -0.19,-0.61 -0.18,-0.45 -0.09,-0.14 0.02,-0.65 0.53,-2.23 -0.97,-0.32 -0.19,-0.12 -0.34,-0.17 -0.78,0.08 -2.22,0.79 -0.88,0.13 -1.01,-0.2 -1.46,-1.16 -0.39,-0.32 -0.14,-0.14 -0.2,-0.15 -0.19,-0.09 -0.32,-0.08 -0.29,-0.02 -0.15,0.07 -0.11,0.15 0.01,0.36 0.04,0.24 0.04,0.18 0.02,0.16 -0.02,0.16 -0.4,0.41 -1.66,1.05 -2.39,1.08 -1.97,1.17 -1.31,1.25 -0.68,0.43 -0.72,0.3 -0.31,0.05 -0.16,0.01 -0.14,-0.03 -0.23,-0.38 -0.25,-1.32 -0.19,-0.64 0.01,-0.49 0.05,-0.28 0.02,-0.31 -0.42,-3.41 -0.04,-1.18 0.2,-2.74 -0.01,-0.6 -0.07,-0.39 -0.16,-0.32 -0.77,-1.06 -0.52,-1.02 -0.19,-0.21 -0.27,-0.21 -1.08,-0.49 -0.25,-0.04 -0.27,0.03 -0.37,0.16 -0.36,0.09 z"
        />
      <path
        id="AF-KHO"
        title="Khost"
        
        d="m 464.83715,285.70119 -2.61,-1.13 -0.74,-0.1 -0.01,0.85 -0.13,0.41 -0.23,0.46 -0.81,0.9 -0.33,0.22 -1.2,0.39 -1.4,0.85 -1.12,0.49 -0.8,0.51 -1.15,0.41 -0.38,0.05 -0.45,0.3 -0.26,0.23 -1.46,2.22 -0.8,-0.62 -0.07,-0.04 -0.13,-0.02 -3.34,0.33 -2.99,0.91 -0.73,0.36 -0.74,0.46 -1.49,1.25 -0.26,0.71 -0.78,1.51 -0.27,0.69 0.05,0.71 0.82,0.89 -1.14,3.7 -0.27,0.69 -0.46,0.73 -0.31,0.38 -1.12,0.67 -2.62,2.35 -0.25,0.39 -0.13,0.63 -0.2,0.72 -0.85,1.03 -0.66,0.74 -0.16,0.28 -0.24,1.19 -0.53,2.23 -0.02,0.65 0.09,0.14 0.18,0.45 0.19,0.61 0.19,1.35 -0.02,0.62 -0.14,0.47 -1.42,2.08 -1.45,1.65 0.22,1.41 1.86,0.18 4.56,1.67 0.02,0 0.46,-0.98 1.29,-1.64 1.61,-1.06 1.96,-0.26 0.99,0.02 1.57,-0.3 0.46,0.14 0.42,0.2 0.44,0.08 0.88,-0.22 2.28,-1.65 1.88,-0.31 3.25,1.62 2.05,-0.15 3.63,-2.22 0.48,-0.1 1.4,0.12 0.59,-0.26 0.37,-0.52 1.63,-3.09 0.57,-0.23 1.16,0.39 1.05,0.09 0.94,-0.54 8.23,-6.95 0.35,-1.91 -0.77,-1.8 -2.56,-2.89 -0.25,-0.43 -0.36,-0.93 -0.34,-0.31 -1.35,-0.45 -0.39,-0.25 -0.67,-0.89 -0.42,-1.05 -0.18,-1.12 0.08,-1.09 0.99,-3.68 0.03,-1.41 -0.18,-0.38 -0.38,-0.27 -0.8,-0.39 -0.44,-0.37 -0.21,-0.3 -0.29,-0.9 -0.41,-2.31 -0.48,-0.63 -2.07,0.37 z"
        />
      <path
        id="AF-GHA"
        title="Ghazni"
        
        d="m 358.21715,260.97119 -2.24,-0.17 -0.66,-0.16 -0.53,-0.27 -1.22,-1.16 -1.5,-1.04 -1.8,-0.69 -1.49,-0.34 -1.22,0.06 -3.29,0.7 -0.39,0.13 -0.43,0.23 -0.62,0.49 -0.32,0.32 -0.19,0.29 -0.29,1.34 -0.1,0.19 -0.24,0.18 -1.51,0.52 -0.81,0.01 -2.29,-0.31 -1.99,1.49 -0.63,0.8 -0.38,0.91 -0.21,0.4 -0.88,2.37 0.89,0.73 0.09,0.37 0.02,0.34 -0.31,0.6 -0.49,1.58 -0.14,0.24 -0.15,0.19 -0.52,0.45 -0.3,0.44 -0.03,0.29 0.12,0.24 0.54,0.35 0.7,0.35 0.08,0.06 0.25,0.39 0.34,0.88 0.66,2.12 -0.02,0.4 -0.17,0.3 -1.02,0.56 -0.36,0.25 -0.33,0.36 -1.66,2.39 -1.03,0.95 -3.06,2.66 -0.44,0.54 -0.55,0.82 -0.36,0.73 -0.76,1.02 -1.03,0.74 -0.98,0.52 -4.61,1.38 -0.27,0.03 -1.2,-0.05 -2.73,0.58 -4.31,1.76 -0.53,0.32 -0.21,0.19 -0.5,0.57 -0.68,1.71 -0.05,0.34 0.01,1.08 1.43,4.23 0.06,1.58 -0.18,0.48 -0.12,0.5 -0.1,0.65 -0.11,2.43 -0.05,0.32 -0.09,0.25 -0.14,0.24 -0.37,0.9 -0.35,2.68 0.73,1.85 1.26,0.23 4.95,-0.25 0.82,0.21 0.29,0.42 0.25,0.63 0.11,0.86 -0.02,0.56 -0.12,0.39 -0.16,0.17 -0.82,0.43 -0.27,0.22 -0.19,0.26 -0.36,0.64 -0.28,0.32 -1.69,1.23 -0.2,0.2 -0.11,0.21 -0.04,0.19 -0.09,0.68 -0.05,0.17 -0.15,0.82 0.08,1.62 -0.02,0.45 -0.1,0.31 -0.08,0.66 -0.02,0.94 0.22,2.07 0.22,1.03 0.33,0.91 0.4,0.59 0.44,0.42 0.59,0.28 2.34,0.54 0.58,0.23 1.5,0.01 0.26,-0.17 0.28,-0.21 0.12,-0.27 0.09,-0.3 0.61,-1.1 0.82,-1.17 0.33,-0.57 0.15,-0.42 -0.06,-0.24 -0.13,-0.26 -0.64,-1 -0.23,-0.44 -0.15,-0.42 -0.03,-0.51 0.09,-0.29 0.18,-0.2 0.24,-0.12 0.65,-0.21 1.34,-0.09 1.42,0.3 0.4,0.17 0.27,0.19 0.12,0.22 0.08,0.26 0.11,1.16 0.12,0.53 0.22,0.54 0.48,0.77 0.31,0.3 0.24,0.14 0.19,0.01 1.51,-0.2 0.49,-0.01 0.21,0.04 0.18,0.13 0.1,0.17 0.06,0.2 0.02,0.19 -0.03,0.43 0.05,0.25 0.15,0.12 0.68,0.21 0.28,0.2 0.42,0.4 0.22,0.11 0.29,-0.01 0.32,-0.1 1.51,0.01 0.32,-0.08 0.32,-0.13 0.25,-0.17 0.24,-0.24 0.43,-0.58 0.58,-0.96 0.79,-0.97 0.21,-0.16 0.3,-0.17 0.55,-0.08 0.24,0.05 0.11,0.14 -0.01,0.19 -0.06,0.2 -0.06,0.15 -0.19,0.33 -0.08,0.18 -0.04,0.15 0,0.13 0.03,0.06 0.05,0.08 0.28,0.31 0.19,0.27 0.09,0.14 0.13,0.27 0.11,0.33 0.08,0.37 0.01,0.33 -0.05,0.3 -0.12,0.27 -0.18,0.23 -0.2,0.21 -0.27,0.19 -1.85,1.03 -0.21,0.21 -0.11,0.27 0.04,0.32 0.25,0.45 0.3,0.22 1.7,0.69 0.39,0.3 0.26,0.3 0.12,0.24 0.05,0.2 -0.02,0.18 -0.08,0.15 -0.14,0.11 -0.21,0.07 -0.7,0.05 -0.17,0.07 -0.15,0.14 -0.14,0.2 -0.13,0.25 -0.1,0.27 -0.06,0.29 0,0.62 0.24,0.69 1.26,1.86 1.23,1.15 0.13,0.21 0.1,0.53 0.14,0.21 7.38,7.42 0.49,0.34 1.61,0.68 0.13,0.16 -0.06,0.19 -3.29,3.67 3.08,2.27 0.78,0.97 0.4,1.94 0.13,0.19 0.14,0.1 1.87,0.31 0.36,0.16 1.58,1.02 0.44,0.43 0.24,0.38 0.02,0.3 -0.05,0.31 -0.12,0.31 -0.22,0.34 -0.64,0.71 -0.82,0.76 -0.86,0.61 -1.33,0.66 -0.25,0.06 -0.2,0.02 -0.16,0 -0.48,-0.08 -0.74,-0.22 -0.18,0 -0.12,0.04 -0.19,0.12 -0.23,0.21 -0.28,0.32 -0.27,0.51 -0.19,0.59 -0.11,0.84 0.08,0.5 0.16,0.34 0.22,0.13 0.19,0.05 0.16,0 1.39,-0.43 0.28,-0.05 0.19,0 0.18,0.04 0.27,0.09 0.33,0.24 0.39,0.38 0.51,0.68 0.2,0.48 0.06,0.54 -0.34,2.19 -0.02,0.52 0.09,0.3 0.14,0.19 0.48,0.34 0.7,0.48 0.31,0.13 3.02,0.44 0.92,0.28 0.66,0.29 0.95,0.77 1.33,0.86 0.76,0.67 0.62,0.45 0.46,0.19 0.45,0.09 3.18,-0.08 0.3,-0.15 1.93,-1.29 1.3,-3.03 0.32,-1.59 -0.01,-0.49 -0.06,-0.49 -0.64,-2.39 -0.1,-0.66 0.09,-0.46 0.14,-0.35 0.48,-0.68 0.1,-2.13 -0.35,-2.35 0.01,-0.63 0.15,-0.6 0.4,-1.07 0.02,-0.38 -0.09,-0.46 -0.2,-0.63 -0.32,-1.79 -0.96,-3.03 -0.19,-0.37 -0.18,-0.19 -0.16,-0.12 -1.02,-0.46 -0.25,-0.17 -2.14,-2.09 -1.42,-0.94 -0.45,-0.61 -0.39,-1.35 -4.49,-3.43 -1.03,-1.16 -0.02,-0.26 0.05,-0.25 0.13,-0.35 1.95,-3.51 2.38,-2.84 4.15,4.11 2,1.28 0.47,0.19 0.39,0.04 0.63,-0.15 2.94,-0.22 1.29,-0.27 1.29,-0.51 0.64,-0.37 1.97,-1.53 1.28,-1.33 0.36,-0.62 0.08,-0.92 0.11,-0.56 0.09,-0.23 0.48,-0.44 0.58,-0.5 3.35,-3.27 0.6,-0.99 0.35,-0.72 2,-2.12 2.21,-6.69 0.37,-0.73 0.58,-0.75 4.54,-3.4 2.89,-3.31 0.56,-0.86 0.47,-0.95 0.31,-0.95 0.21,-1.07 0.51,-1.62 0.56,-0.8 3.38,-3.02 0.11,-0.09 0.28,-1 1.18,-2.61 0.06,-0.5 -0.11,-0.57 -0.43,-1.05 -0.58,-1.09 -0.19,-0.7 -0.12,-1.08 -0.09,-2.06 0.17,-2.12 0,-0.01 -0.14,-1.28 -0.35,-0.43 -0.04,-0.2 0.03,-0.67 -0.06,-0.22 -0.24,-0.2 -0.24,-0.17 -0.2,-0.24 -0.1,-0.31 0.1,-0.62 0.17,-0.46 0.2,-0.4 0.2,-0.19 0.19,-0.1 0.4,-0.08 0.12,-0.08 -0.03,-0.3 -0.16,-0.47 -0.45,-1 -0.38,-1.18 -0.07,-0.38 -0.24,-0.4 -0.19,-0.23 -1.46,-0.7 -1.16,1.14 -2.05,2.55 -0.33,0.27 -4.1,2.41 -0.42,0.17 -0.8,0.09 -0.51,0 -1.94,-0.48 -0.62,-0.28 -0.43,-0.3 -0.13,-0.15 -0.09,-0.13 -0.07,-0.37 0.01,-0.51 0.23,-0.96 0.4,-1.17 0.05,-0.46 0.01,-0.33 -0.45,-1.28 -1.08,0.04 -0.43,0.1 -0.48,0.04 -0.24,-0.01 -0.29,-0.15 -0.32,-0.28 -4.14,-4.37 -0.18,-0.29 -0.71,-0.77 -2.33,-1.45 -0.5,-0.86 -0.25,-0.2 -3.03,-1.23 -0.61,-0.17 -0.49,-0.32 -0.35,-1 -0.03,-0.82 -0.43,-1.46 -0.12,-0.59 -0.03,-0.51 0.07,-0.38 0.02,-0.43 -0.05,-0.43 -0.16,-0.64 -0.06,-0.51 -0.02,-0.49 0.08,-0.85 -0.03,-0.45 -0.48,-2.62 -0.25,-0.55 -0.39,-0.6 -1.46,-1.38 -0.72,-0.49 -1.06,-0.25 -0.69,0.45 -0.16,0.14 -0.34,0.19 -0.26,0.09 -0.7,0.58 -1.39,0.74 -3.09,1.08 -0.74,0.15 -0.64,0.04 z"
        />
      <path
        id="AF-ZAB"
        title="Zabul"
        
        d="m 326.08715,328.39119 -0.19,-0.01 -0.24,-0.14 -0.31,-0.3 -0.48,-0.77 -0.22,-0.54 -0.12,-0.53 -0.11,-1.16 -0.08,-0.26 -0.12,-0.22 -0.27,-0.19 -0.4,-0.17 -1.42,-0.3 -1.34,0.09 -0.65,0.21 -0.24,0.12 -0.18,0.2 -0.09,0.29 0.03,0.51 0.15,0.42 0.23,0.44 0.64,1 0.13,0.26 0.06,0.24 -0.15,0.42 -0.33,0.57 -0.82,1.17 -0.61,1.1 -0.09,0.3 -0.12,0.27 -0.28,0.21 -0.26,0.17 -1.5,-0.01 -0.2,3.41 -0.07,0.42 -0.16,0.59 -0.21,0.32 -0.33,0.6 -0.2,0.24 -0.26,0.15 -0.24,0.08 -0.37,0.25 -0.21,0.1 -0.33,0.04 -0.38,-0.04 -0.41,-0.09 -0.27,-0.11 -0.52,-0.33 -0.43,-0.17 -0.57,0.06 -0.86,0.67 -0.32,0.18 -0.29,0.08 -1.19,-0.06 -1.49,0.11 -0.68,0.17 -0.55,0.29 -0.32,0.32 -3.17,2.02 -0.83,0.66 -0.75,0.76 -0.78,1.06 -0.15,0.26 -0.08,0.27 -0.02,0.28 0.12,0.67 0,0.33 -0.33,0.45 -0.54,0.37 -1.14,0.55 -0.63,0.16 -0.43,0.01 -0.2,-0.12 -0.1,-0.1 -0.06,-0.09 -0.06,-0.19 -0.02,-0.25 0.08,-0.38 1.09,-3.35 0.11,-0.51 0.01,-0.31 -0.06,-0.18 -0.15,-0.14 -0.76,-0.08 -2.14,0.23 -1.46,2.77 -0.78,0.69 -2.38,0.35 -2.31,1.15 -0.4,0.38 -0.58,1.01 -0.62,0.84 -2.38,2.68 -0.43,0.63 -0.04,0.36 0.02,0.4 -0.01,0.5 -0.06,0.57 -0.58,1.18 -0.13,0.33 0.02,0.25 0.13,0.33 0.17,0.34 0.45,0.68 1.55,0.62 0.4,0.04 0.64,-0.01 0.35,-0.16 0.28,-0.24 1.02,-1.57 0.56,-1.36 0.2,-0.38 0.33,-0.45 0.21,-0.18 0.2,-0.06 0.16,0.05 0.17,0.07 0.18,0.05 0.2,-0.01 0.52,-0.09 0.35,0.05 0.2,0.15 0.14,0.2 0.18,0.38 0.12,0.15 0.15,0.14 0.56,0.37 0.33,0.31 0.16,0.09 0.48,0.15 0.35,0.19 0.24,0.28 0.11,0.32 -0.02,0.32 -0.19,0.55 -0.03,0.28 0.07,0.97 -0.01,0.33 -0.03,0.35 -0.55,2.62 -0.11,0.29 -0.48,0.94 -0.64,1.11 -0.2,0.18 -0.45,0.29 -1.74,0.89 -0.52,0.4 -0.36,0.4 -0.65,1.85 -0.27,0.56 -0.56,1 -0.78,0.96 -1.13,0.9 -1.2,1.24 -0.25,0.4 -0.29,0.56 -0.16,0.65 0,0.46 0.09,0.47 0.23,0.59 0.06,0.29 0.06,0.73 0.11,0.4 0.05,0.11 0.03,0.15 0.07,1.27 0.22,1.27 -0.03,0.29 -0.11,0.31 -0.67,1.19 -0.62,1.49 -0.05,0.36 0.08,0.28 0.21,0.17 0.54,0.36 0.42,0.35 0.34,1.23 0.03,1.45 -0.11,0.39 -0.59,1.44 -1.01,1.45 -0.45,0.54 -0.2,0.14 -0.25,0.14 -1.79,0.53 -1.18,0.64 -0.66,0.45 -1.61,1.54 0,1.41 0.14,0.44 0.26,0.56 0.22,0.27 0.18,0.17 1.57,1.03 3.91,4.12 0.11,0.06 0.31,0.01 1.94,-1.37 1.16,-1.23 0.62,-0.49 0.95,-0.57 0.9,-0.38 0.99,-0.2 0.23,0 0.2,0.08 0.21,0.13 0.51,0.07 0.72,0.02 2.16,-0.47 0.52,-0.23 6.17,-5.14 0.57,-0.61 0.21,-0.07 0.18,0.08 0.34,0.46 0.2,0.22 2.28,1.88 0.75,0.78 2.16,1.12 1.93,0.62 0.47,0.21 0.4,0.33 0.4,0.4 0.87,0.72 1.09,0.59 0.77,0.57 0.45,0.22 0.4,0.13 0.28,0.01 1.3,0.3 2.22,0.49 1.07,-0.13 3.41,-1.01 1.01,-0.59 2.07,-0.78 1.33,2.19 0.56,1.72 0.11,0.2 0.13,0.07 0.7,0.07 0.31,0.08 0.36,0.16 0.16,0.11 0.07,0.08 0.67,1.46 0.34,0.42 0.33,0.29 0.52,0.26 0.45,0.17 0.1,0.03 0.11,0 0.12,-0.08 0.17,-0.19 0.26,-0.68 0.14,-0.22 0.2,-0.12 0.79,0.21 2.16,1.24 1.03,1.9 0.19,0.87 -0.07,0.23 -0.4,0.8 -0.13,0.42 0.01,0.26 0.08,0.15 0.26,0.12 0.25,0.07 0.28,0.04 0.26,0.01 0.27,-0.02 1.53,-0.35 0.29,-0.02 3.29,0.15 0.8,-0.09 0.73,-0.18 2.6,-0.98 1.13,-0.02 1.8,0.18 0.39,0.09 2.45,1.23 0.02,0.01 1.59,-1.13 2.99,-3.37 1.35,-0.67 0.67,-0.03 1.47,0.25 1.97,-0.11 0.52,-0.28 0.55,-0.78 0.81,-0.66 2.55,-1.42 0.27,-0.4 0.16,-1.21 0.24,-0.51 1.6,-1.48 0.24,-0.44 -0.01,0 -0.34,-0.25 -1.79,-1.07 -0.86,-0.71 -0.37,-0.43 -0.26,-0.44 -0.23,-0.52 -0.15,-0.52 -0.13,-0.57 -0.15,-1.14 -0.05,-0.88 0.02,-0.35 0.03,-0.32 0.19,-0.43 1.45,-2.22 0.86,-2 0.58,-1.56 0.15,-0.54 0.01,-0.18 -0.03,-0.43 -0.37,-2.12 -0.83,-2.7 -1.93,1.29 -0.3,0.15 -3.18,0.08 -0.45,-0.09 -0.46,-0.19 -0.62,-0.45 -0.76,-0.67 -1.33,-0.86 -0.95,-0.77 -0.66,-0.29 -0.92,-0.28 -3.02,-0.44 -0.31,-0.13 -0.7,-0.48 -0.48,-0.34 -0.14,-0.19 -0.09,-0.3 0.02,-0.52 0.34,-2.19 -0.06,-0.54 -0.2,-0.48 -0.51,-0.68 -0.39,-0.38 -0.33,-0.24 -0.27,-0.09 -0.18,-0.04 -0.19,0 -0.28,0.05 -1.39,0.43 -0.16,0 -0.19,-0.05 -0.22,-0.13 -0.16,-0.34 -0.08,-0.5 0.11,-0.84 0.19,-0.59 0.27,-0.51 0.28,-0.32 0.23,-0.21 0.19,-0.12 0.12,-0.04 0.18,0 0.74,0.22 0.48,0.08 0.16,0 0.2,-0.02 0.25,-0.06 1.33,-0.66 0.86,-0.61 0.82,-0.76 0.64,-0.71 0.22,-0.34 0.12,-0.31 0.05,-0.31 -0.02,-0.3 -0.24,-0.38 -0.44,-0.43 -1.58,-1.02 -0.36,-0.16 -1.87,-0.31 -0.14,-0.1 -0.13,-0.19 -0.4,-1.94 -0.78,-0.97 -3.08,-2.27 3.29,-3.67 0.06,-0.19 -0.13,-0.16 -1.61,-0.68 -0.49,-0.34 -7.38,-7.42 -0.14,-0.21 -0.1,-0.53 -0.13,-0.21 -1.23,-1.15 -1.26,-1.86 -0.24,-0.69 0,-0.62 0.06,-0.29 0.1,-0.27 0.13,-0.25 0.14,-0.2 0.15,-0.14 0.17,-0.07 0.7,-0.05 0.21,-0.07 0.14,-0.11 0.08,-0.15 0.02,-0.18 -0.05,-0.2 -0.12,-0.24 -0.26,-0.3 -0.39,-0.3 -1.7,-0.69 -0.3,-0.22 -0.25,-0.45 -0.04,-0.32 0.11,-0.27 0.21,-0.21 1.85,-1.03 0.27,-0.19 0.2,-0.21 0.18,-0.23 0.12,-0.27 0.05,-0.3 -0.01,-0.33 -0.08,-0.37 -0.11,-0.33 -0.13,-0.27 -0.09,-0.14 -0.19,-0.27 -0.28,-0.31 -0.05,-0.08 -0.03,-0.06 0,-0.13 0.04,-0.15 0.08,-0.18 0.19,-0.33 0.06,-0.15 0.06,-0.2 0.01,-0.19 -0.11,-0.14 -0.24,-0.05 -0.55,0.08 -0.3,0.17 -0.21,0.16 -0.79,0.97 -0.58,0.96 -0.43,0.58 -0.24,0.24 -0.25,0.17 -0.32,0.13 -0.32,0.08 -1.51,-0.01 -0.32,0.1 -0.29,0.01 -0.22,-0.11 -0.42,-0.4 -0.28,-0.2 -0.68,-0.21 -0.15,-0.12 -0.05,-0.25 0.03,-0.43 -0.02,-0.19 -0.06,-0.2 -0.1,-0.17 -0.18,-0.13 -0.21,-0.04 -0.49,0.01 -1.51,0.2 z"
        />
      <path
        id="AF-KAN"
        title="Kandahar"
        
        d="m 252.11715,352.75119 -3.57,-0.68 -0.41,0.03 -0.31,0.07 -0.11,0.05 -0.14,0.11 -0.33,0.31 -1.72,2.18 -0.49,0.83 -0.23,0.67 -0.14,0.91 -0.18,0.68 -0.44,0.82 -0.37,0.47 -0.35,0.32 -0.21,0.12 -0.69,0.26 -0.84,0.42 -0.15,0.13 -0.11,0.13 -0.07,0.35 0,0.56 0.11,1.24 0.3,1.2 -0.01,0.24 -0.27,0.23 -0.46,0.26 -0.18,0.14 -0.09,0.09 -0.07,0.11 -0.08,0.23 -0.25,1 -0.16,0.31 -0.16,0.24 -0.11,0.14 0.01,0.29 0.03,0.24 0.76,1.5 -0.28,0.27 -0.42,0.12 -0.68,0.04 -0.64,-0.11 -0.71,-0.27 -1.84,-1.04 -0.75,-0.26 -2.59,0.13 -0.56,-0.08 -0.42,-0.23 -0.7,-0.87 -0.47,-0.13 -0.78,2.96 -0.02,0.26 -0.11,0.21 -0.19,0.16 -0.85,0.45 -1.39,1.29 -0.19,0.81 -0.04,0.36 -0.09,0.43 -0.39,0.95 -0.06,0.32 -0.06,0.63 -0.1,0.25 -0.2,0.22 -0.4,0.22 -0.16,0.13 -0.11,0.17 0.11,0.19 0.2,0.16 0.2,0.21 0,0.32 -0.13,0.46 -0.36,0.83 -0.71,2.6 -0.26,0.48 -0.33,0.22 -0.75,0.11 -0.97,-0.01 -0.47,-0.1 -0.4,-0.18 -0.79,-0.54 -0.39,-0.16 -0.74,-0.08 -0.44,0.11 -0.42,0.24 -0.81,0.63 -0.9,0.48 -0.28,0.09 -0.25,0.14 -0.25,0.25 -0.26,0.35 -0.35,0.64 -0.39,1.04 -0.04,1.93 -0.43,2.07 -0.26,0.52 -0.76,0.83 -2.14,2.09 -0.34,0.43 -0.84,0.71 -0.15,0.16 -0.12,0.27 -0.16,0.45 -0.92,4.8 -0.03,0.62 0.13,0.4 0.46,0.45 0.35,0.28 0.31,0.18 0.11,0.16 0.02,0.1 -0.4,0.74 -0.76,5.01 -0.09,0.31 -0.76,1.79 -1.47,5.52 -0.65,3.21 -0.69,8.84 -0.16,1.96 -2.17,28.09 -0.66,18.2 -1.43,10.8 -6.34,36.22 -0.02,0.3 0,0.01 8.94,0.08 6.62,0.05 8.06,1.47 2.42,0.08 7.03,-2.06 2.82,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.82 2.81,-0.82 2.82,-0.83 2.81,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.82 2.82,-0.83 2.82,-0.82 2.81,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.83 4.13,-1.21 3.86,-2.79 1.29,-1.71 1,-1.72 0.29,-0.17 0.41,-0.14 0.18,-0.26 -0.39,-0.53 -1.5,-1.16 -1.99,-2.03 -1.71,-1.2 -0.29,-0.75 0.12,-0.89 0.71,-2.12 3.13,-6.4 0.21,-1.07 -0.11,-3.4 0.91,-7.43 -0.11,-1.15 -0.28,-1.15 -0.37,-0.72 -1.17,-1.52 -0.83,-2.24 0.15,-2.45 4.77,-18.15 0.44,-0.78 0.82,-0.45 6.56,-1.34 1.09,-0.49 4.56,-4.7 0.93,-1.3 1.64,-6.39 1.18,-0.82 1.85,-0.26 1.25,-0.96 1.13,-1.3 1.45,-1.27 3.27,-1.61 1.82,-0.53 2.85,-0.06 0.71,0.38 0.35,0.79 0.1,1.26 -0.13,0.46 -0.27,0.35 -0.19,0.35 0.07,0.45 0.37,0.3 0.6,0.2 1.11,0.2 0.98,0.02 1.86,-0.47 0.97,-0.05 0.97,0.3 1.77,0.98 0.99,0.36 0.81,0.09 2.51,-0.12 3.11,0.28 0.89,-0.16 3.36,-1.44 2.88,-0.39 1.79,-0.78 2.59,-0.49 0.9,-0.33 3.09,-2 0.64,-0.58 0.67,-0.49 0.78,-0.23 1.96,0.07 0.75,-0.34 0.5,-1.07 -0.23,-2.38 -1.75,-0.57 -4.03,0.54 -0.96,-0.28 -0.97,-0.6 -0.7,-0.85 -0.28,-2.22 -0.64,-0.99 -0.71,-0.86 -0.35,-0.85 0.62,-1 1.53,-0.04 3.15,0.7 1.5,-0.15 1.47,-0.6 1.05,-0.74 -0.02,-0.01 -2.45,-1.23 -0.39,-0.09 -1.8,-0.18 -1.13,0.02 -2.6,0.98 -0.73,0.18 -0.8,0.09 -3.29,-0.15 -0.29,0.02 -1.53,0.35 -0.27,0.02 -0.26,-0.01 -0.28,-0.04 -0.25,-0.07 -0.26,-0.12 -0.08,-0.15 -0.01,-0.26 0.13,-0.42 0.4,-0.8 0.07,-0.23 -0.19,-0.87 -1.03,-1.9 -2.16,-1.24 -0.79,-0.21 -0.2,0.12 -0.14,0.22 -0.26,0.68 -0.17,0.19 -0.12,0.08 -0.11,0 -0.1,-0.03 -0.45,-0.17 -0.52,-0.26 -0.33,-0.29 -0.34,-0.42 -0.67,-1.46 -0.07,-0.08 -0.16,-0.11 -0.36,-0.16 -0.31,-0.08 -0.7,-0.07 -0.13,-0.07 -0.11,-0.2 -0.56,-1.72 -1.33,-2.19 -2.07,0.78 -1.01,0.59 -3.41,1.01 -1.07,0.13 -2.22,-0.49 -1.3,-0.3 -0.28,-0.01 -0.4,-0.13 -0.45,-0.22 -0.77,-0.57 -1.09,-0.59 -0.87,-0.72 -0.4,-0.4 -0.4,-0.33 -0.47,-0.21 -1.93,-0.62 -2.16,-1.12 -0.75,-0.78 -2.28,-1.88 -0.2,-0.22 -0.34,-0.46 -0.18,-0.08 -0.21,0.07 -0.57,0.61 -6.17,5.14 -0.52,0.23 -2.16,0.47 -0.72,-0.02 -0.51,-0.07 -0.21,-0.13 -0.2,-0.08 -0.23,0 -0.99,0.2 -0.9,0.38 -0.95,0.57 -0.62,0.49 -1.16,1.23 -1.94,1.37 -0.31,-0.01 -0.11,-0.06 -3.91,-4.12 -1.57,-1.03 -0.18,-0.17 -0.22,-0.27 -0.26,-0.56 -0.14,-0.44 0,-1.41 1.61,-1.54 0.66,-0.45 1.18,-0.64 1.79,-0.53 0.25,-0.14 0.2,-0.14 0.45,-0.54 1.01,-1.45 0.59,-1.44 0.11,-0.39 -0.03,-1.45 -0.34,-1.23 -0.42,-0.35 -0.54,-0.36 -0.21,-0.17 -0.08,-0.28 0.05,-0.36 0.62,-1.49 0.67,-1.19 0.11,-0.31 0.03,-0.29 -0.22,-1.27 -0.07,-1.27 -0.03,-0.15 -0.05,-0.11 -0.11,-0.4 -0.06,-0.73 -0.06,-0.29 -0.23,-0.59 -0.09,-0.47 0,-0.46 0.16,-0.65 0.29,-0.56 0.25,-0.4 1.2,-1.24 1.13,-0.9 0.78,-0.96 0.56,-1 0.27,-0.56 0.65,-1.85 0.36,-0.4 0.52,-0.4 1.74,-0.89 0.45,-0.29 0.2,-0.18 0.64,-1.11 0.48,-0.94 0.11,-0.29 0.55,-2.62 0.03,-0.35 0.01,-0.33 -0.07,-0.97 0.03,-0.28 0.19,-0.55 0.02,-0.32 -0.11,-0.32 -0.24,-0.28 -0.35,-0.19 -0.48,-0.15 -0.16,-0.09 -0.33,-0.31 -0.56,-0.37 -0.15,-0.14 -0.12,-0.15 -0.18,-0.38 -0.14,-0.2 -0.2,-0.15 -0.35,-0.05 -0.52,0.09 -0.2,0.01 -0.18,-0.05 -0.17,-0.07 -0.16,-0.05 -0.2,0.06 -0.21,0.18 -0.33,0.45 -0.2,0.38 -0.56,1.36 -1.02,1.57 -0.28,0.24 -0.35,0.16 -0.64,0.01 -0.4,-0.04 -1.55,-0.62 -1.16,0.76 -0.26,0.25 -0.52,0.23 -3.19,0.51 -0.53,0.15 -0.54,-0.13 -0.22,-0.2 -0.12,-0.2 -0.09,-0.14 -0.17,0 -0.23,0.13 -0.27,0.37 -0.1,0.29 -0.02,0.35 0.02,0.59 -0.02,0.17 -0.03,0.18 -0.11,0.28 -0.29,0.24 -1.58,0.27 -3,-0.35 -0.77,0.08 -0.46,-0.05 -0.43,-0.16 -0.37,-0.38 -0.51,-0.72 -0.08,-0.2 -0.11,-0.41 -0.08,-0.18 -0.63,-0.24 -2.26,-0.19 -2.54,-0.32 -0.82,-0.24 -0.37,-0.05 -1.11,0.12 -0.25,0 -1.57,-0.51 -0.43,-0.09 -0.35,-0.01 -0.51,0.13 -0.46,0.21 -0.23,0.14 -0.18,0.18 -0.17,0.2 -0.6,1.02 -0.18,0.24 -0.2,0.2 -0.23,0.15 -0.24,0.11 -0.79,0.2 -0.21,0 -0.15,-0.02 -0.05,-0.21 -0.04,-0.39 0.11,-1.6 -0.29,-3.29 0.1,-0.75 0.16,-0.5 0.13,-0.24 0.03,-0.18 -0.09,-0.21 -0.14,-0.04 -0.14,-0.01 -0.81,0.29 -0.62,0.04 z"
        />
      <path
        id="AF-DAY"
        title="Daykundi"
        
        d="m 283.39715,247.33119 -0.27,-0.04 -0.26,-0.13 -0.63,-0.6 -0.19,-0.14 -0.41,-0.22 -0.53,-0.2 -2.55,-0.46 -0.62,0.03 -0.4,0.18 -0.32,0.69 -0.17,0.26 -0.99,1.14 -0.36,0.28 -0.51,0.26 -0.5,0.05 -1.28,-0.17 -1.8,0.34 -0.32,-0.03 -0.97,-0.18 -1.81,-0.06 -0.35,0.06 -0.1,0.1 -0.66,0.82 -0.4,0.35 -0.54,0.35 -0.87,0.43 -0.58,0.15 -0.53,0.02 -3.08,-0.62 -6.45,-0.42 -3.66,-0.67 -1.83,-0.14 -4.5,0.17 -0.5,0.25 -0.5,1.89 -0.05,0.89 0.07,0.51 -0.12,0.47 -0.68,1.73 -0.22,0.85 -0.25,1.39 -0.04,0.54 0.04,0.37 0.1,0.11 0.13,0.13 0.14,0.16 0.11,0.3 -0.02,0.28 -0.6,1.16 -0.08,0.41 -0.01,0.46 0.03,0.64 -0.27,1.16 -0.28,0.86 -0.14,1.52 0.06,0.23 0.18,0.15 0.12,0.11 0.13,0.17 0.12,0.2 0.12,0.27 0.26,0.78 0.11,0.2 0.14,0.13 0.15,0.07 0.21,0.03 0.63,0.04 0.18,0.23 0.12,0.21 0.32,1.75 -0.27,1.38 -0.4,0.63 -0.58,0.33 -0.74,1.14 -0.3,1.08 -0.26,0.52 -0.19,0.28 -0.17,0.04 -0.88,0.1 -0.21,0.06 -0.15,0.07 -0.14,0.08 -0.25,0.2 -1.17,0.65 -0.22,0.23 -0.15,0.28 -0.06,0.36 -0.01,0.21 0.04,0.17 0.04,0.15 0.1,0.26 0.06,0.21 0.1,0.79 0.06,0.16 0.09,0.15 0.15,0.16 1.3,0.8 0.16,0.17 0.1,0.21 0.07,0.24 0.05,0.23 0.06,0.16 0.09,0.12 0.18,0.19 0.12,0.08 0.12,0.06 0.3,0.07 0.31,0.14 0.15,0.1 0.11,0.11 0.2,0.35 0.31,0.34 0.3,0.58 0.3,1.74 0.42,3.23 0.43,0.94 1.02,0.47 0.78,0.68 0.64,0.73 0.3,0.55 0.18,0.63 -0.03,0.28 -0.12,0.24 -1.22,0.93 -0.75,0.43 -0.68,0.31 -0.26,0.15 -1.61,1.43 -1.44,1.76 -1.6,1.33 -0.13,0.15 -0.1,0.15 -0.12,0.13 -0.14,0.11 -0.15,0.06 -0.16,0.04 -0.64,0.07 -0.18,0.05 -0.14,0.08 -0.11,0.11 -0.69,1.05 -0.12,0.28 0,0.19 0.1,0.11 0.22,0.17 0.05,0.17 0.02,0.13 -0.05,0.84 -1.92,1.03 -0.92,0.32 -1.34,0.27 -1.07,0.43 -0.76,0.5 -1.32,1.04 1,1.13 0.9,0.49 1.64,0.17 0.26,0.12 0.1,0.24 -0.04,0.28 -0.11,0.31 -0.11,0.26 -0.05,0.28 0.16,0.52 1.11,2.02 0.48,0.64 0.49,0.49 0.64,0.53 0.27,0.38 0.18,0.43 0.02,0.99 -0.06,0.47 -0.09,0.38 -0.12,0.32 -0.04,0.25 -0.01,0.63 -0.05,0.39 -0.19,0.67 -0.03,0.27 0.01,0.56 -0.1,0.51 -0.04,0.35 0.01,0.43 0.04,0.34 -0.01,0.84 1.5,0.32 1.43,0.95 0.41,0.19 0.28,0 0.12,-0.27 0.09,-0.36 0.17,-0.36 0.28,-0.26 0.63,-0.18 0.56,0.14 0.52,0.26 0.67,0.45 0.26,0.01 0.1,-0.19 -0.05,-0.49 -0.48,-1.73 -0.44,-1.19 -0.07,-0.29 0.12,-0.26 0.41,-0.09 3.95,0.19 0.52,0.1 0.47,0.15 0.45,0.21 2.85,1.88 0.34,0.06 0.33,-0.06 1.03,-0.41 0.49,-0.09 0.54,-0.04 0.44,0.04 1.64,0.37 0.35,-0.03 0.29,-0.13 0.2,-0.24 0.58,-1.02 0.47,-0.44 0.44,-0.11 0.3,0.02 0.45,0.41 1.84,1.91 1.25,0.7 6.07,1.38 1.46,0.36 0.77,-0.08 0.23,-0.2 0.23,-0.33 0.19,-0.44 0.05,-0.39 -0.01,-0.42 -0.07,-0.42 -0.02,-0.45 0.06,-0.57 0.62,-2.67 0.32,-0.88 0.36,-0.45 0.33,-0.31 1.36,-0.74 0.93,-0.29 1.45,-0.69 5.87,-4.42 0.96,-0.5 0.61,-0.2 0.41,-0.06 0.21,0.06 1.07,0.6 0.42,0.18 0.58,-0.04 0.73,-0.19 2.32,-0.93 0.68,-0.19 0.4,-0.01 0.31,0.04 0.2,0.08 0.17,0.14 0.64,1.02 0.13,0.31 0.08,0.33 0.04,0.32 0.07,0.29 0.21,0.42 0.49,0.79 0.58,0.72 1.36,0.34 3.45,-1.89 1.29,-0.45 1.01,-0.04 0.81,-0.17 0.53,-0.33 0.55,-0.53 0.98,-1.15 0.31,-0.18 0.17,0 0.15,0.22 0.18,1.15 0.26,0.97 0.19,0.24 0.33,0.16 0.8,0.06 0.6,-0.09 1.62,-0.53 0.35,-2.68 0.37,-0.9 0.14,-0.24 0.09,-0.25 0.05,-0.32 0.11,-2.43 0.1,-0.65 0.12,-0.5 0.18,-0.48 -0.06,-1.58 -1.43,-4.23 -0.01,-1.08 0.05,-0.34 0.68,-1.71 0.5,-0.57 0.21,-0.19 0.53,-0.32 4.31,-1.76 2.73,-0.58 1.2,0.05 0.27,-0.03 4.61,-1.38 0.98,-0.52 1.03,-0.74 0.76,-1.02 0.36,-0.73 0.55,-0.82 0.44,-0.54 3.06,-2.66 1.03,-0.95 1.66,-2.39 0.33,-0.36 0.36,-0.25 1.02,-0.56 0.17,-0.3 0.02,-0.4 -0.66,-2.12 -0.34,-0.88 -0.25,-0.39 -0.08,-0.06 -0.7,-0.35 -0.54,-0.35 -0.12,-0.24 0.03,-0.29 0.3,-0.44 0.52,-0.45 0.15,-0.19 0.14,-0.24 0.49,-1.58 0.31,-0.6 -0.02,-0.34 -0.09,-0.37 -0.89,-0.73 -0.7,0.86 -0.43,0.36 -0.44,0.29 -4.03,0.64 -1.62,0.46 -0.26,0.21 -0.2,0.22 -0.17,0.23 -0.37,0.73 -0.16,0.19 -0.35,0.28 -0.13,0.15 -0.12,0.09 -0.15,-0.02 -0.74,-0.87 -0.2,-0.17 -0.1,-0.05 -0.27,-0.03 -0.45,0.04 -0.79,0.22 -0.49,0.19 -2.75,1.69 -0.29,0.06 -0.36,-0.01 -1.83,-0.78 -0.25,-0.17 -0.08,-0.1 -0.12,-0.18 -0.12,-0.24 -0.16,-0.24 -0.24,-0.2 -0.37,-0.18 -8.61,-1.75 -0.82,0 -1.46,0.27 -0.64,0.27 -0.45,0.29 -0.2,0.2 -0.23,0.13 -0.59,0.15 -1.27,0.55 -1.06,-0.14 -2.78,-1.5 -2.78,-2.7 -0.5,-0.58 -0.18,-0.29 -0.13,-0.57 -0.02,-0.82 0.15,-1.74 0.33,-1.03 1.18,-2.54 0.11,-0.6 0.02,-0.38 -0.72,-1.88 -0.22,-2.17 0.08,-0.3 0.17,-0.31 0.3,-0.32 0.65,-0.56 0.26,-0.14 0.51,-0.18 0.22,-0.11 0.15,-0.17 0.09,-0.24 -0.02,-0.35 -0.1,-0.32 -0.29,-0.35 -0.36,-0.26 -0.61,-0.3 -1.54,-0.58 -1.73,-0.08 -0.35,-0.63 -0.48,-0.61 0.02,-0.28 0.04,-0.21 0.89,-1.22 -1.1,-0.43 -6.08,0.96 -0.44,0.18 -0.26,0.04 z"
        />
      <path
        id="AF-URU"
        title="Uruzgan"
        
        d="m 294.63715,313.85119 -1.36,-0.34 -0.58,-0.72 -0.49,-0.79 -0.21,-0.42 -0.07,-0.29 -0.04,-0.32 -0.08,-0.33 -0.13,-0.31 -0.64,-1.02 -0.17,-0.14 -0.2,-0.08 -0.31,-0.04 -0.4,0.01 -0.68,0.19 -2.32,0.93 -0.73,0.19 -0.58,0.04 -0.42,-0.18 -1.07,-0.6 -0.21,-0.06 -0.41,0.06 -0.61,0.2 -0.96,0.5 -5.87,4.42 -1.45,0.69 -0.93,0.29 -1.36,0.74 -0.33,0.31 -0.36,0.45 -0.32,0.88 -0.62,2.67 -0.06,0.57 0.02,0.45 0.07,0.42 0.01,0.42 -0.05,0.39 -0.19,0.44 -0.23,0.33 -0.23,0.2 -0.77,0.08 -1.46,-0.36 -6.07,-1.38 -1.25,-0.7 -1.84,-1.91 -0.45,-0.41 -0.3,-0.02 -0.44,0.11 -0.47,0.44 -0.58,1.02 -0.2,0.24 -0.29,0.13 -0.35,0.03 -1.64,-0.37 -0.44,-0.04 -0.54,0.04 -0.49,0.09 -1.03,0.41 -0.33,0.06 -0.34,-0.06 -2.85,-1.88 -0.45,-0.21 -0.47,-0.15 -0.52,-0.1 -3.95,-0.19 -0.41,0.09 -0.12,0.26 0.07,0.29 0.44,1.19 0.48,1.73 0.05,0.49 -0.1,0.19 -0.26,-0.01 -0.67,-0.45 -0.52,-0.26 -0.56,-0.14 -0.63,0.18 -0.28,0.26 -0.17,0.36 -0.09,0.36 -0.12,0.27 -0.28,0 -0.41,-0.19 -1.43,-0.95 -1.5,-0.32 -0.89,-0.13 -0.26,0.13 -0.38,0.28 -1.09,1.07 -0.27,0.34 -0.11,0.3 0.14,0.47 0.04,0.21 -0.02,0.29 -0.04,0.32 -0.18,0.49 -0.86,0.9 -0.57,0.46 -0.52,0.74 -2.88,5.22 -0.05,0.26 0,0.23 0.07,0.2 0.15,0.19 0.19,0.17 0.4,0.24 0.19,0.16 0.12,0.17 0.09,0.25 0.05,0.27 0.03,0.31 -0.05,0.51 -0.55,2.33 -0.05,0.46 0.03,0.32 0.08,0.23 0.15,0.24 0.12,0.51 0.13,0.39 -0.6,3.08 -0.87,1.9 0.07,0.16 0.14,0.19 0.35,0.05 0.37,0.2 0.48,0.34 0.21,0.06 0.21,0.01 0.75,-0.18 0.32,0.07 0.18,0.21 0.21,0.44 0.2,0.26 0.2,0.13 0.22,0.04 0.54,0.23 0.19,0.61 0.56,2.59 0.34,1.09 0.08,0.78 -0.08,0.48 -0.39,0.68 -0.73,0.89 -0.24,0.44 -0.06,0.28 0.05,0.25 0.1,0.2 0.16,0.46 0.13,0.63 0.14,1.26 0,0.71 -0.06,0.55 -0.15,0.78 -0.1,0.33 -0.15,0.32 -0.46,0.74 -0.4,1.31 -0.59,3.2 0.47,0.13 0.7,0.87 0.42,0.23 0.56,0.08 2.59,-0.13 0.75,0.26 1.84,1.04 0.71,0.27 0.64,0.11 0.68,-0.04 0.42,-0.12 0.28,-0.27 -0.76,-1.5 -0.03,-0.24 -0.01,-0.29 0.11,-0.14 0.16,-0.24 0.16,-0.31 0.25,-1 0.08,-0.23 0.07,-0.11 0.09,-0.09 0.18,-0.14 0.46,-0.26 0.27,-0.23 0.01,-0.24 -0.3,-1.2 -0.11,-1.24 0,-0.56 0.07,-0.35 0.11,-0.13 0.15,-0.13 0.84,-0.42 0.69,-0.26 0.21,-0.12 0.35,-0.32 0.37,-0.47 0.44,-0.82 0.18,-0.68 0.14,-0.91 0.23,-0.67 0.49,-0.83 1.72,-2.18 0.33,-0.31 0.14,-0.11 0.11,-0.05 0.31,-0.07 0.41,-0.03 3.57,0.68 0.62,-0.04 0.81,-0.29 0.14,0.01 0.14,0.04 0.09,0.21 -0.03,0.18 -0.13,0.24 -0.16,0.5 -0.1,0.75 0.29,3.29 -0.11,1.6 0.04,0.39 0.05,0.21 0.15,0.02 0.21,0 0.79,-0.2 0.24,-0.11 0.23,-0.15 0.2,-0.2 0.18,-0.24 0.6,-1.02 0.17,-0.2 0.18,-0.18 0.23,-0.14 0.46,-0.21 0.51,-0.13 0.35,0.01 0.43,0.09 1.57,0.51 0.25,0 1.11,-0.12 0.37,0.05 0.82,0.24 2.54,0.32 2.26,0.19 0.63,0.24 0.08,0.18 0.11,0.41 0.08,0.2 0.51,0.72 0.37,0.38 0.43,0.16 0.46,0.05 0.77,-0.08 3,0.35 1.58,-0.27 0.29,-0.24 0.11,-0.28 0.03,-0.18 0.02,-0.17 -0.02,-0.59 0.02,-0.35 0.1,-0.29 0.27,-0.37 0.23,-0.13 0.17,0 0.09,0.14 0.12,0.2 0.22,0.2 0.54,0.13 0.53,-0.15 3.19,-0.51 0.52,-0.23 0.26,-0.25 1.16,-0.76 -0.45,-0.68 -0.17,-0.34 -0.13,-0.33 -0.02,-0.25 0.13,-0.33 0.58,-1.18 0.06,-0.57 0.01,-0.5 -0.02,-0.4 0.04,-0.36 0.43,-0.63 2.38,-2.68 0.62,-0.84 0.58,-1.01 0.4,-0.38 2.31,-1.15 2.38,-0.35 0.78,-0.69 1.46,-2.77 2.14,-0.23 0.76,0.08 0.15,0.14 0.06,0.18 -0.01,0.31 -0.11,0.51 -1.09,3.35 -0.08,0.38 0.02,0.25 0.06,0.19 0.06,0.09 0.1,0.1 0.2,0.12 0.43,-0.01 0.63,-0.16 1.14,-0.55 0.54,-0.37 0.33,-0.45 0,-0.33 -0.12,-0.67 0.02,-0.28 0.08,-0.27 0.15,-0.26 0.78,-1.06 0.75,-0.76 0.83,-0.66 3.17,-2.02 0.32,-0.32 0.55,-0.29 0.68,-0.17 1.49,-0.11 1.19,0.06 0.29,-0.08 0.32,-0.18 0.86,-0.67 0.57,-0.06 0.43,0.17 0.52,0.33 0.27,0.11 0.41,0.09 0.38,0.04 0.33,-0.04 0.21,-0.1 0.37,-0.25 0.24,-0.08 0.26,-0.15 0.2,-0.24 0.33,-0.6 0.21,-0.32 0.16,-0.59 0.07,-0.42 0.2,-3.41 -0.58,-0.23 -2.34,-0.54 -0.59,-0.28 -0.44,-0.42 -0.4,-0.59 -0.33,-0.91 -0.22,-1.03 -0.22,-2.07 0.02,-0.94 0.08,-0.66 0.1,-0.31 0.02,-0.45 -0.08,-1.62 0.15,-0.82 0.05,-0.17 0.09,-0.68 0.04,-0.19 0.11,-0.21 0.2,-0.2 1.69,-1.23 0.28,-0.32 0.36,-0.64 0.19,-0.26 0.27,-0.22 0.82,-0.43 0.16,-0.17 0.12,-0.39 0.02,-0.56 -0.11,-0.86 -0.25,-0.63 -0.29,-0.42 -0.82,-0.21 -4.95,0.25 -1.26,-0.23 -0.73,-1.85 -1.62,0.53 -0.6,0.09 -0.8,-0.06 -0.33,-0.16 -0.19,-0.24 -0.26,-0.97 -0.18,-1.15 -0.15,-0.22 -0.17,0 -0.31,0.18 -0.98,1.15 -0.55,0.53 -0.53,0.33 -0.81,0.17 -1.01,0.04 -1.29,0.45 -3.45,1.89 z"
        />
      <path
        id="AF-NIM"
        title="Nimroz"
        
        d="m 146.70715,373.68119 -9.07,-2.23 -4.93,-0.26 -2.3,-0.61 -0.28,0 -0.34,0.03 -0.42,0.18 -0.45,0.3 -1.05,1.15 -0.42,0.65 -0.33,0.69 -0.47,1.31 -0.12,0.66 -0.13,4.25 -0.08,0.63 -0.2,0.68 -0.3,0.6 -0.47,0.7 -0.68,0.79 -0.89,0.84 -1.76,1.27 -0.78,0.35 -2.64,0.72 -2.7,0 -0.43,0.09 -4.43,1.7 -0.35,0.2 -0.99,0.71 -0.67,-0.31 -0.49,-0.31 -3.62,-4.09 -2.13,-2.43 -0.34,-0.23 -0.47,-0.24 -0.59,-0.2 -1.579997,-0.3 -0.97,-0.04 -0.64,0.04 -5.42,1.62 -20.14,1.28 -0.22,0.33 -0.06,0.14 -0.07,0.2 0,0.26 0.05,0.31 0.18,0.32 0.11,0.85 0.3,1.42 -0.03,0.47 -0.21,0.45 -0.66,0.62 -3.04,1.59 -0.43,0.4 -0.33,0.52 -0.21,0.66 -0.06,0.38 0.03,0.29 0.36,1.27 0.19,0.93 0,0.32 -0.02,0.28 -0.07,0.35 -0.35,0.61 -0.62,0.81 -1.48,1.62 -0.77,0.65 -1.18,1.34 -2.22,4.22 -1.57,2.07 -0.42,0.23 -0.59,0.26 -1.33,-0.12 -0.28,0.02 -0.24,0.08 -0.18,0.28 -0.1,0.43 0,0.77 0.17,0.82 0.09,0.16 0.29,0.44 0.14,0.29 0.09,0.37 -0.08,0.61 -0.26,0.49 -0.72,0.7 -0.45,0.21 -0.33,0.04 -0.13,-0.09 -0.11,-0.14 -0.08,-0.15 -0.05,-0.07 -0.07,-0.07 -0.11,0.01 -0.11,0.1 -0.19,0.25 -0.09,-0.04 -0.15,-0.41 -0.12,-0.2 -0.13,-0.12 -0.1,-0.07 -0.11,-0.03 -0.03,0.23 0.06,0.45 0.34,1.09 0.33,0.46 0.27,0.29 0.12,0.06 0.06,0.06 0.03,0.1 0,0.19 -0.07,0.25 -0.21,0.48 -0.05,0.33 0.12,0.41 0.12,0.33 -0.03,0.41 -0.38,0.54 -0.44,1.16 -0.19,0.46 -0.01,0.02 2.67,0.39 1.24,0.49 0.96,0.76 1.73,2.21 0.34,1.05 -0.34,2.44 0.02,1.13 0.47,1.16 1.3,2.15 0.41,1.28 0.08,1.66 0.12,0.59 0.85,1.8 0.59,1.85 0.24,1.12 0,1.11 -0.34,1.2 -0.93,1.83 0.21,0.66 0.18,3.87 -0.29,0.16 -0.12,0.4 -0.07,1.02 0.07,0.06 0.12,0.3 -0.83,0.88 -4,4.85 -6.13,7.42 -5.56,6.72 0,0.01 -3.94,4.74 -5.25,6.29 -2.74,3.29 -4.01,4.8 -7.5,8.96 -0.01,0.01 -3.69,4.33 -2.8,3.28 1.53,0.71 3.47,1.12 4.03,1.3 4.05,1.31 4.03,1.31 4.04,1.3 4.04,1.31 4.03,1.3 4.05,1.31 4.03,1.3 4.04,1.3 4.04,1.31 4.04,1.3 4.04,1.3 4.03,1.31 4.04,1.3 4.04,1.3 4.03,1.31 4.61,1.48 5,0.95 6.069997,-0.57 0,-0.02 5.74,-27.27 0.07,-2.49 -0.26,-2.58 0.06,-0.49 0.2,-0.5 1.26,-1.75 0.33,-0.66 0.17,-0.84 0.35,-4.01 -0.09,-2.8 0.17,-0.55 0.28,-0.42 0.3,-0.24 0.37,-0.18 0.42,-0.11 0.53,-0.08 0.41,-0.1 1.65,-0.95 1.97,-1.96 1.46,-1.83 2.05,-3.2 1.2,-2.29 0.65,-1.73 0.54,-1.1 0.61,-0.8 2.56,-1.89 0.75,-0.78 0.25,-0.61 0.04,-0.55 -0.13,-0.44 -0.2,-0.45 -0.26,-0.39 -0.66,-0.81 -0.3,-0.51 -0.16,-0.38 -0.06,-0.94 1.15,-1.73 0.02,-0.28 -0.04,-0.32 -0.69,-0.42 -0.36,-0.31 -0.33,-0.63 0.03,-0.42 0.29,-0.48 0.44,-0.45 1.64,-2.17 0.5,-0.51 0.48,-0.36 0.9,-0.49 0.41,-0.35 0.15,-0.38 0.01,-0.54 -0.46,-2.71 -0.05,-3.87 -0.15,-2.07 0.62,-0.73 1.89,-0.85 0.63,-0.43 0.88,-0.79 0.39,-0.53 0.48,-1.13 2.02,-3.87 0.38,-0.51 0.48,-0.38 1.05,-0.39 0.87,-1.08 0.12,-0.91 -0.03,-0.52 0.29,-4.99 -0.05,-0.65 -0.15,-0.39 -0.2,-0.41 -0.56,-0.87 -0.7,-2.11 0.12,-0.94 1.1,-1.34 0.54,-1.04 0.08,-5.98 2.58,-18.5 1.06,-3.16 2.01,-1.61 0.53,-0.62 0.77,-1.11 1.73,-3.62 0.27,-0.81 0.1,-0.63 -0.34,-1.32 -0.02,-0.48 0.13,-0.27 0.73,-0.73 0.71,-0.88 0.18,-0.48 -0.03,-0.37 -0.69,-0.68 -0.12,-0.24 -0.04,-0.27 0,-0.28 -0.05,-0.3 -0.13,-0.3 -0.38,-0.59 -0.07,-0.22 -0.03,-0.29 0.01,-0.5 -0.2,-0.84 -0.19,-2.01 -1.15,0.07 z"
        />
      <path
        id="AF-HEL"
        title="Helmand"
        
        d="m 174.82715,532.50119 1.32,-0.54 1.77,-3.46 1.1,-1.44 1.71,-0.87 13.09,-3.93 1.06,0.01 0,-0.01 0.02,-0.3 6.34,-36.22 1.43,-10.8 0.66,-18.2 2.17,-28.09 0.16,-1.96 0.69,-8.84 0.65,-3.21 1.47,-5.52 0.76,-1.79 0.09,-0.31 0.76,-5.01 0.4,-0.74 -0.02,-0.1 -0.11,-0.16 -0.31,-0.18 -0.35,-0.28 -0.46,-0.45 -0.13,-0.4 0.03,-0.62 0.92,-4.8 0.16,-0.45 0.12,-0.27 0.15,-0.16 0.84,-0.71 0.34,-0.43 2.14,-2.09 0.76,-0.83 0.26,-0.52 0.43,-2.07 0.04,-1.93 0.39,-1.04 0.35,-0.64 0.26,-0.35 0.25,-0.25 0.25,-0.14 0.28,-0.09 0.9,-0.48 0.81,-0.63 0.42,-0.24 0.44,-0.11 0.74,0.08 0.39,0.16 0.79,0.54 0.4,0.18 0.47,0.1 0.97,0.01 0.75,-0.11 0.33,-0.22 0.26,-0.48 0.71,-2.6 0.36,-0.83 0.13,-0.46 0,-0.32 -0.2,-0.21 -0.2,-0.16 -0.11,-0.19 0.11,-0.17 0.16,-0.13 0.4,-0.22 0.2,-0.22 0.1,-0.25 0.06,-0.63 0.06,-0.32 0.39,-0.95 0.09,-0.43 0.04,-0.36 0.19,-0.81 1.39,-1.29 0.85,-0.45 0.19,-0.16 0.11,-0.21 0.02,-0.26 0.78,-2.96 0.59,-3.2 0.4,-1.31 0.46,-0.74 0.15,-0.32 0.1,-0.33 0.15,-0.78 0.06,-0.55 0,-0.71 -0.14,-1.26 -0.13,-0.63 -0.16,-0.46 -0.1,-0.2 -0.05,-0.25 0.06,-0.28 0.24,-0.44 0.73,-0.89 0.39,-0.68 0.08,-0.48 -0.08,-0.78 -0.34,-1.09 -0.56,-2.59 -0.19,-0.61 -0.54,-0.23 -0.22,-0.04 -0.2,-0.13 -0.2,-0.26 -0.21,-0.44 -0.18,-0.21 -0.32,-0.07 -0.75,0.18 -0.21,-0.01 -0.21,-0.06 -0.48,-0.34 -0.37,-0.2 -0.35,-0.05 -0.14,-0.19 -0.07,-0.16 0.87,-1.9 0.6,-3.08 -0.13,-0.39 -0.12,-0.51 -0.15,-0.24 -0.08,-0.23 -0.03,-0.32 0.05,-0.46 0.55,-2.33 0.05,-0.51 -0.03,-0.31 -0.05,-0.27 -0.09,-0.25 -0.12,-0.17 -0.19,-0.16 -0.4,-0.24 -0.19,-0.17 -0.15,-0.19 -0.07,-0.2 0,-0.23 0.05,-0.26 2.88,-5.22 0.52,-0.74 0.57,-0.46 0.86,-0.9 0.18,-0.49 0.04,-0.32 0.02,-0.29 -0.04,-0.21 -0.14,-0.47 0.11,-0.3 0.27,-0.34 1.09,-1.07 0.38,-0.28 0.26,-0.13 0.89,0.13 0.01,-0.84 -0.04,-0.34 -0.01,-0.43 0.04,-0.35 0.1,-0.51 -0.01,-0.56 0.03,-0.27 0.19,-0.67 0.05,-0.39 0.01,-0.63 0.04,-0.25 0.12,-0.32 0.09,-0.38 0.06,-0.47 -0.02,-0.99 -0.18,-0.43 -0.27,-0.38 -0.64,-0.53 -0.49,-0.49 -0.48,-0.64 -1.11,-2.02 -0.16,-0.52 0.05,-0.28 0.11,-0.26 0.11,-0.31 0.04,-0.28 -0.1,-0.24 -0.26,-0.12 -1.64,-0.17 -0.9,-0.49 -1,-1.13 -1.81,-0.17 -0.53,0.03 -0.59,0.16 -2.09,1.33 -0.81,0.71 -0.55,0.64 -0.24,0.22 -4.22,1.99 -0.13,0.16 -0.11,0.13 -1.33,0.92 -0.48,0.48 -0.36,0.17 -0.43,0.02 -0.88,-0.18 -0.41,-0.21 -0.34,-0.21 -0.29,-0.07 -0.36,0.16 -0.64,0.56 -1.58,1.73 -0.34,0.31 -0.3,0.17 -0.35,0.15 -0.3,0.08 -0.34,0 -0.65,-0.11 -0.26,-0.24 -0.14,-0.19 -0.13,-1.43 -0.04,-0.2 -0.07,-0.2 -0.08,-0.17 -0.61,0.04 -2.17,1.07 0.37,0.59 0.15,0.17 0.12,0.18 0.01,0.17 -0.12,0.21 -1.56,1.4 -0.2,0.38 -0.13,0.49 0,0.79 0.05,0.41 0.07,0.25 0.79,0.43 -4.38,3.36 -0.54,0.49 -0.38,0.6 -0.42,0.52 -0.94,0.96 -0.48,0.59 -0.29,0.59 0.01,0.28 0.09,0.17 0.12,0.08 0.15,0.05 0.09,0.11 0.06,0.18 -0.09,0.32 -0.22,0.41 -0.51,0.76 -0.46,1.02 -0.24,0.43 -0.06,0.23 -0.01,0.12 0.04,0.06 0.15,0.11 1.16,0.48 0.27,0.17 0.19,0.17 0.08,0.2 -0.03,0.24 -0.22,0.29 -0.35,0.27 -6.32,2.49 -1.13,0.2 -0.39,0.16 -0.49,0.34 -0.49,0.44 -0.58,0.88 -0.77,0.82 -0.77,1.17 -0.17,0.34 -0.03,0.22 0.03,0.22 0.06,0.22 -0.23,0.37 -0.49,0.47 -1.99,1.41 -0.81,0.9 -0.46,0.89 -0.15,0.65 0.05,0.24 0.09,0.13 0.17,0.1 0.69,0.23 0.98,0.57 0.2,0.17 0.09,0.21 -0.05,0.29 -0.3,0.65 -0.07,0.3 0.01,0.35 0.05,0.38 -0.43,0.49 -0.84,0.59 -2.26,1.08 -1.61,1.02 -0.49,0.15 -2.49,0.1 -3.49,0.71 -0.51,0.03 -0.33,-0.07 -0.09,-0.17 -0.07,-0.22 -0.08,-0.44 -0.05,-0.08 -0.06,-0.05 -0.09,-0.02 -0.15,0.02 -0.2,0.07 -0.31,0.15 -0.47,0.4 -0.2,0.19 -0.17,0.41 -0.04,1.18 0.09,1.3 0.07,0.27 0.11,0.24 0.48,0.52 0.19,0.39 0.2,0.56 0.16,0.57 0.03,0.52 -0.13,0.44 -0.31,0.3 -0.73,0.34 -0.69,0.42 -0.7,0.61 -0.35,0.47 -0.26,0.43 -0.28,0.3 -0.26,0.12 -0.39,-0.16 -0.43,-0.43 -0.23,0.02 -0.37,0.23 -3.44,2.78 -0.27,0.31 -0.17,0.32 -0.06,0.34 -0.03,0.42 -0.14,0.32 -0.3,0.19 -0.69,0.06 -1.55,-0.4 -0.47,-0.02 -0.4,0.06 -1.11,0.35 -0.3,0.03 -0.34,0.09 -0.47,0.24 -2.68,2.81 -0.57,0.48 -0.87,0.54 -3.79,1.82 -1.15,0.95 0.19,2.01 0.2,0.84 -0.01,0.5 0.03,0.29 0.07,0.22 0.38,0.59 0.13,0.3 0.05,0.3 0,0.28 0.04,0.27 0.12,0.24 0.69,0.68 0.03,0.37 -0.18,0.48 -0.71,0.88 -0.73,0.73 -0.13,0.27 0.02,0.48 0.34,1.32 -0.1,0.63 -0.27,0.81 -1.73,3.62 -0.77,1.11 -0.53,0.62 -2.01,1.61 -1.06,3.16 -2.58,18.5 -0.08,5.98 -0.54,1.04 -1.1,1.34 -0.12,0.94 0.7,2.11 0.56,0.87 0.2,0.41 0.15,0.39 0.05,0.65 -0.29,4.99 0.03,0.52 -0.12,0.91 -0.87,1.08 -1.05,0.39 -0.48,0.38 -0.38,0.51 -2.02,3.87 -0.48,1.13 -0.39,0.53 -0.88,0.79 -0.63,0.43 -1.89,0.85 -0.62,0.73 0.15,2.07 0.05,3.87 0.46,2.71 -0.01,0.54 -0.15,0.38 -0.41,0.35 -0.9,0.49 -0.48,0.36 -0.5,0.51 -1.64,2.17 -0.44,0.45 -0.29,0.48 -0.03,0.42 0.33,0.63 0.36,0.31 0.69,0.42 0.04,0.32 -0.02,0.28 -1.15,1.73 0.06,0.94 0.16,0.38 0.3,0.51 0.66,0.81 0.26,0.39 0.2,0.45 0.13,0.44 -0.04,0.55 -0.25,0.61 -0.75,0.78 -2.56,1.89 -0.61,0.8 -0.54,1.1 -0.65,1.73 -1.2,2.29 -2.05,3.2 -1.46,1.83 -1.97,1.96 -1.65,0.95 -0.41,0.1 -0.53,0.08 -0.42,0.11 -0.37,0.18 -0.3,0.24 -0.28,0.42 -0.17,0.55 0.09,2.8 -0.35,4.01 -0.17,0.84 -0.33,0.66 -1.26,1.75 -0.2,0.5 -0.06,0.49 0.26,2.58 -0.07,2.49 -5.74,27.27 0,0.02 1.39,-0.13 2.38,-0.23 2.38,-0.22 2.37,-0.23 2.38,-0.22 2.38,-0.22 2.38,-0.23 2.38,-0.22 2.38,-0.23 2.37,-0.23 2.38,-0.22 2.38,-0.22 2.38,-0.23 2.37,-0.22 2.38,-0.23 2.38,-0.22 2.39,-0.23 7.4,-0.69 10.64,2.05 8.92,1.73 5.54,2.39 z"
        />
      <path
        id="AF-FRA"
        title="Farah"
        
        d="m 181.77715,318.36119 -0.3,-0.3 -0.37,-0.58 -1.43,-2.83 -0.38,-0.51 -0.68,-0.55 -0.17,-0.19 -0.15,-0.32 -0.17,-0.54 -0.18,-0.27 -0.32,-0.18 -0.53,-0.01 -0.41,-0.14 -0.67,-0.29 -0.16,-0.2 -0.14,-0.3 -0.02,-0.53 0.07,-0.62 0,-0.24 -0.14,-0.67 -0.05,-0.34 0.03,-0.94 -0.15,-0.47 -1.49,-3.51 -2.76,-4.53 -0.8,-0.75 -1.76,-0.95 -1.22,0.13 -2.18,1.02 -0.92,0.69 -0.69,0.63 -0.96,1.2 -0.76,1.19 -0.61,0.53 -0.78,0.3 -3.26,0.34 -2.05,0.47 -1.54,0.62 -0.99,0.6 -1.86,1.53 -1.95,0.78 -2.53,0.5 -9.82,0.4 -3.68,1.16 -0.67,0.09 -1.63,-0.05 -1.6,-0.67 -0.84,0.65 -1.1,0.52 -0.37,0.28 -0.46,0.75 -0.54,1.15 -0.84,2.3 -0.29,1.04 -0.12,0.74 0.02,0.27 -0.13,0.37 -0.12,0.22 -1.3,1.31 -4.24,1.59 -0.17,-0.04 -0.15,-0.07 -0.06,-0.06 -0.07,-0.11 -0.03,-0.14 0,-0.18 0.04,-0.19 0.12,-0.42 0.03,-0.14 -0.06,-0.08 -0.15,-0.01 -1.18,0.21 -4.03,1.43 -0.73,0.16 -0.64,0.07 -1.92,-0.13 -0.26,0.11 -0.29,0.27 -0.32,0.57 -0.12,0.54 -0.18,0.44 -0.26,0.41 -0.54,0.46 -0.73,0.42 -1.97,0.66 -2.5,0.48 -0.41,0.01 -0.37,-0.05 -0.3,-0.08 -1.29,-0.7 -0.219997,-0.08 -0.22,-0.06 -0.29,0.01 -0.4,0.06 -0.63,0.21 -1.99,1.01 -1.42,0.96 -1.25,1.04 -0.78,0.49 -0.31,0.29 -0.32,0.48 -0.29,0.94 -0.06,0.62 0.03,0.47 0.14,0.63 0.02,0.31 -0.03,0.29 -0.11,0.42 -1.13,2.44 -0.18,0.49 -0.04,0.37 0.14,0.89 0,0.15 -0.17,0.13 -0.34,0.06 -0.94,-0.15 -1.1,-0.04 -1.84,0.36 -3.97,0.41 -1.42,0.31 -0.77,0.31 -0.36,0.26 -1.47,1.36 -0.72,0.39 -0.41,0.17 -0.68,0.07 -0.71,-0.07 -0.33,-0.07 -0.29,-0.13 -0.2,-0.29 -0.13,-0.26 -0.17,-0.51 -0.11,-0.21 -0.29,-0.45 -0.08,-0.19 -0.04,-0.24 -0.01,-0.21 0.03,-0.25 0,-0.22 -0.03,-0.22 -0.28,-0.84 -0.12,-0.7 -0.1,-1.54 -0.1,-0.16 -0.16,-0.11 -0.3,-0.05 -0.4,0.02 -0.79,0.35 -2.46,1.81 -1.28,1.47 -0.53,0.57 -0.31,0.23 -0.39,0.2 -0.32,0.06 -0.24,-0.02 -0.22,-0.08 -0.24,-0.15 -0.41,-0.33 -1.8,-1.84 -0.51,-0.91 -0.32,-0.42 -0.36,-0.21 -0.5,-0.11 -2.89,-0.11 -0.52,-0.16 -0.49,-0.21 -0.39,-0.29 -0.3,-0.68 -0.1,-0.94 0.06,-2.05 0.27,-1.89 0.28,-0.88 0.21,-0.33 0.28,-0.26 1.08,-0.66 0.28,-0.24 0.2,-0.25 0.14,-0.28 0.13,-0.37 0.17,-0.32 0.22,-0.28 0.64,-0.51 1.63,-1.66 0.53,-0.75 0.31,-0.36 0.47,-0.43 1.33,-1.02 0.46,-0.6 0.04,-0.64 -2.19,-3.52 -1.9,-2.09 -0.23,-0.47 0.01,-0.52 0.15,-0.26 0.45,-0.41 0.22,-0.25 0.4,-0.61 0.24,-0.25 0.7,-0.52 0.88,-0.91 0.25,-0.39 0.13,-0.38 0.08,-0.46 0.02,-2.48 0.05,-0.5 0.12,-0.38 0.18,-0.27 0.7,-0.68 0.22,-0.31 0.17,-0.43 0.07,-0.48 0.01,-0.6 -0.1,-0.41 -0.47,-0.39 -3.21,-0.74 -3.65,-0.27 -1.48,0.1 -0.88,-0.07 -0.66,-0.74 -2.31,-0.48 -2.22,-0.1 -1.09,0.21 -0.5,0.28 -0.34,0.44 -0.24,0.57 -0.31,0.56 -0.41,0.4 -0.57,0.35 -1.33,0.46 -0.66,0.06 -0.52,-0.05 -1.01,-0.45 -0.56,-0.14 -0.89,0 -6.99,0.75 -3.29,-0.27 -6.42,-1.45 -2.77,-1.21 -1.71,-0.2 -0.97,-0.11 -0.38,0.64 -0.71,0.26 -2.3,0.16 -0.86,0.57 -0.14,0.84 0.17,0.97 0.09,1 -0.27,1.16 -0.51,0.66 -1.59,0.99 -1.4,1.25 -1.84,2.51 -2.3599997,3.21 -2.64,3.57 -2.34,3.18 -0.3,0.81 0.07,4.58 0.71,3.69 1.39,4.74 1.64,5.6 1.69,5.76 1.7799997,6.06 1.97,6.66 2.14,7.97 1.65,6.14 -0.1,4.67 -0.65,4.56 -0.29,0.95 -1.27,1.64 -0.38,0.88 0.17,0.35 0.4,0.24 0.29,0.32 -0.42,1.26 0.1,0.59 0.24,0.56 0.19,0.61 0.09,1.24 -0.36,3.53 0.1,2.77 0.68,5.28 -0.62,4.21 0.11,1.33 0.73,2.76 0.57,5.33 1.62,0.68 4.89,0.72 8.13,1.19 0.08,0.01 8.23,1.21 9.51,1.39 5.59,0.82 0.01,-0.02 0.19,-0.46 0.44,-1.16 0.38,-0.54 0.03,-0.41 -0.12,-0.33 -0.12,-0.41 0.05,-0.33 0.21,-0.48 0.07,-0.25 0,-0.19 -0.03,-0.1 -0.06,-0.06 -0.12,-0.06 -0.27,-0.29 -0.33,-0.46 -0.34,-1.09 -0.06,-0.45 0.03,-0.23 0.11,0.03 0.1,0.07 0.13,0.12 0.12,0.2 0.15,0.41 0.09,0.04 0.19,-0.25 0.11,-0.1 0.11,-0.01 0.07,0.07 0.05,0.07 0.08,0.15 0.11,0.14 0.13,0.09 0.33,-0.04 0.45,-0.21 0.72,-0.7 0.26,-0.49 0.08,-0.61 -0.09,-0.37 -0.14,-0.29 -0.29,-0.44 -0.09,-0.16 -0.17,-0.82 0,-0.77 0.1,-0.43 0.18,-0.28 0.24,-0.08 0.28,-0.02 1.33,0.12 0.59,-0.26 0.42,-0.23 1.57,-2.07 2.22,-4.22 1.18,-1.34 0.77,-0.65 1.48,-1.62 0.62,-0.81 0.35,-0.61 0.07,-0.35 0.02,-0.28 0,-0.32 -0.19,-0.93 -0.36,-1.27 -0.03,-0.29 0.06,-0.38 0.21,-0.66 0.33,-0.52 0.43,-0.4 3.04,-1.59 0.66,-0.62 0.21,-0.45 0.03,-0.47 -0.3,-1.42 -0.11,-0.85 -0.18,-0.32 -0.05,-0.31 0,-0.26 0.07,-0.2 0.06,-0.14 0.22,-0.33 20.14,-1.28 5.42,-1.62 0.64,-0.04 0.97,0.04 1.579997,0.3 0.59,0.2 0.47,0.24 0.34,0.23 2.13,2.43 3.62,4.09 0.49,0.31 0.67,0.31 0.99,-0.71 0.35,-0.2 4.43,-1.7 0.43,-0.09 2.7,0 2.64,-0.72 0.78,-0.35 1.76,-1.27 0.89,-0.84 0.68,-0.79 0.47,-0.7 0.3,-0.6 0.2,-0.68 0.08,-0.63 0.13,-4.25 0.12,-0.66 0.47,-1.31 0.33,-0.69 0.42,-0.65 1.05,-1.15 0.45,-0.3 0.42,-0.18 0.34,-0.03 0.28,0 2.3,0.61 4.93,0.26 9.07,2.23 1.15,-0.07 1.15,-0.95 3.79,-1.82 0.87,-0.54 0.57,-0.48 2.68,-2.81 0.47,-0.24 0.34,-0.09 0.3,-0.03 1.11,-0.35 0.4,-0.06 0.47,0.02 1.55,0.4 0.69,-0.06 0.3,-0.19 0.14,-0.32 0.03,-0.42 0.06,-0.34 0.17,-0.32 0.27,-0.31 3.44,-2.78 0.37,-0.23 0.23,-0.02 0.43,0.43 0.39,0.16 0.26,-0.12 0.28,-0.3 0.26,-0.43 0.35,-0.47 0.7,-0.61 0.69,-0.42 0.73,-0.34 0.31,-0.3 0.13,-0.44 -0.03,-0.52 -0.16,-0.57 -0.2,-0.56 -0.19,-0.39 -0.48,-0.52 -0.11,-0.24 -0.07,-0.27 -0.09,-1.3 0.04,-1.18 0.17,-0.41 0.2,-0.19 0.47,-0.4 0.31,-0.15 0.2,-0.07 0.15,-0.02 0.09,0.02 0.06,0.05 0.05,0.08 0.08,0.44 0.07,0.22 0.09,0.17 0.33,0.07 0.51,-0.03 3.49,-0.71 2.49,-0.1 0.49,-0.15 1.61,-1.02 2.26,-1.08 0.84,-0.59 0.43,-0.49 -0.05,-0.38 -0.01,-0.35 0.07,-0.3 0.3,-0.65 0.05,-0.29 -0.09,-0.21 -0.2,-0.17 -0.98,-0.57 -0.69,-0.23 -0.17,-0.1 -0.09,-0.13 -0.05,-0.24 0.15,-0.65 0.46,-0.89 0.81,-0.9 1.99,-1.41 0.49,-0.47 0.23,-0.37 -0.06,-0.22 -0.03,-0.22 0.03,-0.22 0.17,-0.34 0.77,-1.17 0.77,-0.82 0.58,-0.88 0.49,-0.44 0.49,-0.34 0.39,-0.16 1.13,-0.2 6.32,-2.49 0.35,-0.27 0.22,-0.29 0.03,-0.24 -0.08,-0.2 -0.19,-0.17 -0.27,-0.17 -1.16,-0.48 -0.15,-0.11 -0.04,-0.06 0.01,-0.12 0.06,-0.23 0.24,-0.43 0.46,-1.02 0.51,-0.76 0.22,-0.41 0.09,-0.32 -0.06,-0.18 -0.09,-0.11 -0.15,-0.05 -0.12,-0.08 -0.09,-0.17 -0.01,-0.28 0.29,-0.59 0.48,-0.59 0.94,-0.96 0.42,-0.52 0.38,-0.6 0.54,-0.49 4.38,-3.36 -0.79,-0.43 -0.07,-0.25 -0.05,-0.41 0,-0.79 0.13,-0.49 0.2,-0.38 1.56,-1.4 0.12,-0.21 -0.01,-0.17 -0.12,-0.18 -0.15,-0.17 -0.37,-0.59 -1.51,-1.12 -0.36,-0.74 -0.05,-0.35 -0.06,-0.3 -0.08,-0.24 -0.12,-0.19 -0.33,-0.16 -0.55,-0.13 -1.68,-0.03 -0.34,0.05 -0.14,0.05 -0.16,0.02 -0.3,-0.07 -0.39,-0.16 -0.6,-0.42 -0.44,-0.49 -0.15,-0.23 -0.18,-0.53 -0.07,-0.15 -0.11,-0.11 -0.11,-0.08 -0.16,-0.07 -0.55,-0.07 -0.83,0.19 -0.54,0.57 -1.11,2.92 -0.73,1.29 -0.45,0.56 -0.49,0.46 -0.63,0.48 -0.92,0.57 -0.85,0.4 -1.34,0.3 -0.25,0.11 -0.22,0.16 -0.11,0.14 -0.03,0.13 0.03,0.12 0.12,0.17 1.01,1.06 0.14,0.23 0.09,0.24 -0.02,0.18 -0.08,0.16 -0.15,0.12 -0.21,0.1 -0.29,0.08 -1.32,0.08 -0.42,0.08 -0.17,0.07 -0.21,0.13 -0.53,0.46 -0.14,0.05 -0.24,-0.04 -2.09,-1.15 -1.12,-1.07 -0.27,-0.15 -0.35,0 -0.67,0.26 -0.21,0.04 z"
        />
      <path
        id="AF-SAR"
        title="Sari Pul"
        
        d="m 294.82715,140.68119 -0.77,-0.15 -0.31,-0.18 -2.01,-1.64 -1.48,-0.75 -0.19,-0.25 -0.04,-0.2 0.1,-0.32 0.1,-0.23 0.62,-0.79 1.59,-2.47 0.27,-0.52 0.53,-0.82 0.13,-0.26 0.25,-0.76 1.16,-2.51 0.15,-0.47 0.24,-1.29 0.09,-0.33 0.12,-0.28 0.85,-1.56 0.54,-0.77 0.23,-0.27 1.15,-1.05 0.33,-0.48 0.56,-1.01 0.18,-0.23 0.44,-0.46 0.18,-0.25 0.61,-1.17 0.1,-0.27 0.09,-0.38 0.01,-0.2 -0.02,-0.24 -0.12,-0.34 -0.18,-0.25 -0.21,-0.21 -0.24,-0.17 -1.41,-0.5 -5.24,-1.04 -1.86,0.94 -0.29,0.09 -0.62,0.08 -0.64,-0.04 -1.49,0.1 -3.65,1.04 -5.66,0.94 -4.63,0.27 -1.96,-0.56 -1.31,0.15 -1.15,0.45 -2.06,1.34 -0.26,0.24 -0.16,0.18 -0.47,0.73 -0.5,0.57 -0.47,0.25 -4.42,0.92 -1.36,0.6 -2.92,2.23 -2.48,2.53 -1.19,0.84 -1.08,0.36 -5.31,0.7 -2.57,0.01 -0.79,0.5 -0.2,0.32 -0.23,0.57 -0.04,0.53 0.03,0.54 0.32,1.96 0.01,0.5 -0.87,9.67 1.14,1.08 0.59,0.91 0.21,0.51 0.18,0.64 0.08,0.49 0.01,0.41 -0.54,1.46 -0.05,1.17 0.15,0.47 0.29,0.22 6.23,-0.94 0.43,-0.15 0.32,-0.15 0.4,-0.33 1.24,-1.01 0.77,-0.24 0.32,0.03 0.32,0.08 0.27,0.16 0.28,0.23 0.2,0.26 0.11,0.25 0.01,0.19 -0.04,0.13 -0.33,0.48 -0.06,0.14 0,0.09 0.08,0.5 -0.02,0.12 -0.06,0.13 -0.12,0.17 -0.15,0.16 -0.11,0.23 -0.06,0.27 0.21,0.52 0.25,0.27 0.43,0.24 0.17,0.14 0.1,0.14 0.21,0.88 0.47,1.16 0.11,0.16 0.15,0.16 0.33,0.06 0.08,0.07 0.05,0.18 0.03,0.28 0.48,2.18 0.01,0.49 0.03,0.14 0.03,0.06 0.13,0.01 0.16,0.04 0.24,0.13 0.05,0.13 -0.05,0.16 -0.38,0.48 -0.18,0.34 -0.13,0.38 -0.12,0.65 -0.11,0.32 -0.1,0.2 -0.08,0.06 -0.84,0.29 -1.65,0.26 -1.28,-0.29 -0.86,-0.1 -0.23,0.01 -0.27,0.03 -0.35,0.15 -0.1,0.2 0.02,0.23 0.23,0.43 0.06,0.31 -0.05,0.37 -0.19,0.9 -0.18,0.43 -0.29,0.49 -0.23,0.28 -1.1,1.78 -0.93,1.23 -0.59,0.31 -0.24,0.02 -0.26,-0.02 -1.51,-0.41 -1.52,-0.15 -0.47,0.06 -0.35,0.13 -1.53,1.22 -0.29,0.34 -0.17,0.3 -0.02,0.37 0.03,0.41 -0.02,0.12 -0.06,0.18 -0.25,0.54 -0.14,0.47 -0.01,0.2 0,0.15 0.05,0.22 0.62,2.01 0.09,0.4 0,0.14 -0.01,0.12 -0.1,0.24 -1.5,2.93 -0.62,1.85 -0.22,0.36 -0.26,0.26 -0.68,0.41 -0.16,0.2 -0.09,0.23 -0.17,1.47 -0.09,1.68 0.2,1.12 -0.03,0.55 -0.15,1.12 0.03,0.68 0.16,0.9 0.55,1.86 0.17,0.45 0.21,0.38 1.08,1.32 0.51,0.87 0.47,0.19 2.86,-0.03 1.48,-0.29 0.46,-0.14 0.32,-0.16 0.53,-0.53 0.19,-0.14 0.2,-0.1 1.67,-0.55 0.35,-0.06 0.21,0.01 0.02,0.08 -0.01,0.1 -0.11,0.35 -0.05,0.21 -0.02,0.19 0,0.16 0.03,0.15 0.08,0.14 0.1,0.15 0.15,0.14 0.17,0.11 0.72,0.39 0.14,0.11 0.15,0.13 0.13,0.15 0.11,0.17 0.11,0.17 0.07,0.2 0.12,0.51 0.21,0.29 0.26,0.11 0.52,0.06 0.36,0.14 0.7,0.38 0.23,0.06 0.18,-0.01 0.78,-0.2 0.17,0.02 0.12,0.1 0.07,0.17 0.04,0.21 0,0.2 -0.1,0.65 0,0.26 0.06,0.34 0.09,0.31 0.12,0.32 0.64,1.27 0.26,0.41 0.52,0.59 0.39,0.29 0.35,0.19 5.01,1.73 1.5,0.15 2.43,0.55 0.31,-0.01 0.12,-0.12 0.24,-0.1 0.36,-0.05 0.65,0.05 0.35,0.11 0.29,0.19 0.18,0.25 0.16,0.3 0.13,0.31 0.08,0.28 0.03,0.25 0.01,0.27 -0.06,1.23 -0.04,0.28 -0.07,0.23 -0.08,0.15 -0.13,0.1 -0.54,0.22 -0.18,0.14 -0.01,0.25 0.16,0.31 0.91,0.79 0.16,0.18 -0.02,0.11 -0.08,0.14 -0.37,0.49 -0.13,0.33 0.02,0.37 0.82,0.23 0.4,0.39 0.32,0.53 0.39,0.87 1.38,4.83 0.06,0.37 -0.05,0.2 -0.34,0.79 -0.09,0.4 -0.03,0.51 0.17,0.27 0.15,0.1 0.17,-0.03 0.18,-0.11 0.46,-0.47 1.25,-1.62 0.15,-0.11 0.17,-0.07 0.66,-0.16 0.17,-0.08 0.12,-0.13 0.08,-0.15 0,-0.18 -0.02,-0.18 -0.05,-0.2 -0.03,-0.21 0.04,-0.2 0.09,-0.14 0.15,-0.11 0.21,-0.06 0.89,-0.08 0.15,-0.05 0.11,-0.1 0.09,-0.16 0.06,-0.2 0.08,-0.53 0.07,-0.12 0.15,-0.09 0.65,-0.15 0.21,-0.08 0.17,-0.09 0.09,-0.1 0.04,-0.12 -0.02,-0.12 -0.21,-0.47 -0.06,-0.21 -0.03,-0.22 0.02,-0.23 0.1,-0.24 0.19,-0.22 0.33,-0.2 0.22,-0.02 0.32,0.15 0.37,0.25 0.87,0.41 0.64,0.18 0.87,0.12 0.41,0.01 0.33,-0.03 0.22,-0.08 0.47,-0.27 0.94,-0.4 -0.44,-0.19 -0.33,-0.26 -0.12,-0.13 -0.36,-0.46 -0.15,-0.27 -0.12,-0.34 -0.06,-0.43 -0.02,-0.48 0.12,-1.55 0.09,-0.43 0.11,-0.35 0.14,-0.34 0.2,-0.71 0.11,-1.49 0.42,-2.4 -0.01,-0.37 -0.09,-0.35 -0.17,-0.25 -0.45,-0.43 -0.15,-0.19 -0.09,-0.22 -0.01,-0.23 0.23,-1.56 0.09,-0.33 0.32,-0.74 0.22,-0.4 0.24,-0.35 0.34,-0.38 0.27,-0.22 0.31,-0.19 0.76,-0.05 6.95,0.83 1.01,-0.09 1.67,-0.61 2.48,-1.01 0.35,-0.08 0.95,-0.05 0.3,-0.25 0.34,-0.47 3.14,-5.82 2.41,-2.99 0.53,-0.44 1.31,-0.27 0.59,-0.6 0.76,-0.47 1.55,-0.7 0.9,-0.57 0.83,-0.68 2.29,-2.31 0.29,-0.4 0.23,-0.42 0.17,-0.44 0.11,-0.5 0.07,-0.68 0.01,-0.52 -0.02,-0.43 -0.28,-1.53 -0.01,-0.24 0.03,-0.13 0.09,-0.08 0.15,-0.07 0.68,-0.17 0.14,-0.06 0.06,-0.17 0.03,-0.23 -0.07,-0.79 0.01,-0.31 0.07,-0.5 -0.07,-0.15 -0.15,-0.16 -1.08,-0.57 -0.14,-0.21 0.05,-0.39 0.17,-0.26 0.24,-0.21 0.91,-0.4 0.27,-0.18 0.19,-0.18 0.12,-0.19 0.06,-0.17 0.04,-0.15 -0.01,-0.18 -0.02,-0.23 -0.15,-0.68 -1.11,-0.98 -4.59,-2.16 -2.41,1.44 -0.77,0.37 -0.7,0.2 -0.41,0.21 -0.39,0.25 -0.42,0.12 -5.32,0.45 -0.28,-0.05 -0.26,-0.21 -0.15,-0.23 -0.24,-0.56 -0.07,-0.15 -0.09,-0.13 -0.08,-0.08 -0.06,-0.05 -0.07,-0.02 -6.93,1.31 -0.73,-0.06 -0.11,-0.29 1.05,-3.08 0.52,-0.95 0.27,-0.4 0.46,-0.55 0.42,-0.39 0.22,-0.14 0.69,-0.29 0.18,-0.12 0.13,-0.12 0.09,-0.12 0.05,-0.11 0.35,-1.09 1.31,-2.73 0.36,-1.06 0.05,-0.79 -0.07,-1.03 -0.87,-5.96 -0.17,-0.62 -0.72,-1.06 -0.04,-0.81 0.04,-0.73 0.04,-0.27 0.07,-0.24 0.07,-0.15 0.33,-0.46 0.06,-0.15 0.03,-0.17 -0.01,-0.17 -0.13,-0.54 -0.04,-0.36 -0.01,-2.3 0.08,-0.31 0.19,-0.49 0.02,-0.26 -0.02,-0.31 -0.18,-0.87 -0.14,-0.22 -0.24,-0.2 -0.49,-0.1 -1.17,0.04 z"
        />
      <path
        id="AF-GHO"
        title="Ghor"
        
        d="m 254.48715,199.21119 -0.23,-0.06 -0.7,-0.38 -0.36,-0.14 -0.52,-0.06 -0.26,-0.11 -0.21,-0.29 -0.12,-0.51 -0.07,-0.2 -0.11,-0.17 -0.11,-0.17 -0.13,-0.15 -0.15,-0.13 -0.14,-0.11 -0.72,-0.39 -0.17,-0.11 -0.15,-0.14 -0.1,-0.15 -0.08,-0.14 -0.03,-0.15 0,-0.16 0.02,-0.19 0.05,-0.21 0.11,-0.35 0.01,-0.1 -0.02,-0.08 -0.21,-0.01 -0.35,0.06 -1.67,0.55 -0.2,0.1 -0.19,0.14 -0.53,0.53 -0.32,0.16 -0.46,0.14 -1.48,0.29 -2.86,0.03 -0.47,-0.19 -0.51,-0.87 -1.59,1.16 -1.51,1.62 -0.27,0.19 -2.38,0.93 -0.7,0.03 -0.39,-0.17 -0.21,-0.13 -0.19,-0.16 -0.21,-0.06 -0.25,0.01 -0.84,0.4 -0.12,0.04 -0.11,0.06 -0.09,0.05 -0.12,0 -0.17,-0.07 -0.25,-0.27 -0.03,-0.23 0.06,-0.21 0.21,-0.32 0.06,-0.16 0.01,-0.19 -0.06,-0.22 -0.47,-0.86 -0.19,-0.25 -0.24,-0.22 -0.29,-0.11 -0.27,0.01 -0.32,0.23 -0.35,0.38 -0.18,0.11 -0.58,0.17 -0.15,-0.02 -0.89,-0.44 -0.18,-0.12 -0.47,-0.4 -0.27,-0.19 -0.6,-0.3 -0.49,-0.33 -0.36,-0.11 -0.48,0 -0.84,0.28 -0.66,0.37 -0.39,0.32 -1.34,0.76 -1.75,0.39 -0.14,0.06 -0.13,0.01 -0.09,-0.07 -0.1,-0.26 -0.01,-0.25 0.02,-0.23 -0.02,-0.18 -0.08,-0.11 -0.28,-0.04 -0.43,0.08 -3.65,1.41 -0.34,0.06 -0.34,-0.06 -0.54,-0.26 -1.1,-1.09 -0.33,-0.14 -0.5,-0.06 -2.33,0.3 -3.69,1.28 0.97,2.04 0.72,0.72 2.07,1.33 0.32,0.14 0.31,0.06 1.21,-0.11 0.6,0.18 0.49,0.35 0.46,0.44 0.7,0.83 1.2,1.78 0.39,0.4 2.98,2.14 0.64,0.81 0.36,0.7 0.07,0.52 0.22,0.64 0.39,0.72 0.83,1.19 0.33,0.69 0.13,0.64 -0.09,0.6 -0.47,2 -0.08,0.62 0.01,0.55 0.09,1.05 -0.04,0.49 -0.3,1.47 -0.24,0.78 -0.48,1.08 -0.17,0.25 -0.22,0.19 -0.18,0.1 -0.32,0.4 -1.48,0.72 -8.65,2.39 -3.21,1.61 -0.59,0.17 -0.5,0 -0.39,-0.14 -0.69,-0.04 -0.4,-0.15 -0.78,-0.4 -5.94,-0.24 -1,0.31 -0.61,0.33 -0.4,0.47 -0.28,0.37 -0.11,0.25 -0.18,0.62 -0.79,5.02 -0.02,1.58 0.09,0.39 0.17,0.53 0.74,1.72 0.11,0.82 -0.04,0.48 -0.19,0.24 -0.16,0.09 -0.2,0.03 -0.64,-0.16 -0.84,-0.07 -0.24,-0.1 -0.18,-0.18 -0.25,-0.41 -0.45,-0.9 -0.23,-0.12 -0.35,-0.06 -0.35,0.17 -0.99,0.67 -0.86,0.44 -1.06,0.11 -0.52,0.18 -0.36,0.24 -0.31,0.34 -0.56,0.36 -0.64,0.16 -0.62,0.06 -1,-0.09 -0.73,-0.17 -0.58,-0.07 -0.45,0.07 -0.69,0.27 -0.32,0.23 -0.19,0.26 -0.08,0.34 -0.04,0.43 0,0.52 0.22,1.69 -0.02,0.3 -0.13,0.78 -0.03,0.41 0.04,0.47 0.09,0.44 0.06,0.52 -0.03,0.42 -0.25,0.66 -0.1,0.38 0.04,0.33 0.14,0.23 0.41,0.55 0.23,0.36 0.16,0.4 0.08,0.54 -0.07,0.7 -0.35,0.92 -0.31,0.43 -0.33,0.24 -0.65,0.05 -0.49,0.16 -0.68,0.42 -0.72,0.8 -0.47,0.38 -0.4,0.22 -0.36,0.06 -1.18,-0.05 -0.15,0.03 -0.19,0.06 -0.22,0.03 -0.3,0.01 -0.33,-0.05 -0.37,-0.12 -2.18,-1.13 -0.14,-0.02 -0.09,0.04 -0.36,0.58 -0.31,0.66 -0.67,0.35 -6.15,-0.12 -0.79,-0.25 -0.84,-0.83 -0.66,-0.51 -0.8,-0.48 -1.42,-0.57 -0.76,-0.21 -4.12,-0.36 -0.82,0.03 -0.42,0.06 -6.67,0.27 -0.8,3.38 -1.32,2.53 -2.84,4.25 -0.22,0.65 0.07,0.59 1.95,3.3 0.27,0.64 0.2,0.92 0.17,0.51 0.22,0.43 0.36,0.37 1.54,1.29 0.92,1.11 0.6,0.88 0.39,0.77 0.68,2.47 0.25,0.43 1.37,1.41 0.51,0.83 0.04,0.5 -0.27,0.46 -0.46,0.31 -0.56,0.3 -0.46,0.19 -0.42,0.1 -0.84,0.08 -0.21,0.07 -0.2,0.14 -0.2,0.18 -0.19,0.25 -0.18,0.39 -0.05,0.3 0.05,0.29 0.65,2 0.08,0.55 0,0.33 -0.04,0.15 -0.72,1.45 -1.11,0.8 -1.32,0.44 -4.69,0.44 -5.44,1.52 -0.76,0.34 -0.04,0.09 -0.15,0.21 -0.26,0.27 -0.8,0.55 -0.67,0.29 -0.82,0.19 -1.95,0.87 -1.97,1.49 -0.66,0.69 -0.14,0.31 -0.05,0.36 0.03,0.21 0.09,0.19 0.45,0.4 0.21,0.26 0.19,0.33 0.12,0.47 -0.04,0.38 -0.23,0.69 0.14,0.62 0.34,0.67 0.99,1.37 0.34,0.8 0.25,0.97 0,1.13 0.19,2.18 0.3,1.06 1.6,0.67 1.63,0.05 0.67,-0.09 3.68,-1.16 9.82,-0.4 2.53,-0.5 1.95,-0.78 1.86,-1.53 0.99,-0.6 1.54,-0.62 2.05,-0.47 3.26,-0.34 0.78,-0.3 0.61,-0.53 0.76,-1.19 0.96,-1.2 0.69,-0.63 0.92,-0.69 2.18,-1.02 1.22,-0.13 1.76,0.95 0.8,0.75 2.76,4.53 1.49,3.51 0.15,0.47 -0.03,0.94 0.05,0.34 0.14,0.67 0,0.24 -0.07,0.62 0.02,0.53 0.14,0.3 0.16,0.2 0.67,0.29 0.41,0.14 0.53,0.01 0.32,0.18 0.18,0.27 0.17,0.54 0.15,0.32 0.17,0.19 0.68,0.55 0.38,0.51 1.43,2.83 0.37,0.58 0.3,0.3 0.21,-0.04 0.67,-0.26 0.35,0 0.27,0.15 1.12,1.07 2.09,1.15 0.24,0.04 0.14,-0.05 0.53,-0.46 0.21,-0.13 0.17,-0.07 0.42,-0.08 1.32,-0.08 0.29,-0.08 0.21,-0.1 0.15,-0.12 0.08,-0.16 0.02,-0.18 -0.09,-0.24 -0.14,-0.23 -1.01,-1.06 -0.12,-0.17 -0.03,-0.12 0.03,-0.13 0.11,-0.14 0.22,-0.16 0.25,-0.11 1.34,-0.3 0.85,-0.4 0.92,-0.57 0.63,-0.48 0.49,-0.46 0.45,-0.56 0.73,-1.29 1.11,-2.92 0.54,-0.57 0.83,-0.19 0.55,0.07 0.16,0.07 0.11,0.08 0.11,0.11 0.07,0.15 0.18,0.53 0.15,0.23 0.44,0.49 0.6,0.42 0.39,0.16 0.3,0.07 0.16,-0.02 0.14,-0.05 0.34,-0.05 1.68,0.03 0.55,0.13 0.33,0.16 0.12,0.19 0.08,0.24 0.06,0.3 0.05,0.35 0.36,0.74 1.51,1.12 2.17,-1.07 0.61,-0.04 0.08,0.17 0.07,0.2 0.04,0.2 0.13,1.43 0.14,0.19 0.26,0.24 0.65,0.11 0.34,0 0.3,-0.08 0.35,-0.15 0.3,-0.17 0.34,-0.31 1.58,-1.73 0.64,-0.56 0.36,-0.16 0.29,0.07 0.34,0.21 0.41,0.21 0.88,0.18 0.43,-0.02 0.36,-0.17 0.48,-0.48 1.33,-0.92 0.11,-0.13 0.13,-0.16 4.22,-1.99 0.24,-0.22 0.55,-0.64 0.81,-0.71 2.09,-1.33 0.59,-0.16 0.53,-0.03 1.81,0.17 1.32,-1.04 0.76,-0.5 1.07,-0.43 1.34,-0.27 0.92,-0.32 1.92,-1.03 0.05,-0.84 -0.02,-0.13 -0.05,-0.17 -0.22,-0.17 -0.1,-0.11 0,-0.19 0.12,-0.28 0.69,-1.05 0.11,-0.11 0.14,-0.08 0.18,-0.05 0.64,-0.07 0.16,-0.04 0.15,-0.06 0.14,-0.11 0.12,-0.13 0.1,-0.15 0.13,-0.15 1.6,-1.33 1.44,-1.76 1.61,-1.43 0.26,-0.15 0.68,-0.31 0.75,-0.43 1.22,-0.93 0.12,-0.24 0.03,-0.28 -0.18,-0.63 -0.3,-0.55 -0.64,-0.73 -0.78,-0.68 -1.02,-0.47 -0.43,-0.94 -0.42,-3.23 -0.3,-1.74 -0.3,-0.58 -0.31,-0.34 -0.2,-0.35 -0.11,-0.11 -0.15,-0.1 -0.31,-0.14 -0.3,-0.07 -0.12,-0.06 -0.12,-0.08 -0.18,-0.19 -0.09,-0.12 -0.06,-0.16 -0.05,-0.23 -0.07,-0.24 -0.1,-0.21 -0.16,-0.17 -1.3,-0.8 -0.15,-0.16 -0.09,-0.15 -0.06,-0.16 -0.1,-0.79 -0.06,-0.21 -0.1,-0.26 -0.04,-0.15 -0.04,-0.17 0.01,-0.21 0.06,-0.36 0.15,-0.28 0.22,-0.23 1.17,-0.65 0.25,-0.2 0.14,-0.08 0.15,-0.07 0.21,-0.06 0.88,-0.1 0.17,-0.04 0.19,-0.28 0.26,-0.52 0.3,-1.08 0.74,-1.14 0.58,-0.33 0.4,-0.63 0.27,-1.38 -0.32,-1.75 -0.12,-0.21 -0.18,-0.23 -0.63,-0.04 -0.21,-0.03 -0.15,-0.07 -0.14,-0.13 -0.11,-0.2 -0.26,-0.78 -0.12,-0.27 -0.12,-0.2 -0.13,-0.17 -0.12,-0.11 -0.18,-0.15 -0.06,-0.23 0.14,-1.52 0.28,-0.86 0.27,-1.16 -0.03,-0.64 0.01,-0.46 0.08,-0.41 0.6,-1.16 0.02,-0.28 -0.11,-0.3 -0.14,-0.16 -0.13,-0.13 -0.1,-0.11 -0.04,-0.37 0.04,-0.54 0.25,-1.39 0.22,-0.85 0.68,-1.73 0.12,-0.47 -0.07,-0.51 0.05,-0.89 0.5,-1.89 0.5,-0.25 4.5,-0.17 1.83,0.14 3.66,0.67 6.45,0.42 3.08,0.62 0.53,-0.02 0.58,-0.15 0.87,-0.43 0.54,-0.35 0.4,-0.35 0.66,-0.82 0.1,-0.1 0.35,-0.06 1.81,0.06 0.97,0.18 0.32,0.03 1.8,-0.34 1.28,0.17 0.5,-0.05 0.51,-0.26 0.36,-0.28 0.99,-1.14 0.17,-0.26 0.32,-0.69 0.4,-0.18 0.62,-0.03 2.55,0.46 0.53,0.2 0.41,0.22 0.19,0.14 0.63,0.6 0.26,0.13 0.27,0.04 0.26,-0.04 0.44,-0.18 6.08,-0.96 1.1,0.43 2.97,-2.09 0.46,-0.23 2.65,-0.77 0.22,-0.01 0.21,0.02 1.53,0.46 0.42,-0.19 0.64,-0.42 2.97,-2.54 0.07,-0.69 -0.85,-0.74 -0.21,-0.28 -0.25,-0.65 -0.04,-0.31 0.16,-0.66 0.11,-0.75 0.04,-0.12 0.13,-0.2 1.45,-1.33 0.78,-0.94 0.27,-0.44 0.15,-0.4 0.04,-0.4 -0.06,-0.43 -0.15,-0.48 -0.23,-0.46 -0.5,-0.58 -0.61,-0.53 -1.67,-1.05 -0.33,-0.13 -0.21,0.02 -0.68,0.18 -0.2,0.02 -0.19,-0.02 -0.18,-0.03 -0.83,-0.46 -0.12,-0.03 -0.11,0.03 -0.37,0.2 -0.17,0 -0.11,-0.13 -0.01,-0.42 0.15,-0.31 0.35,-0.44 0.04,-0.16 -0.18,-0.22 -0.34,-0.27 -0.76,-0.43 -0.49,-0.34 -0.44,-0.43 -0.48,-0.8 -0.24,-0.63 -0.44,-1.77 -0.26,-0.33 -1.42,-1.38 -0.81,-0.92 -0.16,-0.23 -0.14,-0.18 -4.02,-3.02 -1.34,-0.65 -2.2,-0.46 -0.94,0.4 -0.47,0.27 -0.22,0.08 -0.33,0.03 -0.41,-0.01 -0.87,-0.12 -0.64,-0.18 -0.87,-0.41 -0.37,-0.25 -0.32,-0.15 -0.22,0.02 -0.33,0.2 -0.19,0.22 -0.1,0.24 -0.02,0.23 0.03,0.22 0.06,0.21 0.21,0.47 0.02,0.12 -0.04,0.12 -0.09,0.1 -0.17,0.09 -0.21,0.08 -0.65,0.15 -0.15,0.09 -0.07,0.12 -0.08,0.53 -0.06,0.2 -0.09,0.16 -0.11,0.1 -0.15,0.05 -0.89,0.08 -0.21,0.06 -0.15,0.11 -0.09,0.14 -0.04,0.2 0.03,0.21 0.05,0.2 0.02,0.18 0,0.18 -0.08,0.15 -0.12,0.13 -0.17,0.08 -0.66,0.16 -0.17,0.07 -0.15,0.11 -1.25,1.62 -0.46,0.47 -0.18,0.11 -0.17,0.03 -0.15,-0.1 -0.17,-0.27 0.03,-0.51 0.09,-0.4 0.34,-0.79 0.05,-0.2 -0.06,-0.37 -1.38,-4.83 -0.39,-0.87 -0.32,-0.53 -0.4,-0.39 -0.82,-0.23 -0.02,-0.37 0.13,-0.33 0.37,-0.49 0.08,-0.14 0.02,-0.11 -0.16,-0.18 -0.91,-0.79 -0.16,-0.31 0.01,-0.25 0.18,-0.14 0.54,-0.22 0.13,-0.1 0.08,-0.15 0.07,-0.23 0.04,-0.28 0.06,-1.23 -0.01,-0.27 -0.03,-0.25 -0.08,-0.28 -0.13,-0.31 -0.16,-0.3 -0.18,-0.25 -0.29,-0.19 -0.35,-0.11 -0.65,-0.05 -0.36,0.05 -0.24,0.1 -0.12,0.12 -0.31,0.01 -2.43,-0.55 -1.5,-0.15 -5.01,-1.73 -0.35,-0.19 -0.39,-0.29 -0.52,-0.59 -0.26,-0.41 -0.64,-1.27 -0.12,-0.32 -0.09,-0.31 -0.06,-0.34 0,-0.26 0.1,-0.65 0,-0.2 -0.04,-0.21 -0.07,-0.17 -0.12,-0.1 -0.17,-0.02 -0.78,0.2 -0.18,0.01 z"
        />
      <path
        id="AF-JOW"
        title="Jawzjan"
        
        d="m 276.12715,67.771194 -0.57,-0.08 -0.97,-0.5 -0.84,-0.83 -1.35,-1.82 -0.88,-0.76 -10.89,-4.1 -0.93,-0.68 -0.33,-0.4 -0.39,-0.58 -0.82,-1.84 -0.38,-0.25 -0.96,-0.22 -0.74,-0.33 -0.12,0.87 -0.3,1.6 -0.64,0.54 -2,-0.02 -0.84,0.19 -0.59,0.35 -0.49,0.63 -0.5,0.99 0,0.01 0,0 -0.01,0.01 -0.6,1.2 -0.49,1.3 -0.23,1.37 0.39,2.62 0.02,1.35 -0.26,1.24 -0.62,0.86 -1.36,1.4 -2.25,3.1 -1.72,0.91 -0.65,0.02 -0.27,0.43 -5.6,10.01 -1.36,4.49 -0.33,1.88 -0.03,0.89 0.03,0.86 0.4,1.81 2.51,3.22 0.56,2.559996 0.15,0.32 0.31,0.52 0.36,0.38 0.68,0.9 0.3,0.57 0.19,0.51 0.03,0.33 -0.02,0.26 -0.34,1.47 -0.42,1.85 -0.6,2.64 -0.15,0.32 -0.29,0.48 -0.28,0.23 -0.37,0.38 -0.1,0.22 0.01,0.23 0.15,0.29 0.21,0.26 0.28,0.26 1.23,0.68 0.29,0.25 0.25,0.28 0.26,0.44 0.06,0.29 0.01,0.21 -0.51,1.91 -0.3,1.88 0.03,0.54 0.13,0.46 0.75,1.22 0.6,1.91 0.3,1.34 0.2,0.63 0.54,1.27 -0.98,0.43 -0.23,0.45 -0.04,0.28 -0.1,0.09 -0.15,0.02 -0.54,-0.09 -8,0.29 -0.94,0.26 -0.26,0.22 -0.37,0.44 -0.17,0.4 -1.49,5.68 0.01,2.81 0.05,0.48 0.07,0.39 0.11,0.33 0.07,0.37 0.03,0.44 -0.03,0.7 -0.08,0.37 -0.16,0.31 -0.4,0.59 -0.33,0.62 -0.17,0.21 -0.39,0.36 -0.21,0.15 -0.52,0.58 0.37,2.03 0.23,0.77 -0.08,0.28 -0.18,0.4 -0.63,0.87 -0.31,0.33 -0.25,0.23 -0.2,0.14 -0.96,0.44 -0.77,0.58 -0.31,0.29 -0.19,0.28 -0.05,0.29 -0.03,0.31 0.02,0.29 0.07,0.24 0.1,0.2 0.23,0.32 0.26,0.23 1.41,1.24 0.83,0.32 0.59,0.07 0.33,0 0.26,-0.07 0.5,-0.38 0.44,-0.23 1.95,-0.22 0.52,-0.13 0.24,-0.01 0.18,0.06 0.09,0.13 0.05,0.16 0.06,0.42 0.15,0.26 0.16,0.08 0.16,-0.03 0.48,-0.26 0.47,-0.16 0.26,0 0.17,0.03 0.41,0.31 0.26,0.16 2.23,0.82 2.32,0.32 3.32,-0.48 0.24,-0.09 0.21,-0.14 0.33,-0.4 0.26,-0.45 0.25,-0.33 0.09,-0.16 0.05,-0.16 0.02,-0.19 0.08,-0.21 0.15,-0.18 0.35,-0.19 0.26,-0.04 0.17,0.03 0.15,0.11 0.14,0.16 0.23,0.43 0.22,0.3 0.35,0.37 0.49,0.39 0.26,0.13 0.2,0 0.15,-0.09 0.49,-0.41 0.17,-0.11 1.37,-0.44 0.44,-0.23 0.84,-0.56 0.8,-0.39 0.18,-0.12 0.17,-0.13 0.16,-0.18 0.14,-0.2 0.13,-0.25 0.09,-0.25 0.11,-0.58 0.04,-0.4 -0.4,0.33 -0.32,0.15 -0.43,0.15 -6.23,0.94 -0.29,-0.22 -0.15,-0.47 0.05,-1.17 0.54,-1.46 -0.01,-0.41 -0.08,-0.49 -0.18,-0.64 -0.21,-0.51 -0.59,-0.91 -1.14,-1.08 0.87,-9.67 -0.01,-0.5 -0.32,-1.96 -0.03,-0.54 0.04,-0.53 0.23,-0.57 0.2,-0.32 0.79,-0.5 2.57,-0.01 5.31,-0.7 1.08,-0.36 1.19,-0.84 2.48,-2.53 2.92,-2.23 1.36,-0.6 4.42,-0.92 0.47,-0.25 0.5,-0.57 0.47,-0.73 0.16,-0.18 0.26,-0.24 2.06,-1.34 1.15,-0.45 1.31,-0.15 1.96,0.56 4.63,-0.27 5.66,-0.94 3.65,-1.04 1.49,-0.1 0.64,0.04 0.62,-0.08 0.29,-0.09 1.86,-0.94 -1.15,-0.98 -1.15,-1.17 -0.43,-0.82 -0.26,-0.94 -0.16,-3.19 -0.62,-0.63 -0.44,-0.28 -0.88,-0.74 -0.24,-0.42 0.01,-0.41 0.41,-0.64 0.46,-0.35 1.67,-0.74 0.2,-0.05 0.23,0.01 0.23,0.05 1.01,0.4 0.25,0.02 0.31,-0.04 0.32,-0.12 0.81,-0.54 0.22,-0.06 0.78,-0.11 0.24,-0.11 0.14,-0.33 0.06,-0.53 -0.43,-1.81 -0.25,-0.6 -0.49,-0.749996 -0.16,-0.65 -0.03,-0.42 0.08,-0.25 0.05,-0.22 0,-0.26 -0.17,-0.37 -0.31,-0.47 -1.17,-1.39 -1.32,-2.21 -0.72,-1.21 -0.23,-1.07 0.22,-1.44 0.41,-1.71 0.99,-3.04 0.11,-0.25 0.05,-0.11 0.14,-0.5 0.06,-0.36 -0.41,-1.05 -2.28,-2.45 -0.66,-0.93 -0.1,-0.19 -0.16,-0.91 -0.02,-0.48 -0.04,-0.25 -0.09,-0.29 -0.12,-0.25 -0.23,-0.36 -0.19,-0.57 -0.27,-0.62 -0.36,-0.4 -0.47,-0.36 -1.7,-0.98 -0.45,-0.16 -0.72,-0.04 -3.02,-0.84 -0.52,-0.22 -0.12,-0.1 -0.12,-0.12 -0.17,-0.22 -0.11,-0.2 -0.05,-0.39 -0.02,-0.32 0.11,-1.95 0.03,-0.41 -0.43,-0.22 -0.46,-0.13 -0.68,-0.57 -0.52,-0.13 -1.6,0.08 z"
        />
      <path
        id="AF-FYB"
        title="Faryab"
        
        d="m 241.16715,129.07119 0.15,-0.02 0.1,-0.09 0.04,-0.28 0.23,-0.45 0.98,-0.43 -0.54,-1.27 -0.2,-0.63 -0.3,-1.34 -0.6,-1.91 -0.75,-1.22 -0.13,-0.46 -0.03,-0.54 0.3,-1.88 0.51,-1.91 -0.01,-0.21 -0.06,-0.29 -0.26,-0.44 -0.25,-0.28 -0.29,-0.25 -1.23,-0.68 -0.28,-0.26 -0.21,-0.26 -0.15,-0.29 -0.01,-0.23 0.1,-0.22 0.37,-0.38 0.28,-0.23 0.29,-0.48 0.15,-0.32 0.6,-2.64 0.42,-1.85 0.34,-1.47 0.02,-0.26 -0.03,-0.33 -0.19,-0.51 -0.3,-0.57 -0.68,-0.9 -0.36,-0.38 -0.31,-0.52 -0.15,-0.32 -0.56,-2.559996 -2.51,-3.22 -0.4,-1.81 -0.03,-0.86 0.03,-0.89 0.33,-1.88 1.36,-4.49 5.6,-10.01 0.27,-0.43 -20.61,0.53 -3.59,1.19 -8.78,4.76 -1.42,1.06 -0.9,1.55 -0.22,2.37 0.92,4.62 0.2,2.37 -0.65,2.05 -1.78,3.28 -5.2,9.569996 -0.8,1.93 -0.62,2.39 -0.16,1.25 0.01,1.22 0.23,1.23 0.68,2.31 0.13,1.25 -0.22,2.4 -0.56,2.22 -0.86,2.09 -3.81,5.91 -0.99,1.19 -1.61,1.3 -1.63,0.61 -3.57,0.84 -0.89,0.37 -0.74,0.49 -0.57,0.73 -0.77,2.42 -0.48,0.4 -0.6,-0.14 -0.81,-0.34 -2,-0.32 -1.8,0.33 -1.71,0.86 -3.21,2.45 -0.61,0.77 -0.41,0.96 0.01,1.07 0.44,2.84 -0.02,0.75 -4.61,-1.81 -1.36,-0.29 -0.76,0.12 1.42,0.84 0.54,1.8 0.03,2.63 -0.18,2.35 -0.85,3.87 -0.42,1.28 -0.12,1.05 0.07,1.25 -0.07,0.29 -0.71,1.15 -0.52,1.45 -0.11,0.67 0.09,0.46 0.3,0.19 0.34,0.1 0.55,0.1 0.64,0.26 0.46,0.26 0.47,0.35 0.83,0.83 0.58,0.74 0.65,1.16 0.41,1.19 0.2,1 0.22,4.18 -0.02,0.58 -0.06,0.5 -0.14,0.59 0,0.33 0.07,0.23 0.19,0.22 0.24,0.2 0.24,0.17 0.52,0.28 7.71,0.55 2.96,0.56 0.31,0.31 0.21,0.36 0.15,0.36 0.06,0.34 -0.01,0.29 -0.11,0.27 -0.06,0.12 -0.33,0.44 -0.03,0.46 1.77,1.04 0.52,0.18 0.39,0.07 0.89,-0.27 0.54,-0.05 1.76,-0.58 2.12,-0.31 0.4,0.37 0.06,0.58 -0.01,0.76 -0.18,1.33 -0.46,1.81 -0.04,0.59 0.03,0.93 -0.26,2.17 -0.03,0.99 0.11,0.77 0.14,0.28 0.27,0.17 4.63,1.54 4.96,0.68 0.9,-0.01 1.44,-0.26 1.62,-0.06 1.14,-0.25 0.52,-0.24 3.69,-1.28 2.33,-0.3 0.5,0.06 0.33,0.14 1.1,1.09 0.54,0.26 0.34,0.06 0.34,-0.06 3.65,-1.41 0.43,-0.08 0.28,0.04 0.08,0.11 0.02,0.18 -0.02,0.23 0.01,0.25 0.1,0.26 0.09,0.07 0.13,-0.01 0.14,-0.06 1.75,-0.39 1.34,-0.76 0.39,-0.32 0.66,-0.37 0.84,-0.28 0.48,0 0.36,0.11 0.49,0.33 0.6,0.3 0.27,0.19 0.47,0.4 0.18,0.12 0.89,0.44 0.15,0.02 0.58,-0.17 0.18,-0.11 0.35,-0.38 0.32,-0.23 0.27,-0.01 0.29,0.11 0.24,0.22 0.19,0.25 0.47,0.86 0.06,0.22 -0.01,0.19 -0.06,0.16 -0.21,0.32 -0.06,0.21 0.03,0.23 0.25,0.27 0.17,0.07 0.12,0 0.09,-0.05 0.11,-0.06 0.12,-0.04 0.84,-0.4 0.25,-0.01 0.21,0.06 0.19,0.16 0.21,0.13 0.39,0.17 0.7,-0.03 2.38,-0.93 0.27,-0.19 1.51,-1.62 1.59,-1.16 -1.08,-1.32 -0.21,-0.38 -0.17,-0.45 -0.55,-1.86 -0.16,-0.9 -0.03,-0.68 0.15,-1.12 0.03,-0.55 -0.2,-1.12 0.09,-1.68 0.17,-1.47 0.09,-0.23 0.16,-0.2 0.68,-0.41 0.26,-0.26 0.22,-0.36 0.62,-1.85 1.5,-2.93 0.1,-0.24 0.01,-0.12 0,-0.14 -0.09,-0.4 -0.62,-2.01 -0.05,-0.22 0,-0.15 0.01,-0.2 0.14,-0.47 0.25,-0.54 0.06,-0.18 0.02,-0.12 -0.03,-0.41 0.02,-0.37 0.17,-0.3 0.29,-0.34 1.53,-1.22 0.35,-0.13 0.47,-0.06 1.52,0.15 1.51,0.41 0.26,0.02 0.24,-0.02 0.59,-0.31 0.93,-1.23 1.1,-1.78 0.23,-0.28 0.29,-0.49 0.18,-0.43 0.19,-0.9 0.05,-0.37 -0.06,-0.31 -0.23,-0.43 -0.02,-0.23 0.1,-0.2 0.35,-0.15 0.27,-0.03 0.23,-0.01 0.86,0.1 1.28,0.29 1.65,-0.26 0.84,-0.29 0.08,-0.06 0.1,-0.2 0.11,-0.32 0.12,-0.65 0.13,-0.38 0.18,-0.34 0.38,-0.48 0.05,-0.16 -0.05,-0.13 -0.24,-0.13 -0.16,-0.04 -0.13,-0.01 -0.03,-0.06 -0.03,-0.14 -0.01,-0.49 -0.48,-2.18 -0.03,-0.28 -0.05,-0.18 -0.08,-0.07 -0.33,-0.06 -0.15,-0.16 -0.11,-0.16 -0.47,-1.16 -0.21,-0.88 -0.1,-0.14 -0.17,-0.14 -0.43,-0.24 -0.25,-0.27 -0.21,-0.52 0.06,-0.27 0.11,-0.23 0.15,-0.16 0.12,-0.17 0.06,-0.13 0.02,-0.12 -0.08,-0.5 0,-0.09 0.06,-0.14 0.33,-0.48 0.04,-0.13 -0.01,-0.19 -0.11,-0.25 -0.2,-0.26 -0.28,-0.23 -0.27,-0.16 -0.32,-0.08 -0.32,-0.03 -0.77,0.24 -1.24,1.01 -0.04,0.4 -0.11,0.58 -0.09,0.25 -0.13,0.25 -0.14,0.2 -0.16,0.18 -0.17,0.13 -0.18,0.12 -0.8,0.39 -0.84,0.56 -0.44,0.23 -1.37,0.44 -0.17,0.11 -0.49,0.41 -0.15,0.09 -0.2,0 -0.26,-0.13 -0.49,-0.39 -0.35,-0.37 -0.22,-0.3 -0.23,-0.43 -0.14,-0.16 -0.15,-0.11 -0.17,-0.03 -0.26,0.04 -0.35,0.19 -0.15,0.18 -0.08,0.21 -0.02,0.19 -0.05,0.16 -0.09,0.16 -0.25,0.33 -0.26,0.45 -0.33,0.4 -0.21,0.14 -0.24,0.09 -3.32,0.48 -2.32,-0.32 -2.23,-0.82 -0.26,-0.16 -0.41,-0.31 -0.17,-0.03 -0.26,0 -0.47,0.16 -0.48,0.26 -0.16,0.03 -0.16,-0.08 -0.15,-0.26 -0.06,-0.42 -0.05,-0.16 -0.09,-0.13 -0.18,-0.06 -0.24,0.01 -0.52,0.13 -1.95,0.22 -0.44,0.23 -0.5,0.38 -0.26,0.07 -0.33,0 -0.59,-0.07 -0.83,-0.32 -1.41,-1.24 -0.26,-0.23 -0.23,-0.32 -0.1,-0.2 -0.07,-0.24 -0.02,-0.29 0.03,-0.31 0.05,-0.29 0.19,-0.28 0.31,-0.29 0.77,-0.58 0.96,-0.44 0.2,-0.14 0.25,-0.23 0.31,-0.33 0.63,-0.87 0.18,-0.4 0.08,-0.28 -0.23,-0.77 -0.37,-2.03 0.52,-0.58 0.21,-0.15 0.39,-0.36 0.17,-0.21 0.33,-0.62 0.4,-0.59 0.16,-0.31 0.08,-0.37 0.03,-0.7 -0.03,-0.44 -0.07,-0.37 -0.11,-0.33 -0.07,-0.39 -0.05,-0.48 -0.01,-2.81 1.49,-5.68 0.17,-0.4 0.37,-0.44 0.26,-0.22 0.94,-0.26 8,-0.29 0.54,0.09 z"
        />
      <path
        id="AF-BAL"
        title="Balkh"
        
        d="m 328.71715,79.381194 -1.08,-0.44 -0.56,-0.94 -0.35,-1.13 -0.49,-1.04 -0.97,-0.9 -2.15,-0.83 -0.98,-0.62 -0.46,-0.93 -0.8,-2.65 -0.6,-0.55 -1.01,-0.3 -1.94,-1.4 -0.89,-0.42 -2.34,-0.05 -4.45,1.06 -6.35,0.28 -0.51,0.19 -0.95,0.83 -0.52,0.19 -1.31,-0.05 -0.6,-0.11 -3.21,-1.37 -1.16,-0.13 -1.24,0.1 -0.94,0.3 -0.81,0.52 -0.86,0.74 -0.74,0.84 -0.41,0.32 -0.51,0.09 -0.6,-0.3 -0.73,-1.09 -0.49,-0.24 -1.16,0.15 -3.34,1.1 -1.27,-0.12 -0.98,-0.74 -0.8,-0.83 -0.34,-0.17 -0.03,0.41 -0.11,1.95 0.02,0.32 0.05,0.39 0.11,0.2 0.17,0.22 0.12,0.12 0.12,0.1 0.52,0.22 3.02,0.84 0.72,0.04 0.45,0.16 1.7,0.98 0.47,0.36 0.36,0.4 0.27,0.62 0.19,0.57 0.23,0.36 0.12,0.25 0.09,0.29 0.04,0.25 0.02,0.48 0.16,0.91 0.1,0.19 0.66,0.93 2.28,2.45 0.41,1.05 -0.06,0.36 -0.14,0.5 -0.05,0.11 -0.11,0.25 -0.99,3.04 -0.41,1.71 -0.22,1.44 0.23,1.07 0.72,1.21 1.32,2.21 1.17,1.39 0.31,0.47 0.17,0.37 0,0.26 -0.05,0.22 -0.08,0.25 0.03,0.42 0.16,0.65 0.49,0.749996 0.25,0.6 0.43,1.81 -0.06,0.53 -0.14,0.33 -0.24,0.11 -0.78,0.11 -0.22,0.06 -0.81,0.54 -0.32,0.12 -0.31,0.04 -0.25,-0.02 -1.01,-0.4 -0.23,-0.05 -0.23,-0.01 -0.2,0.05 -1.67,0.74 -0.46,0.35 -0.41,0.64 -0.01,0.41 0.24,0.42 0.88,0.74 0.44,0.28 0.62,0.63 0.16,3.19 0.26,0.94 0.43,0.82 1.15,1.17 1.15,0.98 5.24,1.04 1.41,0.5 0.24,0.17 0.21,0.21 0.18,0.25 0.12,0.34 0.02,0.24 -0.01,0.2 -0.09,0.38 -0.1,0.27 -0.61,1.17 -0.18,0.25 -0.44,0.46 -0.18,0.23 -0.56,1.01 -0.33,0.48 -1.15,1.05 -0.23,0.27 -0.54,0.77 -0.85,1.56 -0.12,0.28 -0.09,0.33 -0.24,1.29 -0.15,0.47 -1.16,2.51 -0.25,0.76 -0.13,0.26 -0.53,0.82 -0.27,0.52 -1.59,2.47 -0.62,0.79 -0.1,0.23 -0.1,0.32 0.04,0.2 0.19,0.25 1.48,0.75 2.01,1.64 0.31,0.18 0.77,0.15 1.17,-0.04 0.49,0.1 0.24,0.2 0.14,0.22 0.18,0.87 0.02,0.31 -0.02,0.26 -0.19,0.49 -0.08,0.31 0.01,2.3 0.04,0.36 0.13,0.54 0.01,0.17 -0.03,0.17 -0.06,0.15 -0.33,0.46 -0.07,0.15 -0.07,0.24 -0.04,0.27 -0.04,0.73 0.04,0.81 0.72,1.06 0.17,0.62 0.87,5.96 0.07,1.03 -0.05,0.79 -0.36,1.06 -1.31,2.73 -0.35,1.09 -0.05,0.11 -0.09,0.12 -0.13,0.12 -0.18,0.12 -0.69,0.29 -0.22,0.14 -0.42,0.39 -0.46,0.55 -0.27,0.4 -0.52,0.95 -1.05,3.08 0.11,0.29 0.73,0.06 6.93,-1.31 0.07,0.02 0.06,0.05 0.08,0.08 0.09,0.13 0.07,0.15 0.24,0.56 0.15,0.23 0.26,0.21 0.28,0.05 5.32,-0.45 0.42,-0.12 0.39,-0.25 0.41,-0.21 0.7,-0.2 0.77,-0.37 2.41,-1.44 -0.06,-0.65 0.07,-0.49 0.11,-0.51 0.2,-0.56 0.81,-1.47 0.36,-0.44 0.44,-0.43 1.81,-0.87 1.02,-0.78 1.85,-2.22 0.65,-0.78 0.61,-0.47 0.25,-0.29 0.22,-0.4 0.16,-0.61 0.2,-0.41 0.38,-0.33 0.79,-0.42 0.31,-0.25 0.25,-0.5 0.21,-0.68 0.13,-1.17 -0.02,-0.53 -0.11,-0.45 -1.33,-1.78 -0.31,-0.5 -0.18,-0.39 -0.03,-0.13 -0.03,-0.63 -0.04,-0.24 -0.08,-0.16 -0.12,-0.11 -0.3,-0.23 -0.17,-0.2 -0.11,-0.19 -0.05,-0.2 -0.01,-0.13 0.01,-0.1 0.98,-0.96 4.57,-3.51 0.9,-0.29 2.57,-0.39 0.69,-0.21 0.39,-0.3 0.48,-0.46 0.81,-0.98 1.01,-0.94 0.34,-0.38 0.23,-0.45 0.1,-0.8 0,-0.4 -0.09,-0.4 -0.09,-0.28 -0.05,-0.19 0.05,-0.29 0.2,-0.36 0.44,-0.47 0.76,-0.62 0.34,-0.48 0.23,-0.39 0.34,-2.19 0.06,-2.7 0.7,-2.89 1.14,-3.19 -0.02,-0.66 -0.06,-0.46 -1.3,-2.73 -0.84,-1.13 -0.08,-0.15 -0.04,-0.14 0.01,-0.15 0.09,-0.15 0.15,-0.24 0.43,-0.44 0.47,-0.38 0.98,-0.49 2.21,-0.67 0.51,-0.48 0.68,-1.67 0.69,-0.25 5.53,0.52 0.67,-0.18 1.4,-0.57 0.74,-0.18 0.78,-0.05 0.68,0.19 2.77,1.36 1.51,0.95 0.28,0.24 0.64,0.41 1.12,0.37 2.34,0.29 9.66,1.37 1.37,-0.27 3.93,-1.61 -0.37,-1.43 -0.32,-0.66 -0.67,-0.9 -0.97,-0.92 -0.78,-0.57 -0.3,-0.35 -1.3,-2.3 -2.61,-6.4 -0.09,-0.51 -0.1,-3.479996 -0.47,-2.51 0.01,-0.08 -0.22,-0.01 -0.44,-0.32 -0.25,-0.47 -0.19,-0.54 -0.29,-0.5 -1.66,-2.07 -0.44,-0.39 -1.14,-0.6 -0.53,-0.46 -0.77,-1.25 -0.51,-1.08 -0.67,-0.75 -2.2,-0.53 -1.2,-0.61 -1.1,-0.81 -0.6,-0.82 -0.05,-0.91 0.41,-3.89 -0.22,-1.14 -0.57,-0.81 -0.85,-0.52 -1.01,-0.25 -1.73,0.08 -0.61,-0.08 -0.54,-0.27 -1.06,-0.81 -0.55,-0.17 -0.56,0.07 -0.92,0.28 -0.51,0.07 -0.3,0.28 -0.3,0.6 -0.37,0.58 -0.53,0.2 -0.79,-0.71 -0.92,-2.52 -1.11,-0.55 -1.01,0.28 -0.89,0.68 -1.59,1.61 -0.97,0.72 -0.97,0.51 -1.05,0.3 -1.18,0.1 -1.24,0.28 -1.85,1.2 -1.09,0.22 z"
        />
      <path
        id="AF-BAM"
        title="Bamyan"
        
        d="m 352.23715,184.22119 -0.64,-0.06 -6.41,-1.5 -1.22,0.02 -3.01,0.62 -5.23,2.14 -1.9,-0.53 -0.97,-0.06 -0.6,-0.14 -0.27,-0.12 -0.43,-0.04 -0.55,0.08 -4.53,1.76 -3.78,0.97 -4.37,1.96 -1.36,0.32 -4.87,-0.03 -1.32,-0.26 -2.65,-1.06 -1.31,0.27 -0.53,0.44 -2.41,2.99 -3.14,5.82 -0.34,0.47 -0.3,0.25 -0.95,0.05 -0.35,0.08 -2.48,1.01 -1.67,0.61 -1.01,0.09 -6.95,-0.83 -0.76,0.05 -0.31,0.19 -0.27,0.22 -0.34,0.38 -0.24,0.35 -0.22,0.4 -0.32,0.74 -0.09,0.33 -0.23,1.56 0.01,0.23 0.09,0.22 0.15,0.19 0.45,0.43 0.17,0.25 0.09,0.35 0.01,0.37 -0.42,2.4 -0.11,1.49 -0.2,0.71 -0.14,0.34 -0.11,0.35 -0.09,0.43 -0.12,1.55 0.02,0.48 0.06,0.43 0.12,0.34 0.15,0.27 0.36,0.46 0.12,0.13 0.33,0.26 0.44,0.19 2.2,0.46 1.34,0.65 4.02,3.02 0.14,0.18 0.16,0.23 0.81,0.92 1.42,1.38 0.26,0.33 0.44,1.77 0.24,0.63 0.48,0.8 0.44,0.43 0.49,0.34 0.76,0.43 0.34,0.27 0.18,0.22 -0.04,0.16 -0.35,0.44 -0.15,0.31 0.01,0.42 0.11,0.13 0.17,0 0.37,-0.2 0.11,-0.03 0.12,0.03 0.83,0.46 0.18,0.03 0.19,0.02 0.2,-0.02 0.68,-0.18 0.21,-0.02 0.33,0.13 1.67,1.05 0.61,0.53 0.5,0.58 0.23,0.46 0.15,0.48 0.06,0.43 -0.04,0.4 -0.15,0.4 -0.27,0.44 -0.78,0.94 -1.45,1.33 -0.13,0.2 -0.04,0.12 -0.11,0.75 -0.16,0.66 0.04,0.31 0.25,0.65 0.21,0.28 0.85,0.74 -0.07,0.69 -2.97,2.54 -0.64,0.42 -0.42,0.19 -1.53,-0.46 -0.21,-0.02 -0.22,0.01 -2.65,0.77 -0.46,0.23 -2.97,2.09 -0.89,1.22 -0.04,0.21 -0.02,0.28 0.48,0.61 0.35,0.63 1.73,0.08 1.54,0.58 0.61,0.3 0.36,0.26 0.29,0.35 0.1,0.32 0.02,0.35 -0.09,0.24 -0.15,0.17 -0.22,0.11 -0.51,0.18 -0.26,0.14 -0.65,0.56 -0.3,0.32 -0.17,0.31 -0.08,0.3 0.22,2.17 0.72,1.88 -0.02,0.38 -0.11,0.6 -1.18,2.54 -0.33,1.03 -0.15,1.74 0.02,0.82 0.13,0.57 0.18,0.29 0.5,0.58 2.78,2.7 2.78,1.5 1.06,0.14 1.27,-0.55 0.59,-0.15 0.23,-0.13 0.2,-0.2 0.45,-0.29 0.64,-0.27 1.46,-0.27 0.82,0 8.61,1.75 0.37,0.18 0.24,0.2 0.16,0.24 0.12,0.24 0.12,0.18 0.08,0.1 0.25,0.17 1.83,0.78 0.36,0.01 0.29,-0.06 2.75,-1.69 0.49,-0.19 0.79,-0.22 0.45,-0.04 0.27,0.03 0.1,0.05 0.2,0.17 0.74,0.87 0.15,0.02 0.12,-0.09 0.13,-0.15 0.35,-0.28 0.16,-0.19 0.37,-0.73 0.17,-0.23 0.2,-0.22 0.26,-0.21 1.62,-0.46 4.03,-0.64 0.44,-0.29 0.43,-0.36 0.7,-0.86 0.88,-2.37 0.21,-0.4 0.38,-0.91 0.63,-0.8 1.99,-1.49 -0.87,-0.81 -0.2,-0.5 0,-0.62 0.3,-1.19 0.32,-0.5 0.34,-0.33 3.9,-1.51 0.2,-0.16 0.13,-0.19 0.21,-0.57 0.15,-0.32 0.7,-0.95 0.48,-0.51 -0.17,-0.34 -0.57,-0.45 -4.78,-2.18 -0.6,-0.17 -1.56,-0.19 -0.28,-0.1 -0.18,-0.15 0.03,-0.31 0.11,-0.23 1.08,-0.61 0.39,-0.11 0.18,-0.09 0.21,-0.13 0.15,-0.18 0.12,-0.23 0.06,-0.31 0.01,-0.38 -0.05,-0.37 -0.13,-0.41 -0.24,-0.39 -0.49,-0.38 -0.45,-0.14 -0.49,-0.04 -2.13,0.11 -3.38,-0.31 -0.33,-0.13 -0.34,-0.18 -0.31,-0.25 -0.27,-0.35 -0.12,-0.5 -0.01,-0.72 0.31,-0.94 0.24,-0.58 0.25,-0.44 0.24,-0.33 0.25,-0.25 0.3,-0.19 0.31,-0.12 1.3,-0.14 0.27,-0.07 0.24,-0.12 0.84,-0.67 0.17,-0.25 0.09,-0.35 0.06,-1.02 -0.11,-0.45 -0.28,-0.42 -1.45,-1.22 -0.51,-0.73 -0.48,-1.64 0.25,-0.64 0.17,-0.23 0.48,-0.24 0.4,-0.14 2.7,-0.37 4.25,-0.86 0.31,-0.13 1.37,-0.84 0.29,-0.1 0.29,-0.04 0.45,0.07 0.55,0.17 0.93,0.41 0.39,0.32 0.24,0.3 0.23,0.23 0.4,0.12 1.49,0.14 0.93,0.28 0.8,0.12 1.39,0.04 1.83,-0.25 1.13,0.2 8.92,2.53 2.98,0.34 1.09,-2.32 0.25,-0.74 0.2,-0.3 0.95,-1.09 0.32,-0.49 0.33,-0.36 0.35,-0.22 0.56,-0.13 0.42,-0.01 0.36,0.1 0.54,0.31 0.39,-0.16 0.53,-0.44 1.01,-1.1 0.7,-1.16 1.37,-1.03 5.59,-2.91 -0.57,-0.48 -0.92,-0.52 -0.12,-0.18 -0.12,-0.31 0.25,-1.81 0.06,-1.76 -0.15,-1.32 -0.04,-1.51 -0.63,-1.74 -2.55,-2.75 -0.3,0.14 -0.21,0.03 -0.24,0 -0.23,-0.09 -1.7,-1.45 -0.32,-0.17 -0.35,-0.08 -0.34,0 -1.13,0.27 -0.34,0.04 -0.28,-0.03 -0.22,-0.12 -0.18,-0.16 -0.15,-0.17 -0.16,-0.11 -1.48,-0.45 -0.25,-0.18 -0.17,-0.26 -0.12,-0.46 -0.21,-1.99 0,-0.35 0.03,-0.37 0,-0.35 -0.04,-0.35 -0.09,-0.32 -0.12,-0.3 -0.07,-0.32 0,-0.35 0.22,-1.29 0.11,-0.39 0.27,-0.53 0.24,-0.35 0.34,-0.37 0.29,-0.25 1.24,-0.68 0.32,-0.69 0.13,-0.54 0.34,-0.74 0.14,-0.47 0.27,-1.72 0.17,-0.63 0.19,-0.48 0.2,-0.27 0.18,-0.35 0.04,-0.4 -0.38,-1.21 -0.02,-0.53 0.17,-0.63 0.37,-0.84 0.06,-0.44 -0.06,-0.49 -0.73,-2.01 -0.19,-1.04 0.13,-1.53 -4.26,0.93 -1.95,-0.11 -4.82,0.73 -0.39,-0.05 -0.39,-0.23 -0.26,-0.25 -0.4,-0.58 -0.24,-0.23 -0.36,-0.1 -0.48,0.02 -2.64,0.89 -0.52,0.04 z"
        />
      <path
        id="AF-HER"
        title="Hirat"
        
        d="m 42.797153,175.00119 -0.6,-0.53 0.41,-0.67 0.04,-0.16 -0.45,-0.41 -0.36,-0.18 -0.41,0 -2.54,0.49 -0.66,0.25 0.35,0.55 0.52,2.45 0.12,1.2 -0.31,1.24 -0.64,1.12 -1.14,1.39 -0.54,1.15 -0.42,1.87 -0.26,0.6 -1.02,1.38 -0.28,0.66 -0.23,1.22 0.23,3.06 -0.39,1.05 -0.93,0.54 -1.16,0.19 -1.03,0.03 -0.7,0.57 -0.28,1.27 -0.04,1.27 0.03,0.57 0.27,0.26 0.24,0.57 -0.02,0.57 -0.49,0.26 -0.29,0.27 0.25,0.59 1.73,2.33 0.13,0.25 -0.09,0.68 -0.13,0.52 0.07,0.49 0.51,0.54 -1.17,1.65 -0.35,0.85 -0.29,2.45 -0.71,2.22 -0.16,1.16 -0.15,0.57 -0.69,1.11 -0.15,0.74 0.05,0.61 0.21,1.1 0.04,0.51 -0.21,2.09 -0.39,1.95 -1.49,0.5 -0.27,0.97 -0.94,1.7 -1.54,1.2 -0.88,1.03 -0.06,1.39 0.16,1.53 -0.19,1.43 -0.51,0.68 -0.56,0.13 -0.63,-0.05 -0.68,0.11 -0.65,0.38 -0.32,0.39 -0.24,0.47 -2.21,2.52 -0.94,0.65 -1.21,0.34 -2.66,0.36 -1.21,0.62 -0.71,1.24 0.52,0.07 0.41,0.24 0.32,0.4 0.41,1.41 0.43,0.41 1.19,0.54 0.59,0.54 0.47,0.68 0.77,1.53 3.59,4.69 0.56,1.1 -3.62,0.21 -4.93,0.31 -3.4199997,0.2 0.33,1.25 -0.76,0.83 -2.3,1.23 -1.7,1.77 -1.53,1.99 -1.36000003,2.76 -0.29,2.62 0.08,0.79 0.53,5.07 1.39000003,8.93 -0.11,2.29 -1.50000003,3.39 -0.39,1.91 1.21000003,4.25 3.06,2.95 3.91,1.62 3.7999997,0.3 3.57,-0.19 1.87,0.13 1.63,0.42 0.75,0.44 0.82,0.73 0.43,0.84 -0.05,0.09 0.97,0.11 1.71,0.2 2.77,1.21 6.42,1.45 3.29,0.27 6.99,-0.75 0.89,0 0.56,0.14 1.01,0.45 0.52,0.05 0.66,-0.06 1.33,-0.46 0.57,-0.35 0.41,-0.4 0.31,-0.56 0.24,-0.57 0.34,-0.44 0.5,-0.28 1.09,-0.21 2.22,0.1 2.31,0.48 0.66,0.74 0.88,0.07 1.48,-0.1 3.65,0.27 3.21,0.74 0.47,0.39 0.1,0.41 -0.01,0.6 -0.07,0.48 -0.17,0.43 -0.22,0.31 -0.7,0.68 -0.18,0.27 -0.12,0.38 -0.05,0.5 -0.02,2.48 -0.08,0.46 -0.13,0.38 -0.25,0.39 -0.88,0.91 -0.7,0.52 -0.24,0.25 -0.4,0.61 -0.22,0.25 -0.45,0.41 -0.15,0.26 -0.01,0.52 0.23,0.47 1.9,2.09 2.19,3.52 -0.04,0.64 -0.46,0.6 -1.33,1.02 -0.47,0.43 -0.31,0.36 -0.53,0.75 -1.63,1.66 -0.64,0.51 -0.22,0.28 -0.17,0.32 -0.13,0.37 -0.14,0.28 -0.2,0.25 -0.28,0.24 -1.08,0.66 -0.28,0.26 -0.21,0.33 -0.28,0.88 -0.27,1.89 -0.06,2.05 0.1,0.94 0.3,0.68 0.39,0.29 0.49,0.21 0.52,0.16 2.89,0.11 0.5,0.11 0.36,0.21 0.32,0.42 0.51,0.91 1.8,1.84 0.41,0.33 0.24,0.15 0.22,0.08 0.24,0.02 0.32,-0.06 0.39,-0.2 0.31,-0.23 0.53,-0.57 1.28,-1.47 2.46,-1.81 0.79,-0.35 0.4,-0.02 0.3,0.05 0.16,0.11 0.1,0.16 0.1,1.54 0.12,0.7 0.28,0.84 0.03,0.22 0,0.22 -0.03,0.25 0.01,0.21 0.04,0.24 0.08,0.19 0.29,0.45 0.11,0.21 0.17,0.51 0.13,0.26 0.2,0.29 0.29,0.13 0.33,0.07 0.71,0.07 0.68,-0.07 0.41,-0.17 0.72,-0.39 1.47,-1.36 0.36,-0.26 0.77,-0.31 1.42,-0.31 3.97,-0.41 1.84,-0.36 1.1,0.04 0.94,0.15 0.34,-0.06 0.17,-0.13 0,-0.15 -0.14,-0.89 0.04,-0.37 0.18,-0.49 1.13,-2.44 0.11,-0.42 0.03,-0.29 -0.02,-0.31 -0.14,-0.63 -0.03,-0.47 0.06,-0.62 0.29,-0.94 0.32,-0.48 0.31,-0.29 0.78,-0.49 1.25,-1.04 1.42,-0.96 1.99,-1.01 0.63,-0.21 0.4,-0.06 0.29,-0.01 0.22,0.06 0.219997,0.08 1.29,0.7 0.3,0.08 0.37,0.05 0.41,-0.01 2.5,-0.48 1.97,-0.66 0.73,-0.42 0.54,-0.46 0.26,-0.41 0.18,-0.44 0.12,-0.54 0.32,-0.57 0.29,-0.27 0.26,-0.11 1.92,0.13 0.64,-0.07 0.73,-0.16 4.03,-1.43 1.18,-0.21 0.15,0.01 0.06,0.08 -0.03,0.14 -0.12,0.42 -0.04,0.19 0,0.18 0.03,0.14 0.07,0.11 0.06,0.06 0.15,0.07 0.17,0.04 4.24,-1.59 1.3,-1.31 0.12,-0.22 0.13,-0.37 -0.02,-0.27 0.12,-0.74 0.29,-1.04 0.84,-2.3 0.54,-1.15 0.46,-0.75 0.37,-0.28 1.1,-0.52 0.84,-0.65 -0.3,-1.06 -0.19,-2.18 0,-1.13 -0.25,-0.97 -0.34,-0.8 -0.99,-1.37 -0.34,-0.67 -0.14,-0.62 0.23,-0.69 0.04,-0.38 -0.12,-0.47 -0.19,-0.33 -0.21,-0.26 -0.45,-0.4 -0.09,-0.19 -0.03,-0.21 0.05,-0.36 0.14,-0.31 0.66,-0.69 1.97,-1.49 1.95,-0.87 0.82,-0.19 0.67,-0.29 0.8,-0.55 0.26,-0.27 0.15,-0.21 0.04,-0.09 0.76,-0.34 5.44,-1.52 4.69,-0.44 1.32,-0.44 1.11,-0.8 0.72,-1.45 0.04,-0.15 0,-0.33 -0.08,-0.55 -0.65,-2 -0.05,-0.29 0.05,-0.3 0.18,-0.39 0.19,-0.25 0.2,-0.18 0.2,-0.14 0.21,-0.07 0.84,-0.08 0.42,-0.1 0.46,-0.19 0.56,-0.3 0.46,-0.31 0.27,-0.46 -0.04,-0.5 -0.51,-0.83 -1.37,-1.41 -0.25,-0.43 -0.68,-2.47 -0.39,-0.77 -0.6,-0.88 -0.92,-1.11 -1.54,-1.29 -0.36,-0.37 -0.22,-0.43 -0.17,-0.51 -0.2,-0.92 -0.27,-0.64 -1.95,-3.3 -0.07,-0.59 0.22,-0.65 2.84,-4.25 1.32,-2.53 0.8,-3.38 6.67,-0.27 0.42,-0.06 0.82,-0.03 4.12,0.36 0.76,0.21 1.42,0.57 0.8,0.48 0.66,0.51 0.84,0.83 0.79,0.25 6.15,0.12 0.67,-0.35 0.31,-0.66 0.36,-0.58 0.09,-0.04 0.14,0.02 2.18,1.13 0.37,0.12 0.33,0.05 0.3,-0.01 0.22,-0.03 0.19,-0.06 0.15,-0.03 1.18,0.05 0.36,-0.06 0.4,-0.22 0.47,-0.38 0.72,-0.8 0.68,-0.42 0.49,-0.16 0.65,-0.05 0.33,-0.24 0.31,-0.43 0.35,-0.92 0.07,-0.7 -0.08,-0.54 -0.16,-0.4 -0.23,-0.36 -0.41,-0.55 -0.14,-0.23 -0.04,-0.33 0.1,-0.38 0.25,-0.66 0.03,-0.42 -0.06,-0.52 -0.09,-0.44 -0.04,-0.47 0.03,-0.41 0.13,-0.78 0.02,-0.3 -0.22,-1.69 0,-0.52 0.04,-0.43 0.08,-0.34 0.19,-0.26 0.32,-0.23 0.69,-0.27 0.45,-0.07 0.58,0.07 0.73,0.17 1,0.09 0.62,-0.06 0.64,-0.16 0.56,-0.36 0.31,-0.34 0.36,-0.24 0.52,-0.18 1.06,-0.11 0.86,-0.44 0.99,-0.67 0.35,-0.17 0.35,0.06 0.23,0.12 0.45,0.9 0.25,0.41 0.18,0.18 0.24,0.1 0.84,0.07 0.64,0.16 0.2,-0.03 0.16,-0.09 0.19,-0.24 0.04,-0.48 -0.11,-0.82 -0.74,-1.72 -0.17,-0.53 -0.09,-0.39 0.02,-1.58 0.79,-5.02 -5.37,0.39 -0.33,-0.06 -1.26,-0.55 -0.56,-0.18 -0.58,-0.1 -4.75,-0.08 -0.46,0.05 -0.59,0.22 -0.71,0.36 -1.21,0.84 -0.51,0.52 -0.3,0.43 -0.25,1.03 -0.09,0.18 -0.1,0.14 -0.25,0.17 -0.31,0.11 -1.14,0.16 -0.5,0.18 -3.26,2.62 -10.01,3.01 -0.96,0.1 -0.41,-0.12 -0.61,-0.44 -0.4,-0.37 -1.43,-0.81 -3.71,-1.09 -0.74,0.35 -0.79,0.23 -0.53,-0.01 -2.8,-0.48 -0.88,-0.28 -2,-1.08 -0.49,-0.4 -0.7,-0.72 -1.61,-0.87 -3.52,-1.29 -4.06,-0.46 -1.57,-0.14 -0.54,0.11 -0.41,0.25 -1.73,1.5 -0.76,0.16 -3.03,-1.46 -1.56,-0.32 -1.42,-0.28 -0.65,0.02 -0.09,-0.02 -0.08,-0.05 -0.05,-0.15 0.07,-1.62 -0.33,-0.84 -0.25,-0.39 -0.18,-0.16 -0.15,-0.17 -0.73,-1.18 -0.22,-0.2 -0.24,-0.08 -0.91,0.11 -1.83,-0.01 -0.41,-0.12 -0.59,-0.23 -0.64,-0.4 -0.54,-0.42 -0.43,-0.45 -0.33,-0.28 -0.31,-0.18 -1.38,-0.39 -0.36,-0.15 -0.51,-0.29 -1.28,-1.01 -1.68,-1.64 -0.39,-0.27 -0.31,-0.1 -0.22,-0.01 -0.31,0.06 -0.44,0.02 -0.36,-0.03 -2.19,-0.93 -0.16,-0.12 -0.14,-0.21 -0.17,-0.38 -0.34,-1.09 -0.11,-0.61 -0.05,-0.7 0.61,-6.63 0.36,-2.13 0.88,-2.97 0.49,-1.15 4.08,-6.85 1.88,-5.47 0.01,-0.5 -3.04,1.49 -1.27,1.29 -0.61,0.85 -0.63,0.62 -0.73,0.45 -3.52,1.53 -0.8,0.19 -0.43,-0.07 -1.43,-0.6 -0.52,0.02 -0.48,0.14 -0.489997,0.04 -0.53,-0.29 -3.18,-2.95 -1.31,0.07 -1.58,1.47 -4.72,6.44 -0.77,0.4 -0.51,-0.61 -0.91,-2.14 -0.29,-0.91 0.08,-2.4 -0.07,-1.04 -0.33,-1.05 -0.52,-0.94 -0.71,-0.74 -2.67,-1.18 -1.34,-0.9 -4.97,-4.92 -1.28,-0.89 -1.44,-0.71 -2.83,-0.06 -5.84,2.05 -2.88,0.22 -6.54,-1 -3.2,-1.3 -2.23,-2.49 -3.16,-2.9 -0.4,-0.18 -0.33,-0.15 -0.55,-0.09 -0.39,-0.22 -0.31,-0.35 -0.32,-0.47 -0.01,-0.24 0.19,-0.64 -0.02,-0.26 -0.77,-0.69 -0.11,-0.03 -0.07,0.02 z"
        />
      <path
        id="AF-BDG"
        title="Badghis"
        
        d="m 185.50715,186.97119 -0.39,-0.07 -0.52,-0.18 -1.77,-1.04 0.03,-0.46 0.33,-0.44 0.06,-0.12 0.11,-0.27 0.01,-0.29 -0.06,-0.34 -0.15,-0.36 -0.21,-0.36 -0.31,-0.31 -2.96,-0.56 -7.71,-0.55 -0.52,-0.28 -0.24,-0.17 -0.24,-0.2 -0.19,-0.22 -0.07,-0.23 0,-0.33 0.14,-0.59 0.06,-0.5 0.02,-0.58 -0.22,-4.18 -0.2,-1 -0.41,-1.19 -0.65,-1.16 -0.58,-0.74 -0.83,-0.83 -0.47,-0.35 -0.46,-0.26 -0.64,-0.26 -0.55,-0.1 -0.34,-0.1 -0.3,-0.19 -0.09,-0.46 0.11,-0.67 0.52,-1.45 0.71,-1.15 0.07,-0.29 -0.07,-1.25 0.12,-1.05 0.42,-1.28 0.85,-3.87 0.18,-2.35 -0.03,-2.63 -0.54,-1.8 -1.42,-0.84 -0.8,0.13 -1.45,0.45 -4.56,2.68 -1.95,0.51 -5.99,0.37 -0.98,0.22 -0.9,0.5 -0.67,0.7 -1.15,1.57 -0.72,0.65 -3.92,1.85 -4.24,0.88 -10.55,-0.24 -1.03,0.23 -0.75,0.78 -0.21,1.04 0.34,0.76 0.48,0.76 0.22,1.06 0.31,0.78 2.48,2.25 0.68,0.92 0.32,0.27 1.23,0.47 0.25,0.31 -0.04,0.41 -0.29,0.55 -1.34,1 -3.73,1.22 -1.28,1.27 -0.08,0.89 0.11,3.04 0.16,0.73 0.81,0.66 0.17,0.63 -0.5,1.87 -0.21,2.25 -0.29,1.11 -0.65,0.68 -0.96,0.26 -2.01,0.17 -0.98,0.23 -3.26,1.57 -4.39,3.5 -0.22,0.11 -0.01,0.5 -1.88,5.47 -4.08,6.85 -0.49,1.15 -0.88,2.97 -0.36,2.13 -0.61,6.63 0.05,0.7 0.11,0.61 0.34,1.09 0.17,0.38 0.14,0.21 0.16,0.12 2.19,0.93 0.36,0.03 0.44,-0.02 0.31,-0.06 0.22,0.01 0.31,0.1 0.39,0.27 1.68,1.64 1.28,1.01 0.51,0.29 0.36,0.15 1.38,0.39 0.31,0.18 0.33,0.28 0.43,0.45 0.54,0.42 0.64,0.4 0.59,0.23 0.41,0.12 1.83,0.01 0.91,-0.11 0.24,0.08 0.22,0.2 0.73,1.18 0.15,0.17 0.18,0.16 0.25,0.39 0.33,0.84 -0.07,1.62 0.05,0.15 0.08,0.05 0.09,0.02 0.65,-0.02 1.42,0.28 1.56,0.32 3.03,1.46 0.76,-0.16 1.73,-1.5 0.41,-0.25 0.54,-0.11 1.57,0.14 4.06,0.46 3.52,1.29 1.61,0.87 0.7,0.72 0.49,0.4 2,1.08 0.88,0.28 2.8,0.48 0.53,0.01 0.79,-0.23 0.74,-0.35 3.71,1.09 1.43,0.81 0.4,0.37 0.61,0.44 0.41,0.12 0.96,-0.1 10.01,-3.01 3.26,-2.62 0.5,-0.18 1.14,-0.16 0.31,-0.11 0.25,-0.17 0.1,-0.14 0.09,-0.18 0.25,-1.03 0.3,-0.43 0.51,-0.52 1.21,-0.84 0.71,-0.36 0.59,-0.22 0.46,-0.05 4.75,0.08 0.58,0.1 0.56,0.18 1.26,0.55 0.33,0.06 5.37,-0.39 0.18,-0.62 0.11,-0.25 0.28,-0.37 0.4,-0.47 0.61,-0.33 1,-0.31 5.94,0.24 0.78,0.4 0.4,0.15 0.69,0.04 0.39,0.14 0.5,0 0.59,-0.17 3.21,-1.61 8.65,-2.39 1.48,-0.72 0.32,-0.4 0.18,-0.1 0.22,-0.19 0.17,-0.25 0.48,-1.08 0.24,-0.78 0.3,-1.47 0.04,-0.49 -0.09,-1.05 -0.01,-0.55 0.08,-0.62 0.47,-2 0.09,-0.6 -0.13,-0.64 -0.33,-0.69 -0.83,-1.19 -0.39,-0.72 -0.22,-0.64 -0.07,-0.52 -0.36,-0.7 -0.64,-0.81 -2.98,-2.14 -0.39,-0.4 -1.2,-1.78 -0.7,-0.83 -0.46,-0.44 -0.49,-0.35 -0.6,-0.18 -1.21,0.11 -0.31,-0.06 -0.32,-0.14 -2.07,-1.33 -0.72,-0.72 -0.97,-2.04 -0.52,0.24 -1.14,0.25 -1.62,0.06 -1.44,0.26 -0.9,0.01 -4.96,-0.68 -4.63,-1.54 -0.27,-0.17 -0.14,-0.28 -0.11,-0.77 0.03,-0.99 0.26,-2.17 -0.03,-0.93 0.04,-0.59 0.46,-1.81 0.18,-1.33 0.01,-0.76 -0.06,-0.58 -0.4,-0.37 -2.12,0.31 -1.76,0.58 -0.54,0.05 -0.89,0.27 z"
        />
    </svg>

  `,
  france: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180" class="dmb-country-map" data-map-name="france">
      <path d="M60 20 L120 30 L150 70 L135 130 L90 160 L40 135 L25 85 Z"></path>
    </svg>
  `
};

(function () {
  const MODE_KEY = "dmb_mode";
  const COVER_KEY = "dmb_selected_cover";

  function setStoredMode(mode) {
    try {
      if (!mode) localStorage.removeItem(MODE_KEY);
      else localStorage.setItem(MODE_KEY, mode);
    } catch {}
  }

  function clearCoverState() {
    try { localStorage.removeItem(COVER_KEY); } catch {}
    try { sessionStorage.removeItem(COVER_KEY); } catch {}
  }

  function onCustomizeClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    clearCoverState();
    setStoredMode("customize");
    // Start a BRAND-NEW custom book: mint a fresh design id and carry it in the URL
    // so this book has its OWN save key. Without this, every "from scratch" book
    // reused one shared id ("dmb_active_design_book") — so a new book offered the
    // PREVIOUS book's saved design + photos, and a stale local copy survived even
    // after deleting it from Saved Designs. Now a new book restores nothing (empty
    // key); only opening a SPECIFIC saved design (?design=<id>) offers a restore.
    var _newId = "d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    try { localStorage.setItem("dmb_active_design_book", _newId); } catch (err) {}
    window.location.assign("/pages/design-my-book?step=upload&design=" + encodeURIComponent(_newId));
    return false;
  }

  function onBrowseClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    setStoredMode("browse");
    window.location.assign("/collections");
    return false;
  }

  function hookButtonsDirect() {
    const browseBtn =
      document.getElementById("browseCollectionBtn") ||
      document.querySelector('#step1 a[href*="/collections"]');

    const customizeBtn =
      document.getElementById("customizeOrderBtn") ||
      document.querySelector('#step1 a[href*="mode=customize"]');

    if (browseBtn) browseBtn.addEventListener("click", onBrowseClick, true);
    if (customizeBtn) customizeBtn.addEventListener("click", onCustomizeClick, true);
  }

  function enforceUrlWinsOverStorage() {
    try {
      const qs = new URLSearchParams(window.location.search || "");
      const urlMode = qs.get("mode");
      if (urlMode) setStoredMode(urlMode);
    } catch {}
  }

  function enforceCustomizeClearsCover() {
    try {
      const qs = new URLSearchParams(window.location.search || "");
      if (qs.get("mode") === "customize") clearCoverState();
    } catch {}
  }

  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      hookButtonsDirect();
      enforceUrlWinsOverStorage();
      enforceCustomizeClearsCover();
    }
  });

  function renderBuilderCanvas() {
    if (builderMode === "cover") {
      renderCoverCanvas();
    } else {
      renderSpread();
    }
    syncBuilderModeButtons();
    setCanvasZoom(currentZoom);
  }

  function openCoverMode() {
    builderMode = "cover";
    syncBuilderModeButtons();
    renderBuilderCanvas();
    activateLeftTab("cover");
  }

  function initDefaultBuilderPreview() {
    if (!builderStep) return;

    initUnifiedTabs();
    initCoverDesigner();

    builderMode = "cover";
    syncBuilderModeButtons();
    renderCoverCanvas();
    renderThumbsRail();

    if (bookMeta) {
      const selectedPages = Number(pagesEl?.value || 0);
      if (selectedPages > 0) {
        bookMeta.textContent = `${selectedPages} pages (${Math.max(0, selectedPages - 1)} to design) • ${editor.photos.length} photos`;
      } else {
        bookMeta.textContent = "Start by choosing pages, photos, and customizing your cover.";
      }
    }
  }

  function getObjectListForTarget(targetType, pageNumber, zone) {
    if (targetType === "cover") {
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      return editor.coverObjects;
    }

    if (!editor.pageObjects || typeof editor.pageObjects !== "object") {
      editor.pageObjects = {};
    }

    // WARNING: Do NOT use `if (!p)` here — Number(0) = 0 and !0 = true,
    // which would silently return [] for page 0 (the special inner-cover page),
    // making all maps/stickers/text on page 0 invisible in the builder.
    if (pageNumber == null || !Number.isFinite(Number(pageNumber))) return [];
    const p = Number(pageNumber);

    if (!Array.isArray(editor.pageObjects[p])) {
      editor.pageObjects[p] = [];
    }

    return editor.pageObjects[p];
  }

  function renderFreeFrameObjects(container, meta) {
    const targetType = meta?.targetType || "page";
    const pageNumber = meta?.pageNumber ?? null;
    const zone = meta?.zone || null;
    // Pages: z >= 60 keeps frames above the spread overlay (z:50).
    // Cover: use own z-value — drops handled by peek-under method, not z-index.
    const minFrameZ = targetType === "cover" ? 0 : 60;

    const rawObjs = getObjectListForTarget(targetType, pageNumber, zone);

    const objs = Array.isArray(rawObjs)
      ? rawObjs.slice().sort((a, b) => Number(a.z || 0) - Number(b.z || 0))
      : [];

    objs.forEach((obj) => {
      if (obj.type === "text") {
        // Skip empty text — cleared text boxes are removed from state in
        // savePageTextState/saveCoverTextNodeState; this is a safety net so stale
        // empty objects left in older saved sessions never reappear after a re-render.
        if (!obj.text || !obj.text.trim()) return;
        const txt = document.createElement("div");
        txt.id = obj.id;
        txt.textContent = obj.text || "";
        txt.classList.add("dmb-editable-text");
        txt.style.position = "absolute";
        txt.style.left = obj.left || "40px";
        txt.style.top = obj.top || "40px";
        if (obj.width) {
          txt.style.width = obj.width;
          // An explicit width outranks .dmb-editable-text's min-width:120px, which
          // exists only so a brand-new EMPTY box is big enough to tap. Without this
          // release, a box narrowed below 120px with the side grip snapped back wide
          // on the next re-render. (2026-09-14)
          txt.style.minWidth = "0";
        }
        txt.style.fontSize = obj.fontSize || "28px";
        txt.style.fontWeight = obj.fontWeight || "800";
        txt.style.color = obj.color || "#666";
        txt.style.fontFamily = obj.fontFamily || "'Londrina Solid', sans-serif";
        if (obj.textAlign) txt.style.textAlign = obj.textAlign;
        if (obj.textDecoration) txt.style.textDecoration = obj.textDecoration;
        if (obj.whiteSpace) txt.style.whiteSpace = obj.whiteSpace;
        if (obj.transform) txt.style.transform = obj.transform;
        if (obj.rotate) txt.dataset.rotate = obj.rotate;
        txt.dataset.z = obj.z || String(Date.now());
        txt.style.zIndex = txt.dataset.z;
        txt.dataset.pageNumber = String(pageNumber);
        txt.style.padding = "2px 6px";
        txt.style.background = "transparent";
        txt.style.outline = "none";
        attachTextNodeHandlers(txt);
        container.appendChild(txt);
        return;
      }

      if (obj.type !== "photo-frame") return;

      const frame = document.createElement("div");
      frame.className = "dmb-photo-frame-object";
      frame.dataset.objectId = obj.id;
      frame.style.left = `${obj.x}px`;
      frame.style.top = `${obj.y}px`;
      frame.style.width = `${obj.w}px`;
      frame.style.height = `${obj.h}px`;
      const z = obj.z || 10;
      // On pages: z >= 60 (above spread overlay z:50). On cover: z >= 100001 (above cover drag overlay z:100000).
      frame.style.zIndex = String(Math.max(z, minFrameZ));
      frame.dataset.z = String(z);
      if (obj.rotation) frame.style.transform = `rotate(${obj.rotation}deg)`;
      if (obj.coverZone) dmbApplyZoneClip(frame, obj);

      // ── Polaroid frame styling: white mat + thicker bottom + light shadow ──
      const _isPoly = !!obj.polaroid;
      let _polyInsetCss = null;
      if (_isPoly) {
        const _pi = dmbPolaroidInsetVals(obj.w, obj.h);
        _polyInsetCss = `${_pi.top}px ${_pi.right}px ${_pi.bottom}px ${_pi.left}px`;
        frame.classList.add("dmb-polaroid");
        frame.style.background = "#ffffff";
        frame.style.borderRadius = "2px";
        frame.style.boxShadow = (obj.shadow !== false) ? "0 6px 16px rgba(0,0,0,0.18)" : "none";
      }

      if (obj.photoId) {
        const ph = getPhotoById(obj.photoId);
        if (ph) {
          // Overflow visible so buttons escape; inner clip keeps photo contained
          frame.style.overflow = "visible";
          const photoClip = document.createElement("div");
          photoClip.style.cssText = `position:absolute;inset:${_polyInsetCss || "0"};overflow:hidden;${_isPoly ? "" : "border-radius:inherit;"}pointer-events:none;`;
          const img = document.createElement("img");
          img.src = ph.url; img.alt = ""; img.draggable = false;
          img.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;";
          if (obj.frameShape) applyDmbFrameShape(img, obj.frameShape);
          photoClip.appendChild(img);
          frame.appendChild(photoClip);

          // Adaptive button layout based on frame width
          const _btnSVGs = [
            { aria:"Remove photo",  title:"Remove photo",  svg:`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");obj.photoId=null;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail();renderPhotoTray(); }},
            { aria:"Rotate",        title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");obj.rotation=((obj.rotation||0)-90+360)%360;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail(); }},
            { aria:"Crop",          title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(obj.photoId, { get:()=>obj.photoId, set:(id)=>{ obj.photoId=id; } }); }},
            { aria:"Frame shape",   title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="13" height="13" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();showDmbFramePicker(e.currentTarget,obj.frameShape||"",(s)=>{ pushUndoState("Frame Shape");obj.frameShape=s;applyDmbFrameShape(img,s); }); }}
          ];
          const _bs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
          const fw = obj.w || 100;

          if (fw >= 130) {
            // Wide: single row top-right
            _btnSVGs.forEach((d, i) => {
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:4px;right:${4+i*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else if (fw >= 65) {
            // Medium: 2×2 grid top-right
            _btnSVGs.forEach((d, i) => {
              const r=Math.floor(i/2), c=i%2;
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:${4+r*26}px;right:${4+c*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else {
            // Narrow: single ⋯ toggle
            const mb = document.createElement("button"); mb.type="button"; mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:2px;right:2px;width:22px;height:22px;z-index:12;font-size:13px;line-height:1;${_bs}`;
            const pop = document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:4px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _btnSVGs.forEach(d => {
              const b = document.createElement("button"); b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{ pop.style.display="none"; d.fn(ev); });
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{ e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");} });
            frame.appendChild(mb); frame.appendChild(pop);
          }
        }
      } else {
        const plus = document.createElement("div");
        plus.className = "dmb-photo-frame-plus";
        plus.innerHTML = '<span style="font-size:22px;display:block;">+</span><span style="font-size:11px;opacity:.7;">Drop photo here</span>';
        if (_isPoly) {
          plus.style.position = "absolute";
          plus.style.inset = _polyInsetCss;
          plus.style.background = "#f3efe6";
          plus.style.display = "flex";
          plus.style.flexDirection = "column";
          plus.style.alignItems = "center";
          plus.style.justifyContent = "center";
        }
        frame.appendChild(plus);
      }

      const handles = [
        ["tl", "0", "0"],
        ["tm", "50%", "0"],
        ["tr", "100%", "0"],
        ["ml", "0", "50%"],
        ["mr", "100%", "50%"],
        ["bl", "0", "100%"],
        ["bm", "50%", "100%"],
        ["br", "100%", "100%"]
      ];

      handles.forEach(([pos, left, top]) => {
        const h = document.createElement("div");
        h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
        h.dataset.handle = pos;
        h.style.left = left;
        h.style.top = top;
        frame.appendChild(h);
      });

      /* ── Frame rotation handle (Fix 4) ── */
      const _fRotHandle = document.createElement("div");
      _fRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
      _fRotHandle.innerHTML = "&#8635;";
      _fRotHandle.title = "Rotate frame";
      _fRotHandle.style.display = "none";
      document.body.appendChild(_fRotHandle);
      frame._dmbRotHandle = _fRotHandle;

      function _updateFrameRotPos() {
        if (!frame.isConnected) { _fRotHandle.remove(); return; }
        const _rr = frame.getBoundingClientRect();
        _fRotHandle.style.left = (_rr.right + 14) + "px";
        _fRotHandle.style.top = (_rr.bottom + 14) + "px";
      }
      requestAnimationFrame(_updateFrameRotPos);

      _fRotHandle.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        const _startRot = obj.rotation || 0;
        const _rr2 = frame.getBoundingClientRect();
        const _cx = _rr2.left + _rr2.width / 2, _cy = _rr2.top + _rr2.height / 2;
        const _startAng = Math.atan2(e.clientY - _cy, e.clientX - _cx) * 180 / Math.PI;
        const _onMove = (ev) => {
          const _ang = Math.atan2(ev.clientY - _cy, ev.clientX - _cx) * 180 / Math.PI;
          obj.rotation = _dmbSnapAngle(_startRot + (_ang - _startAng));
          frame.style.transform = `rotate(${obj.rotation}deg)`;
          _updateFrameRotPos();
          showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
        };
        const _onUp = () => {
          hideRotDegTooltip();
          document.removeEventListener("pointermove", _onMove);
          document.removeEventListener("pointerup", _onUp);
          pushUndoState("Rotate Frame");
        };
        document.addEventListener("pointermove", _onMove);
        document.addEventListener("pointerup", _onUp);
      });

      frame.addEventListener("click", (e) => {
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, {
          targetType,
          pageNumber,
          zone
        });
      });

      frame.addEventListener("dragover", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      });

      frame.addEventListener("drop", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        if (!payload || !payload.photoId) return;

        pushUndoState("Drop Photo In Frame");
        obj.photoId = payload.photoId;
        renderBuilderCanvas();
        renderPhotoTray();
        renderThumbsRail();
      });

      let dragMode = null;
      let sx = 0, sy = 0, ox = 0, oy = 0, ow = 0, oh = 0;

      frame.addEventListener("pointerdown", (e) => {
        if (e.target.closest(".dmb-frame-handle")) return;
        // Let action buttons (crop, remove, rotate, etc.) receive their click events
        // normally — pointerdown.preventDefault() would suppress click for the whole
        // pointer sequence, making inline buttons unresponsive.
        if (e.target.closest("button")) return;
        e.preventDefault();
        e.stopPropagation();

        showFrameToolbarFor(frame, obj, {
          targetType,
          pageNumber,
          zone
        });

        dragMode = "move";
        sx = e.clientX;
        sy = e.clientY;
        ox = obj.x;
        oy = obj.y;

        const onMove = (ev) => {
          if (dragMode !== "move") return;
          obj.x = ox + (ev.clientX - sx);
          obj.y = Math.max(0, oy + (ev.clientY - sy));
          frame.style.left = `${obj.x}px`;
          frame.style.top = `${obj.y}px`;
          showFrameToolbarFor(frame, obj, {
            targetType,
            pageNumber,
            zone
          });
        };

        const onUp = () => {
          dragMode = null;
          document.removeEventListener("pointermove", onMove);
          document.removeEventListener("pointerup", onUp);
        };

        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", onUp);
      });

      frame.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
        handle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();

          showFrameToolbarFor(frame, obj, {
            targetType,
            pageNumber,
            zone
          });

          dragMode = handle.dataset.handle;
          sx = e.clientX;
          sy = e.clientY;
          ox = obj.x;
          oy = obj.y;
          ow = obj.w;
          oh = obj.h;

          const onMove = (ev) => {
            const dx = ev.clientX - sx;
            const dy = ev.clientY - sy;

            if (dragMode.includes("r")) obj.w = Math.max(60, ow + dx);
            if (dragMode.includes("b")) obj.h = Math.max(60, oh + dy);

            if (dragMode.includes("l")) {
              const nextW = Math.max(60, ow - dx);
              const consumed = ow - nextW;
              obj.x = ox + consumed;
              obj.w = nextW;
            }

            if (dragMode.includes("t")) {
              const nextH = Math.max(60, oh - dy);
              const consumed = oh - nextH;
              obj.y = oy + consumed;
              obj.h = nextH;
            }

            frame.style.left = `${obj.x}px`;
            frame.style.top = `${obj.y}px`;
            frame.style.width = `${obj.w}px`;
            frame.style.height = `${obj.h}px`;
            showFrameToolbarFor(frame, obj, {
              targetType,
              pageNumber,
              zone
            });
          };

          const onUp = () => {
            dragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
          };

          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });
      });

      container.appendChild(frame);
    });
  }
  function getActiveEditablePageIndex() {
    if (typeof builderMode !== "undefined" && builderMode === "cover") return null;

    const spread = Number(editor?.currentSpread || 0);
    const leftPage = spread * 2 + 1;
    const rightPage = leftPage + 1;

    if (leftPage >= 2 && leftPage <= editor.totalPages) return leftPage;
    if (rightPage >= 2 && rightPage <= editor.totalPages) return rightPage;

    return null;
  }

  document.addEventListener("DOMContentLoaded", () => {
    hookButtonsDirect();
    enforceUrlWinsOverStorage();
    enforceCustomizeClearsCover();
  });

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target && e.target.closest ? e.target.closest(".dmb-select-design-btn") : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const href = btn.getAttribute("data-href") || btn.getAttribute("href");
      if (href) window.location.href = href;
    },
    true
  );
})();

/* =========================
   MAIN DMB APP
   ========================= */
(() => {
  /* ── STEP 2 - RENDER MODE predicate + accounting ──────────────────────────
   * Armed ONLY by snippets/dmb-render-mode.liquid, which requires ?render=1 AND a
   * 32-hex job token - so this can never trip on a customer URL. Every guard that
   * uses it is one line and a no-op for customers.
   * FUNCTION DECLARATIONS on purpose: they hoist above the eval-time IIFEs in this
   * module (the sessionStorage write and the guest-session lifecycle both run before
   * any branch and both need this). var state avoids a TDZ during module evaluation.
   * The accounting object exists because the PDF engine wraps EVERY photo/sticker/
   * logo draw in a swallowing try/catch: without it, a 404 or a CORS failure yields a
   * "successful" book with blank areas and no signal at all. */
  function _dmbRenderMode() {
    try { return window.DMB_RENDER_MODE === true; } catch (e) { return false; }
  }
  function _dmbRenderLiveText() {
    try { return !!(window.DMB_RENDER_MODE && window.__DMB_RENDER_LIVETEXT); } catch (e) { return false; }
  }
  var _DMB_RM = {
    token: "", job: "", proxy: "", crops: "prefer-r2", hash: false, livetext: false,
    exclude: null, from: -1, to: -1, part: 0, parts: 1, staged: 0, count: 0, hb: null,
    // INCREMENTAL RENDER: fps[i] = content fingerprint of PDF page i (from the mint);
    // reuse = indices the Worker already holds a staged image for. Those pages are
    // NOT rendered - the loop emits a numbering placeholder and moves on.
    fps: null, reuse: null,
    notes: { photo_missing: [], master_miss: [], crop_fallback: [], crop_rebake: 0 },
    fonts: { loaded: [], missing: [], system: [] },
  };
  function _dmbRenderNote(kind, id) {
    try {
      if (kind === "crop_rebake") { _DMB_RM.notes.crop_rebake++; return; }
      var a = _DMB_RM.notes[kind];
      if (a && a.length < 200 && a.indexOf(id) === -1) a.push(id);
    } catch (e) {}
  }

  // ---------- constants ----------
  // Base prices keyed by SIZE → page count. A4 is the original size; A5 is the
  // cheaper size. (old = compare-at / "was"; new = current selling price — these
  // mirror the Shopify variant compare_at_price / price so the builder total
  // matches checkout.) A4 values are unchanged from before, so non-size code
  // paths (e.g. magazine, which stays "A4") behave exactly as they used to.
  const PRICES = {
    A4: {
      "24": { old: 50,    new: 35 },
      "30": { old: 55,    new: 38.50 },
      "40": { old: 65,    new: 45.50 },
      "50": { old: 75,    new: 52.50 },
      "76": { old: 93.50, new: 65.45 },
      "100":{ old: 120,   new: 84 }
    },
    A5: {
      "24": { old: 47.50, new: 33.25 },
      "30": { old: 52.50, new: 36.75 },
      "40": { old: 62.50, new: 43.75 },
      "50": { old: 72.50, new: 50.75 },
      "76": { old: 85,    new: 59.50 },
      "100":{ old: 100,   new: 70 }
    }
  };

  // ── Extra spreads pricing ─────────────────────────────────────────────────
  // Each extra spread (2 pages) is priced by the "spread" product. The base price
  // comes from PRICES above; extra spread cost is added on top in updatePrice()
  // and in addDesignedBookToCart() (via DMB_EXTRA_SPREAD_VARIANT_ID line items).
  // Price comes LIVE from window.DMB_EXTRA_SPREAD_PRICE (exposed by the Liquid from
  // the product's real price), so editing that product updates every label. Fallback
  // 1.99 only if the product/price can't be read.
  const EXTRA_SPREAD_PRICE = (typeof window.DMB_EXTRA_SPREAD_PRICE === "number" && window.DMB_EXTRA_SPREAD_PRICE > 0)
    ? window.DMB_EXTRA_SPREAD_PRICE
    : 1.99;

  const PHOTO_LIMITS = {
    "24": { min: 23, max: 32 },
    "30": { min: 29, max: 38 },
    "40": { min: 39, max: 48 },
    "50": { min: 49, max: 58 },
    "76": { min: 75, max: 84 },
    "100":{ min: 99, max: 108 }
  };

  // ── Book variants (pages × size → Shopify variant id) ─────────────────────
  // Fallback map (the original hardcoded ids). The liquid emits the LIVE list
  // (window.DMB_BOOK_VARIANTS) straight from the "custom-photo-book" product, and
  // _dmbIngestBookVariants() below merges it in — so ADDING a page-count or size
  // variant in Shopify admin makes it appear in the builder with the correct price
  // and checkout variant, with NO code change. If the product can't be read, this
  // fallback keeps the original sizes working.
  const BOOK_VARIANT_IDS = {
    "24": { A4: 48404302856407, A5: 48892347941079 },
    "30": { A4: 48350688051415, A5: 48892348104919 },
    "40": { A4: 48350688084183, A5: 48892348268759 },
    "50": { A4: 48350688116951, A5: 48892348432599 },
    "76": { A4: 48892348596439, A5: 48892348629207 },
    "100":{ A4: 48892348793047, A5: 48892348825815 }
  };

  (function _dmbIngestBookVariants() {
    var list = window.DMB_BOOK_VARIANTS;
    if (!Array.isArray(list)) return;   // product unreadable → keep hardcoded fallbacks
    list.forEach(function (v) {
      if (!v) return;
      var pages = String(v.pages == null ? "" : v.pages).trim();
      var size  = String(v.size  == null ? "" : v.size ).trim().toUpperCase();
      // Defensive: if the option order is ever swapped in admin (size in option1),
      // detect it — pages must be numeric, size must look like "A4"/"A5".
      if (!/^\d+$/.test(pages) && /^\d+$/.test(size)) { var t = pages; pages = size; size = t; }
      if (!/^\d+$/.test(pages)) return;
      if (size !== "A4" && size !== "A5") return;
      var priceNew = Number(v.price);
      var priceOld = Number(v.compare);
      if (!(priceOld > 0)) priceOld = priceNew;   // no compare-at → no strike-through
      if (priceNew > 0) {
        if (!PRICES[size]) PRICES[size] = {};
        PRICES[size][pages] = { old: priceOld, new: priceNew };
      }
      // PHOTO_LIMITS is only kept for parity; derive new sizes to match the existing
      // pattern (min = pages − 1, max = pages + 8) without disturbing hardcoded ones.
      if (!PHOTO_LIMITS[pages]) {
        PHOTO_LIMITS[pages] = { min: Math.max(1, Number(pages) - 1), max: Number(pages) + 8 };
      }
      if (v.id) { (BOOK_VARIANT_IDS[pages] = BOOK_VARIANT_IDS[pages] || {})[size] = v.id; }
    });
  })();

  // Minimum photos to start designing — a FLAT 20, regardless of page count
  // (small or large book, the requirement is the same).
  const MIN_PHOTOS = 20;

  const SPECIAL_PAGE_TEXT = "Our special first page design";
  const LOCKED_PAGE_NUMBER = 1;
  const PORTRAIT_MAX_RATIO = 0.85;
  let spreadPhotoDragState = null; // { type:"pan"|"resize", si, startX, startY, startPanX, startPanY, startZoom }

  // ---------- page templates ----------
  const TEMPLATE_NAMES = {
    t1: "Triple Stack",
    t2: "Inset Full",
    t3: "Diagonal Duo",
    t4: "Tall Left Split Right",
    t5: "Center Panel Bands",
    t6: "2x2 Grid Top",
    t7: "3x3 Grid",
    t8: "Centered Duo",
    t9: "Triple Bands",
    t10: "Floating lower",
    t11: "Triple Stack Right",
    t12: "Floating Exact Center",
    t13: "Floating Upper",
    t14: "2x2 Upper",
    t15: "Banner Top + Full",
    t16: "Wide Top + 4 Mixed",
    t17: "Asymmetric 5",
    t18: "Full + Bottom 3",
    t19: "2 Column Full",
    t20: "Left 4 + Right Full",
    t21: "Left Full + Right 4",
    t22: "Top Wide + 2 Portrait",
    t23: "2x2 Full Bleed",
    t24: "Almost Full Page",
    t25: "Top 3 + Mixed Rows",
    t26: "Top 3 + Stack + Full",
    t27: "3 Center Bands",
    t28: "2 Portraits Centered",
    t29: "Right Column 3",
    t30: "Side by Side",
    t31: "Top and Bottom",
    t32: "Two Portraits",
    t33: "Big Top, Wide Bottom",
    t34: "Full-Bleed Halves",
    t35: "Wide Center",
    tfull: "Full Page"
  };

  const TEMPLATE_DEFS = {
    // Single frame covering the ENTIRE page/cover (full bleed) — drop one photo to
    // fill the whole page. Listed first so it's easy to find.
    tfull: [
      { key: "S1", x: 0, y: 0, w: 100, h: 100 }
    ],
    // ── Added layouts (2-photo mostly — that category was thin) ──
    t30: [
      { key: "S1", x: 6,  y: 6, w: 42, h: 88 },
      { key: "S2", x: 52, y: 6, w: 42, h: 88 }
    ],
    t31: [
      { key: "S1", x: 6, y: 6,  w: 88, h: 42 },
      { key: "S2", x: 6, y: 52, w: 88, h: 42 }
    ],
    t32: [
      { key: "S1", x: 8,  y: 20, w: 40, h: 60 },
      { key: "S2", x: 52, y: 20, w: 40, h: 60 }
    ],
    t33: [
      { key: "S1", x: 6, y: 6,  w: 88, h: 54 },
      { key: "S2", x: 6, y: 64, w: 88, h: 30 }
    ],
    t34: [
      { key: "S1", x: 0, y: 0,  w: 100, h: 50 },
      { key: "S2", x: 0, y: 50, w: 100, h: 50 }
    ],
    t35: [
      { key: "S1", x: 4, y: 26, w: 92, h: 48 }
    ],
    t1: [
      { key: "S1", x: 28, y: 8,  w: 44, h: 24 },
      { key: "S2", x: 28, y: 35, w: 44, h: 24 },
      { key: "S3", x: 28, y: 62, w: 44, h: 24 }
    ],
    t2: [
      { key: "S1", x: 8, y: 8, w: 84, h: 84 }
    ],
    t3: [
      { key: "S1", x: 10, y: 12, w: 42, h: 28 },
      { key: "S2", x: 48, y: 60, w: 42, h: 28 }
    ],
    t4: [
      { key: "S1", x: 0,  y: 0,  w: 48, h: 100 },
      { key: "S2", x: 48, y: 0,  w: 52, h: 48 },
      { key: "S3", x: 48, y: 48, w: 52, h: 52 }
    ],
    t5: [
      { key: "S1", x: 20, y: 21, w: 60, h: 58 }
    ],
    t6: [
      { key: "S1", x: 14, y: 22, w: 32, h: 24 },
      { key: "S2", x: 54, y: 22, w: 32, h: 24 },
      { key: "S3", x: 14, y: 54, w: 32, h: 24 },
      { key: "S4", x: 54, y: 54, w: 32, h: 24 }
    ],
    t7: [
      { key: "S1", x: 2,  y: 8,  w: 31, h: 26 },
      { key: "S2", x: 34, y: 8,  w: 32, h: 26 },
      { key: "S3", x: 67, y: 8,  w: 31, h: 26 },
      { key: "S4", x: 2,  y: 36, w: 31, h: 26 },
      { key: "S5", x: 34, y: 36, w: 32, h: 26 },
      { key: "S6", x: 67, y: 36, w: 31, h: 26 },
      { key: "S7", x: 2,  y: 64, w: 31, h: 26 },
      { key: "S8", x: 34, y: 64, w: 32, h: 26 },
      { key: "S9", x: 67, y: 64, w: 31, h: 26 }
    ],
    t8: [
      { key: "S1", x: 24, y: 10, w: 52, h: 36 },
      { key: "S2", x: 24, y: 49, w: 52, h: 38 }
    ],
    t9: [
      { key: "S1", x: 0, y: 0,  w: 100, h: 31 },
      { key: "S2", x: 0, y: 31, w: 100, h: 31 },
      { key: "S3", x: 0, y: 62, w: 100, h: 38 }
    ],
    t10: [
      { key: "S1", x: 24, y: 46, w: 52, h: 28 }
    ],
    t11: [
      { key: "S1", x: 50, y: 8,  w: 44, h: 24 },
      { key: "S2", x: 50, y: 35, w: 44, h: 24 },
      { key: "S3", x: 50, y: 62, w: 44, h: 24 }
    ],
    t12: [
      { key: "S1", x: 24, y: 36, w: 52, h: 28 }
    ],
    t13: [
      { key: "S1", x: 24, y: 16, w: 52, h: 28 }
    ],
    // ── User-designed layouts (1–16) ──────────────────────────────────────
    // 1: 2×2 grid, upper portion – all frames same size, h-gap = v-gap = 10%
    t14: [
      { key: "S1", x:  9, y: 13, w: 36, h: 24 },
      { key: "S2", x: 55, y: 13, w: 36, h: 24 },
      { key: "S3", x:  9, y: 47, w: 36, h: 24 },
      { key: "S4", x: 55, y: 47, w: 36, h: 24 }
    ],
    // 2: 3 equal frames top row + 1 large frame filling rest of page
    t15: [
      { key: "S1", x:  0, y:  0, w: 31, h: 28 },
      { key: "S2", x: 32, y:  0, w: 32, h: 28 },
      { key: "S3", x: 65, y:  0, w: 35, h: 28 },
      { key: "S4", x:  0, y: 29, w:100, h: 71 }
    ],
    // 3: 1 wide centered top + 2 rows of 2 asymmetric frames (wide-narrow / narrow-wide)
    t16: [
      { key: "S1", x: 22, y:  7, w: 66, h: 29 },
      { key: "S2", x: 22, y: 37, w: 44, h: 22 },
      { key: "S3", x: 67, y: 37, w: 21, h: 22 },
      { key: "S4", x: 22, y: 60, w: 21, h: 21 },
      { key: "S5", x: 44, y: 60, w: 44, h: 21 }
    ],
    // 4: asymmetric 5-frame – left col 2 frames, right col 3 frames
    t17: [
      { key: "S1", x:  9, y:  7, w: 40, h: 39 },
      { key: "S2", x: 51, y:  7, w: 41, h: 17 },
      { key: "S3", x: 51, y: 25, w: 41, h: 17 },
      { key: "S4", x:  9, y: 47, w: 40, h: 27 },
      { key: "S5", x: 51, y: 43, w: 41, h: 31 }
    ],
    // 5: 1 large full-bleed top + 3 equal frames bottom row
    t18: [
      { key: "S1", x:  0, y:  0, w:100, h: 78 },
      { key: "S2", x:  0, y: 79, w: 32, h: 21 },
      { key: "S3", x: 33, y: 79, w: 32, h: 21 },
      { key: "S4", x: 67, y: 79, w: 33, h: 21 }
    ],
    // 6: 2 equal full-height columns, full bleed
    t19: [
      { key: "S1", x:  0, y:  0, w: 50, h:100 },
      { key: "S2", x: 51, y:  0, w: 49, h:100 }
    ],
    // 7: left col 4 stacked + right col 1 tall full-bleed
    t20: [
      { key: "S1", x:  0, y:  0, w: 32, h: 24 },
      { key: "S2", x:  0, y: 25, w: 32, h: 24 },
      { key: "S3", x:  0, y: 50, w: 32, h: 24 },
      { key: "S4", x:  0, y: 75, w: 32, h: 25 },
      { key: "S5", x: 34, y:  0, w: 66, h:100 }
    ],
    // 8: left col 1 tall full-bleed + right col 4 stacked
    t21: [
      { key: "S1", x:  0, y:  0, w: 67, h:100 },
      { key: "S2", x: 69, y:  0, w: 31, h: 24 },
      { key: "S3", x: 69, y: 25, w: 31, h: 24 },
      { key: "S4", x: 69, y: 50, w: 31, h: 24 },
      { key: "S5", x: 69, y: 75, w: 31, h: 25 }
    ],
    // 9: 1 wide landscape top (with margins) + 2 portrait frames below
    t22: [
      { key: "S1", x:  7, y:  6, w: 86, h: 43 },
      { key: "S2", x:  7, y: 51, w: 41, h: 43 },
      { key: "S3", x: 51, y: 51, w: 42, h: 43 }
    ],
    // 10: 2×2 full-bleed grid
    t23: [
      { key: "S1", x:  0, y:  0, w: 49, h: 49 },
      { key: "S2", x: 51, y:  0, w: 49, h: 49 },
      { key: "S3", x:  0, y: 51, w: 49, h: 49 },
      { key: "S4", x: 51, y: 51, w: 49, h: 49 }
    ],
    // 11: single large frame, equal margin top and bottom, small right margin
    t24: [
      { key: "S1", x:  0, y:  6, w: 91, h: 88 }
    ],
    // 12: top row 3 equal + large bottom-left + 3 stacked bottom-right
    t25: [
      { key: "S1", x:  0, y:  0, w: 32, h: 28 },
      { key: "S2", x: 33, y:  0, w: 32, h: 28 },
      { key: "S3", x: 66, y:  0, w: 34, h: 28 },
      { key: "S4", x:  0, y: 29, w: 65, h: 71 },
      { key: "S5", x: 66, y: 29, w: 34, h: 23 },
      { key: "S6", x: 66, y: 53, w: 34, h: 23 },
      { key: "S7", x: 66, y: 77, w: 34, h: 23 }
    ],
    // 13: top row 3 equal + 3 stacked bottom-left + large bottom-right
    t26: [
      { key: "S1", x:  0, y:  0, w: 32, h: 28 },
      { key: "S2", x: 33, y:  0, w: 32, h: 28 },
      { key: "S3", x: 66, y:  0, w: 34, h: 28 },
      { key: "S4", x:  0, y: 29, w: 32, h: 23 },
      { key: "S5", x:  0, y: 53, w: 32, h: 23 },
      { key: "S6", x:  0, y: 77, w: 32, h: 23 },
      { key: "S7", x: 33, y: 29, w: 67, h: 71 }
    ],
    // 14: 3 horizontal bands, centered with side margins
    t27: [
      { key: "S1", x: 18, y:  0, w: 64, h: 31 },
      { key: "S2", x: 18, y: 33, w: 64, h: 31 },
      { key: "S3", x: 18, y: 66, w: 64, h: 34 }
    ],
    // 15: 2 portrait frames side by side, centered horizontally and vertically
    t28: [
      { key: "S1", x:  4, y: 22, w: 44, h: 57 },
      { key: "S2", x: 52, y: 22, w: 44, h: 57 }
    ],
    // 16: right column only – 3 stacked frames
    t29: [
      { key: "S1", x: 51, y:  0, w: 49, h: 31 },
      { key: "S2", x: 51, y: 33, w: 49, h: 31 },
      { key: "S3", x: 51, y: 66, w: 49, h: 34 }
    ]
  };

  // ── Photo Frame Shapes ───────────────────────────────────────────────────
  var DMB_FRAME_SHAPES = [
    { id: "none",    label: "None" },
    { id: "circle",  label: "Circle" },
    { id: "rounded", label: "Rounded" },
    { id: "soft",    label: "Soft" },
    { id: "heart",   label: "Heart" },
    { id: "star",    label: "Star" },
    { id: "diamond", label: "Diamond" },
    { id: "hexagon", label: "Hexagon" },
  ];

  function ensureDmbClipPaths() {
    if (document.getElementById("dmb-clip-defs")) return;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.id = "dmb-clip-defs";
    svg.setAttribute("width", "0"); svg.setAttribute("height", "0");
    svg.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;pointer-events:none;";
    svg.innerHTML = '<defs>' +
      '<clipPath id="dmb-clip-heart" clipPathUnits="objectBoundingBox"><path d="M0.5,0.85 C0.2,0.72 0,0.52 0,0.35 C0,0.14 0.16,0.04 0.3,0.04 C0.4,0.04 0.48,0.13 0.5,0.18 C0.52,0.13 0.6,0.04 0.7,0.04 C0.84,0.04 1,0.14 1,0.35 C1,0.52 0.8,0.72 0.5,0.85Z"/></clipPath>' +
      '<clipPath id="dmb-clip-star" clipPathUnits="objectBoundingBox"><polygon points="0.5,0.02 0.61,0.37 0.98,0.37 0.69,0.59 0.79,0.94 0.5,0.72 0.21,0.94 0.31,0.59 0.02,0.37 0.39,0.37"/></clipPath>' +
      '<clipPath id="dmb-clip-diamond" clipPathUnits="objectBoundingBox"><polygon points="0.5,0 1,0.5 0.5,1 0,0.5"/></clipPath>' +
      '<clipPath id="dmb-clip-hexagon" clipPathUnits="objectBoundingBox"><polygon points="0.25,0.02 0.75,0.02 1,0.5 0.75,0.98 0.25,0.98 0,0.5"/></clipPath>' +
      '</defs>';
    document.body.appendChild(svg);
  }

  function applyDmbFrameShape(el, shapeId) {
    el.style.borderRadius = "";
    el.style.clipPath = "";
    if (!shapeId || shapeId === "none") return;
    if (shapeId === "circle")       { el.style.borderRadius = "50%"; }
    else if (shapeId === "rounded") { el.style.borderRadius = "20%"; }
    else if (shapeId === "soft")    { el.style.borderRadius = "15px"; }
    else { ensureDmbClipPaths(); el.style.clipPath = "url(#dmb-clip-" + shapeId + ")"; }
  }

  function showDmbFramePicker(anchorEl, currentShape, onSelect) {
    var existing = document.getElementById("dmb-frame-shape-picker");
    if (existing) { existing.remove(); return; }
    ensureDmbClipPaths();
    var picker = document.createElement("div");
    picker.id = "dmb-frame-shape-picker";
    picker.style.cssText = "position:fixed;z-index:99999;background:#1e1e1e;border:1px solid #444;border-radius:12px;padding:10px;box-shadow:0 8px 32px rgba(0,0,0,0.7);display:grid;grid-template-columns:repeat(4,1fr);gap:8px;";
    DMB_FRAME_SHAPES.forEach(function(shape) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.title = shape.label;
      var active = (shape.id === (currentShape || "none"));
      btn.style.cssText = "width:52px;height:60px;border:2px solid " + (active ? "#a9b4ff" : "#333") + ";border-radius:8px;background:#2a2a2a;cursor:pointer;padding:5px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;";
      var preview = document.createElement("div");
      preview.style.cssText = "width:32px;height:32px;background:linear-gradient(135deg,#c084fc,#818cf8);overflow:hidden;flex-shrink:0;";
      applyDmbFrameShape(preview, shape.id);
      var lbl = document.createElement("span");
      lbl.style.cssText = "font-size:8px;color:#aaa;font-weight:700;line-height:1;text-transform:uppercase;letter-spacing:0.3px;";
      lbl.textContent = shape.label;
      btn.appendChild(preview); btn.appendChild(lbl);
      btn.addEventListener("click", function(e) {
        e.stopPropagation();
        picker.remove();
        document.removeEventListener("pointerdown", outsideClose);
        onSelect(shape.id === "none" ? "" : shape.id);
      });
      picker.appendChild(btn);
    });
    var rect = anchorEl.getBoundingClientRect();
    var left = Math.min(rect.left - 80, window.innerWidth - 260);
    picker.style.left = Math.max(8, left) + "px";
    picker.style.top = (rect.bottom + 8) + "px";
    document.body.appendChild(picker);
    function outsideClose(e) {
      if (!picker.contains(e.target) && e.target !== anchorEl) {
        picker.remove();
        document.removeEventListener("pointerdown", outsideClose);
      }
    }
    setTimeout(function() { document.addEventListener("pointerdown", outsideClose); }, 60);
  }

  // Rounded-rectangle path with SEPARATE x and y corner radii, at (x,y).
  // CSS border-radius is per-AXIS: on a 200x120 box, `border-radius:50%` is an
  // ELLIPSE 200x120, not a 120px circle. Canvas arc()/quadraticCurveTo() cannot
  // express that, which is why the PDF used to square off wide frames.
  function _dmbRoundRectPath(ctx, x, y, w, h, rx, ry) {
    rx = Math.max(0, Math.min(rx, w / 2));
    ry = Math.max(0, Math.min(ry, h / 2));
    if (rx <= 0 || ry <= 0) { ctx.rect(x, y, w, h); return; }
    var K = Math.PI / 2;
    ctx.moveTo(x + rx, y);
    ctx.lineTo(x + w - rx, y);
    ctx.ellipse(x + w - rx, y + ry,     rx, ry, 0, -K, 0);
    ctx.lineTo(x + w, y + h - ry);
    ctx.ellipse(x + w - rx, y + h - ry, rx, ry, 0, 0, K);
    ctx.lineTo(x + rx, y + h);
    ctx.ellipse(x + rx,     y + h - ry, rx, ry, 0, K, Math.PI);
    ctx.lineTo(x, y + ry);
    ctx.ellipse(x + rx,     y + ry,     rx, ry, 0, Math.PI, 3 * K);
    ctx.closePath();
  }

  // Clip the canvas to a photo-frame shape, matching applyDmbFrameShape (1194)
  // pixel for pixel.
  //   pxScale = canvas px per BUILDER px (PAGE_SCALE 9.19 / FACE_SCALE 8.27).
  // Only "soft" needs it: on screen that shape is a FIXED 15 CSS px radius, so
  // the printed radius must be 15 * pxScale. Every other shape is expressed as a
  // fraction of the box and scales on its own.
  function applyCanvasFrameClip(ctx, shapeId, w, h, pxScale) {
    if (!shapeId || shapeId === "none") return;
    var P = (typeof pxScale === "number" && pxScale > 0) ? pxScale : 1;
    ctx.beginPath();
    if (shapeId === "circle") {
      // screen: border-radius:50%  ->  an ellipse filling the box
      ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
    } else if (shapeId === "rounded") {
      // screen: border-radius:20%  ->  20% of EACH axis (elliptical corners)
      _dmbRoundRectPath(ctx, 0, 0, w, h, w * 0.2, h * 0.2);
    } else if (shapeId === "soft") {
      // screen: border-radius:15px ->  a fixed 15 CSS px on both axes
      _dmbRoundRectPath(ctx, 0, 0, w, h, 15 * P, 15 * P);
    } else if (shapeId === "heart") {
      ctx.moveTo(w*0.5,h*0.85);
      ctx.bezierCurveTo(w*0.2,h*0.72, 0,h*0.52, 0,h*0.35);
      ctx.bezierCurveTo(0,h*0.14, w*0.16,h*0.04, w*0.3,h*0.04);
      ctx.bezierCurveTo(w*0.4,h*0.04, w*0.48,h*0.13, w*0.5,h*0.18);
      ctx.bezierCurveTo(w*0.52,h*0.13, w*0.6,h*0.04, w*0.7,h*0.04);
      ctx.bezierCurveTo(w*0.84,h*0.04, w,h*0.14, w,h*0.35);
      ctx.bezierCurveTo(w,h*0.52, w*0.8,h*0.72, w*0.5,h*0.85); ctx.closePath();
    } else if (shapeId === "star") {
      var sp = [[0.5,0.02],[0.61,0.37],[0.98,0.37],[0.69,0.59],[0.79,0.94],[0.5,0.72],[0.21,0.94],[0.31,0.59],[0.02,0.37],[0.39,0.37]];
      sp.forEach(function(p,i){ i===0?ctx.moveTo(p[0]*w,p[1]*h):ctx.lineTo(p[0]*w,p[1]*h); }); ctx.closePath();
    } else if (shapeId === "diamond") {
      ctx.moveTo(w*0.5,0); ctx.lineTo(w,h*0.5); ctx.lineTo(w*0.5,h); ctx.lineTo(0,h*0.5); ctx.closePath();
    } else if (shapeId === "hexagon") {
      var hp = [[0.25,0.02],[0.75,0.02],[1,0.5],[0.75,0.98],[0.25,0.98],[0,0.5]];
      hp.forEach(function(p,i){ i===0?ctx.moveTo(p[0]*w,p[1]*h):ctx.lineTo(p[0]*w,p[1]*h); }); ctx.closePath();
    }
    ctx.clip();
  }
  function getSlotFrameShape(pageNumber, slot) {
    return (editor.pageFrameShapes && editor.pageFrameShapes[pageNumber] && editor.pageFrameShapes[pageNumber][slot]) || "";
  }
  function setSlotFrameShape(pageNumber, slot, shapeId) {
    if (!editor.pageFrameShapes) editor.pageFrameShapes = {};
    if (!editor.pageFrameShapes[pageNumber]) editor.pageFrameShapes[pageNumber] = {};
    editor.pageFrameShapes[pageNumber][slot] = shapeId || "";
  }

  // ---------- helpers ----------
  // Local renderBuilderCanvas — delegates to the actual render functions in this IIFE
  function renderBuilderCanvas() {
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    if (builderMode === "cover") renderCoverCanvas();
    else renderSpread();
    if (typeof syncBuilderModeButtons === "function") syncBuilderModeButtons();
    if (typeof setCanvasZoom === "function") setCanvasZoom(currentZoom);
    if (typeof syncPhotoTrayHeight === "function") syncPhotoTrayHeight();
    // Pulse the preview button to remind customer to review after each edit
    const _pb = document.getElementById("previewBtn");
    if (_pb) _pb.classList.add("dmb-preview-needs-check");
    // Show photo quality notice the very first time a photo lands on any page
    _maybeShowPhotoQualityToast();
  }

  // ── Fix 3: 45° magnetic snap rotation helper ─────────────────────────────
  // Returns the raw angle snapped to the nearest 45° multiple when within
  // SNAP_DEG degrees of it, otherwise returns the raw angle unchanged.
  // Works for all rotation handlers: text, maps, stickers, shapes, icons.
  // "Breakaway" is natural: the angle is only snapped while the raw value stays
  // inside the snap zone; rotate past 5° away and it instantly releases.
  const _ROT_SNAP_DEG = 5;
  function _dmbSnapAngle(rawDeg) {
    // Normalise to 0–360 to find the nearest 45° multiple
    const norm    = ((rawDeg % 360) + 360) % 360;
    const nearest = Math.round(norm / 45) * 45; // 0, 45, 90 … 360
    const diff    = norm - nearest;
    return Math.abs(diff) <= _ROT_SNAP_DEG ? rawDeg - diff : rawDeg;
  }

  // ── First-photo quality toast ─────────────────────────────────────────────
  // Shows once per session the moment the customer places their first photo.
  // Disappears automatically after 4 s with a fade-out.
  // Uses sessionStorage so it never re-appears during the same browser session.
  let _photoQualityToastShown = false;
  function _maybeShowPhotoQualityToast() {
    if (_dmbRenderMode()) return;   // render mode: no UI, no sessionStorage
    if (_photoQualityToastShown) return;
    if (sessionStorage.getItem("dmb_photo_quality_toast_shown")) { _photoQualityToastShown = true; return; }
    // Check if at least one page slot has a photo
    const slots = editor.pageSlots || {};
    const hasPhoto = Object.values(slots).some(function(s) { return s && (s.A || s.B); });
    if (!hasPhoto) return;
    _photoQualityToastShown = true;
    sessionStorage.setItem("dmb_photo_quality_toast_shown", "1");
    const toast = document.getElementById("dmbPhotoQualityToast");
    if (!toast) return;
    // Add a close (✕) button once — the toast now STAYS until the customer
    // dismisses it (no auto-dismiss timer). One handler covers book/magazine/card.
    if (!toast.querySelector(".dmb-toast-close")) {
      const _x = document.createElement("button");
      _x.type = "button";
      _x.className = "dmb-toast-close";
      _x.setAttribute("aria-label", "Close");
      _x.textContent = "✕";
      // pointer-events:auto — the toast itself is pointer-events:none (so it never
      // blocks the builder), which would also swallow clicks on this ✕; re-enable
      // just the button so it can be closed.
      _x.style.cssText = "background:transparent;border:none;color:inherit;opacity:.55;font-size:15px;line-height:1;cursor:pointer;padding:4px;margin-left:8px;align-self:flex-start;flex-shrink:0;pointer-events:auto;";
      _x.addEventListener("click", function () {
        toast.classList.remove("dmb-toast-visible");
        setTimeout(function () { toast.style.display = "none"; }, 500);
      });
      toast.appendChild(_x);
    }
    // Animate in (closes only via the ✕)
    toast.style.display = "flex";
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { toast.classList.add("dmb-toast-visible"); });
    });
  }

  let DMB_CURRENT_DRAG = null;
  const $ = (id) => document.getElementById(id);
  const fmtMoney = (n) => "$" + Number(n).toFixed(2);
  const isLockedPage = (p) => !window.DMB_MAGAZINE_MODE && p === LOCKED_PAGE_NUMBER;

  function getActivePageNumberForMap() {
    if (!editor.totalPages) return null;

    if (builderMode === "cover") return "cover";

    if (editor.currentSpread === -1) return 0;

    const leftPage = editor.currentSpread * 2 + 1;
    const rightPage = leftPage + 1;

    // Honour lastToolbarSide, exactly like insertShapeIntoActivePage (8922) and the
    // per-page Add text / Add shape / Add polaroid buttons. This used to return the
    // LEFT page unconditionally, so adding a map while working on a right-hand page
    // dropped it on the facing page instead. On a phone - which shows ONE page at a
    // time - that reads as "Insert did nothing", because the map landed on a page
    // that is not on screen.
    if (lastToolbarSide === "right" && rightPage <= editor.totalPages && !isLockedPage(rightPage)) return rightPage;
    if (leftPage  <= editor.totalPages && !isLockedPage(leftPage))  return leftPage;
    if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) return rightPage;
    return null;
  }

  // Set by the per-page "Add map" button so the picker knows its target without
  // asking. Cleared every time the map modal opens, so a ribbon-opened picker
  // always falls back to asking.
  let _dmbMapTargetPage = null;

  // Which page should this map go on? A spread has TWO pages and the old code
  // silently picked the left one. Ask, unless the answer is already unambiguous.
  // Returns a page number, "cover", or null when there is nowhere to put it / the
  // customer cancelled.
  async function _dmbResolveMapTargetPage() {
    if (builderMode === "cover") return "cover";
    if (_dmbMapTargetPage != null) return _dmbMapTargetPage;   // per-page button
    if (!editor.totalPages) return null;
    if (editor.currentSpread === -1) return 0;

    // PHONE ONLY. Desktop shows both pages of the spread side by side, so the
    // destination is obvious and a dialog is pure friction - it just uses the
    // page the customer last worked on (lastToolbarSide). The phone shows ONE
    // page at a time, which is where a silent wrong-page insert looks like
    // nothing happened, so that is the only case worth interrupting.
    if (!(window.innerWidth <= 749)) return getActivePageNumberForMap();

    const lp = editor.currentSpread * 2 + 1, rp = lp + 1;
    const opts = [];
    if (lp <= editor.totalPages && !isLockedPage(lp)) opts.push(lp);
    if (rp <= editor.totalPages && !isLockedPage(rp)) opts.push(rp);
    if (!opts.length) return null;
    if (opts.length === 1) return opts[0];

    const choice = await showChoiceDialog(
      "Which page?",
      "You are looking at a spread. Choose the page this map should go on.",
      opts.map(function (p) { return { id: String(p), label: "Page " + p }; })
          .concat([{ id: "cancel", label: "Cancel" }])
    );
    if (!choice || choice === "cancel") return null;
    return parseInt(choice, 10);
  }

  function uid() {
    return "p_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
  // Unique object id. Date.now() alone collides when two objects are added in the
  // same millisecond (e.g. two sticker image onloads firing together) → they'd share
  // an id and one could overwrite/hide the other. The random suffix prevents that.
  function _dmbOid(prefix) {
    return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  function syncInputFiles(inputEl, filesArr) {
    if (!inputEl) return;
    const dt = new DataTransfer();
    filesArr.forEach((f) => dt.items.add(f));
    inputEl.files = dt.files;
  }

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result || "").split(",")[1] || "");
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
  }

  // ── Mobile image compression ──────────────────────────────────────────────
  // Resizes oversized photos before they enter the builder, preventing iOS/Safari
  // from crashing due to canvas memory limits when processing large camera images.
  // 2500 px max keeps full print quality (300 Dpi on an 8" side) while cutting
  // a 48 MP iPhone photo from ~15 MB down to ~1–2 MB.
  // Read a JPEG's pixel dimensions straight from its header bytes — NO pixel
  // decode. Lets us decide the downscale target WITHOUT ever fully decoding a huge
  // photo (a 10 MB / 48 MP JPEG would be ~195 MB as a full bitmap — decoding 60 of
  // those in a row is the phone OOM). iOS Safari uploads camera photos as JPEG
  // (HEIC is auto-converted through a file input), so this fast path covers the
  // common case. Returns {w,h} or null. Scans the first 256 KB for the SOF marker.
  async function _dmbReadJpegSize(file) {
    try {
      const buf = new Uint8Array(await file.slice(0, 256 * 1024).arrayBuffer());
      if (buf.length < 4 || buf[0] !== 0xFF || buf[1] !== 0xD8) return null;   // not JPEG
      let i = 2;
      while (i + 9 < buf.length) {
        if (buf[i] !== 0xFF) { i++; continue; }
        let marker = buf[i + 1];
        while (marker === 0xFF && i + 1 < buf.length) { i++; marker = buf[i + 1]; }  // skip fill bytes
        // Standalone markers (no length): RSTn, SOI, EOI, TEM.
        if (marker === 0xD8 || marker === 0xD9 || (marker >= 0xD0 && marker <= 0xD7) || marker === 0x01) { i += 2; continue; }
        // SOF0..SOF15 carry the frame size — but C4 (DHT), C8 (JPG), CC (DAC) are NOT SOF.
        if (marker >= 0xC0 && marker <= 0xCF && marker !== 0xC4 && marker !== 0xC8 && marker !== 0xCC) {
          const h = (buf[i + 5] << 8) | buf[i + 6];
          const w = (buf[i + 7] << 8) | buf[i + 8];
          return (w > 0 && h > 0) ? { w, h } : null;
        }
        const len = (buf[i + 2] << 8) | buf[i + 3];   // segment length (includes these 2 bytes)
        if (len < 2) return null;
        i += 2 + len;
      }
    } catch (e) {}
    return null;
  }

  async function compressImageIfNeeded(file) {
    const MAX_DIM = 2500;
    const QUALITY  = 0.88;
    if (typeof createImageBitmap !== "function") return file;   // very old browser: keep original

    // FAST PATH (JPEG): read dimensions from the header (bytes, no decode).
    const hdr = await _dmbReadJpegSize(file);
    if (hdr && hdr.w <= MAX_DIM && hdr.h <= MAX_DIM) return file;   // small enough — no decode at all

    // Build a REDUCED-resolution decode target so a huge photo is never fully
    // decoded. createImageBitmap with resizeWidth/Height maps to iOS ImageIO's
    // scaled decode (kCGImageSourceThumbnailMaxPixelSize), so peak memory is the
    // 2500 px result (~25 MB), not the 48 MP original (~195 MB).
    // Cap ONLY the longer edge and let the browser preserve the TRUE aspect — never
    // force BOTH dims from the header, because a mis-read/edge-case header (e.g. some
    // iPhone ultra-wide 0.5× JPEGs) would then stretch the photo. imageOrientation
    // bakes EXIF rotation so the saved file needs no orientation flag.
    const target = { resizeQuality: "high", imageOrientation: "from-image" };
    if (hdr) {
      if (hdr.w >= hdr.h) target.resizeWidth = Math.min(hdr.w, MAX_DIM);
      else                target.resizeHeight = Math.min(hdr.h, MAX_DIM);
    } else {
      target.resizeWidth = MAX_DIM;
    }

    let bmp;
    try { bmp = await createImageBitmap(file, target); }
    catch (e) {
      try { bmp = await createImageBitmap(file, { imageOrientation: "from-image" }); }
      catch (e1) { try { bmp = await createImageBitmap(file); } catch (e2) { return file; } }
    }
    try {
      let w = bmp.width || 0, h = bmp.height || 0;
      if (!w || !h) return file;
      // Aspect-preserving safety cap: if the decode came back larger than MAX_DIM on
      // its long edge, scale BOTH edges by the same factor (never distort).
      if (Math.max(w, h) > MAX_DIM) {
        const s = MAX_DIM / Math.max(w, h);
        w = Math.max(1, Math.round(w * s));
        h = Math.max(1, Math.round(h * s));
      }
      const canvas = document.createElement("canvas");
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext("2d");
      try { ctx.imageSmoothingQuality = "high"; } catch (e) {}
      ctx.drawImage(bmp, 0, 0, w, h);
      const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
      canvas.width = 0; canvas.height = 0;                       // free canvas memory now
      if (!blob) return file;
      return new File([blob], file.name, { type: "image/jpeg", lastModified: file.lastModified });
    } catch (e) {
      return file;
    } finally {
      try { if (bmp && bmp.close) bmp.close(); } catch (e) {}    // release the decode immediately
    }
  }

  async function compressFilesForMobile(files) {
    // PRINT-MASTER pipeline (flag ON): desktop AND mobile — every photo becomes a
    // ~3500px master (attached as f._dmbMaster, uploaded to R2 then freed) + a
    // 2500px editing proxy. Still strictly ONE AT A TIME (parallel decode = iOS OOM).
    if (_dmbPrintMasterOn()) {
      const out = [];
      for (const f of files) out.push(await _dmbMakePrintDerivatives(f));
      return out;
    }
    if (window.innerWidth > 749) return files;   // desktop — use originals
    // Process ONE AT A TIME — parallel (Promise.all) loads all originals into
    // memory simultaneously, which is what causes the iOS crash.
    const result = [];
    for (const f of files) {
      result.push(await compressImageIfNeeded(f));
    }
    return result;
  }

  // ── Print-master derivatives (flag-gated; see _dmbPrintMasterOn) ───────────
  // ONE memory-safe scaled decode → a ~3500px PRINT MASTER (kept as original
  // bytes when the photo is already ≤3500px — zero re-encode loss) + a 2500px
  // editing PROXY. The proxy is what enters the builder (ph.file / R2 photos/);
  // the master rides along as proxy._dmbMaster until its own R2 upload frees it.
  async function _dmbMakePrintDerivatives(file) {
    try {
      // QR-relay photos USED to bail out here with no master at all, on the theory
      // that the phone had already re-encoded them so any master would be "fake
      // quality". Half right: they are re-encoded once, but the phone sends them at
      // up to 4096px (sections/phone-upload.liquid: `var MAX = 4096` at q0.92) -
      // LARGER than _DMB_MASTER_DIM, and well above the 2480x3508 a full-bleed A4
      // page needs at 300 DPI. So the bail-out threw away print-grade pixels AND
      // made every proof read "0 of N photos at full print quality" for a book that
      // would have printed perfectly well - alarming a customer at the moment of
      // payment about a problem that did not exist.
      //
      // They now take the SAME path as every other photo. The master keeps the
      // phone's bytes verbatim (see masterBlob below) because a second re-encode is
      // the only step here that would genuinely lose anything, and the 2500px
      // editing proxy is still derived through the one memory-safe scaled decode -
      // so this is no heavier on a phone than any other import. (2026-09-14)
      if (file && file._dmbRelay) _dmbMasterStats.relay++;
      if (typeof createImageBitmap !== "function") return file;
      const hdr = await _dmbReadJpegSize(file);
      const longEdge = hdr ? Math.max(hdr.w, hdr.h) : 0;
      // Already <= proxy size -> the photo IS its own full-res master; keep the
      // exact original bytes, nothing to derive (matches the legacy fast path).
      // Register it as its own master anyway so photos-orig/{pid} exists for EVERY
      // imported photo. The render path, the cover draw-by-id branch and the
      // print-quality counter all treat "has a master" as the invariant, and without
      // this a small photo is indistinguishable from one whose master never uploaded
      // - which is why a book of sub-2500px photos reported 0 at full print quality.
      if (hdr && longEdge <= _DMB_PROXY_DIM) {
        try { file._dmbMaster = file; _dmbMasterStats.queued++; } catch (e) {}
        return file;
      }
      // Decode ONCE, scaled to the master size (iOS ImageIO scaled decode — never
      // materialises the full 48MP bitmap).
      const target = { resizeQuality: "high", imageOrientation: "from-image" };
      if (hdr) {
        if (hdr.w >= hdr.h) target.resizeWidth = Math.min(hdr.w, _DMB_MASTER_DIM);
        else                target.resizeHeight = Math.min(hdr.h, _DMB_MASTER_DIM);
      }
      // No else: asking for resizeWidth = _DMB_MASTER_DIM when the header could not
      // be read (PNG, or any non-JPEG _dmbReadJpegSize cannot parse) does not CAP the
      // decode - it RESIZES to exactly 3500, so a 900px screenshot was upscaled ~4x
      // and that upscale was then re-encoded and stored as its "print master".
      // Inventing pixels wastes bytes and makes the master a lie. Decode at natural
      // size instead; the explicit cap a few lines below still brings anything
      // genuinely larger than _DMB_MASTER_DIM back down. (2026-09-14)
      let bmp = null, imgEl = null;
      try { bmp = await createImageBitmap(file, target); }
      catch (e0) {
        try { bmp = await createImageBitmap(file, { imageOrientation: "from-image" }); }
        catch (e1) { try { bmp = await createImageBitmap(file); } catch (e2) { bmp = null; } }
      }
      if (!bmp) {
        // createImageBitmap refused the file (iOS Safari does this for some camera
        // JPEGs / HEIC). Decode through an <img> instead - Safari renders those
        // natively - so the photo still gets a real master rather than silently
        // dropping to the proxy-only legacy path with no master at all.
        imgEl = await new Promise(function (res) {
          try {
            const u = URL.createObjectURL(file);
            const im = new Image();
            let done = false;
            const fin = function (ok) { if (done) return; done = true; try { URL.revokeObjectURL(u); } catch (e) {} res(ok ? im : null); };
            im.onload = function () { fin(true); };
            im.onerror = function () { fin(false); };
            setTimeout(function () { fin(false); }, 20000);
            im.src = u;
          } catch (e) { res(null); }
        });
        if (!imgEl || !imgEl.naturalWidth) {
          _dmbMasterStats.decode_failed++;
          return _dmbIsMobileUpload() ? await compressImageIfNeeded(file) : file;
        }
      }
      const src = bmp || imgEl;
      try {
        let w = bmp ? bmp.width : imgEl.naturalWidth, h = bmp ? bmp.height : imgEl.naturalHeight;
        if (Math.max(w, h) > _DMB_MASTER_DIM) {          // decode ignored the resize → cap manually
          const s = _DMB_MASTER_DIM / Math.max(w, h);
          w = Math.max(1, Math.round(w * s)); h = Math.max(1, Math.round(h * s));
        }
        const mc = document.createElement("canvas");
        mc.width = w; mc.height = h;
        const mctx = mc.getContext("2d");
        try { mctx.imageSmoothingQuality = "high"; } catch (e) {}
        mctx.drawImage(src, 0, 0, w, h);
        // Master: exact original bytes when the photo is already ≤ master size
        // (no re-encode loss), else the 3500px re-encode.
        // A relay photo is ALREADY a q0.92 encode from the phone; re-encoding it
        // down to 3500px would be the one step that actually costs quality, and it
        // is bigger than the master target anyway. Keep its bytes exactly as sent.
        const masterBlob = ((file && file._dmbRelay) || (hdr && longEdge <= _DMB_MASTER_DIM))
          ? file
          : await new Promise((res) => mc.toBlob(res, "image/jpeg", _DMB_MASTER_Q));
        // Proxy: downscaled from the master canvas — no second decode of the file.
        const ps = _DMB_PROXY_DIM / Math.max(w, h);
        const pw = Math.max(1, Math.round(w * ps)), ph2 = Math.max(1, Math.round(h * ps));
        const pc = document.createElement("canvas");
        pc.width = pw; pc.height = ph2;
        const pctx = pc.getContext("2d");
        try { pctx.imageSmoothingQuality = "high"; } catch (e) {}
        pctx.drawImage(mc, 0, 0, pw, ph2);
        const proxyBlob = await new Promise((res) => pc.toBlob(res, "image/jpeg", _DMB_PROXY_Q));
        mc.width = 0; mc.height = 0; pc.width = 0; pc.height = 0;   // free canvas memory now
        if (!proxyBlob) return await compressImageIfNeeded(file);   // fallback: legacy single derivative
        const proxy = new File([proxyBlob], file.name, { type: "image/jpeg", lastModified: file.lastModified });
        if (masterBlob) { proxy._dmbMaster = masterBlob; _dmbMasterStats.queued++; }
        return proxy;
      } finally {
        try { if (bmp && bmp.close) bmp.close(); } catch (e) {}     // release the decode immediately
      }
    } catch (e) {
      try { return _dmbIsMobileUpload() ? await compressImageIfNeeded(file) : file; } catch (e2) { return file; }
    }
  }

  // ── Apps Script URL + HTTP helper — module-level so both uploadPdfToGoogleDrive
  // and addDesignedBookToCart can call postToScript (e.g. for trash_file).
  const DMB_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwzcCe9WkOMqPiSc58NJOMEPbDfLOH3q_C_4leRgoaK5Xg5BSLh2dpjvCRbzZF8/exec";

  async function postToScript(payload, attempts = 3) {
    let lastErr;
    for (let i = 1; i <= attempts; i++) {
      try {
        const res = await fetch(DMB_APPS_SCRIPT_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || "Script error");
        return data;
      } catch (err) {
        lastErr = err;
        if (i < attempts) await new Promise(r => setTimeout(r, i * 1500));
      }
    }
    throw lastErr;
  }

  // Expose the Drive uploader + Apps Script poster so the native card editor
  // (card-editor.js) reuses the EXACT same book upload pipeline (upload to Drive →
  // _pdf_file_id line-item property → Apps Script renames with the order # at
  // checkout). `label` marks the card's file so it's distinct from the book's.
  window.__dmbUploadPdf   = function (blob, label) { return uploadPdfToGoogleDrive(blob, label); };
  window.__dmbPostToScript = function (payload, attempts) { return postToScript(payload, attempts); };
  // Expose the customer's uploaded photo library so the native card editor can
  // offer "pick from your uploaded photos" instead of a fresh device upload.
  window.__dmbGetPhotos = function () {
    try { return (editor.photos || []).map(function (p) { return { id: p.id, url: p.url, file: p.file || null, filename: p.filename || (p.file && p.file.name) || "" }; }); }
    catch (e) { return []; }
  };
  // Let the card editor trigger the same "upload from phone" QR flow the book uses.
  window.__dmbOpenPhoneUpload = function () { try { openPhoneUploadModal(); } catch (e) {} };

  async function uploadPdfToGoogleDrive(pdfBlob, label) {
    const _lbl = label ? (String(label).replace(/[^a-z0-9]+/gi, "_") + "_") : "";
    const filename = `memories_nutshell_${_lbl}${DMB_SESSION_ID}-${++dmbBookCounter}.pdf`;

    // ── Architecture: Drive Resumable Upload ─────────────────────────────────
    // We use Google Drive's native resumable-upload API (via Apps Script as proxy).
    // Each chunk is forwarded directly from browser → Apps Script → Drive byte-range.
    // This eliminates ALL of the old failure modes:
    //   ✓ No temp files in Drive (no "Missing chunk N" race condition)
    //   ✓ No in-memory base64 concatenation (no OOM for large books)
    //   ✓ No 6-minute Apps Script timeout during finalize
    //   ✓ Works for any size PDF (1 GB+)
    //   ✓ If a chunk fails, Drive reports exactly where to resume
    //
    // CHUNK_BYTES must be a multiple of 256 KB as required by Drive's resumable API.
    const CHUNK_BYTES = 3 * 256 * 1024;  // 768 KB — valid multiple of 256 KB
    const totalSize   = pdfBlob.size;
    const totalChunks = Math.ceil(totalSize / CHUNK_BYTES);

    // ── Progress helpers ──────────────────────────────────────────────────────
    const _progWrap  = document.getElementById("dmbUploadProgressWrap");
    const _progBar   = document.getElementById("dmbUploadProgressBar");
    const _progLabel = document.getElementById("dmbUploadProgressLabel");
    const _progMsg   = document.getElementById("dmbPdfOverlayMsg");
    const _uploadMsgs = [
      "Sending your memories our way",
      "Packaging your precious moments",
      "Almost there, hang tight",
      "Wrapping up your story",
      "Delivering your book with care",
      "Just a little more",
      "Your memories are on their way",
      "Sealing every beautiful moment"
    ];
    function _setProgress(done, total, phase) {
      const pct = Math.round((done / total) * 100);
      if (_progWrap)  _progWrap.style.display  = "block";
      if (_progBar)   _progBar.style.width      = pct + "%";
      if (_progLabel) _progLabel.textContent    = phase || _uploadMsgs[Math.floor((done / total) * (_uploadMsgs.length - 1))];
      if (_progMsg)   _progMsg.textContent      = ("Sending your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book"));
    }
    function _hideProgress() {
      if (_progWrap) _progWrap.style.display = "none";
    }

    // ── Step 1: Initialise the Drive resumable-upload session ─────────────────
    _setProgress(0, totalChunks + 1, "Preparing to send");
    const initRes    = await postToScript({ action: "init_upload", filename, totalSize });
    const sessionUri = initRes.sessionUri;

    // ── Step 2: Send chunks — each forwarded directly to Drive ───────────────
    let byteStart = 0;
    for (let i = 0; i < totalChunks; i++) {
      _setProgress(i + 1, totalChunks + 1, _uploadMsgs[i % _uploadMsgs.length]);
      const slice    = pdfBlob.slice(byteStart, byteStart + CHUNK_BYTES);
      const b64chunk = await blobToBase64(slice);
      const raw      = b64chunk.includes(",") ? b64chunk.split(",")[1] : b64chunk;

      const chunkRes = await postToScript({
        action:     "upload_chunk",
        sessionUri,           // Apps Script forwards this chunk to Drive directly
        data:       raw,
        byteStart,
        totalSize
      });

      byteStart += slice.size;

      if (chunkRes.complete) {
        // Drive confirmed the upload is fully complete on this chunk.
        _setProgress(totalChunks + 1, totalChunks + 1, "Your book is safe with us! 🎉");
        if (_progMsg) _progMsg.textContent = "Almost ready";
        _hideProgress();
        return chunkRes;  // { ok, id, viewUrl, downloadUrl }
      }
    }

    // If we exit the loop without seeing complete:true, something went wrong.
    _hideProgress();
    throw new Error("Upload finished all chunks but Drive did not confirm completion.");
  }

  // ── Streaming print path (large books) ────────────────────────────────────
  // A big book (e.g. 300 pages) can exhaust a phone's memory if the whole PDF is
  // built in the tab. For large books we instead render page-by-page (the exact
  // same pixels — see __dmbBuildPdfStreaming/addCanvasPage), upload each finished
  // page to R2 via the Worker, then ask the Cloud Run "stapler" to assemble the
  // final PDF and store it in Drive — identical output, but peak memory ≈ one page.
  // Falls back to the in-browser path (below, in Add to Cart) on any failure.
  const _DMB_STREAM_MIN_PAGES = (typeof window.DMB_STREAM_MIN_PAGES === "number")
    ? window.DMB_STREAM_MIN_PAGES : 0;   // 0 = ALL books stream (server saves to Drive,
    // bypassing the browser→Apps Script upload a 3rd-party app is CORS-blocking). Set a
    // higher number via window.DMB_STREAM_MIN_PAGES to restrict streaming to big books.

  function _dmbDataUrlToBlob(durl) {
    const comma = durl.indexOf(",");
    const bin = atob(durl.slice(comma + 1));
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: "image/jpeg" });
  }

  // ── Proof previews ────────────────────────────────────────────────────────
  // The proof screen is the last thing a customer sees before paying, and it used to
  // download the PRINT-resolution page for every sheet: an A4 page at 250-300 DPI and
  // JPEG 0.96 is 2-3 MB, over a workers.dev link measured at 0.42 MB/s. That is several
  // seconds per page turn, on the one screen where hesitation costs an order.
  //
  // So each page is ALSO encoded small, off the very same canvas, in the same pass. It
  // is not a re-render and not a different source - it is the identical image, scaled -
  // so the proof still shows exactly what will print. 1600px on the long edge is sharp
  // at 2x on any sheet the proof screen can display, and lands ~15x smaller.
  const _DMB_PROOF_PREV_DIM = 1600, _DMB_PROOF_PREV_Q = 0.78;

  // Best effort, deliberately: a missing preview costs that page a slower proof (the
  // Worker serves the full-resolution page instead), while a failed ORDER because a
  // thumbnail would not upload would be absurd. One short attempt, never throws.
  async function _dmbUploadRenderPreview(proxy, index, blob, fp, qsBase) {
    try {
      // Two callers, two URL shapes. The renderer stages with a job token; the browser
      // fallback stages with the design's own id + sid. Both land in the same /v/ prefix
      // on the Worker, and handleRenderProofPage reads whichever exists.
      const u = (_dmbRenderMode() && _DMB_RM && _DMB_RM.token)
        ? (proxy + "/render-stage?t=" + encodeURIComponent(_DMB_RM.token) +
           "&i=" + index + "&prev=1" + (fp ? "&fp=" + encodeURIComponent(fp) : ""))
        : (qsBase ? (proxy + "/render-page?" + qsBase + "&i=" + index + "&prev=1") : "");
      if (!u) return false;
      const ctrl = new AbortController();
      const timer = setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 20000);
      const r = await fetch(u, { method: "POST", headers: { "content-type": "image/jpeg" }, body: blob, signal: ctrl.signal });
      clearTimeout(timer);
      return !!(r && r.ok);
    } catch (e) { return false; }
  }

  // Upload one finished page; retry a few times (a dropped page must not fail the order).
  async function _dmbUploadRenderPage(proxy, qsBase, index, blob, fp, wMm, hMm) {
    // fp: content fingerprint -> the Worker stores the page under p/<fp>.jpg (content-
    // addressed, reusable by a later job); no fp -> the legacy positional <i>.jpg.
    const _fpq = fp ? ("&fp=" + encodeURIComponent(fp) + "&w=" + encodeURIComponent(String(wMm || "")) + "&h=" + encodeURIComponent(String(hMm || ""))) : "";
    const u = (_dmbRenderMode() && _DMB_RM.token)
      ? (proxy + "/render-stage?t=" + encodeURIComponent(_DMB_RM.token) + "&i=" + index + _fpq)
      : (proxy + "/render-page?" + qsBase + "&i=" + index);
    let lastErr = null;
    // Slow-connection hardening: each attempt gets a generous timeout so a STALLED upload
    // aborts and retries instead of hanging the whole order forever, and we allow many
    // retries so a flaky ~2 Mbps link still gets every page through. A page (~200–500 KB at
    // 250 DPI / JPEG 0.85) uploads in a few seconds even at 2 Mbps; 90 s tolerates a very
    // congested link before a single attempt is abandoned.
    const PER_ATTEMPT_MS = 90000;
    const MAX_ATTEMPTS   = 8;
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      let ctrl = null, timer = null;
      try {
        ctrl = new AbortController();
        timer = setTimeout(() => { try { ctrl.abort(); } catch (e) {} }, PER_ATTEMPT_MS);
        const r = await fetch(u, { method: "POST", headers: { "content-type": "image/jpeg" }, body: blob, credentials: "same-origin", signal: ctrl.signal });
        if (timer) clearTimeout(timer);
        if (r.ok) return true;
        lastErr = new Error("HTTP " + r.status);
      } catch (e) { if (timer) clearTimeout(timer); lastErr = e; }
      // Capped backoff: keep retrying a flaky link without long stalls between tries.
      await new Promise((res) => setTimeout(res, Math.min(attempt * 1200, 6000)));
    }
    throw new Error("page " + index + " upload failed after " + MAX_ATTEMPTS + " tries: " + (lastErr && lastErr.message));
  }

  // Assemble the staged pages into one PDF — SAME-ORIGIN (through the App Proxy), so
  // nothing is cross-origin for a customer's extensions/ad-blockers to interfere with.
  // Start returns instantly; the stapler does the work in the background and calls the
  // Worker back; we poll for the result. Each request is short. Returns { id, viewUrl, downloadUrl }.
  async function _dmbAssembleViaStapler(proxy, qsBase, pages, onStatus) {
    if (typeof onStatus === "function") onStatus(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
    const startRes = await fetch(proxy + "/assemble?" + qsBase, {
      method: "POST", headers: { "content-type": "application/json" }, credentials: "same-origin",
      body: JSON.stringify({ pages: pages }),
    });
    let startData = null; try { startData = await startRes.json(); } catch (e) {}
    if (!startRes.ok || !startData || startData.status !== "pending") {
      throw new Error("assemble start failed: " + ((startData && startData.error) || ("status " + startRes.status)));
    }
    const deadline = Date.now() + 12 * 60 * 1000;   // big books can take a few minutes
    let ticks = 0;
    while (Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, 3000));
      let st = null;
      try { st = await (await fetch(proxy + "/assemble-status?" + qsBase, { credentials: "same-origin" })).json(); }
      catch (e) { continue; }   // transient — keep polling
      if (st && st.status === "done" && st.id) return st;
      if (st && st.status === "error") throw new Error("assemble failed: " + (st.error || "unknown"));
      if (typeof onStatus === "function" && (++ticks % 4 === 0)) onStatus(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
    }
    throw new Error("assemble timed out");
  }

  // Render → upload each page → assemble. Returns { id, viewUrl, downloadUrl } shaped
  // exactly like uploadPdfToGoogleDrive so the Add-to-Cart code is unchanged after this.
  async function _dmbStreamingBuildAndUpload(label, excludePages, onProgress, onStatus, onHide) {
    const proxy = window.DMB_DESIGNS_PROXY || "/apps/designs";
    const designId = getCustomerSaveKey().replace(/^dmb_progress_/, "");
    // A session id gives guests a stable owner; logged-in customers use their customer
    // id (from the App-Proxy signature). render-page + assemble share the SAME owner → token.
    let sid = ""; try { sid = _dmbPhotoBackup.guestId() || ""; } catch (e) {}
    if (!sid) sid = "s" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    const qsBase = "id=" + encodeURIComponent(designId) + "&sid=" + encodeURIComponent(sid);

    const manifest = await window.__dmbBuildPdfStreaming(async function (pg) {
      const blob = _dmbDataUrlToBlob(pg.jpeg);
      await _dmbUploadRenderPage(proxy, qsBase, pg.index, blob);
      // Proof preview, best effort and AFTER the real page is safely staged. This path
      // renders in the customer's own tab, so the small copy comes off the very same
      // canvas the printable page came from - same image, scaled.
      if (pg.preview) {
        try { await _dmbUploadRenderPreview(proxy, pg.index, _dmbDataUrlToBlob(pg.preview), "", qsBase); } catch (e) {}
      }
    }, onProgress, excludePages, { wantPreview: true });

    const pages = (manifest && manifest.pages ? manifest.pages : [])
      .map((p) => ({ index: p.index, wMm: p.wMm, hMm: p.hMm }));
    if (!pages.length) throw new Error("streaming produced no pages");

    // ── PROOF, on the fallback path too ──────────────────────────────────────
    // The proof used to live ONLY inside the server render. That render fails SOFT by
    // design so an order is never blocked, which meant any server-side problem silently
    // dropped the customer onto this path - and this path bound the book and added it to
    // the cart without ever showing them a page. The owner's rule is that nobody pays
    // for a book they have not seen, and a rule that quietly disappears on the error
    // path is not a rule.
    //
    // It can be the SAME screen because this path stages the same way: every page is
    // already in R2 under the design's own token when we get here, and the Worker's
    // handleRenderProofPage falls back to the positional key when there is no active
    // render job. Nothing is assembled until they approve. (2026-09-18)
    if (typeof _dmbSrProofScreen === "function") {
      try { if (onHide) onHide(); } catch (e) {}
      let _choice = "approve";
      try {
        _choice = await _dmbSrProofScreen(pages, qsBase, null);
      } catch (e) {
        // A broken proof must not cost the order. Bind what they already approved by
        // getting this far, exactly as this path behaved before the proof existed.
        _choice = "approve";
      }
      if (_choice !== "approve") return "__dmb_proof_rejected__";
      if (typeof onStatus === "function") {
        try { onStatus("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")); } catch (e) {}
      }
    }

    // The stapler deletes the staged pages after assembly (via the Worker callback).
    const result = await _dmbAssembleViaStapler(proxy, qsBase, pages, onStatus);
    return { id: result.id, viewUrl: result.viewUrl, downloadUrl: result.downloadUrl };
  }

  function mergeFilesKeepOld(existingArr, newlyPickedArr) {
    const out = Array.isArray(existingArr) ? existingArr.slice() : [];
    const newArr = Array.isArray(newlyPickedArr) ? newlyPickedArr : [];

    const key = (f) => `${f.name}__${f.size}__${f.lastModified}`;
    const seen = new Set(out.map(key));

    newArr.forEach((f) => {
      const k = key(f);
      if (!seen.has(k)) {
        out.push(f);
        seen.add(k);
        // Start decoding this photo's dimensions in the background now (upload
        // step), so the builder/cover doesn't have to wait for it on open.
        try { _dmbWarmMeta(f); } catch (e) {}
        // INSTANT BACKUP: stream this photo to R2 the moment it's picked —
        // a phone-tab crash during the upload step can no longer lose it.
        try { _dmbInstantBackup.enqueue(f); } catch (e) {}
      }
    });

    return out;
  }

  function showReuseNotice() {
    let n = document.getElementById("dmbReuseNotice");

    if (!n) {
      n = document.createElement("div");
      n.id = "dmbReuseNotice";
      n.style.position = "fixed";
      n.style.left = "50%";
      n.style.bottom = "20px";
      n.style.transform = "translateX(-50%)";
      n.style.zIndex = "99999";
      n.style.background = "rgba(17,17,17,0.92)";
      n.style.color = "#fff";
      n.style.padding = "10px 14px";
      n.style.borderRadius = "999px";
      n.style.fontSize = "12px";
      n.style.fontWeight = "800";
      n.style.boxShadow = "0 8px 24px rgba(0,0,0,0.2)";
      document.body.appendChild(n);
    }

    n.textContent = "You have used this photo before (reused).";
    n.style.display = "block";
    n.style.opacity = "1";

    clearTimeout(showReuseNotice._t);
    showReuseNotice._t = setTimeout(() => {
      if (n) n.style.opacity = "0";
      setTimeout(() => { if (n) n.style.display = "none"; }, 180);
    }, 1400);
  }

  function enforceMax(filesArr, maxAllowed) {
    if (!maxAllowed) return;
    if (filesArr.length > maxAllowed) filesArr.length = maxAllowed;
  }

  function setDragPayload(e, payload) {
    DMB_CURRENT_DRAG = payload;
    const json = JSON.stringify(payload);
    e.dataTransfer.setData("application/x-dmb", json);
    e.dataTransfer.setData("text/x-dmb", json);
    e.dataTransfer.setData("text/plain", json);
    e.dataTransfer.effectAllowed = "copyMove";
  }

  function getDragPayload(e) {
    const dt = e.dataTransfer;
    if (!dt) return DMB_CURRENT_DRAG;

    let raw =
      dt.getData("application/x-dmb") ||
      dt.getData("text/x-dmb") ||
      dt.getData("text/plain") ||
      "";

    raw = (raw || "").trim();
    if (!raw) return DMB_CURRENT_DRAG;

    if (raw[0] !== "{") return { type: "photo", photoId: raw };

    try {
      return JSON.parse(raw);
    } catch {
      return DMB_CURRENT_DRAG;
    }
  }

  // ── Touch drag-and-drop for photos ─────────────────────────────────────────
  // HTML5 draggable=true only works with a mouse; on a phone/iPad a drag never
  // starts and the long-press selects the whole UI instead. This reuses the
  // existing drop handlers by dispatching a synthetic drop at the finger point:
  // getDragPayload() falls back to the DMB_CURRENT_DRAG global when there's no real
  // dataTransfer, and every drop reads payload.photoId (set here) before ever
  // touching dataTransfer, so a fake dataTransfer + clientX/Y is enough.
  function _dmbSyntheticDnD(type, x, y) {
    const el = document.elementFromPoint(x, y);
    if (!el) return null;
    const ev = new Event(type, { bubbles: true, cancelable: true });
    const fakeDT = { getData: function () { return ""; }, setData: function () {}, clearData: function () {},
      setDragImage: function () {}, dropEffect: "copy", effectAllowed: "copyMove", files: [], items: [], types: [] };
    try { Object.defineProperty(ev, "dataTransfer", { value: fakeDT, configurable: true }); } catch (e) {}
    try { Object.defineProperty(ev, "clientX", { value: x, configurable: true }); } catch (e) {}
    try { Object.defineProperty(ev, "clientY", { value: y, configurable: true }); } catch (e) {}
    el.dispatchEvent(ev);
    return el;
  }

  // Wire a pointer-based drag onto a photo-tray thumbnail (touch only; mouse keeps
  // native HTML5 drag). A finger press-and-move lifts a floating ghost that follows
  // the finger; releasing over a page/cover frame drops the photo in.
  function _dmbWireThumbTouchDrag(t, ph) {
    let sx = 0, sy = 0, pid = null, dragging = false, ghost = null;
    function cleanup() {
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      document.removeEventListener("pointercancel", onUp);
    }
    function onMove(e) {
      if (e.pointerId !== pid) return;
      if (!dragging) {
        const dx = e.clientX - sx, dy = e.clientY - sy;
        const adx = Math.abs(dx), ady = Math.abs(dy);
        // Start the drag on the FIRST few px of a vertical(-ish) move so it feels
        // instant — no hold, no dead zone. `touch-action:pan-x` already routes a
        // clearly-horizontal swipe to the tray scroll, but bail here too as a guard.
        if (adx < 5 && ady < 5) return;                          // ignore micro-jitter only
        if (adx > ady) { cleanup(); pid = null; return; }        // horizontal → tray scroll
        dragging = true;                                         // vertical → lift NOW
        DMB_CURRENT_DRAG = { type: "photo", photoId: ph.id };
        document.body.classList.add("dmb-dragging-photo");
        ghost = document.createElement("div");
        ghost.className = "dmb-drag-ghost";
        const im = document.createElement("img");
        const _tImg = t.querySelector("img");
        im.src = ph.thumbUrl || (typeof _dmbThumbCache !== "undefined" && _dmbThumbCache[ph.id]) || (_tImg && _tImg.src) || "";
        ghost.appendChild(im);
        document.body.appendChild(ghost);
      }
      e.preventDefault();
      if (ghost) { ghost.style.left = e.clientX + "px"; ghost.style.top = e.clientY + "px"; }
    }
    function onUp(e) {
      if (e.pointerId !== pid) return;
      cleanup();
      if (!dragging) { pid = null; return; }   // was a tap → thumb's own handler opens the menu
      e.preventDefault();
      const x = e.clientX, y = e.clientY;
      if (ghost) ghost.style.display = "none";   // so elementFromPoint sees the drop target
      try { _dmbSyntheticDnD("dragover", x, y); } catch (_) {}
      try { _dmbSyntheticDnD("drop", x, y); } catch (_) {}
      if (ghost) { ghost.remove(); ghost = null; }
      document.body.classList.remove("dmb-dragging-photo");
      DMB_CURRENT_DRAG = null;
      dragging = false; pid = null;
    }
    t.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse") return;                       // desktop uses native draggable
      if (e.target.closest && e.target.closest(".dmb-photo-hover-menu")) return;
      pid = e.pointerId; sx = e.clientX; sy = e.clientY; dragging = false;
      document.addEventListener("pointermove", onMove, { passive: false });
      document.addEventListener("pointerup", onUp);
      document.addEventListener("pointercancel", onUp);
    });
  }


  function syncCoverInputsFromState() {
    if (coverColorInput) coverColorInput.value = coverState.color || "#ffffff";
    if (coverColorSwatch) coverColorSwatch.style.background = coverState.color || "#ffffff";
    updateCoverPreview();
    if (typeof renderCoverTextList === "function") renderCoverTextList();
  }

  function renderCoverTextList() {
    const list = document.getElementById("dmbCoverTextList");
    if (!list) return;
    list.innerHTML = "";
    if (!Array.isArray(editor.coverUserTexts) || !editor.coverUserTexts.length) {
      const empty = document.createElement("div");
      empty.className = "dmb-cover-text-empty";
      empty.textContent = 'No text added yet. Click "Add text" on the cover.';
      list.appendChild(empty);
      return;
    }
    editor.coverUserTexts.forEach(({ id, zone }) => {
      const saved = coverState.textStyles?.[id];
      const row = document.createElement("div");
      row.className = "dmb-cover-text-row";

      const inp = document.createElement("input");
      inp.type = "text";
      inp.className = "dmb-input";
      inp.value = saved?.text || "";
      inp.placeholder = "Enter text…";
      inp.setAttribute("data-text-id", id);
      inp.addEventListener("input", () => {
        if (!coverState.textStyles) coverState.textStyles = {};
        if (!coverState.textStyles[id]) coverState.textStyles[id] = {};
        coverState.textStyles[id].text = inp.value;
        const liveNode = document.getElementById(id);
        if (liveNode) { liveNode.textContent = inp.value; }
      });

      const zoneLabel = document.createElement("span");
      zoneLabel.className = "dmb-cover-text-zone";
      zoneLabel.textContent = zone;

      const delBtn = document.createElement("button");
      delBtn.type = "button";
      delBtn.className = "dmb-cover-text-del";
      delBtn.title = "Remove text";
      delBtn.innerHTML = "&#x2715;";
      delBtn.addEventListener("click", () => {
        pushUndoState("Delete Cover Text");
        editor.coverUserTexts = editor.coverUserTexts.filter((t) => t.id !== id);
        if (coverState.textStyles) delete coverState.textStyles[id];
        const liveNode = document.getElementById(id);
        if (liveNode) liveNode.remove();
        renderCoverTextList();
        saveCoverDesignToStorage();
      });

      row.appendChild(inp);
      row.appendChild(zoneLabel);
      row.appendChild(delBtn);
      list.appendChild(row);
    });
  }

  // ── Magazine page/spread plan ─────────────────────────────────────────────
  // Magazines use a FIXED layout per size (not ceil(pages/2)): page 0 (single,
  // editable) + N two-page spreads + 1 trailing single (editable) page. N is
  // looked up by the selected "pages" variant value, giving:
  //   totalPages   = 2·N + 1   (pages 1..2N are the N pairs; page 2N+1 is the single
  //                             trailing page — odd, so it auto-renders alone)
  //   totalSpreads = N + 1      (N pairs + the trailing single-page spread; page 0 is
  //                             "Spread 0" shown on top of these)
  // Price/variant still key off the dropdown value (the size), so this is layout-only.
  // Books — and any magazine size not in the table — keep the old ceil(pages/2) model.
  // Keyed by the actual custom-magazine "pages" option values (24/30/42/50/70/90).
  // The 40/76/100 aliases are kept harmless in case a variant uses those numbers —
  // an unlisted size falls back to ceil(pages/2), which adds one extra spread.
  var MAG_SPREADS_BY_SIZE = {
    24: 11, 30: 15, 42: 19, 50: 25, 70: 33, 90: 43,
    40: 19, 76: 33, 100: 43,
  };

  function _dmbPagePlan(selectedPages) {
    var sp = Number(selectedPages) || 0;
    if (window.DMB_MAGAZINE_MODE) {
      var n = MAG_SPREADS_BY_SIZE[sp];
      if (n) return { totalPages: n * 2 + 1, totalSpreads: n + 1 };
    }
    // Books, or an unknown magazine size → previous behavior (pairs only, no trailing single).
    return { totalPages: sp, totalSpreads: Math.max(1, Math.ceil(sp / 2)) };
  }

  function initEmptyBookFromPages() {
    const selectedPages = Number(pagesEl?.value || 0);
    if (!selectedPages) return;

    // Reset extra spreads whenever base page count changes
    editor.extraSpreads = 0;
    const _plan = _dmbPagePlan(selectedPages);
    editor.totalPages = _plan.totalPages;
    editor.editablePages = Math.max(0, editor.totalPages - 1);
    editor.totalSpreads = _plan.totalSpreads;
    editor.currentSpread = 0;

    // Page-count changes are NON-DESTRUCTIVE. Changing the count must NOT wipe the
    // customer's work: keep the cover (page-count-independent) AND every existing
    // page's content (shapes, photos, text, templates, backgrounds). We only ADD
    // empty structure for newly-added pages and TRIM pages that no longer exist.
    // (Previously this reset all page maps + the cover to {} on every change, so a
    // shape/photo/text vanished whenever the customer adjusted the page count.)
    editor.pageSlots       = editor.pageSlots       || {};
    editor.pageRot         = editor.pageRot         || {};
    editor.pageTemplate    = editor.pageTemplate    || {};
    editor.pageFrames      = editor.pageFrames      || {};
    editor.pageFrameRot    = editor.pageFrameRot    || {};
    editor.pageFrameShapes = editor.pageFrameShapes || {};
    editor.pageObjects     = editor.pageObjects     || {};
    editor.pageBackgrounds = editor.pageBackgrounds || {};
    if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];

    // Trim any content that belongs to pages beyond the new page count.
    [editor.pageSlots, editor.pageRot, editor.pageTemplate, editor.pageFrames,
     editor.pageFrameRot, editor.pageFrameShapes, editor.pageObjects, editor.pageBackgrounds
    ].forEach(function (map) {
      Object.keys(map).forEach(function (k) {
        if (Number(k) > editor.totalPages) delete map[k];
      });
    });

    // Add empty structure for any newly-added pages; leave existing pages intact.
    for (let p = 1; p <= editor.totalPages; p++) {
      if (!(p in editor.pageSlots))    editor.pageSlots[p]    = { A: null, B: null };
      if (!(p in editor.pageRot))      editor.pageRot[p]      = { A: 0, B: 0 };
      if (!(p in editor.pageTemplate)) editor.pageTemplate[p] = null;
      if (!(p in editor.pageFrames))   editor.pageFrames[p]   = {};
      if (!(p in editor.pageFrameRot)) editor.pageFrameRot[p] = {};
      if (!Array.isArray(editor.pageObjects[p])) editor.pageObjects[p] = [];
    }

    if (bookMeta) {
      bookMeta.textContent = `${selectedPages} pages (${editor.editablePages} to design) • ${editor.photos.filter((p) => !_dmbIsCropDerived(p)).length} photos`;
    }

    // Show the "Add spread" button now that a page count is chosen
    _syncSpreadAdderUI();

    renderThumbsRail();

    if (builderMode === "cover") {
      renderCoverCanvas();
    } else {
      renderSpread();
    }
  }

  // ── Extra spreads: add / remove 2 pages at +$1.99 each ───────────────────
  // Callers: "+" and "−" buttons in the spread adder row.
  // WARNING: always call updatePrice() + refreshPhotoRule() after changing
  //          editor.extraSpreads so the displayed price + photo rule stay in sync.

  function addExtraSpread() {
    if (!pagesEl?.value) { alert("Please select a page count first."); return; }
    pushUndoState("Add Extra Spread");   // snapshot BEFORE mutating so undo restores the prior state
    const newL = editor.totalPages + 1;
    const newR = editor.totalPages + 2;
    // Initialise the two new pages exactly like initEmptyBookFromPages does
    [newL, newR].forEach(p => {
      editor.pageSlots[p]     = { A: null, B: null };
      editor.pageRot[p]       = { A: 0, B: 0 };
      editor.pageTemplate[p]  = null;
      editor.pageFrames[p]    = {};
      editor.pageFrameRot[p]  = {};
      editor.pageObjects[p]   = [];
    });
    editor.totalPages    += 2;
    editor.editablePages += 2;
    editor.totalSpreads  += 1;
    editor.extraSpreads  += 1;
    updatePrice();
    refreshPhotoRule();
    _syncSpreadAdderUI();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function removeExtraSpread() {
    if ((editor.extraSpreads || 0) <= 0) return;
    pushUndoState("Remove Extra Spread");   // snapshot BEFORE mutating
    const remL = editor.totalPages - 1;
    const remR = editor.totalPages;
    // Navigate away from the spread being removed
    const maxAllowedSpread = Math.max(0, editor.totalSpreads - 2);
    if (editor.currentSpread >= maxAllowedSpread) {
      editor.currentSpread = Math.max(0, maxAllowedSpread - 1);
    }
    // Clean up removed pages
    [remL, remR].forEach(p => {
      delete editor.pageSlots[p];
      delete editor.pageRot[p];
      delete editor.pageTemplate[p];
      delete editor.pageFrames[p];
      delete editor.pageFrameRot[p];
      delete editor.pageObjects[p];
    });
    editor.totalPages    -= 2;
    editor.editablePages -= 2;
    editor.totalSpreads  -= 1;
    editor.extraSpreads  -= 1;
    updatePrice();
    refreshPhotoRule();
    _syncSpreadAdderUI();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  // Sync the spread adder row: update counter, cost label, and button states.
  // The row is always visible inside the builder — no show/hide needed here.
  function _syncSpreadAdderUI() {
    const countEl   = $("dmbSpreadCountEl");
    const costEl    = $("dmbSpreadCostEl");
    const removeBtn = $("dmbRemoveSpreadBtn");
    const n = editor.extraSpreads || 0;
    if (countEl) countEl.textContent = n;
    if (costEl) {
      if (n > 0) {
        costEl.textContent = "+" + fmtMoney(n * EXTRA_SPREAD_PRICE);
        costEl.style.display = "inline";
      } else {
        costEl.style.display = "none";
      }
    }
    if (removeBtn) removeBtn.disabled = n <= 0;
  }


  // ── Recently-used colors ──────────────────────────────────────────────
  // Shared, persisted palette of colors the customer has applied (cover / page
  // background + text). Every color picker shows these as one-tap swatches, with
  // the current color highlighted. A swatch is applied by writing the value onto
  // the real <input type=color> and dispatching input/change, so the existing
  // apply logic runs unchanged.
  const DMB_RECENT_COLORS_KEY = "dmbRecentColors";
  function dmbGetRecentColors() {
    try { const a = JSON.parse(localStorage.getItem(DMB_RECENT_COLORS_KEY) || "[]"); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function _dmbNormHex(c) {
    if (!c) return "";
    c = String(c).trim().toLowerCase();
    if (/^#[0-9a-f]{6}$/.test(c)) return c;
    if (/^#[0-9a-f]{3}$/.test(c)) return "#" + c[1] + c[1] + c[2] + c[2] + c[3] + c[3];
    const m = c.match(/^rgba?\(([^)]+)\)/);
    if (m) {
      const p = m[1].split(",").map((x) => parseInt(x, 10));
      if (p.length >= 3 && p.slice(0, 3).every((n) => !isNaN(n))) {
        return "#" + p.slice(0, 3).map((n) => Math.max(0, Math.min(255, n)).toString(16).padStart(2, "0")).join("");
      }
    }
    return "";
  }
  function dmbAddRecentColor(c) {
    const hex = _dmbNormHex(c);
    if (!hex) return;
    let list = dmbGetRecentColors().filter((x) => x !== hex);
    list.unshift(hex);
    list = list.slice(0, 10);
    try { localStorage.setItem(DMB_RECENT_COLORS_KEY, JSON.stringify(list)); } catch (e) {}
    dmbRefreshRecentSwatches();
  }
  function dmbRefreshRecentSwatches() {
    document.querySelectorAll(".dmb-recent-swatches").forEach((strip) => {
      if (strip._dmbRender) strip._dmbRender();
    });
  }
  // Bring a design's saved colour palette onto THIS device (merge synced-first with any
  // local palette). The palette rides inside the design snapshot so it syncs cross-device.
  function _dmbApplyRecentColors(snap) {
    try {
      const rc = snap && snap.recentColors;
      if (!Array.isArray(rc) || !rc.length) return;
      const merged = [];
      rc.concat(dmbGetRecentColors()).forEach((h) => { const n = _dmbNormHex(h); if (n && merged.indexOf(n) === -1) merged.push(n); });
      localStorage.setItem(DMB_RECENT_COLORS_KEY, JSON.stringify(merged.slice(0, 10)));
      dmbRefreshRecentSwatches();
    } catch (e) {}
  }
  // Attach a recent-colors swatch strip to a color <input>. `container` is where the
  // strip is appended (defaults to the input's parent). Idempotent per input.
  function dmbEnhanceColorInput(input, container) {
    if (!input || input._dmbColorEnhanced) return;
    const host = container || input.parentElement;
    if (!host) return;
    input._dmbColorEnhanced = true;
    // A background strip (cover / page) defers to the selected text: if a text box
    // is selected, clicking a swatch colors the TEXT, not the background. The text
    // toolbar's own strip always colors text.
    const isBackground = input.id !== "dmbTextColor";
    const strip = document.createElement("div");
    strip.className = "dmb-recent-swatches";
    host.appendChild(strip);
    const render = () => {
      const colors = dmbGetRecentColors();
      const cur = _dmbNormHex(input.value);
      strip.innerHTML = "";
      colors.forEach((hex) => {
        const b = document.createElement("button");
        b.type = "button"; b.className = "dmb-recent-swatch"; b.title = hex;
        b.style.background = hex;
        if (hex === cur) b.classList.add("active");
        b.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          // Text selected + background strip → recolor the text instead.
          if (isBackground && typeof selectedTextNode !== "undefined" && selectedTextNode) {
            const tc = document.getElementById("dmbTextColor");
            if (tc) {
              tc.value = hex;
              tc.dispatchEvent(new Event("input", { bubbles: true }));
              tc.dispatchEvent(new Event("change", { bubbles: true }));
            }
          } else {
            input.value = hex;
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
          dmbRefreshRecentSwatches();
        });
        strip.appendChild(b);
      });
      strip.style.display = colors.length ? "" : "none";
    };
    strip._dmbRender = render;
    input.addEventListener("change", () => dmbAddRecentColor(input.value));
    // NOTE: do NOT seed the palette with the input's default/current colour — the
    // saved palette must only ever hold colours the user actively CHOSE, never
    // auto-generated defaults (per request). It grows only on a real 'change'.
    render();
  }

  // iOS-safe colour picker. iOS Safari ignores a programmatic .click() on a
  // hidden <input type=color>, so on phones the "＋ Custom colour…" buttons never
  // opened the native wheel. Fix: overlay the REAL input transparently over its
  // button so a genuine finger tap lands on the input itself and opens the picker
  // (same pattern the cover-background swatch already uses). Mobile only — desktop
  // keeps the .click() path. Idempotent per button. Listeners survive appendChild.
  function _dmbColorTapFix(customEl, inputEl) {
    try {
      if (!customEl || !inputEl) return;
      if (!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches)) return;
      if (customEl._dmbColorTapWired) return;
      customEl._dmbColorTapWired = true;
      customEl.style.position = "relative";
      if (inputEl.parentElement !== customEl) customEl.appendChild(inputEl);
      inputEl.classList.add("dmb-color-overlay");
    } catch (e) {}
  }

  // ── Text toolbar: colour-wheel + icon dropdowns ────────────────────────────
  // Tint the colour-wheel button's centre dot with the current text colour.
  function _dmbSyncTextColorDot() {
    const dot = document.getElementById("dmbTextColorDot");
    const inp = document.getElementById("dmbTextColor");
    if (dot && inp) dot.style.background = inp.value || "#000000";
  }
  // Same, for the frame toolbar's icon colour-wheel.
  function _dmbSyncFrameIconDot() {
    const dot = document.getElementById("dmbFrameIconColorDot");
    const inp = document.getElementById("dmbFrameIconColorInput");
    if (dot && inp) dot.style.background = inp.value || "#000000";
  }
  // Shape edit bar's Fill + Border colour-wheels. Fill shows a red "no-fill" slash
  // when Outline-only is on.
  function _dmbSyncShapeDots() {
    const fEl = document.getElementById("dmbShapeFill");
    const sEl = document.getElementById("dmbShapeStroke");
    const fDot = document.getElementById("dmbShapeFillDot");
    const sDot = document.getElementById("dmbShapeStrokeDot");
    const outlineOnly = !!document.getElementById("dmbShapeOutlineOnly")?.checked;
    if (fDot) fDot.style.background = outlineOnly
      ? "linear-gradient(45deg, transparent 43%, #e5484d 43%, #e5484d 57%, transparent 57%), #fff"
      : ((fEl && fEl.value) || "#6366f1");
    if (sDot && sEl) sDot.style.background = sEl.value || "#000000";
  }
  // Map edit bar's Fill + Border colour-wheels (Fill shows a "no-fill" slash when
  // Transparent is on).
  function _dmbSyncMapDots() {
    const fEl = document.getElementById("dmbEditFill");
    const sEl = document.getElementById("dmbEditStroke");
    const fDot = document.getElementById("dmbEditFillDot");
    const sDot = document.getElementById("dmbEditStrokeDot");
    const transp = !!document.getElementById("dmbEditTransparentFill")?.checked;
    if (fDot) fDot.style.background = transp
      ? "linear-gradient(45deg, transparent 43%, #e5484d 43%, #e5484d 57%, transparent 57%), #fff"
      : ((fEl && fEl.value) || "#d9d9d9");
    if (sDot && sEl) sDot.style.background = sEl.value || "#111111";
  }
  // Reflect the 3 hidden map checkboxes onto the visible Fill-mode segmented control
  // (Solid / Outline / None) and the Borders toggle.
  function _dmbSyncMapModeUI() {
    const outline = !!document.getElementById("dmbEditShowOutline")?.checked;
    const transp  = !!document.getElementById("dmbEditTransparentFill")?.checked;
    const noBord  = !!document.getElementById("dmbEditHideProvinces")?.checked;
    const mode = outline ? "outline" : (transp ? "none" : "solid");
    document.querySelectorAll("#dmbEditFillMode .dmb-map-seg-btn").forEach((b) => {
      b.classList.toggle("is-on", b.dataset.fillmode === mode);
    });
    const bt = document.getElementById("dmbEditBordersBtn");
    if (bt) bt.setAttribute("aria-pressed", noBord ? "false" : "true");
  }
  // Dock an object edit bar INTO the fixed ribbon (the sticky header strip),
  // flowing inline in the context zone. The bar drops its own floating chrome
  // (position/background/border) via the `.dmb-in-ribbon` class and rides along
  // with the sticky ribbon on scroll — no manual repositioning needed.
  function _dmbDockBar(bar) {
    if (!bar) return;
    // On phones the desktop top ribbon (.dmb-stage-header) is display:none, so the
    // object menu docks into the mobile icon ribbon under the page-nav row instead.
    const _mob = window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches;
    const slot = (_mob && document.getElementById("dmbMshRibbon")) ||
                 document.getElementById("dmbRibbonContext");
    if (slot && bar.parentNode !== slot) slot.appendChild(bar);
    bar.classList.add("dmb-in-ribbon");
    bar.style.position = "";
    bar.style.left = ""; bar.style.top = ""; bar.style.right = ""; bar.style.bottom = "";
    // Clear the inline display so the `.dmb-in-ribbon` layout (flex) governs the
    // OPEN state; close/drag-hide re-set inline display:none, which then wins.
    bar.style.display = "";
    _dmbUpdateRibbonPlaceholder();
  }
  // Show the greyed "select an object to edit" placeholder only when no object
  // bar is currently docked/open in the ribbon.
  function _dmbUpdateRibbonPlaceholder() {
    const ph = document.getElementById("dmbRibbonPlaceholder");
    if (!ph) return;
    const _shown = (id) => { const b = document.getElementById(id); return b && b.style.display !== "none" && b.classList.contains("dmb-in-ribbon"); };
    const _open  = (id) => { const b = document.getElementById(id); return b && b.classList.contains("is-open"); };
    const anyOpen = _shown("dmbMapEditBar") || _shown("dmbShapeEditBar") ||
                    _open("dmbTextToolbar") || _open("dmbFrameToolbar");
    ph.hidden = !!anyOpen;
    // Mobile: hide the idle Add/Page row while an object menu is docked in its place.
    const idle = document.getElementById("dmbMshRibbonIdle");
    if (idle) idle.hidden = !!anyOpen;
  }
  // Mirror the hidden <select id=dmbTextAlign> onto the icon toggle button.
  function _dmbSyncAlignIcon() {
    const sel = document.getElementById("dmbTextAlign");
    const icon = document.getElementById("dmbTextAlignIcon");
    const menu = document.getElementById("dmbTextAlignMenu");
    if (!sel || !icon || !menu) return;
    const val = sel.value || "left";
    const opt = menu.querySelector('.dmb-align-opt[data-align="' + val + '"]');
    if (opt) icon.innerHTML = opt.innerHTML;
    menu.querySelectorAll(".dmb-align-opt").forEach((b) =>
      b.classList.toggle("active", b.getAttribute("data-align") === val));
  }
  // Close every text-toolbar popup except the one passed in.
  function _dmbCloseTextMenus(except) {
    ["dmbTextColorPop", "dmbTextAlignMenu", "dmbTextMoreMenu"].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el !== except) el.hidden = true;
    });
  }

  function initUnifiedTabs() {
    const tabs = Array.from(document.querySelectorAll(".dmb-icon-tab"));
    const panels = Array.from(document.querySelectorAll(".dmb-side-panel"));
    const title = document.getElementById("dmbLeftTitle");

    const labels = {
      images: "Pictures",
      cover: "Cover",
      layouts: "Layouts",
      backgrounds: "Backgrounds",
      stickers: "Stickers",
      text: "Text"
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.getAttribute("data-tab");
        const _mshMobile = !!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches);

        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));
        tab.classList.add("active");
        const panel = document.querySelector(`.dmb-side-panel[data-panel="${key}"]`);
        if (panel) panel.classList.add("active");
        if (title) title.textContent = labels[key] || "Panel";
        // Mark the active tab on the panel so CSS can hide the title bar on the Pictures
        // tab (desktop) while keeping it on the other tabs.
        try { const _lp = tab.closest(".dmb-builder-shell")?.querySelector(".dmb-builder-leftpanel") || document.querySelector(".dmb-builder-leftpanel"); if (_lp) _lp.setAttribute("data-active-tab", key); } catch (e) {}
        if (key === "cover") {
          builderMode = "cover";
          if (typeof syncBuilderModeButtons === "function") syncBuilderModeButtons();
          if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        }
        // Layouts tab: render the inline panel (target + categories + A4 thumbnails,
        // direct apply — no popup) on BOTH mobile and desktop, for pages AND cover.
        if (key === "layouts") {
          if (_mshMobile) {
            _mshBuildLayoutsPanel();
          } else {
            const t = (typeof window._dmbPendingLayoutTarget === "string") ? window._dmbPendingLayoutTarget : "left";
            window._dmbPendingLayoutTarget = null;
            _dmbBuildDesktopLayoutsPanel(t);
          }
        }
      });
    });

    // Initial state: mark the active tab (Pictures by default) so the CSS hides its title.
    try {
      const _activeTab = document.querySelector(".dmb-icon-tab.active");
      const _activeKey = _activeTab ? _activeTab.getAttribute("data-tab") : "images";
      const _lp0 = document.querySelector(".dmb-builder-leftpanel");
      if (_lp0) _lp0.setAttribute("data-active-tab", _activeKey);
    } catch (e) {}
  }

  // opts.ignoreSearch / opts.ignoreUsedFilter let a CALLER opt out of the tray's
  // view state. "Do the Magic" needs both: the search box and the "Hide used"
  // toggle are how the customer is LOOKING at their photos, and they must never
  // decide which photos end up in the book. With the search box filled, Magic
  // used to silently lay out only the matching photos and leave the rest behind.
  function applyPhotoFilters(list, opts) {
    let arr = Array.isArray(list) ? list.slice() : [];
    const _ig = opts || {};

    // Derived crop photos are internal placement bytes — never show them in the tray.
    arr = arr.filter((p) => !_dmbIsCropDerived(p));

    if (!_ig.ignoreSearch && currentPhotoSearch.trim()) {
      const q = currentPhotoSearch.trim().toLowerCase();
      arr = arr.filter((p) => {
        const filename = String(p.filename || p.file?.name || "").toLowerCase();
        const dateTaken = String(p.dateTaken || "").toLowerCase();
        const tags = Array.isArray(p.tags) ? p.tags.join(" ").toLowerCase() : "";
        return filename.includes(q) || dateTaken.includes(q) || tags.includes(q);
      });
    }

    if (!_ig.ignoreUsedFilter && hideUsedPhotos) {
      const used = getUsedPhotoIds();
      arr = arr.filter((p) => !used.has(p.id));
    }

    if (currentPhotoSort === "latest") {
      arr.sort((a, b) => (b.addedIndex || 0) - (a.addedIndex || 0));
    } else if (currentPhotoSort === "date") {
      arr.sort((a, b) => String(a.dateTaken || "").localeCompare(String(b.dateTaken || "")));
    } else if (currentPhotoSort === "filename") {
      arr.sort((a, b) => String(a.filename || "").localeCompare(String(b.filename || "")));
    } else if (currentPhotoSort === "portrait") {
      arr.sort((a, b) => (a.ratio || 1) - (b.ratio || 1));
    } else if (currentPhotoSort === "landscape") {
      arr.sort((a, b) => (b.ratio || 1) - (a.ratio || 1));
    } else {
      arr.sort((a, b) => (a.addedIndex || 0) - (b.addedIndex || 0));
    }

    return arr;
  }


  function setCanvasZoom(scale) {
    // Phone shell: the canvas is always auto-fit AND CENTRED (translate(-50%,-50%)).
    // Any plain scale() here uses transform-origin:top-left and would knock the
    // canvas off-centre (the iPad-portrait "half off-screen" bug), so delegate every
    // zoom to _mshFitSpread, which owns the centred fit.
    try {
      if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) { _mshFitSpread(); return; }
    } catch (e) {}

    currentZoom = Math.max(0.25, Math.min(2, scale));

    if (spreadCanvas) {
      spreadCanvas.style.transform = `scale(${currentZoom})`;
      spreadCanvas.style.transformOrigin = "top left";
    }

    // Collapse the viewport box to the scaled size (transform:scale leaves a
    // full-size layout box → dead space below a zoomed-out book).
    _dmbCollapseSpreadVp();

    const zoomLabel =
      document.getElementById("zoomValue") ||
      document.getElementById("zoomLabel");

    if (zoomLabel) {
      zoomLabel.textContent = `${Math.round(currentZoom * 100)}%`;
    }

    const zoomRange = document.getElementById("zoomRange");
    if (zoomRange) {
      zoomRange.value = String(Math.round(currentZoom * 100));
    }

    // Re-match the second column's bottom to the (now-shorter) builder box.
    if (typeof syncPhotoTrayHeight === "function") syncPhotoTrayHeight();
  }

  // Desktop: shrink the cover just enough that the WHOLE cover plus its Front/Back
  // face labels fits the canvas height — no vertical scroll. Phones are handled by
  // _mshFitSpread. Measures the cover's true (transform-independent) height via
  // offsetHeight, which already includes the label-reserve margin, against the
  // height the canvas column can give it. Only shrinks (fit ≤ 1); deterministic, so
  // it converges and never fights itself across re-renders.
  function _dmbFitCoverIntoView() {
    try {
      if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) return;
      if (builderMode !== "cover") return;
      var cv = document.getElementById("spreadCanvas");
      var stageEl = document.querySelector(".dmb-canvas-stage");
      var wrapCol = document.querySelector(".dmb-canvas-wrap");
      if (!cv || !stageEl || !wrapCol) return;
      var header = stageEl.querySelector(".dmb-stage-header");
      var bottom = stageEl.querySelector(".dmb-stage-bottombar");
      var cs = getComputedStyle(stageEl);
      var pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var gap = (parseFloat(cs.rowGap || cs.gap) || 0) * 2;
      var chrome = (header ? header.offsetHeight : 0) + (bottom ? bottom.offsetHeight : 0) + pad + gap + 10;
      var availH = (wrapCol.clientHeight || 0) - chrome;
      var availW = (wrapCol.clientWidth || 0) - 20;
      var needH = cv.offsetHeight, needW = cv.offsetWidth;   // offsetHeight includes the label margin
      if (availH < 80 || needH < 80) return;
      var fit = Math.min(1, availH / needH, (needW > 0 && availW > 0) ? availW / needW : 1);
      fit = Math.max(0.5, fit);
      if (Math.abs(fit - currentZoom) > 0.015) setCanvasZoom(fit);
    } catch (e) {}
  }

  // Collapse the spread viewport to the SCALED canvas size so a zoomed-out book
  // leaves no dead space below it. A MutationObserver re-applies this the moment
  // any render resets the viewport style (forceSpreadLayout for pages,
  // renderCoverCanvas for the cover set height:auto) — it runs before the browser
  // paints, so the gap never flashes when a photo is dropped.
  let _dmbVpCollapsing = false;
  let _dmbVpCollapsed = false;
  function _dmbCollapseSpreadVp() {
    // Use getElementById (not the `spreadViewport`/`spreadCanvas` consts, which
    // are declared later in this IIFE) so this is safe to reference from the
    // top-level observer setup below without a temporal-dead-zone error.
    const vp = document.getElementById("spreadViewport");
    const cv = document.getElementById("spreadCanvas");
    if (!vp || !cv) return;
    // Only collapse when zoomed OUT (<100%): transform:scale leaves a full-size
    // layout box (dead space below a shrunk book). At 100%+ there's none, so do
    // NOTHING and let the normal layout stand — forcing a fixed size there added
    // stray horizontal/vertical scroll bars (e.g. on the laptop).
    if (currentZoom >= 1) {
      if (_dmbVpCollapsed) {
        _dmbVpCollapsing = true;
        vp.style.width = "";
        vp.style.height = "";
        vp.style.boxSizing = "";
        vp.style.overflow = "";
        _dmbVpCollapsing = false;
        _dmbVpCollapsed = false;
      }
      return;
    }
    const w = cv.offsetWidth, h = cv.offsetHeight;
    if (!w || !h) return;
    const tw = Math.round(w * currentZoom) + "px";
    const th = Math.round(h * currentZoom) + "px";
    if (_dmbVpCollapsed && vp.style.width === tw && vp.style.height === th) return;
    _dmbVpCollapsing = true;
    vp.style.boxSizing = "content-box";   // width/height = the visible (scaled) canvas
    vp.style.overflow = "hidden";          // clip the dead space — no scroll bars
    vp.style.width = tw;
    vp.style.height = th;
    _dmbVpCollapsing = false;
    _dmbVpCollapsed = true;
    if (typeof syncPhotoTrayHeight === "function") syncPhotoTrayHeight();
  }
  (function _dmbInitVpObserver() {
    const vp = document.getElementById("spreadViewport");
    if (vp && "MutationObserver" in window) {
      new MutationObserver(() => { if (!_dmbVpCollapsing) _dmbCollapseSpreadVp(); })
        .observe(vp, { attributes: true, attributeFilter: ["style"] });
    }
  })();

  function openPagesMode() {
    builderMode = "pages";
    syncBuilderModeButtons();
    renderBuilderCanvas();
  }

  function saveProjectLocal() {
    saveProjectLocalWithMessage();
  }

  // Per-mode key for the transient "last session" project snapshot so book,
  // magazine and card sessions never overwrite each other's in-progress work.
  function _dmbProjKey() {
    return "dmb_saved_project_v1_" + (window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "mag" : "book");
  }

  function loadProjectLocal() {
    try {
      const raw = localStorage.getItem(_dmbProjKey());
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function initProjectMenu() {
    const btn = $("projectMenuBtn");
    if (!btn) return;
    btn.onclick = openProjectMenuPrompt;
  }

  function initHistoryButton() {
    const btn = $("historyBtn");
    if (!btn) return;
    btn.onclick = openHistoryPanel;
  }

  function initPhotoImportMenu() {
    // handled by the single delegated click + change listeners at the bottom
  }
  
  function initPhotoSearchSortControls() {
    const sort = $("photoSortSelect");
    const hide = $("hideUsedPhotosToggle");

    if (sort) {
      sort.addEventListener("change", () => {
        currentPhotoSort = sort.value || "earliest";
        renderPhotoTray();
      });
    }

    if (hide) {
      hide.addEventListener("change", () => {
        hideUsedPhotos = !!hide.checked;
        renderPhotoTray();
      });
    }
  }

  function refreshBuilderPhotos() {
    // Use the concurrency-capped, tiny-decode meta reader (_dmbWarmMeta) — NOT a
    // Promise.all over full-res getImageMetaFromFile, which decoded every photo at
    // full resolution at once and crashed phones on large uploads.
    // Time-box EVERY meta read and swallow rejections, so the library is rebuilt
    // and the tray repaints even when one photo's decode misbehaves. Before this,
    // a single unsettled promise meant editor.photos was never rebuilt: the newly
    // added photos silently never reached the tray, while the "N photos selected"
    // counter (which reads bookFiles) had already counted them. A photo whose
    // ratio could not be read is still added - it just starts at ratio 1.
    const _metaJobs = bookFiles.map((f) =>
      _dmbSettleWithin(_dmbWarmMeta(f), _DMB_META_TIMEOUT + 2000, { w: 1, h: 1, ratio: 1 }));
    Promise.all(_metaJobs).catch(() => bookFiles.map(() => ({ w: 1, h: 1, ratio: 1 }))).then((metas) => {
      // Preserve any derived crop photos (they aren't in bookFiles) so cropped placements
      // don't lose their bytes when the library is rebuilt after adding more photos.
      const _derivedKeep = (editor.photos || []).filter(_dmbIsCropDerived);
      // Carry per-photo state (R2-confirmed mark, cached thumb) across the rebuild
      // by pid — without this, every rebuild wiped _r2, which made the light-memory
      // release stop working after each "add more photos" batch.
      const _prevById = {};
      try { (editor.photos || []).forEach((p) => { if (p && p.id) _prevById[p.id] = p; }); } catch (e) {}
      // Print-master path in light-mem: a rebuild must NOT hand a fresh object URL
      // back to a photo that was released (off-spread + safely on R2) — that would
      // re-pin hundreds of blobs right after we freed them. Off-spread released
      // photos stay lazy (url "") and re-materialize on demand (recovery/render).
      const _keep = (_dmbPrintMasterOn() && _dmbLightMem()) ? _dmbCurrentSpreadPhotoIds() : null;
      editor.photos = bookFiles.map((f, i) => {
        // Prefer the id assigned at PICK time (f._dmbPid, set by the instant
        // R2 backup) so the builder, backups and restores all agree on one id
        // per photo and nothing is ever uploaded twice.
        const pid = f._dmbPid || editor.photos[i]?.id || uid();
        // Positional fallback ONLY when that entry really is this photo — the old
        // array's tail holds derived crops, which a new file must never inherit from.
        const prev = _prevById[pid] || ((editor.photos[i] && editor.photos[i].id === pid) ? editor.photos[i] : {});
        const lazy = !!(_keep && prev._r2 && !_keep.has(pid));
        return {
          id: pid,
          file: f,
          url: prev.url || (lazy ? "" : URL.createObjectURL(f)),
          ratio: metas[i]?.ratio ?? prev.ratio ?? 1,
          filename: String(f.name || "").toLowerCase(),
          dateTaken: metas[i]?.date || prev.dateTaken || "",
          tags: prev.tags || [],
          addedIndex: i,
          _r2: prev._r2 || false,
          thumbUrl: prev.thumbUrl || ""
        };
      }).concat(_derivedKeep);

      renderPhotoTray();

      if (editor.totalPages > 0 && editor.totalSpreads > 0) {
        renderThumbsRail();
        renderBuilderCanvas();
      }
    });
  }

  // True when a page already carries *designed* content from a template (or the
  // user): overlay objects (text, stickers, maps, shapes, icons), a chosen page
  // layout, or pre-placed frames. A bare photo slot does NOT count — that's just
  // an auto-fill the Magic step is free to redistribute. Used to decide whether
  // the Magic auto-fill should leave a page alone.
  function _dmbPageHasContent(p) {
    try {
      if (Array.isArray(editor.pageObjects?.[p]) && editor.pageObjects[p].length) return true;
      const fr = editor.pageFrames?.[p];
      if (fr && Object.keys(fr).length) return true;
      if (editor.pageTemplate?.[p]) return true;
    } catch (e) {}
    return false;
  }

  // Thorough "is this page occupied?" check for the Magic auto-fill — unlike
  // _dmbPageHasContent it ALSO detects hand-placed slot photos (A/B) and full-spread
  // photos, so Magic never overwrites a page the customer designed by hand.
  function _dmbPageOccupied(p) {
    try {
      const sl = editor.pageSlots?.[p];
      if (sl && (sl.A || sl.B)) return true;
      if (Array.isArray(editor.pageObjects?.[p]) && editor.pageObjects[p].length) return true;
      const fr = editor.pageFrames?.[p];
      if (fr && Object.values(fr).some((v) => v)) return true;
      if (editor.pageTemplate?.[p]) return true;
      const si = Math.floor((p - 1) / 2);
      if (p >= 1 && editor.spreadPhoto?.[si] && editor.spreadPhoto[si].photoId) return true;
      // Half of the facing page's object is on this page. Magic treats an unoccupied
      // page as free to fill, so without this it lays photo frames straight over the
      // far half of a shape or map that spans the spread.
      if (_dmbPartnerOverhang(p)) return true;
    } catch (e) {}
    return false;
  }

  // "Do the Magic" — a VARIED, magazine-style auto-layout that uses EVERY photo.
  //
  // The contract (owner, 2026-09-13): the customer picked a page count and
  // uploaded a set of photos; Magic must place ALL of them into those pages and
  // may NOT add pages. Not one photo is left over.
  //
  // That is why the work is split into "decide the budget" and then "place". The
  // old version walked pages one at a time and stopped at `p <= totalPages`,
  // silently abandoning whatever was still queued - so anyone with more photos
  // than pages simply lost the tail. Now every usable page is handed a QUOTA
  // whose total equals the number of photos, so completeness is arithmetic
  // rather than a hope.
  //
  // Layouts, chosen by how many photos a page has to carry:
  //   1 photo  → full-page portrait, a full-SPREAD landscape (only when there is
  //              genuine slack), or the whole photo housed in an aspect-matched
  //              centered frame so nothing is cropped
  //   2 photos → the two stacked page slots (A / B)
  //   3+       → a tidy grid of free photo-frames, last row centered
  // All of them use existing structures (pageSlots / spreadPhoto / free
  // photo-frames), so they save, restore and render in the PDF exactly like
  // hand placement.
  function smartCreateBook() {
    if (!editor.totalPages || !editor.photos.length) return;
    if (!editor.spreadPhoto) editor.spreadPhoto = {};   // spreads write editor.spreadPhoto[...]

    const dims = getPageDims();

    // Classify a photo by aspect ratio (w / h).
    const kind = (ph) => {
      const r = (ph && ph.ratio) || 1;
      if (r <= 0.92) return "portrait";
      if (r >= 2.0)  return "pano";
      if (r >= 1.2)  return "landscape";
      return "square";
    };

    // Tagged _magic so a re-run can tell its own frames from the customer's work.
    const _frame = (ph, pageNum, x, y, w, h, i) => ({
      id: uid(), type: "photo-frame", targetType: "page", page: pageNum, zone: null,
      x: Math.round(x), y: Math.round(y), w: Math.round(w), h: Math.round(h),
      z: Date.now() + (i || 0), photoId: ph.id, _magic: true,
    });

    // Cover inside an aspect-MATCHED frame shows the whole photo (no crop).
    // ── Fit: how much of a photo actually survives in a box ───────────────────
    // Photos are drawn object-fit:cover, so a cell that does not match the photo's
    // shape CROPS the overflow. The visible fraction is min(pa,ca)/max(pa,ca) -
    // 1.0 when the aspects match, falling away as they diverge. Every layout
    // decision below maximises it: the owner's rule is "pick the layout from the
    // picture's dimensions, keep the maximum of the picture showing".
    const _fit = (a, b) => (a > 0 && b > 0) ? Math.min(a, b) / Math.max(a, b) : 0;
    const PAGE_A   = dims.w / dims.h;                  // a single page
    const SPREAD_A = (dims.w * 2) / dims.h;            // both pages of a spread
    const GM = Math.round(dims.w * 0.055);             // ~5mm safe margin
    const GG = Math.max(4, Math.round(dims.w * 0.025));// gutter
    const cellOf = (cols, rows) => ({
      cw: (dims.w - 2 * GM - (cols - 1) * GG) / cols,
      ch: (dims.h - 2 * GM - (rows - 1) * GG) / rows,
    });

    // Shrink a frame to the photo's OWN aspect inside its cell, centered, so the
    // whole picture shows. Skipped when the cell already matches within 10%,
    // where filling it edge to edge looks better than a letterboxed gap.
    const fitBox = (pa, x, y, w, h) => {
      const ca = w / h;
      if (_fit(pa, ca) >= 0.9) return { x: x, y: y, w: w, h: h };
      let fw, fh;
      if (pa > ca) { fw = w; fh = w / pa; } else { fh = h; fw = h * pa; }
      return { x: x + (w - fw) / 2, y: y + (h - fh) / 2, w: fw, h: fh };
    };

    // Choose the grid whose CELLS best match the photos that will sit in them.
    // Two landscapes want one column of two rows; two tall portraits want two
    // columns of one row. Guessing from the page's orientation alone (what this
    // used to do) got both of those wrong.
    const bestGrid = (list) => {
      const n = list.length;
      let best = null;
      for (let cols = 1; cols <= n; cols++) {
        const rows = Math.ceil(n / cols);
        if (cols * rows - n >= cols) continue;           // would leave a whole row empty
        const c = cellOf(cols, rows), ca = c.cw / c.ch;
        let score = 0;
        list.forEach((ph) => { score += _fit((ph && ph.ratio) || 1, ca); });
        score = score / n - Math.abs(cols - rows) * 0.02;   // nudge towards balance
        if (!best || score > best.score) best = { cols: cols, rows: rows, score: score };
      }
      return best || { cols: 1, rows: n };
    };

    // The whole photo, housed in a frame cut to its own aspect, centered.
    const centeredFrame = (ph, pageNum) => {
      const r = (ph && ph.ratio) || 1;
      const maxW = dims.w * 0.82, maxH = dims.h * 0.82;
      let fw, fh;
      if (r >= (maxW / maxH)) { fw = maxW; fh = maxW / r; }
      else                    { fh = maxH; fw = maxH * r; }
      return _frame(ph, pageNum, (dims.w - fw) / 2, (dims.h - fh) / 2, fw, fh, 0);
    };

    // Grid for a page carrying 2+, shaped by bestGrid and fitted per cell. A short
    // last row is centered so an odd count doesn't leave a corner hole.
    const gridFrames = (list, pageNum) => {
      const n = list.length;
      const g = bestGrid(list);
      const c = cellOf(g.cols, g.rows);
      return list.map((ph, k) => {
        const r = Math.floor(k / g.cols);
        const inRow = Math.min(g.cols, n - r * g.cols);
        const col = k - r * g.cols;
        const rowW = inRow * c.cw + (inRow - 1) * GG;
        const b = fitBox((ph && ph.ratio) || 1,
          (dims.w - rowW) / 2 + col * (c.cw + GG), GM + r * (c.ch + GG), c.cw, c.ch);
        return _frame(ph, pageNum, b.x, b.y, b.w, b.h, k);
      });
    };

    // Magazine "hero": one photo across the top, the rest in a strip beneath it.
    const heroFrames = (list, pageNum) => {
      const innerW = dims.w - 2 * GM, innerH = dims.h - 2 * GM;
      const heroH = Math.round(innerH * 0.6);
      const rest = list.slice(1), c = rest.length;
      const cw = (innerW - (c - 1) * GG) / c, ch = innerH - heroH - GG;
      const hb = fitBox((list[0] && list[0].ratio) || 1, GM, GM, innerW, heroH);
      const out = [_frame(list[0], pageNum, hb.x, hb.y, hb.w, hb.h, 0)];
      rest.forEach((ph, k) => {
        const b = fitBox((ph && ph.ratio) || 1, GM + k * (cw + GG), GM + heroH + GG, cw, ch);
        out.push(_frame(ph, pageNum, b.x, b.y, b.w, b.h, k + 1));
      });
      return out;
    };

    // ── Capture-time ordering ─────────────────────────────────────────────────
    // A sortable timestamp per photo so the book reads in the order the pictures
    // were taken. Best source first: EXIF/restored dateTaken → a date encoded in
    // the filename (IMG_20230604_153012, PXL_…, Screenshot_…) → the file's modified
    // time → upload order as a stable last resort.
    const _ts = (ph) => {
      if (!ph) return 0;
      try {
        if (ph.dateTaken) { const d = Date.parse(ph.dateTaken); if (!isNaN(d)) return d; }
      } catch (e) {}
      try {
        const m = String(ph.filename || "").match(
          /(20\d{2})[-_.]?(0[1-9]|1[0-2])[-_.]?(0[1-9]|[12]\d|3[01])(?:[-_.T ]?([01]\d|2[0-3])[-_.:]?([0-5]\d)[-_.:]?([0-5]\d)?)?/);
        if (m) { const d = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)); if (!isNaN(d)) return d; }
      } catch (e) {}
      try { if (ph.file && ph.file.lastModified) return ph.file.lastModified; } catch (e) {}
      return 1e12 + (ph.addedIndex || 0);
    };
    const _sortQueue = (q) => q.sort((a, b) => (_ts(a) - _ts(b)) || ((a.addedIndex || 0) - (b.addedIndex || 0)));

    // ── Moment grouping ───────────────────────────────────────────────────────
    // Split the chronological queue into exactly `nPages` contiguous chunks that
    // sum to every photo (each page ≥ 1 when there are at least as many photos as
    // pages). Chunk boundaries start evenly spaced (balanced page density), then
    // each is nudged up to ±2 photos to fall on the LARGEST nearby time gap — so a
    // page breaks between two separate moments rather than mid-burst. No absolute
    // threshold, so it adapts to any shoot.
    const _momentChunks = (tsArr, nPages) => {
      const N = tsArr.length, sizes = new Array(Math.max(0, nPages)).fill(0);
      if (nPages <= 0) return sizes;
      if (N <= nPages) { for (let i = 0; i < N; i++) sizes[i] = 1; return sizes; }
      const gap = (i) => (i > 0 && i < N) ? Math.max(0, tsArr[i] - tsArr[i - 1]) : -1;
      const bnd = []; for (let k = 0; k <= nPages; k++) bnd.push(Math.round(k * N / nPages));
      const W = 2;
      for (let k = 1; k < nPages; k++) {
        const lo = Math.max(bnd[k - 1] + 1, bnd[k] - W);
        const hi = Math.min(Math.round((k + 1) * N / nPages) - 1, bnd[k] + W);
        let bi = bnd[k], bg = gap(bnd[k]);
        for (let i = lo; i <= hi; i++) { const g = gap(i); if (g > bg) { bg = g; bi = i; } }
        bnd[k] = bi;
      }
      for (let k = 1; k < nPages; k++) {
        if (bnd[k] <= bnd[k - 1]) bnd[k] = bnd[k - 1] + 1;
        if (bnd[k] > N - (nPages - k)) bnd[k] = N - (nPages - k);   // leave ≥1 for the pages after
      }
      bnd[nPages] = N;
      for (let k = 0; k < nPages; k++) sizes[k] = Math.max(0, bnd[k + 1] - bnd[k]);
      return sizes;
    };

    // ── Designed-layout selection (orientation-aware + varied) ─────────────────
    // Curated pools of hand-designed TEMPLATE_DEFS layouts per photo count (the
    // sparse/tiny-floating ones are left out so no page looks empty). For a page's
    // photos we score each candidate by how well its SLOTS' shapes match the
    // photos' shapes (object-fit:cover crops the mismatch), avoid repeating the
    // previous layout, and add a little jitter — so landscapes land in wide slots,
    // portraits in tall slots, and the sequence never looks mechanical.
    const _MAGIC_TPL = {
      1: ["t2", "t24", "t5", "t35"],
      2: ["t34", "t19", "t31", "t30", "t28", "t32", "t33", "t8"],
      3: ["t22", "t4", "t9", "t27", "t1", "t11", "t29"],
      4: ["t23", "t18", "t15", "t6", "t14"],
      5: ["t16", "t17", "t20", "t21"],
      7: ["t25", "t26"],
      9: ["t7"],
    };
    const _slotAR = (s) => (s && s.w > 0 && s.h > 0) ? (s.w / s.h) * PAGE_A : PAGE_A;
    const _assign = (slots, photos) => {
      const ar = slots.map(_slotAR);
      // Fill the most extreme-shaped slots first so a lone landscape isn't stolen by
      // a near-square slot before the wide slot gets its turn.
      const order = slots.map((_, i) => i)
        .sort((a, b) => Math.abs(Math.log(ar[b])) - Math.abs(Math.log(ar[a])));
      const used = new Array(photos.length).fill(false);
      const asn = new Array(slots.length).fill(-1);
      let total = 0;
      order.forEach((si) => {
        let bi = -1, bs = -1;
        photos.forEach((ph, pi) => {
          if (used[pi]) return;
          const sc = _fit((ph && ph.ratio) || 1, ar[si]);
          if (sc > bs) { bs = sc; bi = pi; }
        });
        if (bi >= 0) { asn[si] = bi; used[bi] = true; total += bs; }
      });
      return { asn: asn, score: photos.length ? total / photos.length : 0 };
    };
    const _pickTpl = (photos, lastTid) => {
      const pool = _MAGIC_TPL[photos.length];
      if (!pool) return null;
      let best = null;
      pool.forEach((tid) => {
        const slots = TEMPLATE_DEFS[tid];
        if (!slots || slots.length !== photos.length) return;
        const a = _assign(slots, photos);
        let sc = a.score + Math.random() * 0.08;
        if (tid === lastTid) sc -= 0.18;              // don't repeat the last layout
        if (!best || sc > best.sc) best = { tid: tid, asn: a.asn, sc: sc, raw: a.score };
      });
      return best;
    };
    const _tplFrames = (tid, asn, photos, pageNum) => {
      const slots = TEMPLATE_DEFS[tid] || [];
      const out = [];
      slots.forEach((s, si) => {
        const pi = asn[si];
        if (pi == null || pi < 0) return;
        const ph = photos[pi];
        if (!ph) return;
        let x = s.x / 100 * dims.w, y = s.y / 100 * dims.h, w = s.w / 100 * dims.w, h = s.h / 100 * dims.h;
        // A photo that doesn't suit its slot shape is INSET (shown whole, centred)
        // rather than cropped — the slot still anchors the designed composition.
        const pr = (ph && ph.ratio) || 1;
        if (_fit(pr, w / h) < 0.72) { const b = fitBox(pr, x, y, w, h); x = b.x; y = b.y; w = b.w; h = b.h; }
        out.push(_frame(ph, pageNum, x, y, w, h, si));
      });
      return out;
    };

    // ── "Is this page exactly as Magic left it?" ──────────────────────────────
    // A signature of everything on the page, recorded in editor.magicPages after
    // each run. On a re-run a page whose signature still matches is one Magic laid
    // out and the customer has NOT touched, so it may be re-flowed. Any move,
    // resize, rotation, photo swap, deletion or added sticker changes the
    // signature, and the page becomes the customer's - permanently off limits.
    const _pageSig = (p) => {
      const sl = editor.pageSlots[p] || {};
      const rt = editor.pageRot[p] || {};
      const si = Math.floor((p - 1) / 2);
      const sp = (p >= 1 && editor.spreadPhoto) ? editor.spreadPhoto[si] : null;
      const objs = (editor.pageObjects[p] || [])
        .map((o) => [o.type, o.photoId || "", o.x, o.y, o.w, o.h].join(":")).join("|");
      return [sl.A || "", sl.B || "", rt.A || 0, rt.B || 0, objs,
        sp ? [sp.photoId, sp.panX, sp.panY, sp.zoom].join(":") : ""].join("~");
    };
    const _magicOwned = (p) => {
      const rec = editor.magicPages && editor.magicPages[p];
      if (!rec) return false;
      if (editor.pageTemplate && editor.pageTemplate[p]) return false;   // customer's layout
      const fr = editor.pageFrames && editor.pageFrames[p];
      if (fr && Object.values(fr).some((v) => v)) return false;
      return rec === _pageSig(p);
    };

    // ── What to place ─────────────────────────────────────────────────────────
    // Photos not used anywhere yet. ignoreSearch/ignoreUsedFilter: the tray's
    // search box and "Hide used" toggle are a VIEW, and must never shrink the set
    // of photos that goes into the book. Magic does its own used-check here.
    const _unplaced = () => {
      const used = (function () { try { return getUsedPhotoIds(); } catch (e) { return new Set(); } })();
      return applyPhotoFilters(editor.photos, { ignoreSearch: true, ignoreUsedFilter: true })
        .filter((ph) => ph && !used.has(ph.id));
    };
    let queue = _sortQueue(_unplaced());   // chronological: the book reads as it was shot
    if (!queue.length) return;   // nothing new to place - never reshuffle for no reason

    pushUndoState("Smart Creation");

    // ── 1. Fill layouts the customer chose but left empty ─────────────────────
    // A "Choose layout" page counts as occupied, so the page loop below skips it -
    // but its empty frames are slots the customer deliberately made, and leaving
    // them blank while photos go unplaced defeats the point of the button.
    for (let p = 0; p <= editor.totalPages && queue.length; p++) {
      if (isLockedPage(p)) continue;
      const tid = getPageTemplateId(p);
      if (!tid) continue;
      const defs = (typeof TEMPLATE_DEFS !== "undefined" && TEMPLATE_DEFS[tid]) || [];
      if (!defs.length) continue;
      if (!editor.pageFrames[p]) editor.pageFrames[p] = {};
      defs.forEach((d) => {
        if (!queue.length || !d || !d.key) return;
        if (editor.pageFrames[p][d.key]) return;          // already filled - leave it alone
        editor.pageFrames[p][d.key] = queue.shift().id;
      });
    }

    // ── 2. Reclaim the pages Magic itself laid out ────────────────────────────
    // Without this, a customer who runs Magic, uploads more photos and runs it
    // again is told there are no empty pages - and those photos never land, which
    // breaks the whole "every photo is used" promise in the most ordinary
    // workflow there is. Magic's own UNTOUCHED pages are fair game: their photos
    // go back in the queue and the book is re-flowed evenly around the new ones.
    // Anything the customer made, or edited even slightly, is never reclaimed.
    const owned = [];
    for (let p = 0; p <= editor.totalPages; p++) {
      if (!isLockedPage(p) && _magicOwned(p)) owned.push(p);
    }
    if (owned.length) {
      owned.forEach((p) => {
        if (editor.pageSlots[p]) { editor.pageSlots[p].A = null; editor.pageSlots[p].B = null; }
        if (Array.isArray(editor.pageObjects[p])) {
          editor.pageObjects[p] = editor.pageObjects[p].filter((o) => !(o && o._magic));
        }
        const si = Math.floor((p - 1) / 2);
        if (p >= 1 && editor.spreadPhoto && editor.spreadPhoto[si] && editor.spreadPhoto[si]._magic) {
          delete editor.spreadPhoto[si];
        }
        if (editor.magicPages) delete editor.magicPages[p];
      });
      queue = _sortQueue(_unplaced());   // the reclaimed photos count as unplaced again
    }

    // ── 3. Where the rest can go ──────────────────────────────────────────────
    const pages = [];
    for (let p = 0; p <= editor.totalPages; p++) {
      if (isLockedPage(p)) continue;          // books: page 1 is fixed. Magazines have none.
      if (_dmbPageOccupied(p)) continue;
      pages.push(p);
    }

    // Record what Magic leaves behind, so the next run can tell its own work from
    // the customer's, then repaint.
    const _finish = () => {
      editor.magicPages = editor.magicPages || {};
      pages.forEach((p) => { if (_dmbPageOccupied(p)) editor.magicPages[p] = _pageSig(p); });
      builderMode = "pages";
      renderPhotoTray();
      renderThumbsRail();
      renderBuilderCanvas();
    };

    if (!queue.length) { _finish(); return; }     // the layouts took everything
    if (!pages.length) {
      // Say so rather than doing nothing - a button that appears to ignore you is
      // worse than a refusal that explains itself.
      try {
        showChoiceDialog(
          "No empty pages left",
          "Every page already has something on it, so there is nowhere to put your remaining " +
          queue.length + " photo" + (queue.length > 1 ? "s" : "") +
          ". Clear a page or choose more pages, then try again.",
          [{ id: "ok", label: "OK" }]
        );
      } catch (e) {}
      _finish();
      return;
    }

    // ── Spreads, planned UP FRONT ─────────────────────────────────────────────
    // A full-bleed spread spends TWO pages on ONE photo. The previous version
    // could only afford one when a neighbouring page happened to have no photos
    // of its own, so a book with at least as many photos as pages got NONE.
    // Planning them before the quotas fixes that without weakening the
    // guarantee: the pages a spread claims leave the pool, and the photos that
    // remain are distributed over what is left - the rest just runs a touch denser.
    const P = pages.length;
    const spreadEvenly = (count, total) => {
      const out = new Array(total).fill(0);
      if (count <= 0 || total <= 0) return out;
      for (let k = 0; k < total; k++) {
        if (Math.floor((k + 1) * count / total) > Math.floor(k * count / total)) out[k] = 1;
      }
      return out;
    };
    const isWide = (ph) => { const t = kind(ph); return t === "landscape" || t === "pano"; };

    // A spread needs the LEFT page of a physical spread and its neighbour, both
    // free. Pages pair up as (1,2), (3,4), ...
    const candidates = [];
    for (let k = 0; k + 1 < P; k++) {
      if (pages[k] >= 1 && pages[k] % 2 === 1 && pages[k + 1] === pages[k] + 1) candidates.push(k);
    }
    let wantSpreads = Math.min(
      Math.floor(P / 8),                  // roughly one spread every 8 pages
      queue.filter(isWide).length,        // each one needs a wide photo
      candidates.length,
      Math.max(0, (P - 1) >> 1),          // always leave an ordinary page behind
      Math.max(0, queue.length - 1)       // and at least one photo for the rest
    );
    // Don't spend two pages on one photo when the book is already packed: past
    // roughly three photos a page a spread reads as a mistake, not a flourish.
    if (queue.length > P * 3) wantSpreads = 0;

    const spreadAt = new Set();
    if (wantSpreads > 0) {
      const stride = P / wantSpreads;
      let next = stride / 2, lastK = -2;
      for (const k of candidates) {
        if (spreadAt.size >= wantSpreads) break;
        if (k <= lastK + 1) continue;          // never overlap the previous spread
        if (k < next - 0.5) continue;          // keep them evenly spaced
        spreadAt.add(k); lastK = k; next += stride;
      }
    }
    // Reserve a wide photo per spread NOW, so the ordinary pages cannot eat them
    // before the loop reaches the spread slots.
    const spreadPool = [];
    spreadAt.forEach(() => {
      // Take the photo whose shape best matches the DOUBLE-page box, not merely
      // the first wide one: across a 1.41 spread a 1.5 landscape loses almost
      // nothing, while a 2.4 panorama loses about 40% of its width.
      let bi = -1, bs = -1;
      queue.forEach((ph, idx) => {
        if (!isWide(ph)) return;
        const sc = _fit((ph && ph.ratio) || 1, SPREAD_A);
        if (sc > bs) { bs = sc; bi = idx; }
      });
      if (bi >= 0) spreadPool.push(queue.splice(bi, 1)[0]);
    });
    while (spreadPool.length < spreadAt.size) spreadAt.delete(Array.from(spreadAt).pop());

    // ── Quotas for every page that is NOT part of a spread ────────────────────
    // Each gets `base`, and `extra` of them get one more, so the quotas sum to
    // EXACTLY the photos left after the spreads took theirs. More photos than
    // pages just means denser pages - never a dropped photo.
    //
    // The extras are spread EVENLY through the book (Bresenham), not handed to
    // the first `extra` pages. Front-loading produced a visible density step -
    // "2 2 2 2 2 2 1 1 1 ..." - and, with fewer photos than pages, packed them
    // all into the front and left the whole back half blank.
    const normalIdx = [];
    for (let k = 0; k < P; k++) {
      if (spreadAt.has(k)) { k += 1; continue; }   // the partner page goes with it
      normalIdx.push(k);
    }
    const quota = new Array(P).fill(0);
    if (normalIdx.length) {
      // Moment-aware: contiguous chronological chunks, balanced but broken on the
      // big time gaps, summing to exactly the photos left (each page ≥ 1 when there
      // are at least as many photos as pages — so no page is left empty).
      const chunks = _momentChunks(queue.map(_ts), normalIdx.length);
      normalIdx.forEach((k, j) => { quota[k] = chunks[j] || 0; });
    }

    const _ensurePage = (pp) => {
      if (!editor.pageSlots[pp]) editor.pageSlots[pp] = { A: null, B: null };
      if (!editor.pageRot[pp])   editor.pageRot[pp]   = { A: 0, B: 0 };
      if (!Array.isArray(editor.pageObjects[pp])) editor.pageObjects[pp] = [];
    };

    let variety = 0;
    let _lastTid = null;   // last designed layout used, so we never repeat back-to-back
    for (let k = 0; k < P; k++) {
      const p = pages[k];

      if (spreadAt.has(k)) {
        const ph = spreadPool.shift();
        if (ph) {
          _ensurePage(p); _ensurePage(pages[k + 1]);
          editor.spreadPhoto[(p - 1) / 2] =
            { photoId: ph.id, panX: 0, panY: 0, zoom: 1, _magic: true };
        }
        k += 1;                                  // the partner page is consumed
        continue;
      }

      const q = quota[k];
      if (q <= 0 || !queue.length) continue;
      _ensurePage(p);

      if (q >= 2) {
        // Prefer a hand-designed layout whose slot shapes match THESE photos
        // (orientation-aware, varied, never the same as the previous page). Counts
        // with no designed template (6, 8) fall back to the aspect-matched grid.
        const take = queue.splice(0, Math.min(q, queue.length));
        const pick = _pickTpl(take, _lastTid);
        // Use a designed layout when its slots genuinely suit these photos; otherwise
        // the aspect-matched grid (which can make wide or tall cells to fit the shots
        // and shows each photo whole) carries the page.
        if (pick && pick.raw >= 0.72) {
          _lastTid = pick.tid;
          _tplFrames(pick.tid, pick.asn, take, p).forEach((f) => editor.pageObjects[p].push(f));
        } else {
          const useHero = (variety % 3 === 2) && take.length >= 3 && take.length <= 4 && isWide(take[0]);
          (useHero ? heroFrames(take, p) : gridFrames(take, p)).forEach((f) => editor.pageObjects[p].push(f));
        }
        variety += 1;
        continue;
      }

      // q === 1 - one photo owning the page. Fill it edge to edge when the photo is
      // close to the page's own shape (at most ~15% lost); otherwise house the WHOLE
      // picture in a frame cut to its own aspect, centred - never crop a lone photo.
      const only = queue.shift();
      if (_fit((only && only.ratio) || 1, PAGE_A) >= 0.85) editor.pageSlots[p].A = only.id;
      else editor.pageObjects[p].push(centeredFrame(only, p));
      variety += 1;
    }

    // A reserved spread photo that never found its slot goes back in the queue so
    // the backstop below can still place it - nothing is allowed to fall out here.
    if (spreadPool.length) { spreadPool.splice(0).forEach((ph) => queue.push(ph)); }

    // ── Backstop ──────────────────────────────────────────────────────────────
    // The quotas already sum to the queue length, so this should never run. It
    // exists so "not a single photo is left behind" holds even if a future edit
    // breaks that arithmetic: re-grid the last page from scratch with everything
    // it holds plus the strays, which cannot overlap because the grid is rebuilt.
    if (queue.length) {
      const p = pages[pages.length - 1];
      _ensurePage(p);
      const ids = [];
      if (editor.pageSlots[p].A) { ids.push(editor.pageSlots[p].A); editor.pageSlots[p].A = null; }
      if (editor.pageSlots[p].B) { ids.push(editor.pageSlots[p].B); editor.pageSlots[p].B = null; }
      (editor.pageObjects[p] || []).forEach((o) => {
        if (o && o._magic && o.type === "photo-frame" && o.photoId) ids.push(o.photoId);
      });
      editor.pageObjects[p] = (editor.pageObjects[p] || [])
        .filter((o) => !(o && o._magic && o.type === "photo-frame"));
      const all = ids.map((id) => { try { return getPhotoById(id); } catch (e) { return null; } })
        .filter(Boolean).concat(queue.splice(0));
      gridFrames(all, p).forEach((f) => editor.pageObjects[p].push(f));
    }

    _finish();
  }

  function getCurrentBuilderStateSnapshot() {
    return {
      book_title: getEffectiveBookTitle(),
      pages_selected: Number(pagesEl?.value || 0),
      coverState: cloneState(coverState),
      editor: cloneState(editor),
      builderMode,
      currentPhotoSort,
      currentPhotoSearch,
      hideUsedPhotos,
      // The customer's recent-colours palette rides with the design so it appears on
      // their other devices too (it's otherwise localStorage-only = per device).
      recentColors: dmbGetRecentColors()
    };
  }

  // Apply a SAVED design snapshot onto the live editor/coverState. EXTRACTED from the
  // ?restore=1 Phase-3 block so Step-2 render mode reconstructs state through the EXACT
  // same code - there is no second implementation to drift. Photos must already be in
  // editor.photos (cover URLs are rehydrated from their ids at the end).
  function _dmbApplySavedEditorState(_saved) {
    const _cl = (v) => { try { return JSON.parse(JSON.stringify(v || {})); } catch (e) { return {}; } };
    const _se = (_saved && _saved.editor) || {};
    const _pg = _se.totalPages || Number(_saved && _saved.pages_selected) || 0;
    editor.totalPages     = _pg;
    editor.editablePages  = _se.editablePages  || Math.max(0, _pg - 1);
    editor.totalSpreads   = _se.totalSpreads   || Math.max(1, Math.ceil(_pg / 2));
    // Restore WHERE THEY WERE. This was hardcoded to 0, so every refresh landed on
    // spread 0 (pages 1 and 2) no matter which spread was open. Page 0 is stored as -1,
    // which is why that case looked like its own bug: it is the same bug, just the most
    // visible instance of it. Clamped to the book's real range, because a saved index
    // can outlive a page-count reduction and an out-of-range index renders nothing.
    // (2026-10-12)
    var _sp = Number(_se.currentSpread);
    if (!isFinite(_sp)) _sp = 0;
    var _maxSp = Math.max(0, (editor.totalSpreads || 1) - 1);
    editor.currentSpread  = Math.max(-1, Math.min(_sp, _maxSp));
    editor.pageSlots      = _cl(_se.pageSlots);
    editor.pageRot        = _cl(_se.pageRot);
    editor.pageTemplate   = _cl(_se.pageTemplate);
    editor.pageFrames     = _cl(_se.pageFrames);
    editor.pageFrameRot   = _cl(_se.pageFrameRot);
    editor.pageFrameShapes= _cl(_se.pageFrameShapes);
    editor.pageObjects    = _cl(_se.pageObjects);
    editor.pageBackgrounds= _cl(_se.pageBackgrounds);
    editor.magicPages     = _cl(_se.magicPages);
    editor.spreadPhoto    = _cl(_se.spreadPhoto);
    editor.extraSpreads   = _se.extraSpreads || 0;
    editor.orientation    = (_se.orientation === "landscape" ? "landscape" : "portrait");
    editor.coverObjects   = Array.isArray(_se.coverObjects)   ? _cl(_se.coverObjects)   : [];
    editor.coverUserTexts = Array.isArray(_se.coverUserTexts) ? _cl(_se.coverUserTexts) : [];
    editor.cropRects      = _cl(_se.cropRects || {});   // crop ratios for derived photos
    if (!Array.isArray(editor.coverObjects)) try { migrateCoverObjectsToFlat(); } catch (e) {}
    if (_saved && _saved.coverState) {
      const _cs = _saved.coverState;
      ["frontImageUrl", "backImageUrl", "bleedImageUrl", "spineImageUrl", "imageUrl"].forEach((k) => {
        if (_cs[k] && String(_cs[k]).startsWith("blob:")) {
          _cs[k] = "";
          // A dead blob: URL means the URL is gone, NOT that the photo is gone.
          // EVERY photo URL in the builder is createObjectURL(), so every wrap
          // image looks exactly like this after a reload - this branch is the
          // normal case, not an edge case.
          //
          // The front and back faces keep their ids here and
          // _dmbRehydrateCoverPhotoUrls() (a few lines below) rebuilds their URLs
          // from those ids. The wrap used to have its id AND its zone deleted
          // instead, so the rehydrate had nothing left to work with and the
          // wrap-around background was DESTROYED on restore - then autosaved in
          // its stripped form. The printed book came out with a white front and
          // spine while the back kept its own face photo. Verified 2026-09-12.
          //
          // Keep the id. Only drop the zone when there is no id to recover from,
          // so a legacy design cannot leave a zone pointing at nothing.
          if (k === "bleedImageUrl" && !_cs.bleedImageId) { _cs.bleedZone = ""; }
        }
      });
      Object.keys(_cs).forEach((k) => { try { coverState[k] = _cs[k]; } catch (e) {} });
    }
    builderMode = (_saved && _saved.builderMode) || "pages";
    // Rebuild cover face/bleed URLs from their preserved photo ids (the blob: URLs were
    // cleared above). No-op for lazy records: url stays "" and the photo is drawn by id.
    try { _dmbRehydrateCoverPhotoUrls(); } catch (e) {}
    return _pg;
  }

  function applyBuilderStateSnapshot(snapshot) {
    if (!snapshot) return;

    _dmbApplyRecentColors(snapshot);   // bring across the saved colour palette

    if (pagesEl && snapshot.pages_selected) {
      pagesEl.value = String(snapshot.pages_selected);
      updatePrice();
      refreshPhotoRule();
    }

    if (snapshot.coverState) {
      const cs = snapshot.coverState;
      coverState.template      = cs.template      || "default";
      coverState.title1        = cs.title1        || "";
      coverState.title2        = cs.title2        || "";
      coverState.color         = cs.color         || "#ffffff";
      coverState.imageUrl      = cs.imageUrl      || "";
      coverState.imageFile     = cs.imageFile     || null;
      coverState.frontLayout   = cs.frontLayout   || null;
      coverState.backLayout    = cs.backLayout    || null;
      coverState.frontFrames   = cloneState(cs.frontFrames   || {});
      coverState.backFrames    = cloneState(cs.backFrames    || {});
      coverState.frontFrameRot = cloneState(cs.frontFrameRot || {});
      coverState.backFrameRot  = cloneState(cs.backFrameRot  || {});
      coverState.frontFrameShapes = cloneState(cs.frontFrameShapes || {});
      coverState.backFrameShapes  = cloneState(cs.backFrameShapes  || {});
      coverState.bleedImageUrl = cs.bleedImageUrl || "";
      coverState.bleedImageId  = cs.bleedImageId  || "";
      coverState.bleedZone     = cs.bleedZone     || "";
      coverState.bleedImageRot = cs.bleedImageRot || 0;
      coverState.spineImageUrl = cs.spineImageUrl || "";
      if (cs.textStyles) coverState.textStyles = cloneState(cs.textStyles);
      syncCoverInputsFromState();
    }

    if (snapshot.editor) {
      const se = snapshot.editor;
      editor.totalPages    = se.totalPages    || 0;
      editor.editablePages = se.editablePages || 0;
      editor.totalSpreads  = se.totalSpreads  || Math.ceil((se.totalPages || 0) / 2);
      editor.currentSpread = se.currentSpread || 0;
      editor.pageSlots     = cloneState(se.pageSlots     || {});
      editor.pageRot       = cloneState(se.pageRot       || {});
      editor.pageTemplate  = cloneState(se.pageTemplate  || {});
      editor.pageFrames    = cloneState(se.pageFrames    || {});
      editor.pageFrameRot  = cloneState(se.pageFrameRot  || {});
      editor.pageFrameShapes = cloneState(se.pageFrameShapes || {});
      editor.pageObjects      = cloneState(se.pageObjects      || {});
      editor.pageBackgrounds  = cloneState(se.pageBackgrounds  || {});
      editor.magicPages       = cloneState(se.magicPages       || {});
      editor.spreadPhoto      = cloneState(se.spreadPhoto      || {});
      editor.coverObjects     = cloneState(se.coverObjects     || []);
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      editor.coverUserTexts = cloneState(se.coverUserTexts || []);
      // Crop geometry (0–1 ratios per derived crop id) — lets the server render /
      // another device re-bake crops from the print master. See editor.cropRects.
      editor.cropRects = cloneState(se.cropRects || {});
      // Restore extra spreads so price display and spread adder stay in sync
      editor.extraSpreads = se.extraSpreads || 0;
      // Restore the chosen book size (A4/A5) so price + variant follow the design
      editor.bookSize = (se.bookSize === "A5" ? "A5" : "A4");
      // Restore orientation so a landscape design reopens landscape
      editor.orientation = (se.orientation === "landscape" ? "landscape" : "portrait");
    }

    builderMode = snapshot.builderMode || "pages";
    currentPhotoSort = snapshot.currentPhotoSort || "earliest";
    currentPhotoSearch = snapshot.currentPhotoSearch || "";
    hideUsedPhotos = !!snapshot.hideUsedPhotos;

    if (photoSortSelect) photoSortSelect.value = currentPhotoSort;
    if (hideUsedPhotosToggle) hideUsedPhotosToggle.checked = hideUsedPhotos;

    updatePrice();          // re-display price including any restored extraSpreads
    try { _dmbSyncSizeToggleUI(); } catch (e) {}   // reflect restored A4/A5 choice
    try { _dmbSyncOrientationToggleUI(); } catch (e) {}   // reflect restored orientation
    _syncSpreadAdderUI();   // re-sync spread adder counter + visibility
    updateCoverPreview();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
    // Full state restore — every page changed; clear and re-render preview cache
    try { _dmbPvReinitAll(); } catch(e) {}
  }

  const editor = {
    totalPages: 0,
    editablePages: 0,
    totalSpreads: 0,
    currentSpread: 0,
    extraSpreads: 0,      // count of extra spreads added by customer (each = 2 pages, +$1.99)
    bookSize: "A4",       // "A4" (default) or "A5" — chosen via the top-bar toggle (book only)
    orientation: "portrait", // "portrait" (default) or "landscape" — top-bar toggle
    pageSlots: {},
    pageRot: {},
    pageTemplate: {},
    pageFrames: {},
    pageFrameRot: {},
    pageObjects: {},
    pageBackgrounds: {},  // { [pageNumber]: "#rrggbb" } — per-page background color
    magicPages: {},       // { [pageNumber]: signature } — pages "Do the Magic" laid out
                          // and the customer has not touched since. See _pageSig.
    coverObjects: [],
    coverUserTexts: [],   // [{id, zone}] — user-added text nodes on the cover
    photos: [],
    // { [derivedCropId]: { srcPid, x, y, w, h } } — crop geometry as 0–1 ratios of
    // the SOURCE image, recorded by applyCrop. Lets any resolution of the source
    // (proxy locally, print master on the server) reproduce the exact same crop,
    // and lets a restore on another device re-bake derived photos it never held.
    cropRects: {}
  };

  // ── Orientation (Portrait default / Landscape) ─────────────────────────────
  // SINGLE SOURCE OF TRUTH for page dimensions, so the toggle flips the whole
  // book (canvas, thumbnails, PDF, object bounds) from one place. In PORTRAIT
  // these return exactly the historical numbers (270 × 382), so portrait
  // behaviour is byte-for-byte unchanged — landscape just swaps the two axes.
  var DMB_PAGE_SHORT_PX = 270;
  var DMB_PAGE_LONG_PX  = Math.round(270 * 1.414);   // 382
  function dmbIsLandscape() { return !!(editor && editor.orientation === "landscape"); }
  function getPageDims() {
    return dmbIsLandscape()
      ? { w: DMB_PAGE_LONG_PX,  h: DMB_PAGE_SHORT_PX }   // landscape: 382 × 270
      : { w: DMB_PAGE_SHORT_PX, h: DMB_PAGE_LONG_PX };   // portrait:  270 × 382
  }
  function getPageAspectCss() { var d = getPageDims(); return d.w + " / " + d.h; }

  // Cover TEXT vertical position is stored CANONICAL (relative to the portrait
  // face = 424px) and scaled to the current face at render time. Portrait scale
  // = 1 (identical to before); landscape = 212/424 so text never clips off the
  // shorter face. `left`/width are unscaled (face width stays 300px on-screen).
  function _dmbCoverTopScale() {
    return dmbIsLandscape() ? (Math.round(300 * 210 / 297) / Math.round(300 * 297 / 210)) : 1;
  }
  // Resolve a CSS length that MIGHT be a percentage into px, against the element's
  // own containing block.
  //
  // Cover SPINE text is created with top:"50%" (see addDefaultText) so it centres on
  // the face whatever that face's height is. Everywhere that did the obvious
  // parseFloat(node.style.top) on such a node read the NUMBER 50 and wrote back the
  // STRING "50px" - reinterpreting "half way down the 424px face" (212px) as "50px
  // from the top", moving the text 162px up. parseFloat is only ever safe on a value
  // you yourself wrote as px. (2026-09-14)
  function _dmbLenPx(node, prop) {
    var raw = (node && node.style) ? (node.style[prop] || "") : "";
    var n = parseFloat(raw);
    if (!isFinite(n)) return 0;
    if (String(raw).trim().slice(-1) !== "%") return n;
    var par = node.offsetParent || node.parentElement;
    var vertical = (prop === "top" || prop === "bottom" || prop === "height");
    var base = par ? (vertical ? par.clientHeight : par.clientWidth) : 0;
    return (n / 100) * base;
  }

  function _dmbCoverCanonicalTop(v) {
    // A percentage is ALREADY face-relative, which is exactly what "canonical" means
    // here, so it passes through untouched. It used to be run through parseFloat and
    // re-emitted with "px", which turned a spine title's top:50% into top:50px the
    // first time its state was saved - and because that was written INTO saved state,
    // the text jumped up the cover on the next re-render and stayed there. (2026-09-14)
    var str = String(v == null ? "" : v).trim();
    if (str.slice(-1) === "%") return str;
    var t = parseFloat(str);
    return isFinite(t) ? ((t / _dmbCoverTopScale()) + "px") : (v || "");
  }

  // Keep a CHOSEN LAYOUT preset's frames at their EXACT portrait shape on any
  // page. Portrait → unchanged. Landscape → fit the whole layout into a centered
  // portrait-aspect column (letterboxed, empty space left/right) so no frame is
  // stretched. Maps a frame's portrait-% {x,y,w,h} to the current page's %.
  function _dmbLayoutFramePct(f) {
    var bw = getPageDims().w, bh = getPageDims().h;
    var boxW = Math.min(bh * (DMB_PAGE_SHORT_PX / DMB_PAGE_LONG_PX), bw); // portrait-aspect width
    var wPct = (boxW / bw) * 100, lPct = (100 - wPct) / 2;
    return { x: lPct + f.x * (wPct / 100), y: f.y, w: f.w * (wPct / 100), h: f.h };
  }

  // Two-photo (A/B) placement on a single page: stacked (top/bottom) in portrait,
  // side-by-side (left/right) in landscape — so a wide page reads naturally.
  function _dmbTwoUpPlacement() {
    return dmbIsLandscape()
      ? { a: { top: 0, bottom: 0, left: 0, width: "50%" },
          b: { top: 0, bottom: 0, right: 0, width: "50%" } }
      : { a: { top: 0, height: "50%" },
          b: { bottom: 0, height: "50%" } };
  }

  // Remap free (PIXEL-positioned) objects when the page shape flips, so text,
  // stickers, icons and manual photo-frames stay on the page instead of falling
  // off. Percentage-based things (auto-layout slot frames, cover %-frames) adapt
  // on their own and are deliberately left alone. Each object is center-mapped to
  // the same RELATIVE spot on the new shape, keeps its size, and is clamped
  // inside. (Known limitation: clamping makes a Portrait→Landscape→Portrait round
  // trip drift slightly for edge-hugging objects.)
  function _dmbRemapPxObjects(arr, fromW, fromH, toW, toH) {
    if (!Array.isArray(arr)) return;
    arr.forEach(function (o) {
      if (!o || typeof o.x !== "number" || typeof o.y !== "number") return;
      var w = (typeof o.w === "number" ? o.w : 0);
      var h = (typeof o.h === "number" ? o.h : 0);
      var cx = (o.x + w / 2) / fromW;   // relative center 0..1
      var cy = (o.y + h / 2) / fromH;
      var nx = cx * toW - w / 2;
      var ny = cy * toH - h / 2;
      o.x = Math.max(0, Math.min(nx, Math.max(0, toW - w)));
      o.y = Math.max(0, Math.min(ny, Math.max(0, toH - h)));
    });
  }

  function reshapeForOrientation(from, to) {
    if (from === to) return;
    var portrait  = { w: DMB_PAGE_SHORT_PX, h: DMB_PAGE_LONG_PX };
    var landscape = { w: DMB_PAGE_LONG_PX,  h: DMB_PAGE_SHORT_PX };
    var f = (from === "landscape") ? landscape : portrait;
    var t = (to   === "landscape") ? landscape : portrait;

    // Interior free objects (per page).
    if (editor.pageObjects && typeof editor.pageObjects === "object") {
      Object.keys(editor.pageObjects).forEach(function (p) {
        _dmbRemapPxObjects(editor.pageObjects[p], f.w, f.h, t.w, t.h);
      });
    }
    // Cover free objects: the horizontal extent (back|spine|front) is unchanged by
    // orientation — only the face HEIGHT flips (424 ↔ 212). Remap Y so objects
    // stay on the face for the owner to rearrange. (Positions are approximate.)
    var faceFromH = (from === "landscape") ? Math.round(300 * 210 / 297) : Math.round(300 * 297 / 210);
    var faceToH   = (to   === "landscape") ? Math.round(300 * 210 / 297) : Math.round(300 * 297 / 210);
    var isMag = !!window.DMB_MAGAZINE_MODE;
    var spreadW = isMag ? 300 * 2 : (300 * 2 + 22);
    _dmbRemapPxObjects(editor.coverObjects, spreadW, faceFromH, spreadW, faceToH);
    // NOTE: cover TEXT nodes are handled differently — their `top` is stored
    // canonical (portrait face) and scaled at render time (_dmbCoverTopScale),
    // so they never clip and flipping can't corrupt them. Nothing to do here.
  }

  // Silent auto-save (no banner) — debounced so it doesn't fire on every keystroke
  let _autoSaveTimer = null;
  function autoSave() {
    clearTimeout(_autoSaveTimer);
    _autoSaveTimer = setTimeout(() => {
      try {
        const payload = getCurrentBuilderStateSnapshot();
        localStorage.setItem(_dmbProjKey(), JSON.stringify(payload));
      } catch {}
      _dmbAutoPersist();
      try { _dmbCloudPersist(); } catch (e) {}
    }, 800);
  }

  // ── Issue 1: keep the per-customer progress saved continuously so a refresh
  // or app-switch can resume without re-uploading. State → localStorage (fast,
  // reliable); photos → IndexedDB (saved when the photo set changes). ──
  function _dmbWriteProgressState() {
    if (_dmbRenderMode()) return;   // render mode: never writes localStorage/IDB/cloud
    if (!editor || !editor.totalPages) return;   // nothing meaningful to save yet
    // Mirror heavy crop images to IndexedDB (debounced); the localStorage copy below
    // is stripped of them so it stays tiny + can't overflow the ~5 MB cap.
    try { _dmbPersistObjImages(); } catch (e) {}
    // Every local save also schedules the durable R2 backup (debounced, everyone —
    // guests + signed-in), so no edit path (e.g. a colour-only change) is missed.
    try { _dmbCloudPersist(); } catch (e) {}
    try {
      const p = getCurrentBuilderStateSnapshot();
      _dmbStripObjImagesFromSnapshot(p);   // drop inline base64 (kept in IndexedDB)
      p.savedAt = new Date().toISOString();
      p._saveType = window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "magazine" : "book";
      p._templateKey = getTemplateKey() || "custom";
      let prev = null;
      try { prev = JSON.parse(localStorage.getItem(getCustomerSaveKey()) || "null"); } catch (e) {}
      const urlCover = new URLSearchParams(window.location.search).get("cover") || getTemplateKey() || "";
      p._coverHandle = urlCover || (prev && prev._coverHandle) || "";
      localStorage.setItem(getCustomerSaveKey(), JSON.stringify(p));
    } catch (e) {}
  }
  let _dmbStateTimer = null;
  function _dmbAutoPersist() {
    clearTimeout(_dmbStateTimer);
    _dmbStateTimer = setTimeout(_dmbWriteProgressState, 600);
  }
  let _dmbPhotoTimer = null;
  function _dmbPersistPhotos() {
    if (_dmbRenderMode()) return;   // render mode: no IndexedDB writes
    clearTimeout(_dmbPhotoTimer);
    _dmbPhotoTimer = setTimeout(() => {
      try {
        const ph = editor.photos || [];
        if (!ph.length) return;
        const sig = ph.map((p) => p.id).join(",");
        if (sig === _dmbPersistPhotos._sig) return;   // unchanged set — skip churn
        // Only record the signature as saved AFTER a confirmed successful write,
        // so a failed save (quota / private browsing) is retried, not skipped.
        _savePhotosToIDB(getCustomerSaveKey(), ph).then((ok) => {
          if (ok) { _dmbPersistPhotos._sig = sig; }
          else { _dmbNotifySaveTrouble(); }
        }).catch(() => { _dmbNotifySaveTrouble(); });
      } catch (e) {}
    }, 1200);
  }

  // One-time, gentle warning when photos can't be persisted on this device
  // (storage full, private browsing, or IndexedDB disabled). Prevents the
  // "silent loss" where a customer designs a whole book that never saved.
  let _dmbSaveTroubleShown = false;
  function _dmbNotifySaveTrouble() {
    if (_dmbSaveTroubleShown) return;
    _dmbSaveTroubleShown = true;
    try {
      const el = document.createElement("div");
      el.style.cssText = "position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:1000001;background:#7a1f1f;color:#fff;border-radius:12px;padding:13px 18px;max-width:92vw;font-size:13px;font-weight:700;line-height:1.45;box-shadow:0 10px 40px rgba(0,0,0,.4);display:flex;gap:12px;align-items:center;";
      el.innerHTML = '<span>⚠️ We couldn\'t save your photos on this device (storage may be full or private browsing is on). Your design may not be saved — consider using a laptop or iPad.</span>';
      const x = document.createElement("button");
      x.textContent = "×";
      x.style.cssText = "background:rgba(255,255,255,.2);border:none;color:#fff;width:26px;height:26px;border-radius:999px;font-size:16px;cursor:pointer;flex-shrink:0;";
      x.addEventListener("click", () => { try { el.remove(); } catch (e) {} });
      el.appendChild(x);
      document.body.appendChild(el);
      setTimeout(() => { try { el.remove(); } catch (e) {} }, 12000);
    } catch (e) {}
  }

  // Save state synchronously when the page is hidden/closed (leaving the app).
  // Also flush the photo save: a photo added in the last ~1.2s (before the
  // debounce fired) would otherwise never be persisted.
  function _dmbFlushOnHide() {
    if (_dmbRenderMode()) return;              // render mode: no save on pagehide/visibilitychange
    try { _dmbTextStyleCommit(); } catch (e) {}   // flush a debounced text-style edit before leaving
    _dmbWriteProgressState();
    // Flush the ACCOUNT (cloud) manifest too — the debounced cloud save may not
    // have captured the latest photo set, and a cross-device reopen reads ONLY the
    // cloud. keepalive lets this survive the unload. (Same-device is already covered
    // by the IDB save below + the cloud/IDB merge on restore.)
    try { _dmbCloudFlushNow(true); } catch (e) {}
    try {
      const ph = editor.photos || [];
      if (!ph.length) return;
      const sig = ph.map((p) => p.id).join(",");
      if (sig === _dmbPersistPhotos._sig) return;   // already saved
      _savePhotosToIDB(getCustomerSaveKey(), ph).then((ok) => {
        if (ok) _dmbPersistPhotos._sig = sig;
      }).catch(() => {});
    } catch (e) {}
  }
  window.addEventListener("pagehide", _dmbFlushOnHide);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") _dmbFlushOnHide();
  });

  // Resume banner shown on a fresh load when saved progress exists (issue 1).
  // Full-screen loader (the vacation-emoji orbit) shown while a saved design is being
  // restored — covers the "photos take a moment to appear" gap after clicking Resume.
  function _dmbShowRestoreLoader() {
    if (document.getElementById("dmbRestoreLoader")) return;
    const ov = document.createElement("div");
    ov.id = "dmbRestoreLoader";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000002;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(250,247,242,0.98);gap:6px;";
    try {
      const node = _dmbPvMakeLoadingNode();
      const lbl = node.querySelector("div:last-child"); if (lbl) lbl.textContent = "Loading your photos & layout";
      ov.appendChild(node);
    } catch (e) {}
    const msg = document.createElement("div");
    msg.textContent = "✨ Bringing your design back…";
    msg.style.cssText = "font-size:15px;font-weight:800;color:#1e1e1e;margin-top:2px;";
    ov.appendChild(msg);
    document.body.appendChild(ov);
    // Safety: never leave the loader stuck if a restore step throws.
    setTimeout(_dmbHideRestoreLoader, 25000);
  }
  function _dmbHideRestoreLoader() { const o = document.getElementById("dmbRestoreLoader"); if (o) o.remove(); }

  // Centered "welcome back" modal offering Resume / Start fresh. onResume runs after
  // the loader is shown; onFresh is optional.
  function _dmbResumeModal(onResume, onFresh) {
    if (document.getElementById("dmbResumeModal")) return;
    const ov = document.createElement("div");
    ov.id = "dmbResumeModal";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.45);padding:20px;";
    const card = document.createElement("div");
    card.style.cssText = "background:#fff;border-radius:18px;max-width:380px;width:100%;padding:28px 24px 22px;box-shadow:0 24px 70px rgba(0,0,0,.4);text-align:center;";
    card.innerHTML =
      '<div style="font-size:36px;margin-bottom:8px;">📂</div>' +
      '<h3 style="margin:0 0 8px;font-size:20px;font-weight:900;color:#1e1e1e;">Welcome back!</h3>' +
      '<p style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#555;">We saved your design. Pick up where you left off, or start fresh.</p>';
    const resumeBtn = document.createElement("button");
    resumeBtn.textContent = "Resume my design";
    resumeBtn.style.cssText = "display:block;width:100%;background:#6d3bd4;color:#fff;border:none;border-radius:10px;padding:14px;cursor:pointer;font-weight:900;font-size:15px;margin-bottom:10px;";
    const freshBtn = document.createElement("button");
    freshBtn.textContent = "Start fresh";
    freshBtn.style.cssText = "display:block;width:100%;background:#f1ebe0;color:#555;border:none;border-radius:10px;padding:12px;cursor:pointer;font-weight:800;font-size:14px;";
    card.appendChild(resumeBtn); card.appendChild(freshBtn);
    ov.appendChild(card); document.body.appendChild(ov);
    resumeBtn.addEventListener("click", () => { ov.remove(); _dmbShowRestoreLoader(); try { onResume(); } catch (e) {} });
    freshBtn.addEventListener("click", () => { ov.remove(); try { onFresh && onFresh(); } catch (e) {} });
  }

  function _dmbShowResumeBanner() {
    _dmbResumeModal(
      () => {
        try { const u = new URL(window.location.href); u.searchParams.set("restore", "1"); window.location.assign(u.toString()); }
        catch (e) { window.location.search = (window.location.search ? window.location.search + "&" : "?") + "restore=1"; }
      },
      async () => { try { await clearCustomerProgress(); } catch (e) {} }
    );
  }

  // ── PDF Preview Cache ─────────────────────────────────────────────────────
  // Pages are rendered to JPEG dataURLs in the background using the SAME
  // renderPage() / renderCoverSpread() code path as the real PDF export.
  // A 2-second debounce ensures re-renders only happen after edits settle.
  var _dmbPvCache   = {};       // pageNumber → JPEG dataURL
  var _dmbPvCover   = null;     // { back, spine, front } JPEG dataURLs
  var _dmbPvDirty   = new Set();
  var _dmbPvRendering = new Set();
  var _dmbPvTimer   = null;
  var _dmbPvRunning = false;
  var _dmbPvRefresh = null;     // callback set when preview overlay is open
  var _dmbPvGen     = 0;        // generation counter — incremented on reinit so
                                // in-flight renders from the previous generation
                                // know to discard their result instead of writing
                                // stale data to the (already cleared) cache.

  function _dmbPvMarkDirty(key) {
    _dmbPvDirty.add(key);
    clearTimeout(_dmbPvTimer);
    _dmbPvTimer = setTimeout(_dmbPvRun, 2000);
  }

  // Vacation-emoji orbit loading animation
  function _dmbPvMakeLoadingNode() {
    var emojis = ["✈️","🛂","🧳","🗺️","📸","🏖️"];
    var outer = document.createElement("div");
    outer.style.cssText = "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;width:100%;height:100%;min-height:200px;";
    var ring = document.createElement("div");
    ring.style.cssText = "position:relative;width:130px;height:130px;";
    emojis.forEach(function(em, i) {
      var s = document.createElement("span");
      s.className = "dmb-pv-emoji";
      s.textContent = em;
      s.style.animationDelay = (-i * (3.5 / emojis.length)).toFixed(2) + "s";
      s.style.animationDuration = (3.2 + i * 0.2).toFixed(1) + "s";
      ring.appendChild(s);
    });
    var lbl = document.createElement("div");
    lbl.textContent = "Rendering…";
    lbl.style.cssText = "color:#888;font-size:11px;letter-spacing:0.4px;";
    outer.appendChild(ring);
    outer.appendChild(lbl);
    return outer;
  }

  async function _dmbPvRun() {
    if (_dmbPvRunning) return;
    if (_dmbRenderMode()) return;   // render mode: NO background previews (CPU + _dmbNoMasterPids poisoning)
    _dmbPvRunning = true;
    var _myGen = _dmbPvGen; // snapshot generation at start — used to detect reinit
    try {
      while (_dmbPvDirty.size > 0) {
        // Abort entire loop if a reinit happened while we were awaiting
        if (_dmbPvGen !== _myGen) break;
        var _pvKeys = Array.from(_dmbPvDirty);
        for (var _pki = 0; _pki < _pvKeys.length; _pki++) {
          if (_dmbPvGen !== _myGen) break; // reinit mid-loop — stop immediately
          var _pvKey = _pvKeys[_pki];
          if (_dmbPvRendering.has(_pvKey)) continue;
          _dmbPvDirty.delete(_pvKey);
          _dmbPvRendering.add(_pvKey);
          try {
            var _pvResult = await new Promise(function(res, rej) {
              var _pvK = _pvKey;
              buildPdfBlobOnePagePerBookPage(null, _pvK === "cover"
                ? { cover: true,  resolve: res, reject: rej }
                : { page:  _pvK,  resolve: res, reject: rej });
            });
            // Discard result if a reinit happened while we were rendering
            if (_dmbPvGen !== _myGen) break;
            if (_pvKey === "cover") {
              _dmbPvCover = {
                back:  _pvResult.back.toDataURL("image/jpeg", 0.93),
                spine: _pvResult.spine.toDataURL("image/jpeg", 0.93),
                front: _pvResult.front.toDataURL("image/jpeg", 0.93),
              };
            } else {
              _dmbPvCache[_pvKey] = _pvResult.toDataURL("image/jpeg", 0.93);
            }
            if (typeof _dmbPvRefresh === "function") _dmbPvRefresh(_pvKey);
          } catch(_pvErr) {
            if (_dmbPvGen !== _myGen) break; // reinit — don't retry stale page
            console.warn("[DMB Preview] render failed for", _pvKey, ":", _pvErr && _pvErr.message);
            // Re-mark dirty so it retries on the next edit
            _dmbPvDirty.add(_pvKey);
          } finally {
            _dmbPvRendering.delete(_pvKey);
          }
          // Yield between pages so the UI stays responsive
          await new Promise(function(r) { setTimeout(r, 80); });
        }
      }
    } finally {
      // Only reset running flag if still our generation — a newer run took over
      if (_dmbPvGen === _myGen) _dmbPvRunning = false;
    }
  }

  function _dmbPvInitAll() {
    setTimeout(function() {
      _dmbPvDirty.add("cover");
      for (var _pvp = 0; _pvp <= (editor.totalPages || 0); _pvp++) {
        _dmbPvDirty.add(_pvp);
      }
      _dmbPvRunning = false; // allow fresh start
      _dmbPvRun();
    }, 1800);
  }

  // Call after any full state restore (undo/redo, progress restore, project load)
  // that changes ALL pages at once — clears stale cache and re-renders everything.
  function _dmbPvReinitAll() {
    _dmbPvGen++;            // invalidate ALL in-flight renders from previous generation
    _dmbPvCache   = {};
    _dmbPvCover   = null;
    _dmbPvDirty.clear();
    _dmbPvRendering.clear();
    clearTimeout(_dmbPvTimer);
    _dmbPvRunning = false;
    _dmbPvInitAll();
  }
  // ── End PDF Preview Cache ─────────────────────────────────────────────────

  // ── Contain-to-page ───────────────────────────────────────────────────────
  // Clips a free item to its page / cover-zone boundary using a CSS clip-path
  // polygon computed in the element's own (pre-rotation) coordinate space.
  //
  //   obj.contained  0 = off  |  1 = page / zone  |  2 = full spread (cover)
  //
  // The polygon technique:
  //   • Take the 4 corners of the clip rectangle in page coordinates
  //   • Translate them relative to the element centre, then inverse-rotate them
  //     into the element's local space (so the polygon follows any rotation)
  //   • CSS clip-path clips in local space → after transform the visible region
  //     is exactly the original rectangle in page space ✓

  function _dmbContainBounds(obj, isCover) {
    var FACE_PX  = 300, SPINE_PX = COVER_SPINE_W;
    var FACE_H   = dmbIsLandscape() ? Math.round(300 * 210 / 297) : Math.round(300 * 297 / 210); // portrait 424, landscape 212
    var _pd = getPageDims();
    var PAGE_W   = _pd.w,  PAGE_H = _pd.h; // portrait 270×382, landscape 382×270
    // Magazine has no spine — front face starts at COVER_BACK_W (300), not COVER_FRONT_X (322)
    var isMag    = !!window.DMB_MAGAZINE_MODE;
    var FRONT_X  = isMag ? FACE_PX : (FACE_PX + SPINE_PX);  // 300 (mag) | 322 (book)
    var SPREAD_W = isMag ? FACE_PX * 2 : (FACE_PX * 2 + SPINE_PX); // 600 | 622
    if (!isCover) {
      // Horizontal containment follows the object: a spanning shape clipped at the fold
      // would be amputated on screen while the PDF printed it whole, because the render
      // path's own clip is gated on obj.coverZone and so never applies to a page object.
      // Screen and print must agree. Vertical containment is unchanged - the top and
      // bottom page edges are real edges on any sheet. (2026-09-14)
      var _ox = (obj && obj.x) || 0, _ow = (obj && obj.w) || 0;
      return { l: Math.min(0, _ox), t: 0, r: Math.max(PAGE_W, _ox + _ow), b: PAGE_H };
    }
    if ((obj.contained || 0) === 2)
      return { l: 0, t: 0, r: SPREAD_W, b: FACE_H }; // full spread
    var zone = obj.coverZone || "front";
    if (zone === "back")  return { l: 0,        t: 0, r: FACE_PX,          b: FACE_H };
    if (zone === "spine") return { l: FACE_PX,   t: 0, r: FACE_PX + SPINE_PX, b: FACE_H };
    return                        { l: FRONT_X,  t: 0, r: FRONT_X + FACE_PX,  b: FACE_H };
  }

  function _dmbContainClipPath(obj, bounds) {
    var L = obj.x || 0, T = obj.y || 0, W = obj.w || 100, H = obj.h || 100;
    var R    = -(obj.rotation || 0) * Math.PI / 180; // inverse rotation
    var cosR = Math.cos(R), sinR = Math.sin(R);
    var cx   = L + W / 2, cy = T + H / 2;
    var pts  = [[bounds.l, bounds.t],[bounds.r, bounds.t],
                [bounds.r, bounds.b],[bounds.l, bounds.b]].map(function(c) {
      var dx = c[0] - cx, dy = c[1] - cy;
      var lx = dx * cosR - dy * sinR + W / 2;
      var ly = dx * sinR + dy * cosR + H / 2;
      return lx.toFixed(1) + "px " + ly.toFixed(1) + "px";
    });
    return "polygon(" + pts.join(", ") + ")";
  }

  function _dmbApplyContain(wrapEl, obj, isCover) {
    if (!wrapEl) return;
    if (!obj || !obj.contained) { wrapEl.style.clipPath = ""; return; }
    wrapEl.style.clipPath = _dmbContainClipPath(obj, _dmbContainBounds(obj, isCover));
  }

  function _dmbContainBtnText(obj, isCover) {
    var s = obj.contained || 0;
    if (s === 0)            return "Contain: Off";
    if (isCover && s === 2) return "Contain: Spread ✓";
    if (isCover)            return "Contain: Zone ✓";
    return "Contain: On ✓";
  }

  function _dmbContainCycle(obj, wrapEl, isCover) {
    pushUndoState("Contain to page");
    var max = isCover ? 3 : 2;
    obj.contained = ((obj.contained || 0) + 1) % max;
    _dmbApplyContain(wrapEl, obj, isCover);
    ["dmbMapContainBtn","dmbShapeContainBtn","dmbFrameContainBtn"].forEach(function(id) {
      var btn = document.getElementById(id);
      if (btn) btn.textContent = _dmbContainBtnText(obj, isCover);
    });
  }

  // Re-apply contain clips to all visible item wrappers after any state change
  function _dmbReapplyAllContains() {
    document.querySelectorAll("[data-object-id]").forEach(function(el) {
      var objId   = el.dataset.objectId;
      var isCover = !!el.closest(".dmb-cover-preview");
      var obj = null;
      if (isCover) {
        obj = (editor.coverObjects || []).find(function(o) { return o.id === objId; });
      } else {
        var arrs = Object.values(editor.pageObjects || {});
        for (var _i = 0; _i < arrs.length; _i++) {
          if (!Array.isArray(arrs[_i])) continue;
          var _f = arrs[_i].find(function(o) { return o.id === objId; });
          if (_f) { obj = _f; break; }
        }
      }
      if (obj) _dmbApplyContain(el, obj, isCover);
    });
  }
  // ── End Contain-to-page ───────────────────────────────────────────────────

  // Cover zone layout constants (px)
  const COVER_BACK_W = 300; // matches .dmb-cover-face { width: 300px } in CSS
  // Spine = 8 mm. The 300px face represents the 210 mm cover, so 8 mm ≈ 8/210×300 ≈ 11px.
  // This makes the on-screen spine proportional to the real 8 mm (was 22px ≈ 15 mm) and,
  // since the PDF spine crop reads this same value, the print isn't horizontally squished.
  const COVER_SPINE_W = 11;
  const COVER_FRONT_X = COVER_BACK_W + COVER_SPINE_W; // 311

  const DMB_MAG_ICONS = [
    { id: "vogue", label: "Vogue", file: "mag-icon-vogue.png" },
    { id: "elle", label: "Elle", file: "mag-icon-elle.png" },
    { id: "harpers-bazaar", label: "Harper's Bazaar", file: "mag-icon-harpers-bazaar.png" },
    { id: "harpers-bazaar-arabian", label: "Harper's Bazaar Arabian", file: "mag-icon-harpers-bazaar-arabian.png" },
  ];
  const _dmbIconColorCache = {};

  async function dmbGetColoredIconDataUrl(iconId, color) {
    const key = iconId + "|" + (color || "#000000");
    if (_dmbIconColorCache[key]) return _dmbIconColorCache[key];
    const iconUrl = dmbMagIconUrl(iconId);
    try {
      const resp = await fetch(iconUrl, { mode: "cors", cache: "force-cache" });
      const blob = await resp.blob();
      const blobUrl = URL.createObjectURL(blob);
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = blobUrl;
      });
      URL.revokeObjectURL(blobUrl);
      const c = document.createElement("canvas");
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const cx = c.getContext("2d");
      cx.drawImage(img, 0, 0);
      cx.globalCompositeOperation = "source-in";
      cx.fillStyle = color || "#000000";
      cx.fillRect(0, 0, c.width, c.height);
      const dataUrl = c.toDataURL("image/png");
      _dmbIconColorCache[key] = dataUrl;
      return dataUrl;
    } catch(e) { return iconUrl; }
  }

  function dmbMagIconUrl(iconId) {
    const ic = DMB_MAG_ICONS.find((i) => i.id === iconId);
    if (!ic) return "";
    const base = (window.DMB_ASSET_BASE || "").replace(/\/[^/]+$/, "/");
    return base + ic.file;
  }

  function dmbFindObjectById(id, targetType) {
    if (targetType === "cover") {
      return (editor.coverObjects || []).find((o) => o.id === id) || null;
    }
    let found = null;
    Object.values(editor.pageObjects || {}).forEach((arr) => {
      if (!found) found = (arr || []).find((o) => o.id === id) || null;
    });
    return found;
  }

  let selectedTextNode = null;
  let selectedFrameObject = null;
  let dmbRotateHandle = null;
  let lastToolbarSide = "left";
  let activeMarkerType = null;
  let pendingMapMarkerPlacement = false;
  let currentInsertedMap = null;

  // Migrate old {front,back,spine} format to a flat array using full-cover x coordinates
  function migrateCoverObjectsToFlat() {
    if (Array.isArray(editor.coverObjects)) return;
    const old = editor.coverObjects || {};
    const flat = [];
    (old.back || []).forEach(o => flat.push(Object.assign({}, o)));
    (old.spine || []).forEach(o => flat.push(Object.assign({}, o, { x: (o.x || 0) + COVER_BACK_W })));
    (old.front || []).forEach(o => flat.push(Object.assign({}, o, { x: (o.x || 0) + COVER_FRONT_X })));
    editor.coverObjects = flat;
  }

  function ensureCoverObjects() {
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    return editor.coverObjects;
  }

  function getCoverObjectsForZone(zone) {
    return ensureCoverObjects();
  }

  function pushObjectToCoverZone(zone, obj) {
    ensureCoverObjects().push(obj);
    return obj;
  }

  function getCurrentCoverZone() {
    return activeCoverZone || "front";
  }

  // Put a NEWLY INSERTED cover item on the face the user actually has selected.
  //
  // The cover is ONE continuous coordinate space, not three separate canvases:
  //   back  x 0 .. 300      spine x 300 .. 311      front x 311 .. 611
  // (in magazine mode there is no spine, so the front face starts at 300.)
  // So every insert that used a hardcoded corner - x:20 for stickers and icons,
  // x:60 for shapes - was not "unplaced", it was explicitly landing on the BACK
  // face, whichever face the user had selected. Maps, text, photo frames and
  // layouts each grew their own zone maths over time; stickers, icons and shapes
  // never did. This is that maths in one place.
  //
  // The item keeps the SAME inset it has always had - it just gets measured from
  // the selected face's left edge instead of from the cover's. The clamp keeps a
  // large item from spilling onto the neighbouring face, which would look exactly
  // like the bug being fixed. (2026-09-14)
  function _dmbPlaceOnActiveCoverFace(obj, insetX, insetY) {
    if (!obj) return obj;
    const zone = getCurrentCoverZone();
    const w = Number(obj.w) || 0, h = Number(obj.h) || 0;
    const faceH = Math.round(COVER_BACK_W * 1.414);   // A4 face, same ratio as the CSS
    if (zone === "spine") {
      // 11px of spine cannot hold an inset. Centre the item on the spine instead so
      // it straddles the fold symmetrically - the only sensible reading of "put this
      // on the spine" for anything wider than a hairline.
      obj.x = Math.round(COVER_BACK_W + (COVER_SPINE_W - w) / 2);
      obj.y = Math.round((faceH - h) / 2);
      return obj;
    }
    const startX = (zone === "back") ? 0
                 : (window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X);
    obj.x = Math.min(startX + (insetX || 0), startX + Math.max(0, COVER_BACK_W - w));
    obj.y = Math.min((insetY || 0), Math.max(0, faceH - h));
    // Tag the face as well. Until an item has been dragged once obj.coverZone is
    // unset, and dmbAlignObjectInZone's else-branch then treats it as FRONT - so
    // "align left" on a freshly added BACK-cover sticker threw it onto the front
    // face. Drag-end (_dmbAutoAssignCoverZone) has always written this field; the
    // insert now agrees with it from the start instead of waiting for a drag.
    // Deliberately NOT set for the spine above: the zone clip would slice the item
    // down to the 11px spine and it would look like it had vanished.
    obj.coverZone = zone;
    return obj;
  }

  function getObjectByTarget(targetType, pageNumber, zone, objectId) {
    const arr = getObjectListForTarget(targetType, pageNumber, zone);
    return arr.find((o) => o.id === objectId) || null;
  }

  function deleteFrameObjectByTarget(targetType, pageNumber, zone, objectId) {
    const arr = getObjectListForTarget(targetType, pageNumber, zone);
    const idx = arr.findIndex((o) => o.id === objectId);
    if (idx >= 0) arr.splice(idx, 1);
    if (selectedFrameObject && selectedFrameObject.id === objectId) {
      selectedFrameObject = null;
    }
  }

  function markActiveCoverZone() {
    ["coverFront", "coverBack", "coverSpine"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove("dmb-cover-zone-active");
    });

    const targetId =
      activeCoverZone === "back"
        ? "coverBack"
        : activeCoverZone === "spine"
        ? "coverSpine"
        : "coverFront";

    const activeEl = document.getElementById(targetId);
    if (activeEl) activeEl.classList.add("dmb-cover-zone-active");

    updateCoverZoneButtons();
  }

  function duplicateFrameObjectByTarget(targetType, pageNumber, zone, objectId) {
    const obj = getObjectByTarget(targetType, pageNumber, zone, objectId);
    if (!obj) return null;

    const copy = {
      ...cloneState(obj),
      id: uid(),
      x: obj.x + 20,
      y: obj.y + 20,
      z: Date.now()
    };

    getObjectListForTarget(targetType, pageNumber, zone).push(copy);
    return copy;
  }

  // ── Z-ORDER STEP HELPERS (2026-05) ──────────────────────────────────────
  // "⬆ Front" / "⬇ Back" buttons move an object ONE STEP at a time through
  // the stack (not jump-to-top / jump-to-bottom).
  // After the swap, z values are renormalised to multiples of 1000 to avoid
  // collisions. The BOTTOM item gets z=0 when it reaches the very last
  // position so it goes behind photos (which use z=1 in makePlacedImageBox).
  // The PDF renderer (renderPage / renderCoverSpread) reads these z values to
  // decide whether to draw an object before or after the photo layer.
  function _stepZ(targetType, pageNumber, zone, objectId, direction) {
    const list = getObjectListForTarget(targetType, pageNumber, zone);
    if (!list || list.length === 0) return;

    // Sort by current z (ascending = bottom to top)
    list.sort((a, b) => (a.z || 0) - (b.z || 0));
    const idx = list.findIndex(o => o.id === objectId);
    if (idx === -1) return;

    const newIdx = direction === "up"
      ? Math.min(list.length - 1, idx + 1)
      : Math.max(0, idx - 1);

    if (newIdx === idx) return; // already at top/bottom of the object stack

    // Swap positions in the sorted array
    const tmp = list[idx];
    list[idx] = list[newIdx];
    list[newIdx] = tmp;

    // Reassign clean z values: step 0 = z 1000, step 1 = z 2000, etc.
    // The bottom-most item (idx 0) gets z 1000 — still above placed photos (z=1)
    // unless this is a "send backward" where the object was already at the bottom,
    // in which case we drop it below photos by setting z = 0.
    list.forEach((o, i) => { o.z = (i + 1) * 1000; });

    // If sending backward and the object ended up at the very bottom of the
    // stack, drop it below photos (z=0) so it goes behind images too.
    if (direction === "down" && newIdx === 0) {
      list[0].z = 0;
    }
  }

  function bringFrameForwardByTarget(targetType, pageNumber, zone, objectId) {
    _stepZ(targetType, pageNumber, zone, objectId, "up");
  }

  function sendFrameBackwardByTarget(targetType, pageNumber, zone, objectId) {
    _stepZ(targetType, pageNumber, zone, objectId, "down");
  }

  // ── UNIFIED one-step layering across ALL item types ────────────────────────
  // Text, stickers, mag-icons, shapes, maps and photo-frames on the same surface
  // (cover overlay or a page body) share ONE z-order. Forward/back moves the item
  // one step past the adjacent item of ANY type. z is written to both the DOM and
  // each item's model, so the builder, the PDF preview and Save Design all agree.
  const _DMB_LAYER_SEL = ".dmb-editable-text,.dmb-sticker-object,.dmb-mag-icon-object,.dmb-shape-object,.dmb-map-object,.dmb-photo-frame-object";
  function _dmbLayerZOf(el) { return Number(el.dataset.z || el.style.zIndex || 0) || 0; }
  function _dmbLayerSetZ(el, z) {
    const zs = String(z);
    el.dataset.z = zs;
    el.style.zIndex = zs;
    try {
      if (el.classList.contains("dmb-editable-text")) {
        if (el.id && coverState.textStyles && coverState.textStyles[el.id]) coverState.textStyles[el.id].z = zs;
        const pn = parseInt(el.dataset.pageNumber);
        if (Number.isFinite(pn) && editor.pageObjects && Array.isArray(editor.pageObjects[pn])) {
          const o = editor.pageObjects[pn].find((x) => x.id === el.id); if (o) o.z = z;
        }
      } else if (el.dataset.objectId) {
        const oid = el.dataset.objectId;
        let o = (editor.coverObjects || []).find((x) => x.id === oid);
        if (!o && editor.pageObjects) {
          Object.keys(editor.pageObjects).forEach((p) => {
            const arr = editor.pageObjects[p];
            if (Array.isArray(arr)) { const f = arr.find((x) => x.id === oid); if (f) o = f; }
          });
        }
        if (o) o.z = z;
      }
    } catch (e) {}
  }
  function _dmbUnifiedLayerStep(el, dir) {
    if (!el) return false;
    const container = el.closest("#coverOverlay") || el.closest("[data-page-body='true']") || el.closest("[data-page-body]") || el.parentElement;
    if (!container) return false;
    const nodes = Array.from(container.querySelectorAll(_DMB_LAYER_SEL));
    if (nodes.length < 2) return false;
    nodes.sort((a, b) => _dmbLayerZOf(a) - _dmbLayerZOf(b));   // bottom → top
    const i = nodes.indexOf(el);
    if (i === -1) return false;
    const j = dir === "forward" ? i + 1 : i - 1;
    if (j < 0 || j >= nodes.length) return false;             // already top/bottom
    nodes.splice(i, 1);
    nodes.splice(j, 0, el);
    // Clean ascending z (1000,2000,…): above placed photos (z=1), collision-free.
    nodes.forEach((n, idx) => _dmbLayerSetZ(n, (idx + 1) * 1000));
    // Sent fully to the bottom → drop behind the photo layer (matches _stepZ).
    if (dir === "backward" && nodes[0] === el) _dmbLayerSetZ(el, 0);
    return true;
  }
  // Run a layer step for the selected element, then persist + refresh the preview.
  function _dmbDoLayerStep(el, dir) {
    if (!el || !el.isConnected) return;
    pushUndoState(dir === "forward" ? "Bring Forward" : "Send Backward");
    _dmbUnifiedLayerStep(el, dir);
    try { _dmbAutoPersist(); } catch (e) {}
    try {
      if (builderMode === "cover") _dmbPvMarkDirty("cover");
      else { _dmbPvMarkDirty(editor.currentSpread * 2 + 1); _dmbPvMarkDirty(editor.currentSpread * 2 + 2); }
    } catch (e) {}
  }
  function _dmbSelectedFrameEl() {
    if (!selectedFrameObject) return null;
    try { return document.querySelector('[data-object-id="' + selectedFrameObject.id + '"]'); } catch (e) { return null; }
  }
  function ensurePageObjects(pageNumber) {
    if (!editor.pageObjects) editor.pageObjects = {};
    if (!editor.pageObjects[pageNumber]) editor.pageObjects[pageNumber] = [];
    return editor.pageObjects[pageNumber];
  }

  function getCurrentVisiblePageNumber() {
    if (builderMode !== "pages") return null;
    const leftPage = editor.currentSpread * 2 + 1;
    if (leftPage > editor.totalPages) return null;
    if (!isLockedPage(leftPage)) return leftPage;
    const rightPage = leftPage + 1;
    if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) return rightPage;
    return null;
  }

  function newFrameObject(target) {
    return {
      id: uid(),
      type: "photo-frame",
      targetType: target?.targetType || "page",
      page: target?.page ?? null,
      zone: target?.zone || null,
      x: 40,
      y: 40,
      w: 220,
      h: 160,
      z: Date.now(),
      photoId: null
    };
  }

  function getObjectById(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    return arr.find((o) => o.id === objectId) || null;
  }

  function deleteFrameObject(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    const idx = arr.findIndex((o) => o.id === objectId);
    if (idx >= 0) arr.splice(idx, 1);
    if (selectedFrameObject && selectedFrameObject.id === objectId) {
      selectedFrameObject = null;
    }
  }

  function duplicateFrameObject(pageNumber, objectId) {
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return null;
    const copy = {
      ...cloneState(obj),
      id: uid(),
      x: obj.x + 20,
      y: obj.y + 20,
      z: Date.now()
    };
    ensurePageObjects(pageNumber).push(copy);
    return copy;
  }

  function bringFrameForward(pageNumber, objectId) {
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return;
    obj.z = Date.now();
  }

  function sendFrameBackward(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    const minZ = arr.length ? Math.min(...arr.map((o) => Number(o.z || 0))) : 0;
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return;
    obj.z = minZ - 1;
  }

  // ── Hide the floating toolbars WHILE an item is being moved/resized ─────────
  // The blue frame bar (and the text/map/shape bars) block the view during a drag,
  // so we hide the open bar the instant the pointer actually moves on an item and
  // bring the correct one back — repositioned — the moment the pointer is released.
  // Works for every item type on desktop AND touch. Each show fn records itself in
  // `_dmbLastBarShow`, which we replay on release.
  let _dmbDragSuppress = false;
  let _dmbLastBarShow = null;
  let _dmbBarDown = null;
  function _dmbHideBarsForDrag() {
    // DISABLED (per user request): the edit menus now dock in the fixed ribbon, so
    // they no longer cover the item being moved/resized — the menu must stay open
    // throughout a drag/resize/nudge and only close when the item is deselected.
    // Kept as a no-op so every existing caller is harmless.
    return;
  }
  function _dmbReshowBarAfterDrag() {
    if (typeof _dmbLastBarShow === "function") { try { _dmbLastBarShow(); } catch (e) {} }
  }
  // Cheap rotate-handle tracker for use DURING a drag: keeps the fixed-positioned
  // rotate handle on the moving object without re-running the full (heavy) toolbar
  // re-init (which rewrites every form control, hides other bars, re-docks — all
  // pointless mid-drag since the bar is already open & docked). Deduped to 1 rAF/frame.
  let _dmbRotTrackRAF = null;
  function _dmbTrackRotHandle(el) {
    if (_dmbRotTrackRAF) cancelAnimationFrame(_dmbRotTrackRAF);
    _dmbRotTrackRAF = requestAnimationFrame(() => {
      _dmbRotTrackRAF = null;
      const h = el && el._dmbRotHandle;
      if (!h || h.style.display === "none" || !el.isConnected) return;
      const r = el.getBoundingClientRect();
      h.style.left = (r.right + 14) + "px";
      h.style.top  = (r.bottom + 14) + "px";
    });
  }
  // The floating edit bars + rotate handles are position:fixed, so a page scroll
  // would leave them stranded while the object moves away behind them. Reposition
  // them to follow the selected object on scroll/resize.
  function _dmbRepositionFloatingChrome() {
    const _vis = (el) => el && el.style.display !== "none";
    const _mapB = document.getElementById("dmbMapEditBar");
    const _shpB = document.getElementById("dmbShapeEditBar");
    const _txtB = document.getElementById("dmbTextToolbar");
    const _frmB = document.getElementById("dmbFrameToolbar");
    const barOpen = _vis(_mapB) || _vis(_shpB) ||
      (_txtB && _txtB.classList.contains("is-open")) ||
      (_frmB && _frmB.classList.contains("is-open"));
    if (!barOpen) return;   // nothing selected — leave the rotate handles alone
    // The edit bars now dock inside the sticky ribbon and ride along on scroll,
    // so only the object's rotate handle (fixed-positioned) needs re-tracking.
    document.querySelectorAll(
      ".dmb-shape-object.dmb-selected, .dmb-map-object.dmb-selected, " +
      ".dmb-photo-frame-object.is-selected, .dmb-sticker-object.is-selected, .dmb-mag-icon-object.is-selected"
    ).forEach((el) => {
      const h = el._dmbRotHandle;
      if (!h || h.style.display === "none" || !el.isConnected) return;
      const r = el.getBoundingClientRect();
      h.style.left = (r.right + 14) + "px";
      h.style.top  = (r.bottom + 14) + "px";
    });
  }
  (function _dmbWireChromeReposition() {
    let raf = 0;
    const onScrollResize = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; try { _dmbRepositionFloatingChrome(); } catch (e) {} });
    };
    // capture:true also catches scrolls from inner scrollable containers.
    window.addEventListener("scroll", onScrollResize, true);
    window.addEventListener("resize", onScrollResize);
  })();

  // ── Rotate-handle governor ────────────────────────────────────────────────
  // The object rotate handles (`.dmb-map-rotate-handle`, one per photo-frame /
  // map / shape / sticker / mag-icon) are position:fixed at z-index 999999 and
  // are shown/hidden/tracked by ~10 scattered call sites. That fragility caused
  // recurring bugs: a handle not following its object, not disappearing on
  // deselect, or showing THROUGH a modal that opened over it (it out-ranks every
  // modal on z-index, and nothing hides it). This is a single per-frame safety
  // net that enforces ONE invariant, self-healing whatever a call site missed:
  //   a fixed rotate handle is visible  ⇔  its object is selected + on-screen
  //                                        + no modal/overlay is open.
  // It only does work while something is selected or a handle is showing, so it
  // is free at idle. Fast per-drag tracking still comes from _dmbTrackRotHandle;
  // this just catches the cases those handlers don't (nudge, zoom, re-render,
  // a modal opening, an orphaned/stale handle).
  const _DMB_SEL_OBJ_SEL =
    ".dmb-shape-object.dmb-selected,.dmb-map-object.dmb-selected," +
    ".dmb-photo-frame-object.is-selected,.dmb-sticker-object.is-selected,.dmb-mag-icon-object.is-selected";
  function _dmbGovernRotHandles() {
    // During an active drag the fast per-drag tracker (_dmbTrackRotHandle) already
    // keeps the handle on the object, and no modal can open mid-drag — so skip the
    // governor entirely to keep the perf-sensitive drag path free of its work.
    if (_dmbDragSuppress) return;
    const handles = document.querySelectorAll(".dmb-map-rotate-handle");
    const txt = document.getElementById("dmbTextRotateHandle");
    const txtVisible = !!(txt && txt.classList.contains("is-visible"));
    // Cheap gate (no getComputedStyle): anything to govern this frame?
    let anyHandleShown = txtVisible;
    if (!anyHandleShown) { for (let i = 0; i < handles.length; i++) { if (handles[i].style.display !== "none") { anyHandleShown = true; break; } } }
    const sel = document.querySelector(_DMB_SEL_OBJ_SEL);
    if (!sel && !anyHandleShown) return;   // idle — nothing selected, nothing visible

    const open = _dmbModalOpen();          // pricier check — only reached when active
    const vw = window.innerWidth, vh = window.innerHeight;
    // Reads first (rects), then writes, to avoid layout thrash.
    const wanted = [];
    if (!open && sel) {
      document.querySelectorAll(_DMB_SEL_OBJ_SEL).forEach((el) => {
        const h = el._dmbRotHandle;
        if (!h || !el.isConnected) return;
        const r = el.getBoundingClientRect();
        if ((r.width === 0 && r.height === 0) ||           // not laid out
            r.right < 0 || r.bottom < 0 || r.left > vw || r.top > vh) return;  // off-screen
        h._dmbWantLeft = (r.right + 14) + "px";
        h._dmbWantTop  = (r.bottom + 14) + "px";
        wanted.push(h);
      });
    }
    for (let i = 0; i < handles.length; i++) {
      const h = handles[i];
      if (wanted.indexOf(h) !== -1) {
        h.style.left = h._dmbWantLeft; h.style.top = h._dmbWantTop;
        if (h.style.display === "none") h.style.display = "";
      } else if (h.style.display !== "none") {
        h.style.display = "none";        // deselected / stale / off-screen / modal open
      }
    }
    // Text rotate handle (position:absolute, z 100002 — also out-ranks modals):
    // hide it whenever a modal is open or no text box is selected.
    if (txtVisible) {
      const frame = document.getElementById("dmbTextSelFrame");
      const textSelected = !!(frame && frame.style.display !== "none");
      if (open || !textSelected) txt.classList.remove("is-visible");
    }
  }
  (function _dmbWireRotGovernor() {
    const loop = () => { try { _dmbGovernRotHandles(); } catch (e) {} requestAnimationFrame(loop); };
    requestAnimationFrame(loop);
  })();

  // Phone-style toast: a translucent pill that slides down from the top, holds
  // briefly, then fades out. Used for transient confirmations (e.g. "Restored…").
  function _dmbToast(message, ms) {
    try {
      let host = document.getElementById("dmbToastHost");
      if (!host) {
        host = document.createElement("div");
        host.id = "dmbToastHost";
        document.body.appendChild(host);
      }
      const t = document.createElement("div");
      t.className = "dmb-toast";
      const clean = String(message == null ? "" : message).replace(/^\s*[✅✔✓✅]\s*/, "").trim();
      t.innerHTML = '<span class="dmb-toast-ic"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span class="dmb-toast-txt"></span>';
      t.querySelector(".dmb-toast-txt").textContent = clean;
      host.appendChild(t);
      requestAnimationFrame(() => t.classList.add("dmb-toast-in"));
      const dur = ms || 2000;
      setTimeout(() => {
        t.classList.remove("dmb-toast-in");
        t.classList.add("dmb-toast-out");
        setTimeout(() => { try { t.remove(); } catch (e) {} }, 340);
      }, dur);
    } catch (e) {}
  }

  // Wire the "nothing selected" ribbon (Add tiles + Page quick actions). Each
  // button proxies the existing control so there's a single source of truth.
  (function _dmbWireEmptyRibbon() {
    const ph = document.getElementById("dmbRibbonPlaceholder");
    if (!ph || ph.dataset.dmbWired) return;
    ph.dataset.dmbWired = "1";
    const clickById = (id) => { const b = document.getElementById(id); if (b) b.click(); };
    const clickPageAction = (label) => {
      const b = Array.from(document.querySelectorAll(".dmb-page-action-btn"))
        .find((x) => x.textContent.trim() === label);
      if (b) b.click();
    };
    const ADD = { text: "canvasTextBtn", photo: "canvasPhotoBtn", shape: "canvasShapeBtn", map: "addMyMapBtn", sticker: "dmbStickersBtn" };
    ph.addEventListener("click", (e) => {
      const add = e.target.closest("[data-dmb-add]");
      if (add) { const id = ADD[add.getAttribute("data-dmb-add")]; if (id) clickById(id); return; }
      const pg = e.target.closest("[data-dmb-page]");
      if (!pg) return;
      const act = pg.getAttribute("data-dmb-page");
      if (act === "undo") clickById("undoBtn");
      else if (act === "redo") clickById("redoBtn");
      else if (act === "magic") clickById("smartCreationBtn");
      else if (act === "layout") clickPageAction("Choose layout");
      else if (act === "duplicate") clickPageAction("Duplicate page");
      else if (act === "bg") _dmbOpenDeskBgPop(pg);
    });
  })();

  // ── Desktop "Background" toolbar control ────────────────────────────────────
  // A background-colour picker in the over-canvas ribbon. Works for pages (current
  // spread, Left/Right/Both) AND the cover (recolours coverState.color), for books
  // and magazines alike — mirrors the mobile ribbon's Background popup. The model,
  // rendering and PDF export already honour editor.pageBackgrounds / coverState.color.
  let _deskBgTarget = "both";
  let _deskBgPop = null;
  function _deskTargetPageNums() {
    var bodies = Array.prototype.slice.call(document.querySelectorAll('[data-page-body][data-page-number]'));
    var nums = bodies.map(function (b) { return parseInt(b.getAttribute("data-page-number"), 10); }).filter(function (n) { return isFinite(n); });
    if (!nums.length) return [];
    if (_deskBgTarget === "left") return nums.slice(0, 1);
    if (_deskBgTarget === "right") return nums.slice(-1);
    return nums;
  }
  // One undo step per colour drag: a live (input) scrub pushes once, later scrub
  // events in the same drag reuse that step. Discrete actions always push.
  var _deskBgUndoTaken = false;
  function _deskUndoOnce(label, live) {
    if (!live || !_deskBgUndoTaken) pushUndoState(label);
    _deskBgUndoTaken = !!live;
  }
  function _deskApplyBg(color, live) {
    var isDefault = !color || String(color).toLowerCase() === "#ffffff";
    if (builderMode === "cover") {
      _deskUndoOnce("Cover Background", live);
      coverState.color = isDefault ? "#ffffff" : color;
      try { saveCoverDesignToStorage(); } catch (e) {}
      try { if (coverColorInput) coverColorInput.value = coverState.color; } catch (e) {}
      try { if (coverColorSwatch) coverColorSwatch.style.background = coverState.color; } catch (e) {}
      renderCoverCanvas();
      return;
    }
    var targets = _deskTargetPageNums();
    if (!targets.length) return;
    _deskUndoOnce("Page Background", live);
    if (!editor.pageBackgrounds) editor.pageBackgrounds = {};
    targets.forEach(function (p) { if (isDefault) delete editor.pageBackgrounds[p]; else editor.pageBackgrounds[p] = color; });
    renderBuilderCanvas();
    try { renderThumbsRail(); } catch (e) {}
  }
  function _deskSyncBgUI() {
    var pop = _deskBgPop; if (!pop) return;
    var isCover = (builderMode === "cover");
    var title = pop.querySelector("#dmbDeskBgTitle");
    var toggle = pop.querySelector(".dmb-desk-bg-target");
    if (title) title.textContent = isCover ? "Cover background" : "Page background";
    if (toggle) toggle.style.display = isCover ? "none" : "";
    var cur = "#ffffff";
    if (isCover) cur = coverState.color || "#ffffff";
    else { var t = _deskTargetPageNums(); if (t.length) cur = (editor.pageBackgrounds && editor.pageBackgrounds[t[0]]) || "#ffffff"; }
    var inp = pop.querySelector("#dmbDeskBgInput"); if (inp) inp.value = (cur && cur.charAt(0) === "#") ? cur : "#ffffff";
    var grid = pop.querySelector("#dmbDeskBgSwatches");
    var empty = pop.querySelector("#dmbDeskBgEmpty");
    var recents = (typeof dmbGetRecentColors === "function" ? dmbGetRecentColors() : []) || [];
    if (grid) {
      grid.innerHTML = "";
      recents.slice(0, 10).forEach(function (hex) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "dmb-desk-bg-swatch"; b.dataset.hex = hex; b.style.background = hex;
        if (String(hex).toLowerCase() === String(cur).toLowerCase()) b.classList.add("active");
        grid.appendChild(b);
      });
    }
    if (empty) empty.style.display = recents.length ? "none" : "";
  }
  function _dmbBuildDeskBgPop() {
    if (_deskBgPop) return _deskBgPop;
    var pop = document.createElement("div");
    pop.id = "dmbDeskBgPop";
    // NOT ".dmb-text-color-pop" — that class is managed by _dmbMobileRibbonPopovers,
    // which on desktop strips our inline fixed position and drops the popup to the
    // page's bottom-left. Own class only; shell styling lives in .dmb-desk-bgpop.
    pop.className = "dmb-desk-bgpop";
    pop.hidden = true;
    pop.innerHTML =
      '<div class="dmb-text-color-pop-title" id="dmbDeskBgTitle">Page background</div>' +
      '<div class="dmb-desk-bg-target" role="group" aria-label="Which page">' +
        '<button type="button" data-tgt="left">Left</button>' +
        '<button type="button" data-tgt="right">Right</button>' +
        '<button type="button" data-tgt="both" class="active">Both</button>' +
      '</div>' +
      '<div class="dmb-desk-bg-swatches" id="dmbDeskBgSwatches"></div>' +
      '<div class="dmb-desk-bg-empty" id="dmbDeskBgEmpty">Pick a colour below.</div>' +
      '<button type="button" class="dmb-desk-bg-custom" id="dmbDeskBgCustom">＋ Custom colour…' +
        '<input type="color" class="dmb-desk-bg-input" id="dmbDeskBgInput" value="#ffffff"></button>' +
      '<button type="button" class="dmb-desk-bg-remove" id="dmbDeskBgRemove">Remove background</button>';
    document.body.appendChild(pop);
    _deskBgPop = pop;

    pop.querySelector(".dmb-desk-bg-target").addEventListener("click", function (e) {
      var b = e.target.closest("button[data-tgt]"); if (!b) return;
      _deskBgTarget = b.dataset.tgt;
      pop.querySelectorAll(".dmb-desk-bg-target button").forEach(function (x) { x.classList.toggle("active", x === b); });
    });
    pop.querySelector("#dmbDeskBgSwatches").addEventListener("click", function (e) {
      var sw = e.target.closest(".dmb-desk-bg-swatch"); if (!sw) return;
      _deskApplyBg(sw.dataset.hex); _deskSyncBgUI();
    });
    var inp = pop.querySelector("#dmbDeskBgInput");
    var customBtn = pop.querySelector("#dmbDeskBgCustom");
    customBtn.addEventListener("click", function (e) { if (e.target === inp) return; try { inp.click(); } catch (er) {} });
    inp.addEventListener("input", function () { _deskApplyBg(inp.value, true); });
    inp.addEventListener("change", function () { try { dmbAddRecentColor(inp.value); } catch (e) {} _deskApplyBg(inp.value, true); _deskSyncBgUI(); });
    pop.querySelector("#dmbDeskBgRemove").addEventListener("click", function () { _deskApplyBg(""); _deskSyncBgUI(); });

    document.addEventListener("mousedown", function (e) {
      if (pop.hidden) return;
      if (pop.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-dmb-page="bg"]')) return;
      pop.hidden = true;
    });
    return pop;
  }
  function _dmbOpenDeskBgPop(anchorBtn) {
    var pop = _dmbBuildDeskBgPop();
    if (!pop.hidden) { pop.hidden = true; return; }   // toggle closed
    _deskBgUndoTaken = false;
    _deskSyncBgUI();
    pop.hidden = false;
    try {
      var r = anchorBtn.getBoundingClientRect();
      pop.style.position = "fixed";
      pop.style.top = (r.bottom + 6) + "px";
      pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - 228)) + "px";
      pop.style.zIndex = "2147483000";
    } catch (e) {}
  }

  // On phones the object menu docks inside the horizontally-scrolling ribbon, whose
  // overflow (and the photo dock below) would clip/cover any popup that opens
  // downward. Fix: when a colour palette / dropdown inside the mobile ribbon opens,
  // pin it as a FIXED element ABOVE its button (fixed escapes ancestor overflow),
  // so it floats over the canvas instead of hiding under the photo tray.
  (function _dmbMobileRibbonPopovers() {
    // Every custom popup that can open from the mobile ribbon: the colour wheels
    // (Text/Fill/Border/Shape/Sticker all share .dmb-text-color-pop), the map
    // options menu, and the text-align menu. Native <select> dropdowns already
    // render above everything, so they need no help.
    const POP_SEL = ".dmb-text-color-pop, .dmb-mapopts-menu, .dmb-align-menu";
    const isMob = () => window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches;
    function isOpen(pop) {
      if (pop.hidden) return false;
      const cs = getComputedStyle(pop);
      return cs.display !== "none" && cs.visibility !== "hidden";
    }
    function place(pop) {
      // Pin as a BOTTOM SHEET just above the bottom tab bar (#dmbMshTabs sits at
      // the very bottom of the shell and is always visible). We must NOT anchor
      // above the ribbon: #dmbMshRibbon sits near the TOP of the mobile shell
      // (right under the page-nav), so anchoring above it threw the sheet off the
      // top of the screen — which is why nothing appeared. A bottom-pinned sheet
      // can never fly off-screen regardless of where the ribbon or edit bar live.
      // left+right (not width) stops the compact menus collapsing to a sliver;
      // position:fixed + !important escapes every ancestor's overflow/stacking so
      // it works even if the bar never docked into the ribbon.
      let bottomPx = 12;
      const tabs = document.getElementById("dmbMshTabs");
      if (tabs) { const b = tabs.getBoundingClientRect(); if (b.height > 0) bottomPx = Math.max(12, window.innerHeight - b.top + 8); }
      const set = (k, v) => pop.style.setProperty(k, v, "important");
      set("position", "fixed");
      set("top", "auto");
      set("left", "10px");
      set("right", "10px");
      set("width", "auto");
      set("min-width", "0");
      set("max-width", "none");
      set("bottom", bottomPx + "px");
      set("max-height", Math.max(200, window.innerHeight - bottomPx - 70) + "px");
      set("overflow-y", "auto");
      set("z-index", "2147483000");
    }
    function clear(pop) {
      ["position","top","right","bottom","left","width","min-width","max-width","z-index","max-height","overflow-y"].forEach((p) => pop.style.removeProperty(p));
    }
    // Re-entrancy guard: place()/clear() write inline styles, which the observer
    // would see as new mutations → infinite loop. Ignore mutations we caused.
    let writing = false;
    function sync() {
      if (writing) return;
      writing = true;
      try {
        const mob = isMob();
        document.querySelectorAll(POP_SEL).forEach((pop) => {
          if (mob && isOpen(pop)) place(pop); else clear(pop);
        });
      } finally {
        // Clear the guard on the next macrotask, AFTER the observer has delivered
        // (and we've ignored) the mutations from our own writes. setTimeout — not
        // rAF, which is paused while the tab/pane is backgrounded.
        setTimeout(() => { writing = false; }, 0);
      }
    }
    // Fire on ANY open, however it was triggered — no dependence on the click
    // target or on the bar having docked into the ribbon. The observer catches
    // the hidden/style/class flip that opens the popup.
    try {
      const mo = new MutationObserver(() => sync());
      mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["hidden", "style", "class"] });
    } catch (e) {}
    document.addEventListener("click", () => setTimeout(sync, 0), true);
    window.addEventListener("resize", sync);
    window.addEventListener("scroll", () => { if (isMob()) sync(); }, true);
  })();

  // Unified mobile colour sheet — built to behave EXACTLY like the page-background
  // wheel: a self-contained popup attached to <body>, opened by a simple tap. On
  // phones, EVERY colour-wheel button opens THIS instead of its in-ribbon popup.
  // The in-ribbon popups depended on the object's edit bar docking into the ribbon
  // AND the observer lifting them out of the ribbon's overflow — a chain that was
  // unreliable on iOS ("nothing happens on tap"). Values are written back to each
  // wheel's real hidden <input type=color>, so every existing apply path
  // (text / shape / map / sticker) runs unchanged.
  (function _dmbMshColorSheets() {
    const isMob = () => window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches;
    // wheel button id → [target <input type=color> id, sheet title]
    const WHEELS = {
      dmbTextColorBtn:      ["dmbTextColor",           "Text colour"],
      dmbShapeFillBtn:      ["dmbShapeFill",           "Fill colour"],
      dmbShapeStrokeBtn:    ["dmbShapeStroke",         "Border colour"],
      dmbEditFillBtn:       ["dmbEditFill",            "Fill colour"],
      dmbEditStrokeBtn:     ["dmbEditStroke",          "Border colour"],
      dmbFrameIconColorBtn: ["dmbFrameIconColorInput", "Colour"]
    };
    let sheet = null, target = null;
    function build() {
      if (sheet) return sheet;
      sheet = document.createElement("div");
      sheet.id = "dmbMshColorSheet";
      sheet.className = "dmb-text-color-pop dmb-msh-bgpop";   // the observer floats it as a bottom sheet
      sheet.hidden = true;
      sheet.innerHTML =
        '<div class="dmb-text-color-pop-title" id="dmbMshColorSheetTitle">Colour</div>' +
        '<div class="dmb-msh-bg-swatches" id="dmbMshColorSwatches"></div>' +
        '<div id="dmbMshColorEmpty" style="font-size:12px;color:#9a9a9a;padding:2px 2px 0" hidden>No saved colours yet — pick one with “＋ Custom colour…”.</div>' +
        '<button type="button" class="dmb-msh-bg-custom">＋ Custom colour…' +
          '<input type="color" class="dmb-msh-bg-input dmb-color-overlay" value="#000000"></button>';
      document.body.appendChild(sheet);
      const input = sheet.querySelector(".dmb-msh-bg-input");
      const swWrap = sheet.querySelector("#dmbMshColorSwatches");
      const emptyMsg = sheet.querySelector("#dmbMshColorEmpty");
      // `save` = add to the saved palette. Only true on a FINAL pick (custom change /
      // swatch tap) — NOT during live scrubbing — so the palette only ever holds
      // colours the user actually chose (never generated/proposed).
      const write = (hex, save) => {
        if (!target || !hex) return;
        try {
          target.value = hex;
          target.dispatchEvent(new Event("input",  { bubbles: true }));   // live preview (applies)
          // Only fire 'change' on a FINAL pick — the target's own change listener
          // saves to the palette, so firing it during live scrubbing would add every
          // intermediate colour. Live scrub applies via 'input' only.
          if (save) {
            target.dispatchEvent(new Event("change", { bubbles: true }));
            if (hex.toLowerCase() !== "#ffffff") dmbAddRecentColor(hex);
          }
        } catch (e) {}
      };
      // The palette = the user's SAVED colours (shared with desktop via
      // dmbGetRecentColors / localStorage). No preset/generated swatches.
      sheet._renderSwatches = () => {
        const colors = ((typeof dmbGetRecentColors === "function") ? dmbGetRecentColors() : []) || [];
        swWrap.innerHTML = colors.map((h) =>
          '<button type="button" class="dmb-msh-bg-swatch" data-hex="' + h + '" title="' + h + '" style="background:' + h + '"></button>').join("");
        const has = colors.length > 0;
        swWrap.hidden = !has;
        if (emptyMsg) emptyMsg.hidden = has;
      };
      swWrap.addEventListener("click", (e) => {
        const b = e.target.closest(".dmb-msh-bg-swatch"); if (!b) return;
        // Apply the colour but KEEP the sheet open — it only closes when the user
        // dismisses it (outside tap). Mark the tapped swatch active for feedback.
        e.stopPropagation();
        write(b.dataset.hex, true);
        swWrap.querySelectorAll(".dmb-msh-bg-swatch").forEach((s) => s.classList.toggle("active", s === b));
      });
      const custom = sheet.querySelector(".dmb-msh-bg-custom");
      // NO preventDefault — a bubbled preventDefault cancels the native picker on iOS.
      custom.addEventListener("click", (e) => { e.stopPropagation(); if (e.target === input) return; try { input.click(); } catch (e2) {} });
      input.addEventListener("input",  () => write(input.value, false));   // live preview, not saved
      // Final pick → apply + save + refresh swatches. Do NOT hide the sheet here:
      // some devices fire 'change' WHILE the picker is still open (dragging the
      // gradient), and hiding the sheet removes the <input> the picker is attached
      // to, which dismisses the picker mid-edit. The sheet closes on outside-tap.
      input.addEventListener("change", () => { write(input.value, true); sheet._renderSwatches(); });
      // Outside-tap closes the sheet — but NOT while the native colour picker is up
      // (the picker steals focus; a tap that returns focus must not kill the sheet).
      document.addEventListener("click", (e) => {
        if (sheet.hidden) return;
        if (e.target.closest("#dmbMshColorSheet")) return;
        if (document.activeElement === input) return;   // picker still focused/open
        sheet.hidden = true;
      });
      return sheet;
    }
    function open(inputEl, title) {
      const s = build();
      target = inputEl;
      const t = s.querySelector("#dmbMshColorSheetTitle"); if (t) t.textContent = title || "Colour";
      const input = s.querySelector(".dmb-msh-bg-input");
      try { input.value = /^#[0-9a-f]{6}$/i.test(inputEl.value) ? inputEl.value : "#000000"; } catch (e) {}
      if (typeof s._renderSwatches === "function") s._renderSwatches();   // refresh saved colours each open
      s.hidden = false;
    }
    // Capture phase so we intercept BEFORE each wheel button's own in-ribbon toggle.
    document.addEventListener("click", (e) => {
      if (!isMob()) return;
      for (const btnId in WHEELS) {
        if (e.target.closest("#" + btnId)) {
          const inputEl = document.getElementById(WHEELS[btnId][0]);
          if (inputEl) { e.preventDefault(); e.stopPropagation(); open(inputEl, WHEELS[btnId][1]); }
          return;
        }
      }
    }, true);
  })();

  /* ── 5 mm "safe area" guides ──────────────────────────────────────────────
   * While an object is being dragged, draw a proportional rectangle 5 mm inside
   * each page edge (real A4 = 210 × 297 mm) so the customer can keep content 5 mm
   * clear of the trim. Purely visual: no snapping, no clamping, no messages. The
   * inset is recomputed from each page's current pixel size, so it stays correct
   * at any zoom/screen size (works on laptop and phone alike). Removed on release.
   * ──────────────────────────────────────────────────────────────────────── */
  let _dmbBleedGuideEls = [];
  function _dmbShowBleedGuides() {
    _dmbHideBleedGuides();
    const BLEED_MM = 5;
    // px-per-mm from HEIGHT (always the full page height) → correct 5 mm at any scale.
    // Real page height: A4 = 297 mm, A5 = 210 mm.
    const realHmm = (editor && editor.bookSize === "A5") ? 210 : 297;
    const mkGuide = (host, left, top, width, height) => {
      if (width <= 0 || height <= 0) return;
      const g = document.createElement("div");
      g.className = "dmb-bleed-guide";
      g.style.cssText =
        "position:absolute;pointer-events:none;z-index:2147483647;box-sizing:border-box;" +
        "left:" + left + "px;top:" + top + "px;width:" + width + "px;height:" + height + "px;" +
        "border:1px dashed rgba(107,98,214,.75);border-radius:1px;" +
        // Own compositing layer + contain: the dashed border is rasterized once and just
        // composited, so dragging an object underneath doesn't force it to repaint.
        "transform:translateZ(0);will-change:transform;contain:layout paint;";
      host.appendChild(g);
      _dmbBleedGuideEls.push(g);
    };
    // Interior A4 pages — guide drawn inside each page body. (Hosts already establish
    // a positioning context for their absolute objects, so no getComputedStyle needed
    // — reading it every frame during a re-render forced a reflow and caused drag lag.)
    document.querySelectorAll('#spreadCanvas [data-page-body="true"]').forEach((pg) => {
      const h = pg.clientHeight; if (!h) return;
      const inset = (BLEED_MM / realHmm) * h;
      mkGuide(pg, inset, inset, pg.clientWidth - 2 * inset, pg.clientHeight - 2 * inset);
    });
    // Cover — one guide per FACE (back + front, each a real A4). The cover is drawn as
    // back + spine + front with an object overlay (z:9999) on top, and each face is its
    // own stacking context (z:1), so a face-level guide would hide behind the overlay.
    // Draw the guides on the .dmb-cover-preview container instead, above the overlay,
    // positioned over each face — never across the spine.
    const cover = document.querySelector(".dmb-cover-preview");
    if (cover) {
      cover.querySelectorAll(".dmb-cover-face").forEach((face) => {
        const h = face.clientHeight; if (!h) return;
        const inset = (BLEED_MM / realHmm) * h;
        mkGuide(cover, face.offsetLeft + inset, face.offsetTop + inset, face.clientWidth - 2 * inset, face.clientHeight - 2 * inset);
      });
    }
  }
  function _dmbHideBleedGuides() {
    if (_dmbBleedGuideEls.length) {
      for (let i = 0; i < _dmbBleedGuideEls.length; i++) { try { _dmbBleedGuideEls[i].remove(); } catch (e) {} }
      _dmbBleedGuideEls = [];
    } else {
      const ex = document.querySelectorAll(".dmb-bleed-guide");   // fallback (e.g. leftovers)
      if (ex.length) ex.forEach((g) => g.remove());
    }
  }

  (function _dmbWireDragBarSuppression() {
    const ITEM_SEL = ".dmb-frame-handle,.dmb-photo-frame-object,.dmb-sticker-object,.dmb-mag-icon-object,.dmb-map-object,.dmb-shape-object,.dmb-editable-text,.dmb-map-marker";
    const BAR_SEL  = "#dmbFrameToolbar,#dmbTextToolbar,#dmbMapEditBar,#dmbShapeEditBar";
    document.addEventListener("pointerdown", (e) => {
      const t = e.target;
      if (t && t.closest && t.closest(BAR_SEL)) { _dmbBarDown = null; return; } // clicking a bar button
      const onItem = t && t.closest && t.closest(ITEM_SEL);
      _dmbBarDown = onItem ? { x: e.clientX, y: e.clientY } : null;
    }, true);
    document.addEventListener("pointermove", (e) => {
      if (!_dmbBarDown) return;
      if (_dmbDragSuppress) return;   // already dragging — do NO per-move work (guides
                                      // were created once at drag-start and persist)
      if (Math.hypot(e.clientX - _dmbBarDown.x, e.clientY - _dmbBarDown.y) > 3) {
        _dmbDragSuppress = true;
        _dmbHideBarsForDrag();
        try { _dmbShowBleedGuides(); } catch (e2) {}   // show the 5 mm safe-area guides during the drag
      }
    }, true);
    const _end = () => {
      if (_dmbDragSuppress) { _dmbDragSuppress = false; _dmbReshowBarAfterDrag(); }
      try { _dmbHideBleedGuides(); } catch (e2) {}      // remove guides on release
      _dmbBarDown = null;
    };
    document.addEventListener("pointerup", _end, true);
    document.addEventListener("pointercancel", _end, true);
  })();

  // SAFETY NET for touch drag lag that GROWS over a session: most object drag
  // handlers remove their document "pointermove" listener only on "pointerup", NOT
  // on "pointercancel". On touch a cancelled pointer (second finger, OS reclaim,
  // gesture conflict) then leaks that drag's pointermove handler FOREVER — every
  // future move runs it too, so the builder gets laggier the more you drag. When a
  // cancel lands during an active object drag/press, synthesize a matching pointerup
  // so every handler's onUp cleanup path runs and nothing leaks.
  (function _dmbCancelLeakGuard() {
    let _synth = false;   // reentrancy guard (our synthetic pointerup must not loop)
    document.addEventListener("pointercancel", (e) => {
      if (_synth) return;
      // A bare pointerup is harmless when no drag is active (the per-drag onUp
      // handlers only exist during a drag; nothing else keys off a lone pointerup),
      // so synthesize one on EVERY cancel — this runs whatever cleanup a live drag
      // registered, whether or not the suppression flags were already cleared.
      _synth = true;
      try {
        document.dispatchEvent(new PointerEvent("pointerup", {
          bubbles: true, cancelable: true,
          pointerId: e.pointerId, pointerType: e.pointerType, isPrimary: e.isPrimary,
          clientX: e.clientX, clientY: e.clientY
        }));
      } catch (err) {}
      _synth = false;
    }, true);
  })();

  function hideFrameToolbar() {
    const bar = document.getElementById("dmbFrameToolbar");
    if (bar) bar.classList.remove("is-open");
    document.querySelectorAll(".dmb-photo-frame-object, .dmb-sticker-object").forEach((el) => {
      el.classList.remove("is-selected");
      if (el._dmbRotHandle) el._dmbRotHandle.style.display = "none";
    });
    selectedFrameObject = null;
    try { _dmbUpdateRibbonPlaceholder(); } catch (e) {}
  }

  // Reposition the frame toolbar (and the object's rotation handle) inside a
  // deduped rAF. Reading getBoundingClientRect right after a drag's style write
  // forces a synchronous reflow every frame — doing it in rAF removes that
  // layout thrashing, which is what made touch drag/resize lag ("slack").
  let _dmbToolbarPosRAF = null;
  function _dmbPositionFrameToolbar(bar, el, root) {
    if (_dmbToolbarPosRAF) cancelAnimationFrame(_dmbToolbarPosRAF);
    _dmbToolbarPosRAF = requestAnimationFrame(() => {
      _dmbToolbarPosRAF = null;
      if (!bar || !el || !el.isConnected || !root) return;
      const er = el.getBoundingClientRect();
      // Dock the frame toolbar into the fixed ribbon; the rotate handle stays on
      // the object (fixed-positioned, follows it on scroll).
      bar.classList.add("is-open");
      _dmbDockBar(bar);
      if (el._dmbRotHandle) {
        el._dmbRotHandle.style.left = (er.right + 14) + "px";
        el._dmbRotHandle.style.top = (er.bottom + 14) + "px";
        el._dmbRotHandle.style.display = "";
      }
    });
  }

  function showFrameToolbarFor(el, obj, meta) {
    const bar = document.getElementById("dmbFrameToolbar");
    const root = document.getElementById("dmb-root");
    if (!bar || !root || !el || !obj) return;
    // Remember how to re-open this bar, and stay hidden while a drag is in progress.
    _dmbLastBarShow = () => showFrameToolbarFor(el, obj, meta);
    // (drag no longer hides the bar — it stays open while moving/resizing)

    // During a drag this is called on every pointermove for the SAME object.
    // Only do the one-time selection bookkeeping when the selection actually
    // changes — the rest of the time we just reposition (cheaply, via rAF).
    const _sameSel = selectedFrameObject && selectedFrameObject.id === obj.id && el.classList.contains("is-selected");

    // Fast path while dragging THIS already-selected object: the bar is already open
    // and docked, so skip the per-move re-init and just track the rotate handle.
    if (_dmbDragSuppress && _sameSel) { _dmbTrackRotHandle(el); return; }

    selectedFrameObject = {
      id: obj.id,
      type: obj.type || "sticker",
      targetType: meta?.targetType || obj.targetType || "page",
      pageNumber: meta?.pageNumber ?? obj.page ?? null,
      zone: meta?.zone || obj.zone || null
    };

    // Cheap button-state updates (kept always so e.g. the polaroid shadow label
    // refreshes when toggled while the object stays selected).
    const iconControls = document.getElementById("dmbFrameIconControls");
    if (iconControls) iconControls.style.display = obj.type === "mag-icon" ? "" : "none";
    const _containBtn = document.getElementById("dmbFrameContainBtn");
    if (_containBtn) {
      const _showContain = obj.type !== "photo-frame";
      _containBtn.style.display = _showContain ? "" : "none";
      if (_showContain) _containBtn.textContent = _dmbContainBtnText(obj, meta?.targetType === "cover");
    }
    const _shadowBtn = document.getElementById("dmbFramePolaroidShadowBtn");
    if (_shadowBtn) {
      if (obj.polaroid) {
        _shadowBtn.style.display = "";
        _shadowBtn.textContent = (obj.shadow === false) ? "Shadow: Off" : "Shadow: On";
      } else {
        _shadowBtn.style.display = "none";
      }
    }
    if (obj.type === "mag-icon") {
      const colorInput = document.getElementById("dmbFrameIconColorInput");
      if (colorInput) colorInput.value = obj.color || "#000000";
      try { _dmbSyncFrameIconDot(); } catch (e) {}
    }

    if (!_sameSel) {
      // Heavy one-time work — only on a genuine (re)selection, never per move.
      hideTextToolbar();
      dmbCloseEditBar();
      dmbCloseShapeEditBar();
      document.querySelectorAll(".dmb-photo-frame-object, .dmb-sticker-object").forEach((node) => {
        if (node === el) return;
        node.classList.remove("is-selected");
        if (node._dmbRotHandle) node._dmbRotHandle.style.display = "none";
      });
      el.classList.add("is-selected");
    }

    _dmbPositionFrameToolbar(bar, el, root);
  }

  function ensureFrameToolbar() {
    if (document.getElementById("dmbFrameToolbar")) return;

    const root = document.getElementById("dmb-root");
    if (!root) return;

    const bar = document.createElement("div");
    bar.id = "dmbFrameToolbar";
    bar.className = "dmb-frame-toolbar dmb-ribbon-bar";
    bar.innerHTML = `
      <div class="dmb-ribbon-r1">
        <button type="button" id="dmbFrameShapeBtn" class="dmb-frame-tool-btn dmb-frame-shape-chip" title="Frame shape"><svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13.5,9 19,9.5 15,13.5 16.5,19 11,16 5.5,19 7,13.5 3,9.5 8.5,9" fill="currentColor" stroke="none" opacity="0.45"/></svg> Frame shape</button>
        <button type="button" id="dmbFramePolaroidShadowBtn" class="dmb-frame-tool-btn" title="Toggle polaroid shadow" style="display:none;">Shadow: On</button>
        <span id="dmbFrameIconControls" style="display:none;">
          <span class="dmb-text-color-wrap" id="dmbFrameColorWrap">
            <button type="button" id="dmbFrameIconColorBtn" class="dmb-frame-tool-btn dmb-text-colorwheel" title="Icon colour" aria-haspopup="true">
              <span class="dmb-cw-ring"></span><span class="dmb-cw-dot" id="dmbFrameIconColorDot"></span>
            </button>
            <input type="color" id="dmbFrameIconColorInput" value="#000000" style="position:absolute;opacity:0;pointer-events:none;width:0;height:0;">
            <div class="dmb-text-color-pop" id="dmbFrameColorPop" hidden>
              <div class="dmb-text-color-pop-title">Icon colour</div>
              <button type="button" id="dmbFrameColorCustom" class="dmb-text-color-custom">＋ Custom colour…</button>
            </div>
          </span>
          <button type="button" id="dmbFrameIconFitBtn" class="dmb-frame-tool-btn" title="Fit to page">Fit to page</button>
        </span>
      </div>
      <div class="dmb-ribbon-r2">
        <span class="dmb-rgrp">
          <span class="dmb-seg" role="group" aria-label="Align on page">
            <button type="button" id="dmbFrameAlignLeftBtn" title="Align left on page" aria-label="Align left on page"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="13" y2="12"/><line x1="4" y1="18" x2="17" y2="18"/></svg></button>
            <button type="button" id="dmbFrameAlignCenterBtn" title="Centre on page" aria-label="Centre on page"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="6" y1="18" x2="18" y2="18"/></svg></button>
            <button type="button" id="dmbFrameAlignRightBtn" title="Align right on page" aria-label="Align right on page"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="11" y1="12" x2="20" y2="12"/><line x1="7" y1="18" x2="20" y2="18"/></svg></button>
          </span>
          <span class="dmb-rgl">on page</span>
        </span>
        <span class="dmb-rdiv"></span>
        <span class="dmb-rgrp">
          <span class="dmb-rrow">
            <button type="button" id="dmbFrameFrontBtn" class="dmb-ic-btn" title="Bring forward" aria-label="Bring forward"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg></button>
            <button type="button" id="dmbFrameBackBtn" class="dmb-ic-btn" title="Send backward" aria-label="Send backward"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg></button>
          </span>
          <span class="dmb-rgl">layer</span>
        </span>
        <span class="dmb-rdiv"></span>
        <span class="dmb-rgrp">
          <span class="dmb-rrow">
            <button type="button" id="dmbFrameDuplicateBtn" class="dmb-ic-btn" title="Duplicate" aria-label="Duplicate"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg></button>
            <button type="button" id="dmbFrameContainBtn" class="dmb-contain-chip" title="Contain to page — clip item to page/zone boundary" style="display:none;">Contain: Off</button>
            <button type="button" id="dmbFrameDeleteBtn" class="dmb-ic-btn" title="Delete" aria-label="Delete"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg></button>
          </span>
          <span class="dmb-rgl">edit</span>
        </span>
      </div>
    `;
    root.appendChild(bar);

  ["left", "center", "right"].forEach(function(align) {
    const btnId = { left: "dmbFrameAlignLeftBtn", center: "dmbFrameAlignCenterBtn", right: "dmbFrameAlignRightBtn" }[align];
    document.getElementById(btnId)?.addEventListener("click", () => {
      if (!selectedFrameObject) return;
      const { id, targetType } = selectedFrameObject;
      let obj = null;
      if (targetType === "cover") {
        obj = (editor.coverObjects || []).find(function(o) { return o.id === id; });
      } else {
        Object.values(editor.pageObjects || {}).forEach(function(arr) {
          if (!obj) { const f = arr.find(function(o) { return o.id === id; }); if (f) obj = f; }
        });
      }
      const el = document.querySelector(`[data-object-id="${id}"]`);
      if (!obj || !el) return;
      dmbAlignObjectInZone(el, obj, align, targetType);
      showFrameToolbarFor(el, obj, { targetType, pageNumber: selectedFrameObject.pageNumber, zone: selectedFrameObject.zone });
    });
  });

  document.getElementById("dmbFrameDuplicateBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Duplicate Frame");
    const dup = duplicateFrameObjectByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    if (dup) {
      requestAnimationFrame(() => {
        const el = document.querySelector(`.dmb-photo-frame-object[data-object-id="${dup.id}"]`);
        if (el) {
          showFrameToolbarFor(el, dup, {
            targetType: dup.targetType,
            pageNumber: dup.page ?? null,
            zone: dup.zone || null
          });
        }
      });
    }
  });

  document.getElementById("dmbFrameFrontBtn")?.addEventListener("click", () => {
    _dmbDoLayerStep(_dmbSelectedFrameEl(), "forward");
  });

  document.getElementById("dmbFrameBackBtn")?.addEventListener("click", () => {
    _dmbDoLayerStep(_dmbSelectedFrameEl(), "backward");
  });

  document.getElementById("dmbFrameShapeBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    const btn = document.getElementById("dmbFrameShapeBtn");
    if (!btn) return;
    showDmbFramePicker(btn, obj ? (obj.frameShape || "") : "", (shapeId) => {
      if (obj) {
        obj.frameShape = shapeId;
        const el = document.querySelector(`[data-object-id="${selectedFrameObject.id}"] img`);
        if (el) applyDmbFrameShape(el, shapeId);
      }
      if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    });
  });

  document.getElementById("dmbFramePolaroidShadowBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    if (!obj || !obj.polaroid) return;
    pushUndoState("Toggle Polaroid Shadow");
    obj.shadow = (obj.shadow === false) ? true : false;
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    requestAnimationFrame(() => {
      const el = document.querySelector(`.dmb-photo-frame-object[data-object-id="${obj.id}"]`);
      if (el) showFrameToolbarFor(el, obj, {
        targetType: selectedFrameObject.targetType,
        pageNumber: selectedFrameObject.pageNumber,
        zone: selectedFrameObject.zone
      });
    });
  });

  document.getElementById("dmbFrameDeleteBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Delete Frame");
    deleteFrameObjectByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    hideFrameToolbar();
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
  });

  // ── Full desktop keyboard control of the selected canvas object ─────────────
  //   Delete/Backspace = delete · arrows = nudge (Shift = 10px, else 1px) ·
  //   Ctrl/⌘+D = duplicate · Ctrl/⌘+C / V = copy / paste · Ctrl/⌘+Z = undo ·
  //   Ctrl/⌘+Shift+Z or Ctrl+Y = redo · Esc = deselect.
  //   Works for photo frames, stickers, magazine icons, shapes, maps and text.
  //   All shortcuts are ignored while typing in a text box / input so they never
  //   eat characters (the browser's own text editing + undo keep working there).
  let _dmbClipboard = null;
  let _dmbNudgeBurst = false, _dmbNudgeTimer = null;
  function _dmbBeginNudgeUndo() {
    if (!_dmbNudgeBurst) {
      pushUndoState("Move");                 // one undo entry per burst
      _dmbNudgeBurst = true;
      _dmbDragSuppress = true;               // hide the floating menu while nudging…
      try { _dmbHideBarsForDrag(); } catch (e) {}
    }
    clearTimeout(_dmbNudgeTimer);
    _dmbNudgeTimer = setTimeout(() => {       // …and bring it back once the keys go quiet
      _dmbNudgeBurst = false;
      _dmbDragSuppress = false;
      try { _dmbReshowBarAfterDrag(); } catch (e) {}
    }, 500);
  }
  function _dmbActiveSel() {
    if (typeof selectedTextNode !== "undefined" && selectedTextNode && selectedTextNode.isConnected) return { kind: "text", node: selectedTextNode };
    if (dmbEditingMapObj && dmbEditingMapEl && dmbEditingMapEl.isConnected) return { kind: "map", obj: dmbEditingMapObj, el: dmbEditingMapEl };
    if (dmbEditingShapeObj && dmbEditingShapeEl && dmbEditingShapeEl.isConnected) return { kind: "shape", obj: dmbEditingShapeObj, el: dmbEditingShapeEl };
    if (selectedFrameObject) {
      const el = document.querySelector('[data-object-id="' + selectedFrameObject.id + '"]');
      const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
      if (el && obj) return { kind: "frame", obj, el, sfo: selectedFrameObject };
    }
    return null;
  }
  function _dmbReselectObj(obj) {
    const el = document.querySelector('[data-object-id="' + obj.id + '"]');
    if (!el) return;
    if (obj.type === "map")        { try { dmbOpenEditBar(obj, el); } catch (e) {} }
    else if (obj.type === "shape") { try { dmbOpenShapeEditBar(obj, el); } catch (e) {} }
    else { try { showFrameToolbarFor(el, obj, { targetType: obj.targetType, pageNumber: obj.page, zone: obj.zone }); } catch (e) {} }
  }

  // ── Click-through selection ────────────────────────────────────────────────
  // A text box has a big, mostly-transparent hit area, so a small shape tucked
  // under it is hard to click. These helpers let a click that lands on a text
  // box's EMPTY area (or an Alt-click anywhere) select the item BENEATH instead.
  function _dmbFindAnyObjectById(id) {
    return dmbFindObjectById(id, "page") || dmbFindObjectById(id, "cover");
  }
  // True when (x,y) is over the node's actual glyphs (not its transparent padding).
  function _dmbPointOnGlyphs(node, x, y) {
    try {
      const r = document.createRange();
      r.selectNodeContents(node);
      const rects = r.getClientRects();
      const PAD = 4;
      for (const rc of rects) {
        if (rc.width < 0.5 && rc.height < 0.5) continue;
        if (x >= rc.left - PAD && x <= rc.right + PAD && y >= rc.top - PAD && y <= rc.bottom + PAD) return true;
      }
    } catch (e) {}
    return false;
  }
  // The topmost selectable canvas item under (x,y), skipping `exceptEl` and the
  // floating toolbars. Returns { el, obj } or null.
  function _dmbSelectableBeneath(x, y, exceptEl) {
    let stack = [];
    try { stack = document.elementsFromPoint(x, y) || []; } catch (e) { return null; }
    for (const el of stack) {
      if (!el || el === exceptEl || (exceptEl && exceptEl.contains && exceptEl.contains(el))) continue;
      if (el.closest && (el.closest("#dmbTextToolbar") || el.closest("#dmbFrameToolbar") ||
                         el.closest(".dmb-map-edit-bar") || el.closest(".dmb-text-sel-frame"))) continue;
      // Frames, stickers, shapes and maps all carry data-object-id.
      const objEl = el.closest && el.closest("[data-object-id]");
      if (objEl && objEl !== exceptEl) {
        const obj = _dmbFindAnyObjectById(objEl.getAttribute("data-object-id"));
        if (obj) return { el: objEl, obj };
      }
      // Another text box beneath.
      const txt = el.closest && el.closest(".dmb-editable-text");
      if (txt && txt !== exceptEl) return { el: txt, obj: { __text: true, node: txt } };
    }
    return null;
  }
  // Select a specific item (any type) by its element/obj.
  function _dmbSelectObjectEl(obj, el) {
    if (!obj) return;
    if (obj.__text) { try { showTextToolbarFor(obj.node); } catch (e) {} return; }
    try { hideTextToolbar(); } catch (e) {}
    if (obj.type === "map")        { try { dmbOpenEditBar(obj, el); } catch (e) {} }
    else if (obj.type === "shape") { try { dmbOpenShapeEditBar(obj, el); } catch (e) {} }
    else { try { showFrameToolbarFor(el, obj, { targetType: obj.targetType, pageNumber: obj.page, zone: obj.zone }); } catch (e) {} }
  }
  function _dmbNudge(sel, dx, dy) {
    _dmbBeginNudgeUndo();
    if (sel.kind === "text") {
      const n = sel.node;
      // Resolve through _dmbLenPx first: a spine title's top is "50%", and adding dy
      // to the bare number 50 turned one arrow press into a 162px jump up the cover.
      // Converting to px HERE is right - the user is moving it, so it becomes an
      // absolute position - but it must convert from where the text actually is.
      n.style.left = (_dmbLenPx(n, "left") + dx) + "px";
      n.style.top  = (_dmbLenPx(n, "top")  + dy) + "px";
      try { saveCoverTextNodeState(n); } catch (e) {}
      try { savePageTextState(n); } catch (e) {}
      try { showTextToolbarFor(n); } catch (e) {}
      // Show the same alignment/spacing guides as a mouse drag (no snapping).
      try {
        const parent = n.parentElement;
        if (parent) {
          const { gH, gV } = dmbGetSnapGuides(parent);
          const _isCover = !!parent.closest(".dmb-cover-preview");
          const _tpn = parseInt(n.dataset.pageNumber);
          const _tmeta = _isCover ? { targetType: "cover" } : (Number.isFinite(_tpn) ? { targetType: "page", pageNumber: _tpn } : null);
          const _PL = 6, _PT = 2;   // matches text padding 2px 6px (glyph box)
          const _gw = Math.max(0, (n.offsetWidth || 132) - _PL * 2) || 120;
          const _gh = Math.max(0, (n.offsetHeight || 34) - _PT * 2) || 26;
          const _st = { id: n.id, x: _dmbLenPx(n, "left") + _PL, y: _dmbLenPx(n, "top") + _PT, w: _gw, h: _gh };
          dmbCheckSnap(_st, parent, gH, gV, _tmeta, true);
        }
      } catch (e) {}
      return;
    }
    const obj = sel.obj, el = sel.el;
    if (sel.kind === "shape" && obj.shapeType === "line") {
      _dmbLineMigrate(obj);
      obj.x1 += dx; obj.y1 += dy; obj.x2 += dx; obj.y2 += dy;
      if (obj.bx != null) { obj.bx += dx; obj.by += dy; }
      try { _dmbLineRefreshEl(obj, el); } catch (e) {}
      try { dmbOpenShapeEditBar(obj, el); } catch (e) {}
      try { _dmbInvalidateSibCache(); } catch (e) {}
      return;
    }
    obj.x = (obj.x || 0) + dx; obj.y = (obj.y || 0) + dy;
    el.style.left = obj.x + "px"; el.style.top = obj.y + "px";
    if (obj.coverZone) { try { dmbApplyZoneClip(el, obj); } catch (e) {} }
    const _meta = sel.sfo ? { targetType: sel.sfo.targetType, pageNumber: sel.sfo.pageNumber, zone: sel.sfo.zone } : { targetType: obj.targetType, pageNumber: obj.page, zone: obj.zone };
    if (sel.kind === "map")        { try { dmbOpenEditBar(obj, el); } catch (e) {} }
    else if (sel.kind === "shape") { try { dmbOpenShapeEditBar(obj, el); } catch (e) {} }
    else { try { showFrameToolbarFor(el, obj, _meta); } catch (e) {} }
    try { _dmbInvalidateSibCache(); } catch (e) {}
    // Show the same guides/labels as a mouse drag (render only, no snapping).
    try {
      const container = el.closest('[data-page-body="true"], .dmb-cover-preview') || el.parentElement;
      if (container) { const { gH, gV } = dmbGetSnapGuides(container); dmbCheckSnap(obj, container, gH, gV, { targetType: _meta.targetType, pageNumber: _meta.pageNumber }, true); }
    } catch (e) {}
  }
  function _dmbClickBtn(id) { const b = document.getElementById(id); if (b) { b.click(); return true; } return false; }
  // ══════════════════════════════════════════════════════════════════════════
  // MULTI-SELECT, stage 1: ctrl or cmd click to add and remove, then move, nudge
  // or delete the whole set together.
  //
  // Built ALONGSIDE the single-selection model, not in place of it. Every edit bar,
  // resize frame and per-type drag handler in this file assumes exactly one selected
  // thing, and rewriting that is where the risk lives. It is also not needed for a
  // group move: a set of two or more simply takes precedence, intercepting the press
  // in the CAPTURE phase before the per-type drag can start, and handing control back
  // the moment the set drops below two. (2026-10-12)
  const _DMB_SEL_SEL = ".dmb-editable-text, .dmb-map-object, .dmb-shape-object, " +
                       ".dmb-photo-frame-object, .dmb-sticker-object";
  let _dmbMulti = [];                                  // [{ el, isText, id }]

  function _dmbMultiCount() {
    _dmbMulti = _dmbMulti.filter((m) => m && m.el && m.el.isConnected);
    return _dmbMulti.length;
  }
  function _dmbMultiIndexOf(el) {
    for (let i = 0; i < _dmbMulti.length; i++) if (_dmbMulti[i].el === el) return i;
    return -1;
  }
  function _dmbMultiPaint() {
    try {
      document.querySelectorAll(".dmb-multi-sel").forEach((n) => n.classList.remove("dmb-multi-sel"));
      _dmbMulti.forEach((m) => { if (m.el && m.el.isConnected) m.el.classList.add("dmb-multi-sel"); });
    } catch (e) {}
  }
  function _dmbMultiClear() { _dmbMulti = []; _dmbMultiPaint(); }

  // The object record plus the array that owns it. Objects can live on any page or on
  // the cover, and the DOM only carries the id, so this is the bridge back to state.
  function _dmbFindObjRecord(id) {
    if (!id) return null;
    try {
      if (Array.isArray(editor.coverObjects)) {
        const c = editor.coverObjects.find((o) => o && o.id === id);
        if (c) return { obj: c, list: editor.coverObjects };
      }
      const po = editor.pageObjects || {};
      const keys = Object.keys(po);
      for (let i = 0; i < keys.length; i++) {
        const arr = po[keys[i]];
        if (!Array.isArray(arr)) continue;
        const o = arr.find((v) => v && v.id === id);
        if (o) return { obj: o, list: arr };
      }
    } catch (e) {}
    return null;
  }

  // Text keeps its position in CSS; everything else keeps it in the model.
  function _dmbMultiPos(m) {
    try {
      if (m.isText) return { x: _dmbLenPx(m.el, "left"), y: _dmbLenPx(m.el, "top") };
      const rec = _dmbFindObjRecord(m.id);
      if (!rec) return null;
      return { x: rec.obj.x || 0, y: rec.obj.y || 0 };
    } catch (e) { return null; }
  }

  function _dmbMultiMoveTo(m, x, y) {
    try {
      if (m.isText) {
        m.el.style.left = Math.round(x) + "px";
        m.el.style.top  = Math.round(y) + "px";
        return;
      }
      const rec = _dmbFindObjRecord(m.id);
      if (!rec) return;
      const o = rec.obj;
      const ddx = x - (o.x || 0), ddy = y - (o.y || 0);
      o.x = x; o.y = y;
      // A line's box is DERIVED from its endpoints, so they have to travel too or the
      // next recompute pulls it straight back to where it was.
      if (o.type === "shape" && o.shapeType === "line") {
        if (o.x1 != null) o.x1 += ddx;
        if (o.x2 != null) o.x2 += ddx;
        if (o.bx != null) o.bx += ddx;
        if (o.y1 != null) o.y1 += ddy;
        if (o.y2 != null) o.y2 += ddy;
        if (o.by != null) o.by += ddy;
      }
      m.el.style.left = Math.round(x) + "px";
      m.el.style.top  = Math.round(y) + "px";
    } catch (e) {}
  }

  function _dmbMultiSave() {
    try {
      _dmbMulti.forEach((m) => {
        if (!m.isText || !m.el || !m.el.isConnected) return;
        saveCoverTextNodeState(m.el);
        savePageTextState(m.el);
      });
    } catch (e) {}
    try { saveCoverDesignToStorage(); } catch (e) {}
    try { _dmbWriteProgressState(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
  }

  function _dmbMultiNudge(dx, dy) {
    if (_dmbMultiCount() < 1) return false;
    pushUndoState("Move Selection");
    _dmbMulti.forEach((m) => {
      const p = _dmbMultiPos(m);
      if (p) _dmbMultiMoveTo(m, p.x + dx, p.y + dy);
    });
    _dmbMultiSave();
    return true;
  }

  function _dmbMultiDelete() {
    if (_dmbMultiCount() < 1) return false;
    pushUndoState("Delete Selection");
    const members = _dmbMulti.slice();
    _dmbMultiClear();
    members.forEach((m) => {
      try {
        if (m.isText) {
          if (typeof _dmbRemoveTextNode === "function") _dmbRemoveTextNode(m.el);
          else if (m.el && m.el.isConnected) m.el.remove();
          return;
        }
        const rec = _dmbFindObjRecord(m.id);
        if (rec) {
          const i = rec.list.indexOf(rec.obj);
          if (i >= 0) rec.list.splice(i, 1);
        }
        if (m.el && m.el.isConnected) m.el.remove();
      } catch (e) {}
    });
    try { _dmbDeselectAll(); } catch (e) {}
    try { if (builderMode === "cover") renderCoverCanvas(); else renderSpread(); } catch (e) {}
    try { renderThumbsRail(); } catch (e) {}
    _dmbMultiSave();
    return true;
  }

  // ---- ctrl / cmd click toggles membership -------------------------------
  document.addEventListener("pointerdown", function (e) {
    try {
      if (!(e.ctrlKey || e.metaKey)) return;
      const el = (e.target && e.target.closest) ? e.target.closest(_DMB_SEL_SEL) : null;
      if (!el) return;
      e.preventDefault(); e.stopPropagation();
      const i = _dmbMultiIndexOf(el);
      if (i >= 0) _dmbMulti.splice(i, 1);
      else _dmbMulti.push({
        el: el,
        isText: el.classList.contains("dmb-editable-text"),
        id: (el.dataset && el.dataset.objectId) || el.id || "",
      });
      _dmbMultiPaint();
    } catch (err) {}
  }, true);

  // ---- a plain press on a member drags the whole group --------------------
  document.addEventListener("pointerdown", function (e) {
    try {
      if (e.ctrlKey || e.metaKey) return;
      if (_dmbMultiCount() < 2) return;
      const el = (e.target && e.target.closest) ? e.target.closest(_DMB_SEL_SEL) : null;
      if (!el || _dmbMultiIndexOf(el) < 0) {
        // Pressing the CANVAS drops the group. Pressing a toolbar must not, or every
        // attempt to act on the selection would destroy it first.
        const onCanvas = e.target && e.target.closest &&
          e.target.closest('[data-page-body="true"], #coverOverlay, [data-spread-row]');
        if (onCanvas) _dmbMultiClear();
        return;
      }
      e.preventDefault(); e.stopPropagation();
      const Z = (typeof _nodeOnScreenScale === "function" ? (_nodeOnScreenScale(el) || 1) : 1);
      const sx = e.clientX, sy = e.clientY;
      const start = _dmbMulti.map((m) => ({ m: m, p: _dmbMultiPos(m) })).filter((r) => r.p);
      let moved = false;
      const onMove = function (ev) {
        const dx = (ev.clientX - sx) / Z, dy = (ev.clientY - sy) / Z;
        // A 2px threshold so a plain click on a member does not count as a move and
        // push a pointless undo step.
        if (!moved && Math.abs(dx) < 2 && Math.abs(dy) < 2) return;
        if (!moved) { moved = true; try { pushUndoState("Move Selection"); } catch (er) {} }
        start.forEach((r) => _dmbMultiMoveTo(r.m, r.p.x + dx, r.p.y + dy));
      };
      const onUp = function () {
        document.removeEventListener("pointermove", onMove, true);
        document.removeEventListener("pointerup", onUp, true);
        document.removeEventListener("pointercancel", onUp, true);
        if (moved) _dmbMultiSave();
      };
      document.addEventListener("pointermove", onMove, true);
      document.addEventListener("pointerup", onUp, true);
      document.addEventListener("pointercancel", onUp, true);
    } catch (err) {}
  }, true);

  // ---- marquee: drag on empty canvas to select what it covers --------------
  // The test is done entirely in CLIENT coordinates, comparing getBoundingClientRect
  // of the marquee against each candidate. That is deliberate: objects live in
  // per-page coordinates, the two pages of a spread sit at different offsets, the
  // canvas has its own zoom, and rotated items have a box that does not match their
  // stored x/y/w/h. Converting all of that would be four chances to be subtly wrong.
  // Screen space is already the common space, and because zoom scales the marquee and
  // the objects equally, an AREA RATIO measured there is exactly the ratio the
  // customer sees. (2026-10-12)
  const _DMB_MARQUEE_COVER = 0.9;        // how much of an item must be inside

  // Things that sit INSIDE a page but are not the page: resize and rotate handles,
  // the text selection frame, the spread photo layer, the little menus. Each starts
  // a drag of its own, and several of them are SIBLINGS of the object they belong to
  // rather than children, so the "started on an item" test above cannot see them.
  // Without this, resizing a text box by a corner dot ALSO dragged a selection
  // rectangle across the page: both gestures armed on the same press, and this one
  // listens in the capture phase, so the handle's own stopPropagation came too late
  // to prevent it. The [class*="handle"] entry is deliberately broad, so a handle
  // added later is covered without anyone having to remember this list. (2026-10-13)
  const _DMB_NO_MARQUEE = '[class*="handle"], [data-handle], [data-h], ' +
    '.dmb-text-sel-frame, .dmb-text-sel-h, .dmb-map-marker, ' +
    '.dmb-photo-menu, .dmb-photo-hover-menu, [data-spread-img-layer], ' +
    '.dmb-insert-zone, .dmb-page-del';

  // Drop any native text selection. Guarded because a selection inside an ACTIVE
  // edit is the caret: clearing that would throw the customer out of their own
  // typing position, so a box being edited is left alone.
  function _dmbDropNativeSelection() {
    try {
      const sel = window.getSelection();
      if (!sel || sel.isCollapsed || !sel.rangeCount) return;
      const a = document.activeElement;
      if (a && a.isContentEditable && a.classList &&
          a.classList.contains("is-editing")) return;
      sel.removeAllRanges();
    } catch (e) {}
  }

  function _dmbMarqueeSelect(r, add) {
    try {
      if (!add) _dmbMulti = [];
      document.querySelectorAll(_DMB_SEL_SEL).forEach(function (el) {
        if (!el || !el.isConnected) return;
        const b = el.getBoundingClientRect();
        const area = b.width * b.height;
        if (area <= 0) return;                       // hidden or not laid out
        const ix = Math.max(0, Math.min(r.right, b.right) - Math.max(r.left, b.left));
        const iy = Math.max(0, Math.min(r.bottom, b.bottom) - Math.max(r.top, b.top));
        if ((ix * iy) / area < _DMB_MARQUEE_COVER) return;
        if (_dmbMultiIndexOf(el) >= 0) return;
        _dmbMulti.push({
          el: el,
          isText: el.classList.contains("dmb-editable-text"),
          id: (el.dataset && el.dataset.objectId) || el.id || "",
        });
      });
      _dmbMultiPaint();
    } catch (e) {}
  }

  document.addEventListener("pointerdown", function (e) {
    try {
      if (e.button !== 0) return;
      const t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(_DMB_SEL_SEL)) return;           // started on an item, not the canvas
      if (t.closest("input, textarea, select, button, .dmb-ribbon-bar")) return;
      if (t.closest(_DMB_NO_MARQUEE)) return;        // started on something that drags itself
      if (!t.closest('[data-page-body="true"], #coverOverlay, [data-spread-row]')) return;

      // Holding a modifier ADDS to the existing group instead of replacing it.
      const add = !!(e.ctrlKey || e.metaKey || e.shiftKey);
      const sx = e.clientX, sy = e.clientY;
      let box = null, armed = false;

      const onMove = function (ev) {
        const dx = ev.clientX - sx, dy = ev.clientY - sy;
        // Arm only once this is clearly a drag, so a plain click still falls through to
        // the canvas deselect handler exactly as before.
        if (!armed) {
          if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
          armed = true;
          // Dragging across a page also drags a native TEXT selection through every
          // caption it crosses (the boxes are contenteditable). Suppressing it needs
          // both halves: the class stops any NEW selection from extending, and the
          // clear below drops whatever the browser already took between pointerdown
          // and the 4px arm threshold.
          document.body.classList.add("dmb-marquee-on");
          _dmbDropNativeSelection();
          box = document.createElement("div");
          box.className = "dmb-marquee";
          document.body.appendChild(box);
        }
        _dmbDropNativeSelection();
        box.style.left   = Math.min(sx, ev.clientX) + "px";
        box.style.top    = Math.min(sy, ev.clientY) + "px";
        box.style.width  = Math.abs(dx) + "px";
        box.style.height = Math.abs(dy) + "px";
        ev.preventDefault();
      };
      const onUp = function () {
        document.removeEventListener("pointermove", onMove, true);
        document.removeEventListener("pointerup", onUp, true);
        document.removeEventListener("pointercancel", onUp, true);
        document.body.classList.remove("dmb-marquee-on");   // before the early return
        if (!armed || !box) return;                  // it was a click, not a drag
        _dmbDropNativeSelection();
        const r = box.getBoundingClientRect();
        box.remove();
        _dmbMarqueeSelect(r, add);
      };
      document.addEventListener("pointermove", onMove, true);
      document.addEventListener("pointerup", onUp, true);
      document.addEventListener("pointercancel", onUp, true);
    } catch (err) {}
  }, true);

  // ---- group copy and duplicate -------------------------------------------
  // Both go through the EXISTING per-type duplicators rather than a second
  // implementation. Duplicating text is not a matter of cloning a node: it has to be
  // registered in coverUserTexts or pageObjects, get its handlers attached and a fresh
  // z assigned, and a parallel copy of that logic is exactly how two paths drift apart
  // and one of them starts producing text the PDF cannot see.
  //
  // Those helpers each push their own undo state, so the batch suppresses
  // pushUndoState for its duration and pushes exactly one step itself. Both the object
  // and the text duplicators offset by the same +20, so a group keeps its internal
  // layout precisely. (2026-10-12)
  let _dmbMultiClip = null;

  function _dmbMultiIdSet() {
    const out = new Set();
    try {
      document.querySelectorAll(_DMB_SEL_SEL).forEach(function (el) {
        out.add((el.dataset && el.dataset.objectId) || el.id || "");
      });
    } catch (e) {}
    return out;
  }

  // Whatever appeared since `before` is the new copy, whatever type it is. Diffing ids
  // avoids every duplicator having to report back what it made.
  function _dmbMultiSelectNewSince(before) {
    try {
      _dmbMulti = [];
      document.querySelectorAll(_DMB_SEL_SEL).forEach(function (el) {
        const id = (el.dataset && el.dataset.objectId) || el.id || "";
        if (!id || before.has(id)) return;
        _dmbMulti.push({ el: el, isText: el.classList.contains("dmb-editable-text"), id: id });
      });
      _dmbMultiPaint();
    } catch (e) {}
  }

  function _dmbMultiDuplicate(label) {
    if (_dmbMultiCount() < 1) return false;
    const members = _dmbMulti.slice();
    const before = _dmbMultiIdSet();
    const _realPush = pushUndoState;
    _realPush(label || "Duplicate Selection");
    try {
      pushUndoState = function () {};          // one step for the whole batch
      members.forEach(function (m) {
        try {
          if (m.isText) {
            if (!m.el || !m.el.isConnected) return;
            selectedTextNode = m.el;           // the toolbar button acts on the selection
            _dmbClickBtn("dmbDuplicateTextBtn");
            return;
          }
          const rec = _dmbFindObjRecord(m.id);
          if (!rec || !rec.obj) return;
          const o = rec.obj;
          duplicateFrameObjectByTarget(o.targetType, o.page, o.zone, o.id);
        } catch (e) {}
      });
    } finally {
      pushUndoState = _realPush;
    }
    try { if (builderMode === "cover") renderCoverCanvas(); else renderSpread(); } catch (e) {}
    try { renderThumbsRail(); } catch (e) {}
    _dmbMultiSave();
    // The copies become the selection, so the next drag moves the new ones and the
    // originals stay where they are.
    requestAnimationFrame(function () { _dmbMultiSelectNewSince(before); });
    return true;
  }

  function _dmbMultiCopy() {
    if (_dmbMultiCount() < 1) return false;
    _dmbMultiClip = _dmbMulti.map(function (m) { return { id: m.id, isText: m.isText }; });
    return true;
  }

  function _dmbMultiPaste() {
    if (!_dmbMultiClip || !_dmbMultiClip.length) return false;
    // Re-resolve against the live DOM: the copied items may have been moved, edited or
    // deleted between the copy and the paste.
    const live = [];
    _dmbMultiClip.forEach(function (c) {
      let el = null;
      try {
        el = c.isText ? document.getElementById(c.id)
                      : document.querySelector('[data-object-id="' + c.id + '"]');
      } catch (e) {}
      if (el && el.isConnected) live.push({ el: el, isText: c.isText, id: c.id });
    });
    if (!live.length) return false;
    const keep = _dmbMulti;
    _dmbMulti = live;
    const ok = _dmbMultiDuplicate("Paste Selection");
    if (!ok) _dmbMulti = keep;
    return ok;
  }

  // The group had a bounding box with corner handles here (proportional resize of
  // the whole selection). REMOVED at the owner's request on 2026-10-13: every
  // selected item already draws its own frame, so a second box around them read as
  // clutter rather than a control. The selection itself is unchanged - it still
  // moves, nudges, deletes, copies and duplicates as a group; only the extra box
  // and the resize-by-handle it carried are gone.

  function _dmbDoDelete(sel) {
    if (sel.kind === "text")  return _dmbClickBtn("dmbDeleteTextBtn");
    if (sel.kind === "map")   return _dmbClickBtn("dmbEditDelete");
    if (sel.kind === "shape") return _dmbClickBtn("dmbShapeDelete");
    return _dmbClickBtn("dmbFrameDeleteBtn");
  }
  function _dmbDoDuplicate(sel) {
    if (sel.kind === "text")  return _dmbClickBtn("dmbDuplicateTextBtn");
    if (sel.kind === "frame") return _dmbClickBtn("dmbFrameDuplicateBtn");
    if (sel.kind === "shape") return _dmbClickBtn("dmbShapeDuplicateBtn");
    // map has no toolbar Dup button → duplicate generically
    const obj = sel.obj;
    pushUndoState("Duplicate");
    const dup = duplicateFrameObjectByTarget(obj.targetType, obj.page, obj.zone, obj.id);
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    if (dup) requestAnimationFrame(() => _dmbReselectObj(dup));
    return true;
  }
  function _dmbDoCopy(sel) {
    if (sel.kind === "text") { _dmbClipboard = { kind: "text", node: sel.node }; return; }
    _dmbClipboard = { kind: "obj", data: cloneState(sel.obj) };
  }
  function _dmbDoPaste() {
    if (!_dmbClipboard) return;
    if (_dmbClipboard.kind === "text") { if (_dmbClipboard.node && _dmbClipboard.node.isConnected) { selectedTextNode = _dmbClipboard.node; _dmbClickBtn("dmbDuplicateTextBtn"); } return; }
    const d = _dmbClipboard.data; if (!d) return;
    pushUndoState("Paste");
    const copy = { ...cloneState(d), id: uid(), x: (d.x || 0) + 14, y: (d.y || 0) + 14, z: Date.now() };
    const list = getObjectListForTarget(d.targetType, d.page, d.zone);
    if (!list) return;
    list.push(copy);
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    requestAnimationFrame(() => _dmbReselectObj(copy));
  }
  function _dmbDeselectAll() {
    try { hideFrameToolbar(); } catch (e) {}
    try { hideTextToolbar(); } catch (e) {}
    try { dmbCloseEditBar(); } catch (e) {}
    try { dmbCloseShapeEditBar(); } catch (e) {}
  }
  // True when a builder modal/overlay is open — the canvas shortcuts must NOT fire then
  // (e.g. the crop or spread-preview overlays own the arrow keys; a dialog owns Enter/Esc).
  function _dmbModalOpen() {
    const ids = ["dmbDupPageModal", "dmbCropOverlay", "dmbPreviewOverlay", "dmbTutorialModal", "dmbMapModal",
      "dmbStickerModal", "dmbMagIconModal", "dmbCustomStickerModal", "dmbCoverTemplateModal", "dmbCardModal",
      "dmbMobileQualityModal", "dmbResumeModal", "dmbPhoneUploadModal", "dmbPdfOverlay", "dmbPublishTplModal"];
    for (let i = 0; i < ids.length; i++) {
      const el = document.getElementById(ids[i]);
      if (el && getComputedStyle(el).display !== "none") return true;
    }
    // Fallback: any full-screen high-z fixed overlay dropped straight on <body> (e.g. the
    // generic choice dialog), but never the builder itself.
    const kids = document.body.children;
    for (let i = 0; i < kids.length; i++) {
      const el = kids[i];
      if (!el || el.nodeType !== 1) continue;
      if (el.querySelector && el.querySelector('[data-page-body], #dmb-root, .dmb-builder-leftpanel')) continue;
      const cs = getComputedStyle(el);
      if (cs.position !== "fixed" || cs.display === "none" || cs.visibility === "hidden") continue;
      if ((parseInt(cs.zIndex) || 0) < 9999) continue;
      const r = el.getBoundingClientRect();
      if (r.width > window.innerWidth * 0.6 && r.height > window.innerHeight * 0.6) return true;
    }
    return false;
  }
  document.addEventListener("keydown", (e) => {
    if (_dmbModalOpen()) return;   // a dialog/overlay is up — leave the keys to it
    const ae = document.activeElement;
    const editing = ae && (ae.isContentEditable || ae.tagName === "INPUT" || ae.tagName === "TEXTAREA");
    const mod = e.ctrlKey || e.metaKey;

    // Undo / redo — global (no selection needed). Skipped while typing so the
    // browser's own text-undo still works inside inputs / text boxes.
    if (mod && !editing && (e.key === "z" || e.key === "Z")) { e.preventDefault(); if (e.shiftKey) redoLastAction(); else undoLastAction(); return; }
    if (mod && !editing && (e.key === "y" || e.key === "Y")) { e.preventDefault(); redoLastAction(); return; }

    if (editing) return;   // never steal keys while typing

    const sel = _dmbActiveSel();

    // A group of two or more answers these keys first; the single selection may not
    // even exist while a group is held.
    if (mod && (e.key === "v" || e.key === "V") && _dmbMultiClip && _dmbMultiClip.length) {
      e.preventDefault(); _dmbMultiPaste(); return;
    }
    if (_dmbMultiCount() >= 1) {
      if (mod && (e.key === "d" || e.key === "D")) { e.preventDefault(); _dmbMultiDuplicate(); return; }
      if (mod && (e.key === "c" || e.key === "C")) { e.preventDefault(); _dmbMultiCopy(); return; }
      if (e.key === "Delete" || e.key === "Backspace") { e.preventDefault(); _dmbMultiDelete(); return; }
      if (e.key === "Escape") { e.preventDefault(); _dmbMultiClear(); return; }
      const _ms = e.shiftKey ? 10 : 1;
      let _mx = 0, _my = 0;
      if (e.key === "ArrowLeft") _mx = -_ms;
      else if (e.key === "ArrowRight") _mx = _ms;
      else if (e.key === "ArrowUp") _my = -_ms;
      else if (e.key === "ArrowDown") _my = _ms;
      if (_mx || _my) { e.preventDefault(); _dmbMultiNudge(_mx, _my); return; }
      // Anything else falls through to the normal single-selection handling below.
    }

    if (mod && (e.key === "d" || e.key === "D")) { if (sel) { e.preventDefault(); _dmbDoDuplicate(sel); } return; }
    if (mod && (e.key === "c" || e.key === "C")) { if (sel) { e.preventDefault(); _dmbDoCopy(sel); } return; }
    if (mod && (e.key === "v" || e.key === "V")) { if (_dmbClipboard) { e.preventDefault(); _dmbDoPaste(); } return; }

    if (!sel) return;

    if (e.key === "Delete" || e.key === "Backspace") { e.preventDefault(); _dmbDoDelete(sel); return; }
    if (e.key === "Escape") { e.preventDefault(); _dmbDeselectAll(); return; }
    // Enter / F2 on a SELECTED text box → jump into writing mode (caret editing).
    if (sel.kind === "text" && (e.key === "Enter" || e.key === "F2")) { e.preventDefault(); enterTextEditMode(sel.node); return; }

    const step = e.shiftKey ? 10 : 1;
    let dx = 0, dy = 0;
    if (e.key === "ArrowLeft") dx = -step;
    else if (e.key === "ArrowRight") dx = step;
    else if (e.key === "ArrowUp") dy = -step;
    else if (e.key === "ArrowDown") dy = step;
    else return;
    e.preventDefault();
    _dmbNudge(sel, dx, dy);
  });

  // Icon colour: the colour-wheel button opens a palette popup (recent swatches +
  // custom picker), matching the text toolbar.
  const _fColorBtn = document.getElementById("dmbFrameIconColorBtn");
  const _fColorPop = document.getElementById("dmbFrameColorPop");
  const _fColorCustom = document.getElementById("dmbFrameColorCustom");
  const _fColorInput = document.getElementById("dmbFrameIconColorInput");
  if (_fColorBtn && _fColorPop) {
    _fColorBtn.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      const willOpen = _fColorPop.hidden;
      _fColorPop.hidden = !willOpen;
      const mm = document.getElementById("dmbFrameMoreMenu"); if (mm && willOpen) mm.hidden = true;
    });
    _fColorPop.addEventListener("click", (e) => {
      if (e.target.closest(".dmb-recent-swatch")) _fColorPop.hidden = true;
    });
  }
  if (_fColorCustom && _fColorInput) {
    _fColorCustom.addEventListener("click", (e) => {
      e.stopPropagation();                          // identical to the background wheel — NO preventDefault
      if (e.target === _fColorInput) return;        // overlay input tapped → let it open the native picker
      try { _fColorInput.click(); } catch (e2) {}   // desktop fallback: opens the OS colour picker
    });
  }
  if (_fColorInput && _fColorPop) {
    try { dmbEnhanceColorInput(_fColorInput, _fColorPop); } catch (e) {}
    try { if (_fColorCustom) _fColorPop.appendChild(_fColorCustom); } catch (e) {}
    try { _dmbColorTapFix(_fColorCustom, _fColorInput); } catch (e) {}
  }

  document.getElementById("dmbFrameIconColorInput")?.addEventListener("input", (e) => {
    if (!selectedFrameObject) return;
    const newColor = e.target.value;
    try { _dmbSyncFrameIconDot(); } catch (e2) {}
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    if (!obj) return;
    obj.color = newColor;
    _dmbIconColorCache[obj.iconId + "|" + newColor] = null;
    dmbGetColoredIconDataUrl(obj.iconId, newColor).then((dataUrl) => {
      const imgEl = document.querySelector(`[data-object-id="${obj.id}"] img`);
      if (imgEl) imgEl.src = dataUrl;
    });
    pushUndoState("Recolor Icon");
  });
  document.getElementById("dmbFrameIconColorInput")?.addEventListener("change", () => {
    const p = document.getElementById("dmbFrameColorPop"); if (p) p.hidden = true;
  });

  // "More" dropdown (align-on-page + duplicate).
  const _fMoreToggle = document.getElementById("dmbFrameMoreToggle");
  const _fMoreMenu = document.getElementById("dmbFrameMoreMenu");
  if (_fMoreToggle && _fMoreMenu) {
    _fMoreToggle.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      const willOpen = _fMoreMenu.hidden;
      _fMoreMenu.hidden = !willOpen;
      const cp = document.getElementById("dmbFrameColorPop"); if (cp && willOpen) cp.hidden = true;
    });
    _fMoreMenu.addEventListener("click", (e) => {
      if (e.target.closest(".dmb-text-more-item")) _fMoreMenu.hidden = true;
    });
  }
  // Outside-click closes the frame-toolbar popups (bound once with the toolbar).
  document.addEventListener("click", (e) => {
    if (!e.target.closest("#dmbFrameColorWrap")) { const p = document.getElementById("dmbFrameColorPop"); if (p) p.hidden = true; }
    if (!e.target.closest("#dmbFrameMoreDD")) { const p = document.getElementById("dmbFrameMoreMenu"); if (p) p.hidden = true; }
  });

  document.getElementById("dmbFrameIconFitBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    if (!obj || obj.type !== "mag-icon") return;
    const el = document.querySelector(`[data-object-id="${obj.id}"]`);
    const container = el?.parentElement;
    if (!el || !container) return;
    const cW = container.offsetWidth || 270;
    const cH = container.offsetHeight || 382;
    const PAD = 5;
    const aspect = (obj.naturalW && obj.naturalH) ? obj.naturalW / obj.naturalH : obj.w / (obj.h || 1);
    let nw, nh, nx, ny;
    if (aspect >= 1) {
      nw = cW - PAD * 2; nh = Math.round(nw / aspect); nx = PAD; ny = Math.round((cH - nh) / 2);
    } else {
      nh = cH - PAD * 2; nw = Math.round(nh * aspect); ny = PAD; nx = Math.round((cW - nw) / 2);
    }
    pushUndoState("Fit Icon to Page");
    obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    requestAnimationFrame(() => {
      const newEl = document.querySelector(`[data-object-id="${obj.id}"]`);
      if (newEl) showFrameToolbarFor(newEl, obj, { targetType: selectedFrameObject.targetType, pageNumber: selectedFrameObject.pageNumber, zone: selectedFrameObject.zone });
    });
  });

  // ── Contain-to-page button (frame toolbar) ────────────────────────────────
  document.getElementById("dmbFrameContainBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const _cObj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    const _cEl  = document.querySelector(`[data-object-id="${selectedFrameObject.id}"]`);
    if (!_cObj || !_cEl) return;
    const _cIsCover = selectedFrameObject.targetType === "cover";
    _dmbContainCycle(_cObj, _cEl, _cIsCover);
  });

  }

  function getTextToolbar() {
    return document.getElementById("dmbTextToolbar");
  }

  function getDmbRoot() {
    return document.getElementById("dmb-root");
  }

  function rgbToHex(rgb) {
    const m = String(rgb || "").match(/\d+/g);
    if (!m || m.length < 3) return "#000000";
    return "#" + m.slice(0, 3).map((x) => Number(x).toString(16).padStart(2, "0")).join("");
  }

  var _rotDegTip = null;
  function showRotDegTooltip(deg, clientX, clientY) {
    if (!_rotDegTip) {
      _rotDegTip = document.createElement("div");
      _rotDegTip.style.cssText = "position:fixed;z-index:99999;background:rgba(0,0,0,0.78);color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:20px;pointer-events:none;white-space:nowrap;font-family:sans-serif;letter-spacing:0.3px;";
      document.body.appendChild(_rotDegTip);
    }
    _rotDegTip.textContent = Math.round(((deg % 360) + 360) % 360) + "°";
    _rotDegTip.style.left = (clientX + 18) + "px";
    _rotDegTip.style.top = (clientY - 12) + "px";
    _rotDegTip.style.display = "block";
  }
  function hideRotDegTooltip() {
    if (_rotDegTip) _rotDegTip.style.display = "none";
  }

  function ensureRotateHandle() {
    if (dmbRotateHandle && document.body.contains(dmbRotateHandle)) return dmbRotateHandle;

    const root = getDmbRoot();
    if (!root) return null;

    const handle = document.createElement("div");
    handle.id = "dmbTextRotateHandle";
    handle.className = "dmb-text-rotate-handle";
    handle.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M19.5 4.5v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    root.appendChild(handle);
    dmbRotateHandle = handle;

    let rotating = false;
    let centerX = 0;
    let centerY = 0;
    let startAngle = 0;
    let startRotate = 0;

    const onMove = (e) => {
      if (!rotating || !selectedTextNode) return;

      const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * 180 / Math.PI;
      const raw  = startRotate + (angle - startAngle);
      const next = _dmbSnapAngle(raw); // Fix 3: 45° magnetic snap

      selectedTextNode.dataset.rotate = String(next);
      selectedTextNode.style.transform = `rotate(${next}deg)`;
      saveCoverTextNodeState(selectedTextNode);
      showTextToolbarFor(selectedTextNode);
      showRotDegTooltip(next, e.clientX, e.clientY);
    };

    const onUp = () => {
      rotating = false;
      hideRotDegTooltip();
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
    };

    handle.addEventListener("pointerdown", (e) => {
      if (!selectedTextNode) return;

      e.preventDefault();
      e.stopPropagation();

      const rect = selectedTextNode.getBoundingClientRect();
      centerX = rect.left + rect.width / 2;
      centerY = rect.top + rect.height / 2;

      startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * 180 / Math.PI;
      startRotate = Number(selectedTextNode.dataset.rotate || "0");

      rotating = true;
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    return handle;
  }

  function positionRotateHandle(node) {
    const handle = ensureRotateHandle();
    const root = getDmbRoot();
    if (!handle || !root || !node) return;

    const nodeRect = node.getBoundingClientRect();
    const rootRect = root.getBoundingClientRect();

    const left = nodeRect.left - rootRect.left + (nodeRect.width / 2) - 13;
    const top = nodeRect.bottom - rootRect.top + 10;

    handle.style.left = `${left}px`;
    handle.style.top = `${top}px`;
    handle.classList.add("is-visible");
  }

  function hideRotateHandle() {
    const handle = ensureRotateHandle();
    if (handle) handle.classList.remove("is-visible");
  }

  // ── Text selection frame: 4 corner circles (font size) + 2 side handles (width) ──
  // Overlays the selected text exactly (same left/top/size/rotation) as a sibling,
  // so the handles sit on the rotated box corners. Body has pointer-events:none so
  // the text stays clickable; only the handles capture pointer events.
  // z === 0 is a REAL layer ("send fully to back", set by _dmbUnifiedLayerStep),
  // not a missing value. `obj.z || fallback` silently promoted it back to the top
  // on screen while the PDF kept drawing it behind the photos.
  function _dmbZOf(obj, fallback) {
    var z = obj && obj.z;
    return (z === 0 || z === "0" || (z != null && z !== "")) ? Number(z) || 0 : fallback;
  }

  // ── Top of the stack for a NEW item ───────────────────────────────────────
  // Anything the customer adds must land ABOVE everything already on that page -
  // they just chose to put it there, so it should not appear buried. Scans the
  // real z values on the target (pages: editor.pageObjects[pn]; cover: the free
  // coverObjects plus coverState.textStyles, which stores cover text separately)
  // and returns one more than the highest. Floored at Date.now() so it stays
  // consistent with the timestamp-based z values every other insert has always
  // used, and so items added later still beat items added earlier.
  function _dmbNextTopZ(pageNumber) {
    var max = 0;
    var bump = function (v) {
      var x = parseFloat(v);
      if (isFinite(x) && x > max) max = x;
    };
    try {
      if (pageNumber === "cover") {
        (editor.coverObjects || []).forEach(function (o) { if (o) bump(o.z); });
        var ts = (typeof coverState !== "undefined" && coverState) ? coverState.textStyles : null;
        if (ts) Object.keys(ts).forEach(function (k) { if (ts[k]) bump(ts[k].z); });
      } else {
        var objs = (editor.pageObjects &&
          (editor.pageObjects[pageNumber] || editor.pageObjects[String(pageNumber)])) || [];
        if (Array.isArray(objs)) objs.forEach(function (o) { if (o) bump(o.z); });
      }
    } catch (e) {}
    return Math.max(max + 1, Date.now());
  }

  // ── Sticker crop that survives asset re-uploads ────────────────────────────
  // A sticker's cropX/Y/W/H is the tight bounding box of its non-transparent pixels,
  // measured in the pixel space of the image analysed at INSERT time. Shopify Files
  // can later serve the very same url at a different size (re-upload / CDN
  // transform), and older objects never recorded which size they were measured on
  // (cropRefW/H) - so the stored rect can point at the wrong region of the image the
  // renderer actually loaded; drawImage clamps it and stretches what is left (the
  // squashed, smeared cross on the Baptism template: rect measured on a ~1000px
  // copy, image now 3691px). Rule: use the stored rect ONLY when it was measured on
  // an image of exactly this size; otherwise re-derive the tight box from THIS
  // image's alpha (same rule as insert, on a <=1024px scan so a 3700px PNG is never
  // read at full size) and cache it per url+size.
  const _dmbStickerCropCache = new Map();
  function _dmbStickerCropFor(obj, img) {
    const nw = (img && (img.naturalWidth || img.width)) || 0, nh = (img && (img.naturalHeight || img.height)) || 0;
    if (!nw || !nh) return null;
    if (obj && obj.cropW > 0 && obj.cropH > 0 && obj.cropRefW === nw && obj.cropRefH === nh) {
      return { cropX: obj.cropX || 0, cropY: obj.cropY || 0, cropW: obj.cropW, cropH: obj.cropH };
    }
    const key = String((img.currentSrc || img.src || (obj && obj.url) || "")).slice(0, 300) + "|" + nw + "x" + nh;
    if (_dmbStickerCropCache.has(key)) return _dmbStickerCropCache.get(key);
    let out = null;
    try {
      const sc = Math.min(1, 1024 / Math.max(nw, nh));
      const sw = Math.max(1, Math.round(nw * sc)), sh = Math.max(1, Math.round(nh * sc));
      const c = document.createElement("canvas"); c.width = sw; c.height = sh;
      const x = c.getContext("2d", { willReadFrequently: true });
      x.drawImage(img, 0, 0, sw, sh);
      const px = x.getImageData(0, 0, sw, sh).data;
      let minX = sw, minY = sh, maxX = -1, maxY = -1;
      for (let yy = 0; yy < sh; yy++) {
        const row = yy * sw * 4;
        for (let xx = 0; xx < sw; xx++) {
          if (px[row + xx * 4 + 3] > 10) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
      }
      c.width = 0; c.height = 0;
      if (maxX >= minX && maxY >= minY) {
        // Back to full-resolution pixels, padded by one scan pixel so an edge is never shaved.
        const inv = 1 / sc;
        const X0 = Math.max(0, Math.floor((minX - 1) * inv)), Y0 = Math.max(0, Math.floor((minY - 1) * inv));
        const X1 = Math.min(nw, Math.ceil((maxX + 2) * inv)), Y1 = Math.min(nh, Math.ceil((maxY + 2) * inv));
        out = { cropX: X0, cropY: Y0, cropW: Math.max(1, X1 - X0), cropH: Math.max(1, Y1 - Y0) };
      } else {
        out = { cropX: 0, cropY: 0, cropW: nw, cropH: nh };   // fully transparent: draw as-is
      }
    } catch (e) {
      // Tainted canvas: the pixels cannot be read, so the tight box cannot be
      // measured. Fall back to the stored rect when it at least fits this image (it
      // is correct whenever the asset has not been re-uploaded), but mark the result
      // a GUESS and return WITHOUT caching, so a later CORS-clean load of the same
      // image replaces it with a real measurement.
      return (obj && obj.cropW > 0 && obj.cropH > 0 && (obj.cropX || 0) + obj.cropW <= nw && (obj.cropY || 0) + obj.cropH <= nh)
        ? { cropX: obj.cropX || 0, cropY: obj.cropY || 0, cropW: obj.cropW, cropH: obj.cropH, guessed: true }
        : { cropX: 0, cropY: 0, cropW: nw, cropH: nh, guessed: true };
    }
    _dmbStickerCropCache.set(key, out);
    return out;
  }

  function _nodeOnScreenScale(node) {
    const op = node && node.offsetParent;
    if (!op) return 1;
    const r = op.getBoundingClientRect();
    return (r.width / (op.offsetWidth || r.width)) || 1;
  }

  // Re-centre a spine cover text on the spine (glyph centre → spine centre x).
  // Used after resizing so the spine text never drifts off-centre (esp. in the PDF
  // preview). No-op for non-spine text, magazines, or detached nodes.
  function _dmbRecenterSpineText(node) {
    try {
      if (!node || !node.isConnected || window.DMB_MAGAZINE_MODE) return;
      const _ov = document.getElementById("coverOverlay");
      if (!_ov) return;
      const _ut = (editor.coverUserTexts || []).find((en) => en.id === node.id);
      const _ovr = _ov.getBoundingClientRect();
      const _Z = (_ovr.width / (_ov.offsetWidth || 622)) || 1;
      const r = node.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      const nvx = ((r.left + r.width / 2) - _ovr.left) / _Z;
      const onSpine = (_ut && _ut.zone === "spine") ||
        (nvx >= COVER_BACK_W && nvx <= COVER_BACK_W + COVER_SPINE_W);
      if (!onSpine) return;
      // Glyph (letter) centre, accounting for the rotation in the transform string.
      let gcx = nvx;
      const _tf = node.style.transform;
      node.style.transform = "none";
      const _ur = node.getBoundingClientRect();
      const _rng = document.createRange(); _rng.selectNodeContents(node);
      const _gr = _rng.getBoundingClientRect();
      node.style.transform = _tf;
      if (_gr && _gr.width > 0 && _gr.height > 0) {
        const _gdx = ((_gr.left + _gr.width  / 2) - (_ur.left + _ur.width  / 2)) / _Z;
        const _gdy = ((_gr.top  + _gr.height / 2) - (_ur.top  + _ur.height / 2)) / _Z;
        let _eff = parseFloat(node.dataset.rotate || "0") || 0;
        if (!_eff) { const _m = (_tf || "").match(/rotate\(\s*(-?[\d.]+)deg/); if (_m) _eff = parseFloat(_m[1]) || 0; }
        const _rad = _eff * Math.PI / 180;
        gcx = nvx + (_gdx * Math.cos(_rad) - _gdy * Math.sin(_rad));
      }
      const _spineCx = COVER_BACK_W + COVER_SPINE_W / 2;
      const _dx = _spineCx - gcx;
      if (Math.abs(_dx) > 0.5) {
        node.style.left = ((parseFloat(node.style.left) || 0) + _dx) + "px";
        saveCoverTextNodeState(node);
      }
    } catch (e) {}
  }

  // ── Alignment lines while a text box is being RESIZED ─────────────────────
  // Straight into _dmbResizeSnap, the same function every photo frame, map, shape
  // and sticker already uses for its own resize. So a text box lines up against the
  // same references, draws the same blue lines (solid for an edge, dashed for a
  // centre), the same pink equal-spacing bars and the same live size chip - rather
  // than a second implementation that would drift away from all of it.
  //
  // `mode` is the handle: "ml"/"mr" for the side grips, "tl"/"tr"/"bl"/"br" for the
  // corners. Text is measured by its GLYPH box (inset by the 2px 6px padding), the
  // same box the move drag snaps, so text lines up letter to letter.
  //
  // `apply` asks for the width correction back. The SIDE grips take it: the width is
  // theirs to set, so the edge lands exactly on what it lines up with. The CORNER
  // dots do not. They drive the font size, which is a whole number of pixels, and one
  // step of it moves the edge of a line of text by several px - so there is no size
  // that lands the corner exactly, and pulling at the width behind the drag would
  // only fight it. They show the lines and leave the size to the finger. (2026-10-13)
  // Effective rotation of a text node, from wherever it is kept.
  function _dmbNodeRotation(node) {
    let r = parseFloat(node && node.dataset ? node.dataset.rotate : 0) || 0;
    if (!r) {
      const m = String((node && node.style && node.style.transform) || "").match(/rotate\(\s*(-?[\d.]+)deg/);
      if (m) r = parseFloat(m[1]) || 0;
    }
    return r;
  }

  function _dmbTextResizeGuides(node, mode, apply) {
    try {
      const parent = node && node.parentElement;
      if (!parent || typeof _dmbResizeSnap !== "function") return 0;
      const TX_PL = 6, TX_PT = 2;                 // matches the CSS padding: 2px 6px
      const isCover = !!parent.closest(".dmb-cover-preview");
      const pn = parseInt(node.dataset.pageNumber);
      const meta = isCover ? { targetType: "cover" }
                 : (Number.isFinite(pn) ? { targetType: "page", pageNumber: pn } : null);
      if (!meta) return 0;
      const left = _dmbLenPx(node, "left"), top = _dmbLenPx(node, "top");
      const w = node.offsetWidth || 0, h = node.offsetHeight || 0;
      if (!w || !h) return 0;
      const obj = {
        id: node.id,
        x: left + TX_PL, y: top + TX_PT,
        w: Math.max(0, w - TX_PL * 2), h: Math.max(0, h - TX_PT * 2),
        // The rotation can live in EITHER place: dataset.rotate for an ordinary box,
        // or the transform string for spine text (translate(-50%,-50%) rotate(-90deg)
        // with dataset.rotate still "0"). Read both, so _dmbResizeSnap applies its own
        // rotated-item guard and a spine title never gets lines drawn against an
        // upright box it is not.
        rotation: _dmbNodeRotation(node),
      };
      const w0 = obj.w;
      _dmbResizeSnap(obj, parent, meta, mode);     // mutates obj, draws the guides
      return apply ? (obj.w - w0) : 0;             // the width correction, in model px
    } catch (e) { return 0; }
  }

  // Touch drags fire pointermove faster than the screen refreshes, and each one
  // forces a layout. Keep only the newest event and run it once per frame; flush()
  // applies a pending move so the drop lands exactly where the finger ended.
  function _dmbRafMove(fn) {
    let raf = 0, pending = null;
    const run = function () { raf = 0; const ev = pending; pending = null; if (ev) fn(ev); };
    const wrapped = function (ev) { pending = ev; if (!raf) raf = requestAnimationFrame(run); };
    wrapped.flush = function () { if (raf) { cancelAnimationFrame(raf); raf = 0; } run(); };
    return wrapped;
  }

  function ensureTextSelectFrame() {
    let frame = document.getElementById("dmbTextSelFrame");
    if (frame) return frame;
    frame = document.createElement("div");
    frame.id = "dmbTextSelFrame";
    frame.className = "dmb-text-sel-frame";
    // Inline styles so it works even if the CSS file is cached/stale.
    // z-index must clear EVERY item layer, not just the default ones. On the cover,
    // photo-frames are boosted to 100001 (one above the cover drag overlay at
    // 100000), so a frame pinned at 100000 slid BEHIND a cover item — the text
    // glyphs (z = Date.now()) showed on top but the selection box/handles hid
    // behind the item. Max-int keeps the frame above all items on every surface.
    // The frame body is pointer-events:none, so this never blocks taps on text.
    frame.style.cssText = "position:absolute;border:1.5px solid #7c8aff;box-sizing:border-box;" +
      "pointer-events:none;z-index:2147483647;display:none;";
    // Handles look EXACTLY as before (same dots/pills, same positions). The ONLY
    // change is invisible: each visible mark is wrapped in a larger TRANSPARENT hit
    // pad (44px touch / 28px desktop) so a fingertip lands on it reliably. The dot/pill
    // is a pointer-events:none child centred in the pad, so nothing looks different.
    const _coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    const HIT  = _coarse ? 44 : 28;                      // invisible finger pad
    const _cSz = _coarse ? 12 : 10;                      // visible corner dot — small & subtle
    const _sW  = _coarse ? 8 : 6, _sH = _coarse ? 20 : 16;   // visible side pill — small & subtle
    [["tl", 0, 0], ["tr", 100, 0], ["bl", 0, 100], ["br", 100, 100]].forEach(function (c) {
      const pad = document.createElement("div");
      pad.className = "dmb-text-sel-h dmb-text-sel-corner";
      pad.dataset.h = c[0];
      pad.style.cssText = "position:absolute;background:transparent;border:0;pointer-events:auto;z-index:3;touch-action:none;cursor:nwse-resize;" +
        "transform:translate(-50%,-50%);width:" + HIT + "px;height:" + HIT + "px;left:" + c[1] + "%;top:" + c[2] + "%;";
      const dot = document.createElement("div");
      dot.style.cssText = "position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);pointer-events:none;" +
        "background:#fff;border:2px solid #7c8aff;border-radius:999px;width:" + _cSz + "px;height:" + _cSz + "px;";
      pad.appendChild(dot);
      frame.appendChild(pad);
    });
    [["ml", 0, 50], ["mr", 100, 50]].forEach(function (c) {
      const pad = document.createElement("div");
      pad.className = "dmb-text-sel-h dmb-text-sel-side";
      pad.dataset.h = c[0];
      pad.style.cssText = "position:absolute;background:transparent;border:0;pointer-events:auto;z-index:2;touch-action:none;cursor:ew-resize;" +
        "transform:translate(-50%,-50%);width:" + HIT + "px;height:" + HIT + "px;left:" + c[1] + "%;top:" + c[2] + "%;";
      const pill = document.createElement("div");
      pill.style.cssText = "position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);pointer-events:none;" +
        "background:#fff;border:2px solid #7c8aff;border-radius:4px;width:" + _sW + "px;height:" + _sH + "px;";
      pad.appendChild(pill);
      frame.appendChild(pad);
    });

    // Corner drag → font size (radial distance from the text centre; rotation-proof).
    frame.querySelectorAll(".dmb-text-sel-corner").forEach(function (h) {
      h.addEventListener("pointerdown", function (e) {
        if (!selectedTextNode) return;
        e.preventDefault(); e.stopPropagation();
        const node = selectedTextNode;
        // The corner is a WHOLE-BOX font-size control. Flatten any per-word size runs
        // first so the whole text resizes (otherwise run-spans keep their own size and
        // the drag only changes the box width).
        try { _dmbStripRunProp(node, "font-size"); } catch (e2) {}
        const rect = node.getBoundingClientRect();
        const cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
        const startDist = Math.hypot(e.clientX - cx, e.clientY - cy) || 1;
        const startFont = parseFloat(window.getComputedStyle(node).fontSize) || 28;
        // Resize anchored at the OPPOSITE corner: only the two edges meeting the
        // dragged corner move; the far corner stays put. The box width scales with
        // the font (so text keeps fitting), and we shift left/top so the opposite
        // corner is the fixed anchor.
        const _hdir = h.dataset.h || "br";
        const _growRight = _hdir.indexOf("r") >= 0; // right corner → anchor LEFT edge
        const _growDown  = _hdir.indexOf("b") >= 0; // bottom corner → anchor TOP edge
        const startEW   = parseFloat(node.style.width) || 0;  // explicit (locked) width, if any
        const startW    = node.offsetWidth;
        const startH    = node.offsetHeight;
        const startLeft = _dmbLenPx(node, "left");
        const startTop  = _dmbLenPx(node, "top");
        // Spine text must STAY centred on the spine — the opposite-corner anchor
        // (below) would drift it off-centre, so for spine we re-centre instead.
        const _utC = (editor.coverUserTexts || []).find((en) => en.id === node.id);
        const _isSpineTxt = !window.DMB_MAGAZINE_MODE && !!(_utC && _utC.zone === "spine") &&
                            !!node.closest(".dmb-cover-preview");
        try { h.setPointerCapture(e.pointerId); } catch (_) {}
        const move = _dmbRafMove(function (ev) {
          const d = Math.hypot(ev.clientX - cx, ev.clientY - cy);
          const nf = Math.max(8, Math.min(400, Math.round(startFont * (d / startDist))));
          node.style.fontSize = nf + "px";
          if (startEW > 0) {
            node.style.width = Math.max(1, Math.round(startEW * (nf / startFont))) + "px";
          }
          // Non-spine: keep the opposite corner anchored. Spine re-centring + state
          // saves are deferred to drag-END (below) to keep touch dragging smooth —
          // they do forced layout reads that are too costly to run every move.
          if (!_isSpineTxt) {
            const dw = node.offsetWidth  - startW;
            const dh = node.offsetHeight - startH;
            node.style.left = (_growRight ? startLeft : startLeft - dw) + "px";
            node.style.top  = (_growDown  ? startTop  : startTop  - dh) + "px";
          }
          // Lines only: the corner drives the font size, so there is no width of its
          // own to snap. Measured AFTER the anchor above, on the final geometry.
          _dmbTextResizeGuides(node, _hdir, false);
          positionTextSelectFrame(node); positionRotateHandle(node);
          const fsi = document.getElementById("dmbFontSize"); if (fsi) fsi.value = String(nf);
        });
        const up = function () {
          move.flush();
          document.removeEventListener("pointermove", move);
          document.removeEventListener("pointerup", up);
          document.removeEventListener("pointercancel", up);
          if (_isSpineTxt) _dmbRecenterSpineText(node);
          saveCoverTextNodeState(node); savePageTextState(node);
          positionTextSelectFrame(node); positionRotateHandle(node);
          pushUndoState("Resize Text"); saveCoverDesignToStorage();
        };
        document.addEventListener("pointermove", move);
        document.addEventListener("pointerup", up);
        document.addEventListener("pointercancel", up);
      });
    });

    // Side drag → box width. The edge you are HOLDING is the only one that moves;
    // the opposite edge stays exactly where it is. Drag is projected onto the box's
    // local x-axis. (It used to grow about the centre, which meant pulling the right
    // grip also pushed the left edge out - half the box moved on its own.)
    frame.querySelectorAll(".dmb-text-sel-side").forEach(function (h) {
      h.addEventListener("pointerdown", function (e) {
        if (!selectedTextNode) return;
        e.preventDefault(); e.stopPropagation();
        const node = selectedTextNode;
        const rot = (parseFloat(node.dataset.rotate || "0") || 0) * Math.PI / 180;
        const ux = Math.cos(rot), uy = Math.sin(rot);     // box local-x unit (screen)
        // ---- The floor, measured once --------------------------------------
        // .dmb-editable-text carries min-width:120px, both in the stylesheet and
        // inline at creation, so that a brand-new EMPTY box is big enough to tap and
        // type into. During an explicit width drag that floor used to fight the user:
        // offsetWidth stopped at 120 while the requested width kept falling to the old
        // 40px clamp, and because `left` was derived from the REQUESTED width the box
        // stopped getting narrower and began SLIDING sideways instead - which is what
        // it looked like from the outside: "it shrinks to a point, then just moves".
        //
        // An explicit drag outranks a convenience minimum, so the minimum is released
        // below. The honest floor is the widest UNBREAKABLE word: narrower than that
        // and the glyphs spill outside the box, and the PDF - which replays the saved
        // box - would no longer match the screen. Measured here with the minimum
        // temporarily out of the way, then everything is put back, because a tap on
        // the grip that never turns into a drag must change nothing. (2026-09-14)
        let floorW = 24;
        const _mw0 = node.style.minWidth, _ws0 = node.style.whiteSpace, _w0 = node.style.width;
        try {
          node.style.minWidth = "0";
          node.style.whiteSpace = "pre-wrap";
          node.style.width = "min-content";
          floorW = Math.max(24, node.offsetWidth);
        } catch (_) {}
        node.style.width = _w0; node.style.whiteSpace = _ws0; node.style.minWidth = _mw0;
        const startW = node.offsetWidth;
        // Never let the floor be WIDER than the box already is - an old design whose
        // box is already narrower than its longest word must not jump wider the
        // instant the grip is touched.
        floorW = Math.max(24, Math.min(floorW, startW));
        const startLeft = _dmbLenPx(node, "left");
        const startTop  = _dmbLenPx(node, "top");
        const sx = e.clientX, sy = e.clientY;
        const Z = _nodeOnScreenScale(node);
        const sign = (h.dataset.h === "mr") ? 1 : -1;
        let _released = false;
        try { h.setPointerCapture(e.pointerId); } catch (_) {}
        // Set the width, then put the box back where the opposite edge has to be.
        // Factored out because the snap below has to run it a second time.
        const _applyW = function (wPx) {
          node.style.width = Math.max(floorW, Math.round(wPx)) + "px";
          // Anchor on what the browser ACTUALLY rendered, never on what we asked for.
          // If anything still refuses to shrink, `applied` simply stops changing and
          // the box holds still. A box must never keep moving while its width stands
          // still - that was the whole bug.
          const applied = node.offsetWidth - startW;
          // ---- hold the opposite edge -------------------------------------
          // The element is positioned by its top-left but ROTATES about its centre,
          // so "keep one edge still" is not simply "leave left alone": widening by
          // `applied` moves the centre `applied/2` along the box's own x-axis, and
          // that axis is (ux, uy). Undo exactly that much so the far edge lands back
          // on itself. At 0 degrees it reduces to left unchanged (right grip) or
          // left -= applied (left grip), which is what it looks like on screen.
          const _half = applied / 2;
          if (sign > 0) {                                   // right grip → left edge holds
            node.style.left = (startLeft + _half * (ux - 1)) + "px";
            node.style.top  = (startTop  + _half * uy) + "px";
          } else {                                          // left grip → right edge holds
            node.style.left = (startLeft - _half * (ux + 1)) + "px";
            node.style.top  = (startTop  - _half * uy) + "px";
          }
        };
        const move = _dmbRafMove(function (ev) {
          if (!_released) {
            // First real movement: this is a deliberate resize, so the new-box
            // minimum stands down and narrowing implies wrapping.
            _released = true;
            node.style.minWidth = "0";
            node.style.whiteSpace = "pre-wrap";
          }
          const dproj = ((ev.clientX - sx) * ux + (ev.clientY - sy) * uy) / Z;
          _applyW(startW + sign * dproj);
          // The edge the finger is holding snaps to whatever it lines up with, and
          // the blue lines show what that was. Re-derived from the pointer on every
          // move BEFORE this runs, so a snap can never accumulate: let go of the
          // alignment and the edge follows the finger again.
          const _sdw = _dmbTextResizeGuides(node, sign > 0 ? "mr" : "ml", true);
          if (Math.abs(_sdw) > 0.01) _applyW(node.offsetWidth + _sdw);
          // Spine re-centre + state saves deferred to drag-END for smooth touch.
          positionTextSelectFrame(node); positionRotateHandle(node);
        });
        const up = function () {
          move.flush();
          document.removeEventListener("pointermove", move);
          document.removeEventListener("pointerup", up);
          document.removeEventListener("pointercancel", up);
          _dmbRecenterSpineText(node);   // keep spine text on the spine centre
          saveCoverTextNodeState(node); savePageTextState(node);
          positionTextSelectFrame(node); positionRotateHandle(node);
          pushUndoState("Resize Text Width"); saveCoverDesignToStorage();
        };
        document.addEventListener("pointermove", move);
        document.addEventListener("pointerup", up);
        document.addEventListener("pointercancel", up);
      });
    });

    return frame;
  }

  function positionTextSelectFrame(node) {
    if (!node) return;
    const frame = ensureTextSelectFrame();
    const parent = node.parentElement;
    if (!parent) return;
    if (frame.parentElement !== parent) parent.appendChild(frame);
    frame.style.left = node.offsetLeft + "px";
    frame.style.top = node.offsetTop + "px";
    frame.style.width = node.offsetWidth + "px";
    frame.style.height = node.offsetHeight + "px";
    frame.style.transform = node.style.transform || "";
    frame.style.transformOrigin = "center center";
    // Same colour + thickness (1.5px #7c8aff); dashed while writing, solid when selected.
    frame.style.borderStyle = node.classList.contains("is-editing") ? "dashed" : "solid";
    frame.style.display = "block";
  }

  function hideTextSelectFrame() {
    const frame = document.getElementById("dmbTextSelFrame");
    if (frame) frame.style.display = "none";
  }

  // ── Text box modes ─────────────────────────────────────────────────────────
  // A text box has two states:
  //   • SELECTED  → solid handle frame; node is contenteditable="false" and blurred,
  //                 so the global arrow-key handler MOVES the box (like any object).
  //   • EDITING   → dashed box; node is contenteditable="true" and focused, so the
  //                 arrow keys move the caret inside the text (native behaviour).
  // Flipping contenteditable is what routes the arrow keys: the global keydown skips
  // whenever document.activeElement is editable.
  function enterTextEditMode(node) {
    if (!node) return;
    node.setAttribute("contenteditable", "true");
    node.classList.add("is-editing");
    // Writing mode keeps the SAME selection frame + handles, only the frame border
    // switches to dashed (handled in positionTextSelectFrame).
    showTextToolbarFor(node);
    try {
      node.focus({ preventScroll: true });
      const r = document.createRange();
      r.selectNodeContents(node);
      r.collapse(false);               // caret at the end, ready to type
      const s = window.getSelection();
      s.removeAllRanges(); s.addRange(r);
    } catch (e) {}
  }
  function enterTextSelectMode(node) {
    if (!node) return;
    node.classList.remove("is-editing");
    node.setAttribute("contenteditable", "false");   // no caret while merely selected
    if (document.activeElement === node) { try { node.blur(); } catch (e) {} }
    showTextToolbarFor(node);          // select + solid handle frame
  }

  function showTextToolbarFor(node) {
    const toolbar = getTextToolbar();
    const root = getDmbRoot();
    if (!toolbar || !node || !root) return;
    _dmbLastBarShow = () => showTextToolbarFor(node);
    // (drag no longer hides the text toolbar — it stays open while moving/resizing)

    // During a drag this is called every pointermove for the SAME node. Run the
    // heavy selection bookkeeping (class sweep, getComputedStyle, font sync) ONLY
    // on a genuine selection change; otherwise just reposition. Big touch-lag win.
    const _sameSel = (selectedTextNode === node) && node.classList.contains("is-selected");
    if (!_sameSel) {
      // Switching to a different box → commit the previous box's pending style edit
      // now, so its burst closes and the new box starts a fresh undo burst.
      try { _dmbTextStyleCommit(); } catch (e) {}
      hideFrameToolbar();
      dmbCloseShapeEditBar(); // close shape bar when text toolbar opens
      dmbCloseEditBar();
      selectedTextNode = node;
      document.querySelectorAll(".dmb-editable-text").forEach((el) => {
        // Any OTHER box loses selection AND its writing state, so switching boxes
        // never leaves a stale dashed/editable box behind.
        if (el !== node) {
          el.classList.remove("is-editing");
          el.style.outline = "none"; el.style.outlineOffset = "";
          if (el.getAttribute("contenteditable") === "true") el.setAttribute("contenteditable", "false");
        }
        el.classList.remove("is-selected");
      });
      node.classList.add("is-selected");
    }

    // Fast path while dragging THIS already-selected text: the toolbar is already
    // open & docked — skip the re-dock and just keep the selection frame + rotate
    // handle on the moving text.
    if (_dmbDragSuppress && _sameSel) {
      positionTextSelectFrame(node);
      positionRotateHandle(node);
      return;
    }

    // Dock the text toolbar into the fixed ribbon instead of floating it above
    // the text box.
    toolbar.classList.add("is-open");
    _dmbDockBar(toolbar);

    // Sync the toolbar inputs from the node ONLY on a real selection change
    // (getComputedStyle + the font-family scan are too costly to run every move).
    if (!_sameSel) {
      const fontFamily = document.getElementById("dmbFontFamily");
      const fontSize = document.getElementById("dmbFontSize");
      const textColor = document.getElementById("dmbTextColor");
      const textAlign = document.getElementById("dmbTextAlign");
      const cs = window.getComputedStyle(node);
      if (fontSize) fontSize.value = String(Math.round(parseFloat(cs.fontSize) || 28));
      if (textColor) textColor.value = rgbToHex(cs.color);
      if (textAlign) textAlign.value = cs.textAlign || "left";
      try { _dmbSyncTextColorDot(); } catch (e) {}
      try { _dmbSyncAlignIcon(); } catch (e) {}
      if (fontFamily) {
        const ff = (cs.fontFamily || "").toLowerCase();
        for (const opt of fontFamily.options) {
          const v = opt.value.toLowerCase().replace(/['"]/g, "");
          if (ff.includes(v.split(",")[0].trim())) {
            fontFamily.value = opt.value;
            break;
          }
        }
      }
    }

    positionRotateHandle(node);
    // Frame + handles show in BOTH modes; positionTextSelectFrame draws its border
    // dashed while writing (is-editing) and solid while merely selected.
    positionTextSelectFrame(node);
  }

  function hideTextToolbar() {
    try { _dmbTextStyleCommit(); } catch (e) {}   // flush any pending text-style edit on deselect
    const toolbar = getTextToolbar();
    if (toolbar) toolbar.classList.remove("is-open");
    try { _dmbCloseTextMenus(null); } catch (e) {}   // never reopen a stale popup
    hideTextSelectFrame();

    document.querySelectorAll(".dmb-editable-text").forEach((el) => {
      el.classList.remove("is-selected");
      el.classList.remove("is-editing");
      el.style.outline = "none"; el.style.outlineOffset = "";
      if (el.getAttribute("contenteditable") === "true") el.setAttribute("contenteditable", "false");
    });

    hideRotateHandle();
    selectedTextNode = null;
    try { _dmbUpdateRibbonPlaceholder(); } catch (e) {}
  }

  // Fully discard a text box: remove its DOM node, purge it from every persisted
  // store, and close its menu. Used for empty boxes the user abandons (blur /
  // click-away) so an empty box never lingers on the canvas or in saved state.
  function _dmbRemoveTextNode(node) {
    if (!node) return;
    if (node.id) {
      if (Array.isArray(editor.coverUserTexts)) {
        editor.coverUserTexts = editor.coverUserTexts.filter((en) => en.id !== node.id);
      }
      if (coverState.textStyles) delete coverState.textStyles[node.id];
      const _pn = parseInt(node.dataset.pageNumber);
      if (Number.isFinite(_pn) && Array.isArray(editor.pageObjects?.[_pn])) {
        editor.pageObjects[_pn] = editor.pageObjects[_pn].filter((o) => o.id !== node.id);
      }
    }
    if (selectedTextNode === node) hideTextToolbar();
    node.remove();
    try { saveCoverDesignToStorage(); } catch (_) {}
  }

  // ── Fix 5: Auto-zone assignment ──────────────────────────────────────
  // Automatically assigns the cover zone (front/spine/back) based on where
  // the centre of the object sits after a drag. No dialog — silent assignment.
  // The zone drives clipping (dmbApplyZoneClip) and alignment (dmbAlignObjectInZone).
  function _dmbAutoAssignCoverZone(obj, el) {
    if (window.DMB_MAGAZINE_MODE) {
      // Magazine: no spine — just front/back split at COVER_BACK_W
      var cx = (obj.x || 0) + (obj.w || el.offsetWidth || 0) / 2;
      obj.coverZone = cx < COVER_BACK_W ? "back" : "front";
    } else {
      var cx = (obj.x || 0) + (obj.w || el.offsetWidth || 0) / 2;
      if (cx < COVER_BACK_W) obj.coverZone = "back";
      else if (cx < COVER_FRONT_X) obj.coverZone = "spine";
      else obj.coverZone = "front";
    }
    dmbApplyZoneClip(el, obj);
    // Re-apply contain clip with the newly assigned zone
    try { if (obj.contained) _dmbApplyContain(el, obj, true); } catch(e) {}
  }

  // Legacy wrapper — kept for any remaining callers but now auto-assigns
  // instead of showing a dialog.
  function checkCoverZoneBoundaries(getLeft, getWidth, setLeft, setZone) {
    // No-op: zone assignment is now handled by _dmbAutoAssignCoverZone
    // which is called directly from each pointerup handler.
  }

  function makeTextInteractive(node) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    let moved = false;
    // Mode the box was in when the current gesture began ("idle" | "editing" | "solid").
    // Drives the click toggle: 1st click on an idle box edits, next click solidifies.
    let _modeAtDown = "idle";
    // Natural glyph width for drag clamp (computed at drag start without forced CSS width
    // so a wide alignment box like width:220px doesn't trap the visible text in the middle).
    let _dragNW = 0;
    // Pointer id of the active drag — captured once a real move begins so touch
    // devices keep delivering pointermove/up (and don't bail to pointercancel).
    let _ptrId = null;
    // Spine text is always horizontally centred — during a drag only vertical
    // movement is allowed (horizontal is pinned to the start = centred position).
    let _spineLock = false;
    // Cached at drag start (constant during a position drag) so onMove avoids
    // per-move layout reflows: the on-screen scale and the clamp bounds.
    let _dragZ = 1, _dragBounds = null;
    let _dragFrame = null, _dragRot = null, _fr0L = 0, _fr0T = 0, _rh0L = 0, _rh0T = 0;

    const onMove = _dmbRafMove((e) => {
      if (!dragging) return;

      // Convert screen-pixel finger movement into canvas-model pixels. The
      // builder canvas is rendered with transform:scale(currentZoom) (50% on
      // phones), so a raw clientX delta would move the text by only `zoom`× the
      // finger distance — the object lags behind the finger on touch. Dividing
      // by the node's on-screen scale makes 1 finger px == 1 model px again.
      const _sdx = e.clientX - startX;
      const _sdy = e.clientY - startY;
      const _Z = _dragZ;   // cached at drag start (no per-move reflow)
      const dx = _sdx / _Z;
      const dy = _sdy / _Z;

      if (!moved && (Math.abs(_sdx) > 2 || Math.abs(_sdy) > 2)) {
        moved = true;
        // Past the threshold this press is a MOVE, not a caret tap: cancel any native
        // text-selection the mousedown started and drop the box out of writing (it goes
        // solid / not-dashed) so the drag relocates the whole box.
        try { window.getSelection().removeAllRanges(); } catch (e2) {}
        enterTextSelectMode(node);
        // Capture the pointer on the first real movement so the whole drag is
        // delivered here even on touch (and a plain tap stays a tap-to-edit).
        try { if (_ptrId != null) node.setPointerCapture(_ptrId); } catch (e2) {}
      }
      if (!moved) return;   // sub-threshold jitter on a tap → no move / no snap guides

      let newLeft = startLeft + dx;
      let newTop = startTop + dy;

      const parent = node.parentElement;
      // Centre-based bounds (keep the box CENTRE on the cover/page; the rotated
      // extent may spill past the edges). Precomputed once at drag start — see the
      // pointerdown handler — so onMove does NO layout reflows here.
      if (parent && _dragBounds) {
        newLeft = Math.max(_dragBounds.xMin, Math.min(newLeft, _dragBounds.xMax));
        newTop  = Math.max(_dragBounds.yMin, Math.min(newTop,  _dragBounds.yMax));
      }

      node.style.left = `${newLeft}px`;
      node.style.top = `${newTop}px`;
      // Full sibling snap for text: shows guides AND snaps to all other objects.
      // The snap uses the GLYPH box (visible text), not the element box.  The text
      // element has padding 2px 6px, so the box left edge is 6px left of the first
      // letter and the box right edge is 6px right of the last letter.  We inset by
      // the padding so the alignment line lands on the actual letter edges, then
      // convert the snapped glyph-x back to the element box-x.
      if (parent) {
        const { gH: tGH, gV: tGV } = dmbGetSnapGuides(parent);
        const _isCoverTxt = !!parent.closest(".dmb-cover-preview");
        const _tpn = parseInt(node.dataset.pageNumber);
        const _tmeta = _isCoverTxt
          ? { targetType: "cover" }
          : (Number.isFinite(_tpn) ? { targetType: "page", pageNumber: _tpn } : null);
        const _TX_PL = 6, _TX_PT = 2; // matches CSS padding: 2px 6px
        const _glyphW = Math.max(0, (node.offsetWidth  || 132) - _TX_PL * 2) || 120;
        const _glyphH = Math.max(0, (node.offsetHeight || 34)  - _TX_PT * 2) || 26;
        const _snapTxt = {
          id: node.id,
          x: newLeft + _TX_PL, y: newTop + _TX_PT,
          w: _glyphW,
          h: _glyphH,
        };
        dmbCheckSnap(_snapTxt, parent, tGH, tGV, _tmeta);
        // Convert snapped glyph position back to the element box position
        newLeft = _snapTxt.x - _TX_PL;
        newTop  = _snapTxt.y - _TX_PT;
        // CRITICAL: re-apply to the DOM so the snap actually moves the text.
        // Without this the snapped position is computed but never written, so the
        // guide appears but the text does not snap into place.
        node.style.left = `${newLeft}px`;
        node.style.top  = `${newTop}px`;
      }
      // Spine: keep the horizontal position pinned (centred) — vertical only.
      if (_spineLock) {
        newLeft = startLeft;
        node.style.left = `${newLeft}px`;
      }
      // State saves are deferred to drag-END (onUp) so touch dragging stays smooth.
      showTextToolbarFor(node);
      // The selection frame + rotate handle no longer hide during a drag (the menu
      // stays open), so they must FOLLOW the text as it moves — otherwise the box
      // outline lags behind and snaps over only on release.
      // Follow the box by its offset from drag start (no layout reads per frame).
      // The handle lives in screen space, so its offset is scaled by the canvas zoom.
      if (_dragFrame) {
        _dragFrame.style.left = (_fr0L + (newLeft - startLeft)) + "px";
        _dragFrame.style.top  = (_fr0T + (newTop - startTop)) + "px";
      }
      if (_dragRot) {
        _dragRot.style.left = (_rh0L + (newLeft - startLeft) * _dragZ) + "px";
        _dragRot.style.top  = (_rh0T + (newTop - startTop) * _dragZ) + "px";
      }
    });

    const onUp = () => {
      onMove.flush();
      dragging = false;
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      document.removeEventListener("pointercancel", onUp);
      try { if (_ptrId != null) node.releasePointerCapture(_ptrId); } catch (e2) {}
      _ptrId = null;
      if (!moved) {
        // A TAP (no drag): the browser already placed the caret where the user clicked.
        // Enter WRITING mode without disturbing that caret — do NOT call
        // enterTextEditMode(), which collapses the caret to the end of the text.
        node.setAttribute("contenteditable", "true");
        node.classList.add("is-editing");
        showTextToolbarFor(node);
        try { if (document.activeElement !== node) node.focus({ preventScroll: true }); } catch (e2) {}
        return;
      }
      positionTextSelectFrame(node); positionRotateHandle(node);   // exact, once, on release
      pushUndoState("Move Text");
      if (moved && node.closest(".dmb-cover-preview")) {
        // Determine which cover zone the text now sits in (by its visual centre x,
        // measured from the full-cover overlay so the zoom transform is handled)
        // and update its stored zone. If it landed on the spine, snap it to the
        // spine's horizontal centre — vertical position is kept as dropped.
        const _ov = document.getElementById("coverOverlay");
        if (_ov) {
          const _ovr = _ov.getBoundingClientRect();
          const _Zs  = (_ovr.width / (_ov.offsetWidth || 622)) || 1;
          const _nr  = node.getBoundingClientRect();
          const _cx  = ((_nr.left + _nr.width / 2) - _ovr.left) / _Zs;
          let _zone;
          if (window.DMB_MAGAZINE_MODE) {
            _zone = _cx < COVER_BACK_W ? "back" : "front";
          } else if (_cx < COVER_BACK_W) {
            _zone = "back";
          } else if (_cx <= COVER_BACK_W + COVER_SPINE_W) {
            _zone = "spine";
          } else {
            _zone = "front";
          }
          const _ut = (editor.coverUserTexts || []).find((en) => en.id === node.id);
          if (_ut) _ut.zone = _zone;
          if (_zone === "spine" && !window.DMB_MAGAZINE_MODE) {
            // Centre the LETTERS (glyph centre), not the box — for −90° spine text
            // the in-box line-height gap becomes a horizontal offset after rotation.
            let _gcx = _cx;
            try {
              const _tf = node.style.transform;
              node.style.transform = "none";
              const _ur = node.getBoundingClientRect();
              const _rng = document.createRange(); _rng.selectNodeContents(node);
              const _gr = _rng.getBoundingClientRect();
              node.style.transform = _tf;
              if (_gr && _gr.width > 0 && _gr.height > 0) {
                const _gdx = ((_gr.left + _gr.width  / 2) - (_ur.left + _ur.width  / 2)) / _Zs;
                const _gdy = ((_gr.top  + _gr.height / 2) - (_ur.top  + _ur.height / 2)) / _Zs;
                let _eff = parseFloat(node.dataset.rotate || "0") || 0;
                if (!_eff) { const _m = (_tf || "").match(/rotate\(\s*(-?[\d.]+)deg/); if (_m) _eff = parseFloat(_m[1]) || 0; }
                const _rad = _eff * Math.PI / 180;
                _gcx = _cx + (_gdx * Math.cos(_rad) - _gdy * Math.sin(_rad));
              }
            } catch (e) {}
            const _spineCx = COVER_BACK_W + COVER_SPINE_W / 2;
            const _dx = _spineCx - _gcx;
            node.style.left = ((parseFloat(node.style.left) || 0) + _dx) + "px";
          }
        }
      }
      else if (moved) {
        // Interior page cross-page move: if the box centre now sits over the OTHER
        // page body of the spread, reparent it there (and reindex it in
        // editor.pageObjects). Dropping over a LOCKED page or the gutter snaps it
        // back inside its current page.
        try {
          const _oldBody = node.parentElement;
          const _spread = _oldBody && _oldBody.closest("#spreadCanvas");
          if (_spread) {
            const _nr = node.getBoundingClientRect();
            const _cx = _nr.left + _nr.width / 2, _cy = _nr.top + _nr.height / 2;
            const _Z = _dragZ || 1;
            const _bodies = Array.from(_spread.querySelectorAll('[data-page-body="true"]'));
            let _hit = null;
            for (const b of _bodies) { const r = b.getBoundingClientRect(); if (_cx >= r.left && _cx <= r.right && _cy >= r.top && _cy <= r.bottom) { _hit = b; break; } }
            const _clampBack = (body) => {
              const bw = node.offsetWidth, bh = node.offsetHeight;
              let l = parseFloat(node.style.left) || 0, t = parseFloat(node.style.top) || 0;
              l = Math.max(0, Math.min(l, Math.max(0, (body.offsetWidth  || 0) - bw)));
              t = Math.max(0, Math.min(t, Math.max(0, (body.offsetHeight || 0) - bh)));
              node.style.left = l + "px"; node.style.top = t + "px";
            };
            if (_hit && _hit !== _oldBody) {
              const _newPn = parseInt(_hit.dataset.pageNumber);
              if (Number.isFinite(_newPn) && !isLockedPage(_newPn)) {
                const _oldPn = parseInt(node.dataset.pageNumber);
                const _nbr = _hit.getBoundingClientRect();
                const _newLeft = (_nr.left - _nbr.left) / _Z;
                const _newTop  = (_nr.top  - _nbr.top ) / _Z;
                _hit.appendChild(node);
                node.style.left = _newLeft + "px";
                node.style.top  = _newTop  + "px";
                node.dataset.pageNumber = String(_newPn);
                if (Number.isFinite(_oldPn) && Array.isArray(editor.pageObjects[_oldPn])) {
                  const _i = editor.pageObjects[_oldPn].findIndex((o) => o.id === node.id);
                  if (_i >= 0) {
                    const _obj = editor.pageObjects[_oldPn].splice(_i, 1)[0];
                    if (!Array.isArray(editor.pageObjects[_newPn])) editor.pageObjects[_newPn] = [];
                    editor.pageObjects[_newPn].push(_obj);
                  }
                }
              } else {
                _clampBack(_oldBody);   // locked target → keep it on its own page
              }
            } else if (!_hit) {
              _clampBack(_oldBody);     // dropped over the gutter → snap inside
            }
          }
        } catch (e) {}
      }
      // Persist the final position once, at drag-end (deferred from onMove so the
      // drag stays smooth on touch).
      saveCoverTextNodeState(node);
      savePageTextState(node);
    };

    node.addEventListener("pointerdown", (e) => {
      if (e.target.closest("#dmbTextToolbar")) return;
      if (e.target.closest("#dmbTextRotateHandle")) return;
      // Click-through: if this text box isn't the active one and the press lands on
      // its transparent area (not the letters) — or the user Alt-clicks anywhere —
      // and a selectable item sits beneath that point, select THAT item instead. This
      // keeps small shapes tucked under a text box reachable with a normal click.
      try {
        const _idleText = (selectedTextNode !== node);
        if ((_idleText && !_dmbPointOnGlyphs(node, e.clientX, e.clientY)) || e.altKey) {
          const _beneath = _dmbSelectableBeneath(e.clientX, e.clientY, node);
          if (_beneath) {
            e.preventDefault(); e.stopPropagation();
            _dmbSelectObjectEl(_beneath.obj, _beneath.el);
            return;
          }
        }
      } catch (_pt) {}
      _modeAtDown = node.classList.contains("is-editing") ? "editing"
                  : (selectedTextNode === node ? "solid" : "idle");
      moved = false;

      // ── Writing mode: a drag across the LETTERS selects them ───────────────
      // Dragging used to relocate the box from every state, writing included,
      // and it cancelled the native selection on purpose. That is why no part of
      // a text box could be selected: the only gesture that can pick out a few
      // words was being spent on moving the box.
      //
      // So in writing mode (dashed box, caret in the text) a press that lands on
      // the glyphs is left entirely to the browser - no capture, no listeners,
      // nothing armed - and it drag-selects exactly as text does anywhere else.
      // The box is still moved by dragging it while it is SELECTED (solid frame,
      // one click away), and still moved from writing mode by grabbing it
      // anywhere other than the letters, which on a centred box is most of it.
      // This is the same split Canva and Slides use. (2026-10-12)
      if (_modeAtDown === "editing") {
        let _onGlyphs = false;
        try { _onGlyphs = _dmbPointOnGlyphs(node, e.clientX, e.clientY); } catch (_g) {}
        if (_onGlyphs) { dragging = false; return; }
      }
      // Unified gesture (Canva/Slides-style): a plain TAP drops the caret exactly
      // where the user clicks (native contenteditable), a DRAG past 2px relocates the
      // whole box. So we make the box editable NOW and DON'T preventDefault, letting
      // the browser place the caret; onMove converts the press into a move the moment
      // the finger travels far enough (going solid / not-dashed and cancelling the
      // native text-selection). Works from idle, solid AND editing states.
      if (selectedTextNode !== node) showTextToolbarFor(node);   // select (solid frame)
      if (node.getAttribute("contenteditable") !== "true") node.setAttribute("contenteditable", "true");

      dragging = true;
      _ptrId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      // Resolve through _dmbLenPx: a spine title's top is "50%". Reading it as the
      // bare number 50 made the text teleport ~162px UP the spine the instant the
      // drag passed its 2px threshold - and the spine lock below pins only the
      // HORIZONTAL position, so nothing caught the vertical jump. (2026-09-14)
      startLeft = _dmbLenPx(node, "left");
      startTop = _dmbLenPx(node, "top");
      // Spine cover text stays horizontally centred — lock horizontal during drag.
      {
        const _ut = (editor.coverUserTexts || []).find((en) => en.id === node.id);
        _spineLock = !!(_ut && _ut.zone === "spine") &&
                     !window.DMB_MAGAZINE_MODE &&
                     !!node.closest(".dmb-cover-preview");
      }
      // Compute natural glyph width without any forced CSS width so the drag clamp
      // uses the actual visible text extent (not an alignment box that may be wider).
      { const _sw = node.style.width; node.style.width = ''; _dragNW = node.offsetWidth || 80; node.style.width = _sw; }

      // Cache the scale + clamp bounds ONCE (cover/parent rects, scale and box size
      // are all constant during a position drag) so onMove does no layout reflows.
      _dragZ = _nodeOnScreenScale(node) || 1;
      {
        const _pp = node.parentElement;
        const _bw0 = node.offsetWidth, _bh0 = node.offsetHeight;
        let _xMn, _xMx;
        const _cw = _pp && _pp.closest(".dmb-cover-preview");
        if (_cw) {
          const _cr = _cw.getBoundingClientRect();
          const _pr = _pp.getBoundingClientRect();
          _xMn = Math.round((_cr.left  - _pr.left) / _dragZ - _bw0 / 2);
          _xMx = Math.round((_cr.right - _pr.left) / _dragZ - _bw0 / 2);
        } else {
          // Interior page: let the box travel across the spread's OTHER page during
          // the drag (it is reparented to that page on drop). Clamp to the whole
          // spread, expressed in THIS page body's coordinate system.
          const _spread = _pp && _pp.closest("#spreadCanvas");
          if (_spread) {
            const _sr = _spread.getBoundingClientRect();
            const _pr = _pp.getBoundingClientRect();
            _xMn = Math.round((_sr.left  - _pr.left) / _dragZ - _bw0 / 2);
            _xMx = Math.round((_sr.right - _pr.left) / _dragZ - _bw0 / 2);
          } else {
            _xMn = Math.round(-_bw0 / 2);
            _xMx = Math.round((_pp ? _pp.offsetWidth : 0) - _bw0 / 2);
          }
        }
        _dragBounds = {
          xMin: _xMn, xMax: _xMx,
          yMin: Math.round(-_bh0 / 2),
          yMax: Math.round((_pp ? _pp.offsetHeight : 0) - _bh0 / 2),
        };
      }
      // Selection frame + rotate handle: read their resting position ONCE here. During
      // the drag they move by the same offset as the box (no layout reads per frame);
      // onUp re-measures them exactly.
      positionTextSelectFrame(node); positionRotateHandle(node);
      const _dragFr = ensureTextSelectFrame();
      const _dragRh = ensureRotateHandle();
      _dragFrame = _dragFr; _dragRot = _dragRh;
      _fr0L = parseFloat(_dragFr.style.left) || 0; _fr0T = parseFloat(_dragFr.style.top) || 0;
      _rh0L = parseFloat(_dragRh.style.left) || 0; _rh0T = parseFloat(_dragRh.style.top) || 0;

      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
      document.addEventListener("pointercancel", onUp);
    });

    node.addEventListener("click", (e) => {
      e.stopPropagation();   // don't let the canvas deselect the box
      moved = false;
      // Tap-vs-drag and caret placement are handled by the pointer gesture
      // (pointerdown / onMove / onUp) — nothing to toggle here.
    });

    // Prevent native browser text-selection drag from bubbling to the page drop handler
    node.addEventListener("dragstart", (e) => { e.preventDefault(); e.stopPropagation(); });

    // Intercept Backspace / Delete when the text box is empty.
    // Without this, the browser removes the DOM node directly but leaves it in
    // editor.pageObjects / editor.coverObjects, so it reappears on the next
    // re-render.  We replicate the same cleanup the Delete toolbar button does.
    node.addEventListener("keydown", (e) => {
      // Escape leaves writing mode → back to SELECTED (solid box, arrows move it).
      if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); enterTextSelectMode(node); return; }
      if (e.key !== "Backspace" && e.key !== "Delete") return;
      if (node.textContent.trim() !== "") return; // still has content — let browser handle it
      // Empty box: do NOT delete it. Keep the box on the canvas (it shows its
      // placeholder) so a stray Backspace on a just-added text can't wipe the
      // whole box. An empty box is discarded only when the user clicks away
      // while it's still empty (see the blur / click-out handlers below).
      e.preventDefault();
    });

    node.addEventListener("blur", () => {
      // Defer to let focus settle (clicking a toolbar control blurs the text).
      setTimeout(() => {
        const ae = document.activeElement;
        // Focus moved into a toolbar control (font size, colour…) — keep the
        // editing session and its menu alive.
        if (ae && ae.closest && ae.closest("#dmbTextToolbar")) {
          if (selectedTextNode === node) showTextToolbarFor(node);
          return;
        }
        if (ae === node) return; // caret returned to the text itself
        // Left empty → drop the box together with its menu, immediately.
        if (!captureVisualText(node).trim()) { _dmbRemoveTextNode(node); return; }
        // Non-empty: preserve previous behaviour (keep it selected if it still
        // is; an outside click will already have deselected it).
        if (selectedTextNode === node) showTextToolbarFor(node);
      }, 0);
    });
  }

  // Make a text box fit the page (or cover face) it sits on: wrap the text, keep the
  // box inside the trim, then step the font down until the whole thing fits. Used
  // after a paste, where the incoming text can be far longer than the box was drawn
  // for and would otherwise run straight off the sheet. (2026-10-12)
  // ── Paste with nothing open → a new text box ──────────────────────────────
  // A paste only reaches here when NEITHER item clipboard holds anything: the
  // Ctrl+V key handler takes the event (and preventDefaults, which stops the paste
  // event ever firing) whenever an item or a group was copied, so a copied frame
  // still pastes as a frame. What is left is text from outside the builder, and the
  // only sensible place for that is a box of its own. (2026-10-13)
  function _dmbBuilderBusy() {
    try {
      if (document.documentElement.classList.contains("dmbce-open")) return true;  // card editor
      const ids = ["dmbPreviewOverlay", "dmbProofOverlay", "dmbCardModal", "dmbNoticeDialog", "dmbDupPageModal"];
      for (let i = 0; i < ids.length; i++) {
        const el = document.getElementById(ids[i]);
        if (el && el.offsetParent !== null) return true;
      }
    } catch (e) {}
    return false;
  }

  function _dmbPasteAsNewTextBox(txt) {
    // Go through the Add text button, so the box is REGISTERED exactly like every
    // other one: right page or cover zone, id, z, model entry, handlers. A second
    // implementation here is precisely how a box ends up on screen but missing from
    // the PDF.
    const btn = document.getElementById("canvasTextBtn") || document.getElementById("addTextBtn");
    if (!btn) return false;
    const before = document.querySelectorAll(".dmb-editable-text").length;
    btn.click();
    const node = (typeof selectedTextNode !== "undefined") ? selectedTextNode : null;
    if (!node || !node.isConnected) return false;
    if (document.querySelectorAll(".dmb-editable-text").length <= before) return false;
    node.textContent = txt;
    try { _dmbFitTextToSheet(node); } catch (e) {}          // wrap + shrink onto the sheet
    try { saveCoverTextNodeState(node); } catch (e) {}
    try { savePageTextState(node); } catch (e) {}
    try { saveCoverDesignToStorage(); } catch (e) {}
    try { _dmbWriteProgressState(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
    // Land SELECTED, not writing. The text is already there, and a selected box is
    // the one you can drag straight into place (in writing mode a drag across the
    // letters selects them instead).
    try { enterTextSelectMode(node); } catch (e) {}
    try { positionTextSelectFrame(node); positionRotateHandle(node); } catch (e) {}
    return true;
  }

  document.addEventListener("paste", function (e) {
    try {
      if (typeof _dmbRenderMode === "function" && _dmbRenderMode()) return;
      // Something that takes typing already has the focus: a box being written in,
      // a toolbar field, a search box. Its own handler owns the paste.
      const a = document.activeElement;
      if (a && (a.isContentEditable || a.tagName === "INPUT" ||
                a.tagName === "TEXTAREA" || a.tagName === "SELECT")) return;
      if (e.target && e.target.closest &&
          e.target.closest("input, textarea, [contenteditable='true']")) return;
      if (_dmbBuilderBusy()) return;
      // The builder has to be the thing on screen, and it has to have somewhere to
      // put the box.
      const host = document.querySelector('[data-page-body="true"], #coverOverlay');
      if (!host || host.offsetParent === null) return;

      let txt = "";
      try {
        const cd = e.clipboardData || window.clipboardData;
        txt = (cd && cd.getData("text/plain")) || "";
      } catch (err) {}
      // Normalise the line endings exactly as the in-box paste does, then drop the
      // blank edges a copy from a web page nearly always brings with it. An image on
      // the clipboard leaves this empty, and nothing happens.
      txt = txt.replace(/\r\n?/g, "\n").replace(/^\s+|\s+$/g, "");
      if (!txt) return;
      e.preventDefault();
      _dmbPasteAsNewTextBox(txt);
    } catch (err) {}
  }, true);

  function _dmbFitTextToSheet(node) {
    try {
      if (!node) return;
      var host = node.closest('[data-page-body="true"]') ||
                 node.closest("#coverOverlay") ||
                 node.closest(".dmb-cover-preview") ||
                 node.parentElement;
      if (!host) return;
      var isPage = !!node.closest('[data-page-body="true"]');
      var HW = host.offsetWidth || 0, HH = host.offsetHeight || 0;
      if (!HW || !HH) return;
      var M = 10;                                  // keep clear of the trim edge

      // Long pasted text must WRAP; without this a single line runs off the sheet and
      // no amount of shrinking brings it back.
      node.style.whiteSpace = "pre-wrap";
      node.style.minWidth = "0";                   // an explicit width outranks the
                                                   // 120px new-box minimum

      // ---- width ----
      var availW = Math.max(60, HW - M * 2);
      var w = node.offsetWidth || 0;
      if (!w || w > availW) w = availW;
      if (w < 60) w = Math.min(availW, 160);
      node.style.width = Math.round(w) + "px";

      // ---- horizontal position: only for PAGE text ----
      // Cover text is zone-anchored and spine text is centred with a percentage top;
      // nudging either from here would undo that, so leave cover boxes where they are.
      if (isPage) {
        var left = _dmbLenPx(node, "left");
        if (left + w > HW - M) left = Math.max(M, HW - M - w);
        if (left < M) left = M;
        node.style.left = Math.round(left) + "px";
      }

      // ---- font size: step down until the height fits below the box top ----
      var top = isPage ? _dmbLenPx(node, "top") : 0;
      var availH = Math.max(40, HH - M - (isPage ? top : M));
      var fs = parseFloat(window.getComputedStyle(node).fontSize) || 28;
      var guard = 0;
      while (node.offsetHeight > availH && fs > 6 && guard++ < 80) {
        fs = Math.max(6, fs - Math.max(1, Math.round(fs * 0.08)));
        node.style.fontSize = fs + "px";
      }

      // Still too tall at the minimum size: slide the box up rather than let it hang
      // off the bottom of the sheet. Page text only, for the same reason as above.
      if (isPage && node.offsetHeight > availH) {
        node.style.top = Math.max(M, HH - M - node.offsetHeight) + "px";
      }

      try {
        var fsi = document.getElementById("dmbFontSize");
        if (fsi) fsi.value = String(Math.round(fs));
      } catch (e) {}
    } catch (e) {}
  }

  function attachTextNodeHandlers(node) {
    if (!node) return;
    if (node.dataset.dmbTextReady === "true") return;
    node.dataset.dmbTextReady = "true";

    node.classList.add("dmb-editable-text");
    node.style.position = "absolute";
    node.dataset.z = node.dataset.z || String(Date.now());
    node.style.zIndex = node.dataset.z;
    node.style.transformOrigin = "center center";
    // Touch drag fix: without touch-action:none the browser claims the drag
    // gesture on this (contenteditable) node and fires pointercancel instead of
    // pointerup, so the move is never committed (no pushUndoState → no autosave
    // → preview/PDF revert to the template position). A tap still focuses the
    // node for editing; only pan/scroll-from-this-node is suppressed.
    node.style.touchAction = "none";

    if (!node.style.left) node.style.left = "40px";
    if (!node.style.top) node.style.top = "40px";

    // Boxes start non-editable (idle / SELECTED). Writing mode flips this to "true"
    // via enterTextEditMode, so a stray focus can never put the arrow keys into
    // caret-move mode on an unselected box.
    node.setAttribute("contenteditable", "false");

    // Mode transitions are owned by makeTextInteractive's pointerdown/click; here we
    // only stop the click bubbling to the canvas deselect handler.
    node.addEventListener("click", (e) => { e.stopPropagation(); });

    // Paste carries the SOURCE's markup: Word and web pages bring their own font,
    // size and colour inline, so pasted text landed looking nothing like the box it
    // was pasted into. Take the plain text only, so it inherits the box's own styling,
    // then re-fit the box to the sheet. execCommand keeps the browser's native undo
    // stack, which a manual range insert would break. (2026-10-12)
    node.addEventListener("paste", (e) => {
      let txt = "";
      try {
        const cd = e.clipboardData || window.clipboardData;
        txt = (cd && cd.getData("text/plain")) || "";
      } catch (err) {}
      if (!txt) return;                       // nothing usable: let the browser handle it
      e.preventDefault();
      txt = txt.replace(/\r\n?/g, "\n");
      let ok = false;
      try { ok = document.execCommand("insertText", false, txt); } catch (err) {}
      if (!ok) {
        // Fallback for anywhere execCommand is unavailable.
        try {
          const sel = window.getSelection();
          if (sel && sel.rangeCount) {
            const r = sel.getRangeAt(0);
            r.deleteContents();
            const tn = document.createTextNode(txt);
            r.insertNode(tn);
            r.setStartAfter(tn); r.collapse(true);
            sel.removeAllRanges(); sel.addRange(r);
          } else {
            node.textContent = (node.textContent || "") + txt;
          }
        } catch (err) {}
      }
      // Drop anything the browser slipped in that is not ours, keeping what IS:
      // <br> line breaks and the spans that carry per-word formatting. This used to
      // flatten the box to textContent whenever it held ANY element, which quietly
      // joined every line into one (textContent has no line breaks) and, since the
      // per-word looks arrived, wiped those too.
      try { _dmbStripForeignMarkup(node); } catch (err) {}
      try { _dmbFitTextToSheet(node); } catch (err) {}
      // Run the normal save path so the PDF capture and autosave see the new text.
      try { node.dispatchEvent(new Event("input", { bubbles: true })); } catch (err) {}
      try { positionTextSelectFrame(node); positionRotateHandle(node); } catch (err) {}
      try { pushUndoState("Paste Text"); } catch (err) {}
    });

    node.addEventListener("input", () => {
      // Keep empty boxes visible (they show the placeholder); an abandoned empty
      // box is removed on blur / click-out, not hidden here.
      node.style.display = "block";
      if (
        node.id === "coverFrontTitle1" ||
        node.id === "coverBackTitle1" ||
        node.id === "coverSpineTitle1"
      ) {
        coverState.title1 = node.textContent.trim();
        if (coverTitle1Input) coverTitle1Input.value = coverState.title1;
      }

      if (
        node.id === "coverFrontTitle2" ||
        node.id === "coverBackTitle2"
      ) {
        coverState.title2 = node.textContent.trim();
        if (coverTitle2Input) coverTitle2Input.value = coverState.title2;
      }
      saveCoverTextNodeState(node);
      savePageTextState(node);
      saveCoverDesignToStorage();
      // Persist to the progress-state key that the ?restore=1 refresh flow reads —
      // IMMEDIATELY, not on a debounce. Text edits used to write only the
      // cover-specific storage and relied on the debounced autosave / pagehide flush
      // to reach the restore key, so text typed just before a refresh could vanish
      // while the background colour (saved earlier) survived. A per-keystroke ~8 KB
      // localStorage write is cheap.
      try { _dmbWriteProgressState(); } catch (e) {}
      try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
      showTextToolbarFor(node);
    });

    makeTextInteractive(node);
  }

  function wireTextToolbar() {
    if (wireTextToolbar._done) return;
    wireTextToolbar._done = true;

    ensureRotateHandle();

    const fontFamily = document.getElementById("dmbFontFamily");
    const fontSize = document.getElementById("dmbFontSize");
    const textColor = document.getElementById("dmbTextColor");
    const underlineBtn = document.getElementById("dmbUnderlineBtn");
    const textAlign = document.getElementById("dmbTextAlign");
    const duplicateBtn = document.getElementById("dmbDuplicateTextBtn");
    const deleteBtn = document.getElementById("dmbDeleteTextBtn");
    const applyAllBtn = document.getElementById("dmbApplyAllTextBtn");
    const textFrontBtn = document.getElementById("dmbTextFrontBtn");
    const textBackBtn = document.getElementById("dmbTextBackBtn");
    const textPosLeft = document.getElementById("dmbTextPosLeft");
    const textPosCenter = document.getElementById("dmbTextPosCenter");
    const textPosRight = document.getElementById("dmbTextPosRight");

    // ── Format painter ────────────────────────────────────────────────────
    // Select a text box, click the brush, then click another box to give it the first
    // one's look.
    //
    // It copies ONLY the properties that are actually persisted by
    // saveCoverTextNodeState / savePageTextState. Copying anything beyond that set
    // would look correct on screen and then silently revert on the next reload or in
    // the printed PDF, which is worse than not copying it at all. (2026-10-12)
    const fmtPaintBtn = document.getElementById("dmbFormatPaintBtn");
    const _FMT_PROPS = ["color", "fontFamily", "fontSize", "fontWeight", "textAlign", "textDecoration"];
    let _fmtClip = null;

    function _fmtSetArmed(on) {
      if (!on) _fmtClip = null;
      try { document.body.classList.toggle("dmb-fmt-painting", !!on); } catch (e) {}
      if (fmtPaintBtn) fmtPaintBtn.classList.toggle("is-active", !!on);
      if (on) document.addEventListener("pointerdown", _fmtOnPick, true);
      else    document.removeEventListener("pointerdown", _fmtOnPick, true);
    }

    // Capture phase, so the paint lands before the box's own drag/select handlers get
    // the event and start moving it instead.
    function _fmtOnPick(e) {
      const t = (e.target && e.target.closest) ? e.target.closest(".dmb-editable-text") : null;
      if (!t) { _fmtSetArmed(false); return; }   // clicked away: disarm, change nothing
      e.preventDefault(); e.stopPropagation();
      if (!_fmtClip) { _fmtSetArmed(false); return; }
      pushUndoState("Copy Formatting");
      // Any per-word look on the TARGET is cleared first. "Make this box look like
      // that one" has no meaning while some of its words are still overriding the
      // answer - the brush would appear to do nothing to them.
      try { _dmbFlattenRuns(t); } catch (err) {}
      _FMT_PROPS.forEach(function (p) { if (_fmtClip[p]) t.style[p] = _fmtClip[p]; });
      try { saveCoverTextNodeState(t); savePageTextState(t); saveCoverDesignToStorage(); } catch (err) {}
      try { _dmbWriteProgressState(); } catch (err) {}
      try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (err) {}
      try { positionTextSelectFrame(t); positionRotateHandle(t); } catch (err) {}
      _fmtSetArmed(false);                       // one box per click of the brush
    }

    if (fmtPaintBtn) {
      fmtPaintBtn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        if (document.body.classList.contains("dmb-fmt-painting")) { _fmtSetArmed(false); return; }
        if (!selectedTextNode) return;           // nothing to copy from
        const cs = window.getComputedStyle(selectedTextNode);
        _fmtClip = {};
        // Prefer the inline value (what gets saved); fall back to computed so a box
        // styled only by the stylesheet still copies something sensible.
        _FMT_PROPS.forEach(function (p) {
          _fmtClip[p] = selectedTextNode.style[p] || (cs && cs[p]) || "";
        });
        _fmtSetArmed(true);
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") _fmtSetArmed(false);
    });
    function applyToSelected(fn) {
      if (!selectedTextNode) return;
      const node = selectedTextNode;
      // One undo snapshot per burst (captures the PRE-edit state).
      _dmbTextStyleBeginUndo();
      fn(node);                                     // visual change — applied + painted now
      try { showTextToolbarFor(node); } catch (e) {}  // light (same selection): just reposition
      _dmbTextStyleScheduleCommit(node);            // heavy saves debounced, off the hot path
      // Only re-focus the text node if the user is NOT currently interacting with
      // a control that owns focus. Re-focusing would steal focus back to the text:
      //  • a toolbar control (e.g. the font-size input) — every digit after the
      //    first would land in the text content instead of the input;
      //  • a colour picker / the mobile colour sheet — stealing focus from an open
      //    <input type=color> DISMISSES the native picker mid-edit (text-only bug:
      //    shapes/maps don't re-focus anything, so their picker stayed open).
      const _active = document.activeElement;
      const _ownsFocus = _active && (
        _active.closest("#dmbTextToolbar") ||
        _active.closest("#dmbMshColorSheet") ||
        (_active.tagName === "INPUT" && _active.type === "color")
      );
      if (!_ownsFocus) {
        try { node.focus(); } catch (e) {}
      }
    }

    if (fontFamily) {
      fontFamily.addEventListener("change", () => {
        // Words selected → only those words. Nothing selected → the whole box,
        // exactly as before.
        if (_dmbApplyToTextSelection({ fontFamily: fontFamily.value }, "Font")) return;
        applyToSelected((node) => {
          _dmbStripRunProp(node, "font-family");   // whole box → override any per-word runs
          node.style.fontFamily = fontFamily.value;
        });
      });
    }

    if (fontSize) {
      const applyFontSize = () => {
        const v = Number(fontSize.value);
        if (!Number.isFinite(v) || v <= 0) return;

        if (_dmbApplyToTextSelection({ fontSize: v + "px" }, "Font Size")) return;
        applyToSelected((node) => {
          _dmbStripRunProp(node, "font-size");   // whole box → override any per-word runs
          node.style.fontSize = `${v}px`;
        });
      };

      fontSize.addEventListener("input", applyFontSize);
      fontSize.addEventListener("change", applyFontSize);
    }

    if (textColor) {
      textColor.addEventListener("input", () => {
        if (_dmbApplyToTextSelection({ color: textColor.value }, "Text Colour")) {
          try { _dmbSyncTextColorDot(); } catch (e) {}
          return;
        }
        applyToSelected((node) => {
          _dmbStripRunProp(node, "color");   // whole box → override any per-word runs
          node.style.color = textColor.value;
        });
        try { _dmbSyncTextColorDot(); } catch (e) {}
      });
      // Recently-used colours now live INSIDE the colour-wheel popup.
      try { dmbEnhanceColorInput(textColor, document.getElementById("dmbTextColorPop")); } catch (e) {}
      // Keep the custom-colour button last (the swatch strip is appended after it).
      try {
        const _cc = document.getElementById("dmbTextColorCustom");
        const _cp = document.getElementById("dmbTextColorPop");
        if (_cc && _cp) _cp.appendChild(_cc);
        _dmbColorTapFix(_cc, textColor);
      } catch (e) {}
      try { _dmbSyncTextColorDot(); } catch (e) {}
    }

    // Colour-wheel button → toggle the palette popup.
    const colorBtn = document.getElementById("dmbTextColorBtn");
    const colorPop = document.getElementById("dmbTextColorPop");
    const colorCustom = document.getElementById("dmbTextColorCustom");
    if (colorBtn && colorPop) {
      colorBtn.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const willOpen = colorPop.hidden;
        _dmbCloseTextMenus(colorPop);
        colorPop.hidden = !willOpen;
      });
      // Picking a recent swatch closes the popup.
      colorPop.addEventListener("click", (e) => {
        if (e.target.closest(".dmb-recent-swatch")) colorPop.hidden = true;
      });
    }
    if (colorCustom && textColor) {
      colorCustom.addEventListener("click", (e) => {
        e.stopPropagation();                       // identical to the background wheel — NO preventDefault
        if (e.target === textColor) return;        // overlay input tapped → let it open the native picker
        try { textColor.click(); } catch (e2) {}   // desktop fallback: opens the OS colour picker
      });
    }
    if (textColor && colorPop) {
      textColor.addEventListener("change", () => { colorPop.hidden = true; });
    }

    // Alignment icon dropdown → drives the hidden <select> (reuses its handler).
    const alignToggle = document.getElementById("dmbTextAlignToggle");
    const alignMenu = document.getElementById("dmbTextAlignMenu");
    if (alignToggle && alignMenu) {
      alignToggle.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const willOpen = alignMenu.hidden;
        _dmbCloseTextMenus(alignMenu);
        alignMenu.hidden = !willOpen;
      });
      alignMenu.querySelectorAll(".dmb-align-opt").forEach((opt) => {
        opt.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          if (textAlign) {
            textAlign.value = opt.getAttribute("data-align");
            textAlign.dispatchEvent(new Event("change", { bubbles: true }));
          }
          try { _dmbSyncAlignIcon(); } catch (e2) {}
          alignMenu.hidden = true;
        });
      });
    }
    try { _dmbSyncAlignIcon(); } catch (e) {}

    // "More" dropdown: on-page position (←/↔/→) + Duplicate.
    const moreToggle = document.getElementById("dmbTextMoreToggle");
    const moreMenu = document.getElementById("dmbTextMoreMenu");
    if (moreToggle && moreMenu) {
      moreToggle.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const willOpen = moreMenu.hidden;
        _dmbCloseTextMenus(moreMenu);
        moreMenu.hidden = !willOpen;
      });
      moreMenu.addEventListener("click", (e) => {
        if (e.target.closest(".dmb-text-more-item")) moreMenu.hidden = true;
      });
    }

    // Outside-click closes every text-toolbar popup (bound once).
    if (!wireTextToolbar._popClose) {
      wireTextToolbar._popClose = true;
      document.addEventListener("click", (e) => {
        if (!e.target.closest("#dmbTextColorWrap")) { const p = document.getElementById("dmbTextColorPop"); if (p) p.hidden = true; }
        if (!e.target.closest("#dmbTextAlignDD")) { const p = document.getElementById("dmbTextAlignMenu"); if (p) p.hidden = true; }
        if (!e.target.closest("#dmbTextMoreDD")) { const p = document.getElementById("dmbTextMoreMenu"); if (p) p.hidden = true; }
      });
    }

    if (underlineBtn) {
      underlineBtn.addEventListener("click", () => {
        // On a selection the toggle has to read the SELECTION's state, not the
        // box's, or underlining three words would report back the wrong answer
        // and the next click would underline them a second time.
        if (selectedTextNode && _dmbActiveTextRange(selectedTextNode)) {
          const _off = _dmbSelUnderlined(selectedTextNode);
          if (_dmbApplyToTextSelection({ textDecoration: _off ? "none" : "underline" }, "Underline")) return;
        }
        applyToSelected((node) => {
          node.style.textDecoration =
            node.style.textDecoration === "underline" ? "none" : "underline";
        });
      });
    }

    if (textAlign) {
      textAlign.addEventListener("change", () => {
        applyToSelected((node) => {
          node.style.textAlign = textAlign.value;
          node.style.width = "220px";
        });
      });
    }
    if (textFrontBtn) {
      textFrontBtn.addEventListener("click", () => {
        _dmbDoLayerStep(selectedTextNode, "forward");
        if (selectedTextNode) showTextToolbarFor(selectedTextNode);
      });
    }

    if (textBackBtn) {
      textBackBtn.addEventListener("click", () => {
        _dmbDoLayerStep(selectedTextNode, "backward");
        if (selectedTextNode) showTextToolbarFor(selectedTextNode);
      });
    }

    if (textPosLeft) {
      textPosLeft.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "left");
      });
    }
    if (textPosCenter) {
      textPosCenter.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "center");
      });
    }
    if (textPosRight) {
      textPosRight.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "right");
      });
    }

    if (duplicateBtn) {
      duplicateBtn.addEventListener("click", () => {
        if (!selectedTextNode || !selectedTextNode.parentElement) return;

        const clone = selectedTextNode.cloneNode(true);
        clone.dataset.dmbTextReady = "";
        // Same %-resolution as the drag: duplicating a spine title read top:"50%" as
        // 50 and dropped the copy at 70px - 162px ABOVE the original instead of 20px
        // below it - then saved that px value permanently. The `|| 40` fallback is
        // kept verbatim so nothing else about this handler changes.
        clone.style.left = `${(_dmbLenPx(selectedTextNode, "left") || 40) + 20}px`;
        clone.style.top = `${(_dmbLenPx(selectedTextNode, "top") || 40) + 20}px`;
        clone.dataset.rotate = selectedTextNode.dataset.rotate || "0";
        clone.style.transform = selectedTextNode.style.transform || "";
        clone.dataset.z = String(Date.now());
        clone.style.zIndex = clone.dataset.z;

        // Register clone in the data model so it survives re-renders
        const newId = (builderMode === "cover" ? "utext_" : "pgtext_") + Date.now() + "_" + Math.random().toString(36).slice(2);
        clone.id = newId;

        if (builderMode === "cover") {
          const zone = activeCoverZone === "back" ? "back" : activeCoverZone === "spine" ? "spine" : "front";
          if (!Array.isArray(editor.coverUserTexts)) editor.coverUserTexts = [];
          editor.coverUserTexts.push({ id: newId, zone });
        } else {
          const pn = parseInt(selectedTextNode.dataset.pageNumber);
          if (Number.isFinite(pn)) {
            clone.dataset.pageNumber = String(pn);
            if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
            editor.pageObjects[pn].push({
              id: newId, type: "text",
              text: captureVisualText(clone),
              whiteSpace: clone.style.whiteSpace || "",
              left: clone.style.left || "40px",
              top: clone.style.top || "40px",
              fontSize: clone.style.fontSize || "28px",
              fontWeight: clone.style.fontWeight || "800",
              color: clone.style.color || "#666",
              fontFamily: clone.style.fontFamily || "",
              textAlign: clone.style.textAlign || "",
              textDecoration: clone.style.textDecoration || "",
              transform: clone.style.transform || "",
              rotate: clone.dataset.rotate || "0",
              z: clone.dataset.z || String(Date.now()),
              width: clone.style.width || ""
            });
          }
        }

        attachTextNodeHandlers(clone);
        selectedTextNode.parentElement.appendChild(clone);
        // Save AFTER the append: boxWidth/boxHeight and the captured line breaks can
        // only be measured on a node that is actually laid out. Saving beforehand
        // stored zeros and an empty renderedLines, so the PDF re-wrapped the copy
        // from scratch and a duplicated multi-line caption printed as one long line.
        if (builderMode === "cover") { try { saveCoverTextNodeState(clone); } catch (e) {} }
        else { try { savePageTextState(clone); } catch (e) {} }
        enterTextSelectMode(clone);   // duplicate lands SELECTED (solid), arrows move it
      });
    }

    if (deleteBtn) {
      deleteBtn.addEventListener("click", () => {
        if (!selectedTextNode) return;
        const node = selectedTextNode;
        pushUndoState("Delete Text");
        // Remove from registry so it doesn't reappear on re-render
        if (node.id) {
          editor.coverUserTexts = (editor.coverUserTexts || []).filter((e) => e.id !== node.id);
          if (coverState.textStyles) delete coverState.textStyles[node.id];
          const _dpn = parseInt(node.dataset.pageNumber);
          if (Number.isFinite(_dpn) && Array.isArray(editor.pageObjects?.[_dpn])) {
            editor.pageObjects[_dpn] = editor.pageObjects[_dpn].filter((o) => o.id !== node.id);
          }
        }
        hideTextToolbar();
        node.remove();
      });
    }

    if (applyAllBtn) {
      applyAllBtn.addEventListener("click", () => {
        if (!selectedTextNode) return;

        pushUndoState("Apply Text Style To All");
        const styles = {
          fontFamily: selectedTextNode.style.fontFamily,
          fontSize: selectedTextNode.style.fontSize,
          color: selectedTextNode.style.color,
          textDecoration: selectedTextNode.style.textDecoration,
          textAlign: selectedTextNode.style.textAlign,
          transform: selectedTextNode.style.transform,
          width: selectedTextNode.style.width,
          // width can switch a box between wrapping and not; carry the flag with it
          // or the model and the DOM disagree about how the text breaks.
          whiteSpace: selectedTextNode.style.whiteSpace
        };

        document.querySelectorAll(".dmb-editable-text").forEach((el) => {
          Object.assign(el.style, styles);
          el.dataset.rotate = selectedTextNode.dataset.rotate || "0";
          // Write it through to the MODEL — the PDF reads nothing else.
          try { saveCoverTextNodeState(el); } catch (e) {}
          try { savePageTextState(el); } catch (e) {}
        });
        try { saveCoverDesignToStorage(); } catch (e) {}
        try { _dmbAutoPersist(); } catch (e) {}
      });
    }

    document.addEventListener("click", (e) => {
      const clickedText = e.target.closest(".dmb-editable-text");
      const clickedToolbar = e.target.closest("#dmbTextToolbar");
      const clickedRibbon = e.target.closest(".dmb-stage-header") || e.target.closest("#dmbMshRibbon");   // desktop OR mobile ribbon
      const clickedRotateHandle = e.target.closest("#dmbTextRotateHandle");
      const clickedSelFrame = e.target.closest("#dmbTextSelFrame");
      const clickedColorSheet = e.target.closest("#dmbMshColorSheet");   // mobile body colour sheet — keep the text selected
      if (!clickedText && !clickedToolbar && !clickedRibbon && !clickedRotateHandle && !clickedSelFrame && !clickedColorSheet) {
        // If the selected box is empty, discard it together with its menu so an
        // abandoned text box never lingers; otherwise just close the menu.
        const _prev = selectedTextNode;
        if (_prev && !captureVisualText(_prev).trim()) {
          _dmbRemoveTextNode(_prev);
        } else {
          hideTextToolbar();
        }
      }
    });

    // Deselect a frame object (sticker / photo / mag-icon) when the press lands
    // anywhere outside it — the 8 resize dots + floating toolbar + rotate handle
    // should disappear, matching the text-box behavior above. Covers presses on the
    // spread background AND anywhere off the spread (gutter, gray area, etc.).
    // Uses a CAPTURE-phase pointerdown (like the shape edit-bar deselect) because
    // the sticker/canvas layers call stopPropagation() on click/pointerdown, so a
    // bubbling click never reaches document.
    document.addEventListener("pointerdown", (e) => {
      if (!selectedFrameObject) return;
      const t = e.target;
      if (t && t.closest && (
        t.closest(".dmb-photo-frame-object") ||   // on a photo frame
        t.closest(".dmb-sticker-object")     ||   // on a sticker / mag-icon
        t.closest("#dmbFrameToolbar")        ||   // on the floating toolbar
        t.closest(".dmb-stage-header")       ||   // anywhere in the fixed ribbon
        t.closest("#dmbMshRibbon")           ||   // mobile ribbon (idle + docked bars)
        t.closest("#dmbMshColorSheet")       ||   // mobile body colour sheet — keep the frame selected
        t.closest(".dmb-frame-handle")       ||   // on a resize dot
        t.closest(".dmb-map-rotate-handle")  ||   // on the rotate handle
        t.closest(".dmb-map-rot-float")           // rotate handle (float variant)
      )) return;
      hideFrameToolbar();
    }, { capture: true });

    window.addEventListener("resize", () => {
      if (selectedTextNode) showTextToolbarFor(selectedTextNode);
    });
  }

  function saveProjectLocalWithMessage() {
    const payload = getCurrentBuilderStateSnapshot();
    try {
      localStorage.setItem(_dmbProjKey(), JSON.stringify(payload));
      if (saveMsg) {
        saveMsg.textContent = "Saved ✅";
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1400);
      }
    } catch {
      alert("Could not save on this device.");
    }
  }

  function openSavedProjectLocal() {
    const raw = loadProjectLocal();
    if (!raw) {
      alert("No saved project found.");
      return;
    }
    applyBuilderStateSnapshot(raw);
  }

  function startNewProjectLocal() {
    const ok = window.confirm("Start a new project? Unsaved changes may be lost.");
    if (!ok) return;

    try {
      localStorage.removeItem(_dmbProjKey());
    } catch {}

    window.location.href = window.DMB_CARD_MODE
      ? "/pages/design-my-book?type=card&step=2&mode=customize"
      : window.DMB_MAGAZINE_MODE
      ? "/pages/design-my-magazine?step=2&mode=customize"
      : "/pages/design-my-book?step=2&mode=customize";
  }

  function openProjectMenuPrompt() {
    const choice = window.prompt("Type one: save / open / new", "save");
    if (!choice) return;

    const v = choice.trim().toLowerCase();

    if (v === "save") {
      saveProjectLocalWithMessage();
    } else if (v === "open") {
      openSavedProjectLocal();
    } else if (v === "new") {
      startNewProjectLocal();
    }
  }

  function openHistoryPanel() {
    if (!undoStack.length) {
      alert("No history yet.");
      return;
    }

    const lines = undoStack
      .map((s, i) => `${i + 1}. ${s.label || "Edited"}`)
      .join("\n");

    const pick = window.prompt(`History:\n\n${lines}\n\nType a number to restore that step:`, "");
    if (!pick) return;

    const idx = Number(pick);
    if (!Number.isInteger(idx) || idx < 1 || idx > undoStack.length) return;

    const target = undoStack[idx - 1];
    if (!target) return;

    editor.currentSpread = target.currentSpread;
    editor.pageSlots = cloneState(target.pageSlots);
    editor.pageRot = cloneState(target.pageRot);
    editor.pageTemplate = cloneState(target.pageTemplate);
    editor.pageFrames = cloneState(target.pageFrames);
    editor.pageFrameRot = cloneState(target.pageFrameRot);
    builderMode = target.builderMode || "pages";
    editor.pageObjects = cloneState(target.pageObjects || {});
    editor.coverObjects = cloneState(target.coverObjects || []);
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    coverState.textStyles = cloneState(target.coverState?.textStyles || {});
    coverState.template = target.coverState?.template || "default";
    coverState.title1 = target.coverState?.title1 || "";
    coverState.title2 = target.coverState?.title2 || "";
    coverState.color = target.coverState?.color || "#ffffff";

    syncCoverInputsFromState();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function ensurePreviewOverlay() {
    if (document.getElementById("dmbPreviewOverlay")) return;

    const overlay = document.createElement("div");
    overlay.id = "dmbPreviewOverlay";
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.background = "rgba(0,0,0,0.82)";
    overlay.style.zIndex = "99999";
    overlay.style.display = "none";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "24px";

    const panel = document.createElement("div");
    panel.id = "dmbPreviewPanel";
    panel.style.width = "min(1200px, 96vw)";
    panel.style.height = "min(92vh, 920px)";
    panel.style.background = "#1a1a1a";
    panel.style.borderRadius = "20px";
    panel.style.display = "flex";
    panel.style.flexDirection = "column";
    panel.style.overflow = "hidden";

    const head = document.createElement("div");
    head.id = "dmbPreviewHead";
    head.style.cssText = "display:flex;justify-content:space-between;align-items:center;padding:14px 20px;border-bottom:1px solid #333;flex-shrink:0;";

    const titleWrap = document.createElement("div");
    titleWrap.id = "dmbPreviewTitleWrap";
    titleWrap.style.cssText = "display:flex;align-items:center;gap:16px;";

    const titleEl = document.createElement("div");
    titleEl.id = "dmbPreviewTitle";
    titleEl.textContent = "Preview";
    titleEl.style.cssText = "font-weight:900;font-size:16px;color:#fff;";

    const navWrap = document.createElement("div");
    navWrap.id = "dmbPreviewNavWrap";
    navWrap.style.cssText = "display:flex;align-items:center;gap:10px;";

    const prevBtn = document.createElement("button");
    prevBtn.id = "dmbPreviewPrev";
    prevBtn.type = "button";
    prevBtn.textContent = "◀ Prev";
    prevBtn.style.cssText = "padding:7px 14px;border-radius:8px;border:1px solid #555;background:#2a2a2a;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";

    const spreadLabel = document.createElement("div");
    spreadLabel.id = "dmbPreviewSpreadLabel";
    spreadLabel.style.cssText = "font-size:12px;color:#aaa;min-width:80px;text-align:center;";

    const nextBtn = document.createElement("button");
    nextBtn.id = "dmbPreviewNext";
    nextBtn.type = "button";
    nextBtn.textContent = "Next ▶";
    nextBtn.style.cssText = "padding:7px 14px;border-radius:8px;border:1px solid #555;background:#2a2a2a;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";

    const closeBtn = document.createElement("button");
    closeBtn.id = "dmbPreviewClose";
    closeBtn.type = "button";
    closeBtn.style.cssText = "padding:7px 16px;border-radius:8px;border:1px solid #555;background:#333;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";
    closeBtn.textContent = "Close";

    const body = document.createElement("div");
    body.id = "dmbPreviewBody";
    body.style.cssText = "flex:1 1 auto;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:24px;background:#111;";

    closeBtn.addEventListener("click", () => { overlay.style.display = "none"; });

    // ── Confirm banner (shown only in confirm-mode) ───────────────────────
    const confirmBanner = document.createElement("div");
    confirmBanner.id = "dmbPreviewConfirmBanner";
    confirmBanner.style.cssText = "display:none;flex-shrink:0;background:#1a1a1a;border-top:1px solid #333;padding:16px 24px;display:none;flex-direction:column;align-items:center;gap:12px;";

    const confirmMsg = document.createElement("div");
    confirmMsg.style.cssText = "color:#ffd700;font-size:14px;font-weight:700;text-align:center;";
    confirmMsg.textContent = "📋 Review every page carefully using the arrows above — cover, special page, and all spreads. When everything looks perfect, confirm below.";

    const confirmBtn = document.createElement("button");
    confirmBtn.id = "dmbPreviewConfirmBtn";
    confirmBtn.type = "button";
    confirmBtn.textContent = "✅ Looks perfect — Confirm & Place Order";
    confirmBtn.style.cssText = "background:#22c55e;color:#fff;border:none;border-radius:10px;padding:14px 32px;font-size:15px;font-weight:900;cursor:pointer;letter-spacing:0.3px;";
    confirmBtn.addEventListener("mouseover", () => { confirmBtn.style.background = "#16a34a"; });
    confirmBtn.addEventListener("mouseout",  () => { confirmBtn.style.background = "#22c55e"; });

    confirmBanner.appendChild(confirmMsg);
    confirmBanner.appendChild(confirmBtn);

    navWrap.appendChild(prevBtn);
    navWrap.appendChild(spreadLabel);
    navWrap.appendChild(nextBtn);
    titleWrap.appendChild(titleEl);
    titleWrap.appendChild(navWrap);
    head.appendChild(titleWrap);
    head.appendChild(closeBtn);
    panel.appendChild(head);
    panel.appendChild(body);
    panel.appendChild(confirmBanner);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    // ── Mobile layout overrides (applied inline — more reliable than CSS on dynamic elements) ──
    if (window.innerWidth <= 749) {
      panel.style.width         = "100vw";
      panel.style.height        = "100dvh";
      panel.style.borderRadius  = "0";
      panel.style.maxHeight     = "100dvh";

      head.style.position       = "relative";
      head.style.flexDirection  = "column";
      head.style.alignItems     = "flex-start";
      head.style.padding        = "10px 14px";
      head.style.gap            = "6px";

      titleWrap.style.flexDirection = "column";
      titleWrap.style.alignItems    = "flex-start";
      titleWrap.style.gap           = "6px";
      titleWrap.style.width         = "100%";
      titleWrap.style.paddingRight  = "80px"; // space for close button

      titleEl.style.fontSize    = "14px";
      titleEl.style.whiteSpace  = "nowrap";
      titleEl.style.overflow    = "hidden";
      titleEl.style.textOverflow = "ellipsis";
      titleEl.style.maxWidth    = "100%";

      closeBtn.style.position   = "absolute";
      closeBtn.style.top        = "10px";
      closeBtn.style.right      = "14px";
      closeBtn.style.padding    = "8px 16px";
      closeBtn.style.fontSize   = "14px";

      navWrap.style.gap         = "8px";

      body.style.padding        = "10px";
    }

    // Keyboard navigation
    overlay.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); prevBtn.click(); }
      if (e.key === "ArrowRight") { e.preventDefault(); nextBtn.click(); }
      if (e.key === "Escape") { overlay.style.display = "none"; }
    });
    overlay.setAttribute("tabindex", "0");
  }

  function getSelectedTextNode() {
    return selectedTextNode || null;
  }

  function bringSelectedTextToFront() {
    const node = getSelectedTextNode();
    if (!node) return;
    const z = String(Date.now());
    node.dataset.z = z;
    node.style.zIndex = z;
    showTextToolbarFor(node);
  }

  function sendSelectedTextToBack() {
    const node = getSelectedTextNode();
    if (!node) return;

    const all = Array.from(document.querySelectorAll(".dmb-editable-text, .dmb-photo-frame-object, .dmb-map-object"));
    let minZ = 1;

    all.forEach((el) => {
      if (el === node) return;
      const z = Number(el.dataset.z || el.style.zIndex || 1);
      if (!Number.isNaN(z)) minZ = Math.min(minZ, z);
    });

    const next = String(minZ - 1);
    node.dataset.z = next;
    node.style.zIndex = next;
    showTextToolbarFor(node);
  }

  function buildPreviewPageNode(pageNumber) {
    if (pageNumber === 0) {
      const coverWrap = document.createElement("div");
      // Carry the landscape context so the CLONED faces render wide/short exactly
      // like the builder (otherwise they'd revert to the portrait aspect).
      coverWrap.className = "dmb-cover-preview" + (dmbIsLandscape() ? " dmb-cover-landscape" : "");
      coverWrap.style.padding = "0";

      let back = $("coverBack")?.cloneNode(true);
      let spine = window.DMB_MAGAZINE_MODE ? null : ($("coverSpine")?.cloneNode(true) ?? null);
      let front = $("coverFront")?.cloneNode(true);

      if (!back || (!window.DMB_MAGAZINE_MODE && !spine) || !front) {
        // Cover not currently in DOM — temporarily render it to capture full fidelity
        // (stickers, texts, maps, logo) then restore the previous view.
        const savedMode = builderMode;
        builderMode = "cover";
        renderCoverCanvas();
        back = $("coverBack")?.cloneNode(true);
        spine = window.DMB_MAGAZINE_MODE ? null : ($("coverSpine")?.cloneNode(true) ?? null);
        front = $("coverFront")?.cloneNode(true);
        const _overlayTmp = $("coverOverlay")?.cloneNode(true);
        // Restore previous view
        builderMode = savedMode;
        if (savedMode !== "cover") renderSpread();
        // Build the preview wrapper from the temporary render and return early
        [back, spine, front].filter(Boolean).forEach(el => {
          el.style.cursor = "default";
          el.style.pointerEvents = "none";
          el.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
        });
        if (back) coverWrap.appendChild(back);
        if (spine) coverWrap.appendChild(spine);
        if (front) coverWrap.appendChild(front);
        if (_overlayTmp) {
          _overlayTmp.style.pointerEvents = "none";
          _overlayTmp.style.zIndex = "9999";
          _overlayTmp.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
          coverWrap.appendChild(_overlayTmp);
        }
        return coverWrap;
      }

      [back, spine, front].filter(Boolean).forEach(el => {
        el.style.cursor = "default";
        el.style.pointerEvents = "none";
        el.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
      });

      coverWrap.appendChild(back);
      if (spine) coverWrap.appendChild(spine);
      coverWrap.appendChild(front);
      // Include the overlay so stickers, objects, and logo appear in preview
      const _previewOverlay = $("coverOverlay")?.cloneNode(true);
      if (_previewOverlay) {
        _previewOverlay.style.pointerEvents = "none";
        _previewOverlay.style.zIndex = "9999";
        _previewOverlay.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
        coverWrap.appendChild(_previewOverlay);
      }
      return coverWrap;
    }

    return makeA4Page(pageNumber, pageNumber % 2 === 0 ? "R" : "L", true);
  }

  function openPreviewOverlay(confirmMode) {
    ensurePreviewOverlay();
    const overlay     = document.getElementById("dmbPreviewOverlay");
    const body        = document.getElementById("dmbPreviewBody");
    const prevBtn     = document.getElementById("dmbPreviewPrev");
    const nextBtn     = document.getElementById("dmbPreviewNext");
    const spreadLabel = document.getElementById("dmbPreviewSpreadLabel");
    const titleEl     = document.getElementById("dmbPreviewTitle");
    const confirmBanner = document.getElementById("dmbPreviewConfirmBanner");
    const confirmBtn    = document.getElementById("dmbPreviewConfirmBtn");
    if (!overlay || !body) return;

    // ── Confirm banner ────────────────────────────────────────────────────
    if (confirmBanner) {
      if (confirmMode) {
        confirmBanner.style.display = "flex";
        // Show a "please review" message for 4.5s before revealing the confirm button
        if (confirmBtn) confirmBtn.style.display = "none";
        const _reviewMsg = document.getElementById("dmbPreviewReviewMsg") || document.createElement("div");
        _reviewMsg.id = "dmbPreviewReviewMsg";
        _reviewMsg.className = "dmb-pv-review-msg";
        _reviewMsg.innerHTML = "✨ <strong>Almost there!</strong> Flip through every page carefully using the arrows — what you see is <em>exactly</em> what we'll print and deliver to you. Take your time! 📖";
        _reviewMsg.style.opacity = "1";
        if (!_reviewMsg.parentNode) confirmBanner.insertBefore(_reviewMsg, confirmBtn);
        setTimeout(function() {
          _reviewMsg.style.opacity = "0";
          setTimeout(function() {
            if (_reviewMsg.parentNode) _reviewMsg.remove();
            if (confirmBtn) confirmBtn.style.display = "";
          }, 600);
        }, 4500);
      } else {
        confirmBanner.style.display = "none";
      }
    }

    // Wire confirm button to the actual cart flow (only once)
    if (confirmMode && confirmBtn && !confirmBtn.dataset.wired) {
      confirmBtn.dataset.wired = "1";
      confirmBtn.addEventListener("click", () => {
        overlay.style.display = "none";
        _dmbPvRefresh = null;
        if (previewBtn) previewBtn.classList.remove("dmb-preview-needs-check");
        addDesignedBookToCart();
      });
    }

    // Preview opened — remove the "needs check" pulse from preview button
    if (previewBtn) previewBtn.classList.remove("dmb-preview-needs-check");

    // Hide all floating rotation handles — they live on document.body and would
    // otherwise show on top of the preview overlay.
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = "none"; });

    // FIX 1 — flush any pending re-renders immediately (don't wait for the 2s
    // debounce).  This eliminates the staleness window: even if the customer
    // opens Preview within milliseconds of their last edit, the affected page(s)
    // start re-rendering right now and show the loading spinner until done,
    // rather than silently displaying the pre-edit cached image.
    clearTimeout(_dmbPvTimer);
    if (_dmbPvDirty.size > 0) _dmbPvRun();

    // Build spreads list: cover → page 0 → page pairs
    const totalSpreads = editor.totalSpreads || 1;
    const spreads = [{ isCover: true }, { isPage0: true }];
    for (let s = 0; s < totalSpreads; s++) {
      const left = s * 2 + 1;
      const right = s * 2 + 2;
      spreads.push({ isCover: false, isPage0: false, left, right });
    }

    let currentIdx = 0;

    // ── ONE scale for every view ─────────────────────────────────────────────
    // Every view used to fit ITSELF: each image was sized by HEIGHT only, so a lone
    // page 0 filled the height while a two-page spread had to shrink to fit the
    // width, and the three cover faces (back + spine + front = 428 mm) simply
    // overflowed a phone and were clipped - which is why the spine and the right
    // edge of the front cover went missing. Pick the mm->px factor ONCE from the
    // WIDEST view so every sheet is drawn at the same size in every view and the
    // widest one still fits.
    const _pvLS   = (typeof dmbIsLandscape === "function") ? dmbIsLandscape() : false;
    const _pvPW   = _pvLS ? 297 : 210;      // page / cover-face width  (mm)
    const _pvPH   = _pvLS ? 210 : 297;      // page / cover height      (mm)
    const _pvSPW  = 8;                      // spine thickness          (mm)
    const _pvMag  = !!window.DMB_MAGAZINE_MODE;
    const _pvWidest = Math.max(_pvPW * 2 + (_pvMag ? 0 : _pvSPW), _pvPW * 2);
    const _PV_LABEL_H = 20;                 // reserved under every sheet, in all views
    function _pvScale() {
      let bw = 0, bh = 0;
      try {
        const cs = getComputedStyle(body);
        bw = body.clientWidth  - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight)  || 0);
        bh = body.clientHeight - (parseFloat(cs.paddingTop)  || 0) - (parseFloat(cs.paddingBottom) || 0);
      } catch (e) {}
      // A body that is not laid out yet (hidden, or measured in the same tick it
      // was shown) reports 0. Never return 0 - that draws every sheet at zero
      // width - fall back to the window box and ask for one re-fit next frame.
      if (!(bw > 0) || !(bh > 0)) {
        _pvNeedRefit = true;
        if (!(bw > 0)) bw = Math.max(120, (window.innerWidth  || 360) - 48);
        if (!(bh > 0)) bh = Math.max(120, (window.innerHeight || 640) - 230);
      }
      return Math.max(0.05, Math.min((bh - _PV_LABEL_H) / _pvPH, bw / _pvWidest));
    }
    let _pvNeedRefit = false, _pvRefitTries = 0;

    // ── Helper: create a page image from the PDF cache, or a loading spinner ──
    // The sheet is given an EXPLICIT px size from _pvScale(), so a page is the same
    // size whether it is shown alone (page 0) or beside its partner in a spread.
    function _pvPageNode(pn, k, wMm) {
      const hPx = _pvPH * k, wPx = (wMm || _pvPW) * k;
      const slot = document.createElement("div");
      slot.style.cssText = "flex:0 0 auto;min-width:0;display:flex;flex-direction:column;" +
        "align-items:center;justify-content:center;overflow:hidden;width:" + wPx.toFixed(2) + "px;";
      // A page that is dirty or mid-render must NEVER show its stale cached image —
      // the customer would confirm/order from an out-of-date preview. Show the
      // emoji loader until the fresh render lands (_dmbPvRefresh re-renders us).
      const _stale = _dmbPvDirty.has(pn) || _dmbPvRendering.has(pn);
      const url = _stale ? null : _dmbPvCache[pn];
      if (url) {
        const img = document.createElement("img");
        img.src = url;
        img.style.cssText = "display:block;width:" + wPx.toFixed(2) + "px;height:" + hPx.toFixed(2) + "px;" +
          "box-shadow:0 4px 20px rgba(0,0,0,0.6);border-radius:2px;";
        slot.appendChild(img);
      } else {
        // Not yet rendered — schedule if needed and show loading animation
        if (!_dmbPvRendering.has(pn) && !_dmbPvDirty.has(pn)) _dmbPvMarkDirty(pn);
        const hold = document.createElement("div");
        hold.style.cssText = "width:" + wPx.toFixed(2) + "px;height:" + hPx.toFixed(2) + "px;" +
          "display:flex;align-items:center;justify-content:center;";
        hold.appendChild(_dmbPvMakeLoadingNode());
        slot.appendChild(hold);
      }
      const lbl = document.createElement("div");
      lbl.style.cssText = "height:" + _PV_LABEL_H + "px;flex:none;";
      slot.appendChild(lbl);
      return slot;
    }

    function renderSpreadPreview(idx) {
      body.innerHTML = "";
      const s = spreads[idx];

      if (s.isCover) {
        // ── Cover: back face | spine | front face — proportional PDF images ──
        titleEl.textContent = "Preview — Cover";
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;flex-wrap:nowrap;gap:0;height:100%;align-items:center;justify-content:center;max-width:100%;";
        // Same staleness rule as pages: a dirty/re-rendering cover shows the
        // loader, never the pre-edit cached faces.
        const _coverStale = _dmbPvDirty.has("cover") || _dmbPvRendering.has("cover");
        if (_dmbPvCover && !_coverStale) {
          const faces = window.DMB_MAGAZINE_MODE
            // Magazine: back cover | front cover (no spine strip, same left→right as book)
            ? [
                { url: _dmbPvCover.back,  label: "Back"  },
                { url: _dmbPvCover.front, label: "Front" },
              ]
            // Book: back face | spine strip | front face
            : [
                { url: _dmbPvCover.back,  label: "Back"  },
                { url: _dmbPvCover.spine, label: "Spine" },
                { url: _dmbPvCover.front, label: "Front" },
              ];
          const _kC = _pvScale();
          faces.forEach(function(f) {
            // The spine is a real 8 mm strip: at the shared scale it is a few px wide,
            // so its column must be sized from mm like the faces (a height-only fit
            // pushed the row past the panel and the spine + the front cover's right
            // edge were clipped away on a phone).
            const _fw = (f.label === "Spine" ? _pvSPW : _pvPW) * _kC;
            const _fh = _pvPH * _kC;
            const col = document.createElement("div");
            col.style.cssText = "display:flex;flex-direction:column;align-items:center;flex:0 0 auto;" +
              "width:" + _fw.toFixed(2) + "px;";
            if (f.label === "Spine") col.classList.add("dmb-pv-spine-col");
            const img = document.createElement("img");
            img.src = f.url;
            img.style.cssText = "display:block;width:" + _fw.toFixed(2) + "px;height:" + _fh.toFixed(2) + "px;" +
              "box-shadow:0 4px 20px rgba(0,0,0,0.6);border-radius:2px;";
            const lbl = document.createElement("div");
            lbl.textContent = f.label;
            lbl.style.cssText = "height:" + _PV_LABEL_H + "px;line-height:" + _PV_LABEL_H + "px;color:#888;" +
              "font-size:10px;letter-spacing:0.6px;text-transform:uppercase;flex:none;white-space:nowrap;" +
              "overflow:visible;text-align:center;";
            col.appendChild(img);
            col.appendChild(lbl);
            wrap.appendChild(col);
          });
        } else {
          // Cover not rendered yet — schedule and show spinner
          if (!_dmbPvRendering.has("cover") && !_dmbPvDirty.has("cover")) _dmbPvMarkDirty("cover");
          wrap.appendChild(_dmbPvMakeLoadingNode());
        }
        body.appendChild(wrap);

      } else if (s.isPage0) {
        // ── Special inner-cover page ──────────────────────────────────────
        titleEl.textContent = "Preview — Spread 0";
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;align-items:center;justify-content:center;height:100%;width:100%;";
        wrap.appendChild(_pvPageNode(0, _pvScale()));
        body.appendChild(wrap);

      } else {
        // ── Regular spread — two pages side by side with 5px gap ─────────
        const left = s.left, right = s.right;
        titleEl.textContent = "Preview — Spread " + (idx - 1);
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;gap:0;align-items:center;height:100%;width:100%;justify-content:center;";
        const _kS = _pvScale();
        if (left  <= editor.totalPages) wrap.appendChild(_pvPageNode(left,  _kS));
        if (right <= editor.totalPages) wrap.appendChild(_pvPageNode(right, _kS));
        body.appendChild(wrap);
      }

      spreadLabel.textContent = (idx + 1) + " / " + spreads.length;
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === spreads.length - 1;

      // The scale had to be guessed because the body was not measurable yet.
      // Re-render once the browser has laid it out (bounded, so a genuinely
      // zero-sized panel can never loop).
      if (_pvNeedRefit && _pvRefitTries < 3) {
        _pvNeedRefit = false; _pvRefitTries++;
        requestAnimationFrame(function () { try { renderSpreadPreview(idx); } catch (e) {} });
      } else {
        _pvNeedRefit = false;
      }
    }

    // The scale is computed from the body box, so a rotate / resize must re-fit.
    // Replace any listener from a previous open so they cannot accumulate.
    try { if (overlay._pvResize) window.removeEventListener("resize", overlay._pvResize); } catch (e) {}
    overlay._pvResize = function () {
      try { if (overlay.style.display !== "none") renderSpreadPreview(currentIdx); } catch (e) {}
    };
    window.addEventListener("resize", overlay._pvResize);

    if (prevBtn) {
      prevBtn.onclick = () => {
        if (currentIdx > 0) { currentIdx--; renderSpreadPreview(currentIdx); }
      };
    }
    if (nextBtn) {
      nextBtn.onclick = () => {
        if (currentIdx < spreads.length - 1) { currentIdx++; renderSpreadPreview(currentIdx); }
      };
    }

    // Confirm gating: while any page/cover is still (re)rendering, the order
    // button is disabled — the customer can only confirm a preview that is
    // fully up to date (goes with the stale→loader rule in _pvPageNode).
    function _pvSyncConfirmState() {
      if (!confirmBtn) return;
      const busy = _dmbPvDirty.size > 0 || _dmbPvRendering.size > 0;
      if (!confirmBtn.dataset.label) confirmBtn.dataset.label = confirmBtn.textContent;
      confirmBtn.disabled = busy;
      confirmBtn.style.opacity = busy ? "0.55" : "";
      confirmBtn.style.cursor  = busy ? "wait" : "";
      confirmBtn.textContent = busy ? "Rendering your pages… ⏳" : confirmBtn.dataset.label;
    }
    _pvSyncConfirmState();

    // When a page finishes rendering in the background, refresh if it's visible
    _dmbPvRefresh = function(key) {
      _pvSyncConfirmState();
      const s = spreads[currentIdx];
      if (!s) return;
      let affected = false;
      if (key === "cover" && s.isCover) affected = true;
      else if (key === 0 && s.isPage0) affected = true;
      else if (!s.isCover && !s.isPage0 && (key === s.left || key === s.right)) affected = true;
      if (affected) renderSpreadPreview(currentIdx);
    };

    // Keyboard: attach to overlay
    overlay.onkeydown = (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); if (currentIdx > 0) { currentIdx--; renderSpreadPreview(currentIdx); } }
      if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); if (currentIdx < spreads.length - 1) { currentIdx++; renderSpreadPreview(currentIdx); } }
      if (e.key === "Escape") { overlay.style.display = "none"; _dmbPvRefresh = null; document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = ""; }); }
    };

    // Clear live-refresh hook when overlay closes
    overlay.querySelector && overlay.querySelector("[type=button]"); // noop — close handled via button below
    const _closeBtns = overlay.querySelectorAll("button");
    _closeBtns.forEach(function(b) {
      if (b.textContent.trim() === "Close") {
        b.onclick = function() { overlay.style.display = "none"; _dmbPvRefresh = null; document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = ""; }); };
      }
    });

    // Show FIRST: the sheet scale is measured from the body box, and a
    // display:none body reports 0x0 - which rendered every sheet at zero width.
    overlay.style.display = "flex";
    renderSpreadPreview(0);
    overlay.focus();
  }

  function syncBuilderModeButtons() {
    if (coverThumbBtn) {
      coverThumbBtn.classList.toggle("active", builderMode === "cover");
    }
    const canvasToolbar = document.querySelector(".dmb-canvas-toolbar-left");
    if (canvasToolbar) canvasToolbar.style.display = (builderMode === "cover") ? "" : "none";
  }

  function activateLeftTab(key) {
    document.querySelector(`.dmb-icon-tab[data-tab="${key}"]`)?.click();
  }

  function openProjectMenuPrompt() {
    const choice = window.prompt("Type one: save / open / new", "save");
    if (!choice) return;

    const v = choice.trim().toLowerCase();

    if (v === "save") {
      saveProjectLocalWithMessage();
    } else if (v === "open") {
      openSavedProjectLocal();
    } else if (v === "new") {
      startNewProjectLocal();
    }
  }

  function initCoverZoneButtons() {
    const frontBtn = $("coverZoneFrontBtn");
    const backBtn = $("coverZoneBackBtn");
    const spineBtn = $("coverZoneSpineBtn");

    if (frontBtn) {
      frontBtn.addEventListener("click", () => {
        activeCoverZone = "front";
        markActiveCoverZone();
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", () => {
        activeCoverZone = "back";
        markActiveCoverZone();
      });
    }

    if (spineBtn) {
      spineBtn.addEventListener("click", () => {
        activeCoverZone = "spine";
        markActiveCoverZone();
      });
    }

    updateCoverZoneButtons();
  }

  function initProjectMenu() {
    const btn = $("projectMenuBtn");
    if (!btn) return;

    btn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openProjectMenuPrompt();
    };
  }

  function openHistoryPanel() {
    if (!undoStack.length) {
      alert("No history yet.");
      return;
    }

    const lines = undoStack
      .map((s, i) => `${i + 1}. ${s.label || "Edited"}`)
      .join("\n");

    const pick = window.prompt(`History:\n\n${lines}\n\nType a number to restore that step:`, "");
    if (!pick) return;

    const idx = Number(pick);
    if (!Number.isInteger(idx) || idx < 1 || idx > undoStack.length) return;

    const target = undoStack[idx - 1];
    if (!target) return;

    editor.currentSpread = target.currentSpread;
    editor.pageSlots = cloneState(target.pageSlots);
    editor.pageRot = cloneState(target.pageRot);
    editor.pageTemplate = cloneState(target.pageTemplate);
    editor.pageFrames = cloneState(target.pageFrames);
    editor.pageFrameRot = cloneState(target.pageFrameRot);
    builderMode = target.builderMode || "pages";

    coverState.template = target.coverState?.template || "default";
    coverState.title1 = target.coverState?.title1 || "";
    coverState.title2 = target.coverState?.title2 || "";
    coverState.color = target.coverState?.color || "#ffffff";

    syncCoverInputsFromState();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function initHistoryButton() {
    const btn = $("historyBtn");
    if (!btn) return;

    btn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openHistoryPanel();
    };
  }


  // ---------- cover editor state ----------
  const coverState = {
    template: "default",
    title1: "",
    title2: "",
    color: "#ffffff",
    imageUrl: "",
    imageFile: null,
    textStyles: {},
    // Photo grid layouts for front/back cover faces
    frontLayout: null,
    backLayout: null,
    frontFrames: {},
    backFrames: {},
    frontFrameRot: {},
    backFrameRot: {},
    frontImageUrl: "",
    backImageUrl: "",
    frontImageId: "",
    backImageId: "",
    frontImageRot: 0,
    backImageRot: 0,
    frontFrameShapes: {},
    backFrameShapes: {},
    spineImageUrl: "",
    bleedImageUrl: "",
    bleedImageId: "",
    bleedZone: "",
    bleedImageRot: 0,
    // Magazine only: set true once the default front-cover free photo frame has been
    // seeded, so it is never re-added after the customer deletes it.
    magFrontFrameSeeded: false
  };

  function getEffectiveBookTitle() {
    // Use first user-added cover text as book title
    if (Array.isArray(editor.coverUserTexts) && editor.coverUserTexts.length > 0) {
      const first = editor.coverUserTexts[0];
      const txt = (coverState.textStyles?.[first.id]?.text || "").trim();
      if (txt) return txt;
    }
    const legacy = (titleEl?.value || "").trim();
    return legacy || "Untitled";
  }

  function saveCoverDesignToStorage() {
    // Any cover mutation (resize/move/edit/photo/color/…) routes through here, so
    // invalidate the cached cover PREVIEW/PDF images now. Without this the preview
    // keeps showing a stale render (e.g. the original template font size) after the
    // user resizes cover text — the builder shows the new size but the preview/PDF
    // shows the old one. Debounced background regen (see _dmbPvMarkDirty).
    try { _dmbPvMarkDirty("cover"); } catch (e) {}

    const templateKey = getTemplateKey();
    if (!templateKey) return;

    try {
      localStorage.setItem(`dmb_cover_design_${templateKey}`, JSON.stringify({
        template: coverState.template,
        title1: coverState.title1,
        title2: coverState.title2,
        color: coverState.color,
        textStyles: coverState.textStyles || {},
        frontLayout: coverState.frontLayout || null,
        backLayout: coverState.backLayout || null,
        frontFrames: coverState.frontFrames || {},
        backFrames: coverState.backFrames || {},
        frontFrameRot: coverState.frontFrameRot || {},
        backFrameRot: coverState.backFrameRot || {},
        frontImageUrl: coverState.frontImageUrl || "",
        backImageUrl: coverState.backImageUrl || "",
        frontImageId: coverState.frontImageId || "",
        backImageId: coverState.backImageId || "",
        frontImageRot: coverState.frontImageRot || 0,
        backImageRot: coverState.backImageRot || 0,
        frontFrameShapes: coverState.frontFrameShapes || {},
        backFrameShapes: coverState.backFrameShapes || {},
        spineImageUrl: coverState.spineImageUrl || "",
        bleedImageUrl: coverState.bleedImageUrl || "",
        bleedImageId: coverState.bleedImageId || "",
        bleedZone: coverState.bleedZone || "",
        bleedImageRot: coverState.bleedImageRot || 0,
        magFrontFrameSeeded: !!coverState.magFrontFrameSeeded
      }));
    } catch {}
  }

  function loadCoverDesignFromStorage() {
    const templateKey = getTemplateKey();
    if (!templateKey) return null;

    try {
      const raw = localStorage.getItem(`dmb_cover_design_${templateKey}`);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function applyCoverTemplate(templateId) {
    coverState.template = templateId || "default";

    const frontTitle1 = $("coverFrontTitle1");
    const frontTitle2 = $("coverFrontTitle2");
    const spineTitle1 = $("coverSpineTitle1");
    const backTitle2 = $("coverBackTitle2");
    const frontImage = $("coverFrontImage");

    if (!frontTitle1 || !frontTitle2 || !spineTitle1 || !backTitle2) return;

    // reset
    frontTitle1.style.left = "12%";
    frontTitle1.style.top = "12%";
    frontTitle1.style.width = "76%";
    frontTitle1.style.textAlign = "center";

    frontTitle2.style.left = "12%";
    frontTitle2.style.top = "24%";
    frontTitle2.style.width = "76%";
    frontTitle2.style.textAlign = "center";

    if (frontImage) {
      frontImage.style.left = "12%";
      frontImage.style.top = "34%";
      frontImage.style.width = "76%";
      frontImage.style.height = "38%";
    }

    spineTitle1.style.left = "50%";
    spineTitle1.style.top = "50%";
    spineTitle1.style.transform = "translate(-50%,-50%) rotate(-90deg)";

    backTitle2.style.left = "12%";
    backTitle2.style.top = "12%";
    backTitle2.style.width = "76%";
    backTitle2.style.textAlign = "center";

    // future templates go here
    if (templateId === "default") {
      // already default
    }

    const items = document.querySelectorAll(".cover-template-item");
    items.forEach((btn) => {
      const active = btn.getAttribute("data-template") === coverState.template;
      btn.style.borderColor = active ? "#111" : "#ddd";
      btn.style.background = active ? "#f3f3f3" : "#fff";
    });

    saveCoverDesignToStorage();
  }

  function updateCoverPreview() {
    coverState.title1 = (coverTitle1Input?.value || "").trim();
    coverState.title2 = (coverTitle2Input?.value || "").trim();
    coverState.color = (coverColorInput?.value || "#ffffff").trim() || "#ffffff";

    if (builderMode === "cover") {
      // Update background color in-place so user-added text/frames are preserved
      ["coverBack", "coverSpine", "coverFront"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.style.background = coverState.color;
      });
      // Update default title nodes in-place
      [["coverFrontTitle1", "coverBackTitle1", "coverSpineTitle1"], coverState.title1,
       ["coverFrontTitle2", "coverBackTitle2"], coverState.title2].forEach((item, i, arr) => {
        if (i % 2 === 0) {
          const ids = item;
          const val = arr[i + 1];
          ids.forEach((id) => {
            const el = document.getElementById(id);
            if (el) {
              el.textContent = val;
              el.style.display = val ? "block" : "none";
            }
          });
        }
      });
    }

    saveCoverDesignToStorage();
  }

  function initCoverDesigner() {
    const saved = loadCoverDesignFromStorage();
    if (saved) {
      coverState.template = saved.template || "default";
      coverState.title1 = saved.title1 || "";
      coverState.title2 = saved.title2 || "";
      coverState.color = saved.color || "#ffffff";
      coverState.frontLayout = saved.frontLayout || null;
      coverState.backLayout = saved.backLayout || null;
      coverState.frontFrames = saved.frontFrames || {};
      coverState.backFrames = saved.backFrames || {};
      coverState.frontFrameRot = saved.frontFrameRot || {};
      coverState.backFrameRot = saved.backFrameRot || {};
      coverState.frontImageUrl = saved.frontImageUrl || "";
      coverState.backImageUrl = saved.backImageUrl || "";
      coverState.frontImageId = saved.frontImageId || "";
      coverState.backImageId = saved.backImageId || "";
      coverState.frontImageRot = saved.frontImageRot || 0;
      coverState.backImageRot = saved.backImageRot || 0;
      coverState.frontFrameShapes = saved.frontFrameShapes || {};
      coverState.backFrameShapes = saved.backFrameShapes || {};
      coverState.spineImageUrl = saved.spineImageUrl || "";
      coverState.bleedImageUrl = saved.bleedImageUrl || "";
      coverState.bleedImageId = saved.bleedImageId || "";
      coverState.bleedZone = saved.bleedZone || "";
      coverState.bleedImageRot = saved.bleedImageRot || 0;
      coverState.magFrontFrameSeeded = !!saved.magFrontFrameSeeded;
    }

    if (coverTitle1Input && !coverTitle1Input.value) coverTitle1Input.value = coverState.title1;
    if (coverTitle2Input && !coverTitle2Input.value) coverTitle2Input.value = coverState.title2;
    if (coverColorInput) coverColorInput.value = coverState.color;

    // Cover template modal
    const _ctModal = document.getElementById("dmbCoverTemplateModal");
    const _ctClose = document.getElementById("dmbCoverTemplateModalClose");

    if (chooseCoverTemplateBtn && _ctModal) {
      chooseCoverTemplateBtn.addEventListener("click", (e) => {
        e.preventDefault();
        _ctModal.style.display = "flex";
      });
    }
    if (_ctClose && _ctModal) {
      _ctClose.addEventListener("click", () => { _ctModal.style.display = "none"; });
    }
    if (_ctModal) {
      _ctModal.addEventListener("click", (e) => {
        if (e.target === _ctModal) _ctModal.style.display = "none";
      });
    }

    // Delegated (not per-button) so template cards added dynamically from R2 work
    // too. Clicking a card now loads that template's REAL design (R2-first, asset
    // fallback) — not just the legacy default-node reposition. Because applying a
    // template REPLACES the cover, we confirm first when there's cover work to lose.
    const _ctGrid = document.getElementById("coverTemplateList");
    if (_ctGrid) {
      _ctGrid.addEventListener("click", (e) => {
        const btn = e.target.closest(".cover-template-item");
        if (!btn || !_ctGrid.contains(btn)) return;
        e.preventDefault();
        const templateId = btn.getAttribute("data-template") || "default";
        const hasCoverWork = (Array.isArray(editor.coverObjects) && editor.coverObjects.length > 0)
                             || (coverState.template && coverState.template !== "default");
        if (hasCoverWork && !confirm("Apply this cover template? It replaces your current cover design.")) return;
        applyCoverTemplate(templateId);                       // set state + highlight
        if (templateId && templateId !== "default") {
          // Load the actual template payload (predesigned or R2-saved). force=true: this is
          // the customer explicitly choosing to replace their cover (confirmed above).
          Promise.resolve(dmbApplyCoverTemplate(templateId, true))
            .then(() => { coverState.template = templateId; })   // keep highlight correct after load
            .catch(() => {});
        }
        if (_ctModal) _ctModal.style.display = "none";
        updateCoverPreview();
      });
    }

    const chooseCoverLayoutBtn = $("chooseCoverLayoutBtn");
    if (chooseCoverLayoutBtn) {
      chooseCoverLayoutBtn.addEventListener("click", (e) => {
        e.preventDefault();
        // Use the currently active cover zone (front/back) — spine doesn't support layouts
        // Open the Layouts SIDE PANEL (same as for pages). The panel applies its
        // layouts to the cover while the cover is the active builder mode.
        const _isMobTabs = window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches;
        if (_isMobTabs) {
          document.querySelector('.dmb-msh-tab[data-tab="layouts"]')?.click();
        } else {
          document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
        }
      });
    }

    if (coverTitle1Input) {
      coverTitle1Input.addEventListener("input", updateCoverPreview);
    }
    if (coverTitle2Input) {
      coverTitle2Input.addEventListener("input", updateCoverPreview);
    }

    if (coverColorSwatch && coverColorInput) {
      // Phone fix: overlay the REAL <input type=color> on the swatch so a tap lands on
      // it directly. iOS ignores a programmatic .click() on a hidden colour input (and
      // the preventDefault below cancels the native picker), which is why tapping the
      // cover colour did NOTHING on the phone. Desktop is unaffected — _dmbColorTapFix
      // no-ops above 749px and the .click() proxy below still runs there.
      try { _dmbColorTapFix(coverColorSwatch, coverColorInput); } catch (e) {}
      coverColorSwatch.addEventListener("click", (e) => {
        // Mobile: the tap already hit the overlaid input → let it open natively (NEVER
        // preventDefault or re-.click() — both kill the iOS picker). Desktop: proxy the tap.
        if (e.target === coverColorInput) return;
        e.preventDefault();
        coverColorInput.click();
      });

      coverColorInput.addEventListener("input", () => {
        coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
        updateCoverPreview();
      });

      coverColorInput.addEventListener("change", () => {
        coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
        updateCoverPreview();
        try { _dmbWriteProgressState(); } catch (e) {}   // flush colour to the restore key now
      });

      coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
      // Recently-used colors: strip goes below the swatch row, inside its wrapper.
      try { dmbEnhanceColorInput(coverColorInput, (coverColorInput.closest(".dmb-color-row") || coverColorInput).parentElement); } catch (e) {}
    } else if (coverColorInput) {
      coverColorInput.addEventListener("input", updateCoverPreview);
      coverColorInput.addEventListener("change", updateCoverPreview);
    }

    if (coverImageInput) {
      coverImageInput.addEventListener("change", () => {
        const file = coverImageInput.files && coverImageInput.files[0];
        if (!file) {
          coverState.imageFile = null;
          coverState.imageUrl = "";
          updateCoverPreview();
          return;
        }

        coverState.imageFile = file;
        try {
          if (coverState.imageUrl && coverState.imageUrl.startsWith("blob:")) {
            URL.revokeObjectURL(coverState.imageUrl);
          }
        } catch {}

        coverState.imageUrl = URL.createObjectURL(file);
        updateCoverPreview();
      });
    }

    applyCoverTemplate(coverState.template);
    updateCoverPreview();
  }

  // ---------- page template helpers ----------
  function getActiveDesignSurface() {
    return document.querySelector(".dmb-page.is-active .dmb-page-inner")
        || document.querySelector(".dmb-page.is-active")
        || document.getElementById("spreadCanvas");
  }

  /* ── MAP COUNTRY LIST ── */
  const DMB_COUNTRY_KEYS = [
    "afghanistan","albania","algeria","andorra","angola","antigua-and-barbuda","argentina",
    "armenia","australia","austria","azerbaijan","bahamas","bahrain","bangladesh",
    "barbados","belarus","belgium","belize","benin","bermuda","bhutan","bolivia",
    "bosnia-herzegovina-2","botswana","brazil","brunei-darussalam","bulgaria",
    "burkina-faso","burundi","cambodia","cameroon","canada","cape-verde",
    "central-african-republic","chad","chile","china","colombia","comoros","congo",
    "congo-dr","costa-rica","croatia","cuba","cyprus","czech-republic","denmark","djibouti",
    "dominica","dominican-republic","ecuador","egypt","el-salvador","equatorial-guinea",
    "eritrea","estonia","eswatini","ethiopia","fiji","finland","france","gabon","gambia",
    "georgia","germany","ghana","greece","grenada","guatemala","guinea","guinea-bissau",
    "guyana","haiti","honduras","hong-kong","hungary","iceland","india","indonesia","iran",
    "iraq","ireland","italy","ivory-coast","jamaica","japan","jordan","kazakhstan","kenya",
    "kiribati","kosovo","kuwait","kyrgyzstan","laos","latvia","lebanon","lesotho","liberia",
    "libya","liechtenstein","lithuania","luxembourg","macedonia","madagascar","malawi",
    "malaysia","maldives","mali","malta","marshall-islands","mauritania","mauritius",
    "mexico","micronesia","moldova","monaco","mongolia","montenegro","morocco","mozambique",
    "myanmar","namibia","nauru","nepal","netherlands","new-zealand","nicaragua","niger",
    "nigeria","north-korea","norway","oman","pakistan","palau","palestine","panama","papua",
    "paraguay","peru","philippines","poland","portugal","puerto-rico","qatar","romania",
    "russia","rwanda","saint-kitts-and-nevis","saint-lucia",
    "saint-vincent-and-the-grenadines","samoa","san-marino","sao-tome-and-principe",
    "saudi-arabia","senegal","serbia","seychelles","sierra-leone","singapore","slovakia",
    "slovenia","solomon-islands","somalia","south-africa","south-korea","south-sudan",
    "spain","sri-lanka","sudan","suriname","sweden","switzerland","syria","taiwan",
    "tajikistan","tanzania","thailand","timor-leste","togo","tonga","trinidad-and-tobago",
    "tunisia","turkey","turkmenistan","tuvalu","uganda","ukraine","united-arab-emirates",
    "united-kingdom","uruguay","usa","uzbekistan","vanuatu","vatican-city","venezuela",
    "vietnam","vietnam-with-islands","yemen","zambia","zimbabwe"
  ];

  // Continent maps: same machinery as country maps, but each internal <path> is a
  // COUNTRY (not a province). Listed first in the picker. `hideProvinces` on these
  // hides the country borders (single silhouette) — the UI relabels it accordingly.
  const DMB_CONTINENT_KEYS = ["africa","asia","europe","north-america","oceania","south-america"];
  function dmbIsContinentKey(key) { return DMB_CONTINENT_KEYS.indexOf(key) !== -1; }

  function dmbKeyToName(key) {
    const overrides = {
      "north-america": "North America",
      "south-america": "South America",
      "antigua-and-barbuda": "Antigua & Barbuda",
      "equatorial-guinea": "Equatorial Guinea",
      "guinea-bissau": "Guinea-Bissau",
      "marshall-islands": "Marshall Islands",
      "north-korea": "North Korea",
      "sao-tome-and-principe": "São Tomé & Príncipe",
      "saint-kitts-and-nevis": "St. Kitts & Nevis",
      "saint-lucia": "St. Lucia",
      "saint-vincent-and-the-grenadines": "St. Vincent & Grenadines",
      "solomon-islands": "Solomon Islands",
      "south-sudan": "South Sudan",
      "timor-leste": "Timor-Leste",
      "vatican-city": "Vatican City",
      "micronesia": "Micronesia",
      "bosnia-herzegovina-2": "Bosnia & Herzegovina",
      "brunei-darussalam": "Brunei",
      "cape-verde": "Cabo Verde",
      "central-african-republic": "Central African Republic",
      "congo-dr": "Congo (DR)",
      "costa-rica": "Costa Rica",
      "czech-republic": "Czech Republic",
      "dominican-republic": "Dominican Republic",
      "el-salvador": "El Salvador",
      "hong-kong": "Hong Kong",
      "ivory-coast": "Côte d'Ivoire",
      "new-zealand": "New Zealand",
      "papua": "Papua New Guinea",
      "puerto-rico": "Puerto Rico",
      "san-marino": "San Marino",
      "saudi-arabia": "Saudi Arabia",
      "sierra-leone": "Sierra Leone",
      "south-africa": "South Africa",
      "south-korea": "South Korea",
      "sri-lanka": "Sri Lanka",
      "trinidad-and-tobago": "Trinidad & Tobago",
      "united-arab-emirates": "United Arab Emirates",
      "united-kingdom": "United Kingdom",
      "usa": "United States",
      "vietnam-with-islands": "Vietnam (with Islands)",
      "burkina-faso": "Burkina Faso",
      "eswatini": "Eswatini (Swaziland)",
    };
    return overrides[key] || key.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  }

  /* ── MAP MODAL STATE ── */
  let dmbModalSelectedKey = null;
  let dmbModalSvgCache = {};

  function dmbGetAssetUrl(filename) {
    const full = (window.DMB_ASSET_BASE || "");
    // Carry the design-my-book.js "?v=…" version onto map/asset URLs, so updating an
    // asset (e.g. a country map) actually refreshes it instead of serving a stale cache.
    const q = full.indexOf("?");
    const query = q >= 0 ? full.slice(q) : "";
    const base = full.replace(/\?.*$/, "").replace(/\/[^/]+$/, "/");
    return base + filename + query;
  }

  function dmbGetModalStyles() {
    return {
      fill: document.getElementById("dmbMapFill")?.value || "#d9d9d9",
      stroke: document.getElementById("dmbMapStroke")?.value || "#111111",
      strokeWidth: parseFloat(document.getElementById("dmbMapStrokeWidth")?.value ?? 1.2),
      strokeDasharray: document.getElementById("dmbMapStrokeStyle")?.value || "",
      opacity: parseFloat(document.getElementById("dmbMapOpacity")?.value ?? 1),
      showOutline: document.getElementById("dmbMapShowOutline")?.checked || false,
      hideProvinces: document.getElementById("dmbMapHideProvinces")?.checked || false,
      transparentFill: document.getElementById("dmbMapTransparentFill")?.checked || false,
    };
  }

  function dmbEnsureOutlineFilter(svgEl, strokeColor, strokeWidth, filterId, hollowCenter, builderW) {
    const ns = "http://www.w3.org/2000/svg";
    let defs = svgEl.querySelector("defs");
    if (!defs) {
      defs = document.createElementNS(ns, "defs");
      svgEl.insertBefore(defs, svgEl.firstChild);
    }
    const old = defs.querySelector("#" + filterId);
    if (old) old.remove();

    const filter = document.createElementNS(ns, "filter");
    filter.id = filterId;
    filter.setAttribute("x", "-20%");
    filter.setAttribute("y", "-20%");
    filter.setAttribute("width", "140%");
    filter.setAttribute("height", "140%");

    // Honour 0 (Width 0 -> no outline) via parseFloat, defaulting to 1.2 only when
    // the value is genuinely unset.
    let _sw = parseFloat(strokeWidth);
    if (!isFinite(_sw)) _sw = 1.2;

    // ── RADIUS IS IN CSS PIXELS HERE, NOT VIEWBOX UNITS ─────────────────────
    // The map SVGs have NO inner <g>, so `g` below resolves to the <svg> element
    // itself and the filter is applied to the ROOT svg. A filter on a root svg runs
    // in that element's CSS-pixel space - NOT in its viewBox user space - so a
    // radius of R paints an R-PIXEL ring at whatever size the element is rendered.
    // The Width value already means CSS px (the paths use non-scaling-stroke), so
    // the raw value is exactly right and any viewBox conversion is wrong.
    //
    // This is also why the same number behaves differently in print: drawSvgObj
    // rasterises the SAME markup into a bitmap `_mapK` times wider than the builder
    // box, so the ring there must be scaled by _mapK to come out the same physical
    // thickness (see the matching note in drawSvgObj).
    //
    // History, so this is not "fixed" a third time: on 2026-09-11 a viewBox
    // conversion (radius = sw * vbW / builderW) was added here to make a thin
    // builder ring match print. It made the ring vbW/builderW times too thick
    // (Amsterdam template: vbW 636.5, box 170 -> 4.49px instead of 1.2px) and the
    // real mismatch was in drawSvgObj's own radius, which is fixed there instead.
    // Which space the radius is in depends on WHICH element the filter lands on
    // (see the `g` lookup in dmbApplyStylesToSvg - the same expression):
    //   root <svg>  -> CSS-pixel space  -> raw value  (every map ships without a <g>)
    //   inner <g>   -> user space       -> convert via vbW / rendered width
    // Branching on it keeps both correct if a map is ever exported with a group.
    let outlineRadius = Math.max(0, _sw);
    try {
      if (svgEl.querySelector(":scope > g")) {
        const _vb  = (svgEl.getAttribute("viewBox") || "").trim().split(/[\s,]+/);
        const _vbW = (_vb.length >= 3) ? (parseFloat(_vb[2]) || 0) : 0;
        let _bw = parseFloat(builderW);
        if (!isFinite(_bw) || _bw <= 0) _bw = svgEl.clientWidth || 0;
        if (_vbW > 0 && _bw > 0) outlineRadius = Math.max(0, _sw * _vbW / _bw);
      }
    } catch (e) {}

    // Step 1: dilate the combined silhouette
    const morph = document.createElementNS(ns, "feMorphology");
    morph.setAttribute("operator", "dilate");
    morph.setAttribute("radius", String(outlineRadius));
    morph.setAttribute("in", "SourceAlpha");
    morph.setAttribute("result", "dilated");

    // Step 2: subtract original silhouette → outer ring only
    const ring = document.createElementNS(ns, "feComposite");
    ring.setAttribute("in", "dilated");
    ring.setAttribute("in2", "SourceAlpha");
    ring.setAttribute("operator", "out");
    ring.setAttribute("result", "ring");

    // Step 3: flood with stroke color
    const flood = document.createElementNS(ns, "feFlood");
    flood.setAttribute("flood-color", strokeColor || "#111111");
    flood.setAttribute("result", "color");

    // Step 4: clip color to ring shape
    const comp = document.createElementNS(ns, "feComposite");
    comp.setAttribute("in", "color");
    comp.setAttribute("in2", "ring");
    comp.setAttribute("operator", "in");
    comp.setAttribute("result", "coloredRing");

    if (hollowCenter) {
      // Output: ring only, interior transparent (used with transparent fill)
      filter.append(morph, ring, flood, comp);
    } else {
      // Output: original map content + outer ring drawn on top
      const merge = document.createElementNS(ns, "feMerge");
      const mn1 = document.createElementNS(ns, "feMergeNode");
      mn1.setAttribute("in", "SourceGraphic");
      const mn2 = document.createElementNS(ns, "feMergeNode");
      mn2.setAttribute("in", "coloredRing");
      merge.appendChild(mn1);
      merge.appendChild(mn2);
      filter.append(morph, ring, flood, comp, merge);
    }

    defs.appendChild(filter);
  }

  function dmbApplyStylesToSvg(svgEl, styles) {
    const effectiveFill = styles.transparentFill ? "none" : (styles.fill || "#d9d9d9");
    // When showOutline is active with transparent fill, paths still need an opaque fill
    // so SourceAlpha can capture the country silhouette. The filter hides the fill visually.
    const silhouetteFill = styles.fill || "#d9d9d9";
    const pathFill = (styles.showOutline && styles.transparentFill) ? silhouetteFill : effectiveFill;

    const filterId = styles.filterId || "dmbOutlineFilter";
    const g = svgEl.querySelector(":scope > g") || svgEl;

    if (styles.showOutline) {
      dmbEnsureOutlineFilter(svgEl, styles.stroke, styles.strokeWidth, filterId, !!styles.transparentFill, styles.w);
      g.setAttribute("filter", "url(#" + filterId + ")");
    } else {
      g.removeAttribute("filter");
      svgEl.removeAttribute("filter");
    }

    svgEl.style.opacity = styles.opacity != null ? String(styles.opacity) : "1";

    svgEl.querySelectorAll("path").forEach((path) => {
      path.style.fill = pathFill;
      path.style.stroke = styles.hideProvinces ? pathFill : (styles.stroke || "#111111");
      path.style.strokeWidth = styles.hideProvinces ? "1" : (styles.strokeWidth || 1.2);
      path.style.strokeDasharray = styles.hideProvinces ? "" : (styles.strokeDasharray || "");
      path.style.opacity = "";
      path.style.vectorEffect = "non-scaling-stroke";
    });
  }

  /* Fit the preview viewBox around the country PLUS its outline ring.
   *
   * dmbEnsureOutlineFilter hangs the feMorphology on the ROOT <svg> (no map asset
   * has an inner <g>), so the ring radius is in CSS PIXELS while the viewBox is in
   * user units - and the ring is painted OUTSIDE the silhouette's own bbox. The
   * outermost <svg> clips to its viewport (the UA rule svg:not(:root){overflow:hidden}),
   * so a viewBox cropped tight to the silhouette cuts the ring off.
   *
   * With xMidYMid meet the scale is s = min(BW/(Wc+2p), BH/(Hc+2p)); requiring the
   * pad to render as at least R css px (p*s >= R) gives
   *     p = R * max( Wc / (BW - 2R),  Hc / (BH - 2R) )
   * The max() picks whichever axis the meet-fit is limited by, so this is exact:
   * country + ring fills the box edge to edge and no smaller.
   *
   * Always derived from the RAW content box stashed on the node, so repeated
   * refits (every slider move) never compound. (2026-09-13) */
  function dmbFitPreviewViewBox(svgEl, styles) {
    try {
      const bb = String((svgEl && svgEl.dataset && svgEl.dataset.dmbBbox) || "").split(" ").map(parseFloat);
      if (bb.length !== 4 || !isFinite(bb[2]) || bb[2] <= 0 || bb[3] <= 0) return;
      const host = svgEl.parentElement;
      const cs = host ? getComputedStyle(host) : null;
      const BW = host ? (host.clientWidth  - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight)  || 0)) : 0;
      const BH = host ? (host.clientHeight - (parseFloat(cs.paddingTop)  || 0) - (parseFloat(cs.paddingBottom) || 0)) : 0;
      const sw = Math.max(0, parseFloat(styles && styles.strokeWidth) || 0);
      const R  = ((styles && styles.showOutline) ? sw : 0) + sw / 2 + 1;
      let p = 0;
      if (BW > 2 * R && BH > 2 * R) {
        p = R * Math.max(bb[2] / (BW - 2 * R), bb[3] / (BH - 2 * R));
      } else {
        p = bb[2] * 0.02;                      // box too small to reason about
      }
      svgEl.setAttribute("viewBox",
        (bb[0] - p).toFixed(2) + " " + (bb[1] - p).toFixed(2) + " " +
        (bb[2] + p * 2).toFixed(2) + " " + (bb[3] + p * 2).toFixed(2));
      svgEl.setAttribute("preserveAspectRatio", "xMidYMid meet");
    } catch (e) {}
  }

  function dmbUpdateModalPreview() {
    const preview = document.getElementById("dmbMapPreview");
    if (!preview) return;
    const svgEl = preview.querySelector("svg");
    if (!svgEl) return;
    const st = dmbGetModalStyles();
    dmbFitPreviewViewBox(svgEl, st);   // the ring width may just have changed
    dmbApplyStylesToSvg(svgEl, st);
  }

  async function dmbSelectCountry(key) {
    dmbModalSelectedKey = key;

    /* highlight selected row */
    document.querySelectorAll(".dmb-country-item").forEach(el => el.classList.toggle("dmb-country-item--active", el.dataset.key === key));

    /* Continents subdivide by country, so relabel the "provinces" control. */
    const _hpLbl = document.getElementById("dmbMapHideProvincesLbl");
    if (_hpLbl) _hpLbl.textContent = dmbIsContinentKey(key) ? "Hide borders" : "Hide provinces";

    const preview = document.getElementById("dmbMapPreview");
    const insertBtn = document.getElementById("dmbMapInsertBtn");
    if (!preview) return;

    preview.innerHTML = '<span class="dmb-map-preview-placeholder">Loading…</span>';

    try {
      if (!dmbModalSvgCache[key]) {
        const url = dmbGetAssetUrl("dmb-map-" + key + ".svg");
        const res = await fetch(url);
        if (!res.ok) throw new Error("Not found");
        dmbModalSvgCache[key] = await res.text();
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(dmbModalSvgCache[key], "image/svg+xml");
      const svgEl = doc.querySelector("svg");
      if (!svgEl) throw new Error("No SVG element");

      svgEl.removeAttribute("width");
      svgEl.removeAttribute("height");
      svgEl.style.width = "100%";
      svgEl.style.height = "100%";
      svgEl.style.display = "block";

      // Attach BEFORE styling: the outline radius is calibrated against the SVG's
      // laid-out width, which is 0 while the node is still detached - that would
      // draw the first preview with a hairline ring and only correct it once a
      // style control was touched.
      preview.innerHTML = "";
      preview.appendChild(svgEl);

      // ── Give it a viewBox, or it does not scale at all ──────────────────
      // These MapSVG assets ship with NO viewBox attribute. With width/height
      // stripped above, the browser draws them 1:1 in their own user units
      // anchored top-left, so any country bigger than the preview box is simply
      // CUT OFF - measured: Russia 1224 units wide, Bangladesh 600 tall, France
      // 596x584, against a preview box of roughly 640x340 CSS px. That is the
      // "some countries aren't fitting" report, and it is also why small
      // countries looked fine: they happened to be under the box size.
      //
      // Cropping to the real content bounds does double duty - it makes the
      // shape scale to FIT and fills the box as large as it can. Same 2% pad as
      // dmbCropSvgToContent so the preview frames a country exactly like the map
      // that actually gets inserted on the page. (2026-09-13)
      try {
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        svgEl.querySelectorAll("path, polygon, polyline, circle, ellipse, rect").forEach(function (el) {
          try {
            const b = el.getBBox();
            if (b.width > 0 || b.height > 0) {
              minX = Math.min(minX, b.x); minY = Math.min(minY, b.y);
              maxX = Math.max(maxX, b.x + b.width); maxY = Math.max(maxY, b.y + b.height);
            }
          } catch (e2) {}
        });
        if (isFinite(minX) && maxX > minX && maxY > minY) {
          // Stash the RAW content box; dmbFitPreviewViewBox re-derives the pad from
          // it on every style change, so refits never compound.
          svgEl.dataset.dmbBbox = [minX, minY, maxX - minX, maxY - minY].join(" ");
          dmbFitPreviewViewBox(svgEl, dmbGetModalStyles());
        }
      } catch (e) {}

      dmbApplyStylesToSvg(svgEl, dmbGetModalStyles());

      if (insertBtn) insertBtn.disabled = false;
    } catch (e) {
      preview.innerHTML = '<span class="dmb-map-preview-placeholder">Preview unavailable</span>';
    }
  }

  function dmbBuildCountryList(filter) {
    const list = document.getElementById("dmbCountryList");
    if (!list) return;
    const q = (filter || "").toLowerCase().trim();
    list.innerHTML = "";
    const addItem = (key) => {
      const name = dmbKeyToName(key);
      if (q && !name.toLowerCase().includes(q) && !key.includes(q)) return false;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-country-item";
      btn.dataset.key = key;
      btn.textContent = name;
      if (key === dmbModalSelectedKey) btn.classList.add("dmb-country-item--active");
      btn.addEventListener("click", () => dmbSelectCountry(key));
      list.appendChild(btn);
      return true;
    };
    const addHeader = (text) => {
      const h = document.createElement("div");
      h.className = "dmb-country-group";
      h.textContent = text;
      list.appendChild(h);
    };
    // Continents first (each subdivided BY COUNTRY), then the individual countries.
    let contHeader = false;
    DMB_CONTINENT_KEYS.forEach((key) => {
      if (!contHeader) { addHeader("Continents"); contHeader = true; }
      const shown = addItem(key);
      if (!shown && contHeader && !list.querySelector(".dmb-country-item")) {
        // header added but nothing under it yet — leave; trailing empty header is cleaned below
      }
    });
    let countryHeader = false;
    DMB_COUNTRY_KEYS.forEach((key) => {
      if (!countryHeader) { addHeader("Countries"); countryHeader = true; }
      addItem(key);
    });
    // Remove any group header that ended up with no items beneath it (e.g. a search
    // that matched only countries leaves an empty "Continents" header).
    list.querySelectorAll(".dmb-country-group").forEach((h) => {
      const next = h.nextElementSibling;
      if (!next || next.classList.contains("dmb-country-group")) h.remove();
    });
  }

  function dmbOpenMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (!modal) return;
    // Ribbon-opened by default: forget any page the per-page button pinned last
    // time, so the picker asks again instead of reusing a stale target.
    _dmbMapTargetPage = null;
    dmbModalSelectedKey = null;
    const preview = document.getElementById("dmbMapPreview");
    if (preview) preview.innerHTML = '<span class="dmb-map-preview-placeholder">Select a country to preview</span>';
    const insertBtn = document.getElementById("dmbMapInsertBtn");
    if (insertBtn) insertBtn.disabled = true;
    const search = document.getElementById("dmbMapSearch");
    if (search) search.value = "";
    const ooModal = document.getElementById("dmbMapShowOutline");
    if (ooModal) ooModal.checked = false;
    const hpModal = document.getElementById("dmbMapHideProvinces");
    if (hpModal) hpModal.checked = false;
    const tfModal = document.getElementById("dmbMapTransparentFill");
    if (tfModal) tfModal.checked = false;
    dmbBuildCountryList("");
    modal.style.display = "flex";
  }

  function dmbCloseMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (modal) modal.style.display = "none";
  }

  function initMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (!modal || modal.dataset.dmbModalInit) return;
    modal.dataset.dmbModalInit = "1";

    document.getElementById("dmbMapModalClose")?.addEventListener("click", dmbCloseMapModal);
    modal.querySelector(".dmb-map-modal-backdrop")?.addEventListener("click", dmbCloseMapModal);

    document.getElementById("dmbMapSearch")?.addEventListener("input", (e) => {
      dmbBuildCountryList(e.target.value);
    });

    /* style controls → live preview update */
    ["dmbMapFill","dmbMapStroke","dmbMapStrokeWidth","dmbMapStrokeStyle","dmbMapOpacity","dmbMapShowOutline","dmbMapHideProvinces","dmbMapTransparentFill"].forEach((id) => {
      document.getElementById(id)?.addEventListener("change", () => dmbUpdateModalPreview());
      document.getElementById(id)?.addEventListener("input", () => {
        const wv = document.getElementById("dmbMapStrokeWidthVal");
        if (wv) wv.textContent = document.getElementById("dmbMapStrokeWidth")?.value;
        const ov = document.getElementById("dmbMapOpacityVal");
        if (ov) ov.textContent = Math.round(parseFloat(document.getElementById("dmbMapOpacity")?.value) * 100) + "%";
        dmbUpdateModalPreview();
      });
    });

    document.getElementById("dmbMapInsertBtn")?.addEventListener("click", async () => {
      if (!dmbModalSelectedKey || !dmbModalSvgCache[dmbModalSelectedKey]) return;
      // Settle the destination BEFORE building anything, so a cancel costs nothing.
      const _target = await _dmbResolveMapTargetPage();
      if (_target === null) return;
      const styles = dmbGetModalStyles();
      const svgMarkup = dmbModalSvgCache[dmbModalSelectedKey];

      const doInsert = (finalSvg) => {
        if (window.insertMapIntoActivePage) {
          window.insertMapIntoActivePage(finalSvg, dmbModalSelectedKey, styles, _target);
        }
        dmbCloseMapModal();
        const markStayBtn = document.getElementById("markStayBtn");
        if (markStayBtn) markStayBtn.style.display = "inline-flex";
      };

      const islands = dmbFindIslandPaths(svgMarkup);
      if (islands.length > 0) {
        showChoiceDialog(
          "Islands detected",
          `This map has ${islands.length} island(s) that appear separate from the main landmass. Include them?`,
          [
            { id: "yes", label: "Yes, include islands" },
            { id: "no", label: "No, main landmass only" }
          ]
        ).then(choice => {
          if (!choice) return;
          doInsert(choice === "no" ? dmbRemoveIslandPaths(svgMarkup, islands) : svgMarkup);
        });
      } else {
        doInsert(svgMarkup);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.style.display !== "none") dmbCloseMapModal();
    });

    /* Mobile "one sheet" layout (Variant B): inject a "Style ▾" toggle that
       collapses the style controls, so the country list + sticky Insert button
       dominate the bottom sheet. Desktop hides this toggle via CSS and always
       shows the controls. */
    const _mapRight = modal.querySelector(".dmb-map-modal-right");
    const _mapControls = modal.querySelector(".dmb-map-style-controls");
    if (_mapRight && _mapControls && !document.getElementById("dmbMapStyleToggle")) {
      const t = document.createElement("button");
      t.type = "button";
      t.id = "dmbMapStyleToggle";
      t.className = "dmb-map-style-toggle";
      t.innerHTML = 'Style <span class="dmb-mst-caret">&#9662;</span>';
      _mapRight.insertBefore(t, _mapControls);
      t.addEventListener("click", () => {
        _mapRight.classList.toggle("dmb-map-styles-open");
      });
    }
  }

  /* ── MAP EDIT BAR (floating, shown when a placed map is clicked) ── */
  let dmbEditingMapObj = null;
  let dmbEditingMapEl = null;
  let dmbEditBarUndoTimer = null;

  /* ── SHAPE EDIT BAR (floating, shown when a placed shape is clicked) ──
   * WARNING: Keep dmbEditingShapeObj/El in sync with the edit bar. Any
   * function that opens a different toolbar (text, map, frame) must call
   * dmbCloseShapeEditBar() so only one floating bar is ever visible.
   * ────────────────────────────────────────────────────────────────────── */
  let dmbEditingShapeObj = null;
  let dmbEditingShapeEl  = null;
  let _dmbShapeBarInit   = false;  // guard so we only wire bar events once
  let _dmbLineModeActive = false;  // true while waiting for a two-point line drag

  function dmbApplyEditBarToObj() {
    if (!dmbEditingMapObj || !dmbEditingMapEl) return;
    const fill = document.getElementById("dmbEditFill")?.value || "#d9d9d9";
    const stroke = document.getElementById("dmbEditStroke")?.value || "#111111";
    const strokeWidth = parseFloat(document.getElementById("dmbEditWidth")?.value ?? 1.2);
    const strokeDasharray = document.getElementById("dmbEditStrokeStyle")?.value || "";
    const opacity = parseFloat(document.getElementById("dmbEditOpacity")?.value ?? 1);
    const showOutline = document.getElementById("dmbEditShowOutline")?.checked || false;
    const hideProvinces = document.getElementById("dmbEditHideProvinces")?.checked || false;
    const transparentFill = document.getElementById("dmbEditTransparentFill")?.checked || false;

    dmbEditingMapObj.fill = fill;
    dmbEditingMapObj.stroke = stroke;
    dmbEditingMapObj.strokeWidth = strokeWidth;
    dmbEditingMapObj.strokeDasharray = strokeDasharray;
    dmbEditingMapObj.opacity = opacity;
    dmbEditingMapObj.showOutline = showOutline;
    dmbEditingMapObj.hideProvinces = hideProvinces;
    dmbEditingMapObj.transparentFill = transparentFill;

    const wv = document.getElementById("dmbEditWidthVal");
    if (wv) wv.textContent = strokeWidth;
    const ov = document.getElementById("dmbEditOpacityVal");
    if (ov) ov.textContent = Math.round(opacity * 100) + "%";

    try { _dmbSyncMapDots(); } catch (e) {}

    const svgEl = dmbEditingMapEl.querySelector("svg");
    if (svgEl) dmbApplyStylesToSvg(svgEl, { fill, stroke, strokeWidth, strokeDasharray, opacity, showOutline, hideProvinces, transparentFill, filterId: dmbEditingMapObj.filterId, w: dmbEditingMapObj.w });

    // Debounce undo so rapid slider drags collapse into one undo step
    clearTimeout(dmbEditBarUndoTimer);
    dmbEditBarUndoTimer = setTimeout(() => { pushUndoState("Edit Map Style"); }, 600);
  }

  function dmbOpenEditBar(obj, el) {
    _dmbLastBarShow = () => dmbOpenEditBar(obj, el);
    // Fast path while dragging THIS already-selected map: skip the heavy per-move
    // re-init (hiding other bars, rewriting all form controls, re-docking) — the bar
    // is already open & docked. Just keep the rotate handle on the object.
    if (_dmbDragSuppress && dmbEditingMapObj === obj && dmbEditingMapEl === el && el.classList.contains("dmb-selected")) {
      _dmbTrackRotHandle(el); return;
    }
    // (drag no longer hides the map edit bar — it stays open while moving/resizing)
    hideTextToolbar();
    hideFrameToolbar();
    dmbCloseShapeEditBar(); // close shape bar when map bar opens
    // Deselect any previously selected map
    document.querySelectorAll(".dmb-map-object.dmb-selected").forEach((m) => {
      if (m !== el) {
        m.classList.remove("dmb-selected");
        m._dmbRotHandle?.style && (m._dmbRotHandle.style.display = "none");
      }
    });

    dmbEditingMapObj = obj;
    dmbEditingMapEl = el;
    el.classList.add("dmb-selected");
    // Show rotation handle if stored
    if (el._dmbRotHandle) el._dmbRotHandle.style.display = "";

    const bar = document.getElementById("dmbMapEditBar");
    if (!bar) return;

    document.getElementById("dmbEditFill").value = obj.fill || "#d9d9d9";
    document.getElementById("dmbEditStroke").value = obj.stroke || "#111111";
    try { _dmbSyncMapDots(); } catch (e) {}
    document.getElementById("dmbEditWidth").value = obj.strokeWidth ?? 1.2;
    document.getElementById("dmbEditWidthVal").textContent = obj.strokeWidth ?? 1.2;
    document.getElementById("dmbEditStrokeStyle").value = obj.strokeDasharray || "";
    document.getElementById("dmbEditOpacity").value = obj.opacity ?? 1;
    document.getElementById("dmbEditOpacityVal").textContent = Math.round((obj.opacity ?? 1) * 100) + "%";
    const ooEl = document.getElementById("dmbEditShowOutline");
    if (ooEl) ooEl.checked = obj.showOutline || false;
    const hpEl = document.getElementById("dmbEditHideProvinces");
    if (hpEl) hpEl.checked = obj.hideProvinces || false;
    // Continent maps subdivide by country, so the "provinces" toggle is really the
    // country-borders toggle — relabel it.
    const hpLbl = document.getElementById("dmbEditHideProvincesLbl");
    if (hpLbl) hpLbl.textContent = dmbIsContinentKey(obj.mapKey || "") ? "No borders" : "No provinces";
    const tfEl = document.getElementById("dmbEditTransparentFill");
    if (tfEl) tfEl.checked = obj.transparentFill || false;
    try { _dmbSyncMapDots(); } catch (e) {}
    try { _dmbSyncMapModeUI(); } catch (e) {}

    // Update contain button text
    const _mcBtn = document.getElementById("dmbMapContainBtn");
    if (_mcBtn) _mcBtn.textContent = _dmbContainBtnText(obj, !!el.closest(".dmb-cover-preview"));

    /* Dock the bar into the header's empty space (top-left), not over the canvas. */
    bar.style.display = "block";
    _dmbDockBar(bar);
  }

  function dmbCloseEditBar() {
    const bar = document.getElementById("dmbMapEditBar");
    if (bar) bar.style.display = "none";
    if (dmbEditingMapEl) {
      dmbEditingMapEl.classList.remove("dmb-selected");
      if (dmbEditingMapEl._dmbRotHandle) dmbEditingMapEl._dmbRotHandle.style.display = "none";
    }
    dmbEditingMapObj = null;
    dmbEditingMapEl = null;
    try { _dmbUpdateRibbonPlaceholder(); } catch (e) {}
  }

  function initMapEditBar() {
    const bar = document.getElementById("dmbMapEditBar");
    if (!bar || bar.dataset.dmbBarInit) return;
    bar.dataset.dmbBarInit = "1";

    ["dmbEditFill","dmbEditStroke","dmbEditWidth","dmbEditStrokeStyle","dmbEditOpacity","dmbEditShowOutline","dmbEditHideProvinces","dmbEditTransparentFill"].forEach((id) => {
      document.getElementById(id)?.addEventListener("input", dmbApplyEditBarToObj);
      document.getElementById(id)?.addEventListener("change", dmbApplyEditBarToObj);
    });

    // Fill-mode segmented (Solid / Outline / None) → drive the hidden checkboxes.
    document.querySelectorAll("#dmbEditFillMode .dmb-map-seg-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const m = btn.dataset.fillmode;
        const oo = document.getElementById("dmbEditShowOutline");
        const tf = document.getElementById("dmbEditTransparentFill");
        if (oo) oo.checked = (m === "outline");
        if (tf) tf.checked = (m === "outline" || m === "none");
        dmbApplyEditBarToObj();
        _dmbSyncMapModeUI();
      });
    });
    // Borders toggle → hideProvinces (inverse). (Legacy control — null-safe if absent.)
    document.getElementById("dmbEditBordersBtn")?.addEventListener("click", () => {
      const hp = document.getElementById("dmbEditHideProvinces");
      if (hp) hp.checked = !hp.checked;
      dmbApplyEditBarToObj();
      _dmbSyncMapModeUI();
    });

    // "Map options" dropdown (show outline / transparent fill / no provinces).
    const _mOptToggle = document.getElementById("dmbMapOptsToggle");
    const _mOptMenu   = document.getElementById("dmbMapOptsMenu");
    if (_mOptToggle && _mOptMenu) {
      const _isMob = () => window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches;
      let _mOptSlot = null;  // placeholder marking the menu's home inside the edit bar
      // Phones: lift the menu out of the ribbon onto <body> BEFORE showing it, so it
      // can't be trapped by the ribbon's overflow/stacking. This is the same fix that
      // made the colour sheet reliable on iOS ("nothing happens on tap") — the menu
      // used to depend on the popover-observer catching it while still inside the
      // horizontally-scrolling ribbon, which rendered it off-screen. Once on <body>
      // the shared observer pins it as a bottom sheet reliably. Desktop is untouched.
      function _openMapOpts() {
        if (_isMob() && _mOptMenu.parentElement !== document.body) {
          _mOptSlot = document.createComment("dmb-mapopts-home");
          _mOptMenu.parentElement.insertBefore(_mOptSlot, _mOptMenu);
          document.body.appendChild(_mOptMenu);
        }
        _mOptMenu.hidden = false;
      }
      function _closeMapOpts() {
        _mOptMenu.hidden = true;
        if (_mOptSlot && _mOptSlot.parentElement) {           // return it home
          _mOptSlot.parentElement.insertBefore(_mOptMenu, _mOptSlot);
          _mOptSlot.remove(); _mOptSlot = null;
        }
      }
      _mOptToggle.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        if (_mOptMenu.hidden) _openMapOpts(); else _closeMapOpts();
      });
      document.addEventListener("click", (e) => {
        if (_mOptMenu.hidden) return;
        if (e.target === _mOptToggle || e.target.closest("#dmbMapOptsToggle")) return;
        if (e.target.closest("#dmbMapOptsMenu") || e.target.closest("#dmbMapOptsDD")) return;
        _closeMapOpts();
      });
    }

    // Colour-wheel palettes for Fill + Border (recent swatches + custom picker) — the
    // same book colour palette used by text/shapes/stickers.
    [["dmbEditFillBtn","dmbEditFillPop","dmbEditFillCustom","dmbEditFill"],
     ["dmbEditStrokeBtn","dmbEditStrokePop","dmbEditStrokeCustom","dmbEditStroke"]
    ].forEach(([btnId, popId, customId, inputId]) => {
      const btn = document.getElementById(btnId);
      const pop = document.getElementById(popId);
      const custom = document.getElementById(customId);
      const input = document.getElementById(inputId);
      if (btn && pop) {
        btn.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          const willOpen = pop.hidden;
          ["dmbEditFillPop","dmbEditStrokePop"].forEach((id) => { const p = document.getElementById(id); if (p && p !== pop) p.hidden = true; });
          pop.hidden = !willOpen;
        });
        pop.addEventListener("click", (e) => { if (e.target.closest(".dmb-recent-swatch")) pop.hidden = true; });
      }
      if (custom && input) {
        custom.addEventListener("click", (e) => { e.stopPropagation(); if (e.target === input) return; try { input.click(); } catch (e2) {} });   // identical to the background wheel — NO preventDefault (it cancels the native picker on iOS)
      }
      if (input && pop) {
        try { dmbEnhanceColorInput(input, pop); } catch (e) {}
        try { if (custom) pop.appendChild(custom); } catch (e) {}
        try { _dmbColorTapFix(custom, input); } catch (e) {}
        input.addEventListener("input", () => { try { _dmbSyncMapDots(); } catch (e) {} });
        input.addEventListener("change", () => { pop.hidden = true; });
      }
    });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("#dmbEditFillWrap"))   { const p = document.getElementById("dmbEditFillPop");   if (p) p.hidden = true; }
      if (!e.target.closest("#dmbEditStrokeWrap")) { const p = document.getElementById("dmbEditStrokePop"); if (p) p.hidden = true; }
    });

    document.getElementById("dmbEditDone")?.addEventListener("click", dmbCloseEditBar);

    // Contain-to-page button
    document.getElementById("dmbMapContainBtn")?.addEventListener("click", () => {
      if (!dmbEditingMapObj || !dmbEditingMapEl) return;
      const _isCover = !!dmbEditingMapEl.closest(".dmb-cover-preview");
      _dmbContainCycle(dmbEditingMapObj, dmbEditingMapEl, _isCover);
    });

    ["left", "center", "right"].forEach(function(align) {
      const btnId = { left: "dmbEditAlignLeft", center: "dmbEditAlignCenter", right: "dmbEditAlignRight" }[align];
      document.getElementById(btnId)?.addEventListener("click", () => {
        if (!dmbEditingMapObj || !dmbEditingMapEl) return;
        const tType = dmbEditingMapEl.closest(".dmb-cover-preview") ? "cover" : "page";
        dmbAlignObjectInZone(dmbEditingMapEl, dmbEditingMapObj, align, tType);
        _dmbDockBar(document.getElementById("dmbMapEditBar"));
      });
    });

    document.getElementById("dmbEditFrontBtn")?.addEventListener("click", () => {
      _dmbDoLayerStep(dmbEditingMapEl, "forward");
    });

    document.getElementById("dmbEditBackBtn")?.addEventListener("click", () => {
      _dmbDoLayerStep(dmbEditingMapEl, "backward");
    });

    document.getElementById("dmbEditDelete")?.addEventListener("click", () => {
      if (!dmbEditingMapObj) return;
      const objId = dmbEditingMapObj.id;
      // pushUndoState makes the deletion undoable AND persists it to the restore key
      // (via the flush in pushUndoState). Without it, deleting a map was NOT saved —
      // on refresh the deleted map reappeared (the saved copy still had it).
      pushUndoState("Delete Map");
      if (editor.pageObjects) {
        Object.keys(editor.pageObjects).forEach((p) => {
          const arr = editor.pageObjects[p];
          if (Array.isArray(arr)) {
            const idx = arr.findIndex((o) => o.id === objId);
            if (idx !== -1) arr.splice(idx, 1);
          }
        });
      }
      if (Array.isArray(editor.coverObjects)) {
        const idx = editor.coverObjects.findIndex((o) => o.id === objId);
        if (idx !== -1) editor.coverObjects.splice(idx, 1);
      }
      dmbCloseEditBar();
      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    });

    // Close edit bar when pointer lands outside both the bar and any map object.
    // Use capture so stopPropagation on stickers/frames/text doesn't prevent this.
    document.addEventListener("pointerdown", (e) => {
      if (!dmbEditingMapObj) return;
      const bar = document.getElementById("dmbMapEditBar");
      if (bar && bar.contains(e.target)) return; // clicked inside edit bar
      if (e.target.closest(".dmb-stage-header")) return; // anywhere in the fixed ribbon
      if (e.target.closest("#dmbMshRibbon")) return; // mobile ribbon (idle + docked bars)
      if (e.target.closest("#dmbMshColorSheet")) return; // mobile body colour sheet — keep the map selected
      if (e.target.closest("#dmbMapOptsMenu")) return; // "Map options" popover (moved to <body> on phones) — keep the map selected so its toggles apply
      if (e.target.closest(".dmb-map-object")) return; // clicked on a map
      dmbCloseEditBar();
    }, { capture: true });
  }

  /* ══════════════════════════════════════════════════════════════════════
     SHAPE EDIT BAR — open / close / apply / init
     WARNING: All changes to shape appearance must go through dmbApplyShapeEditBar.
     Do NOT update obj.fill/stroke/etc. from anywhere else — always update the
     bar controls first then call dmbApplyShapeEditBar() so the SVG stays in sync.
     ══════════════════════════════════════════════════════════════════════ */

  // Return SVG string for a given shape type + style properties.
  // viewBox 0 0 100 100; caller wraps in a div of the desired pixel size.
  // Turn a border-style keyword + stroke width into an SVG dash attribute string.
  // Dash lengths scale with the stroke width so they look right at any thickness.
  // Values are in screen px because every shape stroke uses non-scaling-stroke.
  function _dmbShapeDashAttrs(strokeStyle, sw) {
    const w = Math.max(1, sw || 1);
    if (strokeStyle === "dashed") return `stroke-dasharray="${(w * 2.4).toFixed(1)},${(w * 1.7).toFixed(1)}"`;
    if (strokeStyle === "dotted") return `stroke-dasharray="0.1,${(w * 1.9).toFixed(1)}" stroke-linecap="round"`;
    return "";
  }

  // ── LINE subsystem (endpoint-based) ─────────────────────────────────────────
  // A line is stored with two endpoints (x1,y1)-(x2,y2) in page/container coords,
  // a stroke `thickness`, and a `lineType` ("straight" | "elbowed" | "curved").
  // Its bounding box (x,y,w,h; rotation always 0) is kept in sync so the rest of
  // the system (move / snap / z-order / duplicate / PDF) keeps working.
  function _dmbLinePad(obj) { return Math.max(2, (obj.thickness || obj.h || 8) / 2 + 3); }
  // Migrate an old-style line (rotated rect: w=length, h=thickness, rotation=angle)
  // to the endpoint model. No-op if already migrated.
  function _dmbLineMigrate(obj) {
    if (obj.x1 != null && obj.y1 != null && obj.x2 != null && obj.y2 != null) {
      if (obj.thickness == null) obj.thickness = obj.h || 8;
      if (!obj.lineType) obj.lineType = "straight";
      return;
    }
    const w = obj.w || 100, h = obj.h || 8;
    const cx = (obj.x || 0) + w / 2, cy = (obj.y || 0) + h / 2;
    const th = (obj.rotation || 0) * Math.PI / 180;
    const hx = Math.cos(th) * w / 2, hy = Math.sin(th) * w / 2;
    obj.x1 = cx - hx; obj.y1 = cy - hy;
    obj.x2 = cx + hx; obj.y2 = cy + hy;
    obj.thickness = h;
    obj.lineType = obj.lineType || "straight";
    obj.rotation = 0;
  }
  function _dmbLineCtrlPoint(a, b) {
    const mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    const dx = b.x - a.x, dy = b.y - a.y, len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len, ny = dx / len;               // perpendicular unit
    const off = Math.min(140, len * 0.28);
    return { x: mx + nx * off, y: my + ny * off };
  }
  function _dmbLineElbowPoint(a, b) {
    return (Math.abs(b.x - a.x) >= Math.abs(b.y - a.y)) ? { x: b.x, y: a.y } : { x: a.x, y: b.y };
  }
  // Curved lines carry a draggable on-curve handle (bx,by) — the point the curve
  // passes THROUGH at its middle. Default = a gentle perpendicular bow.
  function _dmbLineEnsureCurve(obj) {
    if (obj.lineType !== "curved") return;
    if (obj.bx != null && obj.by != null) return;
    const ax = obj.x1, ay = obj.y1, bx2 = obj.x2, by2 = obj.y2;
    const mx = (ax + bx2) / 2, my = (ay + by2) / 2;
    const dx = bx2 - ax, dy = by2 - ay, len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len, ny = dx / len;
    const off = Math.max(14, Math.min(140, len * 0.22));
    obj.bx = mx + nx * off; obj.by = my + ny * off;
  }
  // Quadratic control so the curve passes through the handle (bx,by) at t=0.5:
  //   B(0.5) = 0.25*P0 + 0.5*C + 0.25*P2  =>  C = 2H - 0.5*(P0+P2)
  function _dmbLineQuadControl(obj) {
    return { x: 2 * obj.bx - 0.5 * (obj.x1 + obj.x2), y: 2 * obj.by - 0.5 * (obj.y1 + obj.y2) };
  }
  // Decompose the handle into {t along chord, perp signed distance} so it can be
  // re-placed proportionally after an endpoint moves (keeps the curve's shape).
  function _dmbLineDecompose(obj) {
    const ax = obj.x1, ay = obj.y1, dx = obj.x2 - ax, dy = obj.y2 - ay;
    const len2 = dx * dx + dy * dy || 1, len = Math.sqrt(len2);
    const t = ((obj.bx - ax) * dx + (obj.by - ay) * dy) / len2;
    const px = ax + dx * t, py = ay + dy * t;
    const nx = -dy / len, ny = dx / len;
    const perp = (obj.bx - px) * nx + (obj.by - py) * ny;
    return { t, perp };
  }
  function _dmbLineRecompose(obj, d) {
    const ax = obj.x1, ay = obj.y1, dx = obj.x2 - ax, dy = obj.y2 - ay;
    const len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len, ny = dx / len;
    const px = ax + dx * d.t, py = ay + dy * d.t;
    obj.bx = px + nx * d.perp; obj.by = py + ny * d.perp;
  }
  function _dmbLineRecomputeBox(obj) {
    _dmbLineMigrate(obj);
    const a = { x: obj.x1, y: obj.y1 }, b = { x: obj.x2, y: obj.y2 };
    const pts = [a, b];
    if (obj.lineType === "curved") { _dmbLineEnsureCurve(obj); pts.push(_dmbLineQuadControl(obj)); pts.push({ x: obj.bx, y: obj.by }); }
    else if (obj.lineType === "elbowed") pts.push(_dmbLineElbowPoint(a, b));
    const pad = _dmbLinePad(obj);
    const minX = Math.min.apply(null, pts.map(p => p.x)) - pad;
    const minY = Math.min.apply(null, pts.map(p => p.y)) - pad;
    const maxX = Math.max.apply(null, pts.map(p => p.x)) + pad;
    const maxY = Math.max.apply(null, pts.map(p => p.y)) + pad;
    obj.x = minX; obj.y = minY;
    obj.w = Math.max(1, maxX - minX); obj.h = Math.max(1, maxY - minY);
    obj.rotation = 0;
  }
  function _dmbLineDash(style, tw) {
    if (style === "dashed") return `stroke-dasharray="${(tw * 2.4).toFixed(1)},${(tw * 1.7).toFixed(1)}"`;
    if (style === "dotted") return `stroke-dasharray="0.1,${(tw * 1.9).toFixed(1)}"`;
    return "";
  }
  function buildLineSvg(obj) {
    _dmbLineRecomputeBox(obj);
    const a = { x: obj.x1 - obj.x, y: obj.y1 - obj.y };
    const b = { x: obj.x2 - obj.x, y: obj.y2 - obj.y };
    const col = (obj.fill && obj.fill !== "none" && obj.fill !== "transparent") ? obj.fill : (obj.stroke || "#111111");
    const tw = Math.max(1, obj.thickness || 8);
    let d;
    if (obj.lineType === "curved") {
      _dmbLineEnsureCurve(obj);
      const c = _dmbLineQuadControl(obj);
      const lc = { x: c.x - obj.x, y: c.y - obj.y };
      d = `M${a.x.toFixed(1)} ${a.y.toFixed(1)} Q ${lc.x.toFixed(1)} ${lc.y.toFixed(1)} ${b.x.toFixed(1)} ${b.y.toFixed(1)}`;
    } else if (obj.lineType === "elbowed") {
      const e = _dmbLineElbowPoint({ x: obj.x1, y: obj.y1 }, { x: obj.x2, y: obj.y2 });
      const le = { x: e.x - obj.x, y: e.y - obj.y };
      d = `M${a.x.toFixed(1)} ${a.y.toFixed(1)} L ${le.x.toFixed(1)} ${le.y.toFixed(1)} L ${b.x.toFixed(1)} ${b.y.toFixed(1)}`;
    } else {
      d = `M${a.x.toFixed(1)} ${a.y.toFixed(1)} L ${b.x.toFixed(1)} ${b.y.toFixed(1)}`;
    }
    const op = (obj.opacity != null) ? obj.opacity : 1;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${obj.w.toFixed(1)} ${obj.h.toFixed(1)}" width="100%" height="100%" preserveAspectRatio="none" style="display:block;overflow:visible;opacity:${op};"><path d="${d}" fill="none" stroke="${col}" stroke-width="${tw}" stroke-linecap="round" stroke-linejoin="round" ${_dmbLineDash(obj.strokeStyle, tw)}/></svg>`;
  }
  // Rebuild the SVG + reposition the 2 endpoint handles + resize the wrapper.
  function _dmbLineRefreshEl(obj, el) {
    if (!el) return;
    _dmbLineRecomputeBox(obj);
    el.style.left = obj.x + "px"; el.style.top = obj.y + "px";
    el.style.width = obj.w + "px"; el.style.height = obj.h + "px";
    const old = el.querySelector("svg");
    const tmp = document.createElement("div"); tmp.innerHTML = buildLineSvg(obj);
    const neu = tmp.firstElementChild;
    if (old && neu) old.replaceWith(neu); else if (neu) el.insertBefore(neu, el.firstChild);
    const h1 = el.querySelector('.dmb-line-end-handle[data-end="1"]');
    const h2 = el.querySelector('.dmb-line-end-handle[data-end="2"]');
    if (h1) { h1.style.left = (obj.x1 - obj.x) + "px"; h1.style.top = (obj.y1 - obj.y) + "px"; }
    if (h2) { h2.style.left = (obj.x2 - obj.x) + "px"; h2.style.top = (obj.y2 - obj.y) + "px"; }
    // Curve control handle (CSS shows it only when the line is selected AND curved).
    el.classList.toggle("dmb-line-curved", obj.lineType === "curved");
    const hm = el.querySelector('.dmb-line-mid-handle');
    if (hm && obj.lineType === "curved") {
      _dmbLineEnsureCurve(obj);
      hm.style.left = (obj.bx - obj.x) + "px"; hm.style.top = (obj.by - obj.y) + "px";
    }
  }
  // Render a line object into the canvas: wrapper + line SVG + 2 endpoint handles,
  // whole-line move drag, and per-endpoint drag. Selection opens the shape edit bar.
  function _dmbRenderLineObject(obj, container, targetType, pageNumber, zone) {
    _dmbLineRecomputeBox(obj);
    const wrap = document.createElement("div");
    wrap.className = "dmb-shape-object dmb-line-object";
    wrap.dataset.objectId = obj.id;
    const _lz = (obj.z === 0 || obj.z) ? obj.z : 30;   // 0 is a real z ("send to back")
    wrap.dataset.z = String(_lz);
    wrap.style.cssText = `position:absolute;left:${obj.x}px;top:${obj.y}px;width:${obj.w}px;height:${obj.h}px;z-index:${_lz};transform-origin:center center;overflow:visible;cursor:move;`;
    wrap.innerHTML = buildLineSvg(obj);

    ["1", "2"].forEach((which) => {
      const h = document.createElement("div");
      h.className = "dmb-line-end-handle";
      h.dataset.end = which;
      h.style.left = ((which === "1" ? obj.x1 : obj.x2) - obj.x) + "px";
      h.style.top  = ((which === "1" ? obj.y1 : obj.y2) - obj.y) + "px";
      wrap.appendChild(h);
    });

    // Curve control handle (the on-curve point the customer drags to bend the line).
    const hMid = document.createElement("div");
    hMid.className = "dmb-line-mid-handle";
    wrap.appendChild(hMid);
    if (obj.lineType === "curved") {
      _dmbLineEnsureCurve(obj);
      wrap.classList.add("dmb-line-curved");
      hMid.style.left = (obj.bx - obj.x) + "px"; hMid.style.top = (obj.by - obj.y) + "px";
    }

    function repositionBar() {
      const bar = document.getElementById("dmbShapeEditBar");
      if (!bar || bar.style.display === "none") return;
      _dmbDockBar(bar);   // docked at the top — stays put while editing
    }

    wrap.addEventListener("click", (e) => {
      if (e.target.closest(".dmb-line-end-handle,.dmb-line-mid-handle")) return;
      e.stopPropagation();
      dmbOpenShapeEditBar(obj, wrap);
    });

    // Endpoint drag — keeps the curve's shape proportional (decompose/recompose).
    wrap.querySelectorAll(".dmb-line-end-handle").forEach((h) => {
      h.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        dmbOpenShapeEditBar(obj, wrap);
        const which = h.dataset.end;
        const _Z = _nodeOnScreenScale(wrap) || 1;
        const cRect = container.getBoundingClientRect();
        const _cW = container.offsetWidth  || 270;
        const _cH = container.offsetHeight || 382;
        const _curveD = (obj.lineType === "curved" && obj.bx != null) ? _dmbLineDecompose(obj) : null;
        // A line drawn across the fold could not be EDITED across it: this clamped the
        // endpoint to [0, _cW], its own page, so the first tug on either end snapped the
        // whole line back onto one sheet and it could never reach over again. Endpoints
        // now share the spread with everything else that spans. (2026-09-14)
        const _epX = (targetType === "page") ? _dmbPointRangeX(pageNumber, _cW) : { lo: 0, hi: _cW };
        const onMove = (ev) => {
          // Y still clamps to the sheet - top and bottom are real edges on any page.
          const px = Math.max(_epX.lo, Math.min(_epX.hi, (ev.clientX - cRect.left) / _Z));
          const py = Math.max(0, Math.min(_cH, (ev.clientY - cRect.top)  / _Z));
          if (which === "1") { obj.x1 = px; obj.y1 = py; } else { obj.x2 = px; obj.y2 = py; }
          if (_curveD) _dmbLineRecompose(obj, _curveD);
          _dmbLineRefreshEl(obj, wrap);
          repositionBar();
        };
        const onUp = () => {
          document.removeEventListener("pointermove", onMove);
          document.removeEventListener("pointerup", onUp);
          pushUndoState("Edit Line");
        };
        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", onUp);
      });
    });

    // Curve control-point drag — moves the on-curve handle (bx,by).
    hMid.addEventListener("pointerdown", (e) => {
      e.preventDefault(); e.stopPropagation();
      dmbOpenShapeEditBar(obj, wrap);
      const _Z = _nodeOnScreenScale(wrap) || 1;
      const cRect = container.getBoundingClientRect();
      const _cW = container.offsetWidth  || 270;
      const _cH = container.offsetHeight || 382;
      // The third handle. Its two neighbours (the endpoints and the whole-line drag)
      // were freed to cross the fold; this one still pinned the curve's control point to
      // its own page, so on a right-hand page bx floored at 0 and the bulge of a curve
      // could never be placed on the facing sheet at all. Worse, _dmbLineRecomputeBox
      // derives obj.x/obj.w FROM x1/x2/bx, so clamping bx silently shifted and shrank the
      // line's box mid-drag - which then feeds the overhang and z-index logic. (2026-09-14)
      const _cpX = (targetType === "page") ? _dmbPointRangeX(pageNumber, _cW) : { lo: 0, hi: _cW };
      const onMove = (ev) => {
        obj.bx = Math.max(_cpX.lo, Math.min(_cpX.hi, (ev.clientX - cRect.left) / _Z));
        obj.by = Math.max(0, Math.min(_cH, (ev.clientY - cRect.top)  / _Z));
        _dmbLineRefreshEl(obj, wrap);
        repositionBar();
      };
      const onUp = () => {
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        pushUndoState("Edit Line");
      };
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    // Whole-line move
    wrap.addEventListener("pointerdown", (e) => {
      if (e.target.closest(".dmb-line-end-handle,.dmb-line-mid-handle")) return;
      e.preventDefault(); e.stopPropagation();
      dmbOpenShapeEditBar(obj, wrap);
      const _Z = _nodeOnScreenScale(wrap) || 1;
      const sx = e.clientX, sy = e.clientY;
      const o = { x1: obj.x1, y1: obj.y1, x2: obj.x2, y2: obj.y2, bx: obj.bx, by: obj.by };
      // Clamp the whole-line move by DELTA (clamping the endpoints one by one would
      // skew the line instead of moving it). Same rule as the shape drag: the bbox
      // may hang at most half off — that is deliberate bleed — but never further.
      const _b0 = { x: obj.x, y: obj.y, w: obj.w, h: obj.h };
      const _cW = container.offsetWidth  || 270;
      const _cH = container.offsetHeight || 382;
      // Same spread-wide range the shape and map drags use, so a spanning line can be
      // moved along the fold instead of being pulled back onto one page.
      const _rX  = (targetType === "page") ? _dmbObjDragRangeX(obj, pageNumber, _cW)
                                           : { lo: -_b0.w / 2, hi: _cW - _b0.w / 2 };
      const _loX = _rX.lo - _b0.x, _hiX = _rX.hi - _b0.x;
      const _loY = -_b0.h / 2 - _b0.y, _hiY = _cH - _b0.h / 2 - _b0.y;
      const onMove = (ev) => {
        let dx = (ev.clientX - sx) / _Z, dy = (ev.clientY - sy) / _Z;
        if (_hiX > _loX) dx = Math.max(_loX, Math.min(_hiX, dx));
        if (_hiY > _loY) dy = Math.max(_loY, Math.min(_hiY, dy));
        obj.x1 = o.x1 + dx; obj.y1 = o.y1 + dy; obj.x2 = o.x2 + dx; obj.y2 = o.y2 + dy;
        if (o.bx != null) { obj.bx = o.bx + dx; obj.by = o.by + dy; }
        _dmbLineRefreshEl(obj, wrap);
        repositionBar();
      };
      const onUp = async () => {
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        pushUndoState("Move Line");
        if (targetType === "cover") { try { _dmbAutoAssignCoverZone(obj, wrap); } catch (e2) {} }
        else if (targetType === "page" && typeof pageNumber === "number") {
          try { await dmbHandleCrossPageMove(obj, pageNumber); } catch (e2) {}
        }
      };
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    container.appendChild(wrap);
  }

  function buildShapeSvg(shapeType, fill, stroke, strokeWidth, opacity, cornerRadius, w, h, strokeStyle) {
    const f  = fill        || "#6366f1";
    const s  = stroke      || "transparent";
    const sw = strokeWidth || 0;
    const op = (opacity !== undefined && opacity !== null) ? opacity : 1;
    const half = sw / 2;
    // For rect/rounded-rect: inset the stroked path by sw/2 REAL PIXELS so the
    // border's outer edge hugs the shape box at ANY size (and matches the PDF,
    // which insets by sw/2 px). The 0-100 viewBox is stretched to w×h px, so a
    // viewBox inset of (50*sw/w) == sw/2 px on X and (50*sw/h) == sw/2 px on Y.
    // A constant `half` only lined up when the box was ~100px; on big shapes it
    // scaled up into a visible gap between the box edge and the border. Falls back
    // to `half` when w/h are unknown.
    const ixR = (w && w > 0) ? (50 * sw / w) : half;
    const iyR = (h && h > 0) ? (50 * sw / h) : half;
    // vector-effect="non-scaling-stroke" on every inner element:
    // With preserveAspectRatio="none", the X and Y scales differ for non-square shapes,
    // making stroke-width render thicker on one axis than the other. non-scaling-stroke
    // keeps the stroke exactly `sw` screen-pixels wide on ALL sides regardless of shape
    // aspect ratio — perfectly uniform borders every time.
    const vens = `vector-effect="non-scaling-stroke" ${_dmbShapeDashAttrs(strokeStyle, sw)}`;
    let inner = "";
    switch (shapeType) {
      case "rect":
        // stroke-linejoin="miter" → sharp 90° outer stroke corners (not rounded)
        inner = `<rect x="${ixR}" y="${iyR}" width="${100 - 2 * ixR}" height="${100 - 2 * iyR}" rx="0" ry="0" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="miter" ${vens}/>`;
        break;
      case "rounded-rect": {
        // cx clamped 0-50: 50 = perfect semicircle; stored as viewBox % of 0-100 space
        const _cr = Math.max(0, Math.min(50, (cornerRadius !== undefined && cornerRadius !== null) ? cornerRadius : 12));
        inner = `<rect x="${ixR}" y="${iyR}" width="${100 - 2 * ixR}" height="${100 - 2 * iyR}" rx="${_cr}" ry="${_cr}" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      }
      case "circle":
        inner = `<ellipse cx="50" cy="50" rx="${50 - half}" ry="${50 - half}" fill="${f}" stroke="${s}" stroke-width="${sw}" ${vens}/>`;
        break;
      case "triangle":
        inner = `<polygon points="50,${half} ${100-half},${100-half} ${half},${100-half}" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "star":
        inner = `<polygon points="50,2 61.8,33.8 95.6,35.2 69,56.2 78.2,88.8 50,70 21.8,88.8 31,56.2 4.4,35.2 38.2,33.8" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "heart":
        inner = `<path d="M50,85 C20,70 5,55 5,38 C5,22 16,10 28,10 C36,10 44,15 50,22 C56,15 64,10 72,10 C84,10 95,22 95,38 C95,55 80,70 50,85 Z" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "arrow":
        inner = `<polygon points="5,35 60,35 60,15 95,50 60,85 60,65 5,65" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "pentagon":
        inner = `<polygon points="50,2 95.6,35.2 78.2,88.8 21.8,88.8 4.4,35.2" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "hexagon":
        inner = `<polygon points="98,50 74,91.6 26,91.6 2,50 26,8.4 74,8.4" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "line":
        inner = `<rect x="0" y="0" width="100" height="100" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      default:
        inner = `<rect x="0" y="0" width="100" height="100" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none" style="display:block;overflow:visible;opacity:${op};">${inner}</svg>`;
  }

  // Draw a shape on a Canvas 2D context at (0,0,dw,dh) — used for PDF rendering.
  // ctx should already be saved/translated/rotated by the caller.
  //
  // UNITS — the whole correctness story lives here. On screen the shape is an SVG
  // with viewBox "0 0 100 100" stretched to obj.w x obj.h CSS px, and EVERY inner
  // element carries vector-effect="non-scaling-stroke". So the border is exactly
  // `strokeWidth` CSS px on all four sides however big or lopsided the box is, and
  // the dash lengths from _dmbShapeDashAttrs are in those same CSS px.
  //
  // The PDF canvas is `pxScale` times bigger than the builder (PAGE_SCALE 9.19),
  // so the printed pen must be strokeWidth * pxScale CANVAS px. Building the path
  // inside ctx.scale(dw/100, dh/100) and stroking there — which is what this used
  // to do — gets that wrong twice: the pen comes out strokeWidth * dw/100 wide
  // (right only for a shape exactly 100 builder px across) and it is ELLIPTICAL
  // whenever dw != dh, so the same outline is thicker on the top than on the sides.
  // Rect-likes had the mirror-image bug: they stroked in canvas px with lineWidth
  // = strokeWidth, i.e. ~9.2x TOO THIN, turning a 3 mm frame into a 0.3 mm hairline.
  //
  // Fix: scale the PATH COORDINATES and never scale the context. Fill and stroke
  // both then happen in canvas px, so the pen is isotropic and correctly sized.
  function drawShapeOnCanvas(ctx, shapeType, fill, stroke, strokeWidth, dw, dh, cornerRadius, strokeStyle, pxScale) {
    const f  = fill        || "#6366f1";
    const s  = (strokeWidth && strokeWidth > 0) ? (stroke || "#000") : "transparent";
    const sw = strokeWidth || 0;                        // BUILDER px
    const P  = (typeof pxScale === "number" && pxScale > 0) ? pxScale : 1;
    const SX = dw / 100, SY = dh / 100;                 // viewBox unit -> canvas px
    // The pen, in canvas px. Clamped so a very wide border can never swallow the box
    // (the SVG side is clamped implicitly by the viewBox).
    const swPx = Math.min(sw * P, Math.max(0, Math.min(dw, dh) * 0.99));
    // Dash lengths are screen px on the SVG side (non-scaling-stroke) -> * P here.
    // The dotted pattern's leading 0.1 is a screen px too and must scale with them.
    const _wsw = Math.max(1, sw || 1) * P;
    const _dashPx = strokeStyle === "dashed" ? [_wsw * 2.4, _wsw * 1.7]
                  : strokeStyle === "dotted" ? [0.1 * P, _wsw * 1.9]
                  : [];
    const _dashCap = strokeStyle === "dotted" ? "round" : "butt";
    // Path insets, mirroring buildShapeSvg exactly:
    //   rect / rounded-rect  inset by sw/2 REAL px per side  (SVG x = 50*sw/w units)
    //   circle / triangle    inset by sw/2 VIEWBOX units     (SVG `half`)
    const inR   = swPx / 2;
    const halfV = sw / 2;
    ctx.save();
    ctx.beginPath();
    switch (shapeType) {
      case "rect":
        ctx.rect(inR, inR, Math.max(0, dw - swPx), Math.max(0, dh - swPx));
        break;
      case "rounded-rect": {
        // cornerRadius is stored in viewBox % (0-50). SVG rx/ry in a stretched
        // viewBox give ELLIPTICAL corners, so scale each axis independently.
        const _crV = Math.max(0, Math.min(50, (cornerRadius !== undefined && cornerRadius !== null) ? cornerRadius : 12));
        _dmbRoundRectPath(ctx, inR, inR, Math.max(0, dw - swPx), Math.max(0, dh - swPx), _crV * SX, _crV * SY);
        break;
      }
      case "circle":
        ctx.ellipse(50 * SX, 50 * SY,
                    Math.max(0, 50 - halfV) * SX, Math.max(0, 50 - halfV) * SY,
                    0, 0, Math.PI * 2);
        break;
      case "triangle":
        ctx.moveTo(50 * SX, halfV * SY);
        ctx.lineTo((100 - halfV) * SX, (100 - halfV) * SY);
        ctx.lineTo(halfV * SX, (100 - halfV) * SY);
        ctx.closePath();
        break;
      case "star": {
        const starPts = [[50,2],[61.8,33.8],[95.6,35.2],[69,56.2],[78.2,88.8],[50,70],[21.8,88.8],[31,56.2],[4.4,35.2],[38.2,33.8]];
        ctx.moveTo(starPts[0][0] * SX, starPts[0][1] * SY);
        for (let i = 1; i < starPts.length; i++) ctx.lineTo(starPts[i][0] * SX, starPts[i][1] * SY);
        ctx.closePath();
        break;
      }
      case "heart":
        ctx.moveTo(50 * SX, 85 * SY);
        ctx.bezierCurveTo(20 * SX, 70 * SY, 5 * SX, 55 * SY, 5 * SX, 38 * SY);
        ctx.bezierCurveTo(5 * SX, 22 * SY, 16 * SX, 10 * SY, 28 * SX, 10 * SY);
        ctx.bezierCurveTo(36 * SX, 10 * SY, 44 * SX, 15 * SY, 50 * SX, 22 * SY);
        ctx.bezierCurveTo(56 * SX, 15 * SY, 64 * SX, 10 * SY, 72 * SX, 10 * SY);
        ctx.bezierCurveTo(84 * SX, 10 * SY, 95 * SX, 22 * SY, 95 * SX, 38 * SY);
        ctx.bezierCurveTo(95 * SX, 55 * SY, 80 * SX, 70 * SY, 50 * SX, 85 * SY);
        ctx.closePath();
        break;
      case "arrow": {
        const arrowPts = [[5,35],[60,35],[60,15],[95,50],[60,85],[60,65],[5,65]];
        ctx.moveTo(arrowPts[0][0] * SX, arrowPts[0][1] * SY);
        for (let i = 1; i < arrowPts.length; i++) ctx.lineTo(arrowPts[i][0] * SX, arrowPts[i][1] * SY);
        ctx.closePath();
        break;
      }
      case "pentagon": {
        const pentPts = [[50,2],[95.6,35.2],[78.2,88.8],[21.8,88.8],[4.4,35.2]];
        ctx.moveTo(pentPts[0][0] * SX, pentPts[0][1] * SY);
        for (let i = 1; i < pentPts.length; i++) ctx.lineTo(pentPts[i][0] * SX, pentPts[i][1] * SY);
        ctx.closePath();
        break;
      }
      case "hexagon": {
        const hexPts = [[98,50],[74,91.6],[26,91.6],[2,50],[26,8.4],[74,8.4]];
        ctx.moveTo(hexPts[0][0] * SX, hexPts[0][1] * SY);
        for (let i = 1; i < hexPts.length; i++) ctx.lineTo(hexPts[i][0] * SX, hexPts[i][1] * SY);
        ctx.closePath();
        break;
      }
      case "line":
      default:
        ctx.rect(0, 0, dw, dh);
        break;
    }
    // Only fill if not transparent — canvas ignores fillStyle="none" and renders
    // black instead, so we must skip ctx.fill() entirely for outline-only shapes.
    if (f !== "none" && f !== "transparent") {
      ctx.fillStyle = f;
      ctx.fill();
    }
    if (swPx > 0 && s !== "transparent") {
      ctx.strokeStyle = s;
      ctx.lineWidth   = swPx;
      // buildShapeSvg: miter on plain rect (sharp 90 corners), round everywhere else.
      ctx.lineJoin    = (shapeType === "rect") ? "miter" : "round";
      if (_dashPx.length && ctx.setLineDash) {
        ctx.setLineDash(_dashPx);
        ctx.lineCap = _dashCap;
      }
      ctx.stroke();
      if (ctx.setLineDash) ctx.setLineDash([]);
    }
    ctx.restore();
  }
  function dmbOpenShapeEditBar(obj, el) {
    _dmbLastBarShow = () => dmbOpenShapeEditBar(obj, el);
    // Fast path while dragging THIS already-selected shape: skip the heavy per-move
    // re-init — the bar is already open & docked. Just track the rotate handle.
    if (_dmbDragSuppress && dmbEditingShapeObj === obj && dmbEditingShapeEl === el && el.classList.contains("dmb-selected")) {
      _dmbTrackRotHandle(el); return;
    }
    // (drag no longer hides the shape edit bar — it stays open while moving/resizing)
    // Close other floating bars so only one is visible at a time
    hideTextToolbar();
    hideFrameToolbar();
    dmbCloseEditBar();

    // Deselect previously selected shape
    document.querySelectorAll(".dmb-shape-object.dmb-selected").forEach((m) => {
      if (m !== el) {
        m.classList.remove("dmb-selected");
        if (m._dmbRotHandle) m._dmbRotHandle.style.display = "none";
      }
    });

    dmbEditingShapeObj = obj;
    dmbEditingShapeEl  = el;
    el.classList.add("dmb-selected");
    if (el._dmbRotHandle) el._dmbRotHandle.style.display = "";

    const bar = document.getElementById("dmbShapeEditBar");
    if (!bar) return;
    initShapeEditBar(); // idempotent — only wires events once

    document.getElementById("dmbShapeFill").value    = obj.fill      || "#6366f1";
    document.getElementById("dmbShapeStroke").value  = obj.stroke    || "#000000";
    const _ssEl = document.getElementById("dmbShapeStrokeStyle");
    if (_ssEl) _ssEl.value = obj.strokeStyle || "solid";
    document.getElementById("dmbShapeStrokeW").value = obj.strokeWidth ?? 0;
    document.getElementById("dmbShapeStrokeWVal").textContent = obj.strokeWidth ?? 0;
    document.getElementById("dmbShapeOpacity").value  = obj.opacity ?? 1;
    document.getElementById("dmbShapeOpacityVal").textContent = Math.round((obj.opacity ?? 1) * 100) + "%";
    document.getElementById("dmbShapeRotation").value = Math.round(obj.rotation || 0);

    const _isLine = (obj.shapeType === "line");
    // Show thickness slider only for line shapes; hide for all others
    const thicknessWrap = document.getElementById("dmbShapeThicknessWrap");
    const thicknessInput = document.getElementById("dmbShapeThickness");
    const thicknessVal   = document.getElementById("dmbShapeThicknessVal");
    if (thicknessWrap && thicknessInput && thicknessVal) {
      if (_isLine) {
        _dmbLineMigrate(obj);
        thicknessWrap.style.display = "";
        thicknessInput.value = Math.round(obj.thickness || 8);
        thicknessVal.textContent = Math.round(obj.thickness || 8) + "px";
      } else {
        thicknessWrap.style.display = "none";
      }
    }

    // Line-type dropdown (Straight / Elbowed / Curved) — lines only.
    const _ltWrap = document.getElementById("dmbShapeLineTypeWrap");
    const _ltSel  = document.getElementById("dmbShapeLineType");
    if (_ltWrap) _ltWrap.style.display = _isLine ? "" : "none";
    if (_isLine && _ltSel) _ltSel.value = obj.lineType || "straight";

    // A line has no separate border / rotation controls — its colour is Fill and its
    // width is Thickness. Hide those so the bar only shows what applies.
    const _borderField = document.getElementById("dmbShapeBorderField");
    const _strokeWWrap = document.getElementById("dmbShapeStrokeWWrap");
    const _rotateWrap  = document.getElementById("dmbShapeRotateWrap");
    if (_borderField) _borderField.style.display = _isLine ? "none" : "";
    if (_strokeWWrap) _strokeWWrap.style.display = _isLine ? "none" : "";
    if (_rotateWrap)  _rotateWrap.style.display  = _isLine ? "none" : "";

    // Corner radius slider — only for rounded-rect
    const _crWrap  = document.getElementById("dmbShapeCornerRadiusWrap");
    const _crInput = document.getElementById("dmbShapeCornerRadius");
    const _crVal   = document.getElementById("dmbShapeCornerRadiusVal");
    if (_crWrap) {
      const _isRounded = obj.shapeType === "rounded-rect";
      _crWrap.style.display = _isRounded ? "" : "none";
      if (_isRounded && _crInput) {
        const _crCurrent = (obj.cornerRadius !== undefined && obj.cornerRadius !== null) ? obj.cornerRadius : 12;
        _crInput.value = _crCurrent;
        if (_crVal) _crVal.textContent = _crCurrent;
      }
    }

    // Outline-only toggle: hidden for lines (lines are fills by definition)
    const _outlineChk   = document.getElementById("dmbShapeOutlineOnly");
    const _fillLabelEl  = document.getElementById("dmbShapeFillLabel");
    if (_outlineChk) {
      const _isOutline = (obj.fill === "none" || obj.fill === "transparent");
      _outlineChk.checked = _isOutline;
      _outlineChk.closest("label").style.display = (obj.shapeType === "line") ? "none" : "";
      if (_fillLabelEl) _fillLabelEl.style.opacity = _isOutline ? "0.4" : "1";
    }
    try { _dmbSyncShapeDots(); } catch (e) {}

    // Update contain button text
    const _scBtn = document.getElementById("dmbShapeContainBtn");
    if (_scBtn) _scBtn.textContent = _dmbContainBtnText(obj, !!el.closest(".dmb-cover-preview"));

    bar.style.display = "block";
    _dmbDockBar(bar);
  }

  function dmbCloseShapeEditBar() {
    const bar = document.getElementById("dmbShapeEditBar");
    if (bar) bar.style.display = "none";
    if (dmbEditingShapeEl) {
      dmbEditingShapeEl.classList.remove("dmb-selected");
      if (dmbEditingShapeEl._dmbRotHandle) dmbEditingShapeEl._dmbRotHandle.style.display = "none";
    }
    dmbEditingShapeObj = null;
    dmbEditingShapeEl  = null;
    try { _dmbUpdateRibbonPlaceholder(); } catch (e) {}
  }

  function dmbApplyShapeEditBar() {
    if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
    const obj = dmbEditingShapeObj;

    // ── LINE: colour / opacity / dash / thickness / type; refresh in place ──────
    if (obj.shapeType === "line") {
      _dmbLineMigrate(obj);
      const _lf = document.getElementById("dmbShapeFill");
      if (_lf) obj.fill = _lf.value || "#6366f1";
      obj.strokeStyle = document.getElementById("dmbShapeStrokeStyle")?.value || "solid";
      const _lo = document.getElementById("dmbShapeOpacity");
      if (_lo) { obj.opacity = parseFloat(_lo.value); const _ov = document.getElementById("dmbShapeOpacityVal"); if (_ov) _ov.textContent = Math.round(obj.opacity * 100) + "%"; }
      const _lt = document.getElementById("dmbShapeLineType");
      if (_lt) obj.lineType = _lt.value || "straight";
      const _th = document.getElementById("dmbShapeThickness");
      if (_th) { obj.thickness = Math.max(1, parseFloat(_th.value) || 8); const _tv = document.getElementById("dmbShapeThicknessVal"); if (_tv) _tv.textContent = Math.round(obj.thickness) + "px"; }
      obj.rotation = 0;
      try { _dmbSyncShapeDots(); } catch (e) {}
      try { _dmbLineRefreshEl(obj, dmbEditingShapeEl); } catch (e) {}
      return;
    }

    const _isOutlineOnly = document.getElementById("dmbShapeOutlineOnly")?.checked || false;
    const _fillLbl       = document.getElementById("dmbShapeFillLabel");
    // When outline-only: set fill to "none" and dim the fill picker
    obj.fill = _isOutlineOnly ? "none" : (document.getElementById("dmbShapeFill").value || "#6366f1");
    if (_fillLbl) _fillLbl.style.opacity = _isOutlineOnly ? "0.4" : "1";
    obj.stroke      = document.getElementById("dmbShapeStroke").value;
    obj.strokeWidth = parseFloat(document.getElementById("dmbShapeStrokeW").value) || 0;
    obj.strokeStyle = document.getElementById("dmbShapeStrokeStyle")?.value || "solid";
    obj.opacity     = parseFloat(document.getElementById("dmbShapeOpacity").value);
    obj.rotation    = parseFloat(document.getElementById("dmbShapeRotation").value) || 0;
    // Auto-enable a default stroke when switching to outline-only with no stroke,
    // OR when picking a dashed/dotted border while the width is still 0 (so the
    // chosen style is actually visible).
    if ((_isOutlineOnly || obj.strokeStyle !== "solid") && obj.strokeWidth < 1) {
      obj.strokeWidth = 2;
      const _swEl = document.getElementById("dmbShapeStrokeW");
      if (_swEl) _swEl.value = 2;
    }
    document.getElementById("dmbShapeStrokeWVal").textContent = obj.strokeWidth;
    document.getElementById("dmbShapeOpacityVal").textContent = Math.round(obj.opacity * 100) + "%";
    try { _dmbSyncShapeDots(); } catch (e) {}

    // Corner radius — only for rounded-rect
    if (obj.shapeType === "rounded-rect") {
      const _crEl  = document.getElementById("dmbShapeCornerRadius");
      const _crValEl = document.getElementById("dmbShapeCornerRadiusVal");
      if (_crEl) {
        obj.cornerRadius = Math.max(0, Math.min(50, parseInt(_crEl.value) || 12));
        if (_crValEl) _crValEl.textContent = obj.cornerRadius;
      }
    }

    // Line thickness: changing h re-centers the line vertically around its old midpoint
    if (obj.shapeType === "line") {
      const thicknessInput = document.getElementById("dmbShapeThickness");
      const thicknessVal   = document.getElementById("dmbShapeThicknessVal");
      if (thicknessInput) {
        const newH = Math.max(1, parseFloat(thicknessInput.value) || 8);
        const oldCenterY = (obj.y || 0) + (obj.h || 8) / 2;
        obj.h = newH;
        obj.y = oldCenterY - newH / 2;          // keep line centred at same Y
        dmbEditingShapeEl.style.height = newH + "px";
        dmbEditingShapeEl.style.top    = obj.y + "px";
        if (thicknessVal) thicknessVal.textContent = newH + "px";
      }
    }

    // Update the live SVG inside the shape wrapper.
    // CRITICAL: do NOT use innerHTML = ... on shWrap — it destroys the 8 resize handle
    // divs that are siblings of the SVG. Replace only the SVG element in-place.
    const _shOldSvg = dmbEditingShapeEl.querySelector("svg");
    const _shTmp    = document.createElement("div");
    _shTmp.innerHTML = buildShapeSvg(obj.shapeType, obj.fill, obj.stroke, obj.strokeWidth, obj.opacity, obj.cornerRadius, obj.w, obj.h, obj.strokeStyle);
    const _shNewSvg  = _shTmp.firstElementChild;
    if (_shOldSvg && _shNewSvg) {
      _shOldSvg.replaceWith(_shNewSvg);
    } else if (_shNewSvg) {
      dmbEditingShapeEl.prepend(_shNewSvg); // no existing SVG — add it first
    }
    dmbEditingShapeEl.style.transform = `rotate(${obj.rotation}deg)`;
  }

  function initShapeEditBar() {
    if (_dmbShapeBarInit) return;
    _dmbShapeBarInit = true;

    // Wire all shape bar controls — including dmbShapeThickness for line shapes
    // and dmbShapeCornerRadius for rounded-rect
    ["dmbShapeFill","dmbShapeStroke","dmbShapeStrokeStyle","dmbShapeStrokeW","dmbShapeOpacity","dmbShapeRotation","dmbShapeThickness","dmbShapeCornerRadius","dmbShapeLineType"].forEach((id) => {
      document.getElementById(id)?.addEventListener("input",  dmbApplyShapeEditBar);
      document.getElementById(id)?.addEventListener("change", dmbApplyShapeEditBar);
    });
    // Outline-only checkbox fires on "change" only
    document.getElementById("dmbShapeOutlineOnly")?.addEventListener("change", dmbApplyShapeEditBar);

    // Colour-wheel palettes for Fill and Border (recent swatches + custom picker),
    // matching the text/frame toolbars.
    [["dmbShapeFillBtn","dmbShapeFillPop","dmbShapeFillCustom","dmbShapeFill","dmbShapeFillWrap"],
     ["dmbShapeStrokeBtn","dmbShapeStrokePop","dmbShapeStrokeCustom","dmbShapeStroke","dmbShapeStrokeWrap"]
    ].forEach(([btnId, popId, customId, inputId]) => {
      const btn = document.getElementById(btnId);
      const pop = document.getElementById(popId);
      const custom = document.getElementById(customId);
      const input = document.getElementById(inputId);
      if (btn && pop) {
        btn.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          const willOpen = pop.hidden;
          ["dmbShapeFillPop","dmbShapeStrokePop"].forEach((id) => { const p = document.getElementById(id); if (p && p !== pop) p.hidden = true; });
          pop.hidden = !willOpen;
        });
        pop.addEventListener("click", (e) => { if (e.target.closest(".dmb-recent-swatch")) pop.hidden = true; });
      }
      if (custom && input) {
        custom.addEventListener("click", (e) => { e.stopPropagation(); if (e.target === input) return; try { input.click(); } catch (e2) {} });   // identical to the background wheel — NO preventDefault (it cancels the native picker on iOS)
      }
      if (input && pop) {
        try { dmbEnhanceColorInput(input, pop); } catch (e) {}
        try { if (custom) pop.appendChild(custom); } catch (e) {}
        try { _dmbColorTapFix(custom, input); } catch (e) {}
        input.addEventListener("input", () => { try { _dmbSyncShapeDots(); } catch (e) {} });
        input.addEventListener("change", () => { pop.hidden = true; });
      }
    });
    // Outside-click closes the shape colour popups.
    document.addEventListener("click", (e) => {
      if (!e.target.closest("#dmbShapeFillWrap"))   { const p = document.getElementById("dmbShapeFillPop");   if (p) p.hidden = true; }
      if (!e.target.closest("#dmbShapeStrokeWrap")) { const p = document.getElementById("dmbShapeStrokePop"); if (p) p.hidden = true; }
    });

    document.getElementById("dmbShapeDone")?.addEventListener("click", dmbCloseShapeEditBar);

    // "More" dropdown (align, layer order, duplicate, contain, delete).
    const _shMoreToggle = document.getElementById("dmbShapeMoreToggle");
    const _shMoreMenu   = document.getElementById("dmbShapeMoreMenu");
    if (_shMoreToggle && _shMoreMenu) {
      _shMoreToggle.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        _shMoreMenu.hidden = !_shMoreMenu.hidden;
      });
      _shMoreMenu.addEventListener("click", (e) => {
        if (e.target.closest(".dmb-text-more-item")) _shMoreMenu.hidden = true;
      });
      document.addEventListener("click", (e) => {
        if (!e.target.closest("#dmbShapeMoreDD")) { const m = document.getElementById("dmbShapeMoreMenu"); if (m) m.hidden = true; }
      });
    }

    // Contain-to-page button
    document.getElementById("dmbShapeContainBtn")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
      const _isCover = !!dmbEditingShapeEl.closest(".dmb-cover-preview");
      _dmbContainCycle(dmbEditingShapeObj, dmbEditingShapeEl, _isCover);
    });

    document.getElementById("dmbShapeFrontBtn")?.addEventListener("click", () => {
      _dmbDoLayerStep(dmbEditingShapeEl, "forward");
    });

    document.getElementById("dmbShapeBackBtn")?.addEventListener("click", () => {
      _dmbDoLayerStep(dmbEditingShapeEl, "backward");
    });

    ["left","center","right"].forEach((align) => {
      const btnId = { left:"dmbShapeAlignLeft", center:"dmbShapeAlignCenter", right:"dmbShapeAlignRight" }[align];
      document.getElementById(btnId)?.addEventListener("click", () => {
        if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
        const tType = dmbEditingShapeEl.closest(".dmb-cover-preview") ? "cover" : "page";
        dmbAlignObjectInZone(dmbEditingShapeEl, dmbEditingShapeObj, align, tType);
        _dmbDockBar(document.getElementById("dmbShapeEditBar"));
      });
    });

    document.getElementById("dmbShapeDelete")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj) return;
      const objId = dmbEditingShapeObj.id;
      // Persist the deletion (+ make it undoable). Without this the deleted shape
      // reappeared on refresh — the saved copy still held it.
      pushUndoState("Delete Shape");
      if (editor.pageObjects) {
        Object.keys(editor.pageObjects).forEach((p) => {
          const arr = editor.pageObjects[p];
          if (Array.isArray(arr)) {
            const idx = arr.findIndex((o) => o.id === objId);
            if (idx !== -1) arr.splice(idx, 1);
          }
        });
      }
      if (Array.isArray(editor.coverObjects)) {
        const idx = editor.coverObjects.findIndex((o) => o.id === objId);
        if (idx !== -1) editor.coverObjects.splice(idx, 1);
      }
      if (dmbEditingShapeEl?._dmbRotHandle) dmbEditingShapeEl._dmbRotHandle.remove();
      dmbCloseShapeEditBar();
      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    });

    // Duplicate the selected shape into a brand-new, independent element (fresh id,
    // offset a touch, added to the SAME surface), then select the copy. Also the
    // target of Ctrl+D on a shape.
    document.getElementById("dmbShapeDuplicateBtn")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj) return;
      const src = dmbEditingShapeObj;
      const copy = { ...cloneState(src), id: uid(), x: (src.x || 0) + 20, y: (src.y || 0) + 20, z: Date.now() };
      // Lines carry endpoints — offset those too so the copy is shifted, not overlaid.
      if (copy.shapeType === "line" && copy.x1 != null) {
        copy.x1 += 20; copy.y1 += 20; copy.x2 += 20; copy.y2 += 20;
        if (copy.bx != null) { copy.bx += 20; copy.by += 20; }
      }
      let added = false;
      if (editor.pageObjects) {
        for (const p of Object.keys(editor.pageObjects)) {
          const arr = editor.pageObjects[p];
          if (Array.isArray(arr) && arr.some((o) => o.id === src.id)) { pushUndoState("Duplicate Shape"); arr.push(copy); added = true; break; }
        }
      }
      if (!added && Array.isArray(editor.coverObjects) && editor.coverObjects.some((o) => o.id === src.id)) {
        pushUndoState("Duplicate Shape"); editor.coverObjects.push(copy); added = true;
      }
      if (!added) return;
      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
      requestAnimationFrame(() => {
        const el = document.querySelector('[data-object-id="' + copy.id + '"]');
        if (el) { try { dmbOpenShapeEditBar(copy, el); } catch (e) {} }
      });
    });

    // Close when clicking outside both the bar and any shape object
    document.addEventListener("pointerdown", (e) => {
      if (!dmbEditingShapeObj) return;
      const bar = document.getElementById("dmbShapeEditBar");
      if (bar && bar.contains(e.target))            return; // inside bar
      if (e.target.closest(".dmb-stage-header"))    return; // anywhere in the fixed ribbon
      if (e.target.closest("#dmbMshRibbon"))        return; // mobile ribbon (idle + docked bars)
      if (e.target.closest("#dmbMshColorSheet"))    return; // mobile body colour sheet — keep the shape selected
      if (e.target.closest(".dmb-shape-object"))    return; // on a shape
      if (e.target.closest(".dmb-frame-handle"))    return; // resize handle
      dmbCloseShapeEditBar();
    }, { capture: true });
  }

  // Insert a new shape object into the currently active page/cover.
  // WARNING: Do NOT use a bare `currentPage` variable — it is not defined.
  // Use the same spread/side logic as addDefaultText and map insertion:
  //   - cover mode  → editor.coverObjects
  //   - spread -1   → page 0
  //   - otherwise   → derived from editor.currentSpread + lastToolbarSide
  function insertShapeIntoActivePage(shapeType) {
    const isCover = (builderMode === "cover");
    let pn = null;
    if (!isCover) {
      if (editor.currentSpread === -1) {
        pn = 0;
      } else {
        const _lp = editor.currentSpread * 2 + 1;
        const _rp = _lp + 1;
        if (lastToolbarSide === "right" && _rp <= editor.totalPages && !isLockedPage(_rp)) {
          pn = _rp;
        } else if (_lp <= editor.totalPages && !isLockedPage(_lp)) {
          pn = _lp;
        } else if (_rp <= editor.totalPages && !isLockedPage(_rp)) {
          pn = _rp;
        }
      }
    }
    // Abort silently if there is no valid target page (locked / out of range)
    if (!isCover && pn === null) return;

    const isLine  = shapeType === "line";
    const shapeObj = {
      id:          _dmbOid("shape_"),
      type:        "shape",
      shapeType:   shapeType,
      x:           60,
      y:           60,
      w:           isLine ? 160 : 120,
      h:           isLine ?   8 : 120,
      fill:        "#6366f1",
      stroke:      "#000000",
      strokeWidth: 0,
      strokeStyle: "solid",
      opacity:     1,
      rotation:    0,
      z:           _dmbNextTopZ(isCover ? "cover" : pn),
    };
    pushUndoState("Add Shape");
    if (isCover) {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      _dmbPlaceOnActiveCoverFace(shapeObj, 60, 60);   // land on the SELECTED face
      editor.coverObjects.push(shapeObj);
      renderCoverCanvas();
    } else {
      if (!editor.pageObjects) editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
      editor.pageObjects[pn].push(shapeObj);
      renderBuilderCanvas();
    }
  }

  function initMapTools() {
    initMapModal();
    initMapEditBar();

    const addMyMapBtn = document.getElementById("addMyMapBtn");
    const markStayBtn = document.getElementById("markStayBtn");
    const markerPickerMenu = document.getElementById("markerPickerMenu");

    if (addMyMapBtn && !addMyMapBtn.dataset.boundMapClick) {
      addMyMapBtn.dataset.boundMapClick = "true";
      addMyMapBtn.addEventListener("click", () => {
        dmbOpenMapModal();
      });
    }

    if (markStayBtn && !markStayBtn.dataset.boundMarkerClick) {
      markStayBtn.dataset.boundMarkerClick = "true";
      markStayBtn.addEventListener("click", () => {
        if (!currentInsertedMap) return;
        if (!markerPickerMenu) return;
        if (markerPickerMenu.style.display === "block") {
          markerPickerMenu.style.display = "none";
        } else {
          const rect = markStayBtn.getBoundingClientRect();
          markerPickerMenu.style.top = (rect.bottom + 4) + "px";
          markerPickerMenu.style.left = rect.left + "px";
          markerPickerMenu.style.width = rect.width + "px";
          markerPickerMenu.style.display = "block";
        }
      });
    }

    if (markerPickerMenu && !markerPickerMenu.dataset.boundMarkerMenu) {
      markerPickerMenu.dataset.boundMarkerMenu = "true";
      markerPickerMenu.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-marker-type]");
        if (!btn) return;
        activeMarkerType = btn.dataset.markerType;
        pendingMapMarkerPlacement = true;
        markerPickerMenu.style.display = "none";
      });
    }
  }

  function initStickerLibrary() {
    const btn = document.getElementById("dmbBrowseStickersBtn");
    if (!btn || btn.dataset.boundStickerLib) return;
    btn.dataset.boundStickerLib = "true";

    let stickerData = [];
    let selectedStickerUrl = null;
    let selectedStickerName = null;

    const _stickerUrl = (window.DMB_MAGAZINE_MODE && window.DMB_SELECTED_MAGAZINE_STYLE?.stickersUrl)
      ? window.DMB_SELECTED_MAGAZINE_STYLE.stickersUrl
      : (window.DMB_STICKERS_JSON_URL || "");
    fetch(_stickerUrl)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => { stickerData = Array.isArray(data) ? data : []; })
      .catch(() => { stickerData = []; });

    const modal = document.getElementById("dmbStickerModal");
    const grid = document.getElementById("dmbStickerGrid");
    const search = document.getElementById("dmbStickerSearch");
    const insertBtn = document.getElementById("dmbStickerInsertBtn");
    const closeBtn = document.getElementById("dmbStickerCloseBtn");
    const cancelBtn = document.getElementById("dmbStickerCancelBtn");

    function closeModal() { if (modal) modal.style.display = "none"; }

    function renderGrid(filter) {
      if (!grid) return;
      const q = (filter || "").toLowerCase().trim();
      const items = q ? stickerData.filter((s) => s.name.toLowerCase().includes(q)) : stickerData;
      grid.innerHTML = "";
      selectedStickerUrl = null;
      selectedStickerName = null;
      if (insertBtn) insertBtn.disabled = true;

      if (items.length === 0) {
        grid.innerHTML =
          stickerData.length === 0
            ? '<p style="grid-column:1/-1;text-align:center;color:#888;padding:24px 0;">No stickers uploaded yet.<br><small>Upload PNG images to Shopify Files and add them to custom-stickers.json</small></p>'
            : '<p style="grid-column:1/-1;text-align:center;color:#888;">No stickers match your search.</p>';
        return;
      }

      items.forEach((sticker) => {
        const cell = document.createElement("div");
        cell.style.cssText =
          "border:2px solid transparent;border-radius:8px;padding:8px 6px;cursor:pointer;text-align:center;background:#f7f7f7;transition:border-color .15s;";

        const img = document.createElement("img");
        img.loading = "lazy";      // phones can't keep a whole collection of full-size
        img.decoding = "async";    // PNGs decoded at once → many render blank; defer offscreen
        img.src = sticker.url;
        img.alt = sticker.name;
        img.style.cssText =
          "width:80px;height:80px;object-fit:contain;display:block;margin:0 auto 6px;";

        const label = document.createElement("div");
        label.textContent = sticker.name;
        label.style.cssText =
          "font-size:11px;color:#555;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;";

        cell.appendChild(img);
        cell.appendChild(label);

        cell.addEventListener("click", () => {
          grid.querySelectorAll("[data-sticker-selected]").forEach((c) => {
            c.style.borderColor = "transparent";
            delete c.dataset.stickerSelected;
          });
          cell.style.borderColor = "#4a90e2";
          cell.dataset.stickerSelected = "true";
          selectedStickerUrl = sticker.url;
          selectedStickerName = sticker.name;
          if (insertBtn) insertBtn.disabled = false;
        });

        grid.appendChild(cell);
      });
    }

    btn.addEventListener("click", () => {
      if (!modal) return;
      renderGrid("");
      if (search) search.value = "";
      modal.style.display = "flex";
    });

    closeBtn?.addEventListener("click", closeModal);
    cancelBtn?.addEventListener("click", closeModal);
    modal?.addEventListener("click", (e) => { if (e.target === modal) closeModal(); });
    search?.addEventListener("input", () => renderGrid(search.value));

    insertBtn?.addEventListener("click", () => {
      if (!selectedStickerUrl) return;
      const pageNumber = getActivePageNumberForMap();
      if (pageNumber == null) { closeModal(); return; }
      const isCover = pageNumber === "cover";
      const url = selectedStickerUrl;
      const name = selectedStickerName || "Sticker";
      closeModal();

      const tempImg = new Image();
      tempImg.crossOrigin = "anonymous";
      let _libStickerDone = false;
      tempImg.onload = () => {
        if (_libStickerDone) return; _libStickerDone = true;
        const origW = tempImg.naturalWidth || 100;
        const origH = tempImg.naturalHeight || 100;

        // Find tight bounding box of non-transparent pixels and crop to it
        let cropX = 0, cropY = 0, cropW = origW, cropH = origH;
        let tightUrl = null;
        try {
          const ofc = document.createElement("canvas");
          ofc.width = origW; ofc.height = origH;
          const ofCtx = ofc.getContext("2d");
          ofCtx.drawImage(tempImg, 0, 0);
          const px = ofCtx.getImageData(0, 0, origW, origH).data;
          let minX = origW, minY = origH, maxX = 0, maxY = 0;
          for (let y = 0; y < origH; y++) {
            for (let x = 0; x < origW; x++) {
              if (px[(y * origW + x) * 4 + 3] > 10) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX >= minX && maxY >= minY) {
            cropX = minX; cropY = minY;
            cropW = maxX - minX + 1; cropH = maxY - minY + 1;
          }
          // Export the cropped area as a data URL so the img element needs no offset tricks
          const cropCanvas = document.createElement("canvas");
          cropCanvas.width = cropW; cropCanvas.height = cropH;
          cropCanvas.getContext("2d").drawImage(ofc, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
          tightUrl = cropCanvas.toDataURL("image/png");
        } catch(e) { /* CORS fallback — use original URL */ }

        const MAX = 150;
        let w = cropW, h = cropH;
        if (w > MAX || h > MAX) {
          const scale = MAX / Math.max(w, h);
          w = Math.round(w * scale);
          h = Math.round(h * scale);
        }
        const stickerObj = {
          id: _dmbOid("sticker_"),
          type: "sticker",
          name,
          url,
          tightUrl,
          x: 20,
          y: 20,
          w,
          h,
          z: _dmbNextTopZ(isCover ? "cover" : pageNumber),
          rotation: 0,
          cropX,
          cropY,
          cropW,
          cropH,
          cropRefW: origW,   // size the crop was measured on - see _dmbStickerCropFor
          cropRefH: origH,
        };
        pushUndoState("Insert Sticker");
        if (isCover) {
          if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
          _dmbPlaceOnActiveCoverFace(stickerObj, 20, 20);   // land on the SELECTED face
          editor.coverObjects.push(stickerObj);
        } else {
          if (!editor.pageObjects) editor.pageObjects = {};
          if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
          editor.pageObjects[pageNumber].push(stickerObj);
        }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.onerror = () => {
        if (_libStickerDone) return; _libStickerDone = true;
        // fallback to 100x100 if image can't be measured
        const stickerObj = {
          id: _dmbOid("sticker_"),
          type: "sticker",
          name,
          url,
          x: 20,
          y: 20,
          w: 100,
          h: 100,
          z: _dmbNextTopZ(isCover ? "cover" : pageNumber),
          rotation: 0,
        };
        pushUndoState("Insert Sticker");
        if (isCover) {
          if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
          _dmbPlaceOnActiveCoverFace(stickerObj, 20, 20);   // land on the SELECTED face
          editor.coverObjects.push(stickerObj);
        } else {
          if (!editor.pageObjects) editor.pageObjects = {};
          if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
          editor.pageObjects[pageNumber].push(stickerObj);
        }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.src = url;
    });
  }

  function _commitMagIconObj(obj) {
    pushUndoState("Insert Icon");
    const pageNumber = getActivePageNumberForMap();
    if (pageNumber === "cover") {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      _dmbPlaceOnActiveCoverFace(obj, 20, 20);   // land on the SELECTED face
      editor.coverObjects.push(obj);
      renderCoverCanvas();
    } else {
      const pn = pageNumber;
      if (!editor.pageObjects) editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
      editor.pageObjects[pn].push(obj);
      if (typeof renderSpread === "function") renderSpread();
    }
    if (typeof renderThumbsRail === "function") renderThumbsRail();
  }

  function insertMagIcon(iconId, color) {
    const base = (window.DMB_ASSET_BASE || "").replace(/\/[^/]+$/, "/");
    const ic = DMB_MAG_ICONS.find((i) => i.id === iconId);
    if (!ic) return;
    const url = base + ic.file;
    const img = new Image();
    img.crossOrigin = "anonymous";
    let _magIconDone = false;
    img.onload = () => {
      if (_magIconDone) return; _magIconDone = true;
      const naturalW = img.naturalWidth || 300;
      const naturalH = img.naturalHeight || 120;
      const MAX = 250;
      let w = naturalW, h = naturalH;
      if (w > MAX) { h = Math.round(h * MAX / w); w = MAX; }
      if (h > MAX) { w = Math.round(w * MAX / h); h = MAX; }
      _commitMagIconObj({ id: _dmbOid("mag-icon_"), type: "mag-icon", iconId, color: color || "#000000", x: 20, y: 20, w, h, naturalW, naturalH, z: Date.now(), rotation: 0 });
    };
    img.onerror = () => {
      if (_magIconDone) return; _magIconDone = true;
      _commitMagIconObj({ id: _dmbOid("mag-icon_"), type: "mag-icon", iconId, color: color || "#000000", x: 20, y: 20, w: 200, h: 80, naturalW: 200, naturalH: 80, z: Date.now(), rotation: 0 });
    };
    img.src = url;
  }

  function initMagIconPanel() {
    const modal = document.getElementById("dmbMagIconModal");
    const closeBtn = document.getElementById("dmbMagIconModalClose");
    const colorInput = document.getElementById("dmbMagIconModalColor");
    const grid = document.getElementById("dmbMagIconModalGrid");
    if (!modal) return;
    if (modal.dataset.boundMagIcon) return;
    modal.dataset.boundMagIcon = "true";

    // Open modal
    document.getElementById("dmbMagIconsBtn")?.addEventListener("click", () => {
      modal.style.display = "flex";
    });

    // Close modal
    closeBtn?.addEventListener("click", () => { modal.style.display = "none"; });
    modal.addEventListener("click", (e) => { if (e.target === modal) modal.style.display = "none"; });

    // Insert icon on click
    grid?.addEventListener("click", (e) => {
      const btn = e.target.closest(".dmb-mag-icon-pick-btn");
      if (!btn) return;
      insertMagIcon(btn.dataset.iconId, colorInput ? colorInput.value : "#000000");
      modal.style.display = "none";
    });
  }

  function initCustomStickersPanel() {
    const modal = document.getElementById("dmbCustomStickerModal");
    const closeBtn = document.getElementById("dmbCustomStickerModalClose");
    const grid = document.getElementById("dmbCustomStickerModalGrid");
    if (!modal) return;
    if (modal.dataset.boundCustomStickers) return;
    modal.dataset.boundCustomStickers = "true";

    document.getElementById("dmbStickersBtn")?.addEventListener("click", () => {
      modal.style.display = "flex";
    });

    closeBtn?.addEventListener("click", () => { modal.style.display = "none"; });
    modal.addEventListener("click", (e) => { if (e.target === modal) modal.style.display = "none"; });

    grid?.addEventListener("click", (e) => {
      const btn = e.target.closest(".dmb-mag-icon-pick-btn");
      if (!btn) return;
      const url = btn.dataset.stickerUrl;
      const name = btn.dataset.stickerName || "Sticker";
      modal.style.display = "none";

      const pageNumber = getActivePageNumberForMap();
      if (pageNumber == null) return;
      const isCover = pageNumber === "cover";

      const tempImg = new Image();
      tempImg.crossOrigin = "anonymous";
      let _stickerDone = false;
      tempImg.onload = () => {
        if (_stickerDone) return; _stickerDone = true;
        const origW = tempImg.naturalWidth || 100;
        const origH = tempImg.naturalHeight || 100;
        let cropX = 0, cropY = 0, cropW = origW, cropH = origH, tightUrl = null;
        try {
          const ofc = document.createElement("canvas");
          ofc.width = origW; ofc.height = origH;
          const ofCtx = ofc.getContext("2d");
          ofCtx.drawImage(tempImg, 0, 0);
          const px = ofCtx.getImageData(0, 0, origW, origH).data;
          let minX = origW, minY = origH, maxX = 0, maxY = 0;
          for (let y = 0; y < origH; y++) {
            for (let x = 0; x < origW; x++) {
              if (px[(y * origW + x) * 4 + 3] > 10) {
                if (x < minX) minX = x; if (x > maxX) maxX = x;
                if (y < minY) minY = y; if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX >= minX && maxY >= minY) { cropX = minX; cropY = minY; cropW = maxX - minX + 1; cropH = maxY - minY + 1; }
          const cc = document.createElement("canvas"); cc.width = cropW; cc.height = cropH;
          cc.getContext("2d").drawImage(ofc, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
          tightUrl = cc.toDataURL("image/png");
        } catch(e) {}
        const MAX = 150;
        let w = cropW, h = cropH;
        if (w > MAX || h > MAX) { const s = MAX / Math.max(w, h); w = Math.round(w * s); h = Math.round(h * s); }
        const obj = { id: _dmbOid("sticker_"), type: "sticker", name, url, tightUrl, x: 20, y: 20, w, h, z: Date.now(), rotation: 0, cropX, cropY, cropW, cropH, cropRefW: origW, cropRefH: origH };
        pushUndoState("Insert Sticker");
        if (isCover) { if (!Array.isArray(editor.coverObjects)) editor.coverObjects = []; _dmbPlaceOnActiveCoverFace(obj, 20, 20); editor.coverObjects.push(obj); }
        else { if (!editor.pageObjects) editor.pageObjects = {}; if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = []; editor.pageObjects[pageNumber].push(obj); }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.onerror = () => {
        if (_stickerDone) return; _stickerDone = true;
        const obj = { id: _dmbOid("sticker_"), type: "sticker", name, url, x: 20, y: 20, w: 100, h: 100, z: Date.now(), rotation: 0 };
        pushUndoState("Insert Sticker");
        if (isCover) { if (!Array.isArray(editor.coverObjects)) editor.coverObjects = []; _dmbPlaceOnActiveCoverFace(obj, 20, 20); editor.coverObjects.push(obj); }
        else { if (!editor.pageObjects) editor.pageObjects = {}; if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = []; editor.pageObjects[pageNumber].push(obj); }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.src = url;
    });
  }

  function initPhoneUpload() {
    ["importPhoneBtn", "step1bPhoneBtn"].forEach((id) => {
      const btn = document.getElementById(id);
      if (!btn || btn.dataset.boundPhone) return;
      btn.dataset.boundPhone = "true";
      btn.addEventListener("click", () => {
        const m = document.getElementById("photoImportMenu");   // close the "+ Add" sheet behind the modal
        if (m) m.style.display = "none";
        openPhoneUploadModal();
      });
    });
  }

  // Shows the customer's supplied QR image (theme asset dmb-phone-qr.png) in the
  // popup, served from Shopify's own CDN via dmbGetAssetUrl (the same reliable asset
  // path the country maps use).
  function _dmbRenderPhoneQR() {
    const box = document.getElementById("dmbPhoneQR");
    if (!box) return;
    let src = "dmb-phone-qr.png";
    try { src = dmbGetAssetUrl("dmb-phone-qr.png"); } catch (e) {}
    box.innerHTML = '<img src="' + src + '" alt="Scan to upload from phone" style="width:100%;height:100%;object-fit:contain;display:block;">';
  }

  function openPhoneUploadModal() {
    {
      // R2 RELAY (replaces the old PeerJS direct WebRTC link, which silently
      // failed on cellular↔Wi-Fi — no TURN server — while the phone showed
      // "Sent"). The phone uploads each photo to the shared session folder on
      // R2; we poll it here and pull new photos down. 6-digit code so parallel
      // customers can't collide.
      const sessionId = String(Math.floor(100000 + Math.random() * 900000));
      const uploadUrl = window.location.origin + "/pages/phone-upload?s=" + sessionId;
      const qrSrc = null; // QR generated via qrcode.js into canvas

      let modal = document.getElementById("dmbPhoneUploadModal");
      if (!modal) {
        modal = document.createElement("div");
        modal.id = "dmbPhoneUploadModal";
        modal.style.cssText =
          "position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;";
        modal.innerHTML = [
          '<div style="background:#fff;border-radius:16px;padding:28px 24px;max-width:360px;width:92vw;text-align:center;position:relative;">',
          '<button id="dmbPhoneModalClose" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;line-height:1;">&#x2715;</button>',
          '<h3 style="margin:0 0 6px;font-size:17px;">Upload from Phone</h3>',
          '<p style="margin:0 0 14px;color:#666;font-size:13px;">1. Scan the QR code with your phone camera (or open ' + window.location.host + '/pages/phone-upload)<br>2. Enter the session code below when asked</p>',
          '<div id="dmbPhoneQR" style="width:200px;height:200px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;border-radius:8px;border:1px solid #eee;overflow:hidden;"></div>',
          '<div style="background:#f5f5f5;border-radius:12px;padding:12px 20px;margin-bottom:16px;">',
          '<div style="font-size:11px;color:#999;margin-bottom:4px;letter-spacing:1px;text-transform:uppercase;">Your session code</div>',
          '<div id="dmbPhoneCode" style="font-size:38px;font-weight:900;letter-spacing:6px;color:#111;"></div>',
          '</div>',
          '<div id="dmbPhoneStatus" style="font-size:14px;color:#999;padding:4px 0;">Waiting for phone to connect\u2026</div>',
          '<div id="dmbPhoneCount" style="font-size:13px;color:#2e7d32;margin-top:6px;display:none;"></div>',
          '</div>',
        ].join("");
        document.body.appendChild(modal);
        modal.addEventListener("click", (e) => { if (e.target === modal) closeModal(); });
      }

      const statusEl = document.getElementById("dmbPhoneStatus");
      const countEl  = document.getElementById("dmbPhoneCount");
      const codeEl   = document.getElementById("dmbPhoneCode");
      const closeBtn = document.getElementById("dmbPhoneModalClose");

      codeEl.textContent = sessionId;
      statusEl.textContent = "Waiting for phone to connect\u2026";
      statusEl.style.color = "#999";
      countEl.style.display = "none";
      countEl.textContent = "";
      modal.style.display = "flex";
      _dmbRenderPhoneQR(uploadUrl);   // regenerate for THIS session's code

      let receivedCount = 0;
      let phoneSeen = false;
      const PROXY = window.DMB_DESIGNS_PROXY || "/apps/designs";
      const sessQ = "id=session&sid=" + encodeURIComponent("pu" + sessionId) + "&asg=1";
      const seenPids = new Set(["hello", "phone-hello"]);
      let fetching = false;
      // Timers live on window so a stale closeModal closure (the backdrop-click
      // listener is bound once, at modal creation) still stops the CURRENT poll.
      clearInterval(window._dmbPuPoll); clearInterval(window._dmbPuSlow);

      // Open the session: write the "hello" marker the phone validates against.
      try {
        fetch(PROXY + "/photo?" + sessQ + "&pid=hello", {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ ts: Date.now() }), credentials: "same-origin",
        });
      } catch (e) {}

      async function injectFile(file) {
        // Inject into step1b if builder not open yet, otherwise into builder tray
        const step1bEl = document.getElementById("step1b");
        if (step1bEl && step1bEl.style.display !== "none") {
          const input = document.getElementById("step1bFileInput");
          if (input && typeof DataTransfer !== "undefined") {
            const dt = new DataTransfer();
            for (const f of (input.files || [])) dt.items.add(f);
            dt.items.add(file);
            input.files = dt.files;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
        // ── Derive HERE, because this branch bypasses compressFilesForMobile ──
        // The step1b branch above dispatches a change event, which routes through
        // compressFilesForMobile and produces the 2500px editing proxy + the print
        // master. THIS branch (builder already open) went straight into bookFiles,
        // so a relay photo arrived as a raw original with no master at all - which
        // is exactly why a book built by adding photos from the phone mid-session
        // reported "0 of N photos at full print quality".
        //
        // Awaited on purpose: the derivation decodes one image at a time, and the
        // relay delivers photos one at a time, so this keeps the whole path to a
        // single decode in flight - the same memory envelope as any other import.
        // (2026-09-14)
        let _f = file;
        if (typeof _dmbPrintMasterOn === "function" && _dmbPrintMasterOn()) {
          try { _f = (await compressFilesForMobile([file]))[0] || file; } catch (e2) {}
        }
        bookFiles = mergeFilesKeepOld(bookFiles, [_f]);
        validatePhotos();
        // renderPhotoTray() alone was NOT enough and was the bug: the tray draws
        // from editor.photos, and NOTHING here rebuilt that from the new
        // bookFiles. So a phone-relay photo bumped the "N photos selected"
        // counter (which reads bookFiles) and the tray redrew the OLD list -
        // the photo only appeared later, when some other action happened to call
        // refreshBuilderPhotos(). Adding one photo from the device made every
        // waiting relay photo pop in at once, which is exactly what was reported.
        //
        // refreshBuilderPhotos() is the only bridge bookFiles -> editor.photos.
        // Debounced because the relay delivers photos one at a time: a burst of
        // arrivals collapses into a single rebuild instead of one per photo.
        try { _dmbWarmMeta(_f); } catch (e2) {}        // start its decode now
        try {
          clearTimeout(injectFile._t);
          injectFile._t = setTimeout(function () {
            try { refreshBuilderPhotos(); } catch (e3) {}
          }, 200);
        } catch (e4) { try { refreshBuilderPhotos(); } catch (e5) {} }
      }

      async function pollOnce() {
        if (fetching) return;
        fetching = true;
        // Re-assert the "hello" marker each poll (until the phone is seen) so a phone
        // that scans a moment early — or after the first write hiccuped — still finds
        // the session while it retries for ~15s.
        if (!phoneSeen) {
          try {
            fetch(PROXY + "/photo?" + sessQ + "&pid=hello", {
              method: "POST", headers: { "content-type": "application/json" },
              body: JSON.stringify({ ts: Date.now() }), credentials: "same-origin",
            });
          } catch (e) {}
        }
        try {
          const r = await fetch(PROXY + "/photos?" + sessQ, { credentials: "same-origin" });
          if (!r.ok) return;
          const d = await r.json();
          const list = (d && d.photos) || [];
          // Phone announces itself with a marker so we can show "connected".
          if (!phoneSeen && list.some((p) => p.pid === "phone-hello")) {
            phoneSeen = true;
            statusEl.textContent = "\uD83D\uDCF1 Phone connected! Select photos on your phone.";
            statusEl.style.color = "#2e7d32";
          }
          for (const p of list) {
            if (!p || !p.pid || seenPids.has(p.pid)) continue;
            seenPids.add(p.pid);
            try {
              const pr = await fetch(PROXY + "/photo?" + sessQ + "&pid=" + encodeURIComponent(p.pid), { credentials: "same-origin" });
              if (!pr.ok) { seenPids.delete(p.pid); continue; }   // retry next poll
              const blob = await pr.blob();
              if (!blob || !blob.size) { seenPids.delete(p.pid); continue; }
              // Filename travels inside the pid (after "__").
              const name = decodeURIComponent((p.pid.split("__")[1] || ("phone-" + Date.now() + ".jpg")));
              const file = new File([blob], name, { type: blob.type || "image/jpeg", lastModified: Date.now() });
              // QR-relay photos already live on R2 at phone resolution — mark them
              // so the print-master pipeline doesn't try to derive a master (which
              // would just re-encode the same bytes). They stay proxy-only.
              try { file._dmbRelay = true; } catch (e2) {}
              await injectFile(file);
              receivedCount++;
              countEl.style.display = "block";
              countEl.textContent = receivedCount + " photo" + (receivedCount > 1 ? "s" : "") + " received \u2713";
            } catch (e) { seenPids.delete(p.pid); }
          }
        } catch (e) {} finally { fetching = false; }
      }

      window._dmbPuPoll = setInterval(pollOnce, 2500);
      pollOnce();

      function closeModal() {
        modal.style.display = "none";
        clearInterval(window._dmbPuPoll); window._dmbPuPoll = null;
        // Keep a slow background poll for 5 more minutes \u2014 photos the phone is
        // still sending after the popup closes must not be lost.
        clearInterval(window._dmbPuSlow);
        window._dmbPuSlow = setInterval(pollOnce, 6000);
        setTimeout(() => { clearInterval(window._dmbPuSlow); }, 5 * 60 * 1000);
      }

      closeBtn.onclick = closeModal;
    }
  }

  function enableMapMarkerPlacement() {
    document.addEventListener("click", function(e) {
      if (!pendingMapMarkerPlacement || !activeMarkerType) return;

      const mapObject = e.target.closest(".dmb-map-object");
      if (!mapObject) return;

      const svg = mapObject.querySelector("svg");
      if (!svg) return;

      const svgRect = svg.getBoundingClientRect();
      const x = ((e.clientX - svgRect.left) / svgRect.width) * 100;
      const y = ((e.clientY - svgRect.top) / svgRect.height) * 100;

      if (!Array.isArray(currentInsertedMap.markers)) {
        currentInsertedMap.markers = [];
      }

      currentInsertedMap.markers.push({
        type: activeMarkerType,
        x,
        y
      });

      pendingMapMarkerPlacement = false;

      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
      if (typeof renderThumbsRail === "function") renderThumbsRail();
    });
  }

  function dmbCropSvgToContent(svgMarkup) {
    // Returns { svg: croppedMarkup, aspect: width/height }
    // Crops the SVG viewBox to tightly fit actual path content so the frame matches the visible map.
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return { svg: svgMarkup, aspect: 1 };

      const host = document.createElement("div");
      host.style.cssText = "position:fixed;left:-9999px;top:-9999px;visibility:hidden;width:1px;height:1px;overflow:visible;";
      document.body.appendChild(host);
      const svgClone = svg.cloneNode(true);
      svgClone.setAttribute("width", "1000");
      svgClone.setAttribute("height", "1000");
      host.appendChild(svgClone);

      const elements = Array.from(svgClone.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      elements.forEach(function(el) {
        try {
          const b = el.getBBox();
          if (b.width > 0 || b.height > 0) {
            minX = Math.min(minX, b.x);
            minY = Math.min(minY, b.y);
            maxX = Math.max(maxX, b.x + b.width);
            maxY = Math.max(maxY, b.y + b.height);
          }
        } catch(e2) {}
      });
      document.body.removeChild(host);

      if (!isFinite(minX) || maxX <= minX || maxY <= minY) {
        return { svg: svgMarkup, aspect: 1 };
      }

      const pad = (maxX - minX) * 0.02; // 2% padding each side
      const nx = minX - pad, ny = minY - pad;
      const nw = maxX - minX + pad * 2;
      const nh = maxY - minY + pad * 2;

      svg.setAttribute("viewBox", `${nx} ${ny} ${nw} ${nh}`);
      svg.removeAttribute("width");
      svg.removeAttribute("height");

      return { svg: new XMLSerializer().serializeToString(svg), aspect: nw / nh };
    } catch(e) { return { svg: svgMarkup, aspect: 1 }; }
  }

  function dmbFindIslandPaths(svgMarkup) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return [];
      const vb = svg.getAttribute("viewBox");
      let vbW = 100;
      if (vb) { const parts = vb.trim().split(/[\s,]+/); vbW = parseFloat(parts[2]) || 100; }
      const threshold = Math.max(5, 14 * vbW / 270);
      const host = document.createElement("div");
      host.style.cssText = "position:fixed;left:-9999px;top:-9999px;visibility:hidden;width:1px;height:1px;overflow:visible;";
      document.body.appendChild(host);
      const svgClone = svg.cloneNode(true);
      svgClone.setAttribute("width", "500"); svgClone.setAttribute("height", "500");
      host.appendChild(svgClone);
      const elements = Array.from(svgClone.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      const boxes = elements.map(el => { try { return el.getBBox(); } catch(e) { return null; } });
      document.body.removeChild(host);
      if (elements.length < 2) return [];
      const islands = [];
      boxes.forEach((b, i) => {
        if (!b || b.width === 0 && b.height === 0) return;
        let minDist = Infinity;
        boxes.forEach((b2, j) => {
          if (i === j || !b2) return;
          const dx = Math.max(0, Math.max(b.x, b2.x) - Math.min(b.x + b.width, b2.x + b2.width));
          const dy = Math.max(0, Math.max(b.y, b2.y) - Math.min(b.y + b.height, b2.y + b2.height));
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < minDist) minDist = dist;
        });
        if (minDist > threshold) islands.push({ index: i });
      });
      return islands;
    } catch (e) { return []; }
  }

  function dmbRemoveIslandPaths(svgMarkup, islandIndices) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return svgMarkup;
      const elements = Array.from(svg.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      islandIndices.map(i => i.index).sort((a, b) => b - a).forEach(idx => {
        const el = elements[idx];
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      return new XMLSerializer().serializeToString(svg);
    } catch (e) { return svgMarkup; }
  }

  function insertMapIntoActivePage(svgMarkup, mapKey, styles, forcedPage) {
    const pageNumber = (forcedPage !== undefined && forcedPage !== null)
      ? forcedPage : getActivePageNumberForMap();
    if (pageNumber == null) return;

    const isCover = pageNumber === "cover";
    const s = styles || {};
    const mapId = _dmbOid("map_");

    // Crop SVG viewBox to actual content bounds so frame matches visible map exactly
    const cropped = dmbCropSvgToContent(svgMarkup);
    svgMarkup = cropped.svg;

    // Size map to fit its natural aspect ratio (not fill the whole page)
    let mapX = 0, mapY = 0, mapW, mapH;
    const MAX_MAP_SIZE = 180; // max starting dimension in px
    const naturalAspect = cropped.aspect;
    if (naturalAspect >= 1) {
      mapW = MAX_MAP_SIZE;
      mapH = Math.round(MAX_MAP_SIZE / naturalAspect);
    } else {
      mapH = MAX_MAP_SIZE;
      mapW = Math.round(MAX_MAP_SIZE * naturalAspect);
    }

    if (isCover) {
      const zone = (typeof activeCoverZone !== "undefined" && activeCoverZone) || "front";
      const faceW = 300;
      const faceH = Math.round(faceW * 1.414);
      const zoneStartX = zone === "front" ? (window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X)
                       : zone === "back"  ? 0
                       : COVER_BACK_W;
      mapX = zoneStartX + Math.round((faceW - mapW) / 2);
      mapY = Math.round((faceH - mapH) / 2);
    } else {
      // Center in page body (270px wide, ~338px tall)
      mapX = Math.round((270 - mapW) / 2);
      mapY = Math.round((338 - mapH) / 2);
    }

    const mapObj = {
      id: mapId,
      type: "map",
      name: mapKey || "Map",
      mapKey: mapKey || "",
      svg: svgMarkup,
      x: mapX,
      y: mapY,
      w: mapW,
      h: mapH,
      // Was a hardcoded 20 - far below the Date.now() z every other insert uses,
      // so a newly added map was buried under everything already on the page.
      z: _dmbNextTopZ(pageNumber),
      rotation: 0,
      fill: s.fill || "#d9d9d9",
      stroke: s.stroke || "#111111",
      strokeWidth: s.strokeWidth != null ? s.strokeWidth : 1.2,
      strokeDasharray: s.strokeDasharray || "",
      opacity: s.opacity != null ? s.opacity : 1,
      showOutline: s.showOutline || false,
      hideProvinces: s.hideProvinces || false,
      transparentFill: s.transparentFill || false,
      filterId: "dmbOF_" + mapId,
      markers: []
    };

    pushUndoState("Add Map");   // persist to the restore key + make it undoable
    if (isCover) {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      editor.coverObjects.push(mapObj);
    } else {
      if (!editor.pageObjects || typeof editor.pageObjects !== "object") editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
      editor.pageObjects[pageNumber].push(mapObj);
    }

    currentInsertedMap = mapObj;
    pendingMapMarkerPlacement = false;

    if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    if (typeof renderThumbsRail === "function") renderThumbsRail();
  }
  window.insertMapIntoActivePage = insertMapIntoActivePage;

  function renderMapObject(obj, parent, pageIndex) {
    const wrap = document.createElement("div");
    wrap.className = "dmb-map-object";
    wrap.dataset.objectId = obj.id;
    wrap.style.position = "absolute";
    wrap.style.left = (obj.x || 0) + "%";
    wrap.style.top = (obj.y || 0) + "%";
    wrap.style.width = (obj.width || 70) + "%";
    wrap.style.height = (obj.height || 70) + "%";
    wrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
    wrap.style.transformOrigin = "center center";
    wrap.style.cursor = "move";

    wrap.innerHTML = obj.svg || "";

    const svg = wrap.querySelector("svg");
    if (svg) {
      svg.style.width = "100%";
      svg.style.height = "100%";
      svg.style.display = "block";

      svg.querySelectorAll("path").forEach((path) => {
        path.style.fill = obj.fill || "#d9d9d9";
        path.style.stroke = obj.stroke || "#111111";
        path.style.strokeWidth = obj.strokeWidth || 1.2;
        path.style.strokeDasharray = obj.strokeDasharray || "";
        path.style.opacity = obj.opacity || 1;
        path.style.vectorEffect = "non-scaling-stroke";
      });
    }

    if (Array.isArray(obj.markers)) {
      obj.markers.forEach((markerData) => {
        const marker = createMarkerElement(markerData.type || "pin", markerData.color || "#e74c3c");
        marker.style.left = (markerData.x || 50) + "%";
        marker.style.top  = (markerData.y || 50) + "%";
        wrap.appendChild(marker);
        attachMarkerInteractions(marker, markerData, wrap);
      });
    }

    parent.appendChild(wrap);
    currentInsertedMap = obj;

    /* click → open edit bar */
    wrap.addEventListener("click", (e) => {
      if (e.target.closest(".dmb-map-marker")) return;
      dmbOpenEditBar(obj, wrap);
    });
  }




  function enableBasicDragging(node, container) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;

    node.addEventListener("pointerdown", (e) => {
      if (e.target.closest(".dmb-map-marker")) return;
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(node.style.left || 0);
      startTop = parseFloat(node.style.top || 0);
      node.setPointerCapture?.(e.pointerId);
      e.preventDefault();
    });

    node.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      node.style.left = `${startLeft + dx}px`;
      node.style.top = `${startTop + dy}px`;
    });

    node.addEventListener("pointerup", () => {
      dragging = false;
    });

    node.addEventListener("pointercancel", () => {
      dragging = false;
    });
  }

  function createMarkerElement(markerType, color) {
    const c = color || "#e74c3c";
    const marker = document.createElement("div");
    marker.className = "dmb-map-marker";
    marker.dataset.markerType = markerType;
    marker.style.position = "absolute";
    marker.style.transform = "translate(-50%, -50%)";
    marker.style.zIndex = "10";
    marker.style.cursor = "move";
    marker.style.userSelect = "none";

    if (markerType === "dot") {
      const dot = document.createElement("div");
      dot.className = "dmb-map-marker-dot";
      dot.style.backgroundColor = c;
      marker.appendChild(dot);
    } else if (markerType === "pin") {
      marker.innerHTML = `<svg width="18" height="26" viewBox="0 0 18 26" xmlns="http://www.w3.org/2000/svg"><ellipse cx="9" cy="9" rx="7.5" ry="7.5" fill="${c}" stroke="white" stroke-width="1.5"/><polygon points="9,26 3.5,15 14.5,15" fill="${c}"/><circle cx="9" cy="9" r="2.8" fill="white"/></svg>`;
    } else if (markerType === "heart") {
      marker.style.fontSize = "22px";
      marker.style.lineHeight = "1";
      marker.style.color = c;
      marker.style.textShadow = "0 1px 3px rgba(0,0,0,0.4)";
      marker.textContent = "♥";
    } else if (markerType === "star") {
      marker.style.fontSize = "22px";
      marker.style.lineHeight = "1";
      marker.style.color = c;
      marker.style.textShadow = "0 1px 3px rgba(0,0,0,0.4)";
      marker.textContent = "★";
    }

    return marker;
  }

  function updateMarkerColor(markerEl, markerType, color) {
    if (markerType === "dot") {
      const dot = markerEl.querySelector(".dmb-map-marker-dot");
      if (dot) dot.style.backgroundColor = color;
    } else if (markerType === "pin") {
      markerEl.querySelectorAll("ellipse, polygon").forEach(function(el) { el.setAttribute("fill", color); });
    } else {
      markerEl.style.color = color;
    }
  }

  function attachMarkerInteractions(marker, markerData, wrap) {
    // Drag to reposition — updates markerData.x / markerData.y in %
    marker.addEventListener("pointerdown", function(e) {
      if (e.button !== 0) return;
      e.stopPropagation();
      e.preventDefault();
      const wRect = wrap.getBoundingClientRect();
      const startX = e.clientX, startY = e.clientY;
      const startPctX = markerData.x || 0, startPctY = markerData.y || 0;
      marker.setPointerCapture(e.pointerId);
      function onMove(ev) {
        markerData.x = Math.max(0, Math.min(100, startPctX + ((ev.clientX - startX) / wRect.width)  * 100));
        markerData.y = Math.max(0, Math.min(100, startPctY + ((ev.clientY - startY) / wRect.height) * 100));
        marker.style.left = markerData.x + "%";
        marker.style.top  = markerData.y + "%";
      }
      function onUp() {
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      }
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    // Click to change color
    marker.addEventListener("click", function(e) {
      e.stopPropagation();
      const inp = document.createElement("input");
      inp.type = "color";
      inp.value = markerData.color || "#e74c3c";
      inp.style.cssText = "position:fixed;opacity:0;width:0;height:0;pointer-events:none;";
      document.body.appendChild(inp);
      inp.addEventListener("input", function() {
        markerData.color = inp.value;
        updateMarkerColor(marker, markerData.type, inp.value);
      });
      inp.addEventListener("change", function() {
        markerData.color = inp.value;
        updateMarkerColor(marker, markerData.type, inp.value);
        if (typeof renderThumbsRail === "function") renderThumbsRail();
        setTimeout(function() { inp.remove(); }, 500);
      });
      inp.click();
    });
  }

  function enableBasicMarkerDragging(marker, container) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;

    marker.addEventListener("pointerdown", (e) => {
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(marker.style.left || 0);
      startTop = parseFloat(marker.style.top || 0);
      marker.setPointerCapture?.(e.pointerId);
      e.stopPropagation();
      e.preventDefault();
    });

    marker.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      marker.style.left = `${startLeft + dx}px`;
      marker.style.top = `${startTop + dy}px`;
    });

    marker.addEventListener("pointerup", () => {
      dragging = false;
    });

    marker.addEventListener("pointercancel", () => {
      dragging = false;
    });
  }


  function captureVisualText(el) {
    // Serialize a text box's content to a string, preserving ONLY explicit line
    // breaks: real "\n" characters, <br> elements, and block-level children that
    // the browser creates when the user presses Enter.
    //
    // It must NOT convert *soft* (CSS) wraps into hard newlines. The old version
    // measured every character's on-screen top and inserted a "\n" wherever a word
    // wrapped to a new visual line. That baked the wrapping into the saved text, so
    // a word that merely wrapped because the box was a touch narrow became a
    // PERMANENT new line: backspacing the break merged it, but the next save
    // re-detected the soft wrap and re-inserted the break (it "snapped back" after
    // one action). The PDF renderer re-wraps pre-wrap boxes on its own, so soft
    // wraps never need to be persisted. (Bonus: this drops a per-character
    // getBoundingClientRect — a real typing/save lag source on touch.)
    var result = [];
    var curLine = "";
    function walk(node) {
      if (node.nodeType === 3) {
        var parts = (node.nodeValue || "").split("\n");
        for (var i = 0; i < parts.length; i++) {
          if (i > 0) { result.push(curLine); curLine = ""; }
          curLine += parts[i];
        }
      } else if (node.nodeName === "BR") {
        result.push(curLine); curLine = "";
      } else if (node.nodeType === 1) {
        var disp = window.getComputedStyle(node).display || "";
        var isBlock = disp !== "inline" && disp !== "inline-block" && disp !== "none";
        if (isBlock && (result.length > 0 || curLine !== "")) { result.push(curLine); curLine = ""; }
        node.childNodes.forEach(walk);
      }
    }
    el.childNodes.forEach(walk);
    result.push(curLine);
    while (result.length > 1 && result[result.length - 1] === "") result.pop();
    return result.join("\n");
  }

  // Derive a cover text node's zone (back/spine/front) from its horizontal centre,
  // mirroring _dmbAutoAssignCoverZone. Used to re-register an orphaned text box.
  function _dmbZoneForCoverNode(node) {
    var left = parseFloat(node && node.style ? node.style.left : 0) || 0;
    var w = (node && node.offsetWidth) || 0;
    var cx = left + w / 2;
    if (window.DMB_MAGAZINE_MODE) return cx < COVER_BACK_W ? "back" : "front";
    if (cx < COVER_BACK_W) return "back";
    if (cx < COVER_FRONT_X) return "spine";
    return "front";
  }

  function saveCoverTextNodeState(node) {
    if (!node || !node.id) return;
    if (!coverState.textStyles) coverState.textStyles = {};
    // Do NOT delete the box on a momentary empty. The 'input' handler saves on
    // every keystroke, so clearing a template box to retype it (or a just-added
    // box before the first character) passes through an empty state. Removing it
    // from coverUserTexts orphaned the box — the retyped text still showed on
    // screen (the DOM node lives) but was gone from state, so it was MISSING FROM
    // THE PDF and wiped on the next re-render. Abandoned empty boxes are removed
    // only on blur / click-out (see _dmbRemoveTextNode). Persist whatever's there.
    const _coverTxt = captureVisualText(node);
    // Carry the MEASURED fields forward. They are written by _captureCoverTextBoxes
    // (which needs a live #coverOverlay) and are what lets the PDF place the title
    // on its real ink centre instead of re-deriving it from box + line-height.
    const _prevTS = (coverState.textStyles && coverState.textStyles[node.id]) || {};
    // Inline runs: `rich` is measured-free so it is recomputed on every save;
    // `richLines` needs the laid-out overlay, so it is carried forward here and
    // refreshed by _captureCoverTextBoxes - exactly how renderedLines works.
    const _richNow = _dmbSerializeRich(node);
    coverState.textStyles[node.id] = {
      renderedLines: _prevTS.renderedLines || "",
      rich: _richNow,
      richLines: _richNow ? (_prevTS.richLines || "") : "",
      visCx:   _prevTS.visCx,   visCy:   _prevTS.visCy,
      glyphCx: _prevTS.glyphCx, glyphCy: _prevTS.glyphCy,
      text: _coverTxt,
      left: node.style.left || "",
      // Only the top is stored canonical (portrait-referenced) so landscape text
      // lands on the shorter face; size stays exactly as the user set it.
      top: _dmbCoverCanonicalTop(node.style.top),
      // Store only explicit CSS width — NOT the parent's offsetWidth fallback.
      width: node.style.width || "",
      boxWidth:  String(node.offsetWidth  || 0),
      boxHeight: String(node.offsetHeight || 0),
      color: node.style.color || "",
      fontFamily: node.style.fontFamily || "",
      fontSize: node.style.fontSize || "",
      fontWeight: node.style.fontWeight || "",
      textAlign: node.style.textAlign || "",
      textDecoration: node.style.textDecoration || "",
      whiteSpace: node.style.whiteSpace || "",
      transform: node.style.transform || "",
      // Clamp floating-point drift (e.g. -2.84e-14) to "0" at save time so
      // templates and session state never store near-zero garbage rotations.
      rotate: (Math.abs(parseFloat(node.dataset.rotate || "0")) < 0.001 ? "0" : (node.dataset.rotate || "0")),
      z: node.dataset.z || node.style.zIndex || "20"
    };
    // Self-heal registration: ensure a cover USER text box is listed in
    // coverUserTexts so the PDF and re-renders include it. Repairs boxes orphaned
    // by the earlier empty-strip bug, and re-registers a box the instant the user
    // types into it. Guarded to nodes actually inside #coverOverlay so built-in
    // titles and interior/page text can't be misfiled as cover user texts.
    if (Array.isArray(editor.coverUserTexts) &&
        !editor.coverUserTexts.some((e) => e.id === node.id)) {
      const _ov = document.getElementById("coverOverlay");
      if (_ov && _ov.contains(node)) {
        editor.coverUserTexts.push({ id: node.id, zone: _dmbZoneForCoverNode(node) });
      }
    }
    // Refresh the measurements while the overlay still exists, rAF-debounced so a
    // keystroke costs one layout pass. Without this the values above are only ever
    // as fresh as the last time the cover view was open - and a customer who edits
    // the cover, switches to Pages and checks out would print a stale capture.
    try {
      const _ovNow = document.getElementById("coverOverlay");
      if (_ovNow && _ovNow.contains(node) && typeof _dmbCaptureCoverTextBoxesFn === "function") {
        if (!saveCoverTextNodeState._raf) {
          saveCoverTextNodeState._raf = requestAnimationFrame(function () {
            saveCoverTextNodeState._raf = 0;
            try { _dmbCaptureCoverTextBoxesFn(); } catch (e) {}
          });
        }
      }
    } catch (e) {}
  }

  // -- Capture the browser's REAL rendered line breaks for a wrapped text box --
  // A box narrowed with the side grip wraps at word boundaries (white-space:
  // pre-wrap) and the BROWSER decides the breaks. The PDF must reuse the SAME
  // words-per-line: re-wrapping with canvas measureText can break at a different
  // word than the builder shows, which reflows the whole box (one line is ~25 mm
  // on paper). Returns a JSON array of lines, or "" when the box is not wrapped
  // (the PDF then splits on newlines only, which is exact).
  // Measurement MUST happen un-rotated or getClientRects tops do not group into
  // lines; pass alreadyUnrotated=true when the caller has already done that.
  // ══════════════════════════════════════════════════════════════════════════
  // INLINE FORMATTING - a look that belongs to SOME OF THE WORDS
  //
  // Everything else in this file treats a text box as one look: colour, font,
  // size and underline live on the element and the PDF reads them off the saved
  // object. Styling a few words means a box can hold several looks at once, and
  // that has to survive three separate journeys, not one:
  //
  //   the DOM   spans inside the box while the customer is editing it
  //   storage   localStorage / the cloud design, reopened on any device
  //   the PDF   the canvas renderer, which must draw run by run
  //
  // So two fields are stored, because one cannot do both jobs:
  //
  //   rich       the content as a flat list of segments with EXPLICIT breaks.
  //              This is what rebuilds the DOM. It must never contain a soft
  //              (CSS) wrap, for exactly the reason obj.text must not: a wrap
  //              written down as a break becomes a permanent line break.
  //   richLines  the same content split into the VISUAL lines on screen, each
  //              line a list of runs. This is what the PDF draws, so a wrap that
  //              falls in the middle of a coloured phrase is split correctly.
  //
  // A box with a single look stores NEITHER - both stay empty and every path
  // behaves exactly as it did before this existed. (2026-10-12)
  const _DMB_RUN_PROPS = { c: "color", ff: "fontFamily", fs: "fontSize",
                           fw: "fontWeight", fi: "fontStyle", td: "textDecoration" };
  const _DMB_RUN_KEYS = Object.keys(_DMB_RUN_PROPS);

  function _dmbRunStyleEmpty(st) {
    if (!st) return true;
    for (var i = 0; i < _DMB_RUN_KEYS.length; i++) if (st[_DMB_RUN_KEYS[i]]) return false;
    return true;
  }
  function _dmbRunStyleSame(a, b) {
    a = a || {}; b = b || {};
    for (var i = 0; i < _DMB_RUN_KEYS.length; i++) {
      var k = _DMB_RUN_KEYS[i];
      if ((a[k] || "") !== (b[k] || "")) return false;
    }
    return true;
  }

  // The look that applies to one text node, relative to its box: the inline
  // styles of every wrapper between them, innermost winning. Only inline style is
  // read (never computed style) - a computed read would pick up the BOX's own
  // font and record it on every run, which would then outlive a later change to
  // the box. The legacy tags are here because contenteditable can still produce
  // them on an undo or a paste.
  function _dmbRunStyleOf(textNode, host) {
    var out = {};
    var chain = [], el = textNode ? textNode.parentNode : null;
    while (el && el !== host) { chain.push(el); el = el.parentNode; }
    if (el !== host) return out;                     // not inside this box
    for (var i = chain.length - 1; i >= 0; i--) {    // outermost first
      var n = chain[i], st = n.style;
      if (st) {
        for (var j = 0; j < _DMB_RUN_KEYS.length; j++) {
          var k = _DMB_RUN_KEYS[j], v = st[_DMB_RUN_PROPS[k]];
          if (v) out[k] = v;
        }
      }
      var nm = n.nodeName;
      if (nm === "B" || nm === "STRONG") { if (!out.fw) out.fw = "800"; }
      if (nm === "I" || nm === "EM")     out.fi = "italic";
      if (nm === "U")                    out.td = "underline";
    }
    return out;
  }

  // Flat segments + explicit breaks. Returns "" for a box with one look, so
  // nothing is stored and nothing downstream changes.
  function _dmbSerializeRich(host) {
    if (!host) return "";
    var segs = [], any = false;
    function push(t, st) {
      if (!t) return;
      if (!_dmbRunStyleEmpty(st)) any = true;
      var last = segs[segs.length - 1];
      if (last && typeof last.t === "string" && _dmbRunStyleSame(last.s, st)) { last.t += t; return; }
      segs.push(_dmbRunStyleEmpty(st) ? { t: t } : { t: t, s: st });
    }
    function brk() { segs.push({ br: 1 }); }
    function walk(node) {
      if (node.nodeType === 3) {
        var st = _dmbRunStyleOf(node, host);
        var parts = (node.nodeValue || "").split("\n");
        for (var i = 0; i < parts.length; i++) { if (i > 0) brk(); push(parts[i], st); }
      } else if (node.nodeName === "BR") {
        brk();
      } else if (node.nodeType === 1) {
        var disp = "";
        try { disp = window.getComputedStyle(node).display || ""; } catch (e) {}
        var isBlock = disp !== "inline" && disp !== "inline-block" && disp !== "none";
        if (isBlock && segs.length) brk();
        node.childNodes.forEach(walk);
      }
    }
    try { host.childNodes.forEach(walk); } catch (e) { return ""; }
    if (!any) return "";
    while (segs.length && segs[segs.length - 1].br) segs.pop();
    // Last gate: the segments must spell EXACTLY what captureVisualText saved as
    // obj.text. If the two ever disagreed, a reopened box would show different
    // words or different breaks from the ones the PDF prints - so on any
    // disagreement the formatting is dropped and the plain text stands. Losing a
    // colour is recoverable; printing the wrong line breaks is not.
    try {
      var plain = segs.map(function (g) { return g.br ? "\n" : (g.t || ""); }).join("");
      if (plain !== captureVisualText(host)) return "";
    } catch (e) { return ""; }
    return JSON.stringify(segs);
  }

  // Rebuild the box's content from stored segments. Built with createElement and
  // assigned one style property at a time - never innerHTML - so a design file
  // can only ever restore text and the six properties above.
  function _dmbApplyRich(host, json, fsMap) {
    if (!host || !json) return false;
    var segs = null;
    try { segs = JSON.parse(json); } catch (e) { return false; }
    if (!Array.isArray(segs) || !segs.length) return false;
    try {
      while (host.firstChild) host.removeChild(host.firstChild);
      segs.forEach(function (g) {
        if (!g) return;
        if (g.br) { host.appendChild(document.createElement("br")); return; }
        if (typeof g.t !== "string" || !g.t) return;
        if (_dmbRunStyleEmpty(g.s)) { host.appendChild(document.createTextNode(g.t)); return; }
        var sp = document.createElement("span");
        sp.setAttribute("data-dmb-run", "1");
        _DMB_RUN_KEYS.forEach(function (k) {
          if (!g.s[k]) return;
          var v = String(g.s[k]);
          if (k === "fs" && typeof fsMap === "function") {
            v = fsMap(parseFloat(v) || 0) || v;
          }
          try { sp.style[_DMB_RUN_PROPS[k]] = v; } catch (e) {}
        });
        sp.appendChild(document.createTextNode(g.t));
        host.appendChild(sp);
      });
      return true;
    } catch (e) { return false; }
  }

  // Strip every run back to one look. Used by the format painter: "make this box
  // look like that one" cannot mean anything else while some of its words are
  // still overriding the answer.
  // Unwrap every element in a text box except <br> and our own run spans, keeping
  // the text and the line breaks exactly where they are.
  function _dmbStripForeignMarkup(host) {
    try {
      if (!host || !host.querySelectorAll) return false;
      const els = host.querySelectorAll("*");
      let n = 0;
      for (let i = els.length - 1; i >= 0; i--) {
        const el = els[i];
        if (el.nodeName === "BR") continue;
        if (el.nodeName === "SPAN" && el.getAttribute("data-dmb-run") === "1") continue;
        // A BLOCK element is a line break in its own right - contenteditable makes
        // one every time Enter is pressed, and captureVisualText reads it as a new
        // line. Unwrapping it would silently join two lines, so only INLINE
        // leftovers are unwrapped. Anything a block carries is read by
        // _dmbRunStyleOf like any other wrapper, so nothing is lost by leaving it.
        let _disp = "";
        try { _disp = window.getComputedStyle(el).display || ""; } catch (e2) {}
        if (_disp && _disp !== "inline" && _disp !== "inline-block") continue;
        const p = el.parentNode;
        if (!p) continue;
        while (el.firstChild) p.insertBefore(el.firstChild, el);
        p.removeChild(el);
        n++;
      }
      if (n) host.normalize();
      return n > 0;
    } catch (e) { return false; }
  }

  function _dmbFlattenRuns(host) {
    try {
      if (!host || !host.querySelector) return false;
      if (!host.querySelector("span, b, strong, i, em, u, font")) return false;
      host.textContent = captureVisualText(host);
      return true;
    } catch (e) { return false; }
  }

  // Remove ONE css property from every per-word run span so a WHOLE-BOX change to
  // that property (toolbar with no text selected, or the corner-handle resize) is no
  // longer overridden by a run's own value. Other per-word properties (e.g. colour
  // when you change the size) are kept; a run left with no inline style is unwrapped.
  function _dmbStripRunProp(host, cssProp) {
    try {
      if (!host || !host.querySelectorAll) return;
      host.querySelectorAll("span[data-dmb-run]").forEach(function (sp) {
        try {
          sp.style.removeProperty(cssProp);
          var styleAttr = sp.getAttribute("style");
          if (!styleAttr || !styleAttr.trim()) {
            var parent = sp.parentNode; if (!parent) return;
            while (sp.firstChild) parent.insertBefore(sp.firstChild, sp);
            parent.removeChild(sp);
          }
        } catch (e) {}
      });
      try { host.normalize(); } catch (e) {}
    } catch (e) {}
  }

  // The visual lines, each as a list of runs. Deliberately NOT built on
  // _dmbCaptureRenderedLines: that one groups words by the top of their rect,
  // which is sound only while every word is the same size. Two sizes on one line
  // share a BASELINE, not a top, so a small word beside a big one looks exactly
  // like a new line to that test. Line breaks are found here by the word going
  // BACKWARDS horizontally, which is true of a real break and of nothing else:
  // within a line each word starts at or after the previous word's right edge.
  // The vertical test is kept as well, but only between words of equal height,
  // where it is the original behaviour.
  function _dmbCaptureLineRuns(node, alreadyUnrotated) {
    if (!node) return "";
    var tf = null;
    try {
      if (!alreadyUnrotated) { tf = node.style.transform; node.style.transform = "none"; }
      var lines = [], cur = [];
      var pRight = null, pTop = null, pH = null;
      var pushRun = function (t, st) {
        if (!t) return;
        var last = cur[cur.length - 1];
        if (last && _dmbRunStyleSame(last.s, st)) { last.t += t; return; }
        cur.push(_dmbRunStyleEmpty(st) ? { t: t } : { t: t, s: st });
      };
      var endLine = function () {
        // Trailing whitespace at a wrap is not drawn, so it is not stored.
        while (cur.length) {
          var last = cur[cur.length - 1];
          last.t = last.t.replace(/\s+$/, "");
          if (last.t) break;
          cur.pop();
        }
        lines.push(cur); cur = [];
      };
      var tw = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      var wr = document.createRange(), tn;
      while ((tn = tw.nextNode())) {
        var st = _dmbRunStyleOf(tn, node);
        var txt = tn.textContent || "";
        var i = 0;
        while (i < txt.length) {
          var m = /^(\s+|\S+)/.exec(txt.slice(i));
          var chunk = m ? m[1] : txt.slice(i);
          if (/\S/.test(chunk)) {
            wr.setStart(tn, i); wr.setEnd(tn, i + chunk.length);
            var r0 = wr.getClientRects()[0];
            if (r0 && r0.height > 0) {
              var sameSize = (pH == null) || Math.abs(r0.height - pH) <= Math.max(1, pH * 0.1);
              var broke = (pRight != null && r0.left < pRight - 1) ||
                          (sameSize && pTop != null && (r0.top - pTop) > pH * 0.5);
              if (broke) { endLine(); }
              pRight = r0.right; pTop = r0.top; pH = r0.height;
            }
          }
          pushRun(chunk, st);
          i += chunk.length;
        }
      }
      endLine();
      if (lines.length && lines.some(function (ln) { return ln.length; })) return JSON.stringify(lines);
    } catch (e) {} finally {
      if (tf !== null) { try { node.style.transform = tf; } catch (e2) {} }
    }
    return "";
  }

  // ---- applying a look to the SELECTED WORDS -------------------------------
  // The toolbar controls steal focus (a <select>, a colour input, a button), and
  // on some browsers that drops the highlight. So the last real selection inside
  // a text box is remembered and used when the control fires. A COLLAPSED caret
  // clears it on purpose: clicking into a box and then picking a colour has
  // always meant "the whole box", and it still does.
  let _dmbLastTextRange = null;
  document.addEventListener("selectionchange", function () {
    try {
      const sel = window.getSelection();
      if (!sel || !sel.rangeCount) return;
      const r = sel.getRangeAt(0);
      const c = r.commonAncestorContainer;
      const el = c && (c.nodeType === 3 ? c.parentNode : c);
      const box = (el && el.closest) ? el.closest(".dmb-editable-text") : null;
      if (!box) return;                        // a selection elsewhere changes nothing
      _dmbLastTextRange = r.collapsed ? null : r.cloneRange();
    } catch (e) {}
  });

  function _dmbActiveTextRange(host) {
    const ok = function (r) {
      if (!r || r.collapsed) return null;
      const c = r.commonAncestorContainer;
      const el = c && (c.nodeType === 3 ? c.parentNode : c);
      return (el && host && host.contains(el)) ? r : null;
    };
    try {
      const sel = window.getSelection();
      if (sel && sel.rangeCount) { const r = ok(sel.getRangeAt(0)); if (r) return r; }
    } catch (e) {}
    try {
      if (_dmbLastTextRange && _dmbLastTextRange.startContainer &&
          _dmbLastTextRange.startContainer.isConnected) return ok(_dmbLastTextRange);
    } catch (e) {}
    return null;
  }

  // Is every selected word underlined? Drives the U button's toggle, which has to
  // mean "underline this selection" / "take it off this selection".
  function _dmbSelUnderlined(host) {
    const nodes = _dmbSelTextNodes(host);
    if (!nodes.length) return false;
    const boxU = !!(host.style.textDecoration && host.style.textDecoration.indexOf("underline") !== -1);
    for (let i = 0; i < nodes.length; i++) {
      if (!/\S/.test(nodes[i].nodeValue || "")) continue;
      const td = _dmbRunStyleOf(nodes[i], host).td;
      const on = (td != null && td !== "") ? (td.indexOf("underline") !== -1) : boxU;
      if (!on) return false;
    }
    return true;
  }

  // The text nodes the selection covers WHOLE, after splitting the two boundary
  // nodes so a part-word selection becomes its own node.
  function _dmbSelTextNodes(host, split) {
    const r = _dmbActiveTextRange(host);
    if (!r) return [];
    if (split) {
      try {
        if (r.endContainer.nodeType === 3 && r.endOffset < (r.endContainer.nodeValue || "").length) {
          r.endContainer.splitText(r.endOffset);
        }
        if (r.startContainer.nodeType === 3 && r.startOffset > 0) {
          const after = r.startContainer.splitText(r.startOffset);
          r.setStart(after, 0);
        }
      } catch (e) { return []; }
    }
    const out = [];
    try {
      const tw = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
      let tn;
      while ((tn = tw.nextNode())) {
        if (!tn.nodeValue) continue;
        try {
          if (r.comparePoint(tn, 0) >= 0 && r.comparePoint(tn, tn.nodeValue.length) <= 0) out.push(tn);
        } catch (e) {}
      }
    } catch (e) {}
    return out;
  }

  function _dmbStyleSelection(host, props) {
    const nodes = _dmbSelTextNodes(host, true);
    if (!nodes.length) return false;
    nodes.forEach(function (t) {
      let holder = t.parentNode;
      const reusable = holder && holder !== host && holder.nodeName === "SPAN" &&
                       holder.childNodes.length === 1 &&
                       holder.getAttribute && holder.getAttribute("data-dmb-run") === "1";
      if (!reusable) {
        const sp = document.createElement("span");
        sp.setAttribute("data-dmb-run", "1");
        // Nothing is copied onto the new wrapper: it sits INSIDE whatever was
        // already there, so CSS inheritance carries the rest of the look.
        t.parentNode.insertBefore(sp, t);
        sp.appendChild(t);
        holder = sp;
      }
      Object.keys(props).forEach(function (k) {
        try { holder.style[k] = props[k]; } catch (e) {}
      });
    });
    try {
      const sel = window.getSelection();
      const nr = document.createRange();
      nr.setStartBefore(nodes[0]);
      nr.setEndAfter(nodes[nodes.length - 1]);
      sel.removeAllRanges(); sel.addRange(nr);
      _dmbLastTextRange = nr.cloneRange();
    } catch (e) {}
    return true;
  }

  // Route one toolbar change to the selected words. Returns false when there is
  // no selection, and the caller then does what it always did to the whole box.
  function _dmbApplyToTextSelection(props, label) {
    const node = (typeof selectedTextNode !== "undefined") ? selectedTextNode : null;
    if (!node || !node.isConnected) return false;
    if (!_dmbActiveTextRange(node)) return false;
    try { pushUndoState(label || "Text Edit"); } catch (e) {}
    if (!_dmbStyleSelection(node, props)) return false;
    try { saveCoverTextNodeState(node); } catch (e) {}
    try { savePageTextState(node); } catch (e) {}
    try { saveCoverDesignToStorage(); } catch (e) {}
    try { _dmbWriteProgressState(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
    try { positionTextSelectFrame(node); positionRotateHandle(node); } catch (e) {}
    return true;
  }

  function _dmbCaptureRenderedLines(node, alreadyUnrotated) {
    if (!node) return "";
    let _tf = null;
    try {
      if (!alreadyUnrotated) { _tf = node.style.transform; node.style.transform = "none"; }
      if (getComputedStyle(node).whiteSpace !== "pre-wrap") return "";
      const _lines = [];
      let _curTop = null, _cur = "";
      const _tw = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const _wr = document.createRange();
      let _tn;
      while ((_tn = _tw.nextNode())) {
        const _txt = _tn.textContent;
        let _i = 0;
        while (_i < _txt.length) {
          const _m = /^(\s+|\S+)/.exec(_txt.slice(_i));
          const _chunk = _m ? _m[1] : _txt.slice(_i);
          if (/\S/.test(_chunk)) {
            _wr.setStart(_tn, _i); _wr.setEnd(_tn, _i + _chunk.length);
            const _r0 = _wr.getClientRects()[0];
            if (_r0 && _r0.height > 0) {
              if (_curTop !== null && (_r0.top - _curTop) > _r0.height * 0.5) {
                _lines.push(_cur.replace(/\s+$/, "")); _cur = "";
              }
              _curTop = _r0.top;
            }
          }
          _cur += _chunk;
          _i += _chunk.length;
        }
      }
      _lines.push(_cur.replace(/\s+$/, ""));
      if (_lines.length && _lines.some((l) => l !== "")) return JSON.stringify(_lines);
    } catch (e) {} finally {
      if (_tf !== null) { try { node.style.transform = _tf; } catch (e2) {} }
    }
    return "";
  }

  // -- Wrap a text object the way the BROWSER would, for designs saved before
  // page text stored its own line breaks. Builds a throwaway offscreen replica of
  // the box (same class, width, font and padding as the real node in renderSpread)
  // and reads the real line breaks off it. This is the same layout engine that put
  // the text on screen, so it beats canvas measureText - which measures glyphs in a
  // different context and can break at a different word, reflowing the whole box.
  // Everything stays in BUILDER px (unscaled): wrapping depends on the ratio of text
  // width to box width, so the 300 DPI scale factor is irrelevant here.
  function _dmbWrapLinesViaDom(obj) {
    if (!obj || !obj.text) return null;
    let d = null;
    try {
      d = document.createElement("div");
      d.className = "dmb-editable-text";          // min-width / line-height / text-align
      d.style.position = "absolute";
      d.style.left = "-99999px";
      d.style.top = "0";
      d.style.opacity = "0";                      // keeps layout (display:none would not)
      d.style.pointerEvents = "none";
      d.style.transform = "none";                 // measure un-rotated
      // Cover items store width as a bare number; page objects store "180px".
      let _w = String(obj.width == null ? "" : obj.width).trim();
      if (_w && /^[0-9.]+$/.test(_w)) _w += "px";
      if (_w) d.style.width = _w;
      d.style.fontSize = obj.fontSize || "28px";
      d.style.fontWeight = obj.fontWeight || "800";
      d.style.fontFamily = obj.fontFamily || "'Londrina Solid', sans-serif";
      if (obj.textAlign) d.style.textAlign = obj.textAlign;
      if (obj.textDecoration) d.style.textDecoration = obj.textDecoration;
      d.style.whiteSpace = obj.whiteSpace || "pre";
      d.style.padding = "2px 6px";                // matches the real node + TX_PL/TX_PT
      d.textContent = obj.text;
      document.body.appendChild(d);
      const _json = _dmbCaptureRenderedLines(d, true);
      if (!_json) return null;
      const _arr = JSON.parse(_json);
      return (Array.isArray(_arr) && _arr.length) ? _arr : null;
    } catch (e) {
      return null;
    } finally {
      if (d) { try { d.remove(); } catch (e2) {} }
    }
  }

  function savePageTextState(node) {
    if (!node || !node.id) return;
    const pn = parseInt(node.dataset.pageNumber);
    if (!Number.isFinite(pn)) return;
    if (!Array.isArray(editor.pageObjects?.[pn])) return;
    // If the text box has been fully cleared, remove it from state so a
    // re-render (triggered by adding stickers, frames, etc.) cannot resurrect it.
    // Do NOT delete the box on a momentary empty (input saves per keystroke;
    // clearing to retype would orphan it → missing from PDF + wiped on re-render).
    // Abandoned empties are removed on blur / click-out via _dmbRemoveTextNode.
    const _capturedText = captureVisualText(node);
    const obj = editor.pageObjects[pn].find((o) => o.id === node.id);
    if (!obj) return;
    obj.text = _capturedText;
    obj.left = node.style.left || "";
    obj.top = node.style.top || "";
    // Store only explicit CSS width — NOT the parent offsetWidth fallback.
    // The parent fallback (≈270px page width) is meaningless for positioning and
    // causes wrong textAlign centering in the PDF (text centred across whole page).
    obj.width = node.style.width || "";
    obj.color = node.style.color || "";
    obj.fontFamily = node.style.fontFamily || "";
    obj.fontSize = node.style.fontSize || "";
    obj.fontWeight = node.style.fontWeight || "";
    obj.textAlign = node.style.textAlign || "";
    obj.textDecoration = node.style.textDecoration || "";
    obj.whiteSpace = node.style.whiteSpace || "";
    obj.transform = node.style.transform || "";
    // Clamp floating-point drift (e.g. -2.84e-14) to "0" at save time.
    obj.rotate = (Math.abs(parseFloat(node.dataset.rotate || "0")) < 0.001 ? "0" : (node.dataset.rotate || "0"));
    obj.z = node.dataset.z || node.style.zIndex || "20";
    // ── boxWidth / boxHeight: exact DOM element dimensions (pre-rotation) ──
    // The PDF renderer uses these to compute the rotation pivot (element centre =
    // left + boxWidth/2, top + boxHeight/2).  Canvas text measurement can differ
    // from the browser by 1–3px; for rotated text that small error visibly shifts
    // the anchor.  Storing the real DOM size here eliminates the discrepancy.
    // (Cover text already saves these — this brings page text in line with it.)
    obj.boxWidth  = String(node.offsetWidth  || 0);
    obj.boxHeight = String(node.offsetHeight || 0);
    // Rendered line breaks. Cover text has always stored these; PAGE text did not,
    // so a narrowed page text box was RE-wrapped by the PDF with canvas metrics and
    // could break at a different word than the customer designed.
    obj.renderedLines = _dmbCaptureRenderedLines(node);
    // Inline runs. `rich` rebuilds the box, `richLines` is what the PDF draws.
    // Both are "" for a box with one look, which is every box until someone
    // styles part of one.
    obj.rich = _dmbSerializeRich(node);
    obj.richLines = obj.rich ? _dmbCaptureLineRuns(node) : "";
  }

  function applyCoverTextNodeState(node) {
    if (!node || !node.id) return;
    const saved = coverState.textStyles && coverState.textStyles[node.id];
    if (!saved) return;

    if (saved.text != null) node.textContent = saved.text;
    if (saved.left) node.style.left = saved.left;
    if (saved.top) {
      // Scale canonical (portrait-referenced) top to the current face so a
      // landscape face never clips the text. Portrait scale = 1 → unchanged.
      // Keep a percentage as a percentage - scaling only applies to canonical px.
      // (The sibling restore inside renderCoverCanvas already guarded this; this one
      // did not, so it re-corrupted spine text even after the save was fixed.)
      var _tpRaw = String(saved.top).trim();
      var _tp = parseFloat(_tpRaw);
      node.style.top = (_tpRaw.slice(-1) !== "%" && isFinite(_tp))
        ? ((_tp * _dmbCoverTopScale()) + "px") : saved.top;
    }
    if (saved.width) node.style.width = saved.width;
    if (saved.color) node.style.color = saved.color;
    if (saved.fontFamily) node.style.fontFamily = saved.fontFamily;
    if (saved.fontSize) node.style.fontSize = saved.fontSize;
    if (saved.textAlign) node.style.textAlign = saved.textAlign;
    if (saved.textDecoration) node.style.textDecoration = saved.textDecoration;
    if (saved.transform) node.style.transform = saved.transform;
    if (saved.rotate != null) node.dataset.rotate = saved.rotate;
    if (saved.z != null) {
      node.dataset.z = saved.z;
      node.style.zIndex = saved.z;
    }
  }


  function getPageTemplateId(pageNumber) {
    return editor.pageTemplate?.[pageNumber] || null;
  }

  function isTemplatePage(pageNumber) {
    return !!getPageTemplateId(pageNumber);
  }

  function ensureTemplateState(pageNumber, templateId) {
    if (!editor.pageTemplate) editor.pageTemplate = {};
    if (!editor.pageFrames) editor.pageFrames = {};
    if (!editor.pageFrameRot) editor.pageFrameRot = {};

    editor.pageTemplate[pageNumber] = templateId || null;

    if (templateId) {
      const def = TEMPLATE_DEFS[templateId] || [];
      editor.pageFrames[pageNumber] = editor.pageFrames[pageNumber] || {};
      editor.pageFrameRot[pageNumber] = editor.pageFrameRot[pageNumber] || {};

      def.forEach((f) => {
        if (!(f.key in editor.pageFrames[pageNumber])) editor.pageFrames[pageNumber][f.key] = null;
        if (!(f.key in editor.pageFrameRot[pageNumber])) editor.pageFrameRot[pageNumber][f.key] = 0;
      });

      Object.keys(editor.pageFrames[pageNumber]).forEach((k) => {
        if (!def.find((d) => d.key === k)) delete editor.pageFrames[pageNumber][k];
      });
      Object.keys(editor.pageFrameRot[pageNumber]).forEach((k) => {
        if (!def.find((d) => d.key === k)) delete editor.pageFrameRot[pageNumber][k];
      });
    } else {
      editor.pageFrames[pageNumber] = {};
      editor.pageFrameRot[pageNumber] = {};
    }
  }

  function clearPageAllLayouts(pageNumber) {
    if (isLockedPage(pageNumber)) return;
    if (editor.pageSlots?.[pageNumber]) {
      editor.pageSlots[pageNumber].A = null;
      editor.pageSlots[pageNumber].B = null;
    }
    if (editor.pageRot?.[pageNumber]) {
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;
    }
    if (editor.pageFrames?.[pageNumber]) {
      Object.keys(editor.pageFrames[pageNumber]).forEach((k) => editor.pageFrames[pageNumber][k] = null);
    }
    if (editor.pageFrameRot?.[pageNumber]) {
      Object.keys(editor.pageFrameRot[pageNumber]).forEach((k) => editor.pageFrameRot[pageNumber][k] = 0);
    }
    if (editor.pageObjects?.[pageNumber]) {
      // Keep whatever reaches across the fold. Clearing THIS page's layout must not
      // silently destroy content the customer can see on the FACING page - a spanning
      // object belongs to the spread as much as to this page, and the no-photos branch
      // of setPageTemplateWithConfirm reaches here with no confirmation at all.
      const _objs = editor.pageObjects[pageNumber];
      editor.pageObjects[pageNumber] = Array.isArray(_objs)
        ? _objs.filter(function (o) { return _dmbObjOverhangs(o, pageNumber); })
        : [];
    }
    // Note: spreadPhoto is independent — only removed via its own X button
  }

  function clearPagePhotosOnly(pageNumber) {
    if (isLockedPage(pageNumber)) return;
    if (editor.pageSlots?.[pageNumber]) {
      editor.pageSlots[pageNumber].A = null;
      editor.pageSlots[pageNumber].B = null;
    }
    if (editor.pageRot?.[pageNumber]) {
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;
    }
    if (editor.pageFrames?.[pageNumber]) {
      Object.keys(editor.pageFrames[pageNumber]).forEach(k => { editor.pageFrames[pageNumber][k] = null; });
    }
    if (editor.pageFrameRot?.[pageNumber]) {
      Object.keys(editor.pageFrameRot[pageNumber]).forEach(k => { editor.pageFrameRot[pageNumber][k] = 0; });
    }
    // Note: spreadPhoto is independent — only removed via its own X button
  }

  // Copy an entire page's layout/content onto another page. `withPhotos=false` empties
  // every frame (keeps the structure — template, frame shapes, text, stickers, shapes &
  // background) so the copy can be filled with different photos. Fully REPLACES `dst`.
  // Spread photos are per-spread, not per-page, so they are intentionally left alone.
  function _dmbDuplicatePageTo(src, dst, withPhotos) {
    if (isLockedPage(dst) || src === dst) return;
    const _cl = (v, fb) => (v == null ? fb : cloneState(v));
    editor.pageTemplate    = editor.pageTemplate    || {};
    editor.pageSlots       = editor.pageSlots       || {};
    editor.pageRot         = editor.pageRot         || {};
    editor.pageFrames      = editor.pageFrames      || {};
    editor.pageFrameRot    = editor.pageFrameRot    || {};
    editor.pageFrameShapes = editor.pageFrameShapes || {};
    editor.pageObjects     = editor.pageObjects     || {};
    editor.pageBackgrounds = editor.pageBackgrounds || {};

    editor.pageTemplate[dst]    = editor.pageTemplate[src] || null;
    editor.pageFrameShapes[dst] = _cl(editor.pageFrameShapes[src], {});                     // frame shapes = layout, always
    editor.pageFrameRot[dst]    = withPhotos ? _cl(editor.pageFrameRot[src], {}) : {};
    editor.pageFrames[dst]      = withPhotos ? _cl(editor.pageFrames[src], {}) : {};
    editor.pageSlots[dst]       = withPhotos ? _cl(editor.pageSlots[src], { A: null, B: null }) : { A: null, B: null };
    editor.pageRot[dst]         = withPhotos ? _cl(editor.pageRot[src], { A: 0, B: 0 }) : { A: 0, B: 0 };

    if (editor.pageBackgrounds[src] != null) editor.pageBackgrounds[dst] = editor.pageBackgrounds[src];
    else delete editor.pageBackgrounds[dst];

    const srcObjs = Array.isArray(editor.pageObjects[src]) ? editor.pageObjects[src] : [];
    editor.pageObjects[dst] = srcObjs.map((o) => {
      const c = cloneState(o);
      c.id = uid();
      c.page = dst;
      c.targetType = "page";
      if (!withPhotos && c.type === "photo-frame") c.photoId = null;   // empty the frame
      return c;
    });
    // A spanning object is positioned against ONE specific fold. Copied verbatim onto a
    // page of the opposite parity its overhang points the wrong way entirely - off the
    // OUTER edge, onto a sheet the customer never put it near. Pull the fold-side
    // overhang back inside the destination; deliberate bleed off the outer edge is left
    // exactly as it was, and a same-parity copy with a real partner keeps its span.
    try {
      const _dstLeft = (dst % 2 === 1);
      const _dstSib  = _dstLeft ? dst + 1 : dst - 1;
      const _keepSpan = ((src % 2) === (dst % 2)) &&
                        _dstSib >= 1 && _dstSib <= (editor.totalPages || 0);
      if (!_keepSpan) {
        const _PWd = getPageDims().w;
        editor.pageObjects[dst].forEach(function (c) {
          const ow = c.w || 0, x0 = c.x || 0;
          const nx = _dstLeft ? Math.min(x0, _PWd - ow) : Math.max(x0, 0);
          if (nx === x0) return;
          const d = nx - x0;
          c.x = nx;
          if (c.type === "shape" && c.shapeType === "line") {
            if (c.x1 != null) c.x1 += d;
            if (c.x2 != null) c.x2 += d;
            if (c.bx != null) c.bx += d;
          }
          if (c.straddle) delete c.straddle;
        });
      }
    } catch (e) {}
    try { _dmbInvalidateSibCache(); } catch (e) {}
  }

  // Elegant two-step "Duplicate page" modal. Step 1: destination — a spread button
  // and a "Choose another page" button that expands a small inline number field right
  // under it. Step 2: copy with photos or layout-only. Animated, dark, self-contained.
  function _dmbOpenDuplicatePageModal(srcPage) {
    if (document.getElementById("dmbDupPageModal")) return;
    const total = editor.totalPages;
    const other = (srcPage % 2 === 1) ? (srcPage + 1) : (srcPage - 1);
    const otherValid = other >= 2 && other <= total && !isLockedPage(other) && other !== srcPage;

    const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };
    const optBtn = (title, subtitle, primary) => {
      const b = el("button", "dmb-dupm-opt" + (primary ? " primary" : "")); b.type = "button";
      const tw = el("span", "dmb-dupm-optlabel");
      tw.appendChild(el("span", "dmb-dupm-optt", title));
      if (subtitle) tw.appendChild(el("span", "dmb-dupm-opts2", subtitle));
      b.appendChild(tw);
      b.insertAdjacentHTML("beforeend", '<svg class="dmb-dupm-chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>');
      return b;
    };

    const ov = el("div", "dmb-dupm-overlay"); ov.id = "dmbDupPageModal";
    const modal = el("div", "dmb-dupm");
    ov.appendChild(modal); document.body.appendChild(ov);
    requestAnimationFrame(() => { ov.classList.add("is-open"); modal.classList.add("is-open"); });

    const close = () => { ov.classList.remove("is-open"); modal.classList.remove("is-open"); document.removeEventListener("keydown", onEsc); setTimeout(() => { try { ov.remove(); } catch (e) {} }, 200); };
    const onEsc = (e) => { if (e.key === "Escape") close(); };
    ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
    document.addEventListener("keydown", onEsc);

    function screenDestination() {
      modal.innerHTML = "";
      modal.appendChild(el("div", "dmb-dupm-title", "Duplicate page"));
      modal.appendChild(el("div", "dmb-dupm-sub", "Copy page " + srcPage + " to another page."));
      const opts = el("div", "dmb-dupm-opts"); modal.appendChild(opts);

      if (otherValid) {
        const b = optBtn("Other page on this spread", "Page " + other, true);
        b.addEventListener("click", () => screenOptions(other));
        opts.appendChild(b);
      }

      const b2 = optBtn("Choose another page…", "Type a page number", false);
      const expand = el("div", "dmb-dupm-expand");
      const row = el("div", "dmb-dupm-row");
      const input = el("input", "dmb-dupm-input"); input.type = "number"; input.min = "2"; input.max = String(total); input.placeholder = "e.g. " + (otherValid ? Math.min(total, Math.max(2, srcPage + 2)) : 2);
      const go = el("button", "dmb-dupm-go", "Copy"); go.type = "button";
      row.appendChild(input); row.appendChild(go);
      const hint = el("div", "dmb-dupm-hint", "Any page from 2 to " + total);
      expand.appendChild(row); expand.appendChild(hint);

      let open = false;
      b2.addEventListener("click", () => { open = !open; expand.classList.toggle("is-open", open); b2.classList.toggle("is-armed", open); if (open) setTimeout(() => input.focus(), 80); });
      const err = (m) => { hint.className = "dmb-dupm-hint dmb-dupm-err"; hint.textContent = m; };
      const submit = () => {
        const v = parseInt(input.value, 10);
        if (!Number.isFinite(v) || v < 2 || v > total || isLockedPage(v)) return err("Enter a page between 2 and " + total + ".");
        if (v === srcPage) return err("That's the same page you're on.");
        screenOptions(v);
      };
      go.addEventListener("click", submit);
      input.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } });
      input.addEventListener("input", () => { hint.className = "dmb-dupm-hint"; hint.textContent = "Any page from 2 to " + total; });
      opts.appendChild(b2); opts.appendChild(expand);

      const cancel = el("button", "dmb-dupm-cancel", "Cancel"); cancel.type = "button"; cancel.addEventListener("click", close); modal.appendChild(cancel);
    }

    function screenOptions(dst) {
      modal.innerHTML = "";
      modal.appendChild(el("div", "dmb-dupm-title", "Duplicate page"));
      modal.appendChild(el("div", "dmb-dupm-sub", "Copy page " + srcPage + " → page " + dst + "."));
      if (pageHasAnyContent(dst)) modal.appendChild(el("div", "dmb-dupm-warn", "Page " + dst + " already has content — it will be replaced."));
      const opts = el("div", "dmb-dupm-opts"); modal.appendChild(opts);
      const bp = optBtn("With photos", "An exact copy of this page", true);
      bp.addEventListener("click", () => doCopy(dst, true));
      const bl = optBtn("Layout only", "Same design, frames left empty", false);
      bl.addEventListener("click", () => doCopy(dst, false));
      opts.appendChild(bp); opts.appendChild(bl);
      const back = el("button", "dmb-dupm-cancel", "← Back"); back.type = "button"; back.addEventListener("click", screenDestination); modal.appendChild(back);
    }

    function doCopy(dst, withPhotos) {
      pushUndoState("Duplicate Page");
      _dmbDuplicatePageTo(srcPage, dst, withPhotos);
      editor.currentSpread = Math.floor((dst - 1) / 2);
      renderSpread(); renderThumbsRail(); renderPhotoTray();
      close();
    }

    screenDestination();
  }

  function pageHasAnyPhotos(pageNumber) {
    if (isTemplatePage(pageNumber)) {
      const m = editor.pageFrames?.[pageNumber] || {};
      return Object.values(m).some(Boolean);
    }
    const d = editor.pageSlots?.[pageNumber];
    return !!(d && (d.A || d.B));
  }

  // Does this page's spread PARTNER hold an object that reaches across the fold onto
  // THIS page? The PDF already draws that overhang (getSpreadOverflowObjs in the render
  // path), so a page it covers is emphatically not blank. Kept in ONE helper because
  // the two callers below answer opposite questions and drifted apart once already.
  //
  // Rotation-aware on purpose: a rotated object's footprint is its rotated bounding
  // box, not its x..x+w box, so the plain test both under-reports here and - in the
  // render path - silently dropped one half of a rotated straddler. (2026-09-14)
  // Does object `o`, filed on `pageNumber`, reach across the FOLD onto its spread
  // partner? Only the fold side counts: an object bleeding off the OUTER edge of a
  // page is a deliberate full-bleed look and lands on no other sheet.
  //
  // Rotation-aware: drawFreeObjs rotates about the object centre, so the footprint is
  // the rotated bounding box, not x..x+w. Half-width of that box for a w x h rectangle
  // at angle t is (|w*cos t| + |h*sin t|) / 2 - verified against brute-forced corners.
  function _dmbObjOverhangs(o, pageNumber) {
    try {
      if (!o) return false;
      const pn = Number(pageNumber);
      if (!pn || pn < 1) return false;                  // page 0 has no spread partner
      const isLeftPg = (pn % 2 === 1);                  // spreads are (2k+1, 2k+2)
      const sib = isLeftPg ? pn + 1 : pn - 1;
      if (sib < 1 || sib > (editor.totalPages || 0)) return false;
      const PW = getPageDims().w;
      const ow = o.w || 0;
      const rot = (o.rotation || 0) * Math.PI / 180;
      const cx = (o.x || 0) + ow / 2;
      const half = rot
        ? (Math.abs(ow * Math.cos(rot)) + Math.abs((o.h || 0) * Math.sin(rot))) / 2
        : ow / 2;
      return isLeftPg ? (cx + half > PW) : (cx - half < 0);
    } catch (e) { return false; }
  }

  // Does this page's spread PARTNER hold an object that reaches onto THIS page? The
  // PDF already draws that overhang (getSpreadOverflowObjs in the render path), so a
  // page it covers is emphatically not blank.
  function _dmbPartnerOverhang(pageNumber) {
    try {
      const pn = Number(pageNumber);
      if (!pn || pn < 1) return false;
      const sib = (pn % 2 === 1) ? pn + 1 : pn - 1;
      if (sib < 1 || sib > (editor.totalPages || 0)) return false;
      const objs = editor.pageObjects?.[sib] || editor.pageObjects?.[String(sib)] || [];
      if (!Array.isArray(objs) || !objs.length) return false;
      return objs.some(function (o) { return _dmbObjOverhangs(o, sib); });
    } catch (e) { return false; }
  }

  // Horizontal drag range for a page object. A shape or map may be placed anywhere
  // across the SPREAD: its CENTRE decides which page owns it, and dmbHandleCrossPageMove
  // hands ownership over the moment the centre crosses the fold. Every other type keeps
  // the old single-page range, so a photo frame or text box still cannot be lost in the
  // gutter by accident.
  // Horizontal range a bare POINT may reach - a line's ENDPOINT, which has no width of
  // its own so the box-based range above does not describe it. A line is a shape, and
  // shapes may span a spread, so an endpoint may be carried across the fold onto the
  // facing page. Falls back to the single page whenever there is no partner (page 0, the
  // last page of an odd book, the cover).
  function _dmbPointRangeX(pageNumber, pageW) {
    try {
      const pn = Number(pageNumber);
      if (!pn || pn < 1) return { lo: 0, hi: pageW };
      const isLeftPg = (pn % 2 === 1);
      const sib = isLeftPg ? pn + 1 : pn - 1;
      if (sib < 1 || sib > (editor.totalPages || 0)) return { lo: 0, hi: pageW };
      return isLeftPg ? { lo: 0, hi: pageW * 2 } : { lo: -pageW, hi: pageW };
    } catch (e) { return { lo: 0, hi: pageW }; }
  }

  function _dmbObjDragRangeX(obj, pageNumber, pageW) {
    const halfW = ((obj && obj.w) || 0) / 2;
    const lo0 = -halfW, hi0 = pageW - halfW;
    try {
      if (!obj || (obj.type !== "shape" && obj.type !== "map" && obj.type !== "photo-frame")) return { lo: lo0, hi: hi0 };
      const pn = Number(pageNumber);
      if (!pn || pn < 1) return { lo: lo0, hi: hi0 };
      const isLeftPg = (pn % 2 === 1);
      const sib = isLeftPg ? pn + 1 : pn - 1;
      if (sib < 1 || sib > (editor.totalPages || 0)) return { lo: lo0, hi: hi0 };
      return isLeftPg ? { lo: lo0, hi: hi0 + pageW } : { lo: lo0 - pageW, hi: hi0 };
    } catch (e) { return { lo: lo0, hi: hi0 }; }
  }

  function pageHasAnyContent(pageNumber) {
    if (isLockedPage(pageNumber)) return false;
    const si = Math.floor((pageNumber - 1) / 2);
    if (editor.spreadPhoto?.[si]) return true;
    // ANY free object placed on the page counts as content — a text box, sticker,
    // shape, map, line, or a photo-frame (even an empty one) — not just photos.
    const freeObjs = editor.pageObjects?.[pageNumber] || editor.pageObjects?.[String(pageNumber)] || [];
    if (Array.isArray(freeObjs) && freeObjs.length > 0) return true;
    // Half of the neighbour's object is still ink on this sheet.
    if (_dmbPartnerOverhang(pageNumber)) return true;
    // A custom (non-white) page background is content too.
    const bg = editor.pageBackgrounds?.[pageNumber];
    if (bg && String(bg).toLowerCase() !== "#ffffff") return true;
    return pageHasAnyPhotos(pageNumber);
  }

  // STRICTER than pageHasAnyContent: a page is "completely empty" only when the
  // customer put NOTHING on it — no free object at all (text, sticker, shape,
  // map, or any photo-frame, even an empty one), no spread photo covering it, no
  // template slot photo, and no custom (non-white) background. Used for the
  // empty-sheet drop offer at add-to-cart.
  function pageIsCompletelyEmpty(pageNumber) {
    const objs = editor.pageObjects?.[pageNumber] || editor.pageObjects?.[String(pageNumber)] || [];
    if (Array.isArray(objs) && objs.length > 0) return false;
    // This one decides whether the sheet is OFFERED FOR DELETION at add-to-cart, so a
    // false "empty" here does not merely mislabel a page - it drops printed content.
    if (_dmbPartnerOverhang(pageNumber)) return false;
    const si = Math.floor((pageNumber - 1) / 2);
    if (editor.spreadPhoto?.[si]?.photoId) return false;
    if (pageHasAnyPhotos(pageNumber)) return false;
    const bg = editor.pageBackgrounds?.[pageNumber];
    if (bg && String(bg).toLowerCase() !== "#ffffff") return false;
    return true;
  }

  // Physical sheets are facing pairs: page 1 alone, then (2,3),(4,5),… and the
  // last page alone. Only the paired MIDDLE sheets can be dropped, and only when
  // BOTH their pages are completely empty. Returns the empty ones, e.g. [[2,3],[6,7]].
  function _dmbGetEmptySheets() {
    const N = editor.totalPages || 0;
    const out = [];
    for (let p = 2; p + 1 <= N - 1; p += 2) {     // pairs (2,3),(4,5),…,(N-2,N-1)
      if (pageIsCompletelyEmpty(p) && pageIsCompletelyEmpty(p + 1)) out.push([p, p + 1]);
    }
    return out;
  }

  /* The builder's one dialog, in the same ivory "Keepsake" dress as the Add to
   * Cart screens: warm scrim, ivory card, the site's roman heading face, and a
   * pill action. Replaces the browser's own confirm()/alert() boxes, which show
   * the raw domain name and cannot be styled at all.
   *
   * showChoiceDialog(title, message, options[, extra]) -> Promise<id|null>
   *   options: [{ id, label, danger? }]   danger = destructive (warm red)
   *   extra:   { imageUrl }               small preview above the title
   * Two options lay out side by side; three or more stack. Backdrop click and
   * Escape both resolve null, so there is always a way out. (2026-09-13) */
  function showChoiceDialog(title, message, options, extra) {
    return new Promise((resolve) => {
      const X = extra || {};
      const SERIF = "var(--font-heading--family,'Playfair Display'),Georgia,'Times New Roman',serif";
      const SANS  = "var(--font-body--family,'Inter'),system-ui,-apple-system,sans-serif";

      const overlay = document.createElement("div");
      overlay.style.cssText = "position:fixed;inset:0;z-index:1000030;background:rgba(44,40,34,0.55);" +
        "display:flex;align-items:center;justify-content:center;padding:20px;font-family:" + SANS + ";" +
        "opacity:0;transition:opacity .14s ease;";

      const modal = document.createElement("div");
      modal.style.cssText = "background:#F7F3EC;border:1px solid #E7E1D4;border-radius:16px;" +
        "padding:26px 24px 20px;max-width:340px;width:100%;text-align:center;box-sizing:border-box;" +
        "box-shadow:0 24px 60px rgba(44,40,34,0.32);transform:translateY(6px);transition:transform .14s ease;";

      if (X.imageUrl) {
        const im = document.createElement("img");
        im.src = X.imageUrl;
        im.alt = "";
        im.style.cssText = "display:block;width:76px;height:76px;object-fit:cover;border-radius:10px;" +
          "margin:0 auto 14px;box-shadow:0 3px 12px rgba(44,40,34,0.22);";
        modal.appendChild(im);
      }

      const ttl = document.createElement("div");
      ttl.style.cssText = "font-family:" + SERIF + ";font-weight:700;font-size:20px;line-height:1.2;color:#2C2822;";
      ttl.textContent = title;
      modal.appendChild(ttl);

      if (message) {
        const msg = document.createElement("div");
        msg.style.cssText = "font-size:13px;color:#6B6258;line-height:1.5;margin-top:8px;";
        msg.textContent = message;
        modal.appendChild(msg);
      }

      const row = (options || []).length === 2;
      const btnWrap = document.createElement("div");
      btnWrap.style.cssText = "display:flex;gap:8px;margin-top:20px;" +
        (row ? "flex-direction:row;justify-content:center;" : "flex-direction:column;");
      modal.appendChild(btnWrap);

      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      requestAnimationFrame(() => { overlay.style.opacity = "1"; modal.style.transform = "translateY(0)"; });

      let done = false;
      const cleanup = (id) => {
        if (done) return; done = true;
        document.removeEventListener("keydown", onKey);
        overlay.style.opacity = "0";
        setTimeout(() => { try { overlay.remove(); } catch (e) {} }, 140);
        resolve(id);
      };
      const onKey = (e) => { if (e.key === "Escape") { e.preventDefault(); cleanup(null); } };
      document.addEventListener("keydown", onKey);

      (options || []).forEach((opt) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = opt.label;
        const isCancel = opt.id === "cancel";
        const bg = opt.danger ? "#A6402F" : (isCancel ? "transparent" : "#6B62D6");
        btn.style.cssText = "font-family:inherit;font-weight:600;font-size:13.5px;cursor:pointer;" +
          "border-radius:99px;padding:11px 20px;" + (row ? "flex:1 1 0;min-width:0;" : "") +
          "background:" + bg + ";" +
          "color:" + (isCancel ? "#6B6258" : "#fff") + ";" +
          "border:1px solid " + (isCancel ? "#DDD5C4" : bg) + ";";
        btn.addEventListener("click", () => cleanup(opt.id));
        btnWrap.appendChild(btn);
      });

      overlay.addEventListener("click", (e) => { if (e.target === overlay) cleanup(null); });
    });
  }

  async function handleSpreadZoneDrop(zone, payload, leftPage, rightPage, si) {
    const photoId = payload?.photoId;
    if (!photoId) return;
    const used = getUsedPhotoIds();
    if (payload.type === "photo" && used.has(photoId)) showReuseNotice();

    if (zone === "left") {
      const hasContent = pageHasAnyContent(leftPage);
      if (hasContent) {
        const choice = await showChoiceDialog("Page has content", "This page already has content. What would you like to do?", [
          { id: "replace", label: "Replace existing content" },
          { id: "add", label: "Add alongside" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
        if (choice === "replace") {
          pushUndoState();
          clearPageAllLayouts(leftPage);
          editor.pageSlots[leftPage].A = photoId;
        } else {
          pushUndoState();
          if (!editor.pageSlots[leftPage].B) {
            editor.pageSlots[leftPage].B = editor.pageSlots[leftPage].A ? photoId : null;
            if (!editor.pageSlots[leftPage].A) editor.pageSlots[leftPage].A = photoId;
            else editor.pageSlots[leftPage].B = photoId;
          } else {
            editor.pageSlots[leftPage].A = photoId;
          }
        }
      } else {
        pushUndoState();
        if (!editor.pageSlots[leftPage]) editor.pageSlots[leftPage] = { A: null, B: null };
        editor.pageSlots[leftPage].A = photoId;
      }
    } else if (zone === "right") {
      if (!rightPage || rightPage > editor.totalPages) return;
      const hasContent = pageHasAnyContent(rightPage);
      if (hasContent) {
        const choice = await showChoiceDialog("Page has content", "This page already has content. What would you like to do?", [
          { id: "replace", label: "Replace existing content" },
          { id: "add", label: "Add alongside" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
        if (choice === "replace") {
          pushUndoState();
          clearPageAllLayouts(rightPage);
          editor.pageSlots[rightPage].A = photoId;
        } else {
          pushUndoState();
          if (!editor.pageSlots[rightPage]) editor.pageSlots[rightPage] = { A: null, B: null };
          if (!editor.pageSlots[rightPage].A) editor.pageSlots[rightPage].A = photoId;
          else if (!editor.pageSlots[rightPage].B) editor.pageSlots[rightPage].B = photoId;
          else editor.pageSlots[rightPage].A = photoId;
        }
      } else {
        pushUndoState();
        if (!editor.pageSlots[rightPage]) editor.pageSlots[rightPage] = { A: null, B: null };
        editor.pageSlots[rightPage].A = photoId;
      }
    } else if (zone === "spread") {
      const leftHas = pageHasAnyContent(leftPage);
      const rightHas = rightPage <= editor.totalPages && pageHasAnyContent(rightPage);
      if (leftHas || rightHas) {
        let clearMsg = "Placing a full-spread photo will clear content on ";
        if (leftHas && rightHas) clearMsg += "both pages.";
        else if (leftHas) clearMsg += "the left page.";
        else clearMsg += "the right page.";
        const choice = await showChoiceDialog("Full spread photo", clearMsg, [
          { id: "continue", label: "Continue" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
      }
      pushUndoState();
      clearPageAllLayouts(leftPage);
      if (rightPage <= editor.totalPages) clearPageAllLayouts(rightPage);
      if (!editor.spreadPhoto) editor.spreadPhoto = {};
      editor.spreadPhoto[si] = { photoId, panX: 0, panY: 0, zoom: 1 };
    }
    renderSpread();
    renderThumbsRail();
    renderPhotoTray();
  }

  async function setPageTemplateWithConfirm(pageNumber, templateId) {
    if (isLockedPage(pageNumber)) return false;

    const pageHasPhotos = pageHasAnyPhotos(pageNumber);
    if (pageHasPhotos) {
      const choice = await showChoiceDialog(
        "This page has photos",
        "How would you like to apply the layout?",
        [
          { id: "over", label: "Apply layout over existing photos" },
          { id: "replace", label: "Remove photos and apply layout" },
          { id: "cancel", label: "Cancel" }
        ]
      );
      if (!choice || choice === "cancel") return false;
      pushUndoState();
      if (choice === "replace") clearPageAllLayouts(pageNumber);
    } else {
      pushUndoState();
      clearPageAllLayouts(pageNumber);
    }

    // A chosen layout now drops individual FREE photo-frames (one per slot) so
    // each is clickable / movable / resizable / deletable like a lonely frame and
    // the card layouts — instead of a locked template. Default (null) → no frames.
    if (templateId && TEMPLATE_DEFS[templateId]) _dmbSpawnLayoutFrames(pageNumber, templateId);
    else ensureTemplateState(pageNumber, null);
    renderSpread();
    renderThumbsRail();
    renderPhotoTray();
    return true;
  }

  // Spawn a layout as individual FREE photo-frame objects (one per TEMPLATE_DEFS
  // slot, % → page px). Reuses the whole lonely-frame system (render, drag,
  // resize, delete via keyboard, photo-drop, PDF export). Replaces a previous
  // layout's frames but keeps manually-added frames, text and stickers.
  function _dmbSpawnLayoutFrames(pageNumber, templateId) {
    const slots = TEMPLATE_DEFS[templateId] || [];
    const dims = getPageDims();
    ensureTemplateState(pageNumber, null);                 // skip the locked-template render path
    const arr = ensurePageObjects(pageNumber);
    for (let i = arr.length - 1; i >= 0; i--) if (arr[i].type === "photo-frame" && arr[i].fromLayout) arr.splice(i, 1);
    const now = Date.now();
    slots.forEach((s, i) => {
      const obj = newFrameObject({ targetType: "page", page: pageNumber });
      obj.fromLayout = true;
      obj.x = Math.round(s.x / 100 * dims.w);
      obj.y = Math.round(s.y / 100 * dims.h);
      obj.w = Math.round(s.w / 100 * dims.w);
      obj.h = Math.round(s.h / 100 * dims.h);
      obj.z = now + i;
      arr.push(obj);
    });
  }

  function rotateCCW90(editorObj, pageNumber, slot) {
    if (!editorObj.pageRot[pageNumber]) {
      editorObj.pageRot[pageNumber] = { A: 0, B: 0 };
    }
    const cur = editorObj.pageRot[pageNumber][slot] || 0;
    editorObj.pageRot[pageNumber][slot] = (cur - 90 + 360) % 360;
  }

  function rotateFrameCCW90(editorObj, pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) {
      if (!editorObj.pageFrameRot[pageNumber]) editorObj.pageFrameRot[pageNumber] = {};
      const cur = editorObj.pageFrameRot[pageNumber][slotKey] || 0;
      editorObj.pageFrameRot[pageNumber][slotKey] = (cur - 90 + 360) % 360;
    } else {
      rotateCCW90(editorObj, pageNumber, slotKey);
    }
  }

  function getFramePhotoId(pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) return editor.pageFrames?.[pageNumber]?.[slotKey] || null;
    return editor.pageSlots?.[pageNumber]?.[slotKey] || null;
  }

  function setFramePhotoId(pageNumber, slotKey, photoId) {
    if (isTemplatePage(pageNumber)) editor.pageFrames[pageNumber][slotKey] = photoId || null;
    else editor.pageSlots[pageNumber][slotKey] = photoId || null;
  }

  function getFrameRotation(pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) return editor.pageFrameRot?.[pageNumber]?.[slotKey] || 0;
    return editor.pageRot?.[pageNumber]?.[slotKey] || 0;
  }

  function setFrameRotation(pageNumber, slotKey, deg) {
    if (isTemplatePage(pageNumber)) editor.pageFrameRot[pageNumber][slotKey] = deg || 0;
    else editor.pageRot[pageNumber][slotKey] = deg || 0;
  }

  function clearFrame(pageNumber, slotKey) {
    setFramePhotoId(pageNumber, slotKey, null);
    setFrameRotation(pageNumber, slotKey, 0);
  }

  function getBodyRelativeFrameRects(bodyEl, pageNumber) {
    const tid = getPageTemplateId(pageNumber);
    if (!tid) return null;

    const def = TEMPLATE_DEFS[tid];
    const w = bodyEl.clientWidth || 1;
    const h = bodyEl.clientHeight || 1;

    return def.map((f) => ({
      key: f.key,
      x: (f.x / 100) * w,
      y: (f.y / 100) * h,
      w: (f.w / 100) * w,
      h: (f.h / 100) * h
    }));
  }

  function pickNearestTemplateFrame(bodyEl, pageNumber, clientX, clientY) {
    const rects = getBodyRelativeFrameRects(bodyEl, pageNumber);
    if (!rects || !rects.length) return null;

    const b = bodyEl.getBoundingClientRect();
    const x = clientX - b.left;
    const y = clientY - b.top;

    for (const r of rects) {
      if (x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h) return r;
    }

    let best = null;
    let bestD = Infinity;
    rects.forEach((r) => {
      const cx = r.x + r.w / 2;
      const cy = r.y + r.h / 2;
      const d = (cx - x) ** 2 + (cy - y) ** 2;
      if (d < bestD) {
        bestD = d;
        best = r;
      }
    });
    return best;
  }

  function renderTemplateMini(el, templateId) {
    el.innerHTML = "";
    const defs = TEMPLATE_DEFS[templateId] || [];
    defs.forEach((f) => {
      const d = document.createElement("div");
      d.className = "dmb-template-mini-frame";
      d.style.left = f.x + "%";
      d.style.top = f.y + "%";
      d.style.width = f.w + "%";
      d.style.height = f.h + "%";
      el.appendChild(d);
    });
  }

  function buildTemplatePanel(pageNumber, pageEl) {
    const panel = document.createElement("div");
    panel.className = "dmb-template-panel";
    panel.style.display = "none";

    const title = document.createElement("div");
    title.className = "dmb-template-panel-title";
    title.textContent = "Choose template";
    panel.appendChild(title);

    const list = document.createElement("div");
    list.className = "dmb-template-list";
    panel.appendChild(list);

    const addItem = (id, name, subtitle, isDefault = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";

      const currentId = getPageTemplateId(pageNumber);
      if ((isDefault && !currentId) || (!isDefault && currentId === id)) {
        btn.classList.add("active");
      }

      const row = document.createElement("div");
      row.className = "dmb-template-item-row";

      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";

      if (isDefault) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.left = "0";
        a.style.top = "0";
        a.style.width = "100%";
        a.style.height = "49%";

        const b = document.createElement("div");
        b.className = "dmb-template-mini-frame";
        b.style.left = "0";
        b.style.top = "51%";
        b.style.width = "100%";
        b.style.height = "49%";

        mini.appendChild(a);
        mini.appendChild(b);
      } else {
        renderTemplateMini(mini, id);
      }

      const txt = document.createElement("div");
      txt.style.minWidth = "0";

      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;

      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;

      txt.appendChild(nm);
      txt.appendChild(sub);

      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);

      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isDefault) await setPageTemplateWithConfirm(pageNumber, null);
        else await setPageTemplateWithConfirm(pageNumber, id);
      });

      list.appendChild(btn);
    };

    addItem(null, "Default Layout", "1 photo full / 2-photo split", true);

    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });

    pageEl.appendChild(panel);
    return panel;
  }

  // ---------- elements ----------
  const params = new URLSearchParams(window.location.search);
  const stepParam    = params.get("step");
  const mode         = params.get("mode");
  const restoreParam = params.get("restore");
  const coverTitleParam = params.get("cover_title");
  const coverImgParam = params.get("cover_img");
  const coverHandleParam = params.get("cover");
  const templateParam = params.get("template");

  const step1 = $("step1");
  const step2 = $("step2");
  const step3 = $("step3");
  const builderStep = step2;
  const exportTemplateBtn = $("exportTemplateBtn");

  const selectedCoverBox = $("selectedCoverBox");
  const selectedCoverImg = $("selectedCoverImg");
  const selectedCoverTitle = $("selectedCoverTitle");
  const bookDetails = $("bookDetails");
  const customizeBlock = $("customizeBlock");

  const titleEl = $("bookTitle"); // legacy fallback
  const pagesEl = $("pages");
  const mainError = $("mainError");

  const priceBox = $("priceBox");
  const oldPriceEl = $("oldPrice");
  const newPriceEl = $("newPrice");

  const photosEl = $("bookPhotos");
  const photoRuleEl = $("photoRule");
  const photoCountEl = $("photoCount");
  const photoErrorEl = $("photoError");
  const photoPreviewEl = $("photoPreview");

  // cover designer
  const chooseCoverTemplateBtn = $("chooseCoverTemplateBtn");
  const coverTemplatePanel = $("coverTemplatePanel");
  const coverTitle1Input = $("coverTitle1");
  const coverTitle2Input = $("coverTitle2");
  const coverColorInput = $("coverColor");
  const coverColorSwatch = $("coverColorSwatch");
  const coverImageInput = $("coverImageInput");

  // editor ui
  const editorPhotoTray = $("editorPhotoTray");
  const bookMeta = $("bookMeta");
  const spreadIndexEl = $("spreadIndex");
  const spreadCanvas = $("spreadCanvas");
  const prevSpreadBtn = $("prevSpreadBtn");
  const nextSpreadBtn = $("nextSpreadBtn");
  const backToDetailsBtn = $("backToDetailsBtn");
  const saveLayoutBtn = $("saveLayoutBtn");
  const saveTemplateBtn = $("saveTemplateBtn");
  const saveMsg = $("saveMsg");
  const undoBtn = $("undoBtn");
  const addToCartBtn = $("addToCartBtn");
  const thumbsRail = $("thumbsRail");
  const spreadViewport = $("spreadViewport");
  const redoBtn = $("redoBtn");
  const previewBtn = $("previewBtn");
  const zoomInBtn = $("zoomInBtn");
  const zoomOutBtn = $("zoomOutBtn");
  const zoomResetBtn = $("zoomResetBtn");
  const smartCreationBtn = $("smartCreationBtn");
  const coverThumbBtn = $("coverThumbBtn");
  const canvasTextBtn = $("canvasTextBtn");
  const canvasPhotoBtn = $("canvasPhotoBtn");
  const canvasLayoutBtn = $("canvasLayoutBtn");
  const canvasShapeBtn = $("canvasShapeBtn");
  const canvasLayersBtn = $("canvasLayersBtn");
  const canvasDeleteBtn = $("canvasDeleteBtn");
  const addTextBtn = $("addTextBtn");
  const projectMenuBtn = $("projectMenuBtn");
  const historyBtn = $("historyBtn");
  const addMorePhotosBtn = $("addMorePhotosBtn");
  const importDeviceBtn = $("importDeviceBtn");
  const importCameraBtn = $("importCameraBtn");
  const cameraPhotos = $("cameraPhotos");
  const photoSortSelect = $("photoSortSelect");
  const hideUsedPhotosToggle = $("hideUsedPhotosToggle");
  const coverThumbBtnEl = $("coverThumbBtn");

  if (!step1 || !builderStep) return;

  // ---------- state ----------
  let bookFiles = [];
  let currentMin = 0;
  let currentMax = 0;
  let hideUsedPhotos = false;
  let currentPhotoSort = "earliest";
  let currentPhotoSearch = "";
  // Default canvas zoom: 50% on phones (so the very first render is already 50% —
  // no lag, no 100%→50% flash), 100% on iPad/desktop.
  function _dmbDefaultZoom() {
    return ((("ontouchstart" in window) || (navigator.maxTouchPoints > 0)) &&
      Math.min(window.screen.width || 9999, window.screen.height || 9999) <= 500) ? 0.5 : 1;
  }
  let currentZoom = _dmbDefaultZoom();
  let redoStack = [];
  let builderMode = "pages";
  let selectedObject = null;
  let activeCoverZone = "front";

  // ---------- undo ----------
  const undoStack = [];
  const UNDO_LIMIT = 50;

  function cloneState(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  // Build the template payload with test photos stripped. Shared by "Save to
  // store" and the download fallback so the two can never drift apart.
  function _dmbBuildStrippedTemplatePayload() {
    const payload = buildTemplatePayload();
    // Strip test photos — keep everything else (text, stickers, icons, maps)
    payload.coverState.frontImageUrl = "";
    payload.coverState.backImageUrl = "";
    payload.coverState.imageUrl = "";
    payload.coverState.imageFile = null;
    // ── Strip the photo IDS too, not only the URLs ────────────────────────────
    // Photo ids are per-customer. Published templates carried the TEMPLATE
    // AUTHOR's ids, which exist in nobody else's library, so every customer who
    // applied one got a cover declaring a front photo that could not resolve:
    // the PDF drew nothing (silently), and render mode failed the whole job on
    // the phantom id - dropping the order to the unguarded browser path with NO
    // proof screen. A template ships a design, never someone else's photos.
    payload.coverState.frontImageId = "";
    payload.coverState.backImageId  = "";
    payload.coverState.bleedImageId = "";
    // A blob: URL is this session's object URL and is dead everywhere else. Real
    // https template URLs are kept - those work for every customer.
    ["bleedImageUrl", "spineImageUrl"].forEach(function (k) {
      if (String(payload.coverState[k] || "").startsWith("blob:")) payload.coverState[k] = "";
    });
    if (!payload.coverState.bleedImageUrl) {
      payload.coverState.bleedZone = ""; payload.coverState.bleedImageRot = 0;
    }
    payload.coverObjects = (payload.coverObjects || []).map(obj =>
      obj.type === "photo-frame" ? { ...obj, imageUrl: null, imageData: null } : obj
    );
    if (payload.page0?.pageSlots) payload.page0.pageSlots = { A: null, B: null };
    return payload;
  }

  // Upload each cover/page object's inline base64 crop image to R2 as a separate
  // template file and swap the base64 for a GET url, IN PLACE on the payload. Keeps
  // the template JSON tiny so it loads fast (was ~20 MB inlined → failed to load →
  // blank cover). Rendering is unchanged: the url serves the exact same cropped PNG.
  async function _dmbExternalizeTemplateImages(id, password, payload, proxy) {
    const jobs = [];
    const process = (arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((o) => {
        if (!o || !o.id) return;
        let du = null, field = null;
        if (typeof o.tightUrl === "string" && o.tightUrl.slice(0, 5) === "data:") { du = o.tightUrl; field = "tightUrl"; }
        else if (typeof o.url === "string" && o.url.slice(0, 5) === "data:") { du = o.url; field = "url"; }
        if (!du) return;
        jobs.push((async () => {
          try {
            const blob = await (await fetch(du)).blob();
            const r = await fetch(proxy + "/template-image?id=" + encodeURIComponent(id) + "&oid=" + encodeURIComponent(o.id), {
              method: "POST", credentials: "same-origin",
              headers: { "content-type": blob.type || "image/png", "x-template-password": password },
              body: blob,
            });
            if (r && r.ok) {
              o[field] = proxy + "/template-image?id=" + encodeURIComponent(id) + "&oid=" + encodeURIComponent(o.id);
            }
          } catch (e) {}
        })());
      });
    };
    process(payload.coverObjects);
    if (payload.page0 && payload.page0.pageObjects) {
      Object.keys(payload.page0.pageObjects).forEach((k) => process(payload.page0.pageObjects[k]));
    }
    await Promise.all(jobs);
  }

  // The template id = the active cover/magazine handle, so save & load stay
  // symmetric with _dmbFetchTemplateData (which fetches by this same handle).
  function _dmbActiveTemplateId() {
    if (window.DMB_MAGAZINE_MODE) {
      const mh = sessionStorage.getItem("dmb_mag_template") || coverHandleParam || "";
      return (mh || "").trim();
    }
    return (coverHandleParam || "").trim();
  }

  function exportTemplateJSON() {
    const payload = _dmbBuildStrippedTemplatePayload();
    const json = JSON.stringify(payload, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    // Use the book handle so each book type has its own template file.
    // e.g. ?cover=photobook-20x20 → cover-photobook-20x20.json
    // Falls back to cover-default.json when no handle is in the URL.
    const _handle = _dmbActiveTemplateId();
    a.download = _handle ? ("cover-" + _handle + ".json") : "cover-default.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  // "Save to store": publish the current design straight to R2 as the template
  // for this book — no download → hand-off → push. The password is verified in
  // the Worker (the prompt just collects it). Falls back to a download if the
  // save call fails, so the owner is never stuck.
  function saveTemplateToStore() {
    // Uses an in-page modal instead of native window.prompt/confirm/alert. Browsers
    // (Chrome/Safari) SILENTLY suppress those dialogs once a page has shown a few of
    // them ("Don't allow this page to prompt you again") — after which prompt()
    // returns null with no UI, so the Publish button appeared to do NOTHING. The
    // modal can't be suppressed, and it also lets the admin type the template id when
    // the URL has no ?cover= handle (previously a dead-end alert).
    _dmbShowPublishTemplateModal();
  }

  function _dmbShowPublishTemplateModal() {
    if (document.getElementById("dmbPublishTplModal")) return;
    const landscape = (typeof editor !== "undefined" && editor && editor.orientation === "landscape");
    let presetId = "";
    try { presetId = _dmbActiveTemplateId() || ""; } catch (e) {}
    let title = presetId;
    try { const l = (window._dmbCoverTplImages || {})[presetId]; if (l && l.title) title = l.title; } catch (e) {}

    const ov = document.createElement("div");
    ov.id = "dmbPublishTplModal";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000002;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.55);padding:18px;";
    ov.innerHTML =
      '<div style="background:#fff;border-radius:16px;max-width:340px;width:100%;padding:22px 20px;box-shadow:0 24px 70px rgba(0,0,0,.35);font-family:inherit;box-sizing:border-box;">' +
        '<label style="display:block;font-size:13px;font-weight:700;color:#444;margin:0 0 6px;">Admin PassCode</label>' +
        '<input id="dmbPubTplPw" type="password" autocomplete="off" style="width:100%;box-sizing:border-box;padding:11px 12px;border:1px solid #ccc;border-radius:9px;font-size:14px;margin:0 0 8px;">' +
        '<div id="dmbPubTplMsg" style="min-height:16px;font-size:13px;font-weight:600;line-height:1.4;margin:0 0 12px;"></div>' +
        '<button id="dmbPubTplGo" type="button" style="width:100%;background:#1e1e1e;color:#fff;border:none;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;">Publish</button>' +
      '</div>';
    document.body.appendChild(ov);

    const close = () => { try { ov.remove(); } catch (e) {} };
    const msg = (t, ok) => { const m = document.getElementById("dmbPubTplMsg"); if (m) { m.textContent = t; m.style.color = ok ? "#1a7f37" : "#c0392b"; } };
    ov.addEventListener("click", (e) => { if (e.target === ov) close(); });   // click outside to close

    async function _doPublish() {
      const pwEl = document.getElementById("dmbPubTplPw");
      const goBtn = document.getElementById("dmbPubTplGo");
      const id = presetId;                       // template id comes from the ?cover= handle
      const password = (pwEl.value || "");
      if (!id) { msg("Open a book with a cover in the URL first."); return; }
      if (!password) { msg("Enter the admin passcode."); pwEl.focus(); return; }
      let ttl = title || id;
      try { const l = (window._dmbCoverTplImages || {})[id]; if (l && l.title) ttl = l.title; } catch (e) {}
      goBtn.disabled = true; goBtn.textContent = "Publishing…"; msg("Saving…", true);
      try {
        const payload = _dmbBuildStrippedTemplatePayload();
        const proxy = window.DMB_DESIGNS_PROXY || "/apps/designs";
        // Externalize the heavy base64 crop images (sticker/icon `tightUrl`) to R2
        // as separate files and replace them with GET urls, so the template JSON is
        // tiny. Inlining them made templates ~20 MB → they failed to load and the
        // cover came up blank. Rendering is unchanged (the url points at the exact
        // same cropped PNG).
        msg("Uploading images…", true);
        try { await _dmbExternalizeTemplateImages(id, password, payload, proxy); } catch (e) {}
        msg("Saving…", true);
        const resp = await fetch(proxy + "/save-template", {
          method: "POST", credentials: "same-origin",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ password, id, title: ttl, orientation: landscape ? "landscape" : "portrait", json: payload })
        });
        let data = {}; try { data = await resp.json(); } catch (e) {}
        if (resp.ok && data.ok) {
          msg("✓ Published.", true);
          goBtn.textContent = "Published ✓";
          setTimeout(close, 1600);
          return;
        }
        goBtn.disabled = false; goBtn.textContent = "Publish";
        if (resp.status === 401) { msg("Incorrect passcode — not saved."); return; }
        if (resp.status === 503) { msg("Publishing isn't configured (the passcode secret is missing)."); return; }
        msg("Couldn't publish (" + (data.error || ("HTTP " + resp.status)) + ").");
      } catch (e) {
        goBtn.disabled = false; goBtn.textContent = "Publish";
        msg("Network error (" + (e && e.message ? e.message : "failed") + ").");
      }
    }

    document.getElementById("dmbPubTplGo").addEventListener("click", _doPublish);
    document.getElementById("dmbPubTplPw").addEventListener("keydown", (e) => { if (e.key === "Enter") _doPublish(); });
    setTimeout(() => { try { document.getElementById("dmbPubTplPw").focus(); } catch (e) {} }, 50);
  }


  // ── Predesigned-cover template: cache + background prefetch ────────────────
  // The template (cover-<handle>.json) is fetched over the network. Fetching it
  // only at builder-entry meant a slow/flaky connection could leave the cover
  // blank. So we WARM it as soon as the handle is known (on the upload step) and
  // cache the result per handle, making the later apply instant. Failed fetches
  // are NOT cached, so a later attempt retries.
  const _dmbTplCache = {};   // handle → Promise<data|null>
  function _dmbFetchTemplateData(tag) {
    // Load order: R2 first (self-service, theme-independent), then the theme
    // asset as a fallback. The ~60 pre-existing predesigned covers still live as
    // theme assets, so nothing that works today breaks — R2 just 404s for those
    // and we fall through. Any template saved via "Save to store" lives in R2 and
    // wins from then on, so it survives theme swaps.
    const ls = (typeof editor !== "undefined" && editor && editor.orientation === "landscape");

    // ── R2 (through the App Proxy). Shopify signs the request so the Worker
    //    trusts it; unsaved templates return 404 and we move on to the asset. ──
    const _fetchR2 = (t) => {
      const proxy = window.DMB_DESIGNS_PROXY || "/apps/designs";
      // Cache-bust the R2 read. It previously had NO buster (the asset path below
      // does), so after the owner re-published a template it kept showing the OLD
      // version on OTHER devices (the publishing device showed its live/in-memory
      // copy, so it "worked there" but not on the phone). A per-load token + no-store
      // makes a re-published template appear on the next load anywhere. Extra query
      // params are still covered by Shopify's App-Proxy signature (like &ls=), so the
      // Worker keeps trusting the request. Templates load ~once per session, so the
      // dropped edge-caching is negligible.
      const _bust = "&v=" + Date.now();
      return fetch(proxy + "/template?id=" + encodeURIComponent(t) + "&ls=" + (ls ? 1 : 0) + _bust,
                   { credentials: "same-origin", cache: "no-store" })
        .then((r) => (r && r.ok) ? r.json() : null)
        .catch(() => null);
    };

    // ── Theme asset (legacy home of the predesigned covers). ──
    const _fetchAsset = (t) => {
      const base = new URL(window.DMB_ASSET_BASE, window.location.href);
      base.pathname = base.pathname.replace(/\/[^\/]+$/, "/cover-" + t + ".json");
      // Cache-buster. Shopify's CDN caches these JSONs for a YEAR at a fixed URL,
      // so the OLD version of an updated template kept serving forever (updates
      // never showed). A ~5-minute time bucket keeps the URL stable within a short
      // window (still well cached) but rolls over often enough that a re-pushed
      // template appears within a few minutes — no JS deploy required.
      base.search = "?v=" + Math.floor(Date.now() / 300000);
      return fetch(base.toString(), { cache: "no-store" });
    };

    // Try as-is; if it 404s, retry uppercased (predesigned codes are stored
    // uppercase, e.g. cover-HCITA2603.json) so a mis-cased serial_number still
    // resolves. Custom lowercase handles succeed on the first try.
    const up = String(tag).toUpperCase();
    return _fetchR2(tag)
      .then((d) => d || (up !== tag ? _fetchR2(up) : null))
      .then((d) => {
        if (d) return d;
        return _fetchAsset(tag)
          .then((resp) => {
            if (resp && resp.ok) return resp;
            return (up !== tag) ? _fetchAsset(up) : resp;
          })
          .then((resp) => (resp && resp.ok) ? resp.json() : null)
          .catch(() => null);
      });
  }
  function _dmbWarmTemplate(tag) {
    if (!tag) return Promise.resolve(null);
    let p = _dmbTplCache[tag];
    if (!p) {
      p = _dmbFetchTemplateData(tag);
      _dmbTplCache[tag] = p;
      // Drop a failed result so the next request retries instead of reusing null.
      p.then((data) => { if (!data) { try { delete _dmbTplCache[tag]; } catch (e) {} } });
    }
    return p;
  }

  async function dmbApplyCoverTemplate(tag, force) {
    if (!tag) return;
    // A predesigned template is only a STARTING point. The moment a customer has ANY
    // cover design, we must NEVER overwrite it with the template — the printed PDF has to
    // reproduce exactly the cover they made, edited or not. Only an explicit, confirmed
    // "apply this template" (force) may replace an existing cover. This blocks the
    // automatic open/restore paths from silently reverting or swapping the cover.
    if (!force) {
      const _hasCoverWork =
        (Array.isArray(editor.coverObjects) && editor.coverObjects.length > 0) ||
        (Array.isArray(editor.coverUserTexts) && editor.coverUserTexts.length > 0) ||
        !!coverState.frontImageId || !!coverState.frontImageUrl ||
        !!coverState.backImageId  || !!coverState.backImageUrl  ||
        !!coverState.bleedImageId || !!coverState.bleedImageUrl || !!coverState.spineImageUrl ||
        !!(coverState.title1 && String(coverState.title1).trim()) ||
        !!(coverState.title2 && String(coverState.title2).trim());
      if (_hasCoverWork) return;   // keep the customer's cover — do NOT re-apply the template
    }
    try {
      // Use the prefetched copy when warming already ran (instant); otherwise this
      // starts the fetch now. If the warmed result was null (failed earlier), make
      // one fresh attempt before giving up.
      let data = await _dmbWarmTemplate(tag);
      if (!data) data = await _dmbFetchTemplateData(tag);
      if (!data) return;
      // Apply from a private deep copy so editing the cover never mutates the
      // cached template (the cache may be reused if the template is applied again).
      data = cloneState(data);
      if (data.coverState) {
        Object.assign(coverState, data.coverState);
        syncCoverInputsFromState();
      }
      if (Array.isArray(data.coverObjects)) {
        editor.coverObjects = data.coverObjects;
      }
      if (data.activeCoverZone) activeCoverZone = data.activeCoverZone;
      if (data.coverUserTexts) editor.coverUserTexts = cloneState(data.coverUserTexts);
      // Spine text in templates starts at 6px — the spine is a thin 8 mm strip, so
      // the templates' larger spine sizes would overflow it. Customers can resize
      // afterwards (this only sets the template's starting size, stored per-design).
      try {
        (editor.coverUserTexts || []).forEach(function (t) {
          if (t && t.zone === "spine" && coverState.textStyles && coverState.textStyles[t.id]) {
            coverState.textStyles[t.id].fontSize = "6px";
          }
        });
      } catch (e) {}
      if (data.page0) {
        if (!editor.pageSlots) editor.pageSlots = {};
        if (!editor.pageFrames) editor.pageFrames = {};
        if (!editor.pageTemplate) editor.pageTemplate = {};
        if (!editor.pageObjects) editor.pageObjects = {};
        if (!editor.pageRot) editor.pageRot = {};
        editor.pageSlots[0] = cloneState(data.page0.pageSlots || { A: null, B: null });
        editor.pageFrames[0] = cloneState(data.page0.pageFrames || {});
        editor.pageTemplate[0] = data.page0.pageTemplate || null;
        editor.pageObjects[0] = cloneState(data.page0.pageObjects || []);
        editor.pageRot[0] = cloneState(data.page0.pageRot || { A: 0, B: 0 });
      }
      // A predesigned template may ship a fixed-slot cover layout (frontLayout/
      // frontFrames). Convert it to deletable free photo-frames so the customer can
      // move/resize/delete them like any other frame.
      try { _dmbConvertCoverFixedLayouts(); } catch (e) {}
      renderCoverCanvas();
      // Template also replaces page 0 content — dirty-mark it too
      try { _dmbPvMarkDirty(0); } catch(e) {}
    } catch (err) {
      console.warn("[DMB] Cover template load failed:", err);
    }
  }

  function getTemplateKey() {
    const liveTemplate = new URLSearchParams(window.location.search).get("template");
    return (liveTemplate || "").trim();
  }

  // ── Customer progress save/load (per-book, persists across sessions) ──────

  function getCustomerSaveKey() {
    // RENDER MODE: the design id comes from the JOB RECORD - no URL param, no
    // localStorage read, no mint. Without this, a render URL (which carries no
    // ?design/?cover/?template) makes _dmbActiveCustomId() MINT and WRITE a random
    // id, and then every photo fetch and staging call targets a design that does
    // not exist.
    if (_dmbRenderMode() && window.__DMB_RENDER_JOB) return "dmb_progress_" + window.__DMB_RENDER_JOB;
    const type = window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "mag" : "book";
    // Predesigned template or a product cover handle → keep the existing per-template/
    // per-product key (UNCHANGED — no behaviour change, no orphaning of existing saves).
    let suffix = getTemplateKey();                    // predesigned template
    if (!suffix) {
      try { suffix = new URLSearchParams(location.search).get("cover") || ""; } catch (e) {}
    }
    if (suffix) return `dmb_progress_${type}_${suffix}`;
    // Custom book (no template, no cover): give it its OWN permanent id so two
    // custom books never overwrite each other. Honour ?design= (resume links),
    // else the remembered "active" id (so a revisit still resumes the current one).
    let id = "";
    try { id = new URLSearchParams(location.search).get("design") || ""; } catch (e) {}
    if (!id) id = _dmbActiveCustomId(type);
    return `dmb_progress_${type}_${id}`;
  }
  // Persistent per-browser id of the custom design currently being worked on.
  function _dmbActiveCustomId(type) {
    const k = "dmb_active_design_" + type;
    try {
      let id = localStorage.getItem(k);
      if (!id) {
        // Back-compat: keep using a legacy shared "custom" design if one exists.
        id = localStorage.getItem(`dmb_progress_${type}_custom`)
          ? "custom"
          : ("d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6));
        localStorage.setItem(k, id);
      }
      return id;
    } catch (e) { return "custom"; }
  }
  // Start a brand-new custom design slot (old one is preserved under its id).
  function _dmbRotateCustomId() {
    const type = window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "mag" : "book";
    try {
      // Only meaningful for custom books (no template / cover handle).
      if (getTemplateKey()) return;
      if (new URLSearchParams(location.search).get("cover")) return;
      localStorage.setItem("dmb_active_design_" + type, "d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6));
      // Drop any ?design= from the URL so the new active id is used.
      const u = new URL(location.href); u.searchParams.delete("design");
      history.replaceState(null, "", u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  // ── IndexedDB photo persistence ──────────────────────────────────────────
  function _openPhotoDB() {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open("dmb_photo_store", 1);
      req.onupgradeneeded = (e) => {
        const db = e.target.result;
        if (!db.objectStoreNames.contains("blobs")) db.createObjectStore("blobs");
      };
      req.onsuccess = (e) => resolve(e.target.result);
      req.onerror = () => reject(req.error);
    });
  }

  // Returns true only when bytes were actually written, false otherwise — so the
  // caller can retry and/or warn the customer instead of silently losing photos.
  // Per-saveKey set of pids already written to IndexedDB this session, so repeated
  // saves during an upload only touch NEW photos (no re-reading the whole library).
  const _dmbIdbSavedByKey = {};
  async function _savePhotosToIDB(saveKey, photos) {
    if (!Array.isArray(photos) || !photos.length) return false;
    try {
      // PHONE-MEMORY CRITICAL: write ONE photo at a time. The old code read EVERY
      // photo's full ArrayBuffer into a single array before writing (to dodge IDB's
      // auto-commit between awaits) — so the entire library sat in RAM as buffers
      // ON TOP of the File blobs, and it re-ran on every upload batch. On a phone
      // that doubling is what triggered "a problem repeatedly occurred" (WebKit
      // OOM). Here each photo is read + written in its OWN transaction (self-
      // contained, so no auto-commit race), then its buffer is released before the
      // next — peak memory is ONE photo's bytes, regardless of library size.
      //
      // Bytes are stored as ArrayBuffers (NOT Blobs): iOS keeps IDB Blobs as
      // file-backed refs that can be purged and read back EMPTY → blank photos.
      let saved = _dmbIdbSavedByKey[saveKey];
      if (!saved) { saved = new Set(); _dmbIdbSavedByKey[saveKey] = saved; }

      const db = await _openPhotoDB();
      const metaAll = [];
      const metaFor = (p, type) => ({
        id: p.id, ratio: p.ratio, filename: p.filename,
        dateTaken: p.dateTaken, tags: p.tags, addedIndex: p.addedIndex,
        mime: type || p._dmbMime || "image/jpeg"
      });

      for (const ph of photos) {
        if (!ph || !ph.id) continue;
        if (saved.has(ph.id)) { metaAll.push(metaFor(ph)); continue; }   // already on disk — don't re-read
        let src = ph.file || null;
        if ((!src || (src.size != null && src.size === 0)) && ph.url) {
          try { src = await (await fetch(ph.url)).blob(); } catch (e) { /* keep src */ }
        }
        if (!src || !src.size) continue;              // can't read now → retry on a later save
        const type = src.type || "image/jpeg";
        let buf = null;
        try { buf = await src.arrayBuffer(); } catch (e) { buf = null; }
        if (!buf || !buf.byteLength) continue;
        try {
          const tx = db.transaction("blobs", "readwrite");   // one photo per transaction
          tx.objectStore("blobs").put({ buf, type, bytes: buf.byteLength }, saveKey + "__" + ph.id);
          await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = () => rej(tx.error); });
          saved.add(ph.id);
          try { ph._dmbMime = type; } catch (e) {}
          metaAll.push(metaFor(ph, type));
        } catch (e) { /* leave unsaved → retried next call */ }
        buf = null;                                    // release this photo's bytes now
        await new Promise((r) => setTimeout(r, 0));    // yield so the browser can reclaim
      }

      // Only touch the meta record when we have something to record — never clobber
      // a good manifest with an empty one (e.g. every read failed).
      if (metaAll.length) {
        try {
          const txm = db.transaction("blobs", "readwrite");
          txm.objectStore("blobs").put(metaAll, saveKey + "__meta");
          await new Promise((res, rej) => { txm.oncomplete = res; txm.onerror = () => rej(txm.error); });
        } catch (e) {}
      }
      db.close();
      return metaAll.length > 0;
    } catch(e) { console.warn("[DMB] savePhotos:", e); return false; }
  }

  // Fetch ONE photo's full-res bytes back from R2, using the right identity:
  //   • signed-in → the App Proxy appends the verified logged_in_customer_id, so
  //     the Worker reads from the customer's namespace (no sid needed).
  //   • guest     → add &sid=<guest id> so the Worker reads designs/guest_<sid>/…
  // This is what lets a signed-in customer recover photos that IndexedDB evicted
  // (the reported "most pictures missing on the laptop" case) and what makes the
  // per-photo restore fallback below work for EVERYONE, not just guests.
  async function _dmbFetchPhotoBlob(designId, pid, kind) {
    if (!window.DMB_DESIGNS_PROXY || !pid) return null;
    let url;
    if (_dmbRenderMode() && _DMB_RM.token) {
      // RENDER MODE: token-only identity - no login, no guest sid. The Worker resolves
      // owner + designId from the job record; nothing identifying is in the URL. This
      // also stops _dmbPhotoBackup.guestId() minting a dmb_guest_id in localStorage,
      // which would address designs/guest_<random>/ and 404 every single photo.
      url = window.DMB_DESIGNS_PROXY + "/render-photo?t=" + encodeURIComponent(_DMB_RM.token) +
            "&pid=" + encodeURIComponent(pid);
    } else {
      if (!designId) return null;
      url = window.DMB_DESIGNS_PROXY + "/photo?id=" + encodeURIComponent(designId) + "&pid=" + encodeURIComponent(pid);
      if (!window.DMB_CUSTOMER_ID) {
        try { const sid = _dmbPhotoBackup.guestId(); if (sid) url += "&sid=" + encodeURIComponent(sid); } catch (e) {}
      }
    }
    // kind="master" fetches the ~3500px print master from photos-orig/{pid}. A miss
    // there is a legitimate absence (legacy/relay photo, evicted guest master), so
    // masters get ONE attempt — the caller falls back to the proxy immediately.
    if (kind === "master") url += "&kind=master";
    const _attempts = kind === "master" ? 1 : 3;
    // Retry a few times: this feeds the PDF render when full-res was released in
    // light-memory mode, so a transient network blip must never blank a page. R2
    // has the photo (uploaded at pick time), so a retry reliably succeeds.
    for (let attempt = 0; attempt < _attempts; attempt++) {
      try {
        const r = await fetch(url, { credentials: "same-origin" });
        if (r.ok) { const b = await r.blob(); if (b && b.size) return b; }
      } catch (e) {}
      if (attempt < _attempts - 1) await new Promise((res) => setTimeout(res, 500 * (attempt + 1)));
    }
    return null;
  }

  // Every photo id the CURRENT restored layout points at (page slots, spreads,
  // template frames, free photo-frames, cover). Used to detect which photos a
  // restore is missing so we can pull just those back from the cloud.
  function _dmbCollectReferencedPhotoIds() {
    const ids = new Set();
    const add = (v) => { if (v && typeof v === "string") ids.add(v); };
    try { const ps = editor.pageSlots || {}; Object.keys(ps).forEach((k) => { const s = ps[k] || {}; add(s.A); add(s.B); }); } catch (e) {}
    try { const sp = editor.spreadPhoto || {}; Object.keys(sp).forEach((k) => { if (sp[k]) add(sp[k].photoId); }); } catch (e) {}
    try { const pf = editor.pageFrames || {}; Object.keys(pf).forEach((k) => { const m = pf[k] || {}; Object.keys(m).forEach((kk) => add(m[kk])); }); } catch (e) {}
    try { const po = editor.pageObjects || {}; Object.keys(po).forEach((k) => { (po[k] || []).forEach((o) => { if (o && o.photoId) add(o.photoId); }); }); } catch (e) {}
    try { (editor.coverObjects || []).forEach((o) => { if (o && o.photoId) add(o.photoId); }); } catch (e) {}
    try { Object.keys(coverState || {}).forEach((k) => { if (/imageid$|photoid$/i.test(k)) add(coverState[k]); }); } catch (e) {}
    return ids;
  }

  // The FULL photo manifest for a design from the cloud — every photo that was
  // uploaded, PLACED OR UNUSED (the tray keeps unused photos, and they're saved to
  // R2 + listed in meta.photos). Returns [{id,filename,ratio,dateTaken,...}] or [].
  async function _dmbFetchDesignManifestPhotos(designId) {
    if (!window.DMB_DESIGNS_PROXY || !designId) return [];
    const readMeta = (d) => {
      const meta = d && d.meta;
      if (!meta) return [];
      if (Array.isArray(meta.photos) && meta.photos.length) return meta.photos;
      if (Array.isArray(meta.photoIds)) return meta.photoIds.map((id) => ({ id }));
      return [];
    };
    try {
      if (window.DMB_CUSTOMER_ID) {
        const r = await fetch(window.DMB_DESIGNS_PROXY + "/load?id=" + encodeURIComponent(designId), { credentials: "same-origin" });
        if (r.ok) return readMeta(await r.json());
      } else {
        let sid = ""; try { sid = _dmbPhotoBackup.guestId(); } catch (e) {}
        if (sid) {
          const r = await fetch(window.DMB_DESIGNS_PROXY + "/load-guest?id=" + encodeURIComponent(designId) + "&sid=" + encodeURIComponent(sid), { credentials: "same-origin" });
          if (r.ok) return readMeta(await r.json());
        }
      }
    } catch (e) {}
    return [];
  }

  // ADDITIVE restore repair: bring back EVERY photo the saved design has in the
  // cloud that isn't already in editor.photos — including UNUSED photos still in
  // the tray (they're in the cloud manifest, not just the ones placed on pages).
  // Also covers anything the current layout references. Serial → memory-safe even
  // when many are missing. Never removes/replaces. Returns how many were recovered.
  async function _dmbReconcileMissingPhotosFromCloud() {
    if (!window.DMB_DESIGNS_PROXY || !Array.isArray(editor.photos)) return 0;
    let designId = "";
    try { designId = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
    if (!designId) return 0;

    // Authoritative full list from the cloud (placed AND unused).
    let manifest = [];
    try { manifest = await _dmbFetchDesignManifestPhotos(designId); } catch (e) {}
    const metaById = {};
    manifest.forEach((mp) => { if (mp && mp.id) metaById[mp.id] = mp; });

    // Want = everything in the manifest ∪ everything the layout references.
    const want = new Set();
    manifest.forEach((mp) => { if (mp && mp.id) want.add(mp.id); });
    _dmbCollectReferencedPhotoIds().forEach((id) => { if (id) want.add(id); });

    const present = new Set(editor.photos.map((p) => p && p.id));
    const missing = [];
    want.forEach((id) => { if (id && !present.has(id)) missing.push(id); });
    if (!missing.length) return 0;

    let added = 0;
    // Print-master path in light-mem: do NOT serially download every missing photo
    // (a 300-photo restore would fetch 300 blobs before the builder settles). A
    // photo the current spread doesn't show, whose manifest meta is complete, is
    // restored as a LAZY record — bytes stay on R2 (_r2), it self-heals on view
    // (_dmbRecoverPhotoUrl) and in the PDF (_dmbRenderImg). On-spread photos and
    // ones with incomplete meta still download eagerly, exactly like today.
    const _lazyKeep = (_dmbPrintMasterOn() && _dmbLightMem()) ? _dmbCurrentSpreadPhotoIds() : null;
    for (const pid of missing) {
      const _mp0 = metaById[pid];
      if (_lazyKeep && !_lazyKeep.has(pid) && _mp0 && typeof _mp0.ratio === "number" && _mp0.ratio > 0) {
        editor.photos.push({
          id: pid, file: null, url: "", _r2: true,
          ratio: _mp0.ratio, filename: _mp0.filename || "photo.jpg",
          dateTaken: _mp0.dateTaken || "", tags: _mp0.tags || [],
          addedIndex: (typeof _mp0.addedIndex === "number") ? _mp0.addedIndex : editor.photos.length,
        });
        added++;
        continue;
      }
      let blob = null;
      try { blob = await _dmbFetchPhotoBlob(designId, pid); } catch (e) {}
      if (!blob || !blob.size) continue;
      const mp = metaById[pid] || {};
      let f = null;
      try { f = new File([blob], mp.filename || "photo.jpg", { type: blob.type || "image/jpeg" }); } catch (e) { f = blob; }
      let ratio = mp.ratio;
      if (!ratio) { try { ratio = (await _dmbCheapMeta(f)).ratio || 1; } catch (e) { ratio = 1; } }
      editor.photos.push({
        id: pid, file: f, url: URL.createObjectURL(blob),
        ratio: ratio || 1, filename: mp.filename || "photo.jpg",
        dateTaken: mp.dateTaken || "", tags: mp.tags || [],
        addedIndex: (typeof mp.addedIndex === "number") ? mp.addedIndex : editor.photos.length,
      });
      added++;
    }
    // Restore the original tray order (by addedIndex) so recovered photos slot in
    // where they were, not just appended at the end.
    try { editor.photos.sort((a, b) => (a.addedIndex || 0) - (b.addedIndex || 0)); } catch (e) {}
    return added;
  }

  // ── Level 2: light-memory mode ─────────────────────────────────────────────
  // Goal: never hold every full-res photo in RAM. On phones (where RAM is the
  // constraint) and only for LARGE books, once a photo is safely on R2 its
  // resident full-res bytes are released when it's not on the spread being
  // viewed. The tray keeps showing its small thumbnail; a placed photo that was
  // released self-heals on view via _dmbBindPhotoImg → _dmbRecoverPhotoUrl (and
  // the PDF via _dmbRenderImg) — both re-fetch the full-res original from R2 by
  // id. So the worst case of releasing something still needed is a brief re-fetch,
  // never a blank or a quality change. Default: ON for phones, OFF on desktop;
  // window.DMB_LIGHT_PHOTO_MEM = true/false forces it either way.
  const _DMB_LIGHT_MEM_MIN_PHOTOS = 80;   // small/medium books never release (no churn)
  function _dmbLightMem() {
    if (typeof window === "undefined") return false;
    if (_dmbRenderMode()) return true;   // lazy photo records: bytes stream from R2 on demand
    if (window.DMB_LIGHT_PHOTO_MEM === true) return true;
    if (window.DMB_LIGHT_PHOTO_MEM === false) return false;
    try { return window.innerWidth <= 749; } catch (e) { return false; }   // phones by default
  }

  // ── PRINT MASTERS (flag-gated, default OFF) ────────────────────────────────
  // window.DMB_PRINT_MASTER = true turns on the full-quality pipeline: every
  // imported photo yields TWO derivatives from ONE memory-safe scaled decode —
  //   • a ~3500px PRINT MASTER (true 300 DPI on a full A4) uploaded to R2 at
  //     photos-orig/{pid} (fetched back with &kind=master; feeds the Step-2
  //     server render + the desktop client PDF),
  //   • a 2500px editing PROXY that takes the photo's place everywhere else
  //     (same size/quality as today's mobile proxy → zero regression).
  // Masters ride the existing instant-backup /photo endpoint, so the flag also
  // requires DMB_DESIGNS_PROXY. While OFF, every branch below is dead code.
  const _DMB_MASTER_DIM = 3500, _DMB_MASTER_Q = 0.9;
  const _DMB_PROXY_DIM  = 2500, _DMB_PROXY_Q  = 0.88;   // == today's mobile proxy
  const _DMB_MASTER_SUBBATCH = 10;  // flagged import sub-batch (bounds resident masters)
  function _dmbPrintMasterOn() {
    try {
      // A server render is ALWAYS master-fed. This also gates the cover face/bleed
      // draw-BY-ID branch, which is the only way a lazy cover photo gets drawn at all.
      if (_dmbRenderMode()) return !!window.DMB_DESIGNS_PROXY;
      return !!window.DMB_PRINT_MASTER && !!window.DMB_DESIGNS_PROXY;
    } catch (e) { return false; }
  }
  // Master fetch-miss memo: a pid whose master 404'd (legacy photo, relay photo,
  // evicted guest master) is not re-tried this session — the proxy serves instead.
  const _dmbNoMasterPids = new Set();
  // One-time capability probe: an OLD Worker ignores &kind=master and would write
  // the master OVER the proxy at photos/{pid}. Never upload a master until the
  // Worker proves it routes kind (GET /caps → {masters:true}).
  let _dmbMasterCapsP = null;
  function _dmbMasterCaps() {
    if (!_dmbMasterCapsP) {
      _dmbMasterCapsP = (async () => {
        let ok = false;
        try {
          const r = await fetch((window.DMB_DESIGNS_PROXY || "") + "/caps", { credentials: "same-origin" });
          const j = r.ok ? await r.json().catch(() => null) : null;
          ok = !!(j && j.masters === true);
        } catch (e) { ok = false; }
        // A transient failure (flaky phone connection) must NOT be remembered as
        // "this Worker cannot take masters" for the rest of the session - that
        // silently dropped every master of every later import with no symptom
        // except "0 of N at full print quality". Only a positive answer is cached.
        if (!ok) _dmbMasterCapsP = null;
        return ok;
      })();
    }
    return _dmbMasterCapsP;
  }
  // Background master uploader: a serial promise chain SEPARATE from the instant-
  // backup queue, so the batch-upload wait (which gates the import modal) drains on
  // PROXIES only — masters keep uploading quietly behind it. The blob is freed the
  // moment its upload settles (success OR final failure), so masters never pile up.
  let _dmbMasterChain = Promise.resolve();
  let _dmbMasterPendingCount = 0;
  // Session tally of master outcomes - surfaced in the server-render trace so a
  // low "at full print quality" count can be explained instead of guessed at.
  const _dmbMasterStats = { queued: 0, ok: 0, failed: 0, nocaps: 0, decode_failed: 0, relay: 0 };
  try { window.__DMB_MASTER_STATS = _dmbMasterStats; } catch (e) {}
  function _dmbQueueMasterUpload(f, designId, sid, pid) {
    // pid: explicit for the customer cloud path (editor.photos ids); the guest
    // instant-backup queue stamps f._dmbPid instead.
    const _pid = pid || (f && f._dmbPid);
    if (!f || !f._dmbMaster || !_pid) return;
    if (f._dmbMasterQueued) return;            // one-shot per File, whichever path asks first
    f._dmbMasterQueued = true;
    _dmbMasterPendingCount++;
    _dmbMasterChain = _dmbMasterChain.then(async () => {
      const blob = f._dmbMaster;
      let _state = "failed";
      try {
        if (!blob || !(await _dmbMasterCaps())) { _state = "nocaps"; return; }   // old Worker → proxy-only, no overwrite risk
        let u = (window.DMB_DESIGNS_PROXY || "") + "/photo?id=" + encodeURIComponent(designId) +
                "&pid=" + encodeURIComponent(_pid) + (sid ? "&sid=" + encodeURIComponent(sid) : "") +
                "&kind=master";
        for (let a = 0; a < 2; a++) {
          try {
            const r = await fetch(u, { method: "POST", headers: { "content-type": "image/jpeg" }, body: blob, credentials: "same-origin" });
            if (r.ok) {
              const j = await r.json().catch(() => null);
              _state = (j && j.kind === "master") ? "ok" : "nocaps";
              return;                                       // no echo = old Worker slipped through caps; stop (do not retry into photos/)
            }
          } catch (e) {}
          if (a === 0) await new Promise((res) => setTimeout(res, 1200));
        }
      } catch (e) {} finally {
        try { f._dmbMaster = null; f._dmbMasterState = _state; _dmbMasterStats[_state] = (_dmbMasterStats[_state] || 0) + 1; } catch (e) {}
        _dmbMasterPendingCount = Math.max(0, _dmbMasterPendingCount - 1);
      }
    });
    return _dmbMasterChain;
  }

  // Release resident full-res bytes of photos NOT in the keep-set. Keeps the
  // small thumbUrl. Only acts in light-memory mode and only for photos CONFIRMED
  // on R2 (_r2). Bytes stay safe on R2 and are re-fetched on demand when needed.
  function _dmbReleaseDistantFullRes(keepIds) {
    if (!_dmbLightMem() || !Array.isArray(editor.photos)) return 0;
    const keep = keepIds instanceof Set ? keepIds : new Set(keepIds || []);
    let freed = 0;
    for (const ph of editor.photos) {
      if (!ph || keep.has(ph.id) || !ph._r2) continue;
      if (ph.url && String(ph.url).startsWith("blob:")) { try { URL.revokeObjectURL(ph.url); } catch (e) {} ph.url = ""; }
      if (ph.file) { ph.file = null; freed++; }
    }
    return freed;
  }

  // Photo ids referenced by the spread currently on screen (+ cover) — the set
  // we must KEEP resident so nothing visible has to re-fetch.
  function _dmbCurrentSpreadPhotoIds() {
    const ids = new Set();
    const add = (v) => { if (v && typeof v === "string") ids.add(v); };
    try {
      const si = editor.currentSpread || 0;
      // Keep a small window around the viewed spread so quick back/forward paging
      // doesn't thrash. Page mapping is best-effort (varies by book/magazine plan);
      // being generous here only means keeping a few extra photos resident.
      for (let s = si - 1; s <= si + 1; s++) {
        if (s < 0) continue;
        for (const p of [2 * s + 1, 2 * s + 2, 0]) {
          const sl = (editor.pageSlots || {})[p] || {}; add(sl.A); add(sl.B);
          const pf = (editor.pageFrames || {})[p] || {}; Object.keys(pf).forEach((k) => add(pf[k]));
          const po = (editor.pageObjects || {})[p] || []; po.forEach((o) => { if (o && o.photoId) add(o.photoId); });
        }
        const sp = (editor.spreadPhoto || {})[s]; if (sp) add(sp.photoId);
      }
      (editor.coverObjects || []).forEach((o) => { if (o && o.photoId) add(o.photoId); });
      Object.keys(coverState || {}).forEach((k) => { if (/imageid$|photoid$/i.test(k)) add(coverState[k]); });
      ["frontFrames", "backFrames"].forEach((fk) => { const m = coverState && coverState[fk]; if (m) Object.keys(m).forEach((k) => add(m[k])); });
    } catch (e) {}
    return ids;
  }

  // Called from the render flow. Releases distant full-res only when we've moved
  // to a new spread, in light-mem mode, on a large enough book.
  let _dmbLastReleaseSpread = -999;
  function _dmbMaybeReleaseForSpread() {
    try {
      if (!_dmbLightMem()) return;
      if (!Array.isArray(editor.photos) || editor.photos.length < _DMB_LIGHT_MEM_MIN_PHOTOS) return;
      const cur = editor.currentSpread || 0;
      if (cur === _dmbLastReleaseSpread) return;      // same spread → nothing new to free
      _dmbLastReleaseSpread = cur;
      _dmbReleaseDistantFullRes(_dmbCurrentSpreadPhotoIds());
    } catch (e) {}
  }

  async function _loadPhotosFromIDB(saveKey) {
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readonly");
      const store = tx.objectStore("blobs");
      const meta = await new Promise(res => {
        const r = store.get(saveKey + "__meta");
        r.onsuccess = () => res(r.result || []);
        r.onerror = () => res([]);
      });
      if (!meta.length) { db.close(); return []; }
      const photos = [];
      for (const m of meta) {
        const rec = await new Promise(res => {
          const r = store.get(saveKey + "__" + m.id);
          r.onsuccess = () => res(r.result || null);
          r.onerror = () => res(null);
        });

        // Rebuild a Blob from whatever format the entry is stored in:
        //  • { buf, type } — current format (ArrayBuffer, reliable on iOS)
        //  • Blob          — legacy entries saved before the ArrayBuffer switch
        //  • ArrayBuffer   — defensive fallback
        let blob = null;
        if (rec) {
          if (rec instanceof Blob) {
            blob = rec;
          } else if (rec.buf) {
            try { blob = new Blob([rec.buf], { type: rec.type || m.mime || "image/jpeg" }); } catch (e) {}
          } else if (rec instanceof ArrayBuffer) {
            try { blob = new Blob([rec], { type: m.mime || "image/jpeg" }); } catch (e) {}
          }
        }

        // Only keep photos whose bytes actually came back (size > 0). An empty
        // entry means the data was lost/evicted — skip it rather than showing a
        // blank/white image.
        if (blob && blob.size) {
          // Reconstruct a REAL File so bookFiles holds real files, not empty
          // 0-byte placeholders (otherwise a later refreshBuilderPhotos() rebuilds
          // the images from empty files and they break after a click once restored).
          let _f = null;
          try { _f = new File([blob], (m.filename || "photo.jpg"), { type: blob.type || "image/jpeg" }); }
          catch (e) { _f = blob; }
          photos.push({ ...m, file: _f, url: URL.createObjectURL(blob) });
        } else if (window.DMB_DESIGNS_PROXY) {
          // Local bytes are gone (IndexedDB evicted — the iOS data-loss case, and
          // the signed-in "most photos missing on the laptop" case). Pull this
          // photo back from R2 using the right identity so the design isn't lost.
          // Print-master path in light-mem: an off-spread photo is restored LAZY
          // (no download now — bytes stay on R2, _r2:true, self-heals on view/PDF)
          // so a big-book restore doesn't serially download hundreds of blobs.
          try {
            const _keepIDB = (_dmbPrintMasterOn() && _dmbLightMem()) ? _dmbCurrentSpreadPhotoIds() : null;
            if (_keepIDB && m.id && !_keepIDB.has(m.id) && typeof m.ratio === "number" && m.ratio > 0) {
              photos.push({ ...m, file: null, url: "", _r2: true });
            } else {
              const _did = String(saveKey).replace(/^dmb_progress_/, "");
              const _rb = await _dmbFetchPhotoBlob(_did, m.id);
              if (_rb && _rb.size) {
                let _f2 = null;
                try { _f2 = new File([_rb], (m.filename || "photo.jpg"), { type: _rb.type || "image/jpeg" }); }
                catch (e) { _f2 = _rb; }
                photos.push({ ...m, file: _f2, url: URL.createObjectURL(_rb) });
              }
            }
          } catch (e) {}
        }
      }
      db.close();
      return photos;
    } catch(e) { console.warn("[DMB] loadPhotos:", e); return []; }
  }

  // ── IndexedDB persistence for OBJECT crop images (sticker / cover-icon
  //    "tightUrl" base64, and any inline data: URL). These used to live INLINE in
  //    the design JSON in localStorage — each is a full PNG, so a handful of them
  //    (a) made every save write hundreds of KB (lag) and (b) overflowed the ~5 MB
  //    localStorage cap, after which setItem threw and was SILENTLY swallowed →
  //    "only the first sticker survived a refresh." We now mirror them into
  //    IndexedDB (hundreds of MB, same store as photos) and strip them from the
  //    localStorage state, which stays tiny + instant. Rendering is byte-identical
  //    (same base64 reattached on restore); nothing about size/placement changes.
  function _dmbCollectObjImages() {
    const out = [], seen = {};
    const scan = (arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((o) => {
        if (!o || !o.id || seen[o.id]) return;
        let du = null, field = null;
        if (typeof o.tightUrl === "string" && o.tightUrl.slice(0, 5) === "data:") { du = o.tightUrl; field = "tightUrl"; }
        else if (typeof o.url === "string" && o.url.slice(0, 5) === "data:") { du = o.url; field = "url"; }
        if (du) { out.push({ id: o.id, dataUrl: du, field: field }); seen[o.id] = true; }
      });
    };
    try { scan(editor.coverObjects); } catch (e) {}
    try { if (editor.pageObjects) Object.keys(editor.pageObjects).forEach((k) => scan(editor.pageObjects[k])); } catch (e) {}
    return out;
  }

  // Ids whose crop image is CONFIRMED written to IndexedDB — only those are safe to
  // strip from the localStorage snapshot (an image not yet mirrored stays inline so
  // an instant refresh can't lose it).
  const _dmbObjImgSaved = new Set();
  async function _dmbSaveObjImagesToIDB(saveKey, imgs) {
    if (!Array.isArray(imgs) || !imgs.length) return false;
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readwrite");
      const store = tx.objectStore("blobs");
      const prevMeta = await new Promise((res) => { const r = store.get(saveKey + "__objimgmeta"); r.onsuccess = () => res(r.result || []); r.onerror = () => res([]); });
      const known = {}; (prevMeta || []).forEach((m) => { if (m && m.id) known[m.id] = true; });
      const meta = (prevMeta || []).slice();
      imgs.forEach((im) => {
        store.put({ dataUrl: im.dataUrl, field: im.field }, saveKey + "__objimg__" + im.id);
        if (!known[im.id]) { meta.push({ id: im.id, field: im.field }); known[im.id] = true; }
      });
      store.put(meta, saveKey + "__objimgmeta");
      await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = () => rej(tx.error); });
      db.close();
      imgs.forEach((im) => _dmbObjImgSaved.add(im.id));   // now safe to strip from localStorage
      return true;
    } catch (e) { return false; }
  }

  async function _dmbLoadObjImagesFromIDB(saveKey) {
    const map = {};
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readonly");
      const store = tx.objectStore("blobs");
      const meta = await new Promise((res) => { const r = store.get(saveKey + "__objimgmeta"); r.onsuccess = () => res(r.result || []); r.onerror = () => res([]); });
      for (const m of (meta || [])) {
        if (!m || !m.id) continue;
        const rec = await new Promise((res) => { const r = store.get(saveKey + "__objimg__" + m.id); r.onsuccess = () => res(r.result || null); r.onerror = () => res(null); });
        if (rec && rec.dataUrl) map[m.id] = { dataUrl: rec.dataUrl, field: rec.field || "tightUrl" };
      }
      db.close();
    } catch (e) {}
    return map;
  }

  // Reattach IDB-stored crop images onto the (freshly restored) live objects by id.
  function _dmbReattachObjImages(imgMap) {
    if (!imgMap) return;
    const patch = (arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((o) => {
        if (!o || !o.id) return;
        const rec = imgMap[o.id];
        if (rec && rec.dataUrl) { try { o[rec.field || "tightUrl"] = rec.dataUrl; } catch (e) {} _dmbObjImgSaved.add(o.id); }
      });
    };
    try { patch(editor.coverObjects); } catch (e) {}
    try { if (editor.pageObjects) Object.keys(editor.pageObjects).forEach((k) => patch(editor.pageObjects[k])); } catch (e) {}
  }

  // Debounced mirror of crop images → IndexedDB. Images don't change after an
  // object is added, so this rarely re-runs (guarded by a signature of the id set).
  let _dmbObjImgTimer = null, _dmbObjImgSig = "";
  function _dmbPersistObjImages() {
    clearTimeout(_dmbObjImgTimer);
    _dmbObjImgTimer = setTimeout(() => {
      try {
        const imgs = _dmbCollectObjImages();
        if (!imgs.length) return;
        const sig = imgs.map((i) => i.id).join(",");
        if (sig === _dmbObjImgSig) return;
        _dmbSaveObjImagesToIDB(getCustomerSaveKey(), imgs).then((ok) => { if (ok) _dmbObjImgSig = sig; });
      } catch (e) {}
    }, 350);
  }

  // Strip inline base64 crop images out of a snapshot CLONE before it's written to
  // localStorage (they live in IndexedDB now). Only mutates the passed clone.
  function _dmbStripObjImagesFromSnapshot(snap) {
    try {
      const strip = (arr) => {
        if (!Array.isArray(arr)) return;
        arr.forEach((o) => {
          if (!o || !o.id) return;
          if (!_dmbObjImgSaved.has(o.id)) return;   // keep inline until it's in IndexedDB
          if (typeof o.tightUrl === "string" && o.tightUrl.slice(0, 5) === "data:") o.tightUrl = "";
          if (typeof o.url === "string" && o.url.slice(0, 5) === "data:") o.url = "";
        });
      };
      if (snap && snap.editor) {
        strip(snap.editor.coverObjects);
        if (snap.editor.pageObjects) Object.keys(snap.editor.pageObjects).forEach((k) => strip(snap.editor.pageObjects[k]));
      }
    } catch (e) {}
    return snap;
  }

  // Re-key restored IDB photos to the IDs the saved layout actually references.
  // Page slots / template frames / spread photos / cover frames all store photo
  // IDs. If the IDB photos were written in a different session (or were re-id'd
  // at some point), those references no longer resolve via getPhotoById() — so
  // the tray (which renders the photo array directly) looks perfect, but every
  // PLACED photo on a spread renders as a blank white box. Match each restored
  // photo to a saved-state photo by addedIndex first, then filename, and adopt
  // its saved ID so the layout resolves again. No-op when the IDs already line up.
  function _dmbReconcilePhotoIds(idbPhotos, savedEditor) {
    try {
      const saved = (savedEditor && Array.isArray(savedEditor.photos)) ? savedEditor.photos : [];
      if (!saved.length || !idbPhotos || !idbPhotos.length) return;
      // Fast path: if every saved photo ID is already present, nothing to fix.
      const idbIds = new Set(idbPhotos.map(p => p.id));
      if (saved.every(sp => idbIds.has(sp.id))) return;
      const usedSaved = new Set();
      const pick = (pred) => {
        for (let i = 0; i < saved.length; i++) {
          if (!usedSaved.has(i) && pred(saved[i])) { usedSaved.add(i); return saved[i]; }
        }
        return null;
      };
      idbPhotos.forEach((np) => {
        let m = pick(sp => sp.addedIndex === np.addedIndex && sp.filename === np.filename);
        if (!m) m = pick(sp => sp.filename && sp.filename === np.filename);
        if (!m) m = pick(sp => sp.addedIndex === np.addedIndex);
        if (m && m.id) np.id = m.id;
      });
    } catch (e) {}
  }

  // On restore, the cover face/bleed image URLs are blob: URLs that get cleared
  // (they're dead after a reload). The photo IDs are preserved though, so rebuild
  // the URLs from the restored photos — otherwise a photo dropped directly on the
  // cover front/back comes back blank even though it's still in the tray.
  // Must run AFTER editor.photos has been loaded (getPhotoById needs it).
  function _dmbRehydrateCoverPhotoUrls() {
    try {
      [["frontImageId", "frontImageUrl"],
       ["backImageId", "backImageUrl"],
       ["bleedImageId", "bleedImageUrl"]].forEach(([idK, urlK]) => {
        if ((!coverState[urlK] || !String(coverState[urlK]).length) && coverState[idK]) {
          const p = getPhotoById(coverState[idK]);
          if (p && p.url) coverState[urlK] = p.url;
        }
      });
    } catch (e) {}
  }

  /* ===================================================================
     Cloud design storage (server-side, for LOGGED-IN customers)
     Mirrors the local save to a Cloudflare Worker (via the Shopify App
     Proxy at /apps/designs) so designs survive browser eviction and work
     across devices. Purely additive — local IndexedDB/localStorage still
     runs; cloud is an extra layer that activates only when logged in.
     =================================================================== */
  const _dmbCloud = {
    _uploaded: {},                                   // designId -> Set(photoId) already uploaded this session
    enabled() { return !!(window.DMB_CUSTOMER_ID && window.DMB_DESIGNS_PROXY); },
    base() { return window.DMB_DESIGNS_PROXY || "/apps/designs"; },
    // Stable id for this design = the local save-key suffix (per template/cover handle).
    designId() { return getCustomerSaveKey().replace(/^dmb_progress_/, ""); },
    _f(path, opts) { return fetch(this.base() + path, Object.assign({ credentials: "same-origin" }, opts || {})); },

    async saveState(snapshot, meta) {
      if (!this.enabled()) return false;
      try {
        const id = this.designId();
        const r = await this._f(`/save?id=${encodeURIComponent(id)}`, {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ design: snapshot, meta: meta || {} }),
        });
        return r.ok;
      } catch (e) { return false; }
    },

    // PRINT MASTERS for SIGNED-IN customers. The only other place masters were
    // queued is the guest instant-backup queue (_dmbPhotoBackup, guests only) -
    // it is disabled the moment a customer is logged in, so a signed-in customer's
    // photos NEVER got a master and every proof read "0 of N at full print
    // quality" while the server rendered from the proxies. Mirrors the proxy
    // upload below exactly: same design id, no sid, so both land under the same
    // owner prefix. One-shot per File: the blob is freed once its upload settles.
    queueMasters(photos) {
      if (!this.enabled() || !Array.isArray(photos) || !photos.length) return 0;
      let n = 0;
      try {
        if (!_dmbPrintMasterOn()) return 0;
        const id = this.designId();
        photos.forEach(function (ph) {
          try {
            if (ph && ph.id && ph.file && ph.file._dmbMaster && !ph.file._dmbMasterQueued) {
              _dmbQueueMasterUpload(ph.file, id, "", ph.id); n++;
            }
          } catch (e) {}
        });
      } catch (e) {}
      return n;
    },

    async savePhotosDelta(photos) {
      if (!this.enabled() || !Array.isArray(photos) || !photos.length) return;
      try { this.queueMasters(photos); } catch (e) {}
      const id = this.designId();
      let up = this._uploaded[id];
      if (!up) {
        up = new Set();
        // Build the "already uploaded" set from what R2 ACTUALLY holds (/photos lists
        // real objects) — NOT the design manifest (meta.photoIds), which can claim a
        // photo is saved when its bytes never reached R2 (old book) or were deleted
        // after an order. This makes the delta re-upload genuinely-missing photos, so
        // a design that's complete on one device self-heals on the others.
        let gotList = false;
        try {
          const lr = await this._f(`/photos?id=${encodeURIComponent(id)}`);
          if (lr.ok) { gotList = true; const d = await lr.json(); ((d && d.photos) || []).forEach(p => { const pid = (p && (p.pid || p.id)); if (pid) up.add(pid); }); }
        } catch (e) {}
        // Only if the reality check FAILED (endpoint/network) do we trust the manifest,
        // so a transient error never triggers a full re-upload of every photo.
        if (!gotList) {
          try {
            const lr = await this._f(`/load?id=${encodeURIComponent(id)}`);
            if (lr.ok) { const d = await lr.json(); ((d.meta && d.meta.photoIds) || []).forEach(x => up.add(x)); }
          } catch (e) {}
        }
        this._uploaded[id] = up;
      }
      let uploaded = 0;
      for (const ph of photos) {
        if (up.has(ph.id)) continue;
        let src = ph.file || null;
        if ((!src || src.size === 0) && ph.url) { try { src = await (await fetch(ph.url)).blob(); } catch (e) {} }
        if (!src || !src.size) continue;   // no local bytes here (e.g. the device that's MISSING them) → nothing we can push
        try {
          const r = await this._f(`/photo?id=${encodeURIComponent(id)}&pid=${encodeURIComponent(ph.id)}`, {
            method: "POST", headers: { "content-type": src.type || "image/jpeg" }, body: src,
          });
          if (r.ok) { up.add(ph.id); uploaded++; }
        } catch (e) {}
      }
      return uploaded;
    },

    // Force a one-off backfill: re-upload any photo we hold locally that R2 is missing,
    // WITHOUT needing a design change. Fixes old books whose photos never fully reached
    // R2 (so another device shows blank frames). No-op on a device that lacks the bytes.
    async backfillPhotos() {
      try { this._uploaded[this.designId()] = null; } catch (e) {}   // re-check R2 reality
      let n = 0;
      try { n = await this.savePhotosDelta(editor.photos || []); } catch (e) {}
      // If we actually re-uploaded missing photos, the cloud copy was incomplete/old →
      // push the full current design too (carries the colour palette + completes it).
      if (n > 0) { try { _dmbCloudPersist(); } catch (e) {} }
      return n;
    },

    // Returns { design, meta, photos:[{id,file,url,...}] } or null.
    async load(id) {
      if (!this.enabled()) return null;
      id = id || this.designId();
      try {
        const r = await this._f(`/load?id=${encodeURIComponent(id)}`);
        if (!r.ok) return null;
        const data = await r.json();
        const manifest = (data.meta && data.meta.photos) || [];
        const metaById = new Map();
        manifest.forEach(m => { if (m && m.id) metaById.set(m.id, m); });
        // Download ONLY the photos the design actually PLACES (plus whatever the manifest
        // lists) — NOT the customer's whole uploaded library. R2 can hold dozens of
        // never-placed photos; downloading them all made the restore time out and show
        // NOTHING. The placed set is small, so the book loads fast and complete.
        let realPids = [];
        try {
          const lr = await this._f(`/photos?id=${encodeURIComponent(id)}`);
          if (lr.ok) { const d = await lr.json(); realPids = ((d && d.photos) || []).map(p => p && (p.pid || p.id)).filter(Boolean); }
        } catch (e) {}
        const realSet = new Set(realPids);
        const idsToFetch = new Set();
        // Download ONLY the photos the design PLACES (what the book needs to render) —
        // NOT the whole manifest. A manifest bloated by churn (e.g. 56, incl. duplicates
        // and another book's photos) made the restore time out and show NOTHING on
        // slower devices. The placed set is tiny, so the book renders fast & reliably.
        _dmbRefsFromDesign(data.design).forEach(pid => { if (!realPids.length || realSet.has(pid)) idsToFetch.add(pid); });
        // Download photos in PARALLEL (a small worker pool) — sequential one-at-a-time
        // downloads made a 21-photo restore blow past the caller's timeout and return
        // NOTHING (losing even the cover/layout). Parallel keeps it well under the cap.
        const photos = [];
        const _idArr = Array.from(idsToFetch);
        const _self = this;
        let _idx = 0;
        const _worker = async () => {
          while (_idx < _idArr.length) {
            const pid = _idArr[_idx++];
            try {
              const pr = await _self._f(`/photo?id=${encodeURIComponent(id)}&pid=${encodeURIComponent(pid)}`);
              if (!pr.ok) continue;
              const blob = await pr.blob();
              if (!blob || !blob.size) continue;
              const mp = metaById.get(pid) || { id: pid };
              let f = null;
              try { f = new File([blob], mp.filename || "photo.jpg", { type: blob.type || "image/jpeg" }); } catch (e) { f = blob; }
              photos.push(Object.assign({}, mp, { id: pid, file: f, url: URL.createObjectURL(blob) }));
            } catch (e) {}
          }
        };
        await Promise.all(Array.from({ length: Math.min(6, _idArr.length || 1) }, _worker));
        // Remember what R2 ACTUALLY has (reality), so a later save re-uploads only the
        // genuinely-missing photos — not the (possibly lying) manifest.
        this._uploaded[id] = new Set(realPids.length ? realPids : manifest.map(m => m.id));
        // Stash the REST of the book's photo library (its manifest, minus the placed
        // photos we already fetched) so the caller can pull it into the tray in the
        // BACKGROUND, after the book has rendered. Only ids R2 actually has.
        this._pendingLib = {
          id,
          entries: manifest.filter(m => m && m.id && !idsToFetch.has(m.id) && (!realPids.length || realSet.has(m.id))),
        };
        return { design: data.design, meta: data.meta, photos };
      } catch (e) { return null; }
    },

    // Pull the stashed rest-of-library into the tray in the BACKGROUND (parallel,
    // non-blocking). Safe: loading never triggers a cloud write (edit-gated).
    async loadPendingLib(onBatch) {
      const pl = this._pendingLib; this._pendingLib = null;
      if (!pl || !Array.isArray(pl.entries) || !pl.entries.length) return 0;
      const id = pl.id, self = this; let i = 0, added = 0;
      const worker = async () => {
        while (i < pl.entries.length) {
          const mp = pl.entries[i++];
          try {
            const pr = await self._f(`/photo?id=${encodeURIComponent(id)}&pid=${encodeURIComponent(mp.id)}`);
            if (!pr.ok) continue;
            const blob = await pr.blob(); if (!blob || !blob.size) continue;
            let f = null; try { f = new File([blob], mp.filename || "photo.jpg", { type: blob.type || "image/jpeg" }); } catch (e) { f = blob; }
            if (!editor.photos) editor.photos = [];
            if (!editor.photos.some(p => p.id === mp.id)) { editor.photos.push(Object.assign({}, mp, { file: f, url: URL.createObjectURL(blob) })); added++; if (added % 4 === 0) { try { onBatch && onBatch(); } catch (e) {} } }
          } catch (e) {}
        }
      };
      await Promise.all(Array.from({ length: 6 }, worker));
      try { onBatch && onBatch(); } catch (e) {}
      return added;
    },

    // Background: pull EVERY remaining photo R2 holds for this design into the tray,
    // AFTER the book itself has rendered. Recovers spare/tray photos whose ids no longer
    // match the saved manifest (churn), without ever blocking the initial load. Parallel,
    // best-effort; calls onBatch() as photos arrive so the tray can refresh live.
    async loadTrayLibrary(onBatch) {
      if (!this.enabled()) return 0;
      const id = this.designId();
      let realPids = [];
      try { const lr = await this._f(`/photos?id=${encodeURIComponent(id)}`); if (lr.ok) { const d = await lr.json(); realPids = ((d && d.photos) || []).map(p => p && (p.pid || p.id)).filter(Boolean); } } catch (e) {}
      const have = new Set((editor.photos || []).map(p => p.id));
      const missing = realPids.filter(pid => !have.has(pid));
      if (!missing.length) return 0;
      const self = this; let i = 0, added = 0;
      const worker = async () => {
        while (i < missing.length) {
          const pid = missing[i++];
          try {
            const pr = await self._f(`/photo?id=${encodeURIComponent(id)}&pid=${encodeURIComponent(pid)}`);
            if (!pr.ok) continue;
            const blob = await pr.blob(); if (!blob || !blob.size) continue;
            let f = null; try { f = new File([blob], pid + ".jpg", { type: blob.type || "image/jpeg" }); } catch (e) { f = blob; }
            if (!editor.photos) editor.photos = [];
            if (!editor.photos.some(p => p.id === pid)) { editor.photos.push({ id: pid, file: f, url: URL.createObjectURL(blob) }); added++; if (added % 4 === 0) { try { onBatch && onBatch(); } catch (e) {} } }
          } catch (e) {}
        }
      };
      await Promise.all(Array.from({ length: 6 }, worker));
      try { onBatch && onBatch(); } catch (e) {}
      return added;
    },

    async list() {
      if (!this.enabled()) return [];
      try { const r = await this._f("/list"); if (r.ok) return (await r.json()).designs || []; } catch (e) {}
      return [];
    },

    // Claim a guest's provisional R2 photos into THIS account (server-side copy —
    // fast + reliable, doesn't depend on IndexedDB or a slow foreground re-upload).
    // Called right after a guest signs in. Returns { ok, claimed, pids } or null.
    async claim(designId) {
      if (!this.enabled()) return null;
      const id = designId || this.designId();
      let sid = "";
      try { sid = _dmbPhotoBackup.guestId(); } catch (e) {}
      if (!sid) return null;
      try {
        const r = await this._f(`/claim?id=${encodeURIComponent(id)}&sid=${encodeURIComponent(sid)}`, { method: "POST" });
        if (!r.ok) return null;
        return await r.json();
      } catch (e) { return null; }
    },
  };

  // A stable per-BROWSER id, so we can tell "another device saved" from "we saved".
  function _dmbDeviceId() {
    try {
      let d = localStorage.getItem("dmb_device_id");
      if (!d) { d = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); localStorage.setItem("dmb_device_id", d); }
      return d;
    } catch (e) { return "dev"; }
  }
  // Cross-device sync bookkeeping (the version of the design THIS device currently holds).
  let _dmbCurRev = null, _dmbCurSavedAt = null, _dmbLastSavedSig = null;
  // Content signature: identical design+photo-set → identical string. Used as `rev`,
  // so a re-save of UNCHANGED content produces the same rev (no false "newer" → no
  // cross-device reload ping-pong). savedAt (time) only orders genuinely different content.
  function _dmbCheapSig(snapshot, ph) {
    let s = "";
    try { s = JSON.stringify(snapshot); } catch (e) { s = "" + Date.now(); }
    try { s += "|" + (ph || []).map(p => p.id).join(","); } catch (e) {}
    let h = 0; for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36) + "-" + s.length.toString(36);
  }

  // Debounced cloud mirror of the current design (state + photo deltas).
  let _dmbCloudTimer = null;
  function _dmbBuildCloudMeta(snapshot, ph) {
    return {
      title: (typeof getEffectiveBookTitle === "function" ? getEffectiveBookTitle() : (snapshot.book_title || "")),
      pages: snapshot.pages_selected || editor.totalPages || 0,
      _saveType: window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "magazine" : "book",
      _coverHandle: (new URLSearchParams(location.search).get("cover") || getTemplateKey() || ""),
      photos: ph.map(p => ({ id: p.id, filename: p.filename, ratio: p.ratio, dateTaken: p.dateTaken, tags: p.tags, addedIndex: p.addedIndex })),
      photoIds: ph.map(p => p.id),
      // Cross-device version stamp — /list already returns meta fields, so the other
      // device sees a newer save without any Worker change. rev = content hash.
      savedAt: new Date().toISOString(),
      rev: _dmbCheapSig(snapshot, ph),
      device: _dmbDeviceId(),
    };
  }
  // ── Background R2 mirror of the FULL design — for EVERYONE (signed-in AND
  //    guests). Local (localStorage + IndexedDB) already saves instantly (Phase 1);
  //    this is the durable OFF-DEVICE copy so a lost wifi / closed tab / cleared
  //    storage / new device keeps the work. Debounced, and retried automatically
  //    when the connection returns (online / tab-visible listeners below). Photos
  //    upload as separate full-res binaries; the sticker/icon crop base64 stays
  //    INLINE in this JSON (R2 has no 5 MB limit) so the R2 copy is complete on its
  //    own. Guest copies live under designs/guest_<sid>/ and are promoted to the
  //    account by /claim on sign-in, or cleaned by /delete-guest + the R2 lifecycle.
  let _dmbR2Dirty = false, _dmbR2Busy = false, _dmbDesignFinalized = false;
  // The cloud copy is only written after a GENUINE user edit (set in pushUndoState) —
  // never from merely opening/restoring a book. This is what finally stops a device
  // that loaded a partial/odd copy from silently re-saving it over the good cloud data.
  let _dmbUserEdited = false;
  function _dmbCloudPersist() {
    if (_dmbRenderMode()) return;              // render mode: never touches the cloud copy
    if (_dmbDesignFinalized) return;   // added to cart → don't re-create the R2 copy
    if (!window.DMB_DESIGNS_PROXY || !editor || !editor.totalPages) return;
    _dmbR2Dirty = true;
    clearTimeout(_dmbCloudTimer);
    _dmbCloudTimer = setTimeout(_dmbR2Flush, 1800);
  }
  async function _dmbR2Flush() {
    if (_dmbRenderMode()) return;              // render mode: read-only on R2 (staged pages aside)
    if (_dmbDesignFinalized) return;
    if (_dmbR2Busy || !_dmbR2Dirty) return;
    if (!window.DMB_DESIGNS_PROXY || !editor || !editor.totalPages) return;
    if (navigator.onLine === false) return;                 // offline → wait for 'online'
    // NEVER persist a BLANK design — a transient empty state during load/openEditor
    // must never overwrite good cloud data with nothing. Require at least one photo,
    // one placed frame, or a cover element.
    try {
      const _refs = _dmbDesignPhotoRefs();
      const _blank = !((editor.photos || []).length) && _refs.size === 0 && !((editor.coverObjects || []).length) && !((editor.coverUserTexts || []).length);
      if (_blank) { _dmbR2Dirty = false; return; }
    } catch (e) {}
    // Only write to the cloud after a genuine user edit — never from just opening/
    // restoring a book (that's how a device with a partial copy re-saved it over good
    // data). Local storage still saves; only the shared cloud copy is held back.
    if (!_dmbUserEdited) { _dmbR2Dirty = false; return; }
    _dmbR2Busy = true;
    _dmbR2Dirty = false;                                     // optimistic; re-flag on failure
    try {
      const snapshot = getCurrentBuilderStateSnapshot();
      try { if (snapshot.editor && Array.isArray(snapshot.editor.photos)) snapshot.editor.photos = []; } catch (e) {}
      const meta = _dmbBuildCloudMeta(snapshot, editor.photos || []);
      // Content unchanged since the last cloud write? Skip it — saves bandwidth AND
      // prevents a redundant version bump. (rev is a content hash.)
      if (meta.rev === _dmbLastSavedSig) { _dmbCurRev = meta.rev; _dmbR2Busy = false; return; }
      let ok = false;
      if (window.DMB_CUSTOMER_ID && _dmbCloud.enabled()) {
        // (Anti-truncation photo-count guard REMOVED 2026-08-28: with auto-sync OFF the
        // churn source is gone, and the guard was LOCKING a bloated record — it stopped
        // the user cleaning a wrongly-inflated tray back down. The blank-save guard above
        // still prevents the catastrophic empty overwrite.)
        ok = await _dmbCloud.saveState(snapshot, meta);      // signed-in → /save
        if (ok) { _dmbLastSavedSig = meta.rev; _dmbCurRev = meta.rev; _dmbCurSavedAt = meta.savedAt; }   // our own latest — don't pull it back
        try { await _dmbCloud.savePhotosDelta(editor.photos || []); } catch (e) {}
      } else {
        let sid = ""; try { sid = _dmbPhotoBackup.guestId(); } catch (e) {}
        const gid = getCustomerSaveKey().replace(/^dmb_progress_/, "");
        if (sid && gid) {
          const r = await fetch(window.DMB_DESIGNS_PROXY + "/save-guest?id=" + encodeURIComponent(gid) + "&sid=" + encodeURIComponent(sid), {
            method: "POST", credentials: "same-origin",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ design: snapshot, meta: meta }),
          });
          ok = !!(r && r.ok);
          try { if (typeof _dmbBackupPhotos === "function") _dmbBackupPhotos(); } catch (e) {}  // guest photos → R2
        }
      }
      if (!ok) _dmbR2Dirty = true;
    } catch (e) { _dmbR2Dirty = true; }
    finally {
      _dmbR2Busy = false;
      if (_dmbR2Dirty) { clearTimeout(_dmbCloudTimer); _dmbCloudTimer = setTimeout(_dmbR2Flush, 8000); }  // retry
    }
  }
  (function _dmbWireR2Retry() {
    try {
      window.addEventListener("online", function () { if (_dmbR2Dirty) _dmbR2Flush(); });
      document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible" && _dmbR2Dirty) _dmbR2Flush(); });
    } catch (e) {}
  })();
  // Immediate (non-debounced) cloud manifest flush — used when LEAVING so the
  // account manifest (meta.photos) is never stale vs the design. The photo BYTES
  // are uploaded separately (instant backup + savePhotosDelta) and stay on R2, so
  // this only makes the photo LIST current — cheap. keepalive:true lets it survive
  // a tab-close/unload. Returns the fetch promise (awaitable for in-app nav), else null.
  function _dmbCloudFlushNow(keepalive) {
    if (_dmbRenderMode()) return null;         // render mode: no keepalive save on unload
    try {
      if (_dmbDesignFinalized) return null;   // added to cart → don't re-create the R2 copy
      if (!window.DMB_DESIGNS_PROXY || !editor || !editor.totalPages) return null;
      const snapshot = getCurrentBuilderStateSnapshot();
      try { if (snapshot.editor && Array.isArray(snapshot.editor.photos)) snapshot.editor.photos = []; } catch (e) {}
      const ph = editor.photos || [];
      const meta = _dmbBuildCloudMeta(snapshot, ph);
      if (window.DMB_CUSTOMER_ID && _dmbCloud.enabled()) {
        return fetch(_dmbCloud.base() + "/save?id=" + encodeURIComponent(_dmbCloud.designId()), {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ design: snapshot, meta: meta }),
          credentials: "same-origin", keepalive: !!keepalive,
        });
      }
      // Guest keepalive flush → guest R2 backup, so a last-second edit before the
      // tab closes still lands off-device (the debounced sync may not have fired).
      let sid = ""; try { sid = _dmbPhotoBackup.guestId(); } catch (e) {}
      const gid = getCustomerSaveKey().replace(/^dmb_progress_/, "");
      if (sid && gid) {
        return fetch(window.DMB_DESIGNS_PROXY + "/save-guest?id=" + encodeURIComponent(gid) + "&sid=" + encodeURIComponent(sid), {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ design: snapshot, meta: meta }),
          credentials: "same-origin", keepalive: !!keepalive,
        });
      }
      return null;
    } catch (e) { return null; }
  }

  // ── Option A · Step 2: guest photo backup to R2 ────────────────────────────
  // Streams each photo's bytes to R2 so they survive IndexedDB eviction (the iOS
  // data-loss case). Logged-in customers are already covered by _dmbCloud above;
  // this covers GUESTS, keyed by a persistent per-browser id (dmb_guest_id). The
  // upload is cheap on memory (fetch streams the File) and runs one photo at a time.
  const _dmbPhotoBackup = {
    _uploaded: {},                                   // designId -> Set(pid)
    base() { return window.DMB_DESIGNS_PROXY || ""; },
    enabled() { return !!window.DMB_DESIGNS_PROXY && !window.DMB_CUSTOMER_ID; },  // guests only
    designId() { try { return getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) { return "default"; } },
    guestId() {
      let g = null;
      try {
        g = localStorage.getItem("dmb_guest_id");
        if (!g) { g = "g" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem("dmb_guest_id", g); }
      } catch (e) {}
      return g;
    },
    _q() { const g = this.guestId(); return g ? ("&sid=" + encodeURIComponent(g)) : ""; },
    async uploadAll(photos) {
      if (!this.enabled() || !this.guestId() || !Array.isArray(photos) || !photos.length) return;
      const id = this.designId();
      let up = this._uploaded[id]; if (!up) { up = new Set(); this._uploaded[id] = up; }
      for (const ph of photos) {
        if (!ph || !ph.id || up.has(ph.id)) continue;
        let src = ph.file;
        if ((!src || !src.size) && ph.url) { try { src = await (await fetch(ph.url)).blob(); } catch (e) {} }
        if (!src || !src.size) continue;
        try {
          const r = await fetch(this.base() + "/photo?id=" + encodeURIComponent(id) + "&pid=" + encodeURIComponent(ph.id) + this._q(),
            { method: "POST", headers: { "content-type": src.type || "image/jpeg" }, body: src, credentials: "same-origin" });
          if (r.ok) up.add(ph.id);
        } catch (e) {}
        await new Promise((r) => setTimeout(r, 0));   // yield so memory is reclaimed between photos
      }
    },
    // Restore fallback: pull a single photo's bytes back from R2 when the local copy is gone.
    async fetchBlob(designId, pid) {
      if (!window.DMB_DESIGNS_PROXY || !this.guestId()) return null;
      try {
        const r = await fetch(this.base() + "/photo?id=" + encodeURIComponent(designId) + "&pid=" + encodeURIComponent(pid) + this._q(), { credentials: "same-origin" });
        if (!r.ok) return null;
        const b = await r.blob();
        return b && b.size ? b : null;
      } catch (e) { return null; }
    },
  };

  let _dmbBackupTimer = null;
  function _dmbBackupPhotos() {
    if (_dmbRenderMode()) return;              // render mode: never re-uploads photos
    if (!_dmbPhotoBackup.enabled()) return;
    clearTimeout(_dmbBackupTimer);
    _dmbBackupTimer = setTimeout(() => {
      try { _dmbPhotoBackup.uploadAll(editor.photos || []); } catch (e) {}
    }, 2500);
  }

  // ── INSTANT photo backup (upload step) ─────────────────────────────────────
  // The June backup (_dmbPhotoBackup/_dmbCloud) only kicks in AFTER the customer
  // enters the builder — a phone-tab crash during the UPLOAD STEP lost every
  // picked photo and bounced them to the landing page. This module streams each
  // photo to R2 the moment it is picked (serial queue, one at a time), keeps a
  // localStorage manifest, and offers a "your photos are safe" restore after a
  // crash. Works for guests (guest_<sid>) AND signed-in customers (the Worker's
  // verifiedIdentity prefers the customer id when logged in). Files upload
  // byte-for-byte — no recompression, no quality change.
  const _dmbInstantBackup = {
    _queue: [], _inFlight: 0, _failed: [], _done: 0, _total: 0, _badgeT: null,
    enabled() { return !!window.DMB_DESIGNS_PROXY; },
    designId() { try { return getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) { return "default"; } },
    pending() { return this._queue.length + this._inFlight; },
    _mKey() { return "dmb_upload_backup_" + this.designId(); },
    _manifest() { try { return JSON.parse(localStorage.getItem(this._mKey()) || "null") || { photos: [] }; } catch (e) { return { photos: [] }; } },
    _saveManifest(m) { try { localStorage.setItem(this._mKey(), JSON.stringify(m)); } catch (e) {} },
    clearManifest() { try { localStorage.removeItem(this._mKey()); } catch (e) {} },
    removeFromManifest(pid) {
      const m = this._manifest();
      m.photos = (m.photos || []).filter((p) => p.id !== pid);
      this._saveManifest(m);
    },
    // Tell the later builder-stage backups this pid is already on R2 so they skip it.
    _markUploaded(pid) {
      const id = this.designId();
      try { let s1 = _dmbPhotoBackup._uploaded[id]; if (!s1) { s1 = new Set(); _dmbPhotoBackup._uploaded[id] = s1; } s1.add(pid); } catch (e) {}
      try { let s2 = _dmbCloud._uploaded[id]; if (!s2) { s2 = new Set(); _dmbCloud._uploaded[id] = s2; } s2.add(pid); } catch (e) {}
      // Mark the in-memory photo as safely on R2 so Level-2 light-memory mode
      // (window.DMB_LIGHT_PHOTO_MEM) knows it can release its full-res bytes.
      try { const _pp = (editor.photos || []).find((p) => p && p.id === pid); if (_pp) _pp._r2 = true; } catch (e) {}
    },
    enqueue(file) {
      if (!this.enabled() || !file || !file.size || file._dmbPid) return;
      file._dmbPid = uid();
      this._queue.push(file);
      this._total++;
      this._badge();
      this._drain();
    },
    retryFailed() {
      if (!this._failed.length) return;
      this._queue.push.apply(this._queue, this._failed.splice(0));
      this._badge();
      this._drain();
    },
    async _uploadOne(f, id, sid) {
      let ok = false;
      for (let a = 0; a < 2 && !ok; a++) {           // 2 attempts per photo
        try {
          const r = await fetch(
            (window.DMB_DESIGNS_PROXY || "") + "/photo?id=" + encodeURIComponent(id) +
            "&pid=" + encodeURIComponent(f._dmbPid) + (sid ? "&sid=" + encodeURIComponent(sid) : ""),
            { method: "POST", headers: { "content-type": f.type || "image/jpeg" }, body: f, credentials: "same-origin" }
          );
          ok = r.ok;
        } catch (e) {}
        if (!ok && a === 0) await new Promise((r) => setTimeout(r, 900));
      }
      if (ok) {
        this._done++;
        this._markUploaded(f._dmbPid);
        const m = this._manifest();
        if (!(m.photos || []).some((p) => p.id === f._dmbPid)) {
          m.photos.push({ id: f._dmbPid, filename: f.name || "photo.jpg", type: f.type || "image/jpeg" });
        }
        m.sid = sid; m.ts = Date.now();
        this._saveManifest(m);
        // Print master (flag ON): once the PROXY is safely at photos/{pid}, push the
        // ~3500px master to photos-orig/{pid} on the BACKGROUND chain. It's outside
        // this queue on purpose: the import modal waits on proxies only, and the
        // master blob is freed as soon as its upload settles.
        try { if (_dmbPrintMasterOn() && f._dmbMaster) _dmbQueueMasterUpload(f, id, sid); } catch (e) {}
      } else {
        this._failed.push(f);
      }
      this._badge();
    },
    async _drain() {
      if (this._draining) return;
      this._draining = true;
      const id = this.designId();
      const sid = _dmbPhotoBackup.guestId();
      // Parallel uploads: fetch() STREAMS the File (no decode, low memory), so
      // concurrency is cheap. 6-wide + no inter-upload delay pushes photos to R2 as
      // fast as the connection allows (bandwidth-bound, not client-bound). Files stay
      // full-resolution — byte-for-byte, no quality loss.
      const self = this;
      async function worker() {
        while (self._queue.length) {
          const f = self._queue.shift();
          if (!f) break;
          self._inFlight++;
          try { await self._uploadOne(f, id, sid); } catch (e) { try { self._failed.push(f); } catch (e2) {} }
          self._inFlight--;
        }
      }
      const n = Math.min(6, Math.max(1, this._queue.length));
      const workers = []; for (let w = 0; w < n; w++) workers.push(worker());
      await Promise.all(workers);
      this._draining = false;
      this._badge();
      // A file enqueued in the tiny window while workers were exiting would sit
      // unprocessed until the next pick — catch it.
      if (this._queue.length) this._drain();
    },
    // Badge removed — photo backup runs silently in the background (no visible pill).
    _badge() {
      var b = document.getElementById("dmbInstantBackupBadge");
      if (b) { try { b.remove(); } catch (e) {} }
    },
    // Full-screen wait used by the "Do the Magic"/"Customize" gate: don't leave
    // the upload step while photos are still being secured.
    async waitWithOverlay() {
      let ov = document.getElementById("dmbBackupWaitOverlay");
      if (!ov) {
        ov = document.createElement("div");
        ov.id = "dmbBackupWaitOverlay";
        ov.style.cssText = "position:fixed;inset:0;z-index:1000003;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(250,247,242,0.97);gap:8px;";
        try { ov.appendChild(_dmbPvMakeLoadingNode()); } catch (e) {}
        const t = document.createElement("div");
        t.id = "dmbBackupWaitMsg";
        t.style.cssText = "font-size:15px;font-weight:800;color:#1e1e1e;";
        ov.appendChild(t);
        document.body.appendChild(ov);
      }
      const msg = ov.querySelector("#dmbBackupWaitMsg");
      while (this.pending() > 0) {
        if (msg) msg.textContent = "☁️ Securing your photos… " + this.pending() + " left";
        await new Promise((r) => setTimeout(r, 250));
      }
      try { ov.remove(); } catch (e) {}
    },
    // Crash recovery: a previous upload session streamed photos to R2 — offer to
    // bring them back instead of making the customer re-pick everything.
    async offerRestore() {
      if (!this.enabled() || bookFiles.length) return;
      const m = this._manifest();
      if (!m || !Array.isArray(m.photos) || !m.photos.length) return;
      if (document.getElementById("dmbUploadRestoreModal")) return;
      const n = m.photos.length;
      const self = this;
      const ov = document.createElement("div");
      ov.id = "dmbUploadRestoreModal";
      ov.style.cssText = "position:fixed;inset:0;z-index:1000000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.45);padding:20px;";
      const card = document.createElement("div");
      card.style.cssText = "background:#fff;border-radius:18px;max-width:380px;width:100%;padding:28px 24px 22px;box-shadow:0 24px 70px rgba(0,0,0,.4);text-align:center;";
      card.innerHTML =
        '<div style="font-size:36px;margin-bottom:8px;">📸</div>' +
        '<h3 style="margin:0 0 8px;font-size:20px;font-weight:900;color:#1e1e1e;">Your photos are safe!</h3>' +
        '<p style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#555;">' + n + ' photo' + (n !== 1 ? 's' : '') + ' from your last visit ' + (n !== 1 ? 'are' : 'is') + ' saved securely — bring ' + (n !== 1 ? 'them' : 'it') + ' back?</p>';
      const yes = document.createElement("button");
      yes.textContent = "Restore my photos";
      yes.style.cssText = "display:block;width:100%;background:#6d3bd4;color:#fff;border:none;border-radius:10px;padding:14px;cursor:pointer;font-weight:900;font-size:15px;margin-bottom:10px;";
      const no = document.createElement("button");
      no.textContent = "Start fresh";
      no.style.cssText = "display:block;width:100%;background:#f1ebe0;color:#555;border:none;border-radius:10px;padding:12px;cursor:pointer;font-weight:800;font-size:14px;";
      card.appendChild(yes); card.appendChild(no);
      ov.appendChild(card); document.body.appendChild(ov);
      no.addEventListener("click", () => { ov.remove(); self.clearManifest(); });
      yes.addEventListener("click", async () => {
        ov.remove();
        try { _dmbShowRestoreLoader(); } catch (e) {}
        const did = self.designId();
        const files = [];
        for (const p of m.photos) {
          try {
            const b = await _dmbPhotoBackup.fetchBlob(did, p.id);
            if (!b) continue;
            const f = new File([b], p.filename || "photo.jpg", { type: p.type || b.type || "image/jpeg" });
            f._dmbPid = p.id;          // already on R2 — enqueue() skips it
            self._markUploaded(p.id);
            files.push(f);
          } catch (e) {}
        }
        if (files.length) {
          bookFiles = mergeFilesKeepOld(bookFiles, files);
          try { validatePhotos(); } catch (e) {}
          try { renderUploadGrid(); } catch (e) {}
          try { refreshBuilderPhotos(); } catch (e) {}
        }
        try { _dmbHideRestoreLoader(); } catch (e) {}
        if (!files.length) alert("We couldn't reach your saved photos right now — please check your connection and refresh, or add them again.");
      });
    },

    // Silent restore (NO popup) — used when a GUEST refreshes the upload step, so an
    // accidental refresh doesn't lose their just-picked photos. Same download+inject
    // as the "yes" branch above, minus the offer dialog. Returns true if it restored.
    async restoreSilently() {
      if (!this.enabled() || bookFiles.length) return false;
      const m = this._manifest();
      if (!m || !Array.isArray(m.photos) || !m.photos.length) return false;
      const self = this;
      const did = self.designId();
      try { _dmbShowRestoreLoader(); } catch (e) {}
      const files = [];
      for (const p of m.photos) {
        try {
          const b = await _dmbPhotoBackup.fetchBlob(did, p.id);
          if (!b) continue;
          const f = new File([b], p.filename || "photo.jpg", { type: p.type || b.type || "image/jpeg" });
          f._dmbPid = p.id;
          self._markUploaded(p.id);
          files.push(f);
        } catch (e) {}
      }
      if (files.length) {
        bookFiles = mergeFilesKeepOld(bookFiles, files);
        try { validatePhotos(); } catch (e) {}
        try { renderUploadGrid(); } catch (e) {}
        try { refreshBuilderPhotos(); } catch (e) {}
      }
      try { _dmbHideRestoreLoader(); } catch (e) {}
      return files.length > 0;
    },
  };

  // Saved designs folder (theme page) — single source of truth for the link.
  var DMB_SAVED_DESIGNS_URL = "/pages/my-saved-designs";

  // Clean builder path used as the post-login return target. We deliberately keep
  // it MINIMAL (just ?restore=1) — Shopify's new customer accounts validate the
  // return_url and silently fall back to /account when it's a complex URL (extra
  // params like step=…). A clean same-origin path is far more likely to be honored,
  // so the customer actually lands back on the builder instead of the account page.
  function _dmbBuilderRestorePath() {
    var base = window.DMB_CARD_MODE ? "/pages/design-my-book?type=card&restore=1"
      : (window.DMB_MAGAZINE_MODE ? "/pages/design-my-magazine" : "/pages/design-my-book") + "?restore=1";
    // CRITICAL: carry the design's identity (cover/template/design) through the login
    // round-trip. getCustomerSaveKey() derives the save key from these params — drop
    // them and the key CHANGES after login, so the restore can't find the guest's
    // saved layout + photos and they appear lost. (Custom books are stable via a
    // stored id; template/cover designs MUST keep their param.)
    try {
      var sp = new URLSearchParams(location.search);
      ["cover", "template", "design"].forEach(function (k) {
        var v = sp.get(k);
        if (v) base += "&" + k + "=" + encodeURIComponent(v);
      });
    } catch (e) {}
    return base;
  }
  function _dmbLoginUrlBackToBuilder() {
    var u = window.DMB_LOGIN_URL || "/account/login";
    try {
      u += (u.indexOf("?") >= 0 ? "&" : "?") + "return_url=" + encodeURIComponent(_dmbBuilderRestorePath());
    } catch (e) {}
    return u;
  }

  // Login URL that returns to THIS page (the upload step) — used by the mandatory
  // upload-page sign-in gate so a guest lands back on the same upload page (now
  // signed in) and can proceed. (The builder variant above returns to ?step=2.)
  function _dmbLoginUrlBackToUpload() {
    var u = window.DMB_LOGIN_URL || "/account/login";
    try {
      var back = location.pathname + location.search;
      u += (u.indexOf("?") >= 0 ? "&" : "?") + "return_url=" + encodeURIComponent(back);
    } catch (e) {}
    return u;
  }

  // Central "leaving TO sign in" redirect. Used by EVERY sign-in button so the
  // behaviour is consistent: (1) mark __dmbGuestSigningIn so the guest's provisional
  // work is NOT discarded on the unload that this redirect triggers; (2) flush the
  // design locally so it survives the round-trip; (3) set dmb_save_after_login so
  // ON RETURN (now signed in) it's mirrored to the account. Then go to login.
  async function _dmbGoSignIn(loginUrl) {
    try { window.__dmbGuestSigningIn = true; } catch (e) {}
    try { localStorage.setItem("dmb_save_after_login", getCustomerSaveKey()); } catch (e) {}
    try { _dmbLeaveGuardDismissed = true; } catch (e) {}
    // Lightweight feedback so the button doesn't look frozen while we finish the
    // photo write (usually <1s; capped at 5s) before the redirect.
    var _ov = null;
    try {
      _ov = document.createElement("div");
      _ov.style.cssText = "position:fixed;inset:0;z-index:1000006;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.55);color:#fff;font-size:15px;font-weight:800;text-align:center;padding:20px;";
      _ov.textContent = "Saving your design… ☁️";
      document.body.appendChild(_ov);
      // Fallback: if the redirect is somehow blocked, don't leave the overlay stuck.
      setTimeout(function () { try { if (_ov && _ov.parentNode) _ov.remove(); } catch (e) {} }, 6000);
    } catch (e) {}
    // Persist the layout, then WAIT for the photo write before redirecting — a
    // fire-and-forget IDB save races the navigation, so photos added in the last
    // moment before Sign-in could be dropped and appear lost after login.
    try { _dmbWriteProgressState(); } catch (e) {}
    try {
      if (editor && Array.isArray(editor.photos) && editor.photos.length) {
        await Promise.race([
          _savePhotosToIDB(getCustomerSaveKey(), editor.photos),
          new Promise(function (r) { setTimeout(r, 5000); }),   // never trap the redirect
        ]);
      }
    } catch (e) {}
    location.assign(loginUrl || _dmbLoginUrlBackToBuilder());
  }

  // Discard a guest's provisional work when they LEAVE WITHOUT signing in: delete
  // their R2 photos (best-effort beacon; App Proxy signs it) and wipe the local
  // cache, so nothing lingers on the server and a later guest visit has nothing to
  // resume. Called only on a real page unload (see the pagehide listener), never on
  // a tab/app switch, and never when signing in (__dmbGuestSigningIn).
  function _dmbGuestDiscardOnLeave() {
    if (_dmbRenderMode()) return;              // render mode: never deletes anything
    try {
      var did = _dmbInstantBackup.designId();
      var sid = _dmbPhotoBackup.guestId();
      if (did && sid && window.DMB_DESIGNS_PROXY && navigator.sendBeacon) {
        navigator.sendBeacon(window.DMB_DESIGNS_PROXY + "/delete-guest?id=" +
          encodeURIComponent(did) + "&sid=" + encodeURIComponent(sid));
      }
    } catch (e) {}
    try { localStorage.removeItem(getCustomerSaveKey()); } catch (e) {}
    try { localStorage.removeItem("dmb_save_after_login"); } catch (e) {}
    try { if (_dmbInstantBackup.clearManifest) _dmbInstantBackup.clearManifest(); } catch (e) {}
    try { _clearPhotosFromIDB(getCustomerSaveKey()); } catch (e) {}
  }
  // True when THIS page load is a refresh/reload (vs a fresh navigation).
  function _dmbWasReload() {
    try {
      var _nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (_nav && _nav.type) return _nav.type === "reload";
      if (performance.navigation) return performance.navigation.type === 1;
    } catch (e) {}
    return false;
  }
  // True when this load CONTINUES the same browser tab (a refresh or in-tab nav),
  // vs a brand-new tab (fresh visit / bookmark / reopen after close). sessionStorage
  // survives refreshes on EVERY browser (incl. mobile Safari / bfcache) but is empty
  // in a new tab — far more reliable than Navigation Timing's reload type, which
  // mis-reports refreshes as "navigate" on some devices and was letting a guest's
  // refresh be treated as a fresh visit and DISCARD their design. Read the flag
  // (was this tab already active?) BEFORE setting it for the next load.
  var _DMB_TAB_CONTINUED = (function () {
    if (_dmbRenderMode()) return false;   // render mode: no sessionStorage write
    try {
      var _was = sessionStorage.getItem("dmb_tab_active_v1") === "1";
      sessionStorage.setItem("dmb_tab_active_v1", "1");
      return _was;
    } catch (e) { return false; }
  })();
  // ── Guest session lifecycle (decided at LOAD, by navigation type) ───────────
  // A guest's work is provisional. We CAN'T tell a refresh from a close at unload
  // time (both look identical), and discarding on unload nuked a design on an
  // accidental refresh. So instead we decide on the NEXT load:
  //   • RELOAD (refresh) → keep everything; the ?restore flow continues the design.
  //   • Any other entry (fresh visit / bookmark / back after closing) → discard the
  //     previous provisional work (R2 + local) so a returning guest starts clean and
  //     is never offered a resume.
  // "Close & never return" is cleaned by the R2 lifecycle. Signed-in customers are
  // exempt (they have real saved designs).
  (function _dmbGuestSessionLifecycle() {
    try {
      if (window.DMB_CUSTOMER_ID || !window.DMB_DESIGNS_PROXY) return;
      if (_dmbRenderMode()) return;   // render mode: never discards a guest design
      if (_dmbWasReload() || _DMB_TAB_CONTINUED) return; // refresh / same tab → keep + restore
      // A sign-in is in progress (they clicked "Sign in to save"): KEEP their work
      // even on a navigate return, in case login was cancelled/failed and they came
      // back to try again — otherwise clicking Sign-in then backing out would delete
      // the very design they were trying to save. (A SUCCESSFUL sign-in returns
      // signed-in → already exempt above; the flag is consumed once signed in.)
      try { if (localStorage.getItem("dmb_save_after_login")) return; } catch (e) {}
      var _hasStale = false;
      try { _hasStale = !!localStorage.getItem(getCustomerSaveKey()); } catch (e) {}
      if (_hasStale) _dmbGuestDiscardOnLeave();          // fresh entry → clear stale work
    } catch (e) {}
  })();

  // Clear confirmation after a design is saved to the account. Replaces the plain
  // toast so the customer can SEE where their designs live (the Saved designs
  // folder) and isn't left wondering whether/where it saved.
  function _dmbShowSavedConfirm() {
    var ov = document.getElementById("dmbSavedConfirm");
    if (ov) { ov.style.display = "flex"; return; }
    ov = document.createElement("div");
    ov.id = "dmbSavedConfirm";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000001;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.55);padding:18px;";
    var card = document.createElement("div");
    card.style.cssText = "background:#f4efe7;border-radius:20px;max-width:360px;width:100%;padding:30px 26px 22px;text-align:center;position:relative;box-shadow:0 24px 70px rgba(0,0,0,.35);font-family:inherit;";
    card.innerHTML =
      '<div style="font-size:34px;margin:2px 0 6px;">✅</div>' +
      '<h3 style="margin:0 0 6px;font-size:22px;font-weight:800;color:#1e1e1e;">Saved to your account</h3>' +
      '<p style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#a06f86;font-weight:600;">Your design is saved and you can reopen it on any device from your Saved designs folder.</p>' +
      '<a href="' + DMB_SAVED_DESIGNS_URL + '" style="display:block;text-decoration:none;box-sizing:border-box;background:#1e1e1e;color:#fff;border-radius:11px;padding:13px 18px;font-size:15px;font-weight:800;">📁 View my saved designs</a>' +
      '<button type="button" id="dmbSavedConfirmStay" style="margin-top:10px;background:transparent;border:none;color:#9a8f82;font-size:13px;font-weight:600;cursor:pointer;padding:6px;">Keep editing</button>';
    ov.appendChild(card);
    document.body.appendChild(ov);
    var close = function () { ov.style.display = "none"; };
    card.querySelector("#dmbSavedConfirmStay").addEventListener("click", close);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
  }

  // Guest nudge: "Sign in to save your design + open it on any device."
  // Dismissible, once per session, only when NOT logged in.
  function _dmbMaybeShowSignInPrompt() {
    if (_dmbRenderMode()) return;   // render mode: no UI
    if (window.DMB_CUSTOMER_ID) return;                       // already signed in
    if (!window.DMB_LOGIN_URL) return;
    try { if (sessionStorage.getItem("dmb_signin_prompted")) return; sessionStorage.setItem("dmb_signin_prompted", "1"); } catch (e) {}
    if (document.getElementById("dmbSignInPrompt")) return;
    // Light-card popup matching the site aesthetic, with an ✕ close in the corner.
    let bottomPx = 20;
    try {
      const tabs = document.getElementById("dmbMshTabs");
      if (tabs) { const b = tabs.getBoundingClientRect(); if (b.height > 0 && b.top < window.innerHeight) bottomPx = Math.max(20, window.innerHeight - b.top + 12); }
    } catch (e) {}
    const el = document.createElement("div");
    el.id = "dmbSignInPrompt";
    el.style.cssText = "position:fixed;bottom:" + bottomPx + "px;left:50%;transform:translateX(-50%);z-index:999998;background:#ffffff;color:#3d3833;border:1px solid #e7e1d4;border-radius:18px;padding:22px 24px 18px;box-shadow:0 18px 50px rgba(70,60,40,.28);width:min(340px,calc(100vw - 28px));box-sizing:border-box;font-family:inherit;text-align:center;";
    el.innerHTML =
      '<button type="button" id="dmbSignInPromptX" aria-label="Close" style="position:absolute;top:9px;right:12px;border:none;background:transparent;font-size:26px;line-height:1;color:#a89e8b;cursor:pointer;padding:4px 6px;">&times;</button>' +
      '<div style="font-size:32px;margin:0 0 6px;">&#128190;</div>' +
      '<h3 style="margin:0 0 5px;font-size:19px;font-weight:800;color:#3d3833;">Save your work</h3>' +
      '<p style="margin:0 0 16px;font-size:13.5px;line-height:1.5;color:#8a8272;font-weight:600;">Sign in to save your design and open it on any device.</p>' +
      '<button type="button" id="dmbSignInPromptGo" style="display:block;width:100%;box-sizing:border-box;background:#6b62d6;color:#fff;border:none;border-radius:11px;padding:13px 18px;font-size:15px;font-weight:800;cursor:pointer;">Sign in</button>';
    document.body.appendChild(el);
    el.querySelector("#dmbSignInPromptGo").addEventListener("click", () => { _dmbGoSignIn(); });
    el.querySelector("#dmbSignInPromptX").addEventListener("click", () => { el.remove(); });
    setTimeout(() => { if (el.isConnected) el.remove(); }, 20000);
  }

  // "Sign in to save" popup shown when a GUEST taps Save Design. Cream palette to
  // match the home sign-in popup. Signed-in users skip this and save directly.
  // opts.mandatory  → no ✕ / no "Maybe later" / no overlay-close (must sign in)
  // opts.loginUrl   → where the "Sign in" button redirects (default: back to builder)
  function _dmbShowSaveSignIn(opts) {
    opts = opts || {};
    var mandatory = !!opts.mandatory;
    var loginUrl  = opts.loginUrl || _dmbLoginUrlBackToBuilder();
    let ov = document.getElementById("dmbSaveSignIn");
    if (ov) { ov.style.display = "flex"; return; }
    ov = document.createElement("div");
    ov.id = "dmbSaveSignIn";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000001;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.55);padding:18px;";
    const card = document.createElement("div");
    card.style.cssText = "background:#f4efe7;border-radius:20px;max-width:360px;width:100%;padding:30px 26px 22px;text-align:center;position:relative;box-shadow:0 24px 70px rgba(0,0,0,.35);font-family:inherit;";
    card.innerHTML =
      (mandatory ? '' : '<button type="button" id="dmbSaveSignInX" aria-label="Close" style="position:absolute;top:10px;right:14px;border:none;background:transparent;font-size:26px;line-height:1;color:#8a8278;cursor:pointer;padding:4px;">&times;</button>') +
      '<div style="font-size:34px;margin:2px 0 6px;">💾</div>' +
      '<h3 style="margin:0 0 6px;font-size:22px;font-weight:800;color:#1e1e1e;">Sign in to save</h3>' +
      '<p style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#a06f86;font-weight:600;">Sign in to save your design and open it on all your devices.</p>' +
      '<button type="button" id="dmbSaveSignInGo" style="display:block;width:100%;box-sizing:border-box;background:#1e1e1e;color:#fff;border:none;border-radius:11px;padding:13px 18px;font-size:15px;font-weight:800;cursor:pointer;">Sign in</button>' +
      (mandatory ? '' : '<button type="button" id="dmbSaveSignInLater" style="margin-top:10px;background:transparent;border:none;color:#9a8f82;font-size:13px;font-weight:600;cursor:pointer;padding:6px;">Maybe later</button>');
    ov.appendChild(card);
    document.body.appendChild(ov);
    const close = () => { ov.style.display = "none"; };
    if (!mandatory) {
      var _x = card.querySelector("#dmbSaveSignInX");     if (_x) _x.addEventListener("click", close);
      var _l = card.querySelector("#dmbSaveSignInLater"); if (_l) _l.addEventListener("click", close);
      ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
    }
    card.querySelector("#dmbSaveSignInGo").addEventListener("click", () => { _dmbGoSignIn(loginUrl); });
  }

  // After a guest signs in via the Save Design popup, finish the save: once the
  // design has restored, mirror it to the customer's account on R2 (state + photos),
  // so it's saved permanently and reachable on any device. Runs once, then clears.
  function _dmbMaybeSaveAfterLogin() {
    if (!window.DMB_CUSTOMER_ID) return;
    let flag = null;
    try { flag = localStorage.getItem("dmb_save_after_login"); } catch (e) {}
    if (!flag) return;
    let tries = 0;
    const tick = () => {
      tries++;
      const ready = editor && editor.totalPages > 0;
      if (ready) {
        // settle a moment so restored photos are in editor.photos before we upload
        setTimeout(async () => {
          try { localStorage.removeItem("dmb_save_after_login"); } catch (e) {}
          try {
            // ── CLAIM FIRST ─────────────────────────────────────────────────
            // Copy the guest's R2 photos straight into the account server-side —
            // fast + reliable, independent of IndexedDB and the slow foreground
            // upload below. Mark the copied pids as already-uploaded so the delta
            // save doesn't re-push them (it then only handles the rare photo that
            // never reached R2 during the guest session).
            try {
              const _did = _dmbCloud.designId();
              const _claimed = await _dmbCloud.claim(_did);
              if (_claimed && Array.isArray(_claimed.pids) && _claimed.pids.length) {
                _dmbCloud._uploaded[_did] = _dmbCloud._uploaded[_did] || new Set();
                _claimed.pids.forEach((p) => _dmbCloud._uploaded[_did].add(p));
              }
            } catch (e) {}
            await saveCustomerProgress();                                   // local
            if (typeof _dmbCloudPersist === "function") _dmbCloudPersist();  // account (state + any un-claimed photos → R2)
            _dmbShowSavedConfirm();   // clear confirmation + link to the Saved designs folder
          } catch (e) {}
        }, 1500);
        return;
      }
      if (tries < 40) setTimeout(tick, 500);   // wait up to ~20s for the restore
      else { try { localStorage.removeItem("dmb_save_after_login"); } catch (e) {} }
    };
    setTimeout(tick, 800);
  }

  // Small bottom toast (reused for save confirmations).
  function _dmbToast(msg) {
    try {
      const el = document.createElement("div");
      el.style.cssText = "position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:1000002;background:#1e1e1e;color:#fff;border-radius:12px;padding:13px 18px;max-width:92vw;font-size:14px;font-weight:700;box-shadow:0 10px 40px rgba(0,0,0,.4);";
      el.textContent = msg;
      document.body.appendChild(el);
      setTimeout(() => { try { el.remove(); } catch (e) {} }, 5000);
    } catch (e) {}
  }

  async function _clearPhotosFromIDB(saveKey) {
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readwrite");
      const store = tx.objectStore("blobs");
      const keys = await new Promise(res => {
        const r = store.getAllKeys();
        r.onsuccess = () => res(r.result || []);
        r.onerror = () => res([]);
      });
      keys.filter(k => String(k).startsWith(saveKey + "__")).forEach(k => store.delete(k));
      await new Promise(res => { tx.oncomplete = res; tx.onerror = res; });
      db.close();
    } catch(e) {}
  }

  // ── Public save / load / clear ───────────────────────────────────────────
  async function saveCustomerProgress() {
    const key = getCustomerSaveKey();
    let _localOk = true;
    try {
      // Save builder state to localStorage (with timestamp)
      const payload = getCurrentBuilderStateSnapshot();
      payload.savedAt = new Date().toISOString();
      payload._saveType = window.DMB_CARD_MODE ? "card" : window.DMB_MAGAZINE_MODE ? "magazine" : "book";
      payload._templateKey = getTemplateKey() || "custom";
      // Cover handle: try URL ?cover= param, then ?template= param, then carry
      // forward whatever was stored in the previous save (so re-saving from
      // ?restore=1 — which has no ?cover= — doesn't lose the original handle).
      const _urlCover = new URLSearchParams(window.location.search).get("cover") || getTemplateKey() || "";
      const _prevSave = loadCustomerProgress();
      payload._coverHandle = _urlCover || (_prevSave && _prevSave._coverHandle) || "";
      // The photos array is dead weight in localStorage — restore reads photos
      // back from IndexedDB, never from here (see applyBuilderStateSnapshot). For
      // a big book it's the bulk of the payload, so dropping it keeps this write
      // well under the ~5 MB localStorage quota.
      try {
        if (payload.editor && Array.isArray(payload.editor.photos)) payload.editor.photos = [];
      } catch (_) {}
      // Heavy crop images (sticker/icon base64) also come OUT — they live in
      // IndexedDB (mirrored below) and are reattached on restore. Keeps this write
      // small so a few stickers can't overflow the ~5 MB cap and silently drop.
      try { _dmbStripObjImagesFromSnapshot(payload); } catch (_) {}
      try { _dmbPersistObjImages(); } catch (_) {}
      localStorage.setItem(key, JSON.stringify(payload));
    } catch(e) {
      // localStorage full/unavailable — do NOT alert and do NOT abort. Photos
      // still go to IndexedDB below, logged-in customers also get the cloud save,
      // and (critically) the order flow must never be blocked by a failed local
      // autosave. We just record that the local copy didn't land.
      _localOk = false;
      console.warn("saveCustomerProgress: localStorage write failed:", e);
    }
    // Save photos to IndexedDB in background — show progress
    if (saveMsg) { saveMsg.textContent = "Saving photos…"; saveMsg.style.display = "block"; }
    await _savePhotosToIDB(key, editor.photos || []);
    if (saveMsg) {
      saveMsg.textContent = _localOk ? "All saved ✅" : "Saved";
      setTimeout(() => { saveMsg.style.display = "none"; }, 2500);
    }
    return _localOk;
  }

  function loadCustomerProgress() {
    try {
      const raw = localStorage.getItem(getCustomerSaveKey());
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }

  async function clearCustomerProgress() {
    const key = getCustomerSaveKey();
    try { localStorage.removeItem(key); } catch {}
    await _clearPhotosFromIDB(key);
  }

  // Delete THIS design's cloud/R2 copy so it drops out of "Saved Designs". Used
  // after add-to-cart: clearCustomerProgress() only wipes the LOCAL copy, so the
  // account copy (which Saved Designs lists from R2) kept showing the book. Covers
  // signed-in (/design DELETE) and guests (/delete-guest).
  async function _dmbDeleteCloudDesign() {
    // Stop the background R2 sync from re-creating what we're about to delete.
    _dmbDesignFinalized = true;
    try { clearTimeout(_dmbCloudTimer); } catch (e) {}
    _dmbR2Dirty = false;
    if (!window.DMB_DESIGNS_PROXY) return;
    const proxy = window.DMB_DESIGNS_PROXY;
    let id = "";
    try { id = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
    if (!id) return;
    try {
      if (window.DMB_CUSTOMER_ID) {
        await fetch(proxy + "/design?id=" + encodeURIComponent(id), { method: "DELETE", credentials: "same-origin", keepalive: true });
      } else {
        let sid = ""; try { sid = _dmbPhotoBackup.guestId(); } catch (e) {}
        if (sid) await fetch(proxy + "/delete-guest?id=" + encodeURIComponent(id) + "&sid=" + encodeURIComponent(sid), { method: "POST", credentials: "same-origin", keepalive: true });
      }
    } catch (e) {}
  }

  // Cross-device / cleared-cache resume: a logged-in customer with no local copy
  // may still have a cloud design. Offer to restore it via the ?restore=1 flow.
  // Reload the builder with ?restore=1 so the tested restore flow auto-loads the
  // saved design (local + cloud) in place.
  function _dmbReloadWithRestore(href) {
    try { const u = new URL(href, location.origin); u.searchParams.set("restore", "1"); location.replace(u.toString()); }
    catch (e) { location.search = (location.search ? location.search + "&" : "?") + "restore=1"; }
  }
  // Builder URL that resumes a specific saved design (from its /list meta).
  function _dmbResumeUrlFor(d) {
    if (!d || !d.id) return null;
    const t = d._saveType || String(d.id).split("_")[0];
    const isMag = (t === "magazine" || t === "mag");
    const base = isMag ? "/pages/design-my-magazine" : "/pages/design-my-book";
    let u = base + "?restore=1";
    if (d._coverHandle) {
      u += isMag ? "&template=" + encodeURIComponent(d._coverHandle) : "&cover=" + encodeURIComponent(d._coverHandle);
    } else {
      const suffix = String(d.id).replace(/^(book|magazine|mag|card)_/, "");  // custom design → resume by id
      if (suffix) u += "&design=" + encodeURIComponent(suffix);
    }
    return u;
  }
  // ══════════════════════════════════════════════════════════════════════════
  // Instant cross-device sync (signed-in). Poll the photo-free /list every few
  // seconds while the tab is visible; when ANOTHER device saves a newer version of
  // THIS design, auto-load it (newest wins). No Worker change — the version stamp
  // (savedAt / rev / device) rides inside meta, which /list already returns.
  // ══════════════════════════════════════════════════════════════════════════
  let _dmbSyncTimer = null, _dmbSyncPendingRev = null, _dmbSyncReadyAt = 0, _dmbSyncBusy = false;
  function _dmbSyncActive() {
    return !!(window.DMB_CUSTOMER_ID && _dmbCloud && _dmbCloud.enabled() && !_dmbDesignFinalized);
  }
  async function _dmbSyncRemote() {
    try { const list = await _dmbCloud.list(); const curId = _dmbCloud.designId(); return (list || []).find((d) => d && d.id === curId) || null; }
    catch (e) { return null; }
  }
  function _dmbSyncPull(remote) {
    if (!remote) return;
    if (_dmbR2Dirty) { try { _dmbR2Flush(); } catch (e) {} return; }   // we hold newer local edits → keep ours
    if (_dmbDragSuppress) return;                                       // mid drag / nudge — wait for a calm moment
    try { if (_dmbModalOpen()) return; } catch (e) {}
    const u = _dmbResumeUrlFor(remote);
    if (u) { _dmbSyncBusy = true; try { location.assign(u); } catch (e) { _dmbSyncBusy = false; } }
  }
  async function _dmbSyncCheck(immediate) {
    if (!_dmbSyncActive() || _dmbSyncBusy) return;
    if (Date.now() < _dmbSyncReadyAt) return;                          // settle grace right after (re)load
    if (_dmbR2Dirty) { try { _dmbR2Flush(); } catch (e) {} return; }   // push ours first so it can win
    const remote = await _dmbSyncRemote();
    if (!remote || !remote.rev) return;
    // ── Photo-library protection ──────────────────────────────────────────
    // NEVER let a version with FEWER photos win — that truncation is exactly how this
    // book's tray got wiped (a device saved with an empty photo list). If WE hold more
    // photos than the cloud copy, PUSH ours (safe: only adds) and do not pull.
    const _remotePhotos = (remote.photoIds || []).length;
    const _localPhotos  = (editor && editor.photos ? editor.photos.length : 0);
    if (_localPhotos > _remotePhotos) { try { _dmbCloudPersist(); } catch (e) {} return; }
    // Same CONTENT as what we hold (rev is a content hash) → nothing to do, even if the
    // other device re-saved it with a newer time. This is what kills the reload loop.
    if (remote.rev === _dmbCurRev) { if (remote.savedAt) _dmbCurSavedAt = remote.savedAt; _dmbSyncPendingRev = null; return; }
    // Different content, but it's OUR device's own newer save — adopt as current.
    if (remote.device && remote.device === _dmbDeviceId()) { _dmbCurRev = remote.rev; _dmbCurSavedAt = remote.savedAt || _dmbCurSavedAt; return; }
    // Another device holds genuinely different content — pull if it's newer by time.
    const newer = remote.savedAt && (!_dmbCurSavedAt || remote.savedAt > _dmbCurSavedAt);
    if (!newer) return;
    // Pull instantly if the user just refocused this tab; otherwise wait one poll for
    // the other device to settle (so we don't reload on its every keystroke).
    if (immediate || _dmbSyncPendingRev === remote.rev) _dmbSyncPull(remote);
    else _dmbSyncPendingRev = remote.rev;
  }

  // ── Cross-device DIAGNOSTIC (open the book with ?dmbdiag=1) ────────────────
  // Shows the real facts on THIS device: the design id in use, how many photos the
  // layout references, how many are actually in R2, how many locally. Lets us pinpoint
  // WHY photos differ across devices instead of guessing.
  // Photo ids a DESIGN object PLACES (template slots, layout frames, full-spread, free
  // frames, cover). `design` = { editor:{...}, coverState:{...} }.
  function _dmbRefsFromDesign(design) {
    const s = new Set();
    try {
      const E = (design && design.editor) || {};
      Object.values(E.pageSlots || {}).forEach(ps => { if (ps) { if (ps.A) s.add(ps.A); if (ps.B) s.add(ps.B); } });
      Object.values(E.pageFrames || {}).forEach(fr => { if (fr) Object.values(fr).forEach(v => { if (v) s.add(v); }); });
      Object.values(E.spreadPhoto || {}).forEach(sp => { if (sp && sp.photoId) s.add(sp.photoId); });
      Object.values(E.pageObjects || {}).forEach(arr => { if (Array.isArray(arr)) arr.forEach(o => { if (o && o.type === "photo-frame" && o.photoId) s.add(o.photoId); }); });
      (E.coverObjects || []).forEach(o => { if (o && o.type === "photo-frame" && o.photoId) s.add(o.photoId); });
      const cs = (design && design.coverState) || {};
      ["frontImageId", "backImageId", "bleedImageId"].forEach(k => { if (cs[k]) s.add(cs[k]); });
    } catch (e) {}
    return s;
  }
  // Same, for the CURRENT live builder (used by the diagnostic).
  function _dmbDesignPhotoRefs() {
    return _dmbRefsFromDesign({ editor: (typeof editor !== "undefined" ? editor : {}), coverState: (typeof coverState !== "undefined" ? coverState : {}) });
  }
  async function _dmbDiagPanel() {
    if (document.getElementById("dmbDiagPanel")) return;
    const proxy = window.DMB_DESIGNS_PROXY || "/apps/designs";
    const cid = window.DMB_CUSTOMER_ID || "(not signed in)";
    let designId = "?"; try { designId = _dmbCloud.designId(); } catch (e) {}
    const refs = Array.from(_dmbDesignPhotoRefs());
    const localCount = (editor && editor.photos ? editor.photos.length : 0);
    let r2 = [], r2err = "", listEntry = null;
    try {
      const rr = await fetch(proxy + "/photos?id=" + encodeURIComponent(designId), { credentials: "same-origin" });
      if (rr.ok) { const d = await rr.json(); r2 = (d.photos || []).map(p => p.pid || p.id); } else r2err = "HTTP " + rr.status;
    } catch (e) { r2err = String(e && e.message || e); }
    try { const list = await _dmbCloud.list(); listEntry = (list || []).find(d => d && d.id === designId) || null; } catch (e) {}
    const r2set = new Set(r2);
    const refsInR2 = refs.filter(id => r2set.has(id)).length;
    const missing = refs.filter(id => !r2set.has(id));
    const localSet = new Set((editor && editor.photos || []).map(p => p.id));
    const refsLocal = refs.filter(id => localSet.has(id)).length;

    const restoreQ = (new URLSearchParams(location.search).get("restore") === "1") ? "YES (loaded from cloud)" : "no (loaded local)";
    let pageItems = 0, coverItems = 0, pageCount = 0, extra = 0;
    try {
      const E = editor || {};
      Object.values(E.pageObjects || {}).forEach(a => { if (Array.isArray(a)) pageItems += a.length; });
      coverItems = ((E.coverObjects || []).length) + ((E.coverUserTexts || []).length);
      pageCount = E.totalPages || 0; extra = E.extraSpreads || 0;
    } catch (e) {}
    const lines = [
      "CODE VERSION: 20260828b",
      "Pages: " + pageCount + " (extra spreads " + extra + ")  |  items on pages: " + pageItems + "  |  cover items: " + coverItems,
      "DEVICE: " + (navigator.userAgent.slice(0, 60)),
      "Loaded via ?restore=1: " + restoreQ,
      "Signed-in customer: " + cid,
      "Design id (this device): " + designId,
      "",
      "PHOTOS IN THE TRAY (editor.photos): " + localCount,
      "Photos the layout PLACES: " + refs.length,
      "  • those present in R2:   " + refsInR2 + " / " + refs.length,
      "  • those loaded locally:  " + refsLocal + " / " + refs.length,
      "Total objects in R2 for this id: " + (r2err ? ("ERROR " + r2err) : r2.length),
      "",
      "/list entry (cloud record): " + (listEntry ? ("photoIds=" + ((listEntry.photoIds || []).length) + ", savedAt=" + (listEntry.savedAt || "?") + ", device=" + (listEntry.device || "?")) : "NOT FOUND"),
      "",
      "Missing-from-R2 sample: " + (missing.slice(0, 6).join(", ") || "(none)"),
      "R2 pids sample: " + (r2.slice(0, 8).join(", ") || "(none)"),
    ];
    const ov = document.createElement("div");
    ov.id = "dmbDiagPanel";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000005;background:rgba(0,0,0,.75);display:flex;align-items:center;justify-content:center;padding:16px;";
    const card = document.createElement("div");
    card.style.cssText = "background:#111;color:#eee;border:1px solid #444;border-radius:14px;max-width:560px;width:100%;padding:18px;font-family:ui-monospace,Menlo,monospace;font-size:12.5px;line-height:1.55;box-shadow:0 20px 60px rgba(0,0,0,.6);";
    const ta = document.createElement("textarea");
    ta.readOnly = true; ta.value = lines.join("\n");
    ta.style.cssText = "width:100%;height:300px;background:#0b0b0b;color:#cfe;border:1px solid #333;border-radius:8px;padding:10px;font:inherit;resize:vertical;box-sizing:border-box;";
    const title = document.createElement("div"); title.textContent = "☁️ Cross-device photo diagnostic"; title.style.cssText = "font-weight:900;font-size:14px;margin-bottom:10px;color:#fff;font-family:system-ui,sans-serif;";
    const row = document.createElement("div"); row.style.cssText = "display:flex;gap:8px;margin-top:12px;";
    const copyBtn = document.createElement("button"); copyBtn.textContent = "Copy"; copyBtn.style.cssText = "flex:1;background:#6d6de6;color:#111;border:none;border-radius:8px;padding:10px;font-weight:800;cursor:pointer;font-family:system-ui,sans-serif;";
    copyBtn.onclick = () => { try { ta.select(); document.execCommand("copy"); copyBtn.textContent = "Copied ✓"; } catch (e) {} };
    const closeBtn = document.createElement("button"); closeBtn.textContent = "Close"; closeBtn.style.cssText = "flex:1;background:#333;color:#fff;border:none;border-radius:8px;padding:10px;font-weight:800;cursor:pointer;font-family:system-ui,sans-serif;";
    closeBtn.onclick = () => { try { ov.remove(); } catch (e) {} };
    card.appendChild(title); card.appendChild(ta); row.appendChild(copyBtn); row.appendChild(closeBtn); card.appendChild(row);
    ov.appendChild(card); document.body.appendChild(ov);
  }
  try { if (new URLSearchParams(location.search).get("dmbdiag") === "1") setTimeout(() => { try { _dmbDiagPanel(); } catch (e) {} }, 5000); } catch (e) {}
  // AUTOMATIC cross-device sync is DISABLED (2026-08-27). Its polling + auto-pull +
  // heal-push churned designs across devices and degraded a real customer book. Until it
  // is redesigned as an explicit, conflict-safe "Sync now" action, this is a no-op:
  // designs still save to the cloud on edit and restore on resume (the safe originals),
  // just with no background device-to-device propagation. The save-side SAFETY guards
  // (empty-save + anti-truncation in _dmbR2Flush) stay ON.
  function _dmbStartCrossDeviceSync() {
    return;   // disabled — see comment above
  }

  // Signed-in customer with no local copy: OFFER to resume their saved cloud design
  // (prefer the one matching this context, else the most recent). A banner — it never
  // auto-forces, so deliberately starting a fresh design still works.
  async function _dmbAutoCloudRestore() {
    if (restoreParam === "1") return;
    try {
      const list = await _dmbCloud.list();
      if (!list || !list.length) return;
      // ONLY offer a restore for THIS exact book (its own design id). Previously
      // this defaulted to list[0] (the most-recently-saved design) when the current
      // id wasn't found — so opening a NEW book offered the LAST book's design +
      // photos. A book with no saved design of its own now restores nothing.
      const curId = _dmbCloud.designId();
      const m = list.find((d) => d && d.id === curId);
      if (m) _dmbOfferCloudResume(m);
    } catch (e) {}
  }
  // Centered "welcome back" modal offering to resume a saved cloud design.
  function _dmbOfferCloudResume(target) {
    if (!target) return;
    _dmbResumeModal(
      () => { const u = _dmbResumeUrlFor(target); if (u) location.assign(u); },
      () => {}
    );
  }

  // Discreet, page-styled "restore this book's saved design" card on the upload
  // step — REPLACES the old auto "Your photos are safe" popup, which fired on any
  // book (its manifest key was shared for custom books). This one:
  //   • only for SIGNED-IN customers,
  //   • only when a saved design for THIS EXACT book exists (cloud id match) OR
  //     this book has photos from an interrupted upload (local manifest),
  //   • inserted just above the "+ Add Photos" button, never as a blocking popup.
  async function _dmbShowRestoreThisBook() {
    try {
      if (!window.DMB_CUSTOMER_ID || !_dmbCloud.enabled()) return;   // signed-in only
      if (bookFiles && bookFiles.length) return;                     // already adding photos
      if (document.getElementById("dmbRestoreThisBook")) return;

      // A saved cloud design for THIS EXACT book only (scoped by design id) — so it
      // never appears on a different book, only where a real saved design exists.
      let target = null;
      try {
        const list = await _dmbCloud.list();
        const curId = _dmbCloud.designId();
        target = (list || []).find((d) => d && d.id === curId) || null;
      } catch (e) {}
      if (!target) return;
      if (bookFiles && bookFiles.length) return;                     // photos added while we fetched
      if (document.getElementById("dmbRestoreThisBook")) return;

      const btn = document.querySelector(".dmb-upload2-btn--primary");
      if (!btn || !btn.parentElement) return;

      const n = target.photos ? target.photos.length : (target.photoIds ? target.photoIds.length : 0);
      const card = document.createElement("div");
      card.id = "dmbRestoreThisBook";
      card.style.cssText = "display:flex;align-items:center;gap:12px;background:#fff;border:1px solid #e4ded3;border-radius:14px;padding:12px 14px;margin-bottom:14px;box-shadow:0 6px 20px rgba(0,0,0,.06);";
      const txt = document.createElement("div");
      txt.style.cssText = "flex:1;min-width:0;text-align:left;";
      txt.innerHTML =
        '<div style="font-weight:900;color:#1e1e1e;font-size:14px;">📂 You have a saved design for this book</div>' +
        '<div style="font-size:12.5px;color:#666;font-weight:600;margin-top:2px;">' +
        (n ? ("Pick up where you left off — " + n + " photo" + (n === 1 ? "" : "s") + " saved.") : "Pick up right where you left off.") +
        '</div>';
      const go = document.createElement("button");
      go.type = "button"; go.textContent = "Restore";
      go.style.cssText = "flex-shrink:0;background:#6d3bd4;color:#fff;border:none;border-radius:10px;padding:10px 18px;font-weight:900;font-size:14px;cursor:pointer;";
      go.addEventListener("click", () => { const u = _dmbResumeUrlFor(target); if (u) location.assign(u); });
      card.appendChild(txt); card.appendChild(go);
      btn.parentElement.insertBefore(card, btn);
    } catch (e) {}
  }

  // Set when the user actively entered the builder from the upload step (they are
  // now designing THIS design) — suppresses the "Resume from where you left off?"
  // banner, which would otherwise pop up on top of the design they just started
  // (progress is saved immediately on entry, so it would always trigger).
  let _dmbSuppressResumeOffer = false;

  function offerCustomerProgressRestore() {
    // If we arrived via ?restore=1, the IIFE below already handles restore
    // automatically — don't show the banner on top of that.
    if (restoreParam === "1") return;
    // Just came from the upload flow → already in this design, don't offer resume.
    if (_dmbSuppressResumeOffer) return;
    // Only offer resume to a SIGNED-IN customer who has a saved version of THIS
    // exact design (per-design save key). Guests never see it — their local
    // autosave shouldn't trigger a "resume?" prompt on a design they're in.
    if (!window.DMB_CUSTOMER_ID) return;
    const saved = loadCustomerProgress();
    if (!saved) {
      // No local copy — a logged-in customer may have a cloud design. Auto-restore it.
      if (_dmbCloud.enabled()) { _dmbAutoCloudRestore(); }
      return;
    }

    const banner = document.createElement("div");
    banner.style.cssText = "position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#1e1e1e;color:#fff;border-radius:12px;padding:14px 20px;display:flex;align-items:center;gap:14px;z-index:999999;box-shadow:0 8px 30px rgba(0,0,0,.5);font-size:14px;font-weight:700;max-width:92vw;";
    banner.innerHTML = `<span>📂 Resume from where you left off?</span>`;

    const yesBtn = document.createElement("button");
    yesBtn.textContent = "Resume";
    yesBtn.style.cssText = "background:#4a90e2;color:#fff;border:none;border-radius:8px;padding:8px 16px;cursor:pointer;font-weight:900;font-size:13px;flex-shrink:0;";

    const noBtn = document.createElement("button");
    noBtn.textContent = "Start fresh";
    noBtn.style.cssText = "background:#444;color:#fff;border:none;border-radius:8px;padding:8px 14px;cursor:pointer;font-weight:700;font-size:13px;flex-shrink:0;";

    banner.appendChild(yesBtn);
    banner.appendChild(noBtn);
    document.body.appendChild(banner);

    yesBtn.addEventListener("click", async () => {
      banner.remove();
      if (saveMsg) { saveMsg.textContent = "Restoring…"; saveMsg.style.display = "block"; }

      const _cl = v => { try { return JSON.parse(JSON.stringify(v || {})); } catch(e) { return {}; } };
      const se  = saved.editor || {};
      _dmbApplyRecentColors(saved);   // sync the colour palette

      // ── 1. Load IDB photos ───────────────────────────────────────────────
      const idbPhotos = await _loadPhotosFromIDB(getCustomerSaveKey());
      // Re-key restored photos to the IDs the saved layout references, so placed
      // photos resolve (otherwise spreads show blank/white while the tray is fine).
      _dmbReconcilePhotoIds(idbPhotos, se);
      // Only replace editor.photos if IDB has them (IDs now match saved page slots)
      const useIdb = idbPhotos.length > 0;
      if (useIdb) {
        editor.photos = idbPhotos;
        try { bookFiles = idbPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
      }
      // If no IDB photos: keep current editor.photos (this session's uploads).
      // We skip restoring page-slot assignments since IDs won't match.

      // ── 2. Always restore cover state (does not depend on photo IDs) ─────
      if (saved.coverState) {
        const cs = saved.coverState;
        ["frontImageUrl","backImageUrl","bleedImageUrl","spineImageUrl","imageUrl"].forEach(k => {
          if (cs[k] && String(cs[k]).startsWith("blob:")) {
            // Keep bleedImageId + bleedZone. _dmbRehydrateCoverPhotoUrls() below
            // rebuilds the URL from the id; deleting the id here destroyed the
            // wrap-around cover background on EVERY resume. See the full note in
            // _dmbApplySavedEditorState.
            cs[k] = ""; if (k === "bleedImageUrl" && !cs.bleedImageId) { cs.bleedZone = ""; }
          }
        });
        Object.keys(cs).forEach(k => { try { coverState[k] = cs[k]; } catch(e) {} });
        if (coverColorSwatch) coverColorSwatch.style.background = coverState.color || "#ffffff";
        try { syncCoverInputsFromState(); } catch(e) {}
      }

      // ── 3. Always restore page structure (layout templates, stickers, maps)
      editor.pageTemplate    = _cl(se.pageTemplate);
      editor.pageFrames      = _cl(se.pageFrames);
      editor.pageFrameRot    = _cl(se.pageFrameRot);
      editor.pageFrameShapes = _cl(se.pageFrameShapes);
      editor.pageObjects     = _cl(se.pageObjects);
      editor.coverObjects    = Array.isArray(se.coverObjects)   ? _cl(se.coverObjects)   : [];
      editor.coverUserTexts  = Array.isArray(se.coverUserTexts) ? _cl(se.coverUserTexts) : [];
      if (!Array.isArray(editor.coverObjects)) try { migrateCoverObjectsToFlat(); } catch(e) {}

      // ── 4. Restore photo assignments ONLY if IDB photos are available ────
      if (useIdb) {
        editor.pageSlots   = _cl(se.pageSlots);
        editor.pageRot     = _cl(se.pageRot);
        editor.spreadPhoto = _cl(se.spreadPhoto || {});
      }
      // If no IDB: keep current pageSlots (user will drag fresh photos to pages)

      // ── 5. Restore pages count + extra spreads ───────────────────────────
      // Restore the EXTRA SPREADS first (added spreads = +2 pages / +1 spread each).
      editor.extraSpreads = se.extraSpreads || 0;
      const pg = se.totalPages || Number(saved.pages_selected) || editor.totalPages || 0;
      if (pg) {
        editor.totalPages    = pg;
        editor.editablePages = se.editablePages || Math.max(0, pg - 1);
        editor.totalSpreads  = se.totalSpreads  || Math.max(1, Math.ceil(pg / 2));
        // The #pages dropdown holds the BASE page count (a real option), NOT the
        // total-with-extra-spreads — renderSpread recomputes total = base + extras.
        // Setting it to the total (e.g. 32) selects nothing → the builder renders
        // a blank "Spread 1/1". So set the base and let extraSpreads add the rest.
        const _base = Number(saved.pages_selected) || Math.max(0, pg - (editor.extraSpreads || 0) * 2) || pg;
        const _pEl = document.getElementById("pages");
        if (_pEl) _pEl.value = String(_base);
        const _s1bEl = document.getElementById("step1bPages");   // keep the upload-step dropdown in sync too
        if (_s1bEl) _s1bEl.value = String(_base);
        try { updatePrice(); } catch(e) {}
        try { _syncSpreadAdderUI(); } catch(e) {}
      }
      editor.currentSpread = 0;
      builderMode = saved.builderMode || "pages";

      // Rebuild cover face/bleed image URLs from their preserved photo IDs
      // (the blob: URLs were cleared in step 2). Photos are loaded by now.
      if (useIdb) { try { _dmbRehydrateCoverPhotoUrls(); } catch(e) {} }

      // Reattach sticker/icon crop images (base64) from IndexedDB (stripped from state).
      try { _dmbReattachObjImages(await _dmbLoadObjImagesFromIDB(getCustomerSaveKey())); } catch(e) {}

      // ── 6. Re-render ─────────────────────────────────────────────────────
      try { syncCoverInputsFromState(); } catch(e) {}
      try { renderPhotoTray(); }          catch(e) {}
      try { renderThumbsRail(); }         catch(e) {}
      // Explicitly re-render the cover even if builderMode is "pages",
      // because coverState + coverObjects were just restored.
      try { renderCoverCanvas(); }        catch(e) {}
      try { renderBuilderCanvas(); }      catch(e) {}
      // Progress restore replaces ALL pages — clear stale preview cache
      try { _dmbPvReinitAll(); }          catch(e) {}

      if (saveMsg) saveMsg.style.display = "none";
      _dmbToast(useIdb
        ? `Restored — ${idbPhotos.length} photos + full layout`
        : "Cover & layout restored — drag your photos onto the pages");

      // ── 7. Cloud reconcile (ADDITIVE) ────────────────────────────────────
      // Recover any photo the layout references but IndexedDB no longer has —
      // partial eviction (the reported "most photos missing on the laptop"
      // case) or a full eviction / different device. When IDB had nothing but a
      // saved layout exists AND the cloud is reachable, also restore the page
      // assignments (ids match the cloud photo ids) so pulled-back photos land
      // in their right places instead of the "drag your photos" fallback.
      try {
        const _proxy = !!window.DMB_DESIGNS_PROXY;
        if (_proxy && !useIdb) {
          editor.pageSlots   = _cl(se.pageSlots);
          editor.pageRot     = _cl(se.pageRot);
          editor.spreadPhoto = _cl(se.spreadPhoto || {});
          try { _dmbRehydrateCoverPhotoUrls(); } catch (e) {}
        }
        const _recovered = await _dmbReconcileMissingPhotosFromCloud();
        if (_recovered > 0 || (_proxy && !useIdb)) {
          try { bookFiles = editor.photos.map((p) => p.file || new File([], p.filename || "photo")); } catch (e) {}
          try { renderPhotoTray(); }     catch (e) {}
          try { renderThumbsRail(); }    catch (e) {}
          try { renderCoverCanvas(); }   catch (e) {}
          try { renderBuilderCanvas(); } catch (e) {}
          try { _dmbPvReinitAll(); }     catch (e) {}
        }
        if (_recovered > 0) {
          if (saveMsg) saveMsg.style.display = "none";
          _dmbToast(`Restored — recovered ${_recovered} photo${_recovered === 1 ? "" : "s"} from the cloud`);
        }
      } catch (e) {}
    });

    noBtn.addEventListener("click", async () => {
      banner.remove();
      // Custom book: keep the previous design and start a NEW id (so a second
      // custom book never overwrites the first). Templates/products: clear as before.
      const _isCustom = !getTemplateKey() && !(new URLSearchParams(location.search).get("cover"));
      if (_isCustom) { _dmbRotateCustomId(); }
      else { await clearCustomerProgress(); }
    });

    setTimeout(() => { if (banner.isConnected) banner.remove(); }, 30000);
  }

  function buildTemplatePayload() {
    return {
      coverState: cloneState(coverState),
      coverObjects: cloneState(ensureCoverObjects()),
      activeCoverZone: activeCoverZone || "front",
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      page0: {
        pageSlots: cloneState(editor.pageSlots?.[0] || { A: null, B: null }),
        pageFrames: cloneState(editor.pageFrames?.[0] || {}),
        pageTemplate: editor.pageTemplate?.[0] || null,
        pageObjects: cloneState(editor.pageObjects?.[0] || []),
        pageRot: cloneState(editor.pageRot?.[0] || { A: 0, B: 0 })
      }
    };
  }

  function saveCurrentTemplate() {
    const templateKey = getTemplateKey();

    if (!templateKey) {
      alert("No template key found in the URL.");
      return;
    }

    try {
      const payload = buildTemplatePayload();
      localStorage.setItem(getTemplateStorageKey(templateKey), JSON.stringify(payload));

      if (saveMsg) {
        saveMsg.textContent = `Template ${templateKey} saved ✅`;
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1600);
      }
    } catch (err) {
      console.error(err);
      alert("Could not save template.");
    }
  }

  function loadTemplateByKey(templateKey) {
    if (!templateKey) return false;

    try {
      const raw = localStorage.getItem(getTemplateStorageKey(templateKey));
      if (!raw) return false;

      const payload = JSON.parse(raw);

      coverState.template = payload.coverState?.template || "default";
      coverState.title1 = payload.coverState?.title1 || "";
      coverState.title2 = payload.coverState?.title2 || "";
      coverState.color = payload.coverState?.color || "#ffffff";
      coverState.imageUrl = payload.coverState?.imageUrl || "";
      coverState.imageFile = payload.coverState?.imageFile || null;
      coverState.textStyles = cloneState(payload.coverState?.textStyles || {});

      editor.coverObjects = cloneState(payload.coverObjects || []);
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      activeCoverZone = payload.activeCoverZone || "front";
      editor.coverUserTexts = cloneState(payload.coverUserTexts || []);

      // Restore Page 0 state
      if (payload.page0) {
        if (!editor.pageSlots) editor.pageSlots = {};
        if (!editor.pageFrames) editor.pageFrames = {};
        if (!editor.pageTemplate) editor.pageTemplate = {};
        if (!editor.pageObjects) editor.pageObjects = {};
        if (!editor.pageRot) editor.pageRot = {};
        editor.pageSlots[0] = cloneState(payload.page0.pageSlots || { A: null, B: null });
        editor.pageFrames[0] = cloneState(payload.page0.pageFrames || {});
        editor.pageTemplate[0] = payload.page0.pageTemplate || null;
        editor.pageObjects[0] = cloneState(payload.page0.pageObjects || []);
        editor.pageRot[0] = cloneState(payload.page0.pageRot || { A: 0, B: 0 });
      }

      syncCoverInputsFromState();
      builderMode = "cover";
      renderBuilderCanvas();
      // Template also replaces page 0 content — dirty-mark it too
      try { _dmbPvMarkDirty(0); } catch(e) {}
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  function getTemplateStorageKey(templateKey) {
    return `dmb_template_${templateKey}`;
  }

  function buildTemplatePayload() {
    return {
      coverState: cloneState(coverState),
      coverObjects: cloneState(ensureCoverObjects()),
      activeCoverZone: activeCoverZone || "front",
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      page0: {
        pageSlots: cloneState(editor.pageSlots?.[0] || { A: null, B: null }),
        pageFrames: cloneState(editor.pageFrames?.[0] || {}),
        pageTemplate: editor.pageTemplate?.[0] || null,
        pageObjects: cloneState(editor.pageObjects?.[0] || []),
        pageRot: cloneState(editor.pageRot?.[0] || { A: 0, B: 0 })
      }
    };
  }

  function saveCurrentTemplate() {
    const templateKey = getTemplateKey();

    if (!templateKey) {
      alert("No template key found in the URL.");
      return;
    }

    try {
      const payload = buildTemplatePayload();
      localStorage.setItem(getTemplateStorageKey(templateKey), JSON.stringify(payload));

      if (saveMsg) {
        saveMsg.textContent = `Template ${templateKey} saved ✅`;
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1600);
      }
    } catch (err) {
      console.error(err);
      alert("Could not save template.");
    }
  }

  // All per-page structural maps that an edit can touch. Capturing/restoring the FULL
  // set is what makes undo/redo work for every action (background colours, frame shapes,
  // full-spread photos, etc.) — not just the handful the old snapshot listed.
  const _DMB_UNDO_MAPS = [
    "pageSlots", "pageRot", "pageTemplate", "pageFrames", "pageFrameRot",
    "pageFrameShapes", "pageObjects", "pageBackgrounds", "spreadPhoto", "magicPages"
  ];
  function _dmbCaptureState(label) {
    const s = {
      label: label || "Edited",
      builderMode,
      currentSpread: editor.currentSpread,
      totalPages: editor.totalPages,
      editablePages: editor.editablePages,
      totalSpreads: editor.totalSpreads,
      extraSpreads: editor.extraSpreads,
      bookSize: editor.bookSize,
      orientation: editor.orientation,
      coverObjects: cloneState(ensureCoverObjects()),
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      coverState: cloneState(coverState)
    };
    _DMB_UNDO_MAPS.forEach((k) => { s[k] = cloneState(editor[k] || {}); });
    return s;
  }
  function _dmbRestoreState(s) {
    if (!s) return;
    builderMode = s.builderMode || "pages";
    editor.currentSpread = s.currentSpread;
    if (s.totalPages != null)    editor.totalPages    = s.totalPages;
    if (s.editablePages != null) editor.editablePages = s.editablePages;
    if (s.totalSpreads != null)  editor.totalSpreads  = s.totalSpreads;
    editor.extraSpreads = s.extraSpreads || 0;
    if (s.bookSize)    editor.bookSize    = s.bookSize;
    if (s.orientation) editor.orientation = s.orientation;
    _DMB_UNDO_MAPS.forEach((k) => { editor[k] = cloneState(s[k] || {}); });
    editor.coverObjects = cloneState(s.coverObjects || []);
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    editor.coverUserTexts = cloneState(s.coverUserTexts || []);
    // Restore the ENTIRE coverState (front/back/spine/bleed photos, frames, layouts,
    // shapes, rotations, colour, text styles) — not just a handful of fields.
    if (s.coverState) Object.keys(s.coverState).forEach((k) => { coverState[k] = cloneState(s.coverState[k]); });
    // Re-sync all dependent UI, then re-render.
    try { syncCoverInputsFromState(); } catch (e) {}
    try { _syncSpreadAdderUI(); } catch (e) {}
    try { updatePrice(); } catch (e) {}
    try { refreshPhotoRule(); } catch (e) {}
    try { syncBuilderModeButtons(); } catch (e) {}
    try { _dmbInvalidateSibCache(); } catch (e) {}
    renderBuilderCanvas();
    renderThumbsRail();
    renderPhotoTray();
    autoSave();
    try { _dmbReapplyAllContains(); } catch (e) {}
    try { _dmbPvReinitAll(); } catch (e) {}
  }

  function pushUndoState(actionLabel = "Edited") {
    _dmbUserEdited = true;      // a real edit happened → cloud saving is now allowed
    _dmbInvalidateSibCache();   // objects changed → snap-sibling cache is stale
    undoStack.push(_dmbCaptureState(actionLabel));

    if (undoStack.length > UNDO_LIMIT) undoStack.shift();
    redoStack = [];
    autoSave();
    // ALSO flush the restore-key snapshot ~immediately, so a refresh right after an
    // edit can't lose it (autoSave alone waits 800ms + 600ms and each new edit cancels
    // the pending timer — rapid edits then refreshed within ~1.4s were never written,
    // e.g. "only the background persisted, stickers/map/text gone"). IMPORTANT: use a
    // MICROTASK, not a synchronous call — pushUndoState runs BEFORE the caller mutates
    // editor (it snapshots the PRE-edit state for undo), so a synchronous write here
    // would persist the OLD state (missing the just-added/removed object). The
    // microtask runs after the caller's synchronous add/remove + render finish, so it
    // captures the POST-edit state, and it still fires before the browser can process
    // a refresh. queueMicrotask isn't cancellable, so rapid edits each get saved.
    try {
      queueMicrotask(function () { try { _dmbWriteProgressState(); } catch (e) {} });
    } catch (e) { try { _dmbWriteProgressState(); } catch (_) {} }
    // Re-apply contain clips — position/size/zone may have changed
    try { _dmbReapplyAllContains(); } catch(e) {}

    // ── Dirty-mark the PDF preview cache ─────────────────────────────────
    // pushUndoState is called for most meaningful changes (sticker moves,
    // photo changes, text edits, template changes, shape resizes, map edits).
    // NOTE: spread photo pan/zoom drag does NOT call pushUndoState — that
    // case is handled separately in the spread photo mouseup handler.
    try {
      if (builderMode === "cover") {
        _dmbPvMarkDirty("cover");
      } else if (editor.currentSpread === -1) {
        _dmbPvMarkDirty(0);
      } else {
        _dmbPvMarkDirty(editor.currentSpread * 2 + 1);
        _dmbPvMarkDirty(editor.currentSpread * 2 + 2);
      }
    } catch(e) {}
  }

  // ── Text style edits: snappy live apply + deferred heavy commit ─────────────
  // Changing a text box's font / size / colour used to run the FULL heavy path on
  // every keystroke (a whole-design JSON snapshot + a before-paint _dmbWriteProgressState
  // that reads, parses and rewrites the entire saved design in localStorage), which
  // blocked the repaint — the change only appeared seconds later. Now the style is
  // applied + painted immediately; one undo snapshot is taken per burst; and the heavy
  // persistence is debounced to run once after the user stops (and flushed on
  // deselect / page-hide / selection change so nothing is ever lost).
  let _dmbTextStyleBurst = false;
  let _dmbTextStyleTimer = null;
  let _dmbTextStylePending = null;
  function _dmbTextStyleBeginUndo() {
    if (_dmbTextStyleBurst) return;
    _dmbTextStyleBurst = true;
    try {
      _dmbInvalidateSibCache();
      undoStack.push(_dmbCaptureState("Text Edit"));
      if (undoStack.length > UNDO_LIMIT) undoStack.shift();
      redoStack = [];
    } catch (e) {}
  }
  function _dmbTextStyleScheduleCommit(node) {
    if (node) _dmbTextStylePending = node;
    clearTimeout(_dmbTextStyleTimer);
    _dmbTextStyleTimer = setTimeout(_dmbTextStyleCommit, 450);
  }
  function _dmbTextStyleCommit() {
    clearTimeout(_dmbTextStyleTimer);
    const node = _dmbTextStylePending;
    _dmbTextStyleBurst = false;
    _dmbTextStylePending = null;
    if (!node || !node.isConnected) return;
    try { saveCoverTextNodeState(node); } catch (e) {}
    try { savePageTextState(node); } catch (e) {}
    try { saveCoverDesignToStorage(); } catch (e) {}
    try { autoSave(); } catch (e) {}
    try { _dmbWriteProgressState(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
    try { _dmbReapplyAllContains(); } catch (e) {}
    try {
      if (builderMode === "cover") _dmbPvMarkDirty("cover");
      else if (editor.currentSpread === -1) _dmbPvMarkDirty(0);
      else { _dmbPvMarkDirty(editor.currentSpread * 2 + 1); _dmbPvMarkDirty(editor.currentSpread * 2 + 2); }
    } catch (e) {}
  }
  function _dmbTextStyleCancelBurst() {
    clearTimeout(_dmbTextStyleTimer);
    _dmbTextStyleBurst = false;
    _dmbTextStylePending = null;
  }

  function undoLastAction() {
    if (!undoStack.length) return;
    try { _dmbTextStyleCancelBurst(); } catch (e) {}
    // Capture the CURRENT (post-edit) state onto the redo stack, then restore the prior one.
    redoStack.push(_dmbCaptureState("Redo"));
    if (redoStack.length > UNDO_LIMIT) redoStack.shift();
    _dmbRestoreState(undoStack.pop());
  }

  function redoLastAction() {
    if (!redoStack.length) return;
    try { _dmbTextStyleCancelBurst(); } catch (e) {}
    undoStack.push(_dmbCaptureState("Undo"));
    if (undoStack.length > UNDO_LIMIT) undoStack.shift();
    _dmbRestoreState(redoStack.pop());
  }
  // ---------- cover storage ----------
  function saveCoverToStorage(cover) {
    try { localStorage.setItem("dmb_selected_cover", JSON.stringify(cover)); } catch {}
  }

  function loadCoverFromStorage() {
    try {
      const raw = localStorage.getItem("dmb_selected_cover");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function syncStepVisibility() {
    if (!step1 || !builderStep) return;

    const builderVisible = getComputedStyle(builderStep).display !== "none";
    if (builderVisible) {
      step1.style.display = "none";
      if (bookDetails) bookDetails.style.display = "none";
    }
  }

  syncStepVisibility();

  try {
    const obs = new MutationObserver(syncStepVisibility);
    obs.observe(builderStep, { attributes: true, attributeFilter: ["style", "class"] });
  } catch {}

  document.addEventListener("click", () => setTimeout(syncStepVisibility, 0), true);

  if (mode !== "customize" && (coverTitleParam || coverImgParam || coverHandleParam)) {
    saveCoverToStorage({
      title: coverTitleParam || "",
      img: coverImgParam || "",
      handle: coverHandleParam || ""
    });
  }

  if (mode === "customize") {
    try { localStorage.removeItem("dmb_selected_cover"); } catch {}
    try { sessionStorage.removeItem("dmb_selected_cover"); } catch {}
  }

  const storedCover = loadCoverFromStorage();
  const hasCoverInUrl = !!(coverTitleParam || coverImgParam || coverHandleParam);

  try {
    const noStep = !stepParam;
    const noMode = !mode;
    const noCoverParams = !hasCoverInUrl;

    if (!_dmbRenderMode() && noStep && noMode && noCoverParams) {
      localStorage.removeItem("dmb_selected_cover");
      sessionStorage.removeItem("dmb_selected_cover");
      localStorage.removeItem("dmb_mode");
    }
  } catch {}

  const shouldShowBuilder =
    stepParam === "2" ||
    mode === "customize" ||
    hasCoverInUrl ||
    restoreParam === "1";   // ← "Continue editing" from saved books page

  const shouldShowUpload = stepParam === "upload" && restoreParam !== "1";

  // Issue 1: on a fresh load (not already restoring or opening the builder),
  // if saved progress exists, offer to resume it instead of re-uploading.
  // Signed-in customers only — guests don't get a resume prompt (same rule as
  // the in-builder offer).
  if (restoreParam !== "1" && !shouldShowBuilder && window.DMB_CUSTOMER_ID) {
    setTimeout(async () => {
      try {
        const _sv = loadCustomerProgress();
        if (_sv && _sv.editor && (_sv.editor.totalPages || _sv.pages_selected)) {
          _dmbShowResumeBanner();
          return;
        }
        // No local copy (different device, or the browser evicted it) — the design
        // may still be safe in the customer's account. Offer to resume it from cloud.
        if (_dmbCloud.enabled()) { _dmbAutoCloudRestore(); }
      } catch (e) {}
    }, 800);
  }

  // Builder opened DIRECTLY (refresh, or a ?cover=/template link) for a signed-in
  // customer — the auto-open shows a fresh builder and suppresses the in-builder
  // resume offer. If THIS design has a saved cloud copy, surface the resume banner so
  // their work is one click away (and clearly not lost). Offer-only: it only appears
  // when the current context MATCHES a saved design, so a brand-new design isn't nagged.
  if (restoreParam !== "1" && shouldShowBuilder && window.DMB_CUSTOMER_ID) {
    setTimeout(async () => {
      try {
        if (!_dmbCloud.enabled()) return;
        const list = await _dmbCloud.list();
        const curId = _dmbCloud.designId();
        const m = list && list.find((d) => d && d.id === curId);
        if (m) _dmbOfferCloudResume(m);
      } catch (e) {}
    }, 1600);
  }

  if (_dmbRenderMode()) {
    // ── RENDER MODE (Step 2, full-quality server render) ──────────────────────
    // A headless job page: show the builder shell (renderCoverCanvas needs
    // #spreadCanvas, and the engine reads #coverOverlay z-index for cover z-order)
    // and hand off to the render module at the end of this file. No upload step, no
    // ?restore=1 flow, no landing page, no resume offers, no tours.
    step1.style.display = "none";
    builderStep.style.display = "block";
    if (bookDetails) bookDetails.style.display = "none";
    { const _s1b = document.getElementById("step1b"); if (_s1b) _s1b.style.display = "none"; }
    _dmbRenderModeBoot();      // hoisted; yields a macrotask before touching anything
  } else if (shouldShowUpload) {
    step1.style.display = "none";
    builderStep.style.display = "none";
    if (bookDetails) bookDetails.style.display = "none";
    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "flex";
    try { initPhoneUpload(); } catch(e) {}
    // Heads-up on landing: photos upload in batches of 30.
    setTimeout(function () { try { _dmbShowLimitNotice(); } catch (e) {} }, 500);

    // Restore on the upload step:
    //  • Signed-in → a DISCREET inline card (not a popup), and ONLY when a saved
    //    design exists for THIS EXACT book. See _dmbShowRestoreThisBook.
    //  • Guest who REFRESHED this step → restore SILENTLY (no popup), so an accidental
    //    refresh doesn't lose their just-picked photos. A guest arriving FRESH gets
    //    nothing (their provisional work was already discarded — no resume by design).
    if (window.DMB_CUSTOMER_ID) {
      setTimeout(function () { try { _dmbShowRestoreThisBook(); } catch (e) {} }, 600);
    } else if (_dmbWasReload() || _DMB_TAB_CONTINUED) {
      setTimeout(function () { try { _dmbInstantBackup.restoreSilently(); } catch (e) {} }, 600);
    }

    // Prefetch the cover template NOW (the handle is already in the URL / magazine
    // session) so it's cached and applies instantly when the builder opens —
    // removes the blank-cover window when the at-entry fetch is slow/flaky.
    try {
      const _warmHandles = [];
      if (coverHandleParam) _warmHandles.push(coverHandleParam);
      try { const _mh = sessionStorage.getItem("dmb_mag_template"); if (_mh && _warmHandles.indexOf(_mh) < 0) _warmHandles.push(_mh); } catch (e) {}
      _warmHandles.forEach(function (h) { try { _dmbWarmTemplate(h); } catch (e) {} });
    } catch (e) {}

    // ── Mobile add-photos notice ─────────────────────────────────────────────
    // Phones only (iPad/laptop are the smoother devices). Dismissible popup,
    // shown every time the add-photos step is reached.
    function _dmbShowUploadMobileNotice() {
      if (window.innerWidth > 749) return;                       // phones only
      if (document.getElementById("dmbUploadMobileNotice")) return;
      const ov = document.createElement("div");
      ov.id = "dmbUploadMobileNotice";
      ov.style.cssText = "position:fixed;inset:0;z-index:1000000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.55);padding:20px;";
      ov.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:380px;width:100%;padding:26px 22px 22px;box-shadow:0 20px 60px rgba(0,0,0,.35);text-align:center;position:relative;">' +
          '<button type="button" id="dmbUploadNoticeX" aria-label="Close" style="position:absolute;top:12px;right:12px;width:30px;height:30px;border:none;background:#f1f1f1;border-radius:999px;font-size:18px;line-height:1;cursor:pointer;color:#444;padding:0;">&times;</button>' +
          '<div style="font-size:34px;margin-bottom:8px;">&#128241;</div>' +
          '<h3 style="margin:0 0 10px;font-size:18px;font-weight:800;color:#1e1e1e;">A quick note before you upload</h3>' +
          '<p style="margin:0 0 14px;font-size:14px;line-height:1.55;color:#555;">Uploading a large batch of photos &mdash; or very high-resolution images &mdash; from a phone can sometimes be slow or interrupted. For the smoothest experience, we gently recommend designing on a <strong>laptop or iPad</strong>.</p>' +
          '<p style="margin:0 0 18px;font-size:13px;line-height:1.55;color:#888;">Even when designing on your laptop or iPad, you can upload photos straight from your phone using the &ldquo;Upload from Phone&rdquo; option. &#128156;</p>' +
          '<button type="button" id="dmbUploadNoticeGotIt" style="background:#1e1e1e;color:#fff;border:none;border-radius:10px;padding:12px 26px;font-size:14px;font-weight:800;cursor:pointer;width:100%;">Got it</button>' +
        '</div>';
      document.body.appendChild(ov);
      const close = () => { try { ov.remove(); } catch(e) {} };
      ov.querySelector("#dmbUploadNoticeX").addEventListener("click", close);
      ov.querySelector("#dmbUploadNoticeGotIt").addEventListener("click", close);
      ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
    }
    try { _dmbShowUploadMobileNotice(); } catch(e) {}

    // Register upload step handlers here (early), in case the IIFE fails later.
    // Both "Do the Magic" (auto-arrange) and "Customize" (manual) share this flow;
    // the only difference is whether smartCreateBook() runs at the end.
    async function _proceedFromUpload(autoArrange) {
      const errEl = document.getElementById("uploadStepError");
      const pagesSel = document.getElementById("step1bPages");

      // ── Guard 1: pages must be selected ──────────────────────────────
      if (!pagesSel?.value) {
        if (errEl) { errEl.textContent = window.DMB_MAGAZINE_MODE ? "Please select the number of pages for your magazine." : "Please select the number of pages for your book."; errEl.style.display = "block"; }
        return;
      }

      // ── Guard 2: minimum photos (base pages − 4) ──────────────────────
      // Extra spreads added later inside the builder do NOT affect this check.
      const _minRequired = MIN_PHOTOS;   // flat 20, independent of page count
      const _uploaded    = bookFiles.length;
      if (_minRequired > 0 && _uploaded < _minRequired) {
        const _need = _minRequired - _uploaded;
        if (errEl) {
          errEl.textContent =
            `📸 Add ${_need} more photo${_need !== 1 ? "s" : ""} to start designing! ` +
            `You have ${_uploaded}, you need at least ${_minRequired}.`;
          errEl.style.display = "block";
        }
        return;
      }

      if (errEl) errEl.style.display = "none";

      // NOTE: the R2 instant backup keeps draining in the BACKGROUND — entering
      // the builder is just a div swap (no navigation), so the queue survives.
      // Never block the customer on it (an early gate here made big batches feel
      // stuck for minutes). Failed uploads retry silently; the badge shows state.
      try { _dmbInstantBackup.retryFailed(); } catch (e) {}

      if (pagesEl) pagesEl.value = pagesSel.value;
      if (s1b) s1b.style.display = "none";
      if (step1) step1.style.display = "none";
      if (builderStep) builderStep.style.display = "block";
      // We're actively starting/continuing THIS design — don't let the in-builder
      // "Resume from where you left off?" banner pop up over it.
      _dmbSuppressResumeOffer = true;
      try { await openEditor(); } catch(err) { console.error("openEditor failed:", err); }
      if (window.DMB_MAGAZINE_MODE) {
        const magHandle = sessionStorage.getItem("dmb_mag_template");
        if (magHandle) {
          sessionStorage.removeItem("dmb_mag_template");
          // Persist handle in URL so saveCurrentTemplate() names the file correctly
          try {
            const _u = new URL(window.location.href);
            _u.searchParams.set("cover", magHandle);
            history.replaceState(null, "", _u.toString());
          } catch {}
          try { await dmbApplyCoverTemplate(magHandle); } catch(err) {}
        }
      } else {
        if (coverHandleParam) {
          try { await dmbApplyCoverTemplate(coverHandleParam); } catch(err) { console.warn("Cover template apply failed:", err); }
        }
      }

      // "Do the Magic" auto-arranges the photos across the interior pages;
      // "Customize" leaves the pages empty for manual placement. Either way
      // everything stays fully editable afterward.
      if (autoArrange) {
        try { smartCreateBook(); } catch(err) { console.warn("smartCreateBook failed:", err); }
      }

      // Rewrite the URL so a page REFRESH re-enters the builder and restores this
      // design, instead of dropping back to the upload step (the old behaviour:
      // the URL stayed ?step=upload). The design (localStorage) and photos
      // (IndexedDB) are autosaved continuously and flushed on pagehide, so
      // ?restore=1 rebuilds it. The cover handle (if any) is left intact so the
      // restore reads the same per-design save key.
      try {
        const _u = new URL(window.location.href);
        _u.searchParams.set("step", "2");
        _u.searchParams.set("restore", "1");
        history.replaceState(null, "", _u.toString());
      } catch (e) {}
      // Write an initial snapshot now so an instant refresh already has data.
      try { _dmbWriteProgressState(); _dmbPersistPhotos(); } catch (e) {}
    }

    const _magicBtn = document.getElementById("dmbDoMagicBtn");
    if (_magicBtn) _magicBtn.addEventListener("click", function() { _proceedFromUpload(true); });

    const _customizeBtn = document.getElementById("dmbCustomizeBtn");
    if (_customizeBtn) _customizeBtn.addEventListener("click", function() { _proceedFromUpload(false); });

    const _backBtn = document.getElementById("backToHomeBtn");
    if (_backBtn) {
      _backBtn.addEventListener("click", function() {
        window.location.assign(window.DMB_CARD_MODE ? "/pages/design-my-book?type=card" : window.DMB_MAGAZINE_MODE ? "/pages/design-my-magazine" : "/pages/design-my-book");
      });
    }

  } else if (shouldShowBuilder) {
      step1.style.display = "none";
      builderStep.style.display = "block";
      if (bookDetails) bookDetails.style.display = "none";

      // ?restore=1: load saved state, then open editor (so editor inits around
      // the pre-loaded data), then re-apply state to overwrite anything editor
      // touched during init, then render.
      if (restoreParam === "1") {
        _dmbShowRestoreLoader();   // emoji loader until the design + photos finish loading
        (async () => {
          let _saved = loadCustomerProgress();
          // Only BLOCK the restore on the cloud when there is NO usable local copy.
          // _dmbCloud.load() downloads every photo sequentially (one round-trip per
          // image) with NO timeout, so awaiting it even when a local design already
          // exists left signed-in customers staring at an empty builder on refresh —
          // for tens of seconds on a full book, or FOREVER if a single photo fetch
          // stalled (which looked exactly like "everything disappeared"). Guests never
          // hit this because they have no cloud, which is why their refresh restores
          // instantly. A same-device refresh has the whole design in localStorage +
          // IndexedDB, so restore from that immediately (same fast path as guests).
          // The cloud is only needed when the local copy is gone (different device /
          // cleared cache) — and even then it's time-boxed so a stalled download can
          // never hang the builder.
          let _cloud = null;
          const _haveLocal = !!(_saved && _saved.editor);
          if (_dmbCloud.enabled() && !_haveLocal) {
            try {
              _cloud = await Promise.race([
                _dmbCloud.load(),
                new Promise((res) => setTimeout(() => res(null), 45000)),
              ]);
            } catch (e) {}
          }
          if ((!_saved || !_saved.editor) && _cloud && _cloud.design && _cloud.design.editor) {
            _saved = _cloud.design;
          }
          // GUEST recovery: local storage was evicted mid-session (iOS/Safari can
          // purge localStorage + IndexedDB) but the R2 backup has the full design.
          if ((!_saved || !_saved.editor) && !window.DMB_CUSTOMER_ID && window.DMB_DESIGNS_PROXY) {
            try {
              let _gsid = ""; try { _gsid = _dmbPhotoBackup.guestId(); } catch (e) {}
              const _gid = getCustomerSaveKey().replace(/^dmb_progress_/, "");
              if (_gsid && _gid) {
                const _gr = await Promise.race([
                  fetch(window.DMB_DESIGNS_PROXY + "/load-guest?id=" + encodeURIComponent(_gid) + "&sid=" + encodeURIComponent(_gsid), { credentials: "same-origin" }),
                  new Promise((res) => setTimeout(() => res(null), 15000)),
                ]);
                if (_gr && _gr.ok) { const _gd = await _gr.json(); if (_gd && _gd.design && _gd.design.editor) _saved = _gd.design; }
              }
            } catch (e) {}
          }
          if (!_saved || !_saved.editor) {
            try { await openEditor(); } catch(e) {}
            _dmbHideRestoreLoader();
            return;
          }
          if (saveMsg) { saveMsg.textContent = "Restoring your design…"; saveMsg.style.display = "block"; }

          const _cl = v => { try { return JSON.parse(JSON.stringify(v || {})); } catch(e) { return {}; } };
          const _se = _saved.editor || {};
          _dmbApplyRecentColors(_saved);   // sync the colour palette (cross-device)
          const _pg = _se.totalPages || Number(_saved.pages_selected) || 0;
          // The #pages dropdown holds the BASE count (a real option), NOT the total
          // that includes added spreads (e.g. 32) — setting it to a non-option value
          // selects nothing and renderSpread then reads 0 → blank "Spread 1/1". Use
          // the base; extraSpreads (restored below) adds the rest back.
          const _base = Number(_saved.pages_selected) || Math.max(0, _pg - (_se.extraSpreads || 0) * 2) || _pg;
          try { const _s1bP = document.getElementById("step1bPages"); if (_s1bP && _base) _s1bP.value = String(_base); } catch (e) {}

          // ── Phase 1: pre-load state so openEditor sees it ────────────────
          // MERGE cloud + local IndexedDB photos (union by id). The cloud photo
          // manifest can LAG the local copy — the account save is debounced and is
          // NOT flushed on leave — so cloud alone may be missing recently-added
          // photos, while the local design (loaded above) still references them
          // (→ error/white boxes on pages, missing from the tray). Taking the union
          // guarantees every photo the design references resolves. Prefer the cloud
          // copy for shared ids; fill any gaps from IDB.
          let _cloudPhotos = (_cloud && Array.isArray(_cloud.photos)) ? _cloud.photos : [];
          let _idbPhotos = [];
          try { _idbPhotos = (await _loadPhotosFromIDB(getCustomerSaveKey())) || []; } catch (e) {}
          let _rPhotos;
          if (_cloudPhotos.length && _idbPhotos.length) {
            const _pById = new Map();
            _idbPhotos.forEach(function (p) { if (p && p.id) _pById.set(p.id, p); });
            _cloudPhotos.forEach(function (p) { if (p && p.id) _pById.set(p.id, p); }); // cloud wins on overlap
            _rPhotos = Array.from(_pById.values());
          } else {
            _rPhotos = _cloudPhotos.length ? _cloudPhotos : _idbPhotos;
          }
          // Align restored photo IDs with the saved layout so placed photos
          // resolve (otherwise spreads render blank/white while the tray is fine).
          _dmbReconcilePhotoIds(_rPhotos, _se);
          if (_rPhotos.length) {
            editor.photos = _rPhotos;
            try { bookFiles = _rPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
          }
          const _pElR = document.getElementById("pages");
          if (_pElR && _base) _pElR.value = String(_base);

          // ── Phase 2: open editor (UI init only — skip state reset) ─────────
          // skipStateReset=true preserves the IDB photos loaded in Phase 1
          // and prevents openEditor from clearing editor.coverObjects / pageSlots.
          editor.totalPages    = _pg;
          editor.editablePages = _se.editablePages || Math.max(0, _pg - 1);
          editor.totalSpreads  = _se.totalSpreads  || Math.max(1, Math.ceil(_pg / 2));
          try { await openEditor({ skipStateReset: true }); } catch(e) { console.warn("[DMB] restore openEditor:", e); }

          // ── Phase 3: apply ALL saved values (SHARED with Step-2 render mode) ──
          //    (belt-and-suspenders: openEditor may still have touched some fields)
          // Re-apply IDB photos FIRST — openEditor() above overwrote editor.photos with
          // empty bookFiles — so _dmbApplySavedEditorState can rehydrate cover URLs by id.
          if (_rPhotos.length) {
            editor.photos = _rPhotos;
            try { bookFiles = _rPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
          }
          _dmbApplySavedEditorState(_saved);
          if (_pElR && _base) _pElR.value = String(_base);

          // Reattach sticker/icon crop images (base64) from IndexedDB onto the
          // restored objects — they were stripped from the localStorage state.
          try { _dmbReattachObjImages(await _dmbLoadObjImagesFromIDB(getCustomerSaveKey())); } catch(e) {}

          // ── Phase 4: sync UI inputs then render ───────────────────────────
          try { syncCoverInputsFromState(); }  catch(e) {}
          try { updatePrice(); }               catch(e) {}
          try { _syncSpreadAdderUI(); }        catch(e) {}     // reflect restored added spreads
          try { _dmbSyncOrientationToggleUI(); } catch(e) {}   // reflect restored orientation
          try { renderPhotoTray(); }           catch(e) {}
          try { renderThumbsRail(); }          catch(e) {}
          // Always render the cover (Phase 3 restored coverState + coverObjects
          // but renderBuilderCanvas only renders the cover when builderMode="cover").
          // Since saved builderMode is typically "pages", explicitly render both.
          try { renderCoverCanvas(); }         catch(e) {}
          try { renderBuilderCanvas(); }       catch(e) {}
          try { _dmbHideRestoreLoader(); }     catch(e) {}   // design is on screen now
          // The book is on screen (rendered from just its placed photos). Now pull the
          // REST of the book's photo library into the tray in the background — safe,
          // because cloud saving is edit-gated so this can't overwrite anything.
          try { _dmbCloud.loadPendingLib(() => { try { renderPhotoTray(); } catch (e) {} }); } catch (e) {}

          if (saveMsg) saveMsg.style.display = "none";
          _dmbToast(_rPhotos.length
            ? `Restored — ${_rPhotos.length} photos + full layout`
            : "Layout restored (re-upload photos to fill pages)");

          // ADDITIVE reconcile: same-device refreshes use the local IDB copy only
          // (cloud is skipped when a local copy exists), so a partial IndexedDB
          // eviction would still leave placed photos missing here. Pull back any
          // referenced-but-absent photo from R2 by id, then re-render if we did.
          try {
            const _rec = await _dmbReconcileMissingPhotosFromCloud();
            if (_rec > 0) {
              try { bookFiles = editor.photos.map((p) => p.file || new File([], p.filename || "photo")); } catch (e) {}
              try { renderPhotoTray(); }     catch (e) {}
              try { renderThumbsRail(); }    catch (e) {}
              try { renderCoverCanvas(); }   catch (e) {}
              try { renderBuilderCanvas(); } catch (e) {}
              if (saveMsg) saveMsg.style.display = "none";
              _dmbToast(`Restored — recovered ${_rec} photo${_rec === 1 ? "" : "s"} from the cloud`);
            }
          } catch (e) {}
        })();
      }
    } else {
      step1.style.display = "flex";
      builderStep.style.display = "none";
      if (bookDetails) bookDetails.style.display = "none";
    }
  const coverToShow =
    mode !== "customize"
      ? (coverImgParam || coverTitleParam
          ? { title: coverTitleParam || "", img: coverImgParam || "" }
          : storedCover)
      : null;

  if (selectedCoverBox && selectedCoverImg && selectedCoverTitle) {
    if (mode !== "customize" && coverToShow && (coverToShow.img || coverToShow.title)) {
      selectedCoverBox.style.display = "flex";
      if (coverToShow.img) selectedCoverImg.src = coverToShow.img;
      selectedCoverImg.alt = coverToShow.title || "Selected cover";
      selectedCoverTitle.textContent = coverToShow.title || "";
    } else {
      selectedCoverBox.style.display = "none";
    }
  }

  // ---------- Step 2 ----------
  function updatePrice() {
    if (!pagesEl || !priceBox || !oldPriceEl || !newPriceEl) return;
    // Magazines price from their own product; books (and magazine-fallback) use PRICES.
    let data = null;
    if (window.DMB_MAGAZINE_MODE) {
      const me = _dmbMagEntry(pagesEl.value, editor.bookSize);
      if (me) data = { old: me.old, new: me.new };
    }
    if (!data) {
      const _sizeTbl = PRICES[editor.bookSize || "A4"] || PRICES.A4;
      data = _sizeTbl[pagesEl.value];
    }
    if (data) {
      // Add extra spread cost ($1.99 × extraSpreads) on top of base price
      const extraCost = (editor.extraSpreads || 0) * EXTRA_SPREAD_PRICE;
      // Only show the struck-through "old" price when there's a real compare-at.
      const showOld = data.old && data.old > data.new;
      oldPriceEl.textContent = showOld ? fmtMoney(data.old + extraCost) : "";
      oldPriceEl.style.display = showOld ? "" : "none";
      newPriceEl.textContent = fmtMoney(data.new + extraCost);
      priceBox.style.display = "block";
    } else {
      priceBox.style.display = "none";
    }
  }

  function makeThumbWithRemove(file, idx, onRemove) {
    const wrap = document.createElement("div");
    wrap.style.position = "relative";
    wrap.style.width = "70px";
    wrap.style.height = "70px";

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);
    img.alt = file.name;
    img.style.width = "70px";
    img.style.height = "70px";
    img.style.objectFit = "cover";
    img.style.borderRadius = "10px";
    img.style.border = "1px solid #ddd";
    wrap.appendChild(img);

    // ── Circle-X remove button (Fix 1) ─────────────────────────────────────
    const btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("aria-label", "Remove image");
    btn.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 8l8 8M16 8l-8 8"/></svg>`;
    btn.style.cssText = "position:absolute;top:-7px;right:-7px;width:22px;height:22px;border-radius:999px;border:none;background:#111;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      onRemove(idx);
    });

    wrap.appendChild(btn);
    return wrap;
  }

  function renderPreview(filesArr, containerEl, maxThumbs, onRemove) {
    if (!containerEl) return;
    containerEl.innerHTML = "";

    if (!filesArr.length) {
      containerEl.style.display = "none";
      return;
    }

    containerEl.style.display = "flex";

    filesArr.slice(0, maxThumbs).forEach((file, idx) => {
      containerEl.appendChild(makeThumbWithRemove(file, idx, onRemove));
    });

    if (filesArr.length > maxThumbs) {
      const more = document.createElement("div");
      more.textContent = `+${filesArr.length - maxThumbs} more`;
      more.style.fontSize = "12px";
      more.style.color = "#666";
      more.style.alignSelf = "center";
      containerEl.appendChild(more);
    }
  }

  function refreshPhotoRule() {
    // ── Minimum photos rule: min = BASE pages − 4 ────────────────────────
    // IMPORTANT: use pagesEl.value (the dropdown selection), NOT editor.totalPages.
    // editor.totalPages includes extra spreads added inside the builder, but
    // the photo upload step requirement must NOT change when spreads are added.
    // Example: 24 pages → minimum 20 photos. Adding 2 spreads → still 20.
    const pages = Number(pagesEl?.value || 0);
    if (pages > 0) {
      currentMin = MIN_PHOTOS;        // flat 20, independent of page count
      currentMax = pages + 8;
      if (photoRuleEl) {
        photoRuleEl.textContent = `Upload at least ${currentMin} photos to start`;
        photoRuleEl.style.display = "block";
      }
    } else {
      currentMin = 0;
      currentMax = 0;
      if (photoRuleEl) {
        photoRuleEl.textContent = "Select pages to see how many photos you need";
        photoRuleEl.style.display = "block";
      }
    }
    if (photoErrorEl) photoErrorEl.style.display = "none";
    validatePhotos();
  }

  function validatePhotos() {
    const count = bookFiles.length;
    if (photoCountEl) {
      photoCountEl.style.display = count ? "block" : "none";
      photoCountEl.textContent = count ? `${count} photo${count !== 1 ? "s" : ""} selected` : "";
    }
    if (photoErrorEl) {
      if (currentMin > 0 && count < currentMin) {
        const need = currentMin - count;
        photoErrorEl.textContent =
          `📸 Add ${need} more photo${need !== 1 ? "s" : ""} to start designing! ` +
          `You have ${count}, you need at least ${currentMin}.`;
        photoErrorEl.style.display = "block";
      } else {
        photoErrorEl.style.display = "none";
      }
    }
    return count > 0 && (currentMin === 0 || count >= currentMin);
  }

  window.editorAutoOpened = window.editorAutoOpened || false;

  async function tryAutoOpenEditor() {
    const selectedPages = Number(pagesEl?.value || 0);

    if (!selectedPages || bookFiles.length === 0) {
      window.editorAutoOpened = false;
      return;
    }

    // ── Minimum photo check: block auto-open if not enough photos ──────────
    // Minimum = base pages − 4 (extra spreads added inside the builder are
    // NOT factored in — this check is for the upload step only).
    const minNeeded = selectedPages > 0 ? MIN_PHOTOS : 0;
    if (minNeeded > 0 && bookFiles.length < minNeeded) {
      window.editorAutoOpened = false;
      // Ensure the error message is visible
      refreshPhotoRule();
      return;
    }

    // Don't reset if builder is already open with content
    const alreadyOpen =
      builderStep &&
      builderStep.style.display === "block" &&
      editor.totalPages > 0;

    if (alreadyOpen) return;

    const alreadyMatching = editor.totalPages === selectedPages;

    if (window.editorAutoOpened && alreadyMatching) return;

    window.editorAutoOpened = true;
    // Same as the button path: we're actively entering THIS design, so suppress
    // the "Resume from where you left off?" banner.
    _dmbSuppressResumeOffer = true;

    try {
      await openEditor();
      // Auto-open must also apply the predesigned cover template — otherwise the
      // cover comes up blank (previously only the Do-the-Magic/Customize buttons
      // applied it). No-op for custom books (their cover-<handle>.json 404s).
      try {
        if (window.DMB_MAGAZINE_MODE) {
          const _mh = sessionStorage.getItem("dmb_mag_template");
          if (_mh) {
            sessionStorage.removeItem("dmb_mag_template");
            try { const _u = new URL(location.href); _u.searchParams.set("cover", _mh); history.replaceState(null, "", _u.toString()); } catch (e) {}
            await dmbApplyCoverTemplate(_mh);
          }
        } else if (coverHandleParam) {
          await dmbApplyCoverTemplate(coverHandleParam);
        }
      } catch (e) {}
    } catch (err) {
      window.editorAutoOpened = false;
      console.error("tryAutoOpenEditor failed:", err);
    }
  }
  
  function validateCustomizeRequired() {
    if (mode !== "customize") return true;
    return !!getEffectiveBookTitle();
  }

  function removeBookFileAt(idx) {
    if (idx < 0 || idx >= bookFiles.length) return;
    bookFiles.splice(idx, 1);
    syncInputFiles(photosEl, bookFiles);
    validatePhotos();
  }

  if (pagesEl) {
    pagesEl.addEventListener("change", () => {
      updatePrice();
      refreshPhotoRule();
      initEmptyBookFromPages();
    });
  }

  if (!templateParam && restoreParam !== "1") {
    // Only reset to defaults when NOT restoring from saved progress
    coverState.template = "default";
    coverState.title1 = "";
    coverState.title2 = "";
    coverState.color = "#ffffff";
    coverState.imageUrl = "";
    coverState.imageFile = null;
    coverState.textStyles = {};
    editor.coverObjects = [];
  }


  // --- frame rendering helpers (second-IIFE versions, have full access to editor/state) ---

  function dmbGetSnapGuides(cont) {
    let gH = cont.querySelector(".dmb-snap-guide-h");
    let gV = cont.querySelector(".dmb-snap-guide-v");
    if (!gH) {
      gH = document.createElement("div");
      gH.className = "dmb-snap-guide-h";
      cont.appendChild(gH);
    }
    if (!gV) {
      gV = document.createElement("div");
      gV.className = "dmb-snap-guide-v";
      cont.appendChild(gV);
    }
    // NOTE: these two are vestigial - dmbCheckSnap takes gH/gV as parameters and never
    // touches them. Every line the customer sees comes from the POOLED guides, which are
    // hosted on the spread row so they can cross the fold and out-stack both pages.
    return { gH, gV };
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Fix 6 — Smart alignment guides (object-to-object + container centre)
  // ══════════════════════════════════════════════════════════════════════════
  //
  // `dmbCheckSnap` is called during every drag pointermove. It:
  //   1. Gathers sibling objects on the same page/cover
  //   2. Computes 5 reference edges per object (left, centreX, right, top, centreY, bottom)
  //   3. Snaps obj.x / obj.y when within SNAP_T px of any reference
  //   4. Shows dynamic guide lines at each matched edge
  //
  // Guide-line pool: we lazily create <div> elements inside the container and
  // reuse them across frames to avoid DOM churn (max ~8 visible at once).

  const _SNAP_T = 4;                 // snap threshold in px (snap when within 4px, jump exactly onto the line)
  const _GUIDE_HIDE_MS = 500;        // guides stay visible 500 ms after drag stops

  // Where a snap overlay must LIVE to be able to draw over both pages.
  //
  // Raising the z-index was not enough, and the reason is worth writing down. A new
  // item's z is floored at Date.now(), which CSS clamps to the 32-bit maximum, so the
  // overlays and the items end up on the SAME z-index and the winner is decided by DOM
  // order. Parented inside the left page, a guide comes before every item in the right
  // page, so it always lost there - which is exactly what it looked like: fine over the
  // page being dragged on, behind the item it was measuring against.
  //
  // Hosting the overlay on the spread row fixes it structurally: a child appended to the
  // row comes after BOTH page divs, so it wins the tie over either page, and it beats a
  // lifted item (z 9000, also a child of the row) on z-index outright. It also means a
  // horizontal guide simply spans the row - no negative-inset trickery.
  //
  // Returns the host plus the page's offset inside it, which every caller adds to its
  // page-space coordinates. Falls back to the container (cover, page 0, previews) where
  // there is no spread row, and the offsets are then zero and nothing changes. (2026-09-18)
  function _dmbOverlayHost(container) {
    try {
      const pageEl = container && container.parentElement;
      const row = pageEl && pageEl.parentElement;
      if (row && row.dataset && row.dataset.spreadRow) {
        return { host: row, ox: pageEl.offsetLeft || 0, oy: pageEl.offsetTop || 0 };
      }
    } catch (e) {}
    return { host: container, ox: 0, oy: 0 };
  }

  function _dmbGetGuidePool(container) {
    const host = _dmbOverlayHost(container).host;
    if (!host._snapPool) host._snapPool = [];
    return host._snapPool;
  }

  // axis: "h" (horizontal = constant Y) or "v" (vertical = constant X)
  // isCenter: true → dashed line (centre-to-centre snap), false → solid (edge snap)
  function _dmbAcquireGuide(container, axis, isCenter) {
    const pool = _dmbGetGuidePool(container);
    let el = pool.find(g => g._axis === axis && g._inUse === false);
    if (!el) {
      el = document.createElement("div");
      el._axis = axis;
      el.style.pointerEvents = "none";
      el.style.position = "absolute";
      el.style.zIndex = "2147483647";   // 32-bit max: items clamp here too, DOM order wins (see note)
      el.style.opacity = "0";
      el.style.transition = "opacity 0.08s ease";
      if (axis === "h") {
        el.style.left = "0"; el.style.right = "0"; el.style.height = "2px";
      } else {
        el.style.top = "0"; el.style.bottom = "0"; el.style.width = "2px";
      }
      // On the spread row, left:0/right:0 already spans BOTH pages, and top:0/bottom:0
      // spans the full sheet height - the row is exactly the spread.
      _dmbOverlayHost(container).host.appendChild(el);
      pool.push(el);
    }
    el._inUse = true;
    // Re-apply class every acquisition so dashed/solid toggles correctly on reuse
    const base = axis === "h" ? "dmb-snap-guide-h dmb-snap-guide-dynamic" : "dmb-snap-guide-v dmb-snap-guide-dynamic";
    el.className = isCenter ? base + " dmb-snap-guide-center" : base;
    // Re-assert the spans on every acquisition: the pool hands the same element back to
    // different drags, and an earlier attempt at this problem used to write negative
    // insets here.
    if (axis === "h") { el.style.left = "0"; el.style.right = "0"; }
    else              { el.style.top  = "0"; el.style.bottom = "0"; }
    return el;
  }

  function _dmbReleaseAllGuides(container) {
    const pool = _dmbGetGuidePool(container);
    pool.forEach(g => {
      g._inUse = false;
      g.style.opacity = "0";
    });
  }

  // Show alignment guides + snap during a "lifted" drag (page item moved to spread-row).
  // During lift the item is positioned in spread-row coords; snap needs page-body coords.
  // Returns { dx, dy } — the snap delta to add to the lifted position.
  function _dmbLiftSnap(spreadLeft, spreadTop, objW, objH, objId, liftState, gH, gV, targetType, pageNumber) {
    if (!liftState || !liftState.origParent || !liftState.pagesRow) return { dx: 0, dy: 0 };
    // Cache the page↔spread-row offset once per drag — the rects don't move while
    // dragging, so re-reading them every move forced two needless reflows.
    if (!liftState._snapOff) {
      // Divide the screen-px offset by the canvas zoom so it's in the SAME model
      // units as the dragged coords (sSox etc. are already /_Z). Without this the
      // snapped position drifts by a constant amount whenever zoom ≠ 100%.
      const _Z = (typeof _nodeOnScreenScale === "function" ? (_nodeOnScreenScale(liftState.origParent) || 1) : 1);
      const _pR = liftState.pagesRow.getBoundingClientRect();
      const _pb = liftState.origParent.getBoundingClientRect();
      liftState._snapOff = { x: (_pb.left - _pR.left) / _Z, y: (_pb.top - _pR.top) / _Z };
    }
    const _offX = liftState._snapOff.x;
    const _offY = liftState._snapOff.y;
    const _so = { id: objId, x: spreadLeft - _offX, y: spreadTop - _offY, w: objW, h: objH };
    dmbCheckSnap(_so, liftState.origParent, gH, gV, { targetType, pageNumber });
    return { dx: _so.x - (spreadLeft - _offX), dy: _so.y - (spreadTop - _offY) };
  }

  // Cache of the snap siblings for the CURRENT drag. dmbCheckSnap runs on every
  // pointermove and measuring each text sibling's DOM box (scrollWidth/offsetWidth/
  // offsetHeight via getElementById) forces a layout reflow per sibling per move —
  // a major touch-lag source. Siblings don't change during a drag, so we cache the
  // computed list and reuse it; it's invalidated whenever a change is committed
  // (pushUndoState) so the next drag re-measures fresh.
  let _dmbSibCache = null; // { key, list }
  let _dmbSnapGen = 0;     // bumped on every committed change; used to cache container size per drag
  function _dmbInvalidateSibCache() { _dmbSibCache = null; _dmbSnapGen++; }
  function _dmbGetSiblingObjects(obj, targetType, pageNumber) {
    const _ck = targetType + ":" + (pageNumber == null ? "_" : pageNumber) + ":" + (obj && obj.id);
    if (_dmbSibCache && _dmbSibCache.key === _ck) return _dmbSibCache.list;

    let arr;
    if (targetType === "cover") {
      arr = editor.coverObjects || [];
    } else if (pageNumber != null) {
      arr = ensurePageObjects(pageNumber);
      // The two pages of a spread are ONE sheet of paper to the customer, so an item on
      // the FACING page has to behave like a sibling: same top edge, same centre line,
      // same equal-spacing run. Snapping only ever saw the owner page, so two frames a
      // few pixels apart across the fold could not be lined up at all.
      //
      // Bring the partner's objects into THIS page's coordinate space by shifting them
      // one page width; everything downstream - the five reference edges, the centre
      // lines, the equal-spacing bars, the mm labels - then works unchanged. (2026-09-18)
      try {
        const _pn = Number(pageNumber);
        if (_pn >= 1) {
          const _isLeftPg = (_pn % 2 === 1);          // spreads are (2k+1, 2k+2)
          const _sib = _isLeftPg ? _pn + 1 : _pn - 1;
          if (_sib >= 1 && _sib <= (editor.totalPages || 0)) {
            const _dx = _isLeftPg ? getPageDims().w : -getPageDims().w;
            const _sibArr = ensurePageObjects(_sib) || [];
            arr = arr.concat(_sibArr.map(function (o) {
              if (!o) return o;
              // A shifted COPY: the real object must not move just because something on
              // the other page is being dragged near it.
              const c = Object.assign({}, o);
              if (c.type === "text") c.left = (parseFloat(c.left || "0") + _dx) + "px";
              else                   c.x    = (c.x || 0) + _dx;
              return c;
            }));
          }
        }
      } catch (e) {}
    } else {
      _dmbSibCache = { key: _ck, list: [] };
      return _dmbSibCache.list;
    }
    // Normalise text objects (they use left/top strings instead of x/y numbers)
    // so the snap engine can treat every sibling uniformly.  Text is inset by its
    // padding (2px 6px) so its snap edges are the GLYPH edges (first/last letter),
    // matching the dragged-text behaviour — text-to-text aligns letter-to-letter.
    const _TX_PL = 6, _TX_PT = 2;
    const list = arr
      .filter(o => o && o.id !== obj.id)
      .map(o => {
        if (o.type !== "text") return o;
        const el = document.getElementById(o.id);
        const boxW = el ? Math.max(el.scrollWidth, el.offsetWidth) : 132;
        const boxH = el ? (el.offsetHeight || 34)                 : 34;
        return {
          ...o,
          x: parseFloat(o.left || "0") + _TX_PL,
          y: parseFloat(o.top  || "0") + _TX_PT,
          w: Math.max(0, boxW - _TX_PL * 2),
          h: Math.max(0, boxH - _TX_PT * 2),
        };
      })
      .filter(o => (o.w || 0) > 4 && (o.h || 0) > 4);
    _dmbSibCache = { key: _ck, list };
    return list;
  }

  // ── Smart-guide extras: mm conversion + pooled labels & spacing bars ──────────
  // Model-px → millimetres for the surface being edited, so guide labels show the
  // REAL printed distance (this is a print product; mm is the meaningful unit).
  function _dmbMmPerPx(container, targetType) {
    try {
      const ls = dmbIsLandscape();
      if (targetType === "cover") {
        const wmm = window.DMB_CARD_MODE ? (ls ? 178 : 127) : (ls ? 297 : 210);
        return wmm / 300;                       // 300 model-px == one cover face
      }
      let wmm;
      if (window.DMB_CARD_MODE) wmm = ls ? 178 : 127;
      else if (editor && editor.bookSize === "A5") wmm = ls ? 210 : 148;
      else wmm = ls ? 297 : 210;
      const px = (container && container.offsetWidth) || 270;
      return wmm / px;
    } catch (e) { return 210 / 270; }
  }
  // Format a model-px-derived millimetre distance as CENTIMETRES with NO unit suffix
  // (e.g. 10 mm → "1", 4 mm → "0.4", 15 mm → "1.5").
  function _dmbFmtCm(mm) {
    const v = Math.round((mm / 10) * 10) / 10;
    return v === Math.round(v) ? String(Math.round(v)) : v.toFixed(1);
  }

  // mm-distance chips — pooled per container, reused across frames (like the guide lines).
  function _dmbAcquireLabel(container) {
    const host = _dmbOverlayHost(container).host;
    if (!host._snapLabels) host._snapLabels = [];
    let el = host._snapLabels.find(l => l._inUse === false);
    if (!el) {
      el = document.createElement("div");
      el.className = "dmb-snap-label";
      el.style.position = "absolute";
      el.style.zIndex = "2147483647";   // 32-bit max; acquired last, so the chips stay on top
      el.style.pointerEvents = "none";
      el.style.opacity = "0";
      host.appendChild(el);
      host._snapLabels.push(el);
    }
    el._inUse = true;
    el.className = "dmb-snap-label";
    return el;
  }
  // Spacing bars — the coloured line drawn along a gap. axis "x" = horizontal gap.
  function _dmbAcquireSpace(container, axis) {
    const host = _dmbOverlayHost(container).host;
    if (!host._snapSpaces) host._snapSpaces = [];
    let el = host._snapSpaces.find(s => s._inUse === false && s._axis === axis);
    if (!el) {
      el = document.createElement("div");
      el._axis = axis;
      el.style.position = "absolute";
      el.style.zIndex = "2147483647";   // 32-bit max; acquired after the guides, so it sits above them
      el.style.pointerEvents = "none";
      el.style.opacity = "0";
      host.appendChild(el);
      host._snapSpaces.push(el);
    }
    el._inUse = true;
    el.className = "dmb-snap-space dmb-snap-space-" + axis;
    return el;
  }
  function _dmbReleaseExtras(container) {
    const host = _dmbOverlayHost(container).host;
    (host._snapLabels || []).forEach(l => { l._inUse = false; l.style.opacity = "0"; });
    (host._snapSpaces || []).forEach(s => { s._inUse = false; s.style.opacity = "0"; });
  }
  // Draw one spacing bar + mm chip along `axis` from a→b at perpendicular offset `perp`.
  // `equal` renders it in the "matched spacing" highlight colour.
  function _dmbDrawSpace(container, axis, a, b, perp, mmpp, equal) {
    const len = b - a;
    if (len < 1) return;
    const bar = _dmbAcquireSpace(container, axis);
    if (equal) bar.className += " dmb-snap-space-eq";
    // a/b/perp arrive in PAGE space; the bar now lives on the spread row, so shift by the
    // page's offset inside it. Zero everywhere there is no row (cover, page 0, preview).
    const { ox: _sox, oy: _soy } = _dmbOverlayHost(container);
    if (axis === "x") {
      bar.style.left = (a + _sox) + "px"; bar.style.width = len + "px";
      bar.style.top = (perp + _soy) + "px"; bar.style.height = "";
    } else {
      bar.style.top = (a + _soy) + "px"; bar.style.height = len + "px";
      bar.style.left = (perp + _sox) + "px"; bar.style.width = "";
    }
    bar.style.opacity = "1";
    const lab = _dmbAcquireLabel(container);
    if (equal) lab.className += " dmb-snap-label-eq";
    lab.textContent = _dmbFmtCm(len * mmpp);
    const mid = (a + b) / 2;
    if (axis === "x") { lab.style.left = (mid + _sox) + "px"; lab.style.top = (perp + _soy) + "px"; lab.style.transform = "translate(-50%,-135%)"; }
    else              { lab.style.left = (perp + _sox) + "px"; lab.style.top = (mid + _soy) + "px"; lab.style.transform = "translate(-50%,-50%)"; }
    lab.style.opacity = "1";
  }

  // _noSnap = true → render the guides/labels for the object's CURRENT position but
  // do NOT move it (used by arrow-key nudging, which must stay pixel-exact). In that
  // mode a guide only shows when the object is already essentially on it (≤0.75px).
  function dmbCheckSnap(obj, container, gH, gV, _meta, _noSnap) {
    // _meta = { targetType, pageNumber } — optional; when absent falls back to container-centre only
    // Cache the container size per drag (it doesn't change mid-drag) to avoid an
    // offsetWidth/Height reflow every move. Invalidated via _dmbSnapGen on commits.
    let cW, cH;
    if (container._dmbSizeGen === _dmbSnapGen && container._dmbCW) {
      cW = container._dmbCW; cH = container._dmbCH;
    } else {
      cW = container.offsetWidth || 270;
      cH = container.offsetHeight || 338;
      container._dmbCW = cW; container._dmbCH = cH; container._dmbSizeGen = _dmbSnapGen;
    }

    // Dragged object edges
    const dL = obj.x, dR = obj.x + obj.w, dCx = obj.x + obj.w / 2;
    const dT = obj.y, dB = obj.y + obj.h, dCy = obj.y + obj.h / 2;

    // Collect snap candidates: { axis:"x"|"y", objEdge, refEdge }
    const snapsX = [];
    const snapsY = [];

    // Container vertical centre (Y mid-point — same for all targets)
    snapsY.push({ ref: cH / 2, edges: [dCy], label: "cc" });

    // Container edges (top=0, bottom=cH)
    snapsY.push({ ref: 0,  edges: [dT], label: "ce" });
    snapsY.push({ ref: cH, edges: [dB], label: "ce" });

    // Horizontal snap targets depend on target type
    const targetType = _meta?.targetType;
    const pageNumber = _meta?.pageNumber;

    if (targetType === "cover") {
      // Cover: snap to each zone's centre and edges
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      // Back zone: 0 → COVER_BACK_W
      snapsX.push({ ref: COVER_BACK_W / 2, edges: [dCx], label: "cc" });
      snapsX.push({ ref: 0,  edges: [dL], label: "ce" });
      snapsX.push({ ref: COVER_BACK_W, edges: [dR], label: "ce" });
      // Front zone: _magFX → _magFX + 300
      snapsX.push({ ref: _magFX + 150, edges: [dCx], label: "cc" });
      snapsX.push({ ref: _magFX, edges: [dL], label: "ce" });
      snapsX.push({ ref: _magFX + 300, edges: [dR], label: "ce" });
      // Spine zone (books only)
      if (!window.DMB_MAGAZINE_MODE && COVER_SPINE_W > 0) {
        snapsX.push({ ref: COVER_BACK_W + COVER_SPINE_W / 2, edges: [dCx], label: "cc" });
        snapsX.push({ ref: COVER_BACK_W, edges: [dL], label: "ce" });
        snapsX.push({ ref: COVER_BACK_W + COVER_SPINE_W, edges: [dR], label: "ce" });
      }
    } else {
      // Page objects: snap to container centre and edges
      snapsX.push({ ref: cW / 2, edges: [dCx], label: "cc" });
      snapsX.push({ ref: 0,  edges: [dL], label: "ce" });
      snapsX.push({ ref: cW, edges: [dR], label: "ce" });
    }

    // Sibling object edges (alignment candidates)
    const siblings = (targetType != null) ? _dmbGetSiblingObjects(obj, targetType, pageNumber) : [];

    for (const sib of siblings) {
      const sL = sib.x, sR = sib.x + sib.w, sCx = sib.x + sib.w / 2;
      const sT = sib.y, sB = sib.y + sib.h, sCy = sib.y + sib.h / 2;
      snapsX.push({ ref: sL,  edges: [dL, dR], label: "obj" });
      snapsX.push({ ref: sR,  edges: [dL, dR], label: "obj" });
      snapsX.push({ ref: sCx, edges: [dCx],    label: "cc"  }); // centre→dashed
      snapsY.push({ ref: sT,  edges: [dT, dB], label: "obj" });
      snapsY.push({ ref: sB,  edges: [dT, dB], label: "obj" });
      snapsY.push({ ref: sCy, edges: [dCy],    label: "cc"  }); // centre→dashed
    }

    // Best ALIGNMENT snap per axis
    let bestX = null, bestXDist = _SNAP_T + 1;
    for (const s of snapsX) for (const e of s.edges) {
      const d = Math.abs(e - s.ref);
      if (d < bestXDist) { bestXDist = d; bestX = { ref: s.ref, edge: e, delta: s.ref - e, kind: s.label }; }
    }
    let bestY = null, bestYDist = _SNAP_T + 1;
    for (const s of snapsY) for (const e of s.edges) {
      const d = Math.abs(e - s.ref);
      if (d < bestYDist) { bestYDist = d; bestY = { ref: s.ref, edge: e, delta: s.ref - e, kind: s.label }; }
    }

    // ── Distribution / equal-spacing snap ─────────────────────────────────
    // Look for a target position that makes the gap to a neighbour EQUAL to an
    // already-existing gap (centre equally between two items, or continue a chain
    // with the same spacing). Chosen only when it's closer than the alignment snap.
    const _ov = (a1, a2, b1, b2) => Math.min(a2, b2) - Math.max(a1, b1);
    // Every adjacent pair of perpendicularly-overlapping siblings → a reference gap
    // {G, a, b, perp, axis}. Collected for BOTH axes so the dragged item can match a
    // spacing that exists ANYWHERE on the spread, horizontal OR vertical.
    function _collectRefGaps(sibs, axis) {
      const out = [];
      for (const s of sibs) {
        let nr = null;
        for (const t of sibs) {
          if (t === s) continue;
          if (t.e1 >= s.e2 - 0.5 && _ov(s.p1, s.p2, t.p1, t.p2) > 0) { if (!nr || t.e1 < nr.e1) nr = t; }
        }
        if (nr) { const G = nr.e1 - s.e2; if (G > 0.5) { const pa = Math.max(s.p1, nr.p1), pb = Math.min(s.p2, nr.p2); out.push({ G, a: s.e2, b: nr.e1, perp: (pa + pb) / 2, axis }); } }
      }
      return out;
    }
    // Solve one axis. `mainAxis` = "x" or "y". `sibs` are on that axis; `refGaps` is the
    // COMBINED gap list from both axes (so an X move can match a Y spacing and vice versa).
    function _distCand(mainAxis, aStart, aEnd, aW, dPerp, sibs, refGaps) {
      let L = null, R = null;
      for (const s of sibs) {
        if (_ov(dPerp.p1, dPerp.p2, s.p1, s.p2) <= 0) continue;
        if (s.e2 <= aStart + 0.5) { if (!L || s.e2 > L.e2) L = s; }
        else if (s.e1 >= aEnd - 0.5) { if (!R || s.e1 < R.e1) R = s; }
      }
      const dMid = (dPerp.p1 + dPerp.p2) / 2;
      const cands = [];
      // (a) centre EQUALLY between the left & right neighbour on this axis
      if (L && R && (R.e1 - L.e2 - aW) >= 0) {
        const target = (L.e2 + R.e1 - aW) / 2;
        cands.push({ target, gaps: [{ axis: mainAxis, a: L.e2, b: target, perp: dMid }, { axis: mainAxis, a: target + aW, b: R.e1, perp: dMid }] });
      }
      // (b) match ANY reference gap (either axis): place the item that same distance
      //     from its nearest neighbour, and highlight BOTH the item's gap and the
      //     original reference gap wherever it lives.
      for (const rg of refGaps) {
        if (L) { const target = L.e2 + rg.G; cands.push({ target, gaps: [{ axis: mainAxis, a: L.e2, b: target, perp: dMid }, { axis: rg.axis, a: rg.a, b: rg.b, perp: rg.perp }] }); }
        if (R) { const target = R.e1 - aW - rg.G; cands.push({ target, gaps: [{ axis: mainAxis, a: target + aW, b: R.e1, perp: dMid }, { axis: rg.axis, a: rg.a, b: rg.b, perp: rg.perp }] }); }
      }
      let best = null, bestD = _SNAP_T + 1;
      for (const c of cands) { const d = Math.abs(c.target - aStart); if (d < bestD) { bestD = d; best = c; } }
      return best ? { target: best.target, gaps: best.gaps, dist: bestD } : null;
    }

    let distX = null, distY = null;
    if (targetType != null && siblings.length) {
      const sibX = siblings.map(s => ({ e1: s.x, e2: s.x + s.w, p1: s.y, p2: s.y + s.h }));
      const sibY = siblings.map(s => ({ e1: s.y, e2: s.y + s.h, p1: s.x, p2: s.x + s.w }));
      const refGaps = _collectRefGaps(sibX, "x").concat(_collectRefGaps(sibY, "y"));
      distX = _distCand("x", dL, dR, obj.w, { p1: dT, p2: dB }, sibX, refGaps);
      distY = _distCand("y", dT, dB, obj.h, { p1: dL, p2: dR }, sibY, refGaps);
    }

    // Apply the closest of {alignment, distribution} per axis. In _noSnap (arrow-key)
    // mode nothing moves and a guide only reflects an alignment the object is ALREADY
    // essentially on (≤0.75px), so the lines/labels appear exactly when it lines up.
    const T = _noSnap ? 0.75 : _SNAP_T;
    const alignXok = bestX && bestXDist <= T;
    let appliedX = null;
    if (distX && distX.dist <= T && (!alignXok || distX.dist < bestXDist)) { if (!_noSnap) obj.x = distX.target; appliedX = "dist"; }
    else if (alignXok) { if (!_noSnap) obj.x += bestX.delta; appliedX = "align"; }

    const alignYok = bestY && bestYDist <= T;
    let appliedY = null;
    if (distY && distY.dist <= T && (!alignYok || distY.dist < bestYDist)) { if (!_noSnap) obj.y = distY.target; appliedY = "dist"; }
    else if (alignYok) { if (!_noSnap) obj.y += bestY.delta; appliedY = "align"; }

    // ── Render guides + mm labels ─────────────────────────────────────────
    // Rendering is wrapped so any DOM hiccup can never break the drag itself
    // (the position snap above has already been applied).
    try {
    _dmbReleaseAllGuides(container);
    _dmbReleaseExtras(container);
    const mmpp = _dmbMmPerPx(container, targetType);
    const fL = obj.x, fR = obj.x + obj.w, fCx = obj.x + obj.w / 2;
    const fT = obj.y, fB = obj.y + obj.h, fCy = obj.y + obj.h / 2;

    // Alignment lines (blue solid = edge, dashed = centre)
    const { ox: _gox, oy: _goy } = _dmbOverlayHost(container);
    if (appliedX === "align") { const ln = _dmbAcquireGuide(container, "v", bestX.kind === "cc"); ln.style.left = (bestX.ref + _gox) + "px"; ln.style.transform = ""; ln.style.opacity = "1"; }
    if (appliedY === "align") { const ln = _dmbAcquireGuide(container, "h", bestY.kind === "cc"); ln.style.top = (bestY.ref + _goy) + "px"; ln.style.transform = ""; ln.style.opacity = "1"; }

    // Distribution: highlight the equal gaps (pink) with labels. Each gap draws on its
    // OWN axis (g.axis) at its own row/column, so a matched horizontal spacing lights up
    // horizontally and a matched vertical spacing lights up vertically — even together.
    if (appliedX === "dist" && distX) distX.gaps.forEach(g => _dmbDrawSpace(container, g.axis, g.a, g.b, g.perp, mmpp, true));
    if (appliedY === "dist" && distY) distY.gaps.forEach(g => _dmbDrawSpace(container, g.axis, g.a, g.b, g.perp, mmpp, true));

    // Live spacing labels: distance from the item to its nearest neighbour on each
    // side — or to the page/zone edge when there's no neighbour — so the customer
    // always sees the real space. Shown per axis only when distribution isn't already
    // drawing equal bars there (avoids double lines).
    function _liveSides(sibs, e1, e2, lo, hi, axis, perp) {
      let L = null, R = null;
      for (const s of sibs) {
        if (s.e2 <= e1 + 0.5) { if (!L || s.e2 > L.e2) L = s; }
        else if (s.e1 >= e2 - 0.5) { if (!R || s.e1 < R.e1) R = s; }
      }
      const gL = { a: L ? L.e2 : lo, b: e1 };
      const gR = { a: e2, b: R ? R.e1 : hi };
      if (gL.b - gL.a >= 1) _dmbDrawSpace(container, axis, gL.a, gL.b, perp, mmpp, false);
      if (gR.b - gR.a >= 1) _dmbDrawSpace(container, axis, gR.a, gR.b, perp, mmpp, false);
    }
    // Rebuild the in-line sibling sets from the FINAL position for accurate live gaps.
    if (targetType != null && siblings.length) {
      if (appliedX !== "dist") {
        const rs = siblings.filter(s => _ov(fT, fB, s.y, s.y + s.h) > Math.min(obj.h, s.h) * 0.2).map(s => ({ e1: s.x, e2: s.x + s.w }));
        _liveSides(rs, fL, fR, 0, cW, "x", fCy);
      }
      if (appliedY !== "dist") {
        const cs = siblings.filter(s => _ov(fL, fR, s.x, s.x + s.w) > Math.min(obj.w, s.w) * 0.2).map(s => ({ e1: s.y, e2: s.y + s.h }));
        _liveSides(cs, fT, fB, 0, cH, "y", fCx);
      }
    }

    // Auto-hide everything shortly after the drag stops moving
    clearTimeout(container._snapHideT);
    container._snapHideT = setTimeout(() => { _dmbReleaseAllGuides(container); _dmbReleaseExtras(container); }, _GUIDE_HIDE_MS);
    } catch (_snapErr) { try { _dmbReleaseAllGuides(container); _dmbReleaseExtras(container); } catch (_e2) {} }
  }

  // ── Resize-time snapping ──────────────────────────────────────────────────
  // Snaps the MOVING edge(s) of `obj` (which edges move is decided by the handle
  // `mode`: tl/tr/bl/br/ml/mr/tm/bm) onto alignment references (page/zone edges +
  // sibling edges & centres), keeping the anchored opposite edge fixed. Draws the
  // guide line(s) and a live W×H mm size chip. Skipped for rotated items (their
  // edges aren't axis-aligned). Mutates obj.{x,y,w,h}; caller re-applies styles.
  function _dmbResizeSnap(obj, container, meta, mode) {
    try {
      if (!obj || !mode) return;
      const rot = (((obj.rotation || 0) % 360) + 360) % 360;
      if (rot > 0.5 && rot < 359.5) return;               // rotated → skip
      const targetType = meta && meta.targetType;
      const pageNumber = meta && meta.pageNumber;
      let cW, cH;
      if (container._dmbSizeGen === _dmbSnapGen && container._dmbCW) { cW = container._dmbCW; cH = container._dmbCH; }
      else { cW = container.offsetWidth || 270; cH = container.offsetHeight || 338; container._dmbCW = cW; container._dmbCH = cH; container._dmbSizeGen = _dmbSnapGen; }
      const mmpp = _dmbMmPerPx(container, targetType);
      const sibs = (targetType != null) ? _dmbGetSiblingObjects(obj, targetType, pageNumber) : [];
      const refX = [], refY = [];
      if (targetType === "cover") {
        const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
        const zones = [[0, COVER_BACK_W], [_magFX, _magFX + 300]];
        if (!window.DMB_MAGAZINE_MODE && COVER_SPINE_W > 0) zones.push([COVER_BACK_W, COVER_BACK_W + COVER_SPINE_W]);
        zones.forEach(([x1, x2]) => { refX.push(x1, x2, (x1 + x2) / 2); });
      } else { refX.push(0, cW, cW / 2); }
      refY.push(0, cH, cH / 2);
      for (const s of sibs) { refX.push(s.x, s.x + s.w, s.x + s.w / 2); refY.push(s.y, s.y + s.h, s.y + s.h / 2); }
      const nearest = (refs, val) => { let best = null, bd = _SNAP_T + 1; for (const r of refs) { const d = Math.abs(r - val); if (d < bd) { bd = d; best = r; } } return (best != null && bd <= _SNAP_T) ? { ref: best, dist: bd } : null; };
      const MIND = 24;
      const movingLeft   = mode === "tl" || mode === "ml" || mode === "bl";
      const movingRight  = mode === "tr" || mode === "mr" || mode === "br";
      const movingTop    = mode === "tl" || mode === "tm" || mode === "tr";
      const movingBottom = mode === "bl" || mode === "bm" || mode === "br";
      const _ov = (a1, a2, b1, b2) => Math.min(a2, b2) - Math.max(a1, b1);

      // Sibling edges projected onto each axis, with the perpendicular span kept so
      // we only consider neighbours the frame actually lines up against.
      const arrX = sibs.map(s => ({ lo: s.x, hi: s.x + s.w, pp1: s.y, pp2: s.y + s.h }));
      const arrY = sibs.map(s => ({ lo: s.y, hi: s.y + s.h, pp1: s.x, pp2: s.x + s.w }));
      // Nearest sibling boundary strictly on the `dir` side of `pos` that overlaps the
      // perpendicular span [pp1,pp2]; falls back to the page/zone edge `fb`.
      const _neighEdge = (arr, pos, dir, pp1, pp2, fb) => {
        let best = null;
        for (const s of arr) {
          if (_ov(pp1, pp2, s.pp1, s.pp2) <= 0) continue;
          if (dir > 0) { if (s.lo >= pos - 0.5 && (best == null || s.lo < best)) best = s.lo; }
          else         { if (s.hi <= pos + 0.5 && (best == null || s.hi > best)) best = s.hi; }
        }
        return best != null ? best : fb;
      };

      _dmbReleaseAllGuides(container); _dmbReleaseExtras(container);
      let snapV = null, snapH = null, xEqual = false, yEqual = false;

      // ── X axis (left/right handle) ──────────────────────────────────────────
      // Prefer an EQUAL-SPACING snap (moving-side gap == the fixed anchored-side gap)
      // over plain edge alignment when it's at least as close, so resizing a frame
      // until its two side gaps match lights both up in pink — same as the move path.
      if (movingLeft || movingRight) {
        const pT = obj.y, pB = obj.y + obj.h;
        const movEdge  = movingRight ? (obj.x + obj.w) : obj.x;
        const anchEdge = movingRight ? obj.x : (obj.x + obj.w);
        const dir = movingRight ? 1 : -1;
        const movNeighbor  = _neighEdge(arrX, movEdge,  dir,  pT, pB, movingRight ? cW : 0);
        const anchNeighbor = _neighEdge(arrX, anchEdge, -dir, pT, pB, movingRight ? 0  : cW);
        const anchGap = movingRight ? (anchEdge - anchNeighbor) : (anchNeighbor - anchEdge);
        let eq = null;
        if (anchGap > 0.5) {
          const target = movingRight ? (movNeighbor - anchGap) : (movNeighbor + anchGap);
          const okW = movingRight ? (target - obj.x >= MIND) : ((obj.x + obj.w) - target >= MIND);
          const movGap = movingRight ? (movNeighbor - target) : (target - movNeighbor);
          if (okW && movGap > 0.5) { const d = Math.abs(target - movEdge); if (d <= _SNAP_T) eq = { target, dist: d, movNeighbor, anchNeighbor }; }
        }
        const al = nearest(refX, movEdge);
        if (eq && (!al || eq.dist <= al.dist)) {
          if (movingRight) { obj.w = Math.max(MIND, eq.target - obj.x); }
          else { const right = obj.x + obj.w; obj.x = Math.min(eq.target, right - MIND); obj.w = right - obj.x; }
          xEqual = true;
          const perp = obj.y + obj.h / 2;
          const nMov = movingRight ? (obj.x + obj.w) : obj.x;
          if (movingRight) { _dmbDrawSpace(container, "x", nMov, eq.movNeighbor, perp, mmpp, true); _dmbDrawSpace(container, "x", eq.anchNeighbor, obj.x, perp, mmpp, true); }
          else             { _dmbDrawSpace(container, "x", eq.movNeighbor, nMov, perp, mmpp, true); _dmbDrawSpace(container, "x", obj.x + obj.w, eq.anchNeighbor, perp, mmpp, true); }
        } else if (al) {
          if (movingRight) { obj.w = Math.max(MIND, al.ref - obj.x); snapV = obj.x + obj.w; }
          else { const right = obj.x + obj.w; obj.x = Math.min(al.ref, right - MIND); obj.w = right - obj.x; snapV = obj.x; }
        }
      }

      // ── Y axis (top/bottom handle) ──────────────────────────────────────────
      if (movingTop || movingBottom) {
        const pL = obj.x, pR = obj.x + obj.w;
        const movEdge  = movingBottom ? (obj.y + obj.h) : obj.y;
        const anchEdge = movingBottom ? obj.y : (obj.y + obj.h);
        const dir = movingBottom ? 1 : -1;
        const movNeighbor  = _neighEdge(arrY, movEdge,  dir,  pL, pR, movingBottom ? cH : 0);
        const anchNeighbor = _neighEdge(arrY, anchEdge, -dir, pL, pR, movingBottom ? 0  : cH);
        const anchGap = movingBottom ? (anchEdge - anchNeighbor) : (anchNeighbor - anchEdge);
        let eq = null;
        if (anchGap > 0.5) {
          const target = movingBottom ? (movNeighbor - anchGap) : (movNeighbor + anchGap);
          const okH = movingBottom ? (target - obj.y >= MIND) : ((obj.y + obj.h) - target >= MIND);
          const movGap = movingBottom ? (movNeighbor - target) : (target - movNeighbor);
          if (okH && movGap > 0.5) { const d = Math.abs(target - movEdge); if (d <= _SNAP_T) eq = { target, dist: d, movNeighbor, anchNeighbor }; }
        }
        const al = nearest(refY, movEdge);
        if (eq && (!al || eq.dist <= al.dist)) {
          if (movingBottom) { obj.h = Math.max(MIND, eq.target - obj.y); }
          else { const bottom = obj.y + obj.h; obj.y = Math.min(eq.target, bottom - MIND); obj.h = bottom - obj.y; }
          yEqual = true;
          const perp = obj.x + obj.w / 2;
          const nMov = movingBottom ? (obj.y + obj.h) : obj.y;
          if (movingBottom) { _dmbDrawSpace(container, "y", nMov, eq.movNeighbor, perp, mmpp, true); _dmbDrawSpace(container, "y", eq.anchNeighbor, obj.y, perp, mmpp, true); }
          else              { _dmbDrawSpace(container, "y", eq.movNeighbor, nMov, perp, mmpp, true); _dmbDrawSpace(container, "y", obj.y + obj.h, eq.anchNeighbor, perp, mmpp, true); }
        } else if (al) {
          if (movingBottom) { obj.h = Math.max(MIND, al.ref - obj.y); snapH = obj.y + obj.h; }
          else { const bottom = obj.y + obj.h; obj.y = Math.min(al.ref, bottom - MIND); obj.h = bottom - obj.y; snapH = obj.y; }
        }
      }

      const { ox: _rox, oy: _roy } = _dmbOverlayHost(container);
      if (snapV != null) { const ln = _dmbAcquireGuide(container, "v", false); ln.style.left = (snapV + _rox) + "px"; ln.style.transform = ""; ln.style.opacity = "1"; }
      if (snapH != null) { const ln = _dmbAcquireGuide(container, "h", false); ln.style.top = (snapH + _roy) + "px"; ln.style.transform = ""; ln.style.opacity = "1"; }
      const lab = _dmbAcquireLabel(container);
      lab.textContent = _dmbFmtCm(obj.w * mmpp) + " × " + _dmbFmtCm(obj.h * mmpp);
      lab.style.left = (obj.x + obj.w / 2 + _rox) + "px"; lab.style.top = (obj.y + _roy) + "px"; lab.style.transform = "translate(-50%,-135%)"; lab.style.opacity = "1";

      // Live spacing labels — mirror the whole-frame move path (dmbCheckSnap →
      // _liveSides): show the gap from each edge of the (now-resized) frame to its
      // nearest neighbour, or to the page/zone edge when there's none. Skipped on an
      // axis where the equal-spacing bars above already drew the gaps (avoids double).
      try {
        const fL = obj.x, fR = obj.x + obj.w, fT = obj.y, fB = obj.y + obj.h;
        const fCx = fL + obj.w / 2, fCy = fT + obj.h / 2;
        const _liveSides = (arr, e1, e2, lo, hi, axis, perp) => {
          let L = null, R = null;
          for (const s of arr) {
            if (s.e2 <= e1 + 0.5) { if (!L || s.e2 > L.e2) L = s; }
            else if (s.e1 >= e2 - 0.5) { if (!R || s.e1 < R.e1) R = s; }
          }
          const gL = { a: L ? L.e2 : lo, b: e1 };
          const gR = { a: e2, b: R ? R.e1 : hi };
          if (gL.b - gL.a >= 1) _dmbDrawSpace(container, axis, gL.a, gL.b, perp, mmpp, false);
          if (gR.b - gR.a >= 1) _dmbDrawSpace(container, axis, gR.a, gR.b, perp, mmpp, false);
        };
        if (sibs.length) {
          if (!xEqual) { const rs = sibs.filter(s => _ov(fT, fB, s.y, s.y + s.h) > Math.min(obj.h, s.h) * 0.2).map(s => ({ e1: s.x, e2: s.x + s.w })); _liveSides(rs, fL, fR, 0, cW, "x", fCy); }
          if (!yEqual) { const cs = sibs.filter(s => _ov(fL, fR, s.x, s.x + s.w) > Math.min(obj.w, s.w) * 0.2).map(s => ({ e1: s.y, e2: s.y + s.h })); _liveSides(cs, fT, fB, 0, cH, "y", fCx); }
        }
      } catch (e) {}

      clearTimeout(container._snapHideT);
      container._snapHideT = setTimeout(() => { _dmbReleaseAllGuides(container); _dmbReleaseExtras(container); }, _GUIDE_HIDE_MS);
    } catch (e) {}
  }

  function dmbApplyZoneClip(el, obj) {
    if (!obj.coverZone) { el.style.clipPath = ""; return; }
    const FACE_W = 300;
    let zoneX1, zoneX2;
    if (obj.coverZone === "back") {
      zoneX1 = 0; zoneX2 = COVER_BACK_W;
    } else if (obj.coverZone === "spine") {
      zoneX1 = COVER_BACK_W; zoneX2 = COVER_FRONT_X;
    } else {
      zoneX1 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      zoneX2 = zoneX1 + FACE_W;
    }
    const leftClip = Math.max(0, zoneX1 - (obj.x || 0));
    const rightClip = Math.max(0, (obj.x || 0) + (obj.w || 0) - zoneX2);
    el.style.clipPath = (leftClip === 0 && rightClip === 0) ? "" : `inset(0 ${rightClip}px 0 ${leftClip}px)`;
  }

  function dmbAlignObjectInZone(el, obj, align, targetType) {
    let zoneX = 0, zoneW;
    if (targetType === "cover") {
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      if (obj.coverZone === "back") { zoneX = 0; zoneW = COVER_BACK_W; }
      else if (obj.coverZone === "spine") { zoneX = COVER_BACK_W; zoneW = COVER_SPINE_W; }
      else { zoneX = _magFX; zoneW = 300; }
    } else {
      const container = el.closest('[data-page-body="true"]') || el.parentElement;
      zoneW = container ? container.offsetWidth : 270;
      // A spanning shape or map belongs to the SPREAD, so align it across the spread.
      // Aligning it to one page was the only control that silently destroyed a span:
      // one tap on the align buttons and the object jumped wholly onto its own sheet.
      const _apn = (container && container.dataset) ? Number(container.dataset.pageNumber) : NaN;
      if (Number.isFinite(_apn) && _dmbObjOverhangs(obj, _apn)) {
        const _ar = _dmbPointRangeX(_apn, zoneW);
        zoneX = _ar.lo; zoneW = _ar.hi - _ar.lo;
      }
    }
    const elementW = obj.w || el.offsetWidth || 100;
    let newX;
    if (align === "left") newX = zoneX;
    else if (align === "center") newX = Math.round(zoneX + (zoneW - elementW) / 2);
    else newX = zoneX + zoneW - elementW;
    // A line's box is DERIVED from its endpoints, so writing obj.x alone achieved
    // nothing - the next _dmbLineRecomputeBox rebuilt the box from x1/x2/bx and put the
    // line straight back. Align has therefore always been a silent no-op on lines. Carry
    // the endpoints by the same delta so the button does what it says. (2026-09-14)
    const _adx = newX - (obj.x || 0);
    obj.x = newX;
    if (_adx && obj.type === "shape" && obj.shapeType === "line") {
      if (obj.x1 != null) obj.x1 += _adx;
      if (obj.x2 != null) obj.x2 += _adx;
      if (obj.bx != null) obj.bx += _adx;
    }
    el.style.left = newX + "px";
    if (obj.coverZone) dmbApplyZoneClip(el, obj);
    pushUndoState("Align " + align.charAt(0).toUpperCase() + align.slice(1));
  }

  function dmbAlignTextNode(node, align) {
    const parent = node.parentElement;
    if (!parent) return;
    let zoneX = 0, zoneW;
    const coverWrap = parent.closest(".dmb-cover-preview");
    if (coverWrap) {
      const utEntry = (editor.coverUserTexts || []).find(function(e) { return e.id === node.id; });
      const zone = utEntry?.zone || activeCoverZone;
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      if (zone === "back") { zoneX = 0; zoneW = COVER_BACK_W; }
      else if (zone === "spine") { zoneX = COVER_BACK_W; zoneW = COVER_SPINE_W; }
      else { zoneX = _magFX; zoneW = 300; }
    } else {
      zoneW = parent.offsetWidth;
    }
    // scrollWidth captures actual text content width even when it overflows an
    // explicit CSS width (e.g. width:220px set by the textAlign dropdown).
    // offsetWidth alone returns the box size, not the visual text extent.
    const nodeW = Math.max(node.offsetWidth, node.scrollWidth) || 120;
    let newX;
    if (align === "left") newX = zoneX;
    else if (align === "center") newX = Math.round(zoneX + (zoneW - nodeW) / 2);
    else newX = zoneX + zoneW - nodeW;
    node.style.left = newX + "px";
    // Save to BOTH cover state AND page objects so the new position is
    // reflected in the PDF for both cover text and page text.
    // WARNING: do NOT remove savePageTextState — without it, position alignment
    // buttons (← ↔ →) leave editor.pageObjects.left stale and the PDF shows
    // the text at the old position instead of the new one.
    saveCoverTextNodeState(node);
    savePageTextState(node);
    pushUndoState("Align Text " + align.charAt(0).toUpperCase() + align.slice(1));
    showTextToolbarFor(node);
  }

  function getObjectListForTarget(targetType, pageNumber) {
    if (targetType === "cover") {
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      return editor.coverObjects;
    }
    if (!editor.pageObjects || typeof editor.pageObjects !== "object") {
      editor.pageObjects = {};
    }
    const p = Number(pageNumber);
    if (p == null || isNaN(p) || p < 0) return [];
    if (!Array.isArray(editor.pageObjects[p])) editor.pageObjects[p] = [];
    return editor.pageObjects[p];
  }

  // ── Cross-page move helper ──────────────────────────────────────────────
  async function dmbHandleCrossPageMove(obj, sourcePageNumber) {
    const si = editor.currentSpread;
    if (si < 0 || si == null) return;
    const leftPage  = si * 2 + 1;
    const rightPage = si * 2 + 2;
    if (sourcePageNumber !== leftPage && sourcePageNumber !== rightPage) return;
    if (rightPage > (editor.totalPages || 0)) return;

    const PAGE_W   = getPageDims().w;
    const isOnLeft = (sourcePageNumber === leftPage);
    const cx       = obj.x + (obj.w || 0) / 2;
    const objRight = obj.x + (obj.w || 0);

    let targetPage = sourcePageNumber;
    let straddling = false;
    if (isOnLeft) {
      if      (cx > PAGE_W)    targetPage = rightPage;
      else if (objRight > PAGE_W) straddling = true;
    } else {
      if      (cx < 0)         targetPage = leftPage;
      else if (obj.x < 0)      straddling = true;
    }

    // No longer across the fold - drop the "deliberate" marker so a later accidental
    // overhang asks again rather than inheriting this object's history.
    if (!straddling && obj.straddle) { try { delete obj.straddle; } catch (e) {} }

    if (straddling && (obj.type === "shape" || obj.type === "map" || obj.type === "photo-frame")) {
      // THE FEATURE: shapes and maps are allowed to span both pages of a spread. The
      // render path already prints cross-fold overhang (getSpreadOverflowObjs), and the
      // per-page fingerprint already hashes the facing page's objects (pageFp's
      // partnerObjs), so what is on screen is what prints and editing it re-renders both
      // sheets. Nothing here needs to move the object at all - it stays filed on the page
      // its CENTRE is on, which is what the two branches above already decided.
      //
      // Every other type still has to pick a page: a photo frame or a text box split down
      // the gutter is almost always a slip, not a design. (2026-09-14)
      obj.straddle = true;
      return;
    }

    if (straddling) {
      const choice = await showChoiceDialog(
        "Object spans both pages",
        // Reached only by text and stickers now: photo frames, shapes and maps are all
        // allowed across the fold, and the PDF prints the overhang on both sheets.
        "This item crosses the divider between two pages. Where should it go?",
        [
          { id: "stay", label: `Keep on Page ${sourcePageNumber}` },
          { id: "move", label: `Move to Page ${isOnLeft ? rightPage : leftPage}` }
        ]
      );
      if (choice !== "move") return;
      targetPage = isOnLeft ? rightPage : leftPage;
    }

    if (targetPage === sourcePageNumber) return;

    const src = editor.pageObjects[sourcePageNumber];
    if (!Array.isArray(src)) return;
    const idx = src.findIndex(o => o.id === obj.id);
    if (idx === -1) return;
    src.splice(idx, 1);

    const _dxPage = isOnLeft ? -PAGE_W : PAGE_W;
    obj.x += _dxPage;
    // A line stores endpoints, not a box — the box is recomputed from them, so the
    // endpoints must move too or the next recompute puts the line back.
    if (obj.type === "shape" && obj.shapeType === "line") {
      if (obj.x1 != null) obj.x1 += _dxPage;
      if (obj.x2 != null) obj.x2 += _dxPage;
      if (obj.bx != null) obj.bx += _dxPage;
    }

    if (!Array.isArray(editor.pageObjects[targetPage])) editor.pageObjects[targetPage] = [];
    editor.pageObjects[targetPage].push(obj);

    if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    if (typeof renderThumbsRail   === "function") renderThumbsRail();
  }

  function renderFreeFrameObjects(container, meta) {
    const targetType = meta?.targetType || "page";
    const pageNumber = meta?.pageNumber ?? null;
    const zone = meta?.zone || null;
    // Pages: z >= 60 keeps frames above the spread overlay (z:50).
    // Cover: use own z-value — drops handled by peek-under method, not z-index.
    const minFrameZ = targetType === "cover" ? 0 : 60;

    const rawObjs = getObjectListForTarget(targetType, pageNumber, zone);
    const objs = Array.isArray(rawObjs)
      ? rawObjs.slice().sort((a, b) => Number(a.z || 0) - Number(b.z || 0))
      : [];

    objs.forEach((obj) => {
      if (obj.type === "map") {
        const wrap = document.createElement("div");
        wrap.className = "dmb-map-object";
        wrap.dataset.objectId = obj.id;
        wrap.style.position = "absolute";
        wrap.style.left = obj.x + "px";
        wrap.style.top = obj.y + "px";
        wrap.style.width = obj.w + "px";
        wrap.style.height = obj.h + "px";
        var _zMap = Number(_dmbZOf(obj, 20)) || 0;
        if (_dmbObjOverhangs(obj, pageNumber)) _zMap = Math.max(1, _zMap);
        wrap.style.zIndex = String(_zMap);
        wrap.dataset.z = String(obj.z || 20);
        wrap.style.cursor = "move";
        wrap.style.overflow = "visible";
        wrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
        wrap.style.transformOrigin = "center center";
        if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
        if (obj.contained) _dmbApplyContain(wrap, obj, targetType === "cover");

        const mapParser = new DOMParser();
        const svgDoc = mapParser.parseFromString(obj.svg || "", "image/svg+xml");
        const svgEl = svgDoc.querySelector("svg");
        if (svgEl) {
          if (!svgEl.getAttribute("viewBox")) {
            const origW = svgEl.getAttribute("width");
            const origH = svgEl.getAttribute("height");
            if (origW && origH) {
              svgEl.setAttribute("viewBox", `0 0 ${parseFloat(origW)} ${parseFloat(origH)}`);
            }
          }
          svgEl.removeAttribute("width");
          svgEl.removeAttribute("height");
          svgEl.style.width = "100%";
          svgEl.style.height = "100%";
          svgEl.style.display = "block";
          dmbApplyStylesToSvg(svgEl, obj);
          wrap.appendChild(svgEl);
        }

        if (Array.isArray(obj.markers)) {
          obj.markers.forEach((markerData) => {
            const marker = createMarkerElement(markerData.type || "pin", markerData.color || "#e74c3c");
            marker.style.left = (markerData.x || 50) + "%";
            marker.style.top  = (markerData.y || 50) + "%";
            wrap.appendChild(marker);
            attachMarkerInteractions(marker, markerData, wrap);
          });
        }

        const mapHandles = [
          ["tl","0","0"],["tm","50%","0"],["tr","100%","0"],
          ["ml","0","50%"],["mr","100%","50%"],
          ["bl","0","100%"],["bm","50%","100%"],["br","100%","100%"]
        ];
        mapHandles.forEach(([pos, l, t]) => {
          const h = document.createElement("div");
          h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          h.dataset.handle = pos;
          h.style.left = l;
          h.style.top = t;
          wrap.appendChild(h);
        });

        /* ── rotation handle (fixed-position, appended to body to escape overflow:hidden) ── */
        const rotHandle = document.createElement("div");
        rotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        rotHandle.innerHTML = "&#8635;";
        rotHandle.title = "Rotate";

        const degDisplay = document.createElement("div");
        degDisplay.className = "dmb-map-rotate-deg dmb-map-rot-float";
        degDisplay.textContent = Math.round(obj.rotation || 0) + "\u00b0";
        degDisplay.style.display = "none";

        rotHandle.style.display = "none"; // hidden until map is selected
        document.body.appendChild(rotHandle);
        document.body.appendChild(degDisplay);
        wrap._dmbRotHandle = rotHandle; // store reference for show/hide

        function updateRotPos() {
          if (!wrap.isConnected) { rotHandle.remove(); degDisplay.remove(); return; }
          const r = wrap.getBoundingClientRect();
          // Place handle at the actual BR corner of the bounding box, offset outward
          rotHandle.style.left = (r.right + 14) + "px";
          rotHandle.style.top = (r.bottom + 14) + "px";
          degDisplay.style.left = (r.right + 14) + "px";
          degDisplay.style.top = (r.bottom + 40) + "px";
        }

        requestAnimationFrame(updateRotPos);

        rotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = wrap.getBoundingClientRect();
          const cx = r.left + r.width / 2;
          const cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          degDisplay.style.display = "block";
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            wrap.style.transform = `rotate(${obj.rotation}deg)`;
            degDisplay.textContent = Math.round(obj.rotation) + "\u00b0";
            updateRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            degDisplay.style.display = "none";
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        /* ── snap guides ── */
        const { gH, gV } = dmbGetSnapGuides(container);

        let mDragMode = null;
        let mSx = 0, mSy = 0, mOx = 0, mOy = 0, mOw = 0, mOh = 0, mAspect = 1;
        const MIND = 40;

        wrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          if (e.target.closest(".dmb-map-marker")) return;
          e.preventDefault();
          e.stopPropagation();
          if (obj.contained) wrap.style.clipPath = ""; // show full during drag
          // e.preventDefault() suppresses the click event, so select here directly
          dmbOpenEditBar(obj, wrap);
          mDragMode = "move";
          mSx = e.clientX; mSy = e.clientY;
          mOx = obj.x; mOy = obj.y;
          // On-screen scale of the canvas (transform:scale(currentZoom)). Used to
          // turn screen-pixel finger deltas into model pixels so touch dragging at
          // <100% zoom tracks the finger exactly instead of lagging.
          const _Z = _nodeOnScreenScale(wrap) || 1;
          let _liftMap = null;
          if (targetType === "page") {
            const _pr = wrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = wrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftMap = { pagesRow: _pr, origParent: wrap.parentElement, origZ: wrap.style.zIndex };
              mOx = (_wr.left - _rr.left) / _Z; mOy = (_wr.top - _rr.top) / _Z;
              wrap.style.left = mOx + "px"; wrap.style.top = mOy + "px"; wrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(wrap);
            }
          }
          const onMove = (ev) => {
            if (mDragMode !== "move") return;
            const dx = (ev.clientX - mSx) / _Z, dy = (ev.clientY - mSy) / _Z;
            if (_liftMap) {
              const _rawL = mOx + dx, _rawT = mOy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftMap, gH, gV, targetType, pageNumber);
              wrap.style.left = (_rawL + _sdx) + "px"; wrap.style.top = (_rawT + _sdy) + "px";
            } else {
              // Clamp to keep at least half the object inside the page
              const _cW = container.offsetWidth  || 270;
              const _cH = container.offsetHeight || 382;
              // Fallback branch (no spread row to lift into: cover, page 0). Aligned with
            // the release clamp so a map can never be yanked onto one sheet if the lift
            // ever fails - _dmbObjDragRangeX returns the single-page range anyway
            // wherever there is no spread partner, so this changes nothing today.
            const _rangeXf = _dmbObjDragRangeX(obj, pageNumber, _cW);
            obj.x = Math.max(_rangeXf.lo, Math.min(_rangeXf.hi, mOx + dx));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, mOy + dy));
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
              dmbCheckSnap(obj, container, gH, gV, { targetType, pageNumber });
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
            }
            updateRotPos();
          };
          const onUp = async () => {
            mDragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftMap) {
              const _rx = parseFloat(wrap.style.left), _ry = parseFloat(wrap.style.top);
              const _pgR = _liftMap.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftMap.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? (_pgR.left - _rR.left) / _Z : 0); obj.y = _ry;
              // Clamp so object can't land fully outside its destination page
              const _cW = _liftMap.origParent.offsetWidth  || 270;
              const _cH = _liftMap.origParent.offsetHeight || 382;
              const _rangeXm = _dmbObjDragRangeX(obj, pageNumber, _cW);
              obj.x = Math.max(_rangeXm.lo, Math.min(_rangeXm.hi, obj.x));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, obj.y));
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
              wrap.style.zIndex = _liftMap.origZ; _liftMap.origParent.appendChild(wrap); _liftMap = null;
            }
            pushUndoState("Move Map");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, wrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        wrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            mDragMode = handle.dataset.handle;
            mSx = e.clientX; mSy = e.clientY;
            mOx = obj.x; mOy = obj.y; mOw = obj.w; mOh = obj.h;
            mAspect = mOh > 0 ? mOw / mOh : 1;
            const _Z = _nodeOnScreenScale(wrap) || 1;
            const onMove = (ev) => {
              const dx = (ev.clientX - mSx) / _Z;
              const dy = (ev.clientY - mSy) / _Z;
              let newW, newH;

              // Width-driven handles (all except top/bottom middle)
              if (["tl","ml","bl"].includes(mDragMode)) newW = Math.max(MIND, mOw - dx);
              else if (["tr","mr","br"].includes(mDragMode)) newW = Math.max(MIND, mOw + dx);

              // Height-driven handles (top/bottom middle only)
              if (mDragMode === "tm") newH = Math.max(MIND, mOh - dy);
              else if (mDragMode === "bm") newH = Math.max(MIND, mOh + dy);

              // Compute the other dimension proportionally
              if (newW !== undefined) newH = Math.max(MIND, Math.round(newW / mAspect));
              else if (newH !== undefined) newW = Math.max(MIND, Math.round(newH * mAspect));

              obj.w = newW; obj.h = newH;

              // Position adjustments to keep the correct anchor
              if (["tl","ml","bl"].includes(mDragMode)) obj.x = mOx + (mOw - newW);
              else if (mDragMode === "tm" || mDragMode === "bm") obj.x = mOx + (mOw - newW) / 2;
              if (["tl","tm","tr"].includes(mDragMode)) obj.y = mOy + (mOh - newH);
              else if (mDragMode === "ml" || mDragMode === "mr") obj.y = mOy + (mOh - newH) / 2;

              _dmbResizeSnap(obj, container, { targetType, pageNumber }, mDragMode);
              wrap.style.left = obj.x + "px";
              wrap.style.top = obj.y + "px";
              wrap.style.width = obj.w + "px";
              wrap.style.height = obj.h + "px";
              if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
              updateRotPos();
            };
            const onUp = () => {
              mDragMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Map");
              if (targetType === "cover") {
                _dmbAutoAssignCoverZone(obj, wrap);
              }
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        currentInsertedMap = obj;
        container.appendChild(wrap);
        requestAnimationFrame(updateRotPos);
        return;
      }

      if (obj.type === "sticker") {
        // Ensure minimum valid dimensions (preserve user-set sizes — never overwrite on re-render)
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) {
          obj.w = 100; obj.h = 100;
        }

        const sWrap = document.createElement("div");
        sWrap.className = "dmb-sticker-object";
        sWrap.dataset.objectId = obj.id;
        sWrap.style.position = "absolute";
        sWrap.style.left = (obj.x || 20) + "px";
        sWrap.style.top = (obj.y || 20) + "px";
        sWrap.style.width = obj.w + "px";
        sWrap.style.height = obj.h + "px";
        sWrap.style.zIndex = String(_dmbZOf(obj, 30));
        sWrap.dataset.z = String(_dmbZOf(obj, 30));
        sWrap.style.cursor = "move";
        sWrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
        sWrap.style.transformOrigin = "center center";
        if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
        if (obj.contained) _dmbApplyContain(sWrap, obj, targetType === "cover");

        const sImg = document.createElement("img");
        // CORS so the crop resolver can read this image's alpha (cdn.shopify.com and
        // theme assets send ACAO:*; the PDF path already depends on it). If a host
        // refuses, reload once without it - the sticker must never vanish on screen.
        try {
          if (/^https?:/i.test(String(obj.tightUrl || obj.url || ""))) {
            sImg.crossOrigin = "anonymous";
            let _sTry = 0;
            const _sRetry = function () {
              const _b = obj.tightUrl || obj.url || "";
              if (!_b) return;
              _sTry++;
              if (_sTry === 1) {
                // Usual cause: the image is already in the HTTP cache from a NON-CORS
                // load, so the CORS request is refused from cache. Force one fresh
                // fetch before giving up on readable pixels (readable = measurable
                // crop = the sticker is not deformed).
                sImg.addEventListener("error", _sRetry, { once: true });
                sImg.src = _b + (_b.indexOf("?") >= 0 ? "&" : "?") + "dmbcors=1";
              } else {
                sImg.crossOrigin = null;
                sImg.src = _b;
              }
            };
            sImg.addEventListener("error", _sRetry, { once: true });
          }
        } catch (e) {}
        // Use the pre-cropped data URL if available; fall back to original CDN URL
        sImg.src = obj.tightUrl || obj.url || "";
        sImg.alt = obj.name || "";
        sImg.draggable = false;
        sImg.style.display = "block";
        sImg.style.pointerEvents = "none";
        // Crop parity with the PDF. Without tightUrl both renderers load the FULL
        // PNG, but only the PDF re-crops it - so show the same window here.
        const _sCrop = (!obj.tightUrl && obj.cropW > 0 && obj.cropH > 0);
        let _sClip = null;
        const _sApplySize = () => {
          if (!_sCrop) {
            sImg.style.width = obj.w + "px";
            sImg.style.height = obj.h + "px";
            return;
          }
          const _nw = sImg.naturalWidth || obj.cropW, _nh = sImg.naturalHeight || obj.cropH;
          // Same resolver as the PDF, so screen and print show the same window.
          const _c = (sImg.naturalWidth ? _dmbStickerCropFor(obj, sImg) : null) ||
                     { cropX: obj.cropX || 0, cropY: obj.cropY || 0, cropW: obj.cropW, cropH: obj.cropH };
          sImg.style.position = "absolute";
          sImg.style.width  = (_nw / _c.cropW * obj.w) + "px";
          sImg.style.height = (_nh / _c.cropH * obj.h) + "px";
          sImg.style.left   = (-(_c.cropX || 0) / _c.cropW * obj.w) + "px";
          sImg.style.top    = (-(_c.cropY || 0) / _c.cropH * obj.h) + "px";
        };
        if (_sCrop) {
          // Its own clipping layer: overflow:hidden on sWrap would also swallow
          // the resize handles, which are children of the wrapper.
          _sClip = document.createElement("div");
          _sClip.style.cssText = "position:absolute;inset:0;overflow:hidden;pointer-events:none;";
          _sClip.appendChild(sImg);
          sWrap.appendChild(_sClip);
          if (sImg.complete && sImg.naturalWidth) _sApplySize();
          else sImg.addEventListener("load", _sApplySize, { once: true });
        } else {
          sWrap.appendChild(sImg);
        }
        _sApplySize();

        // Place handles at exact pixel positions on the sticker wrapper corners/edges
        function sStickerHandlePts(w, h) {
          return { tl:[0,0], tm:[w/2,0], tr:[w,0], ml:[0,h/2], mr:[w,h/2], bl:[0,h], bm:[w/2,h], br:[w,h] };
        }
        function updateStickerHandles(w, h) {
          const pts = sStickerHandlePts(w, h);
          sWrap.querySelectorAll(".dmb-frame-handle").forEach((el) => {
            const [lx, ty] = pts[el.dataset.handle] || [0, 0];
            el.style.left = lx + "px";
            el.style.top = ty + "px";
          });
        }
        const sInitW = obj.w || 100, sInitH = obj.h || 100;
        const sInitPts = sStickerHandlePts(sInitW, sInitH);
        [["tl","tl"],["tm","tm"],["tr","tr"],["ml","ml"],["mr","mr"],["bl","bl"],["bm","bm"],["br","br"]].forEach(([pos]) => {
          const h = document.createElement("div");
          h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          h.dataset.handle = pos;
          const [lx, ty] = sInitPts[pos];
          h.style.left = lx + "px";
          h.style.top = ty + "px";
          sWrap.appendChild(h);
        });

        const { gH: sGH, gV: sGV } = dmbGetSnapGuides(container);

        sWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
        });

        let sDMode = null, sSx = 0, sSy = 0, sSox = 0, sSoy = 0, sSow = 0, sSoh = 0;
        const S_MIN = 30;

        sWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault();
          e.stopPropagation();
          if (obj.contained) sWrap.style.clipPath = ""; // show full during drag
          showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
          sDMode = "move";
          sSx = e.clientX; sSy = e.clientY;
          sSox = obj.x; sSoy = obj.y;
          const _Z = _nodeOnScreenScale(sWrap) || 1;
          const _cW = container.offsetWidth  || 270;   // cache once — avoids a per-move reflow
          const _cH = container.offsetHeight || 382;
          let _liftS = null;
          if (targetType === "page") {
            const _pr = sWrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = sWrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftS = { pagesRow: _pr, origParent: sWrap.parentElement, origZ: sWrap.style.zIndex };
              sSox = (_wr.left - _rr.left) / _Z; sSoy = (_wr.top - _rr.top) / _Z;
              sWrap.style.left = sSox + "px"; sWrap.style.top = sSoy + "px"; sWrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(sWrap);
            }
          }
          const onMove = (ev) => {
            if (sDMode !== "move") return;
            const dx = (ev.clientX - sSx) / _Z, dy = (ev.clientY - sSy) / _Z;
            if (_liftS) {
              const _rawL = sSox + dx, _rawT = sSoy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftS, sGH, sGV, targetType, pageNumber);
              sWrap.style.left = (_rawL + _sdx) + "px"; sWrap.style.top = (_rawT + _sdy) + "px";
            } else {
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, sSox + dx));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, sSoy + dy));
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
              dmbCheckSnap(obj, container, sGH, sGV, { targetType, pageNumber });
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            }
          };
          const onUp = async () => {
            sDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftS) {
              const _rx = parseFloat(sWrap.style.left), _ry = parseFloat(sWrap.style.top);
              const _pgR = _liftS.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftS.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? (_pgR.left - _rR.left) / _Z : 0); obj.y = _ry;
              const _cW = _liftS.origParent.offsetWidth  || 270;
              const _cH = _liftS.origParent.offsetHeight || 382;
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, obj.x));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, obj.y));
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              sWrap.style.zIndex = _liftS.origZ; _liftS.origParent.appendChild(sWrap); _liftS = null;
            }
            pushUndoState("Move Sticker");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, sWrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        sWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            sDMode = handle.dataset.handle;
            sSx = e.clientX; sSy = e.clientY;
            sSox = obj.x; sSoy = obj.y;
            sSow = obj.w || 100; sSoh = obj.h || 100;
            const sAspect = sSow / (sSoh || 1);
            const _Z = _nodeOnScreenScale(sWrap) || 1;
            const onMove = (ev) => {
              const dx = (ev.clientX - sSx) / _Z;
              const dy = (ev.clientY - sSy) / _Z;
              let nx = sSox, ny = sSoy, nw = sSow, nh = sSoh;
              if (sDMode === "tm" || sDMode === "bm") {
                nh = Math.max(S_MIN, sDMode === "tm" ? sSoh - dy : sSoh + dy);
                if (sDMode === "tm") ny = sSoy + sSoh - nh;
                nw = Math.max(S_MIN, Math.round(nh * sAspect));
                nx = sSox + (sSow - nw) / 2;
              } else if (sDMode === "ml" || sDMode === "mr") {
                nw = Math.max(S_MIN, sDMode === "ml" ? sSow - dx : sSow + dx);
                if (sDMode === "ml") nx = sSox + sSow - nw;
                nh = Math.max(S_MIN, Math.round(nw / sAspect));
                ny = sSoy + (sSoh - nh) / 2;
              } else {
                if (sDMode.includes("r")) nw = Math.max(S_MIN, sSow + dx);
                if (sDMode.includes("l")) { nw = Math.max(S_MIN, sSow - dx); nx = sSox + sSow - nw; }
                nh = Math.max(S_MIN, Math.round(nw / sAspect));
                if (sDMode.includes("t")) ny = sSoy + sSoh - nh;
              }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              _dmbResizeSnap(obj, container, { targetType, pageNumber }, sDMode);
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              sWrap.style.width = obj.w + "px"; sWrap.style.height = obj.h + "px";
              _sApplySize();
              updateStickerHandles(obj.w, obj.h);
              if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
              showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            };
            const onUp = () => {
              sDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Sticker");
              if (targetType === "cover") {
                _dmbAutoAssignCoverZone(obj, sWrap);
              }
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        /* ── rotation handle (fixed-position, appended to body to escape overflow:hidden) ── */
        const sRotHandle = document.createElement("div");
        sRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        sRotHandle.innerHTML = "&#8635;";
        sRotHandle.title = "Rotate";
        sRotHandle.style.display = "none";
        document.body.appendChild(sRotHandle);
        sWrap._dmbRotHandle = sRotHandle;

        function updateStickerRotPos() {
          if (!sWrap.isConnected) { sRotHandle.remove(); return; }
          const r = sWrap.getBoundingClientRect();
          sRotHandle.style.left = (r.right + 14) + "px";
          sRotHandle.style.top = (r.bottom + 14) + "px";
        }

        requestAnimationFrame(updateStickerRotPos);

        sRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = sWrap.getBoundingClientRect();
          const cx = r.left + r.width / 2;
          const cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            sWrap.style.transform = `rotate(${obj.rotation}deg)`;
            updateStickerRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Rotate Sticker");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        container.appendChild(sWrap);
        return;
      }

      /* ── SHAPE OBJECTS ─────────────────────────────────────────────────────
       * Shapes follow the same drag/resize/rotate pattern as stickers, but
       * use an inline SVG instead of an <img>. The shape type (rect, circle, etc.)
       * is stored in obj.shapeType. Editing is via dmbShapeEditBar.
       *
       * WARNING: Do NOT merge this block with the sticker block above — shapes
       * use dmbOpenShapeEditBar, not showFrameToolbarFor.
       * ────────────────────────────────────────────────────────────────────── */
      if (obj.type === "shape" && obj.shapeType === "line") {
        // Lines have their own endpoint-based renderer (2 draggable ends, no box).
        _dmbRenderLineObject(obj, container, targetType, pageNumber, zone);
        return;
      }

      if (obj.type === "shape") {
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) { obj.w = 120; obj.h = 120; }

        const shWrap = document.createElement("div");
        shWrap.className = "dmb-shape-object";
        shWrap.dataset.objectId = obj.id;
        shWrap.style.position        = "absolute";
        shWrap.style.left            = (obj.x || 60) + "px";
        shWrap.style.top             = (obj.y || 60) + "px";
        shWrap.style.width           = obj.w + "px";
        shWrap.style.height          = obj.h + "px";
        var _zShape = Number(_dmbZOf(obj, 30)) || 0;
        if (_dmbObjOverhangs(obj, pageNumber)) _zShape = Math.max(1, _zShape);
        shWrap.style.zIndex          = String(_zShape);
        shWrap.style.transform       = `rotate(${obj.rotation || 0}deg)`;
        shWrap.style.transformOrigin = "center center";
        shWrap.style.overflow        = "visible";
        shWrap.dataset.z             = String(_dmbZOf(obj, 30));
        if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
        if (obj.contained) _dmbApplyContain(shWrap, obj, targetType === "cover");

        // The SVG fills the wrapper completely
        shWrap.innerHTML = buildShapeSvg(obj.shapeType, obj.fill, obj.stroke, obj.strokeWidth, obj.opacity, obj.cornerRadius, obj.w, obj.h, obj.strokeStyle);

        // 8 resize handles (same positions as maps/stickers)
        const shHandles = [
          ["tl","0","0"],["tm","50%","0"],["tr","100%","0"],
          ["ml","0","50%"],["mr","100%","50%"],
          ["bl","0","100%"],["bm","50%","100%"],["br","100%","100%"]
        ];
        shHandles.forEach(([pos, l, t]) => {
          const hEl = document.createElement("div");
          hEl.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          hEl.dataset.handle = pos;
          hEl.style.left = l;
          hEl.style.top  = t;
          shWrap.appendChild(hEl);
        });

        // Rotation handle (body-level, escapes overflow:hidden)
        const shRotHandle = document.createElement("div");
        shRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        shRotHandle.innerHTML = "&#8635;";
        shRotHandle.title     = "Rotate";
        shRotHandle.style.display = "none";
        document.body.appendChild(shRotHandle);
        shWrap._dmbRotHandle = shRotHandle;

        function updateShRotPos() {
          if (!shWrap.isConnected) { shRotHandle.remove(); return; }
          const r = shWrap.getBoundingClientRect();
          shRotHandle.style.left = (r.right + 14) + "px";
          shRotHandle.style.top  = (r.bottom + 14) + "px";
        }
        requestAnimationFrame(updateShRotPos);

        shRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault(); e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r  = shWrap.getBoundingClientRect();
          const cx = r.left + r.width  / 2;
          const cy = r.top  + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            shWrap.style.transform = `rotate(${obj.rotation}deg)`;
            // Sync rotation input in edit bar if this shape is selected
            const rotInput = document.getElementById("dmbShapeRotation");
            if (rotInput && dmbEditingShapeObj === obj) rotInput.value = Math.round(obj.rotation);
            updateShRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup",  onUp);
            pushUndoState("Rotate Shape");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup",   onUp);
        });

        // Snap guides
        const { gH: shGH, gV: shGV } = dmbGetSnapGuides(container);

        let shDMode = null, shSx = 0, shSy = 0, shOx = 0, shOy = 0, shOw = 0, shOh = 0;
        const SH_MIN = 10;

        // Click → open shape edit bar
        shWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          dmbOpenShapeEditBar(obj, shWrap);
        });

        // Pointer move/drag
        shWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault(); e.stopPropagation();
          if (obj.contained) shWrap.style.clipPath = ""; // show full during drag
          dmbOpenShapeEditBar(obj, shWrap);
          shDMode = "move";
          shSx = e.clientX; shSy = e.clientY;
          shOx = obj.x; shOy = obj.y;
          const _Z = _nodeOnScreenScale(shWrap) || 1;
          const _cW = container.offsetWidth  || 270;   // cache once — container size can't
          const _cH = container.offsetHeight || 382;   // change mid-drag; reading it each
                                                        // move forced a reflow every frame
          const _rangeX = _dmbObjDragRangeX(obj, pageNumber, _cW);   // spread-wide for shape/map
          const onMove = (ev) => {
            if (shDMode !== "move") return;
            const dx = (ev.clientX - shSx) / _Z, dy = (ev.clientY - shSy) / _Z;
            obj.x = Math.max(_rangeX.lo, Math.min(_rangeX.hi, shOx + dx));
            obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, shOy + dy));
            shWrap.style.left = obj.x + "px";
            shWrap.style.top  = obj.y + "px";
            if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
            dmbCheckSnap(obj, container, shGH, shGV, { targetType, pageNumber });
            shWrap.style.left = obj.x + "px"; shWrap.style.top = obj.y + "px";
            // Bar is docked at the top — no need to move it while dragging the shape.
          };
          const onUp = async () => {
            shDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup",  onUp);
            pushUndoState("Move Shape");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, shWrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup",  onUp);
        });

        // Resize handles
        shWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault(); e.stopPropagation();
            shDMode = handle.dataset.handle;
            shSx = e.clientX; shSy = e.clientY;
            shOx = obj.x; shOy = obj.y;
            shOw = obj.w || 120; shOh = obj.h || 120;
            const _Z = _nodeOnScreenScale(shWrap) || 1;
            const onMove = (ev) => {
              const dx = (ev.clientX - shSx) / _Z, dy = (ev.clientY - shSy) / _Z;
              let nx = shOx, ny = shOy, nw = shOw, nh = shOh;
              if (shDMode.includes("r")) nw = Math.max(SH_MIN, shOw + dx);
              if (shDMode.includes("l")) { nw = Math.max(SH_MIN, shOw - dx); nx = shOx + shOw - nw; }
              if (shDMode.includes("b")) nh = Math.max(SH_MIN, shOh + dy);
              if (shDMode.includes("t")) { nh = Math.max(SH_MIN, shOh - dy); ny = shOy + shOh - nh; }
              // For tm/bm (top/bottom middle) → height only
              if (shDMode === "tm") { nh = Math.max(SH_MIN, shOh - dy); ny = shOy + shOh - nh; nw = shOw; }
              if (shDMode === "bm") { nh = Math.max(SH_MIN, shOh + dy); nw = shOw; }
              if (shDMode === "ml") { nw = Math.max(SH_MIN, shOw - dx); nx = shOx + shOw - nw; nh = shOh; }
              if (shDMode === "mr") { nw = Math.max(SH_MIN, shOw + dx); nh = shOh; }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              _dmbResizeSnap(obj, container, { targetType, pageNumber }, shDMode);
              shWrap.style.left   = obj.x + "px";
              shWrap.style.top    = obj.y + "px";
              shWrap.style.width  = obj.w + "px";
              shWrap.style.height = obj.h + "px";
              if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
            };
            const onUp = () => {
              shDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup",  onUp);
              // Rebuild the SVG at the new size: rect/rounded-rect borders inset by
              // sw/2 px, which is size-dependent, and a live resize only rescales the
              // existing SVG (doesn't rebuild it). Replace just the <svg> child so the
              // 8 resize handles (siblings) survive.
              try {
                const _old = shWrap.querySelector("svg");
                if (_old) {
                  const _tmp = document.createElement("div");
                  _tmp.innerHTML = buildShapeSvg(obj.shapeType, obj.fill, obj.stroke, obj.strokeWidth, obj.opacity, obj.cornerRadius, obj.w, obj.h, obj.strokeStyle);
                  const _new = _tmp.firstElementChild;
                  if (_new) _old.replaceWith(_new);
                }
              } catch (e) {}
              pushUndoState("Resize Shape");
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup",  onUp);
          });
        });

        container.appendChild(shWrap);
        return;
      }

      if (obj.type === "mag-icon") {
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) { obj.w = 150; obj.h = 60; }
        const miWrap = document.createElement("div");
        miWrap.className = "dmb-sticker-object dmb-mag-icon-object";
        miWrap.dataset.objectId = obj.id;
        miWrap.dataset.iconId = obj.iconId || "";
        miWrap.style.cssText = `position:absolute;left:${obj.x||20}px;top:${obj.y||20}px;width:${obj.w}px;height:${obj.h}px;z-index:${obj.z||30};cursor:move;transform:rotate(${obj.rotation||0}deg);transform-origin:center center;`;
        miWrap.dataset.z = String(_dmbZOf(obj, 30));
        if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
        if (obj.contained) _dmbApplyContain(miWrap, obj, targetType === "cover");

        const miImgEl = document.createElement("img");
        miImgEl.draggable = false;
        miImgEl.style.cssText = "width:100%;height:100%;object-fit:contain;display:block;pointer-events:none;";
        miWrap.appendChild(miImgEl);
        dmbGetColoredIconDataUrl(obj.iconId, obj.color || "#000000").then((dataUrl) => {
          if (miImgEl.isConnected) miImgEl.src = dataUrl;
        });

        function miHandlePts(w, h) { return { tl:[0,0], tm:[w/2,0], tr:[w,0], ml:[0,h/2], mr:[w,h/2], bl:[0,h], bm:[w/2,h], br:[w,h] }; }
        function updateMiHandles(w, h) {
          const pts = miHandlePts(w, h);
          miWrap.querySelectorAll(".dmb-frame-handle").forEach((el) => {
            const [lx, ty] = pts[el.dataset.handle] || [0, 0];
            el.style.left = lx + "px"; el.style.top = ty + "px";
          });
        }
        const miInitPts = miHandlePts(obj.w, obj.h);
        [["tl"],["tm"],["tr"],["ml"],["mr"],["bl"],["bm"],["br"]].forEach(([pos]) => {
          const hEl = document.createElement("div");
          hEl.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          hEl.dataset.handle = pos;
          const [lx, ty] = miInitPts[pos];
          hEl.style.left = lx + "px"; hEl.style.top = ty + "px";
          miWrap.appendChild(hEl);
        });

        const { gH: miGH, gV: miGV } = dmbGetSnapGuides(container);

        miWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
        });

        let miDMode = null, miSx = 0, miSy = 0, miOx = 0, miOy = 0, miOw = 0, miOh = 0;
        const MI_MIN = 20;

        miWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault(); e.stopPropagation();
          if (obj.contained) miWrap.style.clipPath = ""; // show full during drag
          showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
          miDMode = "move"; miSx = e.clientX; miSy = e.clientY; miOx = obj.x; miOy = obj.y;
          const _Z = _nodeOnScreenScale(miWrap) || 1;
          let _liftMI = null;
          if (targetType === "page") {
            const _pr = miWrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = miWrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftMI = { pagesRow: _pr, origParent: miWrap.parentElement, origZ: miWrap.style.zIndex };
              miOx = (_wr.left - _rr.left) / _Z; miOy = (_wr.top - _rr.top) / _Z;
              miWrap.style.left = miOx + "px"; miWrap.style.top = miOy + "px"; miWrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(miWrap);
            }
          }
          const onMove = (ev) => {
            if (miDMode !== "move") return;
            const dx = (ev.clientX - miSx) / _Z, dy = (ev.clientY - miSy) / _Z;
            if (_liftMI) {
              const _rawL = miOx + dx, _rawT = miOy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftMI, miGH, miGV, targetType, pageNumber);
              miWrap.style.left = (_rawL + _sdx) + "px"; miWrap.style.top = (_rawT + _sdy) + "px";
            } else {
              obj.x = miOx + dx; obj.y = miOy + dy;
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
              dmbCheckSnap(obj, container, miGH, miGV, { targetType, pageNumber });
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            }
          };
          const onUp = async () => {
            miDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftMI) {
              const _rx = parseFloat(miWrap.style.left), _ry = parseFloat(miWrap.style.top);
              const _pgR = _liftMI.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftMI.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? (_pgR.left - _rR.left) / _Z : 0); obj.y = _ry;
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              miWrap.style.zIndex = _liftMI.origZ; _liftMI.origParent.appendChild(miWrap); _liftMI = null;
            }
            pushUndoState("Move Icon");
            if (targetType === "cover") _dmbAutoAssignCoverZone(obj, miWrap);
            else if (targetType === "page" && typeof pageNumber === "number") await dmbHandleCrossPageMove(obj, pageNumber);
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        miWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault(); e.stopPropagation();
            showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            miDMode = handle.dataset.handle; miSx = e.clientX; miSy = e.clientY;
            miOx = obj.x; miOy = obj.y; miOw = obj.w || 150; miOh = obj.h || 60;
            const miAspect = miOw / (miOh || 1);
            const _Z = _nodeOnScreenScale(miWrap) || 1;
            const onMove = (ev) => {
              const dx = (ev.clientX - miSx) / _Z, dy = (ev.clientY - miSy) / _Z;
              let nx = miOx, ny = miOy, nw = miOw, nh = miOh;
              if (miDMode === "tm" || miDMode === "bm") {
                nh = Math.max(MI_MIN, miDMode === "tm" ? miOh - dy : miOh + dy);
                if (miDMode === "tm") ny = miOy + miOh - nh;
                nw = Math.max(MI_MIN, Math.round(nh * miAspect)); nx = miOx + (miOw - nw) / 2;
              } else if (miDMode === "ml" || miDMode === "mr") {
                nw = Math.max(MI_MIN, miDMode === "ml" ? miOw - dx : miOw + dx);
                if (miDMode === "ml") nx = miOx + miOw - nw;
                nh = Math.max(MI_MIN, Math.round(nw / miAspect)); ny = miOy + (miOh - nh) / 2;
              } else {
                if (miDMode.includes("r")) nw = Math.max(MI_MIN, miOw + dx);
                if (miDMode.includes("l")) { nw = Math.max(MI_MIN, miOw - dx); nx = miOx + miOw - nw; }
                nh = Math.max(MI_MIN, Math.round(nw / miAspect));
                if (miDMode.includes("t")) ny = miOy + miOh - nh;
              }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              _dmbResizeSnap(obj, container, { targetType, pageNumber }, miDMode);
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              miWrap.style.width = obj.w + "px"; miWrap.style.height = obj.h + "px";
              updateMiHandles(obj.w, obj.h);
              if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
              showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            };
            const onUp = () => {
              miDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Icon");
              if (targetType === "cover") _dmbAutoAssignCoverZone(obj, miWrap);
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        const miRotHandle = document.createElement("div");
        miRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        miRotHandle.innerHTML = "&#8635;"; miRotHandle.title = "Rotate"; miRotHandle.style.display = "none";
        document.body.appendChild(miRotHandle);
        miWrap._dmbRotHandle = miRotHandle;

        function updateMiRotPos() {
          if (!miWrap.isConnected) { miRotHandle.remove(); return; }
          const r = miWrap.getBoundingClientRect();
          miRotHandle.style.left = (r.right + 14) + "px"; miRotHandle.style.top = (r.bottom + 14) + "px";
        }
        requestAnimationFrame(updateMiRotPos);

        miRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault(); e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = miWrap.getBoundingClientRect();
          const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            miWrap.style.transform = `rotate(${obj.rotation}deg)`;
            updateMiRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Rotate Icon");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        container.appendChild(miWrap);
        return;
      }

      if (obj.type === "text") {
        // Safety net: never re-create an empty text box — it was deleted.
        // The primary cleanup happens in savePageTextState, but stale data in
        // older localStorage saves may still have {text: ""} objects.
        if (!obj.text || !obj.text.trim()) return;
        const txt = document.createElement("div");
        txt.id = obj.id;
        txt.textContent = obj.text || "";
        // Part-of-the-box formatting, rebuilt from segments. Falls through to the
        // plain text above if anything about the stored value is off.
        if (obj.rich) { try { _dmbApplyRich(txt, obj.rich); } catch (eR) {} }
        txt.classList.add("dmb-editable-text");
        txt.style.position = "absolute";
        txt.style.left = obj.left || "40px";
        txt.style.top = obj.top || "40px";
        if (obj.width) {
          txt.style.width = obj.width;
          // An explicit width outranks .dmb-editable-text's min-width:120px, which
          // exists only so a brand-new EMPTY box is big enough to tap. Without this
          // release, a box narrowed below 120px with the side grip snapped back wide
          // on the next re-render. (2026-09-14)
          txt.style.minWidth = "0";
        }
        txt.style.fontSize = obj.fontSize || "28px";
        txt.style.fontWeight = obj.fontWeight || "800";
        txt.style.color = obj.color || "#666";
        txt.style.fontFamily = obj.fontFamily || "'Londrina Solid', sans-serif";
        if (obj.textAlign) txt.style.textAlign = obj.textAlign;
        if (obj.textDecoration) txt.style.textDecoration = obj.textDecoration;
        if (obj.whiteSpace) txt.style.whiteSpace = obj.whiteSpace;
        if (obj.transform) txt.style.transform = obj.transform;
        if (obj.rotate) txt.dataset.rotate = obj.rotate;
        txt.dataset.z = String(_dmbZOf(obj, Date.now()));
        txt.style.zIndex = txt.dataset.z;
        txt.dataset.pageNumber = String(pageNumber);
        txt.style.padding = "2px 6px";
        txt.style.background = "transparent";
        txt.style.outline = "none";
        attachTextNodeHandlers(txt);
        container.appendChild(txt);
        return;
      }

      if (obj.type !== "photo-frame") return;

      const frame = document.createElement("div");
      frame.className = "dmb-photo-frame-object";
      frame.dataset.objectId = obj.id;
      frame.style.left = `${obj.x}px`;
      frame.style.top = `${obj.y}px`;
      frame.style.width = `${obj.w}px`;
      frame.style.height = `${obj.h}px`;
      const z = _dmbZOf(obj, 10);
      // On pages: z >= 60 (above spread overlay z:50). On cover: z >= 100001 (above cover drag overlay z:100000).
      // z === 0 is the explicit "behind the photos" layer and must NOT be lifted —
      // the PDF draws it there, so lifting it here made the frame print as nothing.
      frame.style.zIndex = String(z === 0 ? 0 : Math.max(z, minFrameZ));
      frame.dataset.z = String(z);
      if (obj.rotation) frame.style.transform = `rotate(${obj.rotation}deg)`;
      if (obj.coverZone) dmbApplyZoneClip(frame, obj);

      // ── Polaroid frame styling: white mat + thicker bottom + light shadow ──
      const _isPoly = !!obj.polaroid;
      let _polyInsetCss = null;
      if (_isPoly) {
        const _pi = dmbPolaroidInsetVals(obj.w, obj.h);
        _polyInsetCss = `${_pi.top}px ${_pi.right}px ${_pi.bottom}px ${_pi.left}px`;
        frame.classList.add("dmb-polaroid");
        frame.style.background = "#ffffff";
        frame.style.borderRadius = "2px";
        frame.style.boxShadow = (obj.shadow !== false) ? "0 6px 16px rgba(0,0,0,0.18)" : "none";
      }

      if (obj.photoId) {
        const ph = getPhotoById(obj.photoId);
        if (ph) {
          // Overflow visible so buttons escape; inner clip keeps photo contained
          frame.style.overflow = "visible";
          const photoClip = document.createElement("div");
          photoClip.style.cssText = `position:absolute;inset:${_polyInsetCss || "0"};overflow:hidden;${_isPoly ? "" : "border-radius:inherit;"}pointer-events:none;`;
          const img = document.createElement("img");
          img.src = ph.url; img.alt = ""; img.draggable = false;
          img.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;";
          if (obj.frameShape) applyDmbFrameShape(img, obj.frameShape);
          photoClip.appendChild(img);
          frame.appendChild(photoClip);

          // Adaptive button layout based on frame width
          const _btnSVGs = [
            { aria:"Remove photo",  title:"Remove photo",  svg:`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");obj.photoId=null;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail();renderPhotoTray(); }},
            { aria:"Rotate",        title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");obj.rotation=((obj.rotation||0)-90+360)%360;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail(); }},
            { aria:"Crop",          title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(obj.photoId, { get:()=>obj.photoId, set:(id)=>{ obj.photoId=id; } }); }},
            { aria:"Frame shape",   title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="13" height="13" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();showDmbFramePicker(e.currentTarget,obj.frameShape||"",(s)=>{ pushUndoState("Frame Shape");obj.frameShape=s;applyDmbFrameShape(img,s); }); }}
          ];
          const _bs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
          const fw = obj.w || 100;

          if (fw >= 130) {
            // Wide: single row top-right
            _btnSVGs.forEach((d, i) => {
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:4px;right:${4+i*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else if (fw >= 65) {
            // Medium: 2×2 grid top-right
            _btnSVGs.forEach((d, i) => {
              const r=Math.floor(i/2), c=i%2;
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:${4+r*26}px;right:${4+c*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else {
            // Narrow: single ⋯ toggle
            const mb = document.createElement("button"); mb.type="button"; mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:2px;right:2px;width:22px;height:22px;z-index:12;font-size:13px;line-height:1;${_bs}`;
            const pop = document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:4px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _btnSVGs.forEach(d => {
              const b = document.createElement("button"); b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{ pop.style.display="none"; d.fn(ev); });
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{ e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");} });
            frame.appendChild(mb); frame.appendChild(pop);
          }
        }
      } else {
        const plus = document.createElement("div");
        plus.className = "dmb-photo-frame-plus";
        plus.innerHTML = '<span style="font-size:22px;display:block;">+</span><span style="font-size:11px;opacity:.7;">Drop photo here</span>';
        if (_isPoly) {
          plus.style.position = "absolute";
          plus.style.inset = _polyInsetCss;
          plus.style.background = "#f3efe6";
          plus.style.display = "flex";
          plus.style.flexDirection = "column";
          plus.style.alignItems = "center";
          plus.style.justifyContent = "center";
        }
        frame.appendChild(plus);
      }

      const handles = [
        ["tl", "0", "0"], ["tm", "50%", "0"], ["tr", "100%", "0"],
        ["ml", "0", "50%"], ["mr", "100%", "50%"],
        ["bl", "0", "100%"], ["bm", "50%", "100%"], ["br", "100%", "100%"]
      ];
      handles.forEach(([pos, left, top]) => {
        const h = document.createElement("div");
        h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
        h.dataset.handle = pos;
        h.style.left = left;
        h.style.top = top;
        frame.appendChild(h);
      });

      /* ── Frame rotation handle (Fix 4) ── */
      const _fRotHandle2 = document.createElement("div");
      _fRotHandle2.className = "dmb-map-rotate-handle dmb-map-rot-float";
      _fRotHandle2.innerHTML = "&#8635;";
      _fRotHandle2.title = "Rotate frame";
      _fRotHandle2.style.display = "none";
      document.body.appendChild(_fRotHandle2);
      frame._dmbRotHandle = _fRotHandle2;

      function _updateFrameRotPos2() {
        if (!frame.isConnected) { _fRotHandle2.remove(); return; }
        const _rr = frame.getBoundingClientRect();
        _fRotHandle2.style.left = (_rr.right + 14) + "px";
        _fRotHandle2.style.top = (_rr.bottom + 14) + "px";
      }
      requestAnimationFrame(_updateFrameRotPos2);

      _fRotHandle2.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        const _startRot = obj.rotation || 0;
        const _rr2 = frame.getBoundingClientRect();
        const _cx = _rr2.left + _rr2.width / 2, _cy = _rr2.top + _rr2.height / 2;
        const _startAng = Math.atan2(e.clientY - _cy, e.clientX - _cx) * 180 / Math.PI;
        const _onMove = (ev) => {
          const _ang = Math.atan2(ev.clientY - _cy, ev.clientX - _cx) * 180 / Math.PI;
          obj.rotation = _dmbSnapAngle(_startRot + (_ang - _startAng));
          frame.style.transform = `rotate(${obj.rotation}deg)`;
          _updateFrameRotPos2();
          showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
        };
        const _onUp = () => {
          hideRotDegTooltip();
          document.removeEventListener("pointermove", _onMove);
          document.removeEventListener("pointerup", _onUp);
          pushUndoState("Rotate Frame");
        };
        document.addEventListener("pointermove", _onMove);
        document.addEventListener("pointerup", _onUp);
      });

      frame.addEventListener("click", (e) => {
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
      });

      frame.addEventListener("dragover", (e) => {
        e.preventDefault();
        const payload = getDragPayload(e);
        e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      });

      frame.addEventListener("drop", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        if (!payload || !payload.photoId) return;
        pushUndoState("Drop Photo In Frame");
        obj.photoId = payload.photoId;
        if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
        renderPhotoTray();
        renderThumbsRail();
      });

      let dragMode = null;
      let sx = 0, sy = 0, ox = 0, oy = 0, ow = 0, oh = 0;

      const { gH: fGH, gV: fGV } = dmbGetSnapGuides(container);

      frame.addEventListener("pointerdown", (e) => {
        if (e.target.closest(".dmb-frame-handle")) return;
        // Let action buttons (crop, remove, rotate, etc.) receive their click events.
        // pointerdown.preventDefault() suppresses the click event for the whole pointer
        // sequence, so buttons inside the frame would silently do nothing without this guard.
        if (e.target.closest("button")) return;
        e.preventDefault();
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
        dragMode = "move";
        sx = e.clientX; sy = e.clientY;
        ox = obj.x; oy = obj.y;
        const _Z = _nodeOnScreenScale(frame) || 1;
        let _liftF = null;
        if (targetType === "page") {
          const _pr = frame.closest("[data-spread-row]");
          if (_pr) {
            _liftF = { pagesRow: _pr, origParent: frame.parentElement, origZ: frame.style.zIndex };
            // Use CSS-based page offset instead of getBoundingClientRect().
            // getBoundingClientRect gives the AXIS-ALIGNED bounding box of the rotated
            // element, which differs from the CSS left/top (the pre-rotation anchor).
            // Using offsetLeft/offsetTop avoids the position jump on rotated frames.
            const _pageEl = _liftF.origParent.parentElement; // the page div
            const _pageOffL = (_pageEl && _pageEl.offsetLeft) || 0;
            const _pageOffT = (_pageEl && _pageEl.offsetTop)  || 0;
            ox = obj.x + _pageOffL;
            oy = obj.y + _pageOffT;
            _liftF._offL = _pageOffL; _liftF._offT = _pageOffT;   // exact offsets for the snap (see onMove)
            frame.style.left = ox + "px"; frame.style.top = oy + "px"; frame.style.zIndex = "9000"; // below guides (9999)
            _pr.appendChild(frame);
          }
        }

        // Coalesce pointermoves to one update per animation frame: on touch the
        // finger fires moves faster than the screen refreshes, and each one did snap
        // geometry + guide drawing + a style write/read on a transform-scaled canvas
        // (forced reflow) — the main cause of the drag lag. We keep only the latest
        // event and apply it once per frame; the frame still tracks the finger.
        let _mvRaf = false, _mvEv = null;
        const _applyMove = () => {
          _mvRaf = false;
          const ev = _mvEv;
          if (!ev || dragMode !== "move") return;
          const dx = (ev.clientX - sx) / _Z, dy = (ev.clientY - sy) / _Z;
          if (_liftF) {
            // Snap in the page-body's OWN model coordinates: subtract the exact page
            // offset we added at lift start, snap, then re-add it. This keeps the snap
            // math in the same units the siblings use, so aligned edges land EXACTLY
            // (the old _dmbLiftSnap mixed getBoundingClientRect px with layout px, which
            // left a constant drift).
            const _rawL = ox + dx, _rawT = oy + dy;
            const _so = { id: obj.id, x: _rawL - _liftF._offL, y: _rawT - _liftF._offT, w: obj.w, h: obj.h };
            dmbCheckSnap(_so, _liftF.origParent, fGH, fGV, { targetType, pageNumber });
            frame.style.left = (_so.x + _liftF._offL) + "px";
            frame.style.top  = (_so.y + _liftF._offT) + "px";
          } else {
            obj.x = ox + dx; obj.y = oy + dy;
            frame.style.left = `${obj.x}px`; frame.style.top = `${obj.y}px`;
            if (obj.coverZone) dmbApplyZoneClip(frame, obj);
            dmbCheckSnap(obj, container, fGH, fGV, { targetType, pageNumber });
            frame.style.left = `${obj.x}px`; frame.style.top = `${obj.y}px`;
            showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          }
        };
        const onMove = (ev) => {
          if (dragMode !== "move") return;
          _mvEv = ev;
          if (_mvRaf) return;
          _mvRaf = true;
          requestAnimationFrame(_applyMove);
        };
        const onUp = async () => {
          if (_mvRaf) { _applyMove(); }   // flush the last coalesced move so the drop is exact
          dragMode = null;
          document.removeEventListener("pointermove", onMove);
          document.removeEventListener("pointerup", onUp);
          if (_liftF) {
            const _rx = parseFloat(frame.style.left), _ry = parseFloat(frame.style.top);
            // Use same CSS-based offset as the lift start (no getBoundingClientRect)
            const _pageEl2 = _liftF.origParent?.parentElement;
            const _pOff = (_pageEl2 && _pageEl2.offsetLeft) || 0;
            const _pOffT = (_pageEl2 && _pageEl2.offsetTop)  || 0;
            obj.x = _rx - _pOff;
            obj.y = _ry - _pOffT;
            frame.style.left = obj.x + "px"; frame.style.top = obj.y + "px";
            frame.style.zIndex = _liftF.origZ; _liftF.origParent.appendChild(frame); _liftF = null;
          }
          pushUndoState("Move Frame");
          if (targetType === "cover") {
            _dmbAutoAssignCoverZone(obj, frame);
          } else if (targetType === "page" && typeof pageNumber === "number") {
            await dmbHandleCrossPageMove(obj, pageNumber);
          }
        };
        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", onUp);
      });

      frame.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
        handle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          dragMode = handle.dataset.handle;
          sx = e.clientX; sy = e.clientY;
          ox = obj.x; oy = obj.y; ow = obj.w; oh = obj.h;
          const _Z = _nodeOnScreenScale(frame) || 1;

          const onMove = (ev) => {
            const dx = (ev.clientX - sx) / _Z;
            const dy = (ev.clientY - sy) / _Z;
            // Decompose screen-space delta into the element's rotated local coordinate system.
            // Without this, resizing a rotated frame pulls in the wrong direction.
            // For non-rotated frames (rotation=0): cos=1, sin=0 → ldx=dx, ldy=dy (no change).
            const _rot = (obj.rotation || 0) * Math.PI / 180;
            const _cos = Math.cos(_rot), _sin = Math.sin(_rot);
            const ldx = dx * _cos + dy * _sin;   // delta along element's local X axis
            const ldy = -dx * _sin + dy * _cos;  // delta along element's local Y axis

            if (dragMode.includes("r")) obj.w = Math.max(60, ow + ldx);
            if (dragMode.includes("b")) obj.h = Math.max(60, oh + ldy);
            if (dragMode.includes("l")) {
              const nextW = Math.max(60, ow - ldx);
              const diff = ow - nextW;
              // The left edge moves in the element's local -X direction; convert to parent space
              obj.x = ox + diff * _cos;
              obj.y = oy + diff * _sin;
              obj.w = nextW;
            }
            if (dragMode.includes("t")) {
              const nextH = Math.max(60, oh - ldy);
              const diff = oh - nextH;
              // The top edge moves in the element's local -Y direction; convert to parent space
              obj.x = ox - diff * _sin;
              obj.y = oy + diff * _cos;
              obj.h = nextH;
            }
            _dmbResizeSnap(obj, container, { targetType, pageNumber }, dragMode);
            frame.style.left = `${obj.x}px`;
            frame.style.top = `${obj.y}px`;
            frame.style.width = `${obj.w}px`;
            frame.style.height = `${obj.h}px`;
            if (obj.coverZone) dmbApplyZoneClip(frame, obj);
            showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          };
          const onUp = () => {
            dragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Resize Frame");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, frame);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });
      });

      container.appendChild(frame);
    });
  }
  // --- end frame rendering helpers ---

  // Holder so the PDF/preview export path can run the SAME cover-text box capture
  // that renderCoverCanvas defines (it's a closure local to renderCoverCanvas).
  // Forcing a fresh synchronous capture right before a cover export guarantees the
  // stored visCx/visCy/glyphCx/glyphCy/boxWidth reflect the CURRENT orientation, so
  // the PDF's live-mirror + glyph paths never fall back to stale (e.g. portrait)
  // geometry after a Portrait/Landscape flip. (Single source of truth — no duped
  // measurement logic.) See _dmbCaptureCoverTextBoxesFn() call in renderCoverSpread.
  let _dmbCaptureCoverTextBoxesFn = null;

  function renderCoverCanvas() {
    // Remember WHICH VIEW this is. The snapshot already carries editor.currentSpread
    // and builderMode, but nothing was saving on NAVIGATION - every _dmbAutoPersist
    // call sat on an edit path. So a refresh returned the customer to wherever they
    // last TYPED rather than wherever they were looking, which on a long book means a
    // completely different spread, or the cover. Debounced at 600ms, and
    // _dmbWriteProgressState ignores an empty editor, so this cannot overwrite good
    // state with a half-built one during a restore. (2026-10-12)
    try { _dmbAutoPersist(); } catch (e) {}
    if (!spreadCanvas || !spreadIndexEl) return;
    // Migrate any fixed-slot cover layout (frontLayout/backLayout) into deletable free
    // photo-frames. The %→px math matches where the locked slots drew, so this is
    // visually lossless; it just makes template/layout frames selectable + deletable.
    // No-op once converted (frontLayout/backLayout become null). Idempotent + cheap.
    try { _dmbConvertCoverFixedLayouts(); } catch (e) {}

    // Magazine: seed ONE typical (deletable / movable / resizable) free photo frame on
    // the FRONT cover — once — in place of the old locked full-face grey slot. Only when
    // the front has no full-bleed photo and no front frame yet; the persisted
    // coverState.magFrontFrameSeeded flag stops it coming back after the user deletes it.
    try {
      if (window.DMB_MAGAZINE_MODE && !_dmbRenderMode() && !coverState.magFrontFrameSeeded) {
        coverState.magFrontFrameSeeded = true;
        var _mcArr = ensureCoverObjects();
        var _hasFrontFrame = _mcArr.some(function (o) { return o && o.type === "photo-frame" && o.coverZone === "front"; });
        if (!coverState.frontImageUrl && !_hasFrontFrame) {
          var _mf = newFrameObject({ targetType: "cover" });
          _mf.coverZone = "front";
          // px in the full-spread space; magazine front face spans x 300..600, y 0..424.
          // Centred frame with a ~33px / ~44px margin so the background shows around it.
          _mf.x = 333; _mf.y = 44; _mf.w = 234; _mf.h = 336;
          _mcArr.push(_mf);
        }
        try { saveCoverDesignToStorage(); } catch (e) {}
        try { _dmbWriteProgressState(); } catch (e) {}
        try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
      }
    } catch (e) {}

    // Reset the viewport to fit the cover (clears any stale fixed height left over
    // from a spread's forceSpreadLayout — otherwise the cover shows empty space below it).
    if (spreadViewport) {
      spreadViewport.style.height = "auto";
      spreadViewport.style.minHeight = "0";
      spreadViewport.style.maxHeight = "760px";
    }
    // Remove orphaned fixed-position rotation handles before re-render
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    // Cover is the first view: nothing before it, Spread 0 comes next.
    if (prevSpreadBtn) prevSpreadBtn.disabled = true;
    if (nextSpreadBtn) nextSpreadBtn.disabled = editor.totalSpreads <= 0;
    // Mark cover dirty so PDF preview re-renders after this change (2s debounce)
    _dmbPvMarkDirty("cover");

    spreadCanvas.innerHTML = "";

    const wrap = document.createElement("div");
    wrap.className = "dmb-cover-preview";
    // Landscape: widen the cover faces (CSS flips the face aspect ratio). Elements
    // carry over (colours/fonts/text) but positions are approximate — the owner
    // rearranges and re-publishes the landscape (-ls) template.
    if (dmbIsLandscape()) wrap.classList.add("dmb-cover-landscape");

    const back = document.createElement("div");
    back.className = "dmb-cover-face dmb-cover-back";
    back.id = "coverBack";
    back.style.cursor = "pointer";
    if (coverState.backImageUrl) {
      back.style.background = coverState.color || "#ffffff";
      back.style.overflow = "hidden";
      const _backImgDiv = document.createElement("div");
      _backImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.backImageUrl}) center/cover no-repeat;transform:rotate(${coverState.backImageRot||0}deg);transform-origin:center center;z-index:0;pointer-events:none;`;
      back.appendChild(_backImgDiv);
      // Control buttons (X, rotate, crop, frames) — same style as page photos
      const _bRm = document.createElement("button");
      _bRm.type="button"; _bRm.setAttribute("aria-label","Remove photo"); _bRm.title="Remove photo";
      _bRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      _bRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); coverState.backImageUrl=""; coverState.backImageId=""; coverState.backImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
      back.appendChild(_bRm);
      const _bRot = document.createElement("button");
      _bRot.type="button"; _bRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _bRot.title="Rotate 90° anti-clockwise";
      _bRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      _bRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); coverState.backImageRot=((coverState.backImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
      back.appendChild(_bRot);
      const _bCrop = document.createElement("button");
      _bCrop.type="button"; _bCrop.setAttribute("aria-label","Crop photo"); _bCrop.title="Crop photo";
      _bCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
      _bCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.backImageId) openCropModal(coverState.backImageId, { get:()=>coverState.backImageId, set:(id)=>{ coverState.backImageId=id; coverState.backImageUrl=getPhotoById(id)?.url||""; } }); });
      back.appendChild(_bCrop);
      const _bFrame = document.createElement("button");
      _bFrame.type="button"; _bFrame.setAttribute("aria-label","Frame shape"); _bFrame.title="Frame shape";
      _bFrame.innerHTML=`<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      _bFrame.style.cssText="position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); showDmbFramePicker(_bFrame, coverState.backImageFrameShape||"", (shapeId)=>{ pushUndoState("Frame Shape"); coverState.backImageFrameShape=shapeId; applyDmbFrameShape(_backImgDiv, shapeId); saveCoverDesignToStorage(); }); });
      back.appendChild(_bFrame);
    } else {
      // Magazines used to show a locked full-face grey "Drop photo here" slot here
      // (hid the background, not deletable). Now books AND magazines just show the
      // background colour; photos go into the typical free frame (seeded below) or
      // onto the face by dropping directly.
      back.style.background = coverState.color || "#ffffff";
    }
    back.addEventListener("click", (e) => {
      e.stopPropagation();
      activeCoverZone = "back";
      if (typeof markActiveCoverZone === "function") markActiveCoverZone();
      if (typeof hideTextToolbar === "function") hideTextToolbar();
    });
    back.addEventListener("dragover", (e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; back.style.outline = "2px solid #111"; back.style.outlineOffset = "-2px"; });
    back.addEventListener("dragleave", () => { back.style.outline = "none"; });
    back.addEventListener("drop", (e) => {
      e.preventDefault(); back.style.outline = "none";
      const payload = getDragPayload(e);
      const photoId = payload?.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
      if (!photoId) return;
      const photo = getPhotoById(photoId);
      if (!photo) return;
      pushUndoState("Drop Photo On Cover Back");
      coverState.backImageUrl = photo.url;
      coverState.backImageId = photoId;
      coverState.backImageRot = 0;
      saveCoverDesignToStorage();
      renderCoverCanvas();
    });


    let spine = null;
    if (!window.DMB_MAGAZINE_MODE) {
      spine = document.createElement("div");
      spine.className = "dmb-cover-spine";
      spine.style.background = coverState.color || "#ffffff";
      spine.id = "coverSpine";
      spine.style.cursor = "pointer";
      // Hide internal seam borders when a bleed photo covers those junctions
      if (coverState.bleedZone === "full" || coverState.bleedZone === "spine-back")  spine.style.borderLeft  = "none";
      if (coverState.bleedZone === "full" || coverState.bleedZone === "front-spine") spine.style.borderRight = "none";
      if (coverState.spineImageUrl) {
        const _spineImgDiv = document.createElement("div");
        _spineImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.spineImageUrl}) center/cover no-repeat;z-index:0;pointer-events:none;`;
        spine.appendChild(_spineImgDiv);
      }
      spine.addEventListener("click", (e) => {
        e.stopPropagation();
        activeCoverZone = "spine";
        if (typeof markActiveCoverZone === "function") markActiveCoverZone();
        if (typeof hideTextToolbar === "function") hideTextToolbar();
      });
    }


    const front = document.createElement("div");
    front.className = "dmb-cover-face dmb-cover-front";
    front.id = "coverFront";
    front.style.cursor = "pointer";
    if (coverState.frontImageUrl) {
      front.style.background = coverState.color || "#ffffff";
      front.style.overflow = "hidden";
      const _frontImgDiv = document.createElement("div");
      _frontImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.frontImageUrl}) center/cover no-repeat;transform:rotate(${coverState.frontImageRot||0}deg);transform-origin:center center;z-index:0;pointer-events:none;`;
      front.appendChild(_frontImgDiv);
      // Control buttons (X, rotate, crop, frames) — same style as page photos
      const _fRm = document.createElement("button");
      _fRm.type="button"; _fRm.setAttribute("aria-label","Remove photo"); _fRm.title="Remove photo";
      _fRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      _fRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); coverState.frontImageUrl=""; coverState.frontImageId=""; coverState.frontImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
      front.appendChild(_fRm);
      const _fRot = document.createElement("button");
      _fRot.type="button"; _fRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _fRot.title="Rotate 90° anti-clockwise";
      _fRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      _fRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); coverState.frontImageRot=((coverState.frontImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
      front.appendChild(_fRot);
      const _fCrop = document.createElement("button");
      _fCrop.type="button"; _fCrop.setAttribute("aria-label","Crop photo"); _fCrop.title="Crop photo";
      _fCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
      _fCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.frontImageId) openCropModal(coverState.frontImageId, { get:()=>coverState.frontImageId, set:(id)=>{ coverState.frontImageId=id; coverState.frontImageUrl=getPhotoById(id)?.url||""; } }); });
      front.appendChild(_fCrop);
      const _fFrame = document.createElement("button");
      _fFrame.type="button"; _fFrame.setAttribute("aria-label","Frame shape"); _fFrame.title="Frame shape";
      _fFrame.innerHTML=`<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      _fFrame.style.cssText="position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); showDmbFramePicker(_fFrame, coverState.frontImageFrameShape||"", (shapeId)=>{ pushUndoState("Frame Shape"); coverState.frontImageFrameShape=shapeId; applyDmbFrameShape(_frontImgDiv, shapeId); saveCoverDesignToStorage(); }); });
      front.appendChild(_fFrame);
    } else {
      // (Magazine grey full-face slot removed — see the back face above.) Front shows
      // the background colour; the default free photo frame is seeded in coverObjects.
      front.style.background = coverState.color || "#ffffff";
    }
    front.addEventListener("click", (e) => {
      e.stopPropagation();
      activeCoverZone = "front";
      if (typeof markActiveCoverZone === "function") markActiveCoverZone();
      if (typeof hideTextToolbar === "function") hideTextToolbar();
    });
    front.addEventListener("dragover", (e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; front.style.outline = "2px solid #111"; front.style.outlineOffset = "-2px"; });
    front.addEventListener("dragleave", () => { front.style.outline = "none"; });
    front.addEventListener("drop", (e) => {
      e.preventDefault(); front.style.outline = "none";
      const payload = getDragPayload(e);
      const photoId = payload?.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
      if (!photoId) return;
      const photo = getPhotoById(photoId);
      if (!photo) return;
      pushUndoState("Drop Photo On Cover Front");
      coverState.frontImageUrl = photo.url;
      coverState.frontImageId = photoId;
      coverState.frontImageRot = 0;
      saveCoverDesignToStorage();
      renderCoverCanvas();
    });


    const overlay = document.createElement("div");
    overlay.id = "coverOverlay";
    overlay.className = "dmb-cover-overlay";
    overlay.style.zIndex = "9999";

    wrap.appendChild(back);
    if (spine) wrap.appendChild(spine);
    wrap.appendChild(front);
    wrap.appendChild(overlay);

    // ── Builder-only "Front" / "Back" face labels ──────────────────────────────
    // A small caption directly UNDER each cover face so the customer can tell which
    // face is the front and which is the back (books AND magazines; the spine gets
    // nothing). Hung off the WRAP (already position:relative), NOT the faces — a face
    // with a photo sets overflow:hidden and would clip a label placed inside it.
    // Pure UI: pointer-events:none, absolutely positioned so it changes no dimension,
    // never in the PDF (export uses renderCoverSpread, not this DOM), skipped in render
    // mode and hidden in the order-preview modal via CSS.
    if (!_dmbRenderMode()) {
      var _tagFaceW  = 300;                                 // matches .dmb-cover-face width
      var _tagSpineW = window.DMB_MAGAZINE_MODE ? 0 : 11;   // matches .dmb-cover-spine width
      [["Back", 0], ["Front", _tagFaceW + _tagSpineW]].forEach(function (p) {
        var tag = document.createElement("div");
        tag.className = "dmb-cover-face-tag";
        tag.textContent = p[0];
        tag.setAttribute("aria-hidden", "true");
        tag.style.left = p[1] + "px";
        tag.style.width = _tagFaceW + "px";
        wrap.appendChild(tag);
      });
    }

    // ── SAFE-ZONE GUIDE LINES ──────────────────────────────────────────────
    // Add two vertical dashed guide lines (14px from left/right edge) to each
    // cover face: back, spine, and front.  They show ONLY while an object is
    // being dragged (class dmb-cover-guides-on on the wrap) and disappear on
    // pointerup.  Guides are purely visual (pointer-events:none) — the customer
    // can place objects outside them if they wish.
    //
    // WARNING: Do NOT add these to the overlay — they belong inside each face
    // so they appear behind dragged objects (overlay z:9999) and serve as a
    // passive reference, never blocking interaction.
    (function _addCoverSafeGuides() {
      function addGuidesToFace(faceEl) {
        ["left", "right"].forEach(function(side) {
          var g = document.createElement("div");
          g.className = "dmb-cover-safe-guide dmb-cover-safe-guide-" + side;
          g.setAttribute("aria-hidden", "true");
          faceEl.appendChild(g);
        });
      }
      addGuidesToFace(back);
      if (spine) addGuidesToFace(spine);
      addGuidesToFace(front);

      // Show guides on any pointerdown inside the cover preview.
      // Capture phase so we catch events on deeply nested children (objects
      // in the overlay) before they stop propagation.
      wrap.addEventListener("pointerdown", function() {
        wrap.classList.add("dmb-cover-guides-on");
      }, { capture: true });

      // Global pointerup hides guides on all cover previews.
      // Guard with a flag so we only add this listener once per page load
      // (renderCoverCanvas is called on every state change — without the guard
      //  we would accumulate identical listeners).
      if (!window._dmbCoverGuideHideWired) {
        window._dmbCoverGuideHideWired = true;
        document.addEventListener("pointerup", function() {
          document.querySelectorAll(".dmb-cover-preview.dmb-cover-guides-on")
            .forEach(function(w) { w.classList.remove("dmb-cover-guides-on"); });
        });
      }
    })();
    // ── end safe-zone guides ───────────────────────────────────────────────

    // ── Cover drag overlay (same style as spread drop overlay) ──
    const coverDragOverlay = document.createElement("div");
    coverDragOverlay.className = "dmb-cover-drag-overlay";

    function makeCoverZone(label) {
      const zone = document.createElement("div");
      zone.className = "dmb-cover-drop-zone";
      const lbl = document.createElement("div");
      lbl.className = "dmb-cover-zone-label";
      lbl.textContent = label;
      zone.appendChild(lbl);
      return zone;
    }

    let coverDropZones;
    if (window.DMB_MAGAZINE_MODE) {
      const zBack  = makeCoverZone("Back");
      const zFront = makeCoverZone("Front");
      coverDragOverlay.appendChild(zBack);
      coverDragOverlay.appendChild(zFront);
      coverDropZones = [
        { el: zBack,  targets: ["back"] },
        { el: zFront, targets: ["front"] }
      ];
    } else {
      const zBack       = makeCoverZone("Back");
      const zBackSpine  = makeCoverZone("Back + Spine");
      const zFull       = makeCoverZone("Full cover");
      const zSpineFront = makeCoverZone("Spine + Front");
      const zFront      = makeCoverZone("Front");
      coverDragOverlay.appendChild(zBack);
      coverDragOverlay.appendChild(zBackSpine);
      coverDragOverlay.appendChild(zFull);
      coverDragOverlay.appendChild(zSpineFront);
      coverDragOverlay.appendChild(zFront);
      coverDropZones = [
        { el: zBack,       targets: ["back"] },
        { el: zBackSpine,  targets: ["back", "spine"] },
        { el: zFull,       targets: ["back", "spine", "front"] },
        { el: zSpineFront, targets: ["spine", "front"] },
        { el: zFront,      targets: ["front"] }
      ];
    }

    wrap.appendChild(coverDragOverlay);

    let coverWrapEnter = 0;
    wrap.addEventListener("dragenter", (e) => {
      if (!getDragPayload(e)) return;
      coverWrapEnter++;
      coverDragOverlay.classList.add("active");
    });
    wrap.addEventListener("dragleave", (e) => {
      if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
      if (--coverWrapEnter <= 0) { coverWrapEnter = 0; coverDragOverlay.classList.remove("active"); }
    });
    wrap.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });

    // Peek at the element underneath the cover drag overlay at screen position (cx,cy).
    // We briefly hide the overlay so elementFromPoint sees what's beneath it.
    function _elementUnderOverlay(cx, cy) {
      const saved = coverDragOverlay.style.display;
      coverDragOverlay.style.display = "none";
      const el = document.elementFromPoint(cx, cy);
      coverDragOverlay.style.display = saved;
      return el;
    }

    // Return the nearest cover photo-frame DOM element at screen point, or null.
    function _coverFrameElAtPoint(cx, cy) {
      const under = _elementUnderOverlay(cx, cy);
      if (!under) return null;
      // Free photo-frame (in overlay)
      const free = under.closest(".dmb-photo-frame-object");
      if (free) return free;
      // Layout frame (direct child of front/back face with data-cover-frame-key)
      const layout = under.closest("[data-cover-frame-key]");
      if (layout) return layout;
      return null;
    }

    function _clearCoverFrameHover() {
      document.querySelectorAll(".dmb-cover-frame-dragover")
        .forEach(f => f.classList.remove("dmb-cover-frame-dragover"));
    }

    coverDropZones.forEach(({ el, targets }) => {
      let zc = 0;
      el._pendingCoverFrame = null;

      el.addEventListener("dragenter", (e) => {
        e.preventDefault(); e.stopPropagation();
        if (++zc > 0) el.classList.add("drag-over");
      });
      el.addEventListener("dragleave", () => {
        if (--zc <= 0) { zc = 0; el.classList.remove("drag-over"); }
        _clearCoverFrameHover();
        el._pendingCoverFrame = null;
      });
      el.addEventListener("dragover", (e) => {
        e.preventDefault(); e.stopPropagation();
        // Peek under overlay to find frames and show black-border highlight
        const frameEl = _coverFrameElAtPoint(e.clientX, e.clientY);
        _clearCoverFrameHover();
        if (frameEl) { frameEl.classList.add("dmb-cover-frame-dragover"); }
        el._pendingCoverFrame = frameEl || null;
      });
      el.addEventListener("drop", (e) => {
        e.preventDefault(); e.stopPropagation();
        _clearCoverFrameHover();
        coverWrapEnter = 0; coverDragOverlay.classList.remove("active"); el.classList.remove("drag-over");
        const payload = getDragPayload(e);
        if (!payload) return;
        const photoId = payload.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
        if (!photoId) return;
        const photo = getPhotoById(photoId);
        if (!photo) return;

        // ── Route to frame if cursor was over one ────────────────────────────
        const frameEl = el._pendingCoverFrame || _coverFrameElAtPoint(e.clientX, e.clientY);
        el._pendingCoverFrame = null;
        if (frameEl) {
          // Free photo-frame (stored in editor.coverObjects)
          if (frameEl.dataset.objectId) {
            const obj = (editor.coverObjects || []).find(o => o.id === frameEl.dataset.objectId);
            if (obj) {
              pushUndoState("Drop Photo In Cover Frame");
              obj.photoId = photoId;
              saveCoverDesignToStorage();
              renderCoverCanvas(); renderThumbsRail(); renderPhotoTray();
              return;
            }
          }
          // Layout frame (coverState.frontFrames / backFrames)
          if (frameEl.dataset.coverFrameKey) {
            const fZone = frameEl.dataset.coverZone || "front";
            const fKey  = frameEl.dataset.coverFrameKey;
            pushUndoState("Drop Photo In Cover Layout Frame");
            if (fZone === "front") { if (!coverState.frontFrames) coverState.frontFrames = {}; coverState.frontFrames[fKey] = photoId; }
            else                   { if (!coverState.backFrames)  coverState.backFrames  = {}; coverState.backFrames[fKey]  = photoId; }
            saveCoverDesignToStorage();
            renderCoverCanvas(); renderThumbsRail(); renderPhotoTray();
            return;
          }
        }

        // ── Zone drop (original logic) ────────────────────────────────────────
        pushUndoState("Drop Photo On Cover");
        if (targets.length > 1) {
          // Multi-zone: seamless bleed image
          if (targets.includes("front")) { coverState.frontImageUrl = ""; coverState.frontImageId = ""; coverState.frontImageRot = 0; }
          if (targets.includes("back"))  { coverState.backImageUrl  = ""; coverState.backImageId  = ""; coverState.backImageRot  = 0; }
          coverState.spineImageUrl = "";
          coverState.bleedImageUrl = photo.url;
          coverState.bleedImageId  = photoId;
          coverState.bleedImageRot = 0;
          coverState.bleedZone     = targets.includes("back") && targets.includes("front") ? "full"
                                   : targets.includes("back") ? "spine-back" : "front-spine";
        } else {
          // Single zone: individual face image, clear any bleed that covers it
          if (targets.includes("front")) {
            coverState.frontImageUrl = photo.url; coverState.frontImageId = photoId; coverState.frontImageRot = 0;
            if (coverState.bleedZone === "front-spine" || coverState.bleedZone === "full") { coverState.bleedImageUrl = ""; coverState.bleedImageId = ""; coverState.bleedZone = ""; coverState.bleedImageRot = 0; }
          }
          if (targets.includes("back")) {
            coverState.backImageUrl = photo.url; coverState.backImageId = photoId; coverState.backImageRot = 0;
            if (coverState.bleedZone === "spine-back" || coverState.bleedZone === "full") { coverState.bleedImageUrl = ""; coverState.bleedImageId = ""; coverState.bleedZone = ""; coverState.bleedImageRot = 0; }
          }
        }
        saveCoverDesignToStorage();
        renderCoverCanvas();
        renderThumbsRail();
        renderPhotoTray();
      });
    });

    spreadCanvas.appendChild(wrap);

    // Fit the cover (incl. its Front/Back labels) into the canvas height so there is
    // no vertical scroll. Desktop only; re-fits on window resize.
    if (!window._dmbCoverFitResizeWired) {
      window._dmbCoverFitResizeWired = true;
      window.addEventListener("resize", function () {
        if (builderMode === "cover") requestAnimationFrame(_dmbFitCoverIntoView);
      });
    }
    requestAnimationFrame(_dmbFitCoverIntoView);

    // Render photo grid layout frames inside each face (clipped to face bounds)
    function renderCoverFaceFrames(faceEl, zone) {
      const layoutId = zone === "front" ? coverState.frontLayout : coverState.backLayout;
      if (!layoutId) return;
      const defs   = TEMPLATE_DEFS[layoutId] || [];
      const frames = zone === "front" ? coverState.frontFrames : coverState.backFrames;
      faceEl.style.overflow = "hidden";
      defs.forEach((f) => {
        const fw = document.createElement("div");
        fw.style.cssText = `position:absolute;left:${f.x}%;top:${f.y}%;width:${f.w}%;height:${f.h}%;border:1px solid #eee;background:#f5f5f5;overflow:hidden;z-index:2;box-sizing:border-box;`;
        fw.dataset.coverZone = zone;
        fw.dataset.coverFrameKey = f.key;
        const pid = frames[f.key] || null;
        if (!pid) {
          const hint = document.createElement("div");
          hint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;pointer-events:none;background:rgba(220,220,220,0.55);border:1.5px dashed #ccc;border-radius:2px;";
          hint.innerHTML = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="#c0c0c0" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="#bbb" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="#bbb" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:8px;font-weight:900;color:#bbb;letter-spacing:0.4px;text-transform:uppercase;">Drop photo</span>`;
          fw.appendChild(hint);
        } else {
          const photo = getPhotoById(pid);
          if (photo) {
            const frameRots = zone === "front" ? coverState.frontFrameRot : coverState.backFrameRot;
            const frameShapes = zone === "front" ? coverState.frontFrameShapes : coverState.backFrameShapes;
            const frameRot = frameRots[f.key] || 0;
            const frameShape = frameShapes[f.key] || "";
            const img = document.createElement("img");
            _dmbBindPhotoImg(img, photo);
            img.draggable = false;
            img.style.cssText = `position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;transform:rotate(${frameRot}deg);transform-origin:center center;`;
            if (frameShape) applyDmbFrameShape(img, frameShape);
            fw.appendChild(img);
            // Control buttons — X, rotate, crop, frames
            const _lRm = document.createElement("button");
            _lRm.type="button"; _lRm.setAttribute("aria-label","Remove photo"); _lRm.title="Remove photo";
            _lRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
            _lRm.style.cssText="position:absolute;top:4px;right:4px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); if(zone==="front") coverState.frontFrames[f.key]=null; else coverState.backFrames[f.key]=null; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
            fw.appendChild(_lRm);
            const _lRot = document.createElement("button");
            _lRot.type="button"; _lRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _lRot.title="Rotate 90° anti-clockwise";
            _lRot.innerHTML=`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            _lRot.style.cssText="position:absolute;top:4px;right:32px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); const rots = zone==="front"?coverState.frontFrameRot:coverState.backFrameRot; rots[f.key]=((rots[f.key]||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
            fw.appendChild(_lRot);
            const _lCrop = document.createElement("button");
            _lCrop.type="button"; _lCrop.setAttribute("aria-label","Crop photo"); _lCrop.title="Crop photo";
            _lCrop.innerHTML=`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
            _lCrop.style.cssText="position:absolute;top:4px;right:60px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); openCropModal(pid, { get:()=>{ const m=zone==="front"?coverState.frontFrames:coverState.backFrames; return m[f.key]; }, set:(id)=>{ const m=zone==="front"?coverState.frontFrames:coverState.backFrames; m[f.key]=id; } }); });
            fw.appendChild(_lCrop);
            const _lFrame = document.createElement("button");
            _lFrame.type="button"; _lFrame.setAttribute("aria-label","Frame shape"); _lFrame.title="Frame shape";
            _lFrame.innerHTML=`<svg viewBox="0 0 22 22" width="12" height="12" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
            _lFrame.style.cssText="position:absolute;top:4px;right:88px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); const shapes = zone==="front"?coverState.frontFrameShapes:coverState.backFrameShapes; showDmbFramePicker(_lFrame, shapes[f.key]||"", (shapeId)=>{ pushUndoState("Frame Shape"); shapes[f.key]=shapeId; applyDmbFrameShape(img, shapeId); saveCoverDesignToStorage(); }); });
            fw.appendChild(_lFrame);
          }
        }
        fw.addEventListener("dragover", (e) => {
          e.preventDefault(); e.stopPropagation();
          e.dataTransfer.dropEffect = "copy";
          fw.style.outline = "2px solid #111"; fw.style.outlineOffset = "-2px";
        });
        fw.addEventListener("dragleave", () => { fw.style.outline = "none"; });
        fw.addEventListener("drop", (e) => {
          e.preventDefault(); e.stopPropagation();
          fw.style.outline = "none";
          const payload = getDragPayload(e);
          const photoId = (payload?.photoId) || ((e.dataTransfer.getData("text/plain") || "").trim());
          if (!photoId) return;
          pushUndoState("Drop Photo In Cover Frame");
          if (zone === "front") coverState.frontFrames[f.key] = photoId;
          else coverState.backFrames[f.key] = photoId;
          saveCoverDesignToStorage();
          renderCoverCanvas();
        });
        faceEl.appendChild(fw);
      });
    }
    renderCoverFaceFrames(back, "back");
    renderCoverFaceFrames(front, "front");

    // ── Seamless bleed image (spans back+spine+front or a subset) ──
    if (coverState.bleedImageUrl && coverState.bleedZone) {
      const _bleedZoneMap = {
        "spine-back":  { x: 0,              w: COVER_BACK_W + COVER_SPINE_W },
        "full":        { x: 0,              w: COVER_BACK_W + COVER_SPINE_W + 300 },
        "front-spine": { x: COVER_BACK_W,   w: COVER_SPINE_W + 300 }
      };
      const _bz = _bleedZoneMap[coverState.bleedZone];
      if (_bz) {
        const bleedWrap = document.createElement("div");
        // Extend 1px beyond each covered edge to absorb border seams
        const _bleedLeft = _bz.x > 0 ? _bz.x - 1 : 0;
        const _bleedW    = _bz.x > 0 ? _bz.w + 2 : _bz.w + 1;
        bleedWrap.style.cssText = `position:absolute;left:${_bleedLeft}px;top:0;width:${_bleedW}px;height:100%;overflow:hidden;z-index:5;`;
        const bleedImg = document.createElement("div");
        bleedImg.style.cssText = `position:absolute;inset:0;background:url(${coverState.bleedImageUrl}) center/cover no-repeat;transform:rotate(${coverState.bleedImageRot||0}deg);transform-origin:center center;pointer-events:none;`;
        bleedWrap.appendChild(bleedImg);
        // Control buttons — top-right of the bleed wrap (left/back corner side)
        const _blRm = document.createElement("button");
        _blRm.type="button"; _blRm.setAttribute("aria-label","Remove photo"); _blRm.title="Remove photo";
        _blRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
        _blRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Bleed Photo"); coverState.bleedImageUrl=""; coverState.bleedImageId=""; coverState.bleedZone=""; coverState.bleedImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
        bleedWrap.appendChild(_blRm);
        const _blRot = document.createElement("button");
        _blRot.type="button"; _blRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _blRot.title="Rotate 90° anti-clockwise";
        _blRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        _blRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Bleed Photo"); coverState.bleedImageRot=((coverState.bleedImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
        bleedWrap.appendChild(_blRot);
        const _blCrop = document.createElement("button");
        _blCrop.type="button"; _blCrop.setAttribute("aria-label","Crop photo"); _blCrop.title="Crop photo";
        _blCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
        _blCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.bleedImageId) openCropModal(coverState.bleedImageId, { get:()=>coverState.bleedImageId, set:(id)=>{ coverState.bleedImageId=id; coverState.bleedImageUrl=getPhotoById(id)?.url||""; } }); });
        bleedWrap.appendChild(_blCrop);
        wrap.insertBefore(bleedWrap, overlay);
      }
    }

    renderFreeFrameObjects(overlay, { targetType: "cover" });

    // Re-create user-added text nodes (survive re-renders via editor.coverUserTexts)
    // All user texts live in the overlay so they drag seamlessly across back/spine/front
    if (Array.isArray(editor.coverUserTexts)) {
      const _magFrontX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      const zoneOffsets = { back: 40, spine: COVER_BACK_W + 5, front: _magFrontX + 40 };
      editor.coverUserTexts.forEach(({ id, zone }) => {
        const saved = coverState.textStyles && coverState.textStyles[id];
        const utxt = document.createElement("div");
        utxt.id = id;
        utxt.contentEditable = "true";
        utxt.classList.add("dmb-editable-text");
        utxt.style.position = "absolute";
        utxt.style.minWidth = "120px";
        utxt.style.padding = "2px 6px";
        utxt.style.background = "transparent";
        utxt.style.outline = "none";
        utxt.style.fontSize = saved?.fontSize || "28px";
        utxt.style.fontWeight = "800";
        utxt.style.color = saved?.color || "#666";
        utxt.style.fontFamily = saved?.fontFamily || "'Londrina Solid', sans-serif";
        utxt.style.left = saved?.left || (zoneOffsets[zone] ?? (_magFrontX + 40)) + "px";
        // `top` is stored canonical (portrait face). Scale to the current face so
        // landscape cover text sits INSIDE the shorter face instead of hanging off
        // below it. Portrait scale = 1 → identical.
        var _utTopRaw = saved?.top || "40px";
        var _utTopNum = parseFloat(_utTopRaw);
        utxt.style.top = (isFinite(_utTopNum) && !String(_utTopRaw).endsWith("%"))
          ? ((_utTopNum * _dmbCoverTopScale()) + "px") : _utTopRaw;
        // ── Cross-device lock ────────────────────────────────────────────────
        // Pin the box to its design-time width so a ROTATED text pivots around the
        // exact same centre on every device. Without this the box auto-sizes to the
        // text, and the same font measures a few px differently on iOS vs laptop,
        // shifting rotated text on iPad/phone. boxWidth is the laptop-measured width,
        // so the laptop is unchanged and the iPad/phone now match it.
        if (saved?.boxWidth && parseFloat(saved.boxWidth) > 0) {
          utxt.style.width = saved.boxWidth + "px";
        } else if (saved?.width) {
          utxt.style.width = saved.width;
        }
        // An explicit width outranks the 120px new-box minimum set above, otherwise a
        // cover box narrowed with the side grip snapped back wide on re-render.
        if (utxt.style.width) utxt.style.minWidth = "0";
        // Ensure z is always persisted — if not saved yet, assign one now so
        // the PDF render uses the same value as the builder DOM.
        if (!saved?.z) {
          const _newZ = String(Date.now());
          if (!coverState.textStyles) coverState.textStyles = {};
          if (!coverState.textStyles[id]) coverState.textStyles[id] = {};
          coverState.textStyles[id].z = _newZ;
        }
        utxt.dataset.z = coverState.textStyles?.[id]?.z || String(Date.now());
        utxt.style.zIndex = utxt.dataset.z;
        if (saved?.textAlign) utxt.style.textAlign = saved.textAlign;
        if (saved?.textDecoration) utxt.style.textDecoration = saved.textDecoration;
        if (saved?.whiteSpace) utxt.style.whiteSpace = saved.whiteSpace;
        // In landscape, uniformly shrink the text (font + box) by the same factor
        // as the vertical position, so the composition keeps the SAME proportions
        // it had on the taller portrait cover — just fitted. Display-only: stored
        // fontSize/width stay canonical (no save drift). transform-origin top-left
        // keeps the element anchored at its (scaled) top-left position.
        if (saved?.transform) utxt.style.transform = saved.transform;
        if (saved?.rotate) utxt.dataset.rotate = saved.rotate;
        utxt.textContent = saved?.text || "";
        if (saved?.rich) { try { _dmbApplyRich(utxt, saved.rich); } catch (eR) {} }
        utxt.dataset.placeholder = "Type here";
        attachTextNodeHandlers(utxt);
        // Sync to panel when text is edited directly on the cover
        utxt.addEventListener("input", () => {
          const panelInput = document.querySelector(`#dmbCoverTextList input[data-text-id="${id}"]`);
          if (panelInput) panelInput.value = utxt.textContent;
        });
        overlay.appendChild(utxt);  // overlay spans full cover — seamless drag
      });
    }

    // Logo watermark — appended to overlay last so it always renders above stickers/maps/texts
    if (window.DMB_LOGO_URL) {
      const logoImg = document.createElement("img");
      logoImg.className = "dmb-logo-watermark";
      logoImg.src = window.DMB_LOGO_URL;
      const _logoLeft = COVER_BACK_W - Math.round(COVER_BACK_W * 0.06) - 90;
      const _logoZ = Math.max(
        ...(editor.coverObjects || []).map(function(o) { return Number(o.z) || 0; }),
        ...(editor.coverUserTexts || []).map(function(u) { var s = coverState.textStyles && coverState.textStyles[u.id]; return s ? (Number(s.z) || 0) : 0; }),
        99999
      ) + 1;
      logoImg.style.cssText = "position:absolute;bottom:6%;left:" + _logoLeft + "px;width:90px;opacity:0.85;pointer-events:none;display:block;z-index:" + _logoZ + ";";
      overlay.appendChild(logoImg);
    }

    if (typeof renderCoverTextList === "function") renderCoverTextList();

    if (typeof markActiveCoverZone === "function") {
      markActiveCoverZone();
    }

    // ── Capture the EXACT rendered box size for every cover text node ────────
    // The PDF uses boxWidth/boxHeight to compute the rotation pivot
    // (center = left + boxWidth/2). It MUST equal the browser's real
    // offsetWidth/Height or rotated text lands in the wrong place.
    //
    // FIX: always OVERWRITE (do not skip when a value already exists) — templates
    // can ship a stale boxWidth (authored under different width semantics), and a
    // stale pivot slides rotated text in the PDF. Also re-measure AFTER fonts load,
    // because measuring with a fallback font gives the wrong width.
    const _captureCoverTextBoxes = () => {
      // RENDER MODE: never re-measure. The saved geometry was captured by the
      // CUSTOMER's own browser with this same code, so freezing it reproduces exactly
      // what they saw; re-measuring here would use the container's fonts and can move
      // a word wrap (a visible defect, not sub-pixel noise). &livetext=1 opts back in.
      // This guard must live HERE: renderCoverCanvas also schedules this capture via
      // requestAnimationFrame and document.fonts.ready, which the call-site guards miss.
      if (_dmbRenderMode() && !_dmbRenderLiveText()) return;
      if (!coverState.textStyles) return;
      const _ov = document.getElementById("coverOverlay");
      if (!_ov) return;
      const _ovr = _ov.getBoundingClientRect();
      // Actual on-screen scale of the overlay (handles the zoom transform).
      const _Z = (_ovr.width / (_ov.offsetWidth || 622)) || 1;
      // id → cover zone (front/spine/back) so we can special-case the spine.
      const _zoneById = {};
      (editor.coverUserTexts || []).forEach(t => { if (t && t.id) _zoneById[t.id] = t.zone; });
      let _changed = false;
      _ov.querySelectorAll(".dmb-editable-text").forEach(node => {
        if (!node.id || !coverState.textStyles[node.id]) return;
        const s = coverState.textStyles[node.id];
        if (!(node.offsetWidth > 0)) return;

        // Box AABB centre (= rotation centre) in cover-space px.
        const r = node.getBoundingClientRect();
        let nvx = ((r.left + r.width  / 2) - _ovr.left) / _Z;
        const nvy = ((r.top  + r.height / 2) - _ovr.top)  / _Z;

        // ── ROBUST GLYPH CENTRE ──────────────────────────────────────────────
        // The letters do NOT necessarily sit at the box centre (line-height /
        // vertical-align push them around inside the box). Measuring a Range on a
        // rotated node is unreliable in Safari, so: temporarily strip the rotation,
        // measure the real glyph box vs the element box (no repaint happens between
        // these synchronous reads), restore the rotation, then rotate the glyph's
        // offset and add it to the box centre. This yields the letters' TRUE centre.
        let gcx = nvx, gcy = nvy;
        try {
          const _tf = node.style.transform;
          node.style.transform = "none";
          const _ur = node.getBoundingClientRect();              // un-rotated box
          const _rng = document.createRange(); _rng.selectNodeContents(node);
          const _gr = _rng.getBoundingClientRect();              // un-rotated glyphs

          // ── Capture the browser's REAL line breaks for wrapped boxes ─────────
          // Boxes narrowed with the side grip wrap at word boundaries
          // (white-space:pre-wrap). The PDF used to RE-wrap with canvas
          // measurements, which can break at a different word than the builder
          // shows. Read the rendered lines here (word rects grouped by top, while
          // the node is un-rotated) and store them so the PDF reuses them 1:1.
          // Node is already un-rotated here (transform "none" above), so the shared
          // capture measures directly. One source of truth: _dmbCaptureRenderedLines.
          const _rlJson = _dmbCaptureRenderedLines(node, true);
          if (s.renderedLines !== _rlJson) _changed = true;
          s.renderedLines = _rlJson;   // "" when not wrapped → PDF falls back to \n split
          // Same measurement, run by run, for a box whose words carry their own
          // look. Only measured when there is something to measure.
          const _rrJson = s.rich ? _dmbCaptureLineRuns(node, true) : "";
          if (s.richLines !== _rrJson) _changed = true;
          s.richLines = _rrJson;

          node.style.transform = _tf;                            // restore (no paint between)
          if (_gr && _gr.width > 0 && _gr.height > 0) {
            const _gdx = ((_gr.left + _gr.width  / 2) - (_ur.left + _ur.width  / 2)) / _Z;
            const _gdy = ((_gr.top  + _gr.height / 2) - (_ur.top  + _ur.height / 2)) / _Z;
            // Effective rotation: dataset.rotate, or the rotate() inside the CSS
            // transform string. Spine/centred text keeps its rotation in the
            // transform (translate(-50%,-50%) rotate(-90deg)) with dataset.rotate=0,
            // so without this the glyph offset would rotate by the wrong angle.
            let _eff = parseFloat(node.dataset.rotate || "0") || 0;
            if (!_eff) {
              const _m = (_tf || "").match(/rotate\(\s*(-?[\d.]+)deg/);
              if (_m) _eff = parseFloat(_m[1]) || 0;
            }
            const _rad = _eff * Math.PI / 180;
            gcx = nvx + (_gdx * Math.cos(_rad) - _gdy * Math.sin(_rad));
            gcy = nvy + (_gdx * Math.sin(_rad) + _gdy * Math.cos(_rad));
          }
        } catch (e) {}

        // ── SPINE: keep the LETTERS horizontally centred on the spine ──────────
        // Centre on the glyph centre (gcx), NOT the box centre: for −90° spine text
        // the in-box line-height gap (smaller above the line than below) becomes a
        // HORIZONTAL offset once rotated, so centring the box leaves the letters
        // visibly off to one side. Shifting style.left by (spineCx − gcx) lands the
        // letters dead-centre. Vertical untouched. Books only — magazines have none.
        // "On the spine" = saved zone is spine OR the box centre sits in the strip
        // [COVER_BACK_W, COVER_BACK_W + COVER_SPINE_W] (catches dragged-on texts
        // whose stored zone was never updated).
        const _onSpine = !window.DMB_MAGAZINE_MODE &&
          (_zoneById[node.id] === "spine" ||
           (nvx >= COVER_BACK_W && nvx <= COVER_BACK_W + COVER_SPINE_W));
        if (_onSpine) {
          const _spineCx = COVER_BACK_W + COVER_SPINE_W / 2;
          const _dx = _spineCx - gcx;
          if (Math.abs(_dx) > 0.5) {
            node.style.left = ((parseFloat(node.style.left) || 0) + _dx) + "px";
            s.left = node.style.left;
            nvx += _dx;       // box centre shifts with the box
            gcx = _spineCx;   // letters now sit exactly on the spine centre
            _changed = true;
          }
          // Correct a stale zone so the drag lock + future logic treat it as spine.
          if (_zoneById[node.id] !== "spine") {
            const _ut = (editor.coverUserTexts || []).find((en) => en.id === node.id);
            if (_ut) { _ut.zone = "spine"; _zoneById[node.id] = "spine"; }
          }
        }

        if (s.boxWidth !== String(node.offsetWidth) || s.visCx !== String(nvx) ||
            s.glyphCx !== String(gcx) || s.glyphCy !== String(gcy)) _changed = true;
        s.boxWidth  = String(node.offsetWidth);
        s.boxHeight = String(node.offsetHeight);
        s.visCx = String(nvx);
        s.visCy = String(nvy);
        s.glyphCx = String(gcx);
        s.glyphCy = String(gcy);
      });
      // The PDF preview is cached; refresh it so it picks up the new geometry.
      if (_changed) { try { _dmbPvMarkDirty("cover"); } catch (e) {} }
    };
    // Expose to the export path (renderCoverSpread) so it can force a fresh capture
    // in the current orientation right before drawing the cover.
    _dmbCaptureCoverTextBoxesFn = _captureCoverTextBoxes;
    requestAnimationFrame(_captureCoverTextBoxes);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => requestAnimationFrame(_captureCoverTextBoxes));
    }

    spreadIndexEl.textContent = "Cover";
  }

  updatePrice();
  refreshPhotoRule();
  _syncSpreadAdderUI(); // sync counter display on load
  initCoverDesigner();

  wireTextToolbar();
  ensureFrameToolbar();
  initCoverZoneButtons();

  if (builderStep) {
    initUnifiedTabs();
    builderMode = "cover";
    syncBuilderModeButtons();
    renderCoverCanvas();
    renderThumbsRail();

    if (bookMeta) {
      const selectedPages = Number(pagesEl?.value || 0);
      if (selectedPages > 0) {
        bookMeta.textContent = `${selectedPages} pages (${Math.max(0, selectedPages - 1)} to design) • ${editor.photos.filter((p) => !_dmbIsCropDerived(p)).length} photos`;
      } else {
        bookMeta.textContent = "Start by choosing pages, photos, and customizing your cover.";
      }
    }
  }

  if (templateParam && restoreParam !== "1") {
    // Load the user's saved template state — skip if ?restore=1 is handling it.
    loadTemplateByKey(templateParam);
  }

  // ---------- editor core ----------
  function getUsedPhotoIds() {
    const used = new Set();

    // From page 0, not page 1: Magic puts a photo in page 0's slot A, and starting
    // at 1 meant that photo was reported UNUSED - so a second Magic run placed it
    // again somewhere else (a duplicate) and the "Hide used" filter kept showing it.
    for (let p = 0; p <= editor.totalPages; p++) {
      const tid = getPageTemplateId(p);

      if (tid) {
        const fm = editor.pageFrames?.[p] || {};
        Object.values(fm).forEach((id) => { if (id) used.add(id); });
      } else {
        const A = editor.pageSlots[p]?.A;
        const B = editor.pageSlots[p]?.B;
        if (A) used.add(A);
        if (B) used.add(B);
      }
    }

    // Also include full-spread photos
    if (editor.spreadPhoto) {
      Object.values(editor.spreadPhoto).forEach((sp) => { if (sp?.photoId) used.add(sp.photoId); });
    }

    // Include photos placed in free photo frames (editor.pageObjects)
    if (editor.pageObjects) {
      Object.values(editor.pageObjects).forEach((objs) => {
        if (!Array.isArray(objs)) return;
        objs.forEach((o) => { if (o.type === "photo-frame" && o.photoId) used.add(o.photoId); });
      });
    }
    // Include free frames on cover
    if (Array.isArray(editor.coverObjects)) {
      editor.coverObjects.forEach((o) => { if (o.type === "photo-frame" && o.photoId) used.add(o.photoId); });
    }

    // Include page 0 (special page)
    const tid0 = getPageTemplateId(0);
    if (tid0) {
      const fm0 = editor.pageFrames?.[0] || {};
      Object.values(fm0).forEach((id) => { if (id) used.add(id); });
    } else {
      const A0 = editor.pageSlots[0]?.A;
      const B0 = editor.pageSlots[0]?.B;
      if (A0) used.add(A0);
      if (B0) used.add(B0);
    }

    // A placement holding a DERIVED crop means its ORIGINAL source is "used" too — so the
    // original greys out / hides in the tray just like a normally-placed photo.
    Array.from(used).forEach((id) => { const s = _dmbCropSourceId(id); if (s !== id) used.add(s); });

    return used;
  }

  function getPhotoById(id) {
    return editor.photos.find((p) => p.id === id) || null;
  }

  // ── White-photo recovery ───────────────────────────────────────────────────
  // Placed/tray/thumbnail images render from a local object URL of the picked
  // file. That blob can die mid-session: the browser evicts it under memory
  // pressure (a batch of large photos) or simply can't decode the format
  // (e.g. iPhone HEIC). The <img> then shows a blank WHITE box with no way back.
  // But every photo was streamed to R2 at pick time, so we re-fetch the bytes by
  // pid, rebuild a fresh object URL, update the shared record (so later renders
  // use the good URL too), and retry the element. Fetches are de-duped per pid so
  // N on-screen copies of the same photo trigger just one request.
  const _dmbPhotoRecovery = {};
  function _dmbRecoverPhotoUrl(ph) {
    if (!ph || !ph.id) return Promise.resolve(null);
    if (_dmbPhotoRecovery[ph.id]) return _dmbPhotoRecovery[ph.id];
    const p = (async function () {
      if (!window.DMB_DESIGNS_PROXY) return null;
      try {
        const designId = getCustomerSaveKey().replace(/^dmb_progress_/, "");
        // Identity-correct fetch: works for signed-in customers too (not just
        // guests). This is what lets a released or evicted photo self-heal on
        // screen for a logged-in user.
        const blob = await _dmbFetchPhotoBlob(designId, ph.id);
        if (!blob || !blob.size) return null;
        const fresh = URL.createObjectURL(blob);
        ph.url = fresh;
        try { if (!ph.file || !ph.file.size) ph.file = new File([blob], ph.filename || "photo.jpg", { type: blob.type || "image/jpeg" }); } catch (e) {}
        return fresh;
      } catch (e) { return null; }
    })();
    _dmbPhotoRecovery[ph.id] = p;
    // Drop the cache shortly after it settles so a later transient can retry.
    p.then(function () {}, function () {}).then(function () {
      setTimeout(function () { if (_dmbPhotoRecovery[ph.id] === p) delete _dmbPhotoRecovery[ph.id]; }, 4000);
    });
    return p;
  }
  // Point an <img> at a photo's URL AND wire self-healing: on a load error, pull
  // the bytes back from R2 once and swap in a fresh URL. One recovery try per
  // element (no retry loop if the photo is truly gone).
  function _dmbBindPhotoImg(img, ph) {
    if (!img) return;
    img.src = (ph && ph.url) ? ph.url : "";
    if (!ph || img._dmbRecoverBound) return;
    img._dmbRecoverBound = true;
    img.addEventListener("error", function () {
      if (img._dmbRecoverTried) return;
      img._dmbRecoverTried = true;
      _dmbRecoverPhotoUrl(ph).then(function (fresh) { if (fresh) img.src = fresh; });
    });
  }

  function applyRotationAndCover(imgEl, boxEl, deg) {
    imgEl.style.objectFit = "cover";
    imgEl.style.objectPosition = "center";
    imgEl.style.transformOrigin = "center";

    if (deg % 180 !== 0) {
      const w = boxEl.clientWidth || 1;
      const h = boxEl.clientHeight || 1;
      const s = Math.max(w / h, h / w);
      imgEl.style.transform = `rotate(${deg}deg) scale(${s})`;
    } else {
      imgEl.style.transform = `rotate(${deg}deg)`;
    }
  }

  async function getImageMetaFromFile(file) {
    const url = URL.createObjectURL(file);
    try {
      const img = new Image();
      img.decoding = "async";
      // Never await img.decode() unguarded: it can stay unsettled forever (large
      // image + tab not painting). This runs while HOLDING the meta semaphore, so
      // one hang here would leak a slot and, after a few, block every photo-meta
      // read — i.e. the builder would never finish opening. Wait for load (that's
      // all we need to read naturalWidth/Height) and time-box the whole thing.
      const w8 = new Promise((res, rej) => {
        img.onload = () => res(true);
        img.onerror = () => rej(new Error("image load failed"));
      });
      img.src = url;
      await Promise.race([
        w8,
        new Promise((_, rej) => setTimeout(() => rej(new Error("meta timeout")), 8000)),
      ]);
      const w = img.naturalWidth || 1;
      const h = img.naturalHeight || 1;
      return { w, h, ratio: w / h };
    } catch {
      return { w: 1, h: 1, ratio: 1 };
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  // ── Memory-safe aspect-ratio read (phone-crash fix) ───────────────────────
  // The OLD path decoded EVERY photo at full resolution via <img>.decode() just
  // to read its width/height, and both openEditor and refreshBuilderPhotos did it
  // with Promise.all — so picking 300 photos fired 300 simultaneous full-res
  // bitmap decodes and iOS Safari ran out of memory and killed the tab.
  //
  // This reads the ratio from a TINY resized decode (createImageBitmap with a
  // small resizeWidth → a few hundred KB, closed immediately) and gates ALL
  // decodes through a global semaphore so at most _DMB_META_MAX run at once,
  // no matter how many callers fan out. Only the aspect RATIO is used downstream
  // (portrait/landscape choice + display box), never the absolute pixels, so the
  // resized read is exact enough and full-res quality is never involved here.
  /* Settle a promise no matter what: resolve with `fallback` if it rejects OR if
   * it has not settled within `ms`. createImageBitmap is a NATIVE promise that can
   * simply never settle on iOS Safari for some HEIC / very large files - the same
   * hazard already documented for img.decode(). Unguarded, the await below never
   * returns, its `finally` never runs, and the meta semaphore permanently loses a
   * slot; three such files starve a max-3 gate, every later meta read blocks on
   * acquire, and refreshBuilderPhotos' Promise.all never resolves. The visible
   * symptom is newly added photos never appearing in the tray while the
   * "N photos selected" counter - which reads bookFiles, updated earlier - has
   * already moved. (2026-09-13) */
  function _dmbSettleWithin(p, ms, fallback) {
    let t = null;
    return Promise.race([
      Promise.resolve(p).then((v) => v, () => fallback),
      new Promise((res) => { t = setTimeout(() => res(fallback), ms); }),
    ]).then((v) => { try { clearTimeout(t); } catch (e) {} return v; });
  }
  const _DMB_META_TIMEOUT = 8000;

  const _dmbMetaSem = { n: 0, max: 3, q: [] };
  function _dmbMetaAcquire() {
    return new Promise((res) => {
      if (_dmbMetaSem.n < _dmbMetaSem.max) { _dmbMetaSem.n++; res(); }
      else _dmbMetaSem.q.push(res);
    });
  }
  function _dmbMetaRelease() {
    _dmbMetaSem.n = Math.max(0, _dmbMetaSem.n - 1);
    const next = _dmbMetaSem.q.shift();
    if (next) { _dmbMetaSem.n++; next(); }
  }
  async function _dmbCheapMeta(file) {
    if (!file) return { w: 1, h: 1, ratio: 1 };
    await _dmbMetaAcquire();
    try {
      let bmp = null;
      if (typeof createImageBitmap === "function") {
        // imageOrientation:"from-image" so the ratio matches what the <img> actually
        // displays (browsers auto-apply EXIF orientation to <img> but NOT to
        // createImageBitmap by default) — otherwise EXIF-rotated shots get a swapped
        // ratio and land in a wrong-aspect box, looking stretched/squished.
        // Every decode is time-boxed so this function ALWAYS reaches its finally
        // and releases the semaphore slot.
        bmp = await _dmbSettleWithin(
          createImageBitmap(file, { resizeWidth: 256, resizeQuality: "low", imageOrientation: "from-image" }),
          _DMB_META_TIMEOUT, null);
        if (!bmp) {
          bmp = await _dmbSettleWithin(
            createImageBitmap(file, { resizeWidth: 256, resizeQuality: "low" }), _DMB_META_TIMEOUT, null);
        }
        if (!bmp) {   // older Safari: no options
          bmp = await _dmbSettleWithin(createImageBitmap(file), _DMB_META_TIMEOUT, null);
        }
      }
      if (bmp) {
        const w = bmp.width || 1, h = bmp.height || 1;
        if (bmp.close) bmp.close();
        return { w, h, ratio: w / h };
      }
      // Fallback for browsers without createImageBitmap: the original <img> decode.
      // Heavier, but it still runs under the semaphore we hold (max _DMB_META_MAX
      // at once), so it can't fan out into the old crash.
      const meta = await _dmbSettleWithin(getImageMetaFromFile(file), _DMB_META_TIMEOUT, null);
      return meta || { w: 1, h: 1, ratio: 1 };
    } catch (e) {
      return { w: 1, h: 1, ratio: 1 };
    } finally {
      _dmbMetaRelease();
    }
  }

  /* ── Photo-meta warm cache ─────────────────────────────────────────────────
   * Decoding every uploaded photo to read its dimensions is the slow step that
   * makes the cover lag when the builder first opens (openEditor awaits ALL
   * metas before rendering). To hide that latency we start the decode the moment
   * a file is added on the upload step, while the user is still picking photos /
   * choosing pages. By the time they reach the builder the work is usually done,
   * so openEditor resolves instantly from cache instead of decoding from cold.
   * Keyed by the File object (WeakMap → no leaks); stores the in-flight Promise
   * so a still-decoding file is awaited once, never decoded twice. The decode
   * itself is the memory-safe, concurrency-capped _dmbCheapMeta above. */
  const _dmbMetaCache = new WeakMap();
  function _dmbWarmMeta(file) {
    if (!file) return Promise.resolve({ w: 1, h: 1, ratio: 1 });
    let p = _dmbMetaCache.get(file);
    if (!p) { p = _dmbCheapMeta(file); _dmbMetaCache.set(file, p); }
    return p;
  }
  function _dmbWarmMetaFor(files) {
    try { (files || []).forEach((f) => { if (f) _dmbWarmMeta(f); }); } catch (e) {}
  }

  // Cap the photo scroll box so its BOTTOM lines up with the bottom of the
  // builder/cover box — the box "comes up" to the builder and photos scroll inside.
  let _syncTrayQueued = false;
  function syncPhotoTrayHeight() {
    const panel = document.querySelector(".dmb-builder-leftpanel");
    const stage = document.querySelector(".dmb-canvas-stage");
    if (!panel || !stage) return;
    // Phones use the flex mobile shell — the desktop "match the panel height to the
    // canvas column" hack sets an INLINE height that pins the docked panel short and
    // clips the photo tray. Disable it (and clear any stale inline height) on mobile.
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) {
      if (panel.style.height) panel.style.height = "";
      return;
    }
    if (builderStep && getComputedStyle(builderStep).display === "none") return;
    if (_syncTrayQueued) return;
    _syncTrayQueued = true;
    requestAnimationFrame(() => {
      _syncTrayQueued = false;
      // Match the photo-tray BOX height to the builder/cover box, so their bottoms
      // line up; the photo grid scrolls inside.
      const h = Math.round(stage.getBoundingClientRect().height);
      if (h > 0) panel.style.height = h + "px";
    });
  }
  window.addEventListener("resize", () => { try { syncPhotoTrayHeight(); } catch (e) {} });

  /* ===================================================================
     Tray photo menu (Remove / Duplicate / Add to photobook)
     Desktop: opens from the ⋯ button. Touch (phone/iPad): opens on a
     quick tap of the photo (a scroll or hold-drag is NOT a tap).
     =================================================================== */

  function dmbIsTouchLike() {
    // Phones AND tablets get the "hold then drag" hint. Touch capability covers
    // real tablets/phones; the width fallback (<=1024px) guarantees any tablet-
    // sized screen is included even if its touch flags are reported oddly.
    return !!(
      ("ontouchstart" in window) ||
      (navigator.maxTouchPoints > 0) ||
      (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) ||
      (window.innerWidth <= 1024)
    );
  }

  // The pages currently visible in the open spread (left first, then right).
  function dmbCurrentSpreadPageNums() {
    if (editor.currentSpread === -1) return [0];
    const lp = editor.currentSpread * 2 + 1;
    const rp = lp + 1;
    const arr = [];
    if (lp <= editor.totalPages && !isLockedPage(lp)) arr.push(lp);
    if (rp <= editor.totalPages && !isLockedPage(rp)) arr.push(rp);
    return arr;
  }

  // First empty slot/frame on a page, or null if the page is full.
  function dmbFirstEmptySlotOnPage(pn) {
    if (isLockedPage(pn)) return null;
    if (isTemplatePage(pn)) {
      const def = TEMPLATE_DEFS[getPageTemplateId(pn)] || [];
      for (const f of def) { if (!getFramePhotoId(pn, f.key)) return f.key; }
      return null;
    }
    if (!editor.pageSlots[pn]) editor.pageSlots[pn] = { A: null, B: null };
    if (!editor.pageSlots[pn].A) return "A";
    if (!editor.pageSlots[pn].B) return "B";
    return null;
  }

  // Scan the whole book for the first page with a free slot.
  function dmbFindFirstFreePageSlot() {
    for (let p = 1; p <= editor.totalPages; p++) {
      if (isLockedPage(p)) continue;
      const slot = dmbFirstEmptySlotOnPage(p);
      if (slot) return { page: p, slot: slot };
    }
    return null;
  }

  function dmbPlacePhotoInSlot(pn, slot, photoId) {
    if (!isTemplatePage(pn)) {
      if (!editor.pageSlots[pn]) editor.pageSlots[pn] = { A: null, B: null };
      if (!editor.pageRot[pn]) editor.pageRot[pn] = { A: 0, B: 0 };
    }
    setFramePhotoId(pn, slot, photoId);
    setFrameRotation(pn, slot, 0);
  }

  // When viewing the cover, "Add to photobook" drops onto front, then back.
  function dmbPlacePhotoOnCover(photoId) {
    const photo = getPhotoById(photoId);
    if (!photo) return false;
    let zone = null;
    if (!coverState.frontImageUrl) zone = "front";
    else if (!coverState.backImageUrl) zone = "back";
    else return false;
    pushUndoState("Add To Cover");
    if (zone === "front") {
      coverState.frontImageUrl = photo.url; coverState.frontImageId = photoId; coverState.frontImageRot = 0;
    } else {
      coverState.backImageUrl = photo.url; coverState.backImageId = photoId; coverState.backImageRot = 0;
    }
    saveCoverDesignToStorage();
    renderCoverCanvas(); renderThumbsRail(); renderPhotoTray();
    return zone;
  }

  function addPhotoToBook(photoId) {
    const used = getUsedPhotoIds();
    const isReused = used.has(photoId);

    // Cover mode → place on the cover (front, then back).
    if (builderMode === "cover") {
      const zone = dmbPlacePhotoOnCover(photoId);
      if (zone) dmbAddedToast(zone === "front" ? "Added to cover (front)" : "Added to cover (back)");
      else dmbActionToast("Your cover already has front and back photos.", null, null);
      return;
    }

    // Pages → fill the first empty slot on the open spread (left page, then right).
    for (const pn of dmbCurrentSpreadPageNums()) {
      const slot = dmbFirstEmptySlotOnPage(pn);
      if (slot) {
        pushUndoState("Add To Photobook");
        dmbPlacePhotoInSlot(pn, slot, photoId);
        if (isReused) showReuseNotice();
        renderSpread(); renderThumbsRail(); renderPhotoTray();
        dmbAddedToast("Added to page " + pn);
        return;
      }
    }

    // Open spread is full → offer the next free page (give the customer the choice).
    const next = dmbFindFirstFreePageSlot();
    if (next) {
      dmbActionToast("This spread is full.", "Add to page " + next.page + " →", () => {
        pushUndoState("Add To Photobook");
        dmbPlacePhotoInSlot(next.page, next.slot, photoId);
        if (isReused) showReuseNotice();
        builderMode = "pages";
        editor.currentSpread = Math.floor((next.page - 1) / 2);
        renderBuilderCanvas();
        dmbAddedToast("Added to page " + next.page);
      });
    } else {
      dmbActionToast("Your book is full — add more pages to place this photo.", null, null);
    }
  }

  async function dmbRemovePhoto(ph) {
    // Was window.confirm(), which renders the browser's own grey box with the
    // domain name in it. Shows the actual photo so there is no doubt which one
    // is about to go.
    const ok = await showChoiceDialog(
      "Remove this photo?",
      "It will be taken out of your library and off any page it sits on.",
      [{ id: "cancel", label: "Keep it" }, { id: "remove", label: "Remove", danger: true }],
      { imageUrl: (ph && (ph.thumbUrl || ph.url)) || "" }
    );
    if (ok !== "remove") return;
    const idx = editor.photos.findIndex((x) => x.id === ph.id);
    if (idx >= 0) {
      bookFiles.splice(idx, 1);
      editor.photos.splice(idx, 1);
      renderPhotoTray();
      renderThumbsRail();
      renderBuilderCanvas();
    }
  }

  function dmbDuplicatePhoto(ph) {
    if (ph.file) {
      const clone = new File([ph.file], ph.file.name, { type: ph.file.type });
      bookFiles.push(clone);
      try { _dmbWarmMeta(clone); } catch (e) {}
      refreshBuilderPhotos();
    }
  }

  // --- the popup menu itself ---
  let _dmbOpenPhotoMenu = null;
  function _dmbPhotoMenuOutside(e) {
    if (_dmbOpenPhotoMenu && !_dmbOpenPhotoMenu.contains(e.target)) closeDmbPhotoMenu();
  }
  function closeDmbPhotoMenu() {
    if (_dmbOpenPhotoMenu) { _dmbOpenPhotoMenu.remove(); _dmbOpenPhotoMenu = null; }
    document.removeEventListener("pointerdown", _dmbPhotoMenuOutside, true);
    window.removeEventListener("scroll", closeDmbPhotoMenu, true);
  }
  function openDmbPhotoMenu(anchorEl, ph) {
    closeDmbPhotoMenu();
    const menu = document.createElement("div");
    menu.className = "dmb-photo-menu";

    const mk = (label, cls, fn) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "dmb-photo-menu-btn" + (cls ? " " + cls : "");
      b.textContent = label;
      b.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); closeDmbPhotoMenu(); fn(); });
      return b;
    };

    menu.appendChild(mk("Add to photobook", "dmb-photo-menu-add", () => addPhotoToBook(ph.id)));
    menu.appendChild(mk("Duplicate", "", () => dmbDuplicatePhoto(ph)));
    menu.appendChild(mk("Remove photo", "dmb-photo-menu-remove", () => dmbRemovePhoto(ph)));

    if (dmbIsTouchLike()) {
      const hint = document.createElement("div");
      hint.className = "dmb-photo-menu-hint";
      hint.innerHTML = '<span class="dmb-photo-menu-hint-or">or</span>Hold the photo for a moment, then drag to the editor';
      menu.appendChild(hint);
    }

    document.body.appendChild(menu);
    _dmbOpenPhotoMenu = menu;

    // Position under the photo, clamped to the viewport.
    const r = anchorEl.getBoundingClientRect();
    const mw = menu.offsetWidth, mh = menu.offsetHeight;
    let left = r.left;
    let top = r.bottom + 6;
    if (left + mw > window.innerWidth - 8) left = window.innerWidth - 8 - mw;
    if (left < 8) left = 8;
    if (top + mh > window.innerHeight - 8) top = r.top - mh - 6;
    if (top < 8) top = 8;
    menu.style.left = left + "px";
    menu.style.top = top + "px";

    setTimeout(() => {
      document.addEventListener("pointerdown", _dmbPhotoMenuOutside, true);
      window.addEventListener("scroll", closeDmbPhotoMenu, true);
    }, 0);
  }

  function dmbAddedToast(text) {
    let n = document.getElementById("dmbAddedToast");
    if (!n) { n = document.createElement("div"); n.id = "dmbAddedToast"; n.className = "dmb-mini-toast"; document.body.appendChild(n); }
    n.textContent = text;
    n.style.display = "block"; n.style.opacity = "1";
    clearTimeout(dmbAddedToast._t);
    dmbAddedToast._t = setTimeout(() => { n.style.opacity = "0"; setTimeout(() => { n.style.display = "none"; }, 200); }, 1400);
  }

  function dmbActionToast(message, actionLabel, onAction) {
    let n = document.getElementById("dmbActionToast");
    if (n) n.remove();
    n = document.createElement("div");
    n.id = "dmbActionToast";
    n.className = "dmb-action-toast";
    const msg = document.createElement("span");
    msg.textContent = message;
    n.appendChild(msg);
    if (actionLabel && onAction) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "dmb-action-toast-btn";
      b.textContent = actionLabel;
      b.addEventListener("click", () => { n.remove(); onAction(); });
      n.appendChild(b);
    }
    const x = document.createElement("button");
    x.type = "button";
    x.className = "dmb-action-toast-x";
    x.setAttribute("aria-label", "Dismiss");
    x.textContent = "✕";
    x.addEventListener("click", () => n.remove());
    n.appendChild(x);
    document.body.appendChild(n);
    clearTimeout(dmbActionToast._t);
    dmbActionToast._t = setTimeout(() => { if (n && n.isConnected) n.remove(); }, 6000);
  }

  // ── Photo-tray thumbnails (Option A: stop the upload crash) ────────────────
  // The tray must NEVER decode full-size photos — that's what blows past iOS's
  // memory ceiling when many photos are added. Instead each tray cell shows a tiny
  // (~320px) thumbnail. Thumbnails are generated ONE AT A TIME (a serial queue) so
  // only one photo is ever decoded at a moment, and cached by photo id.
  const _DMB_THUMB_PLACEHOLDER =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Crect width='40' height='40' fill='%23eceff4'/%3E%3C/svg%3E";
  const _dmbThumbCache = {};        // photoId -> small objectURL
  const _dmbThumbQueued = {};       // photoId -> true (queued/in-flight)
  let _dmbThumbQ = [];
  let _dmbThumbBusy = false;

  async function _dmbMakeThumbBlob(file, maxDim) {
    maxDim = maxDim || 320;
    try {
      let bmp;
      try { bmp = await createImageBitmap(file, { resizeWidth: maxDim, resizeQuality: "medium" }); }
      catch (e) { bmp = await createImageBitmap(file); }     // older Safari: no resize option
      const s = Math.min(1, maxDim / Math.max(bmp.width, bmp.height));
      const w = Math.max(1, Math.round(bmp.width * s));
      const h = Math.max(1, Math.round(bmp.height * s));
      const c = document.createElement("canvas"); c.width = w; c.height = h;
      c.getContext("2d").drawImage(bmp, 0, 0, w, h);
      if (bmp.close) bmp.close();
      const blob = await new Promise((res) => c.toBlob(res, "image/jpeg", 0.7));
      c.width = 0; c.height = 0;                              // free canvas memory now
      return blob;
    } catch (e) { return null; }
  }

  async function _dmbThumbDrain() {
    if (_dmbThumbBusy) return;
    _dmbThumbBusy = true;
    while (_dmbThumbQ.length) {
      const job = _dmbThumbQ.shift();
      const ph = job.ph;
      if (!ph || _dmbThumbCache[ph.id]) continue;
      let src = ph.file;
      if ((!src || !src.size) && ph.url) { try { src = await (await fetch(ph.url)).blob(); } catch (e) {} }
      // Print-master path: a lazily-released photo (no file, no url — bytes live on
      // R2) must NEVER hit the fail/purge path just because its thumb came late.
      // Pull it back from R2 once; recovery also restores ph.url/ph.file for later.
      if ((!src || !src.size) && _dmbPrintMasterOn() && ph._r2 && ph.id) {
        try { const u = await _dmbRecoverPhotoUrl(ph); if (u) src = await (await fetch(u)).blob(); } catch (e) {}
      }
      if (!src || !src.size) { _dmbHandleThumbFail(ph); continue; }
      const blob = await _dmbMakeThumbBlob(src, 320);
      if (blob && blob.size) {
        const u = URL.createObjectURL(blob);
        _dmbThumbCache[ph.id] = u;
        ph.thumbUrl = u;
        // Update any live tray <img> for this photo without a full re-render.
        document.querySelectorAll('img[data-dmb-thumb="' + ph.id + '"]').forEach((im) => { im.src = u; });
      } else {
        _dmbHandleThumbFail(ph);
      }
      // Yield so the browser can reclaim memory between photos (prevents pile-up).
      await new Promise((r) => setTimeout(r, 0));
    }
    _dmbThumbBusy = false;
  }

  // A photo's thumbnail could not be generated. Decide whether its image is
  // permanently unrecoverable and, if so, auto-remove it everywhere (per the user's
  // choice) so no blank box shows and no page frame prints blank.
  // SAFETY: a photo that still has its uploaded file blob is NEVER deleted — that
  // guards against transient decode/memory failures on a good photo; it's just
  // retried. Only a photo whose in-memory data is GONE (evicted/lost) is removed —
  // immediately if it has no URL to recover from, or after a failed URL retry.
  function _dmbHandleThumbFail(ph) {
    if (!ph || _dmbThumbCache[ph.id] || ph.thumbUrl) return;      // recovered — fine now
    if (ph.file && ph.file.size) { _dmbThumbQueued[ph.id] = false; return; }   // still have the file — retry, never delete
    if (!ph.url) { _dmbPurgeBrokenPhoto(ph.id); return; }         // no in-memory data AND no URL → unrecoverable
    // Has a URL: only delete after two failures AND a definitive image-load error,
    // so a flaky-but-valid URL is never removed.
    ph._thumbFails = (ph._thumbFails || 0) + 1;
    if (ph._thumbFails < 2) { _dmbThumbQueued[ph.id] = false; return; }
    if (ph._verifying) return;
    ph._verifying = true;
    const test = new Image();
    test.onload = () => { ph._verifying = false; ph._thumbFails = 0; _dmbThumbQueued[ph.id] = false; _dmbQueueThumb(ph); };
    test.onerror = () => { ph._verifying = false; _dmbPurgeBrokenPhoto(ph.id); };
    test.src = ph.url;
  }

  // Remove a broken photo from the album AND clear it from every page/cover
  // placement (mirrors getUsedPhotoIds' traversal) so nothing is left printing blank.
  function _dmbPurgeBrokenPhoto(phId) {
    if (!phId) return;
    const idx = editor.photos ? editor.photos.findIndex((x) => x.id === phId) : -1;
    if (idx < 0) return;                                          // already gone
    try {
      for (let p = 0; p <= (editor.totalPages || 0); p++) {
        const fm = editor.pageFrames && editor.pageFrames[p];
        if (fm) Object.keys(fm).forEach((k) => { if (fm[k] === phId) fm[k] = null; });
        const slots = editor.pageSlots && editor.pageSlots[p];
        if (slots) { if (slots.A === phId) slots.A = null; if (slots.B === phId) slots.B = null; }
      }
      if (editor.spreadPhoto) {
        Object.keys(editor.spreadPhoto).forEach((k) => {
          const sp = editor.spreadPhoto[k];
          if (sp && sp.photoId === phId) editor.spreadPhoto[k] = null;
        });
      }
      if (editor.pageObjects) {
        Object.values(editor.pageObjects).forEach((objs) => {
          if (Array.isArray(objs)) objs.forEach((o) => { if (o && o.type === "photo-frame" && o.photoId === phId) o.photoId = null; });
        });
      }
      if (Array.isArray(editor.coverObjects)) {
        editor.coverObjects.forEach((o) => { if (o && o.type === "photo-frame" && o.photoId === phId) o.photoId = null; });
      }
    } catch (e) {}
    // Remove the photo itself (bookFiles is parallel-indexed to editor.photos).
    if (typeof bookFiles !== "undefined" && Array.isArray(bookFiles)) bookFiles.splice(idx, 1);
    editor.photos.splice(idx, 1);
    console.warn("[DMB] Auto-removed a photo whose image was missing:", phId);
    try { renderPhotoTray(); } catch (e) {}
    try { renderThumbsRail(); } catch (e) {}
    try { if (typeof builderMode !== "undefined" && builderMode === "cover") renderCoverCanvas(); else renderSpread(); } catch (e) {}
  }

  function _dmbQueueThumb(ph) {
    if (!ph || _dmbThumbCache[ph.id] || _dmbThumbQueued[ph.id]) return;
    _dmbThumbQueued[ph.id] = true;
    _dmbThumbQ.push({ ph });
    _dmbThumbDrain();
  }

  // Display src for the page-rail mini previews. NEVER returns the full-res photo
  // URL — a large book places a photo on every page, and one full-res <img> per
  // page decoded at once is the other phone-crash source. Returns the cached
  // 320px thumb when ready, else a tiny placeholder and queues generation; the
  // thumb drain hot-swaps any <img data-dmb-thumb="pid"> the moment it's ready.
  function _dmbMiniThumbSrc(ph) {
    if (!ph) return _DMB_THUMB_PLACEHOLDER;
    const t = ph.thumbUrl || _dmbThumbCache[ph.id];
    if (!t) { try { _dmbQueueThumb(ph); } catch (e) {} }
    return t || _DMB_THUMB_PLACEHOLDER;
  }

  function renderPhotoTray() {
    if (_dmbRenderMode()) return;   // the PDF never reads the tray (skips 4 persistence calls too)
    if (!editorPhotoTray) return;
    syncPhotoTrayHeight();

    // Keep saved progress current so a refresh / app-switch can resume (issue 1).
    if (typeof _dmbPersistPhotos === "function") _dmbPersistPhotos();
    if (typeof _dmbAutoPersist === "function") _dmbAutoPersist();
    if (typeof _dmbCloudPersist === "function") _dmbCloudPersist();
    if (typeof _dmbBackupPhotos === "function") _dmbBackupPhotos();   // guest photo backup → R2

    const used = getUsedPhotoIds();
    const photos = applyPhotoFilters(editor.photos);

    editorPhotoTray.innerHTML = "";

    photos.forEach((ph) => {
      const isUsed = used.has(ph.id);

      const t = document.createElement("div");
      t.className = "dmb-photo-thumb";
      t.draggable = true;

      t.addEventListener("dragstart", (e) => {
        setDragPayload(e, { type: "photo", photoId: ph.id });
      });

      // Touch (phone/iPad): a quick tap opens the menu. A scroll or a
      // hold-and-drag involves finger movement, so it is NOT treated as a tap.
      let _tapX = 0, _tapY = 0, _tapT = 0, _tapTouch = false;
      t.addEventListener("pointerdown", (e) => {
        _tapTouch = (e.pointerType !== "mouse");
        _tapX = e.clientX; _tapY = e.clientY; _tapT = Date.now();
      });
      t.addEventListener("pointerup", (e) => {
        if (!_tapTouch) return;                                   // desktop uses the ⋯ button
        if (e.target.closest && e.target.closest(".dmb-photo-hover-menu")) return; // ⋯ handles itself
        const moved = Math.hypot(e.clientX - _tapX, e.clientY - _tapY);
        const elapsed = Date.now() - _tapT;
        if (moved < 10 && elapsed < 600) {
          e.preventDefault();
          openDmbPhotoMenu(t, ph);
        }
      });

      // Touch drag-and-drop (phones/iPad): press-and-drag the thumb onto a page/cover
      // frame to place the photo. Desktop keeps the native HTML5 draggable above.
      _dmbWireThumbTouchDrag(t, ph);

      const img = document.createElement("img");
      // Use the small thumbnail — NEVER the full-size photo (that's the crash).
      const _tu = ph.thumbUrl || _dmbThumbCache[ph.id];
      img.src = _tu || _DMB_THUMB_PLACEHOLDER;
      img.dataset.dmbThumb = ph.id;
      img.alt = "photo";
      img.draggable = false;
      img.loading = "lazy";
      img.decoding = "async";
      t.appendChild(img);
      if (!_tu) _dmbQueueThumb(ph);   // generate it (serially) and swap in when ready

      if (isUsed) {
        const badge = document.createElement("div");
        badge.className = "dmb-photo-used";
        badge.textContent = "USED";
        t.appendChild(badge);
      }

      const menuWrap = document.createElement("div");
      menuWrap.className = "dmb-photo-hover-menu";

      const menuBtn = document.createElement("button");
      menuBtn.type = "button";
      menuBtn.className = "dmb-photo-hover-menu-btn";
      menuBtn.textContent = "⋯";
      menuWrap.appendChild(menuBtn);

      menuBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openDmbPhotoMenu(t, ph);
      });

      t.appendChild(menuWrap);
      editorPhotoTray.appendChild(t);
    });
    // Phones: give every tile its natural-aspect width (= tray height × photo
    // aspect) so photos fill their frames edge-to-edge with no white bars.
    try { requestAnimationFrame(_dmbSizePhotoTiles); } catch (e) {}
    // Desktop: justified gallery — set each tile's --asp so the flexbox packs rows.
    try { requestAnimationFrame(_dmbJustifyPhotoTray); } catch (e) {}
  }

  // Desktop photo tray = justified gallery. For each tile, set the CSS var --asp to
  // the photo's real aspect ratio (read from the loaded thumbnail); the CSS then uses
  // it for aspect-ratio + flex so each row fills the width with photos at their true
  // proportions (no cropping). Recomputes on image load (async thumbnail swap).
  function _dmbJustifyPhotoTray() {
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) return; // mobile uses the strip
    const tray = document.getElementById("editorPhotoTray");
    if (!tray) return;
    Array.from(tray.children).forEach((tile) => {
      const img = tile.querySelector("img");
      if (!img) return;
      const setAsp = () => {
        const nw = img.naturalWidth, nh = img.naturalHeight;
        if (nw && nh) tile.style.setProperty("--asp", (nw / nh).toFixed(4));
      };
      setAsp();
      if (!img._dmbAspHook) { img._dmbAspHook = true; img.addEventListener("load", setAsp); }
    });
  }

  // Size each photo tile on phones DETERMINISTICALLY: explicit height = the strip
  // height, and explicit width = height × the image's real aspect ratio (read from
  // the loaded thumbnail). The image then fills that exact frame (object-fit:contain,
  // never cropped). This does NOT rely on flex width:auto re-shrinking when the
  // thumbnail swaps in — which was leaving a grey gap beside portrait photos — so
  // there is never a gap. Recomputes on every image load (covers the async
  // placeholder → real-thumbnail swap).
  function _dmbSizePhotoTiles() {
    if (!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches)) return;
    const tray = document.getElementById("editorPhotoTray");
    const scroll = document.getElementById("dmbPicturesScrollArea");
    if (!tray || !scroll) return;
    const H = scroll.clientHeight || tray.clientHeight || 0;
    if (!H) { requestAnimationFrame(_dmbSizePhotoTiles); return; }
    Array.from(tray.children).forEach((tile) => {
      const img = tile.querySelector("img");
      const fit = () => {
        // Measure height once and use the SAME value for height AND width, so the
        // tile's aspect exactly matches the photo's — no letterbox, no gap. (Using
        // two different measurements let a scrollbar-induced height change skew it.)
        const HH = scroll.clientHeight || tray.clientHeight || H;
        if (!HH) return;
        const nw = img && img.naturalWidth, nh = img && img.naturalHeight;
        const W = Math.max(24, Math.round(HH * ((nw && nh) ? nw / nh : 1)));
        // setProperty(..., "important") — the tile's CSS width/height are `!important`,
        // and a stylesheet !important beats a plain inline style, so we MUST mark these
        // inline values important too or the sizing is silently ignored.
        tile.style.setProperty("height", HH + "px", "important");
        tile.style.setProperty("width", W + "px", "important");
      };
      fit();
      if (img && !img._dmbFitHook) { img._dmbFitHook = true; img.addEventListener("load", fit); }
    });
  }


  // ═══════════════════════════════════════════════════════════════════════════
  // PAGE REORDER / INSERT ENGINE (desktop drag-to-reorder + insert-a-spread).
  // Pages 0 (Special) and 1 (locked SPECIAL) are fixed. Movable pages are 2..N.
  // Each page carries 8 structures keyed by page number; a spread photo is keyed
  // by spread index (a page pair). This engine rebuilds the movable region from a
  // `sources` list (each entry = an old page number to move, or null for a new
  // blank page), remapping all 8 structures and re-pairing spread photos (dropping
  // any that a single-page move splits apart). Validated by a standalone unit test.
  // ═══════════════════════════════════════════════════════════════════════════
  const _DMB_PAGE_STRUCTS = ["pageSlots","pageRot","pageTemplate","pageFrames","pageFrameRot","pageFrameShapes","pageObjects","pageBackgrounds"];

  function _dmbApplyPageSources(sources) {
    const ed = editor;
    const oldTotal = ed.totalPages;
    // 1) capture old bundles for movable pages (2..N)
    const oldBundles = {};
    for (let p = 2; p <= oldTotal; p++) {
      oldBundles[p] = {};
      _DMB_PAGE_STRUCTS.forEach((k) => { oldBundles[p][k] = ed[k] ? ed[k][p] : undefined; });
    }
    // 2) capture old spread photos as pairs of old page numbers
    const oldSpreadPhotos = [];
    const oldSpreads = Math.ceil(oldTotal / 2);
    for (let si = 0; si < oldSpreads; si++) {
      const sp = ed.spreadPhoto && ed.spreadPhoto[si];
      if (sp && sp.photoId) oldSpreadPhotos.push({ left: si * 2 + 1, right: si * 2 + 2, photo: sp });
    }
    // 3) clear movable region (page >= 2) in all 8 structures
    _DMB_PAGE_STRUCTS.forEach((k) => {
      if (!ed[k]) { ed[k] = {}; return; }
      Object.keys(ed[k]).forEach((key) => { if (+key >= 2) delete ed[k][key]; });
    });
    // 4) write the new positions (2..)
    const newPosOfOld = {};
    for (let i = 0; i < sources.length; i++) {
      const newP = i + 2, src = sources[i];
      if (src == null) {
        ed.pageSlots[newP] = { A: null, B: null }; ed.pageRot[newP] = { A: 0, B: 0 };
        ed.pageTemplate[newP] = null; ed.pageFrames[newP] = {}; ed.pageFrameRot[newP] = {};
        ed.pageFrameShapes[newP] = {}; ed.pageObjects[newP] = [];
      } else {
        const b = oldBundles[src] || {};
        _DMB_PAGE_STRUCTS.forEach((k) => { if (b[k] !== undefined) ed[k][newP] = b[k]; });
        newPosOfOld[src] = newP;
      }
    }
    // 5) rebuild spreadPhoto — keep only pairs still adjacent on a valid (odd,even) boundary
    const dropped = [];
    const nsp = {};
    oldSpreadPhotos.forEach(({ left, right, photo }) => {
      const nl = newPosOfOld[left], nr = newPosOfOld[right];
      if (nl && nr && nr === nl + 1 && nl % 2 === 1) nsp[(nl - 1) / 2] = photo;
      else dropped.push(photo.photoId);
    });
    ed.spreadPhoto = nsp;
    // 6) recount
    ed.totalPages = sources.length + 1;
    ed.editablePages = Math.max(0, ed.totalPages - 1);
    ed.totalSpreads = Math.ceil(ed.totalPages / 2);
    // 7) A spanning object is placed against a SPECIFIC pairing of two pages. Re-ordering
    // re-pairs them, so that placement no longer describes anything the customer chose -
    // and an object still hanging over the fold would now print onto a sheet it was never
    // put near. Pull the fold-side overhang back in, the same judgement step 5 above makes
    // when it drops a spread photo whose pair no longer sits together. Outer-edge bleed is
    // untouched, because that never depended on the pairing. (2026-09-14)
    try {
      const _PWr = getPageDims().w;
      Object.keys(ed.pageObjects || {}).forEach(function (k) {
        const pn = Number(k);
        const arr = ed.pageObjects[k];
        if (!pn || pn < 1 || !Array.isArray(arr)) return;
        const isLeftPg = (pn % 2 === 1);
        arr.forEach(function (o) {
          if (!o) return;
          const ow = o.w || 0, x0 = o.x || 0;
          const nx = isLeftPg ? Math.min(x0, _PWr - ow) : Math.max(x0, 0);
          if (nx === x0) return;
          const d = nx - x0;
          o.x = nx;
          if (o.type === "shape" && o.shapeType === "line") {
            if (o.x1 != null) o.x1 += d;
            if (o.x2 != null) o.x2 += d;
            if (o.bx != null) o.bx += d;
          }
          if (o.straddle) delete o.straddle;
        });
      });
    } catch (e) {}
    return { dropped };
  }

  // List of currently movable page numbers (2..N).
  function _dmbMovablePages() { const a = []; for (let p = 2; p <= editor.totalPages; p++) a.push(p); return a; }

  // Would moving page `from` to movable-index `toIdx` split any full-spread photo?
  function _dmbSingleMoveWouldSplit(from, toIdx) {
    const seq = _dmbMovablePages(); const i = seq.indexOf(from); if (i < 0) return false;
    seq.splice(i, 1); seq.splice(toIdx, 0, from);
    const pos = {}; seq.forEach((p, idx) => { pos[p] = idx + 2; });
    const spreads = Math.ceil(editor.totalPages / 2);
    for (let si = 0; si < spreads; si++) {
      const sp = editor.spreadPhoto && editor.spreadPhoto[si]; if (!sp || !sp.photoId) continue;
      const nl = pos[si * 2 + 1], nr = pos[si * 2 + 2];
      if (!(nl && nr && nr === nl + 1 && nl % 2 === 1)) return true;
    }
    return false;
  }

  // Commit after any structural change: navigate safely, re-price, re-render, persist.
  function _dmbReorderCommit(label) {
    editor.currentSpread = Math.min(Math.max(0, editor.currentSpread), Math.max(0, editor.totalSpreads - 1));
    // NOTE: the undo snapshot is taken by each caller BEFORE it mutates (so undo restores
    // the pre-reorder state); it must NOT be taken here (that would capture the post-edit state).
    try { updatePrice(); } catch (e) {}
    try { refreshPhotoRule(); } catch (e) {}
    try { _syncSpreadAdderUI(); } catch (e) {}
    try { renderThumbsRail(); } catch (e) {}
    try { renderBuilderCanvas(); } catch (e) {}
    try { _dmbPvReinitAll(); } catch (e) {}
    // Persist (structural change → save + re-key everything for restore).
    try { if (typeof _dmbPersistPhotos === "function") _dmbPersistPhotos(); } catch (e) {}
    try { if (typeof _dmbAutoPersist === "function") _dmbAutoPersist(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
  }

  // Move a single page to a new movable index (0-based among 2..N). Caller has already
  // resolved the split-warning + swap/insert choice.
  function _dmbMoveSinglePage(from, toIdx) {
    const seq = _dmbMovablePages(); const i = seq.indexOf(from); if (i < 0) return;
    pushUndoState("Move page");
    seq.splice(i, 1); seq.splice(toIdx, 0, from);
    _dmbApplyPageSources(seq);
    _dmbReorderCommit("Move page");
  }

  // Swap two single pages (used for the "swap" drop choice).
  function _dmbSwapPages(a, b) {
    const seq = _dmbMovablePages(); const ia = seq.indexOf(a), ib = seq.indexOf(b);
    if (ia < 0 || ib < 0) return;
    pushUndoState("Swap pages");
    const t = seq[ia]; seq[ia] = seq[ib]; seq[ib] = t;
    _dmbApplyPageSources(seq);
    _dmbReorderCommit("Swap pages");
  }

  // Spread mode: page 2 is fixed; reorder the full pairs (3,4),(5,6)… to pair-slot `toPairIdx`.
  function _dmbSpreadPairs() {
    const pairs = []; let trailing = null;
    for (let p = 3; p <= editor.totalPages; p += 2) { if (p + 1 <= editor.totalPages) pairs.push([p, p + 1]); else trailing = p; }
    return { pairs, trailing };
  }
  function _dmbMoveSpread(l, r, toPairIdx) {
    pushUndoState("Move spread");
    const { pairs, trailing } = _dmbSpreadPairs();
    let ps = pairs.filter((pr) => !(pr[0] === l && pr[1] === r));
    ps.splice(toPairIdx, 0, [l, r]);
    const seq = editor.totalPages >= 2 ? [2] : [];
    ps.forEach((pr) => seq.push(pr[0], pr[1]));
    if (trailing != null) seq.push(trailing);
    _dmbApplyPageSources(seq);
    _dmbReorderCommit("Move spread");
  }

  // Delete a single content page (2..N). Everything after it shifts up by one and the
  // total drops by one (odd totals are fine — the last spread just becomes a single page,
  // same as a trailing page). The locked Special pages (0 and 1) can't be deleted. Full-
  // spread photos whose two halves are no longer adjacent get dropped by _dmbApplyPageSources.
  function _dmbDeletePage(p) {
    if (p < 2 || isLockedPage(p)) return;
    if (editor.totalPages <= 1) return;
    // Magazines cannot lose a single page: see _dmbMagRemoveSpreadPair.
    if (window.DMB_MAGAZINE_MODE) { _dmbMagRemoveSpreadPair(p); return; }
    pushUndoState("Delete page");
    // While the customer still has added extra spreads, each deletion first eats into those
    // (drops one +$0.99 charge and keeps extraSpreads from outrunning the real page count).
    // Once extras are exhausted, further deletions trim the paid base tier with no refund.
    if ((editor.extraSpreads || 0) > 0) {
      editor.extraSpreads = Math.max(0, editor.extraSpreads - 1);
    }
    const seq = _dmbMovablePages().filter((x) => x !== p);
    _dmbApplyPageSources(seq);
    _dmbReorderCommit("Delete page");
  }

  // ── A notice the customer has to read ─────────────────────────────────────
  // Deliberately NOT showChoiceDialog: no buttons, no backdrop click, no Escape.
  // The only way out is the X in the top right corner, so it cannot be dismissed
  // by the stray tap that closes everything else on a phone. Used where something
  // happened that the customer did not ask for and has to understand, which is why
  // it explains rather than asks. (2026-10-12)
  function _dmbNoticeDialog(title, message) {
    try {
      const SERIF = "var(--font-heading--family,'Playfair Display'),Georgia,'Times New Roman',serif";
      const SANS  = "var(--font-body--family,'Inter'),system-ui,-apple-system,sans-serif";
      const prev = document.getElementById("dmbNoticeDialog");
      if (prev) prev.remove();

      const overlay = document.createElement("div");
      overlay.id = "dmbNoticeDialog";
      overlay.style.cssText = "position:fixed;inset:0;z-index:1000040;background:rgba(44,40,34,0.55);" +
        "display:flex;align-items:center;justify-content:center;padding:20px;font-family:" + SANS + ";" +
        "opacity:0;transition:opacity .14s ease;";

      const modal = document.createElement("div");
      modal.style.cssText = "position:relative;background:#F7F3EC;border:1px solid #E7E1D4;border-radius:16px;" +
        "padding:30px 26px 24px;max-width:360px;width:100%;text-align:center;box-sizing:border-box;" +
        "box-shadow:0 24px 60px rgba(44,40,34,0.32);transform:translateY(6px);transition:transform .14s ease;";

      const x = document.createElement("button");
      x.type = "button";
      x.setAttribute("aria-label", "Close");
      x.style.cssText = "position:absolute;top:8px;right:8px;width:34px;height:34px;border:0;background:transparent;" +
        "color:#6B6258;cursor:pointer;border-radius:999px;display:flex;align-items:center;justify-content:center;";
      x.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
        'stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      modal.appendChild(x);

      const ttl = document.createElement("div");
      ttl.style.cssText = "font-family:" + SERIF + ";font-weight:700;font-size:20px;line-height:1.2;color:#2C2822;";
      ttl.textContent = title;
      modal.appendChild(ttl);

      const msg = document.createElement("div");
      msg.style.cssText = "font-size:13px;color:#6B6258;line-height:1.55;margin-top:10px;";
      msg.textContent = message;
      modal.appendChild(msg);

      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.style.opacity = "1"; modal.style.transform = "translateY(0)"; });

      const close = function () {
        overlay.style.opacity = "0";
        setTimeout(function () { try { overlay.remove(); } catch (e) {} }, 150);
      };
      x.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      // Swallow every other way out, including a click on the backdrop.
      overlay.addEventListener("click", function (e) { e.stopPropagation(); });
      return overlay;
    } catch (e) { return null; }
  }

  // ── Magazines change length two spreads at a time ─────────────────────────
  // A magazine is printed on folded sheets: one sheet carries FOUR pages, so the
  // total can only move in fours. One spread is two pages, which is half a sheet
  // and cannot be printed on its own. Books are bound differently and are
  // untouched by any of this. (2026-10-12)
  const _DMB_MAG_SPREAD_STEP = 2;          // spreads per add / remove, magazines only
  function _dmbMagStep() { return window.DMB_MAGAZINE_MODE ? _DMB_MAG_SPREAD_STEP : 1; }

  // Price of one magazine add (two spreads). Live from the "spread" product, so it
  // is never out of step with what the cart charges.
  function _dmbMagPairCost() {
    try { return fmtMoney(EXTRA_SPREAD_PRICE * _DMB_MAG_SPREAD_STEP); } catch (e) { return ""; }
  }

  function _dmbMagPairNotice(added) {
    const cost = _dmbMagPairCost();
    const money = added
      ? (cost ? (" They are charged as two spreads, so " + cost + " has been added to your price.") : "")
      : (cost ? (" The " + cost + " they cost has come off your price.") : "");
    _dmbNoticeDialog(
      added ? "Two spreads added" : "Two spreads removed",
      "A magazine is printed on folded sheets, so its pages always come in fours. " +
      "That is why two spreads (4 pages) were " + (added ? "added" : "removed") +
      " together instead of one." + money +
      " If that is not what you wanted, press Undo."
    );
  }

  function _dmbMagFixedLengthNotice() {
    _dmbNoticeDialog(
      "Magazine pages come in fours",
      "A magazine is printed on folded sheets, so pages cannot be taken away one at a " +
      "time. This magazine is the length you chose at the start, and only spreads you " +
      "added yourself can be removed, two at a time. To make it shorter, choose a " +
      "smaller magazine from the page count, or clear this page and use it for " +
      "something else."
    );
  }

  // Insert a new blank spread (2 pages) at movable index `atIdx`; +1 extra spread (price).
  function _dmbInsertSpreadAt(atIdx) {
    const step = _dmbMagStep();            // magazines: 2 spreads = one folded sheet
    pushUndoState(step > 1 ? "Insert 2 spreads" : "Insert spread");
    const seq = _dmbMovablePages();
    const blanks = [];
    for (let i = 0; i < step * 2; i++) blanks.push(null);
    seq.splice.apply(seq, [atIdx, 0].concat(blanks));
    _dmbApplyPageSources(seq);
    editor.extraSpreads = (editor.extraSpreads || 0) + step;
    _dmbReorderCommit("Insert spread");
    if (step > 1) _dmbMagPairNotice(true);
  }

  // Magazine removal: take out the whole four page sheet the page sits on.
  // Only spreads the customer ADDED can go: the rest is the length they chose and
  // paid for, and the recompute in renderSpread would put them straight back.
  function _dmbMagRemoveSpreadPair(p) {
    const extra = editor.extraSpreads || 0;
    if (extra < _DMB_MAG_SPREAD_STEP) { _dmbMagFixedLengthNotice(); return; }
    if (editor.totalPages < 6) { _dmbMagFixedLengthNotice(); return; }
    pushUndoState("Remove 2 spreads");
    // Start at the spread this page belongs to, then slide the four page window
    // back inside the movable range if it would run off either end. Removing four
    // CONSECUTIVE pages shifts everything after by an even number, so every
    // remaining page keeps its side of the fold.
    const si = Math.floor((p - 1) / 2);
    let start = 2 * si + 1;
    start = Math.max(2, Math.min(start, editor.totalPages - 3));
    const kill = {};
    for (let i = 0; i < 4; i++) kill[start + i] = true;
    _dmbApplyPageSources(_dmbMovablePages().filter(function (x) { return !kill[x]; }));
    editor.extraSpreads = Math.max(0, extra - _DMB_MAG_SPREAD_STEP);
    _dmbReorderCommit("Remove 2 spreads");
    _dmbMagPairNotice(false);
  }

  // Overlay a page's "free" objects (stickers, text, shapes, magazine icons) into a mini
  // thumbnail at scaled positions, so a pages-tray card mirrors the real page. Photo-frame
  // photos and slot/template photos are drawn by the main thumbnail code; this adds the
  // decorative layers on top. Returns how many overlay elements were added.
  let _dmbMiniFilterSeq = 0;   // unique <filter> id per map thumbnail
  function _dmbRenderPageOverlay(mini, objs, PW, PH) {
    if (!mini || !Array.isArray(objs) || !objs.length || !PW || !PH) return 0;
    let added = 0;
    // container-type lets text size scale with the thumbnail via cqw units.
    mini.style.containerType = "inline-size";
    const pct = (v, d) => ((v || 0) / d * 100).toFixed(1);
    const sorted = objs.slice().sort((a, b) => (a.z || 0) - (b.z || 0));
    sorted.forEach((o) => {
      if (!o || !o.type) return;
      const rot = o.rotation || 0;
      if (o.type === "sticker") {
        const src = o.tightUrl || o.url; if (!src) return;
        const img = document.createElement("img");
        img.src = src; img.draggable = false;
        img.style.cssText = `position:absolute;left:${pct(o.x,PW)}%;top:${pct(o.y,PH)}%;width:${pct(o.w,PW)}%;height:${pct(o.h,PH)}%;object-fit:contain;transform:rotate(${rot}deg);transform-origin:center center;`;
        mini.appendChild(img); added++;
      } else if (o.type === "mag-icon" && o.iconId && typeof dmbMagIconUrl === "function") {
        const img = document.createElement("img");
        img.src = dmbMagIconUrl(o.iconId); img.draggable = false;
        img.style.cssText = `position:absolute;left:${pct(o.x,PW)}%;top:${pct(o.y,PH)}%;width:${pct(o.w,PW)}%;height:${pct(o.h,PH)}%;object-fit:contain;transform:rotate(${rot}deg);`;
        mini.appendChild(img); added++;
      } else if (o.type === "shape") {
        // Render the ACTUAL shape/line SVG (same builders as the canvas) so the
        // thumbnail matches — outline-only shapes, borders, and true line geometry
        // all show, instead of a flat colored box.
        const d = document.createElement("div");
        d.style.cssText = `position:absolute;left:${pct(o.x,PW)}%;top:${pct(o.y,PH)}%;width:${pct(o.w,PW)}%;height:${pct(o.h,PH)}%;transform:rotate(${rot}deg);transform-origin:center center;overflow:visible;`;
        try {
          d.innerHTML = (o.shapeType === "line")
            ? buildLineSvg(o)
            : buildShapeSvg(o.shapeType, o.fill, o.stroke, o.strokeWidth, (o.opacity != null ? o.opacity : 1), o.cornerRadius, o.w, o.h, o.strokeStyle);
          // buildShapeSvg emits vector-effect:non-scaling-stroke, i.e. a stroke of
          // exactly `strokeWidth` CSS PIXELS whatever size the shape is drawn at.
          // That is right on the canvas (1 builder px = 1 CSS px) but wrong here: a
          // thumbnail is a fraction of the page, so the border keeps its pixel width
          // while the shape shrinks and reads several times too heavy - the same
          // thing that made the tray's map look wrong.
          // `mini` is a container-type:inline-size box, so expressing the width in
          // cqw (% of the thumbnail's width) makes it track the thumbnail at any
          // size, and stays a single isotropic length - which is why the stroke uses
          // non-scaling-stroke in the first place (a 0..100 viewBox stretched to a
          // non-square box would otherwise give a thicker pen on one axis).
          // Lines are already correct: buildLineSvg uses a viewBox of the object's
          // own size with NO vector-effect, so its stroke scales on its own.
          if (o.shapeType !== "line" && PW > 0) {
            const _cq = (v) => (v / PW * 100).toFixed(3) + "cqw";
            d.querySelectorAll("[stroke-width]").forEach((el) => {
              const _sw = parseFloat(el.getAttribute("stroke-width")) || 0;
              if (_sw > 0) el.style.strokeWidth = _cq(_sw);
              const _da = (el.getAttribute("stroke-dasharray") || "").trim();
              if (_da) {
                el.style.strokeDasharray = _da.split(/[\s,]+/)
                  .map((v) => _cq(parseFloat(v) || 0)).join(",");
              }
            });
          }
        } catch (e) { return; }
        mini.appendChild(d); added++;
      } else if (o.type === "map") {
        const d = document.createElement("div");
        d.style.cssText = `position:absolute;left:${pct(o.x,PW)}%;top:${pct(o.y,PH)}%;width:${pct(o.w,PW)}%;height:${pct(o.h,PH)}%;transform:rotate(${rot}deg);transform-origin:center center;`;
        d.innerHTML = o.svg || "";
        const _msvg = d.querySelector("svg");
        if (_msvg) {
          _msvg.style.width = "100%"; _msvg.style.height = "100%"; _msvg.style.display = "block";
          // Re-use the CANVAS styler, so the tray obeys the same rules the page does
          // - hideProvinces, transparentFill, and the showOutline SILHOUETTE ring -
          // instead of stroking every province path and showing internal borders the
          // page hides. Two things make it scale correctly here:
          //   1. wrap the paths in a <g> FIRST. dmbApplyStylesToSvg hangs the filter
          //      on `svgEl.querySelector(":scope > g") || svgEl`, so with a <g> the
          //      filter runs in USER space and dmbEnsureOutlineFilter converts the
          //      radius by vbW / o.w - the ring then tracks the thumbnail at any
          //      size with nothing to measure. (On the page the map has no <g>, the
          //      filter lands on the root <svg>, and CSS-pixel space is correct
          //      because 1 builder px == 1 CSS px there.)
          //   2. the path stroke-width it sets carries non-scaling-stroke, i.e. a
          //      constant number of CSS px, so convert those to user units too.
          try {
            const _g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            while (_msvg.firstChild) _g.appendChild(_msvg.firstChild);
            _msvg.appendChild(_g);
            dmbApplyStylesToSvg(_msvg, Object.assign({}, o, {
              filterId: "dmbOFmini" + (++_dmbMiniFilterSeq),
            }));
          } catch (e) {}
          let _mk = 1;
          try {
            const _vb  = (_msvg.getAttribute("viewBox") || "").trim().split(/[\s,]+/);
            const _vbW = (_vb.length >= 3) ? (parseFloat(_vb[2]) || 0) : 0;
            const _ow  = parseFloat(o.w) || 0;
            if (_vbW > 0 && _ow > 0) _mk = _vbW / _ow;
          } catch (e) {}
          if (_mk !== 1) {
            _msvg.querySelectorAll("path").forEach((path) => {
              const _sw = parseFloat(path.style.strokeWidth) || 0;
              if (_sw > 0) path.style.strokeWidth = (_sw * _mk).toFixed(3);
              const _da = (path.style.strokeDasharray || "").trim();
              if (_da) {
                path.style.strokeDasharray = _da.split(/[\s,]+/)
                  .map((v) => ((parseFloat(v) || 0) * _mk).toFixed(3)).join(",");
              }
              path.style.vectorEffect = "";   // user units now: must scale with the map
            });
          }
        }
        mini.appendChild(d); added++;
      } else if (o.type === "text" && o.text && o.text.trim()) {
        const d = document.createElement("div");
        d.textContent = o.text;
        if (o.rich) {
          // Same share-of-the-width unit the box itself uses, so a word set in a
          // bigger size stays bigger RELATIVE to the rest instead of printing at
          // its real pixel size inside a 90px thumbnail.
          try {
            _dmbApplyRich(d, o.rich, function (px) {
              return px > 0 ? ((px / PW * 100).toFixed(2) + "cqw") : "";
            });
          } catch (eR) {}
        }
        const fpx = parseFloat(o.fontSize || 28) || 28;
        const leftPx = parseFloat(o.left || 0) || 0;
        const topPx = parseFloat(o.top || 0) || 0;
        const wCss = o.width ? `width:${(parseFloat(o.width) / PW * 100).toFixed(1)}%;` : "";
        d.style.cssText = `position:absolute;left:${(leftPx/PW*100).toFixed(1)}%;top:${(topPx/PH*100).toFixed(1)}%;${wCss}font-size:${(fpx/PW*100).toFixed(2)}cqw;line-height:1.2;font-weight:${o.fontWeight||800};color:${o.color||"#666"};font-family:${o.fontFamily||"'Londrina Solid', sans-serif"};${o.textAlign?`text-align:${o.textAlign};`:""}${o.textDecoration?`text-decoration:${o.textDecoration};`:""}white-space:${o.whiteSpace||"pre"};transform:${o.transform||"none"};transform-origin:center center;overflow:hidden;`;
        mini.appendChild(d); added++;
      }
    });
    return added;
  }

  function renderThumbsRail() {
    if (_dmbRenderMode()) return;   // 300 thumbnails of pure memory
    if (!thumbsRail) return;

    thumbsRail.innerHTML = "";

    // Page 0 thumb (special page — always first)
    {
      const card0 = document.createElement("button");
      card0.type = "button";
      card0.className = "dmb-page-thumb";
      card0.dataset.pageNum = "0"; card0.dataset.locked = "1";
      card0.style.textAlign = "left";

      const label0 = document.createElement("div");
      label0.textContent = "Special Page";
      label0.style.fontWeight = "900";
      label0.style.fontSize = "12px";
      label0.style.marginBottom = "6px";
      card0.appendChild(label0);

      const mini0 = document.createElement("div");
      mini0.style.width = "100%";
      mini0.style.aspectRatio = getPageAspectCss();
      mini0.style.borderRadius = "10px";
      mini0.style.border = "1px solid #eee";
      mini0.style.overflow = "hidden";
      mini0.style.position = "relative";
      const _pageBg0 = editor.pageBackgrounds?.[0];
      mini0.style.background = _pageBg0 || "#fafafa";

      const thumbTemplateId0 = getPageTemplateId(0);
      if (thumbTemplateId0) {
        const tag0 = document.createElement("div");
        tag0.textContent = TEMPLATE_NAMES[thumbTemplateId0] || thumbTemplateId0.toUpperCase();
        tag0.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:900;color:#555;";
        mini0.appendChild(tag0);
        (TEMPLATE_DEFS[thumbTemplateId0] || []).forEach((f) => {
          const r = document.createElement("div");
          r.style.position = "absolute";
          r.style.left = f.x + "%";
          r.style.top = f.y + "%";
          r.style.width = f.w + "%";
          r.style.height = f.h + "%";
          r.style.border = "1px solid #ddd";
          r.style.boxSizing = "border-box";
          mini0.appendChild(r);
        });
        const pf0 = editor.pageFrames?.[0] || {};
        Object.entries(pf0).forEach(([slotKey, photoId]) => {
          if (!photoId) return;
          const frameDef = (TEMPLATE_DEFS[thumbTemplateId0] || []).find((x) => x.key === slotKey);
          const ph = getPhotoById(photoId);
          if (!frameDef || !ph) return;
          const img = document.createElement("img");
          img.src = _dmbMiniThumbSrc(ph);
          img.dataset.dmbThumb = ph.id;
          img.style.cssText = `position:absolute;left:${frameDef.x}%;top:${frameDef.y}%;width:${frameDef.w}%;height:${frameDef.h}%;object-fit:cover;`;
          const _tShape0 = editor.pageFrameShapes?.[0]?.[slotKey];
          if (_tShape0) applyDmbFrameShape(img, _tShape0);
          mini0.appendChild(img);
        });
      } else {
        const A0 = editor.pageSlots[0]?.A;
        const B0 = editor.pageSlots[0]?.B;
        if (A0 && !B0) {
          const ph = getPhotoById(A0);
          const img = document.createElement("img");
          img.src = _dmbMiniThumbSrc(ph);
          if (ph) img.dataset.dmbThumb = ph.id;
          img.style.cssText = "width:100%;height:100%;object-fit:cover;";
          mini0.appendChild(img);
        } else if (A0 && B0) {
          const phA = getPhotoById(A0);
          const phB = getPhotoById(B0);
          const top = document.createElement("div");
          top.style.cssText = "position:absolute;left:0;right:0;top:0;height:50%;";
          const imgA = document.createElement("img");
          imgA.src = _dmbMiniThumbSrc(phA);
          if (phA) imgA.dataset.dmbThumb = phA.id;
          imgA.style.cssText = "width:100%;height:100%;object-fit:cover;";
          top.appendChild(imgA);
          const bot = document.createElement("div");
          bot.style.cssText = "position:absolute;left:0;right:0;bottom:0;height:50%;";
          const imgB = document.createElement("img");
          imgB.src = _dmbMiniThumbSrc(phB);
          if (phB) imgB.dataset.dmbThumb = phB.id;
          imgB.style.cssText = "width:100%;height:100%;object-fit:cover;";
          bot.appendChild(imgB);
          mini0.appendChild(top);
          mini0.appendChild(bot);
        } else {
          const _freeObjs0 = Array.isArray(editor.pageObjects?.[0]) ? editor.pageObjects[0] : [];
          const _frames0 = _freeObjs0.filter(o => o.type === "photo-frame" && o.photoId);
          const _pd0 = getPageDims(); const PW0 = _pd0.w, PH0 = _pd0.h;
          if (_frames0.length > 0) {
            _frames0.forEach(o => {
              const _fph = getPhotoById(o.photoId);
              if (!_fph) return;
              const _fi = document.createElement("img");
              _fi.src = _dmbMiniThumbSrc(_fph);
              _fi.dataset.dmbThumb = _fph.id;
              _fi.style.cssText = `position:absolute;left:${(o.x/PW0*100).toFixed(1)}%;top:${(o.y/PH0*100).toFixed(1)}%;width:${(o.w/PW0*100).toFixed(1)}%;height:${(o.h/PH0*100).toFixed(1)}%;object-fit:cover;border-radius:2px;`;
              if (o.frameShape) applyDmbFrameShape(_fi, o.frameShape);
              mini0.appendChild(_fi);
            });
          }
          // stickers / text / shapes drawn by _dmbRenderPageOverlay below.
        }
      }

      // Mirror decorative layers (stickers, text, shapes) on the Special Page card too.
      {
        const _pd0o = getPageDims();
        _dmbRenderPageOverlay(mini0, editor.pageObjects?.[0], _pd0o.w, _pd0o.h);
        if (!mini0.children.length && !_pageBg0) {
          const empty0 = document.createElement("div");
          empty0.textContent = "Empty";
          empty0.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:900;color:#aaa;";
          mini0.appendChild(empty0);
        }
      }

      card0.appendChild(mini0);
      card0.addEventListener("click", () => {
        builderMode = "pages";
        editor.currentSpread = -1;
        renderBuilderCanvas();
        // (no auto-scroll on page-thumbnail click — let the customer control scrolling)
      });
      thumbsRail.appendChild(card0);
    }

    for (let p = 1; p <= editor.totalPages; p++) {
      const card = document.createElement("button");
      card.type = "button";
      card.className = "dmb-page-thumb";
      card.dataset.pageNum = String(p);
      if (p === 1 || isLockedPage(p)) card.dataset.locked = "1";
      card.style.textAlign = "left";

      const label = document.createElement("div");
      label.textContent = `Page ${p}`;
      label.style.fontWeight = "900";
      label.style.fontSize = "12px";
      label.style.marginBottom = "6px";
      card.appendChild(label);

      const mini = document.createElement("div");
      mini.style.width = "100%";
      mini.style.aspectRatio = getPageAspectCss();
      mini.style.borderRadius = "10px";
      mini.style.border = "1px solid #eee";
      mini.style.overflow = "hidden";
      mini.style.position = "relative";
      // Mirror the page's background color (falls back to the empty-page grey).
      const _pageBg = editor.pageBackgrounds?.[p];
      mini.style.background = _pageBg || "#fafafa";

      if (isLockedPage(p)) {
        const sp = document.createElement("div");
        sp.textContent = "SPECIAL";
        sp.style.position = "absolute";
        sp.style.inset = "0";
        sp.style.display = "flex";
        sp.style.alignItems = "center";
        sp.style.justifyContent = "center";
        sp.style.fontSize = "11px";
        sp.style.fontWeight = "900";
        sp.style.color = "#777";
        mini.appendChild(sp);
      } else {
        const thumbTemplateId = getPageTemplateId(p);

        if (thumbTemplateId) {
          const tag = document.createElement("div");
          tag.textContent = TEMPLATE_NAMES[thumbTemplateId] || thumbTemplateId.toUpperCase();
          tag.style.position = "absolute";
          tag.style.inset = "0";
          tag.style.display = "flex";
          tag.style.alignItems = "center";
          tag.style.justifyContent = "center";
          tag.style.fontSize = "10px";
          tag.style.fontWeight = "900";
          tag.style.color = "#555";
          mini.appendChild(tag);

          (TEMPLATE_DEFS[thumbTemplateId] || []).forEach((f) => {
            const _fp = _dmbLayoutFramePct(f);
            const r = document.createElement("div");
            r.style.position = "absolute";
            r.style.left = _fp.x + "%";
            r.style.top = _fp.y + "%";
            r.style.width = _fp.w + "%";
            r.style.height = _fp.h + "%";
            r.style.border = "1px solid #ddd";
            r.style.boxSizing = "border-box";
            mini.appendChild(r);
          });

          const pageFrames = editor.pageFrames?.[p] || {};
          Object.entries(pageFrames).forEach(([slotKey, photoId]) => {
            if (!photoId) return;
            const frameDef = (TEMPLATE_DEFS[thumbTemplateId] || []).find((x) => x.key === slotKey);
            const ph = getPhotoById(photoId);
            if (!frameDef || !ph) return;

            const _fpi = _dmbLayoutFramePct(frameDef);
            const img = document.createElement("img");
            img.src = _dmbMiniThumbSrc(ph);
            img.dataset.dmbThumb = ph.id;
            img.style.position = "absolute";
            img.style.left = _fpi.x + "%";
            img.style.top = _fpi.y + "%";
            img.style.width = _fpi.w + "%";
            img.style.height = _fpi.h + "%";
            img.style.objectFit = "cover";
            const _tShape = editor.pageFrameShapes?.[p]?.[slotKey];
            if (_tShape) applyDmbFrameShape(img, _tShape);
            mini.appendChild(img);
          });
        } else {
          // Check for full-spread photo first
          const thumbSi = Math.floor((p - 1) / 2);
          const thumbSp = editor.spreadPhoto?.[thumbSi];
          if (thumbSp?.photoId) {
            const ph = getPhotoById(thumbSp.photoId);
            if (ph) {
              const img = document.createElement("img");
              img.src = _dmbMiniThumbSrc(ph);
              img.dataset.dmbThumb = ph.id;
              img.style.width = "100%";
              img.style.height = "100%";
              img.style.objectFit = "cover";
              mini.appendChild(img);
            }
          }

          const A = editor.pageSlots[p]?.A;
          const B = editor.pageSlots[p]?.B;

          if (!thumbSp?.photoId && A && !B) {
            const ph = getPhotoById(A);
            const img = document.createElement("img");
            img.src = _dmbMiniThumbSrc(ph);
            if (ph) img.dataset.dmbThumb = ph.id;
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.objectFit = "cover";
            mini.appendChild(img);
          } else if (!thumbSp?.photoId && A && B) {
            const phA = getPhotoById(A);
            const phB = getPhotoById(B);

            const _thumbLS = dmbIsLandscape();
            const top = document.createElement("div");
            top.style.position = "absolute";
            if (_thumbLS) { top.style.left = "0"; top.style.top = "0"; top.style.bottom = "0"; top.style.width = "50%"; }
            else { top.style.left = "0"; top.style.right = "0"; top.style.top = "0"; top.style.height = "50%"; }

            const imgA = document.createElement("img");
            imgA.src = _dmbMiniThumbSrc(phA);
            if (phA) imgA.dataset.dmbThumb = phA.id;
            imgA.style.width = "100%";
            imgA.style.height = "100%";
            imgA.style.objectFit = "cover";
            top.appendChild(imgA);

            const bot = document.createElement("div");
            bot.style.position = "absolute";
            if (_thumbLS) { bot.style.right = "0"; bot.style.top = "0"; bot.style.bottom = "0"; bot.style.width = "50%"; }
            else { bot.style.left = "0"; bot.style.right = "0"; bot.style.bottom = "0"; bot.style.height = "50%"; }

            const imgB = document.createElement("img");
            imgB.src = _dmbMiniThumbSrc(phB);
            if (phB) imgB.dataset.dmbThumb = phB.id;
            imgB.style.width = "100%";
            imgB.style.height = "100%";
            imgB.style.objectFit = "cover";
            bot.appendChild(imgB);

            const divider = document.createElement("div");
            divider.style.position = "absolute";
            divider.style.background = "rgba(0,0,0,0.12)";
            if (_thumbLS) { divider.style.top = "0"; divider.style.bottom = "0"; divider.style.left = "50%"; divider.style.width = "1px"; }
            else { divider.style.left = "0"; divider.style.right = "0"; divider.style.top = "50%"; divider.style.height = "1px"; }

            mini.appendChild(top);
            mini.appendChild(bot);
            mini.appendChild(divider);
          } else if (!thumbSp?.photoId) {
            // Check for free objects (frames with photos, text, stickers, maps)
            const _freeObjs = Array.isArray(editor.pageObjects?.[p]) ? editor.pageObjects[p] : [];
            const _framesWithPhoto = _freeObjs.filter(o => o.type === "photo-frame" && o.photoId);
            const _pdT = getPageDims(); const PAGE_W_THUMB = _pdT.w, PAGE_H_THUMB = _pdT.h;

            if (_framesWithPhoto.length > 0) {
              // Render free frame photos at scaled positions
              _framesWithPhoto.forEach(o => {
                const _fph = getPhotoById(o.photoId);
                if (!_fph) return;
                const _fi = document.createElement("img");
                _fi.src = _dmbMiniThumbSrc(_fph);
                _fi.dataset.dmbThumb = _fph.id;
                _fi.style.cssText = `position:absolute;left:${(o.x/PAGE_W_THUMB*100).toFixed(1)}%;top:${(o.y/PAGE_H_THUMB*100).toFixed(1)}%;width:${(o.w/PAGE_W_THUMB*100).toFixed(1)}%;height:${(o.h/PAGE_H_THUMB*100).toFixed(1)}%;object-fit:cover;border-radius:2px;`;
                if (o.frameShape) applyDmbFrameShape(_fi, o.frameShape);
                mini.appendChild(_fi);
              });
            }
            // Stickers / text / shapes (and remaining free objects) are drawn by
            // _dmbRenderPageOverlay below; the "Empty" label is decided after that.
          }
        }
      }

      // Mirror decorative layers (stickers, text, shapes, mag-icons) on top, then only
      // label the card "Empty" if nothing at all rendered and no background color is set.
      if (!isLockedPage(p)) {
        const _pd = getPageDims();
        _dmbRenderPageOverlay(mini, editor.pageObjects?.[p], _pd.w, _pd.h);
        if (!mini.children.length && !_pageBg) {
          const empty = document.createElement("div");
          empty.textContent = "Empty";
          empty.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:900;color:#aaa;";
          mini.appendChild(empty);
        }
      }

      card.appendChild(mini);

      // Hover delete (circle-X): removes just this one page. Only on real content
      // pages (2..N, never the locked Special pages). Sits on top of the card and
      // swallows its own mouse/drag events so it never starts a reorder-drag.
      if (p >= 2 && !isLockedPage(p)) {
        const del = document.createElement("button");
        del.type = "button";
        del.className = "dmb-page-del";
        del.setAttribute("aria-label", "Delete page " + p);
        del.title = "Delete this page";
        del.draggable = false;
        del.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg>`;
        del.addEventListener("mousedown", (e) => { e.stopPropagation(); });
        del.addEventListener("dragstart", (e) => { e.preventDefault(); e.stopPropagation(); });
        del.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          _dmbDeletePage(p);
        });
        card.appendChild(del);
      }

      card.addEventListener("click", () => {
        builderMode = "pages";
        editor.currentSpread = Math.floor((p - 1) / 2);
        renderBuilderCanvas();
        // (no auto-scroll on page-thumbnail click — let the customer control scrolling)
      });

      thumbsRail.appendChild(card);
    }
    // Desktop: layer drag-to-reorder + insert affordances over the rail.
    try { _dmbBuildPageReorderUI(); } catch (e) {}
  }

  // ── Page reorder UI (desktop only) ─────────────────────────────────────────
  // Groups the page thumbnails into spread pairs, adds a ⣿ grip per movable pair
  // (drag = move whole spread), makes each movable page draggable (drag = move that
  // one page), shows a black insertion line while dragging, and reveals a "+" in the
  // gaps between spreads to insert a new blank spread. Single-page drops ask
  // swap-vs-insert; a drop that would split a full-spread photo warns first.
  let _dmbPageDrag = null;   // { kind:'page'|'spread', page?, pair? }

  // Build an off-screen drag ghost that shows BOTH pages of a spread side by side.
  // The native drag image would only show the single card that fired `dragstart`,
  // which looks like just one page is moving. We clone both cards, strip the delete
  // "X"/insert-zones, lay them flush together, and hand it to setDragImage(). The
  // node lives off-screen and is removed on the next tick.
  function _dmbBuildSpreadDragGhost(pair) {
    const cl = _dmbCardByPage(pair[0]), cr = _dmbCardByPage(pair[1]);
    if (!cl || !cr) return null;
    const wrap = document.createElement("div");
    wrap.className = "dmb-spread-drag-ghost";
    // Bigger, fully opaque, bold dark frame — browsers render drag images with some
    // built-in transparency, so we over-build the contrast/size to stay clearly visible.
    wrap.style.cssText = "position:fixed;top:-10000px;left:-10000px;display:flex;gap:0;" +
      "pointer-events:none;background:#fff;border:3px solid #111;border-radius:14px;" +
      "overflow:hidden;box-shadow:0 12px 30px rgba(0,0,0,.45);opacity:0.65;";
    [cl, cr].forEach((card, i) => {
      const clone = card.cloneNode(true);
      clone.classList.remove("dmb-pt-big", "active");
      clone.style.transform = "none";
      clone.style.margin = "0";
      clone.style.border = "none";
      clone.style.borderRadius = "0";
      clone.style.width = "150px";       // scale each page up (default thumb is 112px)
      clone.style.background = "#fff";
      if (i === 1) clone.style.borderLeft = "2px solid #111";   // center seam of the spread
      clone.querySelectorAll(".dmb-page-del, .dmb-insert-zone, .dmb-drop-line, .dmb-spread-box")
        .forEach((n) => n.remove());
      wrap.appendChild(clone);
    });
    document.body.appendChild(wrap);
    return wrap;
  }

  function _dmbBuildPageReorderUI() {
    if (!thumbsRail) return;
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) return; // desktop only
    thumbsRail.classList.add("dmb-rail-reorder");
    const cards = Array.from(thumbsRail.querySelectorAll(".dmb-page-thumb"));
    // index cards by page number
    const cardByPage = {};
    cards.forEach((c) => { cardByPage[c.dataset.pageNum] = c; });

    // Tag each spread pair on BOTH its cards (drives spread-hover + spread-drag).
    const { pairs } = _dmbSpreadPairs();
    pairs.forEach(([l, r]) => {
      const a = cardByPage[String(l)], b = cardByPage[String(r)];
      if (a) { a._dmbPair = [l, r]; a.classList.add("dmb-pt-spread-start"); }
      if (b) { b._dmbPair = [l, r]; b.classList.add("dmb-pt-spread-end"); }
    });

    // Movable cards are draggable. The drag KIND (single page vs whole spread) comes
    // from the current HOVER MODE (set by _dmbRailHover): hovering a page BODY enlarges
    // just that page → single-page drag; hovering BETWEEN the pair or within a few px
    // AROUND it enlarges both pages → whole-spread drag. (No ⣿ grip.)
    cards.forEach((c) => {
      const p = +c.dataset.pageNum;
      if (c.dataset.locked === "1" || p < 2) return;
      c.draggable = true;
      c.classList.add("dmb-pt-draggable");
      c.addEventListener("dragstart", (e) => {
        _dmbPageDrag = (_dmbHoverMode && _dmbHoverMode.kind === "spread" && _dmbHoverMode.pair)
          ? { kind: "spread", pair: _dmbHoverMode.pair }
          : { kind: "page", page: p };
        try { e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/x-dmb", "1"); } catch (err) {}
        // Whole-spread drag → show BOTH pages in the drag ghost so it's obvious the
        // pair moves together (native drag would only ghost the one card under the cursor).
        if (_dmbPageDrag.kind === "spread" && _dmbPageDrag.pair && e.dataTransfer && e.dataTransfer.setDragImage) {
          try {
            const ghost = _dmbBuildSpreadDragGhost(_dmbPageDrag.pair);
            if (ghost) {
              e.dataTransfer.setDragImage(ghost, ghost.offsetWidth / 2, ghost.offsetHeight / 2);
              setTimeout(() => { try { ghost.remove(); } catch (_e) {} }, 0);
            }
          } catch (err) {}
        }
        thumbsRail.classList.add("dmb-rail-dragging");
        _dmbClearHover();   // stop enlarging while dragging
      });
      c.addEventListener("dragend", () => { _dmbPageDrag = null; thumbsRail.classList.remove("dmb-rail-dragging"); _dmbClearDropLine(); });
    });

    // Insertion line (reused).
    if (!thumbsRail.querySelector(".dmb-drop-line")) {
      const line = document.createElement("div"); line.className = "dmb-drop-line"; thumbsRail.appendChild(line);
    }
    // Spread-selection rectangle (the platform shown under a pair in spread mode).
    if (!thumbsRail.querySelector(".dmb-spread-box")) {
      const b = document.createElement("div"); b.className = "dmb-spread-box"; thumbsRail.appendChild(b);
    }

    _dmbWirePageRailHover();
    _dmbWirePageRailDnD();
    _dmbBuildInsertZones(cardByPage, pairs);   // collapsed gaps that open on hover (CSS)
  }

  // Rail-level hover: enlarge ONE page (hover its body) or BOTH pages of a pair (hover
  // between them / within ~20px around the pair), and remember the resulting drag mode.
  let _dmbHoverMode = null;   // null | {kind:'single',page} | {kind:'spread',pair}
  function _dmbWirePageRailHover() {
    if (thumbsRail._dmbHoverWired) return;
    thumbsRail._dmbHoverWired = true;
    thumbsRail.addEventListener("mousemove", (e) => { if (!_dmbPageDrag) _dmbRailHover(e); });
    thumbsRail.addEventListener("mouseleave", () => _dmbClearHover());
  }
  function _dmbCardByPage(p) { return thumbsRail.querySelector('.dmb-page-thumb[data-page-num="' + p + '"]'); }
  function _dmbSetHover(mode) {
    _dmbHoverMode = mode;
    thumbsRail.querySelectorAll(".dmb-pt-big").forEach((el) => el.classList.remove("dmb-pt-big"));
    const box = thumbsRail.querySelector(".dmb-spread-box");
    if (box) box.style.display = "none";
    if (!mode) return;
    if (mode.kind === "spread" && mode.pair) {
      const cl = _dmbCardByPage(mode.pair[0]), cr = _dmbCardByPage(mode.pair[1]);
      [cl, cr].forEach((c) => { if (c) c.classList.add("dmb-pt-big"); });
      if (cl && cr && box) {
        // Rectangle UNDER both pages of the pair (a platform holding the spread).
        const PAD = 11;
        const left   = Math.min(cl.offsetLeft, cr.offsetLeft) - PAD;
        const right  = Math.max(cl.offsetLeft + cl.offsetWidth, cr.offsetLeft + cr.offsetWidth) + PAD;
        const top    = Math.min(cl.offsetTop, cr.offsetTop) - PAD;
        const bottom = Math.max(cl.offsetTop + cl.offsetHeight, cr.offsetTop + cr.offsetHeight) + PAD;
        box.style.left = left + "px"; box.style.top = top + "px";
        box.style.width = (right - left) + "px"; box.style.height = (bottom - top) + "px";
        box.style.display = "block";
      }
    } else if (mode.kind === "single") {
      const c = _dmbCardByPage(mode.page); if (c) c.classList.add("dmb-pt-big");
    }
  }
  function _dmbClearHover() { _dmbSetHover(null); }
  function _dmbRailHover(e) {
    const M = 22;   // "a certain px" band for the SPREAD trigger (seam + top + bottom)
    const movable = Array.from(thumbsRail.querySelectorAll(".dmb-page-thumb"))
      .filter((c) => +c.dataset.pageNum >= 2)
      .sort((a, b) => (+a.dataset.pageNum) - (+b.dataset.pageNum));
    if (!movable.length) { _dmbClearHover(); return; }
    const x = e.clientX, y = e.clientY;
    // over a card?
    let over = null;
    for (const c of movable) { const r = c.getBoundingClientRect(); if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) { over = c; break; } }
    if (over) {
      const r = over.getBoundingClientRect();
      let spread = false;
      if (over._dmbPair) {
        // Spread trigger = the pair's shared boundary: the SEAM edge (facing its
        // partner) + top + bottom. The OUTER edge (facing a between-spreads gap) is
        // left free so the insert-"+" zone can be nice and sensitive there.
        const isStart = over._dmbPair[0] === (+over.dataset.pageNum);
        const nearSeam = isStart ? ((r.right - x) < M) : ((x - r.left) < M);
        spread = nearSeam || (y - r.top < M) || (r.bottom - y < M);
      }
      _dmbSetHover(spread ? { kind: "spread", pair: over._dmbPair } : { kind: "single", page: +over.dataset.pageNum });
      return;
    }
    // in a gap: is it the SEAM within a pair? → spread. Otherwise clear (insert-zone CSS handles gaps).
    let left = null, right = null;
    for (let i = 0; i < movable.length; i++) {
      const r = movable[i].getBoundingClientRect();
      if (r.right <= x) left = movable[i];
      if (!right && r.left >= x) right = movable[i];
    }
    if (left && right && left._dmbPair && left._dmbPair[0] === (+left.dataset.pageNum) && left._dmbPair[1] === (+right.dataset.pageNum)) {
      _dmbSetHover({ kind: "spread", pair: left._dmbPair });
    } else {
      _dmbClearHover();
    }
  }

  function _dmbClearDropLine() {
    const line = thumbsRail && thumbsRail.querySelector(".dmb-drop-line");
    if (line) line.style.display = "none";
  }

  // Compute the drop gap under the cursor: returns { idx, x } where idx is the
  // movable-index (0-based among 2..N) the dragged item would be inserted BEFORE.
  function _dmbDropTargetAtX(clientX) {
    const movable = Array.from(thumbsRail.querySelectorAll('.dmb-page-thumb'))
      .filter((c) => +c.dataset.pageNum >= 2)
      .sort((a, b) => (+a.dataset.pageNum) - (+b.dataset.pageNum));
    if (!movable.length) return null;
    // Determine insertion index by comparing cursor with each card's mid-x.
    let idx = movable.length; let lineX = null;
    for (let i = 0; i < movable.length; i++) {
      const r = movable[i].getBoundingClientRect();
      const mid = r.left + r.width / 2;
      if (clientX < mid) { idx = i; lineX = r.left - 4; break; }
    }
    if (lineX == null) { const r = movable[movable.length - 1].getBoundingClientRect(); lineX = r.right + 4; }
    return { idx, lineX };
  }

  function _dmbWirePageRailDnD() {
    if (thumbsRail._dmbDndWired) return; // wire the rail-level listeners once
    thumbsRail._dmbDndWired = true;
    const line = () => thumbsRail.querySelector(".dmb-drop-line");
    thumbsRail.addEventListener("dragover", (e) => {
      if (!_dmbPageDrag) return;
      e.preventDefault();
      try { e.dataTransfer.dropEffect = "move"; } catch (err) {}
      const t = _dmbDropTargetAtX(e.clientX);
      const l = line();
      if (t && l) {
        const railRect = thumbsRail.getBoundingClientRect();
        l.style.display = "block";
        l.style.left = (t.lineX - railRect.left + thumbsRail.scrollLeft) + "px";
      }
    });
    thumbsRail.addEventListener("drop", (e) => {
      if (!_dmbPageDrag) return;
      e.preventDefault();
      const t = _dmbDropTargetAtX(e.clientX);
      _dmbClearDropLine();
      const drag = _dmbPageDrag; _dmbPageDrag = null;
      thumbsRail.classList.remove("dmb-rail-dragging");
      if (!t) return;
      _dmbHandlePageDrop(drag, t.idx);
    });
    thumbsRail.addEventListener("dragleave", (e) => {
      if (e.target === thumbsRail && !thumbsRail.contains(e.relatedTarget)) _dmbClearDropLine();
    });
  }

  // Handle a completed drop. `idx` = movable-index (0-based among 2..N) to insert BEFORE.
  async function _dmbHandlePageDrop(drag, idx) {
    const movable = _dmbMovablePages();
    if (drag.kind === "spread") {
      const [l, r] = drag.pair;
      const { pairs } = _dmbSpreadPairs();
      const origSlot = pairs.findIndex((pr) => pr[0] === l);
      if (origSlot < 0) return;
      let rawTarget = Math.max(0, Math.min(Math.round((idx - 1) / 2), pairs.length));
      let toPairIdx = (origSlot < rawTarget) ? rawTarget - 1 : rawTarget;
      toPairIdx = Math.max(0, Math.min(toPairIdx, pairs.length - 1));
      if (toPairIdx === origSlot) return;
      _dmbMoveSpread(l, r, toPairIdx);
      return;
    }
    // single page
    const from = drag.page;
    const fromIdx = movable.indexOf(from);
    if (fromIdx < 0) return;
    if (idx === fromIdx || idx === fromIdx + 1) return;   // dropped in its own slot
    const swapPartner = movable[idx];                     // page displaced (undefined if end)
    let mode = "insert";
    if (swapPartner != null) {
      const choice = await showChoiceDialog(
        "Move this page",
        `Drop Page ${from} here — swap it with Page ${swapPartner}, or insert it and shift the rest?`,
        [ { id: "insert", label: `Insert Page ${from} here (shift the rest)` },
          { id: "swap",   label: `Swap Page ${from} and Page ${swapPartner}` },
          { id: "cancel", label: "Cancel" } ]
      );
      if (!choice || choice === "cancel") return;
      mode = choice;
    }
    if (mode === "swap") { _dmbSwapPages(from, swapPartner); return; }
    // insert — adjust target index for the removal of `from`
    const toIdx = (fromIdx < idx) ? idx - 1 : idx;
    if (_dmbSingleMoveWouldSplit(from, toIdx)) {
      const ok = await showChoiceDialog(
        "Full-spread photo",
        "Moving this page will separate a photo that spans a whole spread, so that photo will be removed. Continue?",
        [ { id: "yes", label: "Move it (remove the spread photo)" }, { id: "no", label: "Cancel" } ]
      );
      if (ok !== "yes") return;
    }
    _dmbMoveSinglePage(from, toIdx);
  }

  // Hover-"+" zones in the gaps BETWEEN spreads (click inserts a blank spread there).
  function _dmbBuildInsertZones(cardByPage, pairs) {
    const mk = (movableIdx) => {
      const z = document.createElement("div");
      z.className = "dmb-insert-zone";
      try {
        z.title = window.DMB_MAGAZINE_MODE
          ? ("Insert two blank spreads here (4 pages, " + _dmbMagPairCost() + ")")
          : ("Insert a blank spread here (2 pages, " + fmtMoney(EXTRA_SPREAD_PRICE) + ")");
      } catch (e) { z.title = "Insert a blank spread here"; }
      const plus = document.createElement("div");
      plus.className = "dmb-insert-plus"; plus.textContent = "+";
      z.appendChild(plus);
      z.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); _dmbInsertSpreadAt(movableIdx); });
      return z;
    };
    pairs.forEach(([l]) => {
      const startCard = cardByPage[String(l)];
      if (startCard && startCard.parentNode) startCard.parentNode.insertBefore(mk(l - 2), startCard);
    });
    const movableCards = Array.from(thumbsRail.querySelectorAll(".dmb-page-thumb")).filter((c) => +c.dataset.pageNum >= 2);
    const last = movableCards[movableCards.length - 1];
    if (last && last.parentNode) {
      const z = mk(_dmbMovablePages().length);
      if (last.nextSibling) last.parentNode.insertBefore(z, last.nextSibling); else last.parentNode.appendChild(z);
    }
  }

  // "+ Add a spread" → ask before/after the CURRENT spread, then insert a blank spread.
  async function _dmbAddSpreadPrompt() {
    const cur = (typeof editor.currentSpread === "number") ? editor.currentSpread : 0;
    // Magazines get two spreads per add, so every label here says so.
    const _mt = window.DMB_MAGAZINE_MODE ? "Add 2 spreads" : "Add a spread";
    const _mw = window.DMB_MAGAZINE_MODE ? "two blank spreads" : "the new blank spread";
    // Say the cost before anything is added, while Cancel is still on the screen.
    let _mc = "";
    try {
      _mc = window.DMB_MAGAZINE_MODE
        ? (" A magazine adds pages in fours, so this is 4 pages for " + _dmbMagPairCost() + ".")
        : (" That is 2 pages for " + fmtMoney(EXTRA_SPREAD_PRICE) + ".");
    } catch (e) {}
    // On the Special Page (currentSpread -1) or the first spread (0), pages 1 & 2 are the
    // fixed intro — a new spread can't go before them, only AFTER page 2. Tell the customer
    // and add it there, instead of offering a "before" that isn't allowed.
    if (cur <= 0) {
      const ok = await showChoiceDialog(
        _mt,
        "Pages 1 and 2 are the fixed intro, so new pages can only be added after page 2." + _mc,
        [ { id: "ok",     label: "Add after page 2" },
          { id: "cancel", label: "Cancel" } ]
      );
      if (!ok || ok === "cancel") return;
      _dmbInsertSpreadAt(1);   // movable index 1 = right after page 2
      return;
    }
    const si = Math.max(0, cur);
    const choice = await showChoiceDialog(
      _mt,
      "Where would you like " + _mw + "?" + _mc,
      [ { id: "after",  label: "After the spread I'm on" },
        { id: "before", label: "Before the spread I'm on" },
        { id: "cancel", label: "Cancel" } ]
    );
    if (!choice || choice === "cancel") return;
    const movLen = _dmbMovablePages().length;
    let movableIdx = (choice === "before") ? (si * 2 - 1) : (si * 2 + 1);
    // Never allow inserting before page 2 (min index 1); clamp to the end otherwise.
    movableIdx = Math.max(1, Math.min(movableIdx, movLen));
    _dmbInsertSpreadAt(movableIdx);
  }

  function updateCoverZoneButtons() {
    const frontBtn = $("coverZoneFrontBtn");
    const backBtn = $("coverZoneBackBtn");
    const spineBtn = $("coverZoneSpineBtn");

    [frontBtn, backBtn, spineBtn].forEach((btn) => {
      if (btn) btn.classList.remove("active");
    });

    if (activeCoverZone === "front" && frontBtn) frontBtn.classList.add("active");
    if (activeCoverZone === "back" && backBtn) backBtn.classList.add("active");
    if (activeCoverZone === "spine" && spineBtn) spineBtn.classList.add("active");
  }
  function makeHint(text) {
    const hint = document.createElement("div");
    hint.textContent = text;
    hint.style.position = "absolute";
    hint.style.inset = "14px";
    hint.style.border = "2px dashed #ddd";
    hint.style.borderRadius = "12px";
    hint.style.display = "flex";
    hint.style.alignItems = "center";
    hint.style.justifyContent = "center";
    hint.style.color = "#888";
    hint.style.fontWeight = "900";
    hint.style.fontSize = "12px";
    hint.style.pointerEvents = "none";
    return hint;
  }

  function handleDropOnPage(pageNumber, clientY, payload, dataTransfer, bodyEl, clientX) {
    if (isLockedPage(pageNumber)) return;

    if (isTemplatePage(pageNumber)) {
      const photoId = (() => {
        if (payload && payload.photoId) return payload.photoId;

        const tp = dataTransfer ? (dataTransfer.getData("text/plain") || "").trim() : "";
        if (!tp) return "";

        if (tp[0] === "{") {
          try {
            const obj = JSON.parse(tp);
            return obj.photoId || "";
          } catch {
            return "";
          }
        }
        return tp;
      })();

      if (!photoId) return;

      const targetRect = pickNearestTemplateFrame(bodyEl, pageNumber, clientX ?? 0, clientY ?? 0);
      if (!targetRect) return;

      const slotKey = targetRect.key;
      const currentInTarget = getFramePhotoId(pageNumber, slotKey);

      const used = getUsedPhotoIds();
      const isReusedPhoto = payload?.type === "photo" && used.has(photoId);
      if (isReusedPhoto) showReuseNotice();

      pushUndoState();

      if (payload && payload.type === "placed") {
        const fromPage = Number(payload.fromPage);
        const fromSlot = payload.fromSlot;

        if (fromPage && fromSlot) {
          if (fromPage === pageNumber && fromSlot === slotKey) return;

          const replaced = currentInTarget;
          const replacedRot = getFrameRotation(pageNumber, slotKey);

          setFramePhotoId(pageNumber, slotKey, photoId);
          setFrameRotation(pageNumber, slotKey, 0);

          if (replaced) {
            setFramePhotoId(fromPage, fromSlot, replaced);
            setFrameRotation(fromPage, fromSlot, replacedRot);
          } else {
            clearFrame(fromPage, fromSlot);

            if (!isTemplatePage(fromPage)) {
              if (fromSlot === "A" && editor.pageSlots[fromPage]?.B) {
                editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
                editor.pageSlots[fromPage].B = null;
                editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
                editor.pageRot[fromPage].B = 0;
              }
            }
          }

          renderSpread();
          renderThumbsRail();
          renderPhotoTray();
          return;
        }
      }

      setFramePhotoId(pageNumber, slotKey, photoId);
      setFrameRotation(pageNumber, slotKey, 0);

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    const photoId = (() => {
      if (payload && payload.photoId) return payload.photoId;

      const tp = dataTransfer ? (dataTransfer.getData("text/plain") || "").trim() : "";
      if (!tp) return "";

      if (tp[0] === "{") {
        try {
          const obj = JSON.parse(tp);
          return obj.photoId || "";
        } catch {
          return "";
        }
      }
      return tp;
    })();

    if (!photoId) return;

    const targetA = editor.pageSlots[pageNumber]?.A || null;
    const targetB = editor.pageSlots[pageNumber]?.B || null;
    const targetRotA = editor.pageRot?.[pageNumber]?.A || 0;
    const targetRotB = editor.pageRot?.[pageNumber]?.B || 0;

    const used = getUsedPhotoIds();
    const isReusedPhoto = payload?.type === "photo" && used.has(photoId);
    if (isReusedPhoto) showReuseNotice();

    const rect = bodyEl.getBoundingClientRect();
    const y = (typeof clientY === "number" ? clientY : rect.top) - rect.top;
    const mid = rect.height / 2;
    const droppedOnTop = y < mid;

    pushUndoState();

    if (payload && payload.type === "placed") {
      const fromPage = Number(payload.fromPage);
      const fromSlot = payload.fromSlot;

      if (fromPage && fromSlot && editor.pageSlots[fromPage]) {
        if (
          !(
            (fromPage === pageNumber && fromSlot === "A" && targetA === photoId && !targetB) ||
            (fromPage === pageNumber && fromSlot === "B" && targetB === photoId)
          )
        ) {
          editor.pageSlots[fromPage][fromSlot] = null;
          editor.pageRot[fromPage][fromSlot] = 0;

          if (!editor.pageSlots[fromPage].A && editor.pageSlots[fromPage].B) {
            editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
            editor.pageSlots[fromPage].B = null;
            editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
            editor.pageRot[fromPage].B = 0;
          }
        }
      }
    }

    if (!targetA && !targetB) {
      editor.pageSlots[pageNumber].A = photoId;
      editor.pageSlots[pageNumber].B = null;
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    if (targetA && !targetB) {
      const old = targetA;
      const oldRot = targetRotA;

      if (droppedOnTop) {
        editor.pageSlots[pageNumber].A = photoId;
        editor.pageSlots[pageNumber].B = old;
        editor.pageRot[pageNumber].A = 0;
        editor.pageRot[pageNumber].B = oldRot;
      } else {
        editor.pageSlots[pageNumber].A = old;
        editor.pageSlots[pageNumber].B = photoId;
        editor.pageRot[pageNumber].A = oldRot;
        editor.pageRot[pageNumber].B = 0;
      }

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    if (targetA && targetB) {
      const replaceSlot = droppedOnTop ? "A" : "B";
      const replaced = editor.pageSlots[pageNumber][replaceSlot];
      const replacedRot = editor.pageRot[pageNumber][replaceSlot] || 0;

      editor.pageSlots[pageNumber][replaceSlot] = photoId;
      editor.pageRot[pageNumber][replaceSlot] = 0;

      if (payload && payload.type === "placed") {
        const fromPage = Number(payload.fromPage);
        const fromSlot = payload.fromSlot;

        if (replaced && fromPage && fromSlot && editor.pageSlots[fromPage]) {
          editor.pageSlots[fromPage][fromSlot] = replaced;
          editor.pageRot[fromPage][fromSlot] = replacedRot;

          if (!editor.pageSlots[fromPage].A && editor.pageSlots[fromPage].B) {
            editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
            editor.pageSlots[fromPage].B = null;
            editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
            editor.pageRot[fromPage].B = 0;
          }
        }
      }

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
    }
  }

  // ---------- Non-destructive crop model ----------
  // Cropping never overwrites a source photo. Instead it makes a DERIVED photo (id =
  // "<sourceId>__dmbCropOf__<unique>") holding the cropped bytes, keeps the original in
  // the tray untouched, and points ONLY that one placement (page slot, free frame, cover
  // zone, layout frame) at the derived photo. The id itself encodes the source, so the
  // relationship round-trips through save/restore with no schema change, and Reset simply
  // points the placement back at the source and drops the derived photo.
  const _DMB_CROP_TAG = "__dmbCropOf__";
  function _dmbIsCropDerived(ph) {
    return !!(ph && typeof ph.id === "string" && ph.id.indexOf(_DMB_CROP_TAG) !== -1);
  }
  function _dmbCropSourceId(id) {
    if (typeof id !== "string") return id;
    const i = id.indexOf(_DMB_CROP_TAG);
    return i === -1 ? id : id.slice(0, i);
  }
  // Remove a derived crop photo from editor.photos IF nothing else still references it.
  function _dmbGcDerivedPhoto(derivedId) {
    if (!derivedId || derivedId.indexOf(_DMB_CROP_TAG) === -1) return;
    let stillUsed = false;
    try { stillUsed = getUsedPhotoIds().has(derivedId); } catch (e) { stillUsed = true; }
    // Cover main/bleed zones aren't in getUsedPhotoIds — check them explicitly.
    try {
      ["frontImageId", "backImageId", "bleedImageId", "spineImageId", "imageId"].forEach((k) => {
        if (coverState && coverState[k] === derivedId) stillUsed = true;
      });
    } catch (e) {}
    if (stillUsed) return;
    const idx = editor.photos.findIndex((p) => p && p.id === derivedId);
    if (idx !== -1) {
      try { URL.revokeObjectURL(editor.photos[idx].url); } catch (e) {}
      editor.photos.splice(idx, 1);
    }
    try { if (editor.cropRects) delete editor.cropRects[derivedId]; } catch (e) {}
  }

  // ---------- Crop Modal ----------
  let DMB_CROP = {
    open: false,
    photoId: null,      // the SOURCE photo id being cropped (always the original)
    placement: null,    // { get:()=>currentId, set:(id)=>{...} } — where the crop is written
    currentId: null,    // the id the placement held when the modal opened (source or derived)
    img: null,
    canvas: null,
    ctx: null,
    rect: null,
    dragMode: null,
    start: null,
    imgDraw: null
  };

  function ensureCropModal() {
    if (document.getElementById("dmbCropOverlay")) return;

    const overlay = document.createElement("div");
    overlay.id = "dmbCropOverlay";
    overlay.style.position = "absolute";
    overlay.style.inset = "0";
    overlay.style.background = "rgba(0,0,0,0.65)";
    overlay.style.display = "none";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.zIndex = "9999";

    const panel = document.createElement("div");
    panel.style.width = "min(92vw, 900px)";
    panel.style.maxHeight = "90vh";
    panel.style.background = "#fff";
    panel.style.borderRadius = "16px";
    panel.style.overflow = "hidden";
    panel.style.boxShadow = "0 20px 60px rgba(0,0,0,0.35)";
    panel.style.display = "flex";
    panel.style.flexDirection = "column";

    const head = document.createElement("div");
    head.style.display = "flex";
    head.style.alignItems = "center";
    head.style.justifyContent = "space-between";
    head.style.padding = "12px 14px";
    head.style.borderBottom = "1px solid #eee";

    const title = document.createElement("div");
    title.textContent = "Crop photo";
    title.style.fontWeight = "900";
    title.style.fontSize = "14px";

    const hint = document.createElement("div");
    hint.textContent = "Drag to draw a crop box. Drag inside the box to move it.";
    hint.style.fontSize = "12px";
    hint.style.color = "#666";
    hint.style.fontWeight = "700";
    hint.style.marginLeft = "10px";

    const left = document.createElement("div");
    left.style.display = "flex";
    left.style.alignItems = "center";
    left.appendChild(title);
    left.appendChild(hint);

    const actions = document.createElement("div");
    actions.style.display = "flex";
    actions.style.gap = "10px";

    const mkBtn = (txt) => {
      const b = document.createElement("button");
      b.type = "button";
      b.textContent = txt;
      b.style.border = "1px solid #111";
      b.style.borderRadius = "999px";
      b.style.padding = "8px 12px";
      b.style.fontWeight = "900";
      b.style.cursor = "pointer";
      b.style.background = "#fff";
      return b;
    };

    const cancelBtn = mkBtn("Cancel");
    const resetOrigBtn = mkBtn("Reset to original");   // revert this placement's crop
    resetOrigBtn.id = "dmbCropResetOrig";
    resetOrigBtn.style.borderColor = "#c0392b";
    resetOrigBtn.style.color = "#c0392b";
    resetOrigBtn.style.display = "none";               // shown only when a crop is applied
    const resetBtn = mkBtn("Clear box");               // clears the drawn selection
    const doneBtn = mkBtn("Done");
    doneBtn.style.background = "#111";
    doneBtn.style.color = "#fff";

    actions.appendChild(cancelBtn);
    actions.appendChild(resetOrigBtn);
    actions.appendChild(resetBtn);
    actions.appendChild(doneBtn);

    head.appendChild(left);
    head.appendChild(actions);

    const body = document.createElement("div");
    body.style.padding = "12px";
    body.style.background = "#fafafa";
    body.style.display = "flex";
    body.style.justifyContent = "center";
    body.style.alignItems = "center";

    const canvas = document.createElement("canvas");
    canvas.id = "dmbCropCanvas";
    canvas.style.background = "#000";
    canvas.style.borderRadius = "12px";
    canvas.style.maxWidth = "100%";
    canvas.style.maxHeight = "70vh";
    canvas.style.touchAction = "none";

    body.appendChild(canvas);

    panel.appendChild(head);
    panel.appendChild(body);
    overlay.appendChild(panel);

    const root = document.getElementById("dmb-root");
    if (root) {
      const cs = getComputedStyle(root);
      if (cs.position === "static") root.style.position = "relative";
      root.appendChild(overlay);
    } else {
      document.body.appendChild(overlay);
    }

    cancelBtn.addEventListener("click", closeCropModal);
    resetBtn.addEventListener("click", () => {
      DMB_CROP.rect = null;
      drawCropCanvas();
    });
    resetOrigBtn.addEventListener("click", resetCropToOriginal);
    doneBtn.addEventListener("click", applyCrop);

    const onDown = (e) => {
      if (!DMB_CROP.open) return;
      const { x, y } = canvasPoint(e);
      const r = DMB_CROP.rect;

      if (r && x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h) {
        DMB_CROP.dragMode = "move";
        DMB_CROP.start = { x, y, rx: r.x, ry: r.y };
      } else {
        DMB_CROP.dragMode = "new";
        DMB_CROP.start = { x, y };
        DMB_CROP.rect = { x, y, w: 0, h: 0 };
      }
      e.preventDefault();
    };

    const onMove = (e) => {
      if (!DMB_CROP.open || !DMB_CROP.dragMode) return;
      const { x, y } = canvasPoint(e);
      const r = DMB_CROP.rect;

      if (DMB_CROP.dragMode === "new" && DMB_CROP.start && r) {
        r.x = Math.min(DMB_CROP.start.x, x);
        r.y = Math.min(DMB_CROP.start.y, y);
        r.w = Math.abs(x - DMB_CROP.start.x);
        r.h = Math.abs(y - DMB_CROP.start.y);
      }

      if (DMB_CROP.dragMode === "move" && DMB_CROP.start && r) {
        const dx = x - DMB_CROP.start.x;
        const dy = y - DMB_CROP.start.y;
        r.x = DMB_CROP.start.rx + dx;
        r.y = DMB_CROP.start.ry + dy;
      }

      clampCropRect();
      drawCropCanvas();
      e.preventDefault();
    };

    const onUp = () => {
      if (!DMB_CROP.open) return;
      DMB_CROP.dragMode = null;
      DMB_CROP.start = null;
    };

    canvas.addEventListener("pointerdown", onDown);
    canvas.addEventListener("pointermove", onMove);
    canvas.addEventListener("pointerup", onUp);
    canvas.addEventListener("pointercancel", onUp);

    DMB_CROP.canvas = canvas;
    DMB_CROP.ctx = canvas.getContext("2d");
  }

  // openCropModal(currentId, placement?)
  //   currentId  — the id the placement currently holds (source OR a derived crop).
  //   placement  — { get:()=>id, set:(id)=>{…} } describing where to write the result.
  //                (Optional for safety; without it the crop can be drawn but not applied.)
  // The modal ALWAYS loads the original source image, so re-cropping starts from the full
  // photo and "Reset to original" is available whenever a crop is currently applied.
  function openCropModal(currentId, placement) {
    ensureCropModal();

    const srcId = _dmbCropSourceId(currentId);
    const src = getPhotoById(srcId) || getPhotoById(currentId);
    if (!src) return;

    const overlay = document.getElementById("dmbCropOverlay");
    const canvas = DMB_CROP.canvas;

    DMB_CROP.open = true;
    DMB_CROP.photoId = srcId;
    DMB_CROP.currentId = currentId;
    DMB_CROP.placement = placement || null;
    DMB_CROP.rect = null;

    // Reset-to-original is only meaningful when the placement currently shows a crop.
    const resetBtn = document.getElementById("dmbCropResetOrig");
    if (resetBtn) resetBtn.style.display = (currentId !== srcId) ? "" : "none";

    const maxW = Math.min(window.innerWidth * 0.92, 900);
    const maxH = Math.min(window.innerHeight * 0.70, 700);
    canvas.width = Math.floor(maxW);
    canvas.height = Math.floor(maxH);

    const img = new Image();
    img.decoding = "async";
    img.onload = () => {
      DMB_CROP.img = img;
      computeImageDraw();
      drawCropCanvas();
    };
    if (!_dmbPrintMasterOn()) {
      img.src = src.url;                       // legacy path — unchanged
    } else {
      // Print-master flag: crop against the best pixels available — the ~3500px
      // R2 master when it exists (so applyCrop bakes at print quality), else the
      // resident url/file, else the R2 proxy (lazily-restored photo, no local bytes).
      (async () => {
        let _u = "", _tmp = "";
        try {
          if (src.id && !_dmbIsCropDerived(src) && !_dmbNoMasterPids.has(src.id)) {
            let _did = ""; try { _did = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
            const _mb = await _dmbFetchPhotoBlob(_did, src.id, "master");
            if (_mb && _mb.size) { _tmp = _u = URL.createObjectURL(_mb); }
            else _dmbNoMasterPids.add(src.id);
          }
        } catch (e) {}
        if (!_u) _u = src.url || "";
        if (!_u && src.file && src.file.size) { try { _tmp = _u = URL.createObjectURL(src.file); } catch (e) {} }
        if (!_u) { try { _u = (await _dmbRecoverPhotoUrl(src)) || ""; } catch (e) {} }
        if (_tmp) {
          const _rev = () => { try { URL.revokeObjectURL(_tmp); } catch (e) {} };
          img.addEventListener("load", _rev, { once: true });
          img.addEventListener("error", _rev, { once: true });
        }
        img.src = _u;
      })();
    }

    if (overlay) overlay.style.display = "flex";
  }

  function closeCropModal() {
    const overlay = document.getElementById("dmbCropOverlay");
    if (overlay) overlay.style.display = "none";
    DMB_CROP.open = false;
    DMB_CROP.photoId = null;
    DMB_CROP.placement = null;
    DMB_CROP.currentId = null;
    DMB_CROP.img = null;
    DMB_CROP.rect = null;
    DMB_CROP.dragMode = null;
    DMB_CROP.start = null;
  }

  function canvasPoint(e) {
    const rect = DMB_CROP.canvas.getBoundingClientRect();
    return {
      x: (e.clientX - rect.left) * (DMB_CROP.canvas.width / rect.width),
      y: (e.clientY - rect.top) * (DMB_CROP.canvas.height / rect.height)
    };
  }

  function computeImageDraw() {
    const img = DMB_CROP.img;
    const c = DMB_CROP.canvas;
    if (!img || !c) return;

    const scale = Math.min(c.width / img.naturalWidth, c.height / img.naturalHeight);
    const dw = img.naturalWidth * scale;
    const dh = img.naturalHeight * scale;
    const ox = (c.width - dw) / 2;
    const oy = (c.height - dh) / 2;

    DMB_CROP.imgDraw = { scale, ox, oy, dw, dh };
  }

  function clampCropRect() {
    const r = DMB_CROP.rect;
    const d = DMB_CROP.imgDraw;
    if (!r || !d) return;

    const minSize = 20;

    r.w = Math.max(minSize, r.w);
    r.h = Math.max(minSize, r.h);

    const minX = d.ox;
    const minY = d.oy;
    const maxX = d.ox + d.dw;
    const maxY = d.oy + d.dh;

    if (r.x < minX) r.x = minX;
    if (r.y < minY) r.y = minY;
    if (r.x + r.w > maxX) r.x = maxX - r.w;
    if (r.y + r.h > maxY) r.y = maxY - r.h;

    r.w = Math.min(r.w, maxX - minX);
    r.h = Math.min(r.h, maxY - minY);
  }

  function drawCropCanvas() {
    const ctx = DMB_CROP.ctx;
    const c = DMB_CROP.canvas;
    const img = DMB_CROP.img;
    const d = DMB_CROP.imgDraw;
    if (!ctx || !c) return;

    ctx.clearRect(0, 0, c.width, c.height);
    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, c.width, c.height);

    if (!img || !d) return;

    ctx.drawImage(img, d.ox, d.oy, d.dw, d.dh);

    ctx.fillStyle = "rgba(0,0,0,0.45)";
    ctx.fillRect(0, 0, c.width, c.height);

    const r = DMB_CROP.rect;
    if (r) {
      clampCropRect();

      ctx.save();
      ctx.globalCompositeOperation = "destination-out";
      ctx.fillRect(r.x, r.y, r.w, r.h);
      ctx.restore();

      ctx.strokeStyle = "#fff";
      ctx.lineWidth = 2;
      ctx.strokeRect(r.x, r.y, r.w, r.h);
    }
  }

  // Re-render + save after a crop/reset changes a placement.
  function _dmbCropAfter() {
    const pl = DMB_CROP.placement;
    if (pl && typeof pl.after === "function") { try { pl.after(); } catch (e) {} }
    else {
      if (builderMode === "cover") { try { saveCoverDesignToStorage(); } catch (e) {} renderCoverCanvas(); }
      else { try { renderSpread(); } catch (e) {} }
      try { renderThumbsRail(); } catch (e) {}
      try { renderPhotoTray(); } catch (e) {}
    }
    // Persist the new derived-photo bytes + the updated layout so the crop (and Reset)
    // survive a reload. A fresh derived id has no dedup conflict, so a normal save is enough.
    try { _dmbPersistPhotos._sig = null; } catch (e) {}
    try { if (typeof _dmbPersistPhotos === "function") _dmbPersistPhotos(); } catch (e) {}
    try { if (typeof _dmbBackupPhotos === "function") _dmbBackupPhotos(); } catch (e) {}
    try { if (typeof _dmbCloudPersist === "function") _dmbCloudPersist(); } catch (e) {}
  }

  async function applyCrop() {
    const img = DMB_CROP.img;
    const d = DMB_CROP.imgDraw;
    const r = DMB_CROP.rect;
    const srcId = DMB_CROP.photoId;
    const placement = DMB_CROP.placement;

    if (!img || !d || !r || !srcId) return;
    const src = getPhotoById(srcId);
    if (!src) return;
    if (!placement || typeof placement.set !== "function") { closeCropModal(); return; }

    const sx = Math.max(0, Math.round((r.x - d.ox) / d.scale));
    const sy = Math.max(0, Math.round((r.y - d.oy) / d.scale));
    const sw = Math.max(1, Math.round(r.w / d.scale));
    const sh = Math.max(1, Math.round(r.h / d.scale));

    const out = document.createElement("canvas");
    out.width = sw;
    out.height = sh;
    const octx = out.getContext("2d");
    octx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

    const blob = await new Promise((res) => out.toBlob(res, "image/jpeg", 0.92));
    if (!blob) return;

    try { pushUndoState("Crop photo"); } catch (e) {}

    // Build a DERIVED photo that holds the cropped bytes. The original `src` is untouched
    // and stays in the tray. The id encodes the source so the link survives save/restore.
    const derivedId = srcId + _DMB_CROP_TAG + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    const newUrl = URL.createObjectURL(blob);
    const derived = {
      id: derivedId,
      file: new File([blob], src.file?.name || src.filename || "cropped.jpg", { type: "image/jpeg" }),
      url: newUrl,
      ratio: sw / sh,
      filename: src.filename || "",
      dateTaken: src.dateTaken || "",
      tags: [],
      addedIndex: (typeof src.addedIndex === "number" ? src.addedIndex : editor.photos.length)
    };
    editor.photos.push(derived);

    // Record the crop as 0–1 ratios of the SOURCE image. Resolution-independent:
    // the server render (or a restore on another device) reproduces the exact same
    // crop from the print master even though it never saw these baked pixels.
    try {
      const _iw = img.naturalWidth || 1, _ih = img.naturalHeight || 1;
      editor.cropRects = editor.cropRects || {};
      editor.cropRects[derivedId] = { srcPid: srcId, x: sx / _iw, y: sy / _ih, w: sw / _iw, h: sh / _ih };
    } catch (e) {}

    const oldId = DMB_CROP.currentId;   // may be a previous derived crop to replace
    placement.set(derivedId);
    if (oldId && oldId !== derivedId && oldId.indexOf(_DMB_CROP_TAG) !== -1) _dmbGcDerivedPhoto(oldId);

    _dmbCropAfter();
    closeCropModal();
  }

  // Revert this placement back to its original (uncropped) source photo.
  function resetCropToOriginal() {
    const placement = DMB_CROP.placement;
    const srcId = DMB_CROP.photoId;
    const oldId = DMB_CROP.currentId;
    if (!placement || typeof placement.set !== "function" || !srcId) { closeCropModal(); return; }
    try { pushUndoState("Reset crop"); } catch (e) {}
    placement.set(srcId);
    if (oldId && oldId !== srcId && oldId.indexOf(_DMB_CROP_TAG) !== -1) _dmbGcDerivedPhoto(oldId);
    _dmbCropAfter();
    closeCropModal();
  }

  function makePlacedImageBox(photoId, pos, pageNumber, slot, isPreview = false, noButtons = false) {
    const ph = getPhotoById(photoId);

    const box = document.createElement("div");
    box.style.position = "absolute";
    box.style.left = "0";
    box.style.right = "0";
    // Horizontal placement (used for side-by-side 2-up in landscape). When a
    // width is given with one pinned edge, release the opposite edge so width
    // takes effect. Numbers → px; strings (e.g. "50%") used as-is.
    if (pos.left  != null) box.style.left  = (typeof pos.left  === "number" ? pos.left  + "px" : pos.left);
    if (pos.right != null) box.style.right = (typeof pos.right === "number" ? pos.right + "px" : pos.right);
    if (pos.width != null) {
      box.style.width = pos.width;
      if (pos.left  != null) box.style.right = "auto";
      if (pos.right != null) box.style.left  = "auto";
    }
    if (pos.top != null) box.style.top = (typeof pos.top === "number" ? pos.top + "px" : pos.top);
    if (pos.bottom != null) box.style.bottom = (typeof pos.bottom === "number" ? pos.bottom + "px" : pos.bottom);
    if (pos.height != null) box.style.height = pos.height;
    box.style.zIndex = "1";
    box.style.overflow = "hidden";
    box.style.background = "#fff";
    box.style.cursor = "grab";
    box.draggable = true;

    box.addEventListener("dragover", (e) => {
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
    });

    box.addEventListener("drop", (e) => {
      e.preventDefault();
      const parent = box.parentElement;
      if (!parent) return;
      const payload = getDragPayload(e);
      // Find nearest ancestor with a frameKey (works even when placed inside fwClip)
      const frameEl = parent.closest ? parent.closest("[data-frame-key]") : null;
      if (frameEl && frameEl.dataset.frameKey) {
        e.stopPropagation(); // frame handles it — don't let pagesRow see this drop
        const fKey = frameEl.dataset.frameKey;
        const fPage = Number(frameEl.dataset.framePage) || pageNumber;
        const photoId = (function() {
          if (payload && payload.photoId) return payload.photoId;
          const tp = e.dataTransfer ? (e.dataTransfer.getData("text/plain") || "").trim() : "";
          if (!tp) return "";
          if (tp[0] === "{") { try { return JSON.parse(tp).photoId || ""; } catch(ex) { return ""; } }
          return tp;
        })();
        if (!photoId) return;
        const used = getUsedPhotoIds();
        if (payload && payload.type === "photo" && used.has(photoId)) showReuseNotice();
        pushUndoState("Replace Photo In Frame");
        if (payload && payload.type === "placed") {
          const fromPage = Number(payload.fromPage);
          const fromSlot = payload.fromSlot;
          if (fromPage && fromSlot) {
            const currentInTarget = getFramePhotoId(fPage, fKey);
            const replacedRot = getFrameRotation(fPage, fKey);
            setFramePhotoId(fPage, fKey, photoId);
            setFrameRotation(fPage, fKey, 0);
            if (currentInTarget) {
              setFramePhotoId(fromPage, fromSlot, currentInTarget);
              setFrameRotation(fromPage, fromSlot, replacedRot);
            } else {
              clearFrame(fromPage, fromSlot);
            }
          } else {
            setFramePhotoId(fPage, fKey, photoId);
            setFrameRotation(fPage, fKey, 0);
          }
        } else {
          setFramePhotoId(fPage, fKey, photoId);
          setFrameRotation(fPage, fKey, 0);
        }
        renderSpread();
        renderThumbsRail();
        renderPhotoTray();
      }
      // non-frame drop: let event bubble to pagesRow for zone detection
    });

    box.addEventListener("dragstart", (e) => {
      setDragPayload(e, { type: "placed", photoId, fromPage: pageNumber, fromSlot: slot });
    });

    const img = document.createElement("img");
    _dmbBindPhotoImg(img, ph);
    img.alt = "placed";
    img.style.position = "absolute";
    img.style.inset = "0";
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.pointerEvents = "none";
    box.appendChild(img);

    const deg = getFrameRotation(pageNumber, slot);
    applyRotationAndCover(img, box, deg);
    box.dataset.placedImg = "1";
    box.dataset.placedRot = String(deg);
    requestAnimationFrame(() => {
      const latestDeg = getFrameRotation(pageNumber, slot);
      applyRotationAndCover(img, box, latestDeg);
      box.dataset.placedRot = String(latestDeg);
    });

    if (!isPreview && !noButtons) {
      const rm = document.createElement("button");
      rm.type = "button";
      rm.innerHTML = `<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      rm.setAttribute("aria-label", "Remove photo");
      rm.title = "Remove photo";
      rm.style.position = "absolute";
      rm.style.top = "8px";
      rm.style.right = "8px";
      rm.style.width = "28px";
      rm.style.height = "28px";
      rm.style.borderRadius = "999px";
      rm.style.border = "none";
      rm.style.background = "rgba(0,0,0,0.72)";
      rm.style.color = "#fff";
      rm.style.cursor = "pointer";
      rm.style.zIndex = "4";
      rm.style.display = "flex";
      rm.style.alignItems = "center";
      rm.style.justifyContent = "center";
      rm.style.padding = "0";

      rm.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        pushUndoState("Remove Photo");
        clearFrame(pageNumber, slot);

        if (!isTemplatePage(pageNumber)) {
          if (slot === "A" && editor.pageSlots[pageNumber].B) {
            editor.pageSlots[pageNumber].A = editor.pageSlots[pageNumber].B;
            editor.pageSlots[pageNumber].B = null;
            editor.pageRot[pageNumber].A = editor.pageRot[pageNumber].B;
            editor.pageRot[pageNumber].B = 0;
          }
        }

        renderBuilderCanvas();
        renderThumbsRail();
        renderPhotoTray();
      });

      box.appendChild(rm);

      const rotBtn = document.createElement("button");
      rotBtn.type = "button";
      rotBtn.setAttribute("aria-label", "Rotate 90 degrees anti-clockwise");
      rotBtn.title = "Rotate 90° anti-clockwise";
      rotBtn.innerHTML = `
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          <path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      rotBtn.style.position = "absolute";
      rotBtn.style.top = "8px";
      rotBtn.style.right = "40px";
      rotBtn.style.width = "28px";
      rotBtn.style.height = "28px";
      rotBtn.style.borderRadius = "999px";
      rotBtn.style.border = "none";
      rotBtn.style.background = "rgba(0,0,0,0.72)";
      rotBtn.style.cursor = "pointer";
      rotBtn.style.zIndex = "4";
      rotBtn.style.display = "flex";
      rotBtn.style.flexDirection = "column";
      rotBtn.style.alignItems = "center";
      rotBtn.style.justifyContent = "center";
      rotBtn.style.gap = "1px";
      rotBtn.style.padding = "0";

      rotBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        pushUndoState("Rotate Photo");
        rotateFrameCCW90(editor, pageNumber, slot);
        renderBuilderCanvas();
        renderThumbsRail();
      });

      box.appendChild(rotBtn);

      const cropBtn = document.createElement("button");
      cropBtn.type = "button";
      cropBtn.setAttribute("aria-label", "Crop photo");
      cropBtn.title = "Crop photo";
      cropBtn.innerHTML = `
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          <path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
      cropBtn.style.position = "absolute";
      cropBtn.style.top = "8px";
      cropBtn.style.right = "72px";
      cropBtn.style.width = "28px";
      cropBtn.style.height = "28px";
      cropBtn.style.borderRadius = "999px";
      cropBtn.style.border = "none";
      cropBtn.style.background = "rgba(0,0,0,0.72)";
      cropBtn.style.cursor = "pointer";
      cropBtn.style.zIndex = "4";
      cropBtn.style.display = "flex";
      cropBtn.style.alignItems = "center";
      cropBtn.style.justifyContent = "center";
      cropBtn.style.padding = "0";

      cropBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openCropModal(photoId, {
          get: () => editor.pageSlots?.[pageNumber]?.[slot],
          set: (id) => { if (!editor.pageSlots[pageNumber]) editor.pageSlots[pageNumber] = {}; editor.pageSlots[pageNumber][slot] = id; }
        });
      });

      box.appendChild(cropBtn);

      function forwardDropToBody(e) {
        e.preventDefault();
        e.stopPropagation();
        const body = box.parentElement;
        if (!body) return;
        const payload = getDragPayload(e);
        handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body, e.clientX);
      }

      rm.addEventListener("dragover", (e) => e.preventDefault());
      rm.addEventListener("drop", forwardDropToBody);

      rotBtn.addEventListener("dragover", (e) => e.preventDefault());
      rotBtn.addEventListener("drop", forwardDropToBody);

      cropBtn.addEventListener("dragover", (e) => e.preventDefault());
      cropBtn.addEventListener("drop", forwardDropToBody);

      // Frames button
      const frameShapeBtn = document.createElement("button");
      frameShapeBtn.type = "button";
      frameShapeBtn.setAttribute("aria-label", "Frame shape");
      frameShapeBtn.title = "Frame shape";
      frameShapeBtn.innerHTML = `<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      frameShapeBtn.style.cssText = "position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:4;display:flex;align-items:center;justify-content:center;padding:0;";
      frameShapeBtn.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const current = getSlotFrameShape(pageNumber, slot);
        showDmbFramePicker(frameShapeBtn, current, (shapeId) => {
          pushUndoState("Frame Shape");
          setSlotFrameShape(pageNumber, slot, shapeId);
          renderBuilderCanvas();
          renderThumbsRail();
        });
      });
      frameShapeBtn.addEventListener("dragover", (e) => e.preventDefault());
      frameShapeBtn.addEventListener("drop", forwardDropToBody);
      box.appendChild(frameShapeBtn);

      // Apply stored frame shape to the placed image
      const _placedImg = box.querySelector("img");
      if (_placedImg) applyDmbFrameShape(_placedImg, getSlotFrameShape(pageNumber, slot));
    }

    return box;
  }

  function makeA4Page(pageNumber, side, isPreview = false) {
    const page = document.createElement("div");
    const _pdPage = getPageDims();
    page.style.width = _pdPage.w + "px";
    page.style.aspectRatio = _pdPage.w + " / " + _pdPage.h;
    page.style.border = "1px solid #e5e5e5";
    page.style.borderRadius = "0";
    page.style.background = "#fff";
    page.style.position = "relative";
    page.style.overflow = "visible";
    page.style.boxShadow = "0 6px 18px rgba(0,0,0,0.06)";

    const body = document.createElement("div");
    body.style.position = "absolute";
    body.style.inset = "0";
    // Use stored page background color if set; fall back to default page colour
    const _pageBg = editor.pageBackgrounds?.[pageNumber];
    body.style.background = _pageBg || (isPreview ? "#ffffff" : "#fcfcfc");
    body.style.zIndex = "auto";
    body.setAttribute("data-page-body", "true");
    body.dataset.pageNumber = String(pageNumber);
    page.appendChild(body);

    if (isLockedPage(pageNumber)) {
      if (!isPreview) {
        const special = document.createElement("div");
        special.style.position = "absolute";
        special.style.inset = "0";
        special.style.display = "flex";
        special.style.alignItems = "center";
        special.style.justifyContent = "center";
        special.style.textAlign = "center";
        special.style.padding = "24px";
        special.style.fontWeight = "900";
        special.style.fontSize = "13px";
        special.style.color = "#bbb";
        special.textContent = "Can't be edited";
        body.appendChild(special);
      }
      renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
      return page;
    }

    // ── Spread photo ──
    const si = Math.floor((pageNumber - 1) / 2);
    const isLeftPage = (side === "L");
    const sp = editor.spreadPhoto?.[si];
    if (sp && sp.photoId) {
      const ph = getPhotoById(sp.photoId);
      if (ph) {
        const templateIdForSpread = getPageTemplateId(pageNumber);
        const imgWrap = document.createElement("div");
        imgWrap.style.position = "absolute";
        imgWrap.style.width = "200%";
        imgWrap.style.height = "100%";
        imgWrap.style.left = isLeftPage ? "0" : "-100%";
        imgWrap.style.top = "0";
        imgWrap.style.transformOrigin = "50% 50%";
        imgWrap.setAttribute("data-spread-img-layer", "true");
        imgWrap.setAttribute("data-spread-img-side", side);
        const px = sp.panX || 0, py = sp.panY || 0, zoom = sp.zoom || 1, rot = sp.rotation || 0;
        imgWrap.style.transform = `translate(${px}px,${py}px) scale(${zoom}) rotate(${rot}deg)`;
        // Store transform values for PDF pre-rendering (avoids html2canvas transform issues)
        imgWrap.dataset.pdfPanX = String(px);
        imgWrap.dataset.pdfPanY = String(py);
        imgWrap.dataset.pdfZoom = String(zoom);
        imgWrap.dataset.pdfRotation = String(rot);
        if (templateIdForSpread || isPreview) {
          imgWrap.style.cursor = "default";
          imgWrap.style.pointerEvents = "none";
          imgWrap.style.zIndex = "0";
        } else {
          imgWrap.style.cursor = "move";
          imgWrap.style.zIndex = "1";
        }
        const img = document.createElement("img");
        _dmbBindPhotoImg(img, ph);
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "cover";
        img.style.pointerEvents = "none";
        img.style.display = "block";
        img.draggable = false;
        imgWrap.appendChild(img);
        body.appendChild(imgWrap);
        if (!templateIdForSpread && !isPreview) {
          imgWrap.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            spreadPhotoDragState = { type: "pan", si, startX: e.clientX, startY: e.clientY, startPanX: sp.panX || 0, startPanY: sp.panY || 0 };
            e.preventDefault();
            e.stopPropagation();
          });
        }
        if (!isLeftPage && !isPreview) {
          // X button (matches regular photos style)
          const rmBtn = document.createElement("button");
          rmBtn.type = "button";
          rmBtn.innerHTML = `<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
          rmBtn.setAttribute("aria-label", "Remove spread photo");
          rmBtn.style.cssText = "position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          rmBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            pushUndoState();
            editor.spreadPhoto[si] = null;
            renderSpread(); renderThumbsRail(); renderPhotoTray();
          });
          body.appendChild(rmBtn);
          // Rotate button
          const rotBtn = document.createElement("button");
          rotBtn.type = "button";
          rotBtn.setAttribute("aria-label", "Rotate 90°");
          rotBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          rotBtn.style.cssText = "position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          rotBtn.addEventListener("click", (e) => {
            e.preventDefault(); e.stopPropagation();
            sp.rotation = ((sp.rotation || 0) + 90) % 360;
            renderSpread(); renderThumbsRail();
          });
          body.appendChild(rotBtn);
          // Crop button
          const cropBtn = document.createElement("button");
          cropBtn.type = "button";
          cropBtn.setAttribute("aria-label", "Crop photo");
          cropBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
          cropBtn.style.cssText = "position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          cropBtn.addEventListener("click", (e) => {
            e.preventDefault(); e.stopPropagation();
            openCropModal(sp.photoId, { get: () => sp.photoId, set: (id) => { sp.photoId = id; } });
          });
          body.appendChild(cropBtn);
        }
        if (!templateIdForSpread) {
          renderFreeFrameObjects(body, { targetType: "page", pageNumber });
          return page;
        }
        // Has template: fall through to render template frames on top of spread photo
      }
    }

    const msg = document.createElement("div");
    msg.style.position = "absolute";
    msg.style.left = "12px";
    msg.style.right = "12px";
    msg.style.bottom = "12px";
    msg.style.padding = "10px 12px";
    msg.style.borderRadius = "12px";
    msg.style.background = "rgba(0,0,0,0.70)";
    msg.style.color = "#fff";
    msg.style.fontWeight = "900";
    msg.style.fontSize = "12px";
    msg.style.display = "none";
    msg.style.zIndex = "4";
    msg.textContent = "To add another picture to this page, drag another picture over it.";
    msg.style.pointerEvents = "none";
    if (!isPreview) body.appendChild(msg);

    const templateIdForBody = getPageTemplateId(pageNumber);
    if (templateIdForBody) {
      const defs = TEMPLATE_DEFS[templateIdForBody] || [];
      const hasAny = Object.values(editor.pageFrames?.[pageNumber] || {}).some(Boolean);

      if (!hasAny && !isPreview) body.appendChild(makeHint("Choose a frame, then drop a photo"));

      // Render slot photos as background (when layout applied "over" existing photos)
      const slotA = editor.pageSlots?.[pageNumber]?.A;
      const slotB = editor.pageSlots?.[pageNumber]?.B;
      if (slotA || slotB) {
        if (slotA && !slotB) {
          const bg = makePlacedImageBox(slotA, { top: 0, bottom: 0 }, pageNumber, "A", isPreview);
          bg.style.zIndex = "0";
          bg.style.pointerEvents = "none";
          body.appendChild(bg);
        } else if (slotA && slotB) {
          // Layout background stays as designed (stacked) — the layout itself is
          // kept at its portrait shape, so its background matches.
          const bgA = makePlacedImageBox(slotA, { top: 0, height: "50%" }, pageNumber, "A", isPreview);
          bgA.style.zIndex = "0"; bgA.style.pointerEvents = "none";
          const bgB = makePlacedImageBox(slotB, { bottom: 0, height: "50%" }, pageNumber, "B", isPreview);
          bgB.style.zIndex = "0"; bgB.style.pointerEvents = "none";
          body.appendChild(bgA);
          body.appendChild(bgB);
        }
      }

      defs.forEach((f) => {
        const _fp = _dmbLayoutFramePct(f);   // keep the frame's exact portrait shape
        const frameWrap = document.createElement("div");
        frameWrap.style.position = "absolute";
        frameWrap.style.left = _fp.x + "%";
        frameWrap.style.top = _fp.y + "%";
        frameWrap.style.width = _fp.w + "%";
        frameWrap.style.height = _fp.h + "%";
        frameWrap.style.border = "1px solid #eee";
        frameWrap.style.background = "#fff";
        frameWrap.style.overflow = "visible";  // buttons escape; inner clip handles photo
        frameWrap.style.zIndex = "60";  // above spread overlay (z-index:50) so drops land on frame
        frameWrap.dataset.frameKey = f.key;
        frameWrap.dataset.framePage = String(pageNumber);

        const fwClip = document.createElement("div");
        fwClip.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:inherit;";
        frameWrap.appendChild(fwClip);

        const pid = getFramePhotoId(pageNumber, f.key);

        if (!pid && !isPreview) {
          const hint = document.createElement("div");
          hint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;pointer-events:none;background:rgba(220,220,220,0.55);border:1.5px dashed #ccc;border-radius:2px;";
          hint.innerHTML = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="#c0c0c0" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="#bbb" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="#bbb" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:8px;font-weight:900;color:#bbb;letter-spacing:0.4px;text-transform:uppercase;">Drop photo</span>`;
          fwClip.appendChild(hint);
        } else if (pid) {
          const placed = makePlacedImageBox(pid, { top: 0, bottom: 0 }, pageNumber, f.key, isPreview, true);
          placed.style.cssText += ";position:absolute;left:0;right:0;top:0;bottom:0;height:auto;";
          fwClip.appendChild(placed);
          // Re-apply stored frame shape after image loads
          const _storedShape = editor.pageFrameShapes?.[pageNumber]?.[f.key] || '';
          if (_storedShape) {
            const _si = placed.querySelector('img');
            if (_si) applyDmbFrameShape(_si, _storedShape);
          }

          if (!isPreview) {
            const _tBtnSVGs = [
              { aria:"Remove", title:"Remove photo", svg:`<svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");clearFrame(pageNumber,f.key);renderSpread();renderThumbsRail();renderPhotoTray(); }},
              { aria:"Rotate", title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");const rots=editor.pageFrameRot?.[pageNumber]||{};rots[f.key]=((rots[f.key]||0)-90+360)%360;if(!editor.pageFrameRot)editor.pageFrameRot={};editor.pageFrameRot[pageNumber]=rots;renderSpread();renderThumbsRail(); }},
              { aria:"Crop",   title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(pid, { get:()=>editor.pageFrames?.[pageNumber]?.[f.key], set:(id)=>{ if(!editor.pageFrames[pageNumber]) editor.pageFrames[pageNumber]={}; editor.pageFrames[pageNumber][f.key]=id; } }); }},
              { aria:"Shape",  title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="12" height="12" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation(); if(!editor.pageFrameShapes)editor.pageFrameShapes={}; if(!editor.pageFrameShapes[pageNumber])editor.pageFrameShapes[pageNumber]={}; const curShape=editor.pageFrameShapes[pageNumber][f.key]||''; showDmbFramePicker(e.currentTarget, curShape, (shapeId)=>{ pushUndoState("Frame Shape"); if(!editor.pageFrameShapes)editor.pageFrameShapes={}; if(!editor.pageFrameShapes[pageNumber])editor.pageFrameShapes[pageNumber]={}; editor.pageFrameShapes[pageNumber][f.key]=shapeId; const _img=fwClip.querySelector('img'); if(_img)applyDmbFrameShape(_img,shapeId); renderSpread(); }); }}
            ];
            const _tbs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
            // Always use ··· popup for layout frames (clean at any size)
            const mb=document.createElement("button");mb.type="button";mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:3px;right:3px;width:22px;height:22px;z-index:12;font-size:14px;line-height:1;${_tbs}`;
            const pop=document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:3px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _tBtnSVGs.forEach(d=>{
              const b=document.createElement("button");b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{pop.style.display="none";d.fn(ev);});
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");}});
            frameWrap.appendChild(mb);frameWrap.appendChild(pop);
          }
        }

        frameWrap.addEventListener("dragover", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const payload = getDragPayload(e);
          e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
          frameWrap.style.outline = "2px solid #111";
          frameWrap.style.outlineOffset = "-2px";
          body.style.outline = "none";
        });

        frameWrap.addEventListener("dragleave", () => {
          frameWrap.style.outline = "none";
        });

        frameWrap.addEventListener("drop", (e) => {
          e.preventDefault();
          e.stopPropagation();
          frameWrap.style.outline = "none";
          body.style.outline = "none";
          const payload = getDragPayload(e);
          const photoId = (() => {
            if (payload && payload.photoId) return payload.photoId;
            const tp = e.dataTransfer ? (e.dataTransfer.getData("text/plain") || "").trim() : "";
            if (!tp) return "";
            if (tp[0] === "{") { try { return JSON.parse(tp).photoId || ""; } catch { return ""; } }
            return tp;
          })();
          if (!photoId) return;
          const used = getUsedPhotoIds();
          if (payload?.type === "photo" && used.has(photoId)) showReuseNotice();
          pushUndoState("Drop Photo In Frame");
          if (payload && payload.type === "placed") {
            const fromPage = Number(payload.fromPage);
            const fromSlot = payload.fromSlot;
            if (fromPage && fromSlot) {
              const currentInTarget = getFramePhotoId(pageNumber, f.key);
              const replacedRot = getFrameRotation(pageNumber, f.key);
              setFramePhotoId(pageNumber, f.key, photoId);
              setFrameRotation(pageNumber, f.key, 0);
              if (currentInTarget) {
                setFramePhotoId(fromPage, fromSlot, currentInTarget);
                setFrameRotation(fromPage, fromSlot, replacedRot);
              } else {
                clearFrame(fromPage, fromSlot);
              }
            } else {
              setFramePhotoId(pageNumber, f.key, photoId);
              setFrameRotation(pageNumber, f.key, 0);
            }
          } else {
            setFramePhotoId(pageNumber, f.key, photoId);
            setFrameRotation(pageNumber, f.key, 0);
          }
          renderSpread();
          renderThumbsRail();
          renderPhotoTray();
        });

        body.appendChild(frameWrap);
      });

      renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
      return page;
    }

    if (!editor.pageSlots[pageNumber]) {
      editor.pageSlots[pageNumber] = { A: null, B: null };
    }
    if (!editor.pageRot[pageNumber]) {
      editor.pageRot[pageNumber] = { A: 0, B: 0 };
    }
    if (!editor.pageTemplate[pageNumber]) {
      editor.pageTemplate[pageNumber] = null;
    }
    if (!editor.pageFrames[pageNumber]) {
      editor.pageFrames[pageNumber] = {};
    }
    if (!editor.pageFrameRot[pageNumber]) {
      editor.pageFrameRot[pageNumber] = {};
    }


    const A = editor.pageSlots[pageNumber].A;
    const B = editor.pageSlots[pageNumber].B;

    if (!A && !B) {
      // Only show the dashed "Drop a photo here" placeholder when the page is
      // TRULY empty — not when it already holds a free-frame photo, a spread
      // photo, text, a sticker, or a background. (Slots being empty isn't enough:
      // the magic layout + "Choose layout" place photos as free frames, which left
      // this dashed box showing behind real content.)
      if (!isPreview && pageIsCompletelyEmpty(pageNumber)) body.appendChild(makeHint("Drop a photo here"));
    } else if (A && !B) {
      body.appendChild(makePlacedImageBox(A, { top: 0, bottom: 0 }, pageNumber, "A", isPreview));
      if (!isPreview) {
        msg.style.display = "block";
        // Auto-dismiss after 4 seconds
        setTimeout(() => { msg.style.opacity = "0"; setTimeout(() => { msg.style.display = "none"; }, 400); }, 4000);
      }
    } else {
      const _2 = _dmbTwoUpPlacement();
      body.appendChild(makePlacedImageBox(A, _2.a, pageNumber, "A", isPreview));
      body.appendChild(makePlacedImageBox(B, _2.b, pageNumber, "B", isPreview));

      // Divider between the two photos: horizontal (mid-height) in portrait,
      // vertical (mid-width) in landscape.
      const divider = document.createElement("div");
      divider.style.position = "absolute";
      divider.style.background = "#eee";
      divider.style.zIndex = "2";
      divider.style.pointerEvents = "none";
      if (dmbIsLandscape()) {
        divider.style.top = "0"; divider.style.bottom = "0";
        divider.style.left = "50%"; divider.style.width = "1px";
      } else {
        divider.style.left = "0"; divider.style.right = "0";
        divider.style.top = "50%"; divider.style.height = "1px";
      }
      body.appendChild(divider);
    }

    
    body.addEventListener("dragover", (e) => {
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      body.style.outline = "2px solid #111";
      body.style.outlineOffset = "-2px";
    });

    body.addEventListener("dragleave", () => {
      body.style.outline = "none";
    });

    body.addEventListener("drop", (e) => {
      e.preventDefault();
      e.stopPropagation();
      body.style.outline = "none";
      const payload = getDragPayload(e);
      handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body);
    });

    page.addEventListener("dragover", (e) => {
      if (isLockedPage(pageNumber)) return;
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
    });

    page.addEventListener("drop", (e) => {
      if (isLockedPage(pageNumber)) return;
      e.preventDefault();
      const payload = getDragPayload(e);
      handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body);
    });
    renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
    return page;
  }

  function renderUnifiedCoverObjects(stageEl) {
    const objs = (editor.coverObjects || []).slice().sort((a, b) => (a.z || 0) - (b.z || 0));

    objs.forEach((obj) => {
      if (obj.type === "text") {
        // render text object
      }

      if (obj.type === "photo-frame") {
        // render frame object
      }
    });
  }

  function forceSpreadLayout() {
    if (!spreadViewport || !spreadCanvas) return;

    spreadViewport.style.overflowX = "auto";
    spreadViewport.style.overflowY = "auto";
    spreadViewport.style.padding = "12px";
    spreadViewport.style.minHeight = "0";       // fit the canvas — no forced empty space below it
    spreadViewport.style.height = "auto";
    spreadViewport.style.maxHeight = "760px";   // large spreads still scroll inside this cap
    spreadViewport.style.boxSizing = "border-box";

    spreadCanvas.style.display = "flex";
    spreadCanvas.style.flexWrap = "nowrap";
    spreadCanvas.style.justifyContent = "flex-start";
    spreadCanvas.style.alignItems = "flex-start";
    spreadCanvas.style.gap = "14px";
    spreadCanvas.style.width = "max-content";
    spreadCanvas.style.minWidth = "0";
    spreadCanvas.style.margin = "0";
    spreadCanvas.style.boxSizing = "border-box";

    // Mobile: shrink the spread so both action rails stay on-screen.
    if (typeof _mshFitSpread === "function") { _mshFitSpread(); requestAnimationFrame(_mshFitSpread); }
  }

  // ══════════════════════════════════════════════════════════════════════
  // MOBILE SHELL (Phase 1) — reshapes the builder chrome on phones (<=749px)
  // into the clean mockup structure: fixed top app bar (back/undo/redo/title/
  // preview/Order/menu), a Prev · page-dropdown · Next nav under the stage, and
  // a fixed bottom tab bar (Photos/Covers/Layouts/Stickers/Text). It only BUILDS
  // new chrome that PROXIES to the existing controls + drives navigation with
  // direct closure access (editor/builderMode/renderSpread). Desktop is untouched
  // — every new element is display:none until the max-width:749px media query.
  // Shared JS ⇒ books, magazines and cards all get it. Idempotent.
  // ══════════════════════════════════════════════════════════════════════
  const _MSH_SVG = {
    back:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
    undo:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 14 4 9 9 4"/><path d="M4 9h11a5 5 0 0 1 5 5v1"/></svg>',
    redo:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 14 20 9 15 4"/><path d="M20 9H9a5 5 0 0 0-5 5v1"/></svg>',
    book:  '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
    save:  '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>',
    card:  '<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="12" y1="9" x2="12" y2="15"/><line x1="9" y1="12" x2="15" y2="12"/></svg>',
    lock:  '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    menu:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
    photos:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.6"/><path d="M21 15l-5-5L5 21"/></svg>',
    cover: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h11a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3z"/><line x1="8" y1="4" x2="8" y2="20"/></svg>',
    layouts:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="12" y1="9" x2="12" y2="21"/></svg>',
    stickers:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>',
    text: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 7 4 4 20 4 20 7"/><line x1="12" y1="4" x2="12" y2="20"/><line x1="9" y1="20" x2="15" y2="20"/></svg>'
  };
  const _MSH_TABS = [
    { key: "images",   label: "Photos",   icon: _MSH_SVG.photos },
    { key: "cover",    label: "Covers",   icon: _MSH_SVG.cover },
    { key: "layouts",  label: "Layouts",  icon: _MSH_SVG.layouts },
    { key: "stickers", label: "Stickers", icon: _MSH_SVG.stickers }
  ];
  let _mshBuilt = false;

  // Desktop: relocate the "Add a spread" controls inline into the bottom nav bar,
  // centered in the gap between "Next" and "Add to Cart". On phones this is a no-op —
  // the adder keeps its own row there (mobile shell relies on it as a child of stage).
  function _dmbPlaceSpreadAdderDesktop() {
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) return;
    const adder = document.getElementById("dmbSpreadAdderRow");
    const bar = document.querySelector(".dmb-canvas-stage .dmb-stage-bottombar");
    const cartBtn = document.getElementById("addToCartBtn");
    if (!adder || !bar || !cartBtn || cartBtn.parentNode !== bar) return;
    if (adder.parentNode === bar) return; // already placed
    adder.classList.add("dmb-spread-adder-inbar");
    bar.insertBefore(adder, cartBtn);
  }

  // Desktop: auto-hide the scrollbars on the photo tray AND the pages tray (thumb
  // appears while scrolling / hovering, fades away when idle — the phone's overlay feel).
  function _dmbWireAutoHideScroll(el) {
    if (!el || el._dmbAutoHideWired) return;
    el._dmbAutoHideWired = true;
    let t = null;
    el.addEventListener("scroll", () => {
      el.classList.add("dmb-scrolling");
      if (t) clearTimeout(t);
      t = setTimeout(() => el.classList.remove("dmb-scrolling"), 900);
    }, { passive: true });
  }
  function _dmbInitPhotoScrollAutoHide() {
    _dmbWireAutoHideScroll(document.getElementById("dmbPicturesScrollArea"));
    _dmbWireAutoHideScroll(document.getElementById("thumbsRail"));
    _dmbWireAutoHideScroll(document.querySelector(".dmb-pages-strip"));
  }

  // Phone debugging with no desktop console available. Add ?mshdebug=1 to the builder
  // URL and any init failure is printed on screen. Without the flag this renders
  // nothing at all, so customers never see it. (2026-10-07)
  // STICKY debug flag. openEditor rewrites the URL to ?step=2&restore=1 when the
  // builder opens, which dropped ?mshdebug=1 and switched this diagnostic off at
  // exactly the moment it was needed. Latch it once at load into sessionStorage so it
  // survives the rewrite and any navigation within the site. Accepts the hash form too,
  // since a query string can be lost when a link is shared through a chat app.
  var _DMB_DIAG_ON = false;
  try {
    var _dq = new URLSearchParams(location.search).get("mshdebug") === "1";
    var _dh = (location.hash || "").indexOf("mshdebug") >= 0;
    if (_dq || _dh) sessionStorage.setItem("dmbMshDebug", "1");
    _DMB_DIAG_ON = sessionStorage.getItem("dmbMshDebug") === "1";
  } catch (e) { _DMB_DIAG_ON = false; }

  // ── Self-correct when the browser lies about the viewport width ──────────
  // The whole mobile layout hangs off "is the window narrower than 749px". Safari's
  // "Request Desktop Website" makes a phone report ~980px, so that stops matching and
  // the customer gets the DESKTOP builder on a phone, with no error and no way to know
  // why. The setting is remembered per site per device, which is why one phone looks
  // right and another does not, and why it reads as though the site was changed.
  //
  // A customer will never go hunting in Safari settings, so the site has to fix itself.
  // screen.width still reports the REAL device width even in desktop mode, so the lie is
  // detectable: a coarse pointer on a small physical screen claiming a wide viewport.
  // When that happens, re-emit the mobile block's rules unconditionally. Reading them
  // back out of the stylesheet means there is only ever ONE copy to maintain. (2026-10-07)
  function _dmbFixFakeDesktopViewport() {
    try {
      var coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      var smallScreen = (window.screen && window.screen.width ? window.screen.width : 9999) <= 834;
      var wideViewport = window.innerWidth > 749;
      var el = document.getElementById("dmbForcedMobileCSS");
      if (!(coarse && smallScreen && wideViewport)) {
        if (el) el.remove();
        document.documentElement.classList.remove("dmb-forced-mobile");
        return false;
      }
      document.documentElement.classList.add("dmb-forced-mobile");
      if (el) return true;                       // already applied
      var out = [];
      for (var i = 0; i < document.styleSheets.length; i++) {
        var sh = document.styleSheets[i];
        if (!sh.href || sh.href.indexOf("design-my-book.css") < 0) continue;
        var rules = null;
        try { rules = sh.cssRules; } catch (e) { continue; }   // cross-origin, skip
        if (!rules) continue;
        for (var j = 0; j < rules.length; j++) {
          var r = rules[j];
          if (!r || r.type !== 4) continue;                    // CSSMediaRule only
          var cond = r.conditionText || (r.media && r.media.mediaText) || "";
          if (cond.indexOf("749px") < 0) continue;             // the mobile breakpoint
          for (var k = 0; k < r.cssRules.length; k++) out.push(r.cssRules[k].cssText);
        }
      }
      if (!out.length) return false;
      var st = document.createElement("style");
      st.id = "dmbForcedMobileCSS";
      st.textContent = out.join(String.fromCharCode(10));
      document.head.appendChild(st);
      try { console.warn("[dmb] desktop-mode viewport detected (" + window.innerWidth +
        "px reported, screen is " + window.screen.width + "px); mobile layout forced."); } catch (e) {}
      return true;
    } catch (e) { return false; }
  }
  try {
    _dmbFixFakeDesktopViewport();
    window.addEventListener("resize", function () { setTimeout(_dmbFixFakeDesktopViewport, 150); });
    window.addEventListener("orientationchange", function () { setTimeout(_dmbFixFakeDesktopViewport, 350); });
  } catch (e) {}

  function _dmbShowInitDiag() {
    if (!_DMB_DIAG_ON) return;
    var lines = [];
    try {
      var _bld = "?";
      try {
        var _sc = document.querySelector('script[src*="design-my-book.js"]');
        _bld = ((_sc && _sc.src || "").match(/mncb=([A-Za-z0-9]+)/) || [])[1] || "?";
      } catch (e) {}
      lines.push("build " + _bld + " | width " + window.innerWidth + "px | shell nodes " +
                 document.querySelectorAll('[class*="dmb-msh"]').length);
      // The single most useful line: did openEditor even REACH its init block? An
      // undefined array means it stopped earlier, which points at a hang rather than
      // a throw and tells us to look before the init calls, not at the shell itself.
      lines.push("openEditor reached init block: " +
                 (window.__DMB_INIT_ERRS === undefined ? "NO - it stopped earlier" : "yes"));
      lines.push("screen.width " + (window.screen && window.screen.width) +
                 " | forced-mobile " + (document.getElementById("dmbForcedMobileCSS") ? "YES" : "no"));
      lines.push("builder step2 visible: " +
                 (function () { var e = document.getElementById("step2");
                   return e ? (getComputedStyle(e).display !== "none" ? "yes" : "no") : "missing"; })());
      lines.push("fullscreen class: " +
                 (document.body.classList.contains("dmb-msh-fullscreen") ? "yes" : "NO"));
      if (window.__DMB_MSH_ERR) lines.push("SHELL: " + String(window.__DMB_MSH_ERR).slice(0, 400));
      (window.__DMB_INIT_ERRS || []).forEach(function (m) { lines.push("INIT: " + m.slice(0, 200)); });
      if (!window.__DMB_MSH_ERR && !(window.__DMB_INIT_ERRS || []).length) lines.push("no init errors recorded");
    } catch (e) { lines.push("diag failed: " + e); }
    var box = document.getElementById("dmbInitDiag") || document.createElement("div");
    box.id = "dmbInitDiag";
    box.style.cssText = "position:fixed;left:6px;right:6px;top:70px;z-index:2147483647;" +
      "background:#1b1b1b;color:#ffd9d2;font:11px/1.45 ui-monospace,Menlo,monospace;" +
      "padding:10px 12px;border-radius:8px;white-space:pre-wrap;max-height:45vh;overflow:auto;" +
      "border:2px solid #ff7a5c;box-shadow:0 6px 24px rgba(0,0,0,.5);";
    box.textContent = lines.join("\n");
    if (!box.parentNode) document.body.appendChild(box);
  }

  // The diagnostic above only runs at the END of openEditor, which is useless if
  // openEditor is what failed. Schedule it independently too, so the box appears even
  // when nothing downstream ever runs. Only active with ?mshdebug=1. (2026-10-07)
  try {
    if (_DMB_DIAG_ON) {
      [3000, 8000, 16000, 30000].forEach(function (ms) {
        setTimeout(function () { try { _dmbShowInitDiag(); } catch (e) {} }, ms);
      });
    }
  } catch (e) {}

  function _dmbInitMobileShell() {
    const step2 = document.getElementById("step2");
    if (!step2) return;
    if (_mshBuilt) { _mshSync(); return; }
    _mshBuilt = true;

    const clickId = (id) => { const el = document.getElementById(id); if (el) el.click(); };

    // ── Top app bar ───────────────────────────────────────────────────
    const top = document.createElement("header");
    top.id = "dmbMshTop";
    top.className = "dmb-msh-top";
    top.innerHTML =
      '<button type="button" class="dmb-msh-ic" data-act="back" aria-label="Back">' + _MSH_SVG.back + '</button>' +
      '<button type="button" class="dmb-msh-ic" data-act="undo" aria-label="Undo">' + _MSH_SVG.undo + '</button>' +
      '<button type="button" class="dmb-msh-ic" data-act="redo" aria-label="Redo">' + _MSH_SVG.redo + '</button>' +
      '<button type="button" class="dmb-msh-ic" data-act="addcard" aria-label="Add card">' + _MSH_SVG.card + '</button>' +
      '<div class="dmb-msh-a4a5 dmb-msh-a4a5-hdr" role="group" aria-label="Book size">' +
        '<button type="button" data-size="A4">A4</button>' +
        '<button type="button" data-size="A5">A5</button>' +
      '</div>' +
      '<div class="dmb-msh-title" id="dmbMshTitle">Book title</div>' +
      '<button type="button" class="dmb-msh-ic" data-act="savedesign" aria-label="Save design">' + _MSH_SVG.save + '</button>' +
      '<button type="button" class="dmb-msh-ic" data-act="preview" aria-label="Preview">' + _MSH_SVG.book + '</button>' +
      '<button type="button" class="dmb-msh-order" data-act="order">' + _MSH_SVG.lock + '<span>Order</span></button>' +
      '<button type="button" class="dmb-msh-ic" data-act="menu" aria-label="Menu">' + _MSH_SVG.menu + '</button>';
    step2.appendChild(top);
    // Wire the header A4/A5 toggle to the real .dmb-size-opt buttons + keep it in sync.
    const _hdrA4A5 = top.querySelector(".dmb-msh-a4a5-hdr");
    if (_hdrA4A5) {
      const syncA4A5 = () => {
        const active = document.querySelector(".dmb-size-opt.is-active");
        const cur = active ? active.getAttribute("data-size") : "A4";
        _hdrA4A5.querySelectorAll("button").forEach((b) =>
          b.classList.toggle("active", b.getAttribute("data-size") === cur));
      };
      _hdrA4A5.addEventListener("click", (e) => {
        const b = e.target.closest("button[data-size]"); if (!b) return;
        const real = document.querySelector('.dmb-size-opt[data-size="' + b.getAttribute("data-size") + '"]');
        if (real) real.click();
        syncA4A5();
      });
      document.querySelectorAll(".dmb-size-opt").forEach((btn) =>
        btn.addEventListener("click", () => setTimeout(syncA4A5, 0)));
      syncA4A5();
    }

    // ── Overflow menu sheet (hamburger) ───────────────────────────────
    const menu = document.createElement("div");
    menu.id = "dmbMshMenu";
    menu.className = "dmb-msh-menu";
    menu.innerHTML =
      '<div class="dmb-msh-menu-card">' +
        '<div class="dmb-msh-menu-pages"><span>Pages in book</span><div class="dmb-msh-sizewrap"><select id="dmbMshSizeSelect" class="dmb-msh-sizesel" aria-label="Number of pages"></select></div></div>' +
        '<button type="button" data-proxy="saveLayoutBtn">Save</button>' +
        // Save design / Do the magic / Add card / A4-A5 now live on the builder (quick-actions row + page-nav toggle).
        '<button type="button" data-proxy="historyBtn">History</button>' +
        // "Project" (save/open/new via a typed window.prompt) REMOVED 2026-09-10:
        // it duplicated autosave + cloud resume + History, and its "open" replaced
        // the current design with an old snapshot WITHOUT any confirmation (and
        // dropped the front/back cover photos, which its restore never copied).
        '<button type="button" data-proxy="videoTutorialBtn">Video tutorial</button>' +
        '<button type="button" data-proxy="exportTemplateBtn">Publish template</button>' +
        '<div class="dmb-msh-menu-close">Close</div>' +
      '</div>';
    step2.appendChild(menu);
    const closeMenu = () => menu.classList.remove("open");
    menu.addEventListener("click", (e) => {
      if (e.target === menu || e.target.classList.contains("dmb-msh-menu-close")) { closeMenu(); return; }
      const b = e.target.closest("[data-proxy],[data-proxysel]");
      if (!b) return;
      const id = b.getAttribute("data-proxy");
      const sel = b.getAttribute("data-proxysel");
      const el = id ? document.getElementById(id) : document.querySelector(sel);
      if (el) el.click();
      closeMenu();
    });

    top.addEventListener("click", (e) => {
      const b = e.target.closest("[data-act]"); if (!b) return;
      const act = b.getAttribute("data-act");
      if (act === "back") clickId("backToDetailsBtn");
      else if (act === "undo") clickId("undoBtn");
      else if (act === "redo") clickId("redoBtn");
      else if (act === "savedesign") clickId("saveTemplateBtn");
      else if (act === "addcard") { const c = document.querySelector(".dmb-add-card-cta"); if (c) c.click(); }
      else if (act === "preview") clickId("previewBtn");
      else if (act === "order") clickId("addToCartBtn");
      else if (act === "menu") menu.classList.toggle("open");
    });

    // ── Page navigation (Prev · page dropdown · Next · count) ─────────
    const stage = step2.querySelector(".dmb-canvas-stage");
    const pagenav = document.createElement("div");
    pagenav.id = "dmbMshPagenav";
    pagenav.className = "dmb-msh-pagenav";
    pagenav.innerHTML =
      '<button type="button" class="dmb-msh-nav dmb-msh-nav-prev" data-act="prev"><span class="dmb-msh-nav-ar">&#8249;</span><span class="dmb-msh-nav-lbl">Prev</span></button>' +
      '<div class="dmb-msh-selwrap"><select id="dmbMshPageSelect" class="dmb-msh-select"></select></div>' +
      '<button type="button" class="dmb-msh-nav dmb-msh-nav-next" data-act="next"><span class="dmb-msh-nav-lbl">Next</span><span class="dmb-msh-nav-ar">&#8250;</span></button>' +
      '<button type="button" class="dmb-msh-addpage" data-act="addpage" aria-haspopup="true">＋ Add page</button>';
    if (stage) {
      const adder = document.getElementById("dmbSpreadAdderRow");
      if (adder && adder.parentNode === stage) stage.insertBefore(pagenav, adder);
      else stage.appendChild(pagenav);
    }
    pagenav.querySelector('[data-act="prev"]').addEventListener("click", () => clickId("prevSpreadBtn"));
    pagenav.querySelector('[data-act="next"]').addEventListener("click", () => clickId("nextSpreadBtn"));
    // "＋ Add page" → a small sheet with the supported ways to add pages. A book
    // adds pages as spreads (2-page sheets), so that's the primary option.
    pagenav.querySelector('[data-act="addpage"]').addEventListener("click", () => {
      const old = document.getElementById("dmbMshAddMenu");
      if (old) { old.remove(); return; }
      const m = document.createElement("div");
      m.id = "dmbMshAddMenu";
      m.className = "dmb-msh-addmenu";
      // Magazines add two spreads at a time (one folded sheet), so the button has to
      // say so - and it has to WORK: the "+/-" adder row it used to click exists only
      // in the book section, so on a magazine this did nothing at all.
      const _magAdd = !!window.DMB_MAGAZINE_MODE;
      const _addTtl = _magAdd ? "Add 2 spreads" : "Add a spread";
      let _addSub;
      try {
        _addSub = (_magAdd ? "4 pages · " : "2 pages · ") +
                  fmtMoney(EXTRA_SPREAD_PRICE * (_magAdd ? 2 : 1)) + " · added where you choose";
      } catch (e) { _addSub = _magAdd ? "4 pages" : "2 pages"; }
      m.innerHTML =
        '<div class="dmb-msh-addmenu-card">' +
          '<div class="dmb-msh-addmenu-title">Add pages</div>' +
          '<button type="button" data-add="spread"><b>' + _addTtl + '</b><small>' + _addSub + '</small></button>' +
          '<button type="button" data-add="dup"><b>Duplicate this spread</b><small>copy the current two pages</small></button>' +
          '<button type="button" class="dmb-msh-addmenu-cancel" data-add="cancel">Cancel</button>' +
        '</div>';
      step2.appendChild(m);
      m.addEventListener("click", (e) => {
        const b = e.target.closest("[data-add]");
        if (e.target === m || !b || b.getAttribute("data-add") === "cancel") { m.remove(); return; }
        const a = b.getAttribute("data-add");
        if (a === "spread") {
          const el = document.getElementById("dmbAddSpreadBtn");
          if (el) el.click();
          else { try { _dmbAddSpreadPrompt(); } catch (e) {} }   // magazines have no adder row
        }
        else if (a === "dup") {
          const el = Array.from(document.querySelectorAll(".dmb-page-action-btn")).find((x) => x.textContent.trim() === "Duplicate page");
          if (el) el.click();
        }
        m.remove();
      });
    });
    const pageSel = pagenav.querySelector("#dmbMshPageSelect");
    pageSel.addEventListener("change", () => {
      const v = pageSel.value;
      if (v === "cover") {
        const t = document.querySelector('.dmb-icon-tab[data-tab="cover"]');
        if (t) t.click();
      } else {
        const si = parseInt(v, 10) || 0;
        try { builderMode = "pages"; } catch (e) {}
        editor.currentSpread = si;
        try { if (typeof syncBuilderModeButtons === "function") syncBuilderModeButtons(); } catch (e) {}
        renderSpread();
      }
      _mshSync();
    });

    // ── Page-count dropdown (the "N pages" chip) — mirrors the real #pages
    //    select; changing it rebuilds the book at the new page count. ────────
    const sizeSel = document.getElementById("dmbMshSizeSelect");
    const pagesEl = document.getElementById("pages");
    if (sizeSel && pagesEl) {
      Array.from(pagesEl.options).forEach((o) => {
        if (!o.value) return; // skip the "Select pages" placeholder
        const opt = document.createElement("option");
        opt.value = o.value;
        opt.textContent = o.textContent;
        sizeSel.appendChild(opt);
      });
      sizeSel.addEventListener("change", () => {
        pagesEl.value = sizeSel.value;
        pagesEl.dispatchEvent(new Event("change", { bubbles: true }));
        _mshSync();
      });
    }

    // ── Icon ribbon (under the page-nav row) ──────────────────────────
    // Replaces the per-page side rails so the canvas gets the full width. Idle:
    // a scrollable row of Add + Page quick-actions (icons). When an object is
    // selected its edit bar docks HERE instead (mobile has no top ribbon —
    // .dmb-stage-header is display:none), via _dmbDockBar's mobile branch.
    (function _mshBuildRibbon() {
      if (document.getElementById("dmbMshRibbon")) return;
      const S = 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
      const ICO = {
        text:    '<svg viewBox="0 0 24 24" '+S+'><path d="M4 7V5h16v2"/><path d="M12 5v14"/><path d="M9 19h6"/></svg>',
        photo:   '<svg viewBox="0 0 24 24" '+S+'><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="10" r="1.5"/><path d="M21 16l-5-5-7 7"/></svg>',
        shape:   '<svg viewBox="0 0 24 24" '+S+'><rect x="4" y="4" width="16" height="16" rx="2"/></svg>',
        map:     '<svg viewBox="0 0 24 24" '+S+'><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2z"/><path d="M9 4v14M15 6v14"/></svg>',
        sticker: '<svg viewBox="0 0 24 24" '+S+'><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9l5-5V5a2 2 0 0 0-2-2z"/><path d="M14 21v-4a2 2 0 0 1 2-2h4"/></svg>',
        undo:    '<svg viewBox="0 0 24 24" '+S+'><path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/></svg>',
        redo:    '<svg viewBox="0 0 24 24" '+S+'><path d="m15 14 5-5-5-5"/><path d="M20 9H9a5 5 0 0 0 0 10h3"/></svg>',
        layout:  '<svg viewBox="0 0 24 24" '+S+'><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
        dup:     '<svg viewBox="0 0 24 24" '+S+'><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
        magic:   '<svg viewBox="0 0 24 24" '+S+'><path d="M5 21 15 11l-2-2L3 19z"/><path d="M17 3l.9 2.1L20 6l-2.1.9L17 9l-.9-2.1L14 6z"/></svg>',
        clear:   '<svg viewBox="0 0 24 24" '+S+'><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9l6 6M15 9l-6 6"/></svg>',
        bg:      '<svg viewBox="0 0 24 24" '+S+'><path d="M12 3s6 6.5 6 10.5a6 6 0 0 1-12 0C6 9.5 12 3 12 3z"/></svg>'
      };
      const btn = (act, lbl, ic) =>
        '<button type="button" class="dmb-msh-rb" data-rb="' + act + '"><span class="dmb-msh-rb-ic">' + ic + '</span><span class="dmb-msh-rb-lbl">' + lbl + '</span></button>';
      const ribbon = document.createElement("div");
      ribbon.id = "dmbMshRibbon";
      ribbon.className = "dmb-msh-ribbon";
      const idleRow = document.createElement("div");
      idleRow.id = "dmbMshRibbonIdle";
      idleRow.className = "dmb-msh-ribbon-idle";
      // Undo/Redo live in the top bar; Stickers/Layouts are bottom tabs — so they're
      // NOT duplicated here. Ribbon = add tools + page actions unique to it.
      idleRow.innerHTML =
        btn("text","Text",ICO.text) + btn("photo","Photo",ICO.photo) + btn("shape","Shape",ICO.shape) +
        btn("map","Map",ICO.map) +
        '<span class="dmb-msh-rb-sep"></span>' +
        btn("bg","Background",ICO.bg) + btn("dup","Duplicate",ICO.dup) + btn("magic","Magic",ICO.magic) + btn("clear","Clear",ICO.clear);
      ribbon.appendChild(idleRow);
      if (stage) {
        const adder = document.getElementById("dmbSpreadAdderRow");
        if (adder && adder.parentNode === stage) stage.insertBefore(ribbon, adder);
        else if (pagenav.nextSibling) stage.insertBefore(ribbon, pagenav.nextSibling);
        else stage.appendChild(ribbon);
      }
      const byId = (id) => { const el = document.getElementById(id); if (el) el.click(); };
      const pageAct = (label) => {
        const el = Array.from(document.querySelectorAll(".dmb-page-action-btn")).find((x) => x.textContent.trim() === label);
        if (el) el.click();
      };

      // ── Page background colour (mobile) ────────────────────────────────
      // A ribbon popup that colours the CURRENT spread's page(s). The user picks
      // which page with a Left/Right/Both toggle (default Both). Writes go to the
      // existing editor.pageBackgrounds model (same one the desktop rail uses), so
      // rendering, undo, save, duplicate and PDF export already handle it.
      // The popup carries class .dmb-text-color-pop so _dmbMobileRibbonPopovers
      // floats it as a full-width bottom sheet above everything.
      let _mshBgTarget = "both";
      const bgPop = document.createElement("div");
      bgPop.id = "dmbMshBgPop";
      bgPop.className = "dmb-text-color-pop dmb-msh-bgpop";
      bgPop.hidden = true;
      bgPop.innerHTML =
        '<div class="dmb-text-color-pop-title">Page background</div>' +
        '<div class="dmb-msh-bg-target" role="group" aria-label="Which page to colour">' +
          '<button type="button" data-tgt="left">Left</button>' +
          '<button type="button" data-tgt="right">Right</button>' +
          '<button type="button" data-tgt="both" class="active">Both</button>' +
        '</div>' +
        '<div class="dmb-msh-bg-swatches" id="dmbMshBgSwatches"></div>' +
        '<div id="dmbMshBgEmpty" style="font-size:12px;color:#9a9a9a;padding:2px 2px 0" hidden>No saved colours yet — pick one with “＋ Custom colour…”.</div>' +
        '<button type="button" class="dmb-msh-bg-custom">＋ Custom colour…' +
          '<input type="color" class="dmb-msh-bg-input" value="#ffffff" tabindex="-1" aria-hidden="true"></button>' +
        '<button type="button" class="dmb-msh-bg-remove">Remove background</button>';
      document.body.appendChild(bgPop);
      const _bgInput = bgPop.querySelector(".dmb-msh-bg-input");

      function _mshCurrentPages() {
        // Cover view can be currentSpread === -1 OR builderMode === "cover" while
        // currentSpread is still 0 — both mean "no page spread is showing", so the
        // background must target the cover, not the (hidden) first spread's pages.
        if (typeof builderMode !== "undefined" && builderMode === "cover") return null;
        const si = editor && editor.currentSpread;
        if (si == null || si < 0) return null;   // cover mode
        return { left: si * 2 + 1, right: si * 2 + 2 };
      }
      function _mshApplyBg(color) {
        const norm = (color || "#ffffff").toLowerCase();
        const pages = _mshCurrentPages();
        if (!pages) {   // cover mode → colour the cover instead
          try {
            if (typeof coverState !== "undefined") {
              pushUndoState("Cover Background");
              coverState.color = (norm !== "#ffffff") ? norm : "#ffffff";
              if (typeof saveCoverDesignToStorage === "function") saveCoverDesignToStorage();
              if (typeof renderCoverCanvas === "function") renderCoverCanvas();
            }
          } catch (e) {}
          return;
        }
        let targets = _mshBgTarget === "left" ? [pages.left]
                    : _mshBgTarget === "right" ? [pages.right]
                    : [pages.left, pages.right];
        targets = targets.filter((p) => p >= 1 && p <= (editor.totalPages || 0));
        if (!targets.length) return;
        try { pushUndoState("Page Background"); } catch (e) {}
        editor.pageBackgrounds = editor.pageBackgrounds || {};
        targets.forEach((p) => {
          if (norm !== "#ffffff") editor.pageBackgrounds[p] = norm;
          else delete editor.pageBackgrounds[p];
        });
        try { renderBuilderCanvas(); } catch (e) {}
        try { renderThumbsRail(); } catch (e) {}
      }
      function _mshSyncBgUI() {
        // Reflect the target page's current colour into the picker + active swatch.
        const pages = _mshCurrentPages();
        let cur = "#ffffff";
        if (pages) {
          const p = (_mshBgTarget === "right") ? pages.right : pages.left;
          cur = (editor.pageBackgrounds && editor.pageBackgrounds[p]) || "#ffffff";
        } else if (typeof coverState !== "undefined") {
          cur = coverState.color || "#ffffff";
        }
        cur = String(cur).toLowerCase();
        _bgInput.value = /^#[0-9a-f]{6}$/i.test(cur) ? cur : "#ffffff";
        // Palette = the user's SAVED colours only (no presets/generated swatches).
        const _sw = bgPop.querySelector("#dmbMshBgSwatches");
        const _colors = ((typeof dmbGetRecentColors === "function") ? dmbGetRecentColors() : []) || [];
        if (_sw) {
          _sw.innerHTML = _colors.map((h) =>
            '<button type="button" class="dmb-msh-bg-swatch" data-hex="' + h + '" title="' + h + '" style="background:' + h + '"></button>').join("");
          _sw.hidden = _colors.length === 0;
          _sw.querySelectorAll(".dmb-msh-bg-swatch").forEach((b) =>
            b.classList.toggle("active", (b.dataset.hex || "").toLowerCase() === cur));
        }
        const _em = bgPop.querySelector("#dmbMshBgEmpty"); if (_em) _em.hidden = _colors.length > 0;
        // Cover mode has no Left/Right — hide the toggle there.
        const tgt = bgPop.querySelector(".dmb-msh-bg-target");
        if (tgt) tgt.style.display = pages ? "" : "none";
      }
      function _mshToggleBgPop() {
        const willOpen = bgPop.hidden;
        if (willOpen) _mshSyncBgUI();
        bgPop.hidden = !willOpen;
      }
      // target toggle
      bgPop.querySelectorAll(".dmb-msh-bg-target button").forEach((b) => {
        b.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          _mshBgTarget = b.dataset.tgt;
          bgPop.querySelectorAll(".dmb-msh-bg-target button").forEach((x) => x.classList.toggle("active", x === b));
          _mshSyncBgUI();
        });
      });
      // saved-colour swatches (delegated — the list is re-rendered on each open)
      const _bgSwWrap = bgPop.querySelector("#dmbMshBgSwatches");
      if (_bgSwWrap) _bgSwWrap.addEventListener("click", (e) => {
        const b = e.target.closest(".dmb-msh-bg-swatch"); if (!b) return;
        e.preventDefault(); e.stopPropagation();
        _mshApplyBg(b.dataset.hex);
        try { if ((b.dataset.hex || "").toLowerCase() !== "#ffffff") dmbAddRecentColor(b.dataset.hex); } catch (e2) {}
        _mshSyncBgUI();
      });
      // custom colour — overlay the real input over the button so an iOS tap opens
      // the native wheel (a programmatic .click() is ignored on iOS). Desktop still
      // works via the .click() fallback below.
      const _bgCustomBtn = bgPop.querySelector(".dmb-msh-bg-custom");
      _bgCustomBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (e.target !== _bgInput) { try { _bgInput.click(); } catch (e2) {} }
      });
      try { _dmbColorTapFix(_bgCustomBtn, _bgInput); } catch (e) {}
      _bgInput.addEventListener("input", () => _mshApplyBg(_bgInput.value));   // live scrub
      _bgInput.addEventListener("change", () => { _mshApplyBg(_bgInput.value); _mshSyncBgUI(); try { dmbAddRecentColor(_bgInput.value); } catch (e) {} });
      // remove
      bgPop.querySelector(".dmb-msh-bg-remove").addEventListener("click", (e) => {
        e.stopPropagation(); _mshApplyBg("#ffffff"); _mshSyncBgUI();
      });
      // close on outside tap (but not the opening tap on the ribbon Background btn,
      // and not while the native colour picker is up — it steals focus and the tap
      // that returns focus must not kill the sheet mid-edit).
      document.addEventListener("click", (e) => {
        if (bgPop.hidden) return;
        if (e.target.closest("#dmbMshBgPop") || e.target.closest('[data-rb="bg"]')) return;
        if (document.activeElement === _bgInput) return;
        bgPop.hidden = true;
      });

      idleRow.addEventListener("click", (e) => {
        const b = e.target.closest("[data-rb]"); if (!b) return;
        const a = b.getAttribute("data-rb");
        if (a === "text") byId("canvasTextBtn");
        else if (a === "photo") byId("canvasPhotoBtn");
        else if (a === "shape") byId("canvasShapeBtn");
        else if (a === "map") byId("addMyMapBtn");
        else if (a === "sticker") byId("dmbStickersBtn");
        else if (a === "bg") _mshToggleBgPop();
        else if (a === "undo") byId("undoBtn");
        else if (a === "redo") byId("redoBtn");
        else if (a === "magic") byId("smartCreationBtn");
        else if (a === "layout") pageAct("Choose layout");
        else if (a === "dup") pageAct("Duplicate page");
        else if (a === "clear") pageAct("Clear page");
      });
    })();

    // ── Bottom tab bar ────────────────────────────────────────────────
    const tabbar = document.createElement("nav");
    tabbar.id = "dmbMshTabs";
    tabbar.className = "dmb-msh-tabs";
    tabbar.innerHTML = _MSH_TABS.map((t) =>
      '<button type="button" class="dmb-msh-tab" data-tab="' + t.key + '">' +
        '<span class="dmb-msh-tab-ic">' + t.icon + '</span>' +
        '<span class="dmb-msh-tab-lbl">' + t.label + '</span>' +
      '</button>'
    ).join("");
    step2.appendChild(tabbar);
    tabbar.addEventListener("click", (e) => {
      const b = e.target.closest(".dmb-msh-tab"); if (!b) return;
      const key = b.getAttribute("data-tab");
      const iconTab = document.querySelector('.dmb-icon-tab[data-tab="' + key + '"]');
      if (iconTab) {
        iconTab.click();
      } else {
        // No matching icon-tab (e.g. Text) — activate its side panel directly.
        document.querySelectorAll(".dmb-icon-tab").forEach((t) => t.classList.remove("active"));
        document.querySelectorAll(".dmb-side-panel").forEach((p) => p.classList.remove("active"));
        const panel = document.querySelector('.dmb-side-panel[data-panel="' + key + '"]');
        if (panel) panel.classList.add("active");
        const lt = document.getElementById("dmbLeftTitle");
        if (lt) lt.textContent = (_MSH_TABS.find((x) => x.key === key) || {}).label || "Panel";
      }
      if (key === "layouts") {
        _mshBuildLayoutsPanel();
        // Re-fit the A4 thumbnails once the panel is visible AND its height has
        // settled. A single rAF fires before the activation reflow finishes (tray
        // still short → thumbnails too narrow), so re-run on a couple of timeouts.
        const _fit = () => { try { window._mshSizeLayoutItems && window._mshSizeLayoutItems(); } catch (e) {} };
        requestAnimationFrame(_fit);
        setTimeout(_fit, 180);
        setTimeout(_fit, 450);
      }
      _mshSyncTabs();
    });

    // Resync the page dropdown whenever the spread index text changes
    // (fires on every renderSpread — covers Prev/Next, add-spread, restore…).
    const idxEl = document.getElementById("spreadIndex");
    if (idxEl && window.MutationObserver) {
      new MutationObserver(() => _mshSync()).observe(idxEl, { childList: true, characterData: true, subtree: true });
    }
    // Keep the bottom-tab highlight in sync when panels change elsewhere.
    document.querySelectorAll(".dmb-icon-tab").forEach((t) =>
      t.addEventListener("click", () => setTimeout(_mshSyncTabs, 0))
    );

    // Full-screen the builder on phones: add a body class while #step2 is
    // visible so the CSS can hide the theme header/footer and lock page scroll.
    // Toggled with #step2's inline display so the upload step / other pages stay
    // normal. (Effects are gated by the max-width:749px media query, so desktop
    // is unaffected even though the class is present.)
    try {
      const _mshFS = () => {
        const s = step2.getAttribute("style") || "";
        const shown = !/display\s*:\s*none/i.test(s);
        document.body.classList.toggle("dmb-msh-fullscreen", shown);
      };
      _mshFS();
      new MutationObserver(_mshFS).observe(step2, { attributes: true, attributeFilter: ["style"] });
    } catch (e) {}

    // Re-fit the spread on resize / rotate so the action rails stay visible.
    let _mshRz;
    window.addEventListener("resize", () => {
      clearTimeout(_mshRz);
      _mshRz = setTimeout(() => { _mshFitSpread(); _mshSync(); try { _dmbSizePhotoTiles(); } catch (e) {} }, 150);
    });
    window.addEventListener("orientationchange", () => setTimeout(() => { _mshFitSpread(); try { _dmbSizePhotoTiles(); } catch (e) {} }, 350));

    // Re-fit whenever the canvas re-renders — this covers the COVER view and
    // every spread action/refresh, so the size stays stable and always largest-fit.
    if (spreadCanvas && window.MutationObserver) {
      let _mshRaf;
      new MutationObserver(() => {
        cancelAnimationFrame(_mshRaf);
        _mshRaf = requestAnimationFrame(_mshFitSpread);
      }).observe(spreadCanvas, { childList: true });
    }

    // Photos panel (phones): lift Sort + "Hide used" onto the "Pictures" title
    // row and drop the redundant Pages control (the nav-bar page-count dropdown
    // replaces it). CSS turns the tray into a horizontal swipe row.
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) {
      try {
        const head = step2.querySelector(".dmb-leftpanel-head");
        const addBtn = document.getElementById("addMorePhotosBtn");
        const hideUsed = step2.querySelector(".dmb-hide-used-inline");
        const sortSel = document.getElementById("photoSortSelect");
        if (head && addBtn && !head.dataset.mshHead) {
          head.dataset.mshHead = "1";
          // Replace the "Pictures/Images" title with the "Do the Magic" action — it
          // takes the title's place (per request); proxies the real #smartCreationBtn.
          const _lt = document.getElementById("dmbLeftTitle");
          if (_lt) _lt.style.display = "none";
          // No header row: the whole dock is the photo tray. "Add more pictures"
          // becomes a compact ＋ tile at the START of the strip; "Hide used" a small
          // toggle pinned in the dock's top-right. "Do the Magic" lives in the ribbon.
          const picSec = step2.querySelector('.dmb-side-panel[data-panel="images"] .dmb-pictures-section');
          addBtn.innerHTML = '<span class="dmb-msh-addtile-plus">＋</span><span class="dmb-msh-addtile-lbl">Add</span>';
          addBtn.classList.add("dmb-msh-addtile");
          if (picSec) picSec.insertBefore(addBtn, picSec.firstChild);
          const dock = step2.querySelector(".dmb-builder-leftpanel");
          if (hideUsed && dock) { hideUsed.classList.add("dmb-msh-hidetoggle"); dock.appendChild(hideUsed); }
          if (sortSel) sortSel.style.display = "none";   // not in the requested layout
          _mshBuildPhotoScrollbar();
          // Covers panel: the swatch label reads "Cover background" per the mockup.
          const cvLbl = step2.querySelector('.dmb-side-panel[data-panel="cover"] .dmb-form-grid .dmb-mini-label');
          if (cvLbl) cvLbl.textContent = "Cover background";
          // "Choose cover layout" should NOT open a popup on mobile — send the user
          // to the inline Layouts tab (which now applies to the cover). Capture-phase
          // + stopImmediatePropagation cancels the modal-opening handler.
          const _ccl = document.getElementById("chooseCoverLayoutBtn");
          if (_ccl) _ccl.addEventListener("click", (ev) => {
            ev.preventDefault(); ev.stopImmediatePropagation();
            const lt = document.querySelector('.dmb-msh-tab[data-tab="layouts"]');
            if (lt) lt.click();
          }, true);
        }
      } catch (e) {}
    }

    _mshSync();
  }

  // Rebuild the page dropdown + count + prev/next state from the live model.
  function _mshSync() {
    const sel = document.getElementById("dmbMshPageSelect");
    if (!sel) return;
    const total = Math.max(1, editor.totalSpreads || 1);
    const cur = editor.currentSpread;
    // Navigation model (matches prev/next buttons): Cover (builderMode "cover")
    // → Page 0 / "Spread 0" (currentSpread === -1, a single first page) → 1–2
    // (currentSpread 0) → 3–4 (1) → … Cover is a MODE, so currentSpread === -1
    // is Page 0, NOT the cover — the old code conflated the two, which hid Page 0.
    const inCover = (typeof builderMode !== "undefined" && builderMode === "cover");
    let html = '<option value="cover">Cover</option>';
    html += '<option value="-1">0</option>';   // Page 0 — the single first page
    for (let si = 0; si < total; si++) {
      html += '<option value="' + si + '">' + (si * 2 + 1) + '–' + (si * 2 + 2) + '</option>';
    }
    sel.innerHTML = html;
    sel.value = inCover ? "cover" : String(cur);   // cur === -1 → "-1" (Page 0)
    const sizeSel = document.getElementById("dmbMshSizeSelect");
    const pagesEl = document.getElementById("pages");
    if (sizeSel && pagesEl && pagesEl.value) sizeSel.value = pagesEl.value;
    const prev = document.querySelector('#dmbMshPagenav [data-act="prev"]');
    const next = document.querySelector('#dmbMshPagenav [data-act="next"]');
    // Cover is the first view (nothing before it); every other view can go back
    // (Page 0 → Cover, spread 0 → Page 0, spread n → n-1). Next stops on the last.
    if (prev) prev.disabled = inCover;
    if (next) next.disabled = !inCover && cur >= total - 1;
    const title = document.getElementById("dmbMshTitle");
    if (title) { try { title.textContent = getEffectiveBookTitle() || "Book title"; } catch (e) {} }
    _mshSyncTabs();
  }

  // Highlight the bottom tab matching the currently-active side panel.
  function _mshSyncTabs() {
    const active = document.querySelector(".dmb-side-panel.active");
    const key = active ? active.getAttribute("data-panel") : null;
    document.querySelectorAll(".dmb-msh-tab").forEach((t) =>
      t.classList.toggle("active", t.getAttribute("data-tab") === key)
    );
    // The lifted "add pictures" pill + "hide used" belong to the Photos panel only.
    const showHead = (key === "images");
    document.querySelectorAll(".dmb-msh-headitem").forEach((el) => {
      el.style.display = showHead ? "" : "none";
    });
    // Header only on the Photos panel (title + add pill + hide-used). Covers,
    // Layouts and Stickers have no header/title per the mockups.
    const _head = document.querySelector(".dmb-leftpanel-head");
    if (_head) _head.style.display = (key === "images") ? "" : "none";
    // "Hide used" is pinned to the dock (not inside the images panel), so it must
    // be toggled explicitly — otherwise it lingers over Layouts/Covers/Stickers.
    const _hu = document.querySelector(".dmb-msh-hidetoggle");
    if (_hu) _hu.style.display = (key === "images") ? "" : "none";
  }

  // Apply a layout to a cover face directly (no confirm popup) — mirrors the
  // "apply over, keep photos" branch of setCoverLayoutWithConfirm.
  function _mshApplyCoverLayoutDirect(zone, templateId) {
    if (typeof coverState === "undefined") return;
    try { pushUndoState(); } catch (e) {}
    const isBack = (zone === "back");
    const lKey = isBack ? "backLayout" : "frontLayout";
    const fKey = isBack ? "backFrames" : "frontFrames";
    const rKey = isBack ? "backFrameRot" : "frontFrameRot";
    coverState[fKey] = coverState[fKey] || {};
    coverState[rKey] = coverState[rKey] || {};
    coverState[lKey] = templateId || null;
    if (templateId && TEMPLATE_DEFS[templateId]) {
      const defs = TEMPLATE_DEFS[templateId];
      defs.forEach((f) => {
        if (!(f.key in coverState[fKey])) coverState[fKey][f.key] = null;
        if (!(f.key in coverState[rKey])) coverState[rKey][f.key] = 0;
      });
      Object.keys(coverState[fKey]).forEach((k) => {
        if (!defs.find((d) => d.key === k)) delete coverState[fKey][k];
      });
    } else {
      coverState[fKey] = {}; coverState[rKey] = {};
    }
    // Convert the just-set fixed layout into deletable free frames BEFORE saving, so
    // the persisted design stores free frames (not a fixed layout). renderCoverCanvas
    // would convert anyway, but that runs after this save.
    try { _dmbConvertCoverFixedLayouts(); } catch (e) {}
    try { saveCoverDesignToStorage(); } catch (e) {}
    builderMode = "cover";
    renderCoverCanvas();
  }

  // Phones: scale the whole spread (both pages PLUS the flanking per-page action
  // rails) down with CSS zoom so nothing is cut off the screen. Width-fit only;
  // no-ops on desktop and when it already fits. getBoundingClientRect accounts
  // for zoom, so drag/drop hit-testing still maps correctly.
  function _mshFitSpread() {
    try {
      if (!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches)) return;
      if (!spreadViewport || !spreadCanvas) return;
      // The cover render path (renderCoverCanvas) forces the viewport to
      // height:auto / maxHeight:760 for the DESKTOP layout. In the phone shell the
      // viewport is position:absolute; inset:0 and the centring depends on it being
      // that full-size box — so clear those inline overrides and let the CSS govern,
      // otherwise the cover anchors off-centre and runs off the screen.
      spreadViewport.style.height = ""; spreadViewport.style.minHeight = ""; spreadViewport.style.maxHeight = "";
      // iOS Safari ignores CSS `zoom` on this canvas (that was the whole bug — the
      // cover/spread never shrank). Scale with `transform` instead, which the
      // builder already uses everywhere and iOS supports. Clear any legacy zoom.
      spreadCanvas.style.zoom = "";
      // transform doesn't change the layout box, so scrollWidth/Height = the true
      // unscaled content size regardless of the current transform.
      const naturalW = spreadCanvas.scrollWidth;
      const naturalH = spreadCanvas.scrollHeight;
      // Measure the STAGE box (fixed height, via CSS) — NOT the viewport, which
      // sizes to the tall content and would report the wrong available height.
      const stage = spreadViewport.parentElement || spreadViewport;
      const availW = stage.clientWidth - 10;
      const availH = stage.clientHeight - 10;
      if (naturalW < 4 || naturalH < 4 || availW < 4 || availH < 4) {
        // Layout not ready (common right after a cover re-render) — try again next
        // frame rather than leaving the canvas un-centred. Bounded so it can't spin.
        _mshFitSpread._t = (_mshFitSpread._t || 0) + 1;
        if (_mshFitSpread._t <= 15) requestAnimationFrame(_mshFitSpread);
        return;
      }
      _mshFitSpread._t = 0;
      // Largest size that fits BOTH width and height: keeps every side button on
      // screen for spreads, and shows the WHOLE cover. Deterministic ⇒ never
      // changes; uniform scale ⇒ text/stickers keep exact proportions.
      const fit = Math.min(1, availW / naturalW, availH / naturalH);
      currentZoom = Math.max(0.1, fit);
      // Absolutely CENTER the canvas in the stage and scale about its centre — the
      // layout box stays 680px but translate(-50%,-50%) centres it, so nothing is
      // clipped top/bottom or left/right. iOS-safe (transform, not `zoom`).
      spreadCanvas.style.transformOrigin = "center center";
      spreadCanvas.style.transform = "translate(-50%, -50%) scale(" + currentZoom + ")";
    } catch (e) {}
  }

  // Phones: a visible horizontal scrollbar (◄ track ►) under the photo tray, since
  // native scrollbars are hidden on touch. Arrows scroll; the thumb tracks position.
  function _mshBuildPhotoScrollbar() {
    try {
      const scroller = document.getElementById("dmbPicturesScrollArea");
      if (!scroller || document.getElementById("dmbMshScrollbar")) return;
      const bar = document.createElement("div");
      bar.id = "dmbMshScrollbar";
      bar.className = "dmb-msh-scrollbar";
      bar.innerHTML =
        '<button type="button" class="dmb-msh-sb-arrow" data-dir="-1" aria-label="Scroll left">&#9664;</button>' +
        '<div class="dmb-msh-sb-track"><div class="dmb-msh-sb-thumb"></div></div>' +
        '<button type="button" class="dmb-msh-sb-arrow" data-dir="1" aria-label="Scroll right">&#9654;</button>';
      scroller.parentNode.insertBefore(bar, scroller.nextSibling);
      const thumb = bar.querySelector(".dmb-msh-sb-thumb");
      const update = () => {
        const sw = scroller.scrollWidth, cw = scroller.clientWidth;
        if (sw <= cw + 2) { thumb.style.width = "100%"; thumb.style.left = "0%"; return; }
        thumb.style.width = Math.max(14, (cw / sw) * 100) + "%";
        thumb.style.left = (scroller.scrollLeft / sw * 100) + "%";
      };
      scroller.addEventListener("scroll", update, { passive: true });
      bar.addEventListener("click", (e) => {
        const a = e.target.closest("[data-dir]"); if (!a) return;
        const dir = parseInt(a.getAttribute("data-dir"), 10) || 1;
        scroller.scrollBy({ left: dir * scroller.clientWidth * 0.7, behavior: "smooth" });
      });
      const tray = document.getElementById("editorPhotoTray");
      if (tray && window.MutationObserver) {
        new MutationObserver(() => requestAnimationFrame(update)).observe(tray, { childList: true });
      }
      requestAnimationFrame(update);
    } catch (e) {}
  }

  // Shared inline Layouts panel — used on BOTH mobile and desktop. It replaces the
  // side-panel content with a Left/Right/Both target, category chips by photo-frame
  // count, and layout thumbnails. Tapping one applies DIRECTLY (no confirm popup),
  // keeping existing photos/text. On mobile the thumbnails are a horizontal tray
  // sized by JS (iOS aspect-ratio bug); on desktop they're a vertical A4 grid via
  // CSS aspect-ratio. Keep the two arrangements in sync when editing.
  function _dmbRenderLayoutsPanel(opts) {
    opts = opts || {};
    const mobile = !!opts.mobile;
    try {
      const panel = document.querySelector('.dmb-side-panel[data-panel="layouts"]');
      if (!panel || typeof TEMPLATE_DEFS === "undefined") return;

      // Categories by photo-frame count: 1, 2, 3, and "4+" (everything ≥4).
      const CATS = [
        { key: "1", label: "1 Photo",  test: (n) => n === 1 },
        { key: "2", label: "2 Photos", test: (n) => n === 2 },
        { key: "3", label: "3 Photos", test: (n) => n === 3 },
        { key: "4", label: "4+",       test: (n) => n >= 4 }
      ];
      const idsFor = (cat) => Object.keys(TEMPLATE_DEFS).filter((id) => cat.test((TEMPLATE_DEFS[id] || []).length || 1));

      const wrap = document.createElement("div");
      wrap.className = "dmb-msh-lay" + (mobile ? "" : " dmb-lay-desktop");
      const _targetHTML =
        '<div class="dmb-msh-lay-target" role="group" aria-label="Apply layout to">' +
          '<button type="button" data-tgt="left">Left</button>' +
          '<button type="button" data-tgt="right">Right</button>' +
          '<button type="button" data-tgt="both">Both</button>' +
        '</div>';
      // MOBILE: Left/Right/Both + a photo-count DROPDOWN share one compact row, then
      // the swipe tray — so the whole picker fits the panel with no vertical scroll.
      // DESKTOP: keep the category chip row.
      wrap.innerHTML = mobile
        ? ('<div class="dmb-msh-lay-head">' + _targetHTML +
             '<select class="dmb-msh-lay-catsel" aria-label="Number of photos"></select>' +
           '</div>' +
           '<div class="dmb-msh-lay-tray"></div>')
        : (_targetHTML + '<div class="dmb-msh-lay-cats"></div><div class="dmb-msh-lay-tray"></div>');
      panel.innerHTML = "";
      panel.appendChild(wrap);

      const catsEl = wrap.querySelector(".dmb-msh-lay-cats");     // desktop chips
      const catSel = wrap.querySelector(".dmb-msh-lay-catsel");   // mobile dropdown
      const trayEl = wrap.querySelector(".dmb-msh-lay-tray");
      let target = (opts.defaultTarget === "right" || opts.defaultTarget === "both") ? opts.defaultTarget : "left";
      const _avail = CATS.filter((cat) => idsFor(cat).length);
      let activeCat = _avail[0] || CATS[0];

      // Initial target highlight (reflects which page/menu opened the panel).
      wrap.querySelectorAll(".dmb-msh-lay-target button").forEach((x) =>
        x.classList.toggle("active", x.getAttribute("data-tgt") === target));

      wrap.querySelector(".dmb-msh-lay-target").addEventListener("click", (e) => {
        const b = e.target.closest("[data-tgt]"); if (!b) return;
        target = b.getAttribute("data-tgt");
        wrap.querySelectorAll(".dmb-msh-lay-target button").forEach((x) => x.classList.toggle("active", x === b));
      });

      if (catSel) {
        // Mobile: categories become dropdown options.
        _avail.forEach((cat) => {
          const o = document.createElement("option");
          o.value = cat.key; o.textContent = cat.label;
          catSel.appendChild(o);
        });
        catSel.value = activeCat.key;
        catSel.addEventListener("change", () => {
          activeCat = CATS.find((c) => c.key === catSel.value) || activeCat;
          renderTray();
        });
      } else if (catsEl) {
        // Desktop: categories are chip buttons.
        _avail.forEach((cat) => {
          const b = document.createElement("button");
          b.type = "button"; b.setAttribute("data-cat", cat.key);
          b.textContent = cat.label;
          if (cat === activeCat) b.classList.add("active");
          b.addEventListener("click", () => {
            activeCat = cat;
            catsEl.querySelectorAll("button").forEach((x) => x.classList.toggle("active", x === b));
            renderTray();
          });
          catsEl.appendChild(b);
        });
      }

      // Apply the tapped layout DIRECTLY — NO confirm popup. Uses the existing
      // free-frame spawner (keeps any existing photos/text, replaces prior layout
      // frames). Applies to the targeted page(s) of the current spread, or the
      // active cover face when in cover mode.
      function applyTo(id) {
        if (typeof builderMode !== "undefined" && builderMode === "cover") {
          const zone = (typeof activeCoverZone !== "undefined" && activeCoverZone === "back") ? "back" : "front";
          _mshApplyCoverLayoutDirect(zone, id);
          return;
        }
        const lp = editor.currentSpread * 2 + 1;
        const rp = editor.currentSpread * 2 + 2;
        const targets = target === "both" ? [lp, rp] : target === "right" ? [rp] : [lp];
        try { pushUndoState(); } catch (e) {}
        targets.forEach((p) => {
          if (p > editor.totalPages) return;
          if (typeof isLockedPage === "function" && isLockedPage(p)) return;
          if (id && TEMPLATE_DEFS[id]) _dmbSpawnLayoutFrames(p, id);
          else ensureTemplateState(p, null);
        });
        renderSpread(); renderThumbsRail(); renderPhotoTray();
      }

      // MOBILE only: size every thumbnail to a TRUE A4-portrait shape — the items
      // fill the tray height (CSS height:100%), so we read that real height and set
      // each item's width = height / 1.4142. Avoids CSS aspect-ratio (iOS Safari
      // mishandles it on flex items). Desktop uses CSS aspect-ratio in a grid.
      const A4 = 1.41421;
      function sizeItems() {
        if (!mobile) return;
        const items = trayEl.querySelectorAll(".dmb-msh-lay-item");
        if (!items.length) return;
        // Compute from the TRAY's own height (stable once the panel is visible) —
        // reading the mini's clientHeight lagged during layout settle and left the
        // thumbnails too narrow. Item is border-box with 5px padding all round, so
        // the inner page = trayH - 10; width = inner/A4 + 10 → true A4 portrait.
        const h = trayEl.clientHeight;
        if (!h) { requestAnimationFrame(sizeItems); return; }
        const itemW = Math.round((h - 10) / A4 + 10);
        items.forEach((it) => { it.style.width = itemW + "px"; });
      }
      if (mobile) window._mshSizeLayoutItems = sizeItems;
      // The tray's height only settles after the tab becomes visible / the panel
      // reflows, so a single early sizeItems() leaves stale (too-narrow) widths.
      // A ResizeObserver re-sizes the thumbnails to the true A4 shape whenever the
      // tray's box changes (tab open, rotate, keyboard) — self-healing.
      if (mobile && window.ResizeObserver) {
        try { new ResizeObserver(() => { try { sizeItems(); } catch (e) {} }).observe(trayEl); } catch (e) {}
      }

      function renderTray() {
        trayEl.innerHTML = "";
        idsFor(activeCat).forEach((id) => {
          const item = document.createElement("button");
          item.type = "button"; item.className = "dmb-msh-lay-item";
          item.title = (typeof TEMPLATE_NAMES !== "undefined" && TEMPLATE_NAMES[id]) || id;
          const mini = document.createElement("div");
          mini.className = "dmb-template-mini";
          renderTemplateMini(mini, id);
          item.appendChild(mini);
          item.addEventListener("click", () => applyTo(id));
          trayEl.appendChild(item);
        });
        if (mobile) requestAnimationFrame(sizeItems);
      }
      renderTray();
      if (mobile) {
        // Keep the A4 proportion correct after rotate / viewport changes.
        window.addEventListener("resize", () => requestAnimationFrame(sizeItems));
        window.addEventListener("orientationchange", () => setTimeout(sizeItems, 350));
      }
    } catch (e) {}
  }

  // Phones: build the mobile tray once, lazily (its DOM persists across tab shows).
  let _mshLayBuilt = false;
  function _mshBuildLayoutsPanel(target) {
    if (!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches)) return;
    // Build once for a plain tab open, but ALWAYS rebuild when a specific side is
    // requested (from a page's "Choose layout") so the Left/Right toggle pre-selects it.
    if (_mshLayBuilt && !target) return;
    _dmbRenderLayoutsPanel({ mobile: true, defaultTarget: target || "left" });
    _mshLayBuilt = true;
  }

  // Desktop: (re)build the inline grid each time Layouts is opened, so the target
  // reflects which page (or the far-left menu) triggered it.
  function _dmbBuildDesktopLayoutsPanel(defaultTarget) {
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) return;
    _dmbRenderLayoutsPanel({ mobile: false, defaultTarget: defaultTarget || "left" });
  }

  function renderSpread() {
    // Remember WHICH VIEW this is. The snapshot already carries editor.currentSpread
    // and builderMode, but nothing was saving on NAVIGATION - every _dmbAutoPersist
    // call sat on an edit path. So a refresh returned the customer to wherever they
    // last TYPED rather than wherever they were looking, which on a long book means a
    // completely different spread, or the cover. Debounced at 600ms, and
    // _dmbWriteProgressState ignores an empty editor, so this cannot overwrite good
    // state with a half-built one during a restore. (2026-10-12)
    try { _dmbAutoPersist(); } catch (e) {}
    // Level 2: on a new spread (phones, large books), free the full-res bytes of
    // photos not near the current view — keeps RAM flat; released photos re-fetch
    // from R2 on demand. No-op on desktop / small books / when photos aren't on R2.
    _dmbMaybeReleaseForSpread();
    // Hide the logo watermark — it belongs only on the back cover
    document.querySelectorAll(".dmb-logo-watermark").forEach((el) => { el.style.display = "none"; });
    // Remove any orphaned fixed-position rotation handles from a previous spread render.
    // These are appended to document.body to escape overflow:hidden and are not destroyed
    // when the spread DOM is rebuilt — so we sweep them explicitly before each re-render.
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    if (!spreadCanvas || !spreadIndexEl || !prevSpreadBtn || !nextSpreadBtn) return;

    const selectedPages = Number(document.getElementById("pages")?.value || 0);
    // Include any extra spreads the customer added (+2 pages / +1 spread each),
    // otherwise this recompute would wipe them out on every re-render — leaving
    // the "Spread X / Y" total stale and the Next button unable to reach them.
    const _extraSpreads = editor.extraSpreads || 0;
    if (selectedPages > 0) {
      // Magazines: fixed per-size layout (page 0 + N spreads + trailing single) PLUS
      // any spreads the customer added. Those used to be ignored here, which is why
      // inserting one in a magazine appeared to do nothing: this recompute put the
      // page count straight back. They are added in TWOS (see _dmbMagStep), so the
      // trailing single page stays trailing and no half sheet is ever printed.
      const _plan = _dmbPagePlan(selectedPages);
      // An ODD count on a magazine cannot be real - it can only be left over from
      // that old behaviour, where an inserted spread was counted and then dropped.
      // Round it down so nobody is charged for pages that are not there.
      if (window.DMB_MAGAZINE_MODE && (_extraSpreads % 2)) {
        editor.extraSpreads = _extraSpreads - 1;
      }
      const _extra = editor.extraSpreads || 0;
      editor.totalPages = _plan.totalPages + _extra * 2;
      editor.editablePages = Math.max(0, editor.totalPages - 1);
      editor.totalSpreads = _plan.totalSpreads + _extra;
    } else {
      editor.totalPages = 0;
      editor.editablePages = 0;
      editor.totalSpreads = 1;
    }
    if (editor.currentSpread > editor.totalSpreads - 1) editor.currentSpread = 0;

    // Mark the currently-displayed pages dirty so PDF preview re-renders (2s debounce)
    if (editor.currentSpread === -1) {
      _dmbPvMarkDirty(0);
    } else {
      _dmbPvMarkDirty(editor.currentSpread * 2 + 1);
      _dmbPvMarkDirty(editor.currentSpread * 2 + 2);
    }

    spreadCanvas.innerHTML = "";

    // ── Page 0 (special single page — before all spreads) ──
    if (editor.currentSpread === -1) {
      spreadIndexEl.textContent = "Spread 0 / " + editor.totalSpreads;
      const page0El = makeA4Page(0, "L");

      const dropOverlay0 = document.createElement("div");
      dropOverlay0.className = "dmb-spread-drag-overlay";
      const zone0 = document.createElement("div");
      zone0.className = "dmb-spread-drop-zone";
      zone0.style.flex = "1";
      const zone0Lbl = document.createElement("div");
      zone0Lbl.className = "dmb-drop-zone-label";
      zone0Lbl.textContent = "Drop photo here";
      zone0.appendChild(zone0Lbl);
      dropOverlay0.appendChild(zone0);

      const pagesRow0 = document.createElement("div");
      pagesRow0.style.cssText = "position:relative;display:flex;gap:0;flex-shrink:0;";
      pagesRow0.appendChild(page0El);
      pagesRow0.appendChild(dropOverlay0);

      let ec0 = 0;
      pagesRow0.addEventListener("dragenter", (e) => {
        if (!getDragPayload(e)) return;
        ec0++;
        dropOverlay0.classList.add("active");
      });
      pagesRow0.addEventListener("dragleave", (e) => {
        if (e.relatedTarget && pagesRow0.contains(e.relatedTarget)) return;
        if (--ec0 <= 0) { ec0 = 0; dropOverlay0.classList.remove("active"); }
      });
      pagesRow0.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });
      pagesRow0.addEventListener("drop", async (e) => {
        e.preventDefault();
        ec0 = 0; dropOverlay0.classList.remove("active");
        const payload = getDragPayload(e);
        if (!payload) return;
        await handleSpreadZoneDrop("left", payload, 0, null, -1);
      });

      const lbl0 = document.createElement("div");
      lbl0.className = "dmb-page-label";
      lbl0.textContent = "Spread 0";
      lbl0.style.width = getPageDims().w + "px";
      const labelsRow0 = document.createElement("div");
      labelsRow0.style.display = "flex";
      labelsRow0.appendChild(lbl0);

      const pagesMain0 = document.createElement("div");
      pagesMain0.style.cssText = "display:flex;flex-direction:column;gap:6px;";
      pagesMain0.appendChild(labelsRow0);
      pagesMain0.appendChild(pagesRow0);

      const outerRow0 = document.createElement("div");
      outerRow0.style.cssText = "display:flex;gap:8px;align-items:flex-start;";
      outerRow0.appendChild(buildActionBtns(0));
      outerRow0.appendChild(pagesMain0);

      spreadCanvas.appendChild(outerRow0);
      forceSpreadLayout();
      if (spreadViewport) spreadViewport.scrollLeft = 0;
      prevSpreadBtn.disabled = false;   // Prev on Spread 0 goes back to the cover
      nextSpreadBtn.disabled = editor.totalSpreads <= 0;
      return;
    }

    const spreadNum = editor.currentSpread + 1;
    spreadIndexEl.textContent = `Spread ${spreadNum} / ${editor.totalSpreads}`;

    const leftPage = editor.currentSpread * 2 + 1;
    const rightPage = editor.currentSpread * 2 + 2;
    const si = editor.currentSpread;

    // ── Pages row (position:relative, pages touch — no gap) ──
    const pagesRow = document.createElement("div");
    pagesRow.style.position = "relative";
    pagesRow.style.display = "flex";
    pagesRow.style.gap = "0";
    pagesRow.style.flexShrink = "0";
    pagesRow.dataset.spreadRow = "true";

    // ── Labels row (label per page, each 270px wide to align exactly with its page) ──
    const labelsRow = document.createElement("div");
    labelsRow.style.display = "flex";
    labelsRow.style.gap = "0";

    const leftPageEl = (leftPage <= editor.totalPages) ? makeA4Page(leftPage, "L") : null;
    if (leftPageEl) {
      pagesRow.appendChild(leftPageEl);
      const lbl = document.createElement("div");
      lbl.className = "dmb-page-label";
      lbl.textContent = `Page ${leftPage} (L)`;
      lbl.style.width = getPageDims().w + "px";
      labelsRow.appendChild(lbl);
    }

    const rightPageEl = (rightPage <= editor.totalPages) ? makeA4Page(rightPage, "R") : null;
    if (rightPageEl) {
      pagesRow.appendChild(rightPageEl);
      const lbl = document.createElement("div");
      lbl.className = "dmb-page-label";
      lbl.textContent = `Page ${rightPage} (R)`;
      lbl.style.width = getPageDims().w + "px";
      labelsRow.appendChild(lbl);
    }


    // ── Spine gradient (absolute, overlaid on the seam between the two pages) ──
    const leftHasContent = leftPage <= editor.totalPages && pageHasAnyContent(leftPage);
    const rightHasContent = rightPage <= editor.totalPages && pageHasAnyContent(rightPage);

    if (leftPageEl && rightPageEl) {
      const spine = document.createElement("div");
      spine.className = "dmb-spread-spine" +
        (leftHasContent ? " left-filled" : "") +
        (rightHasContent ? " right-filled" : "");
      // Center the spine on the seam between the two pages. CSS defaults to the
      // portrait seam (259px); override with the real page width so it stays
      // centered in landscape too (seam = page width, minus half the 22px spine).
      spine.style.left = (getPageDims().w - 11) + "px";
      const spineL = document.createElement("div");
      spineL.className = "dmb-spread-spine-left";
      const spineR = document.createElement("div");
      spineR.className = "dmb-spread-spine-right";
      spine.appendChild(spineL);
      spine.appendChild(spineR);
      pagesRow.appendChild(spine);
    }

    // ── Drop overlay (absolute, covers pagesRow exactly) ──
    const dropOverlay = document.createElement("div");
    dropOverlay.className = "dmb-spread-drag-overlay";

    function makeZone(label, disabled) {
      const zone = document.createElement("div");
      zone.className = "dmb-spread-drop-zone" + (disabled ? " disabled" : "");
      const lbl = document.createElement("div");
      lbl.className = "dmb-drop-zone-label";
      lbl.textContent = label;
      zone.appendChild(lbl);
      return zone;
    }

    const leftZone = makeZone(isLockedPage(leftPage) ? "Locked" : "Left page", isLockedPage(leftPage));
    const centerZone = makeZone("Full spread", isLockedPage(leftPage) || !rightPageEl);
    const rightZone = makeZone("Right page", !rightPageEl);
    dropOverlay.appendChild(leftZone);
    dropOverlay.appendChild(centerZone);
    dropOverlay.appendChild(rightZone);
    pagesRow.appendChild(dropOverlay);

    // ── Drag events on pagesRow ──
    // Overlay (z-index:50) is pointer-events:auto — zones receive drops for background area.
    // Template frames (z-index:60) and free frames (z-index:60) are ABOVE the overlay,
    // so they receive drops directly via their own stopPropagation handlers.
    let enterCount = 0;
    function clearZoneHighlights() {
      leftZone.classList.remove("drag-over");
      centerZone.classList.remove("drag-over");
      rightZone.classList.remove("drag-over");
    }
    pagesRow.addEventListener("dragenter", (e) => {
      if (!getDragPayload(e)) return;
      enterCount++;
      dropOverlay.classList.add("active");
    });
    pagesRow.addEventListener("dragleave", (e) => {
      if (e.relatedTarget && pagesRow.contains(e.relatedTarget)) return;
      if (--enterCount <= 0) { enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights(); }
    });
    pagesRow.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });

    // Zone-level highlighting and drop handling (original approach — reliable)
    [leftZone, centerZone, rightZone].forEach(zone => {
      if (zone.classList.contains("disabled")) return;
      let zc = 0;
      zone.addEventListener("dragenter", (e) => { e.preventDefault(); e.stopPropagation(); if (++zc > 0) zone.classList.add("drag-over"); });
      zone.addEventListener("dragleave", () => { if (--zc <= 0) { zc = 0; zone.classList.remove("drag-over"); } });
      zone.addEventListener("dragover",  (e) => { e.preventDefault(); e.stopPropagation(); });
    });

    leftZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || isLockedPage(leftPage)) return;
      await handleSpreadZoneDrop("left", payload, leftPage, rightPage, si);
    });
    centerZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || isLockedPage(leftPage) || !rightPageEl) return;
      await handleSpreadZoneDrop("spread", payload, leftPage, rightPage, si);
    });
    rightZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || !rightPageEl) return;
      await handleSpreadZoneDrop("right", payload, leftPage, rightPage, si);
    });

    // Fallback: pagesRow catches any drops that reach it (e.g. spine area)
    pagesRow.addEventListener("drop", async (e) => {
      e.preventDefault();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload) return;
      const pr = pagesRow.getBoundingClientRect();
      const dx = e.clientX - pr.left;
      const w  = pr.width;
      let zone = !rightPageEl ? "left" : dx < w / 3 ? "left" : dx > w * 2 / 3 ? "right" : "spread";
      if (zone === "left" && isLockedPage(leftPage)) return;
      if (zone !== "left" && !rightPageEl) return;
      await handleSpreadZoneDrop(zone, payload, leftPage, rightPage, si);
    });

    // ── Action buttons helper ──
    function buildActionBtns(pNum) {
      const actions = document.createElement("div");
      actions.className = "dmb-page-outer-actions";

      const clearBtn = document.createElement("button");
      clearBtn.type = "button";
      clearBtn.className = "dmb-page-action-btn";
      clearBtn.textContent = "Clear page";
      clearBtn.addEventListener("click", async () => {
        if (!pageHasAnyContent(pNum)) return;
        const choice = await showChoiceDialog(
          "Clear page",
          "What would you like to remove?",
          [
            { id: "photos", label: "Remove photos only (keep layout & text)" },
            { id: "all", label: "Remove everything" },
            { id: "cancel", label: "Cancel" }
          ]
        );
        if (!choice || choice === "cancel") return;
        pushUndoState("Clear Page");
        if (choice === "photos") clearPagePhotosOnly(pNum);
        else clearPageAllLayouts(pNum);
        renderSpread(); renderThumbsRail(); renderPhotoTray();
      });

      const layoutBtn = document.createElement("button");
      layoutBtn.type = "button";
      layoutBtn.className = "dmb-page-action-btn";
      layoutBtn.textContent = "Choose layout";
      layoutBtn.addEventListener("click", async () => {
        const psi = Math.floor((pNum - 1) / 2);
        if (editor.spreadPhoto?.[psi]) {
          const choice = await showChoiceDialog(
            "Full spread photo active",
            "This page has a full-spread photo. What would you like to do?",
            [
              { id: "keep", label: "Keep spread photo, pick layout on top" },
              { id: "remove", label: "Remove spread photo, pick layout" },
              { id: "cancel", label: "Cancel" }
            ]
          );
          if (!choice || choice === "cancel") return;
          if (choice === "remove") { pushUndoState(); editor.spreadPhoto[psi] = null; renderSpread(); return; }
        }
        // Open the inline Layouts panel with the target pre-set to THIS page
        // (odd page = left, even = right of the spread), then activate the tab.
        const _layTarget = (pNum % 2 === 1) ? "left" : "right";
        window._dmbPendingLayoutTarget = _layTarget;
        document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
        // Robustness: build the panel directly with the correct side too, so the Left/Right
        // toggle is pre-selected even if the tab was already active (a synthetic re-click
        // wouldn't rebuild it) — desktop and phone.
        try {
          if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches) {
            // Open the shell's Layouts tab (the panel shows only while its tab is
            // active), then build it with the page side.
            document.querySelector('.dmb-msh-tab[data-tab="layouts"]')?.click();
            if (typeof _mshBuildLayoutsPanel === "function") _mshBuildLayoutsPanel(_layTarget);
          } else if (typeof _dmbBuildDesktopLayoutsPanel === "function") {
            _dmbBuildDesktopLayoutsPanel(_layTarget);
          }
        } catch (e) {}
      });

      // ── Duplicate this page's layout onto another page ─────────────────
      const dupPageBtn = document.createElement("button");
      dupPageBtn.type = "button";
      dupPageBtn.className = "dmb-page-action-btn";
      dupPageBtn.textContent = "Duplicate page";
      dupPageBtn.addEventListener("click", async () => {
        if (!pageHasAnyContent(pNum)) { await showChoiceDialog("Duplicate page", "This page is empty — there's nothing to copy yet.", [{ id: "ok", label: "OK" }]); return; }
        _dmbOpenDuplicatePageModal(pNum);
      });

      const textBtn = document.createElement("button");
      textBtn.type = "button";
      textBtn.className = "dmb-page-action-btn";
      textBtn.textContent = "Add text";
      textBtn.addEventListener("click", (e) => {
        // Stop this click from bubbling to the document click-out handler — it
        // would otherwise see the brand-new (empty) text box and delete it on the
        // same click, so the button appeared to do nothing.
        e.stopPropagation();
        // Set lastToolbarSide so addDefaultText targets the correct page body
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        if (canvasTextBtn) canvasTextBtn.click();
      });

      const frameBtn = document.createElement("button");
      frameBtn.type = "button";
      frameBtn.className = "dmb-page-action-btn";
      frameBtn.textContent = "Add photo frame";
      frameBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        if (canvasPhotoBtn) canvasPhotoBtn.click();
      });

      const polaroidBtn = document.createElement("button");
      polaroidBtn.type = "button";
      polaroidBtn.className = "dmb-page-action-btn";
      polaroidBtn.textContent = "Add polaroid";
      polaroidBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        dmbAddFrameToActiveTarget({ polaroid: true });
      });

      // ── SHAPES BUTTON (pages) ─────────────────────────────────────────
      // Sets lastToolbarSide so insertShapeIntoActivePage targets this page.
      // Then opens the floating shape picker panel (same as Shapes toolbar btn).
      // WARNING: Do NOT redirect to canvasShapeBtn.click() alone — the picker
      // panel toggle code also repositions the panel; call that directly instead.
      const shapesBtn = document.createElement("button");
      shapesBtn.type = "button";
      shapesBtn.className = "dmb-page-action-btn";
      shapesBtn.textContent = "Add shape";
      shapesBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        // Open the shape picker panel (re-use the canvasShapeBtn click logic)
        if (canvasShapeBtn) canvasShapeBtn.click();
      });

      // ── MAP BUTTON (pages) ────────────────────────────────────────────
      // Same contract as the shape button: stamp lastToolbarSide for THIS page so
      // getActivePageNumberForMap targets it, then open the picker. Without a
      // per-page entry point the only way in was the top ribbon, which left the
      // target page to whatever was touched last.
      const mapBtn = document.createElement("button");
      mapBtn.type = "button";
      mapBtn.className = "dmb-page-action-btn";
      mapBtn.textContent = "Add map";
      mapBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        if (typeof dmbOpenMapModal === "function") dmbOpenMapModal();
        _dmbMapTargetPage = pNum;   // AFTER open - dmbOpenMapModal clears it
      });

      // ── Page background colour ─────────────────────────────────────────
      // A colour swatch button that opens a native colour picker.
      // Shows "×" when a custom colour is set so it can be cleared.
      // WARNING: keep the hidden <input type="color"> INSIDE the button so
      // clicking the button triggers the colour picker on all browsers.
      const bgBtn = document.createElement("button");
      bgBtn.type = "button";
      bgBtn.className = "dmb-page-action-btn dmb-page-bg-btn";
      bgBtn.title = "Page background colour";

      const bgColorInput = document.createElement("input");
      bgColorInput.type = "color";
      bgColorInput.className = "dmb-page-bg-input";
      bgColorInput.value = editor.pageBackgrounds?.[pNum] || "#ffffff";
      bgColorInput.tabIndex = -1;
      bgColorInput.setAttribute("aria-hidden", "true");

      const bgSwatch = document.createElement("span");
      bgSwatch.className = "dmb-page-bg-swatch";
      bgSwatch.style.background = editor.pageBackgrounds?.[pNum] || "#ffffff";

      const bgLabel = document.createElement("span");
      bgLabel.textContent = "Background";

      // ── Circle-X clear background colour (Fix 1) ───────────────────────
      const bgClear = document.createElement("span");
      bgClear.className = "dmb-page-bg-clear";
      bgClear.innerHTML = `<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 8l8 8M16 8l-8 8"/></svg>`;
      bgClear.title = "Remove background colour";
      bgClear.style.display = editor.pageBackgrounds?.[pNum] ? "inline" : "none";

      // LIVE update — used while dragging in the native picker ('input' fires
      // continuously). It updates the visible page background + swatch directly,
      // WITHOUT re-rendering. (A re-render rebuilds this action rail and destroys
      // the <input> the picker is attached to, which closes the picker mid-drag and
      // applies whatever colour the finger was on — the reported bug.)
      // Take the undo snapshot ONCE per picker session, on the first change and BEFORE the
      // background is actually mutated — so undo restores the colour from before this edit
      // (live scrubbing during the drag must not each create their own history entry).
      let _bgUndoTaken = false;
      function _snapBgOnce() { if (!_bgUndoTaken) { pushUndoState("Page Background"); _bgUndoTaken = true; } }
      function _liveBgColor(color) {
        if (!editor.pageBackgrounds) editor.pageBackgrounds = {};
        if (color && color.toLowerCase() !== "#ffffff") editor.pageBackgrounds[pNum] = color;
        else delete editor.pageBackgrounds[pNum];
        bgSwatch.style.background = color || "#ffffff";
        bgClear.style.display = editor.pageBackgrounds?.[pNum] ? "inline" : "none";
        const bodyEl = document.querySelector('[data-page-body][data-page-number="' + pNum + '"]');
        if (bodyEl) bodyEl.style.background = color || "#fcfcfc";
      }
      // COMMIT — used when the picker closes ('change') or on the clear button:
      // record the colour + do the full re-render (safe now — the picker is closed).
      function _commitBgColor(color) {
        _snapBgOnce();   // covers the change-only case (some browsers skip 'input')
        _liveBgColor(color);
        bgColorInput.value = color || "#ffffff";
        renderBuilderCanvas();
        renderThumbsRail();
        _bgUndoTaken = false;   // end of this edit session
      }

      bgColorInput.addEventListener("input", () => { _snapBgOnce(); _liveBgColor(bgColorInput.value); });
      bgColorInput.addEventListener("change", () => _commitBgColor(bgColorInput.value));

      // Clear button: stop propagation so it doesn't re-open the colour picker
      bgClear.addEventListener("click", (e) => {
        e.stopPropagation();
        _commitBgColor("#ffffff");
      });

      bgBtn.appendChild(bgColorInput);
      bgBtn.appendChild(bgSwatch);
      bgBtn.appendChild(bgLabel);
      bgBtn.appendChild(bgClear);

      actions.appendChild(clearBtn);
      actions.appendChild(layoutBtn);
      actions.appendChild(dupPageBtn);
      actions.appendChild(textBtn);
      actions.appendChild(frameBtn);
      actions.appendChild(polaroidBtn);
      actions.appendChild(shapesBtn);
      actions.appendChild(mapBtn);
      actions.appendChild(bgBtn);
      // Recently-used colors for this page's background (strip below the actions).
      try { dmbEnhanceColorInput(bgColorInput, actions); } catch (e) {}
      return actions;
    }

    // ── Outer row: [left actions] + [labels stacked above pages] + [right actions] ──
    const pagesMain = document.createElement("div");
    pagesMain.style.display = "flex";
    pagesMain.style.flexDirection = "column";
    pagesMain.style.gap = "6px";
    pagesMain.appendChild(labelsRow);
    pagesMain.appendChild(pagesRow);

    const outerRow = document.createElement("div");
    outerRow.style.display = "flex";
    outerRow.style.gap = "8px";
    outerRow.style.alignItems = "flex-start";

    if (leftPageEl && !isLockedPage(leftPage)) outerRow.appendChild(buildActionBtns(leftPage));
    outerRow.appendChild(pagesMain);
    if (rightPageEl && !isLockedPage(rightPage)) outerRow.appendChild(buildActionBtns(rightPage));

    spreadCanvas.appendChild(outerRow);
    forceSpreadLayout();
    if (spreadViewport) spreadViewport.scrollLeft = 0;
    prevSpreadBtn.disabled = editor.currentSpread < 0;
    nextSpreadBtn.disabled = editor.currentSpread >= editor.totalSpreads - 1;
  }

  function showLayoutsForPage(pageNumber) {
    const panel = document.querySelector('.dmb-side-panel[data-panel="layouts"]');
    if (!panel) return;
    panel.innerHTML = "";
    const section = document.createElement("div");
    section.className = "dmb-section";
    section.style.cssText = "flex:1 1 0;min-height:0;display:flex;flex-direction:column;overflow:hidden;";
    const title = document.createElement("div");
    title.className = "dmb-mini-label";
    title.textContent = `Layouts — Page ${pageNumber}`;
    section.appendChild(title);
    const listWrap = document.createElement("div");
    listWrap.style.cssText = "overflow-y:auto;flex:1 1 0;min-height:0;margin-top:6px;";
    const list = document.createElement("div");
    list.className = "dmb-template-list";
    const addItem = (id, name, subtitle, isDefault = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";
      const currentId = getPageTemplateId(pageNumber);
      if ((isDefault && !currentId) || (!isDefault && currentId === id)) btn.classList.add("active");
      const row = document.createElement("div");
      row.className = "dmb-template-item-row";
      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";
      if (isDefault) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.cssText = "left:0;top:0;width:100%;height:49%";
        const b = document.createElement("div");
        b.className = "dmb-template-mini-frame";
        b.style.cssText = "left:0;top:51%;width:100%;height:49%";
        mini.appendChild(a);
        mini.appendChild(b);
      } else {
        renderTemplateMini(mini, id);
      }
      const txt = document.createElement("div");
      txt.style.minWidth = "0";
      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;
      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;
      txt.appendChild(nm);
      txt.appendChild(sub);
      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isDefault) await setPageTemplateWithConfirm(pageNumber, null);
        else await setPageTemplateWithConfirm(pageNumber, id);
      });
      list.appendChild(btn);
    };
    addItem(null, "Default Layout", "1 photo full / 2-photo split", true);
    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });
    listWrap.appendChild(list);
    section.appendChild(listWrap);
    panel.appendChild(section);
    document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
  }

  function showLayoutsForCoverZone(zone) {
    // Use a dedicated floating modal so we don't touch the shared layouts panel
    const existing = document.getElementById("dmb-cover-layout-modal");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.id = "dmb-cover-layout-modal";
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:999999;display:flex;align-items:center;justify-content:center;";

    const modal = document.createElement("div");
    modal.style.cssText = "background:#1e1e1e;border:1px solid #444;border-radius:16px;padding:20px;width:340px;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.7);";

    const header = document.createElement("div");
    header.style.cssText = "display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;";
    const ttl = document.createElement("div");
    ttl.style.cssText = "font-weight:900;font-size:15px;color:#fff;";
    ttl.textContent = `Cover Layout — ${zone === "front" ? "Front" : "Back"}`;
    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.textContent = "✕";
    closeBtn.style.cssText = "background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0 4px;";
    closeBtn.addEventListener("click", () => overlay.remove());
    header.appendChild(ttl);
    header.appendChild(closeBtn);
    modal.appendChild(header);

    const listWrap = document.createElement("div");
    listWrap.style.cssText = "overflow-y:auto;flex:1;";
    const list = document.createElement("div");
    list.className = "dmb-template-list";

    const currentId = zone === "front" ? coverState.frontLayout : coverState.backLayout;

    const addItem = (id, name, subtitle, isNone = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";
      if ((isNone && !currentId) || (!isNone && currentId === id)) btn.classList.add("active");
      const row = document.createElement("div");
      row.className = "dmb-template-item-row";
      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";
      if (isNone) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.cssText = "left:0;top:0;width:100%;height:100%";
        mini.appendChild(a);
      } else {
        renderTemplateMini(mini, id);
      }
      const txt = document.createElement("div");
      txt.style.minWidth = "0";
      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;
      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;
      txt.appendChild(nm);
      txt.appendChild(sub);
      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        overlay.remove();
        await setCoverLayoutWithConfirm(zone, isNone ? null : id);
      });
      list.appendChild(btn);
    };

    addItem(null, "No Layout", "Remove layout", true);
    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });

    listWrap.appendChild(list);
    modal.appendChild(listWrap);
    overlay.appendChild(modal);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
  }

  // A cover face is 300 × 424 px on screen (.dmb-cover-face: width:300, aspect 1/1.414).
  // A layout's TEMPLATE_DEFS slots are % of a FACE; convert to overlay px (the free-frame
  // coordinate space) by offsetting with the face's left edge in the cover overlay.
  const _DMB_COVER_FACE_W = 300;
  const _DMB_COVER_FACE_H = 424;
  function _dmbCoverFaceLeftPx(zone) {
    if (zone === "back") return 0;
    return window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;   // front
  }
  // Spawn a cover layout as individual FREE photo-frame objects (targetType:"cover"),
  // one per TEMPLATE_DEFS slot — exactly like the interior-page _dmbSpawnLayoutFrames.
  // They then reuse the whole cover free-frame system: select / drag / resize / rotate /
  // delete (incl. keyboard) / photo-drop / PDF export. Replaces this zone's PREVIOUS
  // layout frames (fromLayout) but keeps manually-added frames, text, stickers.
  function _dmbSpawnCoverLayoutFrames(zone, templateId, carryPhotoIds) {
    const arr = ensureCoverObjects();
    for (let i = arr.length - 1; i >= 0; i--) {
      const o = arr[i];
      if (o && o.type === "photo-frame" && o.fromLayout && (o.coverZone || "front") === zone) arr.splice(i, 1);
    }
    const slots = (templateId && TEMPLATE_DEFS[templateId]) || [];
    const faceLeft = _dmbCoverFaceLeftPx(zone);
    const carry = Array.isArray(carryPhotoIds) ? carryPhotoIds : [];
    const now = Date.now();
    slots.forEach((f, i) => {
      const obj = newFrameObject({ targetType: "cover" });
      obj.fromLayout = true;
      obj.coverZone = zone;
      obj.x = Math.round(faceLeft + (f.x / 100) * _DMB_COVER_FACE_W);
      obj.y = Math.round((f.y / 100) * _DMB_COVER_FACE_H);
      obj.w = Math.round((f.w / 100) * _DMB_COVER_FACE_W);
      obj.h = Math.round((f.h / 100) * _DMB_COVER_FACE_H);
      obj.z = now + i;                       // render clamps to >= minFrameZ (100001) on cover
      if (carry[i]) obj.photoId = carry[i];
      arr.push(obj);
    });
  }
  // Convert any fixed-slot cover layout currently in coverState (e.g. from an applied
  // predesigned template or an old saved design) into free frames, carrying each slot's
  // photo. Then clear the fixed layout so the old locked-slot renderer no longer runs.
  function _dmbConvertCoverFixedLayouts() {
    ["front", "back"].forEach((zone) => {
      const layoutId = zone === "front" ? coverState.frontLayout : coverState.backLayout;
      if (!layoutId || !TEMPLATE_DEFS[layoutId]) return;
      const framesMap = (zone === "front" ? coverState.frontFrames : coverState.backFrames) || {};
      const carry = (TEMPLATE_DEFS[layoutId] || []).map((f) => framesMap[f.key] || null);
      if (zone === "front") { coverState.frontLayout = null; coverState.frontFrames = {}; coverState.frontFrameRot = {}; coverState.frontFrameShapes = {}; }
      else                  { coverState.backLayout  = null; coverState.backFrames  = {}; coverState.backFrameRot  = {}; coverState.backFrameShapes  = {}; }
      _dmbSpawnCoverLayoutFrames(zone, layoutId, carry);
    });
  }

  async function setCoverLayoutWithConfirm(zone, templateId) {
    // Photos that could be preserved = this zone's current layout free-frames + any
    // legacy fixed-slot photos still in coverState (old designs).
    const legacyFrames = (zone === "front" ? coverState.frontFrames : coverState.backFrames) || {};
    const existingFree = ensureCoverObjects().filter(
      (o) => o && o.type === "photo-frame" && o.fromLayout && (o.coverZone || "front") === zone && o.photoId
    );
    const carryPool = existingFree.map((o) => o.photoId).concat(Object.values(legacyFrames).filter(Boolean));
    const hasCoverImage = zone === "front" && !!coverState.imageUrl;

    let carry = [];
    if ((carryPool.length || hasCoverImage) && templateId) {
      const choice = await showChoiceDialog(
        "This cover face has photos",
        "How would you like to apply the layout?",
        [
          { id: "over",    label: "Apply layout, keep existing photos" },
          { id: "replace", label: "Remove photos and apply layout" },
          { id: "cancel",  label: "Cancel" }
        ]
      );
      if (!choice || choice === "cancel") return;
      if (choice === "over") carry = carryPool;
      else if (choice === "replace" && zone === "front") { coverState.imageUrl = ""; coverState.imageFile = null; }
    }

    // Clear any legacy fixed-slot layout for this zone — free frames supersede it.
    if (zone === "front") { coverState.frontLayout = null; coverState.frontFrames = {}; coverState.frontFrameRot = {}; coverState.frontFrameShapes = {}; }
    else                  { coverState.backLayout  = null; coverState.backFrames  = {}; coverState.backFrameRot  = {}; coverState.backFrameShapes  = {}; }

    _dmbSpawnCoverLayoutFrames(zone, templateId, carry);   // templateId null → just clears this zone's layout frames

    saveCoverDesignToStorage();
    builderMode = "cover";
    renderCoverCanvas();
  }

  function _showMobileQualityWarning() {
    // Only on phones, only once per session. Returns true if the Pro tip showed.
    if (window.innerWidth > 749) return false;
    if (sessionStorage.getItem("dmb_mobile_warned")) return false;
    sessionStorage.setItem("dmb_mobile_warned", "1");
    const modal = document.getElementById("dmbMobileQualityModal");
    if (!modal) return false;
    modal.style.display = "flex";
    const dismiss = () => { modal.style.display = "none"; _dmbMaybeShowRotateNotice(); };
    document.getElementById("dmbMobileQualityContinue")?.addEventListener("click", dismiss, { once: true });
    document.getElementById("dmbMobileQualityGotIt")?.addEventListener("click", dismiss, { once: true });
    return true;
  }

  // ── "Rotate your device" prompt — phones + iPads, portrait only ──────────
  // Shows while the builder is open on a real touch device held vertically;
  // auto-hides the moment they turn it to landscape. On phones it's triggered
  // after the Pro tip is dismissed; on iPads (no Pro tip) right when the
  // builder opens. "Continue anyway" lets portrait users dismiss it.
  function _dmbIsRealTouch() {
    return ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
  }
  let _dmbRotateDismissed = false;
  function _dmbEnsureRotateNotice() {
    let el = document.getElementById("dmbRotateNotice");
    if (el) return el;
    el = document.createElement("div");
    el.id = "dmbRotateNotice";
    el.className = "dmb-rotate-notice";
    el.style.display = "none";
    el.innerHTML =
      '<div class="dmb-rotate-box">' +
        '<div class="dmb-rotate-icon">🔄</div>' +
        '<h3 class="dmb-rotate-title">Rotate your device</h3>' +
        '<p class="dmb-rotate-msg">The builder works best in <strong>landscape</strong> — turn your device sideways for more room to design.</p>' +
        '<button type="button" class="dmb-btn" id="dmbRotateContinue">Continue anyway</button>' +
      '</div>';
    document.body.appendChild(el);
    el.querySelector("#dmbRotateContinue").addEventListener("click", function () {
      _dmbRotateDismissed = true;
      el.style.display = "none";
    });
    return el;
  }
  function _dmbMaybeShowRotateNotice() {
    const el = _dmbEnsureRotateNotice();
    if (!el) return;
    const portrait = window.matchMedia
      ? window.matchMedia("(orientation: portrait)").matches
      : (window.innerHeight > window.innerWidth);
    const builderOpen = !!(builderStep && builderStep.style.display !== "none");
    const proTipOpen = document.getElementById("dmbMobileQualityModal")?.style.display === "flex";
    // Rotate banner removed — the builder is portrait-only (CSS keeps it portrait
    // even when the phone is turned), so we never prompt to rotate.
    const show = false;
    el.style.display = show ? "flex" : "none";
  }
  window.addEventListener("resize", _dmbMaybeShowRotateNotice);
  window.addEventListener("orientationchange", function () { setTimeout(_dmbMaybeShowRotateNotice, 250); });

  // ── Phone landscape: desktop layout, but zoom ONLY the canvas (3rd column) ─
  // Columns 1 & 2 stay at their readable slim sizes; only the canvas/spread is
  // scaled to ~5/9 (via the builder's own canvas zoom, so it integrates with the
  // zoom slider) so the spread fits without scrolling. Phones only — iPad keeps
  // its full-size desktop builder. The .dmb-phone-zoom class drives the slim
  // column CSS; applied once on enter, restored on exit so it doesn't fight a
  // manual zoom.
  function _dmbUpdateBuilderViewport() {
    const builderOpen = !!(builderStep && builderStep.style.display !== "none");
    const landscape = window.matchMedia
      ? window.matchMedia("(orientation: landscape)").matches
      : (window.innerWidth > window.innerHeight);
    // Phones ONLY (never iPad): a phone's physical short side is small (≤500px).
    const isPhone = Math.min(window.screen.width || 9999, window.screen.height || 9999) <= 500;
    // Slim desktop-layout columns: phone + landscape only. (The 50% canvas zoom
    // is handled by the default currentZoom on phones — set at init so the first
    // render is already 50% with no lag and nothing resets it on close.)
    // Portrait-only: never switch the builder into the landscape layout. The
    // mobile shell stays portrait; CSS rotates it to portrait when the phone is
    // physically turned sideways. (landscape/isPhone kept for reference.)
    void (builderOpen && landscape && isPhone);
    document.documentElement.classList.toggle("dmb-phone-zoom", false);
  }
  window.addEventListener("resize", _dmbUpdateBuilderViewport);
  window.addEventListener("orientationchange", function () { setTimeout(_dmbUpdateBuilderViewport, 250); });
  // One observer covers entering AND leaving the builder (display toggles).
  if (typeof builderStep !== "undefined" && builderStep && "MutationObserver" in window) {
    new MutationObserver(_dmbUpdateBuilderViewport).observe(builderStep, { attributes: true, attributeFilter: ["style"] });
  }

  async function openEditor({ skipStateReset = false } = {}) {
    // Drop the early "skip-intro" guard classes (they use display:flex !important to
    // prevent a load flash). Now that we're entering the builder, removing them lets
    // the upload step actually hide — otherwise the page stays scrollable between the
    // photo-upload step and the builder.
    document.documentElement.classList.remove('dmb-skip-intro', 'dmb-skip-intro--upload');
    // A card has no interior pages — it's just the Front/Back cover. Use a fixed
    // small page count so openEditor proceeds (interior pages are created but
    // hidden by .dmb-card CSS); the builder then lands in cover mode below.
    const selectedPages = window.DMB_CARD_MODE ? 2 : Number(document.getElementById("pages")?.value || 0);
    if (!selectedPages) return;

    if (step1) step1.style.display = "none";
    if (builderStep) builderStep.style.display = "block";
    // Hide the upload step and mark the URL as "in builder" so a page REFRESH
    // restores the design instead of dropping back to the upload step. Centralised
    // here so EVERY entry path is covered — the Do-the-Magic/Customize buttons AND
    // the auto-open that fires once enough photos are uploaded (which previously
    // skipped this and left the URL at ?step=upload).
    { const _s1bEl = document.getElementById("step1b"); if (_s1bEl) _s1bEl.style.display = "none"; }
    if (!_dmbRenderMode()) try {
      const _bu = new URL(window.location.href);
      if (_bu.searchParams.get("step") !== "2" || _bu.searchParams.get("restore") !== "1") {
        _bu.searchParams.set("step", "2");
        _bu.searchParams.set("restore", "1");
        history.replaceState(null, "", _bu.toString());
      }
    } catch (e) {}
    const _proTipShown = _showMobileQualityWarning();
    // iPad (and phones already warned) get the rotate prompt right away; on a
    // first-time phone it fires after the Pro tip is dismissed instead.
    if (!_proTipShown) _dmbMaybeShowRotateNotice();
    // Apply the phone auto-zoom (50%) after the open renders settle.
    requestAnimationFrame(() => { try { _dmbUpdateBuilderViewport(); } catch (e) {} });
    if (bookDetails) bookDetails.style.display = "none";

    if (!skipStateReset) {
      // Magazine sizes use the fixed plan (page 0 + N spreads + trailing single);
      // books/cards keep ceil(pages/2). Must match initEmptyBookFromPages so the
      // trailing single page + its objects exist from the first render.
      const _plan = _dmbPagePlan(selectedPages);
      editor.totalPages = _plan.totalPages;
      editor.editablePages = Math.max(0, editor.totalPages - 1);
      editor.totalSpreads = _plan.totalSpreads;
      editor.currentSpread = 0;

      editor.pageSlots = {};
      editor.pageRot = {};
      editor.pageTemplate = {};
      editor.pageFrames = {};
      editor.pageFrameRot = {};
      editor.pageObjects = {};
      editor.spreadPhoto = {};
      editor.coverObjects = [];
      editor.coverUserTexts = [];
      for (let p = 1; p <= editor.totalPages; p++) {
        editor.pageSlots[p] = { A: null, B: null };
        editor.pageRot[p] = { A: 0, B: 0 };
        editor.pageTemplate[p] = null;
        editor.pageFrames[p] = {};
        editor.pageFrameRot[p] = {};
        editor.pageObjects[p] = [];
      }
      const totalSpreads = editor.totalSpreads || Math.ceil(selectedPages / 2);
      for (let s = 0; s < totalSpreads; s++) editor.spreadPhoto[s] = null;
    }
    initSpreadPhotoDragListeners();

    const files = skipStateReset ? [] : (bookFiles || []);
    // Reuse decodes already warmed during the upload step (see _dmbWarmMeta);
    // any file not yet warmed is decoded here as a fallback.
    // TIME-BOXED, and this is why the mobile shell vanished on phones.
    //
    // Promise.all never settles if ONE of its promises never settles, and _dmbWarmMeta
    // decodes an image - the exact operation already proven to hang forever on a fully
    // loaded image (see the img.decode note). One bad photo out of twenty four and this
    // await simply never returns, so openEditor stops here: no init calls, no
    // _dmbInitMobileShell, no body class, and the builder falls back to the desktop
    // layout. Nothing throws, so there is nothing in the console and nothing for a
    // try/catch to catch, which is what made it look like a reverted deploy.
    //
    // refreshBuilderPhotos already wraps this identical call in _dmbSettleWithin; this
    // copy was missed. Same guard, same fallback meta. (2026-10-07)
    const metas = await Promise.all(files.map(function (f) {
      return _dmbSettleWithin(_dmbWarmMeta(f), _DMB_META_TIMEOUT + 2000, { w: 1, h: 1, ratio: 1 });
    }));

    if (!skipStateReset) {
      // Print-master path: keep the PICK-time pid (f._dmbPid) as the photo id so
      // the R2 backup, _r2 marking, light-mem release and master fetches all agree
      // — a fresh uid() here silently orphaned every one of those. Also carry _r2/
      // thumb state forward and keep released off-spread photos lazy (no object
      // URL), exactly like refreshBuilderPhotos.
      const _pm = _dmbPrintMasterOn();
      const _prevById = {};
      try { if (_pm) (editor.photos || []).forEach((p) => { if (p && p.id) _prevById[p.id] = p; }); } catch (e) {}
      const _keep = (_pm && _dmbLightMem()) ? _dmbCurrentSpreadPhotoIds() : null;
      editor.photos = files.map((f, i) => {
        if (!_pm) return {
          id: uid(),
          file: f,
          url: URL.createObjectURL(f),
          ratio: metas[i]?.ratio ?? 1,
          filename: String(f.name || "").toLowerCase(),
          dateTaken: metas[i]?.date || "",
          tags: [],
          addedIndex: i
        };
        const pid = f._dmbPid || uid();
        const prev = _prevById[pid] || {};
        const lazy = !!(_keep && prev._r2 && !_keep.has(pid));
        return {
          id: pid,
          file: f,
          url: prev.url || (lazy ? "" : URL.createObjectURL(f)),
          ratio: metas[i]?.ratio ?? prev.ratio ?? 1,
          filename: String(f.name || "").toLowerCase(),
          dateTaken: metas[i]?.date || prev.dateTaken || "",
          tags: prev.tags || [],
          addedIndex: i,
          _r2: prev._r2 || false,
          thumbUrl: prev.thumbUrl || ""
        };
      });
    }

    if (bookMeta) {
      bookMeta.textContent =
        `${getEffectiveBookTitle()} • ${editor.totalPages} pages (${editor.editablePages} to design) • ${editor.photos.filter((p) => !_dmbIsCropDerived(p)).length} photos`;
    }

    // These eight used to run bare. openEditor is async, so the FIRST one to throw
    // rejected the promise and silently skipped everything after it - including
    // _dmbInitMobileShell below. The visible result is a phone falling back to the
    // desktop builder layout with no error shown anywhere, which is exactly the
    // failure this is here to stop. Isolate them so one failure cannot cascade, and
    // record every failure instead of discarding it. (2026-10-07)
    window.__DMB_INIT_ERRS = [];
    [
      ["initUnifiedTabs", initUnifiedTabs],
      ["initPhotoImportMenu", initPhotoImportMenu],
      ["initPhotoSearchSortControls", initPhotoSearchSortControls],
      ["initProjectMenu", initProjectMenu],
      ["initHistoryButton", initHistoryButton],
      ["syncCoverInputsFromState", syncCoverInputsFromState],
      ["ensurePreviewOverlay", ensurePreviewOverlay],
      ["wireTextToolbar", wireTextToolbar],
    ].forEach(function (step) {
      try { step[1](); }
      catch (e) {
        try {
          window.__DMB_INIT_ERRS.push(step[0] + ": " + ((e && e.message) || String(e)));
          console.error("[dmb init] " + step[0] + " failed:", e);
        } catch (e2) {}
      }
    });
    try { initMapTools(); } catch(e) {}
    try { enableMapMarkerPlacement(); } catch(e) {}
    try { initStickerLibrary(); } catch(e) {}
    try { initMagIconPanel(); } catch(e) {}
    try { initCustomStickersPanel(); } catch(e) {}
    try { initPhoneUpload(); } catch(e) {}
    try { _dmbInitMobileShell(); }
    catch (e) {
      // _mshBuilt is set at the TOP of _dmbInitMobileShell, so a throw halfway used to
      // leave the flag true and every later call returned early through _mshSync. The
      // shell stayed half built for the life of the page. Clear the partial DOM and the
      // flag so the next openEditor gets a clean attempt.
      try {
        window.__DMB_MSH_ERR = (e && (e.stack || e.message)) || String(e);
        console.error("[dmb] mobile shell init failed:", e);
      } catch (e2) {}
      try {
        document.querySelectorAll('#step2 [class*="dmb-msh"]').forEach(function (n) { n.remove(); });
        _mshBuilt = false;
      } catch (e3) {}
    }
    try { _dmbShowInitDiag(); } catch (e) {}
    try { window.__DMB_OPENEDITOR_DONE = true; } catch (e) {}
    try { _dmbPlaceSpreadAdderDesktop(); } catch(e) {}
    try { _dmbInitPhotoScrollAutoHide(); } catch(e) {}

    // Global dragend: clear any lingering spread overlays if drag ends without a drop
    document.addEventListener("dragend", () => {
      document.querySelectorAll(".dmb-spread-drag-overlay.active").forEach(el => { el.classList.remove("active"); });
      document.querySelectorAll(".dmb-spread-drop-zone.drag-over").forEach(el => { el.classList.remove("drag-over"); });
      document.querySelectorAll(".dmb-cover-drag-overlay.active").forEach(el => { el.classList.remove("active"); });
    });

    // Global click: close any open ··· option popups when clicking outside
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-frame-key]") && !e.target.closest(".dmb-photo-frame-object")) {
        document.querySelectorAll(".dmb-frame-popup-open").forEach(pop => {
          pop.style.display = "none";
          pop.classList.remove("dmb-frame-popup-open");
        });
      }
    });

    document.dispatchEvent(new CustomEvent("dmb:editorOpened"));

    // A FRESH book opens on the cover, which is where designing starts. A RESTORE must
    // NOT: forcing the cover here threw away the builderMode and currentSpread that the
    // snapshot had just put back, so a refresh always landed on the cover no matter
    // which spread the customer was reading. skipStateReset is precisely the "state was
    // restored, do not reset it" signal, passed by both the ?restore=1 reload and the
    // put-the-builder-back path. (2026-10-12)
    const _keepRestoredView = !!skipStateReset && builderMode === "pages";
    if (!_keepRestoredView) builderMode = "cover";
    syncBuilderModeButtons();
    // Render mode draws no tray/rail: the PDF never reads them, and 300 thumbnails is
    // pure memory. renderPhotoTray is also the biggest persistence cluster in the file.
    if (!_dmbRenderMode()) { renderPhotoTray(); renderThumbsRail(); }
    if (_keepRestoredView) {
      // Clamp first: a saved spread index can outlive a page-count change, and an
      // out-of-range index renders nothing at all.
      try {
        const _maxSp = Math.max(0, (editor.totalSpreads || 1) - 1);
        if (editor.currentSpread > _maxSp) editor.currentSpread = _maxSp;
        if (editor.currentSpread < -1) editor.currentSpread = -1;
      } catch (e) {}
      renderBuilderCanvas();
    } else {
      renderCoverCanvas();
    }

    // Render mode stops here. One early return replaces individual guards for the
    // progress-restore offer, cross-device sync, the post-login save, the TOUR (which
    // on a fresh profile clicks #undoBtn -> pushUndoState -> _dmbUserEdited = true,
    // unlocking the guest R2 save), the add-to-cart hint, the sign-in prompt, the
    // background preview engine and the scroll. setCanvasZoom(1) pins the overlay
    // scale so cover geometry is not read at a device-dependent zoom.
    if (_dmbRenderMode()) { try { setCanvasZoom(1); } catch (e) {} return; }

    // Offer to restore saved customer progress (after first render)
    setTimeout(() => { try { offerCustomerProgressRestore(); } catch(e) {} }, 600);
    setTimeout(() => { try { _dmbStartCrossDeviceSync(); } catch(e) {} }, 900);   // instant multi-device sync
    try { _dmbMaybeSaveAfterLogin(); } catch(e) {}   // finish a guest's save after they sign in

    // Start builder tour for first-time visitors — but NOT on phones: the tour
    // targets the old desktop layout, so it highlights the wrong elements in the
    // mobile shell. (A mobile-specific tour can be added later.)
    if (!(window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches)) {
      setTimeout(() => { try { dmbStartTour(); } catch(e) {} }, 1200);
    }
    // If the tour is already done it won't run (so no "tourEnded" event fires) —
    // show the add-to-cart hint directly (once) so returning visitors still get it.
    try {
      if (localStorage.getItem("dmb_tour_v1_done")) {
        setTimeout(() => { try { _dmbShowAddCartHint(); } catch(e) {} }, 1500);
      }
    } catch(e) {}

    // Nudge guests to sign in so their design is saved + available on any device.
    setTimeout(() => { try { _dmbMaybeShowSignInPrompt(); } catch(e) {} }, 1800);

    // Kick off background PDF preview rendering for all pages
    try { _dmbPvInitAll(); } catch(e) {}

    // Open at the device default (50% on phones, 100% on iPad/desktop).
    setCanvasZoom(_dmbDefaultZoom());

    // Keep the page at the top (header + announcement bar visible) when the builder
    // opens, instead of auto-scrolling down to the builder. The customer controls scroll.
    window.scrollTo({ top: 0, behavior: "auto" });
  }

  function closeEditorBackToDetails() {
    document.querySelectorAll(".dmb-logo-watermark").forEach((el) => el.remove());
    if (step1) step1.style.display = "flex";
    if (builderStep) builderStep.style.display = "none";
    if (bookDetails) bookDetails.style.display = "none";
  }

  let _spreadDragListenersAdded = false;
  function initSpreadPhotoDragListeners() {
    if (_spreadDragListenersAdded) return;
    _spreadDragListenersAdded = true;
    const _pdZ = getPageDims(); const PAGE_W = _pdZ.w, PAGE_H = _pdZ.h;
    document.addEventListener("mousemove", (e) => {
      if (!spreadPhotoDragState) return;
      const { type, si, startX, startY, startPanX, startPanY, startZoom } = spreadPhotoDragState;
      const sp = editor.spreadPhoto?.[si];
      if (!sp) { spreadPhotoDragState = null; return; }
      if (type === "pan") {
        const zoom = sp.zoom || 1;
        const maxX = PAGE_W * (zoom - 1), maxY = (PAGE_H / 2) * (zoom - 1);
        sp.panX = Math.max(-maxX, Math.min(maxX, startPanX + (e.clientX - startX)));
        sp.panY = Math.max(-maxY, Math.min(maxY, startPanY + (e.clientY - startY)));
        spreadCanvas.querySelectorAll("[data-spread-img-layer]").forEach(l => {
          l.style.transform = `translate(${sp.panX}px,${sp.panY}px) scale(${zoom}) rotate(${sp.rotation || 0}deg)`;
        });
      } else if (type === "resize") {
        const newZoom = Math.max(1, Math.min(4, startZoom + (e.clientX - startX) / 150));
        const maxX = PAGE_W * (newZoom - 1), maxY = (PAGE_H / 2) * (newZoom - 1);
        sp.zoom = newZoom;
        sp.panX = Math.max(-maxX, Math.min(maxX, startPanX));
        sp.panY = Math.max(-maxY, Math.min(maxY, startPanY));
        spreadCanvas.querySelectorAll("[data-spread-img-layer]").forEach(l => {
          l.style.transform = `translate(${sp.panX}px,${sp.panY}px) scale(${newZoom}) rotate(${sp.rotation || 0}deg)`;
        });
      }
    });
    document.addEventListener("mouseup", () => {
      if (spreadPhotoDragState) {
        const _pvDragSi = spreadPhotoDragState.si;
        spreadPhotoDragState = null;
        renderThumbsRail();
        // Dirty-mark both pages of the affected spread so the PDF preview
        // re-renders with the new pan/zoom/rotation. This drag handler never
        // calls pushUndoState, so we hook directly here.
        try { _dmbPvMarkDirty(_pvDragSi * 2 + 1); _dmbPvMarkDirty(_pvDragSi * 2 + 2); } catch(e) {}
      }
    });
  }

  function chooseDistributedPages(pages, k) {
    const n = pages.length;
    if (k <= 0) return new Set();
    if (k >= n) return new Set(pages);

    const chosen = [];
    for (let i = 0; i < k; i++) {
      const idx = Math.round((i + 0.5) * (n / k) - 0.5);
      chosen.push(pages[Math.max(0, Math.min(n - 1, idx))]);
    }

    const set = new Set(chosen);

    let guard = 0;
    while (guard++ < 1000) {
      let changed = false;
      const sorted = Array.from(set).sort((a, b) => a - b);

      for (let i = 0; i < sorted.length - 1; i++) {
        if (sorted[i + 1] === sorted[i] + 1) {
          const bad = sorted[i + 1];
          const pos = pages.indexOf(bad);
          const options = [pages[pos + 1], pages[pos - 1]].filter(Boolean);

          for (const opt of options) {
            if (!set.has(opt) && !set.has(opt - 1) && !set.has(opt + 1)) {
              set.delete(bad);
              set.add(opt);
              changed = true;
              break;
            }
          }
        }
      }

      if (!changed) break;
    }

    return set;
  }

  // ── Magazine pricing/variants (separate "custom-magazine" product) ──────────
  // Built from window.DMB_MAGAZINE_VARIANTS (exposed by design-my-magazine.liquid)
  // into { "PAGES|SIZE": {id, new, old} }, normalised so page keys are plain digits
  // and size is A4/A5 regardless of the product's option order. Null if the product
  // isn't set up → callers fall back to the book product.
  // var (NOT let): updatePrice() runs during init BEFORE this line is reached,
  // and a `let` here is in its temporal dead zone at that moment — on magazine
  // pages that threw a ReferenceError that silently killed the rest of the
  // file's initialization (dead Edit buttons etc.). var hoists to undefined.
  var _dmbMagMapCache;
  function _dmbMagVariantMap() {
    if (_dmbMagMapCache !== undefined) return _dmbMagMapCache;
    const arr = window.DMB_MAGAZINE_VARIANTS;
    if (!Array.isArray(arr) || !arr.length) { _dmbMagMapCache = null; return null; }
    const isSz = (s) => /^a[45]$/i.test(String(s).trim());
    const map = {};
    arr.forEach((v) => {
      const o1 = String(v.o1 || ""), o2 = String(v.o2 || "");
      const size = isSz(o1) ? o1.trim().toUpperCase() : isSz(o2) ? o2.trim().toUpperCase() : "A4";
      const pages = String(isSz(o1) ? o2 : o1).replace(/\D/g, "");
      if (!pages) return;
      map[pages + "|" + size] = { id: v.id, new: Number(v.price) || 0, old: Number(v.compare) || 0 };
    });
    _dmbMagMapCache = Object.keys(map).length ? map : null;
    return _dmbMagMapCache;
  }
  function _dmbMagEntry(pagesValue, sizeValue) {
    const m = _dmbMagVariantMap(); if (!m) return null;
    const pages = String(pagesValue || "").replace(/\D/g, "");
    const size = sizeValue === "A5" ? "A5" : "A4";
    return m[pages + "|" + size] || m[pages + "|A4"] || null;
  }

  function getDmbVariantIdByPages(pagesValue, sizeValue) {
    // Magazines use their own product when it's set up; else fall through to books.
    if (window.DMB_MAGAZINE_MODE) {
      const me = _dmbMagEntry(pagesValue, sizeValue);
      if (me && me.id) return me.id;
    }
    // Page count × Size → Shopify variant id. Sourced from BOOK_VARIANT_IDS, which
    // is the hardcoded fallback MERGED with the live custom-photo-book variants
    // (see _dmbIngestBookVariants). Size defaults to A4 so any caller that doesn't
    // pass a size (e.g. magazine) is unchanged.
    const row = BOOK_VARIANT_IDS[String(pagesValue || "")];
    if (!row) return null;
    return row[sizeValue === "A5" ? "A5" : "A4"] || row.A4 || null;
  }

  // ─── PDF generation ────────────────────────────────────────────────
  // Page order — book:     front cover → spine → back cover → pages 1..N
  //              magazine: front cover → blank → pages 0..N → blank → back cover
  // Programmatic PDF — each element drawn directly from source at 300 DPI.
  // No html2canvas: photos are taken straight from their original files/URLs.
  // _pvOpt: { cover:true, resolve, reject } for cover preview
  //         { page:N,   resolve, reject } for single page preview
  //         null/undefined for normal full PDF export
  async function buildPdfBlobOnePagePerBookPage(onProgress, _pvOpt, _excludePages, _stream) {

    // ── Load jsPDF only (no html2canvas needed) ───────────────────────
    function loadScript(src) {
      return new Promise(function(resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
        var s = document.createElement("script");
        s.src = src;
        s.onload = resolve;
        s.onerror = function() { reject(new Error("Could not load " + src)); };
        document.head.appendChild(s);
      });
    }
    // Preview mode skips jsPDF entirely — it only needs canvas rendering
    // Preview mode skips jsPDF entirely - it only needs canvas rendering. The STREAMING
    // path never constructs a jsPDF either (addCanvasPage hands the JPEG off and
    // returns), so RENDER MODE skips the CDN dependency too: one less piece of egress
    // that can abort a whole server job before a single page is drawn.
    if (!_pvOpt && !(_dmbRenderMode() && _stream && _stream.onPage))
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");

    // ── Sizing constants ──────────────────────────────────────────────
    // Both the INTERIOR pages and the COVER faces flip with orientation
    // (landscape = 297 × 210). Portrait books are byte-for-byte unchanged.
    // Landscape cover element positions are approximate until re-authored via an
    // -ls template. Spine thickness is physical (page count) so it stays constant.
    var _dmbLS     = dmbIsLandscape();
    var A4_W_MM    = _dmbLS ? 297 : 210;   // interior page (flips)
    var A4_H_MM    = _dmbLS ? 210 : 297;
    // Card = 5×7in (127×178mm) face; book/magazine cover = A-series (210×297).
    var _dmbCard   = !!window.DMB_CARD_MODE;
    var COVER_W_MM = _dmbCard ? (_dmbLS ? 178 : 127) : (_dmbLS ? 297 : 210);   // cover face (flips with orientation)
    var COVER_H_MM = _dmbCard ? (_dmbLS ? 127 : 178) : (_dmbLS ? 210 : 297);
    var FACE_PX    = 300;
    var FACE_H_PX  = Math.round(FACE_PX * COVER_H_MM / COVER_W_MM);   // portrait 424, landscape 212
    var SPINE_PX   = COVER_SPINE_W;   // matches the on-screen spine so the PDF crop isn't squished
    var SPINE_W_MM = 8;   // fixed physical spine thickness: exactly 8 mm (both orientations)
    var PAGE_W_PX  = getPageDims().w;   // portrait 270, landscape 382

    // Output canvas at full 300 DPI — resolution/sharpness preserved (crisp text, logos,
    // fine lines). Upload size is reduced instead via stronger JPEG compression (0.85 below),
    // which is the least-visible way to shrink the data so big books still finish on a slow
    // (~2 Mbps) connection.
    var MM2PX      = 300 / 25.4;
    // EVERY book — big or small — now uses the SAME near-lossless JPEG quality (0.96).
    // (Previously books ≥100 pages were dropped to 0.85 to shrink the upload on slow
    // connections; the owner wants big books at full quality too. Big books render
    // page-by-page via the streaming path and free each page, so per-page memory is
    // unchanged — only the finished PDF is larger. Overridable via
    // window.DMB_PDF_JPEG_QUALITY if a specific book ever needs a smaller file.)
    var _jpegQuality = (typeof window.DMB_PDF_JPEG_QUALITY === "number")
      ? window.DMB_PDF_JPEG_QUALITY : 0.96;
    var OUT_W      = Math.round(A4_W_MM * MM2PX);    // interior width  (portrait 2480 / landscape 3508)
    var OUT_H      = Math.round(A4_H_MM * MM2PX);    // interior height (portrait 3508 / landscape 2480)
    var PAGE_SCALE = OUT_W / PAGE_W_PX;
    var FACE_SCALE = Math.round(COVER_W_MM * MM2PX) / FACE_PX;   // cover scale from the PORTRAIT face
    var FACE_OUT_H = Math.round(FACE_H_PX * FACE_SCALE);

    // jsPDF is only needed for the real export, not preview rendering
    var jsPDF = (!_pvOpt && window.jspdf) ? window.jspdf.jsPDF : null;
    var pdf   = null;

    // ── CHUNK mode (admin split-download) ─────────────────────────────────
    // When _stream.chunk is a number N, the SAME render pipeline produces SEPARATE small
    // PDFs instead of one huge one: the 3 cover pages become "cover", then every N book
    // pages become "1", "2", "3"… Each finished chunk is a jsPDF blob, returned as an array.
    var _chunkPdf = null, _chunkPageCount = 0, _chunkNo = 0, _chunkOut = [];
    function _finishChunk(name) {
      if (_chunkPdf) { _chunkOut.push({ name: name, blob: _chunkPdf.output("blob") }); }
      _chunkPdf = null; _chunkPageCount = 0;
    }
    function _maybeCloseInteriorChunk() {
      if (_stream && _stream.chunk && _chunkPageCount >= _stream.chunk) {
        _chunkNo++; _finishChunk(String(_chunkNo));
      }
    }
    // ── Phase 1 streaming export (build+verify only; not wired into checkout) ──
    // When _stream.onPage is provided, each finished page is handed off and freed
    // instead of being accumulated in jsPDF, so peak memory ≈ one page. The per-page
    // JPEG is the SAME canvas.toDataURL(...) the in-memory path uses, so the bytes
    // are identical. _pageSeq records page order + dimensions for the returned
    // manifest (what the server "stapler" assembles from).
    _stream = _stream || null;
    var _pageSeq = [];

    // ── Canvas helpers ─────────────────────────────────────────────────
    function mkCanvas(w, h) {
      var c = document.createElement("canvas");
      c.width  = Math.max(1, Math.round(w));
      c.height = Math.max(1, Math.round(h));
      var ctx = c.getContext("2d");
      // ── Quality: always use high-quality image smoothing for PDF rendering ──
      // Default browser setting is "low", which produces aliasing artefacts
      // (white/black dots, noise) when downscaling large camera photos to the
      // 300 DPI canvas. "high" uses bicubic/Lanczos resampling → clean result.
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, c.width, c.height);
      return { canvas: c, ctx: ctx };
    }

    function loadImg(url) {
      return new Promise(function(res, rej) {
        if (!url) return rej(new Error("No URL"));
        var img = new Image();
        if (!url.startsWith("blob:") && !url.startsWith("data:")) img.crossOrigin = "anonymous";
        img.onload  = function() { res(img); };
        img.onerror = function() { rej(new Error("Failed: " + url.slice(0, 60))); };
        img.src = url;
      });
    }

    // ── Level 2 render helpers (need loadImg, so they live in this scope) ─────
    // See _dmbLightMem / _dmbReleaseDistantFullRes (defined at module level).
    // Decode a blob into an <img>, then revoke its object URL immediately. The
    // decoded pixels stay in the element, so the compressed blob is freed right
    // after decode → only ONE full-res image is resident at a time in a render.
    async function _dmbDecodeBlobToImg(blob) {
      const u = URL.createObjectURL(blob);
      const img = new Image();
      img.decoding = "async";
      // Wait for LOAD, not decode(). Canvas drawing only needs the image loaded,
      // and img.decode() is NOT reliable to await: on a large image in a tab the
      // browser isn't painting (customer switched tabs mid-export), Chrome can
      // leave the returned promise unsettled FOREVER — which used to hang the
      // whole PDF render with no error and no timeout. Verified live: an image
      // with complete=true and naturalWidth=3500 still never settled decode().
      // So load is the real gate; decode() is best-effort, time-boxed, and its
      // failure is ignored.
      const loaded = new Promise((res, rej) => {
        img.onload = () => res(true);
        img.onerror = () => rej(new Error("image load failed"));
      });
      img.src = u;
      try {
        if (!img.complete || !img.naturalWidth) await loaded;
        await Promise.race([
          img.decode().catch(() => {}),
          new Promise((res) => setTimeout(res, 3000)),
        ]);
      } finally {
        // Safe once loaded: the element keeps its own copy of the pixels.
        try { URL.revokeObjectURL(u); } catch (e) {}
      }
      if (!img.naturalWidth) throw new Error("decode failed");
      return img;
    }

    // Full-res image for RENDER. Light-mem OFF → exactly loadImg(ph.url)
    // (unchanged). ON → resident url/file if present, else full-res streamed from
    // R2 by id, one image at a time. Same full-res bytes either way — quality is
    // identical; this only changes WHERE the bytes live between uses.
    async function _dmbRenderImg(ph) {
      if (!ph) throw new Error("no photo");
      // Print-master (flag ON, DESKTOP only): the client PDF prefers the ~3500px
      // print master from R2 over the resident proxy — under the flag the local
      // file is a 2500px proxy, so without this the desktop PDF would LOSE quality.
      // Mobile stays on the proxy path (decoding hundreds of 3500px masters is the
      // exact crash we removed — its full-quality PDF comes from the server render).
      // Crop-derived photos are baked from local pixels; no master exists for them.
      // A pid that misses once is memoized and never re-tried this session.
      // RENDER MODE + crops=rebake: a crop-derived photo was baked in the CUSTOMER's
      // browser. Re-bake it from the SOURCE master + editor.cropRects, honouring EXIF.
      // The DEFAULT (crops=prefer-r2) falls through to photos/{derivedId} below - those
      // are the exact bytes the customer's own PDF draws, i.e. the parity source.
      if (_dmbRenderMode() && _DMB_RM.crops === "rebake" && _dmbIsCropDerived(ph)) {
        try { const _ci = await _dmbRenderCropDerivedImg(ph); if (_ci) return _ci; } catch (e) {}
      }
      if (_dmbPrintMasterOn() && !_dmbIsMobileUpload() && ph.id && !_dmbIsCropDerived(ph) && !_dmbNoMasterPids.has(ph.id)) {
        try {
          // If this photo's master might still be uploading, let the chain finish
          // first — otherwise a just-imported photo would memoize a false miss.
          if (_dmbMasterPendingCount > 0) { try { await _dmbMasterChain; } catch (e) {} }
          let _mdid = ""; try { _mdid = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
          const _mb = await _dmbFetchPhotoBlob(_mdid, ph.id, "master");
          if (_mb && _mb.size) return await _dmbDecodeBlobToImg(_mb);
          _dmbNoMasterPids.add(ph.id);
          if (_dmbRenderMode()) _dmbRenderNote("master_miss", ph.id);
        } catch (e) {
          try { _dmbNoMasterPids.add(ph.id); } catch (e2) {}
          if (_dmbRenderMode()) _dmbRenderNote("master_miss", ph.id);
        }
      }
      if (!_dmbLightMem()) return loadImg(ph.url);        // legacy path — byte-identical
      if (ph.url) { try { return await loadImg(ph.url); } catch (e) {} }
      if (ph.file && ph.file.size) { try { return await _dmbDecodeBlobToImg(ph.file); } catch (e) {} }
      let designId = ""; try { designId = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
      const blob = await _dmbFetchPhotoBlob(designId, ph.id);
      if (!blob) {
        // RENDER MODE: last chance for a derived crop whose baked bytes are gone from R2.
        if (_dmbRenderMode() && _dmbIsCropDerived(ph)) {
          try { const _ci = await _dmbRenderCropDerivedImg(ph); if (_ci) return _ci; } catch (e) {}
        }
        if (_dmbRenderMode()) _dmbRenderNote("photo_missing", ph.id);
        throw new Error("photo unavailable: " + (ph.id || "?"));
      }
      return _dmbDecodeBlobToImg(blob);
    }
    // Cover face/bleed photos store a URL and (for tray photos) the photo id.
    // Under the print-master flag, resolve by id through _dmbRenderImg — master
    // quality on desktop, R2 self-heal when the resident URL was released/died.
    // Flag OFF (or no id, e.g. the front background upload): exactly loadImg(url).
    async function _dmbCoverImg(urlVal, idVal) {
      if (_dmbPrintMasterOn() && idVal) {
        try {
          const _cph = getPhotoById(idVal);
          if (_cph) return await _dmbRenderImg(_cph);
        } catch (e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", String(idVal)); }
      }
      if (_dmbRenderMode() && !urlVal) _dmbRenderNote("photo_missing", String(idVal || "cover-bg"));
      return loadImg(urlVal);
    }
    try { if (typeof window !== "undefined") window.__dmbLightMem = { on: _dmbLightMem, renderImg: _dmbRenderImg, release: _dmbReleaseDistantFullRes, keep: _dmbCurrentSpreadPhotoIds }; } catch (e) {}

    // ── Photo drawing helpers ───────────────────────────────────────────────
    // _setHiQ: always re-apply imageSmoothingQuality after ctx.save() because
    // save/restore does NOT preserve the smoothing setting in all browsers.
    function _setHiQ(ctx) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
    }

    // _downsampleImg: stepped downsampling for very large photos.
    // A single drawImage from e.g. 4000px → 600px can still look noisy even
    // with "high" smoothing. Halving in steps produces a cleaner result.
    // Returns a canvas that can be used as the source for the final drawImage.
    // If the photo is small enough (< 2× the target), returns the original img.
    function _downsampleImg(img, targetW, targetH) {
      var sW = img.naturalWidth, sH = img.naturalHeight;
      // Only step-down if source is more than 2× the target dimension
      if (sW <= targetW * 2 && sH <= targetH * 2) return img;
      var cur = img;
      while (sW > targetW * 2 || sH > targetH * 2) {
        var nW = Math.max(Math.round(sW / 2), targetW);
        var nH = Math.max(Math.round(sH / 2), targetH);
        var step = document.createElement("canvas");
        step.width = nW; step.height = nH;
        var sCtx = step.getContext("2d");
        sCtx.imageSmoothingEnabled = true;
        sCtx.imageSmoothingQuality = "high";
        sCtx.drawImage(cur, 0, 0, nW, nH);
        cur = step;
        sW = nW; sH = nH;
      }
      return cur;
    }

    // object-fit:cover + pan/zoom/rotation into a clipped destination rect
    function drawFit(ctx, img, dx, dy, dw, dh, panX, panY, zoom, rotDeg) {
      panX = panX || 0; panY = panY || 0; zoom = zoom || 1; rotDeg = rotDeg || 0;
      var iA = img.naturalWidth / img.naturalHeight;
      var fA = dw / dh;
      var sw, sh;
      if (iA > fA) { sh = dh; sw = sh * iA; } else { sw = dw; sh = sw / iA; }
      // Pre-downsample large source photos for clean anti-aliasing
      var src = _downsampleImg(img, Math.round(sw), Math.round(sh));
      ctx.save();
      _setHiQ(ctx);
      ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
      ctx.translate(dx + dw / 2 + panX, dy + dh / 2 + panY);
      if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
      ctx.scale(zoom, zoom);
      ctx.drawImage(src, -sw / 2, -sh / 2, sw, sh);
      ctx.restore();
    }

    // object-fit:cover + rotation-only (matches applyRotationAndCover)
    function drawRotFit(ctx, img, dx, dy, dw, dh, rotDeg) {
      rotDeg = rotDeg || 0;
      var swapped = (Math.abs(Math.round(rotDeg) % 180) === 90);
      var iW = img.naturalWidth, iH = img.naturalHeight;
      // Cover-fit at the photo's OWN aspect (object-fit:cover happens before the
      // CSS rotate on screen). Using the swapped aspect here scaled the photo
      // non-uniformly into the draw rect, so every 90/270-rotated photo printed
      // stretched while the builder showed it correct.
      var iA = iW / iH, fA = dw / dh;
      var sw, sh;
      if (iA > fA) { sh = dh; sw = sh * iA; } else { sw = dw; sh = sw / iA; }
      var es = swapped ? Math.max(dw / dh, dh / dw) : 1;
      // Pre-downsample large source photos for clean anti-aliasing. The ctx.scale(es)
      // below magnifies the drawn rect, so downsample to the FINAL painted size.
      var src = _downsampleImg(img, Math.round(sw * es), Math.round(sh * es));
      ctx.save();
      _setHiQ(ctx);
      ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
      ctx.translate(dx + dw / 2, dy + dh / 2);
      if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
      if (es !== 1) ctx.scale(es, es);
      ctx.drawImage(src, -sw / 2, -sh / 2, sw, sh);
      ctx.restore();
    }

    // Build a styled SVG string from a map object (fill/stroke/opacity applied)
    function styledSvg(obj) {
      // Builds a CLEAN, minimal SVG for canvas/PDF rendering.
      //
      // Raw SVG map files contain non-standard namespace declarations
      // (xmlns:mapsvg, xmlns:dc, xmlns:rdf, xmlns:sodipodi, etc.) and embedded
      // <metadata>/<defs> blocks. When serialised and loaded as a blob/data URL
      // on a <canvas>, most browsers silently refuse to paint them → maps invisible.
      //
      // This function builds the SVG from scratch with:
      //   • Only xmlns="http://www.w3.org/2000/svg" (no custom namespaces)
      //   • Only <path> elements with fill/stroke applied as attributes
      //   • A proper <defs><filter> when showOutline is active (morphology ring)
      //   • No metadata, no vector-effect (stroke-width recalibrated in drawSvgObj)
      //
      // showOutline + transparentFill ("outline only, hollow interior"):
      //   Paths keep the fill colour (not "none") so SVG SourceAlpha has a
      //   silhouette to dilate. The hollow-centre filter output hides the fill
      //   visually and shows only the outer ring.
      //
      // hideProvinces + transparentFill (no provinces, hollow):
      //   Province strokes are hidden (stroke = fill). Visibility comes from
      //   showOutline; without it the map is intentionally transparent.
      try {
        var doc = new DOMParser().parseFromString(obj.svg || "", "image/svg+xml");
        var svgEl = doc.querySelector("svg");
        if (!svgEl) return obj.svg || "";

        // ── Resolve viewBox ─────────────────────────────────────────────────
        var vb = svgEl.getAttribute("viewBox");
        if (!vb) {
          var vw = svgEl.getAttribute("width"), vh = svgEl.getAttribute("height");
          if (vw && vh) vb = "0 0 " + parseFloat(vw) + " " + parseFloat(vh);
        }

        var opacity     = (obj.opacity != null) ? String(obj.opacity) : "1";
        var baseFill    = obj.fill   || "#d9d9d9";
        var strokeColor = obj.stroke || "#111111";
        var sw          = Math.max(0.5, parseFloat(obj.strokeWidth || 1.2));

        // When showOutline + transparentFill: SourceAlpha needs a real fill to
        // capture the silhouette; the filter hides the fill visually.
        var fill = (obj.transparentFill && !obj.showOutline) ? "none" : baseFill;

        // Province strokes: when hideProvinces, make stroke = fill so internal
        // borders blend away. When fill is "none" (and no showOutline), this
        // results in an intentionally invisible map.
        var stroke      = obj.hideProvinces ? fill : strokeColor;
        var strokeWidth = obj.hideProvinces ? "1"  : String(sw);
        var dasharray   = (!obj.hideProvinces && obj.strokeDasharray) ? String(obj.strokeDasharray) : null;

        // ── showOutline: morphology-based outer-silhouette filter ───────────
        // Mirrors dmbEnsureOutlineFilter() used in the builder DOM.
        // radius is in SVG user-units — drawSvgObj will recalibrate it via
        // the same scaledSW logic it uses for path stroke-width.
        var filterDefs   = "";
        var groupFilter  = "";
        if (obj.showOutline) {
          var filterId  = (obj.filterId || "dmbOF_pdf").replace(/[^a-zA-Z0-9_-]/g, "_");
          var hollow    = !!obj.transparentFill;
          var filterBody =
              '<feMorphology operator="dilate" radius="' + sw + '" in="SourceAlpha" result="dilated"/>'
            + '<feComposite in="dilated" in2="SourceAlpha" operator="out" result="ring"/>'
            + '<feFlood flood-color="' + strokeColor + '" result="color"/>'
            + '<feComposite in="color" in2="ring" operator="in" result="coloredRing"/>';

          if (hollow) {
            // Output: outer ring only — interior remains transparent
            filterBody += '<feComposite in="coloredRing" in2="SourceAlpha" operator="out"/>';
          } else {
            // Output: original content + outer ring drawn on top
            filterBody += '<feMerge>'
              + '<feMergeNode in="SourceGraphic"/>'
              + '<feMergeNode in="coloredRing"/>'
              + '</feMerge>';
          }

          filterDefs  = '<defs>'
            + '<filter id="' + filterId + '" x="-20%" y="-20%" width="140%" height="140%">'
            + filterBody + '</filter></defs>';
          groupFilter = ' filter="url(#' + filterId + ')"';
        }

        // ── Paths ───────────────────────────────────────────────────────────
        var paths = [];
        svgEl.querySelectorAll("path").forEach(function(p) {
          var d = p.getAttribute("d");
          if (!d) return;
          var a = 'd="' + d.replace(/"/g, "&quot;") + '"'
            + ' fill="' + fill + '"'
            + ' stroke="' + stroke + '"'
            + ' stroke-width="' + strokeWidth + '"';
          if (dasharray) a += ' stroke-dasharray="' + dasharray + '"';
          paths.push('<path ' + a + '/>');
        });

        return '<svg xmlns="http://www.w3.org/2000/svg"'
          + (vb ? ' viewBox="' + vb + '"' : '')
          + ' opacity="' + opacity + '">'
          + filterDefs
          + '<g' + groupFilter + '>' + paths.join("") + '</g>'
          + '</svg>';
      } catch(e) { return obj.svg || ""; }
    }

    async function drawSvgObj(ctx, obj, dx, dy, dw, dh) {
      var markup = styledSvg(obj);
      // styledSvg sets vector-effect="non-scaling-stroke" — correct for the
      // builder (always 1.2px on screen) but UNRELIABLE when SVG is loaded as
      // an external image (browsers silently ignore vector-effect in that context).
      // Result: stroke scales by viewBoxWidth/renderWidth. Geographic SVGs have
      // large viewBox coordinates → stroke → 0px → map completely invisible.
      //
      // FIX: parse the SVG viewBox, remove vector-effect from all paths, and
      // recompute stroke-width in SVG user-units so the stroke renders as exactly
      // TARGET_STROKE_PX pixels in the intermediate bitmap — regardless of viewBox.
      // ctx.drawImage then upscales to the PDF canvas size, giving a clearly
      // visible ~5–8px border line at print resolution.

      var builderW = Math.max(1, obj.w || 200);
      var builderH = Math.max(1, obj.h || 200);
      // ONE factor for both axes, so the bitmap's aspect always equals the
      // destination's. Rasterise at the real print scale (dw / builderW) rather
      // than a fixed x2, capped so a full-page map cannot blow past the browser's
      // maximum bitmap dimension.
      var _mapK   = Math.max(2, Math.min(dw / builderW, 4096 / Math.max(builderW, builderH)));
      var renderW = Math.round(builderW * _mapK);  // intermediate bitmap width
      var renderH = Math.round(builderH * _mapK);  // intermediate bitmap height

      try {
        var tmpDoc = new DOMParser().parseFromString(markup, "image/svg+xml");
        var tmpSvg = tmpDoc.querySelector("svg");
        if (tmpSvg) {
          // ── Set explicit bitmap dimensions ──────────────────────────────
          tmpSvg.setAttribute("width",  String(renderW));
          tmpSvg.setAttribute("height", String(renderH));

          // ── Compute viewBox-aware stroke width ─────────────────────────
          // In the builder, vector-effect:non-scaling-stroke makes the stroke
          // always appear as exactly obj.strokeWidth CSS pixels regardless of
          // zoom.  For the PDF we must convert that pixel value to SVG user
          // units at the intermediate bitmap resolution.
          //
          // Formula:
          //   builderW pixels wide ↔ vbW SVG user units
          //   → 1 SVG unit = builderW/vbW px in the builder
          //   → user wants userSW px → in SVG units = userSW * (vbW / builderW)
          //
          // renderW = builderW * 2, so the render is 2× the builder size and
          // the stroke appears 2× larger in the bitmap — ctx.drawImage then
          // scales it down proportionally when drawing onto the PDF canvas.
          var vbStr   = tmpSvg.getAttribute("viewBox") || "";
          var vbParts = vbStr.trim().split(/[\s,]+/);
          // viewBox = "minX minY width height" → width is index 2
          var vbW        = (vbParts.length >= 3) ? (parseFloat(vbParts[2]) || renderW) : renderW;
          var svgPxScale = renderW / vbW; // how many px per SVG user unit
          // User's intended stroke width in builder CSS pixels
          var userSW   = Math.max(0.5, parseFloat(obj.strokeWidth || 1.2));
          // Convert to SVG user units so it renders proportionally in the PDF
          var scaledSW = userSW * vbW / Math.max(1, builderW);

          tmpSvg.querySelectorAll("path").forEach(function(p) {
            // Remove vector-effect — it's ignored in external-image context
            // and causes unpredictable stroke scaling
            p.removeAttribute("vector-effect");
            // Apply viewBox-calibrated stroke width (skip if stroke already none)
            if (p.getAttribute("stroke") !== "none") {
              p.setAttribute("stroke-width", String(scaledSW.toFixed(4)));
            }
          });
          // ── Outline ring: USER UNITS here, unlike the builder ────────────────
          // styledSvg wraps the paths in an inner `<g filter=...>` (see the return
          // statement above), so this filter runs in the SVG's USER space and the
          // radius is in viewBox units - same space as a path's stroke-width.
          // scaledSW is therefore correct:
          //   ring_canvas = R * (renderW/vbW) * (dw/renderW) = R * dw/vbW
          //               = userSW * dw/builderW = userSW * PAGE_SCALE   ✓
          // The BUILDER is the odd one out: the stored map markup has no <g>, so
          // dmbEnsureOutlineFilter's filter lands on the ROOT <svg>, which runs in
          // CSS-pixel space and needs the RAW value. Verified 2026-09-12 across all
          // 208 dmb-map-*.svg assets and 46 template maps: none contains a <g>.
          tmpSvg.querySelectorAll("feMorphology").forEach(function(fe) {
            fe.setAttribute("radius", String(scaledSW.toFixed(4)));
          });
          // #24: stroke-dasharray is measured in CSS px on screen (the builder keeps
          // vector-effect:non-scaling-stroke). Here vector-effect is stripped, so the
          // values must be converted to user units the same way the width is, or a
          // dashed province border prints as a dense stipple.
          var _dashK = vbW / Math.max(1, builderW);
          if (_dashK !== 1) {
            tmpSvg.querySelectorAll("path[stroke-dasharray]").forEach(function(p) {
              var _da = (p.getAttribute("stroke-dasharray") || "").trim();
              if (!_da) return;
              p.setAttribute("stroke-dasharray", _da.split(/[\s,]+/).map(function(v) {
                var n = parseFloat(v);
                return isFinite(n) ? (n * _dashK).toFixed(4) : v;
              }).join(" "));
            });
          }

          markup = new XMLSerializer().serializeToString(tmpSvg);
        }
      } catch(e) {}

      // ── Three rendering paths (all draw at renderW×renderH,
      //    ctx.drawImage upscales to the final dw×dh on the PDF canvas) ──────
      var _mapName = (obj && obj.name) || 'map';

      // Path 1: createImageBitmap — fastest; may fail for complex SVGs.
      try {
        var svgBlob1 = new Blob([markup], { type: "image/svg+xml" });
        var bitmap   = await createImageBitmap(svgBlob1, {
          resizeWidth:  renderW,
          resizeHeight: renderH
        });
        ctx.save(); ctx.drawImage(bitmap, dx, dy, dw, dh); ctx.restore();
        return;
      } catch(e1) { /* fall through */ }

      // Path 2: Blob URL + <img> — reliable fallback. Always revoke the URL.
      try {
        var svgBlob2 = new Blob([markup], { type: "image/svg+xml" });
        var blobUrl  = URL.createObjectURL(svgBlob2);
        try {
          var blobImg = await loadImg(blobUrl);
          ctx.save(); ctx.drawImage(blobImg, dx, dy, dw, dh); ctx.restore();
          return;
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      } catch(e2) { /* fall through */ }

      // Path 3: base64 data URL — last resort (avoids URL-encoding issues).
      try {
        var b64     = btoa(unescape(encodeURIComponent(markup)));
        var dataUrl = "data:image/svg+xml;base64," + b64;
        var dataImg = await loadImg(dataUrl);
        ctx.save(); ctx.drawImage(dataImg, dx, dy, dw, dh); ctx.restore();
      } catch(e3) {
        console.error('[DMB] Map "' + _mapName + '" failed all 3 render paths:', e3.message || e3);
      }
    }

    // Render free objects (stickers / maps / photo-frames) onto ctx
    async function drawFreeObjs(ctx, objects, scale) {
      if (!Array.isArray(objects)) return;
      var sorted = objects.slice().sort(function(a, b) { return (a.z || 0) - (b.z || 0); });
      for (var i = 0; i < sorted.length; i++) {
        var obj = sorted[i];
        if (!obj || !obj.type) continue;
        // Lines: migrate old rect-model + sync the axis-aligned bbox (rotation 0)
        // BEFORE the transform below reads x/y/w/h/rotation.
        if (obj.type === "shape" && obj.shapeType === "line") { try { _dmbLineRecomputeBox(obj); } catch (e) {} }
        // .dmb-photo-frame-object carries `border:2px dashed transparent` with
        // box-sizing:border-box, so on screen the photo sits 2px inside the box.
        var _fbw = (obj.type === "photo-frame") ? 2 * scale : 0;
        var ox = (obj.x || 0) * scale;
        var oy = (obj.y || 0) * scale;
        var ow = (obj.w || 100) * scale;
        var oh = (obj.h || 100) * scale;
        var rotDeg = obj.rotation || 0;
        try {
          ctx.save();
          // ── Contain-to-page PDF clip ──────────────────────────────────────
          // CSS clip-path only works in the browser — the canvas needs its own
          // clip rect. For cover items with obj.contained, clip the drawing to
          // the zone/spread boundary in the SPREAD canvas coordinate system
          // (before the item's own transforms are applied).
          if (obj.coverZone) {
            var _cFPS  = FACE_PX  * scale;
            var _cSPS  = SPINE_PX * scale;
            // Magazine has no spine — front starts at FACE_PX (300), books at COVER_FRONT_X (322)
            var _cFXS  = (window.DMB_MAGAZINE_MODE ? FACE_PX : COVER_FRONT_X) * scale;
            var _cCL, _cCR;
            if (obj.contained === 2) {
              _cCL = 0;
              _cCR = (window.DMB_MAGAZINE_MODE ? FACE_PX * 2 : FACE_PX * 2 + SPINE_PX) * scale;
            } else {
              if (obj.coverZone === "back")       { _cCL = 0;      _cCR = _cFPS; }
              else if (obj.coverZone === "spine") { _cCL = _cFPS;  _cCR = _cFPS + _cSPS; }
              else /* front */                    { _cCL = _cFXS;  _cCR = _cFXS + _cFPS; }
            }
            ctx.beginPath();
            ctx.rect(_cCL, 0, _cCR - _cCL, FACE_OUT_H);
            ctx.clip();
          }
          ctx.translate(ox + ow / 2, oy + oh / 2);
          if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
          ctx.translate(-ow / 2, -oh / 2);
          if (obj.type === "sticker" && (obj.tightUrl || obj.url)) {
            if (obj.tightUrl) {
              // Pre-cropped data URL — no CORS issues, use it directly
              const stickerImg = await loadImg(obj.tightUrl);
              ctx.drawImage(stickerImg, 0, 0, ow, oh);
            } else {
              // Older sticker without tightUrl: fetch via XHR to get a fresh CORS response
              // and avoid canvas tainting from the browser's non-CORS thumbnail cache
              const corsUrl = await (async () => {
                try {
                  const resp = await fetch(obj.url, { mode: "cors", cache: "no-store" });
                  const blob = await resp.blob();
                  return URL.createObjectURL(blob);
                } catch(fe) { return obj.url; }
              })();
              var stickerImg = null;
              try {
                stickerImg = await loadImg(corsUrl);
              } catch (sErr) {
                try { stickerImg = await loadImg(obj.url); } catch (sErr2) { stickerImg = null; }
              }
              if (corsUrl.startsWith("blob:")) URL.revokeObjectURL(corsUrl);
              if (!stickerImg) {
                try { _dmbRenderNote("photo_missing", "sticker:" + (obj.name || obj.id || obj.url)); } catch (e) {}
                console.warn("Sticker failed to load, omitted from PDF:", obj.url);
                throw new Error("sticker unavailable: " + (obj.name || obj.url));
              }
              const _sc = (obj.cropX !== undefined && obj.cropW) ? _dmbStickerCropFor(obj, stickerImg) : null;
              if (_sc) {
                ctx.drawImage(stickerImg, _sc.cropX, _sc.cropY, _sc.cropW, _sc.cropH, 0, 0, ow, oh);
              } else {
                ctx.drawImage(stickerImg, 0, 0, ow, oh);
              }
            }
          } else if (obj.type === "mag-icon" && obj.iconId) {
            try {
              const iconUrl = dmbMagIconUrl(obj.iconId);
              const corsUrl = await (async () => {
                try {
                  const resp = await fetch(iconUrl, { mode: "cors", cache: "no-store" });
                  const blob = await resp.blob();
                  return URL.createObjectURL(blob);
                } catch(fe) { return iconUrl; }
              })();
              const iconImg = await loadImg(corsUrl);
              if (corsUrl.startsWith("blob:")) URL.revokeObjectURL(corsUrl);
              const tmpC = document.createElement("canvas");
              tmpC.width = ow; tmpC.height = oh;
              const tmpX = tmpC.getContext("2d");
              // Screen uses object-fit:contain - letterbox, never distort.
              var _inw = iconImg.naturalWidth || ow, _inh = iconImg.naturalHeight || oh;
              var _icr = Math.min(ow / _inw, oh / _inh);
              var _idw = _inw * _icr, _idh = _inh * _icr;
              tmpX.drawImage(iconImg, (ow - _idw) / 2, (oh - _idh) / 2, _idw, _idh);
              tmpX.globalCompositeOperation = "source-in";
              tmpX.fillStyle = obj.color || "#000000";
              tmpX.fillRect(0, 0, ow, oh);
              ctx.drawImage(tmpC, 0, 0, ow, oh);
            } catch(iconErr) {}
          } else if (obj.type === "map" && obj.svg) {
            await drawSvgObj(ctx, obj, 0, 0, ow, oh);
            // Draw markers on top of the map SVG
            if (Array.isArray(obj.markers) && obj.markers.length > 0) {
              // Fixed CSS sizes from createMarkerElement / .dmb-map-marker-dot,
              // taken to print scale. The element is centred on the anchor point
              // (inline transform: translate(-50%,-50%)).
              var mS = scale;
              obj.markers.forEach(function(md) {
                var mX = ((md.x || 0) / 100) * ow;
                var mY = ((md.y || 0) / 100) * oh;
                var mColor = md.color || "#e74c3c";
                var mType  = md.type  || "pin";
                ctx.save();
                if (mType === "dot") {
                  // 14x14 box, 2px white border inside it (border-box).
                  ctx.beginPath(); ctx.arc(mX, mY, 7 * mS, 0, Math.PI * 2);
                  ctx.fillStyle = "#ffffff"; ctx.fill();
                  ctx.beginPath(); ctx.arc(mX, mY, 5 * mS, 0, Math.PI * 2);
                  ctx.fillStyle = mColor; ctx.fill();
                } else if (mType === "pin") {
                  // The 18x26 SVG, centred on the anchor: head at y=9, tip at y=26.
                  var _px = mX - 9 * mS, _py = mY - 13 * mS;
                  ctx.beginPath();
                  ctx.arc(_px + 9 * mS, _py + 9 * mS, 7.5 * mS, 0, Math.PI * 2);
                  ctx.fillStyle = mColor; ctx.fill();
                  ctx.strokeStyle = "#ffffff"; ctx.lineWidth = 1.5 * mS; ctx.stroke();
                  ctx.beginPath();
                  ctx.moveTo(_px + 9 * mS,    _py + 26 * mS);
                  ctx.lineTo(_px + 3.5 * mS,  _py + 15 * mS);
                  ctx.lineTo(_px + 14.5 * mS, _py + 15 * mS);
                  ctx.closePath();
                  ctx.fillStyle = mColor; ctx.fill();
                  ctx.beginPath();
                  ctx.arc(_px + 9 * mS, _py + 9 * mS, 2.8 * mS, 0, Math.PI * 2);
                  ctx.fillStyle = "#ffffff"; ctx.fill();
                } else {
                  // font-size 22px, inherited UI face, NOT bold, text-shadow 0 1px 3px.
                  var mChar = mType === "heart" ? "\u2665" : "\u2605";
                  ctx.font = (22 * mS) + "px system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif";
                  ctx.fillStyle = mColor; ctx.textBaseline = "middle"; ctx.textAlign = "center";
                  ctx.shadowColor = "rgba(0,0,0,0.4)";
                  ctx.shadowBlur = 3 * mS; ctx.shadowOffsetY = 1 * mS;
                  ctx.fillText(mChar, mX, mY);
                  ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
                }
                ctx.restore();
              });
            }
          } else if (obj.type === "photo-frame") {
            if (obj.polaroid) {
              // White polaroid mat (+ optional light shadow); photo inset into the window.
              ctx.save();
              if (obj.shadow !== false) {
                ctx.shadowColor = "rgba(0,0,0,0.18)";
                ctx.shadowBlur = 16 * scale;
                ctx.shadowOffsetY = 6 * scale;
              }
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(0, 0, ow, oh);
              ctx.restore();
              var _piP = dmbPolaroidInsetVals(obj.w, obj.h);
              var _wx = _fbw + _piP.left * scale, _wy = _fbw + _piP.top * scale;
              var _ww = ow - 2 * _fbw - (_piP.left + _piP.right) * scale;
              var _wh = oh - 2 * _fbw - (_piP.top + _piP.bottom) * scale;
              if (obj.photoId) {
                var _phP = getPhotoById(obj.photoId);
                if (_phP) {
                  ctx.save();
                  ctx.translate(_wx, _wy);
                  if (obj.frameShape) applyCanvasFrameClip(ctx, obj.frameShape, _ww, _wh, scale);
                  drawFit(ctx, await _dmbRenderImg(_phP), 0, 0, _ww, _wh);
                  ctx.restore();
                }
              }
            } else if (obj.photoId) {
              var _ph = getPhotoById(obj.photoId);
              if (_ph) {
                ctx.save();
                ctx.translate(_fbw, _fbw);
                if (obj.frameShape) applyCanvasFrameClip(ctx, obj.frameShape, ow - 2 * _fbw, oh - 2 * _fbw, scale);
                drawFit(ctx, await _dmbRenderImg(_ph), 0, 0, ow - 2 * _fbw, oh - 2 * _fbw);
                ctx.restore();
              }
            }
          } else if (obj.type === "shape") {
            // ── SHAPE PDF rendering ─────────────────────────────────────────
            // The generic transform above (translate-to-centre, rotate, translate-back)
            // has already been applied. drawShapeOnCanvas draws in 0..100 space
            // scaled to ow×oh. Opacity is applied via globalAlpha then reset.
            // WARNING: Do NOT move this block outside the try{}/catch() — ctx.save()
            // above must pair with ctx.restore() at line 11718.
            ctx.globalAlpha = (obj.opacity !== undefined && obj.opacity !== null) ? obj.opacity : 1;
            if (obj.shapeType === "line") {
              // Draw the line path in top-left-relative coords (origin is the bbox
              // top-left after the generic transform; rotation is 0 for lines).
              var _lc = (obj.fill && obj.fill !== "none" && obj.fill !== "transparent") ? obj.fill : (obj.stroke || "#111111");
              var _ltw = Math.max(1, (obj.thickness || 8)) * scale;
              var _lp1 = { x: (obj.x1 - obj.x) * scale, y: (obj.y1 - obj.y) * scale };
              var _lp2 = { x: (obj.x2 - obj.x) * scale, y: (obj.y2 - obj.y) * scale };
              ctx.strokeStyle = _lc; ctx.lineWidth = _ltw; ctx.lineCap = "round"; ctx.lineJoin = "round";
              if (obj.strokeStyle === "dashed")      ctx.setLineDash([_ltw * 2.4, _ltw * 1.7]);
              else if (obj.strokeStyle === "dotted") ctx.setLineDash([0.1 * scale, _ltw * 1.9]);
              else                                   ctx.setLineDash([]);
              ctx.beginPath();
              ctx.moveTo(_lp1.x, _lp1.y);
              if (obj.lineType === "elbowed") {
                var _le = _dmbLineElbowPoint({ x: obj.x1, y: obj.y1 }, { x: obj.x2, y: obj.y2 });
                ctx.lineTo((_le.x - obj.x) * scale, (_le.y - obj.y) * scale);
                ctx.lineTo(_lp2.x, _lp2.y);
              } else if (obj.lineType === "curved") {
                _dmbLineEnsureCurve(obj);
                var _lcc = _dmbLineQuadControl(obj);
                ctx.quadraticCurveTo((_lcc.x - obj.x) * scale, (_lcc.y - obj.y) * scale, _lp2.x, _lp2.y);
              } else {
                ctx.lineTo(_lp2.x, _lp2.y);
              }
              ctx.stroke();
              ctx.setLineDash([]);
            } else {
              var _shOp  = (obj.opacity !== undefined && obj.opacity !== null) ? obj.opacity : 1;
              var _shPad = Math.ceil((obj.strokeWidth || 0) * scale) + 2;
              var _shTW  = Math.ceil(ow) + _shPad * 2, _shTH = Math.ceil(oh) + _shPad * 2;
              var _shHasBoth = (obj.fill && obj.fill !== "none" && obj.fill !== "transparent") &&
                               (obj.strokeWidth > 0) && obj.stroke && obj.stroke !== "transparent";
              if (_shOp < 1 && _shHasBoth && _shTW * _shTH <= 6000000) {
                var _shC = document.createElement("canvas");
                _shC.width = _shTW; _shC.height = _shTH;
                var _shX = _shC.getContext("2d");
                _shX.translate(_shPad, _shPad);
                drawShapeOnCanvas(_shX, obj.shapeType || "rect", obj.fill || "#6366f1", obj.stroke || "transparent", obj.strokeWidth || 0, ow, oh, obj.cornerRadius, obj.strokeStyle, scale);
                ctx.globalAlpha = _shOp;
                ctx.drawImage(_shC, -_shPad, -_shPad);
              } else {
                drawShapeOnCanvas(ctx, obj.shapeType || "rect", obj.fill || "#6366f1", obj.stroke || "transparent", obj.strokeWidth || 0, ow, oh, obj.cornerRadius, obj.strokeStyle, scale);
              }
            }
            ctx.globalAlpha = 1;
          } else if (obj.type === "text" && obj.text) {
            // ══ TEXT PDF RENDERING — replicates HTML/CSS builder exactly ══════════
            //
            // The builder renders text as position:absolute divs with these properties:
            //   • padding: 2px 6px  → text content starts 6px from element left edge,
            //                          2px from element top edge
            //   • transform-origin: center center  → rotation around element CENTRE
            //   • white-space: pre  → ONLY \n splits lines, NO word-wrapping ever
            //   • line-height: normal ≈ 1.2× font-size (browser default)
            //   • transform: rotate(Rdeg)  → rotation stored in obj.rotate / obj.transform
            //   • transform: translate(-50%,-50%) → obj.left/top is VISUAL CENTRE,
            //                                        not top-left of element
            //
            // BUGS FIXED vs previous version:
            //   1. Line height changed 1.1 → 1.2 to match browser default
            //   2. Word-wrap removed (white-space:pre = \n only)
            //   3. Padding offset added (6px H, 2px V) to non-centred text
            //   4. Rotation anchor moved from top-left → element centre
            //   5. Centred text vertical offset: txFontSize/2 → txTotalH/2 (multi-line)
            //   6. Font quotes: single quotes → double quotes for canvas compatibility
            //   7. textDecoration underline drawn manually (canvas has no text-decoration)
            //   8. obj.width no longer falls back to parent width (fixed in savePageTextState)
            //
            // WARNING: ctx.restore() below undoes the generic translate+rotate applied at
            // the top of this for-loop. Do NOT collapse the restore/save pair — text uses
            // its own coordinate system (left/top) instead of the generic x/y.
            ctx.restore(); // undo generic object transform (translate-to-centre, rotate)
            ctx.save();
            // Force-load every custom font before drawing on canvas.
            // document.fonts.ready only waits for fonts already in the loading
            // queue — it does NOT trigger loads for fonts not yet used in the DOM.
            // If a font hasn't been rendered in a live element, canvas falls back
            // to a system font and both Preview and PDF show the wrong typeface.
            // document.fonts.load("weight size 'family'") forces the browser to
            // fetch and decode the font file regardless of DOM usage.
            try { await document.fonts.ready; } catch(e2) {}
            try {
              var _fontFamilies = [
                "900 28px 'Londrina Solid'", "normal 28px 'Aurelia'",
                "normal 28px 'Burbank Big Condensed'", "normal 28px 'White Garden Wide'",
                "normal 28px 'Vogue Moderne'", "normal 28px 'GFS Didot'",
                "normal 28px 'Prata'", "normal 28px 'Theano Didot'",
                "normal 28px 'Lindys Diner'", "normal 28px 'Chomsky'",
                "normal 28px 'Anton'", "normal 28px '70s Disco'",
                "normal 28px 'Geraldine'", "normal 28px 'Lemon Drops'",
                "normal 28px 'Mouldy Cheese'", "normal 28px 'Nature Beauty'",
                "normal 28px 'Super Maples'", "normal 28px 'The Heart of Everything'",
                "normal 28px 'Tomatoes'", "normal 28px 'Wedding Day'"
              ];
              // Load each family at BOTH the authored weight and 800 — ctx.font below
              // draws at (obj.fontWeight || 800), and font matching under a weight the
              // browser never loaded can silently fall back to a system font.
              var _fontLoads = [];
              _fontFamilies.forEach(function(f) {
                _fontLoads.push(document.fonts.load(f));
                _fontLoads.push(document.fonts.load(f.replace(/^\S+/, "800")));
              });
              await Promise.allSettled(_fontLoads);
            } catch(e3) {}

            // ── Padding constants matching builder CSS "padding: 2px 6px" ──────
            var TX_PL = 6, TX_PT = 2; // horizontal pad (each side), vertical pad (each side)

            var txLeft    = parseFloat(obj.left || "0");
            var txTop     = parseFloat(obj.top  || "0");
            var txFontPx  = parseFloat(obj.fontSize || "28");
            var txFontSize = txFontPx * scale;

            // Font: replace ' with " so multi-word names work in canvas ctx.font
            var txFontFam = (obj.fontFamily || "sans-serif").replace(/'/g, '"');
            ctx.font      = (obj.fontWeight || "800") + " " + txFontSize + "px " + txFontFam;
            ctx.fillStyle  = obj.color || "#666";
            ctx.textBaseline = "alphabetic";
            ctx.textAlign    = "left"; // reset; set correctly per line below
            // The box's own face. Drawing a run switches ctx.font, so everything
            // below puts this back afterwards and no later measurement can be taken
            // through a run's font by accident.
            var _txBaseFont = ctx.font;

            // ── Line height: match builder CSS "line-height: 1.1" exactly ──────
            // The previous value (1.2) was larger than the CSS value, so each
            // text box's content sat progressively lower in the PDF than in the
            // builder, causing stacked text boxes to appear increasingly mis-spaced.
            var txLineH = txFontSize * 1.1;

            // ── Half-leading offset ─────────────────────────────────────────────
            // CSS line-height: 1.1 distributes the 0.1×fontSize "leading" equally
            // above and below each glyph (half-leading = 0.05×fontSize).  The top
            // padding starts the LINE BOX at top+2, but the glyph itself is
            // 0.05×fontSize lower inside that box.  canvas textBaseline:"top" draws
            // at the em-square top (no half-leading), so we add it back so the first
            // visible glyph lands at the same pixel as in the browser.
            var txHalfLead = txFontSize * 0.05;   // superseded by txFirstBase below

            // First baseline, from the font's REAL vertical metrics. CSS puts it at
            //   contentTop + (lineHeight - (ascent + descent)) / 2 + ascent
            // The constant above simplifies that to contentTop + 0.05em, which only
            // holds when ascent + descent == 1em. Anton, Burbank and the other
            // display faces are far taller, so their text printed several
            // millimetres below where the builder drew it. The glyph-centre branch
            // already used real metrics; these branches now do too.
            var _txM0  = ctx.measureText("Mg");
            var _txFA  = (_txM0 && _txM0.fontBoundingBoxAscent  > 0) ? _txM0.fontBoundingBoxAscent  : txFontSize * 0.80;
            var _txFD  = (_txM0 && _txM0.fontBoundingBoxDescent > 0) ? _txM0.fontBoundingBoxDescent : txFontSize * 0.20;
            var txFirstBase = (txLineH - (_txFA + _txFD)) / 2 + _txFA;
            // Underline sits just below the baseline, proportional to the descent.
            var _txUOff = (_txFD > 0)
              ? Math.max(txFontSize * 0.06, Math.min(_txFD * 0.55, txFontSize * 0.2))
              : txFontSize * 0.11;

            // ── Lines: split on \n. If the box was narrowed with the side grip
            //    (white-space:pre-wrap), word-wrap each paragraph to the box content
            //    width so the PDF matches the builder. Otherwise \n only (no wrap). ──
            var _txWraps  = (obj.whiteSpace === "pre-wrap");
            var _txWrapW  = (obj.width && parseFloat(obj.width) > 0) ? (parseFloat(obj.width) - TX_PL * 2) * scale : 0;
            var txLines = null;
            // Prefer the builder's CAPTURED rendered lines (see _captureCoverTextBoxes):
            // the exact word-per-line the customer sees. Canvas re-wrapping below is
            // only the fallback (canvas glyph widths can wrap at a different word).
            if (_txWraps && obj.renderedLines) {
              try {
                var _capL = JSON.parse(obj.renderedLines);
                if (Array.isArray(_capL) && _capL.length) txLines = _capL;
              } catch (eCL) {}
            }
            // No captured lines (design saved before page text stored them): let the
            // BROWSER wrap an offscreen replica instead of guessing with canvas
            // metrics, so older designs also print the breaks the builder shows.
            if (!txLines && _txWraps) {
              var _domL = _dmbWrapLinesViaDom(obj);
              if (_domL && _domL.length) txLines = _domL;
            }
            if (txLines) {
              // captured or DOM-measured — nothing to compute
            } else if (_txWraps && _txWrapW > 0) {
              txLines = [];
              obj.text.split("\n").forEach(function (_para) {
                var _words = _para.split(" ");
                var _cur = "";
                for (var _wi = 0; _wi < _words.length; _wi++) {
                  var _test = _cur ? (_cur + " " + _words[_wi]) : _words[_wi];
                  if (!_cur || ctx.measureText(_test).width <= _txWrapW) { _cur = _test; }
                  else { txLines.push(_cur); _cur = _words[_wi]; }
                }
                txLines.push(_cur);
              });
            } else {
              txLines = obj.text.split("\n");
            }
            // ── Inline runs: a box whose WORDS carry their own look ──────────
            // obj.richLines is the box split into the visual lines on screen, each
            // line a list of runs. It exists only for a box that actually holds more
            // than one look, so every other box goes down the identical path it
            // always did - not a reimplementation of it.
            //
            // The guard refuses a richLines that no longer spells the same text as
            // obj.text. A stale capture would print the wrong WORDS, and losing a
            // colour on one render is recoverable where that is not.
            var _rl = null;
            if (obj.richLines) {
              try {
                var _rlP = JSON.parse(obj.richLines);
                var _rlStyled = Array.isArray(_rlP) && _rlP.length && _rlP.some(function (ln) {
                  return Array.isArray(ln) && ln.some(function (r) {
                    return r && r.s && Object.keys(r.s).some(function (k) { return !!r.s[k]; });
                  });
                });
                if (_rlStyled) {
                  var _cand = _rlP.map(function (ln) {
                    return (Array.isArray(ln) ? ln : []).filter(function (r) {
                      return r && typeof r.t === "string";
                    });
                  });
                  var _candTxt = _cand.map(function (ln) {
                    return ln.map(function (r) { return r.t; }).join("");
                  }).join("");
                  var _strip = function (v) { return String(v == null ? "" : v).replace(/\s+/g, ""); };
                  if (_strip(_candTxt) === _strip(obj.text)) _rl = _cand;
                }
              } catch (eRL) {}
            }
            if (_rl) txLines = _rl.map(function (ln) { return ln.map(function (r) { return r.t; }).join(""); });

            // One run's face: everything it did not override comes from the box.
            function _txRunFace(r) {
              var st = (r && r.s) || {};
              var px = st.fs ? parseFloat(st.fs) : txFontPx;
              if (!isFinite(px) || px <= 0) px = txFontPx;
              px *= scale;
              var fam  = String(st.ff || obj.fontFamily || "sans-serif").replace(/'/g, '"');
              var wt   = st.fw || obj.fontWeight || "800";
              var ital = (st.fi === "italic" || st.fi === "oblique") ? "italic " : "";
              // An explicit "none" on the run has to BEAT the box's underline, so the
              // test is "did the run say anything", not "is it underlined".
              var und  = (st.td != null && st.td !== "")
                ? (String(st.td).indexOf("underline") !== -1)
                : !!(obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1);
              return { font: ital + wt + " " + px + "px " + fam, px: px,
                       color: st.c || obj.color || "#666", under: und };
            }
            function _txRunLineW(ln) {
              var w = 0;
              for (var i = 0; i < ln.length; i++) {
                ctx.font = _txRunFace(ln[i]).font;
                w += ctx.measureText(ln[i].t).width;
              }
              ctx.font = _txBaseFont;
              return w;
            }
            // How tall one line is, by the actual CSS rule for a line box: every run
            // contributes its own line-height (1.1 x its OWN size) split equally above
            // and below its glyphs, and the line is as tall as the tallest
            // contributor. The box's own font always takes part - that is the CSS
            // strut, and it is why one small word inside a big box does not pull the
            // lines closer together. With a single size this collapses exactly to
            // txFirstBase and txLineH, which is why an ordinary box still lands on
            // the same pixel it did before.
            function _txRunLineMetrics(ln) {
              var above = 0, below = 0;
              var take = function (fontStr, px) {
                ctx.font = fontStr;
                var m = ctx.measureText("Mg");
                var A = (m && m.fontBoundingBoxAscent  > 0) ? m.fontBoundingBoxAscent  : px * 0.80;
                var D = (m && m.fontBoundingBoxDescent > 0) ? m.fontBoundingBoxDescent : px * 0.20;
                var half = (px * 1.1 - (A + D)) / 2;
                if (half + A > above) above = half + A;
                if (half + D > below) below = half + D;
              };
              take(_txBaseFont, txFontSize);
              for (var i = 0; i < ln.length; i++) { var f = _txRunFace(ln[i]); take(f.font, f.px); }
              ctx.font = _txBaseFont;
              return { above: above, below: below, h: above + below };
            }
            // A line's real INK extents, for the glyph-centre anchor.
            function _txRunLineInk(ln) {
              var asc = 0, dsc = 0;
              for (var i = 0; i < ln.length; i++) {
                var f = _txRunFace(ln[i]);
                ctx.font = f.font;
                var m = ctx.measureText(ln[i].t);
                var a = (m.actualBoundingBoxAscent  != null) ? m.actualBoundingBoxAscent  : f.px * 0.70;
                var d = (m.actualBoundingBoxDescent != null) ? m.actualBoundingBoxDescent : f.px * 0.20;
                if (a > asc) asc = a;
                if (d > dsc) dsc = d;
              }
              ctx.font = _txBaseFont;
              return { asc: asc, dsc: dsc };
            }
            // Baseline of line li, measured DOWN from the top of the content box.
            var _rlBase = null, _rlTotalH = 0;
            if (_rl) {
              _rlBase = [];
              var _rlAcc = 0;
              for (var _rli = 0; _rli < _rl.length; _rli++) {
                var _rlM = _txRunLineMetrics(_rl[_rli]);
                _rlBase.push(_rlAcc + _rlM.above);
                _rlAcc += _rlM.h;
              }
              _rlTotalH = _rlAcc;
            }
            function _txBaseAt(li) {
              return _rlBase ? _rlBase[li] : (li * txLineH + txFirstBase);
            }
            // Draw one line, run by run, from an exact left edge and baseline.
            function _txRunDraw(ln, x, yBase) {
              for (var i = 0; i < ln.length; i++) {
                var f = _txRunFace(ln[i]);
                ctx.font = f.font; ctx.fillStyle = f.color;
                ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
                var w = ctx.measureText(ln[i].t).width;
                ctx.fillText(ln[i].t, x, yBase);
                if (f.under && /\S/.test(ln[i].t)) {
                  var m2 = ctx.measureText("Mg");
                  var D2 = (m2 && m2.fontBoundingBoxDescent > 0) ? m2.fontBoundingBoxDescent : f.px * 0.2;
                  var off = Math.max(f.px * 0.06, Math.min(D2 * 0.55, f.px * 0.2));
                  ctx.save();
                  ctx.strokeStyle = f.color;
                  ctx.lineWidth = Math.max(1, f.px * 0.075);
                  ctx.beginPath();
                  ctx.moveTo(x, yBase + off);
                  ctx.lineTo(x + w, yBase + off);
                  ctx.stroke();
                  ctx.restore();
                }
                x += w;
              }
              ctx.font = _txBaseFont; ctx.fillStyle = obj.color || "#666";
            }

            var txTotalH = _rl ? _rlTotalH : (txLines.length * txLineH); // total height of all lines

            // ── Width constraint (for alignment only, NOT wrapping) ──────────
            var txMaxW = (obj.width && parseFloat(obj.width) > 0)
              ? parseFloat(obj.width) * scale : 0;

            // ── Rotation: prefer obj.rotate dataset, override with transform string ──
            // Both are stored in degrees.
            var txRotD = parseFloat(obj.rotate || "0") || 0;
            if (obj.transform) {
              // FIX: regex handles scientific notation (e.g. "rotate(-2.84217e-14deg)")
              // so floating-point drift doesn't parse as "-2.84217" (a real rotation).
              var _txRotM = obj.transform.match(/rotate\(\s*(-?[\d.]+(?:[eE][+-]?\d+)?)/);
              if (_txRotM) txRotD = parseFloat(_txRotM[1]);
            }
            // Clamp near-zero float drift to exactly 0. Values like -2.84e-14 accumulate
            // from repeated rotate-then-unrotate operations and should use the simpler
            // non-rotated rendering path — not the rotated path with a ~0° rotation.
            if (Math.abs(txRotD) < 0.001) txRotD = 0;

            // ── Layout mode detection ─────────────────────────────────────────
            // txCentered: transform contains translate(-50%,-50%) so obj.left/top
            // is the VISUAL CENTRE of the element (not top-left of the box).
            var txCentered = !!(obj.transform && obj.transform.indexOf("translate(-50%") !== -1);

            // ── Natural content width = widest line (canvas coords) ─────────────
            // When obj.width is not set (txMaxW === 0), we still need a reference
            // width so that centre/right alignment works correctly across all lines.
            // Example: "our\nstory" centred → "story" is widest; "our" must be
            // centred WITHIN "story"'s width, not left-aligned at the same x.
            // txEffectiveW is the width used for alignment (explicit or natural).
            var txNaturalW = 0;
            txLines.forEach(function(l, li) {
              var w = _rl ? _txRunLineW(_rl[li]) : ctx.measureText(l).width;
              if (w > txNaturalW) txNaturalW = w;
            });
            // Alignment reference = the element's CONTENT-box width. The browser
            // centres / right-aligns text within content (= box width − horizontal
            // padding). Prefer the REAL measured box (boxWidth) so it matches the
            // builder exactly — including min-width boxes wider than the glyphs;
            // fall back to an explicit width, then to the natural glyph width.
            // .dmb-editable-text { min-width: 120px } - an auto-width caption is
            // never narrower than that on screen, so a box with no stored boxWidth
            // must not collapse to the glyph width here. Spine text clears min-width
            // inline (it takes the txCentered branch), so it is excluded.
            var TX_MINW = 120;
            var _txBoxWpx = (obj.boxWidth && parseFloat(obj.boxWidth) > 0)
              ? parseFloat(obj.boxWidth)
              : (txMaxW > 0 ? txMaxW / scale
                            : (txCentered ? (txNaturalW / scale + TX_PL * 2)
                                          : Math.max(TX_MINW, txNaturalW / scale + TX_PL * 2)));
            var txContentW = Math.max(0, _txBoxWpx - TX_PL * 2) * scale;
            var txEffectiveW = txContentW > 0 ? txContentW : txNaturalW;

            // ── Helper: draw one line with correct alignment + optional underline ──
            // xOrigin: canvas-coord left edge of the content area
            // We always use ctx.textAlign = "left" and compute x manually so that
            // each line is independently centred/right-aligned within txEffectiveW.
            // This matches CSS text-align behaviour for multi-line text.
            function _txDrawLine(line, xOrigin, y, li) {
              var lw = (_rl && li != null) ? _txRunLineW(_rl[li]) : ctx.measureText(line).width;
              var x;
              ctx.textAlign = "left"; // always draw left-to-right; we shift x ourselves
              // Unset alignment defaults to CENTER to match the builder CSS
              // (.dmb-editable-text { text-align:center }). Only an explicit
              // "left" left-aligns.
              var _ta = obj.textAlign || "center";
              if (_ta === "center") {
                // Centre this line within the content width
                x = xOrigin + (txEffectiveW - lw) / 2;
              } else if (_ta === "right") {
                // Right-align this line to the content width's right edge
                x = xOrigin + txEffectiveW - lw;
              } else {
                // Left-align (explicit)
                x = xOrigin;
              }
              // A line of runs is drawn from the same x this function just worked
              // out, so alignment is decided in ONE place for both kinds of box.
              if (_rl && li != null) { _txRunDraw(_rl[li], x, y); return; }
              ctx.fillText(line, x, y);
              // Underline: canvas has no text-decoration — draw a line manually
              if (obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1) {
                // y is the line's em-top (textBaseline:"top"): baseline ≈ +0.88em,
                // browser underline ≈ +0.1em below that → 0.98em (1.05 sat too low).
                ctx.save();
                ctx.strokeStyle = obj.color || "#666";
                ctx.lineWidth   = Math.max(1, txFontSize * 0.075);
                ctx.beginPath();
                ctx.moveTo(x,      y + _txUOff);
                ctx.lineTo(x + lw, y + _txUOff);
                ctx.stroke();
                ctx.restore();
              }
            }

            var _hasGlyph = (obj.glyphCx !== undefined && obj.glyphCx !== null && obj.glyphCx !== "" &&
                            obj.glyphCy !== undefined && obj.glyphCy !== null && obj.glyphCy !== "");
            var _hasVis = (obj.visCx !== undefined && obj.visCx !== null && obj.visCx !== "" &&
                           obj.visCy !== undefined && obj.visCy !== null && obj.visCy !== "");

            if (_hasGlyph && _rl) {
              // ── GLYPH-CENTRE LAYOUT, run by run ─────────────────────────────
              // Same anchor as the branch below (the letters' real ink centre), but
              // the ink box is measured across the runs: its top is the first line's
              // baseline less that line's tallest ascent, its bottom the last line's
              // baseline plus its deepest descent. Centre that on the anchor and
              // every line follows from the baselines already computed above.
              ctx.translate(parseFloat(obj.glyphCx) * scale, parseFloat(obj.glyphCy) * scale);
              if (txRotD) ctx.rotate(txRotD * Math.PI / 180);
              var _rInk = _rl.map(_txRunLineInk);
              var _rW   = _rl.map(_txRunLineW);
              var _rN   = _rl.length;
              var _rShift = ((_txBaseAt(0) - _rInk[0].asc) +
                             (_txBaseAt(_rN - 1) + _rInk[_rN - 1].dsc)) / 2;
              var _rMax = 0;
              _rW.forEach(function (w) { if (w > _rMax) _rMax = w; });
              var _rTa = obj.textAlign || "center";
              for (var _rI = 0; _rI < _rN; _rI++) {
                var _rX = (_rTa === "right") ? (_rMax / 2 - _rW[_rI])
                        : (_rTa === "left")  ? (-_rMax / 2)
                                             : (-_rW[_rI] / 2);
                _txRunDraw(_rl[_rI], _rX, _txBaseAt(_rI) - _rShift);
              }

            } else if (_hasGlyph) {
              // ── GLYPH-CENTRE LAYOUT (most exact) ────────────────────────────
              // Anchor on the letters' real measured INK centre (glyphCx/glyphCy —
              // captured from the live DOM via Range.getBoundingClientRect, which
              // spans ALL lines) and lay the block out from the font's actual ink
              // metrics. This removes every box/padding/line-height/baseline
              // assumption — what the builder shows IS what the PDF draws.
              // Includes txCentered (spine) text: the glyph capture reads the
              // rotation from the CSS transform string, so glyphCx/glyphCy are the
              // true post-rotation letter centre.
              // 2026-07-10: extended from single-line to MULTI-LINE. Multi-line
              // previously used the box-based MEASURED path below, whose
              // "+0.05em half-leading with textBaseline:top" placement only holds
              // for fonts whose ascent+descent ≈ 1em — display fonts (Anton,
              // Burbank…) have bigger vertical metrics, so multi-line titles
              // drifted vertically in the preview/PDF while single lines were exact.
              ctx.translate(parseFloat(obj.glyphCx) * scale, parseFloat(obj.glyphCy) * scale);
              if (txRotD) ctx.rotate(txRotD * Math.PI / 180);
              ctx.textBaseline = "alphabetic";
              // Per-line ink metrics. Baseline-to-baseline spacing IS the CSS
              // line-height (txLineH = 1.1em) — the browser applies that literally,
              // so only the block's END metrics (first ascent / last descent) are
              // needed to centre the ink box on the anchor.
              var _gms = txLines.map(function(l) { return ctx.measureText(l); });
              var _ascOf = function(m) { return (m.actualBoundingBoxAscent  != null) ? m.actualBoundingBoxAscent  : txFontSize * 0.70; };
              var _dscOf = function(m) { return (m.actualBoundingBoxDescent != null) ? m.actualBoundingBoxDescent : txFontSize * 0.20; };
              var _n = txLines.length;
              // Ink box spans firstBaseline−asc0 … firstBaseline+(n−1)·lineH+dscLast.
              // Centre it on the origin → first baseline sits at:
              var _b0 = (_ascOf(_gms[0]) - (_n - 1) * txLineH - _dscOf(_gms[_n - 1])) / 2;
              // Horizontal: centre-aligned lines centre on the anchor. Left/right
              // lines align to the block's widest line — for those alignments the
              // DOM ink box the capture measured is exactly [inkLeft, inkLeft+wMax],
              // so its centre (= the anchor) sits wMax/2 from the shared edge.
              var _wMax = 0; _gms.forEach(function(m) { if (m.width > _wMax) _wMax = m.width; });
              var _ta2 = obj.textAlign || "center";
              txLines.forEach(function(line, li) {
                var _y  = _b0 + li * txLineH;
                var _lw = _gms[li].width;
                var _x;
                ctx.textAlign = "left";
                if (_ta2 === "right")     _x =  _wMax / 2 - _lw;
                else if (_ta2 === "left") _x = -_wMax / 2;
                else                      _x = -_lw / 2;          // center (default)
                ctx.fillText(line, _x, _y);
                if (obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1) {
                  // Underline position from the font's REAL metrics: browsers put it
                  // just below the baseline, proportional to the font's descent —
                  // a fixed 0.12em was visibly off for fonts with unusual metrics.
                  var _fbd = _gms[li].fontBoundingBoxDescent;
                  var _uOff = (_fbd != null && _fbd > 0)
                    ? Math.max(txFontSize * 0.06, Math.min(_fbd * 0.55, txFontSize * 0.2))
                    : txFontSize * 0.11;
                  ctx.save();
                  ctx.strokeStyle = obj.color || "#666";
                  ctx.lineWidth = Math.max(1, txFontSize * 0.075);
                  ctx.beginPath();
                  ctx.moveTo(_x,       _y + _uOff);
                  ctx.lineTo(_x + _lw, _y + _uOff);
                  ctx.stroke();
                  ctx.restore();
                }
              });

            } else if (_hasVis && !txCentered) {
              // ── MEASURED LAYOUT (exact browser geometry) ───────────────────
              // visCx/visCy = the element's TRUE visual centre (axis-aligned
              // bounding-box centre = rotation centre), measured from the live DOM
              // in cover-space px; boxWidth/boxHeight = the real offsetWidth/Height.
              // This reproduces the builder pixel-for-pixel: anchor, size, rotation
              // and alignment all come from what the browser actually rendered, so
              // there is no %→px / pivot / line-box re-derivation to drift.
              var _mbw = (obj.boxWidth  && parseFloat(obj.boxWidth)  > 0) ? parseFloat(obj.boxWidth)  : (txNaturalW / scale + TX_PL * 2);
              var _mbh = (obj.boxHeight && parseFloat(obj.boxHeight) > 0) ? parseFloat(obj.boxHeight) : (txTotalH / scale + TX_PT * 2);
              ctx.translate(parseFloat(obj.visCx) * scale, parseFloat(obj.visCy) * scale);
              if (txRotD) ctx.rotate(txRotD * Math.PI / 180);
              // Box spans [-bw/2,+bw/2] around the centre; content is inset by padding.
              // First line's em-top = box top + top padding + half-leading.
              var _mox = (-_mbw / 2 + TX_PL) * scale;
              var _moy = (-_mbh / 2 + TX_PT) * scale + txFirstBase;
              txLines.forEach(function(line, li) {
                _txDrawLine(line, _mox, _moy - txFirstBase + _txBaseAt(li), li);
              });

            } else if (txCentered) {
              // ── CENTRED LAYOUT ─────────────────────────────────────────────
              // obj.left/top is the VISUAL CENTRE of the element.
              // Translate canvas origin to that centre, apply any rotation, then
              // draw the whole text block centred on origin.
              //
              // Vertical: place line 0 at y = -(txTotalH/2), increment by txLineH.
              // FIX: previous code used txFontSize/2 instead of txTotalH/2,
              //      which misplaced multi-line blocks (all lines shifted down).
              ctx.translate(txLeft * scale, txTop * scale);
              if (txRotD) ctx.rotate(txRotD * Math.PI / 180);

              txLines.forEach(function(line, li) {
                var lw  = _rl ? _txRunLineW(_rl[li]) : ctx.measureText(line).width;
                // y is the BASELINE now: the block's em-top is -txTotalH/2 and the
                // first baseline sits txFirstBase below it.
                var y   = _txBaseAt(li) - txTotalH / 2;
                if (_rl) { _txRunDraw(_rl[li], -lw / 2, y); return; }
                // Horizontal: always centre each line around origin (x = 0)
                ctx.textAlign = "center";
                ctx.fillText(line, 0, y);
                if (obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1) {
                  // Same 1.05 → 0.98 em-top offset correction as _txDrawLine.
                  ctx.save();
                  ctx.strokeStyle = obj.color || "#666";
                  ctx.lineWidth   = Math.max(1, txFontSize * 0.075);
                  ctx.beginPath();
                  ctx.moveTo(-lw / 2, y + _txUOff);
                  ctx.lineTo( lw / 2, y + _txUOff);
                  ctx.stroke();
                  ctx.restore();
                }
              });

            } else {
              // ── NORMAL LAYOUT (obj.left/top is element box top-left) ────────
              //
              // Builder: text content starts at (left + TX_PL, top + TX_PT) in page px.
              // FIX: previous code ignored padding → text appeared 6px left, 2px above
              //      where it should be.
              //
              // Rotation: CSS transform-origin is CENTER of element box, so rotation
              // anchor is (left + boxW/2, top + boxH/2) — NOT the top-left corner.
              // FIX: previous code rotated around (left, top) which caused rotated
              //      text to appear in the wrong position.

              // ── Element box dimensions for the rotation anchor ───────────────
              // CRITICAL for rotated text: the rotation anchor is the element CENTRE
              // (left + boxW/2, top + boxH/2). If boxW is estimated from canvas text
              // measurement it can differ from the browser's CSS rendering by 1–3px;
              // at 90° that error shifts the anchor visibly up/down in the PDF.
              //
              // FIX: prefer obj.boxWidth / obj.boxHeight saved from the real DOM
              // offsetWidth / offsetHeight at design time. Fall back to measurement.
              // Same box the alignment uses - including the CSS min-width floor -
              // so the rotation pivot and the text alignment can never disagree.
              var _txBoxW = _txBoxWpx, _txBoxH;
              if (obj.boxHeight && parseFloat(obj.boxHeight) > 0) {
                _txBoxH = parseFloat(obj.boxHeight);
              } else {
                _txBoxH = txTotalH / scale + TX_PT * 2;
              }

              if (txRotD) {
                // ── Rotated non-centred text ──────────────────────────────────
                // 1. Translate to element centre
                // 2. Rotate (matches CSS transform-origin: center center)
                // 3. Draw text with offset from rotated centre back to content origin
                var _txCx = txLeft + _txBoxW / 2; // centre X in page px
                var _txCy = txTop  + _txBoxH / 2; // centre Y in page px
                ctx.translate(_txCx * scale, _txCy * scale);
                ctx.rotate(txRotD * Math.PI / 180);

                // Content origin relative to (now-rotated) element centre,
                // + half-leading so glyph lands at same pixel as in browser.
                var _rxOrigin = (-_txBoxW / 2 + TX_PL) * scale;
                var _ryOrigin = (-_txBoxH / 2 + TX_PT) * scale + txFirstBase;
                txLines.forEach(function(line, li) {
                  _txDrawLine(line, _rxOrigin, _ryOrigin - txFirstBase + _txBaseAt(li), li);
                });

              } else {
                // ── Non-rotated non-centred text ──────────────────────────────
                // Offset drawing origin by padding + half-leading to reach the
                // exact pixel where the browser places the first glyph.
                var _nxOrigin = (txLeft + TX_PL) * scale;
                var _nyOrigin = (txTop  + TX_PT) * scale + txFirstBase;
                txLines.forEach(function(line, li) {
                  _txDrawLine(line, _nxOrigin, _nyOrigin - txFirstBase + _txBaseAt(li), li);
                });
              }
            }
          }
          ctx.restore();
        } catch(e) { ctx.restore(); }
      }
    }

    // Encode canvas as JPEG and add as a PDF page.
    // Quality 0.96: near-maximum JPEG quality. Each decode→canvas→re-encode cycle
    // loses fidelity; 0.96 minimises that loss while keeping file size reasonable.
    // "NONE" disables jsPDF's own image compression (we handle it via toDataURL).
    async function addCanvasPage(canvas, wMm, hMm) {
      var orient = hMm >= wMm ? "portrait" : "landscape";
      var _i = _pageSeq.length;
      // SHARDING (render mode only): every shard walks - and therefore NUMBERS - every
      // page identically; only the pages in this shard's range are encoded and staged.
      // Skipping an encode cannot change the bytes of the pages that ARE encoded.
      if (_stream && typeof _stream.skip === "function" && _stream.skip(_i)) {
        _pageSeq.push({ index: _i, wMm: wMm, hMm: hMm, orient: orient, skipped: true });
        try { canvas.width = 0; canvas.height = 0; } catch (e) {}
        return;
      }
      // ONE JPEG encode, shared by BOTH paths → guarantees identical page bytes.
      var _jpeg = canvas.toDataURL("image/jpeg", _jpegQuality);   // 0.96 for every book now (big + small)
      _pageSeq.push({ index: _i, wMm: wMm, hMm: hMm, orient: orient });
      if (_stream && _stream.onPage) {
        // PROOF PREVIEW: a second, small encode off the SAME canvas - taken here because
        // two lines down the canvas is freed and this pixel data is gone for good. Same
        // image, scaled: the proof cannot drift from what prints, because there is only
        // ever one render. Wrapped in try/catch and null on failure, so a browser that
        // refuses the extra canvas still stages a perfectly good page. (2026-09-14)
        var _prev = null;
        if (_stream.wantPreview) {
          try {
            var _cw = canvas.width, _ch = canvas.height;
            var _sc = _DMB_PROOF_PREV_DIM / Math.max(_cw || 1, _ch || 1);
            if (_sc < 1) {
              var _pc = document.createElement("canvas");
              _pc.width  = Math.max(1, Math.round(_cw * _sc));
              _pc.height = Math.max(1, Math.round(_ch * _sc));
              var _px = _pc.getContext("2d");
              _px.imageSmoothingEnabled = true;
              try { _px.imageSmoothingQuality = "high"; } catch (e) {}
              _px.drawImage(canvas, 0, 0, _pc.width, _pc.height);
              _prev = _pc.toDataURL("image/jpeg", _DMB_PROOF_PREV_Q);
              try { _pc.width = 0; _pc.height = 0; } catch (e) {}
            }
          } catch (e) { _prev = null; }
        }
        // STREAM: hand the finished page off (upload) and free it now — no jsPDF,
        // so nothing accumulates. Peak memory stays at ~one page.
        try { canvas.width = 0; canvas.height = 0; } catch (e) {}
        await _stream.onPage({ index: _i, wMm: wMm, hMm: hMm, orient: orient, jpeg: _jpeg, preview: _prev });
        return;
      }
      if (_stream && _stream.chunk) {
        // CHUNK: add this page to the current small PDF (a fresh one is started when the
        // previous chunk is finished by _finishChunk / _maybeCloseInteriorChunk).
        if (!_chunkPdf) _chunkPdf = new jsPDF({ unit: "mm", format: [wMm, hMm], orientation: orient, compress: true });
        else _chunkPdf.addPage([wMm, hMm], orient);
        _chunkPdf.addImage(_jpeg, "JPEG", 0, 0, wMm, hMm, undefined, "NONE");
        _chunkPageCount++;
        try { canvas.width = 0; canvas.height = 0; } catch (e) {}
        return;
      }
      // ACCUMULATE (unchanged): embed the SAME jpeg bytes verbatim (DCTDecode).
      if (!pdf) pdf = new jsPDF({ unit: "mm", format: [wMm, hMm], orientation: orient, compress: true });
      else pdf.addPage([wMm, hMm], orient);
      pdf.addImage(_jpeg, "JPEG", 0, 0, wMm, hMm, undefined, "NONE");
      // Parity-test tap (test-only): capture the exact bytes this path embeds.
      if (_stream && _stream.tap) _stream.tap({ index: _i, wMm: wMm, hMm: hMm, orient: orient, jpeg: _jpeg });
    }

    // ── Cover spread ──────────────────────────────────────────────────
    async function renderCoverSpread() {
      var isMag = !!window.DMB_MAGAZINE_MODE;
      var spreadUiW = isMag ? FACE_PX * 2 : (FACE_PX * 2 + SPINE_PX);
      var spreadCvW = Math.round(spreadUiW * FACE_SCALE);
      var spreadCvH = FACE_OUT_H;
      var cc = mkCanvas(spreadCvW, spreadCvH);
      var ctx = cc.ctx;

      // ── Force a fresh live capture in the CURRENT orientation ───────────────
      // The cover text nodes on screen are already laid out in the current
      // orientation; re-measure them now so visCx/visCy/glyphCx/glyphCy/boxWidth
      // are current (not stale portrait geometry after a flip). This makes the
      // live-mirror + glyph paths below reproduce the builder exactly and stops
      // _dmbCoverTopScale from being applied inconsistently. No-ops safely if the
      // cover overlay isn't laid out (offsetWidth 0 → same fallback as before).
      // Belt-and-braces with the guard inside _captureCoverTextBoxes itself.
      if (typeof _dmbCaptureCoverTextBoxesFn === "function" && !(_dmbRenderMode() && !_dmbRenderLiveText())) {
        try { _dmbCaptureCoverTextBoxesFn(); } catch (e) {}
      }

      // Background
      ctx.fillStyle = coverState.color || "#ffffff";
      ctx.fillRect(0, 0, spreadCvW, spreadCvH);

      // ── Build cover object lists early so we can split below/above photos ──
      var _domZc = {};
      document.querySelectorAll("#coverOverlay [style*='z-index'], #coverOverlay [data-z]").forEach(function(el) {
        var z = parseInt(el.style.zIndex || el.dataset.z || "0", 10);
        if (el.id)               _domZc[el.id]               = z;
        if (el.dataset.objectId) _domZc[el.dataset.objectId] = z;
      });
      var _allCoverItems = (editor.coverObjects || []).map(function(o) {
        return Object.assign({}, o, { z: _domZc[o.id] !== undefined ? _domZc[o.id] : (o.z || 0) });
      });
      if (Array.isArray(editor.coverUserTexts)) {
        // Live overlay geometry — used to read each text's REAL on-screen box
        // (the selection box / "4 circles") directly, so the PDF reproduces the
        // builder exactly with no %→px / pivot re-derivation.
        var _ovEl  = document.getElementById("coverOverlay");
        var _ovRect = _ovEl ? _ovEl.getBoundingClientRect() : null;
        var _ovZ = (_ovRect && _ovEl.offsetWidth) ? (_ovRect.width / _ovEl.offsetWidth) || 1 : 1;
        editor.coverUserTexts.forEach(function(entry) {
          var s = coverState.textStyles && coverState.textStyles[entry.id];
          if (!s || !s.text) return;
          var lStr = s.left || "0", tStr = s.top || "0";
          var lPx = lStr.endsWith("%") ? (parseFloat(lStr)/100) * spreadUiW : parseFloat(lStr);
          // top is stored canonical (portrait face); scale to the current face so
          // landscape cover text isn't clipped in the PDF. Portrait scale = 1.
          var tPx = tStr.endsWith("%") ? (parseFloat(tStr)/100) * FACE_H_PX  : (parseFloat(tStr) * _dmbCoverTopScale());
          var wStr = s.width || "";
          var wPx = wStr.endsWith("%") ? (parseFloat(wStr) / 100) * spreadUiW : parseFloat(wStr) || 0;

          // ── Read the LIVE rendered box straight from the DOM ────────────────
          // visCx/visCy = centre of the on-screen (rotated) selection box; boxW/H =
          // the real offsetWidth/Height. This is the user's "place it where the box
          // is" approach and removes the rotation-pivot drift entirely.
          var _vcx = s.visCx, _vcy = s.visCy, _bw = s.boxWidth, _bh = s.boxHeight;
          var _node = document.getElementById(entry.id);
          var _usedLive = false;
          // Glyph centre comes from the robust capture (un-rotate + Range + re-rotate),
          // stored in s.glyphCx/glyphCy. That is the letters' true centre.
          var _gcx = s.glyphCx || "", _gcy = s.glyphCy || "";
          if (!(_dmbRenderMode() && !_dmbRenderLiveText()) && _node && _ovRect && _ovEl.contains(_node) && _node.offsetWidth > 0) {
            var _nr = _node.getBoundingClientRect();
            _vcx = String(((_nr.left + _nr.width  / 2) - _ovRect.left) / _ovZ);
            _vcy = String(((_nr.top  + _nr.height / 2) - _ovRect.top)  / _ovZ);
            _bw  = String(_node.offsetWidth);
            _bh  = String(_node.offsetHeight);
            _usedLive = true;
          }
          // The on-screen cover text is shrunk in landscape via a CSS transform
          // (display only), so its stored font/box are still portrait-size. Scale
          // them here by the same factor so the preview/PDF matches the builder.
          // Portrait scale = 1 → unchanged.
          _allCoverItems.push({ type:"text", text:s.text, left:String(lPx), top:String(tPx),
            fontSize:s.fontSize||"28px", fontWeight:s.fontWeight||"800",
            color:s.color||"#666", fontFamily:s.fontFamily||"'Londrina Solid',sans-serif",
            textAlign:s.textAlign||"", textDecoration:s.textDecoration||"",
            whiteSpace:s.whiteSpace||"",
            renderedLines:s.renderedLines||"",
            rich:s.rich||"", richLines:s.richLines||"",
            transform:s.transform||"", rotate:s.rotate||"0",
            width: wPx > 0 ? String(wPx) : "",
            boxWidth:  _bw || "",
            boxHeight: _bh || "",
            visCx: _vcx != null ? _vcx : "",
            visCy: _vcy != null ? _vcy : "",
            glyphCx: _gcx, glyphCy: _gcy,
            z: _domZc[entry.id] !== undefined ? _domZc[entry.id] : Number(s.z || 0)
          });
        });
      }
      // The cover overlay sits above every photo in the DOM, so cover items are
      // never behind them - unlike interior pages, there is no below/above split.
      var _belowCover = [];
      var _aboveCover = _allCoverItems;

      // Draw objects that are BEHIND photos first
      try { if (_belowCover.length) await drawFreeObjs(ctx, _belowCover, FACE_SCALE); } catch(e) {}

      // Front cover background image (from coverImageInput upload)
      if (coverState.imageUrl) {
        try {
          var frontX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
          drawFit(ctx, await loadImg(coverState.imageUrl), frontX, 0, FACE_PX * FACE_SCALE, spreadCvH);
        } catch(e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", "cover-front-bg"); }
      }

      // Front cover dragged photo (drag-and-drop from photo grid onto front face)
      if (coverState.frontImageUrl || (_dmbPrintMasterOn() && coverState.frontImageId)) {
        try {
          var frontFaceX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
          // frontImageRot is applied on screen (the cover photo's rotate button) and
          // must reach the PDF too - only the BLEED photo's rotation used to.
          drawFit(ctx, await _dmbCoverImg(coverState.frontImageUrl, coverState.frontImageId), frontFaceX, 0, FACE_PX * FACE_SCALE, spreadCvH,
            0, 0, 1, coverState.frontImageRot || 0);
        } catch(e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", "cover-front"); }
      }

      // Back cover dragged photo (drag-and-drop from photo grid onto back face)
      if (coverState.backImageUrl || (_dmbPrintMasterOn() && coverState.backImageId)) {
        try {
          drawFit(ctx, await _dmbCoverImg(coverState.backImageUrl, coverState.backImageId), 0, 0, FACE_PX * FACE_SCALE, spreadCvH,
            0, 0, 1, coverState.backImageRot || 0);
        } catch(e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", "cover-back"); }
      }

      // Spine photo. It renders on screen inside the spine strip (a div with
      // background:url(...) center/cover) but was NEVER drawn into the PDF, so a
      // cover carrying one printed a blank spine. Only legacy designs and published
      // templates can hold it - no current UI sets it - and a multi-zone bleed
      // clears it, so this can never fight the bleed draw below. Magazines have no
      // spine. No spineImageId exists, so this resolves by URL like the front
      // background upload does.
      if (!isMag && coverState.spineImageUrl) {
        try {
          drawFit(ctx, await loadImg(coverState.spineImageUrl),
            FACE_PX * FACE_SCALE, 0, SPINE_PX * FACE_SCALE, spreadCvH);
        } catch(e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", "cover-spine"); }
      }

      // Seamless bleed photo spanning multiple cover zones
      if ((coverState.bleedImageUrl || (_dmbPrintMasterOn() && coverState.bleedImageId)) && coverState.bleedZone) {
        try {
          var _bleedZones = {
            "spine-back":  { dx: 0,                              dw: (FACE_PX + SPINE_PX) * FACE_SCALE },
            "full":        { dx: 0,                              dw: spreadCvW },
            "front-spine": { dx: FACE_PX * FACE_SCALE,           dw: (SPINE_PX + FACE_PX) * FACE_SCALE }
          };
          var _bpz = _bleedZones[coverState.bleedZone];
          if (_bpz) {
            drawFit(ctx, await _dmbCoverImg(coverState.bleedImageUrl, coverState.bleedImageId),
              _bpz.dx, 0, _bpz.dw, spreadCvH,
              0, 0, 1, coverState.bleedImageRot || 0);
          }
        } catch(e) { if (_dmbRenderMode()) _dmbRenderNote("photo_missing", "cover-wrap"); }
      }

      // Draw photo grid layout frames on front cover
      if (coverState.frontLayout) {
        var frontLayoutDefs = TEMPLATE_DEFS[coverState.frontLayout] || [];
        var frontFaceX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
        for (var cfi = 0; cfi < frontLayoutDefs.length; cfi++) {
          var cff = frontLayoutDefs[cfi];
          var cfpid = coverState.frontFrames && coverState.frontFrames[cff.key];
          if (!cfpid) continue;
          try {
            var cfph = getPhotoById(cfpid);
            if (!cfph) continue;
            var cfrot = (coverState.frontFrameRot && coverState.frontFrameRot[cff.key]) || 0;
            drawRotFit(ctx, await _dmbRenderImg(cfph),
              frontFaceX + (cff.x / 100) * FACE_PX * FACE_SCALE,
              (cff.y / 100) * FACE_OUT_H,
              (cff.w / 100) * FACE_PX * FACE_SCALE,
              (cff.h / 100) * FACE_OUT_H, cfrot);
          } catch(e) {}
        }
      }

      // Draw photo grid layout frames on back cover
      if (coverState.backLayout) {
        var backLayoutDefs = TEMPLATE_DEFS[coverState.backLayout] || [];
        for (var cbi = 0; cbi < backLayoutDefs.length; cbi++) {
          var cbf = backLayoutDefs[cbi];
          var cbpid = coverState.backFrames && coverState.backFrames[cbf.key];
          if (!cbpid) continue;
          try {
            var cbph = getPhotoById(cbpid);
            if (!cbph) continue;
            var cbrot = (coverState.backFrameRot && coverState.backFrameRot[cbf.key]) || 0;
            drawRotFit(ctx, await _dmbRenderImg(cbph),
              (cbf.x / 100) * FACE_PX * FACE_SCALE,
              (cbf.y / 100) * FACE_OUT_H,
              (cbf.w / 100) * FACE_PX * FACE_SCALE,
              (cbf.h / 100) * FACE_OUT_H, cbrot);
          } catch(e) {}
        }
      }

      // Draw objects that are IN FRONT of photos (z >= 1)
      try { await drawFreeObjs(ctx, _aboveCover, FACE_SCALE); } catch(e) {}

      // Logo watermark on back cover — drawn last so it is always above all objects
      if (window.DMB_LOGO_URL) {
        try {
          var logoImg = await loadImg(window.DMB_LOGO_URL);
          var logoW = 90 * FACE_SCALE;
          var logoH = logoW * (logoImg.naturalHeight / (logoImg.naturalWidth || 1));
          // Mirror the DOM exactly: left = faceW - round(faceW*0.06) - 90, bottom = 6%.
          var logoX = (FACE_PX - Math.round(FACE_PX * 0.06) - 90) * FACE_SCALE;
          var logoY = FACE_OUT_H - FACE_H_PX * 0.06 * FACE_SCALE - logoH;
          ctx.save(); ctx.globalAlpha = 0.85;
          ctx.drawImage(logoImg, logoX, logoY, logoW, logoH);
          ctx.restore();
        } catch(e) {}
      }

      return cc.canvas;
    }

    // Crop a zone from the cover spread canvas
    function cropCoverZone(spreadCanvas, zone) {
      var isMag = !!window.DMB_MAGAZINE_MODE;
      var bw = Math.round(FACE_PX * FACE_SCALE);
      var sw = Math.round(SPINE_PX * FACE_SCALE);
      var h  = spreadCanvas.height;
      var sx, cw;
      if (zone === "back")        { sx = 0;             cw = bw; }
      else if (zone === "spine")  { sx = bw;            cw = sw; }
      else /* front */            { sx = isMag ? bw : bw + sw; cw = bw; }
      var cc = mkCanvas(cw, h);
      cc.ctx.drawImage(spreadCanvas, sx, 0, cw, h, 0, 0, cw, h);
      return cc.canvas;
    }

    // ── Page rendering ──────────────────────────────────────────────────────
    async function renderPage(pageNumber, side) {
      var cc  = mkCanvas(OUT_W, OUT_H);
      var ctx = cc.ctx;

      // ── Per-page background colour ────────────────────────────────────────
      // mkCanvas fills with white by default. If the customer chose a custom
      // background colour for this page, fill the canvas with it now so it
      // shows under photos and all objects.
      var _bgColor = editor.pageBackgrounds?.[pageNumber];
      if (_bgColor && _bgColor.toLowerCase() !== "#ffffff") {
        ctx.fillStyle = _bgColor;
        ctx.fillRect(0, 0, OUT_W, OUT_H);
      }

      // Helper: get free objects for this page (try both numeric and string key)
      function getPageFreeObjs(pn) {
        if (!editor.pageObjects) return [];
        var objs = editor.pageObjects[pn] || editor.pageObjects[String(pn)] || [];
        return Array.isArray(objs) ? objs : [];
      }

      // Objects filed under this page's spread PARTNER that reach across the fold
      // onto this page. The builder shows them (one continuous spread, pages are
      // overflow:visible); each PDF page is a separate canvas, so without this the
      // overhanging half is simply cut off at the sheet edge.
      function getSpreadOverflowObjs(pn) {
        if (!pn || pn < 1) return [];                  // page 0 has no partner
        var isLeftPg = (pn % 2 === 1);                 // spreads are (2k+1, 2k+2)
        var sib = isLeftPg ? pn + 1 : pn - 1;
        if (sib < 1 || sib > (editor.totalPages || 0)) return [];
        var dxPg = isLeftPg ? PAGE_W_PX : -PAGE_W_PX;  // partner space -> this page
        var out = [];
        getPageFreeObjs(sib).forEach(function (o) {
          if (!o) return;
          var ox = (o.x || 0) + dxPg;
          var ow2 = o.w || 0;
          // Cull on the ROTATED footprint. drawFreeObjs rotates about the object centre,
          // so a rotated object occupies its rotated bounding box - wider than x..x+w for
          // anything not axis-aligned. Testing the unrotated box discarded objects that
          // genuinely reach this sheet, and the customer got one half of a tilted shape
          // with the other half missing and no error anywhere. (2026-09-14)
          var _rot  = (o.rotation || 0) * Math.PI / 180;
          var _cx   = ox + ow2 / 2;
          var _half = _rot
            ? (Math.abs(ow2 * Math.cos(_rot)) + Math.abs((o.h || 0) * Math.sin(_rot))) / 2
            : ow2 / 2;
          if (_cx + _half <= 0 || _cx - _half >= PAGE_W_PX) return;   // does not reach this page
          var c = Object.assign({}, o, { x: ox });
          // A line's box is derived from its endpoints, so shift those too.
          if (c.type === "shape" && c.shapeType === "line") {
            if (c.x1 != null) c.x1 = c.x1 + dxPg;
            if (c.x2 != null) c.x2 = c.x2 + dxPg;
            if (c.bx != null) c.bx = c.bx + dxPg;
          }
          out.push(c);
        });
        return out;
      }

      // Page 0 (the special inner-cover page) uses the same full rendering path
      // as every other page — it handles templates, slot photos with rotation,
      // spread photos, template frames, and the z-order split (below/above photos).
      // The old simplified page-0 handler was missing all of those features,
      // which caused slot photos to not appear when rotation was applied, and
      // template-frame photos to never appear in the PDF.

      if (isLockedPage(pageNumber)) {
        // The locked page still FACES page 2, so it still receives that page's overhang.
        // This early return used to skip the overflow collection entirely (it happens
        // further down), so an object hanging off page 2 across the fold printed on every
        // page except the one it actually reached. drawFreeObjs sorts by z itself, so
        // concatenating is enough to keep the stacking order correct. (2026-09-14)
        try {
          await drawFreeObjs(ctx,
            getPageFreeObjs(pageNumber).concat(getSpreadOverflowObjs(pageNumber)),
            PAGE_SCALE);
        } catch(e) {}
        return cc.canvas;
      }

      var si         = Math.floor((pageNumber - 1) / 2);
      var isLeft     = (side === "L");
      var sp         = editor.spreadPhoto && editor.spreadPhoto[si];
      var templateId = getPageTemplateId(pageNumber);
      var _spreadRendered = false;

      // ── Spread photo ──
      if (sp && sp.photoId) {
        try {
          var sph = getPhotoById(sp.photoId);
          if (sph) {
            var sImg  = await _dmbRenderImg(sph);
            var spW   = OUT_W * 2;
            var spH   = OUT_H;
            var offX  = isLeft ? 0 : -OUT_W;
            var spIA  = sImg.naturalWidth / sImg.naturalHeight;
            var spFA  = spW / spH;
            var spSW, spSH;
            if (spIA > spFA) { spSH = spH; spSW = spSH * spIA; } else { spSW = spW; spSH = spSW / spIA; }
            var sPanX   = (sp.panX || 0) * PAGE_SCALE;
            var sPanY   = (sp.panY || 0) * PAGE_SCALE;
            var sZoom   = sp.zoom || 1;
            var sRotDeg = sp.rotation || 0;
            ctx.save();
            ctx.beginPath(); ctx.rect(0, 0, OUT_W, OUT_H); ctx.clip();
            ctx.translate(spW / 2 + offX + sPanX, spH / 2 + sPanY);
            if (sRotDeg) ctx.rotate(sRotDeg * Math.PI / 180);
            ctx.scale(sZoom, sZoom);
            ctx.drawImage(sImg, -spSW / 2, -spSH / 2, spSW, spSH);
            ctx.restore();
            _spreadRendered = true;
          }
        } catch(e) {}
      }

      // ── Z-ORDER FIX: split free objects around the photo layer ─────────
      // Photos (makePlacedImageBox) use z-index 1 in the builder.
      // "Send backward" (⬇ Back button) sets obj.z = 0, so those objects must
      // be drawn on canvas BEFORE photos to appear behind them in the PDF.
      // Objects with z≥1 (default and "bring forward") are drawn AFTER photos.
      // DO NOT merge _belowObjs and _aboveObjs into a single drawFreeObjs call.
      var _freeObjsAll = getPageFreeObjs(pageNumber).concat(getSpreadOverflowObjs(pageNumber));
      var _belowObjs   = _freeObjsAll.filter(function(o){ return (o.z || 0) < 1; }); // behind photos
      var _aboveObjs   = _freeObjsAll.filter(function(o){ return (o.z || 0) >= 1; }); // above photos
      try { if (_belowObjs.length) await drawFreeObjs(ctx, _belowObjs, PAGE_SCALE); } catch(e) {}

      // ── Template layout ──
      if (templateId) {
        var defs  = TEMPLATE_DEFS[templateId] || [];
        var slotA = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].A;
        var slotB = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].B;
        if (slotA) {
          ctx.save();
          try {
            var phA = getPhotoById(slotA);
            if (phA) {
              var _tAh = slotB ? OUT_H / 2 : OUT_H;
              var _tAShape = getSlotFrameShape(pageNumber, "A");
              if (_tAShape) applyCanvasFrameClip(ctx, _tAShape, OUT_W, _tAh, PAGE_SCALE);
              drawRotFit(ctx, await _dmbRenderImg(phA), 0, 0, OUT_W, _tAh,
                (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].A) || 0);
            }
          } catch(e) {} finally { ctx.restore(); }
        }
        if (slotB) {
          ctx.save();
          try {
            var phB = getPhotoById(slotB);
            if (phB) {
              var _tBShape = getSlotFrameShape(pageNumber, "B");
              ctx.translate(0, OUT_H / 2);
              if (_tBShape) applyCanvasFrameClip(ctx, _tBShape, OUT_W, OUT_H / 2, PAGE_SCALE);
              drawRotFit(ctx, await _dmbRenderImg(phB), 0, 0, OUT_W, OUT_H / 2,
                (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].B) || 0);
            }
          } catch(e) {} finally { ctx.restore(); }
        }
        for (var di = 0; di < defs.length; di++) {
          var f    = defs[di];
          var fpid = editor.pageFrames && editor.pageFrames[pageNumber] && editor.pageFrames[pageNumber][f.key];
          if (!fpid) continue;
          try {
            var fph  = getPhotoById(fpid);
            if (!fph) continue;
            var frot = (editor.pageFrameRot && editor.pageFrameRot[pageNumber] && editor.pageFrameRot[pageNumber][f.key]) || 0;
            var _fp = _dmbLayoutFramePct(f);   // keep the frame's exact portrait shape (letterbox in landscape)
            var _fx = (_fp.x / 100) * OUT_W, _fy = (_fp.y / 100) * OUT_H;
            var _fw = (_fp.w / 100) * OUT_W, _fh = (_fp.h / 100) * OUT_H;
            var _fShape = (editor.pageFrameShapes && editor.pageFrameShapes[pageNumber] && editor.pageFrameShapes[pageNumber][f.key]) || "";
            ctx.save();
            try {
              if (_fShape) { ctx.translate(_fx, _fy); applyCanvasFrameClip(ctx, _fShape, _fw, _fh, PAGE_SCALE); ctx.translate(-_fx, -_fy); }
              drawRotFit(ctx, await _dmbRenderImg(fph), _fx, _fy, _fw, _fh, frot);
            } finally { ctx.restore(); }
          } catch(e) {}
        }
      } else if (!_spreadRendered) {
        // ── Default A/B slot layout (direct drag-and-drop; no template/frames) ──
        // Each slot photo can carry a SHAPE MASK (the ⭐ "Frame shape" button →
        // circle/heart/star/…), stored in editor.pageFrameShapes[page][slot]. The
        // builder clips the <img> to it (applyDmbFrameShape); the PDF/preview must
        // clip the canvas to the same shape or the mask is lost (rendered as a full
        // rectangle). Clip inside a save()/restore() so it only affects this slot.
        var A = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].A;
        var B = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].B;
        if (A) {
          ctx.save();
          try {
            var pA = getPhotoById(A);
            if (pA) {
              var _aw = dmbIsLandscape() ? (B ? OUT_W / 2 : OUT_W) : OUT_W;
              var _ah = dmbIsLandscape() ? OUT_H : (B ? OUT_H / 2 : OUT_H);
              var _aShape = getSlotFrameShape(pageNumber, "A");
              if (_aShape) applyCanvasFrameClip(ctx, _aShape, _aw, _ah, PAGE_SCALE);
              drawRotFit(ctx, await _dmbRenderImg(pA), 0, 0, _aw, _ah,
                (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].A) || 0);
            }
          } catch(e) {} finally { ctx.restore(); }
        }
        if (B) {
          ctx.save();
          try {
            var pB = getPhotoById(B);
            if (pB) {
              var _bx = dmbIsLandscape() ? OUT_W / 2 : 0;
              var _by = dmbIsLandscape() ? 0 : OUT_H / 2;
              var _bw = dmbIsLandscape() ? OUT_W / 2 : OUT_W;
              var _bh = dmbIsLandscape() ? OUT_H : OUT_H / 2;
              var _bShape = getSlotFrameShape(pageNumber, "B");
              ctx.translate(_bx, _by);
              if (_bShape) applyCanvasFrameClip(ctx, _bShape, _bw, _bh, PAGE_SCALE);
              drawRotFit(ctx, await _dmbRenderImg(pB), 0, 0, _bw, _bh,
                (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].B) || 0);
            }
          } catch(e) {} finally { ctx.restore(); }
        }
      }

      // ── Objects "above photos" (z >= 1) drawn AFTER photos ──
      try { if (_aboveObjs.length) await drawFreeObjs(ctx, _aboveObjs, PAGE_SCALE); } catch(e) {}
      return cc.canvas;
    }

    // ── Preview mode: render one canvas and return early ─────────────────────
    // When _pvOpt is set we skip jsPDF entirely, render only the requested
    // page/cover, and hand the canvas(es) back via _pvOpt.resolve().
    if (_pvOpt) {
      try {
        if (_pvOpt.cover) {
          var _pvSpread = await renderCoverSpread();
          _pvOpt.resolve({
            back:  cropCoverZone(_pvSpread, "back"),
            spine: cropCoverZone(_pvSpread, "spine"),
            front: cropCoverZone(_pvSpread, "front"),
          });
        } else {
          var _pvPn   = _pvOpt.page;
          var _pvSide = (_pvPn === 0) ? "L" : (_pvPn % 2 === 0 ? "R" : "L");
          _pvOpt.resolve(await renderPage(_pvPn, _pvSide));
        }
      } catch(_pvErr) {
        if (typeof _pvOpt.reject === "function") _pvOpt.reject(_pvErr);
      }
      return;
    }

    // ── Build PDF ────────────────────────────────────────────────────────────
    // Total steps: book = front+spine+back (3); magazine = front+blank+blank+back (4),
    // plus page 0 + all interior pages.
    var _coverSteps = window.DMB_MAGAZINE_MODE ? 4 : 3;
    var _totalSteps = _coverSteps + 1 + (editor.totalPages || 0);
    var _doneSteps  = 0;
    function _onPageDone() {
      _doneSteps++;
      if (typeof onProgress === "function") onProgress(_doneSteps, _totalSteps);
    }

    // ── INCREMENTAL RENDER (render mode only) ─────────────────────────────
    // _stream.skipRender(i) says "the Worker already holds page i for this exact
    // content - do not render it". The page still CONSUMES its index (a placeholder
    // entry in _pageSeq) so every other page keeps the same number as a full run.
    // The cover spread is only rendered if at least one cover face needs it.
    function _reusedAt(i) {
      return !!(_stream && typeof _stream.skipRender === "function" && _stream.skipRender(i));
    }
    function _pushReused(wMm, hMm) {
      var _i = _pageSeq.length;
      _pageSeq.push({ index: _i, wMm: wMm, hMm: hMm, orient: hMm >= wMm ? "portrait" : "landscape", skipped: true, reused: true });
    }
    var coverSpread = null;
    async function _cover() {
      if (!coverSpread) coverSpread = await renderCoverSpread();
      return coverSpread;
    }
    async function _addCoverFace(zone, wMm, hMm) {
      if (_reusedAt(_pageSeq.length)) { _pushReused(wMm, hMm); return; }
      await addCanvasPage(cropCoverZone(await _cover(), zone), wMm, hMm);
    }

    // A blank white page at the given mm size — used only for magazines (the inside
    // faces of the front & back covers).
    async function _addBlankPage(wMm, hMm) {
      if (_reusedAt(_pageSeq.length)) { _pushReused(wMm, hMm); return; }
      var _bc = document.createElement("canvas");
      _bc.width  = Math.max(1, Math.round(wMm * MM2PX));
      _bc.height = Math.max(1, Math.round(hMm * MM2PX));
      var _bctx = _bc.getContext("2d");
      if (_bctx) { _bctx.fillStyle = "#ffffff"; _bctx.fillRect(0, 0, _bc.width, _bc.height); }
      await addCanvasPage(_bc, wMm, hMm);
    }

    // Cover pages use the fixed PORTRAIT cover dims (see note in Sizing constants).
    if (window.DMB_MAGAZINE_MODE) {
      // Magazine order: FRONT COVER · blank · [interior pages] · blank · BACK COVER.
      // The two blanks are the inside faces of the covers (magazine cover = page size,
      // 210×297). The back cover is emitted AFTER the pages (below), so the covers are
      // NOT contiguous — hence no "cover" chunk split here.
      await _addCoverFace("front", COVER_W_MM, COVER_H_MM); _onPageDone();
      await _addBlankPage(COVER_W_MM, COVER_H_MM); _onPageDone();   // inside front cover
    } else {
      await _addCoverFace("front", COVER_W_MM, COVER_H_MM); _onPageDone();
      await _addCoverFace("spine", SPINE_W_MM, COVER_H_MM); _onPageDone();
      await _addCoverFace("back",  COVER_W_MM, COVER_H_MM); _onPageDone();
      if (_stream && _stream.chunk) _finishChunk("cover");
    }   // cover front+spine+back → "cover" PDF

    // One transient retry per page (a photo blob momentarily unavailable during a long
    // render). Kept to a SINGLE extra attempt so a big book's render is not multiplied.
    async function _renderPageOnce(pnum, side) {
      try { return await renderPage(pnum, side); }
      catch (err) {
        await new Promise(function (r) { setTimeout(r, 300); });
        return await renderPage(pnum, side);   // one retry, then let it throw normally
      }
    }

    // Page 0 (special page before page 1)
    if (_reusedAt(_pageSeq.length)) { _pushReused(A4_W_MM, A4_H_MM); _onPageDone(); }
    else { await addCanvasPage(await _renderPageOnce(0, "L"), A4_W_MM, A4_H_MM); _onPageDone(); }
    _maybeCloseInteriorChunk();

    for (var p = 1; p <= (editor.totalPages || 0); p++) {
      // Empty sheets the customer chose to drop are skipped (both pages of the
      // sheet are in _excludePages). The remaining pages render unchanged.
      if (_excludePages && _excludePages.has(p)) { _onPageDone(); continue; }
      // Unchanged since the last proof (Worker holds its image) -> placeholder only.
      if (_reusedAt(_pageSeq.length)) { _pushReused(A4_W_MM, A4_H_MM); _onPageDone(); continue; }
      await addCanvasPage(await _renderPageOnce(p, p % 2 === 0 ? "R" : "L"), A4_W_MM, A4_H_MM);
      _onPageDone();
      _maybeCloseInteriorChunk();
    }

    // Magazine: after the interior pages, a blank (inside back cover) then the BACK COVER.
    if (window.DMB_MAGAZINE_MODE) {
      await _addBlankPage(COVER_W_MM, COVER_H_MM); _onPageDone();   // inside back cover
      await _addCoverFace("back", COVER_W_MM, COVER_H_MM); _onPageDone();
    }

    if (_stream && _stream.chunk) {
      if (_chunkPdf) { _chunkNo++; _finishChunk(String(_chunkNo)); }   // trailing partial chunk
      return { chunked: true, chunks: _chunkOut };
    }
    if (_stream && _stream.onPage) {
      // Streaming: pages already handed off + freed. Return the manifest the stapler
      // assembles from (order + per-page dimensions); no blob is built in the tab.
      return { streamed: true, count: _pageSeq.length, pages: _pageSeq };
    }
    if (!pdf) throw new Error("No pages were rendered — check that pages are selected.");
    return pdf.output("blob");
  }

  // ─── End PDF generation ────────────────────────────────────────────────

  // ── Phase 1: streaming export + parity self-test (NOT wired into checkout) ──
  // Nothing below runs during a normal Add to Cart — the live purchase path still
  // uses the in-memory export above. These are entry points for testing the
  // streaming render in the real builder console before any server "stapler" or
  // checkout wiring exists.

  // Render page-by-page, handing each finished page to onPage(pg) and freeing it
  // right away (peak memory ≈ one page). Resolves to a manifest {streamed, count,
  // pages:[{index,wMm,hMm,orient}]}. pg = {index, wMm, hMm, orient, jpeg(dataURL)}.
  // The server stapler (later) turns the handed-off JPEGs into the final PDF.
  window.__dmbBuildPdfStreaming = function (onPage, onProgress, excludePages, opts) {
    // `opts` is additive and optional, so every existing caller behaves identically.
    return buildPdfBlobOnePagePerBookPage(onProgress || null, null, excludePages || null,
      Object.assign({ onPage: onPage }, opts || {}));
  };

  // Admin split-download: render the SAME book into separate small PDFs — one "cover" PDF
  // (front+spine+back) and one PDF per `pagesPerChunk` book pages ("1","2","3"…). Returns
  // { chunked:true, chunks:[{name, blob}] }. Used by the password-gated admin ZIP button.
  window.__dmbBuildPdfChunks = function (pagesPerChunk, onProgress) {
    return buildPdfBlobOnePagePerBookPage(onProgress || null, null, null, { chunk: Math.max(1, pagesPerChunk || 10) });
  };

  // Parity proof — render the CURRENT design BOTH ways and confirm every page's
  // JPEG is byte-identical. Run in the builder console:
  //   await __dmbVerifyStreamParity()
  // Expect { byteIdentical: true, mismatchedPageIndexes: [] }.
  window.__dmbVerifyStreamParity = async function (opts) {
    opts = opts || {};
    var exclude = opts.exclude || null;
    // Accumulate path (today's real export) with a tap capturing each page's bytes.
    var accum = [];
    var accBlob = await buildPdfBlobOnePagePerBookPage(null, null, exclude, { tap: function (pg) { accum.push(pg.jpeg); } });
    // Streaming path — capture each page's bytes as they're handed off.
    var strm = [];
    await buildPdfBlobOnePagePerBookPage(null, null, exclude, { onPage: function (pg) { strm.push(pg.jpeg); } });
    var n = Math.max(accum.length, strm.length), diffs = [];
    for (var i = 0; i < n; i++) { if (accum[i] !== strm[i]) diffs.push(i); }
    var report = {
      accumulatePages: accum.length,
      streamPages: strm.length,
      identicalPages: n - diffs.length,
      mismatchedPageIndexes: diffs,
      byteIdentical: diffs.length === 0 && accum.length === strm.length && accum.length > 0,
      accumulateBlobBytes: accBlob ? accBlob.size : null
    };
    try { console.log("[DMB stream parity]", JSON.stringify(report)); } catch (e) {}
    return report;
  };

  // First-time callout that points at "Add to Cart", shown ONCE right after the
  // tour. Explains that adding to cart keeps the book safe (and locks it).
  function _dmbShowAddCartHint() {
    try { if (localStorage.getItem("dmb_addcart_hint_done")) return; } catch (e) {}
    if (document.getElementById("dmbAddCartHint")) return;
    const btn = document.getElementById("addToCartBtn");
    if (!btn) return;
    const r0 = btn.getBoundingClientRect();
    if (!(r0.width > 0 && r0.height > 0)) return;   // button not visible yet

    const wrap = document.createElement("div");
    wrap.id = "dmbAddCartHint";
    wrap.style.cssText = "position:fixed;z-index:1000004;width:272px;max-width:86vw;background:#1e1e1e;color:#fff;border-radius:14px;padding:16px 18px;box-shadow:0 16px 50px rgba(0,0,0,.42);font-family:inherit;";
    wrap.innerHTML =
      '<button type="button" id="dmbAddCartHintX" aria-label="Close" style="position:absolute;top:7px;right:10px;border:none;background:transparent;color:#bcbcbc;font-size:22px;line-height:1;cursor:pointer;padding:2px 4px;">&times;</button>' +
      '<div style="font-weight:900;font-size:15px;margin:0 16px 6px 0;">When you’re done</div>' +
      '<div style="font-size:13px;line-height:1.55;color:#e9e9e9;">Add your book to the cart to keep it safe — then order whenever you like. Just note: once it’s in the cart, the design is final and can’t be edited.</div>' +
      '<div id="dmbAddCartHintArrow" style="position:absolute;width:16px;height:16px;background:#1e1e1e;transform:rotate(45deg);"></div>';
    document.body.appendChild(wrap);

    function place() {
      const b = btn.getBoundingClientRect();
      const w = wrap.getBoundingClientRect();
      const gap = 14;
      let above = true;
      let top = b.top - w.height - gap;
      if (top < 8) { above = false; top = b.bottom + gap; }
      top = Math.max(8, Math.min(top, window.innerHeight - w.height - 8));
      let left = b.left + b.width / 2 - w.width / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - w.width - 8));
      wrap.style.top = top + "px";
      wrap.style.left = left + "px";
      const arrow = document.getElementById("dmbAddCartHintArrow");
      if (arrow) {
        const ax = b.left + b.width / 2 - left - 8;
        arrow.style.left = Math.max(14, Math.min(ax, w.width - 30)) + "px";
        if (above) { arrow.style.bottom = "-7px"; arrow.style.top = ""; }
        else       { arrow.style.top = "-7px"; arrow.style.bottom = ""; }
      }
    }
    place();
    const _rp = function () { place(); };
    window.addEventListener("resize", _rp);
    window.addEventListener("scroll", _rp, { passive: true });

    wrap.querySelector("#dmbAddCartHintX").addEventListener("click", function () {
      try { localStorage.setItem("dmb_addcart_hint_done", "1"); } catch (e) {}
      window.removeEventListener("resize", _rp);
      window.removeEventListener("scroll", _rp);
      wrap.remove();
    });
  }
  document.addEventListener("dmb:tourEnded", function () {
    setTimeout(function () { try { _dmbShowAddCartHint(); } catch (e) {} }, 400);
  });

  // Every photo id the design references — interior template slots, spread photos,
  // template frames, free photo-frames, and the cover. Used to make sure none are
  // missing before an order is placed (a missing photo => a blank printed page).
  function _dmbReferencedPhotoIds() {
    const ids = new Set();
    const add = (v) => { if (v) ids.add(v); };
    const ps = editor.pageSlots || {};
    for (const k in ps) { if (ps[k]) { add(ps[k].A); add(ps[k].B); } }
    const sp = editor.spreadPhoto || {};
    for (const k in sp) { if (sp[k]) add(sp[k].photoId); }
    const pf = editor.pageFrames || {};
    for (const k in pf) { const m = pf[k] || {}; for (const s in m) add(m[s]); }
    const po = editor.pageObjects || {};
    for (const k in po) { (po[k] || []).forEach((o) => { if (o && o.type === "photo-frame") add(o.photoId); }); }
    (editor.coverObjects || []).forEach((o) => { if (o) add(o.photoId); });
    ["frontFrames", "backFrames"].forEach((f) => { const m = (coverState && coverState[f]) || {}; for (const s in m) add(m[s]); });
    // The cover's OWN photos: the front/back face images and the wrap-around
    // background. They were missing from this list, so the hard add-to-cart guard
    // ("never let a book with MISSING photos be ordered") never looked at the
    // cover at all - a cover photo the device had dropped went straight through
    // and printed as a blank face.
    // The guard's existing rule is unchanged and is what makes this safe: a photo
    // that is IN the library but whose image is dead counts as broken, while an id
    // that is not in the library at all is treated as a stale reference and
    // skipped. So a cover that simply has no photo can never be blocked.
    ["frontImageId", "backImageId", "bleedImageId"].forEach((k) => add(coverState && coverState[k]));
    return Array.from(ids);
  }

  // Does an image URL actually load? (8s timeout so a hang can't stall checkout.)
  function _dmbImgLoads(url) {
    return new Promise((resolve) => {
      if (!url) { resolve(false); return; }
      let done = false;
      const finish = (ok) => { if (!done) { done = true; resolve(ok); } };
      const im = new Image();
      im.onload = () => finish(im.naturalWidth > 0);
      im.onerror = () => finish(false);
      setTimeout(() => finish(false), 8000);
      try { im.src = url; } catch (e) { finish(false); }
    });
  }

  // How many referenced photos would print BLANK. Deliberately conservative so it
  // never blocks a legit order over a stale slot reference:
  //  • If the design references photos but the library is EMPTY → total eviction
  //    (the guest week-later case) → all are missing.
  //  • Otherwise only count photos that ARE in the library but whose image is dead
  //    (a revoked/broken blob). Ids absent from the library are treated as stale
  //    refs and ignored (they wouldn't render anyway).
  async function _dmbCountMissingPhotos() {
    const ids = _dmbReferencedPhotoIds();
    if (!ids.length) return 0;
    if (!Array.isArray(editor.photos) || editor.photos.length === 0) return ids.length;
    let broken = 0;
    await Promise.all(ids.map(async (id) => {
      const ph = getPhotoById(id);
      if (!ph || !ph.url) return;                 // not in library → stale ref, skip
      if (!(await _dmbImgLoads(ph.url))) broken++; // in library but image is dead
    }));
    return broken;
  }

  // ── Leave guard: nudge GUESTS to sign in before they leave the builder ──────
  // Only guests with a design in progress (signed-in customers are already backed
  // up to the cloud). Custom "sign in to save" modal when they click a link that
  // leaves the builder; native browser warning on tab-close/refresh/back (browsers
  // don't allow custom UI there).
  let _dmbLeaveGuardDismissed = false;
  function _dmbLeaveGuardActive() {
    if (_dmbRenderMode()) return false;        // render mode: never block a close/navigation
    if (window.DMB_CUSTOMER_ID) return false;                 // signed in → safe
    if (_dmbLeaveGuardDismissed) return false;                // they chose "leave"
    if (!editor || !(editor.totalPages > 0)) return false;    // no real work yet
    const bs = document.getElementById("step2");
    return !!(bs && bs.style.display !== "none");              // only while editing
  }

  window.addEventListener("beforeunload", function (e) {
    // Intentional in-app hop (e.g. Book ⇆ Card): the design is snapshot-saved on
    // unload, so don't nag with the browser's "Leave site?" warning.
    if (window.__dmbIntentionalNav) return;
    // NOTE: no "photos still uploading" block anymore — uploads run in the background
    // and the design's photos live in IndexedDB (+ self-heal / claim on sign-in), so
    // leaving mid-upload no longer loses them. Only the guest "sign in to save" leave
    // warning remains.
    if (!_dmbLeaveGuardActive()) return;
    e.preventDefault();
    e.returnValue = "";   // triggers the browser's generic "Leave site?" warning
  });

  function _dmbShowLeaveGuardModal(onLeave) {
    let ov = document.getElementById("dmbLeaveGuard");
    if (ov) { ov._onLeave = onLeave; ov.style.display = "flex"; return; }
    ov = document.createElement("div");
    ov.id = "dmbLeaveGuard";
    ov.style.cssText = "position:fixed;inset:0;z-index:1000003;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.55);padding:18px;";
    ov._onLeave = onLeave;
    const card = document.createElement("div");
    card.style.cssText = "background:#f4efe7;border-radius:20px;max-width:360px;width:100%;padding:30px 26px 22px;text-align:center;position:relative;box-shadow:0 24px 70px rgba(0,0,0,.35);font-family:inherit;";
    card.innerHTML =
      '<div style="font-size:34px;margin:2px 0 6px;">💾</div>' +
      '<h3 style="margin:0 0 6px;font-size:22px;font-weight:800;color:#1e1e1e;">Save your work?</h3>' +
      '<p style="margin:0 0 20px;font-size:14px;line-height:1.55;color:#a06f86;font-weight:600;">You’re not signed in, so your design could be lost later. Sign in to keep it safe on any device.</p>' +
      '<button type="button" id="dmbLeaveSignIn" style="display:block;width:100%;box-sizing:border-box;background:#1e1e1e;color:#fff;border:none;border-radius:11px;padding:13px 18px;font-size:15px;font-weight:800;cursor:pointer;">Sign in to save</button>' +
      '<button type="button" id="dmbLeaveGo" style="margin-top:10px;background:transparent;border:none;color:#9a8f82;font-size:13px;font-weight:600;cursor:pointer;padding:6px;">Leave without saving</button>';
    ov.appendChild(card);
    document.body.appendChild(ov);
    card.querySelector("#dmbLeaveSignIn").addEventListener("click", function () { _dmbGoSignIn(); });
    card.querySelector("#dmbLeaveGo").addEventListener("click", function () {
      _dmbLeaveGuardDismissed = true;               // also disables the native warning
      ov.style.display = "none";
      const fn = ov._onLeave; if (typeof fn === "function") fn();
    });
    ov.addEventListener("click", function (e) { if (e.target === ov) ov.style.display = "none"; });
  }

  // Intercept clicks on links that LEAVE the builder page (logo, home, menu…).
  document.addEventListener("click", function (e) {
    const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    const raw = a.getAttribute("href") || "";
    if (!raw || raw.charAt(0) === "#" || raw.indexOf("javascript:") === 0) return;
    if (a.target === "_blank") return;               // new tab → this one stays open
    let url; try { url = new URL(raw, location.href); } catch (err) { return; }
    if (url.origin === location.origin && url.pathname === location.pathname) return; // staying here

    // No "wait for uploads" hold anymore — uploads run in the background; photos are
    // in IndexedDB and self-heal / claim on sign-in, so leaving mid-upload is safe.
    // Only the guest "sign in to save" nudge remains.
    if (!_dmbLeaveGuardActive()) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    _dmbShowLeaveGuardModal(function () { window.location.href = url.href; });
  }, true);

  // ── Idle nudge: after a guest sits inactive with a design, prompt sign-in ────
  // Light-card popup matching the site aesthetic: warm white card, periwinkle
  // "Sign in" button, and an ✕ in the top-right corner to close. Floats above the
  // mobile bottom tab bar so it never hides behind it. Once per session.
  function _dmbShowIdleSaveNudge() {
    if (document.getElementById("dmbIdleNudge")) return;
    // Sit clear of the mobile bottom tab bar (#dmbMshTabs); fall back to 20px on desktop.
    let bottomPx = 20;
    try {
      const tabs = document.getElementById("dmbMshTabs");
      if (tabs) { const b = tabs.getBoundingClientRect(); if (b.height > 0 && b.top < window.innerHeight) bottomPx = Math.max(20, window.innerHeight - b.top + 12); }
    } catch (e) {}
    const el = document.createElement("div");
    el.id = "dmbIdleNudge";
    el.style.cssText = "position:fixed;bottom:" + bottomPx + "px;left:50%;transform:translateX(-50%);z-index:999997;background:#ffffff;color:#3d3833;border:1px solid #e7e1d4;border-radius:18px;padding:22px 24px 18px;box-shadow:0 18px 50px rgba(70,60,40,.28);width:min(340px,calc(100vw - 28px));box-sizing:border-box;font-family:inherit;text-align:center;";
    el.innerHTML =
      '<button type="button" id="dmbIdleNudgeX" aria-label="Close" style="position:absolute;top:9px;right:12px;border:none;background:transparent;font-size:26px;line-height:1;color:#a89e8b;cursor:pointer;padding:4px 6px;">&times;</button>' +
      '<div style="font-size:32px;margin:0 0 6px;">&#128190;</div>' +
      '<h3 style="margin:0 0 5px;font-size:19px;font-weight:800;color:#3d3833;">Save your work</h3>' +
      '<p style="margin:0 0 16px;font-size:13.5px;line-height:1.5;color:#8a8272;font-weight:600;">Sign in to save your design and open it on any device.</p>' +
      '<button type="button" id="dmbIdleNudgeGo" style="display:block;width:100%;box-sizing:border-box;background:#6b62d6;color:#fff;border:none;border-radius:11px;padding:13px 18px;font-size:15px;font-weight:800;cursor:pointer;">Sign in</button>';
    document.body.appendChild(el);
    el.querySelector("#dmbIdleNudgeGo").addEventListener("click", function () { _dmbGoSignIn(); });
    el.querySelector("#dmbIdleNudgeX").addEventListener("click", function () { el.remove(); });
  }
  (function _dmbWireIdleNudge() {
    const IDLE_MS = 150000;   // ~2.5 min of no interaction
    let _timer = null, _fired = false;
    function _fire() {
      if (_dmbRenderMode()) return;   // render mode: no UI
      if (_fired) return;
      if (window.DMB_CUSTOMER_ID) return;                          // signed in → skip
      if (!editor || !(editor.totalPages > 0)) { _reset(); return; } // no work yet
      const bs = document.getElementById("step2");
      if (!(bs && bs.style.display !== "none")) { _reset(); return; } // not editing
      _fired = true;
      try { _dmbShowIdleSaveNudge(); } catch (e) {}
    }
    function _reset() {
      if (_fired) return;
      clearTimeout(_timer);
      _timer = setTimeout(_fire, IDLE_MS);
    }
    ["pointerdown", "keydown", "touchstart", "wheel"].forEach(function (ev) {
      document.addEventListener(ev, _reset, { passive: true });
    });
    _reset();
  })();

  async function addDesignedBookToCart() {
    const pagesSelected = String(pagesEl?.value || "");
    const sizeSelected = (editor.bookSize === "A5" ? "A5" : "A4");
    const variantId = getDmbVariantIdByPages(pagesSelected, sizeSelected);

    if (!variantId) {
      alert("Please select the number of pages before adding to cart.");
      return;
    }

    const titleOk = !!getEffectiveBookTitle();
    if (!titleOk) {
      alert("Please add at least one text to the cover before adding to cart.");
      return;
    }

    // ── Guest safety step (mandatory when NOT signed in) ──────────────────────
    // A guest's photos live only on this device and the browser can clear them
    // after ~a week — which produced a silent all-white book. Make them check,
    // and offer sign-in (which backs the design up so it can never be lost).
    if (!window.DMB_CUSTOMER_ID) {
      const _g = await showChoiceDialog(
        "One check before you order",
        "You're not signed in, so your design is saved only on this device and its photos can be lost later. Please make sure every page still shows your photos. Signing in keeps your book safe on any device.",
        [
          { id: "preview", label: "Preview my book first" },
          { id: "signin",  label: "Sign in to keep it safe" },
          { id: "ok",      label: "I checked — it's correct" }
        ]
      );
      if (!_g || _g === "cancel") return;
      if (_g === "preview") { try { openPreviewOverlay(); } catch (e) {} return; }
      if (_g === "signin")  { try { _dmbGoSignIn(); } catch (e) {} return; }
      // _g === "ok" → fall through to the hard photo check below
    }

    // ── Hard guard: never let a book with MISSING photos be ordered ───────────
    // This runs for everyone and is the real safety net — even if the customer
    // clicked "it's correct", a photo the device dropped is caught here instead
    // of shipping a blank book.
    if (saveMsg) { saveMsg.textContent = "Checking your photos…"; saveMsg.style.display = "block"; }
    const _missingPhotos = await _dmbCountMissingPhotos();
    if (saveMsg) saveMsg.style.display = "none";
    if (_missingPhotos > 0) {
      await showChoiceDialog(
        "Some photos are missing",
        _missingPhotos + " photo" + (_missingPhotos > 1 ? "s" : "") + " in your book can't be found on this device anymore, so it would print blank. Please reopen your design and re-add your photos, then order again.",
        [{ id: "ok", label: "OK" }]
      );
      if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.textContent = "Add to Cart"; }
      return;
    }

    // NOTE: Minimum photo check is enforced at the upload step (continueToBuilderBtn
    // and tryAutoOpenEditor), so no need to re-block here at cart time.

    // ── Empty-sheet offer ────────────────────────────────────────────────────
    // A "sheet" is a facing pair (2,3),(4,5),… If BOTH its pages are completely
    // empty, offer to drop the whole sheet (both pages — keeps the count even and
    // bindable). "Keep" → PDF exactly as before. "Remove" → those pages are
    // skipped when building the PDF.
    let _excludePages = null;
    // Books only — magazines weren't in scope, so they behave exactly as before.
    const _emptySheets = window.DMB_MAGAZINE_MODE ? [] : _dmbGetEmptySheets();
    if (_emptySheets.length > 0) {
      const _list = _emptySheets.map(function (s) { return s[0] + "–" + s[1]; }).join(", ");
      const _n = _emptySheets.length;
      const _choice = await showChoiceDialog(
        _n + (_n > 1 ? " empty sheets found" : " empty sheet found"),
        "Pages " + _list + " " + (_n > 1 ? "are" : "is") +
          " completely blank. Do you want to keep these empty pages in your book, or remove them?",
        [
          { id: "keep",   label: "Keep the empty pages" },
          { id: "remove", label: "Remove the empty sheet" + (_n > 1 ? "s" : "") },
          { id: "cancel", label: "Go back and edit" }
        ]
      );
      if (!_choice || _choice === "cancel") return;   // abort — let them keep editing
      if (_choice === "remove") {
        _excludePages = new Set();
        _emptySheets.forEach(function (s) { _excludePages.add(s[0]); _excludePages.add(s[1]); });
      }
    }
    const _removedPages   = _excludePages ? _excludePages.size : 0;
    const _pdfPageCount   = Math.max(0, (editor.totalPages || 0) - _removedPages);

    const selectedCover = loadCoverFromStorage ? (loadCoverFromStorage() || null) : null;
    const _extraSpreads = editor.extraSpreads || 0;

    let properties = {
      "Book Title": getEffectiveBookTitle(),
      "Size": sizeSelected,
      "Orientation": (editor.orientation === "landscape" ? "Landscape" : "Portrait"),
      "Pages Selected": pagesSelected,
      "Extra Spreads": String(_extraSpreads),
      "Removed Sheets": String(_removedPages / 2),
      "PDF Pages": String(_pdfPageCount),
      "Total Pages": String(editor?.totalPages || Number(pagesSelected)),
      "Editable Pages": String(editor?.editablePages ?? (Number(pagesSelected) - 1)),
      "Mode": mode === "customize" ? "customize" : "collection",
      "Selected Cover": selectedCover?.title || selectedCover?.handle || selectedCover?.name || "",
      "Photos Uploaded": String(Array.isArray(bookFiles) ? bookFiles.length : (editor?.photos?.length || 0)),
      "Special Page Text": String(SPECIAL_PAGE_TEXT || ""),
      "Design Version": "DMB v1",
      "Cover Template": coverState.template || "default",
      "Cover Title 1": coverState.title1 || "",
      "Cover Title 2": coverState.title2 || "",
      "Cover Color": coverState.color || "#ffffff"
    };

    try {
      properties["Layout JSON"] = JSON.stringify({
        page_slots: editor?.pageSlots || {},
        page_rot: editor?.pageRot || {},
        page_template: editor?.pageTemplate || {},
        page_frames: editor?.pageFrames || {},
        page_frame_rot: editor?.pageFrameRot || {},
        total_pages: editor?.totalPages || Number(pagesSelected) || 0,
        editable_pages: editor?.editablePages || Math.max(0, (Number(pagesSelected) || 0) - 1)
      });
    } catch {
      properties["Layout JSON"] = "Layout serialization failed";
    }

    const hiddenProps = {};
    Object.keys(properties).forEach((k) => {
      hiddenProps["_" + String(k).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")] = properties[k];
    });

    hiddenProps["Design Summary"] =
      `${properties["Book Title"] || ""} • ${properties["Pages Selected"] || ""} pages • ${properties["Photos Uploaded"] || ""} photos`;

    properties = hiddenProps;

    const pdfOverlay = document.getElementById("dmbPdfOverlay");
    const pdfOverlayMsg = document.getElementById("dmbPdfOverlayMsg");
    const showPdfOverlay = (msg) => {
      if (pdfOverlayMsg) pdfOverlayMsg.textContent = msg;
      if (pdfOverlay) pdfOverlay.style.display = "flex";
    };
    const hidePdfOverlay = () => { if (pdfOverlay) pdfOverlay.style.display = "none"; };

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Adding...";
    }

    showPdfOverlay(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
    // Show generation progress bar
    const _gProgWrap  = document.getElementById("dmbUploadProgressWrap");
    const _gProgBar   = document.getElementById("dmbUploadProgressBar");
    const _gProgLabel = document.getElementById("dmbUploadProgressLabel");
    const _gProgMsg   = document.getElementById("dmbPdfOverlayMsg");
    if (_gProgWrap) _gProgWrap.style.display = "block";
    function _onGenProgress(done, total) {
      const pct = Math.round((done / total) * 100);
      if (_gProgBar)   _gProgBar.style.width   = pct + "%";
      const _genMsgs = [
        "Bringing your memories to life",
        "Turning your photos into something to keep",
        "Your story is taking shape",
        "Crafting something beautiful",
        "Weaving your moments together",
        "Every page tells a story",
        "Adding the finishing touches",
        "Almost a masterpiece"
      ];
      if (_gProgLabel) _gProgLabel.textContent = _genMsgs[Math.floor((done / total) * (_genMsgs.length - 1))];
      if (_gProgMsg)   _gProgMsg.textContent   = ("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book"));
    }

    // ── Keep a digital copy? (option: stays in My Saved Designs after the order ships) ──
    // Signed-in customers only: the copy lives in their account. Guests are sent to
    // sign in first, because their photos exist only on this device.
    let _keepCopy = false;
    {
      const _k = await showChoiceDialog(
        "Keep a digital copy?",
        "Would you like to keep a digital copy of this book on the website so you can edit it later? It stays in My Saved Designs after your order ships.",
        [
          { id: "keep",   label: window.DMB_CUSTOMER_ID ? "Yes, keep a copy" : "Yes, sign in to keep a copy" },
          { id: "print",  label: "No, just print it" },
          { id: "cancel", label: "Cancel" }
        ]
      );
      if (!_k || _k === "cancel") return;
      if (_k === "keep") {
        if (!window.DMB_CUSTOMER_ID) { try { _dmbGoSignIn(); } catch (e) {} return; }
        _keepCopy = true;
        // Make sure the account copy is current before it is ordered.
        try { if (typeof _dmbCloudFlushNow === "function") await _dmbCloudFlushNow(false); } catch (e) {}
      }
    }

    // ── Step 1: Save the design BEFORE generating the PDF ─────────────────────
    // The design is persisted so the customer never loses their work regardless
    // of what happens next. It is only cleared after a confirmed successful
    // upload AND cart add. If anything fails, they can just press Add to Cart
    // again and their design is right there waiting.
    showPdfOverlay("Saving your design");
    // Best-effort local save. The design is being ORDERED right now (its PDF is
    // generated + uploaded and added to the cart below), and for logged-in
    // customers it's also mirrored to the cloud — so a failed local autosave
    // (e.g. localStorage full) must NEVER block checkout. Non-fatal on purpose.
    try {
      if (saveMsg) saveMsg.style.display = "none";
      await saveCustomerProgress();
      if (saveMsg) saveMsg.style.display = "none";
    } catch(saveErr) {
      console.warn("Local design save failed — continuing with order:", saveErr);
    }

    try {
      // ── Step 2+3: Produce the print PDF and get its Drive file id (`up`). ──
      // LARGE books (> _DMB_STREAM_MIN_PAGES actual pages) use the STREAMING path so
      // a big book can't exhaust a phone's memory: render each page, upload it, and
      // let the Cloud Run stapler assemble the PDF. The output is byte-identical.
      // Everything else uses today's proven in-browser path. If streaming fails for
      // ANY reason we fall back to the in-browser path — an order is never blocked.
      // Payment still happens AFTER this, exactly as before.
      let up = null;
      const _pagesActual = Number(editor && editor.totalPages) || 0;

      // ── STEP 4: FULL-QUALITY SERVER RENDER (window.DMB_SERVER_RENDER) ───────
      // Renders on the server from the 3500px print-masters and makes the customer
      // approve the REAL pages before anything is bound. Fails SOFT: on any problem
      // - or if the customer rejects the proof - it returns null, aborts the job and
      // drops through to the two existing paths below, so an order is never blocked.
      try { window.__DMB_SR_ELIGIBLE = _dmbServerRenderOn(); } catch (e) {}
      if (_dmbServerRenderOn()) {
        try {
          up = await _dmbServerRenderAndBind(_excludePages, showPdfOverlay, _onGenProgress, hidePdfOverlay);
          // The customer pressed "Something's wrong - go back" on the proof. The job
          // is already aborted server-side and they want to keep editing, so put the
          // builder back exactly as they left it and stop. Anything else here would
          // rebuild the whole PDF in the browser behind an overlay they cannot close.
          if (up === "__dmb_proof_rejected__") {
            hidePdfOverlay();
            if (_gProgWrap)  _gProgWrap.style.display = "none";
            if (_gProgBar)   _gProgBar.style.width    = "0%";
            if (_gProgLabel) _gProgLabel.textContent  = "";
            if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.textContent = "Add to Cart"; }
            return;
          }
          if (up && _gProgBar)   _gProgBar.style.width  = "100%";
          if (up && _gProgLabel) _gProgLabel.textContent = ("Your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book") + " is ready");
          if (!up) showPdfOverlay(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));   // render failed -> browser fallback
        } catch (srErr) {
          console.warn("Server render failed:", srErr);
          up = null;
        }
      }
      // The in-browser fallback (buildPdfBlobOnePagePerBookPage without streaming) holds
      // EVERY page in jsPDF at once, so it reliably runs out of memory beyond ~60 pages.
      // Big books therefore NEVER use it — they retry the server streaming path instead.
      const _bigBook = _pagesActual > 60;
      const _streamEligible =
        window.DMB_STREAM_PDF_ENABLED !== false &&          // master kill-switch (liquid)
        !!window.DMB_DESIGNS_PROXY &&
        typeof window.__dmbBuildPdfStreaming === "function" &&
        _pagesActual > _DMB_STREAM_MIN_PAGES;

      if (!up && _streamEligible) {
        // SINGLE streaming pass — never re-render a big book (that doubled the load and
        // could exhaust the device). If it fails, we surface the saved-book retry message.
        try {
          showPdfOverlay(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
          up = await _dmbStreamingBuildAndUpload("", _excludePages, _onGenProgress, showPdfOverlay, hidePdfOverlay);
          // "Something's wrong, go back" on the fallback's proof. Same sentinel and the
          // same handling as the server path: put the builder back and stop. Falling
          // through would bind and charge for a book they just rejected.
          if (up === "__dmb_proof_rejected__") {
            hidePdfOverlay();
            if (_gProgWrap)  _gProgWrap.style.display = "none";
            if (_gProgBar)   _gProgBar.style.width    = "0%";
            if (_gProgLabel) _gProgLabel.textContent  = "";
            if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.textContent = "Add to Cart"; }
            return;
          }
          if (_gProgBar)   _gProgBar.style.width  = "100%";
          if (_gProgLabel) _gProgLabel.textContent = ("Your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book") + " is ready");
        } catch (streamErr) {
          console.warn("Streaming PDF failed:", streamErr);
          up = null;
        }
      }

      if (!up) {
        if (_bigBook) {
          // Do NOT attempt the in-browser accumulate build for a big book — it would grind
          // for minutes and then crash the tab. The design is already saved (Step 1), so the
          // outer catch shows the "saved in Saved Books, please try again" message.
          throw new Error("Big book server binding unavailable — design saved, please retry shortly.");
        }
        // Small book — the in-browser path is safe (few pages, low memory).
        showPdfOverlay(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
        const pdfBlob = await buildPdfBlobOnePagePerBookPage(_onGenProgress, null, _excludePages);
        if (_gProgBar)   _gProgBar.style.width  = "100%";
        if (_gProgLabel) _gProgLabel.textContent = ("Your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book") + " is ready");
        showPdfOverlay(("Sending your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));
        up = await uploadPdfToGoogleDrive(pdfBlob);
      }

      properties["_pdf_view"]      = up.viewUrl;
      properties["_pdf_download"]  = up.downloadUrl;
      properties["_pdf_file_id"]   = up.id;
      // Link this line to its stored design so its photos can be auto-deleted from
      // R2 after the order (retention webhook). Works for BOTH logged-in customers
      // (owner = customer id) and guests (owner = guest_<sid>).
      try {
        properties["_design_id"] = getCustomerSaveKey().replace(/^dmb_progress_/, "");
        if (_keepCopy) properties["_keep_copy"] = "yes";
        if (!window.DMB_CUSTOMER_ID && typeof _dmbPhotoBackup !== "undefined") {
          const _sid = _dmbPhotoBackup.guestId();
          if (_sid) properties["_design_sid"] = _sid;
        }
      } catch (e) {}

      // ── Step 4: Add to cart ───────────────────────────────────────────────────
      showPdfOverlay("Adding to your cart");
      const _cartItems = [{ id: variantId, quantity: 1, properties }];
      const _extraSpreadVid = window.DMB_EXTRA_SPREAD_VARIANT_ID;
      if (_extraSpreads > 0 && _extraSpreadVid) {
        _cartItems.push({ id: _extraSpreadVid, quantity: _extraSpreads });
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: _cartItems })
      });

      if (!res.ok) {
        // Cart add failed — trash the Drive file we just uploaded so it doesn't
        // accumulate as an orphan. Customer's design is still saved; they retry
        // and a fresh upload + cart add will happen together.
        try {
          await postToScript({ action: "trash_file", fileId: up.id }, 2);
        } catch(te) { /* non-fatal — cleanupOldChunks will catch it eventually */ }
        let msg = "Failed to add to cart.";
        try { const err = await res.json(); msg = err?.description || err?.message || msg; } catch {}
        throw new Error(msg);
      }

      // ── Step 5: Added to cart — DO NOT destroy the customer's design/photos yet ──
      // The item is only in the CART; the customer has NOT paid. If we deleted the design
      // + R2 photos now (as before) and they abandoned checkout — or anything went wrong
      // after this point — their book and every photo would be gone permanently. So we
      // KEEP the recoverable cloud/R2 copy and its photos; the post-order retention webhook
      // (linked via _design_id / _design_sid on the line item) removes them AFTER the order
      // is actually placed. We only stop the local leftover from popping a resume prompt.
      try { localStorage.removeItem(getCustomerSaveKey()); } catch (e) {}
      try {
        localStorage.setItem("design_my_book_last_added", JSON.stringify({
          added_at: new Date().toISOString(),
          pages_selected: pagesSelected,
          properties
        }));
      } catch {}

      // Order placed — the design is now in the cart, so the leave guard must not
      // pop a "Leave site?" warning on this intended redirect.
      try { _dmbLeaveGuardDismissed = true; } catch (e) {}
      window.location.href = "/";

    } catch (err) {
      // ── Any failure: hide overlay, show friendly message, re-enable button ──
      // The design is already saved (Step 1) so the customer can try again at
      // any time — their book will be exactly as they left it.
      hidePdfOverlay();
      const _msg = "Due to a connection issue your book could not be processed. It's saved in your Saved Books — please try again on a better Wi-Fi connection. 📶";

      // Show as a dismissible banner above the builder (not a blocking alert)
      const _errBanner = document.createElement("div");
      _errBanner.style.cssText = "position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:999999;background:#1e1e1e;color:#fff;border-radius:12px;padding:14px 20px;max-width:92vw;font-size:14px;font-weight:700;text-align:center;box-shadow:0 8px 30px rgba(0,0,0,.5);display:flex;align-items:center;gap:12px;";
      _errBanner.innerHTML = `<span>${_msg}</span><button type="button" style="background:#444;border:none;border-radius:8px;color:#fff;padding:6px 12px;cursor:pointer;font-size:13px;font-weight:900;flex-shrink:0;">OK</button>`;
      _errBanner.querySelector("button").onclick = () => _errBanner.remove();
      document.body.appendChild(_errBanner);
      setTimeout(() => { if (_errBanner.isConnected) _errBanner.remove(); }, 12000);

      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "Add to Cart";
      }
    }
  }

  // Navigation order: Cover → Spread 0 (currentSpread -1) → Spread 1 (0) → … → last.
  if (prevSpreadBtn) {
    prevSpreadBtn.addEventListener("click", () => {
      if (builderMode === "cover") return;        // cover is the first view — nothing before it
      if (editor.currentSpread <= -1) {           // Spread 0 → back to the cover
        builderMode = "cover";
        renderBuilderCanvas();
        return;
      }
      editor.currentSpread--;                     // spread n → n-1 (0 → -1 = Spread 0)
      renderBuilderCanvas();
    });
  }

  if (nextSpreadBtn) {
    nextSpreadBtn.addEventListener("click", () => {
      if (builderMode === "cover") {              // cover → Spread 0
        builderMode = "pages";
        editor.currentSpread = -1;
        renderBuilderCanvas();
        return;
      }
      if (editor.currentSpread < editor.totalSpreads - 1) {
        editor.currentSpread++;
        renderBuilderCanvas();
      }
    });
  }

  if (undoBtn) {
    undoBtn.addEventListener("click", undoLastAction);
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", () => {
      // ONE review, of the REAL thing. With the server render on, the customer is
      // shown the ACTUAL rendered pages (the proof) before anything is bound - that
      // is strictly better than this preview, which is the browser's approximation
      // rendered BEFORE the print pages exist. Showing both would be two review
      // screens back to back for the same decision.
      // Server render OFF (today's default) -> unchanged: confirm-mode preview.
      if (_dmbServerRenderOn()) { addDesignedBookToCart(); return; }
      // Open preview in confirm mode — customer must review every page
      // before the PDF is generated and the order is placed.
      openPreviewOverlay(true);
    });
  }

  // ── Extra spread buttons ──────────────────────────────────────────────────
  // "+" adds a spread (2 pages, +$1.99); "−" removes the last added spread.
  // Buttons are hidden until the customer selects a page count.
  const _addSpreadBtn    = $("dmbAddSpreadBtn");
  const _removeSpreadBtn = $("dmbRemoveSpreadBtn");
  if (_addSpreadBtn)    _addSpreadBtn.addEventListener("click", () => {
    // Ask before/after the current spread and insert there (desktop AND phone).
    try { _dmbAddSpreadPrompt(); } catch (e) { addExtraSpread(); }
  });
  if (_removeSpreadBtn) _removeSpreadBtn.addEventListener("click", removeExtraSpread);
  function initMagazineStylePicker() {
    const styles = window.DMB_MAGAZINE_STYLES || [];
    const grid = document.getElementById("dmbMagStyleGrid");
    const continueBtn = document.getElementById("continueToMagBuilderBtn");
    const backBtn = document.getElementById("backToUploadBtn");
    if (!grid) return;

    // Only init once
    if (grid.dataset.initialized) return;
    grid.dataset.initialized = "1";

    let selectedStyle = null;

    styles.forEach(function(s) {
      const card = document.createElement("div");
      card.className = "dmb-mag-style-card";
      card.dataset.styleId = s.id;
      card.style.cssText =
        "display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px;" +
        "border:2px solid #ddd;border-radius:10px;cursor:pointer;transition:border-color .15s,background .15s;";

      if (s.img) {
        const img = document.createElement("img");
        img.src = s.img;
        img.alt = s.label;
        img.style.cssText = "width:100%;height:140px;object-fit:cover;border-radius:6px;";
        card.appendChild(img);
      } else {
        const ph = document.createElement("div");
        ph.style.cssText =
          "width:100%;height:140px;background:#f0f0f0;border-radius:6px;" +
          "display:flex;align-items:center;justify-content:center;color:#bbb;font-size:12px;text-align:center;padding:8px;box-sizing:border-box;";
        ph.textContent = "Template coming soon";
        card.appendChild(ph);
      }

      const lbl = document.createElement("div");
      lbl.style.cssText = "font-size:13px;font-weight:600;text-align:center;";
      lbl.textContent = s.label;
      card.appendChild(lbl);

      card.addEventListener("click", function() {
        grid.querySelectorAll(".dmb-mag-style-card").forEach(function(c) {
          c.style.borderColor = "#ddd";
          c.style.background = "";
        });
        card.style.borderColor = "#111";
        card.style.background = "#f5f5f5";
        selectedStyle = s.id;
        window.DMB_SELECTED_MAGAZINE_STYLE = s.id;
        if (continueBtn) continueBtn.disabled = false;
      });

      grid.appendChild(card);
    });

    if (continueBtn) {
      continueBtn.disabled = true;
      continueBtn.addEventListener("click", async function() {
        if (!selectedStyle) return;
        const s1c = document.getElementById("step1c");
        if (s1c) s1c.style.display = "none";
        if (builderStep) builderStep.style.display = "block";
        try { await openEditor(); } catch(err) {
          console.error("openEditor failed:", err);
          if (s1c) s1c.style.display = "flex";
          if (builderStep) builderStep.style.display = "none";
        }
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", function() {
        const s1c = document.getElementById("step1c");
        const s1b = document.getElementById("step1b");
        if (s1c) s1c.style.display = "none";
        if (s1b) s1b.style.display = "flex";
      });
    }
  }

  if (backToDetailsBtn) {
    backToDetailsBtn.addEventListener("click", closeEditorBackToDetails);
  }

  if (saveLayoutBtn) {
    saveLayoutBtn.style.display = "none";
  }

  window.addEventListener("beforeunload", () => {
    if (_dmbRenderMode()) return;   // render mode: no localStorage snapshot
    try {
      const payload = getCurrentBuilderStateSnapshot();
      localStorage.setItem(_dmbProjKey(), JSON.stringify(payload));
      // NOTE: we do NOT auto-save to the per-book customer key here.
      // That key is only written by explicit "Save Template" clicks so it
      // never gets corrupted by navigating away mid-session.
    } catch {}
  });
  if (saveTemplateBtn) {
    saveTemplateBtn.addEventListener("click", () => {
      // Guests must sign in to save (so the design follows them across devices).
      if (!window.DMB_CUSTOMER_ID) { _dmbShowSaveSignIn(); return; }
      Promise.resolve(saveCustomerProgress()).then(function () {
        if (typeof _dmbCloudPersist === "function") _dmbCloudPersist();  // mirror to the account
        _dmbShowSavedConfirm();   // confirm + clear link to the Saved designs folder
      });
    });
  }

  // Reflect editor.bookSize on the toggle's two segments (active = filled).
  // Function declaration so it's hoisted — applyBuilderStateSnapshot calls it
  // earlier in the file when restoring a saved design.
  function _dmbSyncSizeToggleUI() {
    const wrap = document.getElementById("dmbSizeToggle");
    if (!wrap) return;
    const cur = editor.bookSize === "A5" ? "A5" : "A4";
    wrap.querySelectorAll(".dmb-size-opt").forEach(function (b) {
      const on = b.dataset.size === cur;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  // ── A4 / A5 size toggle (book builder only) ──────────────────────────────
  // The pill lives in the top bar between History and Undo. It only flips a
  // label/price/variant — the design itself never changes (A4 & A5 share the
  // same shape). Absent on the magazine builder, so all of this no-ops there.
  (function _wireSizeToggle() {
    const wrap = document.getElementById("dmbSizeToggle");
    if (!wrap) return;                       // no toggle on this page → skip
    if (editor.bookSize !== "A5") editor.bookSize = "A4";
    _dmbSyncSizeToggleUI();
    wrap.querySelectorAll(".dmb-size-opt").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const sz = btn.dataset.size === "A5" ? "A5" : "A4";
        if (editor.bookSize === sz) return;
        editor.bookSize = sz;
        _dmbSyncSizeToggleUI();
        try { updatePrice(); } catch (e) {}   // refresh displayed price for the size
        try { autoSave(); } catch (e) {}       // remember the choice with the design
      });
    });
  })();

  // Reflect editor.orientation on the toggle's two segments (active = filled).
  // Hoisted so applyBuilderStateSnapshot can call it when restoring a design.
  function _dmbSyncOrientationToggleUI() {
    const wrap = document.getElementById("dmbOrientToggle");
    if (!wrap) return;
    const cur = editor.orientation === "landscape" ? "landscape" : "portrait";
    wrap.querySelectorAll(".dmb-size-opt").forEach(function (b) {
      const on = b.dataset.orient === cur;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  // ── Portrait / Landscape orientation toggle ───────────────────────────────
  // Sits next to the A4/A5 pill. Flipping RESHAPES the page: %-based photo
  // layouts re-flow automatically, and free objects (text/stickers/frames) are
  // center-mapped to the new shape so nothing is lost. Confirm first when there's
  // a design to keep. Absent on pages without the pill (no-op there).
  (function _wireOrientationToggle() {
    const wrap = document.getElementById("dmbOrientToggle");
    if (!wrap) return;
    if (editor.orientation !== "landscape") editor.orientation = "portrait";
    _dmbSyncOrientationToggleUI();
    wrap.querySelectorAll(".dmb-size-opt").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const to   = btn.dataset.orient === "landscape" ? "landscape" : "portrait";
        const from = editor.orientation === "landscape" ? "landscape" : "portrait";
        if (from === to) return;
        const hasWork = (editor.totalPages || 0) > 0;
        if (hasWork && !confirm(
          to === "landscape"
            ? "Switch to Landscape? Your photos and text are kept — the layout adjusts to the wider shape."
            : "Switch back to Portrait? Your photos and text are kept — the layout adjusts to the taller shape."
        )) return;
        try { reshapeForOrientation(from, to); } catch (e) {}
        editor.orientation = to;
        _dmbSyncOrientationToggleUI();
        // Re-render everything to the new shape.
        try { renderBuilderCanvas(); } catch (e) {}
        try { if (builderMode === "cover") renderCoverCanvas(); } catch (e) {}  // flip cover face too
        try { renderThumbsRail(); } catch (e) {}
        try { updateCoverPreview(); } catch (e) {}
        try { _dmbPvReinitAll(); } catch (e) {}     // rebuild PDF-preview cache at new shape
        try { autoSave(); } catch (e) {}
      });
    });
  })();
  window.addEventListener("resize", () => {
    if (builderStep && builderStep.style.display === "block") {
      try { renderBuilderCanvas(); } catch(e) {}
      renderThumbsRail();
      renderPhotoTray();
    }
  });

  if (redoBtn) redoBtn.addEventListener("click", redoLastAction);

  if (previewBtn) {
    previewBtn.addEventListener("click", () => {
      openPreviewOverlay();
    });
  }

  // ── Tutorial Modal ────────────────────────────────────────────────────
  (function() {
    const tutBtn    = document.getElementById("videoTutorialBtn");
    const tutModal  = document.getElementById("dmbTutorialModal");
    const tutClose  = document.getElementById("dmbTutorialClose");
    const tourBtn   = document.getElementById("dmbStartTourBtn");
    const qrImg     = document.getElementById("dmbTutorialQRImg");
    const qrPh      = document.getElementById("dmbTutorialQRPlaceholder");

    if (!tutBtn || !tutModal) return;

    // If QR image src is set, show the image and hide the placeholder
    if (qrImg && qrImg.src && qrImg.src !== window.location.href) {
      qrImg.style.display = "block";
      if (qrPh) qrPh.style.display = "none";
    }

    function openModal()  { tutModal.style.display = "flex"; }
    function closeModal() { tutModal.style.display = "none"; }

    tutBtn.addEventListener("click", openModal);
    if (tutClose) tutClose.addEventListener("click", closeModal);

    // Click outside the inner box closes the modal
    tutModal.addEventListener("click", (e) => {
      if (e.target === tutModal) closeModal();
    });

    // Escape key closes the modal
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && tutModal.style.display !== "none") closeModal();
    });

    // Start Tour button
    if (tourBtn) {
      tourBtn.addEventListener("click", () => {
        closeModal();
        setTimeout(() => {
          if (window.dmbRestartTour) window.dmbRestartTour();
        }, 200);
      });
    }
  })();
  if (exportTemplateBtn) {
    exportTemplateBtn.addEventListener("click", () => { saveTemplateToStore(); });
  }

  const zoomRange = $("zoomRange");

  if (zoomRange) {
    zoomRange.addEventListener("input", () => {
      setCanvasZoom(Number(zoomRange.value) / 100);
    });
  }

  if (zoomInBtn) {
    zoomInBtn.addEventListener("click", () => {
      const next = Math.min(200, Math.round(currentZoom * 100) + 10);
      setCanvasZoom(next / 100);
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener("click", () => {
      const next = Math.max(25, Math.round(currentZoom * 100) - 10);
      setCanvasZoom(next / 100);
    });
  }

  if (smartCreationBtn) {
    smartCreationBtn.addEventListener("click", () => {
      smartCreateBook();
    });
  }

  if (coverThumbBtn) {
    coverThumbBtn.addEventListener("click", () => {
      builderMode = "cover";
      syncBuilderModeButtons();
      renderBuilderCanvas();
      activateLeftTab("cover");
    });
  }

  if (canvasLayoutBtn) {
    canvasLayoutBtn.addEventListener("click", () => {
      document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
    });
  }

  if (canvasTextBtn || addTextBtn) {
    const addDefaultText = (e) => {
      // Stop this click from bubbling to the document click-out handler, which
      // would otherwise see the brand-new (still empty) box and remove it on the
      // same click — making the button appear to do nothing.
      if (e && e.stopPropagation) e.stopPropagation();
      let target = null;

      const _magFrontX3 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      let coverTextDefaultX = _magFrontX3 + 40;
      if (builderMode === "cover") {
        // Place text in the overlay (spans full cover) so drag is seamless across all zones
        target = document.getElementById("coverOverlay") || spreadCanvas;
        const zoneOffsets = { back: 40, spine: COVER_BACK_W + 5, front: _magFrontX3 + 40 };
        coverTextDefaultX = zoneOffsets[activeCoverZone] ?? (_magFrontX3 + 40);
      } else {
        const pageBodies = spreadCanvas?.querySelectorAll('[data-page-body="true"]');
        let bodyIdx = lastToolbarSide === "right" && pageBodies && pageBodies.length > 1 ? 1 : 0;
        // Never drop text onto a LOCKED page (e.g. the inside-front-cover page 1 on
        // spread 0). If the preferred side is locked, use the other page body.
        if (pageBodies && pageBodies[bodyIdx] && pageBodies.length > 1) {
          const _pn = parseInt(pageBodies[bodyIdx].dataset.pageNumber);
          if (Number.isFinite(_pn) && isLockedPage(_pn)) bodyIdx = bodyIdx === 0 ? 1 : 0;
        }
        target = pageBodies && pageBodies.length ? pageBodies[bodyIdx] : null;
      }

      if (!target) return;
      pushUndoState("Add Text");
      const txt = document.createElement("div");
      // Start empty with a CSS placeholder (not real text), so the box appears
      // immediately, ready to type — nothing to select/delete first, and a stray
      // Backspace can't wipe it.
      txt.textContent = "";
      txt.dataset.placeholder = "Type here";
      txt.contentEditable = "true";
      txt.classList.add("dmb-editable-text");
      // Spine: rotate -90° so text reads along the spine
      if (builderMode === "cover" && activeCoverZone === "spine") {
        const spineCenter = COVER_BACK_W + Math.round(COVER_SPINE_W / 2);
        txt.style.left = spineCenter + "px";
        txt.style.top = "50%";
        txt.style.transform = "translate(-50%, -50%) rotate(-90deg)";
        txt.style.minWidth = "";
      } else {
        txt.style.left = (builderMode === "cover" ? coverTextDefaultX : 40) + "px";
        txt.style.top = "40px";
        txt.style.minWidth = "120px";
      }
      txt.style.padding = "2px 6px";
      // Spine text defaults small (6px) to fit the thin 8 mm spine; everywhere else 28px.
      txt.style.fontSize = (builderMode === "cover" && activeCoverZone === "spine") ? "6px" : "28px";
      txt.style.fontWeight = "800";
      txt.style.color = "#666";
      txt.style.fontFamily = "'Londrina Solid', sans-serif";
      txt.style.background = "transparent";
      txt.style.outline = "none";
      txt.dataset.z = String(Date.now());
      txt.style.zIndex = txt.dataset.z;

      // Track user-added cover text so it survives re-renders
      if (builderMode === "cover") {
        const utId = "utext_" + Date.now() + "_" + Math.random().toString(36).slice(2);
        txt.id = utId;
        const zone = activeCoverZone === "back" ? "back" : activeCoverZone === "spine" ? "spine" : "front";
        if (!Array.isArray(editor.coverUserTexts)) editor.coverUserTexts = [];
        editor.coverUserTexts.push({ id: utId, zone });
        // Don't persist the box yet — it's empty, and saveCoverTextNodeState
        // strips empty boxes from coverUserTexts. State is saved once the user
        // types (input handler). If they never type, blur/click-out removes it.
      }

      if (builderMode !== "cover") {
        const _pn = parseInt(target.dataset.pageNumber);
        if (Number.isFinite(_pn)) {
          txt.dataset.pageNumber = String(_pn);
          const _txtId = "pgtext_" + Date.now() + "_" + Math.random().toString(36).slice(2);
          txt.id = _txtId;
          if (!Array.isArray(editor.pageObjects[_pn])) editor.pageObjects[_pn] = [];
          editor.pageObjects[_pn].push({
            id: _txtId, type: "text",
            text: txt.textContent || "",
            left: txt.style.left || "40px", top: txt.style.top || "40px",
            fontSize: txt.style.fontSize || "28px", fontWeight: txt.style.fontWeight || "800",
            color: txt.style.color || "#666", fontFamily: txt.style.fontFamily || "'Londrina Solid', sans-serif",
            textAlign: "", textDecoration: "", transform: "", rotate: "0",
            z: txt.dataset.z || String(Date.now()), width: ""
          });
        }
      }
      attachTextNodeHandlers(txt);
      target.appendChild(txt);
      // A brand-new box opens straight in writing mode so the user can type at once.
      enterTextEditMode(txt);
    };

    if (canvasTextBtn) canvasTextBtn.addEventListener("click", addDefaultText);
    if (addTextBtn) addTextBtn.addEventListener("click", addDefaultText);
  }

  function dmbAddFrameToActiveTarget(opts) {
    opts = opts || {};
    let target;

    if (builderMode === "cover") {
      target = {
        targetType: "cover",
        zone: getCurrentCoverZone()
      };
    } else {
      let pageNumber = null;
      if (editor.currentSpread === -1) {
        pageNumber = 0;
      } else {
        const leftPage = editor.currentSpread * 2 + 1;
        const rightPage = leftPage + 1;
        if (lastToolbarSide === "right") {
          if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) pageNumber = rightPage;
          else if (leftPage <= editor.totalPages && !isLockedPage(leftPage)) pageNumber = leftPage;
        } else {
          if (leftPage <= editor.totalPages && !isLockedPage(leftPage)) pageNumber = leftPage;
          else if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) pageNumber = rightPage;
        }
      }

      if (pageNumber == null) {
        const msg = document.getElementById("saveMsg");
        if (msg) {
          msg.textContent = "No editable page on this spread.";
          msg.style.display = "block";
          setTimeout(() => { msg.style.display = "none"; }, 1400);
        }
        return;
      }

      target = {
        targetType: "page",
        page: pageNumber
      };
    }

    pushUndoState(opts.polaroid ? "Add Polaroid" : "Add Photo Frame");

    const obj = newFrameObject(target);
    if (opts.polaroid) {
      obj.polaroid = true;
      obj.shadow = true;     // default ON (light)
      obj.w = 200;
      obj.h = 230;           // taller than wide → room for the bottom strip
    }

    if (target.targetType === "cover") {
      // Offset x to full-cover coordinates based on the active zone
      const _magFrontX4 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      const zoneOffsets = { back: 0, spine: COVER_BACK_W, front: _magFrontX4 };
      // ?? not || : the BACK face offset is 0, which is FALSY, so `||` fell through to
      // the front offset and a photo frame added with the back face selected landed on
      // the FRONT. Zone-aware code that is wrong for exactly one zone. (2026-09-14)
      obj.x = (zoneOffsets[target.zone] ?? _magFrontX4) + 40;
      ensureCoverObjects().push(obj);
    } else {
      ensurePageObjects(target.page).push(obj);
    }

    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();

    requestAnimationFrame(() => {
      const el = document.querySelector(`.dmb-photo-frame-object[data-object-id="${obj.id}"]`);
      if (el) {
        showFrameToolbarFor(el, obj, {
          targetType: obj.targetType,
          pageNumber: obj.page ?? null,
          zone: obj.zone || null
        });
      }
    });
  }

  if (canvasPhotoBtn) {
    canvasPhotoBtn.addEventListener("click", () => dmbAddFrameToActiveTarget());
  }

  /* ── SHAPE PICKER — open / close + item click handler ─────────────────
   * Clicking "Shapes" in the toolbar toggles the floating shape picker panel.
   * Clicking a shape in the panel either adds it immediately (all except line)
   * or activates "line draw mode" where the next canvas drag creates the line.
   *
   * WARNING: Line draw mode adds a one-shot pointerdown listener on the canvas
   * container. Always cancel _dmbLineModeActive via Escape or on completion so
   * subsequent canvas clicks work normally.
   * ────────────────────────────────────────────────────────────────────────── */
  (function initShapePickerPanel() {
    const panel   = document.getElementById("dmbShapePickerPanel");
    const closeBtn = document.getElementById("dmbShapePickerClose");
    if (!panel) return;

    // Float the panel OVER the left photos panel (not below the Shapes button, and
    // without replacing the panel's content). Falls back to sitting under the button
    // when the left panel isn't on screen (e.g. mobile layout).
    function positionShapePanel() {
      const lp = document.querySelector(".dmb-builder-leftpanel");
      const r = lp && lp.getBoundingClientRect();
      if (r && r.width > 40 && r.height > 40) {
        const pad = 10;
        panel.style.top       = (r.top + pad) + "px";
        panel.style.left      = (r.left + pad) + "px";
        panel.style.width     = (r.width - pad * 2) + "px";
        panel.style.maxHeight = (r.height - pad * 2) + "px";
        panel.style.overflowY = "auto";
        return;
      }
      if (!canvasShapeBtn) return;
      const btnRect = canvasShapeBtn.getBoundingClientRect();
      panel.style.top       = (btnRect.bottom + 6) + "px";
      panel.style.left      = Math.max(8, btnRect.left) + "px";
      panel.style.width     = "";
      panel.style.maxHeight = "";
      panel.style.overflowY = "";
    }

    if (canvasShapeBtn) {
      canvasShapeBtn.addEventListener("click", () => {
        if (panel.style.display === "none" || !panel.style.display) {
          positionShapePanel();
          panel.style.display = "block";
          canvasShapeBtn.classList.add("is-active");
        } else {
          panel.style.display = "none";
          canvasShapeBtn.classList.remove("is-active");
        }
      });
    }

    closeBtn?.addEventListener("click", () => {
      panel.style.display = "none";
      canvasShapeBtn?.classList.remove("is-active");
    });

    // Close picker when clicking outside it
    document.addEventListener("pointerdown", (e) => {
      if (!panel || panel.style.display === "none") return;
      if (panel.contains(e.target))                 return;
      if (e.target === canvasShapeBtn)              return; // handled by toggle above
      panel.style.display = "none";
      canvasShapeBtn?.classList.remove("is-active");
    }, { capture: true });

    // Shape item click → add shape or activate line mode
    panel.querySelectorAll(".dmb-shape-item[data-shape]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const shapeType = btn.dataset.shape;
        panel.style.display = "none";
        canvasShapeBtn?.classList.remove("is-active");

        if (shapeType === "line") {
          // ── LINE DRAW MODE ── press where the line starts, release where it ends.
          //
          // The mechanism was already this; it was the plumbing that made it feel
          // impossible to place. Three things were wrong, all fixed here (2026-09-14):
          //
          //  1. The line was filed to the page `lastToolbarSide` happened to point at,
          //     NOT the page it was drawn on - while its coordinates were measured
          //     against the page actually pressed. Draw on the right-hand page while the
          //     toolbar last touched the left and the line was stored on the left page at
          //     the right page's coordinates, i.e. somewhere else entirely.
          //  2. Arming used per-element listeners with { once: true }. The first
          //     pointerdown consumed them whatever happened, so a tap, a nudge under the
          //     8px threshold, or a canvas re-render between arming and drawing all left
          //     line mode silently dead - reopen the picker and try again.
          //  3. The listeners sat on the page bodies, below the object drag handlers, so
          //     pressing on anything already on the page started a DRAG instead of a line.
          //
          // Now: one delegated capture-phase listener that stays armed until a line is
          // actually drawn or Escape is pressed.
          _dmbLineModeActive = true;
          document.body.classList.add("dmb-line-draw-mode");

          const endLineMode = () => {
            _dmbLineModeActive = false;
            document.body.classList.remove("dmb-line-draw-mode");
            document.removeEventListener("keydown", cancelLine);
            document.removeEventListener("pointerdown", startLineDraw, true);
          };
          const cancelLine = (e) => { if (e.key === "Escape") endLineMode(); };
          document.addEventListener("keydown", cancelLine);

          const startLineDraw = (downEvt) => {
            if (!_dmbLineModeActive) return;
            // Delegated: find the canvas under the pointer NOW, so a re-render between
            // arming and drawing cannot leave this pointing at a detached element.
            const target = (downEvt.target && downEvt.target.closest)
              ? downEvt.target.closest('[data-page-body="true"], .dmb-cover-preview, #coverOverlay')
              : null;
            if (!target) return;              // pressed off-canvas - stay armed
            const tRect    = target.getBoundingClientRect();
            // Canvas zoom: the page is CSS-scaled, so client px != page px.
            const _lz      = (tRect.width / (target.offsetWidth || tRect.width)) || 1;
            const _lcW     = target.offsetWidth  || (tRect.width  / _lz);
            const _lcH     = target.offsetHeight || (tRect.height / _lz);
            // A line is a SHAPE, and shapes may span both pages of a spread, so the draw
            // is allowed to run across the fold onto the facing page. Y still clamps to
            // the sheet - top and bottom are real edges on any page.
            const _pnT     = Number(target.dataset && target.dataset.pageNumber);
            const _isPg    = Number.isFinite(_pnT) && _pnT >= 1;
            const _isLeft  = _isPg && (_pnT % 2 === 1);
            const _sibPg   = _isPg ? (_isLeft ? _pnT + 1 : _pnT - 1) : 0;
            const _hasSib  = _isPg && _sibPg >= 1 && _sibPg <= (editor.totalPages || 0);
            const _xLo     = (_hasSib && !_isLeft) ? -_lcW : 0;
            const _xHi     = (_hasSib &&  _isLeft) ? _lcW * 2 : _lcW;
            const _lclampX = (v) => Math.max(_xLo, Math.min(_xHi, v));
            const _lclampY = (v) => Math.max(0, Math.min(_lcH, v));
            const startX   = _lclampX((downEvt.clientX - tRect.left) / _lz);
            const startY   = _lclampY((downEvt.clientY - tRect.top)  / _lz);

            // Live preview element
            const preview = document.createElement("div");
            preview.style.cssText = "position:absolute;pointer-events:none;background:#6366f1;opacity:0.6;transform-origin:left center;z-index:9999;border-radius:4px;";
            target.style.position = "relative";
            target.appendChild(preview);

            const onMove = (mv) => {
              const ex = _lclampX((mv.clientX - tRect.left) / _lz);
              const ey = _lclampY((mv.clientY - tRect.top)  / _lz);
              const dx = ex - startX, dy = ey - startY;
              const len = Math.sqrt(dx*dx + dy*dy);
              const ang = Math.atan2(dy, dx) * 180 / Math.PI;
              preview.style.width     = len + "px";
              preview.style.height    = "8px";
              preview.style.left      = startX + "px";
              preview.style.top       = (startY - 4) + "px";
              preview.style.transform = `rotate(${ang}deg)`;
            };

            const onUp = (upEvt) => {
              preview.remove();
              document.removeEventListener("pointermove", onMove);

              const ex   = _lclampX((upEvt.clientX - tRect.left) / _lz);
              const ey   = _lclampY((upEvt.clientY - tRect.top)  / _lz);
              const dx   = ex - startX, dy = ey - startY;
              const len  = Math.sqrt(dx*dx + dy*dy);
              // A tap, or a drag too short to be a line. STAY ARMED: this used to end
              // line mode outright, so one twitchy press meant reopening the picker.
              if (len < 8) return;
              endLineMode();

              const isCover = (builderMode === "cover");
              // File it on the page it was DRAWN on. tRect, startX and startY are all
              // measured against `target`, so any other page here stores the line at
              // coordinates that mean nothing on it.
              let pn = null;
              if (!isCover) {
                if (_isPg && !isLockedPage(_pnT)) {
                  pn = _pnT;
                } else if (editor.currentSpread === -1) {
                  pn = 0;
                } else {
                  const _lp = editor.currentSpread * 2 + 1;
                  const _rp = _lp + 1;
                  if (lastToolbarSide === "right" && _rp <= editor.totalPages && !isLockedPage(_rp)) {
                    pn = _rp;
                  } else if (_lp <= editor.totalPages && !isLockedPage(_lp)) {
                    pn = _lp;
                  } else {
                    pn = (_rp <= editor.totalPages) ? _rp : null;
                  }
                }
              }
              const lineObj = {
                id: _dmbOid("shape_"), type: "shape", shapeType: "line", lineType: "straight",
                x1: startX, y1: startY, x2: ex, y2: ey,   // endpoints in page coords
                thickness: 8,
                fill: "#6366f1", stroke: "transparent", strokeWidth: 0, strokeStyle: "solid",
                opacity: 1, rotation: 0, z: Date.now(),
              };
              try { _dmbLineRecomputeBox(lineObj); } catch (e) {}
              pushUndoState("Add Line");
              if (isCover) {
                if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
                editor.coverObjects.push(lineObj);
                renderCoverCanvas();
              } else if (pn !== null) {
                if (!editor.pageObjects) editor.pageObjects = {};
                if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
                editor.pageObjects[pn].push(lineObj);
                renderBuilderCanvas();
              }
            };

            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp, { once: true });
            // Capture phase + stopPropagation: in line mode the press belongs to the
            // line, not to whatever object happens to be under the finger.
            downEvt.preventDefault();
            downEvt.stopPropagation();
          };

          document.addEventListener("pointerdown", startLineDraw, true);
        } else {
          // All other shapes: add immediately at centre of canvas
          insertShapeIntoActivePage(shapeType);
        }
      });
    });
  })();

  if (canvasLayersBtn) {
    canvasLayersBtn.addEventListener("click", () => {
      const msg = document.getElementById("saveMsg");
      if (msg) {
        msg.textContent = "Layers panel is not active yet.";
        msg.style.display = "block";
        setTimeout(() => { msg.style.display = "none"; }, 1400);
      }
    });
  }

  if (canvasDeleteBtn) {
    canvasDeleteBtn.addEventListener("click", () => {
      if (selectedTextNode) {
        const node = selectedTextNode;
        hideTextToolbar();
        node.remove();
        return;
      }

      if (selectedFrameObject) {
        pushUndoState("Delete Frame");
        deleteFrameObjectByTarget(
          selectedFrameObject.targetType,
          selectedFrameObject.pageNumber,
          selectedFrameObject.zone,
          selectedFrameObject.id
        );
        hideFrameToolbar();
        renderBuilderCanvas();
        return;
      }

      const msg = document.getElementById("saveMsg");
      if (msg) {
        msg.textContent = "Select a text or frame first.";
        msg.style.display = "block";
        setTimeout(() => { msg.style.display = "none"; }, 1400);
      }
    });
  }


  // ── Per-batch photo limit + "add more" callout ────────────────────────────
  // Photos are added in batches of at most _DMB_BATCH_LIMIT. This keeps each
  // upload light (the compress/decode loop only ever handles a small set at once)
  // and makes big libraries additive instead of one huge, memory-heavy drop. When
  // a selection exceeds the limit we keep the first N and tell the customer to add
  // the rest in another batch, then point them at the "Add photos" button.
  const _DMB_BATCH_LIMIT = 30;

  function _dmbToast(msg, ms) {
    try {
      const el = document.createElement("div");
      el.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:1000002;background:#1e1e1e;color:#fff;border-radius:12px;padding:12px 18px;max-width:90vw;font-size:14px;font-weight:700;line-height:1.4;box-shadow:0 10px 40px rgba(0,0,0,.35);text-align:center;";
      el.textContent = msg;
      document.body.appendChild(el);
      setTimeout(() => { try { el.remove(); } catch (e) {} }, ms || 4200);
    } catch (e) {}
  }

  // Is this the memory-constrained (phone) upload path? Matches compressFilesForMobile.
  function _dmbIsMobileUpload() {
    // Render mode is never the phone path. This is the ONLY gate on the print-master
    // branch in _dmbRenderImg, so a small headless viewport would otherwise render
    // PROXY quality silently, with no error and no signal.
    if (_dmbRenderMode()) return false;
    try { return window.innerWidth <= 749; } catch (e) { return false; }
  }

  // Cap a freshly-picked file list to the batch limit; warns if it trimmed some.
  // DESKTOP/LAPTOP: no limit — there's no memory crash there, so return everything.
  function _dmbCapBatch(arr) {
    const files = Array.from(arr || []);
    if (_dmbPrintMasterOn()) return files;                   // print-master path → no cap (imports in internal sub-batches)
    if (!_dmbIsMobileUpload()) return files;                 // laptop → unlimited batch
    if (files.length <= _DMB_BATCH_LIMIT) return files;
    const kept = files.slice(0, _DMB_BATCH_LIMIT);
    _dmbToast("You can add up to " + _DMB_BATCH_LIMIT + " photos at a time. The first " + _DMB_BATCH_LIMIT + " were added — tap “Add photos” again to add the rest.", 6500);
    return kept;
  }

  // "Tour-style" callout anchored to the visible Add-photos button, inviting the
  // customer to add another batch. Has an X to dismiss; auto-hides on its own.
  let _dmbAddMoreCalloutEl = null;
  function _dmbHideAddMoreCallout() {
    try { if (_dmbAddMoreCalloutEl) { _dmbAddMoreCalloutEl.remove(); _dmbAddMoreCalloutEl = null; } } catch (e) {}
  }
  function _dmbShowAddMoreCallout() {
    // The mobile shell has its own Photos tab for adding more photos, so this
    // floating callout (anchored to the old add-photos button) is redundant and
    // mis-positions over the new top bar — skip it ONLY inside the builder
    // (dmb-msh-fullscreen). It still shows on the upload-photos step.
    if (window.matchMedia && window.matchMedia("(max-width: 749px), (orientation: portrait) and (pointer: coarse) and (max-width: 1024px)").matches
        && document.body.classList.contains("dmb-msh-fullscreen")) return;
    try {
      _dmbHideAddMoreCallout();
      // Prefer whichever Add-photos control is visible right now.
      const cands = [document.getElementById("addMorePhotosBtn"), document.querySelector(".dmb-upload2-btn--primary")];
      let btn = null;
      for (const c of cands) { if (c && c.offsetParent !== null) { btn = c; break; } }
      if (!btn) btn = cands.find(Boolean);
      if (!btn) return;
      // Make sure the button (and the callout beneath it) are actually on screen.
      try { btn.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) {}
      // One-time pulse styles for the button so it visibly draws the eye.
      if (!document.getElementById("dmbAddMoreStyle")) {
        const st = document.createElement("style"); st.id = "dmbAddMoreStyle";
        st.textContent = "@keyframes dmbAddPulse{0%{box-shadow:0 0 0 0 rgba(74,144,226,.6)}70%{box-shadow:0 0 0 12px rgba(74,144,226,0)}100%{box-shadow:0 0 0 0 rgba(74,144,226,0)}}.dmb-add-pulse{animation:dmbAddPulse 1.3s ease-out 3}";
        document.head.appendChild(st);
      }
      try { btn.classList.add("dmb-add-pulse"); setTimeout(() => { try { btn.classList.remove("dmb-add-pulse"); } catch (e) {} }, 4200); } catch (e) {}
      const place = () => {
        if (!_dmbAddMoreCalloutEl) return;
        const r = btn.getBoundingClientRect();
        _dmbAddMoreCalloutEl.style.top  = Math.min(window.innerHeight - 70, r.bottom + 10) + "px";
        _dmbAddMoreCalloutEl.style.left = Math.max(8, Math.min(window.innerWidth - 236, r.left)) + "px";
      };
      const box = document.createElement("div");
      box.style.cssText = "position:fixed;z-index:1000003;background:#4a90e2;color:#fff;border-radius:12px;padding:12px 34px 12px 14px;font-size:14px;font-weight:800;box-shadow:0 8px 28px rgba(0,0,0,.4);max-width:230px;line-height:1.35;";
      box.textContent = "➕ Add more pictures";
      const arrow = document.createElement("div");
      arrow.style.cssText = "position:absolute;top:-7px;left:22px;width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #4a90e2;";
      box.appendChild(arrow);
      const x = document.createElement("button");
      x.type = "button"; x.textContent = "×"; x.setAttribute("aria-label", "Close");
      x.style.cssText = "position:absolute;top:3px;right:6px;background:transparent;border:none;color:#fff;font-size:19px;font-weight:900;cursor:pointer;line-height:1;padding:2px 4px;";
      x.addEventListener("click", (e) => { e.stopPropagation(); _dmbHideAddMoreCallout(); });
      box.appendChild(x);
      document.body.appendChild(box);
      _dmbAddMoreCalloutEl = box;
      place();
      const onMove = () => place();
      window.addEventListener("scroll", onMove, { passive: true });
      window.addEventListener("resize", onMove);
      // Tapping the button itself dismisses the callout.
      btn.addEventListener("click", _dmbHideAddMoreCallout, { once: true });
      setTimeout(_dmbHideAddMoreCallout, 20000);   // persist ~20s so it's not missed
    } catch (e) {}
  }

  // ── Blocking "Uploading pictures…" modal ──────────────────────────────────
  // Shown while a batch is compressed + streamed to the cloud. It CANNOT be
  // dismissed by hand: it closes itself when the batch's cloud upload finishes.
  // This forces one batch at a time — a second batch can't pile on while the
  // first is still in memory, which is what pushed the phone over its limit.
  let _dmbUploadModalEl = null;
  function _dmbShowUploadModal(msg) {
    try {
      if (!document.getElementById("dmbUplStyle")) {
        const st = document.createElement("style"); st.id = "dmbUplStyle";
        st.textContent = "@keyframes dmbUplSpin{to{transform:rotate(360deg)}}";
        document.head.appendChild(st);
      }
      if (_dmbUploadModalEl) { _dmbSetUploadModalMsg(msg); return; }
      const ov = document.createElement("div");
      ov.setAttribute("role", "alertdialog");
      ov.style.cssText = "position:fixed;inset:0;z-index:1000010;background:rgba(15,17,22,.72);display:flex;align-items:center;justify-content:center;touch-action:none;";
      // Swallow taps so nothing behind the modal (incl. the file button) is usable.
      ov.addEventListener("click", (e) => { e.stopPropagation(); e.preventDefault(); }, true);
      ov.addEventListener("touchstart", (e) => { e.stopPropagation(); }, true);
      const card = document.createElement("div");
      card.style.cssText = "background:#fff;border-radius:16px;padding:26px 24px 22px;max-width:84vw;width:320px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.45);";
      card.innerHTML =
        '<div style="width:44px;height:44px;margin:0 auto 16px;border:4px solid #e6e9ef;border-top-color:#4a90e2;border-radius:50%;animation:dmbUplSpin .9s linear infinite;"></div>'
        + '<div class="dmb-upl-msg" style="font-size:16px;font-weight:800;color:#1e1e1e;">' + (msg || "Uploading your pictures…") + '</div>'
        + '<div style="margin-top:8px;font-size:13px;color:#666;font-weight:600;line-height:1.4;">Keep this page open. You can add more once this finishes.</div>';
      ov.appendChild(card);
      document.body.appendChild(ov);
      _dmbUploadModalEl = ov;
    } catch (e) {}
  }
  function _dmbSetUploadModalMsg(msg) {
    try { if (_dmbUploadModalEl && msg) { const m = _dmbUploadModalEl.querySelector(".dmb-upl-msg"); if (m) m.textContent = msg; } } catch (e) {}
  }
  function _dmbHideUploadModal() {
    try { if (_dmbUploadModalEl) { _dmbUploadModalEl.remove(); _dmbUploadModalEl = null; } } catch (e) {}
  }

  // One-time (per session) heads-up shown when the customer lands on the upload
  // step, so they know photos go in batches of 30 before they start selecting.
  function _dmbShowLimitNotice() {
    if (!_dmbIsMobileUpload()) return;                       // no batch limit on laptop → no notice
    if (_dmbPrintMasterOn()) return;                         // print-master path has no 30-cap → no notice
    try { if (sessionStorage.getItem("dmb_limit_notice_seen") === "1") return; } catch (e) {}
    try {
      if (document.getElementById("dmbLimitNotice")) return;
      const ov = document.createElement("div");
      ov.id = "dmbLimitNotice";
      ov.style.cssText = "position:fixed;inset:0;z-index:1000009;background:rgba(15,17,22,.6);display:flex;align-items:center;justify-content:center;padding:16px;";
      const card = document.createElement("div");
      card.style.cssText = "background:#fff;border-radius:16px;padding:24px 22px 20px;max-width:340px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.4);";
      card.innerHTML =
        '<div style="font-size:34px;margin-bottom:8px;">📸</div>'
        + '<div style="font-size:17px;font-weight:900;color:#1e1e1e;margin-bottom:8px;">Add up to 30 photos at a time</div>'
        + '<div style="font-size:14px;color:#555;font-weight:600;line-height:1.45;">Pick up to 30 photos and we\'ll upload them. When they\'re done, tap <b>Add photos</b> again for the next batch — as many batches as you like.</div>';
      const btn = document.createElement("button");
      btn.type = "button"; btn.textContent = "Got it";
      btn.style.cssText = "margin-top:18px;background:#4a90e2;color:#fff;border:none;border-radius:10px;padding:12px 26px;font-size:15px;font-weight:800;cursor:pointer;width:100%;";
      const close = () => { try { sessionStorage.setItem("dmb_limit_notice_seen", "1"); } catch (e) {} try { ov.remove(); } catch (e) {} };
      btn.addEventListener("click", close);
      card.appendChild(btn);
      ov.appendChild(card);
      document.body.appendChild(ov);
    } catch (e) {}
  }

  // Wait until this batch's photos have finished streaming to R2 (instant backup
  // queue drained), so we only let the customer add more once memory is clear.
  // Time-boxed so a stalled network can never trap them behind the modal.
  async function _dmbWaitForBatchUpload(maxMs) {
    maxMs = maxMs || 90000;
    const start = Date.now();
    while (Date.now() - start < maxMs) {
      let pending = 0;
      try { pending = _dmbInstantBackup.pending(); } catch (e) { pending = 0; }
      try {
        const done = _dmbInstantBackup._done || 0, total = _dmbInstantBackup._total || 0;
        if (total > 0) _dmbSetUploadModalMsg("Uploading your pictures… " + Math.min(done, total) + " / " + total);
      } catch (e) {}
      if (!pending) break;
      await new Promise((r) => setTimeout(r, 350));
    }
  }

  document.addEventListener("change", async (e) => {
    const fileInput = e.target.closest("#bookPhotos, #step1bFileInput");
    const cameraInput = e.target.closest("#cameraPhotos, #step1bCameraInput");

    // The batch limit + blocking upload modal are ONLY for phones (the memory-
    // constrained path). On a laptop there's no cap and no blocking popup.
    const _mob = _dmbIsMobileUpload();

    if (fileInput) {
      // PRINT-MASTER phone path (flag-gated): no user-facing cap. The whole pick is
      // processed in internal sub-batches of _DMB_MASTER_SUBBATCH so only a handful
      // of photos are ever decoded / resident at once — each sub-batch is derived
      // (master+proxy), merged, streamed to R2, then its distant full-res released
      // before the next sub-batch starts. Same one blocking modal for the whole pick.
      if (_mob && _dmbPrintMasterOn()) {
        const all = Array.from(fileInput.files || []);
        if (!all.length) return;
        _dmbShowUploadModal("Uploading your pictures…");
        try {
          for (let i = 0; i < all.length; i += _DMB_MASTER_SUBBATCH) {
            const chunk = all.slice(i, i + _DMB_MASTER_SUBBATCH);
            const picked = await compressFilesForMobile(chunk);   // flag branch → derivatives
            bookFiles = mergeFilesKeepOld(bookFiles, picked);
            validatePhotos();
            renderUploadGrid();
            refreshBuilderPhotos();
            try { _dmbCloud.queueMasters(editor.photos || []); } catch (e) {}   // signed-in: masters start now
            await _dmbWaitForBatchUpload();          // drain THIS sub-batch's proxies to R2
            // Proactively release full-res of everything R2-confirmed and off-spread,
            // so residency stays ~one sub-batch deep no matter how many were picked.
            try { _dmbLastReleaseSpread = -999; _dmbMaybeReleaseForSpread(); } catch (e2) {}
          }
          try { syncInputFiles(fileInput, bookFiles); } catch (e2) {}
          await tryAutoOpenEditor();
        } finally {
          _dmbHideUploadModal(); _dmbShowAddMoreCallout();
        }
        return;
      }

      // Phone: cap to the batch limit AND immediately trim the input down to those
      // files, so any extra originals the OS picker returned (e.g. 45 selected → 15
      // extra, up to ~10 MB each) are released BEFORE we decode anything.
      const kept = _dmbCapBatch(fileInput.files);   // laptop → returns everything
      if (_mob) { try { syncInputFiles(fileInput, kept); } catch (e2) {} _dmbShowUploadModal("Uploading your pictures…"); }
      try {
        const picked = await compressFilesForMobile(kept);
        bookFiles = mergeFilesKeepOld(bookFiles, picked);
        syncInputFiles(fileInput, bookFiles);
        validatePhotos();
        renderUploadGrid();
        refreshBuilderPhotos();
        if (_mob) await _dmbWaitForBatchUpload();   // hold the modal until this batch is safely on R2
        await tryAutoOpenEditor();
      } finally {
        if (_mob) { _dmbHideUploadModal(); _dmbShowAddMoreCallout(); }
      }
      return;
    }

    if (cameraInput) {
      const kept = _dmbCapBatch(cameraInput.files);
      if (_mob) _dmbShowUploadModal("Uploading your picture…");
      try {
        const picked = await compressFilesForMobile(kept);
        bookFiles = mergeFilesKeepOld(bookFiles, picked);
        validatePhotos();
        renderUploadGrid();
        refreshBuilderPhotos();
        if (_mob) await _dmbWaitForBatchUpload();
        await tryAutoOpenEditor();
      } finally {
        if (_mob) { _dmbHideUploadModal(); _dmbShowAddMoreCallout(); }
      }
    }
  });


  // ---- Drag & Drop zone in step 1b (Upload Your Photos page) ----
  const step1bDragZone = document.getElementById("step1bDragDropZone");
  if (step1bDragZone) {
    step1bDragZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      step1bDragZone.classList.add("drag-over");
    });
    step1bDragZone.addEventListener("dragleave", () => {
      step1bDragZone.classList.remove("drag-over");
    });
    step1bDragZone.addEventListener("drop", async (e) => {
      e.preventDefault();
      step1bDragZone.classList.remove("drag-over");
      let files = _dmbCapBatch(Array.from(e.dataTransfer?.files || []).filter(f => f.type.startsWith("image/")));
      if (!files.length) return;
      // Print-master flag: dropped files get master+proxy derivatives too, so a
      // master exists for every photo no matter which entry path it used.
      if (_dmbPrintMasterOn()) { try { files = await compressFilesForMobile(files); } catch (e2) {} }
      bookFiles = mergeFilesKeepOld(bookFiles, files);
      validatePhotos();
      renderUploadGrid();
      refreshBuilderPhotos();
      _dmbShowAddMoreCallout();
    });
    step1bDragZone.addEventListener("click", () => {
      const input = document.getElementById("step1bFileInput");
      if (input) input.click();
    });
  }

  // ---- Drag & Drop zone inside "Add more photos" popup (builder) ----
  const builderDragDropZone = document.getElementById("builderDragDropZone");
  if (builderDragDropZone) {
    builderDragDropZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      builderDragDropZone.classList.add("drag-over");
    });
    builderDragDropZone.addEventListener("dragleave", () => {
      builderDragDropZone.classList.remove("drag-over");
    });
    builderDragDropZone.addEventListener("drop", async (e) => {
      e.preventDefault();
      builderDragDropZone.classList.remove("drag-over");
      const menu = document.getElementById("photoImportMenu");
      if (menu) menu.style.display = "none";
      let files = _dmbCapBatch(Array.from(e.dataTransfer?.files || []).filter(f => f.type.startsWith("image/")));
      if (!files.length) return;
      // Print-master flag: dropped files get master+proxy derivatives too (see step1b zone).
      if (_dmbPrintMasterOn()) { try { files = await compressFilesForMobile(files); } catch (e2) {} }
      bookFiles = mergeFilesKeepOld(bookFiles, files);
      // Keep the counter and the tray in step. The phone-relay path went the
      // other way round (counter only) and photos silently never appeared.
      try { validatePhotos(); } catch (e2) {}
      refreshBuilderPhotos();
      _dmbShowAddMoreCallout();
    });
  }

  // ---- Scroll arrow for step 1b: show when footer scrolls out of view ----
  // Show/hide the "↓ Select Pages & Continue" cue. Looks up elements live so it
  // can be called the instant photos are uploaded (renderUploadGrid) — not only
  // when the IntersectionObserver happens to fire, which is what made it lag.
  function _dmbUpdateScrollArrow() {
    const btn = document.getElementById("dmbScrollArrowBtn");
    const footer = document.getElementById("step1bFooter");
    const step1bEl = document.getElementById("step1b");
    if (!btn || !footer) return;
    const isStep1bVisible = step1bEl && step1bEl.style.display !== "none";
    const hasPhotos = bookFiles.length > 0;
    const r = footer.getBoundingClientRect();
    const footerVisible = r.top < window.innerHeight && r.bottom > 0;
    btn.style.display = (isStep1bVisible && hasPhotos && !footerVisible) ? "flex" : "none";
  }

  const step1bFooter = document.getElementById("step1bFooter");
  const dmbScrollArrowBtn = document.getElementById("dmbScrollArrowBtn");

  if (step1bFooter && dmbScrollArrowBtn) {
    dmbScrollArrowBtn.addEventListener("click", () => {
      step1bFooter.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    new IntersectionObserver(_dmbUpdateScrollArrow, { threshold: 0.5 }).observe(step1bFooter);
    window.addEventListener("scroll", _dmbUpdateScrollArrow, { passive: true });
  }

  window.__dmbDebug = {
    getState: () => ({
      pagesValue: pagesEl?.value,
      totalPages: editor.totalPages,
      totalSpreads: editor.totalSpreads,
      currentSpread: editor.currentSpread,
      builderMode,
      photos: editor.photos?.length || 0,
      step1: step1?.style.display,
      step2: builderStep?.style.display
    })
  };
  try { initPhoneUpload(); } catch (_) {}

  document.addEventListener("click", async (e) => {
    const addBtn = e.target.closest("#addMorePhotosBtn");
    const deviceBtn = e.target.closest("#importDeviceBtn");
    const cameraBtn = e.target.closest("#importCameraBtn");
    const projectBtn = e.target.closest("#projectMenuBtn");
    const historyBtn = e.target.closest("#historyBtn");

    const menu = $("photoImportMenu");
    const bookInput = $("bookPhotos");
    const cameraInput = $("cameraPhotos");

    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) {
        if (menu.style.display === "block") {
          menu.style.display = "none";
        } else {
          const rect = addBtn.getBoundingClientRect();
          menu.style.top = (rect.bottom + 4) + "px";
          menu.style.left = rect.left + "px";
          menu.style.width = rect.width + "px";
          menu.style.display = "block";
        }
      }
      return;
    }

    if (deviceBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) menu.style.display = "none";
      if (bookInput) bookInput.click();
      return;
    }

    if (cameraBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) menu.style.display = "none";
      if (cameraInput) cameraInput.click();
      return;
    }

    if (projectBtn) {
      e.preventDefault();
      e.stopPropagation();
      openProjectMenuPrompt();
      return;
    }

    if (historyBtn) {
      e.preventDefault();
      e.stopPropagation();
      openHistoryPanel();
      return;
    }
    if (menu && !e.target.closest("#photoImportMenu")) {
      menu.style.display = "none";
    }
  }, true);
document.addEventListener("click", (e) => {
  const mirror = e.target.closest(".dmb-tool-mirror");
  if (!mirror) return;

  lastToolbarSide = "right";
  const targetSelector = mirror.getAttribute("data-click");
  const realBtn = targetSelector ? document.querySelector(targetSelector) : null;
  if (realBtn) realBtn.click();
  lastToolbarSide = "left";
});

document.addEventListener("click", (e) => {
  const inFrame = e.target.closest(".dmb-photo-frame-object");
  const inFrameToolbar = e.target.closest("#dmbFrameToolbar");
  if (!inFrame && !inFrameToolbar) {
    hideFrameToolbar();
  }
});

// ======= UPLOAD STEP =======
// Upload-grid thumbnails through a SERIAL queue of small (320px) thumbs — the
// grid used to hand the <img> the full-resolution file, so a phone decoded
// every full-size photo at once just to paint 70px squares. That decode spike
// is the main "tab crashed and reloaded" trigger during upload. One decode at
// a time, cached per file, keeps memory flat.
const _dmbUpThumbCache = new Map();
const _dmbUpThumbQ = [];
let _dmbUpThumbBusy = false;
function _dmbUploadThumb(file, img) {
  const hit = _dmbUpThumbCache.get(file);
  if (hit) { img.src = hit; return; }
  _dmbUpThumbQ.push([file, img]);
  if (_dmbUpThumbBusy) return;
  _dmbUpThumbBusy = true;
  (async () => {
    while (_dmbUpThumbQ.length) {
      const [f, el] = _dmbUpThumbQ.shift();
      let url = _dmbUpThumbCache.get(f);
      if (!url) {
        // HARD TIMEOUT: a file the browser can't decode (e.g. HEIC on Windows)
        // must never hang the queue — that would leave every later photo's
        // thumbnail blank and look like the photos "never arrived".
        try {
          const b = await Promise.race([
            _dmbMakeThumbBlob(f, 320),
            new Promise((r) => setTimeout(() => r(null), 4000)),
          ]);
          if (b) url = URL.createObjectURL(b);
        } catch (e) {}
        if (!url) { try { url = URL.createObjectURL(f); } catch (e) {} }   // fallback: original
        if (url) _dmbUpThumbCache.set(f, url);
      }
      if (url) el.src = url;
      await new Promise((r) => setTimeout(r, 25));   // yield between decodes
    }
    _dmbUpThumbBusy = false;
  })();
}

function renderUploadGrid() {
  const grid = document.getElementById("uploadPhotoGrid");
  const countEl = document.getElementById("uploadPhotoCount");
  if (!grid) return;

  grid.innerHTML = "";
  const count = bookFiles.length;

  if (countEl) {
    countEl.style.display = count ? "block" : "none";
    countEl.textContent = count ? `${count} photo${count !== 1 ? "s" : ""} selected` : "";
  }

  // Update the "↓ Select Pages & Continue" cue right away when photos change.
  if (typeof _dmbUpdateScrollArrow === "function") _dmbUpdateScrollArrow();

  // When photos are newly added, briefly flash a slim black "belt" around the size
  // selector for 600ms to nudge the customer to pick a size. Debounced: phone
  // uploads drip photos in one at a time (a renderUploadGrid call per arrival), and
  // without this guard the belt would re-flash on every single photo, looking like a
  // persistent flickering black box. One flash per burst is all the nudge needs.
  if (count > (renderUploadGrid._prevCount || 0)) {
    const _now = Date.now();
    if (_now - (renderUploadGrid._lastFlash || 0) > 4000) {
      renderUploadGrid._lastFlash = _now;
      const _sizeSel = document.getElementById("step1bPages");
      if (_sizeSel) {
        _sizeSel.classList.add("dmb-belt-flash");
        setTimeout(() => { _sizeSel.classList.remove("dmb-belt-flash"); }, 600);
      }
    }
  }
  renderUploadGrid._prevCount = count;

  bookFiles.forEach((file, idx) => {
    const thumb = document.createElement("div");
    thumb.className = "dmb-upload-grid-thumb";

    const img = document.createElement("img");
    img.alt = "";
    img.decoding = "async";
    thumb.appendChild(img);
    _dmbUploadThumb(file, img);   // serial small-thumb queue (memory-safe)

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "dmb-upload-grid-thumb-remove";
    removeBtn.setAttribute("aria-label", "Remove photo");
    removeBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6l-12 12"/></svg>`;
    removeBtn.addEventListener("click", () => {
      const _rf = bookFiles[idx];
      bookFiles.splice(idx, 1);
      // Deleted photo shouldn't come back in a crash-restore.
      try { if (_rf && _rf._dmbPid) _dmbInstantBackup.removeFromManifest(_rf._dmbPid); } catch (e) {}
      renderUploadGrid();
    });
    thumb.appendChild(removeBtn);

    grid.appendChild(thumb);
  });
}

document.addEventListener("click", async (e) => {
  if (e.target.closest("#backToHomeBtn")) {
    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "none";
    if (step1) step1.style.display = "flex";
    return;
  }

  if (e.target.closest(".dmb-mag-template-btn")) {
    const btn = e.target.closest(".dmb-mag-template-btn");
    const handle = btn.dataset.handle;

    // Check if there's a saved design for this template
    const _savedKey = handle ? "dmb_progress_mag_" + handle : null;
    const _hasSave  = _savedKey ? !!localStorage.getItem(_savedKey) : false;

    if (_hasSave) {
      // Ask: continue or start fresh
      showChoiceDialog(
        "You have a saved design",
        "We found a saved version of this magazine. Would you like to pick up where you left off?",
        [
          { id: "continue", label: "📂 Continue editing" },
          { id: "new",      label: "🆕 Start fresh" }
        ]
      ).then(choice => {
        if (!choice || choice === "new") {
          // Clear saved progress and go to upload
          try { localStorage.removeItem(_savedKey); } catch(er) {}
          _clearPhotosFromIDB(_savedKey).catch(() => {});
          if (handle) sessionStorage.setItem("dmb_mag_template", handle);
          window.location.href = handle
            ? "/pages/design-my-magazine?step=upload&cover=" + encodeURIComponent(handle)
            : "/pages/design-my-magazine?step=upload";
        } else {
          // Restore directly — skip upload
          if (handle) sessionStorage.setItem("dmb_mag_template", handle);
          window.location.href = handle
            ? "/pages/design-my-magazine?template=" + encodeURIComponent(handle) + "&restore=1"
            : "/pages/design-my-magazine?restore=1";
        }
      });
      return;
    }

    // No saved design — go straight to upload as before
    if (handle) sessionStorage.setItem("dmb_mag_template", handle);
    window.location.href = handle
      ? "/pages/design-my-magazine?step=upload&cover=" + encodeURIComponent(handle)
      : "/pages/design-my-magazine?step=upload";
    return;
  }

  if (e.target.closest("#continueToBuilderBtn")) {
    // In magazine mode the IIFE handler already manages the flow
    if (window.DMB_MAGAZINE_MODE) return;

    const errEl = document.getElementById("uploadStepError");
    const pagesSel = document.getElementById("step1bPages");

    if (!pagesSel?.value) {
      if (errEl) { errEl.textContent = "Please select the number of pages for your book."; errEl.style.display = "block"; }
      return;
    }
    if (errEl) errEl.style.display = "none";

    if (pagesEl) pagesEl.value = pagesSel.value;

    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "none";
    if (step1) step1.style.display = "none";
    if (builderStep) builderStep.style.display = "block";

    try {
      await openEditor();
    } catch (err) {
      console.error("openEditor failed:", err);
      if (s1b) s1b.style.display = "flex";
      if (builderStep) builderStep.style.display = "none";
      if (errEl) { errEl.textContent = "Something went wrong opening the builder. Check the console for details."; errEl.style.display = "block"; }
    }
    return;
  }
});

  /* ═══════════════════════════════════════════════════════════════════════════
   * STEP 2 — SERVER RENDER MODE (window.DMB_RENDER_MODE)
   * Reconstructs a design from a job token and drives the SAME canvas PDF engine
   * customers use (buildPdfBlobOnePagePerBookPage via __dmbBuildPdfStreaming), fed
   * from the 3500px print masters. No UI, no storage, no cloud writes, no history.
   * Everything here is inert unless the render snippet armed the flag.
   * ═════════════════════════════════════════════════════════════════════════ */

  function _dmbRenderSignal(phase, done, total) {
    try {
      window.__DMB_RENDER_PROGRESS = { phase: phase, done: done || 0, total: total || 0,
        staged: _DMB_RM.staged, part: _DMB_RM.part, ts: Date.now() };
    } catch (e) {}
  }
  // Liveness beat: the cover spread can run for minutes without emitting progress.
  // A moving ts with frozen done/staged = "alive but slow"; a frozen ts = main thread
  // gone. The renderer distinguishes the two.
  function _dmbRenderBeat(on) {
    try { if (_DMB_RM.hb) { clearInterval(_DMB_RM.hb); _DMB_RM.hb = null; } } catch (e) {}
    if (!on) return;
    _DMB_RM.hb = setInterval(function () {
      try {
        var p = window.__DMB_RENDER_PROGRESS;
        if (p) { p.ts = Date.now(); window.__DMB_RENDER_PROGRESS = p; }
      } catch (e) {}
    }, 2000);
  }
  async function _dmbRenderPost(path, body) {
    try {
      var r = await fetch(_DMB_RM.proxy + path + "?t=" + encodeURIComponent(_DMB_RM.token), {
        method: "POST", headers: { "content-type": "application/json" },
        credentials: "same-origin", body: JSON.stringify(body || {}),
      });
      return r.ok ? (await r.json().catch(function () { return {}; })) : null;
    } catch (e) { return null; }
  }
  async function _dmbRenderSha256(blob) {
    try {
      var buf = await blob.arrayBuffer();
      var h = await crypto.subtle.digest("SHA-256", buf);
      return { sha256: Array.from(new Uint8Array(h)).map(function (x) { return x.toString(16).padStart(2, "0"); }).join(""),
               bytes: buf.byteLength };
    } catch (e) { return { sha256: "", bytes: 0 }; }
  }

  /* ── Fonts: never render silently in a fallback face ───────────────────────
   * The engine force-loads a fixed family list inside Promise.allSettled + try/catch,
   * so a 404 renders the whole book in sans-serif and reports success. Render mode
   * verifies every family the DESIGN actually uses and FAILS the job instead — a book
   * printed in the wrong font is worse than a failed job, and a failed job falls back
   * to the client pipeline, which has the fonts. */
  var _DMB_RM_WEBFONTS = ["Londrina Solid","Aurelia","Burbank Big Condensed","White Garden Wide",
    "Vogue Moderne","GFS Didot","Prata","Theano Didot","Lindys Diner","Chomsky","Anton","70s Disco",
    "Geraldine","Lemon Drops","Mouldy Cheese","Nature Beauty","Super Maples","The Heart of Everything",
    "Tomatoes","Wedding Day"];   // must match the @font-face list in design-my-book.css
  function _dmbRenderFamilyOf(v) {
    return String(v || "").split(",")[0].trim().replace(/^['"]|['"]$/g, "");
  }
  function _dmbRenderCollectFaces() {
    var out = {};
    function add(fam, w) {
      var f = _dmbRenderFamilyOf(fam) || "Londrina Solid";
      var wt = String(parseInt(w, 10) || 800);
      out[f + "|" + wt] = { family: f, weight: wt };
      out[f + "|800"]   = { family: f, weight: "800" };   // the engine force-loads 800 too
    }
    try { Object.keys(coverState.textStyles || {}).forEach(function (k) {
      var s = coverState.textStyles[k] || {}; add(s.fontFamily, s.fontWeight);
    }); } catch (e) {}
    try { (editor.coverObjects || []).forEach(function (o) {
      if (o && o.type === "text") add(o.fontFamily, o.fontWeight);
    }); } catch (e) {}
    try { Object.keys(editor.pageObjects || {}).forEach(function (p) {
      (editor.pageObjects[p] || []).forEach(function (o) {
        if (o && o.type === "text") add(o.fontFamily, o.fontWeight);
      });
    }); } catch (e) {}
    add("Londrina Solid", 800);
    return Object.keys(out).map(function (k) { return out[k]; });
  }
  // Metric probe: a family that resolved to the last-resort fallback measures exactly
  // like a guaranteed-missing family. Works for system fonts, which fonts.check cannot
  // prove (they have no @font-face).
  function _dmbRenderFontAvailable(familyQuoted, weight) {
    try {
      var c = document.createElement("canvas").getContext("2d");
      var S = "MNwi@1lIO0Wm-gj";
      c.font = weight + " 72px 'dmb__missing__'";
      var base = c.measureText(S).width;
      c.font = weight + " 72px " + familyQuoted + ", 'dmb__missing__'";
      return Math.abs(c.measureText(S).width - base) > 0.5;
    } catch (e) { return true; }
  }
  async function _dmbRenderFontGate() {
    var faces = _dmbRenderCollectFaces();
    try { await Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 20000); })]); } catch (e) {}
    for (var i = 0; i < faces.length; i++) {
      var f = faces[i], q = '"' + f.family + '"', spec = f.weight + " 40px " + q;
      if (_DMB_RM_WEBFONTS.indexOf(f.family) >= 0) {
        try {
          await Promise.race([document.fonts.load(spec),
            new Promise(function (_, rej) { setTimeout(function () { rej(new Error("font timeout")); }, 15000); })]);
        } catch (e) {}
      }
      var ok = false;
      try { ok = document.fonts.check(spec) || document.fonts.check("40px " + q); } catch (e) {}
      if (!ok) ok = _dmbRenderFontAvailable(q, f.weight);
      var label = f.weight + " " + f.family;
      if (ok) { _DMB_RM.fonts.loaded.push(label); }
      else if (_DMB_RM_WEBFONTS.indexOf(f.family) >= 0) { _DMB_RM.fonts.missing.push(label); }
      else { _DMB_RM.fonts.system.push(label); }   // container substitute; warn, don't fail
    }
    try { await document.fonts.ready; } catch (e) {}
    if (_DMB_RM.fonts.missing.length && window.DMB_RENDER_STRICT_FONTS !== false) {
      throw new Error("fonts_missing: " + _DMB_RM.fonts.missing.join(", "));
    }
  }

  /* ── Derived crops: re-bake from the SOURCE master + editor.cropRects ──────
   * cropRects ratios are of the ORIENTED image the crop modal displayed (an <img>,
   * so EXIF was applied) — decode with imageOrientation:"from-image" or an
   * EXIF-rotated original crops the wrong region. Same drawImage + toBlob(0.92)
   * recipe as applyCrop. */
  async function _dmbRenderCropDerivedImg(ph) {
    var rect = null;
    try { rect = (editor.cropRects || {})[ph.id]; } catch (e) {}
    var src = (rect && rect.srcPid) || _dmbCropSourceId(ph.id);
    if (!rect || !src || !(rect.w > 0) || !(rect.h > 0)) { _dmbRenderNote("crop_fallback", ph.id); return null; }
    var blob = await _dmbFetchPhotoBlob(_DMB_RM.job, src, "master");
    if (!blob || !blob.size) blob = await _dmbFetchPhotoBlob(_DMB_RM.job, src);
    if (!blob || !blob.size) { _dmbRenderNote("crop_fallback", ph.id); return null; }
    var bmp = await createImageBitmap(blob, { imageOrientation: "from-image" });
    var sw = Math.max(1, Math.round(rect.w * bmp.width));
    var sh = Math.max(1, Math.round(rect.h * bmp.height));
    var c = document.createElement("canvas");
    c.width = sw; c.height = sh;
    var cx = c.getContext("2d");
    cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = "high";
    cx.drawImage(bmp, Math.round(rect.x * bmp.width), Math.round(rect.y * bmp.height), sw, sh, 0, 0, sw, sh);
    try { bmp.close(); } catch (e) {}
    var out = await new Promise(function (res) { c.toBlob(res, "image/jpeg", 0.92); });
    try { c.width = 0; c.height = 0; } catch (e) {}
    if (!out) { _dmbRenderNote("crop_fallback", ph.id); return null; }
    var u = URL.createObjectURL(out), img = new Image();
    img.decoding = "async";
    await new Promise(function (res, rej) {
      img.onload  = function () { res(); };
      img.onerror = function () { rej(new Error("crop decode failed")); };
      img.src = u;
    });
    try { URL.revokeObjectURL(u); } catch (e) {}
    _dmbRenderNote("crop_rebake");
    return img;
  }

  /* ── State helpers ────────────────────────────────────────────────────────── */
  function _dmbRenderEnsurePageOption(n) {
    if (!n) return;
    ["pages", "step1bPages"].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var has = false;
      for (var i = 0; i < el.options.length; i++) if (Number(el.options[i].value) === Number(n)) has = true;
      if (!has) {   // page count no longer a product variant → openEditor bails SILENTLY at 21919
        var o = document.createElement("option");
        o.value = String(n); o.textContent = String(n);
        el.appendChild(o);
      }
      el.value = String(n);
    });
  }
  // LAZY photo records — ids + meta only. Bytes stay on R2; _dmbRenderImg streams each
  // master on demand and the engine frees it per page, so a 300-photo book never bulk-
  // downloads anything. Shape copied from the builder's own cloud-reconcile branch.
  function _dmbRenderBuildLazyPhotos(meta) {
    var man = (meta && Array.isArray(meta.photos) && meta.photos.length) ? meta.photos
      : ((meta && Array.isArray(meta.photoIds)) ? meta.photoIds.map(function (id) { return { id: id }; }) : []);
    var byId = {}, order = [];
    man.forEach(function (m) { if (m && m.id && !byId[m.id]) { byId[m.id] = m; order.push(m.id); } });
    // A referenced id with NO record makes getPhotoById return null and the placement
    // is dropped silently — never let that happen.
    try {
      _dmbCollectReferencedPhotoIds().forEach(function (id) {
        if (id && !byId[id]) { byId[id] = { id: id }; order.push(id); }
      });
    } catch (e) {}
    var out = order.map(function (id, i) {
      var m = byId[id] || {};
      return { id: id, file: null, url: "", _r2: true,
        ratio: (typeof m.ratio === "number" && m.ratio > 0) ? m.ratio : 1,
        filename: m.filename || "photo.jpg", dateTaken: m.dateTaken || "",
        tags: Array.isArray(m.tags) ? m.tags : [],
        addedIndex: (typeof m.addedIndex === "number") ? m.addedIndex : i };
    });
    out.sort(function (a, b) { return (a.addedIndex || 0) - (b.addedIndex || 0); });
    editor.photos = out;
    try { bookFiles = out.map(function (p) { return new File([], p.filename || "photo"); }); } catch (e) {}
    return out.length;
  }

  /* ── Boot ─────────────────────────────────────────────────────────────────── */
  async function _dmbRenderModeBoot() {
    // Called during module evaluation: yield ONE macrotask so every later declaration
    // (and window.__dmbBuildPdfStreaming) exists before this body runs.
    await new Promise(function (r) { setTimeout(r, 0); });
    var t0 = Date.now();
    _dmbRenderBeat(true);
    try {
      var q = new URLSearchParams(location.search);
      _DMB_RM.token = (q.get("t") || "").trim();
      _DMB_RM.proxy = window.DMB_DESIGNS_PROXY || "/apps/designs";
      if (!/^[a-f0-9]{32}$/.test(_DMB_RM.token)) throw new Error("bad render token");
      window.__DMB_RENDER_TOKEN = _DMB_RM.token;
      _DMB_RM.hash = q.get("hash") === "1";
      window.__DMB_RENDER_LIVETEXT = q.get("livetext") === "1";
      _DMB_RM.part  = Math.max(0, Number(q.get("part")  || 0) || 0);
      _DMB_RM.parts = Math.max(1, Number(q.get("parts") || 1) || 1);
      var rg = String(q.get("pages") || "").match(/^(\d{1,4})-(\d{1,4})$/);
      if (rg) { _DMB_RM.from = Number(rg[1]); _DMB_RM.to = Number(rg[2]); }

      /* 1 ── design + photo meta + job params, TOKEN ONLY */
      _dmbRenderSignal("load", 0, 0);
      // Three separate reads on purpose: /render-design streams the RAW design body
      // through (the R2 copy keeps sticker crop base64 INLINE, so it can be tens of MB
      // and must never be parsed + re-stringified inside the Worker isolate), while
      // meta and the job facts are small.
      var _rq = function (p) {
        return fetch(_DMB_RM.proxy + p + "?t=" + encodeURIComponent(_DMB_RM.token),
          { credentials: "same-origin", cache: "no-store" });
      };
      var rD = await _rq("/render-design");
      if (!rD.ok) throw new Error("render-design HTTP " + rD.status);
      var saved = await rD.json();
      var rI = await _rq("/render-info");
      if (!rI.ok) throw new Error("render-info HTTP " + rI.status);
      var jb = await rI.json();
      var meta = {};
      try { var rM = await _rq("/render-meta"); if (rM.ok) meta = await rM.json(); } catch (e) {}
      if (!saved || !saved.editor) throw new Error("design has no editor state");
      _DMB_RM.job = String(jb.job || meta.id || "");
      if (!_DMB_RM.job) throw new Error("no design id");
      window.__DMB_RENDER_JOB = _DMB_RM.job;      // getCustomerSaveKey() reads this
      _DMB_RM.crops = jb.crops === "rebake" ? "rebake" : "prefer-r2";
      // A magazine rendered on the book page silently produces the WRONG page order
      // and cover size — fail loudly instead.
      if (!!jb.magazine !== !!window.DMB_MAGAZINE_MODE) throw new Error("wrong page for this design");
      var ex = Array.isArray(jb.exclude) ? jb.exclude.map(Number).filter(function (n) { return isFinite(n) && n >= 1; }) : [];
      // Incremental render facts (both optional; absent = render everything, positional).
      _DMB_RM.fps   = (Array.isArray(jb.fps) && jb.fps.length) ? jb.fps.map(String) : null;
      _DMB_RM.reuse = (Array.isArray(jb.reuse) && jb.reuse.length) ? new Set(jb.reuse.map(Number)) : null;

      /* 2 ── #pages must hold the BASE count or openEditor() returns silently */
      var _se = saved.editor || {};
      var _pg = _se.totalPages || Number(saved.pages_selected) || 0;
      if (!_pg) throw new Error("design has no pages");
      var _base = Number(saved.pages_selected) || Math.max(0, _pg - (_se.extraSpreads || 0) * 2) || _pg;
      _dmbRenderEnsurePageOption(_base);
      editor.totalPages    = _pg;
      editor.editablePages = _se.editablePages || Math.max(0, _pg - 1);
      editor.totalSpreads  = _se.totalSpreads  || Math.max(1, Math.ceil(_pg / 2));

      /* 3 ── editor UI init (every side effect is render-mode gated) */
      _dmbRenderSignal("state", 0, 0);
      await openEditor({ skipStateReset: true });

      /* 4 ── state: the SAME code the ?restore=1 flow uses */
      _dmbApplySavedEditorState(saved);
      var nph = _dmbRenderBuildLazyPhotos(meta);
      try { _dmbRehydrateCoverPhotoUrls(); } catch (e) {}   // no-op for lazy records (url stays "")
      // Sticker/icon crop base64 is INLINE in the R2 design.json, so no IDB reattach.
      try { syncCoverInputsFromState(); } catch (e) {}

      /* 5 ── fonts BEFORE any measuring or cover render */
      _dmbRenderSignal("fonts", 0, 0);
      await _dmbRenderFontGate();

      /* 6 ── cover DOM (z-order + legacy fixed-layout conversion), then settle */
      _dmbRenderSignal("crops", 0, 0);
      setCanvasZoom(1);
      // COVER ONLY. renderBuilderCanvas() would dispatch to renderSpread, which
      // recomputes totalPages/editablePages/totalSpreads from the #pages DOM value -
      // and #pages holds the BASE count, so any design with extra spreads would render
      // SHORT. Interior pages are entirely state-driven and need no DOM.
      builderMode = "cover";
      try { renderCoverCanvas(); } catch (e) {}
      // Re-assert the counts in case anything above touched them.
      editor.totalPages    = _pg;
      editor.editablePages = _se.editablePages || Math.max(0, _pg - 1);
      editor.totalSpreads  = _se.totalSpreads  || Math.max(1, Math.ceil(_pg / 2));
      // NEVER await a paint unguarded. requestAnimationFrame does NOT fire while the
      // document is hidden or the instance is throttled, so a bare double-rAF await can
      // hang the whole job forever - verified live: document.hidden true, rAF never
      // fired, the render sat in phase "crops" with a healthy heartbeat. Same rule as
      // the img.decode() fix: settle on a timeout and carry on. Two frames are a
      // nice-to-have for layout settling, not a correctness requirement - the page
      // bytes come from canvas draws, not from anything painted on screen.
      await Promise.race([
        new Promise(function (res) { requestAnimationFrame(function () { requestAnimationFrame(res); }); }),
        new Promise(function (res) { setTimeout(res, 1500); }),
      ]);
      try {
        await Promise.race([
          document.fonts.ready,
          new Promise(function (res) { setTimeout(res, 5000); }),
        ]);
      } catch (e) {}

      /* 7 ── render + stage through the EXISTING streaming seam */
      _DMB_RM.exclude = ex.length ? new Set(ex) : null;
      // The fingerprint list must line up with the sequence this page is about to
      // emit. If it does not (client and page disagree on the page count), drop BOTH
      // fps and reuse and render everything positionally - never reuse by a guess.
      try {
        var _expect = (window.DMB_MAGAZINE_MODE ? 5 : 4) + (editor.totalPages || 0) - (_DMB_RM.exclude ? _DMB_RM.exclude.size : 0);
        if (_DMB_RM.fps && _DMB_RM.fps.length !== _expect) { _DMB_RM.fps = null; _DMB_RM.reuse = null; }
        if (!_DMB_RM.fps) _DMB_RM.reuse = null;
      } catch (e) { _DMB_RM.fps = null; _DMB_RM.reuse = null; }
      var sharded = _DMB_RM.from >= 0;
      var hashes = [], lastPost = 0;
      _dmbRenderSignal("render", 0, (window.DMB_MAGAZINE_MODE ? 4 : 3) + 1 + (editor.totalPages || 0));
      var manifest = await buildPdfBlobOnePagePerBookPage(
        function (done, total) {
          _DMB_RM.count = total;
          _dmbRenderSignal("render", done, total);
          var now = Date.now();
          if (now - lastPost > 10000) {
            lastPost = now;
            _dmbRenderPost("/render-progress", { phase: "render", done: done, total: total, staged: _DMB_RM.staged });
          }
        },
        null, _DMB_RM.exclude,
        {
          // Sharding skips the ENCODE, never the numbering: _pageSeq indices are
          // identical to a single-shard run.
          skip: sharded ? function (i) { return i < _DMB_RM.from || i > _DMB_RM.to; } : undefined,
          // Reused pages are not even RENDERED (skip() above only skips the encode).
          skipRender: _DMB_RM.reuse ? function (i) { return _DMB_RM.reuse.has(i); } : undefined,
          // Ask addCanvasPage for the small proof copy of each page.
          wantPreview: true,
          onPage: async function (pg) {
            var blob = _dmbDataUrlToBlob(pg.jpeg);
            if (_DMB_RM.hash) {
              var h = await _dmbRenderSha256(blob);
              hashes.push({ index: pg.index, wMm: pg.wMm, hMm: pg.hMm, orient: pg.orient, sha256: h.sha256, bytes: h.bytes });
            }
            var _fp = (_DMB_RM.fps && _DMB_RM.fps[pg.index]) || "";
            await _dmbUploadRenderPage(_DMB_RM.proxy, "", pg.index, blob, _fp, pg.wMm, pg.hMm);   // /render-stage?t&i[&fp], 8 x 90 s
            _DMB_RM.staged++;
            // AFTER the page is safely staged, never before: the printable page is the
            // thing that matters and nothing about the proof may delay or endanger it.
            if (pg.preview) {
              try { await _dmbUploadRenderPreview(_DMB_RM.proxy, pg.index, _dmbDataUrlToBlob(pg.preview), _fp); } catch (e) {}
            }
          },
        }
      );

      var seq = (manifest && manifest.pages) ? manifest.pages : [];
      if (!seq.length) throw new Error("render produced no pages");
      // A silently blank page must never reach the printer.
      if (_DMB_RM.notes.photo_missing.length)
        throw new Error("photos unavailable: " + _DMB_RM.notes.photo_missing.slice(0, 8).join(", "));
      if (_DMB_RM.crops === "prefer-r2" && _DMB_RM.notes.crop_fallback.length)
        throw new Error("crop_unrecoverable: " + _DMB_RM.notes.crop_fallback.slice(0, 8).join(", "));
      var mine = seq.filter(function (p) { return !p.skipped; })
                    .map(function (p) { return { index: p.index, wMm: p.wMm, hMm: p.hMm }; });
      if (mine.length !== _DMB_RM.staged)
        throw new Error("staged " + _DMB_RM.staged + " of " + mine.length + " pages");

      _dmbRenderSignal("done", _DMB_RM.count, _DMB_RM.count);
      var _donePayload = {
        part: _DMB_RM.part, parts: _DMB_RM.parts, count: seq.length, pages: mine,
        masterMisses: _DMB_RM.notes.master_miss, crops: _DMB_RM.notes.crop_rebake,
        cropFallbacks: _DMB_RM.notes.crop_fallback, fonts: _DMB_RM.fonts,
      };
      var doneRes = await _dmbRenderPost("/render-done", _donePayload);
      if (!doneRes || doneRes.ok !== true) {
        // One retry, then FAIL. _dmbRenderPost collapses every non-2xx to null, so a
        // rejected manifest looks exactly like a network blip - and reporting ok:true
        // here would hang the job with the renderer believing it had succeeded.
        await new Promise(function (r2) { setTimeout(r2, 2000); });
        doneRes = await _dmbRenderPost("/render-done", _donePayload);
        if (!doneRes || doneRes.ok !== true) throw new Error("render-done rejected by the worker");
      }
      window.__DMB_RENDER_RESULT = {
        ok: true, error: null, pages: mine.length, count: seq.length,
        indexes: mine.map(function (p) { return p.index; }), staged: _DMB_RM.staged, photos: nph,
        crops: _DMB_RM.notes.crop_rebake, cropFallbacks: _DMB_RM.notes.crop_fallback,
        masterMisses: _DMB_RM.notes.master_miss, photoMissing: _DMB_RM.notes.photo_missing,
        fonts: _DMB_RM.fonts, hashes: _DMB_RM.hash ? hashes : undefined,
        assemble: doneRes || null, ms: Date.now() - t0,
      };
    } catch (err) {
      var msg = String((err && err.message) || err).slice(0, 300);
      try { await _dmbRenderPost("/render-fail", { error: msg }); } catch (e) {}
      window.__DMB_RENDER_RESULT = {
        ok: false, error: msg, pages: 0, count: 0, staged: _DMB_RM.staged,
        masterMisses: _DMB_RM.notes.master_miss, photoMissing: _DMB_RM.notes.photo_missing,
        cropFallbacks: _DMB_RM.notes.crop_fallback, fonts: _DMB_RM.fonts, ms: Date.now() - t0,
      };
      _dmbRenderSignal("error", 0, 0);
      try { console.error("[DMB render] " + msg); } catch (e) {}
    }
    _dmbRenderBeat(false);
    window.__DMB_RENDER_DONE = true;   // ALWAYS set — Puppeteer must never hang
  }

  /* Parity harness (test-only, inert for customers): hash every page THIS browser
   * would produce, through the exact same streaming seam.
   *   const a = await window.__dmbHashPagesLocal(null);   */
  window.__dmbHashPagesLocal = async function (excludeArr, onProgress) {
    var ex = (Array.isArray(excludeArr) && excludeArr.length) ? new Set(excludeArr.map(Number)) : null;
    var out = [];
    var manifest = await window.__dmbBuildPdfStreaming(async function (pg) {
      var h = await _dmbRenderSha256(_dmbDataUrlToBlob(pg.jpeg));
      out.push({ index: pg.index, wMm: pg.wMm, hMm: pg.hMm, orient: pg.orient, sha256: h.sha256, bytes: h.bytes });
    }, onProgress || null, ex);
    return { count: out.length, pages: out, seq: (manifest && manifest.pages) || [] };
  };



  /* ═══════════════════════════════════════════════════════════════════════════
   * STEP 4 — SERVER RENDER AT CHECKOUT (window.DMB_SERVER_RENDER)
   *
   * Replaces the in-browser render at Add to Cart with the full-quality server
   * render, and puts a MANDATORY PROOF in front of the customer: they approve the
   * ACTUAL rendered pages before anything is bound or added to the cart.
   *
   * Fails SOFT by design. Any problem - stale design, no masters, renderer down,
   * customer rejects - aborts the job and returns null, and the caller falls
   * straight through to today's proven in-browser pipeline. An order is never
   * blocked by this path.
   * ═══════════════════════════════════════════════════════════════════════════ */

  const _DMB_SR_TRACE = [];
  function _dmbSrTrace(stage, extra) {
    try {
      _DMB_SR_TRACE.push({ stage: stage, ms: Date.now(), info: extra === undefined ? null : extra });
      window.__DMB_SR_TRACE = _DMB_SR_TRACE;
      console.log("[DMB sr] " + stage + (extra !== undefined ? " " + JSON.stringify(extra) : ""));
    } catch (e) {}
  }

  function _dmbServerRenderOn() {
    try {
      return window.DMB_SERVER_RENDER === true &&
             !!window.DMB_DESIGNS_PROXY &&
             !window.DMB_CARD_MODE &&          // cards have their own PDF path
             !_dmbRenderMode();                // never from inside a render page
    } catch (e) { return false; }
  }

  function _dmbSrIds() {
    let sid = ""; try { sid = _dmbPhotoBackup.guestId() || ""; } catch (e) {}
    let id = ""; try { id = getCustomerSaveKey().replace(/^dmb_progress_/, ""); } catch (e) {}
    return { id, sid, qs: "id=" + encodeURIComponent(id) + (sid ? "&sid=" + encodeURIComponent(sid) : "") };
  }

  /* The server renders from the CLOUD copy, and that copy is normally BEHIND: the
   * R2 save is debounced and edit-gated, and Add to Cart only saves locally. Push
   * the current design up and wait for it, or the customer could be sold a book
   * missing their last few edits. Returns the rev we just wrote. */
  async function _dmbSrForceCloudSave() {
    let rev = "";
    try {
      const snap = getCurrentBuilderStateSnapshot();
      try { if (snap.editor && Array.isArray(snap.editor.photos)) snap.editor.photos = []; } catch (e) {}
      rev = (_dmbBuildCloudMeta(snap, editor.photos || []) || {}).rev || "";
    } catch (e) {}
    try {
      const r = await _dmbCloudFlushNow(false);
      if (r && !r.ok) throw new Error("cloud save HTTP " + r.status);
      if (!r) throw new Error("cloud save unavailable");
    } catch (e) { throw new Error("could not save your design to the cloud: " + ((e && e.message) || e)); }
    return rev;
  }

  /* ── INCREMENTAL RENDER: per-page content fingerprints ─────────────────────
   * One fingerprint per PDF page, in the exact order the render page emits them
   * (see buildPdfBlobOnePagePerBookPage). The Worker keeps every staged page under
   * its fingerprint; at the next Add to Cart, pages whose fingerprint is unchanged
   * are reused as-is and only the rest are rendered.
   *
   * CONSERVATIVE BY CONSTRUCTION. A page's fingerprint covers everything its pixels
   * can depend on: the global block (orientation, magazine, page count, JPEG quality,
   * logo/asset base, and the builder BUILD itself - so any deploy invalidates every
   * cached page), the page's own state, its FACING page's objects (they can overhang
   * the fold onto this page), the spread photo, and every referenced photo's
   * identity + crop rect + whether a print master exists for it (master vs proxy
   * changes the pixels). When in doubt a field is included: a needless re-render
   * costs seconds; a wrongly reused page would be printed. */
  function _dmbSrStableStringify(v) {
    const seen = new Set();
    const walk = function (x) {
      if (x === null || typeof x !== "object") {
        if (typeof x === "string" && x.slice(0, 5) === "blob:") return "";   // session-local, never stable
        if (typeof x === "function" || typeof x === "undefined") return null;
        return x;
      }
      if (typeof File !== "undefined" && x instanceof File) return "[file]";
      if (typeof Blob !== "undefined" && x instanceof Blob) return "[blob]";
      if (seen.has(x)) return "[cycle]";
      seen.add(x);
      let out;
      if (Array.isArray(x)) out = x.map(walk);
      else { out = {}; Object.keys(x).sort().forEach(function (k) { out[k] = walk(x[k]); }); }
      seen.delete(x);
      return out;
    };
    return JSON.stringify(walk(v));
  }
  async function _dmbSrHash(str) {
    try {
      const buf = new TextEncoder().encode(str);
      const h = await crypto.subtle.digest("SHA-256", buf);
      return Array.from(new Uint8Array(h)).map(function (b) { return b.toString(16).padStart(2, "0"); }).join("").slice(0, 40);
    } catch (e) {
      let h = 0; for (let i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
      return "c" + (h >>> 0).toString(36) + "-" + str.length.toString(36);
    }
  }
  async function _dmbSrPageFingerprints(snapshot, excludeSet, masterHave) {
    const ed = (snapshot && snapshot.editor) || {};
    const cs = (snapshot && snapshot.coverState) || {};
    const isMag = !!window.DMB_MAGAZINE_MODE;
    const N = Number(ed.totalPages) || 0;
    const ls = ed.orientation === "landscape";
    const pageDims  = ls ? { wMm: 297, hMm: 210 } : { wMm: 210, hMm: 297 };   // interior + cover face (A-series)
    const spineDims = { wMm: 8, hMm: pageDims.hMm };
    let build = "";
    try { const sc = document.querySelector('script[src*="design-my-book.js"]'); build = (sc && sc.src && (sc.src.match(/mncb=([A-Za-z0-9]+)/) || [])[1]) || ""; } catch (e) {}
    const G = {
      v: "fp1", build: build, mag: isMag, orient: ed.orientation || "portrait", total: N,
      extra: Number(ed.extraSpreads) || 0, q: (typeof window.DMB_PDF_JPEG_QUALITY === "number") ? window.DMB_PDF_JPEG_QUALITY : 0.96,
      logo: String(window.DMB_LOGO_URL || ""), assets: String(window.DMB_ASSET_BASE || ""),
    };
    const get = function (m, k) { if (!m) return undefined; return (m[k] !== undefined) ? m[k] : m[String(k)]; };
    const photoSig = function (pid) {
      if (!pid || typeof pid !== "string") return null;
      const src = (typeof _dmbCropSourceId === "function" && _dmbIsCropDerived && _dmbIsCropDerived(pid)) ? _dmbCropSourceId(pid) : pid;
      return pid + ":" + (masterHave && masterHave.has(pid) ? "m" : "p") +
             (src !== pid ? ("<" + src + ":" + (masterHave && masterHave.has(src) ? "m" : "p")) : "") +
             ":" + _dmbSrStableStringify(get(ed.cropRects, pid) || null);
    };
    const objPids = function (objs) {
      const out = [];
      (objs || []).forEach(function (o) { if (o && o.photoId) out.push(o.photoId); });
      return out;
    };
    // coverState.textStyles is a SHARED store: page text (pgtext_*) keeps its style
    // there too. Page-owned entries belong to the page's fingerprint, not the cover's.
    const pageOwnedIds = new Set();
    try { Object.keys(ed.pageObjects || {}).forEach(function (k) { (ed.pageObjects[k] || []).forEach(function (o) { if (o && o.id) pageOwnedIds.add(String(o.id)); }); }); } catch (e) {}
    const tsOf = function (objs) {
      const out = {};
      try { (objs || []).forEach(function (o) { if (o && o.id && cs.textStyles && cs.textStyles[o.id]) out[o.id] = cs.textStyles[o.id]; }); } catch (e) {}
      return out;
    };
    const pageFp = async function (p) {
      const partner = (p >= 1) ? ((p % 2 === 1) ? p + 1 : p - 1) : 0;
      const partnerOk = partner >= 1 && partner <= N;
      const si = Math.floor((p - 1) / 2);
      const objs = get(ed.pageObjects, p) || [];
      const pObjs = partnerOk ? (get(ed.pageObjects, partner) || []) : [];
      const slots = get(ed.pageSlots, p) || null;
      const frames = get(ed.pageFrames, p) || null;
      const spread = (p >= 1) ? (get(ed.spreadPhoto, si) || null) : null;
      const pids = [].concat(objPids(objs), objPids(pObjs));
      if (slots) { if (slots.A) pids.push(slots.A); if (slots.B) pids.push(slots.B); }
      if (frames) Object.keys(frames).forEach(function (k) { if (frames[k]) pids.push(frames[k]); });
      if (spread && spread.photoId) pids.push(spread.photoId);
      const body = {
        G: G, p: p, locked: (typeof isLockedPage === "function") ? !!isLockedPage(p) : false,
        bg: get(ed.pageBackgrounds, p) || null, objs: objs, partnerObjs: pObjs, partnerOk: partnerOk,
        spread: spread, tpl: get(ed.pageTemplate, p) || null, slots: slots, rot: get(ed.pageRot, p) || null,
        frameShapes: get(ed.pageFrameShapes, p) || null, frames: frames, frameRot: get(ed.pageFrameRot, p) || null,
        photos: Array.from(new Set(pids)).sort().map(photoSig),
        ts: tsOf(objs), partnerTs: tsOf(pObjs),
      };
      return await _dmbSrHash(_dmbSrStableStringify(body));
    };
    // Cover hash: the whole coverState EXCEPT textStyles entries owned by pages
    // (otherwise every page-text edit re-rendered all three cover faces).
    const csForCover = Object.assign({}, cs);
    try {
      const ts = {};
      Object.keys(cs.textStyles || {}).forEach(function (id) { if (!pageOwnedIds.has(String(id))) ts[id] = cs.textStyles[id]; });
      csForCover.textStyles = ts;
    } catch (e) {}
    const coverBody = { G: G, cover: csForCover, coverObjects: ed.coverObjects || [], coverUserTexts: ed.coverUserTexts || [], photos: [] };
    try {
      const cp = [];
      objPids(ed.coverObjects).forEach(function (x) { cp.push(x); });
      Object.keys(cs || {}).forEach(function (k) { if (/imageid$|photoid$/i.test(k) && cs[k]) cp.push(cs[k]); });
      [cs.frontFrames, cs.backFrames].forEach(function (m) { if (m) Object.keys(m).forEach(function (k) { if (m[k]) cp.push(m[k]); }); });
      coverBody.photos = Array.from(new Set(cp)).sort().map(photoSig);
    } catch (e) {}
    const coverFp = await _dmbSrHash(_dmbSrStableStringify(coverBody));
    const blankFp = await _dmbSrHash(_dmbSrStableStringify({ G: G, blank: true, dims: pageDims }));

    const fps = [], dims = [];
    const push = function (fp, d) { fps.push(fp); dims.push({ wMm: d.wMm, hMm: d.hMm }); };
    if (isMag) { push("f" + coverFp, pageDims); push("b" + blankFp, pageDims); }
    else { push("f" + coverFp, pageDims); push("s" + coverFp, spineDims); push("k" + coverFp, pageDims); }
    push("p" + (await pageFp(0)), pageDims);
    for (let p = 1; p <= N; p++) {
      if (excludeSet && excludeSet.has(p)) continue;
      push("p" + (await pageFp(p)), pageDims);
    }
    if (isMag) { push("b" + blankFp, pageDims); push("k" + coverFp, pageDims); }
    return { fps: fps, dims: dims };
  }

  /* How many of this design's photos actually have a print master. Reported, never
   * assumed - the whole point of the project is that "full quality" is a fact. */
  async function _dmbSrMasterCoverage(qs) {
    try {
      const base = window.DMB_DESIGNS_PROXY;
      const [pr, mr] = await Promise.all([
        fetch(base + "/photos?" + qs, { credentials: "same-origin" }),
        fetch(base + "/photos?" + qs + "&kind=master", { credentials: "same-origin" }),
      ]);
      const P = ((await pr.json().catch(() => ({}))).photos) || [];
      const M = ((await mr.json().catch(() => ({}))).photos) || [];
      const have = new Set(M.map((x) => x.pid));
      const used = (function () { try { return _dmbCollectReferencedPhotoIds(); } catch (e) { return new Set(); } })();
      const relevant = P.filter((p) => !used.size || used.has(p.pid));
      return { total: relevant.length, withMaster: relevant.filter((p) => have.has(p.pid)).length, have: have };
    } catch (e) { return { total: 0, withMaster: 0 }; }
  }

  /* ── Proof screen ─────────────────────────────────────────────────────────
   * Shows the REAL staged pages - the exact images that go into the PDF - not a
   * re-render. This is the guard against the engine's swallowing try/catch: a
   * sticker or photo that failed to load leaves a BLANK area and still reports
   * success, and this is where a human sees it before paying.
   *
   * Presented the way the Preview panel presents the book: one SPREAD at a time
   * (back|spine|front, then the inner-cover page, then facing pairs) with prev /
   * next, so the customer reads it like the finished book instead of scanning a
   * contact sheet. Only the current spread and its neighbours are fetched, so a
   * 300-page book does not pull 300 full-size images. */
  function _dmbSrProofScreen(pages, qs, info) {
    return new Promise(function (resolve) {
      const base  = window.DMB_DESIGNS_PROXY;
      const isMag = !!window.DMB_MAGAZINE_MODE;
      const isPhone = window.innerWidth <= 749;
      // prev=1 asks for the small proof copy. No client-side fallback is needed: the
      // Worker serves the full-resolution page whenever a preview is missing, so a job
      // rendered before previews existed behaves exactly as it does today.
      const srcOf = function (p) { return base + "/render-proof-page?" + qs + "&i=" + p.index + "&prev=1" + (p.fp ? "&v=" + encodeURIComponent(String(p.fp).slice(0, 24)) : ""); };
      const LABEL_H = 18;   // px reserved under each page for its caption

      // ── Split the staged list into cover faces + interior pages ───────────
      // Book PDF order: front cover, spine, back cover, page 0, pages 1..N.
      // Magazine: front cover, blank, interior..., blank, back cover.
      const byIdx = pages.slice().sort(function (a, b) { return a.index - b.index; });
      const last  = byIdx.length - 1;
      let front = null, spine = null, back = null;
      const interior = [];
      byIdx.forEach(function (p, i) {
        if (p.index === 0)                      { front = p; return; }
        if (!isMag && p.wMm < 30)               { spine = p; return; }
        if (!isMag && p.index === 2)            { back  = p; return; }
        if (isMag && i === last)                { back  = p; return; }
        // A magazine PDF carries two MECHANICAL blank sheets that the customer never
        // designed and cannot act on: the inside faces of its covers, emitted by
        // _addBlankPage as index 1 and last-1 (see the sequence at the "Magazine order"
        // comment in buildPdfBlobOnePagePerBookPage). They were landing in `interior`,
        // which did two bad things at once: the first blank became the sheet captioned
        // "Inside cover", so a magazine proof opened on a blank white page as if
        // something had gone wrong, and every page after it was numbered one too high
        // because the numbering is just this array's index. Keep them out. (2026-09-15)
        if (isMag && (i === 1 || i === last - 1)) return;
        interior.push(p);
      });

      // With the blanks gone, interior[k] IS builder page k for a magazine, so number
      // them the way the builder does. A BOOK's page 0 keeps its "Inside cover" name:
      // there it really is the sheet facing the inside front cover, and the book has no
      // blank in between. A magazine's page 0 is an ordinary first page.
      const pageNoOf = function (p) {
        const k = interior.indexOf(p);
        if (isMag) return "Page " + Math.max(0, k);
        return k <= 0 ? "Inside cover" : "Page " + k;
      };

      // ── Views: cover, then the inner-cover page alone, then facing pairs ──
      // Every view is a row of sheets laid out by their REAL mm, so a spine is
      // exactly as tall as the faces beside it and a pair meets at the fold.
      const views = [];
      const faceOrder = isMag
        ? [{ p: back, l: "Back" }, { p: front, l: "Front" }]
        : [{ p: back, l: "Back" }, { p: spine, l: "Spine" }, { p: front, l: "Front" }];
      const coverItems = faceOrder.filter(function (f) { return !!f.p; });
      if (coverItems.length) views.push({ title: "Your cover", items: coverItems });
      if (interior.length) {
        const _firstL = isMag ? pageNoOf(interior[0]) : "Inside cover";
        views.push({ title: _firstL, items: [{ p: interior[0], l: _firstL }] });
        for (let i = 1; i < interior.length; i += 2) {
          const pair = interior.slice(i, i + 2).map(function (p) { return { p: p, l: pageNoOf(p) }; });
          views.push({ title: pair.map(function (x) { return x.l; }).join(" – "), items: pair });
        }
      }
      if (!views.length) views.push({ title: "", items: [] });

      // Width : height of each view from the page dimensions, so ONE sheet height
      // fits every view - the reader never changes size between cover, inside
      // cover and spreads. Falls back to A4 when a dimension is missing.
      views.forEach(function (v) {
        let w = 0, h = 0;
        v.items.forEach(function (it) {
          const pw = Number(it.p && it.p.wMm) || 210, ph = Number(it.p && it.p.hMm) || 297;
          w += pw; if (ph > h) h = ph;
        });
        v.wMm = w; v.hMm = h || 297; v.aspect = w / (h || 297);
      });
      const maxAspect = views.reduce(function (m, v) { return Math.max(m, v.aspect || 0); }, 0) || 0.71;

      // ══ "Keepsake" proof screen ═════════════════════════════════
      // Full-bleed ivory instead of a charcoal panel on a black scrim: the
      // screen becomes the inside of the book. A roman display line (the site's
      // own heading font via --font-heading--family) over a hairline ornament,
      // sheets floating on the ivory ground, and ONE pill action.
      //
      // Every icon is inline SVG, never an emoji character - the same codepoint
      // renders as soft 3D art on iOS, a flat cartoon on Windows and a third way
      // on Android, and this is the last screen before payment. (2026-09-12)
      const K = {
        ground: "#F7F3EC", hair: "#E7E1D4", hairStrong: "#DDD5C4",
        ink: "#2C2822", muted: "#8C8372", faint: "#A89E8B",
        peri: "#6B62D6", gold: "#C9B98E", warn: "#9A7B2E"
      };
      const K_SERIF = "var(--font-heading--family,'Playfair Display'),Georgia,'Times New Roman',serif";
      const K_SANS  = "var(--font-body--family,'Inter'),system-ui,-apple-system,sans-serif";
      const NOUN    = isMag ? "magazine" : "book";
      const ARROW   = isPhone ? 36 : 40;   // round nav button
      const AGAP    = isPhone ? 0  : 24;   // gap between an arrow and the sheets

      const ov = document.createElement("div");
      ov.id = "dmbProofOverlay";
      ov.style.cssText = "position:fixed;inset:0;z-index:1000020;background:" + K.ground + ";" +
        "display:flex;align-items:stretch;justify-content:center;font-family:" + K_SANS + ";";

      const panel = document.createElement("div");
      panel.style.cssText = "width:100%;max-width:1180px;box-sizing:border-box;overflow:hidden;" +
        "display:flex;flex-direction:column;padding:" +
        (isPhone ? "16px 12px 12px" : "28px 32px 20px") + ";";

      // ── Head: a FIXED roman headline, then the view caption ─────────────
      // The headline never changes as pages are turned, so the head cannot
      // reflow; the view name and sheet counter live in the caption beneath it.
      const head = document.createElement("div");
      head.style.cssText = "flex:0 0 auto;text-align:center;";

      const headline = document.createElement("div");
      headline.style.cssText = "font-family:" + K_SERIF + ";font-weight:700;color:" + K.ink + ";" +
        "line-height:1.14;font-size:" + (isPhone ? "23px" : "30px") + ";";
      headline.textContent = "Before we print it";

      const orn = document.createElement("div");
      orn.style.cssText = "display:flex;align-items:center;justify-content:center;gap:9px;margin-top:9px;";
      const _ornRule = '<span style="display:block;width:' + (isPhone ? 44 : 64) +
        'px;height:1px;background:' + K.hairStrong + '"></span>';
      orn.innerHTML = _ornRule +
        '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.3 6.1 6.2.4-4.8 4 1.6 6-5.3-3.4-5.3 3.4 1.6-6-4.8-4 6.2-.4z" fill="' + K.gold + '"/></svg>' +
        _ornRule;

      const titleEl = document.createElement("div");
      titleEl.style.cssText = "margin-top:9px;font-size:12px;color:" + K.muted + ";" +
        "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;";

      head.appendChild(headline); head.appendChild(orn); head.appendChild(titleEl);

      // The reassurance line costs vertical space the sheets need on a phone,
      // where the swipe hint is redundant anyway (they can just swipe).
      if (!isPhone) {
        const sub = document.createElement("div");
        sub.style.cssText = "margin-top:4px;font-size:12px;color:" + K.faint + ";";
        // Count what they can actually TURN THROUGH, not what the PDF contains: saying
        // "the actual 28 printed pages" while showing 26 sheets invites exactly the kind
        // of "is something missing?" doubt this screen exists to remove.
        const _shown = coverItems.length + interior.length;
        sub.textContent = "These are the actual " + _shown +
          " printed pages. Turn through every one and make sure it looks right." +
          (isMag ? " The inside faces of the cover print blank." : "");
        head.appendChild(sub);
      }

      // The "N of M photos at full print quality" line used to sit here. It was
      // removed on 2026-09-14 because it measured the wrong thing and said it at the
      // worst possible moment - to a customer with their card out.
      //
      // What it actually counted was a PIPELINE fact: "does an object exist at
      // photos-orig/{pid}". That is not a print-quality fact, and it was wrong in
      // BOTH directions:
      //   - false alarm: every crop-derived photo counts as a miss even though it
      //     prints from its source master, and (until the same day's fix) every
      //     phone-relay photo counted as a miss while carrying MORE pixels than the
      //     master it was being compared against;
      //   - false calm: a book of genuine 1000px photos that WILL print soft scores
      //     a perfect N of N, because each one is its own "master".
      // It also cannot see how a photo is PLACED - the same file is sharp as a
      // quarter-page inset and soft full-bleed - which is the only thing that
      // decides whether print quality is actually at risk.
      //
      // The number is still recorded for the owner in _dmbSrTrace("coverage"), where
      // it is useful as a pipeline health signal. A real customer-facing warning
      // needs effective DPI at placement size; until that exists, saying nothing is
      // more honest than saying something false.

      // ── Arrows: flanking the sheets on a laptop, beneath them on a phone ──
      // A phone needs every pixel of width for a two-page spread, so the arrows
      // move below rather than stealing it from the sheets.
      function arrowBtn(dir) {
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", dir < 0 ? "Previous sheet" : "Next sheet");
        b.style.cssText = "flex:0 0 auto;width:" + ARROW + "px;height:" + ARROW + "px;border-radius:50%;" +
          "border:1px solid " + K.hairStrong + ";background:transparent;color:" + K.ink + ";padding:0;" +
          "display:flex;align-items:center;justify-content:center;cursor:pointer;" +
          "transition:background .15s ease,opacity .15s ease;";
        b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="M' +
          (dir < 0 ? "14.5 5.5L8 12l6.5 6.5" : "9.5 5.5L16 12l-6.5 6.5") +
          '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener("click", function () { go(dir); });
        b.addEventListener("mouseenter", function () { if (!b.disabled) b.style.background = "#EFE8DA"; });
        b.addEventListener("mouseleave", function () { b.style.background = "transparent"; });
        return b;
      }
      const prevBtn = arrowBtn(-1);
      const nextBtn = arrowBtn(1);

      const PADX = isPhone ? 4 : 12;   // body padding-x per side (sheetHeight subtracts 2x)
      const body = document.createElement("div");
      body.style.cssText = "position:relative;flex:1 1 auto;min-height:0;display:flex;align-items:center;" +
        "justify-content:center;gap:" + AGAP + "px;padding:" + (isPhone ? "10px 4px" : "18px 12px") + ";";

      const stage = document.createElement("div");
      stage.style.cssText = "flex:0 1 auto;min-width:0;display:flex;justify-content:center;";

      if (isPhone) {
        body.appendChild(stage);
      } else {
        // PINNED, not flanking. The arrows used to be flex siblings of the stage, so
        // justify-content:center centred the WHOLE row - arrows included - and a narrow
        // view (the single inside-cover page) pulled both arrows inward while a full
        // spread pushed them back out. They moved on every turn, which is the one thing
        // a page-turn control must never do: the customer is aiming at a target that
        // relocates under the cursor between clicks.
        //
        // Anchored to the body's own edges they hold ONE position for every sheet. The
        // sheet-height reserve below is deliberately left alone - it still subtracts the
        // arrows and their gaps - so the widest sheet stops clear of them exactly as it
        // did, and taking them out of the flex flow cannot change the measured height
        // (they are shorter than the sheets and the padding is symmetric). (2026-09-14)
        [prevBtn, nextBtn].forEach(function (b) {
          b.style.position = "absolute";
          b.style.top = "50%";
          b.style.transform = "translateY(-50%)";
          b.style.zIndex = "2";
        });
        prevBtn.style.left  = PADX + "px";
        nextBtn.style.right = PADX + "px";
        body.appendChild(prevBtn); body.appendChild(stage); body.appendChild(nextBtn);
      }

      let phoneNav = null;
      if (isPhone) {
        phoneNav = document.createElement("div");
        phoneNav.style.cssText = "flex:0 0 auto;display:flex;align-items:center;" +
          "justify-content:center;gap:48px;padding:2px 0 8px;";
        phoneNav.appendChild(prevBtn); phoneNav.appendChild(nextBtn);
      }

      // ── One common sheet height for every view ────────────────────
      // The tallest sheet that fits the WIDEST view (cover or a spread) inside
      // the body; single pages then use the same height and simply sit narrower,
      // so the reader never changes size between cover, inside cover and spreads.
      function sheetHeight() {
        // clientWidth/clientHeight INCLUDE padding, so subtract BOTH sides of it.
        const reserve = isPhone ? 0 : 2 * (ARROW + AGAP);   // arrows + their gaps
        const padX    = isPhone ? 8  : 24;                  // 2 x body padding-x
        const padY    = isPhone ? 20 : 36;                  // 2 x body padding-y
        let bw = Math.max(0, body.clientWidth  - padX - reserve);
        let bh = Math.max(0, body.clientHeight - padY - LABEL_H);
        if (!bw || !bh) {
          // Not laid out yet. Fall back to the viewport box rather than
          // returning 0 - a zero height paints every sheet invisible, which is
          // precisely how the Preview panel once shipped broken.
          bw = Math.max(0, window.innerWidth  - (isPhone ? 32 : 88) - reserve);
          bh = Math.max(0, window.innerHeight - (isPhone ? 250 : 270));
          if (!bw || !bh) return 0;
        }
        return Math.max(40, Math.min(bh, bw / maxAspect));
      }

      function sheetNode(it, hPx) {
        const p = it.p;
        const pw = Number(p && p.wMm) || 210, ph = Number(p && p.hMm) || 297;
        const wPx = hPx * (pw / ph);
        const slot = document.createElement("div");
        slot.style.cssText = "flex:0 0 auto;display:flex;flex-direction:column;align-items:center;" +
          "width:" + wPx.toFixed(2) + "px;";
        const img = document.createElement("img");
        img.decoding = "async";
        img.alt = it.l || "";
        img.src = srcOf(p);
        img.style.cssText = "display:block;background:#fff;width:" + wPx.toFixed(2) + "px;" +
          "height:" + hPx.toFixed(2) + "px;border-radius:1px;cursor:zoom-in;" +
          "box-shadow:0 6px 22px rgba(60,50,35,0.20),0 1px 3px rgba(60,50,35,0.12);";
        img.addEventListener("click", function () { try { window.open(img.src, "_blank"); } catch (e) {} });
        const lbl = document.createElement("div");
        // A spine slot is only ~9px wide, so its caption can never render as
        // anything but a clipped fragment ("SP"). Blank it and keep the row
        // height, rather than printing debris between BACK and FRONT.
        lbl.textContent = (wPx < 40) ? "" : (it.l || "");
        lbl.style.cssText = "height:" + LABEL_H + "px;line-height:" + LABEL_H + "px;color:" + K.faint + ";" +
          "font-size:9px;letter-spacing:0.12em;text-transform:uppercase;white-space:nowrap;" +
          "overflow:hidden;max-width:100%;";
        slot.appendChild(img); slot.appendChild(lbl);
        return slot;
      }

      let idx = 0;
      let seenEnd = false;
      function render() {
        stage.innerHTML = "";
        const v = views[idx];
        // Caption first: it is the only head content written per-render, so
        // measuring before it is filled sizes view 1 against a shorter head.
        titleEl.textContent = (v.title || ("Your " + NOUN)) +
          " · sheet " + (idx + 1) + " of " + views.length;
        if (idx === views.length - 1) seenEnd = true;
        updateOk();
        const hPx = sheetHeight();

        // Park the arrows against the WIDEST sheet row rather than the body edge, so
        // they sit exactly where the two-page spread put them and stay there for the
        // narrow views too. hPx does not depend on the current view (that is the whole
        // point of one common sheet height), so maxAspect * hPx is constant and this
        // lands on the same pixel every render. When the widest view is limited by
        // WIDTH rather than height the expression collapses to PADX on its own - the
        // old outer position - so nothing regresses on a short, wide window.
        if (!isPhone && body.clientWidth) {
          const _inset = Math.max(PADX, Math.round((body.clientWidth - maxAspect * hPx) / 2) - AGAP - ARROW);
          prevBtn.style.left  = _inset + "px";
          nextBtn.style.right = _inset + "px";
        }

        const row = document.createElement("div");
        row.style.cssText = "display:flex;gap:0;align-items:flex-start;justify-content:center;";
        v.items.forEach(function (it) { row.appendChild(sheetNode(it, hPx)); });
        stage.appendChild(row);

        prevBtn.disabled = (idx === 0);
        nextBtn.disabled = (idx === views.length - 1);
        [prevBtn, nextBtn].forEach(function (b) {
          b.style.opacity = b.disabled ? "0.3" : "1";
          b.style.cursor  = b.disabled ? "default" : "pointer";
        });
        preload(idx + 1); preload(idx - 1);
      }

      // Warm the neighbouring views so turning a page is instant, without
      // fetching the whole book up front.
      const warmed = new Set();
      function preload(i) {
        if (i < 0 || i >= views.length) return;
        views[i].items.forEach(function (it) {
          const p = it.p;
          if (!p || warmed.has(p.index)) return;
          warmed.add(p.index);
          const im = new Image(); im.decoding = "async"; im.src = srcOf(p);
        });
      }

      function go(d) {
        const n = Math.max(0, Math.min(views.length - 1, idx + d));
        if (n !== idx) { idx = n; render(); }
      }

      const onKey = function (e) {
        if (e.key === "ArrowLeft")  { e.preventDefault(); go(-1); }
        if (e.key === "ArrowRight") { e.preventDefault(); go(1); }
      };
      document.addEventListener("keydown", onKey);
      const onResize = function () { render(); };
      window.addEventListener("resize", onResize);

      // Swipe on touch - the phone has no other affordance beside the arrows.
      let tX = 0, tY = 0;
      body.addEventListener("touchstart", function (e) {
        if (!e.touches || !e.touches[0]) return;
        tX = e.touches[0].clientX; tY = e.touches[0].clientY;
      }, { passive: true });
      body.addEventListener("touchend", function (e) {
        const t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        const dx = t.clientX - tX, dy = t.clientY - tY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });

      // ── Foot: one pill action, the reject path demoted to a quiet link ───
      const foot = document.createElement("div");
      foot.style.cssText = "flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:10px;" +
        "border-top:1px solid " + K.hair + ";padding-top:" + (isPhone ? "13px" : "16px") + ";";

      const hint = document.createElement("div");
      // FIXED height, not min-height: this line is written per-render, and an
      // empty vs filled box differed by 4.4px - enough to size view 1 against a
      // taller body and overflow its sheets. Nothing in the head or the foot may
      // change height between renders. (2026-09-12)
      hint.style.cssText = "font-size:11.5px;color:" + K.faint + ";text-align:center;" +
        "height:18px;line-height:18px;overflow:hidden;";

      const ok = document.createElement("button");
      ok.type = "button";
      ok.style.cssText = "display:inline-flex;align-items:center;gap:8px;border:none;border-radius:99px;" +
        "background:" + K.peri + ";color:#fff;cursor:pointer;font-family:inherit;font-weight:600;" +
        "font-size:" + (isPhone ? "14px" : "15px") + ";letter-spacing:0.01em;" +
        "padding:" + (isPhone ? "12px 26px" : "13px 32px") + ";" +
        "box-shadow:0 2px 10px rgba(107,98,214,0.28);";
      ok.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.6l-1.5-1.4C5.4 14.6 2.5 11.9 2.5 8.6 2.5 6 4.5 4 7.1 4c1.5 0 2.9.7 3.8 1.8l1.1 1.3 1.1-1.3C14 4.7 15.4 4 16.9 4 19.5 4 21.5 6 21.5 8.6c0 3.3-2.9 6-8 10.6z" fill="#fff" opacity="0.92"/></svg><span></span>';
      const okLabel = ok.querySelector("span");
      okLabel.textContent = "Yes — print my " + NOUN;

      const backBtn = document.createElement("button");
      backBtn.type = "button";
      backBtn.textContent = "Something's wrong, let me fix it";
      backBtn.style.cssText = "background:none;border:none;cursor:pointer;font-family:inherit;padding:2px 4px;" +
        "font-size:12px;color:" + K.muted + ";text-decoration:underline;text-underline-offset:3px;";

      // Nudge them to actually look at the whole book, but never block the sale.
      function updateOk() {
        hint.textContent = seenEnd ? "" : "Turn to the last page to check everything";
      }

      let settled = false;
      const done = function (v) {
        if (settled) return; settled = true;
        document.removeEventListener("keydown", onKey);
        window.removeEventListener("resize", onResize);
        try { ov.remove(); } catch (e) {}
        resolve(v);
      };
      backBtn.addEventListener("click", function () { done("reject"); });
      ok.addEventListener("click", function () {
        ok.disabled = true; ok.style.opacity = "0.6"; ok.style.cursor = "default";
        okLabel.textContent = "Preparing";
        done("approve");
      });

      foot.appendChild(hint); foot.appendChild(ok); foot.appendChild(backBtn);
      panel.appendChild(head); panel.appendChild(body);
      if (phoneNav) panel.appendChild(phoneNav);
      panel.appendChild(foot);
      ov.appendChild(panel);
      document.body.appendChild(ov);

      // Measure AFTER the panel is in the document, otherwise clientWidth is 0.
      render();
    });
  }
  async function _dmbSrPoll(qs) {
    const r = await fetch(window.DMB_DESIGNS_PROXY + "/assemble-status?" + qs, { credentials: "same-origin" });
    return await r.json().catch(function () { return { status: "unknown" }; });
  }
  function _dmbSrAbort(qs) {
    try {
      return fetch(window.DMB_DESIGNS_PROXY + "/render-abort?" + qs, { method: "POST", credentials: "same-origin" });
    } catch (e) { return Promise.resolve(); }
  }

  /* Returns { id, viewUrl, downloadUrl } shaped exactly like uploadPdfToGoogleDrive,
   * or NULL to fall back to the in-browser pipeline. Never throws past the caller. */
  async function _dmbServerRenderAndBind(excludePages, onStatus, onProgress, onHide) {
    _dmbSrTrace("enter");
    const ids = _dmbSrIds();
    if (!ids.id) { _dmbSrTrace("no_design_id"); return null; }
    const qs = ids.qs;
    const say = function (m) { try { if (onStatus) onStatus(m); } catch (e) {} };

    try {
      say("Saving your design");
      _dmbSrTrace("cloud_save");
      const rev = await _dmbSrForceCloudSave();
      _dmbSrTrace("cloud_saved", rev.slice(0, 8));

      // Masters upload on a BACKGROUND chain behind the proxies: the import modal
      // only waits for proxies, so on a phone that chain can still be running
      // minutes later - and this render reads from photos-orig/. Wait for it,
      // exactly as the in-browser PDF path does. Without this the proof reported
      // "0 of N at full print quality" and the server rendered from the proxies.
      if (_dmbMasterPendingCount > 0) {
        _dmbSrTrace("masters_pending", _dmbMasterPendingCount);
        const _n0 = _dmbMasterPendingCount;
        let _tick = null;
        try {
          say("Uploading your full-quality photos");
          _tick = setInterval(function () {
            say("Uploading your full-quality photos " + Math.max(0, _n0 - _dmbMasterPendingCount) + " / " + _n0);
          }, 500);
          // The chain is re-assigned as items are queued; loop until nothing is left.
          for (let _g = 0; _g < 50 && _dmbMasterPendingCount > 0; _g++) {
            try { await _dmbMasterChain; } catch (e) {}
          }
        } finally { if (_tick) clearInterval(_tick); }
        _dmbSrTrace("masters_done", _dmbMasterPendingCount);
      }

      const cov = await _dmbSrMasterCoverage(qs);
      _dmbSrTrace("coverage", Object.assign({}, cov, { stats: _dmbMasterStats }));

      say("Preparing your pages");
      const ex = (excludePages && excludePages.size) ? Array.from(excludePages) : [];
      // Per-page fingerprints from the SAME snapshot that was just saved (the render
      // page loads that saved state), so "unchanged" means unchanged in what it sees.
      let _fpr = null;
      try {
        _fpr = await _dmbSrPageFingerprints(getCurrentBuilderStateSnapshot(), excludePages, (cov && cov.have) || null);
        _dmbSrTrace("fps", _fpr && _fpr.fps.length);
      } catch (e) { _fpr = null; _dmbSrTrace("fps_failed", String((e && e.message) || e)); }
      const mint = await fetch(window.DMB_DESIGNS_PROXY + "/render-job?" + qs, {
        method: "POST", headers: { "content-type": "application/json" }, credentials: "same-origin",
        body: JSON.stringify(Object.assign({ rev: rev, exclude: ex, crops: "prefer-r2" },
          _fpr ? { fps: _fpr.fps, dims: _fpr.dims } : {})),
      });
      const mj = await mint.json().catch(function () { return null; });
      _dmbSrTrace("mint", { http: mint.status, ok: !!(mj && mj.ok), err: mj && mj.error, reuse: mj && mj.reuse, total: mj && mj.total });
      if (!mint.ok || !mj || !mj.ok) throw new Error((mj && mj.error) || ("mint HTTP " + mint.status));
      if (mj.reuse > 0) say("Keeping " + mj.reuse + " unchanged page" + (mj.reuse === 1 ? "" : "s"));

      // ── Wait for the render. This is the SAME wait the customer has today (their
      //    phone rendering every page), only it happens on a server that cannot run
      //    out of memory - so it is not new waiting, it is the same wait moved.
      const deadline = Date.now() + 40 * 60 * 1000;
      let st = null, lastBeat = Date.now(), lastDone = -1;
      for (;;) {
        await new Promise(function (r) { setTimeout(r, 3000); });
        if (Date.now() > deadline) throw new Error("render timed out");
        st = await _dmbSrPoll(qs);
        if (!st) continue;
        if (st.status === "error") throw new Error(st.error || "render failed");
        if (st.phase === "proof") { _dmbSrTrace("proof_ready"); break; }
        if (st.status === "done") break;                  // already bound (resumed job)
        const d = Number(st.done) || 0, t = Number(st.total) || 0;
        if (d !== lastDone) { lastDone = d; lastBeat = Date.now(); }
        else if (Date.now() - lastBeat > 12 * 60 * 1000) throw new Error("render stalled");
        if (t) {
          say("Printing your pages… " + d + " / " + t);
          try { if (onProgress) onProgress(d, t); } catch (e) {}
        }
      }

      // ── MANDATORY PROOF ────────────────────────────────────────────────────
      if (st.status !== "done") {
        const pr = await fetch(window.DMB_DESIGNS_PROXY + "/render-proof?" + qs, { credentials: "same-origin" });
        const pj = await pr.json().catch(function () { return null; });
        if (!pj || !pj.ok || !(pj.pages || []).length) throw new Error("proof unavailable");

        // The overlay helpers are locals of the cart handler, so it hands us its hide fn.
        try { if (onHide) onHide(); } catch (e) {}
        _dmbSrTrace("proof_shown", (pj.pages || []).length);
        const choice = await _dmbSrProofScreen(pj.pages, qs, cov);
        _dmbSrTrace("proof_choice", choice);
        // REJECTED is not a FAILURE. null means "the server render did not work,
        // fall back to the browser"; this sentinel means "the customer wants to keep
        // editing", which must stop the checkout entirely. Conflating the two made
        // "go back" start a full in-browser render behind a stuck overlay.
        if (choice !== "approve") { await _dmbSrAbort(qs); return "__dmb_proof_rejected__"; }
        say(("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book")));

        const ap = await fetch(window.DMB_DESIGNS_PROXY + "/render-approve?" + qs, {
          method: "POST", headers: { "content-type": "application/json" },
          credentials: "same-origin", body: JSON.stringify({ rev: pj.rev || rev }),
        });
        const aj = await ap.json().catch(function () { return null; });
        if (!ap.ok || !aj || !aj.ok) throw new Error((aj && aj.error) || ("approve HTTP " + ap.status));
      }

      // ── Binding (the existing stapler chain, untouched) ────────────────────
      // Binding is the slowest leg and it used to show ONE static line for up to
      // 12 minutes, so a job that was working looked identical to one that had
      // died - which is how a customer reads it, and then they reload and lose the
      // whole render. The stapler pulls every page image out of R2 one at a time,
      // builds the PDF and uploads it to Drive, so minutes IS normal on a big
      // book. Show the clock and say so. (2026-09-13)
      const bindBy = Date.now() + 12 * 60 * 1000;
      const bindT0 = Date.now();
      for (;;) {
        if (st && st.status === "done" && st.id) break;
        await new Promise(function (r) { setTimeout(r, 3000); });
        if (Date.now() > bindBy) throw new Error("binding timed out");
        st = await _dmbSrPoll(qs);
        if (st && st.status === "error") throw new Error(st.error || "binding failed");
        try {
          var _el = Math.max(0, Math.round((Date.now() - bindT0) / 1000));
          // NO clock: a stopwatch counting up on a checkout screen reads as
          // "something is wrong", which is the opposite of reassuring. The
          // breathing book mark already proves the screen is alive; the staged
          // message below is what actually stops someone reloading - and losing
          // the whole render - when a big book legitimately takes minutes.
          say("Binding your " + (window.DMB_MAGAZINE_MODE ? "magazine" : "book"));
          var _lbl = document.getElementById("dmbUploadProgressLabel");
          if (_lbl) {
            _lbl.textContent = (_el < 45)
              ? "Stitching your pages into one file"
              : "Still working. A big book takes a few minutes \u2014 please keep this tab open.";
          }
        } catch (e) {}
      }
      if (!st.id) throw new Error("no file id");
      _dmbSrTrace("bound", { pages: st.pages, bytes: st.bytes });
      return { id: st.id, viewUrl: st.viewUrl, downloadUrl: st.downloadUrl };
    } catch (err) {
      _dmbSrTrace("FAILED", String((err && err.message) || err).slice(0, 200));
      // Free the job so the /assemble interlock cannot block the in-browser fallback.
      try { await _dmbSrAbort(qs); } catch (e) {}
      return null;
    }
  }

})(); // closes the main (() => { app IIFE at line 699

